/**
 * @module cerberus/account
 * @description Includes components that service the user's account
 */
angular.module('cerberus.account', []);
/**
 * @module cerberus/account
 * @description Includes components that service the workspace and all its parts
 */
angular.module('cerberus.admin', []);
/**
 * @module cerberus/core
 * @description This module contains the core functionality for end users (non-admin)
 */
angular.module('cerberus.core', []);
/**
 * @module cerberus/cpc
 * @description Custom components for Crown Paper Converting Platform
 */
angular.module('cerberus.cpc', []);
/**
 * @module cerberus/slp
 * @description Custom components for the Safe Lending Platform
 */
angular.module('cerberus.les', []);
/**
 * @module cerberus/ui
 * @description Components used throughout the application to build the user interface
 */
angular.module('cerberus.ui', []);
/**
 * @module cerberus/ui-util
 * @description Components that modify the UI but not build it
 */
angular.module('cerberus.ui-util', []);
/**
 * @module cerberus/util
 * @description Background functionality and services
 */
angular.module('cerberus.util', []);
/**
 * @module cerberus
 * @description Core Module
 */
angular.module('cerberus', [
    /* Angular Dependancies */
    'ngRoute',
    'ngAnimate',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngCookies',
    /* Angular UI */
    'ui.tree',
    'ui.codemirror',

    /* Angular UI Bootstrap */
    // ui bootstrap -- modules removed:'ui.bootstrap.carousel','ui.bootstrap.dateparser','ui.bootstrap.datepicker','ui.bootstrap.rating','ui.bootstrap.timepicker', 'ui.bootstrap.progressbar',
    'ui.bootstrap.alert',
    'ui.bootstrap.buttons',
    'ui.bootstrap.typeahead',
    'ui.bootstrap.accordion',
    'ui.bootstrap.collapse',
    'ui.bootstrap.position',
    'ui.bootstrap.dropdown',
    'ui.bootstrap.modal',
    'ui.bootstrap.tooltip',
    'ui.bootstrap.popover',
    'ui.bootstrap.stackedMap',
    'ui.bootstrap.pagination',
    'ui.bootstrap.tabs',
    'ui.bootstrap.tpls',

    /* Other Dependancies */
    'kendo.directives',
    'gridster',
    'LocalStorageModule',
    'ngImgCrop',
    'toaster',
    'firebase',
    'timer',

    /* Sub Modules */
    'cerberus.account',
    'cerberus.admin',
    'cerberus.core',
	'cerberus.cpc',
    'cerberus.les',
    'cerberus.ui',
    'cerberus.ui-util',
    'cerberus.util',
    'cerberus.template'
])
;
angular.module('cerberus')
    .config(["$routeProvider", "$httpProvider", "$provide", "localStorageServiceProvider", "gridsterConfig", function($routeProvider, $httpProvider, $provide, localStorageServiceProvider, gridsterConfig) {

        /**
         *  ROUTES
         */
        // Define page routes last so that all app module routes are enforced
        $routeProvider.when('/:pageId', {
            templateUrl: 'core/pages/pages.tpl.html',
            controller: 'PagesCtrl',
            resolve: {
                _wait: 'WaitForUserData',
                pageId: ["$route", function($route){
                    return $route.current.params.pageId;
                }]
            },
            reloadOnSearch: false
        });
        $routeProvider.when('/', {
            templateUrl: 'core/pages/pages.tpl.html',
            controller: 'PagesCtrl',
            resolve: {
                _wait: 'WaitForUserData',
                pageId: function(){
                    return null;
                }
            },
            reloadOnSearch: false
        });

        // Set Default Route
        $routeProvider.otherwise({redirectTo: '/'});

        /**
         *  HTTP
         */
        // Configure $http service to combine processing of multiple http responses
        // received at around the same time via $rootScope.$applyAsync.
        $httpProvider.useApplyAsync(true);

        // Add request header to protect against CSRF
        $provide.factory('csrfHttpIntercepter', function(){
            return {
                request: function(config){
                    config.headers['X-Requested-With'] = 'XMLHttpRequest';

                    return config;
                }
            };
        });
        $httpProvider.interceptors.push('csrfHttpIntercepter');

        /**
         *  Local Storage
         */
        localStorageServiceProvider.setPrefix('nim');

        /**
         *  Gridster
         */
        gridsterConfig.sparse                               =   true;
        gridsterConfig.pushing                              =   false;
        gridsterConfig.floating                             =   false;
        gridsterConfig.swapping                             =   false;
        gridsterConfig.width                                =   'auto';
        gridsterConfig.columns                              =   24;
        gridsterConfig.colWidth                             =   'auto';
        gridsterConfig.minColumns                           =   1;
        gridsterConfig.rowHeight                            =   8;
        gridsterConfig.minRows                              =   7;
        gridsterConfig.maxRows                              =   1000;
        gridsterConfig.defaultSizeX                         =   6;
        gridsterConfig.defaultSizeY                         =   7;
        gridsterConfig.margins                              =   [0,0];
        gridsterConfig.outerMargin                          =   true;
        gridsterConfig.mobileBreakPoint                     =   698; // will trigger on screen widths >= 768px
        gridsterConfig.mobileModeEnabled                    =   true;
        gridsterConfig.saveGridItemCalculatedHeightInMobile =   true;
        gridsterConfig.resizable.enabled                    =   false;
        gridsterConfig.resizable.handles                    =   ['s', 'e', 'n', 'w', 'se', 'ne', 'sw', 'nw'];
        gridsterConfig.draggable.enabled                    =   false;
        gridsterConfig.draggable.scrollSensitivity          =   20;
        gridsterConfig.draggable.scrollSpeed                =   20;
    }])
;
angular.module('cerberus')
    // == app version ==
    .constant('coreAppVersion', {            // main app version (should match everywere)
        version: '1.7.443',
        build: 'Build: 1.1',
        date: '2025-03-25',
    })
    // == api path ==
    .constant('apiPath', '/server/rest/v1/') // with trailing slash
    // == system generic constants ==
    .constant('userDefinedIdRegex', /^[A-Za-z][A-Za-z0-9]{2,19}$/)
    .constant('statusList',{
        1: { name: 'Active', color: 'success' },
        2: { name: 'Deleted', color: 'danger' },
        3: { name: 'Disabled', color: 'warning' },
        4: { name: 'Pending', color: 'info' },
        5: { name: 'Failed', color: 'danger' },
        6: { name: 'Complete', color: 'primary' }
    })
;
angular.module('cerberus')
    // == app environment ==
    .constant('buildEnvironment', {                                  // main app build environment (to identify proper edition)
        env: 'Prod'
    })
    // == firebase related constants ==
      .constant('fbUrl', 'https://cpcmrp-6a749.firebaseio.com')      // must match fbUrl from app_vars.xml file (production)
    //.constant('fbUrl', 'https://cpcmrpdev.firebaseio.com')         // must match fbUrl from app_vars.xml file (development)
    // == mapbox related constants ==
    .constant('mapboxConfig', {
        token: 'pk.eyJ1IjoibmltYnVzc3ciLCJhIjoiY2o0amd3YXh5MDh4bjJxcWpxYXQwdHFzaSJ9.JwV5qI6JUww1P8-GP7DBWg'
    })
;
angular.module('cerberus')
    .controller('AppCtrl', ["_", "$scope", "$rootScope", "$uibModal", "$window", "AuthService", "toaster", "WaitForUserData", "MenusService", "OrganizationsService", "$location", "localStorageService", function AppCtrl(_, $scope, $rootScope, $uibModal, $window, AuthService, toaster, WaitForUserData, MenusService, OrganizationsService, $location, localStorageService) {
        // ng-if Variables
        $scope.isDoneLoading = false;
        $scope.isModalOpen = false;
        $scope.isWorkspaceModalOpen = false;

        // UI Variables
        $scope.appUI = {
            isHeaderFixed: true,
            isLeftBarCollapsed: true,
            isRightBarCollapsed: true,
            isTopBarCollapsed: true
        };

        // Login Modal
        $scope.openLoginModal = function () {
            //Make sure modal is not already open (edge case for multiple login attempts after session timeout)
            if (!$scope.isModalOpen) {
                $scope.isModalOpen = true;

                // If another backdrop already exists, turn it into a login backdrop
                var existingBackdrop = angular.element($window.document).find('[uib-modal-backdrop]').addClass('login');

                var modalInstance = $uibModal.open({
                    templateUrl: 'core/auth/auth-login.tpl.html',
                    controller: 'AuthLoginCtrl',
                    backdropClass: 'login',
                    windowClass: 'modal-login',
                    keyboard: false,
                    backdrop: 'static'
                });
                modalInstance.result.then(function () {
                    existingBackdrop.removeClass('login');
                    $scope.isModalOpen = false;
                }, function () {
                    existingBackdrop.removeClass('login');
                    $scope.isModalOpen = false;
                });
            }
        };

        // Workspace Modal
        $scope.openWorkspacesModal = MenusService.openWorkspacesModal;

        var tokenRotating = false;
        $scope.$on('auth:rotateToken', function(event){
            if(!tokenRotating){
                tokenRotating = true;
                AuthService.refreshJwt().then(function(data){
                    // Set token in local storage
                    localStorageService.set('jwt', data.jwt);

                    // Set token in rootScope
                    $rootScope.authToken = data.jwt;

                    tokenRotating = false;
                });
            }
            event.preventDefault();
        });

        // Catch logout, or multiple failed login attempts
        $scope.$on('auth:loginCancelled', function () {
            $scope.openLoginModal();
        });

        //Catch server return of unauthorized (401)
        $scope.$on('auth:loginRequired', function () {
            $scope.openLoginModal();
        });

        // Catch server return of forbidden (403)
        $scope.$on('auth:forbidden', function (event, rejection) {
            // For website portal, this forbidden message is supposed to happen
            if(rejection.data.DATA === 'app' && rejection.data.MESSAGE === "Organization/Workspace does not exist or you do not have access."){
                // Redirect to other workspace
                redirectToUserWorkspace();
            }
            else {
                rejection.data.MESSAGE = rejection.data.MESSAGE || 'You do not have access; contact your Administrator';
                toaster.pop('warning', rejection.data.STATUS, rejection.data.MESSAGE);

                // Checks if auth failed because of workspace validity
                if (rejection.data.MESSAGE === "Organization/Workspace does not exist or you do not have access.") {
                    checkWorkspaceValidity(rejection.data.DATA); // For this error, DATA is the organization subdomain
                }
            }
        });

        // Init App on confirmed login
        $scope.$on('auth:loginConfirmed', function () {
            // Resolve Promise so ngRouter can resolve routes
            WaitForUserData.doneWaiting();
            // Check for a defined currentWorkspace id
            if (_.has($rootScope, 'userData.currentWorkspace.id')) {
                // Show the user interface
                $scope.isDoneLoading = true;
            }
            else if(_.has($rootScope, 'userData.currentOrg.defaultWorkspace')){
                toaster.pop('info', 'Redirecting', 'Workspace not specified; loading default.');
                $window.location.replace($rootScope.userData.currentOrg.defaultWorkspace + $location.path());
            }
            else {
                // Since there was not a good currentWorkspace id we show the selection modal
                $scope.openWorkspacesModal();
            }
        });

        // Try to start jump start app in case our cookie is still valid
        AuthService.getUserData(true);

        /**
         * Checks if current organization/workspace combination is valid
         * @param subdomain - app, cpc, nsi, etc.
         */
        function checkWorkspaceValidity(subdomain){
            OrganizationsService.getUserOrganizations().then(function(orgs){
                var orgWsExists = false;
                var host = $location.host();
                if(host === 'localhost'){
                    host = subdomain + '.crownpaperconverting.com';
                }

                // Finds the current organization
                for(var i = 0; i < orgs.length; i++){
                    if(orgs[i].sub_domain === host){
                        var org = orgs[i];

                        // If valid organization, check if current workspace
                        // belongs to that organization
                        var ws = AuthService.getUrlWorkspace($location.absUrl());
                        for(var j = 0; j < org.workspaces.length; j++){
                            if(org.workspaces[j].path === ws){
                                orgWsExists = true;
                                break;
                            }
                        }
                        break;
                    }
                }

                // If organization/workspace is invalid, open modal
                // to let user navigate to different organization
                if(!orgWsExists){
                    // passes in the already loaded orgs
                    $scope.openWorkspacesModal(orgs);
                }
            });
        }

        /**
         * If users signed successfuly to website portal, redirect them to a workspace they belong to
         */
        function redirectToUserWorkspace(){
            OrganizationsService.getUserOrganizations().then(function(orgs){
                // If user belongs to one workspace, automatically navigate to it
                if(orgs.length === 1) {
                    $window.open('https://' + orgs[0]['sub_domain'], '_self');
                }
                else {
                    // Let them choose which workspace to go to
                    $scope.openWorkspacesModal(orgs);
                }
            });
        }
    }])
;
angular.module('cerberus')
    .run(["$rootScope", "$", "kendo", "CodeMirror", "localStorageService", function ($rootScope, $, kendo, CodeMirror, localStorageService) {
        // Recover Session
        $rootScope.authToken = localStorageService.get('jwt');

        //Ajax handle json prefix
        $.ajaxSetup({
            dataFilter: function(data){
                // Do not try to run substring on non-existent data
                // Also, check if our prefix is present
                if(data && data.indexOf(')]}\',') === 0) {
                    return data.substring(5, data.length);
                }

                return data;
            },
            headers: {
                //'X-Requested-With': 'XMLHttpRequest' // for CSRF protection
            }
        });

        // To stop PostgreSQL MIME mode from commenting lines that have a hash (#)
        CodeMirror.mimeModes['text/x-pgsql'].support.commentHash = false;

        // Kendo Configs
        kendo.ui.editor.ColorTool.prototype.options.palette = null;
        kendo.pdf.defineFont({
            // DejaVu Sans
            "DejaVu Sans": "/assets/fonts/DejaVu/DejaVuSans.ttf",
            "DejaVu Sans|Bold": "/assets/fonts/DejaVu/DejaVuSans-Bold.ttf",
            "DejaVu Sans|Bold|Italic": "/assets/fonts/DejaVu/DejaVuSans-BoldOblique.ttf",
            "DejaVu Sans|Italic": "/assets/fonts/DejaVu/DejaVuSans-Oblique.ttf",

            // Sans-serif
            "sans-serif": "/assets/fonts/DejaVu/DejaVuSans.ttf",
            "sans-serif|Bold": "/assets/fonts/DejaVu/DejaVuSans-Bold.ttf",
            "sans-serif|Bold|Italic": "/assets/fonts/DejaVu/DejaVuSans-BoldOblique.ttf",
            "sans-serif|Italic": "/assets/fonts/DejaVu/DejaVuSans-Oblique.ttf",

            // DejaVu Serif
            "DejaVu Serif": "./assets/fonts/DejaVu/DejaVuSerif.ttf",
            "DejaVu Serif|Bold": "./assets/fonts/DejaVu/DejaVuSerif-Bold.ttf",
            "DejaVu Serif|Bold|Italic": "./assets/fonts/DejaVu/DejaVuSerif-BoldOblique.ttf",
            "DejaVu Serif|Italic": "./assets/fonts/DejaVu/DejaVuSerif-Oblique.ttf",

            // Serif
            "serif": "/assets/fonts/DejaVu/DejaVuSerif.ttf",
            "serif|Bold": "/assets/fonts/DejaVu/DejaVuSerif-Bold.ttf",
            "serif|Bold|Italic": "/assets/fonts/DejaVu/DejaVuSerif-BoldOblique.ttf",
            "serif|Italic": "/assets/fonts/DejaVu/DejaVuSerif-Oblique.ttf",

            // Open Sans
            "Open Sans Condensed": "/assets/fonts/Open_Sans_Condensed/OpenSans-CondLight.ttf",
            "Open Sans Condensed|Italic": "/assets/fonts/Open_Sans_Condensed/OpenSans-CondLightItalic.ttf",
            "Open Sans Condensed|Bold": "/assets/fonts/Open_Sans_Condensed/OpenSans-CondBold.ttf",

            // Roboto
            "Roboto": "/assets/fonts/Roboto/Roboto-Regular.ttf",
            "Roboto|Italic": "/assets/fonts/Roboto/Roboto-Italic.ttf",
            "Roboto|Bold": "/assets/fonts/Roboto/Roboto-Bold.ttf",
            "Roboto|Bold|Italic": "/assets/fonts/Roboto/Roboto-BoldItalic.ttf",
            "Roboto|700": "/assets/fonts/Roboto/Roboto-Bold.ttf"
        });
        kendo.dataviz.ui.registerTheme('erp_majestic_theme',
            {
                chart: {
                    title: { color: '#444444', font: '16px Open Sans Condensed' },
                    legend: {
                        labels: { color: '#444444', font: '12px Roboto' },
                        inactiveItems: {
                            labels: { color: '#999999' },
                            markers: { color: '#9A9A9A' }
                        }
                    },
                    seriesDefaults: {
                        labels: { color: '#444444', font: '11px Roboto' },
                        overlay: { gradient: 'none' },
                        errorBars: { color: '#343434' },
                        notes: {
                            icon: {
                                background: '#000000',
                                border: { color: '#000000' }
                            },
                            label: { color: '#444444', font: '11px Roboto' },
                            line: { color: '#000000' }
                        },
                        pie: { overlay: { gradient: 'none' } },
                        donut: { overlay: { gradient: 'none' } },
                        line: { markers: { background: '#ffffff' } },
                        bubble: { opacity: 0.6 },
                        scatter: { markers: { background: '#ffffff' } },
                        scatterLine: { markers: { background: '#ffffff' } },
                        area: { opacity: 0.8 },
                        candlestick: {
                            downColor: '#d0d0d0',
                            line: { color: '#444444' },
                            border: {
                                _brightness: 1.5,
                                opacity: 1
                            },
                            highlight: {
                                border: {
                                    color: '#b8b8b8',
                                    opacity: 0.2
                                }
                            }
                        },
                        waterfall: { line: { color: '#cccccc' } },
                        horizontalWaterfall: { line: { color: '#cccccc' } },
                        ohlc: { line: { color: '#444444' } }
                    },
                    chartArea: { background: '#ffffff' },
                    seriesColors: [
                        '#00bcd4',
                        '#e91e63',
                        '#ffc107',
                        '#673ab7',
                        '#cddc39',
                        '#795548',
                        '#2196f3',
                        '#ff5722',
                        '#9c27b0',
                        '#607d8b',
                        '#333333',
                        '#ffeb3b'
                    ],
                    axisDefaults: {
                        line: { color: '#cccccc' },
                        minorTicks: { color: '#ebebeb' },
                        majorTicks: { color: '#cccccc' },
                        labels: { color: '#333333', font: '12px Roboto' },
                        majorGridLines: { color: '#cccccc' },
                        minorGridLines: { color: '#ebebeb' },
                        title: { color: '#444444' },
                        crosshair: { color: '#000000' },
                        notes: {
                            icon: {
                                background: '#000000',
                                border: { color: '#000000' }
                            },
                            label: { color: '#ffffff', font: '11px Roboto' },
                            line: { color: '#000000' }
                        }
                    }
                },
                gauge: {
                    pointer: { color: '#0074b1' },
                    scale: {
                        rangePlaceholderColor: '#cccccc',
                        labels: { color: '#444444', font: '12px Roboto' },
                        minorTicks: { color: '#ebebeb' },
                        majorTicks: { color: '#cccccc' },
                        line: { color: '#cccccc' }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: { color: '#0074b1' },
                        connectorDefaults: {
                            fill: { color: '#444444' },
                            stroke: { color: '#ffffff' },
                            hover: {
                                fill: { color: '#ffffff' },
                                stroke: { color: '#333333' }
                            }
                        },
                        content: { color: '#333333' }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: { color: '#ffffff' },
                                stroke: { color: '#444444' },
                                hover: {
                                    fill: { color: '#444444' },
                                    stroke: { color: '#444444' }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: { color: '#444444' },
                                fill: { color: '#444444' }
                            }
                        }
                    },
                    selectable: { stroke: { color: '#444444' } },
                    connectionDefaults: {
                        stroke: { color: '#c4c4c4' },
                        content: { color: '#444444' },
                        selection: {
                            handles: {
                                fill: { color: '#ffffff' },
                                stroke: { color: '#444444' }
                            },
                            stroke: { color: '#444444' }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ['#428bca', '#d1e0ec'],
                        ['#5bc0de', '#d6eaf0'],
                        ['#5cb85c', '#d6e9d6'],
                        ['#5cb85c', '#f4e8d7'],
                        ['#e67d4a', '#f2ddd3'],
                        ['#da3b36', '#f0d0cf']
                    ]
                }
            }
        );
    }]
)
;
angular.module('cerberus')
    .factory('appSettingsService', ["$http", function appSettingsService($http) {
        var defaults = {
            platform: { //TODO: Use organization values from database and if null then use these values
                // This will be displayed in various areas
                name: '',
                // This will be used for logo anchor tags
                url: 'https://crownpaperconverting.com',
                // This will be used for meta tags and copyrights
                publisher: 'Crown Paper Converting Software, Inc.'
            },
            //TODO: Move to Database
            login: {
                // Whether or not to show the create account; note this does not disable or enable the function
                createAccountVisible: true,
                // Text in the create account button
                createAccountLabel: 'Create Free Account',
                // This switch between using square logo with name or simply a rectangular logo
                logoStyle: 'rectangular', // 'square' | 'rectangular'
                // Subtitle html
                subtitleVisible: false
            },
            //TODO: Move to Database
            topNav: {
                // This switch between using square logo with name or simply a rectangular logo
                logoStyle: 'rectangular' // 'square' | 'rectangular'
            }
        };

        //init
        _getOverrides();

        var service = {
            branding: branding
        };

        return service;
        ////////////////////
        function branding() {
            return defaults;
        }
        function _getOverrides() {
            $http.get('/assets/platform/client-config-overrides.json').then(function (response) {
                angular.merge(defaults, response.data);
            });
        }

    }])
;
angular.module('cerberus.util')
    .factory('_', ["$window", function _($window) {
        return $window._;
    }])
    .factory('$', ["$window", function $($window) {
        return $window.$;
    }])
    .factory('CodeMirror', ["$window", function CodeMirror($window) {
        return $window.CodeMirror;
    }])
    .factory('kendo', ["$window", function kendo($window) {
        return $window.kendo;
    }])
    .factory('moment', ["$window", function moment($window) {
        return $window.moment;
    }])
    .factory('ics', ["$window", function ics($window) {
        return $window.ics;
    }])
    .factory('RRule', ["$window", function RRule($window) {
        return $window.RRule;
    }])
    .factory('L', ["$window", function L($window) {
        return $window.L;
    }])
    .factory('SignaturePad', ["$window", function SignaturePad($window) {
        return $window.SignaturePad;
    }])
    .factory('Firebase', ["$window", function Firebase($window) {
        return $window.Firebase;
    }])
    .factory('fbUtil', ["fbUrl", "Firebase", function fbUtil(fbUrl, Firebase) {
        return{
            ref: firebaseRef
        };

        function pathRef(args) {
            for (var i = 0; i < args.length; i++) {
                if (angular.isArray(args[i])) {
                    args[i] = pathRef(args[i]);
                }
                else if( typeof args[i] !== 'string' ) {
                    throw new Error('Argument ' + i + ' to firebaseRef is not a string: ' + args[i]);
                }
            }
            return args.join('/');
        }

        function firebaseRef() {
            var ref = new Firebase(fbUrl);
            var args = Array.prototype.slice.call(arguments);
            if( args.length ) {
                ref = ref.child(pathRef(args));
            }
            return ref;
        }
    }])
    .factory('writtenNumber', ["$window", function writtenNumber($window){
        return $window.writtenNumber;
    }])
;
angular.module('cerberus.account')
/**
 * @ngdoc config
 * @description router config
 */
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/users/drafts', {
            templateUrl: 'account/drafts/drafts.tpl.html',
            controller: 'DraftsCtrl',
            controllerAs: 'vm',
            title: 'Drafts',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
    }])
;
angular.module('cerberus.account')
    .controller('DraftsCtrl', ["_", "$scope", "$window", "draftsService", "InstancesService", function DraftsCtrl(_, $scope, $window, draftsService, InstancesService) {
        var vm = this;

        vm.drafts = [];
        vm.selectedIds = [];
        vm.isAllSelected = false;
        vm.navFunctions = {
            callback: _init
        };

        vm.modifySelectArray = draftsService.modifySelectArray;
        vm.selectAll = draftsService.selectAll;
        vm.deleteDraft = draftsService.deleteDraft;
        vm.openDraft = _.partialRight(draftsService.openDraft, vm.navFunctions);
        vm.init = _init;

        $scope.$on('$destroy', function(){
            delete vm.navFunctions.callback;
        });

        vm.getDownloadKey = function(attach){
            InstancesService.getDownloadKey(attach.id).then(function(d){
                InstancesService.getBlob(d).then(function(pdfBlob){
                    $window.saveAs(pdfBlob, attach.name);
                });
            });
        };

        _init();

        function _init(){
            vm.selectedIds = [];
            vm.isAllSelected = false;

            draftsService.getUserDrafts().then(function(drafts){
                vm.drafts = drafts;
            });
        }
    }])
;
angular.module('cerberus.account')
    /**
     * @ngdoc service
     * @name draftsService
     * @alias cerberus/drafts:draftsService
     * @description Makes calls to the "drafts" resource for user login and information
     */
    .factory('draftsService', ["_", "$http", "$q", "apiPath", "toaster", "InstancesWindowService", function draftsService(_, $http, $q, apiPath, toaster, InstancesWindowService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            create: create,
            getUserDrafts: getUserDrafts,
            get: get,
            update: update,
            modifySelectArray: modifySelectArray,
            selectAll: selectAll,
            deleteDraft: deleteDraft,
            openDraft: openDraft
        };
        ////////////////////
        /**
         * Create new draft
         * @function create
         * @param {object} data
         * @returns {promise}
         */
        function create(data){
            var deferred = $q.defer();
            $http.post(apiPath + 'drafts', data)
                .success(function(value){
                    toaster.pop('success', 'Draft Created');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Gets the current user's drafts (based on token)
         * @function getUserDrafts
         * @returns {promise}
         */
        function getUserDrafts(){
            var deferred = $q.defer();
            $http.get(apiPath + 'drafts')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
        /**
         * delete the drafts
         * @function deleteDraft
         * @returns {promise}
         */
        function deleteDraft(selectedIds){
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'drafts/' + selectedIds})
                .success(function(value){
                    toaster.pop('info', 'Draft(s) Deleted');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
        /**
         * Gets a draft by id
         * @function get
         * @param id
         * @returns {promise}
         */
        function get(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'drafts/' + id)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Updates a draft by
         * @function update
         * @param id
         * @param {object} data
         * @returns {promise}
         */
        function update(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'drafts/' + id, data)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
        /**
         * Update the selected array
         * @function modifySelectArray
         */
        function modifySelectArray(draft,selectedArray){
            if(draft.selected){
                selectedArray.push(draft.id);
            }
            else{
                for(var i = 0; i < selectedArray.length; i++){
                    if(draft.id === selectedArray[i]){
                        selectedArray.splice(i,1);
                        break;
                    }
                }
            }
        }
        /**
         * Select all drafts
         * @function selectAll
         */
        function selectAll(draftsArray,selectedArray, isAllSelected){
            for(var i = 0; i < draftsArray.length; i++){
                draftsArray[i].selected = isAllSelected;
                modifySelectArray(draftsArray[i],selectedArray);
            }
        }

        /**
         * Open draft in instance window
         * @param draft
         */
        function openDraft(draft, callbackFunctions){
            InstancesWindowService.openWindow({
                action: 'create',
                widgetId: draft.widgetId,
                title: draft.widgetName,
                draftId: draft.id,
                navFunctions: callbackFunctions
            });
        }
    }])
;

angular.module('cerberus.account')
    .controller('OrganizationsAuditsCtrl', ["kendo", "_", "moment", "$scope", "authToken", "orgId", "workspaceId", "OrganizationsService", function OrganizationsAuditsCtrl(kendo, _, moment, $scope, authToken, orgId, workspaceId, OrganizationsService) {
        $scope.activeRoute = 'audits';
        $scope.orgId = orgId;
        $scope.orgData = {};
        $scope.auditDataSource = new kendo.data.DataSource({
            type: 'odata',
            transport:{
                read: {
                    url: '/server/rest/v1/organizations/' + orgId + '/rest/audit/odata.svc',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authentication', 'Bearer ' + authToken);
                        xhr.setRequestHeader('WSID', workspaceId);
                    },
                    dataType: 'json'
                }
            },
            serverFiltering: true,
            serverPaging: true,
            serverSorting: true,
            pageSize: 200,
            schema: {
                model: {
                    fields: {
                        id:{type: 'string'},
                        date:{type: 'date', parse: parseDateField},
                        remote_addr:{type: 'string'},
                        http_verb:{type: 'string'},
                        path:{type: 'string'},
                        http_response_status_code:{type: 'string'},
                        user_name:{type: 'string'},
                        user_email:{type: 'string'},
                        user_id:{type: 'string'},
                        http_user_agent:{type: 'string'},
                        request_body:{type: 'string', parse: parseRequestBody}
                    }
                }
            }
        });

        $scope.auditGridOptions = {
            columnMenu: true,
            columns:  [
                {width: 120, field: 'user_name', title:'Name'},
                {width: 144, field: 'user_email', title:'Email'},
                {width: 140, field: 'date', title:'Date', format: "{0:g}"},
                {width: 80, field: 'http_verb', title:'HTTP Verb'},
                {width: 360, field: 'path', title:'URL'},
                {width: 80, field: 'http_response_status_code', title:'Response Status Code'},
                {width: 120, field: 'remote_addr', title:'IP Address'},
                {width: 360, field: 'http_user_agent', title:'User Agent'},
                {width: 360, field: 'request_body', title:'Request Body'}
            ],
            dataSource: $scope.auditDataSource,
            filterable: true,
            mobile: true,
            navigatable: true,
            pageable: true,
            reorderable: true,
            resizable: true,
            sortable: true,
            scrollable: true,
            groupable: true,
            selectable: 'row',
            excel: {
                allPages: false,
                fileName: 'Audit-Log.xlsx'
            }
        };

        $scope.exportAuditLog = exportAuditLog;

        init();

        $scope.$on('$locationChangeStart', function (e) {
            if (!e.defaultPrevented) {
                if ($scope.auditGrid) {
                    $scope.auditGrid.destroy();
                    $scope.auditGrid = null;
                }
            }    
        });

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });
        }

        function parseDateField(value){
            var dateValue = moment(value, 'MMMM, DD YYYY HH:mm:ss');
            return dateValue.toDate();
        }

        function parseRequestBody(value){
            if(!_.isString(value)){
                return angular.toJson(value);
            }

            return value;
        }

        function exportAuditLog(auditGrid){
            if(auditGrid){
                auditGrid.saveAsExcel();
            }
        }
    }])
;
angular.module('cerberus.account')
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/organizations/:id/settings', {
            templateUrl: 'account/organizations/settings.tpl.html',
            controller: 'OrganizationsSettingsCtrl',
            title: 'Organization Settings',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/profile', {
            templateUrl: 'account/organizations/profile.tpl.html',
            controller: 'OrganizationsProfileCtrl',
            title: 'Organization Profile',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/users', {
            templateUrl: 'account/organizations/users.tpl.html',
            controller: 'OrganizationsUsersCtrl',
            controllerAs: 'vm',
            title: 'Organization Users',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                userId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.id;
                    });
                }]
            }
        });
        $routeProvider.when('/organizations/:orgId/settings/users/:id', {
            templateUrl: 'account/organizations/users-details.tpl.html',
            controller: 'OrganizationsUsersDetailsCtrl',
            controllerAs: 'vm',
            title: 'Organization User Details',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.orgId;
                }],
                userId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/groups', {
            templateUrl: 'account/organizations/groups.tpl.html',
            controller: 'OrganizationsGroupsCtrl',
            title: 'Organization Groups',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/groups/create', {
            templateUrl: 'account/organizations/groups-create.tpl.html',
            controller: 'OrganizationsGroupsCreateCtrl',
            controllerAs: 'vm',
            title: 'Create Organization Group',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/groups/:id2', {
            templateUrl: 'account/organizations/groups-details.tpl.html',
            controller: 'OrganizationsGroupsDetailsCtrl',
            controllerAs: 'vm',
            title: 'Organization Group Details',
            resolve:{
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                groupId: ["$route", function($route){
                    return $route.current.params['id2'];
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/audits', {
            templateUrl: 'account/organizations/audits.tpl.html',
            controller: 'OrganizationsAuditsCtrl',
            title: 'Organization Audits',
            resolve: {
                _wait: 'WaitForUserData',
                authToken: ["$rootScope", "WaitForUserData", function($rootScope, WaitForUserData){
                    return WaitForUserData.then(function () {
                        return $rootScope.authToken;
                    });
                }],
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                workspaceId: ["$rootScope", "WaitForUserData", function($rootScope, WaitForUserData){
                    return WaitForUserData.then(function () {
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/workspaces', {
            templateUrl: 'account/organizations/workspaces.tpl.html',
            controller: 'OrganizationsWorkspacesCtrl',
            title: 'Organization Workspaces',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/workspaces/create', {
            templateUrl: 'account/organizations/workspaces-create.tpl.html',
            controller: 'OrganizationsWorkspacesCreateCtrl',
            title: 'Create Organization Workspace',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/workspaces/:id2', {
            templateUrl: 'account/organizations/workspaces-details.tpl.html',
            controller: 'OrganizationsWorkspacesDetailsCtrl',
            title: 'Organization Workspace Details',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                workspaceId: ["$route", function($route){
                    return $route.current.params['id2'];
                }]
            }
        });

        $routeProvider.when('/organizations/:id/settings/mail-servers', {
            templateUrl: 'account/organizations/mail-servers.tpl.html',
            controller: 'OrganizationsMailServersCtrl',
            title: 'Organization Mail Servers',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });

        $routeProvider.when('/organizations/:id/settings/mail-servers/create', {
            templateUrl: 'account/organizations/mail-servers-create.tpl.html',
            controller: 'OrganizationsMailServersCreateCtrl',
            title: 'Create Organization Mail Server',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/organizations/:id/settings/mail-servers/:serverId', {
            templateUrl: 'account/organizations/mail-servers-details.tpl.html',
            controller: 'OrganizationsMailServersDetailsCtrl',
            title: 'Organization Mail Server Details',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                serverId: ["$route", function($route){
                    return $route.current.params.serverId;
                }]
            }
        });

        $routeProvider.when('/organizations/:id/settings/media-library', {
            templateUrl: 'account/organizations/media-library.tpl.html',
            controller: 'OrganizationsMediaLibraryCtrl',
            title: 'Organization Media Library',
            resolve: {
                _wait: 'WaitForUserData',
                authToken: ["$rootScope", function($rootScope) {
                    return $rootScope.authToken;
                }],
                orgId:["$route", function($route) {
                    return $route.current.params.id;
                }],
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope) {
                    return WaitForUserData.then(function () {
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });

        $routeProvider.when('/organizations/:id/settings/file/:fileId', {
            templateUrl: 'account/organizations/file-details.tpl.html',
            controller: 'OrganizationsFileDetailsCtrl',
            title: 'Organization File Details',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route) {
                    return $route.current.params.id;
                }],
                fileId: ["$route", function($route) {
                    return $route.current.params.fileId;
                }]
            }
        });

        $routeProvider.when('/organizations/create', {
            templateUrl: 'account/organizations/organizations-create.tpl.html',
            controller: 'OrganizationsCreateCtrl',
            title: 'Create Organization',
            resolve: {
                _wait: 'WaitForUserData',
                defaultDomain: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope) {
                    return WaitForUserData.then(function () {
                        return $rootScope.userData.defaultDomain;
                    });
                }]
            }
        });

        $routeProvider.when('/organizations/:id/settings/workspaces/profile', {
            templateUrl: 'account/organizations/workspaces-details.tpl.html',
            controller: 'OrganizationsCurrentWorkspaceDetailsCtrl',
            title: 'Current Workspace Details',
            resolve: {
                _wait: 'WaitForUserData',
                orgId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                workspaceData: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function () {
                        return $rootScope.userData.currentWorkspace;
                    });
                }]
            }
        });

    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsCreateCtrl', ["$scope", "$location", "defaultDomain", "DesignerUtilityService", "OrganizationsService", function OrganizationsCreateCtrl($scope, $location, defaultDomain, DesignerUtilityService, OrganizationsService) {
    $scope.defaultDomain = defaultDomain;
    $scope.origData = {};
    $scope.tempData = {};
    $scope.workspaceObject = {};

    $scope.clearLogo = _clearLogo;
    $scope.nameToPath = _nameToPath;
    $scope.hasChanges = _hasChanges;
    $scope.submit = _submit;
    $scope.cancel = _cancel;

    _init();

    function _init(){
        _clearLogo();
    }

    function _clearLogo(){
        $scope.tempData.logo = '';
        $scope.imageSrc = null;
    }
    function _nameToPath(name){
        if(name){
            $scope.workspaceObject.path = DesignerUtilityService.labelToUniqueId(name, []);
        }
    }

    function _hasChanges() {
        return !angular.equals($scope.origData, $scope.tempData);
    }

    function _submit(isValid, data, workspaceData){
        if(isValid){
            data.workspaceData = workspaceData;
            OrganizationsService.create(data).then(function(){
                $location.url('users/settings/organizations');
            });
        }
    }

    function _cancel(){
        $location.url('users/settings/organizations');
    }
}]);
angular.module('cerberus.account')
    .controller('OrganizationsFileDetailsCtrl', ["kendo", "$scope", "$location", "fileId", "orgId", "OrganizationsService", function(kendo, $scope, $location, fileId, orgId, OrganizationsService){
        $scope.pageTitle = 'File Details';
        $scope.activeRoute = 'media-library';
        $scope.fileId = fileId;
        $scope.orgId = orgId;
        $scope.orgData = {};
        $scope.temp = {};
        $scope.orig = {};
        $scope.uploadDate = '';
        $scope.url = '';

        $scope.isUnchanged = angular.equals;
        $scope.submit = _submit;
        $scope.cancel = _cancel;

        _init();

        function _init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            OrganizationsService.getAsset(orgId, fileId).then(function(file){
                var fileData = file.data;
                var path = fileData.path;
                delete fileData.path;

                $scope.temp = angular.copy(fileData);
                $scope.orig = angular.copy(fileData);

                $scope.uploadDate = _parseDate(fileData);
                $scope.path = path;
                $scope.url = $location.host() + path;
            });
        }

        function _submit(valid, fileData){
            if(valid && !angular.equals(fileData, $scope.orig)){
                var data = {
                    data: fileData,
                    type: "File"
                };

                OrganizationsService.updateAsset(orgId, fileId, data).then(_cancel);
            }
        }

        function _cancel(){
            $location.url('/organizations/' + $scope.orgId + '/settings/media-library');
        }

        function _parseDate(file){
            //var iso = file.uploadDate.replace(' ', 'T') + 'Z';
			var iso = file.uploadDate;
            var date = new Date(iso);

            return kendo.format('{0:G}', date);
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsGroupsCtrl', ["_", "$scope", "$location", "orgId", "OrganizationsService", "organizationGroupsService", function OrganizationsGroupsCtrl(_, $scope, $location, orgId, OrganizationsService, organizationGroupsService) {
        $scope.activeRoute = 'groups';
        $scope.orgId = orgId;
        $scope.orgData = {};
        $scope.groups = [];
        $scope.records = { 'checked': false, items: {} };
        $scope.deleteGroup = function(){
            var idArray = _.keys($scope.records.items);
            if(idArray.length > 0){
                organizationGroupsService.deleteGroups(idArray).then(init);
            }
        };
        $scope.openGroup = function(id){
            if(id){
                $location.url('organizations/' + $scope.orgId + '/settings/groups/' + id);
            }
            else {
                $location.url('organizations/' + $scope.orgId + '/settings/groups/create');
            }
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            organizationGroupsService.getGroups(orgId).then(function(data){
                $scope.groups = data;
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsGroupsCreateCtrl', ["$scope", "$location", "OrganizationsService", "organizationGroupsService", "orgId", function OrganizationsGroupsCreateCtrl(
        $scope, $location, OrganizationsService, organizationGroupsService, orgId) {
        var vm = this;

        $scope.activeRoute = 'groups';
        $scope.orgData = {};
        $scope.orgId = orgId;

        vm.tempGroupModel = organizationGroupsService.groupModel();
        vm.origGroupModel = angular.copy(vm.tempGroupModel);

        vm.selectedMembers = {};
        vm.selectedMemberOf = {};
        vm.availableMembersDs = null;
        vm.availableMemberOfDs = null;
        vm.membersSelectOptions = {
            placeholder: 'Enter users/groups here...',
            dataTextField: 'name'
        };
        vm.memberOfSelectOptions = {
            placeholder: 'Enter group(s) here...',
            dataTextField: 'name'
        };

        vm.add = organizationGroupsService.addItem;
        vm.remove = organizationGroupsService.removeItem;
        vm.isUnchanged = organizationGroupsService.isUnchanged;
        vm.submit = function(isValid, data){
            if(isValid){
                organizationGroupsService.createOrgGroup(orgId, data.details).then(function(value){
                    $location.url('organizations/' + orgId + '/settings/groups/' + value);
                });
            }
        };

        vm.cancel = function(){
            $location.url('organizations/' + orgId + '/settings/groups');
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsGroupsDetailsCtrl', ["$scope", "kendo", "$location", "toaster", "OrganizationsService", "organizationGroupsService", "groupId", "orgId", function OrganizationsGroupsDetailsCtrl(
        $scope, kendo, $location, toaster, OrganizationsService, organizationGroupsService, groupId, orgId) {
        var vm = this;

        $scope.activeRoute = 'groups';
        $scope.orgData = {};
        $scope.orgId = orgId;
        vm.groupId = groupId;

        vm.tempGroupModel = organizationGroupsService.groupModel();
        vm.origGroupModel = angular.copy(vm.tempGroupModel);

        vm.selectedMembers = {};
        vm.selectedMemberOf = {};
        vm.availableMembersDs = null;
        vm.availableMemberOfDs = null;
        vm.membersSelectOptions = {
            placeholder: 'Enter users/groups here...',
            dataTextField: 'name'
        };
        vm.memberOfSelectOptions = {
            placeholder: 'Enter group(s) here...',
            dataTextField: 'name'
        };

        vm.add = organizationGroupsService.addItem;
        vm.remove = organizationGroupsService.removeItem;
        vm.isUnchanged = organizationGroupsService.isUnchanged;
        vm.submit = function(isValid, data){
            if(isValid){
                organizationGroupsService.updateOrganizationGroup(groupId, data, vm.origGroupModel).then(function(){
                    toaster.pop('success', 'Group updated.');
                    $location.url('organizations/' + orgId + '/settings/groups');
                });
            }
        };

        vm.cancel = function(){
            $location.url('organizations/' + orgId + '/settings/groups');
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            organizationGroupsService.getGroupDetails(vm.groupId).then(function(data){
                vm.tempGroupModel.details = data;
                vm.origGroupModel = angular.copy(vm.tempGroupModel);
            });

            organizationGroupsService.getMembers(vm.groupId).then(function(data){
                vm.tempGroupModel.members.current = data;
                vm.origGroupModel = angular.copy(vm.tempGroupModel);
            });

            organizationGroupsService.getMemberOf(vm.groupId).then(function(data){
                vm.tempGroupModel.memberOf.current = data;
                vm.origGroupModel = angular.copy(vm.tempGroupModel);
            });

            organizationGroupsService.getAvailableMembers(orgId, vm.groupId).then(function(data){
                vm.availableMembersDs = new kendo.data.ObservableArray(data);
            });

            organizationGroupsService.getAvailableMemberOf(orgId, vm.groupId).then(function(data){
                vm.availableMemberOfDs = new kendo.data.ObservableArray(data);
            });
        }
    }])
;
angular.module('cerberus.account')

    .factory('organizationGroupsService', ["_", "$http", "$q", "$location", "apiPath", "toaster", function organizationGroupsService(_, $http, $q, $location, apiPath, toaster) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';

        return {
            getMembers:getMembers,
            getMemberOf: getMemberOf,
            getGroupDetails:getGroupDetails,
            getAvailableMembers: getAvailableMembers,
            getAvailableMemberOf: getAvailableMemberOf,
            createOrgGroup: createOrgGroup,
            getGroups: getGroups,
            deleteGroup: deleteGroup,
            deleteGroups: deleteGroups,
            addItem: addItem,
            removeItem: removeItem,
            isUnchanged: isUnchanged,
            updateDetails: updateDetails,
            updateMembers: updateMembers,
            updateMemberOf: updateMemberOf,
            updateOrganizationGroup: updateOrganizationGroup,
            groupModel: groupModel
        };
        ////////////////////

        function groupModel(){
            return {
                details: null,
                members: {
                    current: [],
                    add: [],
                    remove: [],
                    input: []
                },
                memberOf:{
                    current: [],
                    add: [],
                    remove: [],
                    input: []
                }
            };
        }

        function getGroups(orgId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + orgId + '/groups')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function createOrgGroup(id, data){
            var deferred = $q.defer();
            $http.post(apiPath + 'organizations/' + id + '/groups', data)
                .success(function (value) {
                    toaster.pop('success', 'Group created.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function deleteGroup(id){
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'groups/' + id})
                .success(function(value){
                    deferred.resolve(value);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function deleteGroups(idArray){
            var promises = [];
            for(var i = 0; i < idArray.length; i++){
                promises.push(deleteGroup(idArray[i]));
            }
            return $q.all(promises).then(function(){
                toaster.pop('info', 'Group(s) deleted.');
            });
        }

        function getMemberOf(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'groups/' + id + '/memberOf')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getMembers(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'groups/' + id + '/members')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getGroupDetails(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'groups/' + id)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getAvailableMemberOf(orgId,groupId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + orgId + '/groups/' + groupId + '/available/memberOf')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getAvailableMembers(orgId,groupId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + orgId + '/groups/' + groupId + '/available/members')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function addItem(model,ds) {
            for (var i = 0; i < model.input.length; i++) {
                model.current.push(model.input[i]);
                /* LODASH Version 4 ONLY */
                //var idx = _.findIndex(model.remove, ['id', model.input[i].id]);
                /* NON LODASH OPTION - JAVA NATIVE STYLE */
                var idx = model.remove.map(function(e){ return e.id; }).indexOf(model.input[i].id);
                if (idx > -1) {
                    model.remove.splice(idx, 1);
                }
                else {
                    model.add.push(model.input[i]);
                }
                removeFromArray(ds, model.input[i].id);
            }
            model.input = [];
        }

        function removeItem(model,selected,ds){
            angular.forEach(selected,function(v,k){
                if(v){
                    /* LODASH Version 4 ONLY */
                    //var foundIndex = _.findIndex(model.current, ['id', k]);
                    //var findAddIdx = _.findIndex(model.add, ['id', k]);
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    var foundIndex = _.findIndex(model.current, function(f){return f.id === k;});
                    var findAddIdx = _.findIndex(model.add, function(f){return f.id === k;});
                    if(findAddIdx > -1){
                        model.add.splice(findAddIdx,1);
                    }
                    else{
                        model.remove.push(model.current[foundIndex]);
                    }
                    ds.push(model.current[foundIndex]);
                    model.current.splice(foundIndex,1);
                    selected[k] = false;
                }
            });
        }

        function isUnchanged(temp, orig){
            var isEqualGroup = angular.equals(temp.details, orig.details);
            var isEqualMembers = angular.equals(temp.members.current, orig.members.current);
            var isEqualMemberOf = angular.equals(temp.memberOf.current, orig.memberOf.current);
            return (isEqualGroup && isEqualMembers && isEqualMemberOf);
        }

        function updateMemberOf(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'groups/' + id + '/memberOf', data)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function updateMembers(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'groups/' + id + '/members', data)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function updateDetails(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'groups/' + id, data)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function updateOrganizationGroup(groupId, data, orig){
            var promises = [];

            //Update name and description
            if(!angular.equals(data.details, orig.details)){
                promises.push(
                    updateDetails(groupId, data.details)
                );
            }

            //Updating members
            if(!angular.equals(data.members.current, orig.members.current)){
                promises.push(
                    updateMembers(groupId,{add:data.members.add, remove:data.members.remove})
                );
            }

            //Updating member of
            if(!angular.equals(data.memberOf.current, orig.memberOf.current)){
                promises.push(
                    updateMemberOf(groupId,{add:data.memberOf.add, remove:data.memberOf.remove})
                );
            }

            return $q.all(promises);
        }

        function removeFromArray(array,id){
            for(var i = 0; i < array.length; i++){
                if(array[i].id === id){
                    array.splice(i,1);
                }
            }
        }
    }])
;

angular.module('cerberus.account')
    .controller('OrganizationsMailServersCtrl', ["$scope", "$location", "orgId", "OrganizationsService", function OrganizationsMailServersCtrl($scope, $location, orgId, OrganizationsService) {
        $scope.pageTitle = 'Mail Servers';
        $scope.activeRoute = 'mail-servers';
        $scope.orgId = orgId;
        $scope.orgData = {};
        $scope.servers = [];
        $scope.predicate1 = '';

        $scope.openMailServer = _openMailServer;
        $scope.deleteMailServer = _deleteMailServer;

        _init();

        function _init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            OrganizationsService.getAllAssets(orgId, 'Mail Server').then(function(servers){
                $scope.servers = servers;
            });
        }

        function _openMailServer(id){
            if(id){
                $location.url('/organizations/' + orgId + '/settings/mail-servers/' + id);
            }
            else {
                $location.url('/organizations/' + orgId + '/settings/mail-servers/create');
            }
        }

        function _deleteMailServer(id, index){
            OrganizationsService.deleteAsset(orgId, id).then(function(){
                $scope.servers.splice(index, 1);
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsMailServersCreateCtrl', ["$scope", "$location", "orgId", "OrganizationsService", "usersProfileService", function OrganizationsMailServersCreateCtrl($scope, $location, orgId, OrganizationsService, usersProfileService) {
        $scope.pageTitle = 'New Mail Server';
        $scope.activeRoute = 'mail-servers';
        $scope.orgId = orgId;
        $scope.orgData = {};
        $scope.masterServer = {
            data: {
                protocol: 'HTTP',
                ssl: false,
                tls: false,
                priority: "Normal",
                serverVersion: '2007',
                type: 'exchange'
            }
        };
        $scope.server = angular.copy($scope.masterServer);
        $scope.verifyHtml = '<span class="text-warning">Unverified</span>';
        $scope.versions = [
            {display: "2003"},
            {display: "2007"},
            {display: "2010"}
        ];

        $scope.isUnchanged = _isUnchanged;
        $scope.submit = _submit;
        $scope.cancel = _close;
        $scope.verifyConn = _verifyConn;

        _init();

        function _init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });
        }

        function _isUnchanged(server){
            return angular.equals(server, $scope.masterServer);
        }

        function _submit(isValid, server){
            if(isValid){
                var data = {
                    data: server,
                    type: "Mail Server"
                };

                OrganizationsService.createAsset(orgId, data).then(_close);
            }
        }

        function _close(){
            $location.url('/organizations/' + orgId + '/settings/mail-servers');
        }

        function _verifyConn(){
            $scope.verifyHtml = '<i class="fa fa-spinner"></i>';
            usersProfileService.verifyMailServerConnection($scope.server).then(function(data){
                if(data){
                    $scope.verifyHtml = '<span class="text-success">Success</span>';
                }
                else{
                    $scope.verifyHtml = '<span class="text-danger">Failed</span>';
                }
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsMailServersDetailsCtrl', ["$scope", "$location", "orgId", "serverId", "OrganizationsService", "usersProfileService", function OrganizationsMailServersDetailsCtrl($scope, $location, orgId, serverId, OrganizationsService, usersProfileService) {
        $scope.pageTitle = 'Mail Server Details';
        $scope.activeRoute = 'mail-servers';
        $scope.orgId = orgId;
        $scope.serverId = serverId;
        $scope.orgData = {};
        $scope.masterServer = {};
        $scope.server = {};
        $scope.verifyHtml = '<span class="text-warning">Unverified</span>';
        $scope.versions = [
            {display: "2003"},
            {display: "2007"},
            {display: "2010"}
        ];

        $scope.isUnchanged = _isUnchanged;
        $scope.submit = _submit;
        $scope.cancel = _close;
        $scope.verifyConn = _verifyConn;

        _init();

        function _init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            OrganizationsService.getAsset(orgId, serverId).then(function(server){
                $scope.masterServer = angular.copy(server.data);
                $scope.server = angular.copy(server.data);
            });
        }

        function _isUnchanged(server){
            return angular.equals(server, $scope.masterServer);
        }

        function _submit(isValid, server){
            if(isValid){
                var data = {
                    data: server,
                    type: "Mail Server"
                };

                OrganizationsService.updateAsset(orgId, serverId, data).then(_close);
            }
        }

        function _close(){
            $location.url('/organizations/' + orgId + '/settings/mail-servers');
        }

        function _verifyConn(){
            $scope.verifyHtml = '<i class="fa fa-spinner"></i>';
            usersProfileService.verifyMailServerConnection($scope.server).then(function(data){
                if(data){
                    $scope.verifyHtml = '<span class="text-success">Success</span>';
                }
                else{
                    $scope.verifyHtml = '<span class="text-danger">Failed</span>';
                }
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsMediaLibraryCtrl', ["_", "kendo", "$scope", "$timeout", "$location", "apiPath", "authToken", "orgId", "workspaceId", "OrganizationsService", function(_, kendo, $scope, $timeout, $location, apiPath, authToken, orgId, workspaceId, OrganizationsService){
        $scope.pageTitle = 'Media Library';
        $scope.activeRoute = 'media-library';
        $scope.orgId = orgId;
        $scope.orgData = {};
        $scope.allSelected = false;
        $scope.selected = [];

        $scope.dataSource = new kendo.data.DataSource({
            transport: {
                read: function(e){
                    OrganizationsService.getAllAssets(orgId, 'File').then(function(files){
                        var fileData = [];

                        _.forEach(files, function(asset){
                            var data = asset.data;
                            data.id = asset.id;

                            fileData.push(data);
                        });

                        e.success(fileData);
                    });
                }
            }
        });

        $scope.mediaGridOptions = {
            columns: [
                {
                    headerTemplate: '<input type="checkbox" class="form-control" ng-checked="allSelected" ng-click="selectAll()" />',
                    template: '<input type="checkbox" class="form-control" ng-checked="selected.indexOf(\'#: id #\') >= 0" ng-click="toggleSelected(\'#: id #\')" />',
                    width: 30
                },
                {
                    title: 'File',
                    template: '<div style="height:100px;" nim-file-thumb="#: path #"></div>'
                },
                {
                    title: 'Author',
                    field: 'uploadBy'
                },
                {
                    title: 'Description',
                    field: 'description'
                },
                {
                    title: 'Upload Date',
                    template: _dateTemplate
                },
                {
                    template: '<button class="btn btn-danger" ng-click="deleteFile(\'#: id #\')"><i class="fa fa-trash"></i>&nbsp;Remove</button>',
                    width: 100
                }
            ],
            dataSource: $scope.dataSource,
            selectable: true,
            change: function(e){
                var row = e.sender.select();
                var dataItem = e.sender.dataItem(row);

                $timeout(function(){
                    _editFile(dataItem.id);
                });
            }
        };

        $scope.uploadOptions = {
            async:{
                saveUrl: apiPath + '/organizations/' + orgId + '/assets',
                autoUpload: true
            },
            localization: {
                dropFilesHere: 'Drop files here to start the upload.',
                select: '<span class="fa fa-plus"></span> Add New'
            },
            multiple: false,
            showFileList: false,
            upload: function(e){
                e.data = {
                    type: 'File'
                };

                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener("readystatechange", function () {
                        if (xhr.readyState == 1) {
                            xhr.setRequestHeader('Authentication','Bearer ' + authToken);
                            xhr.setRequestHeader('WSID', workspaceId);
                            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest ');
                        }
                    });
                }
            },
            success: function() {
                $timeout(function(){
                    $scope.selected = [];
                    $scope.allSelected = false;
                    $scope.dataSource.read();
                });
            }
        };

        $scope.toggleSelected = _toggleSelected;
        $scope.selectAll = _selectAll;
        $scope.deleteFile = _deleteFile;
        $scope.batchDelete = _batchDelete;

        _init();

        function _init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });
        }

        function _toggleSelected(fileId){
            var index = $scope.selected.indexOf(fileId);

            if(index >= 0){
                _.pullAt($scope.selected, index);
            }
            else {
                $scope.selected.push(fileId);
            }

            _checkSelected();
        }

        function _selectAll(){
            if($scope.allSelected){
                $scope.allSelected = false;
                $scope.selected = [];
            }
            else {
                var data = _.result($scope.dataSource, 'data');
                var files = _.result (data, 'toJSON', []);

                $scope.allSelected = true;
                $scope.selected = _.map(files, 'id');
            }
        }

        function _checkSelected(){
            $scope.allSelected = $scope.selected.length === $scope.dataSource.total();
        }

        function _dateTemplate(dataItem){
            //var iso = file.uploadDate.replace(' ', 'T') + 'Z';
			var iso = dataItem.uploadDate; 
            var date = new Date(iso);

            return kendo.format('{0:G}', date);
        }

        function _deleteFile(fileId){
            OrganizationsService.deleteAsset(orgId, fileId).then(function(){
                $timeout(function(){
                    $scope.selected = [];
                    $scope.allSelected = false;
                    $scope.dataSource.read();
                });
            });
        }

        function _batchDelete(){
            if($scope.selected.length > 0){
                var ids = $scope.selected.join(',');
                _deleteFile(ids);
            }
        }

        function _editFile(fileId){
            $location.url('/organizations/' + orgId + '/settings/file/' + fileId);
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsProfileCtrl', ["$scope", "$window", "orgId", "OrganizationsService", function OrganizationsProfileCtrl($scope, $window, orgId, OrganizationsService) {
        $scope.activeRoute = 'profile';
        $scope.orgId = orgId;
        $scope.orgData = {};
        $scope.tempData = {};
        $scope.origData = {};

        $scope.clearLogo = function(){
            $scope.tempData.logo = '';
            $scope.imageSrc = null;
        };
        $scope.submit = function(isValid, data){
            if(isValid){
                OrganizationsService.update($scope.orgId, data).then(function(){
                    _init();
                });
            }
        };
        $scope.hasChanges = function () {
            return !angular.equals($scope.origData, $scope.tempData);
        };
        $scope.cancel = function(){
            $window.history.back();
        };

        _init();

        function _init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
                $scope.tempData = angular.copy(orgData);
                $scope.origData = angular.copy(orgData);
            });
        }
    }])
;
angular.module('cerberus.account')
    .factory('OrganizationsService', ["_", "$http", "$q", "apiPath", "toaster", function OrganizationsService(_, $http, $q, apiPath, toaster) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            getUserOrganizations: function () {
                var deferred = $q.defer();
                $http.get(apiPath + 'users/organizations')
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            get: function () {
                var deferred = $q.defer();
                $http.get(apiPath + 'users/organizations')
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            create: function (data) {
                var deferred = $q.defer();
                $http.post(apiPath + 'organizations', data)
                    .success(function (value) {
                        toaster.pop('success', 'Organzation created.');
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            getDetails: function (id) {
                var deferred = $q.defer();
                $http.get(apiPath + 'organizations/' + id)
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            update: function (id, data) {
                var deferred = $q.defer();
                $http.put(apiPath + 'organizations/' + id, data)
                    .success(function (value) {
                        toaster.pop('success', 'Organzation updated.');
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            getOrganizationWorkspaces: function (id) {
                var deferred = $q.defer();
                $http.get(apiPath + 'users/organizations/' + id + '/workspaces')
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            disableUsers: function (orgId, userIds) {
                var deferred = $q.defer();
                $http.put(apiPath + 'organizations/' + orgId + '/users/disable', userIds)
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            enableUsers: function (orgId, userIds) {
                var deferred = $q.defer();
                $http.put(apiPath + 'organizations/' + orgId + '/users/' + userIds + '/enable')
                    .success(function (value) {
                        toaster.pop('success', 'User Enabled');
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            remove: function (orgId, userIds) {
                var deferred = $q.defer();
                $http({ method: 'DELETE', url: apiPath + 'organizations/' + orgId + '/users/' + userIds })
                    .success(function (value) {
                        toaster.pop('info', 'User Removed');
                        deferred.resolve(value);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            createAsset: function (id, data) {
                var deferred = $q.defer();
                $http.post(apiPath + 'organizations/' + id + '/assets', data)
                    .success(function (value) {
                        toaster.pop('success', 'Created.');
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            getAllAssets: function (id, type) {
                var deferred = $q.defer();
                $http.get(apiPath + 'organizations/' + id + '/assets?type=' + type)
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            getAsset: function (orgId, id) {
                var deferred = $q.defer();
                $http.get(apiPath + 'organizations/' + orgId + '/assets/' + id)
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            updateAsset: function (orgId, id, data) {
                var deferred = $q.defer();
                $http.put(apiPath + 'organizations/' + orgId + '/assets/' + id, data)
                    .success(function (value) {
                        toaster.pop('success', 'Updated.');
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            },
            deleteAsset: function (orgId, id) {
                var deferred = $q.defer();
                $http({ method: 'DELETE', url: apiPath + 'organizations/' + orgId + '/assets/' + id })
                    .success(function (value) {
                        toaster.pop('info', 'Deleted');
                        deferred.resolve(value);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            }
        };
    }])
;

angular.module('cerberus.account')
    .controller('OrganizationsSettingsCtrl', ["$scope", "orgId", "OrganizationsService", function OrganizationsSettingsCtrl($scope, orgId, OrganizationsService) {
        $scope.orgId = orgId;
        $scope.orgData = {};

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsUsersCtrl', ["$scope", "$location", "statusList", "orgId", "userId", "ConfirmModalService", "OrganizationsService", "organizationUsersService", function OrganizationsUsersCtrl($scope, $location, statusList, orgId, userId,
                                                                          ConfirmModalService, OrganizationsService, organizationUsersService) {
        var vm = this;
        $scope.activeRoute = 'users';
        $scope.orgId = orgId;
        $scope.orgData = {};

        vm.usersArray = [];
        vm.statusList = statusList;
        vm.currentUserId = userId;
        vm.selectedUsers = {
            checked: false,
            users:{}
        };
        vm.userEmailsBatch = null;
        vm.userEmails = null;
        vm.addUsers = function(emails){
            organizationUsersService.addUsers($scope.orgId, {userEmails:emails}).then(function(){
                init();
            });
        };
        vm.removeUsers = function(data){
            var users = parseSelected(data.users);
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to remove these users from the organization?',
                actionButtonText: 'Remove',
                closeButtonText: 'Cancel',
                check: function(){
                    return true;
                },
                confirm: function(){
                    return organizationUsersService.removeUsers($scope.orgId, users);
                },
                callback: function(){
                    init();
                }
            });
        };
        vm.enableUsers = function(data){
            var users = parseSelected(data.users);
            organizationUsersService.enableUsers($scope.orgId, {userIds:users}).then(function(){
                init();
            });
        };
        vm.disableUsers = function(data){
            var users = parseSelected(data.users);
            organizationUsersService.disableUsers($scope.orgId, {userIds:users}).then(function(){
                init();
            });
        };

        vm.goToUser = function(id){
            $location.url('organizations/' + $scope.orgId + '/settings/users/' + id);
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            organizationUsersService.getUsers(orgId).then(function(data){
                vm.usersArray = data;
            });
        }

        function parseSelected(sel){
            var idArray = [];
            angular.forEach(sel,function(v,k){
                if(v){
                    idArray.push(k);
                }
            });
            return idArray;
        }
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsUsersDetailsCtrl', ["$scope", "kendo", "$location", "orgId", "userId", "OrganizationsService", "organizationGroupsService", "organizationUsersService", "UsersService", "usersProfileService", function OrganizationsUsersDetailsCtrl($scope, kendo, $location, orgId, userId,
                                                                                        OrganizationsService, organizationGroupsService,
                                                                                        organizationUsersService, UsersService, usersProfileService) {
        var vm = this;
        $scope.activeRoute = 'users';
        $scope.orgId = orgId;
        $scope.orgData = {};

        vm.userInfo = null;
        vm.userId = userId;
        vm.tempGroupModel = {
            details: null,
            members: {current:[]},
            memberOf:{
                current:[],
                add:[],
                remove:[],
                input:[]
            }
        };
        vm.origGroupModel = angular.copy(vm.tempGroupModel);
        vm.selectedMemberOf = {};
        vm.availableMemberOfDs = null;
        vm.memberOfSelectOptions = {
            placeholder: 'Enter group(s) here...',
            dataTextField: 'name'
        };

        vm.add = organizationGroupsService.addItem;
        vm.remove = organizationGroupsService.removeItem;
        vm.isUnchanged = function(){
            return organizationGroupsService.isUnchanged(vm.tempGroupModel,vm.origGroupModel);
        };
        vm.submit = function(isValid,data){
            if(isValid){
                if(!angular.equals(data.memberOf.current, vm.origGroupModel.memberOf.current)){
                    UsersService.updateMemberOf(vm.userId,{add:data.memberOf.add, remove:data.memberOf.remove}).then(function(){
                        $location.url('organizations/' + $scope.orgId + '/settings/users');
                    });
                }
            }
        };

        vm.cancel = function(){
            $location.url('organizations/' + $scope.orgId + '/settings/users');
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            usersProfileService.getDefaultUserProfile(userId).then(function(data){
               vm.userInfo = data[0].data;
            });

            organizationUsersService.getMemberOf(orgId, userId).then(function(data){
                vm.tempGroupModel.memberOf.current = data;
                vm.origGroupModel = angular.copy(vm.tempGroupModel);
            });

            organizationUsersService.getAvailableMemberOf(orgId, userId).then(function(data){
                vm.availableMemberOfDs = new kendo.data.ObservableArray(data);
            });
        }
    }])
;
angular.module('cerberus.account')

    .factory('organizationUsersService', ["_", "$http", "$q", "apiPath", "toaster", function organizationUsersService(_, $http, $q, apiPath, toaster) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';

        return {
            getUsers: getUsers,
            getAvailableMemberOf: getAvailableMemberOf,
            getMemberOf: getMemberOf,
            addUsers: addUsers,
            removeUsers: removeUsers,
            enableUsers: enableUsers,
            disableUsers: disableUsers
        };
        ////////////////////

        function disableUsers(orgId,data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'organizations/' + orgId + '/users/disable',data)
                .success(function (value) {
                    toaster.pop('info', 'Selected user(s) has been disabled.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function enableUsers(orgId,data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'organizations/' + orgId + '/users/enable',data)
                .success(function (value) {
                    toaster.pop('info', 'Selected user(s) has been enabled.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function removeUsers(orgId,userIds){
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'organizations/' + orgId + '/users/' + userIds})
                .success(function(value){
                    toaster.pop('info', 'User(s) removed.');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function addUsers(orgId,data) {
            var deferred = $q.defer();
            $http.post(apiPath + 'organizations/' + orgId + '/users',data)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                    toaster.pop('success', 'User(s) has been added.');
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getMemberOf(orgId,userId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + orgId + '/users/' + userId + '/memberOf')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getAvailableMemberOf(orgId,userId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + orgId + '/users/' + userId + '/available/memberOf')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getUsers(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'organizations/' + id + '/users')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }])
;

angular.module('cerberus.account')
    .directive('nimOrgAvailable', ["$http", "apiPath", function($http, apiPath) {
        return {
            require : 'ngModel',
            link : function($scope, element, attrs, ngModel) {
                ngModel.$asyncValidators.nimOrgAvailable = function(name) {
                    valid(false);
                    loading(true);
                    return $http.get(apiPath + 'organizations/name/available?name='+ name).then(
                        function(value) {
                            valid(value.data.DATA);
                            loading(false);
                        },
                        function() {
                            valid(false);
                            loading(false);
                        }
                    );
                };
                ////////////////////
                function valid(bool) {
                    ngModel.$setValidity('record-unavailable', bool);
                }

                function loading(bool) {
                    ngModel.$setValidity('record-loading', !bool);
                }
            }
        };
    }])
;
angular.module('cerberus.account')
    .controller('OrganizationsWorkspacesCtrl', ["$scope", "$location", "orgId", "OrganizationsService", function OrganizationsWorkspacesCtrl($scope, $location, orgId, OrganizationsService) {
        $scope.activeRoute = 'workspaces';
        $scope.orgId = orgId;
        $scope.orgData = {};
        $scope.workspaces = [];
        $scope.goToWorkspacesDetails = function(id){
            if(id){
                $location.url('organizations/' + orgId + '/settings/workspaces/' + id);
            }
            else{
                $location.url('organizations/' + orgId + '/settings/workspaces/create');
            }
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            OrganizationsService.getOrganizationWorkspaces(orgId).then(function(workspaces){
                $scope.workspaces = workspaces;
            });
        }
    }])
    .controller('OrganizationsWorkspacesCreateCtrl', ["$scope", "$location", "orgId", "OrganizationsService", "TemplatesServices", "workspacesService", function OrganizationsWorkspacesCreateCtrl($scope, $location, orgId, OrganizationsService, TemplatesServices, workspacesService) {
        $scope.templatesArray = [];
        $scope.activeRoute = 'workspaces';
        $scope.orgData = {};
        $scope.orgId = orgId;
        $scope.tempData = {
            logo: ''
        };
        $scope.origData = angular.copy($scope.tempData);
        $scope.cropStep = 1;
        $scope.clearLogo = function(){
            $scope.tempData.logo = '';
            $scope.imageSrc = null;
        };
        $scope.submit = function(isValid, data){
            if(isValid){
                workspacesService.create(orgId, data).then(function(){
                    $location.url('organizations/' + orgId + '/settings/workspaces');
                });
            }
        };
        $scope.cancel = function(){
            $location.url('organizations/' + orgId + '/settings/workspaces');
        };
        $scope.hasChanges = function () {
            return !angular.equals($scope.origData, $scope.tempData);
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            TemplatesServices.get('Workspace').then(function(templates){
                $scope.templatesArray = templates;
            });
        }
    }])
    .controller('OrganizationsWorkspacesDetailsCtrl', ["_", "$scope", "$location", "orgId", "workspaceId", "OrganizationsService", "workspacesService", function OrganizationsWorkspacesDetailsCtrl(_, $scope, $location, orgId, workspaceId, OrganizationsService, workspacesService) {
        $scope.activeRoute = 'workspaces';
        $scope.orgData = {};
        $scope.orgId = orgId;
        $scope.tempData = {};
        $scope.origData = {};
        $scope.workspaceId = workspaceId;
        $scope.cropStep = 1;
        $scope.usePath = false;
        $scope.clearLogo = function(){
            $scope.tempData.logo = '';
            $scope.imageSrc = null;
        };
        $scope.submit = function(isValid, data){
            if(isValid){
                workspacesService.update(workspaceId, data).then(function(){
                    $location.url('organizations/' + orgId + '/settings/workspaces');
                });
            }
        };
        $scope.cancel = function(){
            $location.url('organizations/' + orgId + '/settings/workspaces');
        };
        $scope.hasChanges = function () {
            return !angular.equals($scope.origData, $scope.tempData);
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });

            workspacesService.get(workspaceId).then(function(workspaceData){
                _.defaults(workspaceData, { logo: '' });

                $scope.tempData = angular.copy(workspaceData);
                $scope.origData = angular.copy(workspaceData);

                $scope.usePath = workspaceData.path || workspaceData.path !== "";
            });
        }
    }])
    .controller('OrganizationsCurrentWorkspaceDetailsCtrl', ["$scope", "$location", "orgId", "workspaceData", "OrganizationsService", "workspacesService", function OrganizationsCurrentWorkspaceDetailsCtrl($scope, $location, orgId, workspaceData, OrganizationsService, workspacesService) {
        $scope.activeRoute = 'workspaces';
        $scope.orgData = {};
        $scope.orgId = orgId;
        $scope.tempData = angular.copy(workspaceData);
        $scope.tempData.logo = $scope.tempData.logo || '';
        $scope.origData = angular.copy(workspaceData);
        $scope.workspaceId = workspaceData.id;
        $scope.cropStep = 1;
        $scope.usePath = workspaceData.path || workspaceData.path !== "";
        $scope.clearLogo = function(){
            $scope.tempData.logo = '';
            $scope.imageSrc = null;
        };
        $scope.submit = function(isValid, data){
            if(isValid){
                workspacesService.update($scope.workspaceId, data).then(function(){
                    $location.url('organizations/' + orgId + '/settings/workspaces');
                });
            }
        };
        $scope.cancel = function(){
            $location.url('organizations/' + orgId + '/settings/workspaces');
        };
        $scope.hasChanges = function () {
            return !angular.equals($scope.origData, $scope.tempData);
        };

        init();

        function init(){
            OrganizationsService.getDetails(orgId).then(function(orgData){
                $scope.orgData = orgData;
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('UsersAddressBookCtrl', ["$scope", "$location", "usersProfileService", function UsersAddressBookCtrl($scope, $location, usersProfileService) {
        $scope.activeRoute = 'address-book';
        $scope.userProfile = [];

        $scope.goToAddressBookDetails = _goToAddressBookDetails;
        $scope.removeAddress = _removeAddress;

        _init();

        function _init(){
            usersProfileService.getAll('Address').then(function(userProfile){
                $scope.userProfile = userProfile;
            });
        }

        function _goToAddressBookDetails(id){
            if(id){
                $location.url('users/settings/address-book/' + id);
            }
            else{
                $location.url('users/settings/address-book/create');
            }
        }

        function _removeAddress(id, index){
            usersProfileService.remove(id).then(function(){
                $scope.userProfile.splice(index, 1);
            });
        }
    }])
    .controller('UsersAddressBookCreateCtrl', ["$scope", "$location", "usersProfileService", "UsersProfileListService", function UsersAddressBookCreateCtrl($scope, $location, usersProfileService, UsersProfileListService) {
        $scope.activeRoute = 'address-book';
        $scope.countries = UsersProfileListService.addressBookCountries();
        $scope.tempData = {
            country: 'United States'
        };
        $scope.origData = angular.copy($scope.tempData);

        $scope.hasChanges = _hasChanges;
        $scope.submit = _submit;

        function _hasChanges(){
            return !angular.equals($scope.origData, $scope.tempData);
        }

        function _submit(isValid, data){
            if(isValid){
                usersProfileService.create({data:data, type:'Address'}).then(function(){
                    $location.url('users/settings/address-book');
                });
            }
        }
    }])
    .controller('UsersAddressBookDetailsCtrl', ["$scope", "$location", "profileId", "usersProfileService", "UsersProfileListService", function UsersAddressBookDetailsCtrl($scope, $location, profileId, usersProfileService, UsersProfileListService) {
        $scope.activeRoute = 'address-book';
        $scope.countries = UsersProfileListService.addressBookCountries();
        $scope.tempData = {};
        $scope.origData = {};

        $scope.hasChanges = _hasChanges;
        $scope.submit = _submit;

        _init();

        function _init(){
            usersProfileService.get(profileId).then(function(addressModel){
                $scope.tempData = angular.copy(addressModel.data);
                $scope.origData = angular.copy(addressModel.data);
            });
        }

        function _hasChanges(){
            return !angular.equals($scope.origData, $scope.tempData);
        }

        function _submit(isValid, data){
            if(isValid){
                usersProfileService.update(profileId, {data: data}).then(function(){
                    $location.url('users/settings/address-book');
                });
            }
        }
    }])
;
angular.module('cerberus.account')
    .controller('UsersApiKeysCtrl', ["$scope", "usersApiKeysService", function UsersApiKeysCtrl($scope, usersApiKeysService) {
        $scope.activeRoute = 'api-keys';
        $scope.userApiKey = [];
        $scope.apiName = null;
        $scope.hosts = null;
        $scope.showCreateRow = false;
        $scope.createdApiKey = null;
        $scope.editItem = null;

        $scope.submit = _submit;
        $scope.removeKey = _removeKey;
        $scope.saveApiKey = _saveApiKey;
        $scope.editApiKey = _editApiKey;
        $scope.cancelEdit = _cancelEdit;

        _init();

        function _init(){
            usersApiKeysService.get().then(function(userApiKeys){
                $scope.userApiKey = userApiKeys;
            });
        }

        function _submit(name, hosts){
            usersApiKeysService.create({name:name, hosts:hosts}).then(function(value){
                $scope.apiName = null;
                $scope.hosts = null;
                $scope.showCreateRow = false;
                $scope.createdApiKey = value.key;
                $scope.userApiKey.push({
                    id: value.id,
                    name: value.name,
                    hosts: value.hosts
                });
            });
        }

        function _removeKey(id,index){
            usersApiKeysService.remove(id).then(function(){
                $scope.userApiKey.splice(index, 1);
            });
        }

        function _saveApiKey(id, name, hosts, idx){
            usersApiKeysService.update(id, {name:name, hosts:hosts}).then(function(){
                $scope.userApiKey[idx].name = name;
                $scope.userApiKey[idx].hosts = hosts;
                _cancelEdit();
            });
        }

        function _editApiKey(index, name, hosts){
            $scope.editItem = index;
            $scope.apiName = name;
            $scope.hosts = hosts;
        }

        function _cancelEdit(){
            $scope.editItem = null;
            $scope.apiName = null;
        }
    }])
;
angular.module('cerberus.account')
    .factory('usersApiKeysService', ["$http", "$q", "apiPath", "toaster", function usersApiKeysService($http, $q, apiPath, toaster) {
            return {
                get: function () {
                    var deferred = $q.defer();
                    $http.get(apiPath + 'users/apiKey')
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                create: function (data) {
                    var deferred = $q.defer();
                    $http.post(apiPath + 'users/apiKey', data)
                        .success(function (value) {
                            toaster.pop('success', 'Created');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                update: function (id,data) {
                    var deferred = $q.defer();
                    $http.put(apiPath + 'users/apiKey/' + id, data)
                        .success(function (value) {
                            toaster.pop('success', 'Updated');
                            deferred.resolve(value);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                remove: function (id) {
                    var deferred = $q.defer();
                    $http({method: 'DELETE', url: apiPath + 'users/apiKey/' + id})
                        .success(function(value){
                            deferred.resolve(value.DATA);
                        })
                        .error(function(reason){
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                }
            };
        }])
;

angular.module('cerberus.account')
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/users/settings', {
            templateUrl: 'account/users/settings.tpl.html',
            controller: 'UsersSettingsCtrl',
            title: 'User Settings',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/profile', {
            templateUrl: 'account/users/profile.tpl.html',
            controller: 'UsersProfileCtrl',
            title: 'User Profiles',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/profile/create', {
            templateUrl: 'account/users/profile-create.tpl.html',
            controller: 'UsersProfileCreateCtrl',
            title: 'Create User Profile',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/profile/:id', {
            templateUrl: 'account/users/profile-details.tpl.html',
            controller: 'UsersProfileDetailsCtrl',
            title: 'User Profile Details',
            resolve: {
                _wait: 'WaitForUserData',
                userId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/users/settings/password', {
            templateUrl: 'account/users/password.tpl.html',
            controller: 'UsersPasswordCtrl',
            title: 'User Passwords',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/address-book', {
            templateUrl: 'account/users/address-book.tpl.html',
            controller: 'UsersAddressBookCtrl',
            title: 'User Address Book',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/address-book/create', {
            templateUrl: 'account/users/address-book-create.tpl.html',
            controller: 'UsersAddressBookCreateCtrl',
            title: 'Create Address Book',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/address-book/:id', {
            templateUrl: 'account/users/address-book-details.tpl.html',
            controller: 'UsersAddressBookDetailsCtrl',
            title: 'Users Address Book Details',
            resolve: {
                _wait: 'WaitForUserData',
                profileId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        // $routeProvider.when('/users/settings/sessions', {
        //     templateUrl: 'account/users/sessions.tpl.html',
        //     controller: 'UsersSessionsCtrl',
        //     title: 'User Sessions',
        //     resolve: {
        //         _wait: 'WaitForUserData'
        //     }
        // });
        $routeProvider.when('/users/settings/api-keys', {
            templateUrl: 'account/users/api-keys.tpl.html',
            controller: 'UsersApiKeysCtrl',
            title: 'Users API Keys',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/organizations', {
            templateUrl: 'account/users/organizations.tpl.html',
            controller: 'UsersOrganizationsCtrl',
            title: 'User Organizations',
            resolve: {
                _wait: 'WaitForUserData',
                isAdmin: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope) {
                    return WaitForUserData.then(function () {
                        return $rootScope.userData.currentWorkspace.isAdmin;
                    });
                }],
                userId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope) {
                    return WaitForUserData.then(function () {
                        return $rootScope.userData.id;
                    });
                }]
            }
        });
        $routeProvider.when('/users/settings/templates', {
            templateUrl: 'account/users/templates.tpl.html',
            controller: 'UsersTemplatesCtrl',
            title: 'User Templates',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/templates/:id', {
            templateUrl: 'account/users/templates-details.tpl.html',
            controller: 'UsersTemplatesDetailsCtrl',
            title: 'User Template Details',
            resolve: {
                _wait: 'WaitForUserData',
                templateId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/users/settings/mail-servers', {
            templateUrl: 'account/users/mail-servers.tpl.html',
            controller: 'UsersMailServersCtrl',
            title: 'User Mail Servers',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/mail-servers/create', {
            templateUrl: 'account/users/mail-servers-create.tpl.html',
            controller: 'UsersMailServersCreateCtrl',
            title: 'Create User Mail Server',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/users/settings/mail-servers/:id', {
            templateUrl: 'account/users/mail-servers-details.tpl.html',
            controller: 'UsersMailServersDetailsCtrl',
            title: 'User Mail Server Details',
            resolve: {
                _wait: 'WaitForUserData',
                serverId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/users/settings/signature', {
            templateUrl: 'account/users/signature.tpl.html',
            controller: 'UsersSignatureCtrl',
            title: 'User Signature',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
    }])
;
angular.module('cerberus.account')
    .controller('UsersMailServersCtrl', ["$scope", "$location", "ConfirmModalService", "usersProfileService", function UsersMailServersCtrl($scope, $location, ConfirmModalService, usersProfileService) {
        $scope.activeRoute = 'mail-servers';
        $scope.servers = [];

        $scope.openMailServer = _openMailServer;
        $scope.deleteMailServer = _deleteMailServer;

        _init();

        function _init(){
            usersProfileService.getAll('Mail Server').then(function(userProfile){
                $scope.servers = userProfile;
            });
        }

        function _openMailServer(id){
            if(id){
                $location.url('/users/settings/mail-servers/' + id);
            }
            else {
                $location.url('/users/settings/mail-servers/create');
            }
        }

        function _deleteMailServer(id, index){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to delete this Mail Server?',
                instructionText: 'Type "DELETE" to confirm.',
                actionButtonText: 'Delete Mail Server',
                closeButtonText: 'Cancel',
                check: function(input){
                    return angular.equals(input, 'DELETE');
                },
                confirm: function(){
                    return usersProfileService.remove(id);
                },
                callback: function(){
                    $scope.servers.splice(index, 1);
                }
            });
        }
    }])
    .controller('UsersMailServersCreateCtrl', ["$scope", "$location", "usersProfileService", "UsersProfileListService", function UsersMailServersCreateCtrl($scope, $location, usersProfileService, UsersProfileListService) {
        $scope.activeRoute = 'mail-servers';
        $scope.masterServer = UsersProfileListService.mailServerDataModel();
        $scope.server = angular.copy($scope.masterServer);
        $scope.verifyHtml = '<span class="text-warning">Unverified</span>';
        $scope.priorities = UsersProfileListService.mailServerPriorities();
        $scope.versions = UsersProfileListService.mailServerVersions();

        $scope.verifyConn = _verifyConn;
        $scope.isUnchanged = _isUnchanged;
        $scope.save = _save;
        $scope.cancel = _cancel;

        function _verifyConn(){
            $scope.verifyHtml = '<i class="fa fa-spinner"></i>';
            usersProfileService.verifyMailServerConnection($scope.server).then(function(data){
                if(data){
                    $scope.verifyHtml = '<span class="text-success">Success</span>';
                }
                else{
                    $scope.verifyHtml = '<span class="text-danger">Failed</span>';
                }
            });
        }

        function _isUnchanged(server){
            return angular.equals(server, $scope.masterServer);
        }

        function _save(server){
            var data = {
                data: server,
                type: "Mail Server"
            };
            usersProfileService.create(data).then(function(){
                $location.url('users/settings/mail-servers');
            });
        }

        function _cancel(){
            $location.url('/users/settings/mail-servers');
        }
    }])
    .controller('UsersMailServersDetailsCtrl', ["$scope", "$location", "serverId", "usersProfileService", "UsersProfileListService", function UsersMailServersDetailsCtrl($scope, $location, serverId, usersProfileService, UsersProfileListService) {
        $scope.activeRoute = 'mail-servers';
        $scope.masterServer = {};
        $scope.server = {};
        $scope.verifyHtml = '<span class="text-warning">Unverified</span>';
        $scope.priorities = UsersProfileListService.mailServerPriorities();
        $scope.versions = UsersProfileListService.mailServerVersions();

        $scope.verifyConn = _verifyConn;
        $scope.isUnchanged = _isUnchanged;
        $scope.save = _save;
        $scope.cancel = _cancel;

        _init();

        function _init(){
            usersProfileService.get(serverId).then(function(userProfile){
                $scope.masterServer = angular.copy(userProfile.data);
                $scope.server = angular.copy(userProfile.data);
            });
        }

        function _verifyConn(){
            $scope.verifyHtml = '<i class="fa fa-spinner"></i>';
            usersProfileService.verifyMailServerConnection($scope.server).then(function(data){
                if(data){
                    $scope.verifyHtml = '<span class="text-success">Success</span>';
                }
                else{
                    $scope.verifyHtml = '<span class="text-danger">Failed</span>';
                }
            });
        }

        function _isUnchanged(server){
            return angular.equals(server, $scope.masterServer);
        }

        function _save(server){
            var data = {
                data: server,
                type: "Mail Server"
            };
            usersProfileService.update(serverId, data).then(function(){
                $location.url('users/settings/mail-servers');
            });
        }

        function _cancel(){
            $location.url('/users/settings/mail-servers');
        }
    }])
;
angular.module('cerberus.account')
    .controller('UsersOrganizationsCtrl', ["$scope", "$location", "isAdmin", "userId", "OrganizationsService", "usersProfileService", function UsersOrganizationsCtrl($scope, $location, isAdmin, userId, OrganizationsService, usersProfileService) {
        $scope.activeRoute = 'organizations';
        $scope.userOrgs = [];
        $scope.organizations= [];
        $scope.isAdmin = isAdmin;
        $scope.userId = userId;
        $scope.defaultWorkspaces = {};
        $scope.origDefaultWorkspaces = {};

        $scope.goToOrganizationsDetails = _goToOrganizationsDetails;
        $scope.leaveOrganization = _leaveOrganization;
        $scope.hasChanges = _hasChanges;
        $scope.save = _save;

        _init();

        function _init(){
            OrganizationsService.get().then(function(d){
                $scope.userOrgs = angular.copy(d);
                usersProfileService.getAll('Default Workspaces').then(function(defaultWorkspaces){
                    $scope.origDefaultWorkspaces = angular.copy(defaultWorkspaces);
                    $scope.defaultWorkspaces = angular.copy(defaultWorkspaces);
                });
            });
        }

        function _goToOrganizationsDetails(id){
            $location.url('organizations/' + id + '/settings');
        }

        function _leaveOrganization(id){
            OrganizationsService.disableUsers(id, {userIds:[$scope.userId]}).then(function(){
                $location.url('users/settings/organizations');
            });
        }

        function _hasChanges() {
            return !angular.equals($scope.defaultWorkspaces, $scope.origDefaultWorkspaces);
        }

        function _save(){
            usersProfileService.create({data:$scope.defaultWorkspaces, type:'Default Workspaces', isUnique:true}).then(function(){
                $scope.origDefaultWorkspaces = angular.copy($scope.defaultWorkspaces);
            });

            OrganizationsService.get().then(function(userOrgs){
                $scope.userOrgs = userOrgs;
            });
        }

    }])
;
angular.module('cerberus.account')
    .controller('UsersPasswordCtrl', ["_", "$scope", "AuthPasswordService", function UsersPasswordCtrl(_, $scope, AuthPasswordService) {
            $scope.activeRoute = 'account';
            $scope.result = {};
            $scope.data = {};
            $scope.confirmPassword = null;
            $scope.submit = function(isValid, data){
                $scope.result.visible = false;
                if (isValid) {
                    AuthPasswordService.changePassword(data).then(function () {
                        $scope.form.$setPristine();
                        $scope.form.$setUntouched();
                        $scope.data = {};
                        $scope.confirmPassword = null;
                        $scope.result.visible = true;
                        $scope.result.class = 'success';
                        $scope.result.message = "Password Changed";
                    }, function (reason) {
                        $scope.data.oldPassword = null;
                        $scope.result.visible = true;
                        $scope.result.class = 'danger';
                        $scope.result.message = _.get(reason, 'MESSAGE') || "Error please try again";
                    });
                }
            };
        }])
;
angular.module('cerberus.account')
    .controller('UsersProfileCtrl', ["$scope", "$location", "ConfirmModalService", "usersProfileService", function UsersProfileCtrl($scope, $location, ConfirmModalService, usersProfileService) {
        $scope.activeRoute = 'profile';
        $scope.profiles = [];

        $scope.goToUserProfileDetails = _goToUserProfileDetails;
        $scope.deleteUserProfile = _deleteUserProfile;

        _init();

        function _init(){
            usersProfileService.getAll('Profile').then(function(userProfile){
                $scope.profiles = userProfile;
            });
        }

        function _goToUserProfileDetails(id){
            if(id){
                $location.url('users/settings/profile/' + id);
            }
            else{
                $location.url('users/settings/profile/create');
            }
        }

        function _deleteUserProfile(id, index){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to delete this Profile?',
                actionButtonText: 'Delete',
                closeButtonText: 'Cancel',
                check: function(/*input*/){
                    return true;
                },
                confirm: function(){
                    return usersProfileService.remove(id);
                },
                callback: function(){
                    $scope.profiles.splice(index, 1);
                }
            });
        }
    }])
    .controller('UsersProfileCreateCtrl', ["$scope", "$location", "usersProfileService", function UsersProfileCreateCtrl($scope, $location, usersProfileService) {
        $scope.activeRoute = 'profile';
        $scope.masterProfile = { data: {} };
        $scope.userProfile = { data: {} };
        $scope.isDefaultProfile = false;

        $scope.clearLogo = _clearLogo;
        $scope.isUnchanged = _isUnchanged;
        $scope.save = _save;
        $scope.cancel = _cancel;

        _init();

        function _init(){
            _clearLogo();
        }

        function _clearLogo(){
            $scope.userProfile.data.pic_img = '';
            $scope.imageSrc = null;
        }

        function _isUnchanged(data){
            return angular.equals($scope.masterProfile, data);
        }

        function _save(profile){
            profile.type = 'Profile';
            usersProfileService.create(profile).then(function(){
                $location.url('users/settings/profile');
            });
        }

        function _cancel(){
            $location.url('users/settings/profile');
        }
    }])
    .controller('UsersProfileDetailsCtrl', ["$scope", "$location", "userId", "usersProfileService", function UsersProfileCtrl($scope, $location, userId, usersProfileService) {
        $scope.activeRoute = 'profile';
        $scope.masterProfile = {};
        $scope.userProfile = {};
        $scope.isDefaultProfile = false;
        $scope.imageSrc = null;

        $scope.clearLogo = _clearLogo;
        $scope.isUnchanged = _isUnchanged;
        $scope.save = _save;
        $scope.cancel = _cancel;

        _init();

        function _init(){
            usersProfileService.get(userId).then(function(userProfile){
                if(!userProfile.data.pic_img){
                    userProfile.data.pic_img = '';
                }

                $scope.masterProfile = angular.copy(userProfile);
                $scope.userProfile = angular.copy(userProfile);
                $scope.isDefaultProfile = angular.copy(userProfile.isDefault);
            });
        }

        function _clearLogo(){
            $scope.userProfile.data.pic_img = '';
            $scope.imageSrc = null;
        }

        function _isUnchanged(data){
            return angular.equals($scope.masterProfile, data);
        }

        function _save(profile){
            profile.type = 'Profile';
            usersProfileService.update(userId, profile).then(function(){
                $location.url('users/settings/profile');
            });
        }

        function _cancel(){
            $location.url('users/settings/profile');
        }
    }])
;
angular.module('cerberus.account')
    .factory('usersProfileService', ["$http", "$q", "apiPath", "toaster", function usersProfileService($http, $q, apiPath, toaster) {
            return {
                getAll: function (type) {
                    var deferred = $q.defer();
                    var endpoint = 'users/profile';
                    if(type){
                        endpoint = endpoint + '?type=' + type;
                    }
                    $http.get(apiPath + endpoint)
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                get: function (id) {
                    var deferred = $q.defer();
                    $http.get(apiPath + 'users/profile/' + id)
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                create: function (data) {
                    var deferred = $q.defer();
                    $http.post(apiPath + 'users/profile', data)
                        .success(function (value) {
                            toaster.pop('success', 'Saved');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                update: function (id,data) {
                    var deferred = $q.defer();
                    $http.put(apiPath + 'users/profile/' + id, data)
                        .success(function (value) {
                            deferred.resolve(value);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                remove: function (id) {
                    var deferred = $q.defer();
                    $http({method: 'DELETE', url: apiPath + 'users/profile/' + id})
                        .success(function(value){
                            deferred.resolve(value.DATA);
                        })
                        .error(function(reason){
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                getDefaultUserProfile: function (userId) {
                    var deferred = $q.defer();
                    $http.get(apiPath + 'users/' + userId + '/profiles?type=Profile')
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                verifyMailServerConnection: function(data){
                    var deferred = $q.defer();
                    $http.post(apiPath + 'exchange/server/connection/verify', data)
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                }
            };
        }])
;

angular.module('cerberus.account')
    .factory('UsersProfileListService', function UsersProfileListService() {
        return {
            profileFields: profileFields,
            addressBookCountries: addressBookCountries,
            mailServerDataModel: mailServerDataModel,
            mailServerPriorities: mailServerPriorities,
            mailServerVersions: mailServerVersions
        };

        function profileFields(){
            return {
                Address: [
                    { label: 'Display', key: 'display' },
                    { label: 'Attention', key: 'attn' },
                    { label: 'Address line 1', key: 'addr1' },
                    { label: 'Address line 2', key: 'addr2' },
                    { label: 'City', key: 'city' },
                    { label: 'State/Province/Region', key: 'state' },
                    { label: 'Zip', key: 'zip' },
                    { label: 'Country', key: 'country' }
                ],
                'Mail Server': [
                    { label: 'To', key: 'to' }
                ]
            };
        }

        function addressBookCountries(){
            return ['United States'];
        }

        function mailServerDataModel(){
            return {
                isExchangeServer: false,
                protocol: 'HTTP',
                ssl: false,
                tls: false,
                priority: "Normal",
                serverVersion: '2007'
            };
        }

        function mailServerPriorities(){
            return [
                {display: "Urgent"},
                {display: "High"},
                {display: "Normal"},
                {display: "Low"},
                {display: "Non-urgent"}
            ];
        }

        function mailServerVersions(){
            return [
                {display: "2003"},
                {display: "2007"},
                {display: "2010"}
            ];
        }
    });

angular.module('cerberus.account')
    .factory('UsersSecurityService', ["_", "kendo", "$http", "$q", "apiPath", "toaster", function UsersSecurityService(_, kendo, $http, $q, apiPath, toaster) {
            return {
                getAll: function () {
                    var deferred = $q.defer();
                    $http.get(apiPath + 'users/tokens')
                        .success(function (value) {
                            var userTokens = value.DATA;

                            _.forEach(userTokens, function (token) {
                                token.last_requested_time = kendo.parseDate(token.last_requested_time, 'MMMM, dd yyyy HH:mm:ss'); 
                            });

                            deferred.resolve(userTokens);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                revoke: function(id){
                    var deferred = $q.defer();
                    $http({method: 'DELETE', url: apiPath + 'users/tokens/' + id})
                        .success(function(value){
                            toaster.pop('info', 'Token has been revoked.');
                            deferred.resolve(value);
                        })
                        .error(function(reason){
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                }
            };
        }])
;

angular.module('cerberus.account')
    .factory('UsersService', ["$http", "$q", "apiPath", function UsersService($http, $q, apiPath) {
            return {
                updateMemberOf: function(id, data) {
                    var deferred = $q.defer();
                    $http.put(apiPath + 'users/' + id + '/memberOf',data)
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                }
            };
        }])
;

angular.module('cerberus.account')
    .controller('UsersSessionsCtrl', ["$scope", "UsersSecurityService", function UsersSessionsCtrl($scope, UsersSecurityService) {
        $scope.activeRoute = 'security';
        $scope.userTokens = [];

        $scope.revokeToken = _revokeToken;

        _init();

        function _init(){
            UsersSecurityService.getAll().then(function(userTokens){
                $scope.userTokens = userTokens;
            });
        }

        function _revokeToken(id, idx){
            UsersSecurityService.revoke(id).then(function(){
                $scope.userTokens.splice(idx, 1);
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('UsersSettingsCtrl', ["$scope", "coreAppVersion", "buildEnvironment", function UsersSettingsCtrl($scope, coreAppVersion, buildEnvironment) {
        $scope.coreAppVersion = coreAppVersion;
		$scope.buildEnvironment = buildEnvironment;
		
		// DECLARE FUNCTIONS HERE IF NEEDED.
        //_init();
		//
        //function _init(){
        //    _mainInitFunction();
        //}
		//
        //function _mainInitFunction(){
		////something to run when page is accessed.
		//}
		// END SAMPLE FOR DECLARE FUNCTIONS .
	
    }])
;
angular.module('cerberus.account')
    .controller('UsersSignatureCtrl', ["$scope", "$timeout", "usersProfileService", function UsersSignatureCtrl($scope, $timeout, usersProfileService){
        $scope.activeRoute = 'signature';
        $scope.profileId = null;
        $scope.tempData = {
            sig_img: '',
            init_img: ''
        };
        $scope.origData = angular.copy($scope.tempData);

        $scope.sig_path = '';
        $scope.init_path = '';

        $scope.isUnchanged = isUnchanged;
        $scope.submit = submit;
        $scope.clear = clear;

        init();

        function init(){
            usersProfileService.getAll('Signature').then(function(data){
                if(data.length > 0){
                    $scope.profileId = data[0].id;
                    $scope.sig_path = setPath(data[0].data.sig_img);
                    $scope.init_path = setPath(data[0].data.init_img);
                }
            });
        }

        function isUnchanged(){
            return angular.equals($scope.tempData, $scope.origData);
        }

        function submit(isValid, data){
            if(isValid){
                if($scope.profileId){
                    usersProfileService.update($scope.profileId, {data: data}).then(function(){
                        $scope.origData = angular.copy($scope.tempData);
                        $scope.sig_path = setPath($scope.sig_path);
                        $scope.init_path = setPath($scope.init_path);
                    });
                }
                else {
                    usersProfileService.create({data: data, type: 'Signature'}).then(function (newData) {
                        $scope.origData = angular.copy($scope.tempData);

                        $scope.profileId = newData.id;
                        $scope.sig_path = setPath(newData.data.sig_img);
                        $scope.init_path = setPath(newData.data.init_img);
                    });
                }
            }
        }

        function setPath(path){
            var qm = path.indexOf('?');
            var newPath = path;
            if(qm > 0){
                newPath = path.substring(0, qm);
            }
            var date = new Date();
            return newPath + '?' + date.toISOString();
        }

        function clear(field){
            $timeout(function(){
                $scope.tempData[field] = '';
            });
        }
    }])
;
angular.module('cerberus.account')
    .controller('UsersTemplatesCtrl', ["$scope", "$location", "TemplatesServices", function UsersTemplatesCtrl($scope, $location, TemplatesServices) {
        $scope.activeRoute = 'templates';
        $scope.templatesArray = [];
        $scope.selectedType = 'Form';

        $scope.goToTemplateDetails = _goToTemplateDetails;
        $scope.deleteTemplate = _deleteTemplate;

        _init();

        function _init(){
            TemplatesServices.getUserTemplates().then(function(templatesArray){
                $scope.templatesArray = templatesArray;
            });
        }

        function _goToTemplateDetails(id){
            $location.url('users/settings/templates/' + id);
        }

        function _deleteTemplate(id, idx){
            TemplatesServices.deleteTemplate(id).then(function(){
                $scope.templatesArray.splice(idx, 1);
            });
        }
    }])
    .controller('UsersTemplatesDetailsCtrl', ["$scope", "$location", "templateId", "TemplatesServices", function UsersTemplatesDetailsCtrl($scope, $location, templateId, TemplatesServices) {
        $scope.activeRoute = 'templates';
        $scope.tempData = {};
        $scope.origData = {};
        $scope.securityTypes = TemplatesServices.getSecurityLevels();

        $scope.hasChanges = _hasChanges;
        $scope.submit = _submit;

        _init();

        function _init(){
            TemplatesServices.getDetails(templateId).then(function(templateModel){
                $scope.tempData = angular.copy(templateModel);
                $scope.origData = angular.copy(templateModel);
            });
        }

        function _hasChanges(){
            return !angular.equals($scope.origData, $scope.tempData);
        }

        function _submit(isValid, data){
            if(isValid){
                TemplatesServices.update($scope.origData.id, data).then(function(){
                    $location.url('users/settings/templates');
                });
            }
        }
    }])
;
angular.module('cerberus.account')
    .controller('UserVerifySignatureModalCtrl', ["$scope", "$uibModalInstance", "usersProfileService", function UserVerifySignatureModalCtrl($scope, $uibModalInstance, usersProfileService){
        $scope.password = '';

        $scope.ok = function(){
            usersProfileService.verifySignaturePass($scope.password).then(function(data){
                $uibModalInstance.close(data);
            });
        };

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .config(["$routeProvider", function($routeProvider){
        $routeProvider.when('/settings/menus', {
            templateUrl: 'admin/menus/menus.tpl.html',
            controller: 'MenusCtrl',
            controllerAs: 'vm',
            title: 'Menus',
            resolve: {
                _wait: 'WaitForUserData',
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/menus/create', {
            templateUrl: 'admin/menus/menus-create.tpl.html',
            controller: 'MenusCreateCtrl',
            controllerAs: 'vm',
            title: 'Create Menu',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/settings/menus/:id', {
            templateUrl: 'admin/menus/designer/designer.tpl.html',
            controller: 'MenusDesignerCtrl',
            controllerAs: 'vm',
            title: 'Menu Designer',
            resolve: {
                _wait: 'WaitForUserData',
                menuId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
    }])
;
angular.module('cerberus.admin')
    .controller('MenusCtrl', ["$scope", "$location", "workspaceId", "localStorageService", "MenusService", function MenusCtrl($scope, $location, workspaceId, localStorageService, MenusService){
        var vm = this;

        vm.menus = [];

        vm.openMenu = function(id){
            if(id) {
                $location.url('/settings/menus/' + id);
            }
            else{
                $location.url('/settings/menus/create');
            }
        };

        vm.menuFilter = menuFilter;

        init();

        function init(){
            MenusService.getMenus().then(function(menus){
                vm.menus = menus;
            });
        }

        // Getter-Setter function for filter
        function menuFilter(filterText){
            // Checks if value was passed in
            if(arguments.length){
                localStorageService.set('menuFilter.' + workspaceId, filterText);
                return filterText || '';
            }
            else {
                return localStorageService.get('menuFilter.' + workspaceId) || '';
            }
        }
    }])
;
angular.module('cerberus.admin')
    .controller('MenusCreateCtrl', ["$scope", "$location", "MenusService", function MenusCreateCtrl($scope, $location, MenusService){
        var vm = this;

        vm.menuData = {};

        vm.save = function(menu){
            MenusService.createMenu(menu).then(function(id){
                var path = '/settings/menus';
                if(id) {
                    path += '/' + id;
                }

                $location.replace().url(path);
            });
        };
        vm.cancel = function(){
            $location.replace().url('/settings/menus');
        };
    }])
;
angular.module('cerberus.admin')
    .controller('nimPageObjectListCtrl', ["_", "$scope", "$rootScope", "$attrs", "$parse", "apiPath", "localStorageService", "PagesService", "pageObjectsService", "PageObjectsDesignerService", "ConfirmModalService", function nimPageObjectListCtrl(_, $scope, $rootScope, $attrs, $parse, apiPath, localStorageService, PagesService, pageObjectsService, PageObjectsDesignerService, ConfirmModalService){
        $scope.showDelete = $scope.$eval($attrs.showDelete);

        var importFunction = null;

        if($attrs.nimPageObjectImport){
            importFunction = $scope.$eval($attrs.nimPageObjectImport);
        }

        $scope.pages = [
            {
                id: 'unused',
                name: '(Unused)'
            }
        ];
        $scope.pageFilter = localStorageService.get('pageObjectFilter.' + $rootScope.userData.currentWorkspace.id) || '';
        $scope.reloadPageObjects = reloadPageObjects;

        $scope.options = {
            columns: [
                {
                    title: 'Name',
                    field: 'name'
                },
                {
                    title: 'Type',
                    template: typeColTemplate
                }
            ],
            columnMenu: {
                columns: false
            },
            dataSource: {
                transport: {
                    read: transportRead
                }
            },
            filterable: {
                extra: false,
                operators: {
                    string: {
                        contains: 'Contains'
                    }
                }
            },
            scrollable: false,
            selectable: 'row',
            change: selectPageObject
        };

        if(_.isFunction(importFunction)){
            $scope.options.columns.push({
                command: [
                    {
                        name: 'importPageObject',
                        text: '<i class="fa fa-upload"></i>&nbsp;Import',
                        className: 'btn-primary',
                        click: _.partialRight(importClickHandler, false)
                    },
                    {
                        name: 'importAndCopyPageObject',
                        text: '<i class="fa fa-copy"></i>&nbsp;Duplicate',
                        className: 'btn-primary',
                        click: _.partialRight(importClickHandler, true)
                    }
                ],
                width: '70px'
            });
        }

        if($scope.showDelete){
            $scope.options.columns.push({
                command: {
                    name: 'deletePageObject',
                    text: '<i class="fa fa-trash"></i>&nbsp;Delete',
                    className: 'btn-danger',
                    click: deleteClickHandler
                },
                width: '70px'
            });
        }

        PagesService.getPages().then(function(pages){
            $scope.pages = $scope.pages.concat(pages);
        });

        function typeColTemplate(dataItem){
            var type = dataItem.type; // Show object type by default

            if(dataItem.type === 'viz'){ // For viz objects, show viz type\
                if(dataItem.vizSubType) { // Show viz subtype
                    type = dataItem.vizSubType + ' ' + _.capitalize(dataItem.vizType);
                }
                else {
                    type = dataItem.vizType;
                }
            }
            return _.capitalize(type);
        }

        function transportRead(options){
            var cb = readCallback(options);

            if($scope.pageFilter === 'unused'){
                pageObjectsService.getUnusedPageObjects().then(cb);
            }
            else if($scope.pageFilter){
                PagesService.getPage($scope.pageFilter).then(cb);
            }
            else{
                pageObjectsService.getPageObjects().then(cb);
            }
        }

        function readCallback(options){
            return function(result){
                options.success(parseData(result));
            };
        }

        function selectPageObject(e){
            var row = e.sender.select();
            var dataItem = e.sender.dataItem(row);
            // Let parent controller determine what happens when page object is selected
            $scope.$emit('nim-page-object-list-selected', dataItem.toJSON());
        }

        function importClickHandler(e, duplicate){
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var tr = $(e.target).closest('tr');
            var pageObject = $scope.grid.dataItem(tr);

            if(_.isFunction(importFunction)){
                importFunction(pageObject.id, duplicate);
            }
        }

        function deleteClickHandler(e){
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var tr = $(e.target).closest('tr');
            var pageObject = $scope.grid.dataItem(tr);

            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to delete this page object and remove it from each page that uses it?',
                instructionText: 'Type "DELETE ' + pageObject.name + '" to confirm.',
                actionButtonText: 'Delete Page Object',
                closeButtonText: 'Cancel',
                check: function(input){
                    return angular.equals(input, 'DELETE ' + pageObject.name);
                },
                confirm: function(){
                    return PageObjectsDesignerService.deletePageObject(pageObject.id);
                },
                callback: function(){
                    reloadPageObjects();
                }
            });
        }

        function reloadPageObjects(){
            localStorageService.set('pageObjectFilter.' + $rootScope.userData.currentWorkspace.id, $scope.pageFilter);
            _.result($scope, 'grid.dataSource.read');
        }

        function parseData(resultData){
            if($scope.pageFilter && $scope.pageFilter !== 'unused'){
                var data = [];
                _.forEach(resultData.items, function(pageObject){
                    var dataItem = _.pick(pageObject, ['id', 'name', 'type']);
                    dataItem.vizType = _.get(pageObject, 'viz.type', '');
                    dataItem.vizSubType = _.get(pageObject, 'viz.subType', '');
                    data.push(dataItem);
                });
                return data;
            }
            else {
                return resultData;
            }
        }
    }])
    .directive('nimPageObjectList', function(){
        return {
            restrict: 'AE',
            controller: 'nimPageObjectListCtrl',
            template: '<div class="form-group">' +
                '<label for="pageFilter">Page:</label>' +
                '<select id="pageFilter" class="form-control" ng-model="pageFilter" ng-options="p.id as p.name for p in pages" ng-change="reloadPageObjects()" style="width:100%">' +
                    '<option value="">(All)</option>' +
                '</select>' +
            '</div>' +
            '<div kendo-grid="grid" k-options="options"></div>'
        };
    })
;

angular.module('cerberus.admin')
    .config(["$routeProvider", function($routeProvider){
        $routeProvider.when('/settings/page-objects', {
            templateUrl: 'admin/page-objects/page-objects.tpl.html',
            controller: 'PageObjectsCtrl',
            controllerAs: 'vm',
            title: 'Page Objects',
            reloadOnSearch: false,
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/settings/page-objects/:id', {
            templateUrl: 'admin/page-objects/page-objects-designer.tpl.html',
            controller: 'PageObjectsDesignerCtrl',
            controllerAs: 'vm',
            title: 'Page Object Designer',
            reloadOnSearch: false,
            resolve: {
                _wait: 'WaitForUserData',
                pageObjectId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
    }])
;
angular.module('cerberus.admin')
    .controller('PageObjectsCtrl', ["$scope", "$timeout", "$location", function PageObjectsCtrl($scope, $timeout, $location){
        $scope.$on('nim-page-object-list-selected', function(e, pageObject){
            e.stopPropagation();
            // Navigate to Page Object Designer when page object is selected
            $timeout(function(){
                $location.url('/settings/page-objects/' + pageObject.id);
            });
        });
    }])
;
angular.module('cerberus.admin')
    .controller('PageObjectsDesignerCtrl', ["$scope", "$location", "$uibModal", "$timeout", "pageObjectId", "pageObjectsService", "PageObjectsDesignerService", "DesignerUtilityService", "ConfirmModalService", function PageObjectsDesignerCtrl($scope, $location, $uibModal, $timeout, pageObjectId, pageObjectsService, PageObjectsDesignerService, DesignerUtilityService, ConfirmModalService){
        var vm = this;

        $scope.filters = {};

        vm.pageObjectId = pageObjectId;
        vm.temp = null;
        vm.orig = null;

        vm.openPageObjectConfigModal = openPageObjectConfigModal;
        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.isUnchanged = isUnchanged;
        vm.close = close;
        vm.deletePageObject = deletePageObject;

        init();

        function init(){
            pageObjectsService.getPageObject(pageObjectId).then(function(data){
                vm.orig = angular.copy(data);
                vm.temp = angular.copy(vm.orig);
            });
        }
        
        DesignerUtilityService.cancelRouteNav($scope, function () { return !isUnchanged(); });

        $scope.$on('$locationChangeStart', function (e) {
            if (!e.defaultPrevented) {
                $scope.$broadcast('nim-remove-page-objects');
            }
        });

        function openPageObjectConfigModal(){
            var controller = 'PageObjectConfigCtrl';
            if(vm.temp.viz.subType){
                controller = formatName(vm.temp.viz.subType) + 'ConfigCtrl';
            }
            else if(vm.temp.viz.type){
                controller = formatName(vm.temp.viz.type) + 'ConfigCtrl';
            }
            else if(vm.temp.type){
                controller = formatName(vm.temp.type) + 'ConfigCtrl';
            }
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/pages/designer/common/config-modal.tpl.html',
                controller: controller,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    pageObject: function (){
                        return vm.temp;
                    },
                    filters: function () {
                        return [];
                    }
                }
            });
            modalInstance.result.then(function (data) {
                data.viz.settings.batchEdit = !!(data.tools.edit || data.tools.delete);

                if(!angular.equals(vm.temp, data)) {
                    vm.temp = null;
                    $timeout(function () {
                        vm.temp = data;
                    });
                }
            },
            function(reason){
                if(reason === 'delete'){
                    deletePageObject();
                }
            });
        }

        function formatName(name){
            var formattedName = '';
            if(name && name.length > 0){
                formattedName += name.charAt(0).toUpperCase();
                if(name.length > 1){
                    formattedName += name.substr(1, name.length - 1).toLowerCase();
                }
            }
            return formattedName;
        }

        function save(saveAndClose){
            PageObjectsDesignerService.updatePageObject(vm.pageObjectId, vm.temp).then(function(){
                if(saveAndClose){
                    close();
                }
                else{
                    vm.orig = angular.copy(vm.temp);
                }
            });
        }

        function saveAndClose(){
            save(true);
        }

        function isUnchanged(){
            return angular.equals(vm.temp, vm.orig);
        }

        function close(){
            $location.url('/settings/page-objects');
        }

        function deletePageObject(){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to delete this page object and remove it from each page that uses it?',
                instructionText: 'Type "DELETE ' + vm.temp.name + '" to confirm.',
                actionButtonText: 'Delete Page Object',
                closeButtonText: 'Cancel',
                check: function(input){
                    return angular.equals(input, 'DELETE ' + vm.temp.name);
                },
                confirm: function(){
                    return PageObjectsDesignerService.deletePageObject(vm.pageObjectId);
                },
                callback: close
            });
        }
    }])
;
angular.module('cerberus.admin')
    /**
     * @ngdoc service
     * @name PageObjectsDesignerService
     * @alias cerberus/pages-objects:PageObjectsDesignerService
     * @description Utilities for the Page Object Designer
     */
    .factory('PageObjectsDesignerService', ["$http", "$q", "apiPath", "toaster", function PageObjectsDesignerService($http, $q, apiPath, toaster){
        return {
            updatePageObject: updatePageObject,
            deletePageObject: deletePageObject
        };

        function updatePageObject(id, data){
            data.subType = data.subType || '';

            var deferred = $q.defer();
            $http.put(apiPath + 'page/objects/' + id, { pageObjectData: data })
                .success(function(value){
                    toaster.pop('success', 'Page Object Saved');
                    deferred.resolve(value);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function deletePageObject(id){
            var deferred = $q.defer();
            $http.delete(apiPath + 'page/objects/' + id)
                .success(function(value){
                    toaster.pop('success', 'Page Object Deleted');
                    deferred.resolve(value);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }])
;
angular.module('cerberus.admin')
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/settings/pages', {
            templateUrl: 'admin/pages/pages.tpl.html',
            controller: 'PagesListCtrl',
            controllerAs: 'vm',
            title: 'Pages',
            resolve: {
                _wait: 'WaitForUserData',
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            },
            reloadOnSearch: false
        });
        $routeProvider.when('/settings/pages/create', {
            templateUrl: 'admin/pages/pages-create.tpl.html',
            controller: 'PagesCreateCtrl',
            controllerAs: 'vm',
            title: 'Create Page',
            resolve: {
                _wait: 'WaitForUserData',
                workspace: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function () {
                        return $rootScope.userData.currentWorkspace;
                    });
                }]
            },
            reloadOnSearch: false
        });
        $routeProvider.when('/settings/pages/:pageId', {
            templateUrl: 'admin/pages/designer/designer.tpl.html',
            controller: 'PagesDesignerCtrl',
            title: 'Page Designer',
            resolve: {
                _wait: 'WaitForUserData',
                pageId: ["$route", function($route){
                    return $route.current.params.pageId;
                }]
            },
            reloadOnSearch: false
        });
    }])
;
angular.module('cerberus.admin')
    .controller('PagesCreateCtrl', ["_", "$scope", "$location", "workspace", "PageDesignerService", "WorkspacesGroupsService", function PagesCreateCtrl(_, $scope, $location, workspace, PageDesignerService, WorkspacesGroupsService){
        var vm = this;

        vm.workspace = workspace;
        vm.page = {
            name: '',
            icon: 'file-o',
            description: ''
        };

        vm.permissions = {};
        vm.groups = [];

        vm.save = save;
        vm.cancel = cancel;

        init();

        function init(){
            WorkspacesGroupsService.getGroups(workspace.id).then(function(groups){
                vm.groups = _.filter(groups, function(g) {
                    return g.type === 'Custom' || g.type === 'User';
                });
            });
        }

        function save(){
            var newPage = {
                name: vm.page.name,
                icon: vm.page.icon,
                description: vm.page.description,
                permissions: vm.permissions
            };

            PageDesignerService.create(newPage).then(function(pageId){
                $location.url('/settings/pages/' + pageId);
            });
        }

        function cancel(){
            $location.url('/settings/pages');
        }
    }])
;
angular.module('cerberus.admin')
    .controller('PagesListCtrl', ["$scope", "$location", "workspaceId", "localStorageService", "PagesService", function PagesListCtrl($scope, $location, workspaceId, localStorageService, PagesService){
        var vm = this;

        vm.pages = [];

        vm.openPageDesigner = openPageDesigner;
        vm.openPageDetails = openPageDetails;
        vm.pageFilter = pageFilter;

        init();

        function init(){
            PagesService.getPages().then(function(pages){
                vm.pages = pages;
            });
        }

        function openPageDesigner(id){
            $location.url('/settings/pages/' + id);
        }

        function openPageDetails(){
            $location.url('/settings/pages/create');
        }

        // Getter-Setter function for filter
        function pageFilter(filterText){
            // Checks if value was passed in
            if(arguments.length){
                localStorageService.set('pageFilter.' + workspaceId, filterText);
                return filterText || '';
            }
            else {
                return localStorageService.get('pageFilter.' + workspaceId) || '';
            }
        }
    }])
;
angular.module('cerberus.admin')
    .config(["$routeProvider", function($routeProvider){
        $routeProvider.when('/settings/rules', {
            templateUrl: 'admin/rules/rules.tpl.html',
            controller: 'RulesCtrl',
            title: 'Rules',
            resolve: {
                _wait: 'WaitForUserData',
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });

        $routeProvider.when('/settings/rules/add', {
            templateUrl: 'admin/rules/rules-create.tpl.html',
            controller: 'RulesCreateCtrl',
            controllerAs: 'vm',
            title: 'New Rule',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });

        $routeProvider.when('/settings/rules/:id', {
            templateUrl: 'admin/rules/rules-details.tpl.html',
            controller: 'RulesDetailsCtrl',
            controllerAs: 'vm',
            title: 'Edit Rule',
            resolve: {
                _wait: 'WaitForUserData',
                ruleId: ["WaitForUserData", "$route", function(WaitForUserData, $route){
                    return WaitForUserData.then(function(){
                        return $route.current.params.id;
                    });
                }]
            }
        });
    }])
;
angular.module('cerberus.admin')
    .controller('RulesCtrl', ["$scope", "$location", "$timeout", "workspaceId", "localStorageService", "RulesService", function($scope, $location, $timeout, workspaceId, localStorageService, RulesService){
        $scope.ruleFilter = _ruleFilter;
        $scope.filterDataSource = _filterDataSource;
        $scope.rulesGridOptions = {
            columns: [
                {
                    title: 'Name',
                    field: 'name'
                },
                {
                    title: 'Engine',
                    field: 'type'
                },
                {
                    title: 'Path',
                    field: 'path'
                }
            ],
            dataSource: {
                transport: {
                    read: function(options){
                        RulesService.getAvailableRules().then(function(result){
                            options.success(result.rules);
                        });
                    }
                },
                schema: {
                    model: {
                        fields: {
                            name: {
                                type: 'string'
                            }
                        }
                    }
                },
                serverFiltering: false,
                filter: {
                    field: 'name',
                    operator: 'contains',
                    value: _ruleFilter()
                }
            },
            selectable: "row",
            change: function(e){
                var grid = e.sender,
                    selected = grid.select();

                if(selected.length > 0){
                    var ruleId = grid.dataItem(selected[0]).id;
                    $timeout(function(){
                        $location.replace().url('settings/rules/' + ruleId);
                    });
                }
            }
        };

        $scope.$on('$locationChangeStart', function (e) {
            if (!e.defaultPrevented) {
                if ($scope.rulesGrid) {
                    $scope.rulesGrid.destroy();
                    $scope.rulesGrid = null;
                }
            }    
        });

        // Getter-Setter function for filter
        function _ruleFilter(filterText){
            // Checks if value was passed in
            if(arguments.length){
                localStorageService.set('ruleFilter.' + workspaceId, filterText);
                return filterText || '';
            }
            else {
                return localStorageService.get('ruleFilter.' + workspaceId) || '';
            }
        }

        function _filterDataSource(ds){
            if(ds){
                ds.filter({
                    field: 'name',
                    operator: 'contains',
                    value: _ruleFilter()
                });
            }
        }
    }])
;
angular.module('cerberus.admin')
    .controller('RulesCreateCtrl', ["$scope", "$location", "RulesService", function($scope, $location, RulesService){
        var vm = this;

        vm.temp = {};
        vm.orig = {};
        vm.engines = [{
            value: 'nimbus',
            display: 'Nimbus'
        }];

        vm.isUnchanged = _isUnchanged;
        vm.save = _save;
        vm.cancel = _cancel;

        _init();

        function _init(){
            vm.orig = {
                name: '',
                type: 'nimbus',
                path: '',
                description: ''
            };
            vm.temp = angular.copy(vm.orig);
        }

        function _isUnchanged(data){
            return angular.equals(data, vm.orig);
        }

        function _save(data){
            RulesService.addRule(data).then(function(result){
                $location.replace().url('/settings/rules/' + result.ruleId);
            });
        }

        function _cancel(){
            $location.replace().url('/settings/rules');
        }
    }])
;
angular.module('cerberus.admin')
    .controller('RulesDetailsCtrl', ["_", "$scope", "$location", "ruleId", "ConfirmModalService", "RulesService", function(_, $scope, $location, ruleId, ConfirmModalService, RulesService){
        var vm = this;

        vm.temp = {};
        vm.orig = {};
        vm.engines = [{
            value: 'nimbus',
            display: 'Nimbus'
        }];

        vm.isUnchanged = _isUnchanged;
        vm.save = _save;
        vm.cancel = _cancel;
        vm.openDeletionModal = _openDeletionModal;

        _init();

        function _init(){
            RulesService.getRule(ruleId).then(function(rule){
                vm.orig = _.pick(rule, ['name', 'type', 'path', 'description']);
                vm.temp = angular.copy(vm.orig);
            });
        }

        function _isUnchanged(data){
            return angular.equals(data, vm.orig);
        }

        function _save(data){
            RulesService.updateRule(ruleId, data).then(function(){
                _init();
            });
        }

        function _cancel(){
            $location.replace().url('/settings/rules');
        }

        function _openDeletionModal(data){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to delete this rule?',
                instructionText: 'Type "DELETE ' + data.name + '" to confirm.',
                actionButtonText: 'Delete Rule Forever',
                closeButtonText: 'Cancel',
                check: function(input){
                    return angular.equals(input, 'DELETE ' + data.name);
                },
                confirm: function(){
                    return RulesService.deleteRule(ruleId);
                },
                callback: function(){
                    $location.url('/settings/rules');
                }
            });
        }
    }])
;
angular.module('cerberus.admin')
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/settings/queries', {
            templateUrl: 'admin/views/views.tpl.html',
            controller: 'ViewsCtrl',
            controllerAs: 'views',
            title: 'Queries',
            resolve: {
                _wait: 'WaitForUserData',
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/queries/create', {
            templateUrl: 'admin/views/views-create.tpl.html',
            controller: 'ViewsCreateCtrl',
            controllerAs: 'vm',
            title: 'Create Query',
            resolve: {
                _wait: 'WaitForUserData',
                viewData: function(){
                    return {
                        name:'',
                        description:''
                    };
                }
            }
        });
        $routeProvider.when('/settings/queries/:id', {
            templateUrl: 'admin/views/designer/views-designer.tpl.html',
            controller: 'ViewsDesignerCtrl',
            controllerAs: 'vm',
            title: 'Query Designer',
            resolve: {
                _wait: 'WaitForUserData',
                viewId: ["$route", function ($route) {
                    return $route.current.params.id;
                }]
            }
        });
    }])
;
angular.module('cerberus.admin')
    .controller('ViewsCtrl', ["$location", "workspaceId", "localStorageService", "ViewsService", function ViewsCtrl($location, workspaceId, localStorageService, ViewsService) {
        var vm = this;
        vm.viewsArray = [];
        vm.openViewsDetails = _openViewsDetails;
        vm.openViewDesigner = _openViewDesigner;
        vm.viewFilter = _viewFilter;

        _init();

        function _init(){
            ViewsService.get().then(function(viewsArray){
                vm.viewsArray = viewsArray;
            });
        }

        function _openViewsDetails(){
            $location.url('/settings/queries/create');
        }

        function _openViewDesigner(id){
            $location.url('/settings/queries/' + id);
        }

        // Getter-Setter function for filter
        function _viewFilter(filterText){
            // Checks if value was passed in
            if(arguments.length){
                localStorageService.set('viewFilter.' + workspaceId, filterText);
                return filterText || '';
            }
            else {
                return localStorageService.get('viewFilter.' + workspaceId) || '';
            }
        }
    }])
;
angular.module('cerberus.admin')
    .controller('ViewsCreateCtrl', ["$location", "viewData", "ViewsService", function ViewsCreateCtrl($location, viewData, ViewsService) {
        var vm = this;

        vm.tempData = angular.copy(viewData);
        vm.origData = angular.copy(viewData);
        vm.submit = _submit;
        vm.cancel = _cancel;
        vm.hasChanges = _hasChanges;

        function _submit(isValid, data){
            if(isValid){
                ViewsService.create(data).then(function(d){
                    $location.url('/settings/queries/' + d);
                });
            }
        }
        function _cancel(){
            $location.url('/settings/queries');
        }
        function _hasChanges() {
            return !angular.equals(vm.origData, vm.tempData);
        }
    }])
;

angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name ViewsPropertiesService
 * @alias cerberus/views:ViewsPropertiesService
 * @description Provides REST service for "views" resource
 */
    .factory('ViewsPropertiesService', ["_", "$http", "$q", "apiPath", "toaster", function ViewsPropertiesService(_, $http, $q, apiPath, toaster) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            get: get,
            add: add,
            remove: remove,
            update: update,
            modelData: modelData
        };
        ////////////////////

        /**
         * Makes a get call REST api "views/{id}/properties" resource
         * @function get
         * @return {promise}
         */
        function get(viewId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'views/' + viewId + '/properties')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
        /**
         * Makes a get call REST api "views/{id}/properties" resource
         * @function add
         * @return {promise}
         */
        function add(viewId, data) {
            var deferred = $q.defer();
            $http.post(apiPath + 'views/' + viewId + '/properties',data)
                .success(function(value){
                    toaster.pop('success', 'View Property Added');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
        /**
         * Makes a delete call REST api "views/properties/{id}" resource
         * @function remove
         * @return {promise}
         */

        function remove(id) {
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'view/properties/' + id})
                .success(function(value){
                    toaster.pop('info', 'View Property Deleted');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        /**
         * Makes a put call to REST api "views/properties/{id}" resource
         * @function update
         * @param id
         * @param data
         * @returns {promise}
         */
        function update(id, data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'view/properties/' + id, {property:data.property, description: data.description})
                .success(function(value){
                    toaster.pop('success', 'View Property Updated');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
        /**
         * models data before post
         * @function modelDaa
         * @returns {object}
         */
        function modelData(data,adv,type) {
            var isValid = false;
            var d = {
                name: data.name,
                description: data.description,
                type: type,
                property:{}
            };
            if(data.name){
                if(adv && data.adv){
                    d.property.adv = data.adv;
                    if(data.where){
                        d.property.where = data.where;
                    }
                    isValid = true;
                }
                else if(data.function && data.field){
                    d.property = {
                        function: data.function.func,
                        field: data.field,
                        argType: data.function.argType
                    };
                    isValid = true;
                }
            }
            return {
                d: d,
                isValid: isValid
            };
        }
    }])
;

angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name ViewsService
 * @alias cerberus/views:ViewsService
 * @description Provides REST service for "views" resource
 */
    .factory('ViewsService', ["_", "$http", "$q", "apiPath", "toaster", function ViewsService(_, $http, $q, apiPath, toaster) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        // ViewsArray cache, I am not sure if this is a good or bad idea.
        // Angular has its own caching system...
        var viewsArray = [];
        return {
            views: views,
            get: get,
            getDetails: getDetails,
            getColumns: getColumns,
            create: create,
            remove: remove
        };
        ////////////////////
        /**
         * This function makes a convenient function for watcher
         * @function views
         * @return {Array} viewsArray
         */
        function views() {
            return viewsArray;
        }

        /**
         * Makes a get call REST api "views" resource
         * @function get
         * @return {promise}
         */
        function get(full) {
            var fullData = false;
            if(full){
                fullData = full;
            }
            var deferred = $q.defer();
            $http.get(apiPath + 'views?full=' + fullData)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
        /**
         * Makes a get call REST api "views/{id}/details" resource
         * @function getDetails
         * @param {string} id - view id
         * @return {promise}
         */
        function getDetails(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'views/' + id + '/details')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Makes a get call REST api "views/{id}/columns" resource
         * @function getColumns
         * @param {string} id - view id
         * @returns {promise}
         */
        function getColumns(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'views/' + id + '/columns')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
        /**
         * Makes a post call REST api "views" resource
         * @function create
         * @param {View} data - view object
         * @return {promise}
         */
        function create(data){
            var deferred = $q.defer();
            $http.post(apiPath + 'views',data)
                .success(function(value){
                    toaster.pop('success', 'View Created.');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Makes a delete call REST api "views" resource by id
         * @function remove
         * @param {string} id
         * @return {promise}
         */
        function remove(id){
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'views/' + id + '/details'})
                .success(function(value){
                    toaster.pop('info', 'View Deleted');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }])
;

angular.module('cerberus.admin')
    .factory('WidgetsSettingsService', ["_", "$http", "$q", "$window", "apiPath", "toaster", "OdataUtilityService", function WidgetsSettingsService(_, $http, $q, $window, apiPath, toaster, OdataUtilityService) {
        return {
            addWidget: addWidget,
            updateWidget: updateWidget,
            deleteWidget: deleteWidget,
            getFormFields: getFormFields,
            parseFormObjects: parseFormObjects,
            getBaseWidgetViews: getBaseWidgetViews,
            exportAllAsExcel: exportAllAsExcel
        };

        function addWidget(data) {
            var deferred = $q.defer();
            $http.post(apiPath + 'widgets', data)
                .success(function (value) {
                    toaster.pop('success', 'Widget Created');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function updateWidget(widgetId, data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'widgets/' + widgetId, data)
                .success(function (value) {
                    toaster.pop('success', 'Widget Saved');
                    deferred.resolve(value);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function deleteWidget(widgetId) {
            var deferred = $q.defer();
            $http({ method: 'DELETE', url: apiPath + 'widgets/' + widgetId })
                .success(function (value) {
                    toaster.pop('info', 'Widget Deleted');
                    deferred.resolve(value);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getFormFields(id, formIds) {
            var deferred = $q.defer();
            var params = {};
            if (!_.isEmpty(formIds)) {
                params.formOriginIds = formIds.join(',');
            }

            $http.get(apiPath + 'widgets/' + id + '/workflow/forms/objects', { params: params })
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            
            return deferred.promise;
        }

        function parseFormObjects(forms) {
            var formObjects = [];
            _.forEach(forms, function (form) {
                _.forEach(form.objects, function (object) {
                    var formObj = {
                        modelId: object.modelId,
                        label: object.label,
                        formName: form.formName,
                        formId: form.originId,
                        stateId: form.stateId,
                        isLookup: object.isLookUp,
                        isCustomLookup: object.isCustomLookup,
                        dataType: object.dataType
                    };

                    if (formObj.isLookup) {
                        formObj.lookupCol = object.column;
                        formObj.viewId = object.optionId;
                    }

                    formObjects.push(formObj);
                });
            });
            
            return formObjects;
        }

        function getBaseWidgetViews(baseWidget) {
            var deferred = $q.defer();
            $http.get(apiPath + 'widgets/' + baseWidget + '/views')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function exportAllAsExcel(id, filter, sort, exportOptions) {
            var deferred = $q.defer();
            var filterString = '';
            if (filter) {
                filterString = OdataUtilityService.toOdataFilter(filter);
            }
            var sortString = '';
            if (sort && sort[0]) {
                sortString = sort[0].field + ' ' + sort[0].dir;
            }
            var exportOptionStruct = {};
            if (exportOptions) {
                exportOptionStruct = exportOptions;
            }
            $http.get(apiPath + 'widgets/' + id + '/export', {
                    params: {
                        $orderBy: sortString,
                        $filter: filterString,
                        $top: 'all',
                        $exportOption: exportOptionStruct
                    }
                })
                .then(function (value) {
                    toaster.pop('success', 'Downloading...');
                    deferred.resolve(value.data);
                },function (error){
                    deferred.reject(error);
                });
            return deferred.promise;
        }
    }])
;
angular.module('cerberus.admin')
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/settings/widgets', {
            templateUrl: 'admin/widgets/widgets.tpl.html',
            controller: 'WidgetsCtrl',
            title: 'Widgets',
            resolve: {
                _wait: 'WaitForUserData',
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/widgets/create', {
            templateUrl: 'admin/widgets/widgets-create.tpl.html',
            controller: 'WidgetsCreateCtrl',
            controllerAs: 'vm',
            title: 'Create Widget',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/settings/widgets/:id', {
            templateUrl: 'admin/widgets/details/widgets-details.tpl.html',
            controller: 'WidgetsDetailsCtrl',
            title: 'Widget Details',
            resolve: {
                _wait: 'WaitForUserData',
                widgetId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:id/forms', {
            templateUrl: 'admin/widgets/forms/forms.tpl.html',
            controller: 'WidgetsFormsCtrl',
            title: 'Widget Forms',
            resolve: {
                _wait: 'WaitForUserData',
                widgetId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:wid/forms/:id', {
            templateUrl: 'admin/widgets/forms/designer/designer.tpl.html',
            controller: 'FormsDesignerCtrl',
            title: 'Form Designer',
            resolve: {
                _wait: 'WaitForUserData',
                formOriginId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                widgetId: ["$route", function($route){
                    return $route.current.params.wid;
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:wid/forms/:id/template', {
            templateUrl: 'admin/widgets/forms/templates/forms-templates-create.tpl.html',
            controller: 'FormsTemplatesCreateCtrl',
            title: 'Create Form Template',
            resolve: {
                _wait: 'WaitForUserData',
                formOriginId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                widgetId: ["$route", function($route){
                    return $route.current.params.wid;
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:id/workflow', {
            templateUrl: 'admin/widgets/workflows/workflow.tpl.html',
            controller: 'WidgetsWorkflowCtrl',
            controllerAs: 'vm',
            title: 'Widget Workflow',
            resolve: {
                _wait: 'WaitForUserData',
                widgetId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:wid/workflow/:id', {
            templateUrl: 'admin/widgets/workflows/designer/designer.tpl.html',
            controller: 'WorkflowsDesignerCtrl',
            title: 'Workflow Designer',
            resolve: {
                _wait: 'WaitForUserData',
                originId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:id/data', {
            templateUrl: 'admin/widgets/data/widgets-data.tpl.html',
            controller: 'WidgetsDataCtrl',
            title: 'Widget Data',
            resolve: {
                _wait: 'WaitForUserData',
                widgetId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:id/imports', {
            templateUrl: 'admin/widgets/imports/imports.tpl.html',
            controller: 'WidgetsImportsCtrl',
            title: 'Widget Imports',
            resolve: {
                _wait: 'WaitForUserData',
                widgetId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:id/imports/jobs', {
            templateUrl: 'admin/widgets/imports/imports-jobs.tpl.html',
            controller: 'WidgetsImportsJobsCtrl',
            controllerAs: 'vm',
            title: 'Import Jobs',
            resolve: {
                _wait: 'WaitForUserData',
                authToken: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.authToken;
                    });
                }],
                widgetId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:id/imports/rules/create', {
            templateUrl: 'admin/widgets/imports/imports-rules-create.tpl.html',
            controller: 'WidgetsImportsRulesCreateCtrl',
            title: 'Create Import Rule',
            resolve: {
                _wait: 'WaitForUserData',
                widgetId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/settings/widgets/:id/imports/rules/:id2', {
            templateUrl: 'admin/widgets/imports/imports-rules-details.tpl.html',
            controller: 'WidgetsImportsRulesDetailsCtrl',
            title: 'Import Rule Details',
            resolve: {
                _wait: 'WaitForUserData',
                widgetId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                importRuleId: ["$route", function($route){
                    return $route.current.params['id2'];
                }]
            }
        });
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetsCreateCtrl', ["_", "$location", "WidgetsService", "WidgetsSettingsService", "DesignerUtilityService", function WidgetsCreateCtrl(_, $location, WidgetsService, WidgetsSettingsService, DesignerUtilityService){
        var vm = this;
        vm.views = [];
        vm.widgetData = {};
        vm.widgetMaster = {};
        vm.idArray = [];
        vm.isUnchanged = function(data){
            return angular.equals(data, vm.widgetMaster);
        };
        vm.save = function(data){
            WidgetsSettingsService.addWidget(data).then(function(id){
                $location.replace().url('/settings/widgets/' + id);
            });
        };
        vm.cancel = function(){
            $location.replace().url('/settings/widgets');
        };

        vm.preventSpace = DesignerUtilityService.preventSpace;
        vm.labelToUniqueId = function (widget){
            widget.uniqueName = DesignerUtilityService.labelToUniqueId(widget.name, vm.idArray);
        };

        init();

        function init(){
            WidgetsService.getWidgets().then(function(widgets){
                vm.idArray = _.map(widgets, 'uniqueName');
            });

            vm.widgetData = {
                icon: 'puzzle-piece'
            };
            vm.widgetMaster = angular.copy(vm.widgetData);
        }
    }])
;
angular.module('cerberus.admin')
    .directive('nimWidgetIdAvailable', ["$http", "apiPath", function($http, apiPath) {
        return {
            require : 'ngModel',
            link : function($scope, element, attrs, ngModel) {
                ngModel.$asyncValidators.nimWidgetIdAvailable = function(name) {
                    valid(false);
                    loading(true);
                    return $http.get(apiPath + 'widgets/id/available?id='+ name).then(
                        function(value) {
                            valid(value.data.DATA);
                            loading(false);
                        },
                        function() {
                            valid(false);
                            loading(false);
                        }
                    );
                };
                ////////////////////
                function valid(bool) {
                    ngModel.$setValidity('record-unavailable', bool);
                }

                function loading(bool) {
                    ngModel.$setValidity('record-loading', !bool);
                }
            }
        };
    }])
;
angular.module('cerberus.admin')
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/settings', {
            templateUrl: 'admin/workspaces/settings.tpl.html',
            controller: 'WorkspacesSettingsCtrl',
            title: 'Workspace Settings',
            resolve: {
                _wait: 'WaitForUserData',
                currentOrg: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentOrg.id;
                    });
                }],
                currentWorkspace: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/permissions', {
            templateUrl: 'admin/workspaces/permissions.tpl.html',
            controller: 'WorkspacesPermissionsCtrl',
            controllerAs: 'vm',
            title: 'Workspace Permissions',
            resolve:{
                _wait: 'WaitForUserData',
                currentUserId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.id;
                    });
                }],
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/users/:id', {
            templateUrl: 'admin/workspaces/users-details.tpl.html',
            controller: 'WorkspacesUsersDetailsCtrl',
            controllerAs: 'vm',
            title: 'Workspace User Details',
            resolve:{
                _wait: 'WaitForUserData',
                userId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
        $routeProvider.when('/settings/groups/create', {
            templateUrl: 'admin/workspaces/groups-create.tpl.html',
            controller: 'WorkspacesGroupsCreateCtrl',
            controllerAs: 'vm',
            title: 'Create Workspace Group',
            resolve:{
                _wait: 'WaitForUserData',
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/groups/:id', {
            templateUrl: 'admin/workspaces/groups-details.tpl.html',
            controller: 'WorkspacesGroupsDetailsCtrl',
            controllerAs: 'vm',
            title: 'Workspace Group Details',
            resolve:{
                _wait: 'WaitForUserData',
                groupId: ["$route", function($route){
                    return $route.current.params.id;
                }],
                workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function(){
                        return $rootScope.userData.currentWorkspace.id;
                    });
                }]
            }
        });
        $routeProvider.when('/settings/currency', {
            templateUrl: 'admin/workspaces/currency.tpl.html',
            controller: 'WorkspacesCurrencyCtrl',
            title: 'Workspace Currency',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/settings/numbers', {
            templateUrl: 'admin/workspaces/numbers.tpl.html',
            controller: 'WorkspacesNumbersCtrl',
            title: 'Workspace Numbers',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/settings/date-time', {
            templateUrl: 'admin/workspaces/date-time.tpl.html',
            controller: 'WorkspacesDateTimeCtrl',
            title: 'Workspace Date Time',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
        $routeProvider.when('/settings/whitelist', {
            templateUrl: 'admin/workspaces/whitelist.tpl.html',
            controller: 'WorkspacesWhitelistCtrl',
            title: 'Workspace White List',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });

        $routeProvider.when('/settings/profile', {
            templateUrl: 'admin/workspaces/profile.tpl.html',
            controller: 'WorkspacesProfileCtrl',
            title: 'Workspace Profile',
            resolve: {
                _wait: 'WaitForUserData',
                workspaceData: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                    return WaitForUserData.then(function () {
                        return $rootScope.userData.currentWorkspace;
                    });
                }]
            }
        });
    }])
;
angular.module('cerberus.admin')
    .controller('WorkspacesCtrl', ["$scope", "$uibModal", "$rootScope", "$window", function WorkspacesCtrl($scope, $uibModal, $rootScope, $window) {
        $scope.workspaces = [];
        $scope.$watch('$rootScope.userData', function (newValue) {
            $scope.workspaces = newValue.workspaces;
        }, true);
        $scope.goToWorkspace = function(url){
            $window.location.href = url + '/#/';
        };
        $scope.openCreateBusinessWorkspaceModal = function(){
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/workspaces/workspaces-create-modal.tpl.html',
                controller: 'WorkspacesCreateModalCtrl',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    isSubWorkspace: function(){
                        return 0;
                    }
                }
            });
            modalInstance.result.then(function (workspaceUrl) {
                $scope.goToWorkspace(workspaceUrl);
            });
        };
    }])
;

angular.module('cerberus.admin')
    .controller('WorkspacesCreateModalCtrl', ["$scope", "$uibModalInstance", "workspacesService", "isSubWorkspace", "$rootScope", function WorkspacesCreateModalCtrl($scope, $uibModalInstance, workspacesService, isSubWorkspace, $rootScope) {
        $scope.workspaceObject = {};
        $scope.isSubWorkspace = isSubWorkspace;
        $scope.currentWorkspace = $rootScope.userData.currentWorkspace.id;
        $scope.orgSubDomain = $rootScope.userData.currentOrg.sub_domain;

        $scope.updatePath = function(){
            var name = $scope.workspaceObject.name || '';
            $scope.workspaceObject.path = name.replace(/[^A-Z0-9a-z]/g,'').toLowerCase();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function () {
            if(isSubWorkspace > 0){
                $scope.workspaceObject.parent = $scope.currentWorkspace;
            }
            workspacesService.create($rootScope.userData.currentOrg.id,$scope.workspaceObject).then(function(data){
                $uibModalInstance.close(data);
            });
        };

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;

angular.module('cerberus.admin')
    .controller('WorkspacesCurrencyCtrl', ["$scope", "$location", "workspaceSettingsFactory", function WorkspaceCurrencyCtrl($scope, $location, workspaceSettingsFactory) {
        $scope.currencyMaster = {};
        $scope.currencyUser = {};
        $scope.currencyLookup = {
            decimalPrecision:[
                {format:'c', display:"Auto"},
                {format:'c0', display:"0 ( 1 )"},
                {format:'c1', display:"1 ( 1.0 )"},
                {format:'c2', display:"2 ( 1.00 )"}
            ],
            culture:[
                {format:'en-AU', display:"Australia"},
                {format:'en-CA', display:"Canada"},
                {format:'en-GB', display:"United Kingdom"},
                {format:'en-US', display:"United States of America"}
            ]
        };

        $scope.isUnchanged = _isUnchanged;
        $scope.save = _save;
        $scope.reset = _reset;

        _init();

        function _init(){
            workspaceSettingsFactory.getSettings('currencyDecimalPrecision,currencyCulture').then(function(settingsModel){
                $scope.currencyMaster = angular.copy(settingsModel);
                $scope.currencyUser = angular.copy($scope.currencyMaster);
            });
        }

        function _isUnchanged(user) {
            return angular.equals(user, $scope.currencyMaster);
        }

        function _save(user){
            workspaceSettingsFactory.putSettings({settings:user}).then(function(){
                $location.url('/settings');
            });
        }

        function _reset(){
            $location.replace().url('/settings');
        }
    }])
;
angular.module('cerberus.admin')
    .controller('WorkspacesDateTimeCtrl', ["$scope", "$location", "workspaceSettingsFactory", function WorkspaceDateTimeCtrl($scope, $location, workspaceSettingsFactory) {
        $scope.datetimeMaster = {};
        $scope.datetimeUser = {};
        $scope.datetimeLookup = {
            shortDate: [
                {format: 'y', display:'November, 2000'},
                {format: 'm', display:'November 06'}
            ],
            longDate: [
                {format: 'D', display:'Monday, November 06, 2000'},
                {format: 'd', display:'11/6/2000'}
            ],
            shortTime: [
                {format: 'hh:mm tt', display:'12:00 AM'},
                {format: 'HH:mmZ', display:'00:00Z'}
            ],
            longTime: [
                {format: 'hh:mm:ss tt', display:'12:00:00 AM'},
                {format: 'HH:mm:ss"Z"', display:'00:00:00Z'}
            ],
            shortDateTime: [
                {format: 'g', display:'11/6/2000 12:00 AM'},
                {format: 'G', display:'11/6/2000 12:00:00 AM'}
            ],
            longDateTime: [
                {format: 'F', display:'Monday, November 06, 2000 12:00:00 AM'},
                {format: 'u', display:'2000-11-06 00:00:00Z'}
            ],
            culture:[
                {format:'en-AU', display:"Australia"},
                {format:'en-CA', display:"Canada"},
                {format:'en-GB', display:"United Kingdom"},
                {format:'en-US', display:"United States of America"}
            ]
        };

        $scope.isUnchanged = _isUnchanged;
        $scope.save = _save;
        $scope.reset = _reset;

        _init();

        function _init(){
            workspaceSettingsFactory.getSettings('dateTimeShortDate,dateTimeLongDate,dateTimeShortTime,dateTimeLongTime,dateTimeShortDateTime,dateTimeLongDateTime,dateTimeCulture').then(function(settingsModel){
                $scope.datetimeMaster = angular.copy(settingsModel);
                $scope.datetimeUser = angular.copy($scope.datetimeMaster);
            });
        }

        function _isUnchanged(user){
            return angular.equals(user, $scope.datetimeMaster);
        }

        function _save(user){
            workspaceSettingsFactory.putSettings({settings:user}).then(function(){
                $location.url('/settings');
            });
        }

        function _reset(){
            $location.replace().url('/settings');
        }
    }])
;
angular.module('cerberus.admin')
    .controller('WorkspacesGroupsCreateCtrl', ["$location", "workspaceId", "WorkspacesGroupsService", function WorkspacesGroupsCreateCtrl($location, workspaceId, WorkspacesGroupsService) {
        var vm = this;
        vm.tempGroupModel = {
            details: {
                adv:{
                    ip:[]
                }
            },
            members: {
                current: [],
                add: [],
                remove: [],
                input: []
            },
            memberOf:{current:null}
        };
        vm.tmpIpDetails = {};
        vm.origGroupModel = angular.copy(vm.tempGroupModel);
        vm.selectedMembers = {};
        vm.selectedIps = {};
        vm.availableMembersDs = null;
        vm.membersSelectOptions = {
            placeholder: 'Enter users/groups here...',
            dataTextField: 'name'
        };

        vm.add = WorkspacesGroupsService.addItem;
        vm.remove = WorkspacesGroupsService.removeItem;
        vm.addIp = WorkspacesGroupsService.addIp;
        vm.removeIp = WorkspacesGroupsService.removeIp;
        vm.isUnchanged = function(){
            return WorkspacesGroupsService.isUnchanged(vm.tempGroupModel,vm.origGroupModel);
        };
        vm.submit = function(data){
            if(data.details.name){
                WorkspacesGroupsService.createGroup(workspaceId, data.details).then(function(value){
                    $location.url('settings/groups/' + value);
                });
            }
        };

        vm.cancel = function(){
            $location.url('/settings/permissions');
        };
    }])
;
angular.module('cerberus.admin')
    .controller('WorkspacesGroupsDetailsCtrl', ["kendo", "$location", "groupId", "workspaceId", "WorkspacesGroupsService", function WorkspacesGroupsDetailsCtrl(kendo, $location, groupId, workspaceId, WorkspacesGroupsService) {
        var vm = this;
        vm.groupId = groupId;
        vm.tempGroupModel = {
            details: {
                adv:{
                    ip:[]
                }
            },
            members: {
                current: [],
                add: [],
                remove: [],
                input: []
            },
            memberOf:{current:null}
        };
        vm.origGroupModel = angular.copy(vm.tempGroupModel);
        vm.selectedMembers = {};
        vm.availableMembersDs = null;
        vm.membersSelectOptions = {
            placeholder: 'Enter users/groups here...',
            dataTextField: 'name'
        };

        vm.add = WorkspacesGroupsService.addItem;
        vm.remove = WorkspacesGroupsService.removeItem;
        vm.addIp = WorkspacesGroupsService.addIp;
        vm.removeIp = WorkspacesGroupsService.removeIp;
        vm.isUnchanged = function(){
            return WorkspacesGroupsService.isUnchanged(vm.tempGroupModel,vm.origGroupModel);
        };
        vm.submit = function(data){
            if(data.details.name){
                WorkspacesGroupsService.updateGroup(groupId, data, vm.origGroupModel).then(function(){
                    $location.url('/settings/permissions');
                });
            }
        };

        vm.cancel = function(){
            $location.url('/settings/permissions');
        };

        init();

        function init(){
            WorkspacesGroupsService.getGroupDetails(vm.groupId).then(function(data){
                vm.tempGroupModel.details = data;
                vm.origGroupModel = angular.copy(vm.tempGroupModel);
            });

            WorkspacesGroupsService.getMembers(vm.groupId).then(function(data){
                vm.tempGroupModel.members.current = data;
                vm.origGroupModel = angular.copy(vm.tempGroupModel);
            });

            WorkspacesGroupsService.getAvailableMembers(workspaceId,vm.groupId).then(function(data){
                vm.availableMembersDs = new kendo.data.ObservableArray(data);
            });
        }
    }])
;
angular.module('cerberus.admin')

    .factory('WorkspacesGroupsService', ["_", "$http", "$q", "apiPath", "toaster", function WorkspacesGroupsService(_, $http, $q, apiPath, toaster) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';

        return {
            getMembers:getMembers,
            getGroupDetails:getGroupDetails,
            getAvailableMembers: getAvailableMembers,
            createGroup: createGroup,
            getGroups: getGroups,
            addItem: addItem,
            removeItem:removeItem,
            isUnchanged: isUnchanged,
            updateDetails: updateDetails,
            updateMembers: updateMembers,
            updateGroup: updateGroup,
            deleteGroup: deleteGroup,
            deleteGroups: deleteGroups,
            addIp: addIp,
            removeIp: removeIp
        };
        ////////////////////

        function addIp(form,ipArr,model){
            if(form.$valid) {
                    ipArr.push(angular.copy(model));
                    model.start = null;
                    model.end = null;
            }
        }

        function removeIp(ipArr,selected){
            var arr = angular.copy(ipArr);
            angular.forEach(selected,function(v,k){
               if(v){
                   for(var i = 0; i< ipArr.length; i++){
                       if(ipArr[i].start == arr[k].start && ipArr[i].end == arr[k].end){
                           ipArr.splice(i,1);
                           break;
                       }
                   }
               }
                selected[k] = false;
            });
        }

        function getGroups(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'workspaces/' + id + '/groups')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getMembers(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'groups/' + id + '/members')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getGroupDetails(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'groups/' + id)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function createGroup(id, data){
            var deferred = $q.defer();
            $http.post(apiPath + 'workspaces/' + id + '/groups', data)
                .success(function (value) {
                    toaster.pop('success', 'Group created.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function updateMembers(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'groups/' + id + '/members', data)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function updateDetails(id,data){
            var deferred = $q.defer();
            $http.put(apiPath + 'groups/' + id, data)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function updateGroup(id, data, orig){
            var promises = [];
            //Update name and description
            if(!angular.equals(data.details, orig.details)){
                promises.push(
                    updateDetails(id, data.details)
                );
            }
            //Updating members
            if(!angular.equals(data.members.current, orig.members.current)){
                promises.push(
                    updateMembers(id,{add:data.members.add, remove:data.members.remove})
                );
            }
            return $q.all(promises).then(function(){
                toaster.pop('success', 'Group updated.');
            });
        }

        function getAvailableMembers(workspaceId,groupId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'workspaces/' + workspaceId + '/groups/' + groupId + '/available/members')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function isUnchanged(temp,orig){
            var isEqualGroup = angular.equals(temp.details, orig.details);
            var isEqualMembers = angular.equals(temp.members.current, orig.members.current);
            var isEqualMemberOf = angular.equals(temp.memberOf.current, orig.memberOf.current);
            return (isEqualGroup && isEqualMembers && isEqualMemberOf);
        }

        function removeItem(model,selected,ds){
            angular.forEach(selected,function(v,k){
                if(v){
                    /* LODASH Version 4 ONLY */
                    //var foundIndex = _.findIndex(model.current, ['id', k]);
                    //var findAddIdx = _.findIndex(model.add, ['id', k]);
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    var foundIndex = _.findIndex(model.current, function(f){return f.id === k;});
                    var findAddIdx = _.findIndex(model.add, function(f){return f.id === k;});
                    if(findAddIdx > -1){
                        model.add.splice(findAddIdx,1);
                    }
                    else{
                        model.remove.push(model.current[foundIndex]);
                    }
                    ds.push(model.current[foundIndex]);
                    model.current.splice(foundIndex,1);
                    selected[k] = false;
                }
            });
        }

        function addItem(model,ds){
            for(var i = 0; i < model.input.length; i++){
                model.current.push(model.input[i]);
                /* LODASH Version 4 ONLY */
                //var idx = _.findIndex(model.remove, ['id', model.input[i].id]);
                /* NON LODASH OPTION - JAVA NATIVE STYLE */
                var idx = model.remove.map(function(e){ return e.id; }).indexOf(model.input[i].id); /* NON LODASH OPTION */
                if(idx > -1){
                    model.remove.splice(idx,1);
                }
                else{
                    model.add.push(model.input[i]);
                }
                removeFromArray(ds,model.input[i].id);
            }
            model.input = [];
        }

        function deleteGroup(id){
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'groups/' + id})
                .success(function(value){
                    deferred.resolve(value);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function deleteGroups(idArray){
            var promises = [];
            for(var i = 0; i < idArray.length; i++){
                promises.push(deleteGroup(idArray[i]));
            }
            return $q.all(promises).then(function(){
                toaster.pop('info', 'Group(s) deleted.');
            });
        }

        function removeFromArray(array,id){
            for(var i = 0; i < array.length; i++){
                if(array[i].id === id){
                    array.splice(i,1);
                }
            }
        }
    }])
;

angular.module('cerberus.admin')
    .controller('WorkspacesNumbersCtrl', ["$scope", "$location", "workspaceSettingsFactory", function WorkspaceNumbersCtrl($scope, $location, workspaceSettingsFactory) {
        $scope.numbersMaster = {};
        $scope.numbersUser = {};
        $scope.numbersLookup = {
            decimalPrecision:[
                {format:'n', display:"Auto"},
                {format:'n0', display:"0 ( 1 )"},
                {format:'n1', display:"1 ( 1.0 )"},
                {format:'n2', display:"2 ( 1.00 )"}
            ],
            exponentPrecision:[
                {format:'e', display:"Auto"},
                {format:'e0', display:"0"},
                {format:'e1', display:"1"},
                {format:'e2', display:"2"}
            ],
            culture:[
                {format:'en-AU', display:"Australia"},
                {format:'en-CA', display:"Canada"},
                {format:'en-GB', display:"United Kingdom"},
                {format:'en-US', display:"United States of America"}
            ]
        };

        $scope.isUnchanged = _isUnchanged;
        $scope.save = _save;
        $scope.reset = _reset;

        _init();

        function _init(){
            workspaceSettingsFactory.getSettings('numbersDecimalPrecision,numbersExponentPrecision,numbersCulture').then(function(settingsModel){
                $scope.numbersMaster = angular.copy(settingsModel);
                $scope.numbersUser = angular.copy($scope.numbersMaster);
            });
        }

        function _isUnchanged(user) {
            return angular.equals(user, $scope.numbersMaster);
        }

        function _save(user){
            workspaceSettingsFactory.putSettings({settings:user}).then(function(){
                $location.url('/settings');
            });
        }

        function _reset(){
            $location.replace().url('/settings');
        }
    }])
;
angular.module('cerberus.admin')
    .controller('WorkspacesPermissionsCtrl', ["_", "$location", "$uibModal", "statusList", "currentUserId", "workspaceId", "ConfirmModalService", "WorkspacesGroupsService", "WorkspacesUserService", function WorkspacesPermissionsCtrl(_, $location, $uibModal, statusList, currentUserId, workspaceId,
                                                                                ConfirmModalService, WorkspacesGroupsService, WorkspacesUserService){
        var vm = this;

        vm.userEmails = null;
        vm.organizationUsers = null;
        vm.statusList = statusList;
        vm.currentUserId = currentUserId;
        vm.usersArray = [];
        vm.selectedUsers = {
            checked: false,
            users:{}
        };
        vm.userEmailsBatch = null;
        vm.groups = [];
        vm.records = { 'checked': false, items: {} };
        vm.workspaceId = workspaceId;

        // Users Functions
        vm.openBatchUserModal = openBatchUserModal;
        vm.removeUser = removeUser;
        vm.enableUsers = enableUsers;
        vm.disableUsers = disableUsers;
        vm.addUsers = addUsers;
        vm.openUserDetails = openUserDetails;

        // Groups Functions
        vm.openGroup = openGroup;
        vm.deleteGroup = deleteGroup;

        init();

        function init(){
            WorkspacesUserService.getUsers().then(function(data){
                vm.usersArray = data;
            });
            WorkspacesUserService.getOrgUserList().then(function(data){
                vm.organizationUsers = data;
            });
            WorkspacesGroupsService.getGroups(workspaceId).then(function(data){
                vm.groups = data;
            });
        }

        // Users Functions
        function parseSelected(sel){
            var idArray = [];
            angular.forEach(sel,function(v,k){
                if(v){
                    idArray.push(k);
                }
            });
            return idArray;
        }

        function openBatchUserModal(emails){
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/workspaces/users-batch-add-modal.tpl.html',
                controller: 'WorkspacesUsersBatchAddModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    emailList: function () {
                        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        var d = {
                            existUser: [],
                            newUser: [],
                            invalidUser: []
                        };
                        var emailArr = emails.split(',');
                        for(var i = 0; i < emailArr.length; i++){
                            var userIsInWorkspace = false;
                            for(var j = 0; j < vm.usersArray; j++){
                                if(emailArr[i] === vm.usersArray[j].email){
                                    userIsInWorkspace = true;
                                }
                            }
                            if(!userIsInWorkspace){
                                if(!re.test(emailArr[i])){
                                    d.invalidUser.push(emailArr[i]);
                                }
                                else{
                                    if(vm.organizationUsers.indexOf(emailArr[i]) > -1){
                                        d.existUser.push(emailArr[i]);
                                    }
                                    else{
                                        d.newUser.push(emailArr[i]);
                                    }
                                }
                            }
                        }
                        return d;
                    }
                }
            });
            modalInstance.result.then(function () {
                WorkspacesUserService.addUsers({userEmails:emails}).then(function(){
                    init();
                });
            });
        }

        function removeUser(data){
            var users = parseSelected(data.users);
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to remove these users from the current workspace?',
                actionButtonText: 'Remove',
                closeButtonText: 'Cancel',
                check: function(){
                    return true;
                },
                confirm: function(){
                    return WorkspacesUserService.removeUsers(users);
                },
                callback: function(){
                    init();
                }
            });
        }

        function enableUsers(data){
            var users = parseSelected(data.users);
            WorkspacesUserService.enableUsers({userIds:users}).then(function(){
                init();
            });
        }

        function disableUsers(data){
            var users = parseSelected(data.users);
            WorkspacesUserService.disableUsers({userIds:users}).then(function(){
                init();
            });
        }

        function addUsers(data){
            WorkspacesUserService.addUsers({userEmails:data}).then(function(){
                init();
            });
        }

        function openUserDetails(id){
            $location.url('/settings/users/' + id);
        }

        //Groups Functions
        function openGroup(id){
            if(id){
                $location.url('settings/groups/' + id);
            }
            else {
                $location.url('settings/groups/create');
            }
        }

        function deleteGroup(){
            var idArray = _.keys(vm.records.items);
            if(idArray.length > 0){
                WorkspacesGroupsService.deleteGroups(idArray).then(init);
            }
        }
    }])
;
angular.module('cerberus.admin')
    .controller('WorkspacesProfileCtrl', ["_", "$scope", "$location", "workspaceData", "workspacesService", function WorkspacesProfileCtrl(_, $scope, $location, workspaceData, workspacesService) {
        $scope.tempData = angular.copy(workspaceData);
        $scope.tempData.logo = $scope.tempData.logo || '';
        $scope.origData = angular.copy(workspaceData);
        $scope.workspaceId = workspaceData.id;
        $scope.cropStep = 1;
        $scope.usePath = workspaceData.path || workspaceData.path !== "";

        $scope.clearLogo = function(){
            $scope.tempData.logo = '';
            $scope.imageSrc = null;
        };
        $scope.save = function(data){
            workspacesService.update($scope.workspaceId, data).then(function(){
                _.assign(workspaceData, data);
                $location.url('/settings');
            });
        };
        $scope.reset = function(){
            $location.replace().url('/settings');
        };
        $scope.isUnchanged = function() {
            return angular.equals($scope.origData, $scope.tempData);
        };
    }])
;
angular.module('cerberus.admin')
    .factory('workspacesService', ["$http", "$q", "apiPath", "toaster", function workspacesService($http, $q, apiPath, toaster) {
            /** @public */
            return {
                create: function(id,data){
                    var deferred = $q.defer();
                    $http.post(apiPath + 'organizations/' + id + '/workspaces', data)
                        .success(function (value) {
                            toaster.pop('success', 'Business Workspace Created.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                getChildren: function(){
                    var deferred = $q.defer();
                    $http.get(apiPath + 'children')
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                get: function(id){
                    var deferred = $q.defer();
                    $http.get(apiPath + 'workspaces/' + id)
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                update: function(id, data){
                    var deferred = $q.defer();
                    $http.put(apiPath + 'workspaces/' + id, data)
                        .success(function (value) {
                            toaster.pop('success', 'Workspace updated.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                deleteCurrentWorkspace: function(){
                    var deferred = $q.defer();
                    $http({method: 'DELETE', url: apiPath + 'workspaces/current/delete'})
                        .success(function(value){
                            deferred.resolve(value);
                        })
                        .error(function(reason){
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                }
            };
        }])
;

angular.module('cerberus.admin')
    .controller('WorkspacesSettingsCtrl', ["$scope", "$location", "$window", "currentOrg", "currentWorkspace", "ConfirmModalService", "workspacesService", function SettingsCtrl($scope, $location, $window, currentOrg, currentWorkspace, ConfirmModalService, workspacesService) {
        $scope.wsCollapse = false;
        $scope.accountCollapse = true;
        $scope.currentOrg = currentOrg;
        $scope.workspaceName = currentWorkspace.name;
        $scope.workspacePath = currentWorkspace.path;

        $scope.openDeleteWorkspaceModal = function(workspaceName, workspacePath){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to delete this workspace?',
                instructionText: 'Type "DELETE ' + workspaceName + '" to confirm.',
                actionButtonText: 'Delete Workspace Forever',
                closeButtonText: 'Cancel',
                check: function(input){
                    return angular.equals(input, 'DELETE ' + workspaceName);
                },
                confirm: function(){
                    return workspacesService.deleteCurrentWorkspace();
                },
                callback: function(){
                    $window.location = $location.absUrl().replace('/' + workspacePath + '/#/','/#/');
                }
            });
        };
    }])
;
angular.module('cerberus.admin')
    .factory('workspaceSettingsFactory', ["$http", "$q", function($http, $q){
        /** @private */
        var getPath =  function (v){
            return '/server/rest/v1/workspaces/settings?s=' + v.toString();
        };
        var putPath =  function (){
            return '/server/rest/v1/workspaces/settings';
        };
        /** @public */
        return {
            /**
             * Cache all Settings
             *
             * @returns {promise|*}
             */
            getSettingsLookups: function () {
                var deferred = $q.defer();
                $http.get(getPath(''), {cache: true})
                    .success(function (value) {
                        deferred.resolve(value);
                    })
                    .error(function (reason) {
                        deferred.reject(reason);
                    });
                return deferred.promise;
            },
            /**
             * Read Settings from Server
             *
             * @param {Array} varNames
             * @returns {promise|*}
             */
            getSettings: function (varNames) {
                var deferred = $q.defer();
                $http.get(getPath(varNames))
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(reason.DATA);
                    });
                return deferred.promise;
            },
            /**
             * Update Settings to Server
             *
             * @param {Object} data
             * @returns {promise|*}
             */
            putSettings: function (data) {
                var deferred = $q.defer();
                $http.put(putPath(), data)
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(reason.DATA);
                    });
                return deferred.promise;
            }
        };
    }])
;
angular.module('cerberus.admin')
    .controller('WorkspacesUsersBatchAddModalCtrl', ["$scope", "$uibModalInstance", "emailList", function WorkspacesUsersBatchAddModalCtrl($scope, $uibModalInstance, emailList) {
        var vm = this;

        vm.emails = emailList;
        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        vm.ok = function(){
            $uibModalInstance.close();
        };

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('WorkspacesUsersDetailsCtrl', ["_", "kendo", "$location", "userId", "UsersService", "usersProfileService", "WorkspacesGroupsService", "WorkspacesUserService", function WorkspacesUsersDetailsCtrl(_, kendo, $location, userId, UsersService, usersProfileService,
                                                                                  WorkspacesGroupsService, WorkspacesUserService) {
        var vm = this;

        vm.userInfo = null;
        vm.userId = userId;
        vm.tempGroupModel = {
            details: null,
            members: {current:[]},
            memberOf:{
                current:[],
                add:[],
                remove:[],
                input:[]
            }
        };
        vm.origGroupModel = angular.copy(vm.tempGroupModel);
        vm.selectedMemberOf = {};
        vm.availableMemberOfDs = null;
        vm.memberOfSelectOptions = {
            placeholder: 'Enter group(s) here...',
            dataTextField: 'name'
        };
        vm.add = WorkspacesGroupsService.addItem;
        vm.remove = WorkspacesGroupsService.removeItem;
        vm.isUnchanged = function(){
            return WorkspacesGroupsService.isUnchanged(vm.tempGroupModel,vm.origGroupModel);
        };
        vm.submit = function(isValid,data){
            if(isValid){
                if(!angular.equals(data.memberOf.current, vm.origGroupModel.memberOf.current)){
                    UsersService.updateMemberOf(vm.userId,{add:data.memberOf.add, remove:data.memberOf.remove}).then(function(){
                        $location.url('/settings/permissions');
                    });
                }
            }
        };

        vm.cancel = function(){
            $location.url('settings/permissions');
        };

        init();

        function init(){
            // Gets list of users in case user has no profile
            WorkspacesUserService.getUsers().then(function(workspaceUsers){
                var user = _.find(workspaceUsers, 'id', userId);

                if(!vm.userInfo && user){
                    vm.userInfo = {
                        firstName: user.firstName,
                        middleName: user.middleName,
                        lastName: user.lastName,
                        displayEmail: user.email
                    };
                }
            });

            // Gets user profile to display user data
            usersProfileService.getDefaultUserProfile(userId).then(function(userProfile) {
                if (userProfile[0] && userProfile[0].data) {
                    vm.userInfo = userProfile[0].data;
                }
            });

            WorkspacesUserService.getMemberOf(userId).then(function(memberOf){
                vm.tempGroupModel.memberOf.current = memberOf;
                vm.origGroupModel = angular.copy(vm.tempGroupModel);
            });
            WorkspacesUserService.getAvailableMemberOf(userId).then(function(availableMemberOf){
                vm.availableMemberOfDs = new kendo.data.ObservableArray(availableMemberOf);
            });
        }
    }])
;
angular.module('cerberus.admin')
    .factory('WorkspacesUserService', ["_", "$http", "$q", "apiPath", "toaster", function WorkspacesUserService(_, $http, $q, apiPath, toaster) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';

        return {
            getUsers: getUsers,
            getAvailableMemberOf: getAvailableMemberOf,
            getMemberOf: getMemberOf,
            addUsers: addUsers,
            removeUsers: removeUsers,
            getOrgUserList: getOrgUserList,
            enableUsers: enableUsers,
            disableUsers: disableUsers
        };
        ////////////////////

        function disableUsers(data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'workspaces/users/disable', data)
                .success(function (value) {
                    toaster.pop('info', 'Selected user(s) has been disabled.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function enableUsers(data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'workspaces/users/enable', data)
                .success(function (value) {
                    toaster.pop('success', 'Selected user(s) has been enabled.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function removeUsers(id){
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'workspaces/users/' + id})
                .success(function(value){
                    toaster.pop('info', 'User(s) removed.');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getOrgUserList(){
            var deferred = $q.defer();
            $http.get(apiPath + 'workspaces/org/user/list')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function addUsers(data) {
            var deferred = $q.defer();
            $http.post(apiPath + 'workspaces/users', data)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getMemberOf(userId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'workspaces/users/' + userId + '/memberOf')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getAvailableMemberOf(userId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'workspaces/users/' + userId + '/available/memberOf')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getUsers(){
            var deferred = $q.defer();
            $http.get(apiPath + 'workspaces/users')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }])
;
angular.module('cerberus.admin')
    .directive('nimWorkspaceAvailable', ["$http", "apiPath", function($http, apiPath) {
        return {
            require : 'ngModel',
            link : function($scope, element, attrs, ngModel) {
                ngModel.$asyncValidators.nimWorkspaceAvailable = function(name) {
                    valid(false);
                    loading(true);
                    return $http.get(apiPath + 'organization/' + $scope.orgId + '/workspaces/name/available?name='+ name).then(
                        function(value) {
                            valid(value.data.DATA);
                            loading(false);
                        },
                        function() {
                            valid(false);
                            loading(false);
                        }
                    );
                };
                ////////////////////
                function valid(bool) {
                    ngModel.$setValidity('record-unavailable', bool);
                }

                function loading(bool) {
                    ngModel.$setValidity('record-loading', !bool);
                }
            }
        };
    }])
;

angular.module('cerberus.admin')
    .controller('WorkspacesWhitelistCtrl', ["$scope", "$location", "workspaceSettingsFactory", function WorkspacesWhitelistCtrl($scope, $location, workspaceSettingsFactory){
        $scope.pageTitle = 'Upload Whitelist';
        $scope.masterWhitelist = [];
        $scope.whitelist = '';

        $scope.isUnchanged = _isUnchanged;
        $scope.save = _save;
        $scope.cancel = _cancel;

        _init();

        function _init(){
            workspaceSettingsFactory.getSettings('whiteList').then(function(settingsModel){
                $scope.masterWhitelist = angular.fromJson(angular.copy(settingsModel.whiteList));
                $scope.whitelist = $scope.masterWhitelist.join(', ');
            });
        }

        function toArray(listString){
            return listString.replace(/ /g, '').replace('\n', '').split(',');
        }

        function _isUnchanged(list){
            return angular.equals($scope.masterWhitelist, toArray(list));
        }

        function _save(list){
            workspaceSettingsFactory.putSettings({settings:{whiteList:toArray(list)}}).then(function(){
                $location.url('/settings');
            });
        }

        function _cancel(){
            $location.replace().url('/settings');
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc config
     * @description $http interceptor & router config;
     * On 401 response (without 'ignoreAuthModule' option) stores the request
     * and broadcasts events namespaced with 'auth:'.
     */
    .config(["$httpProvider", function($httpProvider) {
        $httpProvider.interceptors.push(["_", "moment", "$rootScope", "$q", "AuthHttpBuffer", function(_, moment, $rootScope, $q, AuthHttpBuffer) {
            return {
                request: function (config) {
                    if ($rootScope.authToken) {
                        config.headers['Authentication'] = 'Bearer ' + $rootScope.authToken;
                        var payload = angular.fromJson(atob($rootScope.authToken.split('.')[1]));
                        var utcNow = moment.utc().valueOf();
                        var utcRotateTime = 1200000; //20 minutes
                        //If token is going to expire in the next 20 minutes rotate it and get a new one
                        if(utcNow > payload.iat + utcRotateTime){
                            //TODO: inject the rotate token service instead of broadcasting it
                            $rootScope.$broadcast('auth:rotateToken', $rootScope.authToken);
                        }
                    }
                    if(_.has($rootScope, 'userData.currentWorkspace.id')) {
                        config.headers['WSID'] = $rootScope.userData.currentWorkspace.id;
                    }

                    return config;
                },
                responseError: function(rejection) {
                    var config = rejection.config || {};
                    if (!config.ignoreAuthModule) {
                        if (rejection.status === 401) {
                            if (_.startsWith(rejection.config.url, '/server/rest/')) {
                                var deferred = $q.defer();
                                AuthHttpBuffer.append(config, deferred);
                                $rootScope.$broadcast('auth:loginRequired', rejection);
                                return deferred.promise;
                            }
                        }
                        if (rejection.status === 403) {
                            $rootScope.$broadcast('auth:forbidden', rejection);
                        }
                    }
                    // otherwise, default behaviour
                    return $q.reject(rejection);
                }
            };
        }]);
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name AuthHttpBuffer
     * @alias cerberus/auth:AuthHttpBuffer
     * @description Holds failed http calls when 401 is received; can reject all promises or retry all calls
     */
    .factory('AuthHttpBuffer', ["$injector", function($injector) {
        /** Holds all the requests, so they can be re-requested in future. */
        var buffer = [];
        /** Service initialized later because of circular dependency problem. */
        var $http;

        return {
            append: append,
            rejectAll: rejectAll,
            retryAll: retryAll
        };
        ////////////////////
        /**
         * This will retry an http request
         * @function retryHttpRequest
         * @param {object} config - the configuration of the original call
         * @param {promise} deferred - the promise from original call
         */
        function retryHttpRequest(config, deferred) {
            function successCallback(response) {
                deferred.resolve(response);
            }
            function errorCallback(response) {
                deferred.reject(response);
            }
            $http = $http || $injector.get('$http');
            $http(config).then(successCallback, errorCallback);
        }

        /**
         * Appends HTTP request configuration object with deferred response attached to buffer.
         * @function append
         * @param {object} config
         * @param {promise} deferred
         */
        function append(config, deferred) {
            buffer.push({
                config: config,
                deferred: deferred
            });
        }

        /**
         * Abandon or reject (if reason provided) all the buffered requests.
         * @function rejectAll
         * @param {*|object} reason
         */
        function rejectAll(reason) {
            if (reason) {
                for (var i = 0; i < buffer.length; ++i) {
                    buffer[i].deferred.reject(reason);
                }
            }
            buffer = [];
        }

        /**
         * Retries all the buffered requests clears the buffer.
         * @function retryAll
         * @param {function} updater - a function to update or change configuration before retrying
         *
         */
        function retryAll(updater) {
            for (var i = 0; i < buffer.length; ++i) {
                retryHttpRequest(updater(buffer[i].config), buffer[i].deferred);
            }
            buffer = [];
        }

    }])
;
angular.module('cerberus.core')
    .controller('AuthLoginCtrl', ["moment", "$scope", "$location", "$rootScope", "appSettingsService", "$uibModalInstance", "AuthService", "AuthPasswordService", "localStorageService", function AuthLoginCtrl(moment, $scope, $location, $rootScope, appSettingsService, $uibModalInstance, AuthService, AuthPasswordService, localStorageService) {
        // Populate Scope
        $scope.branding = appSettingsService.branding();
        $scope.mode = 'login';
        $scope.loginData = {type: localStorageService.get('device') || 'public'};
        $scope.regData = {};
        $scope.regConfirm = null;
        $scope.regTermsConditions = null;
        $scope.forgotData = {};
        $scope.result = {};
        $scope.signingIn = false;

        /* UI */
        // This controls the collapse directive to show and hide sections
        $scope.setMode = function (mode) {
            $scope.mode = mode;
        };

        /* Login */
        $scope.login = function(isValid, data) {
            if (isValid) {
                $scope.signingIn = true;
                
                AuthService.login(data).then(
                    function () {
                        localStorageService.set('device', data.type);
                        $uibModalInstance.close();
                        $scope.signingIn = false;
                    }, function () {
                        $scope.signingIn = false;
                        $scope.loginData.userPassword = null;
                        $scope.result.visible = true;
                        $scope.result.class = 'danger';
                        $scope.result.title = 'Error:';
                        $scope.result.message = 'Invalid email and password combination; try again.';
                    }
                );
            }
        };

        /* Cancel Button */
        $scope.cancel = function () {
            // Reset registration data and form
            //$scope.regData = {};
            //$scope.regConfirm = null;
            //$scope.regTermsConditions = null;
            //$scope.regForm.$setPristine();
            //$scope.regForm.$setUntouched();
            // Reset forgot password data and form
            $scope.forgotData = {};
            $scope.forgotForm.$setPristine();
            $scope.forgotForm.$setUntouched();
            // Reset login data and form
            $scope.loginData.userPassword = null;
            $scope.loginForm.$setPristine();
            $scope.loginForm.$setUntouched();
            // Show the login form
            $scope.setMode('login');
        };

        /* Registration */
        //$scope.register = function(isValid, data){
        //    if (isValid && $scope.regTermsConditions) {
        //        $scope.mode = 'login';
        //        $scope.result.visible = true;
        //        $scope.result.class = 'success';
        //        $scope.result.title = 'Awesome!';
        //        $scope.result.message = 'Check your email for a verification link; you must verify your account before logging in.';
        //        $scope.buttonText = 'Okay';
        //        AuthService.postUser(data).then(
        //            function (value) {},
        //            function (reason) {
        //                $scope.result.visible = true;
        //                $scope.result.class = 'danger';
        //                $scope.mode = 'register';
        //                if (reason.status === 409 || reason.data.CODE === 409) {
        //                    $scope.result.title = 'Error:';
        //                    $scope.result.message = 'Please verify that you entered a valid email.';
        //                } else {
        //                    $scope.result.title = 'Error:';
        //                    $scope.result.message = 'Something went wrong, please try again.';
        //                }
        //            }
        //        );
        //    }
        //    else if(!$scope.regTermsConditions){
        //        $scope.result.visible = true;
        //        $scope.result.class = 'danger';
        //        $scope.result.title = 'Error:';
        //        $scope.result.message = 'Please check "I agree to the Terms and Conditions and Privacy Policy" to continue.';
        //    }
        //};

        /* Forgot Password */
        $scope.forgotPassword = function (isValid, data) {
            if (isValid) {
                AuthPasswordService.sendEmail(data).then(
                    function (/*value*/) {
                        $scope.result.visible = true;
                        $scope.result.class = 'success';
                        $scope.result.title = 'Success:';
                        $scope.result.message = 'Check your email for a password reset link.';
                    },
                    function (reason) {
                        $scope.result.visible = true;
                        $scope.result.class = 'danger';
                        if (reason.status === 404) {
                            $scope.result.title = 'Error:';
                            $scope.result.message = 'We do not have an account with that email address.';
                        } else if (reason.status === 406) {
                            $scope.result.title = 'Whoa there:';
                            $scope.result.message = 'Please verify your email first; a link has been sent to your email.';
                        } else {
                            $scope.result.title = 'Error:';
                            $scope.result.message = 'Please try again.';
                        }
                    }
                );
            }
        };
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name AuthPasswordService
     * @alias cerberus/core:AuthPasswordService
     * @description Makes calls to users/password resource
     */
    .factory('AuthPasswordService', ["$http", "$q", "apiPath", "toaster", function AuthPasswordService($http, $q, apiPath, toaster) {
            return {
                sendEmail: sendEmail,
                resetPassword: resetPassword,
                changePassword: changePassword
            };
            /**
             * Requests email for password reset link/token
             * @function sendEmail
             * @param data
             * @returns {promise}
             */
            function sendEmail(data) {
                var deferred = $q.defer();
                $http.put(apiPath + 'users/password/recovery/email', data)
                    .success(function(value){
                        toaster.pop('success', 'Please check your email for further instructions.');
                        deferred.resolve(value);
                    })
                    .error(function(reason){
                        toaster.pop('error', 'Invalid email.');
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             * Reset user password
             * @function resetPassword
             * @param data
             * @returns {promise}
             */
            function resetPassword(data) {
                var deferred = $q.defer();
                $http.put(apiPath + 'users/password/reset', data)
                    .success(function(value){
                        toaster.pop('success', 'Password has been changed.');
                        deferred.resolve(value);
                    })
                    .error(function(reason){
                        toaster.pop('error', 'Invalid.');
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             * Change user password
             * @function changePassword
             * @param data
             * @returns {promise}
             */
            function changePassword(data) {
                var deferred = $q.defer();
                $http.put(apiPath + 'users/password/change', data)
                    .success(function (value) {
                        deferred.resolve(value);
                    })
                    .error(function (reason) {
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }
        }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name WaitForUserData
     * @alias cerberus/core:WaitForUserData
     * @description This is a FML hack. We need to halt most route changes until
     * userData has been received from the server and applied to the $rootScope
     */
    .factory('WaitForUserData',
    ["$q", function WaitForUserData($q) {
        var p = $q.defer();
        var prom = p.promise;
        prom.doneWaiting = function() {
            p.resolve();
        };
        return prom;
    }])

    /**
     * @ngdoc service
     * @name AuthService
     * @alias cerberus/core:AuthService
     * @description Makes calls to the "auth" resource for user login and information
     */
    .factory('AuthService', ["_", "$q", "$http", "$timeout", "$location", "$rootScope", "$window", "apiPath", "AuthHttpBuffer", "toaster", "localStorageService", function AuthService(_, $q, $http, $timeout, $location, $rootScope, $window, apiPath, AuthHttpBuffer, toaster, localStorageService) {
        var attempts = 0;
        var maxAttempts = 5;
        var service = {
            loginConfirmed: loginConfirmed,
            loginCancelled: loginCancelled,
            login: login,
            getUserData: getUserData,
            logout: logout,
            //postUser: postUser,
            getUrlWorkspace: getUrlWorkspace,
            refreshJwt: refreshJwt
        };
        return service;
        ////////////////////
        /**
         *
         * @returns {*|r.promise|Function|promise|Document.promise}
         */
        function refreshJwt(){
            var deferred = $q.defer(),
                deviceType = localStorageService.get('device');
            $http.get(apiPath + 'refresh/jwt?deviceType=' + deviceType)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        /**
         * Determines the workspace based upon the current URL
         * @function getUrlWorkspace
         * @param {string} url
         * @returns {string}
         */
        function getUrlWorkspace(url) {
            // isolate http:
            url = url.split('//');
            // isolate Angular route
            url = url[1].split('/#');
            // split path
            url = url[0].split('/');
            // remove the domain name
            url.splice(0,1);
            return url[0] || '';
        }

        /**
         * Call this function to indicate that authentication was successful and trigger a
         * retry of all deferred requests.
         * @param data an optional argument to pass on to $broadcast which may be useful for
         * example if you need to pass through details of the user that was logged in
         * @param configUpdater an optional transformation function that can modify the
         * requests that are retried after having logged in.  This can be used for example
         * to add an authentication token.  It must return the request.
         */
        function loginConfirmed(data, configUpdater) {
            var updater = configUpdater || function(config) {return config;};
            $rootScope.$broadcast('auth:loginConfirmed', data);
            AuthHttpBuffer.retryAll(updater);
        }

        /**
         * Call this function to indicate that authentication should not proceed.
         * All deferred requests will be abandoned or rejected (if reason is provided).
         * @param data an optional argument to pass on to $broadcast.
         * @param reason if provided, the requests are rejected; abandoned otherwise.
         */
        function loginCancelled(data, reason) {
            AuthHttpBuffer.rejectAll(reason);
            $rootScope.userData = {};
            $rootScope.authToken = null;

            var device = localStorageService.get('device');

            localStorageService.clearAll();

            localStorageService.set('device', device);

            angular.element($window).find('[ng-view]').empty();
            $rootScope.$broadcast('auth:loginCancelled', data);
        }

        /**
         * @function login
         * @param {object} data - username, password, and isPrivate
         * @returns {promise}
         */
        function login(data){
            var deferred = $q.defer();
            var options = {
                method:'POST',
                url: apiPath + 'auth/login',
                data: data
            };
            $http(options)
                .success(function(value){
                    // Clear attempts counter
                    attempts = 0;

                    // Set token in local storage
                    if (value.DATA.type === 'private') {
                        localStorageService.set('jwt', value.DATA.jwt);
                        $rootScope.isPrivateDevice = true;
                    }

                    // Set token in rootScope
                    $rootScope.authToken = value.DATA.jwt;


                    // Get UserData
                    service.getUserData(true);

                    deferred.resolve(value);
                })
                .error(function(reason){
                    attempts++;
                    if(attempts >= maxAttempts) {
                        loginCancelled();
                        $location.url('/');
                    }
                    deferred.reject(reason);
                    toaster.pop('warning', 'Login Failed', _.get(reason, 'MESSAGE', ''));
                });
            return deferred.promise;
        }

        /**
         * This call will included session information for the user
         * @function getUserData
         * @param {boolean} isLogin - will be used to broadcast the loginConfirmed event
         * @returns {promise}
         */
        function getUserData(isLogin) {
            var deferred = $q.defer();
            var urlWorkspace = getUrlWorkspace($location.absUrl());
            var options = {
                method:'GET',
                url: apiPath + 'auth/userData',
                ignoreAuthModule: false,
                params: {
                    currentWorkspace: urlWorkspace
                }
            };

            $http(options)
                .success(function(value){
                    var userData = value.DATA;

                    // Check if user defined URL was valid
                    if (!_.has(value, 'DATA.currentWorkspace.path') || value.DATA.currentWorkspace.path.toLowerCase() !== urlWorkspace.toLowerCase()) {
                        delete userData.currentWorkspace;
                    }

                    // Set userData on the Root Scope
                    $rootScope.userData = userData;
                    // Confirm login
                    if (isLogin) {
                        service.loginConfirmed(value.DATA, function (config) {
                            if (!_.isUndefined(userData.currentWorkspace)) {
                                config.headers["WSID"] = userData.currentWorkspace.id;
                            }
                            return config;
                        });
                    }

                    deferred.resolve(userData);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        /**
         * This function will clear user information and then logout
         * @function logout
         */
        function logout() {
            $http({method:'POST', url: apiPath + 'auth/logout'}).success(function () {
                loginCancelled();
                $location.url('/');
            });
        }

        /**
         * Call this to create an account
         * @param {object} data
         * @returns {promise}
         */
        //function postUser(data){
        //    var deferred = $q.defer();
        //    $http.post(apiPath + 'users/register', data)
        //        .then(function(value){
        //            deferred.resolve(value);
        //        }, function(reason){
        //            deferred.reject(reason);
        //        });
        //    return deferred.promise;
        //}
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name FormValidationService
     * @alias cerberus/core:FormValidationService
     * @description Helps validate form objects
     */
    .factory('FormValidationService', ["_", "moment", "$timeout", function FormValidationService(_, moment, $timeout){
        return {
            validateFormObject: validateFormObject,
            validateKendoFormObject: validateKendoFormObject
        };

        /**
         * Validates the form field by checking the dataSet
         * value against the form object validation configuration.
         * @param form - instance form
         * @param formObj
         */
        function validateFormObject(form, formObj){
            return function(value, required){
                var results = {};

                var type = formObj.config.type;
                var empty = _.isEmpty(value);

                // Required (formObj.validation.required)
                if (formObj.validation.required || required) {
                    if(type === 'number'){
                        // Makes sure there is a numeric value in this field
                        results['required'] = _.isNumber(value) || (_.isString(value) && !_.isNaN(parseFloat(value)));
                    }
                    else if (type === 'datetime') {
                        // Convert string value to date for validation
                        if (_.isString(value)) {
                            value = moment.utc(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ').toDate();
                        }

                        // Makes sure a valid date has been selected
                        results['required'] = _.isDate(value) && value.toString() !== 'Invalid Date';
                    }
                    else if(type === 'checkbox'){
                        // Checks for truthy value for checkbox
                        results['required'] = !!value;
                    }
                    else if (type === 'text') {
                        // results['required'] = !_.isNull(value) && !_.isUndefined(value);
                        results['required'] = !!value;
                    }
                    else {
                        // Strings, objects, and arrays must have length > 0
                        // null and undefined are considered empty
                        // Edit: numbers are considered empty as well
                        results['required'] = !empty;
                    }

                    if(type === 'location'){
                        // Checks for valid address, but only if required
                        results['nimHasLocation'] = _.has(value, 'properties.formatted_address');
                    }
                }

                // Text Validation
                if (type === 'text') {
                    var length = empty ? 0 : value.length;

                    // Max Length (formObj.validation.max)
                    if (_.isNumber(formObj.validation.max)) {
                        results['maxlength'] = length <= formObj.validation.max;
                    }

                    // Min Length (formObj.validation.min)
                    if (_.isNumber(formObj.validation.min)) {
                        results['minlength'] = length >= formObj.validation.min;
                    }

                    // Pattern (formObj.validation.pattern)
                    if (formObj.validation.pattern) {
                        // Strips forward-slashes from start and end of pattern
                        var regex = new RegExp(formObj.validation.pattern.replace(/^\//, '').replace(/\/$/, ''));
                        results['pattern'] = !value || regex.test(value); // Only checks against pattern if value is given
                    }
                }

                if(form){
                    setFormObjectValidity(form, formObj.config.modelId, results);
                }

                return results;
            };
        }

        /**
         * Creates a callback for k-change event to
         * run validateFormObject
         * @param scope
         * @param form
         * @param formObj
         * @returns {Function}
         */
        function validateKendoFormObject(scope, form, formObj){
            var validate = validateFormObject(form, formObj);
            return function(e){ // k-change callback
                $timeout(function(){
                    validate(_.result(e.sender, 'value'), scope.isRequired);
                });
            };
        }

        /**
         * Sets validity for form field
         * @param form - instance form
         * @param modelId
         * @param validity - map of validity properties and validation results
         */
        function setFormObjectValidity(form, modelId, validity){
            var field = form[modelId];
            if(field) {
                $timeout(function(){
                    _.forEach(validity, function (valid, prop) {
                        field.$setDirty();
                        field.$setTouched();
                        field.$setValidity(prop, valid);
                    });
                });
            }
        }
    }])
;
angular.module('cerberus.core')
	/**
	 * @ngdoc service
	 * @name FormsBuildDynamicService
	 * @alias cerberus/core:FormsBuildDynamicService
	 * @description Builds html templates for form fields (in edit mode)
	 */
	.factory('FormsBuildDynamicService', ["_", "FormsBuildHelperService", "FormsBuildStaticService", function FormsBuildDynamicService(_, FormsBuildHelperService, FormsBuildStaticService) {
		return {
			statictext: statictext,
			hr: hr,
			barcode: barcode,
			reference: FormsBuildStaticService.reference,
			text: text,
			autocomplete: autocomplete,
			location: location,
			map: map,
			textarea: textarea,
			number: number,
			datetime: datetime,
			signature: signature,
			radio: radio,
			checkbox: checkbox,
			select: select,
			multiselect: multiselect,
			table: table,
			readonly: readonly,
			timer: timer,
			image: image,
			rule: rule
		};
		////////////////////
		/**
		 * @function statictext
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function statictext(field){
			return FormsBuildStaticService.statictext(field);
		}

		/**
		 * @function hr
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function hr(field) {
			return FormsBuildStaticService.hr(field);
		}

		/**
		 * @function barcode
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function barcode(field) {
			return FormsBuildStaticService.barcode(field);
		}

		/**
		 * @function text
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function text(field) {
			var modelId = field.config.modelId;
			var ngModel = 'dataSet.' + modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);
			var attrs = angular.copy(field.tag.attrs);

			if(field.param.filter){
				ngModel = 'filters.' + modelId;
			}
			else{
				attrs['ng-change'] = "updateFilterOnChange()";
			}

			attrs['class'] = 'form-control';
			attrs['id'] = modelId;
			attrs['name'] = modelId;
			attrs['type'] = 'text';
			attrs['style'] = 'width:100%;';

			attrs['ng-blur'] = 'validateFormObject(' + ngModel + ', isRequired)';
			attrs['ng-model'] = ngModel;
			attrs['ng-readonly'] = 'isReadonly';

			if(field.validation.mask){
				attrs['kendo-masked-text-box'] = '';
				attrs['k-mask'] = '\'' + field.validation.mask + '\'';
			}

			if(field.display.placeholder){
				attrs['placeholder'] = '\'' + field.display.placeholder + '\'';
			}

			return FormsBuildHelperService.divOpenForm() + label + '<input ' + FormsBuildHelperService.parseAttr(attrs) + '/>' + error + help + '</div>';
		}

		/**
		 * @function autocomplete
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function autocomplete(field) {
			var modelId = field.config.modelId;
			var ngModel = 'dataSet.' + modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);
			var attrs = angular.copy(field.tag.attrs);

			attrs['class'] = 'form-control';
			attrs['id'] = modelId;
			attrs['name'] = modelId;

			attrs['k-data-text-field'] = '\'display\'';
			attrs['k-data-value-field'] = '\'id\'';
			attrs['k-min-length'] = 3;

			attrs['ng-blur'] = 'validateFormObject(' + ngModel + ', isRequired)';
			attrs['ng-model'] = ngModel;
			attrs['ng-readonly'] = 'isReadonly';

			if(field.option.type === 'custom'){
				attrs['k-data-source'] = 'fieldOptions.' + modelId;
			}
			else {
				attrs['k-data-source'] = 'oDataLookUp';
			}

			if(field.param.separator === 'None'){
				attrs['k-separator'] = '\' \'';
			}
			else {
				attrs['k-separator'] = '\'' +  field.param.separator + '\'';
			}

			return FormsBuildHelperService.divOpenForm() + label + '<input kendo-auto-complete ' +
				FormsBuildHelperService.parseAttr(attrs) + '/>' + error + help + '</div>';
		}

		/**
		 * @function location
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function location(field) {
			var modelId = field.config.modelId;
			var ngModel = 'dataSet.' + modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);
			var attrs = angular.copy(field.tag.attrs);

			attrs['class'] = 'form-control nim-location-input';
			attrs['id'] = modelId;
			attrs['name'] = modelId;
			attrs['type'] = 'text';

			attrs['ng-blur'] = 'validateFormObject(' + ngModel + ', isRequired)';
			attrs['ng-change'] = 'setEmptyLocation()';
			attrs['ng-model'] = '_' + modelId;
			// attrs['ng-model-options'] = '{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }';
			attrs['ng-readonly'] = 'isReadonly';

			attrs['nim-stop-enter'] = '';

			attrs['uib-typeahead'] = 'address as address.place_name for address in getLocationAutoComplete($viewValue)';
			attrs['typeahead-on-select'] = 'setLocationData($item, $model, $label, $event)';
			attrs['typeahead-wait-ms'] = '500';

			if(field.display.placeholder){
				attrs['placeholder'] = field.display.placeholder;
			}

			return FormsBuildHelperService.divOpenForm() + label +
				'<input ' + FormsBuildHelperService.parseAttr(attrs) + ' />' +
				error + help +
				'</div>';
		}

		/**
		 * @function map
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function map(field) {
			var modelId = field.config.modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);

			var attrs = {};
			attrs['class'] = 'nim-form-map';
			attrs['id'] = modelId;
			attrs['name'] = modelId;
			attrs['style'] = 'bottom:0; left:0; position:absolute; right:0; top:14px;';

			//attrs['ng-class'] = '{\'has-success\': fieldValidity() === true,\'has-error\': fieldValidity() === false}';
			// attrs['ng-class'] = '{\'has-error\': fieldValidity === false}';
			attrs['ng-model'] = '_' + modelId; // To register with ngForm

			return FormsBuildHelperService.divOpenForm() + label + error + help + '</div>' +
				'<div nim-form-map ' + FormsBuildHelperService.parseAttr(attrs) + '></div>';
		}

		/**
		 * @function textarea
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function textarea(field) {
			var modelId = field.config.modelId;
			var ngModel = 'dataSet.' + modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);
			var attrs = angular.copy(field.tag.attrs);

			attrs['class'] = 'form-control';
			attrs['id'] = modelId;
			attrs['name'] = modelId;

			attrs['ng-readonly'] = 'isReadonly';

			if (field.param.showToolbar === true) {
				attrs['k-change'] = 'validateKendoFormObject';
				attrs['k-ng-model'] = ngModel;
				attrs['k-options'] = 'textEditorOptions';
				attrs['kendo-editor'] = '';

				attrs['ng-model'] = '_' + modelId;
			}
			else {
				attrs['class'] = 'form-control';
				attrs['ng-blur'] = 'validateFormObject(' + ngModel + ', isRequired)';
				attrs['ng-model'] = ngModel;
				attrs['ng-model-options'] = '{ updateOn: \'blur\', debounce: { \'blur\': 0 } }';

				if(field.display.placeholder){
					attrs['placeholder'] = field.display.placeholder;
				}
			}

			return FormsBuildHelperService.divOpenForm() + label + '<textarea ' + FormsBuildHelperService.parseAttr(attrs) + '></textarea>' + error + help + '</div>';
		}

		/**
		 * @function number
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function number(field) {
			var modelId = field.config.modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);
			var attrs = angular.copy(field.tag.attrs);

			attrs['class'] = 'form-control';
			attrs['id'] = modelId;
			attrs['name'] = modelId;
			attrs['style'] = 'width:100%;';
			attrs['type'] = 'number';

			attrs['k-decimals'] = field.param.decimals;
			attrs['k-format'] =  "'" + _.escape(field.display.format) + "'";
			attrs['k-max'] = field.validation.max;
			attrs['k-min'] = field.validation.min;
			attrs['k-step'] = field.param.step;

			attrs['ng-model'] = '_' + modelId;
			attrs['ng-readonly'] = 'isReadonly';

			if(field.param.filter){
				attrs['k-ng-model'] = 'filters.' + modelId;
				attrs['k-change'] = 'validateKendoFormObject';
			}
			else{
				attrs['k-ng-model'] = 'dataSet.' + modelId;
				attrs['k-change'] = 'validateAndUpdateOnChange';
			}

			if(field.display.placeholder){
				attrs['placeholder'] = "'" + field.display.placeholder + "'";
			}

			return FormsBuildHelperService.divOpenForm() + label + '<input kendo-numeric-text-box="nimNumberFormObject" ' + FormsBuildHelperService.parseAttr(attrs) + '/>' + error + help + '</div>';
		}

		/**
		 * @function datetime
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function datetime(field) {
			var modelId = field.config.modelId,
				ngModel = 'dataSet.' + modelId,
				label = FormsBuildHelperService.makeLabel(field, true),
				help = FormsBuildHelperService.makeHelpBlock(field.help),
				error = FormsBuildHelperService.makeValidationHelpBlock(modelId),
				attrs = angular.copy(field.tag.attrs),
				format = _.trim(field.display.format),
				//usesDateTimeFormat = format.match(/^[FGgsu]$/), // Uses single-character specifier for kendo date-time format
				usesDateFormat = format.match(/^[DdMmYy]$/),	// Uses single-character specifier for kendo date format
				usesTimeFormat = format.match(/^[Tt]$/),		// Uses single-character specifier for kendo time format
				hasDatePattern = format.match(/[dMy]/g),		// Uses specifiers for kendo date pattern
				hasTimePattern = format.match(/[fhHmst]/g);	 // Uses specifiers for kendo date pattern
			
			var parseFormatString = '[';
			_.forEach(_.get(field.param, 'parseFormats', []), function (pf) {
				parseFormatString += '\'' + pf + '\',';
			});
			parseFormatString += '\'yyyy-MM-ddTHH:mm:ss.fffZ\',\'yyyy-MM-dd HH:mm:ss.fff\']';

			attrs['class'] = 'form-control';
			attrs['id'] = modelId;
			attrs['name'] = modelId;
			attrs['style'] = 'width:100%;';

			attrs['k-change'] = 'validateKendoFormObject';
			attrs['k-ng-model'] = ngModel;
			attrs['k-format'] = '\'' + format + '\'';
			// attrs['k-parse-formats'] = '[\'yyyy-MM-ddTHH:mm:ss.fffZ\',\'yyyy-MM-dd HH:mm:ss.fff\']';
			attrs['k-parse-formats'] = parseFormatString;

			attrs['ng-model'] = '_' + modelId;
			attrs['ng-readonly'] = 'isReadonly';

			var pickerType = 'date-time',
				depth = '\'month\'';

			// Matches date-time pattern
			if(hasDatePattern && hasTimePattern){
				if(format.includes('d')){
					depth = '\'month\'';
				}
				else if(format.includes('M')){
					depth = '\'year\'';
				}
				else if(format.includes('yy')){
					depth = '\'decade\'';
				}
			}
			// Matches time pattern
			else if(usesTimeFormat || hasTimePattern){
				pickerType = 'time';
			}
			// Matches date pattern
			else if(usesDateFormat || hasDatePattern){
				pickerType = 'date';

				if(!usesDateFormat){
					if(format.includes('d')){
						depth = '\'month\'';
					}
					else if(format.includes('M')){
						depth = '\'year\'';
					}
					else if(format.includes('yy')){
						depth = '\'decade\'';
					}
				}
			}

			attrs['k-depth'] = depth;
			attrs['k-start'] = depth;

			return FormsBuildHelperService.divOpenForm() + label + '<input kendo-' + pickerType + '-picker="nimDateFormObject" ' +  FormsBuildHelperService.parseAttr(attrs) + ' />' + error + help + '</div>';
		}

		/**
		 * @function signature
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function signature(field) {
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var attrs = angular.copy(field.tag.attrs);
			var model = 'dataSet.' + field.config.modelId;
			var ngDisabled = '';
			var wrapLabelClass = label.length ? 'has-label': '';
			if(field.param.condition){
				ngDisabled = 'ng-readonly="isReadonly" ';
			}
			if (field.param.type === 'initial') {
				return '<div class="form-group">' +
					label +
					'<div class="sign-wrap ' + wrapLabelClass + '">' +
					'<img class="sign-img" ' +
					'ng-if="' + model + '.path" ' +
					'ng-src="{{' + model + '.path}}" />' +
					'<div class="sign-text"' +
					'ng-if="!' + model + '.path && ' + model + '.userId" ' +
					'ng-bind="' + model + '.userName | toInitials"></div>' +
					'<div class="sign-meta"' +
					'ng-if="' + model + '.path || ' + model + '.userId">' +
					'</div>' +
					'<a href="" ng-if="' + model + '.path || ' + model + '.userId" ng-click="signButtonClick(vm.sigData, true, false)" class="sign-again"> Hand initials. </a>' +
					'<a href="" ng-if="' + model + '.path || ' + model + '.userId" ng-click="signButtonClick(vm.sigData, true, true)" class="sign-again"> Touch pad. </a>' +
					'<div ng-if="!' + model + '.path && !' + model + '.userId" class="btn-group-justify">' +
					'<table style="width:100%">' +
					'<th style="width:48%"><button class="btn btn-primary btn-block btn-lg" type="button" ng-click="signButtonClick(vm.sigData,false,false)" ' + ngDisabled + ' ' +
					'tabindex="' + attrs.tabindex + '"><i class="fa fa-pencil"></i>&nbsp;INITIAL BY HAND</button></th>' +
					'<th style="width:4%"></th>' +
					'<th style="width:48%"><button class="btn btn-info btn-block btn-lg" type="button" ng-click="signButtonClick(vm.sigData,false,true)" ' + ngDisabled + ' ' +
					'tabindex="' + attrs.tabindex + '"><i class="fa fa-pencil-square-o"></i>&nbsp;TOUCH PAD</button></th>' +
					'</table>' +
					'</div>' +
					'</div>' + help +
					'</div>';
			}
			else {
				return '<div class="form-group">' +
					label +
					'<div class="sign-wrap ' + wrapLabelClass + '">' +
					'<img class="sign-img" ' +
					'ng-if="' + model + '.path" ' +
					'ng-src="{{' + model + '.path}}" />' +
					'<div class="sign-text"' +
					'ng-if="!' + model + '.path && ' + model + '.userId" ' +
					'ng-bind="' + model + '.userName"></div>' +
					'<div class="sign-meta"' +
					'ng-if="' + model + '.path || ' + model + '.userId">' +
					'<span class="sign-name" ng-bind="' + model + '.userName || \'Signature\'"></span>' +
					//'<span class="pull-left" ng-if="!' + model + '.userId">IP: <span ng-bind="' + model + '.userIpAddr || \'TBD\'"></span></span> ' +
					'<span class="sign-date">Date: <span ng-bind="' + model + '.timestamp | date:\'MMM d, y h:mm:ss a\'"></span></span>' +
					//lastSubmit
					'<span ng-if=" ' + model + '.lastSubmit">Last submit: <span ng-bind="' + model + '.lastSubmit | date:\'MMM d, y h:mm:ss a\'"></span></span>' +
					'<span ng-if="!' + model + '.lastSubmit">SIGNATURE NOT SUBMITTED YET!</span>' +
					'</div>' +
					'<a href="" ng-if="' + model + '.path || ' + model + '.userId" ng-click="signButtonClick(vm.sigData, true, false)" class="sign-again"> Hand signature. </a>' +
					'<a href="" ng-if="' + model + '.path || ' + model + '.userId" ng-click="signButtonClick(vm.sigData, true, true)" class="sign-again"> Touch pad. </a>' +
					'<div ng-if="!' + model + '.path && !' + model + '.userId" class="btn-group-justify">' +
					'<table style="width:100%">' +
					'<th style="width:48%"><button class="btn btn-primary btn-block btn-lg" type="button" ng-click="signButtonClick(vm.sigData,false,false)" ' + ngDisabled + ' ' +
					'tabindex="' + attrs.tabindex + '"><i class="fa fa-pencil"></i>&nbsp;SIGN BY HAND</button></th>' +
					'<th style="width:4%"></th>' +
					'<th style="width:48%"><button class="btn btn-info btn-block btn-lg" type="button" ng-click="signButtonClick(vm.sigData,false,true)" ' + ngDisabled + ' ' +
					'tabindex="' + attrs.tabindex + '"><i class="fa fa-pencil-square-o"></i>&nbsp;TOUCH PAD</button></th>' +
					'</table>' +
					'</div>' +
					'</div>' + help +
					'</div>';
			}
		}

		/**
		 * @function radio
		 * @param {Field} field
		 * @returns {string} of html
		 */
		//TODO: refactor radio build
		function radio(field) {
			var modelId = field.config.modelId;
			var ngModel = 'dataSet.' + modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);
			var attrs = angular.copy(field.tag.attrs);  // For radio group
			var subAttrs = {};						  // For individual radio buttons

			attrs['id'] = modelId;
			attrs['name'] = modelId;

			attrs['ng-model'] = '_' + modelId; // For registering with ngForm

			subAttrs['ng-blur'] = 'validateFormObject(' + ngModel + ', isRequired)';
			subAttrs['ng-model'] = ngModel;
			subAttrs['ng-readonly'] = 'isReadonly';

			if(!field.param.isButton){
				subAttrs['type'] = 'radio';
				subAttrs['value'] = '{{::opt}}';

				if(field.option.type === 'custom') {
					attrs['ng-repeat'] = 'opt in ::fieldOptions.' + modelId;
				}
				else{
					attrs['ng-repeat'] = 'opt in oDataLookUp.data()';
					subAttrs['ng-change'] = 'onSelectionChange(null,' + ngModel + '.id)';
				}

				if(field.display.isInline === true){
					attrs['style'] = 'display:inline;';
				} else {
					attrs['class'] = 'radio';
				}

				var inputs = '<div ' + FormsBuildHelperService.parseAttr(attrs) + '><label class="radio-inline"><input nim-store-object ' + FormsBuildHelperService.parseAttr(subAttrs) + ' /><span ng-bind="::opt.display"></span></label></div>';
				return FormsBuildHelperService.divOpenForm() + label + '<div>' + inputs + '</div>' + error + help + '</div>';
			}
			else {
				var buttonClass = field.param.buttonClass || 'default';
				subAttrs['uib-btn-radio'] = 'opt';
				subAttrs['class'] = 'btn btn-' + buttonClass;
				subAttrs['type'] = 'button';

				subAttrs['ng-bind'] = '::opt.display';

				if(field.option.type === 'custom') {
					var options = 'fieldOptions.' + modelId;
					subAttrs['ng-repeat'] = 'opt in ::' + options;
					subAttrs['ng-style'] = '{\'z-index\': ' + options + '.length - $index}';
				}
				else{
					subAttrs['ng-change'] = 'onSelectionChange(null,' + ngModel + '.id)';
					subAttrs['ng-repeat'] = 'opt in oDataLookUp.data()';
					subAttrs['ng-style'] = '{\'z-index\': oDataLookUp.total() - $index}';
				}

				if(field.display.isInline === true){
					attrs['class'] = 'btn-group';
				}
				else {
					attrs['class'] = 'btn-group-vertical';
				}

				if(field.param.buttonGroupArrow){
					attrs['class'] += ' btn-group-arrows';
				}

				var buttons = '<div ' + FormsBuildHelperService.parseAttr(attrs) + '><button ' + FormsBuildHelperService.parseAttr(subAttrs) + '></button></div>';
				return FormsBuildHelperService.divOpenForm() + label + buttons + error + help + '</div>';
			}
		}

		/**
		 * @function checkbox
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function checkbox(field) {
			var modelId = field.config.modelId;
			var ngModel = 'dataSet.' + modelId;
			//var label = FormsBuildHelperService.makeLabel(field.label, modelId);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var attrs = angular.copy(field.tag.attrs);

			attrs['id'] = field.config.modelId;
			attrs['name'] = field.config.modelId;
			attrs['type'] = 'checkbox';

			attrs['ng-model'] = ngModel;
			//attrs['ng-readonly'] = 'isReadonly';
			attrs['ng-disabled'] = 'isReadonly';

			return FormsBuildHelperService.divOpenForm() + '<label class="checkbox-inline"><input ' + FormsBuildHelperService.parseAttr(attrs) + ' />&nbsp;<span>' + field.label.text + '</span></label>' + help + '</div>';
		}

		/**
		 * @function select
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function select(field) {
			var modelId = field.config.modelId;
			var ngModel = 'dataSet.' + modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);
			var defaultDisplay = field.display.placeholder || 'Choose...';
			var attrs = angular.copy(field.tag.attrs);

			attrs['id'] = 'nim_' + modelId;
			attrs['name'] = modelId;
			attrs['style'] = 'width:100%;';

			attrs['k-data-text-field'] = '\'display\'';
			attrs['k-data-value-field'] = '\'id\'';
			attrs['k-option-label'] = '{display:\'' + defaultDisplay + '\',id:-1}';
			attrs['k-select'] = 'validateKendoFormObject';

			attrs['ng-model'] = '_' + modelId;
			attrs['ng-readonly'] = 'isReadonly';

			if(field.param.filter){
				attrs['k-ng-model'] = 'filters.' + modelId;
			}
			else{
				attrs['k-ng-model'] = ngModel;
			}

			if(field.option.type === 'custom'){
				var options = 'fieldOptions.' + modelId;
				attrs['k-close'] = 'dropdownClose';
				attrs['k-data-source'] = options;
				attrs['k-ng-delay'] = options;
			}
			else{
				attrs['k-change'] = 'onSelectionChange';
				attrs['k-close'] = 'dropdownCloseHandler';
				attrs['k-data-bound'] = 'dropdownDataBoundHandler';
				attrs['k-data-source'] = 'oDataLookUp';
				attrs['k-filter'] = field.param.filterOperator || '\'contains\'';
				attrs['k-filtering'] = 'onFilter';
				attrs['k-open'] = 'dropdownOpenHandler';
			}

			return FormsBuildHelperService.divOpenForm() + label + '<select kendo-drop-down-list ' + FormsBuildHelperService.parseAttr(attrs) + '></select>' + error + help + '</div>';
		}

		/**
		 * @function multiselect
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function multiselect(field) {
			var modelId = field.config.modelId;
			var ngModel = 'dataSet.' + modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(modelId);
			var attrs = angular.copy(field.tag.attrs);

			attrs['id'] = modelId;
			attrs['name'] = modelId;
			attrs['style'] = 'width:100%;';

			attrs['k-change'] = 'validateKendoFormObject';
			attrs['k-close'] = 'dropdownClose';
			attrs['k-data-bound'] = 'multiSelectDataBound';
			attrs['k-data-source'] = 'oDataLookUp';
			attrs['k-data-text-field'] = '\'display\'';
			attrs['k-data-value-field'] = '\'id\'';
			attrs['k-filter'] = field.param.filterOperator || '\'contains\'';
			attrs['k-filtering'] = 'onFilter';
			attrs['k-ng-model'] = ngModel;

			attrs['ng-model'] = '_' + modelId;
			attrs['ng-readonly'] = 'isReadonly';

			return FormsBuildHelperService.divOpenForm() + label + '<select kendo-multi-select ' + FormsBuildHelperService.parseAttr(attrs) + '></select>' + error + help + '</div>';
		}

		/**
		 * @function table
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function table(field) {
			var modelId = field.config.modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var error = FormsBuildHelperService.makeValidationHelpBlock(field.config.modelId);
			return FormsBuildHelperService.divOpenForm() + label + '<div nim-form-table class="nim-form-table"></div><input type="hidden" id="' + modelId + '" name="' + modelId + '" ng-model="dataSet.' + modelId + '" />' + error + help + '</div>';
		}

		/**
		 * @function readonly
		 * @param {Field} field
		 * @returns {string} of html
		 */
		function readonly(field) {
			var modelId = field.config.modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var model = 'dataSet.' + modelId;
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			return FormsBuildHelperService.divOpenForm() + label + '<p class="form-control-static" ng-bind="formatReadonly(' + model + ')"></p>' + help + '</div>';
		}

		/**
		 * @function timer
		 * @param {Field} field
		 * @returns {string}
		 */
		function timer(field) {
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);

			return FormsBuildHelperService.divOpenForm() + label + '<timer start-time="timerStart">{{hours}} hour{{hoursS}}, {{minutes}} minute{{minutesS}}, {{seconds}} second{{secondsS}}.</timer>' + help + '</div>';
		}

		/**
		 * @function image
		 * @param {Field} field
		 * @returns {string}
		 */
		function image(field){
			var modelId = field.config.modelId;
			var label = FormsBuildHelperService.makeLabel(field, true);
			var help = FormsBuildHelperService.makeHelpBlock(field.help);
			var model = 'dataSet.' + modelId;
			var imageSource = 'imageSource';
			var attrs = angular.copy(field.tag.attrs);

			attrs['area-type'] = field.param.areaType;
			attrs['image'] = imageSource;
			attrs['result-image'] = model;
			attrs['result-image-size'] = field.param.resultImageSize;

			return FormsBuildHelperService.divOpenForm() + label +
				'<div>' +
				'<input type="file" class="btn btn-default" style="float:left;" nim-input-image="imageSource" />' +
				'<div style="float:right;">' +
				'<button type="button" class="btn btn-default" uib-btn-checkbox ng-model="previewImage" ng-show="imageSource">Preview</button>&nbsp;' +
				'<button type="button" class="btn btn-default" ng-click="clearImage()">Clear</button>' +
				'</div>' +
				'</div>' +
				'<div class="crop-area" style="width:100%" ng-if="imageSource">' +
				'<img-crop ' + FormsBuildHelperService.parseAttr(attrs) + '></img-crop>' +
				'</div>' +
				'<div ng-if="imageSource && previewImage" style="background-color:#ffffff; bottom:0; clear:both; position:absolute; top:49px; width:100%; z-index:1">' +
				'<img ng-src="{{' + model + '}}" />' +
				'</div>' +
				'<div ng-if="!imageSource && imageUrl" style="clear:both">' +
				'<img ng-src="{{imageUrl}}" />' +
				'</div>' + help + '</div>';
		}

		/**
		 * @function rule
		 * @param {Field} field
		 * @returns {*}
		 */
		function rule(field){
			return FormsBuildStaticService.rule(field);
		}
	}])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name FormsBuildHelperService
     * @alias cerberus/core:FormsBuildHelperService
     * @description Provides helper functions fot the Form Builder Services
     */
    .factory('FormsBuildHelperService', function FormsBuildHelperService() {
        return {
            divOpenForm: divOpenForm,
            pFormControlStatic: pFormControlStatic,
            parseAttr: parseAttr,
            makeLabel: makeLabel,
            makeHelpBlock: makeHelpBlock,
            makeValidationHelpBlock: makeValidationHelpBlock,
            filter: filter
        };
        ////////////////////
        /**
         * Html Snippet
         * @function divOpenForm
         * @param params - form field parameters
         * @return {string} of html
         */
        function divOpenForm() {
            return '<div class="form-group has-feedback">';
        }

        /**
         * Html snippet
         * @function pFormControlStatic
         * @return {string} of html
         */
        function pFormControlStatic() {
            return '<p class="form-control-static">';
        }

        /**
         * Concatenates attribute key values to a string
         * @function parseAttr
         * @param {object} attrs
         * @return {string} of html/xml parameters
         */
        function parseAttr(attrs) {
            var string = '';
            if (attrs) {
                for (var key in attrs) {
                    if (attrs.hasOwnProperty(key) && typeof attrs[key] !== 'undefined' && attrs[key] !== null) {
                        string = string + ' ' + key + '="' + attrs[key] + '"';
                    }
                }
            }
            return string;
        }

        /**
         * Creates label html as string
         * @function makeLabel
         * @param {Field} field
         * @param {boolean} isDynamic
         * @return {string} of html
         */
        function makeLabel(field, isDynamic) {
            // Sanity Check
            if (field.label.isHidden === true) { return ''; }

            // Define label parts
            var link = '';
            var model = field.config.modelId || '';
            var text = field.label.text || '';
            var attrs = angular.copy(field.label.attrs);

            if (isDynamic === true) {
                // Add Item link
                if (!field.param.hideAddItem && field.option.type && field.option.type === 'views') {
                    link += ' <a href="" class="add-new" ng-click="openCreateWindow(\'' + field.option.id + '\')" ng-if="!isReadonly"><em>Add Item</em></a>';
                }

                // Advanced Select link
                if (field.param.advSel && field.param.advSel.enabled && field.config.type === 'select') {
                    if (link !== '') { link += ' | '; }
                    link += '<a href="" class="add-new" ng-click="openAdvSelPage(dataSet[nimFormObject.config.modelId])" ng-if="!isReadonly"><em>Advanced</em></a>';
                }

                // Help Popup
                if (field.help && field.help.type === 'popup' && field.help.text) {
                    attrs['uib-popover-template'] = '\'core/forms/help.tpl.html\'';
                    attrs['popover-trigger'] = 'outsideClick';
                    attrs['popover-placement'] = 'auto top-left';
                    text += ' <i class="fa fa-question-circle"></i>';
                }
            }

            return '<label class="control-label" ' + parseAttr(attrs) + ' for="' + model + '">' + text + link + '</label>';
        }

        /**
         * Creates helpBlock html as string
         * @function makeHelpBlock
         * @param {object} helpBlock
         * @return {string} of html
         */
        function makeHelpBlock(helpBlock) {
            if (helpBlock && helpBlock.type === 'static' && helpBlock.text) {
                return '<span class="help-block">' + helpBlock.text + '</span>';
            }
            return '';
        }

        function makeValidationHelpBlock(modelId){
            return '<div class="help-block validation" ng-if="!hideValidation" ng-messages="instanceForm.' + modelId + '.$error" ng-messages-multiple>' +
                '<div ng-message="required">This field is required <a class="close" href="" title="Close" ng-click="hideValidation = true;"><i class="fa fa-close"></i></a></div>' +
                '<div ng-message="nimHasLocation">Invalid Address <a class="close" href="" title="Close" ng-click="hideValidation = true;"><i class="fa fa-close"></i></a></div>' +
                '<div ng-message="maxlength">Text too long <a class="close" href="" title="Close" ng-click="hideValidation = true;"><i class="fa fa-close"></i></a></div>' +
                '<div ng-message="minlength">Text too short <a class="close" href="" title="Close" ng-click="hideValidation = true;"><i class="fa fa-close"></i></a></div>' +
                '<div ng-message="pattern">Invalid text <a class="close" href="" title="Close" ng-click="hideValidation = true;"><i class="fa fa-close"></i></a></div>' +
                '</div>';
        }

        /**
         * Creates angular braces with filter
         * @function filter
         * @param {object} filterObj
         * @param {string} string
         * @return {string} of angularjs templating syntax
         */
        //TODO: use $filter service instead
        function filter(filterObj, string) {
            if (filterObj && filterObj.type) {
                if (filterObj.params && filterObj.params.length > 0) {
                    return '{{::\'' + string + '\'|' + filterObj.type + ':' + filterObj.params + '}}';
                }
                return '{{::\'' + string + '\'|' + filterObj.type + '}}';
            }
            return string;
        }
    })
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name FormsBuildStaticService
     * @alias cerberus/core:FormsBuildStaticService
     * @description Builds html templates for form fields values
     */
    .factory('FormsBuildStaticService', ["_", "moment", "kendo", "FormsBuildHelperService", "CalculationService", "$log", "$filter", function FormsBuildStaticService(_, moment, kendo, FormsBuildHelperService, CalculationService, $log, $filter) {
        return {
            statictext: statictext,
            hr: hr,
            barcode: barcode,
            readonly: readonly,
            text: text,
            number: number,
            datetime: datetime,
            autocomplete: autocomplete,
            location: location,
            map: map,
            textarea: textarea,
            signature: signature,
            radio: radio,
            checkbox: checkbox,
            select: select,
            multiselect: multiselect,
            table: table,
            timer: timer,
            image: image,
            rule: rule
        };
        ////////////////////
        /**
         * @function statictext
         * @returns {string} of html
         */
        function statictext() {
            return '<span class="nim-static-text" ng-bind-html="compiledStaticText"></span>';
        }

        /**
         * @function hr
         * @param {Field} field
         * @returns {string} of html
         */
        function hr(field) {
            var val = '';
            var classes = ['divider', field.param.orientation];
            if(field.param.type === 'text'){
                val = '<span>' + field.param.value + '</span>';
            }
            else if(field.param.type === 'icon'){
                val = '<i class="fa fa-fw fa-' + field.param.value + '"></i>';
            }
            else if(field.param.type === 'none'){
                classes.push('full');
            }

            return '<div class="' + classes.join(' ') + '">' + val + '</div>';
        }

        /**
         * @function barcode
         * @param {Field} field
         * @returns {string} of html
         */
        function barcode(field) {
            var label = FormsBuildHelperService.makeLabel(field);

            //Setup BarCode Value From Field
            var barcodeValue = '';

            if(!_.isNull(field.param.barcodedata.barvalue) && !_.isUndefined(field.param.barcodedata.barvalue)) {
                barcodeValue = field.param.barcodedata.barvalue;
            }

            //Setup BarCode Style
            var barcodeStyle = '';
            if(field.param.barStyle === 'default'){
                barcodeStyle = 'style="width:14em; margin:0 auto; height:3.0em;"';
            }
            else if(field.param.barStyle === 'extrasmall'){
                barcodeStyle = 'style="width:7em; margin:0 auto; height:2.0em;"';
            }
            else if(field.param.barStyle === 'small'){
                barcodeStyle = 'style="width:9em; margin:0 auto; height:2.5em;"';
            }
            else if(field.param.barStyle === 'large'){
                barcodeStyle = 'style="width:20em; margin:0 auto; height:5.0em;"';
            }
            else if(field.param.barStyle === 'extralarge'){
                barcodeStyle = 'style="width:25em; margin:0 auto; height:7.0em;"';
            }

            return FormsBuildHelperService.divOpenForm() + label +
                    '<span kendo-barcode k-type="\'' + field.param.format + '\'" ' +
                    'k-value="\'' + barcodeValue + '\'" ' + barcodeStyle + '</span>' +
                    '</div>';
        }

        /**
         * @function readonly
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function readonly(field, value) {
            var val = '';

            if(!_.isNull(value) && !_.isUndefined(value)){
                val = value;
            }

            if(field.calculation.formula){
                var tokenArr = angular.copy(field.calculation.tokens);
                val = CalculationService.calculate(tokenArr).value;
                val = CalculationService.toDate(val);
            }

            if(field.param.format){
                try {
                    val = kendo.format(field.param.format, val);
                } catch(e){
                    $log.error('Invalid format:', { error: e });
                }
            }

            var label = FormsBuildHelperService.makeLabel(field);
            return FormsBuildHelperService.divOpenForm() + label + FormsBuildHelperService.pFormControlStatic() + val + '</p>' + '</div>';
        }

        /**
         * @function text
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function text(field, value) {
            var label = FormsBuildHelperService.makeLabel(field);
            var val = value || '';
            return FormsBuildHelperService.divOpenForm() + label + FormsBuildHelperService.pFormControlStatic() + FormsBuildHelperService.filter(field.display.filter, val) + '</p>' + '</div>';
        }

        /**
         * @function number
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function number(field, value) {
            var label = FormsBuildHelperService.makeLabel(field);
            var displayValue = parseFloat(value);

            if(isNaN(displayValue)){
                displayValue = '';
            }

            if(field.display.format && field.display.format.length > 0 && displayValue !== ''){
                displayValue = kendo.toString(parseFloat(displayValue), field.display.format.replace(/\\\\/g,'\\'));
            }
            return FormsBuildHelperService.divOpenForm() + label + FormsBuildHelperService.pFormControlStatic() + FormsBuildHelperService.filter(field.display.filter, displayValue) + '</p>' + '</div>';
        }

        /**
         * @function datetime
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function datetime(field, value) {
            var label = FormsBuildHelperService.makeLabel(field);
            var val = '';
            if(value && (!_.isDate(value) || !_.isNaN(value.valueOf()))){
                var date = value;
                
                if (!_.isDate(value)) {
                    date = moment.utc(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ').toDate();
                }    

                val = kendo.toString(date, field.display.format);
            }
            return FormsBuildHelperService.divOpenForm() + label + FormsBuildHelperService.pFormControlStatic() + val + '</p>' + '</div>';
        }

        /**
         * @function autocomplete
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function autocomplete(field, value) {
            var label = FormsBuildHelperService.makeLabel(field);
            var val = value || '';
            return FormsBuildHelperService.divOpenForm() + label + FormsBuildHelperService.pFormControlStatic() + val + '</p>' + '</div>';
        }

        /**
         * @function location
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function location(field, value) {
            var label = FormsBuildHelperService.makeLabel(field);
            var val = _.get(value, 'properties.formatted_address', '');
            return FormsBuildHelperService.divOpenForm() + label + FormsBuildHelperService.pFormControlStatic() + val + '</p>' + '</div>';
        }

        /**
         * @function map
         * @returns {string} of html
         */
        function map() {
            return '<div nim-form-map nimFormMapStatic></div>';
        }

        /**
         * @function textarea
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function textarea(field, value) {
            var val = value;

            if (!_.isString(value)) {
                val = '';
            }
            return FormsBuildHelperService.divOpenForm() + FormsBuildHelperService.makeLabel(field) + '<p class="nim-static-textarea">' + val.trim() + '</p>' + '</div>';
        }

        /**
         * @function signature
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function signature(field, value) {
            var label = FormsBuildHelperService.makeLabel(field);
            var wrapLabelClass = label.length ? 'has-label': '';

            if (field.param.type === 'initial') {
                var initImg = '';
                var initText = '';
                var initMeta = '';

                if(_.get(value, 'path')){
                    initImg = '<img class="sign-img" src="' + value.path + '" />';
                }

                if(!_.get(value, 'path') && _.get(value, 'userId')){
                    var initials = '';
                    var arr = value.userName.split(' ');

                    for (var i = 0; i < arr.length; i++) {
                        initials += arr[i].substring(0,1).toUpperCase() + '.';
                    }

                    initText = '<div class="sign-text">' + initials + '</div>';
                }

                if(_.get(value, 'path') || _.get(value, 'userId')){
                    initMeta = '<div class="sign-meta">' +
                    '<span class="sign-name">' + (value.userName || 'Initials') + '</span>' +
                    '<span class="sign-date">Date: <span>' + $filter('date')(value.timestamp, 'MMM d, y h:mm:ss a') + '</span></span>' +
                    '</div>';
                }

                return '<div class="form-group">' +
                        label +
                        '<div class="sign-wrap ' + wrapLabelClass + '">' +
                            initImg +
                            initText +
                            initMeta +
                        '</div>' +
                    '</div>';
            }
            else {
                var sigImg = '';
                var sigText = '';
                var sigMeta = '';

                if(_.get(value, 'path')){
                    sigImg = '<img class="sign-img" src="' + value.path + '" />';
                }

                if(!_.get(value, 'path') && _.get(value, 'userId')){
                    sigText = '<div class="sign-text">' + value.userName + '</div>';
                }

                if(_.get(value, 'path') || _.get(value, 'userId')){
                    sigMeta = '<div class="sign-meta">' +
                    '<span class="sign-name">' + (value.userName || 'Signature') + '</span>' +
                    '<span class="sign-date">Date: <span>' + $filter('date')(value.timestamp, 'MMM d, y h:mm:ss a') + '</span></span>' +
                    '</div>';
                }

                return '<div class="form-group">' +
                        label +
                        '<div class="sign-wrap ' + wrapLabelClass + '">' +
                            sigImg +
                            sigText +
                            sigMeta +
                        '</div>' +
                    '</div>';
            }
        }

        /**
         * @function radio
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function radio(field, value) {
            var val = angular.fromJson(value);
            var label = FormsBuildHelperService.makeLabel(field);
            var displayVal = val.display || '';
            return FormsBuildHelperService.divOpenForm() + label + '<p>' + displayVal.trim() + '</p></div>';
        }

        /**
         * @function checkbox
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function checkbox(field, value) {
            var checkClass = value ? 'fa-check-square-o' : 'fa-square-o';
            return FormsBuildHelperService.divOpenForm() + '<label class="checkbox-inline static"><i class="fa fa-fw ' + checkClass + '"></i>&nbsp;<span>' + field.label.text + '</span></label></div>';
        }

        /**
         * @function select
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function select(field, value) {
            var displayVal = '';
            if(value && value.display){
                displayVal = value.display;
                if(isNaN(value.display)){
                    displayVal = displayVal.replace(/>/g,'&gt;').replace(/</g,'&lt;');
                }
            }
            return FormsBuildHelperService.divOpenForm() + FormsBuildHelperService.makeLabel(field) + FormsBuildHelperService.pFormControlStatic() + displayVal + '</p>' + '</div>';
        }

        /**
         * @function multiselect
         * @param {Field} field
         * @param {*} value
         * @returns {string} of html
         */
        function multiselect(field, value) {
            var displayVal = '';
            if(value){
                var val = angular.fromJson(value);
                for(var i = 0; i < val.length; i++){
                    displayVal = displayVal + '<li>' + val[i].display + '</li>';
                }
            }
            return FormsBuildHelperService.divOpenForm() + FormsBuildHelperService.makeLabel(field) + '<ul>' + displayVal + '</ul>' + '</p>' + '</div>';
        }

        /**
         * @function table
         * @param {Field} field
         * @returns {string} of html
         */
        function table(field) {
            var label = FormsBuildHelperService.makeLabel(field);
            var help = FormsBuildHelperService.makeHelpBlock(field.help);
            return FormsBuildHelperService.divOpenForm() + label + '<div nim-form-table nimFormTableStatic class="nim-form-table"></div>' + help + '</div>';
        }

        /**
         * @function timer
         * @param field
         * @returns {string}
         */
        function timer(field) {
            var label = FormsBuildHelperService.makeLabel(field);
            var start = moment(field.param.start.time);
            var end = moment(field.param.end.time);
            var dur = moment.duration(end.diff(start));
            var val = dur.days() + ' days ' + dur.hours() + ' hr ' + dur.minutes() + ' min ' + dur.seconds() + ' sec';
            return FormsBuildHelperService.divOpenForm() + label + FormsBuildHelperService.pFormControlStatic() + val + '</p>' + '</div>';
        }

        /**
         * @function image
         * @param field
         * @param value
         * @returns {string}
         */
        function image(field, value){
            var label = FormsBuildHelperService.makeLabel(field);
            var imgName = field.config.modelId + '.png';
            var size = field.param.resultImageSize;

            if(value) {
                return FormsBuildHelperService.divOpenForm() + label + '<div nim-file-thumb="' + imgName + '" nim-attachment-id="' + value + '" size="' + size + 'x' + size + '"></div>' + '</div>';
            }
            else {
                return FormsBuildHelperService.divOpenForm() + label + '</div>';
            }
        }

        /**
         * @function rule
         * @param field
         * @returns {string}
         */
        function rule(field){
            return '<label>' + (field.param.ruleName || '') + '</label>';
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name FormsClassService
     * @alias cerberus/core:FormsClassService
     * @description Constructs Field classes
     */
    .factory('FormsClassService', ["FormsBuildDynamicService", "FormsBuildStaticService", "LeafletDefaultsService", function FormsClassService(FormsBuildDynamicService, FormsBuildStaticService, LeafletDefaultsService) {
        /**
         * Constructs a new field
         * @class Field
         * @classdesc decribes a form object
         * @memberOf FormsClassService
         * @param {Config} config
         * @param {Validation} validation
         * @param {Display} display
         * @param {Label} label
         * @param {Help} help
         * @param {Tag} tag
         * @param {Option} option
         * @param {Calculation} calculation
         * @param {object} param - for field specific (non-standard) parameters
         */
        function Field(config, validation, display, label, help, tag, option, calculation, param) {
            this.config = config;
            this.validation = validation;
            this.display = display;
            this.label = label;
            this.help = help;
            this.tag = tag;
            this.option = option;
            this.calculation = calculation;
            this.param = param;
        }

        /**
         * setData method - revive/extend json objects
         * @memberOf Field
         */
        Field.prototype.setData = function (field) {
            angular.extend(this, field);
        };

        /**
         * build method - builds html for angular $compile
         * @memberOf Field
         */
        Field.prototype.build = function () {
            return FormsBuildDynamicService[this.config.type](this);
        };

        /**
         * buildStatic method - builds html for static display
         * @memberOf Field
         */
        Field.prototype.buildStatic = function (value) {
            return FormsBuildStaticService[this.config.type](this, value);
        };

        return {
            newField: newField,
            statictext: statictext,
            hr: hr,
            reference: reference,
            text: text,
            autocomplete: autocomplete,
            location: location,
            map: map,
            textarea: textarea,
            number: number,
            datetime: datetime,
            radio: radio,
            checkbox: checkbox,
            select: select,
            multiselect: multiselect,
            signature: signature,
            barcode: barcode,
            table: table,
            readonly: readonly,
            timer: timer,
            image: image,
            rule: rule
        };
        ////////////////////
        /**
         * Constructs a new config
         * @class Config
         * @classdesc for use with a field
         * @memberOf FormsClassService
         * @param {string} type
         * @param {string} dataType
         * @param {string} modelId
         * @param {*} defaultValue
         */
        function Config(type, dataType, modelId, defaultValue) {
            this.type = type;
            this.dataType = dataType;
            this.modelId = modelId;
            this.defaultValue = defaultValue;
        }

        /**
         * Constructs a new validation
         * @class Validation
         * @classdesc for use with a field
         * @memberOf FormsClassService
         * @param {boolean} required
         * @param {string|number|date} min
         * @param {string|number|date} max
         * @param {regex} pattern
         * @param {string} mask
         * @param {Array} rules
         */
        function Validation(required, min, max, pattern, mask, rules) {
            this.required = required;
            this.min = min;
            this.max = max;
            this.pattern = pattern;
            this.mask = mask;
            this.rules = rules;
        }

        /**
         * Constructs a new display
         * @class Display
         * @classdesc for use with a field
         * @memberOf FormsClassService
         * @param {boolean} isInline
         * @param {string} placeholder
         * @param {string} filterType
         * @param {string} filterParams
         * @param {string} format
         */
        function Display(isInline, placeholder, filterType, filterParams, format) {
            this.isInline = isInline;
            this.placeholder = placeholder;
            this.filter = {
                type: filterType,
                params: filterParams
            };
            this.format = format;

        }

        /**
         * Constructs a new label
         * @class Label
         * @classdesc for use with a field
         * @memberOf FormsClassService
         * @param {string} text
         * @param {object} attrs
         * @param {boolean} isHidden
         */
        function Label(text, attrs, isHidden) {
            this.text = text;
            this.attrs = attrs;
            this.isHidden = isHidden;
        }

        /**
         * Constructs a new help
         * @class Help
         * @classdesc for use with a field
         * @memberOf FormsClassService
         * @param {string} [text]
         * @param {object} [attrs]
         * @param {string} type
         */
        function Help(text, attrs, type) {
            this.text = text;
            this.attrs = attrs;
            this.type = type;
        }

        /**
         * Constructs a new calculation
         * @class Calculation
         * @classdesc for use with a field
         * @memberOf FormsClassService
         * @param {string} formula
         */
        function Calculation(formula) {
            this.formula = formula;
        }

        /**
         * Constructs a new option
         * @class Option
         * @classdesc for use with a field
         * @memberOf FormsClassService
         * @param {string} type - custom, widget, upload, etc.
         * @param {string} widgetId - public key to the widget
         * @param {string} id - public key to type of option
         * @param {Array} values - only use if type custom (id would be null)
         * @param {Array} autoFill - stores mapping for auto fill
         * @param {string} orderBy - default order option
         * @param {int} returnNum - number of records to return on a call

         */
        function Option(type, widgetId, id, values, autoFill, orderBy, returnNum) {
            this.type = type;
            this.widgetId = widgetId;
            this.id = id;
            this.values = values;
            this.autoFill = autoFill;
            this.orderBy = orderBy;
            this.returnNum = returnNum;
        }

        /**
         * Constructs a new tag
         * @class Tag
         * @classdesc for use with a field
         * @memberOf FormsClassService
         * @param {object} attrs
         * @param {Array} inner
         */
        function Tag(attrs, inner) {
            this.attrs = attrs;
            this.inner = inner;
        }

        /**
         * Builds an empty Field object
         * @function newField
         * @returns {Field} with null values
         */
        function newField() {
            return new Field(
                new Config(null, null, null, null),
                new Validation(false, null, null, null, null,[]),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {}
            );
        }

        /**
         * Builds a static text field
         * @function statictext
         * @returns {Field}
         */
        function statictext() {
            return new Field(
                new Config("statictext", "static", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, true),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    text: ''
                }
            );
        }

        /**
         * Builds a static horizontal rule field
         * @function hr
         * @returns {Field}
         */
        function hr() {
            return new Field(
                new Config("hr", "static", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, true),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    type: 'text',
                    value: '',
                    orientation: 'horizontal'
                }
            );
        }

        /**
         * Builds a static barcode form field
         * @function barcode
         * @returns {Field}
         */
        function barcode() {
            return new Field(
                new Config("barcode", "readonly", null, null),
                //new Config("barcode", "static", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    format: 'code128',
					barStyle: 'default',
                    barcodedata: {}
                }
            );
        }

        /**
         * Builds a readonly reference form field
         * @function reference
         * @returns {Field}
         */
        function reference() {
            return new Field(
                new Config("reference", "readonly", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, true),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {}
            );
        }

        /**
         * Builds a dynamic text form field
         * @function text
         * @returns {Field}
         */
        function text() {
            return new Field(
                new Config("text", "string", null, null),
                new Validation(false, 0, 255, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({},[]),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {}
            );
        }

        /**
         * Builds a dynamic autocomplete text form field
         * @function autocomplete
         * @returns {Field}
         */
        function autocomplete() {
            return new Field(
                new Config("autocomplete", "string", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option('custom', null, null, [], [],'asc',20),
                new Calculation(null),
                {
                    'separator': 'None'
                }
            );
        }

        /**
         * Builds a dynamic location form field
         * @function location
         * @returns {Field}
         */
        function location() {
            return new Field(
                new Config("location", "geoJson", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], 'asc', 20),
                new Calculation(null),
                {
                    'fields': {}
                }
            );
        }

        /**
         * Builds a dynamic map form object
         * @function map
         * @returns {Field}
         */
        function map() {
            return new Field(
                new Config("map", "geoJson", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    geometry: 'point',
                    center: [33.7, -117.8],
                    zoom: 10,
                    allowMultiple: false,
                    pathOptions: {
                        weight: 5,
                        color: 'blue',
                        fillColor: 'blue'
                    },
                    basemaps: [
                        {
                            type: "mapbox.streets-basic",
                            name:"Basic",
                            visible: true
                        },
                        {
                            type: "mapbox.streets-satellite",
                            name:"Satellite",
                            visible: false
                        }
                    ],
                    overlays: [],
                    controls: angular.extend(LeafletDefaultsService.controls(), {
                        draw: true
                    })
                }
            );
        }

        /**
         * Builds a dynamic textarea form field
         * @function textarea
         * @returns {Field}
         */
        function textarea() {
            return new Field(
                new Config("textarea", "string", null, null),
                new Validation(false, 0, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({
                    rows: 5
                }, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {showToolbar: false}
            );
        }

        /**
         * Builds a dynamic number form field
         * @function number
         * @returns {Field}
         */
        function number() {
            return new Field(
                new Config("number", "number", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    step: null,
                    decimals: 0
                }
            );
        }

        /**
         * Builds a dynamic datetime form field
         * @function datetime
         * @returns {Field}
         */
        //TODO: find out how to implement k parse formats
        //TODO: CSS hack to disable time or date buttons
        function datetime() {
            return new Field(
                new Config("datetime", "datetime", null, '@nim_today'),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, 'M/d/yyyy h:mm tt'),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({
                    'k-interval': 30
                }, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    parseFormats: []
                }
            );
        }

        /**
         * Builds a dynamic radio(s) selection form field
         * @function radio
         * @returns {Field}
         */
        function radio() {
            return new Field(
                new Config("radio", "selection", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option('custom', null, null, [
                    {
                        id: 'opt0',
                        display: 'Yes'
                    },
                    {
                        id: 'opt1',
                        display: 'No'
                    }
                ], [],'asc',20),
                new Calculation(null),
                {}
            );
        }

        /**
         * Builds a dynamic checkbox(es) selection form field
         * @function checkbox
         * @returns {Field}
         */
        function checkbox() {
            return new Field(
                new Config("checkbox", "selection", null, false),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({
                    'ng-required': false
                }, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {}
            );
        }

        /**
         * Builds a dynamic select selection form field
         * @function select
         * @returns {Field}
         */
        function select() {
            return new Field(
                new Config("select", "selection", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option('custom', null, null, [], [],'asc',20),
                new Calculation(null),
                {
                    filterOperator: "'contains'",
                    hideAddItem: true
                }
            );
        }

        /**
         * Builds a dynamic multi-select selection form field
         * @function multiselect
         * @returns {Field}
         */
        function multiselect() {
            return new Field(
                new Config("multiselect", "dataseries", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option('views', null, null, [], [], 'asc', 20),
                new Calculation(null),
                {
                    filterOperator: "'contains'"
                }
            );
        }

        /**
         * Builds a dynamic signature vector form field
         * @function signature
         * @returns {Field}
         */
        function signature() {
            return new Field(
                new Config("signature", "signature", null, null),
                new Validation(true, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    type: 'signature',
                    penColor: '#000000'
                }
            );
        }

        /**
         * Builds a dynamic table data series form field
         * @function table
         * @returns {Field}
         */
        function table() {
            return new Field(
                new Config("table", "dataseries", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {}
            );
        }

        /**
         * Builds a dynamic readonly form field
         * @function readonly
         * @returns {Field}
         */
        function readonly() {
            return new Field(
                new Config("readonly", "readonly", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {}
            );
        }

        /**
         * Builds a dynamic readonly form field
         * @function timer
         * @returns {Field}
         */
        function timer() {
            return new Field(
                new Config("timer", "readonly", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    start:{},
                    end:{}
                }
            );
        }

        /**
         * Builds an image upload/crop field
         * @function image
         * @returns {Field}
         */
        function image(){
            return new Field(
                new Config("image", "image", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    areaType: 'circle',
                    resultImageSize: 200
                }
            );
        }

        function rule(){
            var newRule = new Field(
                new Config("rule", "rule", null, null),
                new Validation(false, null, null, null, null, []),
                new Display(false, null, null, null, null),
                new Label(null, {}, false),
                new Help(null, {}, 'popup'),
                new Tag({}, []),
                new Option(null, null, null, [], [], null, null),
                new Calculation(null),
                {
                    ruleId: '',
                    parameterMap: {},
                    returnMap: {}
                }
            );

            newRule.display.section = '__nimHiddenSection';

            return newRule;
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name FormsService
     * @alias cerberus/core:FormsService
     * @description Reads data from the "forms" resource
     */
    .factory('FormsService', ["_", "moment", "kendo", "$http", "$q", "apiPath", "FormsClassService", "DesignerUtilityService", "nimSignatureService", function FormsService(_, moment, kendo, $http, $q, apiPath, FormsClassService, DesignerUtilityService, nimSignatureService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            getForm: getForm,
            getAutoFillValues: getAutoFillValues,
            parseDefaultValue: parseDefaultValue,
            processFormData: processFormData,
            sortFormObjects: sortFormObjects,
            fixDataseriesCols: fixDataseriesCols,
            sectionFilter: sectionFilter,
            sectionCondition: sectionCondition,
            signatureHandler: signatureHandler
        };
        ////////////////////
        /**
         * parseDefaultValue
         * @param type
         * @param value
         * @param interval
         * @returns {*}
         */
        function parseDefaultValue(type, value, interval){
            if(type === 'datetime' && value === '@nim_today'){
                var date = moment(new Date());

                if(interval && date.round){
                    date.round(interval, 'minutes');
                }

                return date.toDate();
            }
            return value;
        }
        /**
         * Given a valid response for the REST api this function
         * constructs classes for the form objects and sort them for display
         * @function processFormData
         * @param {object} data - this is the return from the HTTP call
         * @param {object} defaultDataSet - default data set
         * @return {object} formModel
         */
        function processFormData(data, defaultDataSet) {
            var totalWindowsOpen = $('div.k-widget.k-window').length;

            var formModel = data;
            var sortFunc = DesignerUtilityService.firstBy(function(v1,v2){return v1.row - v2.row;})
                .thenBy(function(v1,v2){return v1.col - v2.col;});

            if(formModel.form.objects && formModel.form.objects.length > 0) {
                // Separate the form objects by section to set the correct tab indices
                var sections = [];
                sections.push(_.reject(formModel.form.objects, 'model.display.section').sort(sortFunc));

                _.forEach(formModel.form.sections, function(section){
                    /* LODASH Version 4 ONLY */
                    //sections.push(_.filter(formModel.form.objects, ['model.display.section', section.name]).sort(sortFunc));
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    sections.push(_.filter(formModel.form.objects, function(c){return c.model.display.section === section.name;}).sort(sortFunc));
                });

                /* LODASH Version 4 ONLY */
                //sections.push(_.filter(formModel.form.objects, ['model.display.section', '__nimHiddenSection']).sort(sortFunc));
                /* LODASH Version 3 & 4 Compatibility Mode */
                sections.push(_.filter(formModel.form.objects, function(c){return c.model.display.section === '__nimHiddenSection';}).sort(sortFunc));

                var tabIndexCounter = 2 + (totalWindowsOpen * 500);
                formModel.tabindexStart = tabIndexCounter;

                _.forEach(sections, function (formObjects) {
                    _.forEach(formObjects, function (formObj) {
                        var newField = FormsClassService.newField();
                        newField.setData(formObj.model);
                        formObj.model = newField;
                        //Default Value
                        if(defaultDataSet && !_.isNull(newField.config.defaultValue) && newField.config.defaultValue !== ''){
                            var defaultVal = {},
                                interval = null;

                            // For parsing default date value to nearest interval
                            if(newField.config.type === 'datetime' && newField.display.format.match(/[HhfmstgG]/g)){
                                interval = newField.tag.attrs['k-interval'];
                            }

                            defaultVal[newField.config.modelId] = parseDefaultValue(newField.config.type, newField.config.defaultValue, interval);
                            if(defaultDataSet[newField.config.modelId] === ''){
                                defaultDataSet[newField.config.modelId] = defaultVal[newField.config.modelId];
                            }
                            else {
                                _.defaultsDeep(defaultDataSet, defaultVal);
                            }
                        }
                        //Generate tab index
                        if(formModel.form.settings.autoTabIndex.enabled){
                            newField.tag.attrs.tabindex = tabIndexCounter;
                            tabIndexCounter++;
                        }
                    });
                });

                formModel.tabindexEnd = tabIndexCounter + 10;
            }
            return formModel;
        }

        function sortFormObjects(formModel) {
            var totalWindowsOpen = $('div.k-widget.k-window').length;

            var sortFunc = DesignerUtilityService.firstBy(function(v1,v2){return v1.row - v2.row;})
                .thenBy(function(v1,v2){return v1.col - v2.col;});

            if(formModel.form.objects && formModel.form.objects.length > 0) {
                // Separate the form objects by section to set the correct tab indices
                var sections = [];
                sections.push(_.reject(formModel.form.objects, 'model.display.section').sort(sortFunc));

                _.forEach(formModel.form.sections, function(section){
                    /* LODASH Version 4 ONLY */
                    //sections.push(_.filter(formModel.form.objects, ['model.display.section', section.name]).sort(sortFunc));
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    sections.push(_.filter(formModel.form.objects, function(c){return c.model.display.section === section.name;}).sort(sortFunc));
                });

                /* LODASH Version 4 ONLY */
                //sections.push(_.filter(formModel.form.objects, ['model.display.section', '__nimHiddenSection']).sort(sortFunc));
                /* LODASH Version 3 & 4 Compatibility Mode */
                sections.push(_.filter(formModel.form.objects, function(c){return c.model.display.section === '__nimHiddenSection';}).sort(sortFunc));

                var tabIndexCounter = 2 + (totalWindowsOpen * 500);
                formModel.tabindexStart = tabIndexCounter;

                _.forEach(sections, function (formObjects) {
                    _.forEach(formObjects, function (formObj) {
                        //Generate tab index
                        if(formModel.form.settings.autoTabIndex.enabled){
                            formObj.model.tag.attrs.tabindex = tabIndexCounter;
                            tabIndexCounter++;
                        }
                    });
                });
                formModel.tabindexEnd = tabIndexCounter + 10;
            }

            //Sort form objects by tabindex and return
            return _.sortBy(formModel.form.objects, 'model.tag.attrs.tabindex');
        }

        /**
         * Get form by id
         * @function getFrom
         * @param {string} id
         * @param {boolean} isPk
         * @returns {promise}
         */
        function getForm(id, isPk) {
            var deferred = $q.defer();
            var url = apiPath + 'forms/' + id;
            if(isPk){
                url += '?isPk=true';
            }
            $http.get(url)
                .success(function (value) {
                    deferred.resolve(processFormData(value.DATA));
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Gets autofill values and populates the scope with appropriate values
         * @function getAutoFillValues
         * @param {string} id
         * @param {object} data
         * @returns {promise}
         */
        function getAutoFillValues(id, data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'autoFill/'+ id, {settings:data})
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function fixDataseriesCols(dataItem, schemaFields) {
            _.forEach(schemaFields, function (col, colField) {
                var modelId = colField,
                    isLookup = false;
                
                if (_.startsWith(modelId, '__') && _.endsWith(modelId, '_display')) {
                    modelId = colField.replace(/^__/, '').replace(/_display$/, '');
                    isLookup = true;
                }
                
                if (_.has(dataItem.__nimData, modelId)) {
                    var val = dataItem.__nimData[modelId],
                        displayVal = '';
                    if (isLookup) {
                        displayVal = _.get(val, 'display', '');
                    }
                    else if (col.type == 'number') {
                        val = parseFloat(val);
                        if (!isNaN(val)) {
                            displayVal = val;
                        }
                    }
                    else if (col.type == 'date') {
                        if (_.isDate(val)) {
                            displayVal = val;
                        }
                        else if (_.isString(val)) {
                          //replaced by HD 2019-07-03
                          //displayVal = kendo.parseDate(val, ['MMMM, dd yyyy HH:mm:ss', 'yyyy-MM-ddTHH:mm:ss.fffZ']);
                            displayVal = kendo.parseDate(val, ['MMMM, dd yyyy HH:mm:ss', 'yyyy-MM-ddTHH:mm:ssz', 'yyyy-MM-ddTHH:mm:ss.fffz'], 'yyyy-MM-ddTHH:mm:sszzz');
                        }
                    }
                    else {
                        displayVal = val;
                    }

                    dataItem[colField] = displayVal;
                }

                if (!dataItem.__rowId) {
                    dataItem.__rowId = DesignerUtilityService.generateGuid();
                }    
            });
        }

        function sectionFilter(section){
            if (angular.isDefined(section)) {
                return function (field) {
                    return field.model.display.section === section;
                };
            }
            else {
                return function (field) {
                    return !field.model.display.section;
                };
            }
        }

        /**
         * Checks if data meets section conditions
         * @function sectionCondition
         * @param condArray - section condition array
         * @param dataSet - state data set
         * @param logic - and/or (optional - assumes "and" by default)
         * @param action - record action ("create", "read", or "readonly")
         * @returns {boolean}
         */
        function sectionCondition(condArray, dataSet, logic, action) {
            if (action == 'readonly') {
                action = 'read';
            }
            var iteratee = function(c){
                // Gets model value from dataSet
                var match,
                    model = _.get(dataSet, c.modelId, false),
                    value = c.val;
                
                if (c.modelId === '__nimRecordAction') {
                    model = action;
                }

                if(c.isFormObj){
                    value = _.get(dataSet, c.val, false);

                    if (_.has(value, 'display')) {
                        value = value.display;
                    }
                }

                // Lookup Value
                if(c.op === 'eq' || c.op === 'neq') {
                    // Check if model value matches condition
                    if (_.isBoolean(model) || _.isBoolean(value)) {
                        var boolModel = !!model,
                            boolValue = !!value;
                        match = boolModel === boolValue;
                    }
                    else if (value === 'NULL' || (!value && value !== 0)) {
                        match = _.isEmpty(model) || model.value === '-1';
                    }
                    else if (_.has(model, 'display')) {
                        match = value === model.display;
                    }
                    else {
                        match = _.map(model, 'display').indexOf(value) >= 0;
                    }

                    // Inverts match result if operator is neq
                    if (c.op === 'neq') {
                        match = !match;
                    }
                }
                else {
                    switch(c.op){
                        // String cases
                        case 'str_contains':
                            match = model.search(value) >= 0;
                            break;
                        case 'str_doesnotcontain':
                            match = model.search(value) < 0;
                            break;
                        case 'str_startswith':
                            match = _.startsWith(model, value);
                            break;
                        case 'str_endswith':
                            match = _.endsWith(model, value);
                            break;
                        case 'str_eq':
                            match = model === value;
                            break;
                        case 'str_neq':
                            match = model !== value;
                            break;

                        // Number cases
                        case 'num_eq':
                            match = model === parseFloat(value);
                            break;
                        case 'num_neq':
                            match = model !== parseFloat(value);
                            break;
                        case 'num_gt':
                            match = model > parseFloat(value);
                            break;
                        case 'num_gte':
                            match = model >= parseFloat(value);
                            break;
                        case 'num_lt':
                            match = model < parseFloat(value);
                            break;
                        case 'num_lte':
                            match = model <= parseFloat(value);
                            break;
                    }
                }

                return match;
            };

            if(logic === 'or'){
                return _.some(condArray, iteratee);
            }
            else {
                return _.every(condArray, iteratee);
            }
        }

        /**
         * Handlers signing process when a sign button is clicked on the forms
         *
         * TODO:  Remove modal header to save space on smaller device
         *
         * @param {object} [sigData]
         * @param {boolean} [isInitial]
         * @param {string} [restrictTo]
         * @param {string} [penColor]
         * @param {boolean} [reSign]
		 * @param {boolean} [isTouchpadSign]
         * @returns {promise}
         */
        function signatureHandler(sigData, isInitial, restrictTo, penColor, reSign, isTouchpadSign) {
            var deferred = $q.defer();
            var sigModel = angular.extend({}, sigData);
            // Has it already been signed in anyway
            if (sigData && !reSign && restrictTo !== 'anon') {
                // If so then was is signed by an account
                if (sigData.userId) {
                    // Set signature
                    sigModel.timestamp = new Date();
                    deferred.resolve(sigModel);
                }
                // If it was an external signature we must check for
                // the existence of the requested signature type: signature or initial
                // if it does not exist we must prompt the user for it.
                else {
                    // Is this an initial signing
                    if (isInitial) {
                        // Does it already exist
                        if (sigData.iniPath) {
                            sigModel.path = sigData.iniPath;
                            sigModel.timestamp = new Date();
                            deferred.resolve(sigModel);
                        }
                        else {
                            // Open Modal and default to anon signature
                            nimSignatureService.openModal(isInitial, restrictTo, penColor, isTouchpadSign).result.then(success, error);
                        }
                    }
                    // Or is this a signature signing
                    else {
                        if (sigData.sigPath) {
                            sigModel.path = sigData.sigPath;
                            sigModel.timestamp = new Date();
                            deferred.resolve(sigModel);
                        }
                        else {
                            // Open Modal and default to anon signature
                            nimSignatureService.openModal(isInitial, restrictTo, penColor, isTouchpadSign).result.then(success, error);
                        }
                    }
                }
            }
            // Signature or initials do not exist and
            // this signature is restricted to an account only
            else if (restrictTo === 'account') {
                // Make the service call to get account signature.
                nimSignatureService.getSignatureWithAccount().then(success, error);
            }
            // Signature or initials do not exist
            else {
                nimSignatureService.openModal(isInitial, restrictTo, penColor, isTouchpadSign).result.then(success, error);
            }

            // Promise success handler
            function success(data) {
                // If this was an account signing
                if (data.userId) {
                    sigModel = data;
                }
                // If this was an anon initials signing
                else if (isInitial) {
                    sigModel.iniPath = data.path;
                    sigModel.timestamp = data.timestamp;
                }
                // Then it must have be an anon signature signing
                else {
                    // Save Signature
                    sigModel.sigPath = data.path;
                    sigModel.timestamp = data.timestamp;
                }
                // Save the signature value
                deferred.resolve(sigModel);
            }

            // Promise error handler
            function error() {
                deferred.reject();
            }

            return deferred.promise;
        }
    }])
;

angular.module('cerberus.core')
    .controller('nimFormMapCtrl', ["$scope", "$attrs", "$element", "$timeout", "LeafletDefaultsService", function nimFormMapCtrl($scope, $attrs, $element, $timeout, LeafletDefaultsService){
        var vm = this;

        var isStatic = $attrs.nimformmapstatic != null && $attrs.nimformmapstatic != 'false';
        var mapOptions = $scope.nimFormObject.param;
        var drawOptions = {
            draw: {
                polygon: false,
                polyline: false,
                circle: false,
                marker: false,
                rectangle: false
            }
        };
        var mapId = $scope.formOriginId + '_' + $scope.nimFormObject.config.modelId;
        var windowRevisionId = angular.element($element).parents('[nim-window-id]').attr('nim-revision-id');
        if (windowRevisionId) {
            mapId = mapId + '_rev_' + windowRevisionId;
        }
        var elementsWithSameId = angular.element('#' + mapId);
        if (elementsWithSameId.length > 0) {
            mapId = mapId + '_dup_' + angular.element('[nim-instance]').length;
        }
        vm.leafletId = mapId;
        vm.result = null;

        drawOptions.draw[mapOptions.geometry] = {
            shapeOptions: mapOptions.pathOptions
        };

        vm.options = {
            basemaps: mapOptions.basemaps || [],
            overlays: mapOptions.overlays || [],
            map: LeafletDefaultsService.map(),
            controls: isStatic ? {} : mapOptions.controls,
            drawOptions: drawOptions,
            allowMultiple: mapOptions.allowMultiple,
            isStatic: isStatic
        };

        //TODO: Figure out a better way to implement this.  It is pretty rough...
        if (angular.isArray($scope.nimFormObject.param.center)) {
            vm.options.map.center = $scope.nimFormObject.param.center;
        }
        if (angular.isNumber($scope.nimFormObject.param.zoom)) {
            vm.options.map.zoom = $scope.nimFormObject.param.zoom;
        }
        if (angular.isDefined($scope.nimFormObject.param.scrollWheelZoom)) {
            vm.options.map.scrollWheelZoom = $scope.nimFormObject.param.scrollWheelZoom;
        }
        if (angular.isNumber($scope.nimFormObject.param.minZoom)) {
            vm.options.map.minZoom = $scope.nimFormObject.param.minZoom;
        }
        if (angular.isNumber($scope.nimFormObject.param.maxZoom)) {
            vm.options.map.maxZoom = $scope.nimFormObject.param.maxZoom;
        }

        if(isStatic){
            vm.options.map = angular.extend(vm.options.map,{
                touchZoom: false,
                dragging: false,
                scrollWheelZoom: false,
                doubleClickZoom: false,
                boxZoom: false,
                zoomControl: false
            });
        }
        else if($scope.nimEditing){
            vm.options.map = angular.extend(vm.options.map, {
                dragging: false,
                scrollWheelZoom: false
            });
        }

        if($scope.dataSet){
            vm.options.drawings = $scope.dataSet[$scope.nimFormObject.config.modelId];
        }

        vm.zoomTo = function(){
            if($scope.location){
                $scope.map.setView({
                    lng: $scope.location.geometry.coordinates[0],
                    lat: $scope.location.geometry.coordinates[1]
                }, 16);
            }
        };

        $scope.$watch("vm.result", function(result){
            if(result) {
                if(result.features.length > 0) {
                    $scope.dataSet[$scope.nimFormObject.config.modelId] = result.features[0];
                    delete $scope.dataSet[$scope.nimFormObject.config.modelId].type;
                }
                else {
                    $scope.dataSet[$scope.nimFormObject.config.modelId] = {};
                }

                if($scope.validateFormObject) {
                    $scope.validateFormObject($scope.dataSet[$scope.nimFormObject.config.modelId], $scope.isRequired);
                }
            }
        });

        // Gridster resize
        $scope.$on('gridster-item-transition-end', function () {
            if($scope.map) {
                $scope.map.invalidateSize();
            }
        });
    }])
    .directive('nimFormMap', function(){
        return {
            restrict: 'AE',
            templateUrl: 'core/forms/nim-form-map.tpl.html',
            scope: true,
            controller: 'nimFormMapCtrl',
            controllerAs: 'vm'
        };
    })
;
angular.module('cerberus.core')
    .controller('nimFormObjectCtrl', ["_", "moment", "kendo", "$scope", "$rootScope", "$element", "$timeout", "$attrs", "$log", "ConfirmModalService", "FormsService", "FormValidationService", "NimFormObjectService", "InstancesService", "InstancesWindowService", function (_, moment, kendo, $scope, $rootScope, $element, $timeout, $attrs, $log,
                                               ConfirmModalService, FormsService, FormValidationService,
                                               NimFormObjectService, InstancesService, InstancesWindowService) {
        $scope.nimFormObject = evalAttr($attrs.nimFormObject);
        $scope.fieldOptions = evalAttr($attrs.fieldOptions);
        $scope.filters = evalAttr($attrs.filters);
        $scope.formOriginId = evalAttr($attrs.formOriginId);
        $scope.nimStatic = evalAttr($attrs.nimStatic);
        $scope.nimInstanceAction = evalAttr($attrs.nimInstanceAction) || '';
        $scope.nimEditing = evalAttr($attrs.nimEditing);
        $scope.dataSet = evalAttr($attrs.dataset);
        $scope.autoFillData = evalAttr($attrs.autoFillData);
        $scope.instanceForm = evalAttr($attrs.nimInstanceForm);
        $scope.validateOnOpen = evalAttr($attrs.validateOnOpen) || '';

        $scope.signed = false;
        $scope.imageSource = null;
        $scope.imageUrl = '';
        $scope.attachmentId = '';
        $scope.previewImage = false;
        $scope.compiledStaticText = '';
        $scope.dropDownWrapperEle = null;
        $scope.textEditorOptions = NimFormObjectService.textEditorOptions();
        $scope.addItemFunctions = {
            callback: addItemCallback
        };
        $scope.isReadonly = false;
        $scope.isRequired = false;
        
        $scope.validateFormObject = FormValidationService.validateFormObject($scope.instanceForm, $scope.nimFormObject);
        $scope.validateKendoFormObject = FormValidationService.validateKendoFormObject($scope, $scope.instanceForm, $scope.nimFormObject);
        $scope.validateAndUpdateOnChange = validateAndUpdateOnChange;
        $scope.formatReadonly = formatReadonly;
        // $scope.pushChange = pushChange;
        $scope.dropdownDataBoundHandler = dropdownDataBoundHandler;
        $scope.dropdownCloseHandler = dropdownCloseHandler;
        $scope.dropdownOpenHandler = dropdownOpenHandler;
        $scope.openCreateWindow = openCreateWindow;
        $scope.updateFilterOnChange = updateFilterOnChange;
        $scope.updateFilter = updateFilter;
        $scope.onSelectionChange = onSelectionChange;
        $scope.onFilter = onFilter;
        $scope.dropdownClose = dropdownClose;
        $scope.multiSelectDataBound = multiSelectDataBound;
        $scope.getLocationAutoComplete = NimFormObjectService.getLocationAutoComplete;
        $scope.setLocationData = _.partial(NimFormObjectService.setLocationData, $scope);
        $scope.setEmptyLocation = NimFormObjectService.setEmptyLocation($scope);
        $scope.clearImage = clearImage;

        var alertPromise;
        var tempModelId = '_' + $scope.nimFormObject.config.modelId;

        // Initialize form object
        init();

        $scope.$on('$destroy', function () {
            if (alertPromise) {
                $timeout.cancel(alertPromise);
            }

            delete $scope.addItemFunctions.callback;
        });

        $scope.$on('nim-remove-form-objects', function () {
            if ($scope.nimNumberFormObject){
                $scope.nimNumberFormObject.destroy();
                $scope.nimNumberFormObject = null;
            }

            if ($scope.nimDateFormObject){
                $scope.nimDateFormObject.destroy();
                $scope.nimDateFormObject = null;
            }

            if($scope.dropDownWrapperEle) {
                $scope.dropDownWrapperEle.off('focus click mouseup mousedown');
            }
        });

        function init() {
            // Copy dataset value to filters struct
            if ($scope.dataSet[$scope.nimFormObject.config.modelId]) {
                $scope.filters[$scope.nimFormObject.config.modelId] = $scope.dataSet[$scope.nimFormObject.config.modelId];
            }

            switch ($scope.nimFormObject.config.type) {
                case 'location':
                    initLocation();
                    break;

                case 'datetime':
                    initDateTime();
                    break;

                case 'textarea':
                    initTextarea();
                    break;

                case 'signature':
                    initSignature();
                    break;

                case 'image':
                    initImage();
                    break;

                case 'rule':
                    initRule();
                    break;

                case 'multiselect':
                    initMultiSelect();
                    break;

                case 'select':
                    initSelect();
                    break;

                case 'radio':
                    initRadio();
                    break;

                case 'autocomplete':
                    initAutoComplete();
                    break;

                case 'number':
                    initNumber();
                    break;

                case 'statictext':
                    initStaticText();
                    break;

            // Initialize barcode here, if neccesary.
            //  case 'barcode':
            //      initBarcode();
            //      break;

                case 'timer':
                    initTimer();
                    break;
            }

            // Set as readonly
            var readonlyByDefault = !!($scope.nimFormObject.param.disabled || $scope.nimFormObject.param.autoIncrement);
            $scope.isReadonly = readonlyByDefault;
            if (!readonlyByDefault && $attrs.nimReadonly) {
                $scope.isReadonly = $scope.$eval($attrs.nimReadonly);

                // Watch nim-readonly attribute if not hard-set as readonly
                $scope.$watch($attrs.nimReadonly, function (readonly) {
                    $scope.isReadonly = readonly;
                });
            }
            
            // Set as required
            var requiredByDefault = !!($scope.nimFormObject.validation.required && $scope.nimFormObject.display.section !== '__nimHiddenSection');
            $scope.isRequired = requiredByDefault;
            if (!requiredByDefault && $attrs.nimRequired) {
                $scope.isRequired = $scope.$eval($attrs.nimRequired);

                // Watch nim-required attribute if not hard-set as required
                $scope.$watch($attrs.nimRequired, function (required) { 
                    $scope.isRequired = required;
                });
            }

            // Validate form object on render if form has already been submitted
            if($scope.instanceForm && $scope.instanceForm.$submitted){
                $timeout(function(){
                    $scope.validateFormObject($scope.dataSet[$scope.nimFormObject.config.modelId], $scope.isRequired);
                });
            }
        }

        function initLocation() { 
            if (!$scope.nimStatic) {
                //Set the text in the autocomplete field when editing
                $scope[tempModelId] = _.get($scope.dataSet, $scope.nimFormObject.config.modelId + '.properties.formatted_address', '');
            }
        }

        function initDateTime() {
            if (!$scope.nimStatic) {
                var dateFormat = _.trim($scope.nimFormObject.display.format);
        
                // Sets the ngModel so the input doesn't appear blank despite having a default value set
                $timeout(function () {
                    var defaultDate = _.get($scope.dataSet, $scope.nimFormObject.config.modelId, '');
                    $scope[tempModelId] = kendo.toString(defaultDate, dateFormat);
                });

                var after = $scope.nimFormObject.param.after;
                if (after) {
                    NimFormObjectService.watchAfterDateField($scope, after, 'nimDateFormObject');
                }

                var before = $scope.nimFormObject.param.before;
                if (before) {
                    NimFormObjectService.watchBeforeDateField($scope, before, 'nimDateFormObject');
                }

                var removeDateRenderWatcher = $scope.$on("kendoWidgetCreated", function (e, widget) {
                    e.preventDefault();
                    removeDateRenderWatcher();

                    if ($scope.nimDateFormObject == widget) {
                        // Fix for weird calculation bug
                        $timeout(function () {
                            var initialDateValue = _.get($scope.dataSet, $scope.nimFormObject.config.modelId, '');
                            if (initialDateValue && _.has(initialDateValue, 'indexOf') && widget) {
                                $scope[tempModelId] = kendo.toString(initialDateValue, dateFormat);
                                widget.value(initialDateValue);
                            }
                        }, 100);
                    }
                });
            }    
        }

        function initTextarea() {
            if (!$scope.nimStatic) {
                // Sets the ngModel so the input doesn't appear blank despite having a default value set
                $scope[tempModelId] = _.get($scope.dataSet, $scope.nimFormObject.config.modelId, '');
            }
         }

        function initSignature() { 
            if (!$scope.nimStatic) {
                //$scope.signed = _.has($scope, 'dataSet.' + $scope.nimFormObject.config.modelId + '.path');
                $scope.signButtonClick = signButtonClick;
            }
        }

        function initImage() {
            if (!$scope.nimStatic) {
                $scope.attachmentId = $scope.dataSet[$scope.nimFormObject.config.modelId];

                if ($scope.attachmentId) {
                    InstancesService.getDownloadKey($scope.attachmentId).then(function (url) {
                        $scope.imageUrl = url;
                    });
                }
            }
         }

        function initRule() {
            if (!$scope.nimStatic) {
                NimFormObjectService.enforceRule($scope, $scope.nimFormObject.param, $scope.dataSet, $scope.nimFormObject.config.modelId);
            }
         }

        function initMultiSelect() {
            if ($scope.nimStatic) {
                multiSelectDataBound();
            }
            else {
                var defaultMultiSelectValue = {};
                defaultMultiSelectValue[$scope.nimFormObject.config.modelId] = [];
                _.defaults($scope.dataSet, defaultMultiSelectValue);

                if ($scope.nimFormObject.option.type != 'custom') {
                    initDataSource();
                    
                    if ($scope.filters[$scope.nimFormObject.config.modelId]) {
                        _.forEach($scope.filters[$scope.nimFormObject.config.modelId], function (item) {
                            $scope.oDataLookUp.add(item);
                        });
                    }
                    else if ($scope.dataSet && $scope.dataSet[$scope.nimFormObject.config.modelId]) {
                        _.forEach($scope.dataSet[$scope.nimFormObject.config.modelId], function (item) {
                            $scope.oDataLookUp.add(item);
                        });
                    }

                    // Logs error that lookupFormOrigin is missing
                    if (!$scope.nimFormObject.param.lookupFormOrigin) {
                        $log.error('Multiselect field "' + $scope.nimFormObject.config.modelId + '" is missing parameter "lookupFormOrigin".');
                    }
                }
            }
         }

        function initSelect() {
            if (!$scope.nimStatic) {
                var initialValue = _.get($scope.dataSet[$scope.nimFormObject.config.modelId], 'id', '');

                if (initialValue) {
                    $scope[tempModelId] = initialValue;
                }

                if ($scope.nimFormObject.option.type != 'custom') {
                    initDataSource();

                    if ($scope.nimFormObject.option.type === 'views' && _.get($scope.nimFormObject.param, 'advSel.enabled') && _.get($scope.nimFormObject.param, 'advSel.pageObjectId')) {
                        $scope.openAdvSelPage = _.partial(InstancesWindowService.openAdvSelPage, $scope, function (data) {
                            if (data) {
                                if (data.id && !$scope.oDataLookUp.get(data.id)) {
                                    $scope.oDataLookUp.add(data);
                                }

                                $scope.dataSet[$scope.nimFormObject.config.modelId] = data;
                                $scope.onSelectionChange(null, data.id);
                            }
                        });
                    }
                }
            }
         }

        function initRadio() {
            if (!$scope.nimStatic) {
                // Makes sure radio binds to correct value
                var radioVal = _.get($scope.dataSet, $scope.nimFormObject.config.modelId);  // Saved radio value

                if (!_.isEmpty(radioVal)) {
                    var radioOptions = _.get($scope.fieldOptions, $scope.nimFormObject.config.modelId, []);

                    // Finds corresponding option and pushes it to the dataSet
                    $scope.dataSet[$scope.nimFormObject.config.modelId] = _.find(radioOptions, radioVal);
                }

                if ($scope.nimFormObject.option.type != 'custom') {
                    initDataSource();

                    $scope.oDataLookUp.fetch(function () {
                        if ($scope.oDataLookUp.data().length < 1) {
                            $scope.oDataLookUp.data([{ id: '-1', display: '(No Results)' }]);
                        }
                    });
                }
            }
         }

        function initAutoComplete() {
            if (!$scope.nimStatic) {
                if ($scope.nimFormObject.option.type != 'custom') {
                    initDataSource();
                    
                    $scope.oDataLookUp.fetch(function () {
                        if ($scope.oDataLookUp.data().length < 1) {
                            $scope.oDataLookUp.data([{ id: '-1', display: '(No Results)' }]);
                        }
                    });
                }
            }
         }
        
        function initNumber() {
            if (!$scope.nimStatic) {
                $scope[tempModelId] = _.get($scope.dataSet, $scope.nimFormObject.config.modelId, '');

                var removeNumberRenderWatcher = $scope.$on("kendoWidgetCreated", function (e, widget) {
                    e.preventDefault();
                    removeNumberRenderWatcher();

                    if ($scope.nimNumberFormObject == widget) {
                        // Fix for weird calculation bug
                        $timeout(function () {
                            var initialNumberValue = _.get($scope.dataSet, $scope.nimFormObject.config.modelId, '');
                            if (_.isNumber(initialNumberValue)) {
                                widget.value(initialNumberValue);
                                $scope[tempModelId] = initialNumberValue;
                            }
                        }, 100);
                    }
                });
            }
         }

        function initStaticText() {
            NimFormObjectService.compileStaticText($scope, $element);

            var conditionallyShown = $scope.nimFormObject.param.conditionalAction === 'show' || !$scope.nimFormObject.param.conditionalAction,
                hasCondition = !_.isEmpty($scope.nimFormObject.param.condition);

            if (!$scope.nimStatic && $scope.nimFormObject.param.showPopup && conditionallyShown && hasCondition) {
                $scope.$on('nim-show-static-text-popup', function (e, id) {
                    e.preventDefault();
                    var bodyText = $scope.compiledStaticText;

                    if (id === $scope.nimFormObject.config.modelId) {
                        alertPromise = $timeout(function () {
                            ConfirmModalService.showModal(null, {
                                headerText: $scope.nimFormObject.label.text || 'Alert',
                                bodyText: bodyText,
                                showActionButton: true,
                                actionButtonClass: 'btn-primary',
                                actionButtonPosition: 'footer',
                                showCloseButton: false,
                                closeButtonText: 'Cancel',
                                footerAlignment: 'center',
                                check: function () {
                                    return true;
                                }
                            });
                        }, 2000);
                    }
                });
            }
        }

        function initTimer() {
            if (!$scope.nimStatic) {
                $scope.timerStart = _.get($scope.nimFormObject,'param.start.time', moment().valueOf());
            }
         }

        // Call this for select, multiselect, radio, autocomplete
        function initDataSource() {

            // Text from drop-down's search field
            $scope.filterInput = null;

            $scope.oDataLookUp = NimFormObjectService.createODataLookUp($scope);

            if ($scope.nimFormObject.param.cascadeFilter) {
                _.forEach($scope.nimFormObject.param.cascadeFilter.filters, function (cascadeFilter) {
                    if (cascadeFilter.field && cascadeFilter.value) {
                        $scope.$watch('filters["' + cascadeFilter.value + '"]', cascadeWatcher);
                    }
                });
            }

            if (_.get($scope.dataSet[$scope.nimFormObject.config.modelId],  'id') != null) {
                if ($scope.nimInstanceAction === 'create') {
                    onSelectionChange(null, $scope.dataSet[$scope.nimFormObject.config.modelId].id);
                }
                else {
                    updateFilter($scope.dataSet, $scope.nimFormObject.config.modelId);

                    if ($scope.nimFormObject.config.type === 'select') {
                        if ($scope.dataSet[$scope.nimFormObject.config.modelId].id < 0) {
                            $scope.dataSet[$scope.nimFormObject.config.modelId] = '';
                        }
                    }
                }
            }

            $scope.$on('nim-auto-fill-dropdown', function(e, modelId, value){
                e.preventDefault();

                if ($scope.nimFormObject.config.modelId === modelId && $scope.oDataLookUp && value && value.id) {
                    if(!$scope.oDataLookUp.get(value.id)) {
                        $scope.oDataLookUp.add(value);
                    }
                }
            });
        }

        // function isReadonly(){
        //     var readonly = !!($scope.nimFormObject.param.disabled || $scope.nimFormObject.param.autoIncrement);
        //     if(!readonly && $attrs.nimReadonly){
        //         readonly = readonly || $scope.$eval($attrs.nimReadonly);
        //     }
        //     return readonly;
        // }

        // function isRequired() {
        //     var required = !!($scope.nimFormObject.validation.required && $scope.nimFormObject.display.section !== '__nimHiddenSection');
        //     if (!required && $attrs.nimRequired) {
        //         required = required || $scope.$eval($attrs.nimRequired);
        //     }

        //     return required;
        // }

        function dropdownClose(){
            $scope.filterInput = null;
        }

        function updateFilterOnChange(){
            updateFilter($scope.dataSet, $scope.nimFormObject.config.modelId);
        }

        function updateFilter(dataSet, modelId){
            $timeout(function(){
                if(!dataSet[modelId] || dataSet[modelId].id === '-1' || dataSet[modelId].id === -1){
                    $scope.filters[modelId] = '';
                }
                else{
                    $scope.filters[modelId] = dataSet[modelId];
                }
            });
        }

        function validateAndUpdateOnChange(e) {
            updateFilterOnChange();
            $scope.validateKendoFormObject(e);
        }

        function onSelectionChange(/*e, id*/) {
            if($scope.nimStatic){
                return;
            }

            // If the dropdown is a filter, the filter map has already been updated
            if(!$scope.nimFormObject.param.filter) {
                $scope.updateFilter($scope.dataSet, $scope.nimFormObject.config.modelId);
            }
            else {
                var id = _.get($scope.filters[$scope.nimFormObject.config.modelId], 'id');
                if(id === -1 || id === '-1'){
                    $scope.filters[$scope.nimFormObject.config.modelId] = '';
                }
            }
            if($scope.nimFormObject.config.type === 'select'){
                if($scope.dataSet[$scope.nimFormObject.config.modelId].id < 0){
                    $scope.dataSet[$scope.nimFormObject.config.modelId] = '';
                }
            }
        }

        function onFilter(e) {
            e.preventDefault();
            $scope.filterInput = e.filter;

            $scope.oDataLookUp.fetch(function () {
                if ($scope.oDataLookUp.data().length < 1) {
                    $scope.oDataLookUp.data([{id: '-1', display: '(No Results)'}]);
                }
            });
        }

        function signButtonClick(sigData, reSign, isTouchpadSign) {
            var isInitial = $scope.nimFormObject.param.type === 'initial';
            var restrictTo = $scope.nimFormObject.param.restrictTo;
            var penColor = $scope.nimFormObject.param.penColor;
            FormsService.signatureHandler(sigData, isInitial, restrictTo, penColor, reSign, isTouchpadSign).then(function (sigModel) {
                // Copy the signature model
                var model = angular.copy(sigModel);
                if (isInitial) {
                    model.path = angular.copy(sigModel.iniPath);
                } else {
                    model.path = angular.copy(sigModel.sigPath);
                }
                // Clean up model
                delete model.sigPath;
                delete model.iniPath;
                // Save the cleaned signature model
                $scope.dataSet[$scope.nimFormObject.config.modelId] = model;
                // Save this Data on the form so future signatures can be signed without all this hoopla
                if(restrictTo !== 'anon') {
                    $scope.$emit('nimSignatureAccepted', sigModel);
                }
            });
        }

        function openCreateWindow(){
            var defaultData = [];

            if(!_.isEmpty($scope.nimFormObject.param.defaultData)){
                _.forEach($scope.nimFormObject.param.defaultData, function(fieldMap){
                    if(_.has($scope.dataSet, fieldMap.sourceField.modelId)){
                        var value = _.get($scope.dataSet, fieldMap.sourceField.modelId),
                            data = {
                                value: value
                            };

                        if (fieldMap.sourceField.isLookUp || fieldMap.sourceField.isCustomLookup) {
                            if (_.isEmpty(value)) {
                                return;
                            }
                            
                            data.value = _.get(value, 'id');
                            data.lookupDisplay = _.get(value, 'display');
                        }

                        defaultData.push({
                            data: data,
                            field: fieldMap.targetField
                        });
                    }
                });
            }

            InstancesWindowService.openWindow({
                action: 'create',
                widgetId: $scope.nimFormObject.option.widgetId,
                title: $scope.nimFormObject.label.text,
                defaultData: defaultData,
                navFunctions: $scope.addItemFunctions
            });
        }

        function multiSelectDataBound(e){
            var param = $scope.nimFormObject.param;
            var dataSet = $scope.dataSet[$scope.nimFormObject.config.modelId];

            if (dataSet) {
                _.forEach(dataSet, function (dataItem) {
                    var lookupData = _.get(dataItem, ['__nimData', param.lookup]);
                    
                    if(lookupData && (!dataItem.display || !dataItem.id)) {
                        dataItem.display = lookupData.display;
                        dataItem.id = lookupData.id;
                    }
                });

                if (_.has(e, 'sender')) {
                    $timeout(function(){
                        var dataSource = e.sender.dataSource;
                        if(_.isEmpty(e.sender.value())){
                            var values = _.map(dataSet, function (item) {
                                if(!dataSource.get(item.id)){
                                    dataSource.pushCreate(item);
                                }

                                return item.id + '';
                            });
                            e.sender.value(values);
                        }

                        // Removes "No Results" item from dataSource if other results are added
                        var noResult = dataSource.get(-1);
                        if(dataSource.total() > 1 && noResult){
                            dataSource.pushDestroy(noResult);
                        }
                    });
                }
            }
        }

        function cascadeWatcher(newValue, oldValue){
            var currentValue = $scope.dataSet[$scope.nimFormObject.config.modelId],
                parentValueSet = parentLookupSet(newValue),
                parentValueWasSet = parentLookupSet(oldValue),
                valueChanged = parentValueChanged(newValue, oldValue);


            if(!parentValueSet && !parentValueWasSet){
                valueChanged = false;
            }
            if(valueChanged || (_.isEmpty(currentValue) && parentValueSet)) {
                $scope.oDataLookUp.read().then(function () {
                    if ($scope.nimFormObject.config.type === 'select') {
                        $timeout(function () {
                            currentValue = $scope.dataSet[$scope.nimFormObject.config.modelId];

                            if ($scope.oDataLookUp.data().length < 1) {
                                $scope.oDataLookUp.data([{ id: '-1', display: '(No Results)' }]);
                                $scope.dataSet[$scope.nimFormObject.config.modelId] = '';
                            }
                            else if (parentValueSet) {
                                var currentId = _.get(currentValue, 'id');

                                // If current value not in filtered data, select first result 
                                if (!$scope.oDataLookUp.get(currentId)) {
                                    var dataItem = {};

                                    if (!$scope.nimFormObject.param.disableCascadeAutoFill) {
                                        dataItem = $scope.oDataLookUp.data()[0];
                                    }

                                    // If this lookup is a filter, don't push to dataSet
                                    if ($scope.nimFormObject.param.filter) {
                                        $scope.filters[$scope.nimFormObject.config.modelId] = angular.copy(dataItem);
                                    }
                                    else {
                                        $scope.dataSet[$scope.nimFormObject.config.modelId] = angular.copy(dataItem);
                                    }

                                    $scope.onSelectionChange(null, dataItem.id);
                                }
                            }
                        });
                    }    
                });
            }
        }

        function parentLookupSet(value){
            if(_.isNumber(value)){
                return true;
            }
            else if(!_.isEmpty(value)){
                var id = value.id;

                return id && id != -1 && id != '-1';
            }

            return false;
        }

        function parentValueChanged(newValue, oldValue) {
            if (_.isObject(newValue)) {
                newValue = newValue.id;
            }
            if (_.isObject(oldValue)) {
                oldValue = oldValue.id;
            }

            return !angular.equals(newValue, oldValue);
        }

        function evalAttr(expr){
            if(expr) {
                return $scope.$eval(expr.replace(/^{{/, '').replace(/}}$/, ''));
            }
            return expr;
        }

        function formatReadonly(val){
            if(!_.isNull(val) && !_.isUndefined(val)){
                if($scope.nimFormObject.param.format){
                    try {
                        return kendo.format($scope.nimFormObject.param.format, val);
                    } catch(e){
                        $log.error('Invalid format:', { error: e });
                    }
                }

                return val;
            }
        }

        function clearImage(){
            // If editing a new image, clear the crop area and display old image (if there is one)
            if($scope.imageSource){
                $scope.imageSource = null;
                $scope.previewImage = false;

                // Puts saved image ID back into the dataSet
                $scope.dataSet[$scope.nimFormObject.config.modelId] = $scope.attachmentId;
            }
            else {
                // Clears saved image
                $scope.dataSet[$scope.nimFormObject.config.modelId] = '';
                $scope.imageUrl = '';
            }
        }

        function dropdownDataBoundHandler(e){
            var filterValue = e.sender.filterInput.val(),
                data = e.sender.dataSource.data();

            if(filterValue && data.length > 0) {
                /* LODASH Version 4 ONLY */
                //var index = _.findIndex(data, ['display', filterValue]);
                /* LODASH Version 3 & 4 Compatibility Mode */
                var index = _.findIndex(data, function(f){return f.display === filterValue;});

                if(index < 0){
                    index = 0;
                }

                e.sender.select(index + 1);
                e.sender.trigger('select');
            }
            else if(!e.sender.value() && !_.isEmpty($scope.dataSet[$scope.nimFormObject.config.modelId])){
                e.sender.value($scope.dataSet[$scope.nimFormObject.config.modelId].id);
            }
        }

        function dropdownOpenHandler(e) {
            var filter = _.get($scope.filterInput, 'value', '');

            e.sender.filterInput.val(filter);   // Makes sure filter input displays current search value
            e.sender._prev = filter;            // Makes sure dropdownlist directive tracks this change correctly
        }

        function dropdownCloseHandler(e){
            if(e.sender.value() !== $scope.dataSet[$scope.nimFormObject.config.modelId]){
                e.sender.trigger('change');
            }
        }

        function addItemCallback(id) {
            NimFormObjectService.getValue($scope.nimFormObject.option.id,$scope.nimFormObject.option.column,id).then(function(d){
                var dataItem = {
                    id: _.last(id.split('-')),
                    display: d
                };

                $scope.dataSet[$scope.nimFormObject.config.modelId] = dataItem;

                $timeout(function(){
                    $scope.oDataLookUp.add(dataItem);
                });
            });
        }
    }])
    .directive('nimFormObject', ["$compile", "$timeout", function ($compile, $timeout) {
        return {
            restrict: 'AE',
            controller: 'nimFormObjectCtrl',
            link: function (scope, element, attrs) {
                var field = scope.nimFormObject;
                var template;
                var isViewing = attrs.nimStatic || false;
                if (isViewing) {
                    var modelIdValue = null;
                    if (scope.dataSet) {
                        modelIdValue = scope.dataSet[field.config.modelId];
                    }
                    template = field.buildStatic(modelIdValue);
                }
                else {
                    template = field.build();
                }

                var addedTemp = $(template).appendTo(element.empty());
                $compile(addedTemp)(scope);
                if(scope.nimFormObject.config.type === 'select'){
                    $timeout(function(){ // Makes k-dropdown :enabled so nimFocus won't skip it
                        element.find('.k-dropdown').prop('disabled', false);
                    });
                }
                else if (scope.nimFormObject.config.type === 'textarea' && scope.nimStatic) {
                    // Resizes static textareas
                    $timeout(function(){
                        if(scope.gridsterItem && scope.gridsterItem.$element){
                            var height = element.children().height(),
                                rows = Math.ceil(height / 8);

                            scope.gridsterItem.setSizeY(rows);
                        }
                    });
                }

                // Handles adding/removing the has-error class on the form-group
                // Only runs if field is inside instanceForm (in edit mode)
                if (scope.instanceForm) {
                    scope.$watch('instanceForm[nimFormObject.config.modelId].$valid', function(valid) {
                        var formGroup = null;
                        // map form objects are not nested under form-groups
                        // apply class to nim-form-map instead
                        if (field.config.type == 'map') {
                            formGroup = element.find('div[nim-form-map]');
                        }
                        else {
                            formGroup = element.find('.form-group');
                        }

                        // element not found
                        if (formGroup.length < 1) { return; }

                        if (valid && formGroup.hasClass('has-error')) {
                            formGroup.removeClass('has-error');
                        }
                        else if (!valid && !formGroup.hasClass('has-error')){
                            formGroup.addClass('has-error');
                        }
                    });
                }
            }
        };
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name NimFormObjectService
     * @alias cerberus/core:nimFromObjectService
     * @description Provides functionality for nimFormObjects
     */
    .factory('NimFormObjectService', ["_", "moment", "kendo", "apiPath", "mapboxConfig", "$http", "$q", "$log", "$rootScope", "$sanitize", "$sce", "$timeout", "$window", "nimUtilityService", "OdataUtilityService", "RulesService", function NimFormObjectService(_, moment, kendo, apiPath, mapboxConfig, $http, $q, $log, $rootScope, $sanitize, $sce, $timeout, $window,
                                                                   nimUtilityService, OdataUtilityService, RulesService){
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            textEditorOptions: textEditorOptions,
            getValue: getValue,
            getLocationAutoComplete: getLocationAutoComplete,
            setLocationData: setLocationData,
            setEmptyLocation: setEmptyLocation,
            watchAfterDateField: watchAfterDateField,
            watchBeforeDateField: watchBeforeDateField,
            createODataLookUp: createODataLookUp,
            compileStaticText: compileStaticText,
            enforceRule: enforceRule
        };

        /**
         * Builds options for textarea form object
         * @returns {Object}
         */
        function textEditorOptions(){
            return {
                encoded: false,
                tools: [
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'justifyLeft',
                    'justifyCenter',
                    'justifyRight',
                    'justifyFull',
                    'insertUnorderedList',
                    'insertOrderedList',
                    'indent',
                    'outdent',
                    'createLink',
                    'unlink',
                    'insertImage',
                    'subscript',
                    'superscript',
                    'createTable',
                    'addRowAbove',
                    'addRowBelow',
                    'addColumnLeft',
                    'addColumnRight',
                    'deleteRow',
                    'deleteColumn',
                    'viewHtml',
                    'formatting',
                    'cleanFormatting',
                    'fontName',
                    'fontSize',
                    'foreColor',
                    'backColor'
                ],
                paste: function (e) {
                    e.html = $sanitize(e.html);
                }
            };
        }

        /**
         * getValue
         * @param viewId
         * @param col
         * @param instanceId
         * @returns {*|r.promise|Function|promise|Document.promise}
         */

        function getValue(viewId, col, instanceId) {
            var deferred = $q.defer();
            $http.get(apiPath + 'view/'+viewId+'/column/'+col+'/instance/'+instanceId)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getLocationAutoComplete(inputString) { 
            return $http.get('https://api.mapbox.com/geocoding/v5/mapbox.places/' + inputString + '.json', {
                params: {
                    access_token: mapboxConfig.token
                }
            }).then(function (response) {
                return response.data.features;
            });
        }

        function setLocationData(scope, model) {
            var location = formatAddress(model);

            scope.dataSet[scope.nimFormObject.config.modelId] = location;
            scope.validateFormObject(location, scope.isRequired);
            
            // Auto-populate fields
            if (scope.nimFormObject.param.fields) {
                _.forEach(scope.nimFormObject.param.fields, function (v, k) {
                    scope.dataSet[k] = _.get(location.properties, v.value, '');
                });
            }
        }

        /**
         * Formats mapbox data to match current model
         * @param rawData - mapbox raw response data
         * @returns {Object} - formatted location data
         */
        function formatAddress(rawData) {
            var properties = {
                administrative_area_level_1_long_name: '',
                administrative_area_level_1_short_name: '',
                administrative_area_level_2_long_name: '',
                administrative_area_level_2_short_name: '',
                country_long_name: '',
                country_short_name: '',
                formatted_address: rawData['place_name'],
                locality_long_name: '',
                locality_short_name: '',
                neighborhood_long_name: '',
                neighborhood_short_name: '',
                postal_address: '',
                postal_code_long_name: '',
                postal_code_short_name: '',
                postal_code_suffix_long_name: '',
                postal_code_suffix_short_name: '',
                route_long_name: '',
                route_short_name: '',
                street_address: '',
                street_number_long_name: '',
                street_number_short_name: ''
            };
            
            _.forEach(rawData.context, function (context) {
                var type = _.head(context.id.split('.'));

                switch (type) {
                    case 'region':
                        properties.administrative_area_level_1_long_name = context.text;

                        if(context.short_code) {
                            properties.administrative_area_level_1_short_name = _.last(context.short_code.split('-'));
                        }
                        break;
                    case 'country':
                        properties.country_long_name = context.text;

                        if(context.short_code) {
                            properties.country_short_name = context.short_code;
                        }
                        break;
                    case 'place':
                        if(context.text && properties.locality_long_name) {
                            properties.locality_long_name = properties.locality_long_name + ', ' + context.text;
                        }else {
                            properties.locality_long_name = context.text;
                        }
                        break;
                    case 'locality':
                        if(context.text && properties.locality_long_name) {
                            properties.locality_long_name = context.text + ', ' + properties.locality_long_name;
                        }else {
                            properties.locality_long_name = context.text;
                        }
                        break;
                    case 'neighborhood':
                        properties.neighborhood_long_name = context.text;
                        break;
                    case 'postcode':
                        properties.postal_code_short_name = context.text;
                        break;
                }
            });

            var type = _.head(rawData.id.split('.'));

            if (type === 'address') {
                properties.route_long_name = rawData.text || '';
                properties.street_number_long_name = rawData.address || '';
                
                if (rawData.text && rawData.address){
                    properties.street_address = rawData.address + ' ' + rawData.text;
                    properties.postal_address = rawData.address + ' ' + rawData.text + '\n';
                } else if (rawData.text) {
                    properties.postal_address = rawData.text + '\n';
                }
                
                if (properties.country_long_name === 'United States'){
                    properties.postal_address = properties.postal_address + properties.locality_long_name + ', ' + properties.administrative_area_level_1_short_name + ' ' + properties.postal_code_short_name;
                }else {
                    properties.postal_address = properties.postal_address + properties.locality_long_name + ', ' + properties.administrative_area_level_1_long_name + ' ' + properties.postal_code_short_name + '\n';
                    properties.postal_address = properties.postal_address + properties.country_long_name;
                }
                //Conversion to Uppercase style
                //properties.postal_address = properties.postal_address.toUpperCase();
            }
            else {
                properties.postal_address = properties.formatted_address;
            }

            return {
                geometry: rawData['geometry'],
                properties: properties
            };
        }
        
        // OLD STYLE - OBSOLETE AND REPLACED WITH NEW ONE
        // function formatAddress(rawData){
        //     return {
        //         geometry: {
        //             type: 'Point',
        //             coordinates: [
        //                 rawData.metadata['longitude'],
        //                 rawData.metadata['latitude']
        //             ]
        //         },
        //         properties: {
        //             administrative_area_level_1_long_name: rawData.components['state_abbreviation'],
        //             administrative_area_level_1_short_name: rawData.components['state_abbreviation'],
        //             administrative_area_level_2_long_name: rawData.metadata['county_name'],
        //             administrative_area_level_2_short_name: rawData.metadata['county_name'],
        //             country_long_name: 'United States',
        //             country_short_name: 'US',
        //             formatted_address: rawData['delivery_line_1'] + ' ' + rawData['last_line'],
        //             locality_long_name: rawData.components['city_name'],
        //             locality_short_name: rawData.components['city_name'],
        //             neighborhood_long_name: '',
        //             neighborhood_short_name: '',
        //             postal_code_long_name: rawData.components['zipcode'],
        //             postal_code_short_name: rawData.components['zipcode'],
        //             postal_code_suffix_long_name: rawData.components['plus4_code'],
        //             postal_code_suffix_short_name: rawData.components['plus4_code'],
        //             route_long_name: rawData.components['street_name'] + ' ' + rawData.components['street_suffix'],
        //             route_short_name: rawData.components['street_name'] + ' ' + rawData.components['street_suffix'],
        //             street_address: rawData['delivery_line_1'],
        //             street_number_long_name: rawData.components['primary_number'],
        //             street_number_short_name: rawData.components['primary_number']
        //         }
        //     };
        // }

        /**
         * Sets location form object value to empty object when user types and changes the
         * value of the autocomplete. Not called when location is selected from type-ahead
         * @param scope
         * @returns {Function} - ngChange handler
         */
        function setEmptyLocation(scope){
            return function(){
                scope.dataSet[scope.nimFormObject.config.modelId] = {};

                if(scope.nimFormObject.param.fields){
                    _.forEach(scope.nimFormObject.param.fields,function(v, k){
                        scope.dataSet[k] = '';
                    });
                }
            };
        }

        /**
         * Sets watcher for date form object's selected 'after' field
         * @param scope
         * @param after - form object 'after' configuration
         * @param dateField - name of kendo date-picker scope variable
         */
        function watchAfterDateField(scope, after, dateField){
            scope.$watch(function(){
                return scope.dataSet[after.modelId];
            }, function(min){
                $timeout(function(){
                    var nimDateFormObject = scope[dateField];
                    if(nimDateFormObject) {
                        var current = scope.dataSet[scope.nimFormObject.config.modelId];
                        nimDateFormObject.min(min);
                        if (!current || moment(current).isBefore(min)) {
                            scope.dataSet[scope.nimFormObject.config.modelId] = min;
                            nimDateFormObject.value(min);
                            nimDateFormObject.trigger('change');
                        }
                        else {
                            nimDateFormObject.value(current);
                        }
                    }
                });
            });
        }

        /**
         * Sets watcher for date form object's selected 'before' field
         * @param scope
         * @param before - form object 'before' configuration
         * @param dateField - name of kendo date-picker scope variable
         */
        function watchBeforeDateField(scope, before, dateField){
            scope.$watch(function(){
                return scope.dataSet[before.modelId];
            }, function(max){
                $timeout(function(){
                    var nimDateFormObject = scope[dateField];
                    if(nimDateFormObject) {
                        var current = scope.dataSet[scope.nimFormObject.config.modelId];
                        nimDateFormObject.max(max);
                        if (!current || moment(current).isAfter(max)) {
                            scope.dataSet[scope.nimFormObject.config.modelId] = max;
                            nimDateFormObject.value(max);
                            nimDateFormObject.trigger('change');
                        }
                        else {
                            nimDateFormObject.value(current);
                        }
                    }
                });
            });
        }

        function createODataLookUp(scope){
            var option = scope.nimFormObject.option,
                param = scope.nimFormObject.param,
                lookupDisplay = option.column;

            var sort = {
                field: option.orderCol || 'display',
                dir: option.orderBy || 'asc'
            };

            if(param.sortBy){
                sort = param.sortBy;
            }
            else if(option.orderBy === 'oldest'){
                sort = {
                    field: 'id',
                    dir: 'asc'
                };
            }
            else if(option.orderBy === 'newest'){
                sort = {
                    field: 'id',
                    dir: 'desc'
                };
            }

            if(option.columnType === 'location'){
                lookupDisplay += '_formatted_address';
            }

            var url = '/server/rest/v1/' + option.type + '/' + option.id + '/odata.svc';
            if(option.type === 'views'){
                url = url + '?$lookupDisplay=' + lookupDisplay;
            }

            return new kendo.data.DataSource({
                type:'odata',
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                pageSize: option.returnNum || 20,
                requestEnd: function(e) {
                    var currentValue = _.get(scope, 'dataSet.' + scope.nimFormObject.config.modelId);
                    var data = oDataToArray(e.response);

                    if (scope.nimFormObject.config.type == 'multiselect') {
                        transformMultiSelectValues(scope, data);
                    }

                    if(_.has(currentValue, 'display') && option.type === 'views'){
                        var exists = !!(_.find(data, 'id', currentValue.id));

                        if (!exists) {
                            data.push(currentValue);
                        }
                    }

                    if(data.length === 0){
                        data.push({ display: '(No Results)', id: -1 });
                    }
                    e.response = arrayToOData(data);
                },
                change: function (e) {
                    // If only one item comes down, __count is left in when the data is added to the data source
                    if(e.sender.total() == 1){
                        var dataItem = e.sender.data()[0];

                        // Removes __count
                        if(_.has(dataItem, '__count')){
                            delete dataItem.__count;
                        }

                        // Sometimes, if only one item comes down, datasource strips out all
                        // properties preceded by "__" (like __instanceId or __widgetId).
                        if (scope.nimFormObject.config.type == 'multiselect' && !dataItem.__instanceId && !dataItem.__widgetId) {
                            transformMultiSelectValues(scope, e.sender.data());
                        }    
                    }
                },
                transport: {
                    read: function (options) {

                        // Check if required parent filters are set
                        var cascadeFilters = _.get(param, 'cascadeFilter.filters');
                        if (!_.isEmpty(cascadeFilters)){
                            var requiredParentFiltersSet = _.every(cascadeFilters, function(filter){
                                if (filter.required) {
                                    var filterValue = scope.filters[filter.value];
                                    return !!_.get(filterValue, 'id');
                                }
                                return true;
                            });

                            // If required filters are not set, return no results                            
                            if (!requiredParentFiltersSet){
                                options.success({
                                    d: {
                                        id: -1,
                                        display: '(No Results)',
                                        __count: 1
                                    }
                                });
                                // Return without allowing the oData call                                
                                return;
                            }
                        }
                        
                        var urlParams = {};

                        // Set $filter parameter
                        var filter = oDataLookUpFilter(scope, param);

                        if (filter) {
                            urlParams.$filter = OdataUtilityService.toOdataFilter(filter);
                        }

                        // Set $top parameter                        
                        if (options.data.pageSize) {
                            urlParams.$top = options.data.pageSize;
                        }

                        // Set $orderBy parameter                        
                        if (!_.isEmpty(sort)) {
                            var sortStrings = [];
                            _.forEach(sort, function (sortItem) {
                                if (sortItem.field) {
                                    var dir = sortItem.dir || 'asc';
                                    sortStrings.push(sortItem.field + ' ' + dir);
                                }
                            });
                            if (sortStrings.length) {
                                urlParams.$orderBy = sortStrings.join(',');
                            }    
                        }

                        $http.get(url, {
                                headers: {
                                    Authentication: 'Bearer ' + $rootScope.authToken,
                                    WSID: $rootScope.userData.currentWorkspace.id
                                },
                                params: urlParams
                            })
                            .then(function (result) {
                                options.success(result.data);
                            },function (reason) {
                                options.error(reason);
                            });
                    }
                },
                sort: sort
            });
        }

        function oDataToArray(oDataResult) {
            var data = [];

            if (_.has(oDataResult, 'd')) {
                if (_.isArray(oDataResult.d.results)) {
                    data = oDataResult.d.results;
                }
                else {
                    data.push(_.omit(oDataResult.d, '__count'));
                }
            }

            return data;
        }

        function arrayToOData(arr) {
            var odata = {
                d: {
                    __count: arr.length
                }
            };

            if (arr.length == 1) {
                _.assign(odata.d, arr[0]);
            }
            else {
                odata.d.results = arr;
            }

            return odata;
        }

        function transformMultiSelectValues(scope, data) {
            var param = scope.nimFormObject.param;
            var dataSet = scope.dataSet[scope.nimFormObject.config.modelId];
            _.forEach(data, function (dataItem) {
                if (dataItem.id != -1) {
                    var matchingRecorditem = _.find(dataSet, function (item) {
                        return _.get(item, ['__nimData', param.lookup, 'id']) == dataItem.id;
                    });
                    if (matchingRecorditem) {
                        _.set(matchingRecorditem, ['__nimData', param.lookup, 'display'], dataItem.display);
                        _.set(matchingRecorditem, [param.lookup, 'display'], dataItem.display);
                        matchingRecorditem.id = dataItem.id;
                        matchingRecorditem.display = dataItem.display;

                        _.assign(dataItem, matchingRecorditem);
                    }
                    else {
                        var nimData = {};

                        dataItem.__widgetId = param.widgetId;
                        dataItem.__optionId = param.optionId;
                        dataItem.__column = param.column;
                        dataItem.__modelId = param.fk;

                        nimData[param.lookup] = {
                            id: dataItem.id,
                            display: dataItem.display
                        };
                    
                        if (scope.nimInstanceAction === 'read') {
                            var displayField = '',
                                display = 'Auto';
                            
                            if (param.column) {
                                displayField = param.column.split('_')[1];
                                display = _.get(scope.dataSet, displayField, 'Auto');
                            }

                            nimData[param.fk] = {
                                id: parseInt(scope.$eval('vm.instanceId')),
                                display: display
                            };
                        }
                        else {
                            nimData[param.fk] = {
                                display: 'Auto'
                            };
                        }
                        dataItem.__nimData = nimData;
                    }
                }    
            });

            _.forEach(dataSet, function (item) {
                if (item) {
                    if (!item.id) {
                        item.id = _.get(item, ['__nimData', param.lookup, 'id']);
                        item.display = _.get(item, ['__nimData', param.lookup, 'display']);
                    }

                    if (!_.find(data, 'id', item.id)) {
                        data.push(item);
                    }
                }    
            });
        }

        function oDataLookUpFilter(scope, param){
            var filters = [];

            var defaultFilter = param.defaultFilter;

            if(defaultFilter && defaultFilter.filters.length){
                if(defaultFilter.filters.length === 1){
                    filters.push(defaultFilter.filters[0]);
                }
                else {
                    filters.push(defaultFilter);
                }
            }

            // Cascade filter
            if(param.cascadeFilter && !_.isEmpty(param.cascadeFilter.filters)){
                var cascadeFilters = [];

                _.forEach(param.cascadeFilter.filters, function(parentFilter){
                    var from = parentFilter.value;
                    var fromField = parentFilter.field;

                    if(from && fromField){
                        var filterValue = scope.filters[from];
                        if(filterValue){
                            if(filterValue.id && filterValue.id != "-1" && filterValue.id != -1) {
                                cascadeFilters.push({
                                    field: fromField.replace('_display', ''),
                                    operator: 'eq',
                                    value: filterValue.id
                                });
                            }
                            else if(typeof filterValue === 'string' || typeof filterValue === 'number'){
                                cascadeFilters.push({
                                    field: fromField,
                                    operator: parentFilter.operator,
                                    value: filterValue
                                });
                            }
                        }
                    }
                });

                if(cascadeFilters.length) {
                    filters.push({
                        logic: param.cascadeFilter.logic,
                        filters: cascadeFilters
                    });
                }
                else if(cascadeFilters.length === 1){
                    filters.push(cascadeFilters[0]);
                }
            }

            // Search input filter
            if(scope.filterInput){
                filters.push({
                    field: scope.filterInput.field,
                    operator: scope.filterInput.operator,
                    value: scope.filterInput.value
                });
            }


            /*if(filters.length === 1){
                return filters[0];
            }
            else */if(filters.length > 0) {
                return {
                    logic: 'and',
                    filters: filters
                };
            }

            return null;
        }

        function compileStaticText(scope/*, element*/){
            if (scope.nimFormObject.param.template) {
                var stateOnly = true;
                var dataSetString = 'dataSet';

                if(scope.$eval('vm.instanceId')){
                    stateOnly = false;
                    dataSetString = 'vm.temp';
                }

                // var origSizeY = 0;

                // if (scope.gridsterItem) {
                //     origSizeY = scope.gridsterItem.sizeY;
                // }

                var watchedData = [{}, {}];

                scope.$watch(function () {
                    watchedData[0] = scope.$eval(dataSetString);
                    watchedData[1] = scope.$eval('autoFillData');

                    return watchedData;
                }, function (newData) {
                    // $timeout(function() {
                    var dataSet = newData[0],
                        autoFillData = newData[1];

                    var flatDataSet = {},
                        userData = {
                            firstName: $rootScope.userData.firstName,
                            lastName: $rootScope.userData.lastName,
                            fullName: $rootScope.userData.firstName + $rootScope.userData.lastName
                        },
                        printData = {
                            pageCurrent: scope.pageCurrent || '#',
                            pageTotal: scope.pageTotal || '#'
                        };

                    if (!stateOnly) {
                        _.forEach(dataSet, function (state) {
                            _.assign(flatDataSet, state);
                        });
                    }
                    else {
                        flatDataSet = dataSet;
                    }

                    flatDataSet = angular.copy(flatDataSet);

                    // 
                    _.forEach(autoFillData, function (dataItem, modelId) {
                        flatDataSet[modelId] = flatDataSet[modelId] || {};

                        _.forEach(dataItem, function (value, key) { 
                            flatDataSet[modelId][key] = value;
                        });
                    });

                    var templateData = {
                        data: defaultPropsToBlank(flatDataSet),
                        user: userData,
                        print: printData,
                        nim: nimUtilityService,
                        instance: {
                            action: scope.nimInstanceAction
                        }
                    };

                    try {
                        var template = kendo.template(scope.nimFormObject.param.template.replace(/&lt;/g, '<').replace(/&gt;/g, '>'));
                        var compiledHtml = template(templateData);

                        scope.compiledStaticText = $sce.trustAsHtml(compiledHtml);
                    }
                    catch (e) {
                        $log.error('Error building HTML:', e, scope.nimFormObject.param.template, templateData);
                        scope.compiledStaticText = $sce.trustAsHtml(scope.nimFormObject.param.text);
                    }
                    // });

                    // $timeout(function () {
                    //     // Resize template gridster item
                    //     if (scope.gridsterItem && scope.gridsterItem.gridster) {
                    //         var height = 0;
                    //         element.find('.nim-static-text').children().each(function (i, element) {
                    //             height += angular.element(element).outerHeight(true);
                    //         });

                    //         var rows = Math.max(Math.ceil(height / 8), origSizeY);
                    //         scope.gridsterItem.setSizeY(rows);
                    //     }
                    // }, 1);
                }, true);
            }
            else {
                $timeout(function(){
                    scope.compiledStaticText = $sce.trustAsHtml(scope.nimFormObject.param.text);
                });
            }
        }

        /**
         * Sets null values in dataSet to empty string
         * @param dataSet - Flattened instance dataSet
         * @returns {Object}
         */
        function defaultPropsToBlank(dataSet){
            var newDataSet = {};

            _.forEach(dataSet, function(value, field){
                if(value == null){
                    newDataSet[field] = '';
                }
                else {
                    newDataSet[field] = value;
                }
            });

            return newDataSet;
        }

        /**
         * Creates watcher that enforces a rule when the required parameters have been set
         * @param scope
         * @param ruleConfig - Form Object's rule configuration
         * @param ruleConfig.ruleId - ID of rule being enforced
         * @param ruleConfig.parameterMap - Maps form fields to rule parameters
         * @param ruleConfig.returnMap - Maps form fields to rule return data values
         * @param dataSet
         * @param ruleModelId
         */
        function enforceRule(scope, ruleConfig, dataSet, ruleModelId){
            if(ruleConfig.ruleId){
                // Make sure a form field's modelId has been mapped to each required field
                var requiredFieldsMapped = true,
                    paramIds = _.keys(ruleConfig.parameterMap),
                    params = [];

                _.forEach(paramIds, function(name){
                    var p = ruleConfig.parameterMap[name];
                    if(p.modelId){
                        params.push('dataSet.' + p.modelId);
                    }
                    else if(!p.req){
                        params.push(_.constant(null));
                    }
                    else {
                        requiredFieldsMapped = false;
                        return false;
                    }
                });

                if(requiredFieldsMapped){
                    // Watches all parameters
                    scope.$watchGroup(params, function(newParams, oldParams){
                        if(!angular.equals(newParams, oldParams)){
                            // Make sure each required parameter has been set
                            var requiredFieldsSet = true,
                                paramStruct = {};
                            _.forEach(paramIds, function(name, index){
                                var p = ruleConfig.parameterMap[name],
                                    val = newParams[index];

                                if(_.isObject(val) && !_.isDate(val)){
                                    if(_.isEmpty(val)){
                                        val = null;
                                    }
                                    else {
                                        val = _.get(val, 'display');
                                    }
                                }

                                // Zero counts as a valid value
                                if(p.req && !val && val !== 0 && val !== false){
                                    requiredFieldsSet = false;
                                    return false; // Breaks from forEach function
                                }
                                else {
                                    paramStruct[name] = val;
                                }
                            });

                            if(requiredFieldsSet){
                                RulesService.getResult(ruleConfig.ruleId, paramStruct).then(function (result) {
                                    dataSet[ruleModelId] = result || {};
                                }, function () {
                                    dataSet[ruleModelId] = {};
                                });
                            }
                            else {
                                dataSet[ruleModelId] = {};
                            }
                        }
                    });
                }
            }
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name FormTabIndexService
     * @alias cerberus/core:FormTabIndexService
     * @description Provides functionality for manually handling tabbing between form fields
     */
    .factory('FormTabIndexService', ["kendo", function FormTabIndexService(kendo) {
        var service = {
            getFocusElement: getFocusElement
        };
        return service;
        ////////////////////

        function getFocusElement(e, windowContent){
            if (e.keyCode == kendo.keys.TAB) {
                e.preventDefault();
                e.stopPropagation();

                var tabEles = windowContent.find('[tabindex]');

                for(var i = 0; i < tabEles.length; i++){
                    if($(tabEles[i]).is(':focus')){
                        $(tabEles[i+1]).focus();
                    }
                }
            }
        }
    }])
;

angular.module('cerberus.core')
    .directive('nimFormTable', function() {
        return {
            restrict: 'AE',
            templateUrl: 'core/forms/nim-form-table.tpl.html',
            controller: ["_", "kendo", "$scope", "$attrs", "$element", "$compile", "$timeout", "DesignerUtilityService", "FormsService", "InstancesWindowService", "printService", function(_, kendo, $scope, $attrs, $element, $compile, $timeout, DesignerUtilityService, FormsService, /*InstancesService,*/ InstancesWindowService, printService) {
                $scope.openSubForm = openSubForm;
                $scope.selectRow = selectRow;
                $scope.rowSelected = rowSelected;
                $scope.selectAllRows = selectAllRows;
                $scope.printLabels = printLabels;
                $scope.printChecks = printChecks;
                $scope.openAdvSelPage = _.partial(InstancesWindowService.openAdvSelPage, $scope, advancedSelectCallback);
                $scope.deleteSelectedRecords = deleteSelectedRecords;

                init();

                $scope.$on('nim-form-table-auto-fill-' + $scope.nimFormObject.config.modelId , function (event, args) {
                    autoFillTable(args.data);
                });

                //Clean up - avoid memory leaks
                $scope.$on('$destroy', function () {
                    $element.off('keyup');
                });

                $scope.$on('nim-remove-form-objects', function () {
                    if ($scope.grid) {
                        $scope.grid.destroy();
                        $scope.grid = null;
                    }

                    if ($scope.pager){
                        $scope.pager.destroy();
                        $scope.pager = null;
                    }
                });

                $scope.$on('nim-sub-form-closed', function (event, args) {
                    if(args.modelId === $scope.nimFormObject.config.modelId) {
                        event.preventDefault();

                        var data = $scope.dataSource.data();

                        if ($scope.isTreeList) {
                            setTreeFields(data, null);
                        }    

                        // This event may fire for the grid on the subform, which is now closed
                        if ($scope.grid && $scope.grid.content) {
                            try {
                                $scope.dataSource.data(data);
                                //$scope.grid.refresh();
                            } catch (e) {
                            }
                        }
                    }
                });

                function init() {
                    $scope.isStatic = $attrs.nimformtablestatic != null && $attrs.nimformtablestatic != 'false';
                    $scope.isTreeList = $scope.nimFormObject.param.isTreeList;
                    $scope.selectedIds = [];
                    $scope.allRowsSelected = false;
                    $scope.editSubData = null;
                    $scope.schemaFields = {};
                    $scope.columns = [];
                    
                    //Get Set Defaults
                    var pageSize = $scope.nimFormObject.tag.attrs.pageSize,
                        pageable = !$scope.isStatic && pageSize;

                    buildColumnsAndSchema(angular.copy($scope.nimFormObject.tag.inner));

                    // For removing HTML tags from strings
                    //function stripHTML(string){
                    //    if(string) {
                    //        // Wraps in div to ensure the string is not treated as a selector
                    //        return angular.element('<div>' + string + '</div>').text();
                    //    }
                    //    return string;
                    //}

                    //If transcluded scope.dataset
                    if ($scope.dataSet) {
                        var d = $scope.dataSet[$scope.nimFormObject.config.modelId];
                        
                        _.forEach(d, function (dataItem) {
                            FormsService.fixDataseriesCols(dataItem, $scope.schemaFields);
                        });

                        //Create DataSource
                        var dsOptions = {
                            data: d,
                            serverFiltering: false,
                            filter: {
                                field: '__nimDelete',
                                operator: 'neq',
                                value: true
                            },
                            pageSize: pageable ? pageSize : null,
                            schema: {
                                model: {
                                    fields: $scope.schemaFields
                                }
                            },
                            aggregate: getAggregate($scope.columns),
                            change: function (e) {
                                $timeout(function () {
                                    var aggregateConfig = e.sender.aggregate();
                                    
                                    if (!_.isEmpty(aggregateConfig)) {
                                        var dataSet = $scope.dataSet,
                                            aggregateValues = e.sender.aggregates();
                                        
                                        _.forEach(aggregateConfig, function (aggregate) {
                                            if (aggregate.modelId && aggregateValues[aggregate.field]) {
                                                dataSet[aggregate.modelId] = _.get(aggregateValues, [aggregate.field, aggregate.aggregate]);
                                            }
                                        });
                                    }
                                });
                            }
                        };

                        if ($scope.isTreeList) {
                            dsOptions = angular.extend(dsOptions, {
                                schema: {
                                    model: {
                                        id: 'id',
                                        fields: {
                                            id: {
                                                type: 'number',
                                                from: '__instanceId'
                                            },
                                            parentId: {
                                                nullable: true,
                                                type: 'number'
                                            },
                                            expanded: {
                                                defaultValue: false,
                                                type: 'boolean'
                                            },
                                            hasChildren: {
                                                defaultValue: false,
                                                type: 'boolean'
                                            }
                                        }
                                    }
                                }
                            });

                            if (d) {
                                setTreeFields(d, null, true);
                            }

                            $scope.dataSource = new kendo.data.TreeListDataSource(dsOptions);

                            $scope.dataSource.data(d);
                            $scope.columns[0].width = 78;
                        }
                        else {
                            $scope.dataSource = new kendo.data.DataSource(dsOptions);
                        }
                    }

                    /**
                     * Kendo Grid Settings
                     */
                    $scope.options = {
                        columnMenu: false,
                        columns: $scope.columns,
                        dataSource: $scope.dataSource,
                        editable: false,
                        filterable: false,
                        mobile: false,
                        navigatable: true,
                        pageable: pageable,
                        reorderable: false,
                        resizable: false,
                        scrollable: false,
                        selectable: true,
                        sortable: false,
                        toolbar: false,
                        dataBound: function () {
                            $timeout(function () {
                                if ($scope.gridsterItem && $scope.gridsterItem.$element) {
                                    var formObjectElement = $element.closest('.form-group');
                                    var oldRows = $scope.gridsterItem.getSizeY();
                                    var rows = Math.ceil(formObjectElement.height() / 8);
                                
                                    if (rows != oldRows) {
                                        if ($scope.itemOpts) {
                                            $scope.itemOpts.sizeY = rows;
                                        }
                                        else {
                                            $scope.gridsterItem.setSizeY(rows);
                                        }
                                    }
                                }

                                checkRowSelection();
                            }, 100);
                        },
                        save: function (e) {
                            var modelId = $scope.nimFormObject.config.modelId;
                            $scope.dataSet[modelId] = $scope.dataSet[modelId] || [];
                            var item = e.sender.dataSource.getByUid(e.model.uid);
                            var index = e.sender.dataSource.indexOf(item);
                            $scope.dataSet[modelId].pop();
                            if (index >= 0 && $scope.dataSet[modelId][index]) {
                                for (var v in e.values) {
                                    $scope.dataSet[modelId][index][v] = e.values[v];
                                }
                            }
                            else {
                                var newRow = {};
                                for (var val in e.values) {
                                    newRow[val] = e.values[val];
                                }
                                $scope.dataSet[modelId].push(newRow);
                            }
                            $scope.grid.refresh();

                            $timeout(function () {
                                $scope.dataSet[$scope.nimFormObject.config.modelId].push($scope.grid.dataSource.aggregates());
                            });
                        },
                        //expand: function(e){
                        //    if(!e.model.__loadedChildRows) {
                        //        e.preventDefault();
                        //
                        //        var formInfo = {
                        //            formId: $scope.isStatic ? $scope.dataSet.__formId : $scope.dataSet[$scope.formOriginId].__formId,
                        //            isPk: true,
                        //            displayOrder: '1'
                        //        };
                        //
                        //        if(e.model.id < 10000000){
                        //            InstancesService.getFormData(e.model.id, [formInfo]).then(function (formData) {
                        //                addFormData(e.model, formData[0].defaultDataSet[$scope.nimFormObject.config.modelId]);
                        //            });
                        //        }
                        //        else {
                        //            addFormData(e.model, angular.copy(e.model.__nimData[$scope.formOriginId][$scope.nimFormObject.config.modelId]));
                        //        }
                        //    }
                        //},
                        change: function (e) {
                            // Edit record on selecting a row only if editing is not disabled
                            if ($scope.nimFormObject.param.disabled || !$scope.nimFormObject.param.disableEdit) {
                                var selected = e.sender.select();
                                if (selected.length > 0) {
                                    var cell = selected.find('#aria_active_cell');
                                    if (!cell.data('selection-disabled')) { // Checks if subform should open when clicking this cell
                                        var data = e.sender.dataItem(selected[0]),
                                            id = data.__instanceId;

                                        if ($scope.isStatic || $scope.nimFormObject.param.disabled) {
                                            InstancesWindowService.openWindow({
                                                action: 'readonly',
                                                instanceId: id
                                            });
                                        }
                                        else {
                                            $scope.editSubData = e.sender.dataSource.getByUid(data.uid);
                                            openSubForm('read', id);
                                        }
                                    }
                                }
                            }
                        }
                    };

                    $scope.pagerOptions = {
                        dataSource: $scope.dataSource
                    };
                }

                function deleteRecord(e){
                    e.preventDefault();
                    var data = getRowData(e);

                    $timeout(function () {
                        if (data.__instanceId) {
                            var nimDataRecord = _.find($scope.dataSet[$scope.nimFormObject.config.modelId], '__instanceId', data.__instanceId);
                            nimDataRecord.__nimDelete = true;
                            $scope.grid.dataSource.data($scope.dataSet[$scope.nimFormObject.config.modelId]);
                        }
                        else {
                            var dataItem = $scope.grid.dataSource.getByUid(data.uid);
                            if (dataItem) {
                                $scope.grid.dataSource.remove(dataItem);
                            }
                            $scope.dataSet[$scope.nimFormObject.config.modelId] = $scope.grid.dataSource.data().toJSON();
                        }

                        var index = $scope.selectedIds.indexOf(data.__rowId);
                        if (index >= 0) {
                            _.pullAt($scope.selectedIds, index);
                        }
                    });
                }

                function deleteSelectedRecords() {
                    if ($scope.selectedIds.length > 0) {
                        var data = $scope.dataSet[$scope.nimFormObject.config.modelId];
                        
                        _.forEach($scope.selectedIds, function (id) {
                            /* LODASH Version 4 ONLY */
                            //var index = _.findIndex(data, ['__rowId', id]);
                            /* LODASH Version 3 & 4 Compatibility Mode */
                            var index = _.findIndex(data, function(f){return f.__rowId === id;});
                            if (index >= 0) {
                                var dataItem = data[index];

                                if (dataItem.__instanceId) {
                                    dataItem.__nimDelete = true;
                                }
                                else {
                                    _.pullAt(data, index);
                                }
                            }
                        });

                        $scope.selectedIds = [];
                        $scope.dataSource.data(data);
                    }
                }

                function duplicateRecord(e){
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    var data = getRowData(e);

                    var newData = angular.copy(data.toJSON());
                    delete newData.__instanceId;

                    newData.__optionId = $scope.nimFormObject.param.optionId;
                    newData.__column = $scope.nimFormObject.param.column;
                    newData.__modelId = $scope.nimFormObject.param.fk;
                    newData.__widgetId = $scope.nimFormObject.param.widgetId;

                    $scope.grid.dataSource.add(newData);
                    $scope.dataSet[$scope.nimFormObject.config.modelId] = $scope.grid.dataSource.data().toJSON();
                }

                //function editRecord(e){
                //    e.preventDefault();
                //    var data = getRowData(e);
                //    $scope.editSubData = $scope.grid.dataSource.getByUid(data.uid);
                //    openSubForm('read', data.id || data.__instanceId);
                //}

                function getRowData(e){
                    var row = $(e.target).closest("tr");
                    return $scope.grid.dataItem(row);
                }

                function setTreeFields(data, id, isTop){
                    if($scope.isTreeList){
                        var widgetId = $scope.$eval('vm.widgetId');
                        if($scope.nimFormObject.param.widgetId == widgetId) { // For recursive table
                            for (var i = 0; i < data.length; i++) {
                                var item = data[i],
                                    tableData = item.__nimData[$scope.nimFormObject.config.modelId];

                                if (isTop) {
                                    item.parentId = null;
                                }
                                else if (!item.parentId) {
                                    item.parentId = id;
                                }
                                item.hasChildren = !!(tableData && tableData.length > 0);
                                item.expanded = !!(item.expanded && item.hasChildren);
                                if (!item.hasOwnProperty('id')) {
                                    if (id) {
                                        item.id = id * 10 + (i + 1);
                                    }
                                    else {
                                        item.id = (i + 1);
                                    }
                                    if (item.id < 10000000) {
                                        item.id += 10000000;
                                    }
                                }
                            }
                        }
                        else {
                            // For lookup
                            var param = $scope.nimFormObject.param;
                            for(var j = 0; j < data.length; j++){
                                var dataItem = data[j];

                                if(!isTop && dataItem.__nimData[param.lookup]){
                                    dataItem.parentId = dataItem.__nimData[param.lookup].id;
                                }
                                else {
                                    dataItem.parentId = null;
                                }
                                dataItem.__loadedChildRows = true;
                            }
                        }
                    }
                }

                //function addFormData(parentRow, formData){
                //    if(!parentRow.__loadedChildRows){
                //        parentRow.__loadedChildRows = true;
                //        parentRow.expanded = !parentRow.expanded;
                //
                //        setTreeFields(formData, parentRow.id);
                //        var data = $scope.dataSource.data().toJSON();
                //        $scope.dataSource.data(data.concat(formData));
                //    }
                //}

                function advancedSelectCallback(data) {
                    if (data) {
                        // autoFillTable(data);
                        _.forEach(data, function (dataItem) {
                            dataItem.__optionId = $scope.nimFormObject.param.optionId;
                            dataItem.__column = $scope.nimFormObject.param.column;
                            dataItem.__modelId = $scope.nimFormObject.param.fk;
                            dataItem.__widgetId = $scope.nimFormObject.param.widgetId;
                            if (dataItem.__nimData) {
                                FormsService.fixDataseriesCols(dataItem, $scope.schemaFields);
                            }
                            else {
                                createNimData(dataItem, $scope.schemaFields);
                            }

                            var reject = false,
                                gridData = $scope.grid.dataSource.data();

                            _.forEach($scope.columns, function (c) {
                                if (c.unique) {
                                    var value = dataItem[c.field],
                                        modelId = c.field;
                                    
                                    if (c.isLookUp || c.isCustomLookup) {
                                        var idField = c.field.replace(/_display$/, '_id');
                                        value = dataItem[idField];
                                        modelId = c.field.replace(/^__/, '').replace(/_display$/, '.id');
                                    }
                                    
                                    if (_.find(gridData, '__nimData.' + modelId, value)) {
                                        reject = true;
                                        return false;
                                    }
                                }
                            });

                            if (!reject) {
                                $scope.grid.dataSource.add(dataItem);
                            }
                        });

                        $scope.dataSet[$scope.nimFormObject.config.modelId] = $scope.grid.dataSource.data().toJSON();
                    }
                }

                function getAggregate(columns, aggregate){
                    aggregate = aggregate || [];

                    var params = $scope.nimFormObject.param;

                    _.forEach(columns, function (column) {
                        var field = column.field;

                        if(_.has(params, 'aggregates', field)) {
                            if (!params.hideAggregates && !_.isEmpty(params.aggregates[field])) {
                                column.footerTemplate = _.partial(aggregateTemplate, column, params.aggregates);
                            }
                            
                            _.forEach(params.aggregates[field], function (aggrObj, a) {
                                aggregate.push({
                                    field: field,
                                    modelId: aggrObj.field,
                                    aggregate: a
                                });
                            });
                        }

                        if(column.columns){
                            getAggregate(column.columns, aggregate);
                        }
                    });
                    
                    return aggregate;
                }

                function aggregateTemplate(column, aggregates, data) {
                    var displayValues = [],
                        field = column.field;

                    _.forEach(aggregates[field], function (aggregateObj, aggregateFunc) {
                        var value = _.get(data, [field, aggregateFunc]) || 0;

                        if (_.isNaN(value)) {
                            value = 0;
                        }
                        if (column.format) {
                            value = kendo.format(column.format, value);
                        }
                        if (aggregateObj.title) {
                            value = aggregateObj.title + ': ' + value;
                        }

                        displayValues.push(value);
                    });

                    return displayValues.join('<br/>');
                }

                function buildColumnsAndSchema(configColumns) {
                    var checkboxHeaderTemplate = '',
                        checkboxTemplate = '',
                        indexColumnWidth = 0,
                        isStatic = $scope.isStatic || $scope.nimFormObject.param.disabled,
                        printingEnabled = $scope.nimFormObject.param.printLabels || $scope.nimFormObject.param.printChecks,
                        rowNumbersEnabled = !$scope.nimFormObject.param.disableRowNumbers;

                    if (isStatic && printingEnabled) {
                        checkboxHeaderTemplate = '<input type="checkbox" ng-checked="allRowsSelected" ng-click="selectAllRows(!allRowsSelected)" style="width:13px;height:13px" />';
                        checkboxTemplate = '<input type="checkbox" ng-checked="rowSelected(#: __instanceId #)" ng-model="selected" ng-click="selectRow(#: __instanceId #)" style="width:13px;height:13px" />';
                        indexColumnWidth += 30;
                    }
                    else if (!isStatic && $scope.nimFormObject.param.batchDelete) {
                        checkboxHeaderTemplate = '<input type="checkbox" ng-checked="allRowsSelected" ng-click="selectAllRows(!allRowsSelected)" style="width:13px;height:13px" />';
                        checkboxTemplate = '<input type="checkbox" ng-checked="rowSelected(\'#: __rowId #\')" ng-model="selected" ng-click="selectRow(\'#: __rowId #\')" style="width:13px;height:13px" />';
                        indexColumnWidth += 30;
                    }

                    if (rowNumbersEnabled) {
                        indexColumnWidth += 30;
                    }

                    if (rowNumbersEnabled || checkboxTemplate) {
                        $scope.columns.push({
                            title: '',
                            headerTemplate: checkboxHeaderTemplate,
                            template: function (dataItem) {
                                var tempItems = [];
                                if (checkboxTemplate) {
                                    var checkbox = kendo.template(checkboxTemplate)(dataItem);
                                    tempItems.push(checkbox);
                                }

                                if (rowNumbersEnabled) {
                                    var index = recordIndex(dataItem);
                                    tempItems.push(index);
                                }

                                return tempItems.join(' ');
                            },
                            width: indexColumnWidth
                        });
                    }    

                    _.forEach(configColumns, function (col) {
                        col.encoded = false;
                        if (col.format) {
                            var format = col.format.replace('{0:', '').replace('}', '');
                            col.template = dataTemplate(col.field, format);
                        }
                        else if (col.type === 'location') {
                            col.template = '{{dataItem.' + col.field + '.properties.formatted_address}}';
                        }
                        else if (col.type === 'dataseries') {
                            col.template = _.partial(dataSeriesColTemplate, col);
                        }

                        if (col.type) {
                            $scope.schemaFields[col.field] = col;
                        }

                        $scope.columns.push(col);
                    });

                    if (!$scope.isStatic) {
                        var commandButtons = [];

                        //Add Duplicate Button to Grid
                        if (!$scope.nimFormObject.param.disabled && !_.get($scope.nimFormObject.param, 'disableDuplicate', true)) {
                            commandButtons.push({
                                name: 'duplicateRecord',
                                text: '<i class="fa fa-files-o"></i>',
                                className: 'btn btn-sm btn-default',
                                click: duplicateRecord
                            });
                        }

                        //Add Delete Button to Grid
                        if (!$scope.nimFormObject.param.disabled && !$scope.nimFormObject.param.disableDelete) {
                            commandButtons.push({
                                name: 'deleteRecord',
                                text: '<i class="fa fa-trash"></i>',
                                className: 'btn btn-sm btn-danger',
                                click: deleteRecord
                            });
                        }

                        if (commandButtons.length > 0) {
                            $scope.columns.push({
                                attributes: { 'data-selection-disabled': true }, // Makes this cell not open subform
                                command: commandButtons,
                                title: ' ',
                                width: (57 * commandButtons.length) + 'px'
                            });
                        }
                    }
                }

                function openSubForm(action, id){
                    var readingNewRecord = false;
                    action = action || 'create';
                    id = id || '';
                    // if(id > 9999999){ // Don't accept temporary ids
                    //     id = '';
                    // }
                    if(!id){ // For reading newly created subform data
                        if(action === 'read'){
                            // Record was added to table and should be edited, not created,
                            // but record has not been saved as an instance, yet.
                            readingNewRecord = true;
                        }
                        action = 'create';
                    }
                    var windowId = 'sub_form_' + DesignerUtilityService.generateGuid();
                    var html = '<div kendo-window="' + windowId + '" k-options="subWindowOptions">' +
                        '<div nim-instance class="nim-instance container-fluid" nim-action="' + action + '" nim-id="' + id + '" nim-widget-id="' + $scope.nimFormObject.param.widgetId + '" nim-window-id="' + windowId + '" nim-reading-new="' + readingNewRecord + '" nim-validate-on-open="' + $scope.validateOnOpen + '"></div>' +
                        '</div>';

                    // Populate Window Scope
                    var windowScope = $scope.$new();
                    windowScope.defaultData = [];
                    windowScope.windowId = windowId;
                    windowScope.subWindowOptions = InstancesWindowService.buildWindowOptions(windowScope, null, function () {
                        $scope.editSubData = null;
                        $scope.dataSource.data($scope.dataSource.data()); // Forces aggregates to update
                    });
                    windowScope.subWindowOptions.title = $scope.nimFormObject.label.text;
                    windowScope.subWindowOptions.actions = ['Close'];
                    windowScope.subWindowOptions.modal = true;
                    windowScope.subWindowOptions.autoFocus = true;

                    if(action === 'create' && !_.isEmpty($scope.nimFormObject.param.otherData)){
                        windowScope.defaultData = [];
                        
                        _.forEach($scope.nimFormObject.param.otherData, function (dataMap) {
                            var value = $scope.dataSet[dataMap.sourceModelId];
                            if(dataMap.type === 'value'){
                                value = dataMap.sourceValue;
                            }

                            var data = {
                                value: value
                            };

                            if ((dataMap.targetField.isLookup || dataMap.targetField.isCustomLookup)) {
                                if (_.isEmpty(value)) {
                                    return;
                                }
                                
                                data = {
                                    lookupDisplay: value.display,
                                    value: value.id
                                };
                            }

                            windowScope.defaultData.push({
                                data: data,
                                field: dataMap.targetField
                            });
                        });
                    }

                    // Open Window
                    InstancesWindowService.windowArea.append(html);
                    $compile(InstancesWindowService.windowArea.find('div[kendo-window="' + windowId + '"]'))(windowScope);
                }

                function autoFillTable(data) {
                    var newData = [],
                        oldData = $scope.grid.dataSource.data().toJSON();

                    _.remove(oldData, function (oldDataItem) {
                        return !oldDataItem.__instanceId;
                    });  

                    _.forEach(oldData, function (oldDataItem) {
                        oldDataItem.__nimDelete = true;
                    });  

                    if (data) {
                        _.forEach(data, function (dataItem) {
                            dataItem.__optionId = $scope.nimFormObject.param.optionId;
                            dataItem.__column = $scope.nimFormObject.param.column;
                            dataItem.__modelId = $scope.nimFormObject.param.fk;
                            dataItem.__widgetId = $scope.nimFormObject.param.widgetId;

                            if(dataItem.__nimData) {
                                FormsService.fixDataseriesCols(dataItem, $scope.schemaFields);
                            }
                            else {
                                createNimData(dataItem, $scope.schemaFields);
                            }
                            
                            newData.push(dataItem);
                        });
                    }

                    $scope.grid.dataSource.data(oldData.concat(newData));
                    $scope.dataSet[$scope.nimFormObject.config.modelId] = $scope.grid.dataSource.data().toJSON();
                }

                function createNimData(dataItem, schema){
                    _.defaults(dataItem, { __nimData: {} });
                    _.forEach(schema, function(schemaField){
                        var modelId = schemaField.field;
                        if(schemaField.isLookUp || schemaField.isCustomLookup){
                            var fieldName = modelId.replace(/^__/, '').replace(/_display$/, '');
                            _.set(dataItem.__nimData, fieldName, { display: dataItem[modelId] });

                            if(dataItem['__' + fieldName + '_id']){
                                _.set(dataItem.__nimData, fieldName + '.id', dataItem['__' + fieldName + '_id']);
                            }
                        }
                        else {
                            _.set(dataItem.__nimData, modelId, dataItem[modelId]);
                        }
                    });
                }
                
                function recordIndex(dataItem) {
                    var data = _.reject($scope.dataSource.data(), '__nimDelete');
                    return data.indexOf(dataItem) + 1;
                }

                // Builds template function
                function dataTemplate(field, format){
                    return function(dataItem){
                        if (format === 'boolCheck'){
                            return dataItem[field] == 'true' || dataItem[field] === true ? '<i class="fa fa-check"></i>' : '';
                        }
                        // Checks if text editor 'new line feed' needs replacement with html 'line break'
                        else if (format === 'htmlGrid'){
                            var fieldValue = dataItem[field];
                            return fieldValue.toString().replace(/(?:\r\n|\r|\n)/g, '<br>');
                        }
                        // Checks if format uses date-specific characters
                        else if(format.search(/[DdFfGgHhMmSsTtuYy]/) >= 0){
                            var dateValue = dataItem[field];
                            if(dateValue){
                                if(_.isString(dateValue)){
                                  //replaced by HD 2019-07-03
                                  //dateValue = kendo.parseDate(dateValue, ['MMMM, dd yyyy HH:mm:ss', 'yyyy-MM-ddTHH:mm:ss.fffZ']);
                                    dateValue = kendo.parseDate(dateValue, ['MMMM, dd yyyy HH:mm:ss', 'yyyy-MM-ddTHH:mm:ssz', 'yyyy-MM-ddTHH:mm:ss.fffz'], 'yyyy-MM-ddTHH:mm:sszzz');
                                }
                                return kendo.toString(dateValue, format);
                            }
                        }
                        else if(dataItem[field] !== null && dataItem[field] !== undefined){
                            var value = parseFloat(dataItem[field]);
                            if(isNaN(dataItem[field])){
                                return '';
                            }
                            else if(isNaN(value)) {
                                return dataItem[field];
                            }
                            else {
                                return kendo.toString(value, format);
                            }
                        }
                        return '';
                    };
                }

                function dataSeriesColTemplate(column, dataItem) {
                    var dataseries = dataItem[column.field];

                    if (!dataseries || !column.nim_dataseries_display) {
                        return '';
                    }

                    var displayValues = _.map(_.reject(dataseries, '__nimDelete'), function (item) {
                        if (_.has(item, column.nim_dataseries_display)) {
                            var value = item[column.nim_dataseries_display];

                            if (_.has(value, 'display')) {
                                value = value.display;
                            }

                            return value;
                        }
                        else if (_.has(item, 'display')) {
                            return item.display;
                        }

                        return '';
                    });

                    return displayValues.join(', ');
                }

                // Row selection
                function selectRow(id) { 
                    var index = selectedRowIndex(id);
                    if (index < 0) {
                        $scope.selectedIds.push(id);
                    }
                    else {
                        _.pullAt($scope.selectedIds, index);
                    }
                    
                    checkRowSelection();
                }

                function rowSelected(id) {
                    return selectedRowIndex(id) >= 0;
                }

                function selectAllRows(selected) {
                    var rows = $scope.dataSource.data();
                    var isStatic = $scope.isStatic || $scope.nimFormObject.param.disabled;
                    var idField = isStatic ? '__instanceId' : '__rowId';

                    _.forEach(rows, function(row) {
                        var id = row[idField],
                            index = selectedRowIndex(id);
                        
                        if (selected && index < 0) {
                            $scope.selectedIds.push(id);
                        }
                        else if (!selected && index >= 0){
                            _.pullAt($scope.selectedIds, index);
                        }
                    });

                    checkRowSelection();
                 }

                function checkRowSelection(){
                    var rows = $scope.dataSource.data();
                    var isStatic = $scope.isStatic || $scope.nimFormObject.param.disabled;
                    var idField = isStatic ? '__instanceId' : '__rowId';
                    var rowIds = _.map(rows, idField);

                    $scope.allRowsSelected = _.every(rowIds, rowSelected);
                }

                function selectedRowIndex(id){
                    return $scope.selectedIds.indexOf(id);
                }

                // Printing
                function printLabels() {
                    var widgetId = $scope.nimFormObject.param.widgetId,
                        instanceIds = angular.copy($scope.selectedIds);
                    
                    if (widgetId && !_.isEmpty(instanceIds)) {
                        var displayValues = {},
                            enabledPrintTypes = {
                                label: true
                            },
                            defaultConfig = {
                                type: 'label'
                            },
                            defaultFilename = kendo.format('{0} - {1:u}', $scope.nimFormObject.label.text, new Date());
                        
                        _.forEach(instanceIds, function(id) {
                            var data = _.reject($scope.dataSource.data(), '__nimDelete');
                            /* LODASH Version 4 ONLY */
                            //var index = _.findIndex(_.reject(data, '__nimDelete'), ['__instanceId', id]) + 1;
                            /* LODASH Version 3 & 4 Compatibility Mode */
                            var index = _.findIndex(_.reject(data, '__nimDelete'), function(f){return f.__instanceId === id;}) + 1;

                            displayValues[id] = index;
                        });

                        printService.configureAndPrint(widgetId, instanceIds, displayValues, enabledPrintTypes, defaultConfig, defaultFilename);
                    }
                }

                function printChecks() {
                    var widgetId = $scope.nimFormObject.param.widgetId,
                        instanceIds = angular.copy($scope.selectedIds);
                    
                    if (widgetId && !_.isEmpty(instanceIds)) {
                        var displayValues = {},
                            enabledPrintTypes = {
                                check: true
                            },
                            defaultConfig = {
                                type: 'check'
                            },
                            defaultFilename = kendo.format('{0} - {1:u}', $scope.nimFormObject.label.text, new Date());
                        
                        _.forEach(instanceIds, function(id) {
                            var data = _.reject($scope.dataSource.data(), '__nimDelete');
                            /* LODASH Version 4 ONLY */
                            //var index = _.findIndex(_.reject(data, '__nimDelete'), ['__instanceId', id]) + 1;
                            /* LODASH Version 3 & 4 Compatibility Mode */
                            var index = _.findIndex(_.reject(data, '__nimDelete'), function(f){return f.__instanceId === id;}) + 1;

                            displayValues[id] = index;
                        });

                        printService.configureAndPrint(widgetId, instanceIds, displayValues, enabledPrintTypes, defaultConfig, defaultFilename);
                    }
                }
            }]
        };
    })
;
angular.module('cerberus.core')
    .directive('nimStoreObject', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            //Because post-link functions are ran in reverse order if no priority is set,
            // it falls back on to alphabetical order, conflict with ngModel
            priority: 1,
            link: function (scope, element, attrs, ctrl) {
                if(attrs.type === 'checkbox'){
                    ctrl.$formatters.push(function(modelValue) {
                        return typeof modelValue === 'object';
                    });
                    ctrl.$parsers.push(function(viewValue) {
                        if(viewValue === true){
                            return angular.fromJson(attrs.true);
                        }
                        else {
                            return angular.fromJson(attrs.false);
                        }
                    });
                }
                else if(attrs.type === 'radio'){
                    ctrl.$formatters.push(function(modelValue) {
                        return angular.toJson(modelValue);
                    });
                    ctrl.$parsers.push(function(viewValue) {
                        return angular.fromJson(viewValue);
                    });
                }
            }
        };
    })
;
angular.module('cerberus.core')
    .factory('RulesService', ["_", "$http", "$q", "apiPath", "toaster", function(_, $http, $q, apiPath, toaster){
        var service = {
            addRule: addRule,
            getAvailableRules: getAvailableRules,
            getRule: getRule,
            updateRule: updateRule,
            deleteRule: deleteRule,
            getResult: getResult
        };

        return service;

        function addRule(data){
            var deferred = $q.defer();

            $http.post(apiPath + 'rules', data)
                .success(function(result){
                    toaster.pop('success', 'Rule Added');
                    deferred.resolve(result.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });

            return deferred.promise;
        }

        function getAvailableRules(){
            var deferred = $q.defer();

            $http.get(apiPath + 'rules')
                .success(function(result){
                    deferred.resolve(result.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });

            return deferred.promise;
        }

        function getRule(id){
            var deferred = $q.defer();

            $http.get(apiPath + 'rules/' + id)
                .success(function(result){
                    deferred.resolve(result.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });

            return deferred.promise;
        }

        function updateRule(id, data){
            var deferred = $q.defer();

            $http.put(apiPath + 'rules/' + id, data)
                .success(function(result){
                    toaster.pop('success', 'Rule Saved');
                    deferred.resolve(result.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });

            return deferred.promise;
        }

        function deleteRule(id){
            var deferred = $q.defer();

            $http.delete(apiPath + 'rules/' + id)
                .success(function(result){
                    toaster.pop('info', 'Rule Deleted');
                    deferred.resolve(result.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });

            return deferred.promise;
        }

        function getResult(id, params){
            var deferred = $q.defer();

            $http.post(apiPath + 'rules/' + id + '/result', {params: params})
                .success(function(result){
                    deferred.resolve(result.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });

            return deferred.promise;
        }
    }])
;
angular.module('cerberus.core')
    .config(["$routeProvider", function($routeProvider){
        $routeProvider.when('/instances/:id', {
            templateUrl: 'core/instances/instances-page.tpl.html',
            controller: 'InstancesPageCtrl',
            controllerAs: 'vm',
            resolve: {
                _wait: 'WaitForUserData',
                instanceId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
    }])
;
angular.module('cerberus.core')
    .controller('InstanceConfirmCloseCtrl', ["$uibModalInstance", function ($uibModalInstance) {
        var vm = this;

        vm.ok = ok;
        vm.cancel = cancel;
        
        function ok(result) {
            $uibModalInstance.close(result);
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }
    }])
;
angular.module('cerberus.core')
    .controller('InstancesPageCtrl', ["_", "$scope", "$location", "$timeout", "$window", "instanceId", "FormsService", "InstancesService", "InstancesWindowService", "nimTitleService", function(_, $scope, $location, $timeout, $window, instanceId, FormsService,
                                              InstancesService, InstancesWindowService, nimTitleService){
        var vm = this;

        vm.title = {};
        vm.instanceIds = [];
        vm.forbidden = false;
        vm.instance = {};
        vm.states = {};
        vm.collapse = {};
        vm.dataLoading = {};
        vm.formDoneLoading = {};
        vm.fieldOptions = {};
        vm.dataSet = {};
        vm.filters = {};
        vm.sectionsShown = {};
        vm.fieldsShown = {};
        vm.staticGridsterOptions = {
            pushing: true
        };

        vm.sectionFilter = FormsService.sectionFilter;

        _init();

        function _init(){
            $window.status = 'Loading';

            vm.instanceIds = instanceId.split(',');
            _.forEach(vm.instanceIds, _loadInstance);
        }

        function _loadInstance(id){
            vm.states[id] = [];
            vm.collapse[id] = {};
            vm.dataLoading[id] = {};
            vm.formDoneLoading[id] = {};
            vm.fieldOptions[id] = {};
            vm.dataSet[id] = {};
            vm.filters[id] = {};
            vm.sectionsShown[id] = {};
            vm.fieldsShown[id] = {};

            // Gets the state from the query parameters
            var queryState = $location.search()['state'];

            InstancesService.getInstance(id, queryState).then(function (data) {
                // Populate controller variables
                vm.instance[id] = data;

                if(!vm.title[id]) {
                    vm.title[id] = data.widgetName;
                    nimTitleService.set(data.widgetName);
                }

                vm.states[id] = angular.copy(data.workflowPath).reverse(); // Reverse the copy, not the original

                if(queryState && _.has(data.workflowObjects, queryState)){
                    vm.states[id] = [queryState];
                }
                else if(_.last(data.workflowPath) !== data.currentWorkflowObjectId) {
                    vm.states[id].unshift(data.currentWorkflowObjectId);
                }

                // Populate form data objects & UI controls
                _.forEach(vm.states[id], function(state, i){
                    vm.collapse[id][state] = false;
                    vm.dataLoading[id][state] = true;
                    vm.formDoneLoading[id][state] = {};
                    vm.sectionsShown[id][state] = {};
                    vm.fieldsShown[id][state] = {};

                    var formChunks = _.chunk(_.get(data.workflowObjects[state], 'model.forms', []));

                    _.forEach(formChunks, function(formArray, j){
                        vm.formDoneLoading[id][state][j] = false;
                        InstancesService.getFormData(id, formArray).then(_formDataCallBack(id, i, j));
                    });
                });

            }, function(response){
                vm.forbidden = response === 'Forbidden';
            });
        }

        function _formDataCallBack(id, stateIndex, formIndex){
            return function(result){
                var formData = result.formData,
                    instance = vm.instance[id],
                    state = vm.states[id][stateIndex],
                    dataLoading = vm.dataLoading[id],
                    formDoneLoading = vm.formDoneLoading[id][state];

                vm.sectionsShown[id][state][formData[0].originatorId] = {};

                formDoneLoading[formIndex] = true;
                dataLoading[state] = !_.every(formDoneLoading);
                updateWindowStatus();

                if(instance.workflowPath[instance.workflowPath.length - 1] !== instance.currentWorkflowObjectId){
                    formData[0] = FormsService.processFormData(formData[0], formData[0].defaultDataSet);
                }

                InstancesWindowService.populateDataAndParseFormulas(state, formData, vm.dataSet[id], vm.fieldOptions[id], angular.noop, angular.noop);
                _.assign(instance.workflowObjects[state].model.forms[formIndex], formData[0]);

                _.forEach(instance.workflowObjects[state].model.forms[formIndex].form.sections, function(section){
                    if(!_.isEmpty(section.condition)) {
                        vm.sectionsShown[id][state][formData[0].originatorId][section.name] =
                            FormsService.sectionCondition(section.condition, vm.dataSet[id][state], section.logic, 'read');
                    }
                    else {
                        vm.sectionsShown[id][state][formData[0].originatorId][section.name] = true;
                    }
                });

                // TODO: set fieldsShown for each form object
                _.forEach(instance.workflowObjects[state].model.forms[formIndex].form.objects, function(formObj){
                    var modelId = formObj.model.config.modelId,
                        section = formObj.model.display.section,
                        params = formObj.model.param;

                    if(vm.sectionsShown[id][state][formData[0].originatorId][section] && !_.isEmpty(params.condition) && params.conditionalAction !== 'active' && params.conditionalAction !== 'readonly'){
                        var result = FormsService.sectionCondition(params.condition, vm.dataSet[id][state], params.conditionalLogic, 'read');

                        if(params.conditionalAction === 'hide'){
                            vm.fieldsShown[id][state][modelId] = !result;
                        }
                        else {
                            vm.fieldsShown[id][state][modelId] = result;
                        }
                    }
                    else {
                        vm.fieldsShown[id][state][modelId] = true;
                    }
                });

                if(instance.workflowObjects[state].model.defaultData) {
                    InstancesWindowService.parseDefaultData(instance.workflowObjects, state, instance.instanceWorkflow);
                }

                //if(!_.some(dataLoading)){
                //    var displayVal = getRecordDisplayValue(vm.dataSet[id], vm.instance[id].widgetSettings.view.column);
                //    if(displayVal) {
                //        if(_.has(displayVal, 'display')) {
                //            displayVal = displayVal.display;
                //        }
                //        //vm.title[id] = vm.instance[id].widgetName + ': ' + displayVal;
                //    }
                //}
            };
        }

        //function getRecordDisplayValue(dataSet, column){
        //    var flatData = {};
        //    var modelId = column.split('_')[1];
        //
        //    _.forEach(dataSet, function(state){
        //        _.assign(flatData, state);
        //    });
        //
        //    return flatData[modelId];
        //}

        function updateWindowStatus(){
            if(!_.isEmpty(vm.dataLoading) && !_.some(vm.dataLoading, function(loading){ return _.some(loading); })){
                $timeout(function(){
                    $window.status = "Complete";
                }, 1000);
            }
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name InstancesService
     * @alias cerberus/core:InstancesService
     * @description Provides CRUD functionality for instances
     */
    .factory('InstancesService', ["_", "$http", "$q", "apiPath", "toaster", "FormsClassService", "DesignerUtilityService", function InstancesService(_, $http, $q, apiPath, toaster, FormsClassService, DesignerUtilityService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        var service = {
            getInstance: getInstance,
            createInstance: createInstance,
            update: update,
            batchUpdate: batchUpdate,
            //newRevision: newRevision,
            updateInstanceObject: updateInstanceObject,
            updateAllInstanceObject: updateAllInstanceObject,
            updateSchema: updateSchema,
            updateAllSchema: updateAllSchema,
            updateCalculations: updateCalculations,
            updateAllCalculations: updateAllCalculations,
            updateRelationships: updateRelationships,
            getRelationships: getRelationships,
            getDownloadKey: getDownloadKey,
            getFormData: getFormData,
            getRevision: getRevision,
            softDelete: softDelete,
            hardDelete: hardDelete,
            deleteAttachment: deleteAttachment,
            getDraft: getDraft,
            getInstanceParticipants: getInstanceParticipants,
            getBlob: getBlob
        };
        return service;
        ////////////////////

        function getRelationships(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'instances/' + id + '/relationships')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * getDownloadKey
         * @param id
         * @returns {*|r.promise|Function|promise|Document.promise}
         */
        function getDownloadKey(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'attachments/' + id + '/download/key')
                .success(function (value) {
                    deferred.resolve(apiPath + 'download/' + value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         revId
         * @param id
         * @returns {*|r.promise|Function|promise|Document.promise}
         */
        function getRevision(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'instances/revision/' + id)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * getFormData
         * @param instanceId
         * @param formArray
         * @param revisionId
         * @param dataOnly
         * @returns {*|r.promise|Function|promise|Document.promise}
         */

        function getFormData(instanceId, formArray, revisionId, dataOnly){
            var fby = function (v1, v2) {
                return v1.row - v2.row;
            };
            var tby = function (v1, v2) {
                return v1.col - v2.col;
            };
            var deferred = $q.defer(),
                url = apiPath + 'instances/' + instanceId + '/form/data?dataOnly=' + (!!dataOnly);

            if(revisionId){
                url += '&revision=' + revisionId;
            }

            $http.put(url,{formArray:formArray})
                .success(function (value) {
                    var newData = value.DATA.formData;
                    for(var i = 0; i < newData.length; i++){
                        if(!_.isEmpty(newData[i])) {
                            newData[i].form.objects.sort(
                                DesignerUtilityService.firstBy(fby)
                                    .thenBy(tby)
                            );
                            for (var j = 0; j < newData[i].form.objects.length; j++) {
                                var newField = FormsClassService.newField();
                                newField.setData(newData[i].form.objects[j].model);
                                newData[i].form.objects[j].model = newField;
                                //Generate tab index
                                if (newData[i].form.settings.autoTabIndex.enabled && newData[i].form.objects[j].model.config.dataType != 'static') {
                                    newData[i].form.objects[j].model.tag.attrs.tabindex = j + 2;
                                }
                            }
                        }
                    }

                    value.DATA.formData = newData;

                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }


        /**
         * Gets and instance by its ID
         * @param {string} instanceId
         * @param {string} state - (Optional) Limits instance data to this state
         * @returns {deferred.promise|{then}}
         */
        function getInstance(instanceId, state) {
            var deferred = $q.defer();
            var queryParam = '';

            if(state){
                queryParam = '?state=' + state;
            }

            $http.get(apiPath + 'instances/' + instanceId + queryParam)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Creates a new instance
         * @param data
         * @returns {deferred.promise|{then}}
         */
        function createInstance(data) {
            var deferred = $q.defer();
            $http.post(apiPath + 'instances', data)
                .success(function (value) {
                    toaster.pop('success', 'Record Created');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    if(_.has(reason, 'DATA.errMsg')) {
                        toaster.pop({
                            type: 'warning',
                            bodyOutputType: 'trustedHtml',
                            body: parseError(reason.DATA.errMsg)
                        });
                    }
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function parseError (errArr){
            var str = '';
            //Parsing error into readable string
            for(var i = 0; i < errArr.length; i++ ){
                str = str + '<strong>' + errArr[i].modelId + '</strong>: ';
                for(var j = 0; j < errArr[i].invalidArr.length; j++){
                    str = str + errArr[i].invalidArr[j] + ' ';
                }
                str = str + '<br>';
            }
            return str;
        }

        /**
         * Updates an instances; more of a submit.  Will progress the instance in its workflow
         * @param {string} id
         * @param data
         * @returns {deferred.promise|{then}}
         */
        function update(id, data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'instances/' + id, data)
                .success(function (value) {
                    toaster.pop('success', 'Success');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    if(_.has(reason, 'DATA.errMsg')) {
                        toaster.pop({
                            type: 'warning',
                            bodyOutputType: 'trustedHtml',
                            body: parseError(reason.DATA.errMsg)
                        });
                    }
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function batchUpdate(recordDataArray){
            var deferred = $q.defer();
            $http.put(apiPath + 'instances/', {recordData: recordDataArray})
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Updates the form Object Data of an instance
         * @param {struct} data
         * @returns {deferred.promise|{then}}
         */
        function updateInstanceObject(data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'instance/update/object', data)
                .success(function (value) {
                    toaster.pop('success', 'Object Data Updated');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Batch operation for updating form Object Data of instances from entire widget
         * @param {string} widgetId
         * @param {struct} updateOptions
         * @returns {deferred.promise|{then}}
         */
        function updateAllInstanceObject(widgetId, updateOptions) {
            var deferred = $q.defer();
            $http.put(apiPath + 'widgets/' + widgetId + '/instances/update/object/all', {updateSettings:updateOptions})
                .success(function (value) {
                    toaster.pop('success', 'Object Data Updated');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Updates the form schemas of an instance to the latest published version
         * @param data
         * @returns {deferred.promise|{then}}
         */
        function updateSchema(data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'instance/update/schema', data)
                .success(function (value) {
                    toaster.pop('success', 'Schema Updated');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Batch operation for updating form schemas of instances from entire widget
         * @param {string} widgetId
         * @param {struct} updateOptions
         * @returns {deferred.promise|{then}}
         */
        function updateAllSchema(widgetId, updateOptions) {
            var deferred = $q.defer();
            $http.put(apiPath + 'widgets/' + widgetId + '/instances/update/schema/all', {updateSettings:updateOptions})
                .success(function (value) {
                    toaster.pop('success', 'Schema Updated');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Updates the form calculations of an instance
         * @param data
         * @returns {deferred.promise|{then}}
         */
        function updateCalculations(data) {
            var deferred = $q.defer();
            $http.put(apiPath + 'instance/update/calcs', data)
                .success(function (value) {
                    toaster.pop('success', 'Calculations Updated');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Batch operation for updating form calculations of instances from entire widget
         * @param {string} widgetId
         * @returns {deferred.promise|{then}}
         */
        function updateAllCalculations(widgetId) {
            var deferred = $q.defer();
            $http.put(apiPath + 'widgets/' + widgetId + '/instances/update/calcs/all')
                .success(function (value) {
                    toaster.pop('success', 'Calculations Updated');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Updates the relationships of an instance
         * @param {string} id
         * @param relationships
         * @returns {deferred.promise|{then}}
         */
        function updateRelationships(id, relationships) {
            var d = {relation: relationships};
            var deferred = $q.defer();
            $http.put(apiPath + 'instances/' + id + '/relationships', d)
                .success(function (value) {
                    deferred.resolve(value);
                    toaster.pop('success', 'Record relationships established.');
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Requests a soft delete of an instance
         * @param {string} id
         * @returns {deferred.promise|{then}}
         */
        function softDelete(id) {
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'instances/soft/delete/' + id})
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Requests a hard delete of an instance
         * @param {Array} id
         * @returns {deferred.promise|{then}}
         */
        function hardDelete(id) {
            var deferred = $q.defer();
            $http.put(apiPath + 'instances/hard/delete', {ids: id})
                .success(function (value) {
                    toaster.pop('success', 'Records deleted.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Deletes an attachment
         * @param {string} id
         * @returns {deferred.promise|{then}}
         */
        function deleteAttachment(id) {
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'attachment/' + id})
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Extends data objects with retrieved draft data
         * @param {object} draftData
         * @param {object} dataSet
         * @param {object} form
         */
        function getDraft(draftData, dataSet, form) {
            for(var mId in dataSet){
                if(draftData.data[mId]){
                    dataSet[mId] = draftData.data[mId];
                }
            }
            angular.extend(form, {fileAttachments: draftData.attachments});
        }
        /**
         * Gets list of users participating in instance
         * @param instanceId
         * @returns {*}
         */
        function getInstanceParticipants(instanceId){
            var deferred = $q.defer();
            $http.get(apiPath + 'instances/' + instanceId + '/participants')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Get file as a blob
         * @param url
         * @returns {Promise}
         */
        function getBlob(url){
            var deferred = $q.defer();
            $http.get(url, {responseType: 'blob'})
                .success(function(data){
                    deferred.resolve(data);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }
    }])
;

angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name InstancesWindowService
     * @alias cerberus/core:InstancesWindowService
     * @description Provides functions for creating a window that contains an instance
     */
    .factory('InstancesWindowService', ["_", "moment", "kendo", "$rootScope", "$compile", "$window", "$timeout", "$location", "$log", "$uibModal", "CalculationService", "ConfirmModalService", "DesignerUtilityService", "DeviceSniffService", "InstancesService", "nimCalcService", function InstancesWindowService(_, moment, kendo, $rootScope, $compile, $window, $timeout, $location, $log, $uibModal,
                                                                       CalculationService, ConfirmModalService, DesignerUtilityService,
                                                                       DeviceSniffService, InstancesService, nimCalcService) {
        // Cache Window Area
        var windowAreaSelector = '#nim-window-area';
        var windowArea = angular.element(windowAreaSelector);

        var service = {
            windowArea: windowArea,
            buildWindowOptions: buildWindowOptions,
            openWindow: checkOpenWindows,
            openRevision: openRevision,
            buildToolbar: buildToolbar,
            deleteInstanceModal: deleteInstanceModal,
            pushActionInstanceModal: pushActionInstanceModal,
            parseDefaultData: parseDefaultData,
            //parseFormulaFields: parseFormulaFields,
            populateDataAndParseFormulas: populateDataAndParseFormulas,
            addFormObjects: addFormObjects,
            openAdvSelPage: openAdvSelPage,
            pickShownFields: pickShownFields,
            openConfirmInstanceCloseModal: openConfirmInstanceCloseModal
        };
        return service;
        ////////////////////
        /**
         * Helper function for sizing windows
         * @returns {{top: number, left: number, width: number, device: number}}
         */
        function determineWindowPosition() {
            var deviceWidth = DeviceSniffService.deviceWidth();
            var existingWindows = windowArea.find('.k-window');
            var maxTop = 0, maxLeft = 0, top = 0, left = 0, width = 320;

            if(deviceWidth >= 1126) {
                width = 1024;
            }
            else if (deviceWidth >= 768 && deviceWidth < 1126) {
                width = deviceWidth - (20 * 2);
            }
            else if (deviceWidth < 768) {
                width = deviceWidth;
            }

            // Determine new Position
            for (var i = 0; i < existingWindows.length; i++) {
                var ele = angular.element(existingWindows[i]);
                maxTop = Math.max(30, ele.position().top);
                maxLeft = Math.max(0, ele.position().left);
            }
            top = maxTop + 30;
            left = width === deviceWidth ? 0 : (deviceWidth - width) / 2;

            return {
                top: top,
                left: left,
                width: width,
                device: deviceWidth
            };
        }
        /**
         * Builds Kendo Window Options with sensible defaults
         * @param {object} scope
         * @param {Function} [openCallback]
         * @param {Function} [closeCallback]
         * @returns {{appendTo: string, visible: boolean, actions: string[], autoFocus: boolean, maxWidth: number, minWidth: number, width: number, position: {top: number, left: number}, open: Function, close: Function, dragstart: Function, dragend: Function}}
         */
        function buildWindowOptions(scope, openCallback, closeCallback) {
            var pos = determineWindowPosition();
            return {
                appendTo: windowAreaSelector,
                visible: true,
                actions: [
                    'Minimize',
                    'Close'
                ],
                autoFocus: false,
                maxWidth: Math.max(pos.device, 1024),
                minWidth: Math.min(pos.device, 480),
                height: '80%',
                width: pos.width,
                position: {
                    top: pos.top,
                    left: pos.left
                },
                open: function () {
                    var othis = this;
                    // Add event Listener
                    angular.element($window).on('orientationchange', function () {
                        var pos = determineWindowPosition();
                        othis.setOptions({
                            width: pos.width,
                            maxWidth: Math.max(pos.device, 1024),
                            minWidth: Math.min(pos.device, 480)
                        });
                    });
                    if (angular.isFunction(openCallback)) {
                        openCallback();
                    }
                },
                close: function (e) {
                    var vm = scope.$eval('vm');

                    if (e.userTriggered && vm.activeState && !vm.isUnchanged()) {
                        e.preventDefault();
                        openConfirmInstanceCloseModal().then(function (result) {
                            if (result == 'submit') {
                                if (vm.isSubForm) {
                                    vm.subFormCreate(false);
                                }
                                else {
                                    var currentWorkflowObject = vm.instance.workflowObjects[vm.createState],
                                        nextWorkflowState = _.get(currentWorkflowObject, 'model.to[0]', '');
                                        
                                    vm.submitForm(vm.activeState, nextWorkflowState, 'submitAndClose');
                                }
                            }
                            else {
                                angular.element($window).off('orientationchange');
                                scope.$broadcast('nim-remove-form-objects');
                                scope.$destroy();
                                if (angular.isFunction(closeCallback)) {
                                    closeCallback();
                                }
                                e.sender.destroy();
                            }
                        });
                    }
                    else {
                        angular.element($window).off('orientationchange');
                        scope.$broadcast('nim-remove-form-objects');
                        scope.$destroy();
                        if (angular.isFunction(closeCallback)) {
                            closeCallback();
                        }
                        e.sender.destroy();
                    }
                },
                dragstart: function () {
                    this.element.parent().css('opacity', 0.7);
                    this.element.find('[nim-instance]').css('opacity', 0);
                },
                dragend: function () {
                    this.element.parent().css('opacity', 1);
                    this.element.find('[nim-instance]').css('opacity', 1);
                }
            };
        }
        /**
         * Intercepts call to InstancesWindowService.openWindow and checks for other
         * open windows for the same instance
         * @param {Object} options
         * @param {string} options.action
         * @param {string} options.widgetId
         * @param {string} options.instanceId
         * @param {string} options.title
         * @param {string} options.draftId
         * @param {string} options.revisionId
         * @param {Array}  options.defaultData
         * @param {Object} options.navFunctions
         */
        function checkOpenWindows(options) {
            var instanceId = _.get(options, 'instanceId'),
                action = _.get(options, 'action');

            if(!instanceId && (action == 'read' || action == 'readonly')){
                return;
            }

            var instanceOpen = false;
            if(instanceId && instanceId !== ''){
                // Checks if there are already windows open for this instance
                var len = $('#instance-' + instanceId).length;
                instanceOpen = len && len > 0;
            }

            if(instanceOpen){
                ConfirmModalService.showModal(null, {
                    headerText: 'Record Already Open',
                    bodyText: 'There is another window open for the selected record. Open new window anyway?',
                    actionButtonText: 'Open New Window',
                    closeButtonText: 'Cancel',
                    confirm: function () {
                        openWindow(options);
                    },
                    check: function () {
                        return true;
                    }
                });
            }
            else {
                openWindow(options);
            }
        }
        /**
         * Opens an instance in a window for creates, edits, etc.
         * @param {Object} options
         * @param {string} options.action
         * @param {string} options.widgetId
         * @param {string} options.instanceId
         * @param {string} options.title
         * @param {string} options.draftId
         * @param {string} options.revisionId
         * @param {Array}  options.defaultData
         * @param {Object} options.navFunctions
         */
        function openWindow(options) {
            var windowId = DesignerUtilityService.generateGuid();
            var windowScope = $rootScope.$new(true);

            var action = _.get(options, 'action', ''),
                widgetId = _.get(options, 'widgetId', ''),
                instance = _.get(options, 'instanceId', ''),
                draft = _.get(options, 'draftId', ''),
                revision = _.get(options, 'revisionId', ''),
                validateOnOpen = _.get(options, 'validateOnOpen', false) ? 'validate' : '';

            var html = '<div id="instance-' + instance + '" kendo-window="' + windowId + '" k-options="windowOptions" style="overflow:visible;">' +
                    '<div nim-instance class="nim-instance container-fluid" nim-action="' + action + '" nim-id="' + instance + '" nim-widget-id="' + widgetId + '" nim-window-id="' + windowId + '" nim-draft-id="' + draft + '" nim-revision-id="' + revision + '" nim-validate-on-open="' + validateOnOpen + '"></div>' +
                '</div>';

            // Populate new scope
            windowScope.defaultData = _.get(options, 'defaultData', []);
            windowScope.windowOptions = buildWindowOptions(windowScope);
            windowScope.windowId = windowId;
            windowScope.windowOptions.title = _.get(options, 'title', '');
            windowScope.navFunctions = _.get(options, 'navFunctions', {});

            // Create Window
            windowArea.append(html);
            $compile(windowArea.find('div[kendo-window="' + windowId + '"]'))(windowScope);
        }

        function openRevision(widgetId, instanceId, revisionId, title){
            openWindow({
                action: 'revision',
                title: title,
                widgetId: widgetId,
                instanceId: instanceId,
                revisionId: revisionId
            });
        }

        /**
         * Given a PageObject this function will build the appropriate
         * Kendo UI Toolbar options object
         * @param {object} scope - show only relevant buttons for an action
         * @param {object} controller
         * @return {object}
         */

        function buildToolbar(scope, controller) {
            scope._recurrenceScope = null;
            scope._recurrenceWindowOptions = {
                title: 'Repeat',
                modal: true,
                autoFocus: false,
                //width: 600,
                //position: {
                //    top: 80,
                //    left: 475
                //},
                open: function () {
                    var othis = this;
                    // Add event Listener
                    angular.element($window).on('orientationchange', function () {
                        var pos = determineWindowPosition();
                        if(pos.width > 600){
                            pos.left += (pos.width - 600) / 2;
                        }

                        othis.setOptions({
                            width: Math.min(pos.width, 600),
                            maxWidth: Math.max(pos.device, 1024),
                            minWidth: Math.min(pos.device, 480),
                            position: {
                                top: pos.top,
                                left: pos.left
                            }
                        });
                    });
                },
                close: function () {
                    angular.element($window).off('orientationchange');
                    this.destroy();
                    scope._recurrenceScope.$destroy();
                    scope._recurrenceScope = null;
                }
            };
            scope._openRecurrenceWindow = function () {
                if (!_.has(controller, 'instance.widgetSettings.recurrence.modelId')) { 
                    $log.warn('Recurrence field not defined');
                    return;
                }
                
                var pos = determineWindowPosition();
                if(pos.width > 600){
                    pos.left += (pos.width - 600) / 2;
                }

                _.assign(scope._recurrenceWindowOptions, {
                    maxWidth: Math.max(pos.device, 1024),
                    minWidth: Math.min(pos.device, 480),
                    width: Math.min(pos.width, 600),
                    position: {
                        top: pos.top,
                        left: pos.left
                    }
                });

                if (!controller.instance.recurrence) {
                    controller.instance.recurrence = null;
                }
                var html = '<div kendo-window="instanceRecurrence" k-options="_recurrenceWindowOptions">' +
                    '    <div class="instances-subwindow" nim-recurrence="$parent.vm.instance" nim-recurrence-id="$parent.vm.instanceId" start-date="$parent.vm.temp[1].' + controller.instance.widgetSettings.recurrence.modelId + '"></div>' +
                    '</div>';
                var newScope = scope.$new();
                windowArea.append(html);
                $compile(windowArea.find('div[kendo-window="instanceRecurrence"]'))(newScope);
                scope._recurrenceScope = newScope;
            };
            scope._relationsScope = null;
            scope._relationsWindowOptions = {
                title: 'Instance Relationships',
                modal: true,
                autoFocus: false,
                //width: 800,
                //position: {
                //    top: 80,
                //    left: 475
                //},
                open: function () {
                    var othis = this;
                    // Add event Listener
                    angular.element($window).on('orientationchange', function () {
                        var pos = determineWindowPosition();
                        if(pos.width > 800){
                            pos.left += (pos.width - 800) / 2;
                        }

                        othis.setOptions({
                            width: Math.min(pos.width, 800),
                            maxWidth: Math.max(pos.device, 1024),
                            minWidth: Math.min(pos.device, 480),
                            position: {
                                top: pos.top,
                                left: pos.left
                            }
                        });
                    });
                },
                close: function () {
                    angular.element($window).off('orientationchange');
                    this.destroy();
                    scope._relationsScope.$destroy();
                    scope._relationsScope = null;
                }
            };
            scope._openRelationshipWindow = function () {
                var pos = determineWindowPosition();
                if(pos.width > 800){
                    pos.left += (pos.width - 800) / 2;
                }

                _.assign(scope._relationsWindowOptions, {
                    maxWidth: Math.max(pos.device, 1024),
                    minWidth: Math.min(pos.device, 480),
                    width: Math.min(pos.width, 800),
                    position: {
                        top: pos.top,
                        left: pos.left
                    }
                });

                var html = '<div kendo-window="instanceRelationship" k-options="_relationsWindowOptions">' +
                    '    <div class="instances-subwindow" nim-relationship></div>' +
                    '</div>';
                var newScope = scope.$new();
                windowArea.append(html);
                $compile(windowArea.find('div[kendo-window="instanceRelationship"]'))(newScope);
                scope._relationsScope = newScope;
            };

            return {
                resizable: true,
                items: [
                    /* Save */
                    {
                        id: 'instance-toolbar-save',
                        type: 'button',
                        text: '<i class="fa fa-floppy-o"></i>',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': vm.activeState && vm.action !== 'create' ? 'inline-block' : 'none'}",
                            title: 'Save'
                        },
                        click: function(){
                            if(controller.activeState){
                                $timeout(function(){
                                    if(controller.isSubForm){
                                        controller.subFormCreate(controller.action === 'create' && !controller.readingNewRecord);
                                    }
                                    else {
                                        var state = controller.activeState,
                                            workflowObject = _.get(controller.instance.workflowObjects, state),
                                            to = _.get(workflowObject, 'model.to', []),
                                            nextState = _.head(to),
                                            submitAction = _.get(workflowObject, 'model.defaultAction');

                                        if (!submitAction || controller.action === 'create') {
                                            submitAction = controller.instance.widgetSettings.defaultAction;
                                        }

                                        controller.submitForm(state, nextState, submitAction);
                                    }
                                });
                            }
                        }
                    },

                    /* Cancel */
                    // {
                    //     id: 'instance-toolbar-cancel',
                    //     type: 'button',
                    //     text: '<i class="fa fa-ban"></i>',
                    //     overflow: 'never',
                    //     attributes: {
                    //         'ng-style': "{'display': vm.activeState ? 'inline-block' : 'none'}",
                    //         title: 'Cancel'
                    //     },
                    //     click: function(){
                    //         $timeout(function(){
                    //             controller.cancel();
                    //         });
                    //     }
                    // },

                    /* Duplicate */
                    {
                        id: 'instance-toolbar-duplicate',
                        type: 'button',
                        text: '<i class="fa fa-files-o"></i>',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': vm.action === 'read' && vm.instance.widgetSettings.enableDuplication && !vm.isSubForm ? 'inline-block' : 'none'}",
                            title: 'Duplicate'
                        },
                        click: function () {
                            if (!_.isEmpty(controller.dataLoading) && !_.some(controller.dataLoading)) {
                                $timeout(function () {
                                    controller.duplicateInstance();
                                });
                            }    
                        }
                    },
                    {
                        type: 'separator',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': vm.activeState || !vm.instance.widgetSettings.enableDuplication ? 'none' : 'inline-block'}"
                        }
                    },

                    /* Delete */
                    {
                        id: 'instance-toolbar-delete',
                        type: 'button',
                        text: '<i class="fa fa-trash-o"></i>',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': vm.activeState ? 'none' : 'inline-block'}",
                            title: 'Delete'
                        },
                        click: function(){
                            if (!_.isEmpty(controller.dataLoading) && !_.some(controller.dataLoading)) {
                                $timeout(function () {
                                    controller.deleteInstance();
                                });
                            }    
                        }
                    },
                    // {
                    //     type: 'separator',
                    //     overflow: 'never',
                    //     attributes: {
                    //         'ng-style': "{'display': vm.activeState ? 'none' : 'inline-block'}"
                    //     }
                    // },

                    /* PDF */
                    // {
                    //     id: 'instance-toolbar-pdf',
                    //     type: 'button',
                    //     overflow: 'never',
                    //     attributes: {
                    //         'ng-style': "{'display': vm.activeState ? 'none' : 'inline-block'}",
                    //         title: 'PDF'
                    //     },
                    //     text: "<i class=\"fa fa-file-pdf-o\"></i>",
                    //     click: function () {
                    //         if (!_.isEmpty(controller.dataLoading) && !_.some(controller.dataLoading)) {
                    //             $timeout(function () {
                    //                 controller.exportInstance();
                    //             });
                    //         }    
                    //     }
                    // },
                    {
                        type: 'separator',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': vm.instance.widgetSettings.recurrence.modelId ? 'inline-block' : 'none'}"
                        }
                    },

                    /* Repeat */
                    {
                        id: 'instance-toolbar-repeat',
                        type: 'button',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': vm.instance.widgetSettings.recurrence.modelId ? 'inline-block' : 'none'}",
                            title: 'Repeat'
                        },
                        text: "<i class=\"fa fa-calendar\"></i>",
                        click: function(){
                            if (!_.isEmpty(controller.dataLoading) && !_.some(controller.dataLoading)) {
                                $timeout(function () {
                                    scope._openRecurrenceWindow();
                                });
                            }    
                        }
                    },
                    {
                        type: 'separator',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': !vm.activeState && (navFunctions.getPrevious || navFunctions.getNext) ? 'inline-block' : 'none'}"
                        }
                    },

                    /* Previous */
                    {
                        id: 'instance-toolbar-previous',
                        type: 'button',
                        text: '<i class="fa fa-chevron-circle-left"></i>',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': navFunctions.getPrevious && !vm.activeState ? 'inline-block' : 'none'}",
                            title: 'Previous'
                        },
                        click: function () {
                            if(!_.isEmpty(controller.dataLoading) && !_.some(controller.dataLoading)) {
                                $timeout(function () {
                                    if (_.isFunction(scope.navFunctions.getPrevious)) {
                                        scope.navFunctions.getPrevious(controller);
                                    }    
                                });
                            }
                        }
                    },

                    /* Next */
                    {
                        id: 'instance-toolbar-next',
                        type: 'button',
                        text: '<i class="fa fa-chevron-circle-right"></i>',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': navFunctions.getNext && !vm.activeState ? 'inline-block' : 'none'}",
                            title: 'Next'
                        },
                        click: function () {
                            if(!_.isEmpty(controller.dataLoading) && !_.some(controller.dataLoading)) {
                                $timeout(function() {
                                    if (_.isFunction(scope.navFunctions.getNext)) {
                                        scope.navFunctions.getNext(controller);
                                    }    
                                });
                            }
                        }
                    },
                    {
                        type: 'separator',
                        overflow: 'never',
                        attributes: {
                            'ng-style': "{'display': vm.action === 'create' ? 'none' : 'inline-block'}"
                        }
                    },
                    /* FILE */
                    {
                        overflow: 'auto',
                        template: '<div class="btn-group" uib-dropdown dropdown-append-to="\'div[kendo-window=' + controller.windowId + ']\'">' +
                        '<a id="instance-toolbar-file" href="" class="k-button" uib-dropdown-toggle>File</a>' +
                        '<ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="instance-toolbar-file">' +
                        '<li role="menuitem" ng-if="!vm.isSubForm"><a href="" ng-click="vm.newInstance()">New</a></li>' +
                        '<li role="menuitem" ng-if="vm.action !== \'create\' && vm.instance.widgetSettings.enableDuplication && !vm.isSubForm"><a href="" ng-click="vm.duplicateInstance()">Duplicate</a></li>' +
                        '<li class="divider" ng-if="vm.activeState && (!vm.isSubForm || vm.action !== \'create\')"></li>' +
                        '<li role="menuitem" ng-if="vm.activeState"><a href="" ng-click="vm.cancel()">Cancel</a></li>' +
                        '<li class="divider" ng-if="vm.action === \'create\' && !vm.isSubForm"></li>' +
                        '<li role="menuitem" ng-if="vm.action === \'create\' && !vm.isSubForm"><a href="" ng-click="vm.saveDraft(vm.activeState)">Save Draft</a></li>' +
                        '<li class="divider" ng-if="vm.activeState"></li>' +
                        '<li role="menuitem" ng-if="vm.activeState && !vm.isSubForm">' +
                        '<a href="" ng-click="vm.submitForm(vm.activeState, vm.instance.workflowObjects[vm.createState].model.to[0], \'submit\')">Submit</a>' +
                        '</li>' +
                        '<li role="menuitem" ng-if="vm.activeState && !vm.isSubForm">' +
                        '<a href="" ng-click="vm.submitForm(vm.activeState, vm.instance.workflowObjects[vm.createState].model.to[0], \'submitAndClose\')">Submit & Close</a>' +
                        '</li>' +
                        '<li role="menuitem" ng-if="vm.activeState && vm.action === \'create\' && !vm.isSubForm">' +
                        '<a href="" ng-click="vm.submitForm(vm.activeState, vm.instance.workflowObjects[vm.createState].model.to[0], \'submitAndNew\')">Submit & New</a>' +
                        '</li>' +
                        '<li role="menuitem" ng-if="vm.activeState && vm.isSubForm && vm.action === \'create\' && !vm.readingNewRecord">' +
                        '<a href="" ng-click="vm.subFormCreate(true)">Save & New</a>' +
                        '</li>' +
                        '<li role="menuitem" ng-if="vm.activeState && vm.isSubForm">' +
                        '<a href="" ng-click="vm.subFormCreate(false)">Save & Close</a>' +
                        '</li>' +
                        '<li class="divider" ng-if="vm.action !== \'create\'"></li>' +
                        '<li role="menuitem" ng-if="vm.action !== \'create\'"><a href="" ng-click="vm.deleteInstance()">Delete</a></li>' +
                        '</ul>' +
                        '</div>'
                    },

                    /* PRINT */
                    {
                        overflow: 'auto',
                        template: '<div class="btn-group" uib-dropdown dropdown-append-to="\'div[kendo-window=' + controller.windowId + ']\'">' +
                        '<a id="instance-toolbar-print" href="" class="k-button" uib-dropdown-toggle ng-if="!vm.activeState">Print</a>' +
                        '<ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="instance-toolbar-print">' +
                        '<li role="menuitem"><a href="" ng-click="vm.printInstanceNormal()">Normal</a></li>' +
                        '<li class="divider"></li>' +
                        '<li role="menuitem"><a href="" ng-click="vm.printInstanceLabels()">Labels</a></li>' +
                        '<li role="menuitem"><a href="" ng-click="vm.printInstanceChecks()">Checks</a></li>' +
                        '<li class="divider"></li>' +
                        '<li role="menuitem"><a href="" ng-click="vm.exportInstance()">Export As...</a></li>' +
                        // '<li role="menuitem"><a href="" ng-click="vm.exportInstance(\'png\')">Export PNG</a></li>' +
                        // '<li role="menuitem"><a href="" ng-click="vm.exportInstance(\'svg\')">Export SVG</a></li>' +
                        '</ul>' +
                        '</div>'
                    },

                    /* ACTIONS */
                    {
                        overflow: 'auto',
                        template: '<div class="btn-group" uib-dropdown dropdown-append-to="\'div[kendo-window=' + controller.windowId + ']\'">' +
                        '<a id="instance-toolbar-actions" href="" class="k-button" uib-dropdown-toggle>Actions</a>' +
                        '<ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="instance-toolbar-actions">' +
                        
                        '<li class="divider" ng-if="!vm.activeState && vm.instance.workflowObjects[vm.instance.currentWorkflowObjectId].model.pushAct.actionEmail"></li>' +
                        '<li role="menuitem" ng-if="!vm.activeState && vm.instance.workflowObjects[vm.instance.currentWorkflowObjectId].model.pushAct.actionEmail">' +
                        '<a href="" ng-click="vm.pushActionInstance(\'actionEmail\')">' +
                        '<div class="fa-stack"><i class="fa fa-fw fa-lg fa-envelope-o fa-stack-1x"></i></div>'+
                        '{{(vm.instance.workflowObjects[vm.instance.currentWorkflowObjectId].model.pushAct.actions.email.menutitle)}}</a></li>' +
                        
                        '<li class="divider" ng-if="vm.action !== \'create\'"></li>' +
                        '<li role="menuitem" ng-if="navFunctions.getPrevious && vm.dataSetLoaded">' +
                        '<a href="" ng-click="navFunctions.getPrevious(vm)">Previous</a>' +
                        '</li>' +
                        '<li role="menuitem" ng-if="navFunctions.getNext && vm.dataSetLoaded">' +
                        '<a href="" ng-click="navFunctions.getNext(vm)">Next</a>' +
                        '</li>' +
                        '<li class="divider" ng-if="(navFunctions.getNext || navFunctions.getPrevious) && vm.dataSetLoaded"></li>' +
                        '<li role="menuitem"><a href="" ng-click="vm.expandAll()">Expand All</a></li>' +
                        '<li role="menuitem"><a href="" ng-click="vm.collapseAll()">Collapse All</a></li>' +
                        '<li class="divider" ng-if="vm.instance.widgetSettings.recurrence.modelId"></li>' +
                        '<li role="menuitem" ng-if="vm.instance.widgetSettings.recurrence.modelId">' +
                        '<a href="" ng-click="_openRecurrenceWindow()">Repeat</a>' +
                        '</li>' +
                        '<li class="divider" ng-if="\'vm.instance.widgetSettings.enableInstanceRelationship === true\'"></li>' +
                        '<li role="menuitem" ng-if="\'vm.instance.widgetSettings.enableInstanceRelationship === true\'">' +
                        '<a href="" ng-click="_openRelationshipWindow()">Relate</a>' +
                        '</li>' +
                        '</ul>' +
                        '</div>'
                    },

                    /* REVISIONS */
                    {
                        overflow: 'auto',
                        template: '<div class="btn-group" uib-dropdown dropdown-append-to="\'div[kendo-window=' + controller.windowId + ']\'" ng-if="vm.action !== \'create\'">' +
                        '<a id="instance-toolbar-revisions" href="" class="k-button" uib-dropdown-toggle>Revisions: {{vm.instance.recordRevision.length || 0}}</a>' +
                        '<ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="instance-toolbar-revisions">' +
                        '<li role="menuitem" ng-repeat="rev in vm.instance.recordRevision | orderBy: \'createDate\'">' +
                        '<a href="" ng-click="vm.revisionOnClick(rev)">{{::(rev.createDate | kendoFormat:\'{0:MM/dd/yyyy h:mm tt}\')}} - {{::rev.createBy}}</a>' +
                        '</li>' +
                        '</ul>' +
                        '</div>'
                    },

                    /* PARTICIPANTS */
                    {
                        overflow: 'auto',
                        template: '<div class="btn-group" uib-dropdown dropdown-append-to="\'div[kendo-window=' + controller.windowId + ']\'" ng-if="vm.action !== \'create\'">' +
                        '<a id="instance-toolbar-participants" href="" class="k-button" uib-dropdown-toggle>Participants: {{vm.participants.length || 0}}</a>' +
                        '<ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="instance-toolbar-participants">' +
                        '<li role="menuitem" ng-repeat="p in vm.participants">' +
                        '<a href="" ng-click="$event.preventDefault()">{{::p.name}}</a>' +
                        '</li>' +
                        '</ul>' +
                        '</div>'
                    }
                ]
            };
        }

        function deleteInstanceModal(idArray, closeWindowCallback){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: '<strong>Are you sure you want to delete the record(s) FOREVER?</strong>',
                actionButtonText: 'Delete ' + idArray.length + ' record(s)',
                closeButtonText: 'Cancel',
                confirm: function () {
                    InstancesService.hardDelete(idArray).then(function () {
                        $timeout(function(){
                            closeWindowCallback();
                        });
                    });
                },
                check: function () {
                    return true;
                }
            });
        }

        /**
         * Opens push action configuration modal to set custom parameters
         * @param sourceInstanceId - source instance where user push action was executed
         * @param actionType - push action title (action type that was exec uted)
         * @param pushActionStruct - entire structure of current push action structure. It will be used in modal controller
         * @returns {Promise}
         */
        function pushActionInstanceModal(InstanceId, actionType, pushActionStruct){
            var pushActionModal = $uibModal.open({
                templateUrl: 'ui/nim-push-action/push-action-modal.tpl.html',
                controller: 'InstancePushActionCtrl',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    InstanceId: _.constant(InstanceId || ''),
                    actionType: _.constant(actionType || ''),
                    pushActionStruct: _.constant(pushActionStruct || {})
                }
            });

            return pushActionModal.result;
        }

        /**
         * Joins old populateFormData and parseFormulaFields functions
         * Populates dataSet and fieldOptions with existing data and sets up calculations
         * @param {string} state - workflow object id (key)
         * @param {array} formsArray - workflowObject.model.forms
         * @param {object} dataSet
         * @param {object} fieldOptions
         * @param {function} calculationWatcherFunc - Creates watcher for calculated fields
         * @param {function} sectionWatcherFunc - Creates watcher for section conditions
         * @param {function} fieldConditionWatcherFunc - Creates watcher for form object conditions
         * @param {function} autoFillWatcherFunc - Creates watcher for auto-populating fields
         * @returns {Function} - Call this when ready to create watchers
         */
        function populateDataAndParseFormulas(state, formsArray, dataSet, fieldOptions, calculationWatcherFunc, sectionWatcherFunc, fieldConditionWatcherFunc, autoFillWatcherFunc){
            var data = {},
                options = {},
                createWatchers = [];

            _.forEach(formsArray, function (form) {
                var formOriginId = form.originatorId;

                // Set data from existing data (supplied by server; empty if creating)
                _.assign(data, form.defaultDataSet);

                // Set fieldOptions (for dropdown)
                if(form.fieldOptions){
                    _.assign(options, form.fieldOptions);
                }

                _.forEach(form.form.sections, function (section) {
                    createWatchers.push(
                        _.partial(sectionWatcherFunc, state, formOriginId, section)
                    );
                });

                //Parse Formulas
                _.forEach(form.form.objects, function (formObj) {
                    if(formObj.model.config.type === 'datetime'){
                        data[formObj.model.config.modelId] = new Date(data[formObj.model.config.modelId]);
                    }

                    if(formObj.model.option.type !== 'custom' && !_.isEmpty(formObj.model.option.autoFill)){
                        createWatchers.push(
                            _.partial(autoFillWatcherFunc, state, formObj.model.config.modelId, formObj.model.param.filter, formObj.model.option)
                        );
                    }

                    if(formObj.model.calculation.formula){
                        var resultObj = {
                            id: formOriginId,
                            model: formObj.model.config.modelId,
                            section: formObj.model.display.section,
                            condition: formObj.model.param.condition,
                            conditionalAction: formObj.model.param.conditionalAction,
                            conditionalLogic: formObj.model.param.conditionalLogic
                        };

                        if(formObj.model.config.type === 'readonly'){
                            var val = CalculationService.calculate(formObj.model.calculation.tokens).value;
                            data[resultObj.model] = CalculationService.toDate(val);
                        }
                        else {
                            var tokenArr = nimCalcService.parse(formObj.model.calculation.formula).items,
                                operands = [];

                            _.forEach(tokenArr, function (token, i) {
                                if (token.type === 'operand' && token.subtype === 'range' && token.value) {
                                    var operand = token.value,
                                        pathComponents = operand.split('.'),
                                        modelId = _.head(pathComponents),
                                        tokValArr = modelId.split('_');

                                    token.value = '';

                                    pathComponents[0] = _.last(tokValArr);

                                    var operandModelId = pathComponents.join('.');

                                    operands.push({
                                        index: i,
                                        modelId: _.trim(operandModelId)
                                    });
                                }
                             });

                            if(operands.length > 0){
                                createWatchers.push(
                                    _.partial(calculationWatcherFunc, state, resultObj, operands, tokenArr)
                                );
                            }
                            else {
                                // If there are no fields in the formula, add the calculated value to the dataSet
                                createWatchers.push(
                                    _.partial(pseudoWatcher, data, resultObj.model, tokenArr)
                                );
                            }
                        }
                    }

                    if(!formObj.model.config.modelId){
                        var guid = DesignerUtilityService.generateGuid();
                        formObj.model.config.modelId = kendo.format('__nim_static_text_{0}', guid);
                    }

                    createWatchers.push(
                        _.partial(fieldConditionWatcherFunc, state, formOriginId, formObj.model)
                    );
                });
            });

            if(!fieldOptions[state]){
                fieldOptions[state] = {};
            }

            _.assign(fieldOptions[state], options);

            if(!dataSet[state]){
                dataSet[state] = {};
            }

            _.defaultsDeep(dataSet[state], data);

            // Returns function to set watchers so they don't get set before the dataSet is ready.
            return function(){
                return _.map(createWatchers, function(fn){
                    return fn();
                });
            };
        }

        function pseudoWatcher(dataSet, modelId, tokenArray){
            var value = dataSet[modelId];

            if(_.isNull(value) || value === ''){
                var result = CalculationService.calculate(tokenArray);
                if(result.type !== 'error') {
                    dataSet[modelId] = result.value;
                }
            }

            return angular.noop;
        }

        /**
         * addFormObjects
         * @param instanceFormArray
         * @param formData
         */
        function addFormObjects(instanceFormArray, formData){
            for(var i = 0; i < instanceFormArray.length; i++){
                instanceFormArray[i] = angular.extend(instanceFormArray[i], formData[i]);
            }
        }

        /**
         * parseDefaultData
         * @param workflowObjects
         * @param state
         * @param instanceWorkflowData
         */
        function parseDefaultData(workflowObjects,state,instanceWorkflowData){
            if(workflowObjects[state].model.defaultData){
                for (var sId in workflowObjects[state].model.defaultData) {
                    for (var f in workflowObjects[sId].model.forms) {
                        if(workflowObjects[state].display.order == "-1"){
                            for(var f2 in workflowObjects[state].model.forms){
                                if(f.originatorId == f2.originatorId){
                                    f2.defaultDataSet = angular.copy(f.defaultDataSet);
                                }
                            }
                        }
                        else{
                            for(var d in instanceWorkflowData[sId].defaultData){
                                f.defaultDataset[d] = instanceWorkflowData[sId].defaultData[d];
                            }
                        }

                    }
                }
            }
        }

        function openAdvSelPage(scope, /*tableData,*/ cb) {
            var advSelConfig = scope.nimFormObject.param.advSel;
            var html = '<div kendo-window="adv_sel_window" k-options="advSelWindowOptions">' +
                '<div nim-advanced-selection nim-page-id="' + advSelConfig.pageId + '" nim-page-object-id="' + advSelConfig.pageObjectId + '"></div>' +
                '</div>';
            var windowScope = scope.$new();
            windowScope.advSelWindowOptions = service.buildWindowOptions(windowScope, null, function () {
                if (windowScope.selectedData && angular.isFunction(cb)) {
                    cb(windowScope.selectedData);
                    }
            });

            windowScope.advSelWindowOptions.title = scope.nimFormObject.label.text;
            windowScope.advSelWindowOptions.actions = ['Close'];
            windowScope.advSelWindowOptions.autoFocus = true;
            windowScope.advSelWindowOptions.dragstart = function (e) {
                e.sender.element.parent().css('opacity', 0.7);
                e.sender.element.find('[nim-advanced-selection]').css('opacity', 0);
            };
            windowScope.advSelWindowOptions.dragend = function (e) {
                e.sender.element.parent().css('opacity', 1);
                e.sender.element.find('[nim-advanced-selection]').css('opacity', 1);
            };

            var originalCloseHandler = windowScope.advSelWindowOptions.close || angular.noop;
            windowScope.advSelWindowOptions.close = function (e) {
                windowScope.$broadcast('nim-remove-page-objects');

                // Call original handler
                originalCloseHandler(e);
            };

            windowScope.advSelConfig = advSelConfig;

            if (scope.nimFormObject.config.type === 'table'){
                var idField = '';

                if (advSelConfig.baseLookup) {
                    idField = advSelConfig.baseLookup.replace(/_display$/, '.id').replace(/^__/, '');
                }

                windowScope.columns = angular.copy(scope.nimFormObject.tag.inner);
                // windowScope.defaultRows = _.reject(tableData, '__nimDelete');
                // windowScope.defaultData = _.map(windowScope.defaultRows, function (tableItem) {
                //     if (idField) {
                //         return _.get(tableItem.__nimData, idField);
                //     }
                //     return tableItem.__instanceId || tableItem.id;
                // });
            }
            else {
                windowScope.columns = [{field: 'display', title: scope.nimFormObject.label.text, type: 'string'}];
                // windowScope.defaultRows = [];
                // windowScope.defaultData = [];
                
                // if (!_.isEmpty(tableData)) {
                //     windowScope.defaultRows = [angular.copy(tableData)];
                //     windowScope.defaultData = [tableData.id];
                // }
            }

            // Open Window
            service.windowArea.append(html);
            $compile(service.windowArea.find('div[kendo-window="adv_sel_window"]'))(windowScope);
        }

        function pickShownFields(dataSet, origDataSet, forms, sectionsShown, fieldsShown){
            var fields = ['nimupload'];
            // var removedFields = [],
            //     removedDataSeries = [];

            _.forEach(forms, function(f){
                var formSectionsShown = sectionsShown[f.originatorId];

                _.forEach(f.form.objects, function(formObj){
                    var modelId = formObj.model.config.modelId;

                    if(!modelId || fields.indexOf(modelId) >= 0){
                        return;
                    }

                    var section = formObj.model.display.section,
                        sectionShown = formSectionsShown[section];

                    if(!section || section === '__nimHiddenSection'){
                        sectionShown = true;
                    }

                    if(fieldsShown[modelId] && sectionShown){
                        fields.push(modelId);
                        // _.remove(removedFields, modelId);
                        // _.remove(removedDataSeries, modelId);

                        if (formObj.model.config.type === 'multiselect') {
                            var origValues = _.get(origDataSet, modelId, []),
                                newValues = _.get(dataSet, modelId, []);
                            _.forEach(origValues, function (item) {
                                var origInstanceId = item.__instanceId,
                                    origId = _.get(item, [formObj.model.param.lookup, 'id']);
                                var newItem = _.find(newValues, function (n) {
                                    return n.__instanceId == origInstanceId || n.id == origId;
                                });
                                if (!newItem) {
                                    newValues.push({
                                        __instanceId: item.__instanceId,
                                        __nimDelete: true
                                    });
                                }
                            });
                        }
                    }
                    // else if(formObj.model.config.dataType === 'dataseries') {
                    //     removedDataSeries.push(modelId);
                    // }
                    // else {
                    //     removedFields.push(modelId);
                    // }
                });
            });

            var finalDataSet = _.pick(dataSet, fields);

            // _.forEach(removedDataSeries, function (modelId) {
            //     var existingRows = _.filter(dataSet[modelId], '__instanceId');
            //     finalDataSet[modelId] = _.map(existingRows, function (row) { 
            //         row.__nimDelete = true;
            //         return row;
            //     });
            // });

            // _.forEach(removedFields, function (modelId) { 
            //     finalDataSet[modelId] = '';
            // });

            return finalDataSet;
        }

        function openConfirmInstanceCloseModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'core/instances/instances-confirm-close-modal.tpl.html',
                controller: 'InstanceConfirmCloseCtrl',
                controllerAs: 'vm',
                backdropClass: 'confirm',
                windowClass: 'modal-confirm',
                backdrop: 'static'
            });

            return modalInstance.result;
        }
    }])
;

angular.module('cerberus.core')
    .controller('NimAdvancedSelectionCtrl', ["_", "kendo", "$scope", "$rootScope", "$attrs", "$timeout", "PagesService", function(_, kendo, $scope, $rootScope, $attrs, $timeout, PagesService){
        var vm = this;

        vm.pageId = $attrs['nimPageId'];
        vm.pageObjectId = $attrs['nimPageObjectId'];
        vm.defaultFilters = _.get($scope.nimFormObject, 'param.advSel.filterMap', []);
        vm.data = [];
        vm.dataSource = new kendo.data.DataSource({
            data: []
        });
        vm.loading = true;

        $scope.selectedData = false;
        $scope.filters = {};
        $scope.defaultFilter = {};

        vm.addSelection = addSelection;
        vm.cancel = closeWindow;

        PagesService.getPage(vm.pageId).then(init);

        $scope.$on('nim-advanced-selection-updated', function(e, data){
            e.preventDefault();
            e.stopPropagation();

            if($scope.nimFormObject.config.type === 'table'){
                vm.data = _.map(data, function (dataItem) {
                    var mappedDataItem = {};

                    if(dataItem){
                        _.forIn($scope.advSelConfig.map, function (val, key) {
                            mappedDataItem[key] = dataItem[val];
                        });

                        if($scope.advSelConfig.baseLookup){
                            var idFieldName = $scope.advSelConfig.baseLookup.replace(/_display$/, '_id');
                            mappedDataItem[idFieldName] = dataItem.id;
                        }
                    }

                    return mappedDataItem;
                });

            }
            else if($scope.nimFormObject.config.type === 'select') {
                var dataItem = _.last(data),
                    idField = $scope.advSelConfig.map.id || 'id';

                if (dataItem) {
                    vm.data = [{
                        id: dataItem[idField],
                        display: dataItem[$scope.advSelConfig.map.display]
                    }];
                }
                else {
                    vm.data = [];
                }
            }

            if(vm.dataSource) {
                vm.dataSource.data(vm.data);
            }
        });

        function init(pageModel){
            vm.pageModel = pageModel;
            vm.gridsterOptions = {
                mobileBreakPoint: 768,
                margins: _.get(pageModel, 'options.gridsterConfig.margins', [15, 15]),
                outerMargin: _.get(pageModel, 'options.gridsterConfig.outerMargin', true),
                pushing: true
            };

            // Protects against potential issue with gridster margins being saved as an object instead of an array
            if(!_.isArray(vm.gridsterOptions.margins)){
                vm.gridsterOptions.margins = [
                    vm.gridsterOptions.margins[0],
                    vm.gridsterOptions.margins[1]
                ];
            }

            vm.loading = false;

            vm.sourceObject = _.find(pageModel.items, 'id', vm.pageObjectId);

            if(vm.sourceObject){
                var columns = $scope.columns || [];

                columns.push({
                    command: [
                        {
                            name: 'removeRecord',
                            text: 'Remove',
                            className: 'btn btn-sm btn-danger',
                            click: removeRecord
                        }
                    ],
                    title: ' ',
                    width: '85px'
                });

                vm.gridOptions = {
                    editable: false,
                    filterable: false,
                    columnMenu: false,
                    columns: columns,
                    dataSource: vm.dataSource
                };
            }

            _.forEach(vm.defaultFilters, function(filterObj){
                $scope.defaultFilter[filterObj.filter.id] = $scope.dataSet[filterObj.modelId];
            });
        }

        function removeRecord(e){
            e.preventDefault();

            var row = $(e.target).closest("tr");
            var uid = row.data('uid');
            var dataItem = vm.dataSource.getByUid(uid);

            $timeout(function(){
                _.remove(vm.data, 'id', dataItem.id);
                vm.dataSource.remove(dataItem);
            });
        }

        function addSelection(){
            if($scope.nimFormObject.config.type === 'table'){
                $scope.selectedData = vm.data;
            }
            else if($scope.nimFormObject.config.type === 'select') {
                $scope.selectedData = _.head(vm.data);
            }

            closeWindow();
        }

        function closeWindow() {
            $scope['adv_sel_window'].close();
        }

        $scope.$on('auth:loginCancelled', function () {
            $timeout(function(){
                closeWindow();
            });
        });
    }])
    .directive('nimAdvancedSelection', function(){
        return {
            restrict: 'AE',
            templateUrl: 'core/instances/advanced-selection-page.tpl.html',
            controller: 'NimAdvancedSelectionCtrl',
            controllerAs: 'vm'
        };
    })
;
/**
 * EXAMPLE
 *
 * <div nim-instance="OtherCtrl.instanceWindow" nim-action="" nim-id="" nim-widget-id=""></div>
 *
 */
angular.module('cerberus.core')
    .controller('NimInstanceCtrl', ["_", "kendo", "moment", "apiPath", "$scope", "$attrs", "$element", "$rootScope", "$timeout", "$window", "$log", "InstancesService", "InstancesWindowService", "WidgetsService", "CalculationService", "checkPrintingService", "DeviceSniffService", "draftsService", "FormsService", "FormValidationService", "labelPrintingService", "normalPrintingService", "printService", "ExportService", "usersProfileService", function NimInstanceCtrl(_, kendo, moment, apiPath, $scope, $attrs, $element, $rootScope, $timeout, $window, $log, InstancesService,
                                                            InstancesWindowService, WidgetsService, CalculationService, checkPrintingService, DeviceSniffService, draftsService,
                                                            FormsService, FormValidationService, labelPrintingService, normalPrintingService, printService, ExportService, usersProfileService) {
        var vm = this;

        vm.instanceId = $attrs.nimId;
        vm.draftId = $attrs.nimDraftId;
        vm.widgetId = $attrs.nimWidgetId;
        vm.windowId = $attrs.nimWindowId;
        vm.action = $attrs.nimAction;
        vm.revisionId = $attrs.nimRevisionId;
        vm.validateOnOpen = $attrs.nimValidateOnOpen;
        vm.downloadApiPath = apiPath + 'download';
        vm.window = $scope[vm.windowId];
        vm.title = vm.window.title();
        vm.isSubForm = _.startsWith(vm.windowId, 'sub_form');
        vm.windowTitle = vm.isSubForm ? _.get($scope.subWindowOptions, 'title') : _.get($scope.windowOptions, 'title');
        vm.isAdmin = $rootScope.userData.currentWorkspace.isAdmin;
        vm.readingNewRecord = false; // For record that has been added to a form table, but not saved
        /* Data Containers */
        vm.instance = {};  // This holds the data returned by the server
        vm.states = [];  // This array is used for display all the states; holds workflowObject ids
        vm.relationships = [];
        vm.participants = [];
        /* Form Edit Data Containers */
        vm.orig = {}; // holds the original data for each state
        vm.temp = {}; // holds the current/edited data for each state
        vm.fieldOptions = {};  // This object holds dropdown values.
        vm.filters = {};  // Used to hold filters when one dropdown affects another.

        /* UI Variables */
        vm.excludeModelId = null; // This is the modelId to exclude from building when acting as a subform.
        vm.isProcessingUploads = false; // Used to prevent submission of a form while uploads are in progress.
        vm.createState = null; // Holds the workflowObject Id (or key) of the state that is being created/progressed
        vm.loading = true; // Used to display loading bar
        vm.forbidden = false; // Used to display warning if user lacks permission to view instance
        vm.forbiddenState = false; // Used to display warning if user lacks permission to view state
        vm.dataLoading = {};
        vm.dataSetLoaded = false;
        vm.formDoneLoading = {};
        vm.updating = false;
        vm.invalid = false;
        vm.edit = {}; // controls which state is currently being edited
        vm.activeState = null;
        vm.collapse = {}; // controls collapsing of different states
        vm.selectedForm = {}; // determines which form is selected in which state
        vm.autoFilling = {};
        vm.autoFilledFields = {};
        vm.showAutoFillScreen = false;
        //vm.toolbarOptions = {};
        vm.userData = {};
        vm.sectionsShown = {};
        vm.fieldsShown = {};
        vm.instanceForms = {};
        vm.formObjectsInvalid = {};
        vm.autoFillData = {};
        vm.formIsActive = {};

        /* Window Functions */
        vm.closeWindow = _closeWindow;

        /* Form Functions */
        vm.editState = _editState;
        vm.openInstanceWindow = _openInstanceWindow;
        vm.selectForm = _selectForm;
        vm.isUnchanged = _isUnchanged;
        vm.submitForm = _submitForm;
        vm.updateInstanceAttrs = _updateInstanceAttrs;
        vm.saveDraft = _saveDraft;
        vm.cancelState = _cancelState;
        vm.deleteFile = _deleteFile;
        vm.getDownloadKey = _getDownloadKey;

        /* Toolbar Functions */
        vm.newInstance = _newInstance;
        vm.duplicateInstance = _duplicateInstance;
        vm.deleteInstance = _deleteInstance;
        vm.cancel = _cancel;
        vm.pushActionInstance = _pushActionInstance; // Used to control push actions, (complex push-actions executed from toolbar menu).
        vm.collapseAll = _collapseAll;
        vm.expandAll = _expandAll;
        vm.revisionOnClick = _revisionOnClick;
        vm.updateSchema = _updateSchema;
        vm.exportInstance = _exportInstance;
        vm.printInstanceNormal = _printInstanceNormal;
        vm.printInstanceChecks = _printInstanceChecks;
        vm.printInstanceLabels = _printInstanceLabels;
        vm.printInstanceSingleStateForm = _printInstanceSingleStateForm;

        /*Sub Form Functions*/
        vm.subFormCreate = _subFormCreate;

        vm.getParticipantInfo = _getParticipantInfo;

        /* Filters */
        vm.sectionFilter = FormsService.sectionFilter;

        vm.tabOnFocus = tabOnFocus;
        vm.tabOnBlur = tabOnBlur;

        vm.showFileSize = _showFileSize;
        vm.gridsterItemOptions = gridsterItemOptions;

        vm.dynamicGridsterOptions = {
            pushing: true,
            swapping: false,
            floating: true
        };

        vm.staticGridsterOptions = {
            pushing: true
        };

        vm.deregisterFunc = [];

        // Printer Variables
        $scope.pageCounter = '####';
        $scope.pageCurrent = '#';
        $scope.pageTotal = '#';

        vm.isProcessingPdf = false;
        vm.isStatePrinting = {};

        vm.init = _init;

        //Init the controller
        _init();
        ////////////////////

        $scope.$on('nimSignatureAccepted', function(e, data){
            vm.sigData = data;
        });
        /**
         * This grand function preps the instance window with all UI variables and form data.
         * Admittedly this is a heavy function and could use some clever optimization. ~ O(N(N + N^3))
         * @private
         */

        function _init() {
            clearWatchers();

            // Reset these values on "Submit" or "Submit & New"
            vm.instanceId = $attrs.nimId;
            vm.action = $attrs.nimAction;
            vm.validateOnOpen = $attrs.nimValidateOnOpen;
            vm.instance = {};
            vm.states = [];
            vm.relationships = [];
            vm.participants = [];
            vm.orig = {};
            vm.temp = {};
            vm.fieldOptions = {};
            vm.filters = {};
            vm.excludeModelId = null;
            vm.isProcessingUploads = false;
            vm.createState = null;
            vm.loading = true;
            vm.forbidden = false;
            vm.dataLoading = {};
            vm.formDoneLoading = {};
            vm.updating = false;
            vm.edit = {};
            vm.activeState = null;
            vm.collapse = {};
            vm.selectedForm = {};
            vm.userData = {};
            vm.autoFilling = {};
            vm.autoFilledFields = {};
            vm.showAutoFillScreen = false;
            vm.dataSetLoaded = false;
            vm.deregisterFunc = [];
            vm.sectionsShown = {};
            vm.fieldsShown = {};
            vm.fieldsActive = {};
            vm.fieldsRequired = {};
            vm.instanceForms = {};
            vm.formObjectsInvalid = {};
            vm.formIsActive = {};

            if ($attrs.nimReadingNew) {
                vm.readingNewRecord = $scope.$eval($attrs.nimReadingNew);
            }

            if (vm.instanceId) {
                InstancesService.getInstanceParticipants(vm.instanceId).then(function (participants) {
                    vm.participants = participants.participants;
                });
            }

            if (vm.action === 'create') {
                WidgetsService.getFirstState(vm.widgetId).then(function (data) {
                    _.remove(data.workflowObjects[1].model.forms, function (form) {
                        return !_.isObject(form) || _.isEmpty(form);
                    });

                    var firstState = "1";

                    if (vm.windowId && !vm.title) {
                        var window = $scope[vm.windowId];
                        if (!window.title()) {
                            vm.title = data.widgetName;
                            window.title(data.widgetName);
                        }
                    }

                    // Populate controller variables
                    vm.instance = data;
                    vm.states = [firstState];

                    // Enable the edit template
                    vm.createState = firstState;
                    vm.edit[firstState] = true;
                    vm.activeState = firstState;
                    vm.collapse[firstState] = false;
                    vm.selectedForm[firstState] = 0;
                    vm.sectionsShown[firstState] = {};

                    if (!vm.instance.widgetSettings.defaultAction) {
                        vm.instance.widgetSettings.defaultAction = vm.instance.widgetSettings.defaultSubmitAndNew ? 'submitAndNew' : 'submitAndClose';
                    }

                    // If a sub-form
                    if (vm.isSubForm) {
                        var setExcludeField = function (value) {
                            for (var i = 0; i < data.workflowObjects[vm.activeState].model.forms.length; i++) {
                                if (data.workflowObjects[vm.activeState].model.forms[i].defaultDataSet[vm.excludeModelId]) {

                                    if (_.isEmpty(vm.orig[vm.activeState])) {
                                        vm.orig[vm.activeState] = {};
                                    }

                                    vm.orig[vm.activeState][vm.excludeModelId] = value;
                                }
                            }
                        };

                        vm.excludeModelId = $scope.nimFormObject.param.fk;
                        //Editing a data item
                        if ($scope.editSubData) {
                            vm.orig[vm.activeState] = angular.copy($scope.editSubData).__nimData;
                            vm.instance.workflowObjects[vm.activeState].model.forms[vm.selectedForm[vm.activeState]].fileAttachments = angular.copy($scope.editSubData).__attachments || [];
                        }
                        ////set display to current value when adding a new item in an update
                        if ($scope.nimFormObject.__meta && $scope.nimFormObject.__meta.sub && $scope.nimFormObject.__meta.sub[vm.excludeModelId]) {
                            setExcludeField($scope.nimFormObject.__meta.sub[vm.excludeModelId]);
                        }
                        //// Set display value to 'Auto' on the linking modelId when in a create
                        else if (vm.excludeModelId) {
                            setExcludeField({ display: 'Auto' });
                        }
                    }

                    _.forEach(data.workflowObjects[vm.activeState].model.forms, function (form) {
                        vm.sectionsShown[firstState][form.originatorId] = {};
                    });

                    var setWatchersFunc = InstancesWindowService.populateDataAndParseFormulas("1", data.workflowObjects["1"].model.forms, vm.orig, vm.fieldOptions, calculationWatcher, sectionConditionWatcher, fieldConditionWatcher, autoFillWatcher);

                    //Check default data, TODO: auto fill needs to work too
                    if (!vm.readingNewRecord && !(vm.isSubForm && $scope.editSubData) && $scope.defaultData && $scope.defaultData.length > 0) {
                        for (var i = 0; i < $scope.defaultData.length; i++) {
                            var d = _.get($scope.defaultData[i], 'data.value');

                            if ($scope.defaultData[i].field.isLookup || $scope.defaultData[i].field.isCustomLookup) {
                                d = { id: _.get($scope.defaultData[i], 'data.value') };

                                if (_.has($scope.defaultData[i], 'data.lookupDisplay')) {
                                    d.display = $scope.defaultData[i].data.lookupDisplay;
                                }
                                // For table filters
                                else if (_.has($scope.defaultData[i], 'data.dataItem')) {
                                    d.display = _.get($scope.defaultData[i].data.dataItem, $scope.defaultData[i].field.lookupCol);
                                }
                            }

                            vm.orig[1][$scope.defaultData[i].field.modelId] = d;

                            fieldAutoFilled(1, $scope.defaultData[i].field.modelId);
                        }
                    }

                    // Add Toolbar
                    vm.toolbarOptions = InstancesWindowService.buildToolbar($scope, vm);

                    // Retrieve Drafts
                    if (vm.draftId) {
                        draftsService.get(vm.draftId).then(function (draftData) {
                            InstancesService.getDraft(draftData, vm.orig[firstState], vm.instance.workflowObjects[1].model.forms[vm.selectedForm[1]]);
                            _.assign(vm.temp, angular.copy(vm.orig));
                            vm.deregisterFunc = vm.deregisterFunc.concat(setWatchersFunc());

                            if (vm.validateOnOpen) {
                                $timeout(function () {
                                    vm.instanceForms[firstState].$setSubmitted(true);
                                    validateState(firstState);
                                    focusFirstInvalidForm(firstState);
                                }, 1);
                            }

                            // Stop loading
                            vm.loading = false;
                            vm.dataSetLoaded = true;

                            // Wait until first round of calculations has finished to copy temp to orig
                            $timeout(function () {
                                _.assign(vm.orig, angular.copy(vm.temp));
                            }, 100);
                        });
                    }
                    else {
                        $timeout(function () {
                            _.assign(vm.temp, angular.copy(vm.orig));
                            vm.deregisterFunc = vm.deregisterFunc.concat(setWatchersFunc());

                            // Stop loading
                            vm.loading = false;
                            vm.dataSetLoaded = true;
                        });

                        if (vm.validateOnOpen) {
                            $timeout(function () {
                                vm.instanceForms[firstState].$setSubmitted(true);
                                validateState(firstState);
                                focusFirstInvalidForm(firstState);
                            }, 1);
                        }

                        // Wait until first round of calculations has finished to copy temp to orig
                        $timeout(function () {
                            _.assign(vm.orig, angular.copy(vm.temp));
                        }, 100);
                    }
                },
                    function (response) {
                        vm.loading = false;
                        vm.forbidden = response['STATUS'] === 'Forbidden';
                    });
            }
            else if (vm.action === 'read' || vm.action === 'readonly') {
                InstancesService.getInstance(vm.instanceId).then(function (data) {
                    if (vm.windowId && !vm.title) {
                        var window = $scope[vm.windowId];

                        if (!window.title()) {
                            vm.title = data.widgetName;
                            window.title(data.widgetName);
                        }
                    }

                    _.forEach(data.recordRevision, function (rev) {
                        rev.createDate = moment.utc(rev.createDate, 'MMMM, DD YYYY HH:mm:ss').local().toDate();
                    });

                    // Populate controller variables
                    vm.instance = data;
                    vm.widgetId = data.widgetId;
                    vm.states = angular.copy(data.workflowPath).reverse(); // Reverse the copy, not the original

                    if (_.get(data, 'widgetSettings.enableInstanceRelationship') === true) {
                        InstancesService.getRelationships(vm.instanceId).then(function (relationships) {
                            vm.relationships = angular.copy(relationships);
                        });
                    }

                    if (!vm.instance.widgetSettings.defaultAction) {
                        vm.instance.widgetSettings.defaultAction = vm.instance.widgetSettings.defaultSubmitAndNew ? 'submitAndNew' : 'submitAndClose';
                    }

                    // If the last state recorded in the workflowPath is not equal to the state (not at a terminus)
                    if (data.workflowPath[data.workflowPath.length - 1] !== data.currentWorkflowObjectId) {
                        if (data.workflowObjects[data.currentWorkflowObjectId]) {
                            // Add the current state to the front.
                            vm.states.unshift(data.currentWorkflowObjectId);
                            vm.createState = data.currentWorkflowObjectId;
                            // Enable the edit template
                            var editableState = !data.workflowObjects[data.currentWorkflowObjectId].model.isFinal || data.workflowObjects[data.currentWorkflowObjectId].model.editable;
                            if (editableState && vm.action !== 'readonly') {
                                // if (!data.workflowObjects[data.currentWorkflowObjectId].model.isFinal && vm.action !== 'readonly') {
                                vm.activeState = data.currentWorkflowObjectId;
                                vm.selectedForm[data.currentWorkflowObjectId] = 0;
                            }
                        }
                    }
                    else if (data.workflowObjects[data.currentWorkflowObjectId].model.isFinal && data.workflowObjects[data.currentWorkflowObjectId].model.editable && vm.action !== 'readonly') {
                        vm.activeState = data.currentWorkflowObjectId;
                        vm.selectedForm[data.currentWorkflowObjectId] = 0;
                    }
                    else if (vm.isSubForm && vm.action !== 'readonly') {
                        vm.activeState = 1;
                    }

                    var forbiddenStates = _.remove(vm.states, function (s) {
                        return !data.workflowObjects[s];
                    });

                    _.forEach(forbiddenStates, function (s) {
                        vm.forbiddenState[s] = true;
                    });

                    if (vm.isSubForm && $scope.editSubData) {
                        vm.orig[vm.activeState] = angular.copy($scope.editSubData.__nimData);
                    }

                    // Populate form data objects & UI controls
                    _.forEach(vm.states, function (state, i) {
                        if (!vm.forbiddenState[state] && data.workflowObjects[state]) {
                            if (!angular.isDefined(vm.edit[state])) {
                                vm.edit[state] = false;
                            }
                            vm.collapse[state] = false;
                            vm.selectedForm[state] = 0;
                            vm.dataLoading[state] = true;
                            vm.formDoneLoading[state] = {};
                            vm.sectionsShown[state] = {};

                            var formChunks = _.chunk(data.workflowObjects[state].model.forms);
                            _.forEach(formChunks, function (formArray, j) {
                                vm.formDoneLoading[state][j] = false;
                                InstancesService.getFormData(vm.instanceId, formArray).then(formDataCallBack(i, j));
                            });
                        }
                    });

                    if (vm.isSubForm && vm.action !== 'readonly') {
                        vm.edit[vm.activeState] = true;
                        vm.excludeModelId = $scope.nimFormObject.param.fk;
                    }

                    // Add Toolbar
                    vm.toolbarOptions = InstancesWindowService.buildToolbar($scope, vm);

                    // Stop loading
                    vm.loading = false;
                }, function (response) {
                    vm.loading = false;
                    vm.forbidden = response === 'Forbidden';
                });
            }
            else if (vm.action === 'revision') {
                InstancesService.getRevision(vm.revisionId).then(function (data) {
                    if (vm.windowId && !vm.title) {
                        var window = $scope[vm.windowId];
                        if (!window.title()) {
                            vm.title = data.widgetName;
                            window.title(data.widgetName);
                        }
                    }

                    // Populate controller variables
                    vm.instance = data;
                    vm.states = angular.copy(data.workflowPath).reverse();

                    if (vm.instanceId && _.get(data, 'widgetSettings.enableInstanceRelationship') === true) {
                        InstancesService.getRelationships(vm.instanceId).then(function (relationships) {
                            vm.relationships = angular.copy(relationships);
                        });
                    }

                    if (!vm.instance.widgetSettings.defaultAction) {
                        vm.instance.widgetSettings.defaultAction = vm.instance.widgetSettings.defaultSubmitAndNew ? 'submitAndNew' : 'submitAndClose';
                    }

                    // Populate form data objects & UI controls
                    _.forEach(vm.states, function (state, i) {
                        if (!angular.isDefined(vm.edit[state])) {
                            vm.edit[state] = false;
                        }
                        vm.collapse[state] = false;
                        vm.selectedForm[state] = 0;
                        vm.dataLoading[state] = true;
                        vm.formDoneLoading[state] = {};
                        vm.sectionsShown[state] = {};

                        var formChunks = _.chunk(data.workflowObjects[state].model.forms);
                        _.forEach(formChunks, function (formArray, j) {
                            if (formArray[0].formId) {
                                vm.formDoneLoading[state][j] = false;
                                InstancesService.getFormData(vm.instanceId, formArray, vm.revisionId).then(formDataCallBack(i, j));
                            }
                        });
                    });

                    // Add Toolbar
                    vm.toolbarOptions = InstancesWindowService.buildToolbar($scope, vm);

                    // Stop loading
                    vm.loading = false;
                });
            }
        }

        function formDataCallBack(stateIndex, formIndex){
            return function(result){
                var formData = result.formData;
                var state = vm.states[stateIndex];
                var workflowObject = vm.instance.workflowObjects[state];

                vm.sectionsShown[state][formData[0].originatorId] = {};

                vm.formDoneLoading[state][formIndex] = true;
                vm.dataLoading[state] = !_.every(vm.formDoneLoading[state]);

                if(!_.isEmpty(formData[0])) {
                    if (vm.instance.workflowPath[vm.instance.workflowPath.length - 1] !== vm.instance.currentWorkflowObjectId) {
                        formData[0] = FormsService.processFormData(formData[0], formData[0].defaultDataSet);
                    }
                    else {
                        // Since items are added to gridster one-by-one in the order of the array,
                        // it is important to sort them first to prevent placement issues
                        formData[0].form.objects = FormsService.sortFormObjects(formData[0]);
                    }
                    var setWatchersFunc = InstancesWindowService.populateDataAndParseFormulas(state, formData, vm.orig, vm.fieldOptions, calculationWatcher, sectionConditionWatcher, fieldConditionWatcher, autoFillWatcher);

                    _.defaultsDeep(vm.temp, angular.copy(vm.orig));
                    _.assign(workflowObject.model.forms[formIndex], formData[0]);

                    if (state === vm.createState && workflowObject.model.defaultData) {
                        InstancesWindowService.parseDefaultData(vm.instance.workflowObjects, state, vm.instance.instanceWorkflow);
                    }     

                    if (state === vm.activeState) {
                        vm.edit[vm.activeState] = true;
                    }

                    vm.deregisterFunc = vm.deregisterFunc.concat(setWatchersFunc());
                }
                else {
                    workflowObject.model.forms[formIndex] = {};
                }

                if(!_.some(vm.dataLoading)){
                    vm.dataSetLoaded = true;

                    _.remove(workflowObject.model.forms, function(f) {
                        var form = angular.copy(f);
                        if (_.isObject(form)) {
                            delete form.$$hashKey;
                        }
                        return !_.isObject(form) || _.isEmpty(form);
                    });

                    var viewColumn = _.get(vm.instance, 'widgetSettings.view.column', '');
                    if(vm.action !== 'revision' && viewColumn){
                        var displayVal = getRecordDisplayValue(vm.orig, viewColumn);
                        if(displayVal) {
                            if(_.has(displayVal, 'display')) {
                                displayVal = displayVal.display;
                            }
                            var window = $scope[vm.windowId];
                            var newTitle = vm.title + ': ' + displayVal;
                            window.title(newTitle);
                        }
                    }

                    if (vm.validateOnOpen && vm.action == 'read') {
                        _editState(vm.instance.currentWorkflowObjectId);

                        $timeout(function () {
                            vm.instanceForms[vm.instance.currentWorkflowObjectId].$setSubmitted(true);
                            validateState(vm.instance.currentWorkflowObjectId);
                            focusFirstInvalidForm(vm.instance.currentWorkflowObjectId);
                        }, 1);
                    }
                }
            };
        }

        function getRecordDisplayValue(dataSet, column) {
            if (!column) {
                return '';
            }

            //Remove first portion of string until first undersore is detected.
            var modelId = column.split('_')[1];                   //Issue: 'undefined' will return if undersore is not contained
            //var modelId = column.substr(column.indexOf("_")+1); //Issue: This will eliminate only first occurence and will leave all remaining underscores...
            if(column.indexOf("_").toString() == '-1'){           //Workaround solution: If no underscore is found, leave the string as is.
                modelId = column;
            }

            var flatData = {};
            _.forEach(dataSet, function(state){
                _.assign(flatData, state);
            });

            return flatData[modelId];
        }

        /**
         * TODO:  Try moving this to the InstancesWindowService
         * Creates an angular scope watcher for form field calculations.
         * Passed into InstancesWindowService.parseFormulaFields as a parameter
         * @param state
         * @param resultVar
         * @param operands
         * @param tokenArr
         * @returns {function} - unwatcher function
         */
        function calculationWatcher(state, resultVar, operands, tokenArr) {
            var watchExpressions = [_.partial(resultFieldDisplayed, state, resultVar), function () { return vm.activeState === state; }];
            var delayCalculation = vm.action != 'create' && vm.createState != state; // If this record is not new, don't calculate initially

            _.forEach(operands, function (op) {
                watchExpressions.push(
                    _.partial(operandValue, state, op)
                );
            });

            var watcher = _.partial(evaluateExpressions, watchExpressions);

            // newResults[0] - resultVar is displayed
            // newResults[1] - form is being edited 
            // newResults[>1] - operandValues 
            return $scope.$watch(watcher, function (newResults, oldResults) {
                var isDisplayed = newResults[0],
                    editingForm = newResults[1],
                    operandValues = _.drop(newResults, 2),
                    oldOperandValues = _.drop(oldResults, 2),
                    valueChanged = resultValuesChanged(operands, resultVar, operandValues, oldOperandValues),
                    resultFormExists = _.has(vm.temp, state),
                    resultFieldValue = _.get(vm.temp, state + '.' + resultVar.model),
                    resultFieldSet = (resultFieldValue || resultFieldValue === 0) && !_.isNaN(resultFieldValue) && !(_.isDate(resultFieldValue) && resultFieldValue.toString() === 'Invalid Date'),
                    resultNeedsUpdate = valueChanged || !resultFieldSet,
                    justAutoFilled = _.get(vm.autoFilledFields[state], resultVar.model, false);

                var changedOperands = [];

                if (isDisplayed && resultFormExists && resultNeedsUpdate && !justAutoFilled && editingForm) {
                    // Add each operand's value to the token array
                    _.forEach(operands, function (operand, i) {
                        var token = tokenArr[operand.index],
                            newValue = operandValues[i];

                        if (newValue && vm.autoFillData[operand.modelId]) {
                            newValue = _.merge({}, vm.autoFillData[operand.modelId], newValue);
                        }

                        if (operand.path) {
                            newValue = _.get(newValue, operand.path);
                        }

                        // Checks if empty lookup value
                        if (angular.equals(newValue, {}) || (_.get(newValue, 'id') === '-1')) {
                            newValue = '';
                        }

                        if (!angular.equals(token.value, newValue)) {
                            changedOperands.push(operand.modelId);
                        }

                        token.value = newValue;
                    });

                    if (delayCalculation) {
                        delayCalculation = false;
                        return;
                    }

                    var result = CalculationService.calculate(tokenArr);

                    var resultValue = result.value;

                    if (result.type === 'error') {
                        $log.warn(resultVar.model, '\t', result.value);
                        resultValue = '';
                    }
                    else if (_.isNumber(resultValue) && (!_.isFinite(resultValue) || _.isNaN(resultValue))) {
                        resultValue = '';
                    }
                    else if (_.isUndefined(resultValue)) {
                        resultValue = '';
                    }
                    
                    if (!angular.equals(vm.temp[state][resultVar.model], resultValue)) {
                        $log.info('Calculate:', resultVar.model + ' (' + resultValue + ')', '<-', changedOperands.join(','));
                        $timeout(function () {
                            if (vm.temp[state]) {
                                vm.temp[state][resultVar.model] = resultValue;
                            }
                            vm.filters[resultVar.model] = resultValue;
                        }, 0);
                    }
                }
                else if (delayCalculation) {
                    delayCalculation = false;
                }
            }, true);
        }

        function resultValuesChanged(operands, resultVar, newResults, oldResults) {
            return _.some(operands, function (op, index) {
                if (op.modelId === resultVar.model) {
                    return false;
                }

                return !angular.equals(newResults[index], oldResults[index]);
            });
        }

        function evaluateExpressions(operandWatchers) {
            return _.map(operandWatchers, function(getValue){
                return getValue();
            });
        }

        function operandValue(currentState, operand){
            var flatDataSet = {},
                modelId = _.trim(operand.modelId);
            
            if (modelId) {
                _.forEach(vm.temp, function (stateData, stateId) {
                    if (stateId != currentState) {
                        _.assign(flatDataSet, stateData);
                    }    
                });

                // Add current state data last to make sure it isn't overwritten
                _.assign(flatDataSet, vm.temp[currentState]);

                flatDataSet = _.merge({}, vm.autoFillData, flatDataSet);

                return _.get(flatDataSet, operand.modelId);
            }
            
            return '';
        }

        function resultFieldDisplayed(state, resultVar){
            var stateFieldsShown = _.get(vm.fieldsShown, state, {}),
                objDisplayed = stateFieldsShown[resultVar.model],
                sectionDisplayed = true;

            if(resultVar.section && resultVar.section !== '__nimHiddenSection'){
                var stateSectionsShown = _.get(vm.sectionsShown, state, {}),
                    formSectionsShown = _.get(stateSectionsShown, resultVar.id, {});

                sectionDisplayed = formSectionsShown[resultVar.section];
            }

            return !!(sectionDisplayed && objDisplayed);
        }

        function sectionConditionWatcher(state, formOriginId, section){
            vm.sectionsShown[state] = vm.sectionsShown[state] || {};
            vm.sectionsShown[state][formOriginId] = vm.sectionsShown[state][formOriginId] || {};

            if(!_.isEmpty(section.condition)) {
                var initialConditionSet = false,
                    watchExpressions = [],
                    expressionTemplate = 'vm.temp[\'{0}\'][\'{1}\']';

                _.forEach(section.condition, function (condition) {
                    watchExpressions.push(
                        kendo.format(expressionTemplate, state, condition.modelId)
                    );

                    if (condition.isFormObj) {
                        watchExpressions.push(
                            kendo.format(expressionTemplate, state, condition.val)
                        );
                    }
                });

                return $scope.$watchGroup(watchExpressions, function (newValues, oldValues) {
                    if (!initialConditionSet || !angular.equals(newValues, oldValues)) {
                        vm.sectionsShown[state] = vm.sectionsShown[state] || {};
                        vm.sectionsShown[state][formOriginId] = vm.sectionsShown[state][formOriginId] || {};
                        vm.sectionsShown[state][formOriginId][section.name] = FormsService.sectionCondition(section.condition, vm.temp[state], section.logic, vm.action);

                        initialConditionSet = true;
                    }
                });
            }

            vm.sectionsShown[state][formOriginId][section.name] = true;
            return angular.noop;
        }

        /**
         * Creates a watcher that checks a form field's condition and shows/hides/enables/disables it.
         * @param state
         * @param formOriginId
         * @param formObjectModel
         * @returns {function} de-registration function for watcher
         */
        function fieldConditionWatcher(state, formOriginId, formObjectModel){
            vm.fieldsShown[state] = vm.fieldsShown[state] || {};
            vm.fieldsActive[state] = vm.fieldsActive[state] || {};
            vm.fieldsRequired[state] = vm.fieldsRequired[state] || {};

            var modelId = formObjectModel.config.modelId,
                params = formObjectModel.param,
                conditionallyReadonly = params.conditionalAction === 'active' || params.conditionalAction === 'readonly',
                conditionallyRequired = params.conditionalAction === 'required' || params.conditionalAction === 'optional',
                alwaysReadonly = !!(params.disabled || params.autoIncrement),
                alwaysRequired = !!(formObjectModel.validation.required && formObjectModel.display.section !== '__nimHiddenSection');
            
            if(!_.isEmpty(params.condition) && !(conditionallyReadonly && alwaysReadonly) && !(conditionallyRequired && alwaysRequired)){
                var initialConditionSet = false,
                    section = formObjectModel.display.section,
                    watchExpressions = [],
                    expressionTemplate = 'vm.temp[\'{0}\'][\'{1}\']';

                if(section && section !== '__nimHiddenSection'){
                    watchExpressions.push(
                        kendo.format('vm.sectionsShown[\'{0}\'][{1}][\'{2}\']', state, formOriginId, section)
                    );
                }
                else {
                    watchExpressions.push(function(){
                        return true;
                    });
                }

                _.forEach(params.condition, function(condition){
                    watchExpressions.push(
                        // kendo.format(expressionTemplate, state, condition.modelId)
                        function () {
                            var flatData = getFlatData(state);
                            return flatData[condition.modelId];
                        }
                    );

                    if (condition.isFormObj) {
                        watchExpressions.push(
                            kendo.format(expressionTemplate, state, condition.val)
                        );
                    }
                });
                    
                vm.fieldsShown[state][modelId] = true;
                vm.fieldsActive[state][modelId] = true;
                vm.fieldsRequired[state][modelId] = false;

                // if(params.conditionalAction === 'active' || params.conditionalAction === 'readonly'){
                //     vm.fieldsShown[state][modelId] = true;

                //     if(alwaysReadonly){
                //         vm.fieldsActive[state][modelId] = !alwaysReadonly;
                //         return angular.noop();
                //     }
                // }
                // else {
                //     vm.fieldsActive[state][modelId] = !alwaysReadonly;
                // }

                return $scope.$watchGroup(watchExpressions, function (newValues, oldValues) {
                    var isSectionShown = _.head(newValues),
                        valuesChanged = !angular.equals(newValues, oldValues),
                        updateNeeded = !initialConditionSet || valuesChanged;

                    if (isSectionShown && updateNeeded){
                        vm.fieldsShown[state] = vm.fieldsShown[state] || {};
                        vm.fieldsActive[state] = vm.fieldsActive[state] || {};
                        vm.fieldsRequired[state] = vm.fieldsRequired[state] || {};

                        var flatDataSet = getFlatData(state);

                        var wasShown = vm.fieldsShown[state][modelId],
                            conditionMet = FormsService.sectionCondition(params.condition, flatDataSet, params.conditionalLogic, vm.action);
                        
                        switch(params.conditionalAction){
                            case 'active':
                                vm.fieldsActive[state][modelId] = conditionMet;
                                break;

                            case 'readonly':
                                vm.fieldsActive[state][modelId] = !conditionMet;
                                break;

                            case 'required':
                                vm.fieldsRequired[state][modelId] = conditionMet;
                                break;

                            case 'optional':
                                vm.fieldsRequired[state][modelId] = !conditionMet;
                                break;

                            case 'hide':
                                vm.fieldsShown[state][modelId] = !conditionMet;
                                break;

                            default:
                                vm.fieldsShown[state][modelId] = conditionMet;

                                var isShown = vm.fieldsShown[state][modelId];

                                if(params.showPopup && isShown && !wasShown){
                                    $timeout(function(){
                                        $scope.$broadcast('nim-show-static-text-popup', modelId);
                                    });
                                }

                                break;
                        }

                        initialConditionSet = true;
                    }
                });
            }

            vm.fieldsShown[state][modelId] = true;
            // vm.fieldsActive[state][modelId] = !alwaysReadonly;
            vm.fieldsActive[state][modelId] = true;
            vm.fieldsRequired[state][modelId] = false;
            return angular.noop;
        }

        function getFlatData(state) {
            var flatDataSet = {};

            _.forEach(vm.temp, function (stateDataSet) {
                _.assign(flatDataSet, stateDataSet);
            });

            _.assign(flatDataSet, vm.temp[state]);

            return flatDataSet;
        }

        function autoFillWatcher(state, modelId, isFilter, selectOptions){
            vm.autoFilledFields[state] = vm.autoFilledFields[state] || {};
            vm.autoFillData[modelId] = {};

            var watchExpression = isFilter ? 'vm.filters.' + modelId + '.id' : 'vm.temp[\'' + state + '\'][\'' + modelId + '\'].id';
            var skipFirstAutoFill = false;
            if (vm.action !== 'create' || vm.readingNewRecord) {
                skipFirstAutoFill = true;
            }

            return $scope.$watch(watchExpression, function(selectedId, previousId){
                var pushData = true,
                    selectedValueChanged = !angular.equals(selectedId, previousId);

                if(vm.activeState !== state){
                    pushData = false;
                }
                //else if(!selectedValueChanged){
                //    pushData = false;
                //}

                if(selectedValueChanged || _.isEmpty(vm.autoFillData[modelId])){
                    var dataSet = vm.temp[state];
                    if(selectedId && selectedId != '-1'){
                        autoFillTriggered(modelId, true);
                        FormsService.getAutoFillValues(selectedId, selectOptions).then(function (data) {
                            vm.autoFillData[modelId] = {};
                            autoFillTriggered(modelId, false);

                            if (data.length > 0) {
                                $timeout(function () {
                                    var autoFilledFields = [];

                                    _.forEach(data, function (targetField, index) {
                                        var autoFillMap = selectOptions.autoFill[index],
                                            propertyId = autoFillMap.type == 'query' ? autoFillMap.queryId : autoFillMap.value,
                                            value = targetField.value;

                                        if (targetField.type === 'timestamp') {
                                            value = moment.utc(value, 'MMMM, DD YYYY HH:mm:ss').toDate();
                                        }

                                        if (typeof value === 'object' && !(value instanceof Date)) {
                                            if (targetField.modelId) {
                                                $scope.$broadcast('nim-auto-fill-dropdown', targetField.modelId, value);
                                            }    

                                            if (_.isArray(value)) {
                                                vm.autoFillData[modelId][propertyId] = value;
                                            }
                                            else {
                                                vm.autoFillData[modelId][propertyId] = _.get(value, "display", "");
                                            }
                                        }
                                        else {
                                            vm.autoFillData[modelId][propertyId] = value;
                                        }

                                        if (!skipFirstAutoFill && pushData && _.get(autoFillMap, 'persists', true)) {
                                            autoFilledFields.push(targetField.modelId);

                                            if (!value && value !== 0) {
                                                //$timeout(function(){
                                                dataSet[targetField.modelId] = '';
                                                vm.filters[targetField.modelId] = '';
                                                //});
                                            }
                                            else {
                                                // $timeout(function(){
                                                dataSet[targetField.modelId] = value;
                                                vm.filters[targetField.modelId] = value;
                                                // }, 0);

                                                fieldAutoFilled(state, targetField.modelId);
                                            }

                                            if (targetField.type === "dataseries" || targetField.type === "query") {
                                                $scope.$broadcast('nim-form-table-auto-fill-' + targetField.modelId, {
                                                    data: value
                                                });
                                            }
                                        }
                                    });

                                    $log.info('Autofill', modelId, '->', autoFilledFields.join(','));
                                    skipFirstAutoFill = false;
                                });
                            }
                            else{
                                clearAutoFillData(selectOptions.autoFill);
                            }
                        }, function () {
                            clearAutoFillData(selectOptions.autoFill);
                            autoFillTriggered(modelId, false);
                        });
                    }
                    else {
                        clearAutoFillData(selectOptions.autoFill);
                    }
                }
            });
        }

        function fieldAutoFilled(state, modelId) {
            var path = [state, modelId];
            _.set(vm.autoFilledFields, path, true);

            $timeout(function () {
                _.set(vm.autoFilledFields, path, false);
            }, 3000);
        }

        function clearAutoFillData(state, autoFillArray){
            _.forEach(autoFillArray, function(autoFill){
                vm.temp[state][autoFill.current.modelId] = '';

                if(autoFill.type && autoFill.type === 'dataseries'){
                    $scope.$broadcast('nim-form-table-auto-fill-' + autoFill.current.modelId,{
                        data: null
                    });
                }
            });
        }

        /* UI Window Functions */
        function _closeWindow(reopenFlag,stopBroadcast,action,id,data) {
            clearWatchers();
            
            if(vm.windowId) {
                $scope[vm.windowId].close();
            }

            if(!stopBroadcast){
                _broadcastInstanceSaved(action, id, data);
            }

            if(reopenFlag){
                // Reopens instance window independent from parent page controller
                InstancesWindowService.openWindow({
                    action: 'create',
                    widgetId: vm.widgetId,
                    title: vm.instance.widgetName,
                    defaultData: $scope.defaultData
                });
            }
        }

        function _broadcastInstanceSaved(action, id, data){
            if(_.isFunction($scope.navFunctions.callback)){
                $scope.navFunctions.callback(id, action, data);
            }
        }

        /* UI Form Functions */
        function tabOnBlur($event){
            angular.element($event.currentTarget).attr('tabindex',vm.instance.workflowObjects[vm.activeState].model.forms[0].tabindexEnd);
        }
        function tabOnFocus($event){
            angular.element($event.currentTarget).attr('tabindex',vm.instance.workflowObjects[vm.activeState].model.forms[0].tabindexStart - 1);
        }
        
        function _editState(state) {
            $timeout(function () {
                vm.formObjectsInvalid[state] = {};
                angular.forEach(vm.edit, function (v, k) {
                    if (k === state + '') {
                        vm.edit[k] = true;
                        vm.activeState = state;
                        // vm.selectedForm[state] = 0;

                        // Expand state on edit
                        vm.collapse[state] = false;
                    }
                    else {
                        vm.edit[k] = false;
                    }
                });
            }, 1);
        }
        function _cancelState(state) {
            vm.temp[state] = angular.copy(vm.orig[state]);
            _editState();
            vm.activeState = null;
            // vm.selectedForm[state] = 0;
        }

        function _openInstanceWindow(id){
            InstancesWindowService.openWindow({
                action: 'read',
                instanceId: id,
                title: vm.instance.widgetName
            });
        }

        function _selectForm(state, index){
            vm.selectedForm[state] = index;
        }

        function _isUnchanged() {
            return angular.equals(vm.temp, vm.orig);
        }

        function _submitForm(state, nextWorkflowState, submitAction) {
            if (vm.isSubForm) { // Don't submit this as its own record if it's a subform
                // TODO: Show Message
                return;
            }

            vm.invalid = false;
            if(vm.action === 'readonly'){
                // TODO: Show Message
                return;
            }

            _.defer(function () {
                // Tells each form object to validate
                var validationResult = validateState(state);

                if (!validationResult.valid) {
                    var formIndex = vm.selectedForm[state],
                        selectedForm = vm.instance.workflowObjects[state].model.forms[formIndex];

                    if (!vm.formObjectsInvalid[state][selectedForm.originatorId]) {
                        focusFirstInvalidForm(state);
                    }

                    return;
                }

                if (vm.updating) {
                    // TODO: Show Message
                    return;
                }

                if (vm.isProcessingUploads) {
                    // TODO: Show Message
                    return;
                }

                var data;
                // If Creating
                if (vm.action === 'create' && state === vm.createState) {
                    data = {
                        widgetId: vm.instance.widgetId,
                        draftId: vm.draftId,
                        recordData: InstancesWindowService.pickShownFields(vm.temp[state], vm.orig[state], vm.instance.workflowObjects[state].model.forms, vm.sectionsShown[state], vm.fieldsShown[state]),
                        current: nextWorkflowState ? nextWorkflowState : '',
                        recurrence: vm.instance.recurrence,
                        ignoreSections: _sectionsIgnored(vm.instance.workflowObjects[state].model.forms, state)
                    };

                    vm.updating = true;
                    InstancesService.createInstance(data).then(function (result) {
                        $attrs.$set('nimValidateOnOpen', '');
                    
                        if (vm.relationships.length > 0) {
                            InstancesService.updateRelationships(result.instanceId, vm.relationships);
                        }

                        // var instanceId = _.last(result.instanceId.split('-'));
                        var instanceId = result.instanceId;

                        if (submitAction === 'submit') {
                            _updateInstanceAttrs(instanceId, 'read');

                            _broadcastInstanceSaved('create', instanceId, data.recordData);
                            _init();
                        }
                        else if (submitAction === 'submitAndNew') {
                            _broadcastInstanceSaved('create', instanceId, data.recordData);
                            _init();
                        }
                        else {
                            _closeWindow(false, false, 'create', instanceId, data.recordData);
                        }
                    }, function () {
                        vm.updating = false;
                    });
                }
                // If Progressing //
                else if (vm.action === 'read' && state === vm.createState) {
                    data = {
                        recordData: InstancesWindowService.pickShownFields(vm.temp[state], vm.orig[state], vm.instance.workflowObjects[state].model.forms, vm.sectionsShown[state], vm.fieldsShown[state]),
                        nextStateId: nextWorkflowState ? nextWorkflowState : '',
                        currentStateId: state,
                        ignoreSections: _sectionsIgnored(vm.instance.workflowObjects[state].model.forms, state)
                    };

                    vm.updating = true;
                    InstancesService.update(vm.instanceId, data).then(function () {
                        $attrs.$set('nimValidateOnOpen', '');

                        if (vm.windowId) {
                            $rootScope.$broadcast('nim-instance-saved:' + vm.instanceId, vm.windowId, vm.temp, state);
                        }

                        //if(vm.instance.workflowObjects[state].model.to.length < 2){
                        //    _closeWindow(null, null, 'update', vm.instanceId, data.recordData);
                        //}
                        //else {
                        //    vm.setCurrentWorkflowObject(id);
                        //}

                        if (submitAction === 'submitAndClose') {
                            _closeWindow(false, false, 'update', vm.instanceId, data.recordData);
                        }
                        else {
                            _broadcastInstanceSaved('update', vm.instanceId, data.recordData);
                            _init();
                            //_editState();
                            //vm.createState = nextWorkflowState;
                            //vm.activeState = null;
                            //vm.orig[state] = angular.copy(vm.temp[state]);
                            //vm.updating = false;
                        }
                    }, function () {
                        vm.updating = false;
                    });
                }
                // Else we must be editing.
                else if (vm.action !== 'create' && state !== vm.createState) {
                    data = {
                        currentStateId: state,
                        recordData: InstancesWindowService.pickShownFields(vm.temp[state], vm.orig[state], vm.instance.workflowObjects[state].model.forms, vm.sectionsShown[state], vm.fieldsShown[state]),
                        ignoreSections: _sectionsIgnored(vm.instance.workflowObjects[state].model.forms, state)
                    };

                    vm.updating = true;
                    InstancesService.update(vm.instanceId, data).then(function () {
                        $attrs.$set('nimValidateOnOpen', '');

                        if (vm.windowId) {
                            $rootScope.$broadcast('nim-instance-saved:' + vm.instanceId, vm.windowId, vm.temp, state);
                        }

                        if (submitAction === 'submitAndClose') {
                            _closeWindow(false, false, 'update', vm.instanceId, data.recordData);
                        }
                        else {
                            _broadcastInstanceSaved('update', vm.instanceId, data.recordData);
                            _init();
                            //_editState();
                            //vm.activeState = null;
                            //vm.orig[state] = angular.copy(vm.temp[state]);
                            //vm.updating = false;
                        }

                        //_closeWindow(null, null, 'update', vm.instanceId, data.recordData);
                        //TODO: rebuild static view
                        // update original
                        //vm.orig[state] = angular.copy(vm.temp[state]);
                        // end the edit session
                        //vm.edit[state] = false;
                    }, function () {
                        vm.updating = false;
                    });
                }
            });
        }

        function _updateInstanceAttrs(id, action){
            $attrs.$set('nimId', id);
            $attrs.$set('nimAction', action);
        }

        function _sectionsIgnored(forms, state){
            var ignoreSections = [];

            _.forEach(forms, function(f){
                _.forEach(f.form.sections, function(s){
                    if(!_.isEmpty(s.condition)) {
                        var formOriginId = f.originatorId;

                        if (!vm.sectionsShown[state][formOriginId][s.name]) {
                            ignoreSections.push({
                                section: s.name,
                                form_origin_id: formOriginId
                            });
                        }
                    }
                });
            });

            return ignoreSections;
        }

        function _saveDraft(submitFunction) {
            var data = {
                widgetId: vm.instance.widgetId,
                recordData: vm.temp[vm.activeState],
                stateId: vm.createState
            };
            if (vm.draftId) {
                draftsService.update(vm.draftId, data).then(function(){
                    if (angular.isFunction(submitFunction)) {
                        submitFunction();
                    }
                });
            }
            else {
                draftsService.create(data).then(function(value){
                    vm.draftId = value.draftId;
                    if (angular.isFunction(submitFunction)) {
                        submitFunction();
                    }
                });
            }
        }

        /**
         * Formats attachment size into human-readable string
         * @param bytes - Attachment size, in bytes
         * @returns {string}
         * @private
         */
        function _showFileSize(bytes){
            var kilobytes = bytes / 1024,
                megabytes = kilobytes / 1024,
                gigabytes = megabytes / 1024;

            if(bytes < 1000){
                return bytes + ' B';
            }
            else if(kilobytes < 1000){
                return _.round(kilobytes, 1) + ' KB';
            }
            else if(megabytes < 1000){
                return _.round(megabytes, 1) + ' MB';
            }
            else {
                return _.round(gigabytes, 1) + ' GB';
            }
        }

        // TODO:  Add this to a build function in the InstancesWindowService
        /* Upload Options */
        vm.uploadOptions = {
            async:{
                saveUrl: '/Server/REST/v1/upload',
                removeUrl: 'remove',
                autoUpload: false
            },
            localization: {
                dropFilesHere: 'Drop files here to start the upload.'
            },
            select:function(){
                vm.isProcessingUploads = true;
                var othis = this;
                if(vm.action === 'create' && !vm.draftId){
                    othis.disable();
                    var d = {
                        widgetId: vm.instance.widgetId,
                        recordData: vm.temp[vm.createState],
                        stateId: vm.createState
                    };
                    draftsService.create(d).then(function(value){
                        vm.draftId = value.draftId;
                        othis.enable();
                        $(".k-button.k-upload-selected").trigger('click');
                    });
                }
                else{
                    $timeout(function(){
                        $(".k-button.k-upload-selected").trigger('click');
                    }, 1);
                }
            },
            upload: function(e){
                e.data = {
                    formOriginId: vm.instance.workflowObjects[vm.activeState].model.forms[vm.selectedForm[vm.activeState]].originatorId,
                    formId: vm.instance.workflowObjects[vm.activeState].model.forms[vm.selectedForm[vm.activeState]].formId,
                    widgetId: vm.instance.widgetId
                };
                if(vm.draftId){
                    e.data.draftId = vm.draftId;
                }
                else{
                    e.data.instanceId = vm.instanceId;
                }

                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener("readystatechange", function () {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                            xhr.setRequestHeader('WSID',$rootScope.userData.currentWorkspace.id);
                            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest ');
                        }
                    });
                }
            },
            success: function(e){
                $timeout(function () {
                    var itemData = e.response.DATA;
                    var form = vm.instance.workflowObjects[vm.activeState].model.forms[vm.selectedForm[vm.activeState]];
                    form.fileAttachments = form.fileAttachments || [];
                    itemData.disableClick = true;
                    form.fileAttachments.push(itemData);
                    if(!vm.temp[vm.activeState].nimupload){
                        vm.temp[vm.activeState].nimupload = [];
                    }
                    vm.temp[vm.activeState].nimupload.push(itemData.id + ',create');
                    vm.isProcessingUploads = false;
                    $(".k-upload-files.k-reset").find("li").remove();
                });
            },
            cancel: function(){
                $timeout(function(){
                    vm.isProcessingUploads = false;
                });
            },
            error: function(){
                $timeout(function(){
                    vm.isProcessingUploads = false;
                });
            }
        };

        /* Upload Functions */
        function _deleteFile(index){
            $timeout(function () {
                var form = vm.instance.workflowObjects[vm.activeState].model.forms[vm.selectedForm[vm.activeState]];
                //InstancesService.deleteAttachment(form.fileAttachments[index].id).then(function (v) {
                form.fileAttachments.splice(index, 1);
                //vm.temp[vm.activeState].nimupload.splice(index, 1);
                vm.temp[vm.activeState].nimupload[index] =  vm.temp[vm.activeState].nimupload[index] + ',delete';
                //});
            });
        }

        /* SubForm Functions */
        function _subFormCreate(reOpen) {
            $timeout(function () {
                // Wait until calculations stop running
                _.defer(function () {
                    var state = vm.activeState;
                    var validationResult = validateState(state);

                    if (!validationResult.valid) {
                        var formIndex = vm.selectedForm[state],
                            selectedForm = vm.instance.workflowObjects[state].model.forms[formIndex];

                        if (!vm.formObjectsInvalid[state][selectedForm.originatorId]) {
                            focusFirstInvalidForm(state);
                        }

                        return;
                    }

                    var forms = vm.instance.workflowObjects[state].model.forms;
                    var attachments = forms[vm.selectedForm[state]].fileAttachments || [];
                    var dataSet = {
                        __nimData: InstancesWindowService.pickShownFields(vm.temp[state], vm.orig[state], vm.instance.workflowObjects[state].model.forms, vm.sectionsShown[state], vm.fieldsShown[state]),
                        __attachments: attachments,
                        __ignoreSections: _sectionsIgnored(forms, state)
                    };

                    // Adjust formatting/displaying of values in the table
                    FormsService.fixDataseriesCols(dataSet, $scope.schemaFields);
                    //

                    if (subDataUnique(dataSet)) {
                        if ($scope.editSubData) {
                            angular.extend($scope.editSubData, dataSet);
                        }
                        else {
                            dataSet.__optionId = $scope.nimFormObject.param.optionId;
                            dataSet.__column = $scope.nimFormObject.param.column;
                            dataSet.__modelId = vm.excludeModelId;
                            dataSet.__widgetId = vm.instance.widgetId;

                            if ($scope.grid) {
                                $scope.grid.dataSource.add(dataSet);
                            }
                        }
                    }

                    if ($scope.grid) {
                        $scope.dataSet[$scope.nimFormObject.config.modelId] = $scope.grid.dataSource.data().toJSON();
                        $scope.grid.refresh();
                    }

                    $rootScope.$broadcast('nim-sub-form-closed', {
                        modelId: $scope.nimFormObject.config.modelId
                    });

                    if (reOpen) {
                        _init();
                    }
                    else if (vm.windowId) {
                        $scope[vm.windowId].close();
                    }
                });
            }, 100);    
        }

        function subDataUnique(dataItem) {
            var unique = true,
                gridData = $scope.grid.dataSource.data();

            _.forEach($scope.columns, function (c) {
                if (c.unique) {
                    var value = dataItem[c.field],
                        modelId = c.field;
                    
                    if (c.isLookUp || c.isCustomLookup) {
                        modelId = c.field.replace(/^__/, '').replace(/_display$/, '.id');
                        value = _.get(dataItem.__nimData, modelId);
                    }

                    if (_.find(gridData, '__nimData.' + modelId, value, dataItem)) {
                        unique = false;
                        return false;
                    }
                }
            });
            
            return unique;
        }

        function _getParticipantInfo(userId){
            if(!vm.userData[userId]){
                usersProfileService.getDefaultUserProfile(userId).then(function(userData){
                    vm.userData[userId] = userData[0].data;
                });
            }
        }

        function _getDownloadKey(attachment){
            if(!attachment.disableClick){
                InstancesService.getDownloadKey(attachment.id).then(function(d){
                    InstancesService.getBlob(d).then(function(pdfBlob){
                        $window.saveAs(pdfBlob, attachment.name);
                    });
                });
            }
        }

        /* Toolbar functions */

        function _newInstance(){
            _updateInstanceAttrs('', 'create');
            _init();
        }

        function _duplicateInstance() {
            if (vm.dataSetLoaded && vm.temp) {
                var dataSet = angular.copy(vm.temp[1]),
                    forms = vm.instance.workflowObjects[1].model.forms,
                    duplicateData = [];

                _.forEach(forms, function (formModel) {
                    _.forEach(formModel.form.objects, function (formObj) {
                        if (formObj.model.config.dataType !== 'static' && !formObj.model.param.autoIncrement && !formObj.model.param.preventDuplication) {
                            // Formats data to be consistent with defaultData model
                            var value = dataSet[formObj.model.config.modelId];

                            if (formObj.model.config.dataType === 'dataseries') {

                                _.forEach(value, function (row) {
                                    delete row['__instanceId'];

                                    row['__column'] = formObj.model.param.column;
                                    row['__modelId'] = formObj.model.param.fk;
                                    row['__widgetId'] = formObj.model.param.widgetId;
                                    row['__optionId'] = formObj.model.param.optionId;

                                    row['__nimData'][formObj.model.param.fk] = { display: 'Auto' };
                                });
                            }

                            duplicateData.push({
                                field: {
                                    formId: formModel.originatorId,
                                    modelId: formObj.model.config.modelId
                                },
                                data: {
                                    value: value
                                }
                            });
                        }
                    });
                });

                _closeWindow(false, true);
                InstancesWindowService.openWindow({
                    action: 'create',
                    widgetId: vm.instance.widgetId,
                    defaultData: duplicateData
                });
            }
        }

        function _deleteInstance() {
            if(vm.action !== 'create') {
                // Makes sure id is number and does not include public key
                var instanceId = vm.instanceId;
                if (_.isString(instanceId)) {
                    instanceId = parseInt(_.last(instanceId.split('-')));
                }

                InstancesWindowService.deleteInstanceModal([instanceId], function(){
                    _closeWindow(false, false, 'delete', vm.instanceId);
                });
            }
        }

        function _cancel() {
            if (vm.action === 'create') {
                if (!vm.isUnchanged()) {
                    InstancesWindowService.openConfirmInstanceCloseModal().then(function() { 
                        _closeWindow(false, true);
                    });
                } else {
                    _closeWindow(false, true);
                }    
            }
            else if(vm.activeState){
                _cancelState(vm.activeState);
            }
        }

        function _pushActionInstance(pushActionType) {
            /* This will be active only when instance window form is not edited. */
            if (vm.action === 'read' && pushActionType === 'actionEmail') {
                // Makes sure ID is number and does not include public key
                var instanceIdNumeric = vm.instanceId; if (_.isString(instanceIdNumeric)){instanceIdNumeric = parseInt(_.last(instanceIdNumeric.split('-')));}
                var currentWorkflowObjectId = _.get(vm.instance, 'currentWorkflowObjectId', 1);
                var pushAct_structure = _.get(vm.instance.workflowObjects[currentWorkflowObjectId], 'model.pushAct', {});
                // Forward instance critical data into push actions to allow data matching within form fields
                pushAct_structure.instance = {};
                pushAct_structure.instance.autoFillData = _.get(vm, 'autoFillData', {});
                var fullDataSet = angular.copy(vm.orig);
                var dataSet = {};
                _.forEach(fullDataSet, function (stateData) {
                    _.assign(dataSet, stateData);
                });
                pushAct_structure.instance.dataSet = dataSet;

                InstancesWindowService.pushActionInstanceModal(instanceIdNumeric, pushActionType, pushAct_structure);
            //} else {
            //    // Add more push action types in here if needed... Otherwise this should never happen.
            //    window.alert('This method of push action is not defined. Aborting now.');
            }
        }

        function _collapseAll() {
            _.forEach(vm.collapse, function(v, k){
                vm.collapse[k] = true;
            });
        }

        function _expandAll() {
            _.forEach(vm.collapse, function(v, k){
                vm.collapse[k] = false;
            });
        }

        function _revisionOnClick(revision) {
            var title = vm.instance.widgetName + ': Revision - ' + kendo.toString(revision.createDate, 'MM/dd/yyyy h:mm tt') + ' - ' + revision.createBy;
            InstancesWindowService.openRevision(null, vm.instanceId, revision.id, title);
        }

        function _updateSchema() {
            InstancesService.updateSchema({ids:[vm.instanceId], createRevision:true, updateWflowState:true}).then(function () {
                _init();
            });
        }

        // TODO: Single state. (Note that Workflow state may contain multiple forms)
        // -- (At existing development level it will print all form windows appending them all in one long document).
        function _exportInstance(type) {
            // if (vm.states.length === 1) {
            //     vm.printInstanceSingleStateForm(vm.states[0]);
            //     return;
            // }
            if (!vm.isProcessingPdf) {
                type = type || 'pdf';
                vm.isProcessingPdf = true;
                $timeout(function () {
                    var elem = vm.window.element.find('#record-div'),
                        defaultConfig = {
                            type: type,
                            filename: _getFileName() //Get file title based widget title
                        };
                    ExportService.exportElement(elem, defaultConfig, function () {
                        vm.isProcessingPdf = false;
                    });
                }, 1);
            }
        }

        // TODO: Single state. (Note that Workflow state may contain multiple forms)
        // -- (At existing development level it will print all form windows appending them all in one long document).
        function _printInstanceNormal() {
            vm.isProcessingPdf = true;

            $timeout(function () {
                var displayVal = {},
                    browser = DeviceSniffService.deviceBrowser(),
                    isIE = _.startsWith(browser, 'IE');
        
                displayVal[vm.instanceId] = getRecordDisplayValue(vm.orig, _.get(vm.instance, 'widgetSettings.view.column', '')) || vm.title;

                var printConfigCb = function (config) {
                    var instance = angular.copy(vm.instance),
                        fullDataSet = angular.copy(vm.orig),
                        dataSet = {};

                    _.forEach(fullDataSet, function (stateData) {
                        _.assign(dataSet, stateData);
                    });

                    var defaultName = _getFileName(displayVal[vm.instanceId]); //Get file title based widget view column, or use default
                    normalPrintingService.printInstance(vm.instanceId, defaultName, config.options, instance, dataSet, vm.autoFillData).then(function () {
                        vm.isProcessingPdf = false;
                    });
                };

                if (isIE) {
                    printService.openPrintConfigurationModal(vm.widgetId, [vm.instanceId], displayVal, { normal: true }, {
                        type: 'normal'
                    }).then(printConfigCb, function () {
                        vm.isProcessingPdf = false;
                    });
                }
                else {
                    printConfigCb({
                        type: 'normal',
                        options: {
                            landscape: false,
                            paperSize: 'letter',
                            margin: {
                                bottom: 0,
                                left: 0,
                                right: 0,
                                top: 0
                            }
                        }
                    });
                }
            }, 1);
        }

        /**
         * Prints a specific single instance form identified by StateID / (Selected active form)
         * @param [state]      - (Required) : Form state withing given instance
         * @param [processPdf] - (Optional) : Available commands used for PDF Processing invoked after generating is complete: 
         *            (1) 'save'  - Force PDF file to be directly downloaded without any extra print window preview
         *            (2) 'write' - Force PDF file to be internally stored locally on server
         *            (3) 'false' - Default, None or Null - Go to printing process
         */
        function _printInstanceSingleStateForm(state, processPdf) {
            if (!vm.isProcessingPdf) {
                processPdf = processPdf || false;
                vm.isProcessingPdf = true;
                vm.isStatePrinting[state] = true;
                vm.collapse[state] = false;

                $timeout(function () {
                    var formIndex = vm.selectedForm[state],
                    
                        form = vm.instance.workflowObjects[state].model.forms[formIndex],
                        displayVal = {},
                        defaultName,
                        enabledPrintTypes = { normal: true },
                        formPrintType = _.get(form, 'form.settings.print.type', 'normal'),
                        browser = DeviceSniffService.deviceBrowser(),
                        isIE = _.startsWith(browser, 'IE');

                    displayVal[vm.instanceId] = getRecordDisplayValue(vm.orig, _.get(vm.instance, 'widgetSettings.view.column', '')) || vm.title;

                    var printConfigCb = function (config) {
                        var instance = angular.copy(vm.instance),
                            formData = angular.copy(form),
                            dataSet = {};
                        
                        _.forEach(vm.states, function (s) {
                            _.assign(dataSet, vm.orig[s]);
                        });

                        _.assign(formData.defaultDataSet, dataSet);
                        
                        instance.workflowObjects[state].model.forms = [formData];
                        instance.workflowPath = [state];

                        if (formData.form.settings.print.customName) {
                            defaultName = _getFileName(displayVal[vm.instanceId], formData.form.settings); //Get file title based form settings, widget view column, or use default
                        }
                        else {
                            defaultName = _getFileName(displayVal[vm.instanceId]); //Get file title based widget view column, or use default
                        }

                        normalPrintingService.printInstance(vm.instanceId, defaultName, config.options, instance, dataSet, vm.autoFillData, processPdf).then(function () {
                            vm.isProcessingPdf = false;
                            vm.isStatePrinting[state] = false;
                        });
                        // var elem = $element.find('.instance-state-body[nim-state-id=' + state + ']');
                        // normalPrintingService.printElement(elem, config.filename, config.options).then(function () {
                        //     vm.isProcessingPdf = false;
                        //     vm.isStatePrinting[state] = false;
                        // });
                    };

                    if (!processPdf && (isIE || formPrintType !== 'normal')) {
                        enabledPrintTypes[formPrintType] = true;

                        printService.openPrintConfigurationModal(vm.widgetId, [vm.instanceId], displayVal, enabledPrintTypes, {
                            type: 'normal'
                        }).then(printConfigCb, function(){
                            vm.isProcessingPdf = false;
                            vm.isStatePrinting[state] = false;
                        });
                    }
                    else {
                        printConfigCb({
                            type: 'normal',
                            options: {
                                landscape: false,
                                paperSize: 'letter',
                                margin: {
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    top: 0
                                }
                            }
                        });
                    }
                }, 1);
            }
        }
        // function _printInstanceSingleStateForm_OldStyle(state) {
        //     if (!vm.isProcessingPdf) {
        //         vm.isProcessingPdf = true;
        //         vm.isStatePrinting[state] = true;
        //         vm.collapse[state] = false;
        //
        //         $timeout(function () {
        //             var elem = $element.find('.instance-state-body[nim-state-id=' + state + ']'),
        //                 formIndex = vm.selectedForm[state],
        //                 formPrintSettings = vm.instance.workflowObjects[state].model.forms[formIndex].form.settings.print;
        //
        //             var defaultConfig = {
        //                 filename: vm.instance.widgetName,
        //                 options: {
        //                     margin: _.get(formPrintSettings, 'margin', {}),
        //                     pageSize: _.get(formPrintSettings, 'pageSize', [8.5, 11])
        //                 }
        //             };
        //
        //             ExportService.exportElement(elem, defaultConfig, function () {
        //                 vm.isProcessingPdf = false;
        //                 vm.isStatePrinting[state] = false;
        //             });
        //         }, 1);
        //     }
        // }

        //Custom - Check printing
        function _printInstanceChecks() {
            var displayVal = {};
            
            displayVal[vm.instanceId] = getRecordDisplayValue(vm.orig, _.get(vm.instance, 'widgetSettings.view.column', '')) || vm.title;

            printService.openPrintConfigurationModal(vm.widgetId, [vm.instanceId], displayVal, {check: true}, {
                type: 'check'
            }).then(function(config){
                var formOriginId = _.last(config.options.targetForm.split('-')),
                    state = _.findKey(vm.instance.instanceWorkflow, formOriginId);

                if(vm.instance.workflowObjects[state]){
                    var formData = {};
                    formData[vm.instanceId] = angular.copy(_.find(vm.instance.workflowObjects[state].model.forms, 'originatorId', parseInt(formOriginId)));

                    if (formData[vm.instanceId]) {
                        _.assign(formData[vm.instanceId].defaultDataSet, vm.orig[state]);
                    }
                    
                    var instanceAutoFillData = {};
                    instanceAutoFillData[vm.instanceId] = vm.autoFillData;

                    var defaultName = _getFileName(displayVal[vm.instanceId]); //Get file title based widget view column, or use default
                    checkPrintingService.printChecks([vm.instanceId], defaultName, config.options, formData, instanceAutoFillData);
                }
            });
        }

        //Custom - Label printing
        function _printInstanceLabels() {
            var displayVal = {};

            displayVal[vm.instanceId] = getRecordDisplayValue(vm.orig, _.get(vm.instance, 'widgetSettings.view.column', '')) || vm.title;

            printService.openPrintConfigurationModal(vm.widgetId, [vm.instanceId], displayVal, {label: true}, {
                type: 'label'
            }).then(function(config){
                var formOriginId = _.last(config.options.targetForm.split('-')),
                    state = _.findKey(vm.instance.instanceWorkflow, formOriginId);

                if (vm.instance.workflowObjects[state]) {
                    var formData = {};
                    formData[vm.instanceId] = angular.copy(_.find(vm.instance.workflowObjects[state].model.forms, 'originatorId', parseInt(formOriginId)));

                    if (formData[vm.instanceId]) {
                        _.assign(formData[vm.instanceId].defaultDataSet, vm.orig[state]);
                    }

                    var instanceAutoFillData = {};
                    instanceAutoFillData[vm.instanceId] = vm.autoFillData;

                    var defaultName = _getFileName(displayVal[vm.instanceId]); //Get file title based widget view column, or use default
                    labelPrintingService.printLabels([vm.instanceId], defaultName, config.options, formData, instanceAutoFillData);
                }
            });
        }

        /**
         * Generate file name for exported file
         * @param {object} widgetDefaultColumn - Propagates column declared as main view column from widget settings
         * @param {object} formData - Will generate a custom file name declared in form settings -> print section
         * @returns {string}
         */
        function _getFileName(widgetDefaultColumn, settings) {
            if (widgetDefaultColumn || settings) {
                var colValue;
                if (settings) {
                    colValue = getRecordDisplayValue(vm.orig, _.get(settings, 'print.filename.field', vm.title));
                    if(colValue) {
                        if(_.has(colValue, 'display')) {
                            colValue = colValue.display;
                        }
                    }
                    else {
                        colValue = vm.title;
                    }
                    var kendoFmt = _.get(settings, 'print.filename.fieldFmt', '{0} - {1:yyyy-MM-dd}');
                    var tmpStr = kendo.format(kendoFmt, colValue, new Date());
                    return tmpStr;
                }
                else {
                    colValue = widgetDefaultColumn || vm.title;
                    if(colValue) {
                        if(_.has(colValue, 'display')) {
                            colValue = colValue.display;
                        }
                    }
                    return colValue;
                }
            }
            //Generate filename in case no variable was propagated in the function
            else if (_.has(vm, 'instance.widgetName')) {
                return kendo.format('{0} - {1:yyyy-MM-dd HH_mm_ss}', vm.instance.widgetName, new Date());
            }
            else if (vm.title) {
                return kendo.format('{0} - {1:yyyy-MM-dd HH_mm_ss}', vm.title, new Date());
            }
            //Last resort
            return kendo.format('{0} - {1:yyyy-MM-dd HH_mm_ss}', 'Download', new Date());
        }

        /**
         * Validates the active state before submittal
         * @param state - active state
         */
        function validateState(state) {
            // Tracks number of invalid form objects in each form of this state
            vm.formObjectsInvalid[state] = {};

            var stateResult = {
                    forms: {}
                },
                forms = vm.instance.workflowObjects[state].model.forms;

            _.forEach(forms, function(formModel){
                var formOriginId = formModel.originatorId,
                    formResult = validateFormObjects(formModel.form.objects, vm.temp[state], vm.instanceForms[state], vm.sectionsShown[state][formOriginId], vm.fieldsShown[state], vm.fieldsRequired[state]);

                stateResult.forms[formOriginId] = {
                    fields: formResult,
                    valid: _.every(formResult, 'valid')
                };
            });

            stateResult.valid = _.every(stateResult.forms, 'valid');

            if(!stateResult.valid){
                _.forEach(stateResult.forms, function(f, formOriginId){
                    if(!f.valid) {
                        vm.formObjectsInvalid[state][formOriginId] = _.countBy(f.fields, 'valid')[false];
                    }
                });
            }

            return stateResult;
        }

        /**
         * Validates each field in a given form
         * @param formObjects
         * @param dataSet - flat dataset of form data
         * @param instanceForm - angular form
         * @param sectionsShown
         * @param fieldsShown
         * @param fieldsRequired
         * @returns {object}
         */
        function validateFormObjects(formObjects, dataSet, instanceForm, sectionsShown, fieldsShown, fieldsRequired) {
            var formResult = {};
            _.forEach(formObjects, function(formObj){
                var modelId = formObj.model.config.modelId,
                    validate = FormValidationService.validateFormObject(instanceForm, formObj.model),
                    //valueInDataSet = _.has(dataSet, modelId) || formObj.config.dataType === 'dataSeries',
                    valueInDataSet = modelId && !formObj.model.param.filter,
                    section = formObj.model.display.section,
                    sectionIncluded = !section || sectionsShown[section],
                    formObjectShown = fieldsShown[modelId],
                    formObjectRequired = fieldsRequired[modelId];

                if(valueInDataSet && sectionIncluded && formObjectShown) {
                    var result = validate(dataSet[modelId], formObjectRequired);
                    formResult[modelId] = {
                        validators: result,
                        valid: _.every(result)
                    };
                }
            });

            return formResult;
        }

        /**
         * After state validation, finds the first form with invalid fields and gives it focus
         * @param state - active state
         */
        function focusFirstInvalidForm(state) {
            var formIndex = 0,
                formIds = _.map(vm.instance.workflowObjects[state].model.forms, 'originatorId'),
                invalidForms = vm.formObjectsInvalid[state];
            
            if (formIds.length > 1) {
                _.forEach(formIds, function (fId, index) {
                    if (invalidForms[fId]) {
                        formIndex = index;
                        vm.formIsActive[state][0] = false;
                        return false;
                    }
                });

                vm.selectedForm[state] = formIndex;
                vm.formIsActive[state][formIndex] = true;
            }
        }

        function autoFillTriggered(modelId, bool){
            vm.autoFilling[modelId] = bool;
            vm.showAutoFillScreen = _.some(vm.autoFilling);
        }

        function gridsterItemOptions(formObjectModel/*, dataSet*/) {
            var options = _.pick(formObjectModel, ['sizeX', 'sizeY', 'row', 'col']);

            // Adjust initial size of form tables
            // if (dataSet && formObjectModel.model.config.type == 'table') {
            //     var tableData = _.get(dataSet, formObjectModel.model.config.modelId, []),
            //         numRows = tableData.length + 2,
            //         height = 30 * numRows + 16;
                
            //     var sizeY = Math.ceil(height / 8);
            //     if (sizeY > options.sizeY) {
            //         options.sizeY = sizeY;
            //     }    
            // }

            return options;
        }

        function clearWatchers() {
            if(!_.isEmpty(vm.deregisterFunc)){
                // De-register old watchers
                _.forEach(vm.deregisterFunc, function(deregisterWatcherFunc){
                    if(_.isFunction(deregisterWatcherFunc)) {
                        deregisterWatcherFunc();
                    }
                });
            }
        }

        $scope.$on('nim-instance-saved:' + vm.instanceId, function(e, windowId, data, state) {
            if(windowId !== vm.windowId) {
                vm.orig[state] = angular.copy(data[state]);
                vm.temp[state] = angular.copy(data[state]);
            }
        });

        $scope.$on('auth:loginCancelled', function () {
            $timeout(function() {
                _closeWindow(false, true);
            });
        });
        
        $scope.$on('$destroy', function () {
            kendo.destroy($element);
        });
    }])
    .directive('nimInstance', function nimInstance() {
        return {
            restrict: 'AE',
            templateUrl: 'core/instances/instances.tpl.html',
            controller: 'NimInstanceCtrl',
            controllerAs: 'vm'
        };
    })
;
angular.module('cerberus.core')
    .controller('NimRelationshipCtrl', ["_", "kendo", "moment", "$scope", "$rootScope", "$timeout", "WidgetsService", "InstancesService", "InstancesWindowService", function NimRelationshipCtrl(_, kendo, moment, $scope, $rootScope, $timeout, WidgetsService, InstancesService, InstancesWindowService) {
        var vm = this;
        var filterText = '';
        var relationIds = [];
        var instanceId = $scope.$parent.vm.instanceId;
        vm.widgetsArray = [];
        vm.selectedRows = {};
        vm.relationshipArray = [];
        vm.relGridOptions = {
            columnMenu: true,
            columns:  [
                //{
                //    template: '<input class="form-control" type="checkbox" ng-checked="vm.rowSelected(vm.selectedWidget.id, #: id #)" ng-model="selected" ng-click="vm.toggleSelectRow(vm.selectedWidget.id, #: id #)" />',
                //    width: 35,
                //    type: 'batch',
                //    title: '',
                //    headerTemplate: '<input class="form-control" type="checkbox" ng-model="selected" ng-click="vm.selectAllRows(vm.grid, vm.selectedWidget.id, selected)" />',
                //    menu: false
                //},
                {
                    field: 'display',
                    title: 'Description',
                    type: 'string'
                },
                {
                    field: 'create_date',
                    title: 'Date Created',
                    type: 'date',
                    width: 150,
                    format: '{0:g}'
                },
                {
                    command: [
                        {
                            name: 'addRow',
                            text: '<i class="fa fa-plus"></i>&nbsp;Add',
                            className: 'btn btn-sm btn-default',
                            click: addRow
                        }
                    ],
                    title: ' ',
                    width: '80px'
                }
            ],
            //dataSource: dataSource,
            filterable: true,
            mobile: false,
            pageable: true,
            reorderable: true,
            resizable: true,
            sortable: true,
            scrollable: true
        };

        vm.openRelatedInstance = openRelatedInstance;

        vm.applyFilter = function(text){
            filterText = angular.copy(text);
            if(vm.dataSource){
                vm.dataSource.read();
            }
        };

        vm.enterFilter = function(e, text){
            if(e.keyCode == 13){ // 13 -> Enter
                vm.applyFilter(text);
            }
        };

        vm.changeRelWidget =function(widget){
            if(widget.default_view){
                var baseWid = widget.uniqueName;
                var dataSource = new kendo.data.DataSource({
                    type: 'odata',
                    transport:{
                        read: {
                            url: '/server/rest/v1/views/' + widget.default_view.id + '/odata.svc?$lookupDisplay=' + widget.default_view.column + '&$select=create_date',
                            beforeSend: function(xhr){
                                xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                                xhr.setRequestHeader('WSID',$rootScope.userData.currentWorkspace.id);
                            },
                            data: function(){
                                var filters = [];
                                var params = {};

                                if(relationIds.length > 0){
                                    params.$notin = baseWid + "_instance_id,'" + relationIds.join("'~~'") + "'";
                                }

                                if(filterText.length > 0){
                                    filters.push("substringof('" + filterText + "'," + widget.default_view.column + ")");
                                }

                                if(filters.length > 0){
                                    params.$filter = '(' + filters.join(' and ') + ')';
                                }

                                return params;
                            },
                            dataType: 'json'
                        }
                    },
                    serverFiltering: true,
                    serverPaging: true,
                    serverSorting: true,
                    pageSize: 10,
                    schema: {
                        model: {
                            fields: {
                                create_date: {
                                    type: 'date',
                                    parse: parseCreateDate
                                }
                            }
                        }
                    }
                });
                if(vm.grid){
                    vm.grid.setDataSource(dataSource);
                    vm.grid.dataSource.read();
                }
                else{
                    vm.relGridOptions.dataSource = dataSource;
                    vm.relGridOptions.dataSource.read();
                }
                vm.dataSource = dataSource;
            }
        };

        vm.toggleSelectRow = function(widgetId, rowId){
            vm.selectedRows[widgetId] = vm.selectedRows[widgetId] || [];
            var selectedRows = vm.selectedRows[widgetId];
            var index = selectedRows.indexOf(rowId);
            if(index < 0){
                selectedRows.push(rowId);
            }
            else{
                selectedRows.splice(index, 1);
            }
        };

        vm.selectAllRows = function(grid, widgetId, selected){
            vm.selectedRows[widgetId] = vm.selectedRows[widgetId] || [];
            var selectedRows = vm.selectedRows[widgetId];
            var rows = grid.dataSource.data();
            if(rows.length > 0){
                var pageNum = grid.pager.page();
                var pageSize = grid.pager.pageSize();
                var start = pageSize * (pageNum - 1);
                var end = (pageSize * pageNum) - 1;
                if(end >= rows.length){
                    end = rows.length - 1;
                }
                for(var r = start; r <= end; r++){
                    var id = rows[r].id;
                    var index = selectedRows.indexOf(id);
                    if(selected && index < 0){
                        selectedRows.push(id);
                    }
                    else if(!selected && index >= 0){
                        selectedRows.splice(index, 1);
                    }
                }
            }
        };

        vm.rowSelected = function(widgetId, id){
            vm.selectedRows[widgetId] = vm.selectedRows[widgetId] || [];
            return vm.selectedRows[widgetId].indexOf(id) >= 0;
        };

        vm.addSelected = function(){
            var data = vm.dataSource.data();
            var wId = vm.selectedWidget.id;
            var widgetName = vm.selectedWidget.name;
            var selectedRows = vm.selectedRows[wId];
            for(var sr = 0; sr < selectedRows.length; sr++){
                var rowId = selectedRows[sr];
                for(var d = 0; d < data.length; d++){
                    if(data[d].id == rowId){
                        vm.relationshipArray.push({
                            id: rowId,
                            widget: widgetName,
                            widgetId: wId,
                            description: data[d].display
                        });
                        relationIds.push(rowId);
                        break;
                    }
                }
            }
            if(vm.dataSource) {
                vm.dataSource.read();
            }
            vm.selectedRows[wId] = [];
        };

        vm.deleteRelationship = function(index, id){
            vm.relationshipArray.splice(index, 1);
            relationIds.splice(relationIds.indexOf(id), 1);

            if(vm.dataSource) {
                vm.dataSource.read();
            }
        };

        vm.close = function(){
            $scope.instanceRelationship.close();
        };

        vm.ok = function(){
            var instanceController = $scope.$parent.vm;
            if(instanceId && instanceId !== ''){
                InstancesService.updateRelationships(instanceId,vm.relationshipArray).then(function(){
                    instanceController.relationships = angular.copy(vm.relationshipArray);
                });
            }
            else{
                instanceController.relationships = angular.copy(vm.relationshipArray);
            }
            vm.close();
        };

        _init();
        ////////////////////
        /**
         * Init controller data and server calls
         */
        function _init() {
            WidgetsService.getWidgets().then(function(data){
                vm.widgetsArray = data;
            });
            if(instanceId && instanceId !== ''){
                InstancesService.getRelationships(instanceId).then(function(d){
                    vm.relationshipArray = angular.copy(d);
                    relationIds = [];
                    for(var r = 0; r < vm.relationshipArray.length; r++){
                        relationIds.push(vm.relationshipArray[r].id);
                    }
                });
            }
        }

        function parseCreateDate(value){
            if(value){
                try {
                    var dateValue = value;

                    if(!_.isDate(dateValue)){
                        dateValue = kendo.parseDate(value, 'MMMM, dd yyyy HH:mm:ss');
                    }

                    var m = moment.utc(dateValue);

                    // Converts to local time
                    m.local();

                    return m.toDate();
                }
                catch(e){}
            }

            return '';
        }

        function addRow(e){
            e.preventDefault();

            var widgetId = vm.selectedWidget.id;
            var widgetName = vm.selectedWidget.name;
            var row = angular.element(e.target).closest('tr');
            var dataItem = vm.grid.dataItem(row);
            var rowId = dataItem.id;

            vm.relationshipArray.push({
                id: rowId,
                widget: widgetName,
                widgetId: widgetId,
                description: dataItem.display
            });

            relationIds.push(rowId);

            vm.dataSource.read();

            //_.remove(vm.selectedRows[widgetId], rowId);
        }

        function openRelatedInstance(rel){
            if(rel.id) {
                InstancesWindowService.openWindow({
                    action: 'read',
                    widgetId: rel.widgetId,
                    instanceId: rel.id,
                    title: rel.description
                });
            }
        }

        $scope.$on('auth:loginCancelled', function () {
            $timeout(function() {
                vm.close();
            });
        });
    }])
    .directive('nimRelationship', function nimRelationship() {
        return {
            restrict: 'AE',
            templateUrl: 'core/instances/instances-relationship-form.tpl.html',
            controller: 'NimRelationshipCtrl',
            controllerAs: 'vm'
        };
    })
;
angular.module('cerberus.core')
    .factory('MenusService', ["_", "$http", "$q", "$rootScope", "$route", "$uibModal", "$location", "toaster", "apiPath", function MenusService(_, $http, $q, $rootScope, $route, $uibModal, $location, toaster, apiPath) {
        var currentDefaultPageId;
        var currentWorkspaceMenu = [];
        var currentWorkspaceMenuId;
        var currentWorkspaceMenuDict = {};
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';

        var service = {
            createMenu: createMenu,
            updateMenu: updateMenu,
            deleteMenu: deleteMenu,
            getMenu: getMenu,
            getWorkspaceMenu: getWorkspaceMenu,
            getMenus: getMenus,
            setDefaultPage: setDefaultPage,
            workspaceMenu: workspaceMenu,
            workspaceMenuDict:workspaceMenuDict,
            editCurrentPage: editCurrentPage,
            editCurrentWorkspaceMenu: editCurrentWorkspaceMenu,
            isPageRoute: isPageRoute,
            isPageActive: isPageActive,
            openWorkspacesModal: openWorkspacesModal,
            clear: clear
        };
        return service;
        ////////////////////

        /**
         * @function createMenu
         * @description Posts data to create new menu in current workspace
         * @param data
         * @returns {promise}
         */
        function createMenu(data){
            var deferred = $q.defer();
            $http.post(apiPath + 'menus', data)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * @function updateMenu
         * @description Updates menu
         * @param id
         * @param data
         * @returns {promise}
         */
        function updateMenu(id, data) {
            var deferred = $q.defer();
            var d = {
                name: data.name,
                description: data.description,
                is_default: data.is_default,
                items: data.items
            };
            $http.put(apiPath + 'menus/' + id, d)
                .success(function(value){
                    $rootScope.$broadcast('nim-menu-updated');
                    toaster.pop('success', 'Menu Updated.');
                    deferred.resolve(value);
                })
                .error(function(reason){
                    toaster.pop('error', 'Error', 'Menu not updated');
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * @function deleteMenu
         * @description Deletes menu by id
         * @param id
         * @returns {promise}
         */
        function deleteMenu(id){
            var deferred = $q.defer();
            $http.delete(apiPath + 'menus/' + id)
                .success(function(value){
                    deferred.resolve(value);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * @function getMenu
         * @description Gets menu items
         * @param [id]
         * @returns {promise}
         */
        function getMenu(id) {
            if(id) {
                var deferred = $q.defer();
                $http.get(apiPath + 'menus/' + id)
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
                return deferred.promise;
            }
            else {
                return getWorkspaceMenu();
            }
        }

        /**
         * @function getDefaultMenu
         * @description Gets current workspace's default menu
         */
        function getWorkspaceMenu(){
            var deferred = $q.defer();
            $http.get(apiPath + 'menus/default')
                .success(function(value){
                    currentWorkspaceMenu = value.DATA.items;
                    currentWorkspaceMenuId = value.DATA.id;
                    processMenu(value.DATA.items, currentWorkspaceMenuDict);
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * @function getMenus
         * @description Gets all menus in current workspace
         * @returns {promise}
         */
        function getMenus(){
            var deferred = $q.defer();
            $http.get(apiPath + 'menus')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * @function setDefaultPage
         * @description Sets page with matching id as default
         * @param id
         * @param menuArray
         */
        function setDefaultPage(id, menuArray){
            var arr = menuArray;
            var setDefault = function(array){
                for(var i = 0;i < array.length; i++){
                    if(array[i].id != id){
                        delete array[i].isDefault;
                    }
                    setDefault(array[i].items);
                }
            };
            setDefault(arr);
        }

        /**
         * Caches the default page and flattens hierarchical structure to a dictionary
         * @param {Array} arr
         * @param {object} dict
         * @param {Array} [idPath]
         * @param {Array} [titlePath]
         */
        function processMenu(arr, dict, idPath, titlePath) {
            idPath = idPath || [];
            titlePath = titlePath || [];
            for (var i = 0, len = arr.length; i < len; i++) {
                dict[arr[i].pageId] = {
                    id: idPath.concat([arr[i].pageId]),
                    title: titlePath.concat([arr[i].title])
                };
                if (arr[i].isDefault === true) {
                    currentDefaultPageId = arr[i].pageId;
                    dict.default = {
                        id: idPath.concat([arr[i].pageId]),
                        title: titlePath.concat([arr[i].title])
                    };
                }
                if(arr[i].items && arr[i].items.length) {
                    var id = idPath.concat([arr[i].pageId]);
                    var title = titlePath.concat([arr[i].title]);
                    processMenu(arr[i].items, dict, id, title);
                }
            }
        }

        /**
         * Finds the default page in a menu array
         * @param {Array} arr
         * @returns {*}
         */
        //function findDefaultPage(arr) {
        //    for (var i = 0, len = arr.length; i < len; i++) {
        //        if (arr[i].isDefault === true) {
        //            return arr[i].pageId;
        //        }
        //        if(arr[i].items && arr[i].items.length) {
        //            return findDefaultPage(arr[i].items);
        //        }
        //    }
        //}

        /**
         * Workspace menu
         * @returns {Array}
         */
        function workspaceMenu() {
            return currentWorkspaceMenu;
        }

        /**
         * Getter setter for workspace menu
         * @returns {object}
         */
        function workspaceMenuDict() {
            return currentWorkspaceMenuDict;
        }

        /**
         * Edit the current page
         */
        function editCurrentPage() {
            var pageId = $route.current.params.pageId;
            if ($route.current.$$route && $route.current.$$route.controller === 'PagesCtrl' && !pageId) {
                pageId = currentDefaultPageId;
            }
            $location.url('/settings/pages/' + pageId);
        }

        /**
         * Edit the current workspace menu (side menu)
         */
        function editCurrentWorkspaceMenu() {
            $location.url('/settings/menus/' + currentWorkspaceMenuId);
        }

        /**
         * Test whether the current route is a page
         * @returns {boolean}
         */
        function isPageRoute() {
            if ($route.current.$$route) {
                return $route.current.$$route.controller === 'PagesCtrl';
            }
            
            return false;
        }

        /**
         * Test whether the current location matches parameters
         * @param {string} viewLocation
         * @param {boolean|*} isDefault
         * @returns {boolean}
         */
        function isPageActive(viewLocation, isDefault) {
            var location = $location.path();
            if ('/' + viewLocation === location || '/settings/pages/' + viewLocation === location) {
                return true;
            }
            else {
                return (isDefault && '/' === location);
            }
        }

        /**
         * Opens the workspace selection modal
         */
        function openWorkspacesModal(orgs) {
            if(!$rootScope.isWorkspaceModalOpen){
                $rootScope.isWorkspaceModalOpen = true;

                var modalInstance = $uibModal.open({
                    templateUrl: 'core/menus/menus-workspaces-modal.tpl.html',
                    controller: 'MenusWorkspacesCtrl',
                    backdropClass: 'darkest',
                    windowClass: 'transparent',
                    size: 'lg',
                    backdrop: 'static',
                    resolve: {
                        userOrgs: function () {
                            if(orgs){
                                // Some functions will check organizations before opening this modal
                                return orgs;
                            }
                            else {
                                return null;
                            }
                        }
                    }
                });

                modalInstance.result.then(function(){
                    $rootScope.isWorkspaceModalOpen = false;
                }, function(){
                    $rootScope.isWorkspaceModalOpen = false;
                });
            }
        }

        /**
         * Cleans up the stored variables; useful for session invalidation.
         */
        function clear() {
            currentDefaultPageId = null;
            currentWorkspaceMenuId = null;
            currentWorkspaceMenu = [];
        }
    }])
;

angular.module('cerberus.core')
/********FROM the Angular 1.3.8 docs*********
 *
 *      enter: function(element, done) {
 *       //run the animation here and call done when the animation is complete
 *       return function(cancelled) {
 *         //this (optional) function will be called when the animation
 *         //completes or when the animation is cancelled (the cancelled
 *         //flag will be set to true if cancelled).
 *       };
 *     },
 *     leave: function(element, done) { },
 *     move: function(element, done) { },
 *
 *     //animation that can be triggered before the class is added
 *     beforeAddClass: function(element, className, done) { },
 *
 *     //animation that can be triggered after the class is added
 *     addClass: function(element, className, done) { },
 *
 *     //animation that can be triggered before the class is removed
 *     beforeRemoveClass: function(element, className, done) { },
 *
 *     //animation that can be triggered after the class is removed
 *     removeClass: function(element, className, done) { }
 */
    .animation('.side-nav-open-animation', ["$window", function ($window) {
            return {
                beforeAddClass : function(element, className, done) {
                    if(className === 'ng-hide') {
                        var tl = new $window.TimelineMax({onComplete:done});
                        var anchors = element.children('li').children('.route');
                        tl.set(element, {height:anchors.outerHeight() * anchors.length, overflow:'hidden'});
                        tl.staggerTo(element.children('li'), 0.25, {marginLeft: -20, opacity: 0.5}, -0.03);
                        tl.to(element, 0.25, {css:{height: 0, clearProps:"height"}, ease:$window.Power1.easeOut}, "-=0.25");
                    }
                },
                removeClass : function(element, className, done) {
                    if(className === 'ng-hide') {
                        var tl = new $window.TimelineMax({onComplete:done});
                        var anchors = element.children('li').children('.route');
                        tl.set(element, {height:0});
                        tl.set(element.children('li'), {marginLeft:-20, opacity:0.5});
                        tl.to(element, 0.25, {css:{height: anchors.outerHeight() * anchors.length, clearProps:"height, overflow"}, ease:$window.Power3.easeOut});
                        tl.staggerTo(element.children('li'), 0.25, {marginLeft: 0, opacity: 1}, 0.03, "-=0.25");
                    }
                }
            };
        }])
;
angular.module('cerberus.core')
    .controller('MenusSideCtrl', ["_", "$scope", "$location", "$routeParams", "MenusService", "OrganizationsService", function MenusSideCtrl(_, $scope, $location, $routeParams, MenusService, OrganizationsService) {
        var vm = this;

        // Menu Containers
        vm.menu = [];

        // Workspaces
        vm.openWorkspacesModal = openWorkspacesModal;
        vm.isPageActive = MenusService.isPageActive;

        // Edit Page
        vm.isPageRoute = MenusService.isPageRoute;
        vm.editCurrentPage = MenusService.editCurrentPage;
        vm.editCurrentMenu = MenusService.editCurrentWorkspaceMenu;

        init();

        ////////////////////

        function init() {
            // Get the Menu
            getMenu();

            // Subscribe to Events
            $scope.$on('nim-menu-updated', getMenu);
            $scope.$on('auth:loginConfirmed', getMenu);
            $scope.$on('auth:loginCancelled', function () {
                vm.menu = [];
                MenusService.clear();
            });
        }

        function getMenu() {
            MenusService.getWorkspaceMenu().then(
                function (defaultMenu) {
                    vm.menu = defaultMenu.items;

                    // Checks which menu item, if any, should be open
                    // Only runs until current page is found
                    _.some(defaultMenu.items, checkIfOpen);
                }
            );
        }

        // Checks if menu item should be open
        function checkIfOpen(item){
            if($routeParams.pageId === item.pageId){
                return true;
            }
            else if(!_.isEmpty(item.items)){
                // This item should be open if one of its nested items is the current page
                return item.open = _.some(item.items, checkIfOpen);
            }
            return false;
        }

        function openWorkspacesModal() {
            OrganizationsService.getUserOrganizations().then(function (orgs) {
                if (orgs.length == 1 && orgs[0].workspaces.length == 1) {
                    $location.url('');
                    return;
                }

                MenusService.openWorkspacesModal(orgs);
            });    
        }
    }])
;
angular.module('cerberus.core')
    .directive('nimSideMenu', ["DeviceSniffService", function(DeviceSniffService){
        return {
            link: function (scope, element) {

                scope.appUI.isLeftBarCollapsed = DeviceSniffService.deviceWidth() <= 768;

                // Collapse Side Menu on small device
                element.bind('resize', function() {
                    scope.appUI.isLeftBarCollapsed = DeviceSniffService.deviceWidth() <= 768;
                });
            }
        };
    }])
;
angular.module('cerberus.core')
    .directive('nimSideMenuItem', ["$location", "$timeout", function($location, $timeout){
        return {
            link: function (scope, element) {
                var children = element.children('.route');
                children.on('click', clickHandler);
                if(scope.item.isTopLevel){
                    scope.$watch(hasActiveChildren, function (newValue) {
                        var val = newValue || false;
                        element.toggleClass('sub-active', val);
                    });
                }
                scope.$on('$destroy', function () {
                    children.off('click');
                });
                ////////////////////
                function hasActiveChildren() {
                    return $(element).find('.active').length > 0;
                }
                function clickHandler(e) {
                    e.preventDefault();

                    $timeout(function(){
                        if(scope.userData.currentWorkspace.isAdmin === true && e.ctrlKey){
                            $location.url('/settings/pages/' + scope.item.pageId);
                        }
                        else {
                            $location.url('/' + scope.item.pageId);
                        }
                    });
                }
            }
        };
    }])
;
angular.module('cerberus.core')
    .controller('MenusTopCtrl', ["$scope", "$document", "$window", "$rootScope", "$location", "$timeout", "$firebaseObject", "toaster", "fbUtil", "appSettingsService", "AuthService", "DeviceSniffService", "MenusService", "nimTitleService", "normalPrintingService", "NotificationsService", function MenusTopCtrl($scope, $document, $window, $rootScope, $location, $timeout, $firebaseObject, toaster, fbUtil, appSettingsService, AuthService, DeviceSniffService, MenusService, nimTitleService, normalPrintingService, NotificationsService) {
        $scope.branding = appSettingsService.branding();
        $scope.workspacePath = $rootScope.userData.currentWorkspace.path;
        $scope.searchDropdownMenuSettings = {
            'auto-close': 'outsideClick'
        };
        $scope.notifications = [];
        $scope.totalUnread = 0;
        $scope.markingAsRead = {};
        $rootScope.printingPage = false;

        $scope.isPageRoute = MenusService.isPageRoute;
        $scope.markAsRead = markAsRead;
        
        var unwatchFb = $firebaseObject(fbUtil.ref('notifications/' + $rootScope.userData.id)).$watch(function () {
            $timeout(function () {
                refreshNotifications();
				if ($scope.totalUnread > 0) {
					toaster.pop('info', 'You have notifications.');
				}
            }, 1000);
        });

        //User Functions
        $scope.logout = function () {
            AuthService.logout();
        };

        //Search
        $scope.goToSearch = function(txt){
            if(txt){
                $location.url('/search').search({q: txt});
            }
            else{
                $location.url('/search');
            }
        };
        //Download Pdf
        $scope.printCurrentPage = function(){
            if(!$scope.printingPage){
                $rootScope.printingPage = true;
                var title = nimTitleService.get(),
                    options = {
                        landscape: false,
                        margin: 0
                    };
                
                var pageContent = $document.find('#page-content > #content-wrap > .gridster-container');

                $timeout(function () {
                    normalPrintingService.printElement(pageContent, title, options).then(function () {
                        $rootScope.printingPage = false;
                    });
                }, 1000);
            }
        };

        //Override for top menu navigation
        $scope.navigate = function(appUI, path){
            appUI.isTopBarCollapsed = true;

            // Handle navigation on mobile
            if(DeviceSniffService.isMobile()) {
                $location.url(path);
            }
        };

        $scope.focusMe = function(e){
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            angular.element(e.target).trigger('focus');
        };

        // If user clicks on top menu on mobile device, close side menu
        $scope.closeSideMenu = function(appUI){
            if (DeviceSniffService.isMobile()){
                appUI.isLeftBarCollapsed = true;
            }
        };

        $scope.$on('destroy', function () {
            unwatchFb();
        });

        function refreshNotifications() {
            NotificationsService.getNotifications(5, 0).then(function (result) {
                $scope.notifications = result.notifications;
                $scope.totalUnread = result.totalUnread;
            });
        }

        function markAsRead(notification) {
            if (!notification.isRead && !$scope.markingAsRead[notification.id]) {
                $scope.markingAsRead[notification.id] = true;

                NotificationsService.markAsRead(notification.id).then(function () {
                    $scope.markingAsRead[notification.id] = false;
                    notification.isRead = true;
                }, function () {
                    $scope.markingAsRead[notification.id] = false;
                });
            }    
        }
    }])
;
angular.module('cerberus.core')
    .controller('MenusWorkspacesCtrl', ["$scope", "$location", "$uibModalInstance", "userOrgs", "OrganizationsService", function MenusWorkspacesCtrl($scope, $location, $uibModalInstance, userOrgs, OrganizationsService) {
        $scope.orgs = [];
        $scope.filter = '';
        $scope.setFilter = function (value) {
            $scope.filter = value;
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss();
        };

        init();

        function init(){
            if(!userOrgs) {
                OrganizationsService.getUserOrganizations().then(function (userOrgs) {
                    $scope.orgs = userOrgs;
                    $scope.filter = getCurrentOrg(userOrgs);
                });
            }
            else {
                $scope.orgs = userOrgs;
                $scope.filter = getCurrentOrg(userOrgs);
            }
        }

        function getCurrentOrg(userOrgs) {
            var host = $location.host();
            var org = '';
            var isOrgValid = false;
            host = host.split('.');
            if (host.length > 2) {
                host.pop();
                host.pop();
                org = host.toString().replace(',', '.');
            }
            for (var i = 0; i < userOrgs.length; i++) {
                if (userOrgs[i].sub_domain === org) {
                    isOrgValid = true;
                    break;
                }
            }
            return isOrgValid ? org : '';
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.core')
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/notifications', {
            templateUrl: 'core/notifications/templates/notifications.tpl.html',
            controller: 'NotificationsCtrl',
            controllerAs: 'vm',
            title: 'Notifications',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
    }])
;
angular.module('cerberus.core')
    .controller('NotificationsCtrl', ["_", "$scope", "NotificationsService", "InstancesWindowService", function (_, $scope, NotificationsService, InstancesWindowService) {
        var vm = this, 
			pageSize = 5;

        vm.notifications = [];
        vm.notificationsBeingMarkedAsRead = {};
		vm.notificationsBeingMarkedAsDeleted = {};
        vm.markingAsRead = false;
        vm.markingAsDeleted = false;
        vm.markingAllAsRead = false;
		vm.markingAllAsDeleted = false;
        vm.loadingNotifications = false;
        vm.allNotificationsLoaded = false;

        vm.openNotification = openNotification;
        vm.markAsRead = markAsRead;
        vm.markAllAsRead = markAllAsRead;
		vm.deleteNotification = deleteNotification;
		vm.deleteAllNotifications = deleteAllNotifications;
        vm.loadNextPage = loadNextPage;

        init();

        function init() {
            loadNextPage();
        }

        //Open notification in a separate window, enable function when no pending operations are running and when record is not deleted.
        function openNotification(notification) {
            if (!notification.isDeleted && !vm.notificationsBeingMarkedAsDeleted[notification.id] && !vm.notificationsBeingMarkedAsRead[notification.id]) {
                var navFunctions = {getNext: false, getPrevious: false};
                InstancesWindowService.openWindow({
                    action: 'read',
                    instanceId: notification.instanceId,
                    navFunctions: navFunctions
                });
            }
        }

        //mark notifications as read  
        function markAsRead(notification) {
            if (!notification.isRead && !vm.notificationsBeingMarkedAsRead[notification.id]) {
                updateMarkingAsRead(notification.id, true);

                NotificationsService.markAsRead(notification.id).then(function () {
                    updateMarkingAsRead(notification.id, false);
                    notification.isRead = true;
                    vm.totalUnread--;
                }, function () {
                    updateMarkingAsRead(notification.id, false);
                });
            }
        }

        function markAllAsRead(notifications) {
            var unreadNotifications = _.reject(notifications, 'isRead');
            if (unreadNotifications.length) {
                vm.markingAllAsRead = true;
                NotificationsService.markAllAsRead(_.map(unreadNotifications, 'id')).then(function () {
                    vm.markingAllAsRead = false;
                    _.forEach(unreadNotifications, function (n){
                        n.isRead = true;
                        vm.totalUnread--;
                    });
                });
            }
        }

        function updateMarkingAsRead(id, value) {
            vm.notificationsBeingMarkedAsRead[id] = value;
            vm.markingAsRead = _.some(vm.notificationsBeingMarkedAsRead);
        }

        //delete notifications (Include only if are not deleted yet and if is not marked already as Deleted)
         function deleteNotification(notification) {
            if (!notification.isDeleted && !vm.notificationsBeingMarkedAsDeleted[notification.id]) {
                updateMarkingAsDeleted(notification.id, true);
                NotificationsService.deleteNotification(notification.id).then(function () {
                    updateMarkingAsDeleted(notification.id, false);
                    notification.isDeleted = true;
                    vm.totalUserNotifications--;
                    if (notification.isRead == false) {
                        notification.isRead = true;
                        vm.totalUnread--;
                    }
                }, function () {
                    updateMarkingAsDeleted(notification.id, false);
                });
            }
        }
        
        //delete all notifications (Include only if are not deleted yet and if are marked already as Read)
        function deleteAllNotifications(notifications) {
            var undeletedNotifications = _.reject(_.filter(notifications, 'isRead'), 'isDeleted');
            if (undeletedNotifications.length) {
                vm.markingAllAsDeleted = true;
                NotificationsService.deleteAllNotifications(_.map(undeletedNotifications, 'id')).then(function () {
                    vm.markingAllAsDeleted = false;
                    _.forEach(undeletedNotifications, function (n){
                        n.isDeleted = true;
                        vm.totalUserNotifications--;
                        if (n.isRead == false) {
                            n.isRead = true;
                            vm.totalUnread--;
                        }
                    });
                    //update list after mass deletion
                    vm.notifications = [];
                    loadNextPage();
                });
            }
        }

        function updateMarkingAsDeleted(id, value) {
            vm.notificationsBeingMarkedAsDeleted[id] = value;
            vm.markingAsDeleted = _.some(vm.notificationsBeingMarkedAsDeleted);
        }

        //get content and load next page
        function loadNextPage() {
            vm.loadingNotifications = true;
            NotificationsService.getNotifications(pageSize, vm.notifications.length).then(function (result) {
                vm.loadingNotifications = false;
                vm.notifications = vm.notifications.concat(result.notifications);
                vm.totalUnread = result.totalUnread;
                vm.totalUserNotifications = result.totalUserNotifications;

                if (result.notifications.length < pageSize) {
                    vm.allNotificationsLoaded = true;
                }
            });
        }
    }])
;
angular.module('cerberus.core')
    .factory('NotificationsService', ["_", "apiPath", "moment", "$http", "$q", function NotificationsService(_, apiPath, moment, $http, $q) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            getNotifications: getNotifications,
            markAsRead: markAsRead,
            markAllAsRead: markAllAsRead,
            deleteNotification: deleteNotification,
            deleteAllNotifications: deleteAllNotifications
        };

        function getNotifications(top, skip) {
            var deferred = $q.defer(),
                config = {
                    params: {
                        $top: top,
                        $skip: skip
                    }
                };

            $http.get(apiPath + 'notifications', config)
                .success(function (response) {
                    deferred.resolve(
                        formatNotificationsResponseData(response.DATA)
                    );
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });

            return deferred.promise;
        }

        function markAsRead(notificationId) {
            var deferred = $q.defer();

            $http.put(apiPath + 'notifications/' + notificationId, {})
                .success(function (response) {
                    deferred.resolve(response.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });

            return deferred.promise;
        }

        function markAllAsRead(notificationIds) {
            var promises = [];
            _.forEach(notificationIds, function (id) {
                promises.push(markAsRead(id));
            });

            return $q.all(promises);
        }

        function deleteNotification(notificationId) {
            var deferred = $q.defer();

            $http.put(apiPath + 'notifications/' + notificationId + '/delete', {})
                .success(function (response) {
                    deferred.resolve(response.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });

            return deferred.promise;
        }

        function deleteAllNotifications(notificationIds) {
            var promises = [];
            _.forEach(notificationIds, function (id) {
                promises.push(deleteNotification(id));
            });

            return $q.all(promises);
        }

        /********** Helpers **********/

        function formatNotificationsResponseData(responseData) {
            responseData.totalUnread = _.get(responseData, 'totalNotifications[0].TOT_UNREAD', 0);
            responseData.totalUserNotifications = _.get(responseData, 'totalNotifications[0].TOT_RECORDS', 0);
            _.forEach(responseData.notifications, function (notification) { 
                notification.date = moment.utc(notification.date, 'MMMM, DD YYYY hh:mm:ss').toDate();
            });

            return responseData;
        }
    }])    
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name PagesClassService
     * @alias cerberus/core:PagesClassService
     * @description
     *   Constructs PageObject class
     */
    .factory('PagesClassService', ["WrapperClassService", "VizClassService", function PagesClassService(WrapperClassService, VizClassService) {
        /**
         * Constructs a new tabset
         * @class Tab
         * @classdesc for use with a tabset
         * @memberOf PagesClassService
         * @param {string} icon
         * @param {string} text
         * @param {boolean} active
         * @param {boolean} disabled
         * @param {string} link
         */
        function Tab(icon, text, active, disabled, link) {
            this.icon = icon;
            this.text = text;
            this.active = active;
            this.disabled = disabled;
            this.link = link;
        }

        /**
         * Constructs a new PageObject
         * @class PageObject
         * @classdesc describes a PageObject
         * @memberOf PagesClassService
         * @param {string} id
         * @param {string} type
         * @param {string} subType
         * @param {Object} tools - Actions or Commands that are allowed by the page object
         * @param {Object} filterMap - Maps page filters to adjust the query
         * @param {Wrapper} wrapper - the wrapper that transcludes the viz
         * @param {Viz} viz - the visualization (chart, table, etc)
         * @param {Object} params - additional parameters for specific subtypes
         */
        function PageObject(id, type, subType, tools, filterMap, wrapper, viz, params) {
            this.id = id;
            this.type = type;
            this.subType = subType;
            this.tools = tools;
            this.filterMap = filterMap;
            this.wrapper = wrapper;
            this.viz = viz;
            this.params = params;
            this.name = '';
            this.sizeX = 6;
            this.sizeY = 7;
        }

        /**
         * setData method - revive/extend json objects
         * @memberOf PageObject
         */
        PageObject.prototype.setData = function (pageObject) {
            angular.extend(this, pageObject);
        };

        return {
            pageObject: PageObject,
            newPageObject: newPageObject,
            tab: tab,
            tabset: tabset,
            button: button
        };
        ////////////////////
        /**
         * Builds a empty page object
         * @function newPageObject
         * @returns {PageObject}
         */
        function newPageObject() {
            return new PageObject(
                null,
                null,
                null,
                {},
                {},
                WrapperClassService.newWrapper(),
                VizClassService.newViz(),
                {}
            );
        }

        /**
         * Builds a empty view control button
         * @function tab
         * @returns {Tab}
         */
        function tab() {
            return new Tab(null, null, false, false, null);
        }

        /**
         * Builds a empty view control page object
         * @function tabset
         * @returns {PageObject}
         */
        function tabset() {
            return new PageObject(
                'tabset',
                'tabset',
                null,
                {},
                {},
                WrapperClassService.newWrapper(),
                VizClassService.newViz(),
                {
                    type: 'tabs',
                    vertical: false,
                    justified: false,
                    tabs: [
                        this.tab()
                    ]
                }
            );
        }

        function button() {
            return new PageObject(
                'button',
                'button',
                null,
                {},
                {},
                WrapperClassService.newWrapper(),
                VizClassService.newViz(),
                {
                    buttons: []
                    //icon: '',
                    //label: '',
                    //action: 'route',    // 'route' | 'create' | 'link'
                    //targetId: '',       // ID of widget or page
                    //type: 'single',     //  'single' | 'split' | 'dropdown'
                    //style: 'default',   // 'danger' | 'primary' | 'info' | 'warning' | 'default'
                    //items: []
                }
            );
        }
    }])
;
angular.module('cerberus.core')
    .controller('PagesCtrl', ["_", "$scope", "$location", "$rootScope", "$window", "pageId", "PagesService", "MenusService", "nimTitleService", "$timeout", function PagesCtrl(_, $scope, $location, $rootScope, $window, pageId, PagesService, MenusService, nimTitleService, $timeout) {
        // Filters
        $scope.filters = PagesService.readUrlParams($location.search());

        $scope.$watch('filters', function(filter){
            if(filter) {
                $location.replace().search(PagesService.buildUrlParams(filter));
            }
            else {
                $location.replace().search({});
            }
        }, true);

        $window.Pace.on('done', paceDone);
        $window.Pace.on('restart', paceRestart);

        $scope.gridsterContainerStyle = {};

        $scope.$watch(function () {
            return MenusService.workspaceMenuDict()[pageId || 'default'];
        }, function (newValue) {
            if (newValue) {
                $scope.crumbTrail = newValue;
                nimTitleService.set(newValue.title[newValue.id.length - 1]);
            }
        });

        $scope.$on('$destroy', function(){
            $window.Pace.off('done', paceDone);
            $window.Pace.off('restart', paceRestart);
        });
        
        $scope.$on('$locationChangeStart', function (e, newUrl, oldUrl) {
            newUrl = newUrl || '';
            oldUrl = oldUrl || '';

            if (!e.defaultPrevented) {
                var path = $location.path();
                // Ignore this event if path did not change
                if (newUrl.indexOf(path) < 0 || oldUrl.indexOf(path) < 0) {
                    $scope.$broadcast('nim-remove-page-objects');
                }
            }
        });

        _init();
        ////////////////////
        function _init(){
            if(pageId){
                PagesService.getPage(pageId).then(setPageModel);
            }
            else {
                PagesService.getDefault().then(setPageModel);
            }

            $scope.userInfo = PagesService.getUserInfo();
        }

        function setPageModel(pageModel){
            $scope.pageModel = pageModel;
            $scope.gridsterOptions = {
                mobileBreakPoint: 768,
                margins: _.get($scope.pageModel, 'options.gridsterConfig.margins', [15, 15]),
                outerMargin: _.get($scope.pageModel, 'options.gridsterConfig.outerMargin', true),
                pushing: true,
                floating: true
            };

            // Protects against potential issue with gridster margins being saved as an object instead of an array
            if(!_.isArray($scope.gridsterOptions.margins)){
                $scope.gridsterOptions.margins = [
                    $scope.gridsterOptions.margins[0],
                    $scope.gridsterOptions.margins[1]
                ];
            }

            $scope.$watch('printingPage', function (isPrinting, wasPrinting) {
                if (isPrinting && !wasPrinting) {
                    var width = 816 + (2 * $scope.gridsterOptions.margins[0]);
                    $scope.gridsterContainerStyle.width = width + 'px';
                }
                else if (wasPrinting && !isPrinting) {
                    $scope.gridsterContainerStyle.width = 'auto';
                }
            });
        }

        function paceDone(){
            $timeout(function(){
                $window.status = "Complete";
            });
        }

        function paceRestart(){
            $timeout(function(){
                $window.status = "";
            });
        }
    }])
;
angular.module('cerberus.core')
    .controller('PagesNestedCtrl', ["_", "$scope", "$timeout", "PagesService", function PagesNestedCtrl(_, $scope, $timeout, PagesService) {
        $scope.nested = true;
        $scope.gridsterOptions = {
            mobileBreakPoint: 768,
            margins: [0,0],
            outerMargin: false,
            pushing: true,
            floating: true
        };
        $scope.getPage = function (id) {
            if(id) {
                PagesService.getPage(id)
                    .then(function (data) {
                        var resizeGridsterItem = $scope.resizeGridsterItem || angular.noop;
                        if (!angular.equals(data, $scope.pageModelNested)) {
                            $scope.pageModelNested = data;
                            $scope.gridsterOptions.margins = _.get($scope.pageModel, 'options.gridsterConfig.margins', [15, 15]);

                            // Protects against potential issue with gridster margins being saved as an object instead of an array
                            if(!_.isArray($scope.gridsterOptions.margins)){
                                $scope.gridsterOptions.margins = [
                                    $scope.gridsterOptions.margins[0],
                                    $scope.gridsterOptions.margins[1]
                                ];
                            }
                        }

                        $timeout(function(){
                            resizeGridsterItem();
                        }, 400);
                    });
            }
        };
    }])
;
angular.module('cerberus.core')
    .controller('NimPageObjectCtrl', ["_", "kendo", "$scope", "$attrs", "$timeout", "$log", "pageObjectsService", "printService", "InstancesWindowService", function NimPageObjectCtrl(_, kendo, $scope, $attrs, $timeout, $log,
                                                                pageObjectsService, printService, InstancesWindowService) {
        // In order to not create another scope we are using the $parse service
        // This controller is meant to be inside an ngRepeat which automagically creates new scopes
        // EDIT: Replaced with $scope.$eval, which is a wrapper for $parse for the given scope
        $scope.pageObject = $scope.$eval($attrs.nimPageObject);
        $scope.nimEditing = $scope.$eval($attrs.isEditingPage);
        $scope.isPreview = false;
        $scope.nimParentId = $scope.$eval($attrs.parentId);
        $scope.nimParentLookUp = $scope.$eval($attrs.parentLookUp);
        $scope.nimIsAdvSelObject = $scope.$eval($attrs.nimAdvSelObject);

        $scope.headerText = '';
        $scope.bodyText = '';
        $scope.footerText = '';

        // $scope.mainPageObject is used to reference child scopes via prototypical inheritance;
        // for example the Viz controller will expose itself via the property .vizCtrl
        $scope.mainPageObject = {};

        // Build Toolbar options with actions as callbacks
        $scope.toolbarOptions = pageObjectsService.buildToolbar($scope.pageObject.tools, {
            templateFunc: toolbarTemplate,
            refreshCb: reloadViz,
            createCb: createInstance,
            deleteCb: deleteSelected,
            printCb: print,
            printLabelsCb: printLabels,
            printChecksCb: printChecks,
            exportXLSCb: exportXLS,
            exportAllXLSCb: exportAllAsXLS,
            exportICSCb: exportICS,
            uploadFilesCb: uploadFiles,
            massImportCb: massImport
        });

        $scope.buttonClick = pageObjectsService.buttonClickHandler;

        var instanceFunctions = {
            callback: instanceCallback
        };

        if ($scope.nimEditing) {
            $scope.isPreview = $scope.$eval($attrs.nimPreviewPageObject);
        }

        $scope.$on('$destroy', function () {
            delete instanceFunctions.callback;
        });

        $scope.$watch(function () {
            var compileData = {
                data: _.get($scope.mainPageObject, 'vizCtrl.data')
            };

            if (_.get($scope.pageObject, 'viz.type') == 'table') {
                compileData.selected = _.get($scope.mainPageObject, 'vizCtrl.selectedRows', []);

                if (!$scope.pageObject.params.allowMultiSelect) {
                    compileData.selected = _.head(compileData.selected);
                }

                compileData.aggregates = _.get($scope.mainPageObject, 'vizCtrl.aggregates', {});
            }

            return compileData;
        }, function (compileData) {
            if (compileData.data) {
                if ($scope.pageObject.wrapper.header.text) {
                    $scope.headerText = pageObjectsService.setHtml($scope.pageObject.wrapper.header.text, compileData);
                }
                if ($scope.pageObject.wrapper.body.text) {
                    $scope.bodyText = pageObjectsService.setHtml($scope.pageObject.wrapper.body.text, compileData);
                }
                if ($scope.pageObject.wrapper.footer.text) {
                    $scope.footerText = pageObjectsService.setHtml($scope.pageObject.wrapper.footer.text, compileData);
                }
            }
        }, true);

        /////////////////////
        function reloadViz() {
            pageObjectsService.reloadViz($scope);
        }
        function createInstance() {
            InstancesWindowService.openWindow({
                action: 'create',
                widgetId: $scope.pageObject.viz.widgetId,
                title: $scope.pageObject.name,
                defaultData: buildDefaultDataArray(),
                navFunctions: instanceFunctions
            });
        }
        function buildDefaultDataArray() {
            var defaultDataArray = [];

            //Default Data Check for filters
            if($scope.pageObject.params.defaultData){
                for(var i = 0; i < $scope.pageObject.params.defaultData.length; i++){
                    if($scope.filters[$scope.pageObject.params.defaultData[i].value]){
                        defaultDataArray.push({
                            data: $scope.filters[$scope.pageObject.params.defaultData[i].value].filters[0],
                            field: $scope.pageObject.params.defaultData[i].formField
                        });
                    }
                }
            }

            pageObjectsService.addCustomValuesToDefaultData(defaultDataArray, $scope.pageObject.params.defaultValues);

            return defaultDataArray;
        }
        function deleteSelected() {
            pageObjectsService.deleteInstance(
                $scope.mainPageObject.vizCtrl.selectedIds,
                function () {
                    broadcastVizUpdate('delete', $scope.mainPageObject.vizCtrl.selectedIds, []);
                });
        }

        function print(){
            // Prints compiled template content
            if($scope.pageObject.viz.type === 'template') {
                pageObjectsService.printPageObject($scope.mainPageObject.vizCtrl.templateHtml);
            }
            // Prints selected instances
            else if($scope.pageObject.viz.type === 'table'){
                var widgetId = _.get($scope.pageObject, 'viz.widgetId'),
                    instanceIds = _.get($scope.mainPageObject, 'vizCtrl.selectedIds');

                if(widgetId && !_.isEmpty(instanceIds)) {
                    var displayValues = {},
                        displayCol = _.get($scope.pageObject, 'params.filterDisplay', ''),
                        enabledPrintTypes = {
                            normal: true,
                            check: _.get($scope.pageObject, 'params.printChecks', false),
                            label: _.get($scope.pageObject, 'params.printLabels', false)
                        },
                        defaultConfig = {
                            // filename: $scope.pageObject.name
                        },
                        defaultFilename = kendo.format('{0} - {1:u}', $scope.pageObject.name, new Date());
                    
                    if (displayCol) {
                        var rows = _.get($scope.mainPageObject, 'vizCtrl.selectedRows');
                        _.forEach(rows, function (r) {
                            displayValues[r.id] = _.get(r, displayCol, '[' + r.id + ']');
                        });
                    }

                    printService.configureAndPrint(widgetId, angular.copy(instanceIds), displayValues, enabledPrintTypes, defaultConfig, defaultFilename).then(function(){
                        _.set($scope.mainPageObject, 'vizCtrl.selectedRows', []);
                        _.set($scope.mainPageObject, 'vizCtrl.selectedIds', []);
                    });
                }
            }
        }

        function printLabels(){
            // Prints selected instances
            if($scope.pageObject.viz.type === 'table'){
                var widgetId = _.get($scope.pageObject, 'viz.widgetId'),
                    instanceIds = _.get($scope.mainPageObject, 'vizCtrl.selectedIds');

                if(widgetId && !_.isEmpty(instanceIds)) {
                    var displayValues = {},
                        displayCol = _.get($scope.pageObject, 'params.filterDisplay', ''),
                        enabledPrintTypes = {
                            label: true
                        },
                        defaultConfig = {
                            type: 'label'
                        },
                        defaultFilename = kendo.format('Labels - {0:yyyy-MM-dd HH-mm-ss}', new Date());

                    if (displayCol) {
                        var rows = _.get($scope.mainPageObject, 'vizCtrl.selectedRows');
                        _.forEach(rows, function (r) {
                            displayValues[r.id] = _.get(r, displayCol, '[' + r.id + ']');
                        });
                    }

                    printService.configureAndPrint(widgetId, angular.copy(instanceIds), displayValues, enabledPrintTypes, defaultConfig, defaultFilename).then(function(){
                        _.set($scope.mainPageObject, 'vizCtrl.selectedRows', []);
                        _.set($scope.mainPageObject, 'vizCtrl.selectedIds', []);
                    });
                }
            }
        }

        function printChecks(){
            // Prints selected instances
            if($scope.pageObject.viz.type === 'table'){
                var widgetId = _.get($scope.pageObject, 'viz.widgetId'),
                    instanceIds = _.get($scope.mainPageObject, 'vizCtrl.selectedIds');

                if(widgetId && !_.isEmpty(instanceIds)) {
                    var displayValues = {},
                        displayCol = _.get($scope.pageObject, 'params.filterDisplay', ''),
                        enabledPrintTypes = {
                            check: true
                        },
                        defaultConfig = {
                            type: 'check'
                        },
                        defaultFilename = kendo.format('Checks - {0:yyyy-MM-dd HH-mm-ss}', new Date());

                    if (displayCol) {
                        var rows = _.get($scope.mainPageObject, 'vizCtrl.selectedRows');
                        _.forEach(rows, function (r) {
                            displayValues[r.id] = _.get(r, displayCol, '[' + r.id + ']');
                        });
                    }

                    printService.configureAndPrint(widgetId, angular.copy(instanceIds), displayValues, enabledPrintTypes, defaultConfig, defaultFilename).then(function(){
                        _.set($scope.mainPageObject, 'vizCtrl.selectedRows', []);
                        _.set($scope.mainPageObject, 'vizCtrl.selectedIds', []);
                    });
                }
            }
        }

        function exportXLS(){
            if ($scope.mainPageObject.vizCtrl.exportXLS) {
                $scope.mainPageObject.vizCtrl.exportXLS();
            }
        }

        function exportAllAsXLS(){
            if ($scope.mainPageObject.vizCtrl.exportAllAsXLS) {
                $scope.mainPageObject.vizCtrl.exportAllAsXLS();
            }
        }
        
        function exportICS(){
            if ($scope.mainPageObject.vizCtrl.exportICS) {
                $scope.mainPageObject.vizCtrl.exportICS();
            }
        }

        function uploadFiles(){
            // if ($scope.mainPageObject.vizCtrl.uploadFiles) {
            //     $scope.mainPageObject.vizCtrl.uploadFiles();
            // }
            pageObjectsService.openUploadModal($scope.pageObject, buildDefaultDataArray());
        }

        function massImport(){
			pageObjectsService.openMassImportModal($scope.pageObject).then(function(){
            });
        }

        function toolbarTemplate() {
            var compileData = {
                data: _.get($scope.mainPageObject, 'vizCtrl.data', [])
            };

            if ($scope.pageObject.type === 'viz') {
                if ($scope.pageObject.viz.type === 'table') {
                    compileData.selected = _.get($scope.mainPageObject, 'vizCtrl.selectedRows', []);
                }
                if ($scope.pageObject.viz.type === 'schedule') {
                    compileData.selected = _.get($scope.mainPageObject, 'vizCtrl.selectedEvents', []);
                }
                if ($scope.pageObject.viz.type === 'list') {
                    compileData.selected = _.get($scope.mainPageObject, 'vizCtrl.selectedItems', []);
                }
            }

            try {
                var temp = kendo.template($scope.pageObject.tools.template);

                return temp(compileData);
            }
            catch (e) {
                $log.error(e);
                return '';
            }
        }

        function broadcastVizUpdate(action, id, data) {
            if(action && id){
                $scope.$broadcast('nim-viz-update-data', action, id, data);
            }
        }

        function instanceCallback(id, action, data) {
            // Replacement for reload
            broadcastVizUpdate(action, id, data);
        }

        //function exportPDF(){
        //    if ($scope.mainPageObject.vizCtrl.exportPDF) {
        //        $scope.mainPageObject.vizCtrl.exportPDF();
        //    }
        //}
    }])
    .directive('nimPageObject', ["$compile", "$timeout", "$window", "pageObjectsService", function($compile, $timeout, $window, pageObjectsService) {
        return {
            restrict: 'AE',
            controller: 'NimPageObjectCtrl',
            link: function(scope, element) {
                // Attribute no-wrapper can be added to the nim-page-object to display the page object without a wrapper
                var noWrapper = element.attr('no-wrapper');
                var wrapperType = scope.pageObject.wrapper.type;
                if(typeof noWrapper !== 'undefined' && noWrapper !== false && noWrapper !== 'false'){
                    wrapperType = 'none';
                }

                element.empty()
                    .append($compile(
                        pageObjectsService.buildHtml(
                            scope.pageObject.type,
                            wrapperType,
                            scope.pageObject.viz.type,
                            scope.pageObject.viz.subType,
                            scope.pageObject.viz.template
                        )
                    )(scope));

                if(scope.pageObject.type === 'tabset'){
                    var jqWindow = angular.element($window);

                    jqWindow.bind('focus', function() {
                        $timeout(function(){
                            resizeGridsterItem();
                        }, 1);
                    });

                    scope.$on('$destroy', function () {
                        jqWindow.unbind('focus');
                    });
                }

                if (!scope.nimParentId) {
                    scope.resizeGridsterItem = resizeGridsterItem;
                }

                function resizeGridsterItem(){
                    if(!scope.nimParentId){
                        if(scope.gridsterItem && scope.gridsterItem.gridster) {
                            var rowHeight = scope.gridsterItem.gridster.rowHeight;
                            var gridsterMargin = scope.gridsterItem.gridster.margins[0] || 0;
                            var section = element.children('.nim-wrapper').children('section');
                            var innerHeight = cssAsInt(section, 'paddingTop') + cssAsInt(section, 'paddingBottom') + cssAsInt(section, 'marginTop') + cssAsInt(section, 'marginBottom') + (gridsterMargin * 2) + 1;

                            section.children('.wrapper').children().each(function(i, element){
                                var child = $(element);

                                if(child.hasClass('body')){
                                    child.children().each(function(j, bodyElem){
                                        innerHeight += $(bodyElem).outerHeight(true);
                                    });

                                    innerHeight += 6;
                                }
                                else if(child.hasClass('toolbar')) {
                                    innerHeight += child.outerHeight(false);
                                }
                                else {
                                    innerHeight += child.outerHeight(true);
                                }
                            });

                            if(scope.tab){
                                $timeout(function(){
                                    (scope.$parent.resizeGridsterItem || angular.noop)();
                                }, 100);
                            }

                            var rows = Math.ceil(innerHeight / rowHeight);

                            $timeout(function(){
                                if(scope.gridsterItem && scope.gridsterItem.gridster) {
                                    scope.gridsterItem.setSizeY(rows);
                                }
                            });
                        }
                    }
                }

                function cssAsInt(element, css) {
                    var px = element.css(css);
                    return parseInt(px.replace('px', ''));
                }
            }
        };
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name pageObjectService
     * @alias cerberus/core:pageObjectService
     * @description Utilities for the nimPageObject directive
     */
    .factory('pageObjectsService', ["_", "apiPath", "kendo", "$location", "$window", "$http", "$q", "$log", "$sce", "$uibModal", "ConfirmModalService", "InstancesService", "InstancesWindowService", function pageObjectsService(_, apiPath, kendo, $location, $window, $http, $q, $log, $sce, $uibModal,
                                                               ConfirmModalService, InstancesService, InstancesWindowService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        var service = {
            buildHtml: buildHtml,
            buildToolbar: buildToolbar,
            deleteInstance: deleteInstance,
            reloadViz: reloadViz,
            printPageObject: printPageObject,
            buttonClickHandler: buttonClickHandler,
            getPageObject: getPageObject,
            getPageObjects: getPageObjects,
            getUnusedPageObjects: getUnusedPageObjects,
            setHtml: setHtml,
            escapePoundSign: escapePoundSign,
            addCustomValuesToDefaultData: addCustomValuesToDefaultData,
            openUploadModal: openUploadModal,
            openMassImportModal: openMassImportModal
        };
        return service;
        ////////////////////////
        /**
         * Given a PageObject this function will build the appropriate
         * Kendo UI Toolbar options object
         * @param type - viz | tabset | button
         * @param wrapperType - tile | portlet | circleTile
         * @param vizType - chart | static | table
         * @param vizSubType - bullet | bar | donut
         * @param vizSubSubType
         * @return {string} of HTML
         */
        function buildHtml(type, wrapperType, vizType, vizSubType, template) {
            // Set Defaults (f*ck you javascript)
            vizType = vizType || '';
            vizSubType = vizSubType || '';
            template = template || '';

            // Init return variable
            var html = '';

            // Set Controller Name
            var typeName = toSentenceCase(vizType);
            var vizControllerName = 'nimViz' + typeName + 'Ctrl';
            if (vizSubType && vizSubType !== '') {
                var subTypeName = toSentenceCase(vizSubType);
                vizControllerName = 'nimViz' + typeName + subTypeName + 'Ctrl';
            }

            // Build Viz HTML
            if (type === 'viz') {
                html = '<div class="nim-wrapper" nim-wrapper="' + wrapperType + '">' +
                '    <div nim-viz-' + vizType + ' ' +
                '         sub-type="' + vizSubType + '" ' +
                '         template="' + template + '"' +
                '         controller-name="' + vizControllerName + '">' +
                '    </div>' +
                '</div>';
            }

            // Build Tabs HTML
            else if (type === 'tabset') {
                html = '<div class="nim-wrapper" nim-wrapper="' + wrapperType + '">' +
                '   <div uib-tabset type="{{::pageObject.params.type}}" justified="pageObject.params.justified" vertical="pageObject.params.vertical">' +
                '       <div uib-tab ng-repeat="tab in ::pageObject.params.tabs" ng-init="$index === 0 ? tab.active = true : tab.active = false" active="tab.active" deselect="$broadcast(\'nim-remove-page-objects\')">' +
                '           <div uib-tab-heading>' +
                '               <i class="fa fa-{{::tab.icon}}"></i><span ng-bind="::tab.text"></span>' +
                '           </div>' +
                '           <div ng-include="tab.active ? \'core/pages/pages-nested.tpl.html\' : null" ng-controller="PagesNestedCtrl" onload="getPage(tab.link)"></div>' +
                '       </div>' +
                '   </div>' +
                '</div>';
            }

            // Build Buttons HTML
            else if (type === 'button') {
                html =
                    //'<div nim-wrapper="' + wrapperType + '">' +
                    '<div ng-style="::{\'margin\': pageObject.wrapper.style.margin}" ng-class="::{\'pull-right\': pageObject.params.right}">' +
                    '   <div class="btn-toolbar">' +
                    '       <div class="btn-group" ng-repeat="button in ::pageObject.params.buttons | filter:{type:\'!filter\'}" uib-dropdown>' +
                    '           <button ng-if="::button.type===\'single\' || button.type===\'split\'" type="button" class="btn btn-{{::button.style}}" ng-click="buttonClick(button, filters)">' +
                    '               <i class="fa fa-{{::button.icon}}"></i>' +
                    '               <span ng-if="::button.icon !== \'\' && button.label !== \'\'">&nbsp;</span>' +
                    '               {{::button.label}}' +
                    '           </button>' +
                    '           <button ng-if="::button.type===\'dropdown\' || button.type===\'split\'" type="button" class="btn btn-{{::button.style}} dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle aria-expanded="false">' +
                    '               <span ng-if="::button.type===\'dropdown\'">' +
                    '                   <i class="fa fa-{{::button.icon}}"></i>' +
                    '                   <span ng-if="::button.icon !== \'\' && button.label !== \'\'">&nbsp;</span>' +
                    '                   {{::button.label}}' +
                    '                   <span ng-if="::button.icon !== \'\' || button.label !== \'\'">&nbsp;</span>' +
                    '               </span>' +
                    '               <span class="caret"></span>' +
                    '           </button>' +
                    '           <ul ng-if="::button.type===\'dropdown\' || button.type===\'split\'" uib-dropdown-menu role="menu">' +
                    '               <li ng-repeat="item in ::button.items">' +
                    '                   <a href ng-click="buttonClick(item, filters)">' +
                    '                       <i class="fa fa-{{::item.icon}}"></i>' +
                    '                       <span ng-show="::item.icon !== \'\'">&nbsp;</span>' +
                    '                       {{::item.label}}' +
                    '                   </a>' +
                    '               </li>' +
                    '           </ul>' +
                    '       </div>' +
                    '   </div>' +
                    '   <div ng-repeat="button in ::pageObject.params.buttons | filter:{type:\'filter\'}" ' +
                    '        nim-filter-form="filters" ' +
                    '        nim-default-filters="defaultFilter" ' +
                    '        id="{{::button.id}}" ' +
                    '        btn-class="::button.style" ' +
                    '        type="::button.action" ' +
                    '        label="::button.label" ' +
                    '        icon="::button.icon" ' +
                    '        params="::button.filterParams"></div>' +
                    '</div>';
            }
/*            else if (type === 'filter') {
                '<div ng-style="{\'margin\': pageObject.wrapper.style.margin}" ng-class="{\'pull-right\': pageObject.params.right}">' +
                '   <div class="form-group">' +
                '       <label>' +
                '           <i class="fa fa-{{pageObject.params.icon}}"></i>' +
                '           <span ng-if="pageObject.params.icon !== \'\' && pageObject.params.label !== \'\'">&nbsp;</span>' +
                '           {{pageObject.params.label}}' +
                '       </label>' +
                '       <div nim-filter="filters" params="{{pageObject.params.filterParams}}"></div>' +
                '   </div>' +
                '</div>';
            }*/

            return html;
        }

        /**
         * @param text
         * @returns {string}
         */
        function toSentenceCase(text){
            var sentence = '';
            if(text && text.length > 0){
                sentence += text.charAt(0).toUpperCase();
                if(text.length > 1){
                    sentence += text.substr(1, text.length - 1).toLowerCase();
                }
            }
            return sentence;
        }

        /**
         * Given a PageObject this function will build the appropriate
         * Kendo UI Toolbar options object
         * @param {object} tools - PageObject.tools property
         * @param {object} callbacks - functions definitions for various actions
         * @return {object}
         */
        function buildToolbar(tools, callbacks) {
            var options = {
                items: []
            };
            if (tools.showTemplate && tools.template && angular.isFunction(callbacks.templateFunc)) {
                options.items.push({
                    id: 'toolbarTemplate',
                    template: callbacks.templateFunc
                });
            }
            if (tools.create && angular.isFunction(callbacks.createCb)) {
                options.items.push({
                    type: 'button',
                    text: 'New',
                    click: callbacks.createCb
                });
            }
            if (tools.exportXLS && angular.isFunction(callbacks.exportXLSCb)) {
                options.items.push({
                    type: 'splitButton',
                    text: '<i class="fa fa-file-excel-o"></i>&nbsp;Export Current Page',
                    click: callbacks.exportXLSCb,
                    menuButtons: [
                        {
                            type: 'button',
                            text: 'ALL (CSV)',
                            click: callbacks.exportAllXLSCb
                        }
                    ]
                });
            }
            if(tools.exportICS && angular.isFunction(callbacks.exportICSCb)){
                options.items.push({
                    type: 'button',
                    text: '<i class="fa fa-calendar"></i>&nbsp;Export Schedule',
                    click: callbacks.exportICSCb
                });
            }
            if (tools.delete && angular.isFunction(callbacks.deleteCb)) {
                options.items.push({
                    type: 'button',
                    text: 'Delete',
                    click: callbacks.deleteCb
                });
            }
            if (tools.exportPDF && angular.isFunction(callbacks.exportPDFCb)) {
                options.items.push({
                    type: 'button',
                    text: '<i class="fa fa-file-pdf-o"></i>&nbsp;Export Selected to PDF',
                    click: callbacks.exportPDFCb
                });
            }
            if (tools.print && angular.isFunction(callbacks.printCb)) {
                options.items.push({
                    type: 'button',
                    text: '<i class="fa fa-print"></i>&nbsp;Print',
                    attributes: {
                        "ng-disabled": "pageObject.viz.type==='table' && !mainPageObject.vizCtrl.selectedIds.length"
                    },
                    click: callbacks.printCb
                });
            }
            if (tools.printLabels && angular.isFunction(callbacks.printLabelsCb)) {
                options.items.push({
                    type: 'button',
                    text: '<i class="fa fa-print"></i>&nbsp;Print Labels',
                    attributes: {
                        "ng-disabled": "pageObject.viz.type==='table' && !mainPageObject.vizCtrl.selectedIds.length"
                    },
                    click: callbacks.printLabelsCb
                });
            }
            if (tools.printChecks && angular.isFunction(callbacks.printChecksCb)) {
                options.items.push({
                    type: 'button',
                    text: '<i class="fa fa-print"></i>&nbsp;Print Checks',
                    attributes: {
                        "ng-disabled": "pageObject.viz.type==='table' && !mainPageObject.vizCtrl.selectedIds.length"
                    },
                    click: callbacks.printChecksCb
                });
            }
            if (tools.upload && angular.isFunction(callbacks.uploadFilesCb)) {
                options.items.push({
                    type: 'button',
                    text: '<i class="fa fa-upload"></i>&nbsp;Upload',
                    attributes: {},
                    click: callbacks.uploadFilesCb
                });
            }
            if (tools.refresh && angular.isFunction(callbacks.refreshCb)) {
                options.items.push({
                    type: 'button',
                    text: '<i class="fa fa-refresh"></i>&nbsp;Refresh',
                    overflow: 'always',
                    click: callbacks.refreshCb
                });
            }
            if (tools.massimport && angular.isFunction(callbacks.massImportCb)) {
                options.items.push({
                    type: 'button',
                    text: '<i class="fa fa-random"></i>&nbsp;Mass Import',
                    overflow: 'always',
                    click: callbacks.massImportCb
                });
            }
            /* return */
            return options;
        }

        ///**
        // * Pushes a separator item into a Kendo Toolbar
        // * @param arr - Kendo toolbar options.items array
        // */
        //function addToolbarSeperator(arr) {
        //    if (arr.length && arr[arr.length - 1].type !== 'separator') {
        //        arr.push({type: 'separator'});
        //    }
        //}

        /**
         * Facade method to delete one more more instances
         * @param selectedRows
         * @param confirmCb
         */
        function deleteInstance(selectedRows, confirmCb) {
            InstancesWindowService.deleteInstanceModal(selectedRows, confirmCb);
        }

        /**
         * Convenience function to broadcast a Viz reload event
         * @param scope
         */
        function reloadViz(scope) {
            scope.$broadcast('nim-viz-reload');
        }

        function printPageObject(html){
            var $printSection = angular.element("print-section");
            $printSection.empty().append(html);
            $window.print();
        }

        /**
         * Click handler for button page object
         * @param button - configuration for the button
         * @param button.action - route/link/create
         * @param button.targetId - id of target page/widget or URL
         * @param filters - page filters
         */
        function buttonClickHandler(button, filters){
            switch(button.action){
                case 'route': // Routes to target page in current tab
                    $location.url(button.targetId);
                    break;
                case 'link': // Opens target URL in new tab
                    $window.open(button.targetId, '_blank');
                    break;
                case 'create': // Creates new instance for target widget
                    buttonCreateHandler(button, filters);
                    break;
                default:
                    break;
            }
        }

        function buttonCreateHandler(button, filters) {
            var defaultDataArray = [];

            //Default Data Check for filters
            if (button.defaultData) {
                _.forEach(button.defaultData, function (defaultItem) {
                    if (filters[defaultItem.value]) {
                        defaultDataArray.push({
                            data: filters[defaultItem.value].filters[0],
                            field: defaultItem.formField
                        });
                    }
                });
            }

            InstancesWindowService.openWindow({ action: button.action, widgetId: button.targetId, defaultData: defaultDataArray });
        }

        function setHtml(template, compileData){
            try{
                var html = '';
                var escapedTemplate = escapePoundSign(template);

                html = kendo.template(escapedTemplate)(compileData);
                html = html.replace(/\\#/g, '#');

                return $sce.trustAsHtml(html);
            }
            catch(e){
                $log.error(e, compileData);
                return '';
            }
        }

        /**
         * Escapes pound signs so they don't cause an error when the template string is compiled by kendo
         * @param templateString
         * @returns {string}
         */
        function escapePoundSign(templateString){
            var htmlAttributes = templateString.match(/="(?!#:|#=)[^"]+"/gm),
                escapedString = templateString;

            _.forEach(htmlAttributes, function(subString){
                escapedString = escapedString.replace(subString, subString.replace(/#/g, '\\#'));
            });

            return escapedString;
        }

        function getPageObject(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'page/objects/' + id)
                .success(function(value){
                    deferred.resolve(parsePageObject(value.DATA));
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getPageObjects() {
            var deferred = $q.defer();
            $http.get(apiPath + 'page/objects')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getUnusedPageObjects() {
            var deferred = $q.defer();
            $http.get(apiPath + 'page/objects/unused')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function parsePageObject(data){
            var pageObject = angular.copy(data);

            var json = angular.copy(pageObject.json_config);
            delete pageObject.json_config;
            pageObject = angular.extend(pageObject, json);

            return pageObject;
        }
        /**
         *
         * @param defaultDataArray
         * @param customValueMap
         */
        function addCustomValuesToDefaultData(defaultDataArray, customValueMap){
            if(defaultDataArray && customValueMap){
                _.forEach(customValueMap, function(jsonValue, modelId){
                    if(!_.find(defaultDataArray, 'field.modelId', modelId)){
                        if(jsonValue) {
                            defaultDataArray.push({
                                data: {
                                    value: angular.fromJson(jsonValue)
                                },
                                field: {
                                    modelId: modelId
                                }
                            });
                        }
                    }
                });
            }
        }

        function openUploadModal(pageObject, defaultData) {
            var modal = $uibModal.open({
                templateUrl: 'core/pages/viz/list/list-upload-modal.tpl.html',
                controller: 'ListUploadModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    defaultData: _.constant(defaultData),
                    listPageObject: _.constant(pageObject)
                }
            });

            return modal.result;
        }

        function openMassImportModal(pageObject){
            var modal = $uibModal.open({
                templateUrl: 'core/pages/viz/table/massimport-upload-modal.tpl.html',
                controller: 'MassimportUploadModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    listPageObject: _.constant(pageObject),

                    _wait: 'WaitForUserData',
                    authToken: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                        return WaitForUserData.then(function(){
                            return $rootScope.authToken;
                        });
                    }],
                    workspaceId: ["WaitForUserData", "$rootScope", function(WaitForUserData, $rootScope){
                        return WaitForUserData.then(function(){
                            return $rootScope.userData.currentWorkspace.id;
                        });
                    }]
                }
            });

            return modal.result;
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name PagesService
     * @alias cerberus/core:PagesService
     * @description REST service for "pages" resource
     */
    .factory('PagesService', ["_", "$http", "$q", "$rootScope", "apiPath", "toaster", "DesignerUtilityService", "PagesClassService", function PagesService(_, $http, $q, $rootScope, apiPath, toaster, DesignerUtilityService, PagesClassService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            getPage: getPage,
            getPages: getPages,
            getPagePermissions: getPagePermissions,
            getDefault: getDefault,
            getUserInfo: getUserInfo,
            buildUrlParams: buildUrlParams,
            readUrlParams: readUrlParams,
            filterObjectToString: filterObjectToString,
            filterStringToObject: filterStringToObject
        };
        ////////////////////////
        /**
         * Given a valid response for the REST api this function
         * constructs classes for the page objects and sort them for display
         * @function processPageData
         * @param {object} data - this is the return from the HTTP call
         * @return {object} pageModel
         */
        function processPageData(data) {
            var pageModel = data;
            if(pageModel.items && pageModel.items.length > 0){
                for(var i = 0; i < pageModel.items.length; i++){
                    if(pageModel.items[i].pageObject){
                        var pageObj = PagesClassService.newPageObject();
                        pageObj.setData(angular.fromJson(pageModel.items[i].pageObject));
                        pageModel.items[i].pageObject = pageObj;
                    }

                    delete pageModel.items[i].imported;
                }

                pageModel.items.sort(
                    DesignerUtilityService.firstBy(function(v1,v2){return v1.row - v2.row;})
                        .thenBy(function(v1,v2){return v1.col - v2.col;})
                );
            }
            if(pageModel.options){
                pageModel.options.filters = pageModel.options.filters || [];
            }
            return pageModel;
        }

        /**
         * Makes a get call REST api "pages" resource by id
         * @function getPage
         * @param {string} id
         * @return {promise}
         */
        function getPage(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'pages/'+ id)
                .success(function(value){
                    deferred.resolve(processPageData(value.DATA));
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * Makes a get call REST api "pages" resource
         * @function getDefault
         * @return {promise}
         */
        function getDefault() {
            var deferred = $q.defer();
            $http.get(apiPath + 'pages/default')
                .success(function(value){
                    deferred.resolve(processPageData(value.DATA));
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getPages(){
            var deferred = $q.defer();
            $http.get(apiPath + 'pages')
                .success(function(value){
                    deferred.resolve(processPageData(value.DATA));
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getPagePermissions(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'pages/' + id + '/permissions')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getUserInfo(){
            return {
                firstName: $rootScope.userData.firstName,
                lastName: $rootScope.userData.lastName,
                fullName: $rootScope.userData.firstName + ' ' + $rootScope.userData.lastName
            };
        }

        function buildUrlParams(filters) {
            var params = {},
                filterDisplays = {};
            
            _.forEach(filters, function (filterObj, filter) {
                var filterString = filterObjectToString(filterObj, filterDisplays);
                if (filterString) {
                    params[filter] = filterString;

                    if (!_.isEmpty(filterObj.filters)) {
                        _.forEach(filterObj.filters, function (f) {
                            if (f.lookupDisplay) {
                                filterDisplays[filter] = f.lookupDisplay;
                            }
                        });
                    }
                }
            });

            if (!_.isEmpty(filterDisplays)) {
                var displayPairs = [];
                _.forEach(filterDisplays, function (displayValue, filter) {
                    displayPairs.push(filter + ',' + displayValue);
                });
                params.__nimFilterDisplay = displayPairs.join('|');
            }    
            
            return params;
        }

        function readUrlParams(params) {
            var filters = {},
                filterDisplays = {};

            if (params.__nimFilterDisplay) {
                var displayPairs = params.__nimFilterDisplay.split('|');
                _.forEach(displayPairs, function (pairString) {
                    var pair = pairString.split(','),
                        filter = _.head(pair),
                        displayValue = _.tail(pair).join(',');
                    
                    filterDisplays[filter] = displayValue;
                });
            }

            _.forEach(params, function (filterString, filter) {
                if (filter == '__nimFilterDisplay') {
                    return false;
                }

                var filterObj = filterStringToObject(filterString, filterDisplays);
                if (filterDisplays[filter] && !_.isEmpty(filterObj.filters)) {
                    filterObj.filters[0].lookupDisplay = filterDisplays[filter];
                }
                filters[filter] = filterObj;
            });

            return filters;
        }

        function filterObjectToString(filterObj){
            if(!filterObj){
                return;
            }

            if(!_.isEmpty(filterObj.filters)){
                var logic = filterObj.logic || 'and';
                var filters = _.map(filterObj.filters, function(f){
                    return filterObjectToString(f);
                });

                filters = _.compact(filters);

                return '(' + _.compact(filters).join(' ' + logic + ' ') + ')';
            }
            else {
                var field = filterObj.field;
                var value = filterObj.value;
                if(_.isNull(value) || _.isUndefined(value)){
                    return;
                }
                else if(value instanceof Date){
                    var dateValue = new Date(value);
                    value = dateValue.toISOString();
                }
                else if(typeof value === 'string'){
                    value = "'" + escapeOperators(value) + "'";
                }

                switch(filterObj.operator){
                    case 'contains':
                        return 'substringof(' + value + ',' + field + ')';
                    case 'doesnotcontain':
                        return 'substringof(' + value + ',' + field + ') eq false';
                    case 'startswith':
                        return 'startswith(' + field + ',' + value + ')';
                    case 'endswith':
                        return 'endswith(' + field + ',' + value + ')';
                    case 'eq':
                        return field + ' eq ' + value;
                    case 'neq':
                        return field + ' ne ' + value;
                    case 'gt':
                        return field + ' gt ' + value;
                    case 'gte':
                        return field + ' ge ' + value;
                    case 'lt':
                        return field + ' lt ' + value;
                    case 'lte':
                        return field + ' le ' + value;
                    default:
                        return '';
                }
            }
        }

        function filterStringToObject(filterStr){
            if(!filterStr){
                return;
            }

            var filter = {};
            if(_.startsWith(filterStr, '(') && _.endsWith(filterStr, ')')){
                var innerStr = filterStr.substr(1, filterStr.length - 2);
                var logic = 'and';

                if(innerStr.search(' or ') >= 0){
                    logic = 'or';
                }

                var filters = innerStr.split(' ' + logic + ' ');

                filter.logic = logic;
                filter.filters = _.compact(_.map(filters, filterStringToObject));
            }
            else {
                var field = null;
                var value = null;
                if(filterStr.search(/^substringof\(.*\)$/) >= 0){
                    filter.operator = 'contains';
                    filterStr = filterStr.replace(/^substringof\(/, '').replace(/\)$/, '');
                    var containsSubStr = filterStr.split(',');
                    field = containsSubStr.pop();
                    value = containsSubStr.join(',');
                }
                else if(filterStr.search(/^substringof\(.*\) eq false$/) >= 0){
                    filter.operator = 'doesnotcontain';
                    filterStr = filterStr.replace(/^substringof\(/, '').replace(/\) eq false$/, '');
                    var doesNotContainSubStr = filterStr.split(',');
                    field = doesNotContainSubStr.pop();
                    value = doesNotContainSubStr.join(',');
                }
                else if(filterStr.search(/^startswith\(.*\)$/) >= 0){
                    filter.operator = 'startswith';
                    filterStr = filterStr.replace(/^startswith\(/, '').replace(/\)$/, '');
                    var startsWithSubStr = filterStr.split(',');
                    field = startsWithSubStr.pop();
                    value = startsWithSubStr.join(',');
                }
                else if(filterStr.search(/^endswith\(.*\)$/) >= 0){
                    filter.operator = 'endswith';
                    filterStr = filterStr.replace(/^endswith\(/, '').replace(/\)$/, '');
                    var endsWithSubStr = filterStr.split(',');
                    field = endsWithSubStr.pop();
                    value = endsWithSubStr.join(',');
                }
                else if(filterStr.search(/ eq /) >= 0){
                    filter.operator = 'eq';
                    var eqSubStr = filterStr.split(' eq ');
                    field = eqSubStr[0];
                    value = eqSubStr[1];
                }
                else if(filterStr.search(/ ne /) >= 0){
                    filter.operator = 'neq';
                    var neSubStr = filterStr.split(' ne ');
                    field = neSubStr[0];
                    value = neSubStr[1];
                }
                else if(filterStr.search(/ gt /) >= 0){
                    filter.operator = 'gt';
                    var gtSubStr = filterStr.split(' gt ');
                    field = gtSubStr[0];
                    value = gtSubStr[1];
                }
                else if(filterStr.search(/ ge /) >= 0){
                    filter.operator = 'gte';
                    var geSubStr = filterStr.split(' ge ');
                    field = geSubStr[0];
                    value = geSubStr[1];
                }
                else if(filterStr.search(/ lt /) >= 0){
                    filter.operator = 'lt';
                    var ltSubStr = filterStr.split(' lt ');
                    field = ltSubStr[0];
                    value = ltSubStr[1];
                }
                else if(filterStr.search(/ le /) >= 0){
                    filter.operator = 'lte';
                    var leSubStr = filterStr.split(' le ');
                    field = leSubStr[0];
                    value = leSubStr[1];
                }

                filter.field = field;
                filter.value = parseFilterValue(value);
            }

            return filter;
        }

        function parseFilterValue(rawString){
            if(_.isNull(rawString)){
                return;
            }
            if(_.startsWith(rawString, '\'') && _.endsWith(rawString, '\'')){
                return removeEscaping(rawString).replace(/^'/, '').replace(/'$/, '');
            }
            else if(rawString.search(/^[0-9]{4}-[0-9]{2}-[0-9]{2}[Tt][0-9]{2}:[0-9]{2}:[0-9]{2}(.[0-9]{1,4})?[Zz]?$/) >= 0){
                return new Date(rawString);
            }
            else {
                var numberValue = parseFloat(rawString);
                if(!isNaN(numberValue)){
                    return numberValue;
                }
            }
        }

        function escapeOperators(value){
            return value
                .replace(/ and /g, ' \\and ')
                .replace(/ or /g, ' \\or ')
                .replace(/ eq /g, ' \\eq ')
                .replace(/ ne /g, ' \\ne ')
                .replace(/ gt /g, ' \\gt ')
                .replace(/ ge /g, ' \\ge ')
                .replace(/ lt /g, ' \\lt ')
                .replace(/ le /g, ' \\le ');
        }

        function removeEscaping(value){
            return value
                .replace(/ \\and /g, ' and ')
                .replace(/ \\or /g, ' or ')
                .replace(/ \\eq /g, ' eq ')
                .replace(/ \\ne /g, ' ne ')
                .replace(/ \\gt /g, ' gt ')
                .replace(/ \\ge /g, ' ge ')
                .replace(/ \\lt /g, ' lt ')
                .replace(/ \\le /g, ' le ');
        }
    }])
;
angular.module('cerberus.core')
    .config(['$routeProvider',
        function ($routeProvider) {
            $routeProvider.when('/search', {
                templateUrl: 'core/search/search.tpl.html',
                controller: 'SearchCtrl',
                controllerAs: 'vm',
                title: 'Search',
                reloadOnSearch: false,
                resolve: {
                    _wait: 'WaitForUserData'
                }
            });
        }
    ])
;
angular.module('cerberus.core')
    .controller('SearchCtrl',
    ["$scope", "SearchService", "InstancesWindowService", "$window", "$location", "$sce", "$routeParams", function($scope, SearchService, InstancesWindowService, $window, $location, $sce, $routeParams){
        var vm = this;
        vm.q = angular.copy($routeParams.q);
        vm.currentPage = 1;
        vm.pageSize = 20;
        vm.searchPageArray = [];
        vm.searchedText = null;
        vm.searchText = $location.search().q || null;
        vm.searchResults = null;

        vm.executeSearch = function(txt,size,current){
            $location.search('q',txt);
            SearchService.search(txt,size,current).then(function(d){
                vm.searchedText = angular.copy(vm.searchText);
                var tmpArr = SearchService.formatPagination(d.found,size,current);
                if(tmpArr.length > 0 && d.results.length > 0){
                    vm.searchResults = d;
                    vm.searchPageArray = tmpArr;
                    vm.currentPage = current;
                }
                else{
                    vm.searchResults = {results:[],found:0};
                }
            });
        };

        vm.cleanHtml = function(html){
            return $sce.trustAsHtml(html);
        };

        vm.getInstanceViaAttachmentId = function(searchItem){
            var tmp = searchItem.id.split('/');
            var fileName = tmp[tmp.length - 1];
            var tmp2 = fileName.split('.');
            var id = tmp2[0];
            SearchService.getInstanceIdViaAttachmentId(id).then(function(d){
                var itm = {
                    id:d,
                    type: 'record'
                };
                vm.openRecord(itm);
            });
        };

        vm.openRecord = function(searchItem){
            if(searchItem.type === 'file'){
                $window.open(searchItem.urlPath);
            }
            else{
                InstancesWindowService.openWindow({
                    action: 'read',
                    instanceId: searchItem.id,
                    title: searchItem.title
                });
            }
        };

        init();

        function init(){
            if(vm.q){
                vm.executeSearch(vm.q,vm.pageSize,1);
            }
        }
    }]
)
;
angular.module('cerberus.core')
    .factory('SearchService',
        ["$http", "$q", "apiPath", function ($http, $q, apiPath) {
            var service = {
                search: search,
                getInstanceIdViaAttachmentId: getInstanceIdViaAttachmentId,
                formatPagination: formatPagination
            };
            return service;
            ////////////////////
            function search(searchTxt,size, current){
                var start = (current - 1) * size;
                if(start < 1){
                    start = 1;
                }
                var top = size;
                var deferred = $q.defer();
                $http.get(apiPath + 'search?q=' + searchTxt + '&$top=' + top + '&$start=' + start)
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }
            function getInstanceIdViaAttachmentId(id){
                var deferred = $q.defer();
                $http.get(apiPath + 'attachments/' + id + '/get/instance')
                    .success(function (value) {
                        deferred.resolve(value.DATA);
                    })
                    .error(function (reason) {
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             *
             * @param total
             * @param size
             * @param current
             * @param paginationSize
             * @returns {Array}
             */
            function formatPagination(total,size,current,paginationSize){
                var rSize = size || 10;
                var pSize = paginationSize || 10;
                var pageArray = [];
                var pages = Math.ceil(total / rSize);
                if(current <= pages) {
                    var startingPage = 0;
                    if(current > pSize/2 && pages - pSize > -1){
                        startingPage = current - (pSize/2);
                    }
                    var pagesToShow = Math.min(pages,pSize);
                    if(startingPage > pages - pSize && startingPage > 0){
                        startingPage = pages - pSize;
                    }
                    for (var i = 0; i < pagesToShow; i++) {
                        pageArray.push({
                            num: startingPage + i + 1
                        });
                    }
                }
                return pageArray;
            }
        }]
    )
;
angular.module('cerberus.core')
    .factory('WidgetsService', ["_", "$http", "$q", "$window", "apiPath", "toaster", "FormsService", function WidgetsService(_, $http, $q, $window, apiPath, toaster, FormsService) {
        var widgetComponents;
        var widgets = [];
        return {
            widgets: function () {
                return widgets;
            },
            widgetComponents: function () {
                return widgetComponents;
            },
            getWidgets: getWidgets,
            getWidget: getWidget,
            getFirstState: getFirstState,
            getAllForms: getAllForms,
            getMax: getMax
        };

        function getWidgets() {
            var deferred = $q.defer();
            $http.get(apiPath + 'widgets')
                .success(function (value) {
                    widgets = value.DATA;
                    deferred.resolve(widgets);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getWidget(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'widgets/' + id)
                .success(function (value) {
                    widgetComponents = value.DATA;
                    deferred.resolve(widgetComponents);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getFirstState(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'widgets/' + id + '/workflows/start/forms')
                .success(function (value) {
                    var newData = value.DATA;
                    _.forEach(newData.workflowObjects, function (wfObj) {
                        wfObj.model.forms = _.map(wfObj.model.forms, function (formModel) {
                            if (formModel.form) {
                                formModel = FormsService.processFormData(formModel, formModel.defaultDataSet);
                            }
                            else {
                                formModel.form = { objects: [] };
                            }

                            return formModel;
                        });
                    });
                    
                    deferred.resolve(newData);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getAllForms(id, printType) {
            var deferred = $q.defer(),
                params = {};

            if (printType) {
                params.printType = printType;
            }
            $http.get(apiPath + 'widgets/' + id + '/forms', { params: params })
                .success(function (value) {
                    deferred.resolve(value.DATA.forms);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            
            return deferred.promise;
        }

        function getMax(widgetId, modelId) {
            var deferred = $q.defer();

            $http.get(apiPath + 'widgets/' + widgetId + '/modelId/' + modelId + '/max')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });

            return deferred.promise;
        }
    }])
;
angular.module('cerberus.cpc')
    .controller('updateInventoryLocationOpenModalCtrl', ["_", "$scope", "$uibModalInstance", "inventoryService", function(_, $scope, $uibModalInstance, inventoryService){
        var vm = this;
        
        
        // Never finished... In development mode...
        
        
        vm.emptyValue = '';
        vm.rollpositions_textarea = '';
        vm.rowPositionSelected = '';
        vm.rowPositionList = [
            {value: '1', display: 'Row position 1'},
            {value: '2', display: 'Row position 2'},
            {value: '3', display: 'Row position 3'}
        ];

        vm.importingDataInProgress = false;
        vm.importingDataShowError = false;
        vm.isUnchanged = isUnchanged;
        vm.submit = submit;
        vm.cancel = cancel;

        // -- add here necessary fuctions needed to be processed within controller, when done, remove this... //

        // Check if text is empty
        function isUnchanged() {
            return angular.equals(vm.rollpositions_textarea, vm.emptyValue);
        }

        // Submit button execution
        function submit() {
            //DEVELOPMENT MODE
            //BLOCK SUBMIT BUTTON
            if (vm.rollpositions_textarea != 'continue') {
                return;
            }

            // Basic validation test, nothing special
            if (vm.rollpositions_textarea == 'test') {
                return;
            }
            // Manage progress monitoring
            vm.importingDataInProgress = true;
            vm.importingDataShowError = false;
            // Initiate function here
            var action = 'update_roll_positions'; // specify here exact action to be executed
            var data = {'values': vm.rollpositions_textarea, 'rowposition': vm.rowPositionSelected};
            inventoryService.updateRollPositions(action, data).then(function (result) {
                vm.importingDataInProgress = false;
                //console.log(result);
                if (result.errMsg) {
                    vm.importingDataShowError = true;
                 //   vm.importError = result.errMsg;
                 //console.log('aaaaaaaaaaabbbbbb');
                }
                //else if (result.instanceId) {
                //    $uibModalInstance.close(result.instanceId);
                //}
                else {
                    $uibModalInstance.close(result.instanceId);
                }
            }, function () {
                vm.importingDataInProgress = false;
                vm.importingDataShowError = false;
            });
        }

        // Cancel button execution
        function cancel() {
            $uibModalInstance.dismiss();
        }

        // Removes Kendo widgets
        //$scope.$on('$destroy', function() {
        //    _.result(vm, 'updateInventoryUpload.destroy');
        //});

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    }])
;
angular.module('cerberus.cpc')
/**
 * @ngdoc config
 * @description router config
 */
    .config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/cpc/inventory', {
            templateUrl: 'cpc/inventory/templates/inventory.tpl.html',
            controller: 'InventoryCtrl',
            controllerAs: 'vm',
            title: 'Inventory',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });
    }])
;
angular.module('cerberus.cpc')
    .controller('InventoryCtrl', ["_", "$scope", "inventoryService", function InventoryCtrl(_, $scope, inventoryService) {
        var vm = this;

        vm.updateInventoryRowPositionsOpenModal = inventoryService.updateInventoryRowPositionsOpenModal;
        vm.updateInventoryLocationOpenModal = inventoryService.updateInventoryLocationOpenModal;
        vm.updateFinishedProductLocationOpenModal = inventoryService.updateFinishedProductLocationOpenModal;
        vm.initiateWarehouseAuditOpenModal = inventoryService.initiateWarehouseAuditOpenModal;
        vm.initiateEDI_RollInputOpenModal = inventoryService.initiateEDI_RollInputOpenModal;
        vm.updateRollPositions = inventoryService.updateRollPositions;
        vm.init = _init;

        $scope.$on('$destroy', function(){
            delete vm.navFunctions.callback;
        });

        _init();

        function _init() {
        // if needed to load something on page init, add it here...
        //    vm.selectedIds = [];
        //    vm.isAllSelected = false;
        //    inventoryService.getSomeData().then(function(drafts){
        //       vm.drafts = drafts;
        //    });
        }
    }])
;
angular.module('cerberus.cpc')
    .controller('initiateEDI_RollInputOpenModalCtrl', ["_", "$scope", "$uibModalInstance", function(_, $scope, $uibModalInstance){
        var vm = this;

        vm.submit = submit;
        vm.cancel = cancel;

        // Submit button execution
        function submit() {
            $uibModalInstance.close();
        }

        // Cancel button execution
        function cancel() {
            $uibModalInstance.dismiss();
        }
    }])
;
angular.module('cerberus.cpc')
    .controller('updateFinishedProductLocationOpenModalCtrl', ["_", "$scope", "$uibModalInstance", "inventoryService", function(_, $scope, $uibModalInstance, inventoryService){
        var vm = this;
        
        
        // Never finished... In development mode...
        
        
        vm.emptyValue = '';
        vm.rollpositions_textarea = '';
        vm.rowPositionSelected = '';
        vm.rowPositionList = [
            {value: '1', display: 'Row position 1'},
            {value: '2', display: 'Row position 2'},
            {value: '3', display: 'Row position 3'}
        ];

        vm.importingDataInProgress = false;
        vm.importingDataShowError = false;
        vm.isUnchanged = isUnchanged;
        vm.submit = submit;
        vm.cancel = cancel;

        // -- add here necessary fuctions needed to be processed within controller, when done, remove this... //

        // Check if text is empty
        function isUnchanged() {
            return angular.equals(vm.rollpositions_textarea, vm.emptyValue);
        }

        // Submit button execution
        function submit() {
            //DEVELOPMENT MODE
            //BLOCK SUBMIT BUTTON
            if (vm.rollpositions_textarea != 'continue') {
                return;
            }

            // Basic validation test, nothing special
            if (vm.rollpositions_textarea == 'test') {
                return;
            }
            // Manage progress monitoring
            vm.importingDataInProgress = true;
            vm.importingDataShowError = false;
            // Initiate function here
            var action = 'update_roll_positions'; // specify here exact action to be executed
            var data = {'values': vm.rollpositions_textarea, 'rowposition': vm.rowPositionSelected};
            inventoryService.updateRollPositions(action, data).then(function (result) {
                vm.importingDataInProgress = false;
                //console.log(result);
                if (result.errMsg) {
                    vm.importingDataShowError = true;
                 //   vm.importError = result.errMsg;
                 //console.log('aaaaaaaaaaabbbbbb');
                }
                //else if (result.instanceId) {
                //    $uibModalInstance.close(result.instanceId);
                //}
                else {
                    $uibModalInstance.close(result.instanceId);
                }
            }, function () {
                vm.importingDataInProgress = false;
                vm.importingDataShowError = false;
            });
        }

        // Cancel button execution
        function cancel() {
            $uibModalInstance.dismiss();
        }

        // Removes Kendo widgets
        //$scope.$on('$destroy', function() {
        //    _.result(vm, 'updateInventoryUpload.destroy');
        //});

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    }])
;
angular.module('cerberus.cpc')
    .controller('updateInventoryRowPositionsOpenModalCtrl', ["_", "$scope", "$uibModalInstance", "inventoryService", function(_, $scope, $uibModalInstance, inventoryService){
        var vm = this;
        vm.emptyValue = '';
        vm.rollpositions_textarea = '';
        vm.rowPositionSelected = '';
        vm.rowPositionList = [
            {value: '1', display: 'Row position 1'},
            {value: '2', display: 'Row position 2'},
            {value: '3', display: 'Row position 3'}
        ];

        vm.importingDataInProgress = false;
        vm.importingDataShowError = false;
        vm.isUnchanged = isUnchanged;
        vm.submit = submit;
        vm.cancel = cancel;

        // -- add here necessary fuctions needed to be processed within controller, when done, remove this... //

        // Check if text is empty
        function isUnchanged() {
            return angular.equals(vm.rollpositions_textarea, vm.emptyValue);
        }

        // Submit button execution
        function submit() {
            // Basic validation test, nothing special
            if (vm.rollpositions_textarea == 'test') {
                return;
            }
            // Manage progress monitoring
            vm.importingDataInProgress = true;
            vm.importingDataShowError = false;
            // Initiate function here
            var action = 'update_roll_positions'; // specify here exact action to be executed
            var data = {'values': vm.rollpositions_textarea, 'rowposition': vm.rowPositionSelected};
            inventoryService.updateRollPositions(action, data).then(function (result) {
                vm.importingDataInProgress = false;
                //console.log(result);
                if (result.errMsg) {
                    vm.importingDataShowError = true;
                 //   vm.importError = result.errMsg;
                 //console.log('aaaaaaaaaaabbbbbb');
                }
                //else if (result.instanceId) {
                //    $uibModalInstance.close(result.instanceId);
                //}
                else {
                    $uibModalInstance.close(result.instanceId);
                }
            }, function () {
                vm.importingDataInProgress = false;
                vm.importingDataShowError = false;
            });
        }

        // Cancel button execution
        function cancel() {
            $uibModalInstance.dismiss();
        }

        // Removes Kendo widgets
        //$scope.$on('$destroy', function() {
        //    _.result(vm, 'updateInventoryUpload.destroy');
        //});

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    }])
;
angular.module('cerberus.cpc')
    /**
     * @ngdoc service
     * @name inventoryService
     * @alias cerberus/cpc:inventoryService
     * @description Makes calls to the "cpc/inventory" resources
     */
    .factory('inventoryService', ["_", "$http", "$q", "apiPath", "$uibModal", "toaster", function inventoryService(_, $http, $q, apiPath, $uibModal, toaster) {

        return {
            updateInventoryRowPositionsOpenModal: updateInventoryRowPositionsOpenModal,
            updateInventoryLocationOpenModal: updateInventoryLocationOpenModal,
            updateFinishedProductLocationOpenModal: updateFinishedProductLocationOpenModal,
            initiateWarehouseAuditOpenModal: initiateWarehouseAuditOpenModal,
            initiateEDI_RollInputOpenModal: initiateEDI_RollInputOpenModal,
            updateRollPositions: updateRollPositions
        };

        ////////////////////
        /**
         * Open modal to create / update inventory roll positions
         */
        function updateInventoryRowPositionsOpenModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'cpc/inventory/templates/inventory-rollpositions-update-modal.tpl.html',
                controller: 'updateInventoryRowPositionsOpenModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {}
            });
            return modalInstance.result;
        }

        ////////////////////
        /**
         * Open modal to update current assigned location of inventory roll materials
         */
        function updateInventoryLocationOpenModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'cpc/inventory/templates/inventory-location-update-modal.tpl.html',
                controller: 'updateInventoryLocationOpenModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {}
            });
            return modalInstance.result;
        }

        ////////////////////
        /**
         * Open modal to update current assigned location of finished products
         */
        function updateFinishedProductLocationOpenModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'cpc/inventory/templates/finished-product-location-update-modal.tpl.html',
                controller: 'updateFinishedProductLocationOpenModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {}
            });
            return modalInstance.result;
        }

        ////////////////////
        /**
         * Open modal to initiate warehouse audit
         */
        function initiateWarehouseAuditOpenModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'cpc/inventory/templates/inventory-warehouse-audit-modal.tpl.html',
                controller: 'initiateInventoryWarehouseAuditModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {}
            });
            return modalInstance.result;
        }

        ////////////////////
        /**
         * Open modal to initiate roll input from an EDI source
         */
        function initiateEDI_RollInputOpenModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'cpc/inventory/templates/inventory-edi-rollinput-modal.tpl.html',
                controller: 'initiateEDI_RollInputOpenModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {}
            });
            return modalInstance.result;
        }

        ////////////////////
        /**
         * Function to update roll positions / warehouse audit
         * Required fields: action, data
         */
        function updateRollPositions(action, data) {
            action = action || 'none';
            data = data || {};

            var deferred = $q.defer(),
                url = apiPath + 'cpc/inventory' + '/update';

            $http.put(url, {data: data}, {params: {action: action}})
                .success(function (value) {
                    toaster.pop('success', 'Update completed');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }])
;

angular.module('cerberus.cpc')
    .controller('initiateInventoryWarehouseAuditModalCtrl', ["_", "$scope", "$uibModalInstance", "inventoryService", function(_, $scope, $uibModalInstance, inventoryService){
        var vm = this;
        vm.emptyValue = '';
        vm.rollpositions_textarea = '';
        vm.rollpositions_textarea_roundTwo = '';
        vm.rowWarehouseSelected = '';
        vm.rowWarehouseList = [
            {value: '1', display: '(1) Roll room warehouse'},
            {value: '2', display: '(2) Production racks'},
            {value: '3', display: '(3) Other'}
        ];
        vm.auditCountId = '';
        vm.auditCountIdList = [
            {value: '1', display: 'Count ID 1'},
            {value: '2', display: 'Count ID 2'},
            {value: '3', display: 'Count ID 3'},
            {value: '4', display: 'Count ID 4'},
            {value: '5', display: 'Count ID 5'},
            {value: '6', display: 'Count ID 6'},
            {value: '7', display: 'Count ID 7'},
            {value: '8', display: 'Count ID 8'},
            {value: '9', display: 'Count ID 9'}
        ];
        vm.AuditHelper =  "..:: Useful information about how to interpret data ::..\n" +
                          "-- =*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=\n" +
                          "-- SCAN METHOD: [[ 'X number' is the AuditCount Number ]]   \n" +
                          "-- CASE #1: Roll Weight == '0', and AuditCount == X number. \n" +
                          "-- CASE #2: Roll Weight  > '0', and AuditCount <> X number. \n" +
                          "-- =*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*="; 

        vm.importingDataInProgress = false;
        vm.importingDataShowError = false;
        vm.isUnchanged = isUnchanged;
        vm.submit = submit;
        vm.cancel = cancel;

        // -- add here necessary fuctions needed to be processed within controller, when done, remove this... //

        // Check if text is empty
        function isUnchanged() {
            return angular.equals(vm.rollpositions_textarea, vm.emptyValue);
        }

        // Submit button execution
        function submit() {
            // Basic validation test, nothing special
            if (vm.rollpositions_textarea == 'test') {
                return;
            }
            // Manage progress monitoring
            vm.importingDataInProgress = true;
            vm.importingDataShowError = false;
            // Initiate function here
            var action = 'warehouse_audit'; // specify here exact action to be executed
            // join both text areas and send it as is. (use semicolon to split them).
            var dataCombined = vm.rollpositions_textarea + ';' + vm.rollpositions_textarea_roundTwo;
            var data = {
                'values': dataCombined,
                'auditcount': vm.auditCountId,
                'warehouse': vm.rowWarehouseSelected
            };
            inventoryService.updateRollPositions(action, data).then(function (result) {
                vm.importingDataInProgress = false;
                //console.log(result);
                if (result.errMsg) {
                    vm.importingDataShowError = true;
                 //   vm.importError = result.errMsg;
                 //console.log('aaaaaaaaaaabbbbbb');
                }
                //else if (result.instanceId) {
                //    $uibModalInstance.close(result.instanceId);
                //}
                else {
                    $uibModalInstance.close(result.instanceId);
                }
            }, function () {
                vm.importingDataInProgress = false;
                vm.importingDataShowError = false;
            });
        }

        // Cancel button execution
        function cancel() {
            $uibModalInstance.dismiss();
        }

        // Removes Kendo widgets
        //$scope.$on('$destroy', function() {
        //    _.result(vm, 'updateInventoryUpload.destroy');
        //});

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationCloseAndFundModalCtrl', ["_", "moment", "kendo", "$scope", "$uibModalInstance", "loanApplicationId", "loanAmount", "noteRate", "lesLoanApplicationsService", function(_, moment, kendo, $scope, $uibModalInstance, loanApplicationId, loanAmount, noteRate, lesLoanApplicationsService){
        var vm = this;

        $scope._finalLoanAmount = loanAmount;
        $scope._finalNoteRate = noteRate;

        vm.loanApplicationId = loanApplicationId;
        vm.loanAmount = kendo.toString(loanAmount, 'c2');
        vm.noteRate = kendo.toString(noteRate, 'p2');
        vm.closing = false;
        vm.fundingData = {
            finalLoanAmount: loanAmount,
            finalNoteRate: noteRate
        };
        vm.dateFundedOptions = {
            format: 'g',
            parseFormats: [
                'yyyy-MM-ddTHH:mm:ss.fffZ',
                'yyyy-MM-dd HH:mm:ss.fff',
                'dddd, MMMM dd, yyyy h:mm:ss tt',
                'M/d/yy',
                'M-d-yy',
                'M/d/yyyy',
                'M-d-yyyy',
                'MM/dd/yy',
                'MM-dd-yy',
                'MM/dd/yyyy',
                'MM-dd-yyyy',
                'M/d/yy h:mm tt',
                'M-d-yy h:mm tt',
                'M/d/yyyy h:mm tt',
                'M-d-yyyy h:mm tt',
                'MM/dd/yy h:mm tt',
                'MM-dd-yy h:mm tt',
                'MM/dd/yyyy h:mm tt',
                'MM-dd-yyyy h:mm tt',
                'M/d/yy h:mm:ss tt',
                'M-d-yy h:mm:ss tt',
                'M/d/yyyy h:mm:ss tt',
                'M-d-yyyy h:mm:ss tt',
                'MM/dd/yy h:mm:ss tt',
                'MM-dd-yy h:mm:ss tt',
                'MM/dd/yyyy h:mm:ss tt',
                'MM-dd-yyyy h:mm:ss tt'
            ]
        };
        vm.finalLoanAmountOptions = {
            decimals: 2,
            format: 'c2',
            min: 0,
            step: 0.01
        };
        vm.finalNoteRateOptions = {
            decimals: 4,
            format: 'p2',
            min: 0,
            step: 0.01
        };

        vm.ok = ok;
        vm.cancel = cancel;

        function ok(){
            vm.closing = true;

            var data = angular.copy(vm.fundingData);

            if (_.isDate(data.dateFunded)) {
                data.dateFunded = data.dateFunded.toISOString();
            }    
            
            lesLoanApplicationsService.updateLoan(vm.loanApplicationId,{action:'closed',data:data}).then(function(){
                vm.closing = false;
                $uibModalInstance.close();
            }, function(){
                vm.closing = false;
            });
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        // Removes Kendo widgets
        $scope.$on('$destroy', function(){
            _.result(vm, 'dateFundedPicker.destroy');
            _.result(vm, 'finalLoanAmountBox.destroy');
        });

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationCtrl', ["_", "moment", "$scope", "$rootScope", "$timeout", "$firebaseObject", "fbUtil", "loanApplicationId", "lesLoanApplicationsService", "pageObjectsService", function(_, moment, $scope, $rootScope, $timeout, $firebaseObject, fbUtil, loanApplicationId, lesLoanApplicationsService, pageObjectsService){
        var vm = this;

        $scope.filters = {};
        
        vm.loanApplicationId = loanApplicationId;
        vm.simpleLoanId = _.last(loanApplicationId.split('-'));
        vm.loanApplication = {};
        vm.status = {};
        vm.statuses = [];
        vm.primaryBorrower = '';
        vm.breadcrumbDisplay = 'Loading...';
        vm.borrowers = [];
        vm.creditScores = {};
        vm.applicationDataLoaded = false;
        vm.auditLogInitialized = false;
        vm.savedForLaterInitialized = false;
        vm.showValidityAlert = false;
        vm.validityErrors = [];
        vm.productSelected = false;
        vm.findings = {};

        vm.toYear = toYear;

        var instanceWindowCallback = {},
            deregisterAuditLog = angular.noop,
            deregisterSavedForLater = angular.noop;

        init();

        function init(){
            lesLoanApplicationsService.getLoanApplication(loanApplicationId).then(function(loanApplication){
                if(loanApplication.recordData.findings){
                    vm.productSelected = true;
                    vm.loanApplication = loanApplication.recordData.loanApp;
                    vm.findings = loanApplication.recordData.findings;
                }
                else{
                    vm.productSelected = false;
                    vm.loanApplication = loanApplication.recordData;
                    vm.findings = {};
                }

                var loanRecordId = _.last(loanApplicationId.split('-')),
                    mainBorrowerName = _.get(vm.loanApplication, 'mainBorrower.fullName');
                
                vm.status = _.get(vm.loanApplication, 'LoanAppStatus.id', 1735);
                vm.primaryBorrower = mainBorrowerName || 'No Primary Borrower';
                vm.actionsAvailable = lesLoanApplicationsService.actionAvailabilityByLoanStatus();
                vm.applicationDataLoaded = true;
                vm.borrowers = [];
                vm.creditScores = {};
                vm.breadcrumbDisplay = vm.primaryBorrower + ' (#' + loanRecordId + ')';

                // Modal/Routing functions are not set until the loan application is verified

                vm.openApplicationRecord = _.partial(lesLoanApplicationsService.openApplicationRecord, loanRecordId, _, instanceWindowCallback);
                //vm.openUpdateModal = _.partial(lesLoanApplicationsService.openUpdateModal, loanApplicationId);
                vm.openExportModal = _.partial(lesLoanApplicationsService.openExportModal, loanApplicationId);
                // vm.openEligibilityPage = _.partial(lesLoanApplicationsService.openEligibilityPage, loanApplicationId);
                vm.openEligibilityPage = openEligibilityPage;
                vm.openCreditPullModal = openCreditPullModal;
                vm.openCreditManualEntryModal = openCreditManualEntryModal;
                vm.openWithdrawalModal = openWithdrawalModal;
                vm.openUnregistrationModal = openUnregistrationModal;
                vm.openCloseAndFundModal = openCloseAndFundModal;
                vm.openReopenModal = openReopenModal;
                vm.openSelectedProduct = openSelectedProduct;

                instanceWindowCallback.callback = function () { $rootScope.$broadcast('nim-loan-update', loanApplicationId); };

                $scope.filters.LoanApplicationID = {
                    filters: [{
                        field: '__nimColumn__',
                        operator: 'eq',
                        value: loanRecordId
                    }],
                    logic: 'or'
                };

                // Set Kendo Grid options
                vm.auditLogOptions = lesLoanApplicationsService.loanAuditLogOptions(loanRecordId);
                vm.savedForLaterOptions = lesLoanApplicationsService.loanSavedForLaterOptions(loanRecordId);
                // vm.attachmentGridOptions = lesLoanApplicationsService.attachmentGridOptions;
                // vm.documentGridOptions = lesLoanApplicationsService.loanDocumentVaultOptions(loanRecordId);
                vm.addDocumentToVault = _.partial(lesLoanApplicationsService.addDocumentToVault, loanRecordId);

                // Watches firebase to reload audit log                
                deregisterAuditLog = $firebaseObject(fbUtil.ref('queries/291C8BED3D8503A658F3C1E4ABC99FD1-176')).$watch(function () {
                    if (!vm.auditLogInitialized) {
                        //Stops first firing of the event
                        $timeout(function () { vm.auditLogInitialized = true; });
                    } else {
                        _.result(vm, 'auditLog.dataSource.read');
                    }
                });

                // Watches firebase to reload saved for later table                
                deregisterSavedForLater = $firebaseObject(fbUtil.ref('queries/3437A61E95CA10A66DA643259BCA80C5-183')).$watch(function () {
                    if (!vm.savedForLaterInitialized) {
                        //Stops first firing of the event
                        $timeout(function () { vm.savedForLaterInitialized = true; });
                    } else {
                        _.result(vm, 'savedForLater.dataSource.read');
                    }
                });

                lesLoanApplicationsService.getLoanAppStatuses().then(function(statuses){
                    vm.statuses = statuses;
                });

                lesLoanApplicationsService.getLoanApplicants(loanRecordId).then(function (borrowers) {
                    vm.borrowers = borrowers;
                });

                lesLoanApplicationsService.getCreditData(loanRecordId).then(function (data) {
                    vm.creditScores = _.groupBy(data.scores, 'borrowerId');
                });
            });

            pageObjectsService.getPageObject('22DACED3D22F2B95DABF06125C9DD278-151').then(function (pageObj) {
                vm.documentVault = pageObj;
            });

            pageObjectsService.getPageObject('1BBBC0190C979291712632271018D4FA-170').then(function (pageObj) {
                vm.creditReport = pageObj;
            });
        }

        function openCreditPullModal(){
            lesLoanApplicationsService.openCreditPullModal(loanApplicationId).then(refreshStatusAndAuditLog);
        }

        function openCreditManualEntryModal(){
            lesLoanApplicationsService.openCreditManualEntryModal(loanApplicationId).then(refreshStatusAndAuditLog);
        }

        function openWithdrawalModal(){
            lesLoanApplicationsService.openWithdrawalModal(loanApplicationId).then(refreshStatusAndAuditLog);
        }

        function openUnregistrationModal(){
            lesLoanApplicationsService.openUnregistrationModal(loanApplicationId).then(refreshStatusAndAuditLog);
        }

        function openCloseAndFundModal(){
            lesLoanApplicationsService.openCloseAndFundModal(loanApplicationId, vm.loanApplication.BaseLoanAmount, vm.findings.noteRate).then(refreshStatusAndAuditLog);
        }

        function openReopenModal(){
            lesLoanApplicationsService.openReopenModal(loanApplicationId).then(refreshStatusAndAuditLog);
        }

        function openEligibilityPage() {
            vm.showValidityAlert = false;
            vm.validityErrors = [];
            
            lesLoanApplicationsService.validateLoanApplication(loanApplicationId).then(function (result) {
                if (!result.isValid) {
                    vm.showValidityAlert = true;
                    /* LODASH Version 4 ONLY */
                    //vm.validityErrors = _.filter(result.messages, ['type', 'error']);
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    vm.validityErrors = _.filter(result.messages, function(c){return c.type === 'error';});
                }

                var defaultQueryParams = {};

                if (vm.loanApplication.isSelfEmployed) {
                    defaultQueryParams['12monthBankStatements'] = true;
                    defaultQueryParams['24monthBankStatements'] = true;
                    }
                // else {
                    defaultQueryParams.fullDocumentation = true; // Now unconditional
                // }
                var baseLoanAmount = vm.loanApplication.BaseLoanAmount || 0;
                var totalAssets = vm.loanApplication.totalAssets || 0;

                if ((totalAssets * 2) >= baseLoanAmount) {
                    defaultQueryParams.assetUtilization = true;
                }

                if (vm.loanApplication.PropertyUsagetype.display == 'Investor') {
                    defaultQueryParams.debtServiceCoverage = true;
                }

                lesLoanApplicationsService.openFindProductsModal(defaultQueryParams, result).then(function (params) {
                    lesLoanApplicationsService.openEligibilityPage(loanApplicationId, params);
                });
            });
        }

        function openSelectedProduct(){
            lesLoanApplicationsService.openFindingsReportModal(loanApplicationId, vm.findings.productId, vm.findings, -1);
        }

        function refreshStatusAndAuditLog(){
            vm.borrowers = [];
            vm.creditScores = {};
            
            lesLoanApplicationsService.getLoanApplication(loanApplicationId).then(function(loanApplication){
                if(loanApplication.recordData.findings){
                    vm.productSelected = true;
                    vm.loanApplication = loanApplication.recordData.loanApp;
                    vm.findings = loanApplication.recordData.findings;
                }
                else{
                    vm.productSelected = false;
                    vm.loanApplication = loanApplication.recordData;
                    vm.findings = {};
                }

                vm.status = _.get(vm.loanApplication, 'LoanAppStatus.id', 1735);
                vm.primaryBorrower = _.get(vm.loanApplication, 'mainBorrower.fullName') || 'No Primary Borrower';

                var lenderCaseId = vm.loanApplication.LenderCaseIdentifier || 'No Case Number';
                vm.breadcrumbDisplay = vm.primaryBorrower + ' (' + lenderCaseId + ')';
            });

            var loanRecordId = _.last(loanApplicationId.split('-'));            
            lesLoanApplicationsService.getLoanApplicants(loanRecordId).then(function (borrowers) {
                vm.borrowers = borrowers;
            });

            lesLoanApplicationsService.getCreditData(loanRecordId).then(function (data) {
                vm.creditScores = _.groupBy(data.scores, 'borrowerId');
            });
        }

        function toYear(value) {
            if (value) {
                if (_.isDate(value)) {
                    return moment.utc(value).local().year();
                }
                else if (_.isString(value)) {
                    return moment.utc(value, 'MMMM, DD YYYY HH:mm:ss').local().year();
                }
            }    

            return '';
        }

        $scope.$on('nim-loan-update', function (e, id) {
            e.preventDefault();

            if (id == loanApplicationId) {
                vm.showValidityAlert = false;
                vm.validityErrors = [];
                refreshStatusAndAuditLog();
            }    
        });

        $scope.$on('$locationChangeStart', function (e, newUrl, oldUrl) {
            newUrl = newUrl || '';
            oldUrl = oldUrl || '';

            if (!e.defaultPrevented) {
                _.result(vm, 'auditLog.destroy');
                _.result(vm, 'savedForLater.destroy');

                // Remove firebase watchers
                deregisterAuditLog();
                deregisterSavedForLater();
            }
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationCreditPullModalCtrl', ["_", "$rootScope", "$scope", "$uibModalInstance", "loanApplicationId", "lesLoanApplicationsService", function(_, $rootScope, $scope, $uibModalInstance, loanApplicationId, lesLoanApplicationsService){
        var vm = this;

        vm.loanApplicationId = loanApplicationId;
        vm.borrowers = [];
        vm.tempBorrowers = [];
        vm.updatingPermissions = false;
        vm.pullingCredit = false;
        vm.errorAlert = '';
        vm.creditPull = {
            creditProvider: null,
            // overrideLiabilities: null,
            referenceNumber: ''
        };
        vm.creditProviderLookupOptions = {
            dataTextField: 'display',
            dataValueField: 'id',
            filter: 'contains',
            optionLabel: {
                display: 'Choose...',
                id: -1
            },
            dataSource: {
                type: 'odata',
                transport: {
                    read: {
                        url: '/server/rest/v1/views/E693092AA6FF4C37362265BC06B0C79D-221/odata.svc',
                        dataType: 'json',
                        beforeSend: function(xhr){
                            xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                            xhr.setRequestHeader('WSID', $rootScope.userData.currentWorkspace.id);
                        },
                        data: {
                            $lookupDisplay: 'provider_name'
                        }
                    }
                }
            }
        };

        vm.ok = ok;
        vm.cancel = cancel;
        vm.updateBorrowerCreditPullPermission = updateBorrowerCreditPullPermission;
        vm.permissionToPullCredit = permissionToPullCredit;

        init();

        function init(){
            var loanRecordId = _.last(loanApplicationId.split('-'));
            lesLoanApplicationsService.getLoanApplicants(loanRecordId).then(function(borrowers){
                vm.borrowers = _.map(borrowers, mapBorrowerPermissionData);
                vm.tempBorrowers = angular.copy(vm.borrowers);
            });
        }

        function ok(form){
            vm.pullingCredit = true;

            if (!validateForm(form)) {
                vm.pullingCredit = false;
                return;
            }

            lesLoanApplicationsService.pullCredit(vm.loanApplicationId, vm.creditPull).then(function(){
                vm.pullingCredit = false;
                $uibModalInstance.close();
            }, function(reason){
                vm.pullingCredit = false;
                
                if (reason.CODE >= 400 && reason.CODE < 500) {
                    vm.errorAlert = reason.DATA;
                }
            });
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        function validateForm(form) {
            var valid = true;
            
            // Credit Provider
            if (!vm.creditPull.creditProvider) {
                valid = false;
                form['credit-provider-lookup'].$setValidity('required', false);
            }
            else {
                form['credit-provider-lookup'].$setValidity('required', null);
            }

            // Override Liabilities
            // if (!_.isBoolean(vm.creditPull.overrideLiabilities)) {
            //     valid = false;
            //     form['credit-liabilities-override'].$setValidity('required', false);
            // }
            // else {
            //     form['credit-liabilities-override'].$setValidity('required', null);
            // }

            // Borrowers
            _.forEach(vm.borrowers, function (borrower, index) {
                if (!borrower.permission) {
                    valid = false;
                    form['borrower-' + index + '-permission'].$setValidity('required', false);
                }
                else {
                    form['borrower-' + index + '-permission'].$setValidity('required', null);
                }
            });

            return valid;
        }

        function updateBorrowerCreditPullPermission(index, id, permission){
            vm.updatingPermissions = true;
            lesLoanApplicationsService.updateBorrowerCreditPullPermission(id, permission).then(function(){
                vm.updatingPermissions = false;
                vm.borrowers[index].permission = permission;
            }, function(){
                vm.updatingPermissions = false;
                vm.tempBorrowers[index].permission = vm.borrowers[index].permission;
            });
        }

        function mapBorrowerPermissionData(borrower){
            return {
                id: _.get(borrower, 'Borrowers_instance_id'),
                firstName: _.get(borrower, 'Borrowers_FirstName', ''),
                lastName: _.get(borrower, 'Borrowers_LastName', ''),
                permission: _.get(borrower, 'Borrowers_BorrowerCreditPullPermission_display', false)
            };
        }

        function permissionToPullCredit(){
            return _.every(vm.borrowers, function(borrower){
                return borrower.permission;
            });
        }

        $scope.$on('$destroy', function(){
            _.result(vm, 'creditProviderLookup.destroy');
        });

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationEligibilityCtrl', ["_", "$scope", "$rootScope", "$location", "$timeout", "$q", "loanApplicationId", "lesLoanApplicationsService", "OdataUtilityService", function(_, $scope, $rootScope, $location, $timeout, $q, loanApplicationId, lesLoanApplicationsService, OdataUtilityService){
        var vm = this;

        vm.loanApplicationId = loanApplicationId;
        vm.loanApplication = {};
        vm.mainBorrower = '';
        vm.lenders = [];
        vm.creditScores = [];
        vm.docTypes = [];
        vm.amortizationTypes = [];
        vm.loadingProducts = false;
        vm.notFound = false;
        vm.productSelected = false;
        vm.tabActive = {};
        vm.breadcrumbDisplay = 'Loading...';
        vm.eligibilityError = '';
        vm.eligibilityType = '';
        vm.eligibilityTypeCounts = {
            all: 0,
            eligible: 0,
            ineligible: 0,
            nearmiss: 0
        };
        vm.termsFilter = {
            field: 'loanAmortizationType',
            operator: 'eq',
            value: ''
        };
        vm.doctypeFilter = {
            field: 'docType',
            operator: 'eq',
            value: ''
        };
        vm.rateFilter = {
            field: 'rate',
            operator: 'lte',
            value: ''
        };
        vm.rateFilterOptions = {
            step: 0.25,
            format: 'n2',
            min: 0,
            decimals: 2
        };

        vm.productRateDetailTableOptions = lesLoanApplicationsService.productRateDetailTableOptions;
        vm.operatorSymbols = OdataUtilityService.operatorSymbols();
        vm.operators = OdataUtilityService.operators();

        vm.updateEligibilityFilter = updateEligibilityFilter;        
        vm.applyFilters = applyFilters;
        vm.clearFilter = clearFilter;
        vm.refineSearch = refineSearch;
        vm.navToLoanPage = navToLoanPage;

        var instanceWindowCallback = {};

        init();

        function init(){
            vm.loanApplication = {};
            vm.mainBorrower = '';
            vm.lenders = [];
            vm.creditScores = [];
            vm.docTypes = [];
            vm.amortizationTypes = [];
            vm.tabActive = {};
            vm.eligibilityError = '';
            vm.eligibilityType = '';
            vm.eligibilityTypeCounts = {
                all: 0,
                eligible: 0,
                ineligible: 0,
                nearmiss: 0
            };
            vm.termsFilter = {
                field: 'loanAmortizationType',
                operator: 'eq',
                value: ''
            };
            vm.doctypeFilter = {
                field: 'docType',
                operator: 'eq',
                value: ''
            };
            vm.rateFilter = {
                field: 'rate',
                operator: 'lte',
                value: ''
            };
            vm.loadingProducts = true;

            lesLoanApplicationsService.getLoanApplication(loanApplicationId).then(function(loanApplication){
                if(loanApplication.recordData.findings){
                    vm.loanApplication = loanApplication.recordData.loanApp;
                    vm.productSelected = true;
                    vm.loadingProducts = false;
                }
                else{
                    vm.loanApplication = loanApplication.recordData;
                }

                var loanRecordId = _.last(loanApplicationId.split('-')),
                    mainBorrowerName = _.get(vm.loanApplication, 'mainBorrower.fullName'),
                    mainBorrowerId = _.get(vm.loanApplication, 'mainBorrower.id');

                instanceWindowCallback.callback = function () { $rootScope.$broadcast('nim-loan-update', loanApplicationId); };
                
                vm.mainBorrower = mainBorrowerName;
                vm.breadcrumbDisplay = mainBorrowerName + ' (#' + loanRecordId + ')';

                vm.openApplicationRecord = _.partial(lesLoanApplicationsService.openApplicationRecord, loanRecordId, false, instanceWindowCallback);

                if (vm.productSelected) {
                    return;
                }

                if (_.isEmpty($location.search())) {
                    setDefaultQueryParams();
                }
                
                lesLoanApplicationsService.getLoanPrograms(loanApplicationId).then(function (programData) {
                    vm.lenders = programData.lenders;

                    var eligibilityPromises = [];
                    
                    _.forEach(vm.lenders, function (l) {
                        _.forEach(l.programs, function (p) {
                            var prom = lesLoanApplicationsService.getLoanProgramEligibility(loanApplicationId, p.id, l.conduit, $location.search()).then(function (eligibilityData) {
                                _.assign(p, eligibilityData);

                                return true;
                            }, function (err) {
                                vm.eligibilityError = err;

                                return true;
                            });

                            eligibilityPromises.push(prom);
                        });
                    });

                    $q.all(eligibilityPromises).then(function () {
                        vm.productEligibilityTableOptions = lesLoanApplicationsService.productEligibilityTableOptions(vm.eligibilityType, vm.lenders);
                        // setEligibilityClickHandler();

                        var eligibilityTypeCounts = _.countBy(vm.productEligibilityTableOptions.dataSource.data, 'eligibility');

                        if (eligibilityTypeCounts.eligible) {
                            vm.tabActive['eligible'] = true;
                            vm.eligibilityType = 'eligible';
                            vm.productEligibilityTableOptions.dataSource.filter.filters.push({
                                field: 'eligibility',
                                operator: 'eq',
                                value: 'eligible'
                            });
                        }
                        else {
                            vm.tabActive['all'] = true;
                        }

                        eligibilityTypeCounts.all = vm.productEligibilityTableOptions.dataSource.data.length;
                        _.assign(vm.eligibilityTypeCounts, eligibilityTypeCounts);

                        var filterData = lesLoanApplicationsService.getFilterOptions(vm.lenders);
                        
                        vm.amortizationTypes = filterData.amortizationTypes;
                        vm.termsLookupOptions = lesLoanApplicationsService.eligibilityFilterLookupOptions(filterData.amortizationTypes);
                        
                        vm.docTypes = filterData.docTypes;
                        vm.docTypeLookupOptions = lesLoanApplicationsService.eligibilityFilterLookupOptions(filterData.docTypes);

                        vm.loadingProducts = false;

                        if (eligibilityTypeCounts.all === 0) {
                            vm.eligibilityError = 'No products found. Please refine your search.';
                        }
                    }, function () {
                        vm.loadingProducts = false;
                        vm.productEligibilityTableOptions = lesLoanApplicationsService.productEligibilityTableOptions(vm.eligibilityType, []);
                    });
                }, function () {
                    vm.loadingProducts = false;
                    vm.productEligibilityTableOptions = lesLoanApplicationsService.productEligibilityTableOptions(vm.eligibilityType, []);
                });

                if (mainBorrowerId) {
                    lesLoanApplicationsService.getCreditData(loanRecordId).then(function (data) {
                        /* LODASH Version 4 ONLY */
                        //vm.creditScores = _.filter(data.scores, ['borrowerId', mainBorrowerId]);
                        /* LODASH Version 3 & 4 Compatibility Mode */
                        vm.creditScores = _.filter(data.scores, function(c){return c.borrowerId === mainBorrowerId;});
                    });
                }
            }, function (reason) {
                if (reason == "Not Found.") {
                    vm.loadingProducts = false;
                    vm.notFound = true;
                }
            });
        }

        function setDefaultQueryParams() {
            var docTypes = [];

            if (vm.loanApplication.isSelfEmployed) {
                docTypes.push('12M Bank Statements');
                docTypes.push('24M Bank Statements');
                }
            // else {
                docTypes.push('Full Document'); // Now unconditional
            // }
            var baseLoanAmount = vm.loanApplication.BaseLoanAmount || 0;
            var totalAssets = vm.loanApplication.totalAssets || 0;

            if ((totalAssets * 2) >= baseLoanAmount) {
                docTypes.push('Asset Utilization');
            }

            if (vm.loanApplication.PropertyUsagetype.display == 'Investor') {
                docTypes.push('Debt Service Coverage');
            }

            $location.replace().search({
                amortizations: 'arm,fixed',
                ppp: 'no',
                docTypes: docTypes.join(',')
            });
        }

        function updateEligibilityFilter(eligibilityType) {
            if (eligibilityType != vm.eligibilityType) {
                vm.eligibilityType = eligibilityType;
                applyFilters();
            }
        }

        function applyFilters() {
            var filter = {
                logic: 'and',
                filters: []
            };

            if (vm.eligibilityType) {
                filter.filters.push({
                    field: 'eligibility',
                    operator: 'eq',
                    value: vm.eligibilityType
                });
            }

            if (vm.termsFilter.value && vm.termsFilter.value !== 'Choose...') {
                filter.filters.push(vm.termsFilter);
            }

            // if (vm.doctypeFilter.value && vm.doctypeFilter.value !== 'Choose...') {
            //     filter.filters.push(vm.doctypeFilter);
            // }

            if (vm.rateFilter.value || vm.rateFilter.value === 0) {
                filter.filters.push(vm.rateFilter);
            }

            $timeout(function () {
                if (vm.productEligibilityTable) {
                    vm.productEligibilityTable.dataSource.filter(filter);
                }
            });
        }

        function clearFilter(filter) {
            filter.value = '';
            applyFilters();
        }

        function refineSearch() {
            var defaultQueryParams = lesLoanApplicationsService.parseProductsQueryParams($location.search());
            lesLoanApplicationsService.openFindProductsModal(defaultQueryParams).then(function (result) {
                $location.replace().search(result);
            });
        }

        function navToLoanPage() {
            $location.url('D4FEB549FFBA0E36B19E7D9579BD4791-2');
        }

        // function setEligibilityClickHandler() {
        //     $scope.$on('kendoWidgetCreated', function (e, kWidget) {
        //         e.preventDefault();
        //         console.log(kWidget);

        //         if (kWidget == vm.productEligibilityTable) {
        //             var openRows = {};
                    
        //             kWidget.tbody.on('click', '.k-master-row', function (event) {
        //                 event.preventDefault();
        //                 event.stopPropagation();
        //                 event.stopImmediatePropagation();
        //                 var uid = angular.element(event.currentTarget).data('uid');

        //                 console.log(uid);
        //                 if (openRows[uid]) {
        //                     kWidget.collapseRow(event.currentTarget);
        //                     openRows[uid] = false;
        //                 }
        //                 else {
        //                     kWidget.expandRow(event.currentTarget);
        //                     openRows[uid] = true;
        //                 }
        //             });
        //         }
        //     });
        // }

        $scope.$on('nim-loan-update', function (e, id) {
            e.preventDefault();

            if (id == loanApplicationId) {
                init();
            }
        });

        $scope.$on('$locationChangeStart', function (e, newUrl) {
            newUrl = newUrl || '';
            
            var path = '/loan-applications/' + loanApplicationId + '/eligibility';
            if (newUrl.indexOf(path) < 0 && !e.defaultPrevented) {
                if (vm.productEligibilityTable) {
                    vm.productEligibilityTable.destroy();
                    vm.productEligibilityTable = null;
                }
                
                if (vm.termsLookup) {
                    vm.termsLookup.destroy();
                    vm.termsLookup = null;
                }
            }
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationExportModalCtrl', ["$scope", "$window", "$uibModalInstance", "loanApplicationId", "InstancesService", "lesLoanApplicationsService", function($scope, $window, $uibModalInstance, loanApplicationId, InstancesService, lesLoanApplicationsService){
        var vm = this;

        vm.exportType = '';
        vm.exporting = false;

        vm.ok = ok;
        vm.cancel = cancel;

        function ok() {
            if (vm.exportType) {
                vm.exporting = true;

                lesLoanApplicationsService.exportLoanApplication(loanApplicationId, vm.exportType).then(function (exportAttachment) {
                    // Save exported file
                    InstancesService.getDownloadKey(exportAttachment.id).then(function (d) {
                        InstancesService.getBlob(d).then(function (blob) {
                            $window.saveAs(blob, exportAttachment.name);

                            finishExport();
                        }, finishExport);
                    }, finishExport);
                }, function () {
                    vm.exporting = false;
                });
            }
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        function finishExport() {
            vm.exporting = false;
            $uibModalInstance.close();
        }

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationFindProductsModalCtrl', ["_", "$scope", "$uibModalInstance", "queryParams", "validation", "lesLoanApplicationsService", function (_, $scope, $uibModalInstance, queryParams, validation, lesLoanApplicationsService) {
        var vm = this,
            allowNavigation = angular.noop,
            defaultParams = {
                arm: true,
                fixed: true,
                interestOnly: false,
                noPrepaymentPenalty: true,
                '12monthPrepaymentPenalty': false,
                '24monthPrepaymentPenalty': false,
                '36monthPrepaymentPenalty': false,
                fullDocumentation: false,
                '12monthBankStatements': false,
                '24monthBankStatements': false,
                assetUtilization: false,
                debtServiceCoverage: false
            };

        vm.queryParams = {};
        vm.isValid = false;
        vm.messages = {};

        vm.ok = ok;
        vm.cancel = cancel;

        init();
        
        function init() {
            vm.queryParams = _.defaults({}, queryParams, defaultParams);
            vm.isValid = validation.isValid;
            vm.messages = _.groupBy(validation.messages, 'type');
        }

        function ok() {
            var result = lesLoanApplicationsService.buildProductsQueryParams(vm.queryParams);
            allowNavigation();
            $uibModalInstance.close(result);
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        // Prevents navigation while modal is open
        allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationFindingsCtrl', ["_", "kendo", "moment", "$scope", "$document", "$location", "$timeout", "$uibModalInstance", "loanApplicationId", "productId", "product", "pricingIndex", "lesLoanApplicationsService", "normalPrintingService", function (_, kendo, moment, $scope, $document, $location, $timeout, $uibModalInstance,
                                                              loanApplicationId, productId, product, pricingIndex,
                                                              lesLoanApplicationsService, normalPrintingService) {
        var vm = this;
        var today = new Date();
        
        vm.loanApplicationId = loanApplicationId;
        vm.simpleLoanId = _.last(loanApplicationId.split('-'));
        vm.productId = productId;
        vm.product = product;
        vm.pricing = {};
        vm.primaryBorrowerName = '';
        vm.propertyAddress = '';
        vm.applicationDataLoaded = false;
        vm.productSelected = false;
        vm.borrowers = [];
        vm.reasons = [];
        vm.reasonCategories = {};
        vm.conditions = [];
        vm.proposedExpenses = [];
        vm.printingFindingsReport = false;
        vm.showReasonsCitations = false;
        vm.showConditionsCitations = false;
        vm.conditionsShown = { all: true };
        vm.eligibilityRunDate = '';
        vm.totalOtherProposedExpenses = 0;
        vm.totalRateAdjustments = 0;
        vm.showSummaryTab = true;
        vm.showConditionsTab = false;
        vm.showAnalysisTab = false;
        vm.showAllTabs = false;
        
        vm.ok = ok;
        vm.cancel = cancel;
        vm.formatPercentage = formatPercentage;
        vm.formatDate = formatDate;
        vm.min = min;
        vm.finalRate = finalRate;
        vm.totalAssets = totalAssets;
        vm.totalConditions = totalConditions;
        vm.setConditionsAndReasons = setConditionsAndReasons;
        vm.printFindingsReport = printFindingsReport;
        vm.assetSum = assetSum;
        
        init();

        function init() {
            vm.totalRateAdjustments = 0;

            _.forEach(product.adjustments, function(adj){
                vm.totalRateAdjustments += adj.value;
            });

            if(pricingIndex >= 0){
                vm.pricing = product.pricing[pricingIndex];
            }
            _.forEach(vm.pricing.adjustments, function(adj){
                vm.totalRateAdjustments += adj.value;
            });
            lesLoanApplicationsService.getLoanApplication(loanApplicationId).then(function (loanApplication) {
                if(loanApplication.recordData.findings){
                    vm.productSelected = true;
                    vm.loanApplication = loanApplication.recordData.loanApp;
                    vm.product = loanApplication.recordData.findings;
                    vm.pricing = loanApplication.recordData.findings;

                    vm.product.conditions = [];
                    vm.product.reasons = [];
                }
                else{
                    vm.productSelected = false;
                    vm.loanApplication = loanApplication.recordData;
                }

                var mainBorrowerName = _.get(vm.loanApplication, 'mainBorrower.fullName');
            
                vm.primaryBorrowerName = mainBorrowerName || 'No Primary Borrower';
                vm.applicationDataLoaded = true;

                if (vm.loanApplication.RegisteredDate) {
                    vm.eligibilityRunDate = vm.loanApplication.RegisteredDate;
                }
                else {
                    vm.eligibilityRunDate = today;
                }

                if (_.has(vm.loanApplication, 'PropertyAddress.properties.formatted_address')) {
                    vm.propertyAddress = vm.loanApplication.PropertyAddress.properties.formatted_address;
                }
                else {
                    vm.propertyAddress = vm.loanApplication.PropertyAddressStreetAddress + ' ' + vm.loanApplication.PropertyAddressCity + ' ' + vm.loanApplication.PropertyAddressState + ' ' + vm.loanApplication.PropertyAddressZIPCode;
                }
                setConditionsAndReasons();
            });
        }

        function ok() {
            $uibModalInstance.close(vm.pricing);
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        function formatPercentage(number, decimals) {
            decimals = decimals || '';
            return kendo.toString(number, 'p' + decimals);
        }

        function formatDate(dateValue, format) {
            if (!dateValue) {
                return '';
            }
            if (_.isString(dateValue)) {
                dateValue = moment(dateValue, ['MMMM, DD YYYY HH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ']).toDate();
            }
            return kendo.toString(dateValue, format);
        }

        function setConditionsAndReasons() {
            var reasons = [],
                conditions = [];

            if(!_.isEmpty(vm.product)){
                reasons = reasons.concat(vm.product.reasons);
                conditions = conditions.concat(vm.product.conditions);
            }
            if(!_.isEmpty(vm.pricing)){
                reasons = reasons.concat(vm.pricing.reason);
                conditions = conditions.concat(vm.pricing.condition);
            }

            /* LODASH Version 4 ONLY */
            //var standardReasons = _.reject(reasons, ['type', 'Rate Sheet']);
            /* LODASH Version 3 & 4 Compatibility Mode */
            var standardReasons = _.reject(reasons, function(r){return r.type === 'Rate Sheet';});
            if (standardReasons.length) {
                reasons = standardReasons;
            }

            vm.reasons = reasons;
            vm.reasonCategories = formatReasons(reasons);
            vm.conditions = formatConditions(conditions);
        
            if (!vm.conditionsShown.all) {
                var index = _.findKey(vm.conditionsShown);
            
                if (vm.conditions[index].items.length === 0) {
                    vm.conditionsShown = { all: true };
                }
            }
        }

        function formatConditions(conds) {
            var map = {
                loan: 0,
                borrower: 1,
                credit: 2,
                assets: 3,
                income: 4,
                property: 5,
                pricing: 6
            };
            var result = [
                {label: 'General', items: []},
                {label: 'Borrower', items: []},
                {label: 'Credit', items: []},
                {label: 'Assets', items: []},
                {label: 'Income', items: []},
                {label: 'Property', items: []},
                {label: 'Pricing', items: []}
            ];
            for (var i = 0; i < conds.length; i++) {
                var key = conds[i].type.toLowerCase();
                if (angular.isDefined(map[key])) { 
                    result[map[key]].items.push(conds[i]);
                }
            }
            return result;
        }

        function formatReasons(reasons) {
            var result = {};

            _.forEach(reasons, function (r) {
                if (r.type) {
                    var category = r.type.toLowerCase();
                    if (!result[category]) {
                        result[category] = { label: r.type, eligibility: r.eligibility };
                    }
                    else if (result[category].eligibility != 'ineligible') {
                        result[category].eligibility = r.eligibility;
                    }
                }    
            });

            return result;
        }

        function min(a, b) {
            return Math.min(a, b);
        }

        function finalRate(baseRate, adjustments) {
            var final = baseRate;

            _.forEach(adjustments, function (adj) {
                final += adj.value;
            });

            return final;
        }

        function totalAssets(assetMap) {
            if(assetMap){
                return assetMap.closingCosts.total + assetMap.downPayment.total + assetMap.reserves.total;
            }

            return 0;
        }

        function totalConditions(conditionsArray) {
            var total = 0;

            _.forEach(conditionsArray, function (c) {
                total += c.items.length;
            });

            return total;
        }

        function assetSum(assets, key) {
            if(assets){
                return assets.downPayment[key] + assets.prepaid[key] + assets.buyDown[key]  + assets.fundingFee[key] + assets.closingCosts[key];
            }

            return 0;
        }

        function printFindingsReport(showAll) {
            if (!vm.printingFindingsReport){
                vm.printingFindingsReport = true;

                var currentlyShown = vm.conditionsShown;
                vm.conditionsShown = { all: true };

                vm.showAllTabs = !!(showAll);

                $timeout(function () {
                    var findingsReportElement = $document.find('#findings-report'),
                        filename = kendo.format('Findings Report - {0:u}', new Date()),
                        options = {
                            paperSize: 'letter',
                            landscape: false,
                            margin: 0
                        };
                    
                    normalPrintingService.printElement(findingsReportElement, filename, options).then(function () {
                        $timeout(function () {
                            vm.printingFindingsReport = false;
                            vm.conditionsShown = currentlyShown;
                            vm.showAllTabs = false;
                        });
                    });
                });
            }
        }

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationImportModalCtrl', ["_", "$rootScope", "$scope", "$uibModalInstance", function(_, $rootScope, $scope, $uibModalInstance){
        var vm = this;

        vm.importLoanUploadOptions = {
            multiple: false,
            async: {
                saveField: 'file',
                saveUrl: '/Server/REST/v1/les/loanApplications',
                autoUpload: false
            },
            localization: {
                dropFilesHere: 'Drag Here',
                select: 'Select File',
                uploadSelectedFiles: 'Import'
            },
            upload: function (e) {
                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener("readystatechange", function () {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                            xhr.setRequestHeader('WSID', $rootScope.userData.currentWorkspace.id);
                            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest ');
                        }
                    });
                }
            },
            success: function (e) {
                if (e.response.DATA.instanceId) {
                    $uibModalInstance.close(e.response.DATA.instanceId);
                }
                if (e.response.DATA.errMsg) {
                    $uibModalInstance.dismiss(e.response.DATA);
                }
            },
            error: function (e) {
                var response = angular.fromJson(e.XMLHttpRequest.response);
                $uibModalInstance.dismiss(response.DATA);
            }
        };

        vm.ok = ok;
        vm.cancel = cancel;

        function ok(){
            $uibModalInstance.close();
        }

        function cancel(){
            $uibModalInstance.dismiss();
        }

        // Removes Kendo widgets
        $scope.$on('$destroy', function(){
            _.result(vm, 'updateLoanUpload.destroy');
        });

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationImportPageCtrl', ["_", "$scope", "$location", "$window", "lesLoanApplicationsService", function (_, $scope, $location, $window, lesLoanApplicationsService) {
        var vm = this;

        var instanceFunctions = {
            callback: linkLiabilitiesAndOpenApplication
        };

        vm.init = init;
        vm.cancel = cancel;
        vm.openIncompleteLoanApplication = _.partialRight(lesLoanApplicationsService.openIncompleteLoanApplication, instanceFunctions);

        init();
        
        function init() {
            vm.errors = [];

            lesLoanApplicationsService.openImportModal().then(function (instanceId) {
                openNewLoanApplication(instanceId);
            }, function (reason) {
                if (!reason || reason == 'backdrop click') {
                    cancel();
                }
                else if (reason.errMsg) {
                    if (_.isArray(reason.errMsg)) {
                        vm.errors = _.map(reason.errMsg, function (err) {
                            var msg = err.modelId + ':';

                            msg += '<ul>';

                            _.forEach(err.invalidArr, function (m) {
                                msg += '<li>' + m + '</li>';
                            });

                            msg += '</ul>';

                            return msg;
                        });
                    }
                    else {
                        vm.errors = [reason.errMsg];
                    }

                    vm.incompleteData = reason.incompleteData;
                    if (vm.incompleteData) {
                        vm.openIncompleteLoanApplication(vm.incompleteData);
                    }    
                }
            });
        }

        function openNewLoanApplication(instanceId) {
            $location.url('loan-applications/' + instanceId);
        }

        function linkLiabilitiesAndOpenApplication(instanceId) {
            vm.errors = [];
            vm.linkingLiabilities = true;
            lesLoanApplicationsService.updateLoan(instanceId, { action: 'linkLiabilities', data: {} }).then(function () {
                openNewLoanApplication(instanceId);
            });
        }

        function cancel() {
            $window.history.back();
        }

        $scope.$on('$destroy', function (e) {
            e.preventDefault();

            delete instanceFunctions.callback;
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationManualEntryModalCtrl', ["_", "$scope", "$uibModalInstance", "$q", "loanApplicationId", "InstancesService", "lesLoanApplicationsService", function (_, $scope, $uibModalInstance, $q, loanApplicationId, InstancesService, lesLoanApplicationsService) {
        var vm = this;

        vm.borrowers = [];
        vm.loadingScores = true;
        vm.savingCredit = false;
        vm.temp = {};
        vm.orig = {};

        vm.ficoScoreOptions = {
            decimals: 0,
            max: 850,
            min: 0,
            format: '###'
        };

        vm.ok = ok;
        vm.cancel = cancel;
        vm.dataIsValid = dataIsValid;
        vm.isUnchanged = isUnchanged;

        init();

        function init() {
            var loanRecordId = _.last(loanApplicationId.split('-'));
            var loadPromises = [
                lesLoanApplicationsService.getLoanApplicants(loanRecordId),
                lesLoanApplicationsService.getCreditData(loanRecordId)
            ];
            
            $q.all(loadPromises).then(function (results) {
                vm.borrowers = results[0];
                var borrowerScores = _.groupBy(results[1].scores, 'borrowerId');
                
                _.forEach(vm.borrowers, function (b) {
                    var id = b.Borrowers_instance_id;
                    if (!borrowerScores[id]) {
                        borrowerScores[id] = [{
                            borrowerFullName: b.Borrowers_BorrowerFullName,
                            borrowerId: id,
                            value: ''
                        }];
                    }
                });

                vm.orig = borrowerScores;
                vm.temp = angular.copy(borrowerScores);

                vm.loadingScores = false;
            });
        }
        
        function ok() {
            if (dataIsValid(vm.temp)) {
                vm.savingCredit = true;
                var savePromises = [];

                _.forEach(vm.temp, function (scores, id) {
                    var newValue = scores[0],
                        oldValue = vm.orig[id][0];
                    
                    if (!angular.equals(newValue, oldValue)) {
                        if (newValue.id) {
                            savePromises.push(
                                lesLoanApplicationsService.updateCreditScore(newValue)
                            );
                        }
                        else {
                            savePromises.push(
                                lesLoanApplicationsService.addCreditScore(newValue)
                            );
                        }
                    }
                });

                $q.all(savePromises).then(function () {
                    vm.savingCredit = false;
                    $uibModalInstance.close();
                }, function () {
                    vm.savingCredit = false;
                });
            }    
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        function dataIsValid(data) {
            return _.every(data, function (scores) {
                return !!(scores[0].value || scores[0].value === 0);
            });
        }

        function isUnchanged() {
            return angular.equals(vm.temp, vm.orig);
        }
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationRegistrationModalCtrl', ["_", "kendo", "$scope", "$uibModalInstance", "loanApplicationId", "productId", "product", "pricing", "queryParams", "lesLoanApplicationsService", function (_, kendo, $scope, $uibModalInstance, loanApplicationId, productId, product, pricing, queryParams, lesLoanApplicationsService) {
        var vm = this;

        vm.loanApplication = {};
        vm.product = product;
        vm.pricing = pricing;
        vm.registering = false;
        
        vm.ok = ok;
        vm.cancel = cancel;

        init();

        function init(){
            lesLoanApplicationsService.getLoanApplication(loanApplicationId).then(function (loanApplication) {
                if(loanApplication.recordData.findings){
                    vm.loanApplication = loanApplication.recordData.loanApp;
                }
                else{
                    vm.loanApplication = loanApplication.recordData;
                }
            });
        }

        function ok() {
            // var registrationData = _.assign({
            //     product: {
            //         id: productId,
            //         display: product.productName
            //     },
            //     conduit: product.conduit || {},
            //     docType: product.docType
            // }, pricing);
            var registrationData = {
                programId: product.programId,
                productId: productId,
                docType: product.docType,
                baseRate: pricing.baseRate,
                rate: pricing.rate,
                conduit: product.conduit || {}
            };

            vm.registering = true;
            lesLoanApplicationsService.updateLoan(loanApplicationId, {
                action: 'registered',
                data: registrationData
            }, queryParams).then(function () {
                vm.registering = false;
                $uibModalInstance.close();
            }, function () {
                vm.registering = false;
            });

        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        // Prevents navigation while modal is open
        vm.allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            vm.allowNavigation();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationReopenModalCtrl', ["_", "$scope", "$uibModalInstance", "loanApplicationId", "lesLoanApplicationsService", function(_, $scope, $uibModalInstance, loanApplicationId, lesLoanApplicationsService){
        var vm = this;

        vm.loanApplicationId = loanApplicationId;
        vm.reopening = false;
        vm.fundingData = {};

        vm.ok = ok;
        vm.cancel = cancel;

        function ok(){
            vm.reopening = true;

            lesLoanApplicationsService.updateLoan(vm.loanApplicationId,{action:'reopen',data:{}}).then(function(){
                vm.reopening = false;
                $uibModalInstance.close();
            }, function(){
                vm.reopening = false;
            });
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationUpdateModalCtrl', ["_", "$rootScope", "$scope", "$uibModalInstance", "loanApplicationId", function(_, $rootScope, $scope, $uibModalInstance, loanApplicationId){
        var vm = this;

        vm.updateLoanUploadOptions = {
            enabled: false, // TODO: Enable this once we've established the logic for updating a loan
            multiple: false,
            async: {
                saveField: 'file',
                saveUrl: '/Server/REST/v1/les/loanApplications/' + loanApplicationId,
                autoUpload: false
            },
            localization: {
                dropFilesHere: 'Drag Here',
                select: 'Select File',
                uploadSelectedFiles: 'Update'
            },
            upload: function (e) {
                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener("readystatechange", function () {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                            xhr.setRequestHeader('WSID',$rootScope.userData.currentWorkspace.id);
                            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest ');
                        }
                    });
                }
            },
            success: function(){
                $uibModalInstance.close();
            }
        };

        vm.ok = ok;
        vm.cancel = cancel;

        function ok(){
            $uibModalInstance.close();
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        // Removes Kendo widgets
        $scope.$on('$destroy', function(){
            _.result(vm, 'updateLoanUpload.destroy');
        });

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESLoanApplicationWithdrawalModalCtrl', ["$scope", "$uibModalInstance", "loanApplicationId", "lesLoanApplicationsService", function($scope, $uibModalInstance, loanApplicationId, lesLoanApplicationsService){
        var vm = this;

        vm.loanApplicationId = loanApplicationId;
        vm.withdrawing = false;
        vm.withdrawalData = {
            withdrawnBy: '',
            reasons: {},
            notes: ''
        };

        vm.ok = ok;
        vm.cancel = cancel;

        function ok() {
            if (vm.withdrawalData.withdrawnBy) {
                vm.withdrawing = true;
                lesLoanApplicationsService.updateLoan(vm.loanApplicationId, { action: 'withdrawn', data: vm.withdrawalData }).then(function () {
                    vm.withdrawing = false;
                    $uibModalInstance.close();
                }, function () {
                    vm.withdrawing = false;
                });
            }
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .config(["$routeProvider", function($routeProvider){
        $routeProvider.when('/loan-applications/create', {
            templateUrl: 'les/loan-applications/templates/loan-application-import-page.tpl.html',
            controller: 'LESLoanApplicationImportPageCtrl',
            controllerAs: 'vm',
            title: 'Import Loan Application',
            resolve: {
                _wait: 'WaitForUserData',
                loanApplicationId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });

        $routeProvider.when('/loan-applications/:id', {
            templateUrl: 'les/loan-applications/templates/loan-application.tpl.html',
            controller: 'LESLoanApplicationCtrl',
            controllerAs: 'vm',
            title: 'Loan Application',
            resolve: {
                _wait: 'WaitForUserData',
                loanApplicationId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });

        $routeProvider.when('/loan-applications/:id/eligibility', {
            templateUrl: 'les/loan-applications/templates/loan-application-eligibility.tpl.html',
            controller: 'LESLoanApplicationEligibilityCtrl',
            controllerAs: 'vm',
            title: 'Eligibility',
            resolve: {
                _wait: 'WaitForUserData',
                loanApplicationId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
    }])
;
angular.module('cerberus.les')
    .factory('lesLoanApplicationsService', ["_", "kendo", "moment", "$http", "$location", "$q", "$rootScope", "$timeout", "$uibModal", "$window", "apiPath", "ConfirmModalService", "InstancesService", "InstancesWindowService", function (_, kendo, moment, $http, $location, $q, $rootScope, $timeout, $uibModal, $window, apiPath,
                                                    ConfirmModalService, InstancesService, InstancesWindowService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        
        return {
            actionAvailabilityByLoanStatus: actionAvailabilityByLoanStatus,
            getLoanApplication: getLoanApplication,
            validateLoanApplication: validateLoanApplication,
            exportLoanApplication: exportLoanApplication,
            getLoanApplicants: getLoanApplicants,
            getLoanPrimaryBorrower: getLoanPrimaryBorrower,
            getLoanAppStatuses: getLoanAppStatuses,
            getCreditScores: getCreditScores,
            getBorrowerIncomeSources: getBorrowerIncomeSources,
            getProposedExpenses: getProposedExpenses,
            getLoanPrograms: getLoanPrograms,
            getLoanProgramEligibility: getLoanProgramEligibility,
            openImportModal: openImportModal,
            openUpdateModal: openUpdateModal,
            openApplicationRecord: openApplicationRecord,
            openExportModal: openExportModal,
            openFindProductsModal: openFindProductsModal,
            openEligibilityPage: openEligibilityPage,
            openCreditPullModal: openCreditPullModal,
            openCreditManualEntryModal: openCreditManualEntryModal,
            openWithdrawalModal: openWithdrawalModal,
            openUnregistrationModal: openUnregistrationModal,
            openCloseAndFundModal: openCloseAndFundModal,
            openReopenModal: openReopenModal,
            openFindingsReportModal: openFindingsReportModal,
            openRegistrationModal: openRegistrationModal,
            updateBorrowerCreditPullPermission: updateBorrowerCreditPullPermission,
            getCreditData: getCreditData,
            pullCredit: pullCredit,
            addCreditScore: addCreditScore,
            updateCreditScore: updateCreditScore,
            updateLoan: updateLoan,
            saveProductForLater: saveProductForLater,
            removeSavedProduct: removeSavedProduct,
            loanAuditLogOptions: loanAuditLogOptions,
            loanFeeLogOptions: loanFeeLogOptions,
            loanSavedForLaterOptions: loanSavedForLaterOptions,
            loanDocumentVaultOptions: loanDocumentVaultOptions,
            attachmentGridOptions: attachmentGridOptions,
            productEligibilityTableOptions: productEligibilityTableOptions,
            productRateDetailTableOptions: productRateDetailTableOptions,
            assetsTableOptions: assetsTableOptions,
            assetDetailsTableOptions: assetDetailsTableOptions,
            eligibilityFilterLookupOptions: eligibilityFilterLookupOptions,
            getFilterOptions: getFilterOptions,
            openIncompleteLoanApplication: openIncompleteLoanApplication,
            addDocumentToVault: addDocumentToVault,
            buildProductsQueryParams: buildProductsQueryParams,
            parseProductsQueryParams: parseProductsQueryParams
        };

        function actionAvailabilityByLoanStatus() {
            return {
                1735: { // New Application
                    edit: true,
                    export: true,
                    pullCredit: true,
                    withdraw: true,
                    findProducts: true
                },
                // 1731: {
                //     edit: true,
                //     export: true,
                //     repullCredit: true,
                //     withdraw: true,
                //     findProducts: true
                // },
                1732: { // Products Found
                    edit: true,
                    export: true,
                    pullCredit: true,
                    withdraw: true,
                    findProducts: true
                },
                1733: { // Product Selected
                    edit: true,
                    readonly: true,
                    export: true,
                    // pullCredit: true,
                    unregister: true,
                    closeAndFund: true
                },
                1734: { // Closed & Insured
                    edit: true,
                    readonly: true,
                    export: true,
                    reopen: true
                }
            };
        }

        function getLoanApplication(id) {
            var deferred = $q.defer();

            $http.get(apiPath + 'les/loanApp/' + id)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function validateLoanApplication(id) {
            var deferred = $q.defer();

            $http.get(apiPath + 'les/loanApp/' + id + '/validate')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function exportLoanApplication(id, format) {
            var deferred = $q.defer(),
                options = {
                    params: {
                        format: format
                    }
                };

            $http.get(apiPath + 'les/loanApp/' + id, options)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getLoanApplicants(id) {
            var deferred = $q.defer(),
                url = apiPath + 'views/46D9163D5583CF87E28716D7CED85CC6-120/odata.svc';

            $http.get(url, {
                params: {
                    $filter: 'Borrowers_LoanApplicationID eq ' + id + 'f'
                }
            }).success(function (value) {
                resolveOData(deferred, value);
            });

            return deferred.promise;
        }

        function getLoanPrimaryBorrower(id) {
            var deferred = $q.defer(),
                url = apiPath + 'views/46D9163D5583CF87E28716D7CED85CC6-120/odata.svc';

            $http.get(url, {
                params: {
                    $filter: 'Borrowers_LoanApplicationID eq ' + id + 'f and Borrowers_PrintPositionType eq 424f'
                }
            }).success(function (value) {
                resolveOData(deferred, value);
            });

            return deferred.promise;
        }

        function getLoanAppStatuses() {
            var deferred = $q.defer();

            var url = apiPath + 'views/F507A886590BBCF8929EF81143812791-175/odata.svc';
            $http.get(url, {
                params: {
                    $lookupDisplay: 'LoanAppStatus_Name',
                    $orderBy: 'LoanAppStatus_SortOrder asc'
                }
            }).success(function (value) {
                resolveOData(deferred, value);
            });

            return deferred.promise;
        }

        function getCreditScores(loanId, borrowerId) {
            var deferred = $q.defer(),
                url = apiPath + 'views/1E1B6FC299BA6A278D94C32B90A97E07-184/odata.svc',
                filter = 'Borrowers_LoanApplicationID eq ' + loanId + 'f';
            
            if (borrowerId) {
                filter += ' and BorrowerCreditScores_Borrower eq \'' + borrowerId + '\'';
            }

            $http.get(url, {
                params: {
                    $filter: filter
                }
            }).success(function (value) {
                resolveOData(deferred, value);
            });

            return deferred.promise;
        }

        function getBorrowerIncomeSources(borrowerId) {
            var deferred = $q.defer(),
                url = apiPath + 'views/9EB426A81E62F9487C39E80A76CF3371-124/odata.svc',
                filter = 'BorrowerCurrentIncome_BorrowerID eq \'' + borrowerId + '\'';
            
            $http.get(url, {
                params: {
                    $filter: filter
                }
            }).success(function (value) {
                resolveOData(deferred, value);
            });

            return deferred.promise;
        }

        function getProposedExpenses(loanId) {
            var deferred = $q.defer(),
                url = apiPath + 'views/9D7D5B555D1059859AA0F500E5598893-162/odata.svc',
                filter = 'OtherProposedHousingExpenses_LoanApplicationID eq \'' + loanId + '\'';
            
            $http.get(url, {
                params: {
                    $filter: filter
                }
            }).success(function (value) {
                resolveOData(deferred, value);
            });

            return deferred.promise;
        }

        function getLoanPrograms(loanId) {
            var deferred = $q.defer();

            $http.get(apiPath + 'les/loanApp/' + loanId + '/programs')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        function getLoanProgramEligibility(loanId, programId, conduit, queryParams) {
            var deferred = $q.defer();
            var apiUrl = apiPath + 'les/loanApp/' + loanId + '/eligibility';
            $http.post(apiUrl, { program_id: programId, conduit: conduit || {} }, { params: queryParams })
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason.DATA);
                });
            return deferred.promise;
        }

        function openImportModal() {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-import-modal.tpl.html',
                controller: 'LESLoanApplicationImportModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {}
            });

            return modalInstance.result;
        }

        function openUpdateModal(id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-update.tpl.html',
                controller: 'LESLoanApplicationUpdateModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id)
                }
            });

            return modalInstance.result;
        }

        function openApplicationRecord(loanRecordId, readonly, navFunctions){
            InstancesWindowService.openWindow({
                action: readonly ? 'readonly' : 'read',
                instanceId: loanRecordId,
                navFunctions: navFunctions
            });
        }

        function openExportModal(id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-export.tpl.html',
                controller: 'LESLoanApplicationExportModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id)
                }
            });

            return modalInstance.result;
        }

        function openFindProductsModal(defaultQueryParams, validation) {
            defaultQueryParams = defaultQueryParams || {};
            validation = validation || { isValid: true, messages: [] };
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-find-products.tpl.html',
                controller: 'LESLoanApplicationFindProductsModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    queryParams: _.constant(defaultQueryParams),
                    validation: _.constant(validation)
                }
            });

            return modalInstance.result;
        }

        function openEligibilityPage(id, queryParams) {
            if (id) {
                $location.url('loan-applications/' + id + '/eligibility').search(queryParams);
            }
        }

        function openCreditPullModal(id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-credit-pull.tpl.html',
                controller: 'LESLoanApplicationCreditPullModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id)
                }
            });

            return modalInstance.result;
        }

        function openCreditManualEntryModal(id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-manual-entry-modal.tpl.html',
                controller: 'LESLoanApplicationManualEntryModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id)
                }
            });

            return modalInstance.result;
        }

        function openWithdrawalModal(id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-withdrawal.tpl.html',
                controller: 'LESLoanApplicationWithdrawalModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id)
                }
            });

            return modalInstance.result;
        }

        function openUnregistrationModal(id) {
            var unregistering = false;

            return ConfirmModalService.showModal(null, {
                closeButtonText: 'Cancel',
                actionButtonText: 'Unselect Product',
                headerText: 'Unselect Product',
                bodyText: 'Are you sure you want to unselect the Loan product for this application?',
                actionButtonPosition: 'footer',
                check: function () {
                    return !unregistering;
                },
                confirm: function () {
                    unregistering = true;

                    var promise = updateLoan(id, { action: 'unregister' });
                    promise.finally(function(){
                        unregistering = false;
                    });

                    return promise;
                }
            });
        }

        function openCloseAndFundModal(id, loanAmount, noteRate) {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-close-and-fund.tpl.html',
                controller: 'LESLoanApplicationCloseAndFundModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id),
                    loanAmount: _.constant(loanAmount),
                    noteRate: _.constant(noteRate)
                }
            });

            return modalInstance.result;
        }

        function openReopenModal(id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-reopen-modal.tpl.html',
                controller: 'LESLoanApplicationReopenModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id)
                }
            });

            return modalInstance.result;
        }

        function openFindingsReportModal(id, productId, product, pricingIndex) {
            var modalInstance = $uibModal.open({
                size: 'lg',
                templateUrl: 'les/loan-applications/templates/loan-application-findings.tpl.html',
                controller: 'LESLoanApplicationFindingsCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id),
                    productId: _.constant(productId),
                    product: _.constant(product),
                    pricingIndex: _.constant(pricingIndex)
                }
            });

            return modalInstance.result;
        }

        function openRegistrationModal(id, productId, product, pricing, queryParams) {
            var modalInstance = $uibModal.open({
                templateUrl: 'les/loan-applications/templates/loan-application-registration-modal.tpl.html',
                controller: 'LESLoanApplicationRegistrationModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id),
                    productId: _.constant(productId),
                    product: _.constant(product),
                    pricing: _.constant(pricing),
                    queryParams: _.constant(queryParams)
                }
            });

            return modalInstance.result;
        }

        function updateBorrowerCreditPullPermission(borrowerId, creditPullPermission) {
            var permissionValue = creditPullPermission ? { display: 'Yes', id: 'opt0' } : { display: 'No', id: 'opt1' };

            return InstancesService.update(borrowerId, {
                currentStateId: 1,
                recordData: {
                    BorrowerCreditPullPermission: permissionValue
                }
            });
        }

        function getCreditData(id) {
            var deferred = $q.defer();

            $http.get(apiPath + 'les/' + id + '/credit')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            
            return deferred.promise;
        }

        function pullCredit(id, creditPullData) {
            var deferred = $q.defer(),
                url = apiPath + 'les/' + id + '/credit';

            $http.post(url, {
                credit_provider_instance_id: creditPullData.creditProvider.id,
                override_liabilities: creditPullData.overrideLiabilities,
                credit_ref_number: creditPullData.referenceNumber
            })
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function addCreditScore(scoreData) {
            return InstancesService.createInstance({
                widgetId: 'B40EFAE20C0A98E72CA89C3D63C6E9A8-173',
                current: '',
                recordData: {
                    Borrower: {
                        display: scoreData.borrowerFullName,
                        id: scoreData.borrowerId
                    },
                    Value: scoreData.value,
                    IsManualEntry: true,
                    CreditRepositorySourceType: 'Manual Entry',
                    CreditDate: kendo.toString(new Date(), 'yyyy-MM-ddTHH:mm:ss.fffZ')
                }
            });
        }

        function updateCreditScore(scoreData) {
            return InstancesService.update(scoreData.id, {
                currentStateId: 1,
                recordData: {
                    Value: scoreData.value
                }
            });
        }

        function updateLoan(id, data, queryParams) {
            queryParams = queryParams || {};

            var deferred = $q.defer(),
                url = apiPath + 'les/loanApp/' + id + '/action';

            $http.put(url, data, { params: queryParams })
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        // function exportLoan(id, format) {
            
        // }

        function saveProductForLater(id, data) {
            var deferred = $q.defer(),
                url = apiPath + 'les/loanApp/' + id + '/save/for/later';

            $http.post(url, data)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function removeSavedProduct(loanId, savedProductId) {
            var deferred = $q.defer(),
                url = apiPath + 'les/loanApp/' + loanId + '/save/for/later';

            $http.put(url, {saveForLaterId: savedProductId})
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function loanAuditLogOptions(loanId) {
            return {
                columns: [
                    { title: 'Date', field: 'LoanAppLedger_StatusDateTime', format: '{0:g}' },
                    { title: 'Subject', field: 'LoanAppLedger_Subject' },
                    { title: 'Description', field: 'LoanAppLedger_Description' },
                    { title: 'By', field: 'LoanAppLedger_StatusBy' }
                ],
                resizable: true,
                filterable: true,
                sortable: true,
                pageable: true,
                dataSource: {
                    type: 'odata',
                    pageSize: 10,
                    serverFiltering: true,
                    serverSorting: true,
                    sort: {
                        field: 'LoanAppLedger_StatusDateTime',
                        dir: 'desc'
                    },
                    transport: {
                        read: {
                            url: apiPath + 'views/291C8BED3D8503A658F3C1E4ABC99FD1-176/odata.svc',
                            dataType: 'json',
                            data: {
                                $filter: 'LoanAppLedger_LoanApp eq ' + loanId + 'f'
                            },
                            beforeSend: function (xhr) {
                                xhr.setRequestHeader('Authentication', 'Bearer ' + $rootScope.authToken);
                                xhr.setRequestHeader('WSID', $rootScope.userData.currentWorkspace.id);
                            }
                        }
                    },
                    schema: {
                        model: {
                            fields: {
                                LoanAppLedger_StatusDateTime: { type: 'date', parse: parseDate },
                                LoanAppLedger_Subject: { type: 'string' },
                                LoanAppLedger_Description: { type: 'string' },
                                LoanAppLedger_StatusBy: { type: 'string' }
                            }
                        }
                    }
                }
            };
        }

        function loanFeeLogOptions(loanId) {
            return {
                columns: [
                    { title: 'Date Incurred', field: 'LoanandFeeLedger_DateIncurred', format: '{0:g}' },
                    { title: 'Fee Type', field: 'FeeSchedule_FeeType_display' },
                    { title: 'Amount', field: 'FeeSchedule_Amount', format: '{0:c2}' }
                ],
                resizable: true,
                filterable: true,
                sortable: true,
                dataSource: {
                    type: 'odata',
                    pageSize: 20,
                    serverFiltering: true,
                    serverSorting: true,
                    sort: {
                        field: 'LoanandFeeLedger_DateIncurred',
                        dir: 'desc'
                    },
                    transport: {
                        read: {
                            url: apiPath + 'views/291C8BED3D8503A658F3C1E4ABC99FD1-150/odata.svc',
                            dataType: 'json',
                            data: {
                                $filter: 'LoanandFeeLedger_LoanInstanceID eq ' + loanId + 'f'
                            },
                            beforeSend: function (xhr) {
                                xhr.setRequestHeader('Authentication', 'Bearer ' + $rootScope.authToken);
                                xhr.setRequestHeader('WSID', $rootScope.userData.currentWorkspace.id);
                            }
                        }
                    },
                    schema: {
                        model: {
                            fields: {
                                LoanandFeeLedger_DateIncurred: { type: 'date', parse: parseDate },
                                FeeSchedule_FeeType_display: { type: 'string' },
                                FeeSchedule_Amount: { type: 'number' }
                            }
                        }
                    }
                }
            };
        }

        function loanSavedForLaterOptions(id) {
            return {
                resizable: true,
                filterable: true,
                sortable: true,
                columns: [ // TODO: Add button to remove from list
                    { title: 'Product', field: 'SavedForLaterProducts_Product_display' },
                    { title: 'Conduit', field: 'SavedForLaterProducts_Conduit_display' },
                    { title: 'Date Saved', field: 'SavedForLaterProducts_DateSaved', format: '{0:g}' },
                    {
                        title: ' ',
                        width: 91,
                        command: [{
                            name: 'removeFromSavedForLater', text: 'Remove', className: 'btn btn-sm btn-danger',
                            click: function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                e.stopImmediatePropagation();
                                
                                var grid = this;
                
                                $timeout(function () {
                                    var row = angular.element(e.target).closest("tr"),
                                        dataItem = grid.dataItem(row);
                
                                    removeSavedProduct(id, dataItem.id).then(function () {
                                        grid.dataSource.read();
                                    });
                                });
                            }
                        }]
                    }
                ],
                dataSource: {
                    type: 'odata',
                    serverFiltering: true,
                    serverSorting: true,
                    transport: {
                        read: {
                            url: apiPath + 'views/3437A61E95CA10A66DA643259BCA80C5-183/odata.svc',
                            dataType: 'json',
                            data: {
                                $filter: 'SavedForLaterProducts_LoanApplication eq ' + id + 'f'
                            },
                            beforeSend: function (xhr) {
                                xhr.setRequestHeader('Authentication', 'Bearer ' + $rootScope.authToken);
                                xhr.setRequestHeader('WSID', $rootScope.userData.currentWorkspace.id);
                            }
                        }
                    },
                    schema: {
                        model: {
                            id: 'SavedForLaterProducts_instance_id',
                            fields: {
                                SavedForLaterProducts_DateSaved: { type: 'date', parse: parseDate },
                                SavedForLaterProducts_Conduit_display: { type: 'string' },
                                SavedForLaterProducts_Product_display: { type: 'string' }
                            }
                        }
                    }
                }
            };
        }

        function loanDocumentVaultOptions(id) {
            return {
                columnMenu: false,
                columns: [
                    { title: 'Name', field: 'DocumentVault_Name' },
                    { title: 'Type', field: 'DocumentVault_Type_display' },
                    { title: 'Date Created', field: 'DocumentVault_sys_created_date', format: '{0:g}' },
                    { title: 'Last Modified By', field: 'DocumentVault_sys_last_modified_by', hidden: true },
                    { title: 'Last Modified Date', field: 'DocumentVault_sys_last_modified_date', hidden: true },
                    { title: 'Attachments', field: 'attachment_count', filterable: false, width: 50, headerTemplate: '<i class="fa fa-lg fa-paperclip" title="Attachments"></i>' }
                ],
                detailTemplate: '<div kendo-grid="attachmentGrid" k-options="vm.attachmentGridOptions(dataItem)"></div>',
                editable: false,
                filterable: false,
                groupable: false,
                mobile: false,
                navigatable: true,
                noRecords: true,
                pageable: true,
                reorderable: true,
                resizable: true,
                selectable: 'row',
                sortable: true,
                toolbar: false,
                dataSource: {
                    pageSize: 10,
                    schema: {
                        model: {
                            fields: {
                                DocumentVault_Name: { type: 'string' },
                                DocumentVault_Type_display: { type: 'string' },
                                DocumentVault_sys_created_date: { type: 'date', parse: parseDate },
                                DocumentVault_sys_last_modified_by: { type: 'date', parse: parseDate },
                                DocumentVault_sys_last_modified_date: { type: 'date', parse: parseDate }
                            }
                        }
                    },
                    serverFiltering: true,
                    serverGrouping: false,
                    serverPaging: true,
                    serverSorting: true,
                    transport: {
                        read: {
                            url: apiPath + 'page/objects/22DACED3D22F2B95DABF06125C9DD278-151/odata.svc',
                            dataType: 'json',
                            data: {
                                $filter: 'DocumentVault_LoanApplicationID eq ' + id + 'f and DocumentVault_Type_display ne \'Credit Report\''
                            },
                            beforeSend: function(xhr) {
                                xhr.setRequestHeader('Authentication', 'Bearer ' + $rootScope.authToken);
                                xhr.setRequestHeader('WSID', $rootScope.userData.currentWorkspace.id);
                            }
                        }
                    },
                    type: 'odata'
                },
                change: function(e) {
                    var selected = e.sender.select();
                    if (!_.isEmpty(selected)) {
                        var dataItem = e.sender.dataItem(selected[0]);

                        InstancesWindowService.openWindow({
                            action: 'read',
                            instanceId: dataItem.id
                        });
                    }
                }
            };
        }

        function attachmentGridOptions(dataItem){
                return {
                    columns: [
                        {
                            field: 'name',
                            title: 'Name'
                        },
                        {
                            field: 'uploadedBy',
                            title: 'Uploaded By'
                        },
                        {
                            field: 'uploadDate',
                            title: 'Upload Date',
                            template: function(attachment){
                                return parseDate(attachment.uploadDate);
                            }
                        }
                    ],
                    dataSource: {
                        data: dataItem.__nimAttachments,
                        pageSize: 10
                    },
                    height: 377,
                    columnMenu: false,
                    editable: false,
                    filterable: true,
                    mobile: false,
                    navigatable: true,
                    pageable: true,
                    reorderable: false,
                    resizable: true,
                    scrollable: true,
                    selectable: true,
                    sortable: true,
                    change: function(e){
                        var selected = e.sender.select();
                        if(selected.length > 0){
                            var attachment = e.sender.dataItem(selected[0]);

                            InstancesService.getDownloadKey(attachment.id).then(function (d) {
                                InstancesService.getBlob(d).then(function (pdfBlob) {
                                    $window.saveAs(pdfBlob, attachment.name);
                                });
                            });
                        }
                    }
                };
            }

        function productEligibilityTableOptions(eligibilityType, lenderData) {
            var products = [],
                filters = [];
            
            if (eligibilityType) {
                filters.push({
                    field: 'eligibility',
                    operator: 'eq',
                    value: eligibilityType
                });
            }

            _.forEach(lenderData, function (lender) {
                _.forEach(lender.programs, function (lenderProgram) {
                    _.forEach(lenderProgram.programs, function (prog) {
                        _.forEach(prog.products, function (product) {
                            var productProgramData = {
                                lenderName: lender.name,
                                lenderId: lender.id,
                                conduit: lender.conduit || {},
                                programName: lenderProgram.progName,
                                programCode: prog.programCode,
                                creditScore: prog.creditScore,
                                programId: lenderProgram.id,
                                investorName: prog.investorName,
                                docType: prog.docType,
                                grade: prog.grade,
                                conditions: prog.conditions,
                                reasons: prog.reasons,
                                adjustments: prog.adjustments
                            };

                            products.push(
                                _.assign({ rate: lowestEligibleRate(product) }, product, productProgramData)
                            );
                        });
                    });
                });
            });

            var openRows = {},
                clickHandlerSet = false;

            return {
                selectable: false,
                filterable: {
                    extra: false,
                    operators: {
                        string: {
                            contains: 'Contains',
                            startswith: 'Starts with'
                        },
                        number: {
                            lte: 'Is less than or equal to'
                        }
                    }
                },
                resizable: false,
                sortable: true,
                detailTemplate: '<table kendo-grid k-options="::vm.productRateDetailTableOptions(vm.loanApplicationId, \'#: data.id #\', vm.eligibilityType, #: kendo.stringify(data) #)"></table>',
                columns: [
                    {
                        title: 'Eligibility', width: 100, filterable: false,
                        template: function (dataItem) {
                            var labelClass = '',
                                text = '';
                            
                            switch (dataItem.eligibility){
                                case 'eligible':
                                    labelClass = 'label-success';
                                    text = 'Eligible';
                                    break;

                                case 'nearmiss':
                                    labelClass = 'label-warning';
                                    text = 'Near Miss';
                                    break;

                                case 'ineligible':
                                    labelClass = 'label-danger';
                                    text = 'Refer/Ineligible';
                                    break;
                                    
                                default:
                                    return '';
                            }

                            return '<span class="label ' + labelClass + '">' + text + '</span>';
                        }
                    },
                    { title: 'Investor', field: 'investorName', width: 120 },
                    { title: 'Program', field: 'programName', width: 120 },
                    { title: 'Product', field: 'productName', width: 160 },
                    { title: 'Doc Type', field: 'docType', width: 120, filterable: { multi: true, checkAll: false } },
                    { title: 'Rate', field: 'rate', format: '{0:n2} %', width: 80 },
                    {
                        title: 'Tags', filterable: false,
                        template: function (dataItem) {
                            var labels = [];

                            if (dataItem.prepaymentPenaltyTermMonths !== '') {
                                labels.push('<span class="label label-info">PPP ' + dataItem.prepaymentPenaltyTermMonths + 'M</span> ');
                            }
                            
                            if (dataItem.interestOnlyTerm !== '') {
                                labels.push('<span class="label label-info">IO ' + (dataItem.interestOnlyTerm / 12) + 'YR</span> ');
                            }

                            return labels.join(' ');
                        }
                    }
                ],
                dataSource: {
                    serverFiltering: false,
                    data: products,
                    sort: [
                        {
                            field: 'rate',
                            dir: 'asc'
                        }                        
                    ],
                    filter: {
                        logic: 'and',
                        filters: filters
                    },
                    schema: {
                        model: {
                            fields: {
                                conduit: { default: {} },
                                rate: { type: 'number' }
                            }
                        }
                    }
                },
                dataBound: function (e) {
                    var grid = e.sender;

                    if (!clickHandlerSet) {
                        clickHandlerSet = true;

                        grid.tbody.on('click', '.k-master-row', function (event) {
                            var uid = angular.element(event.currentTarget).data('uid');

                            if (!angular.element(event.target).is('a.k-icon')) {
                                if (openRows[uid]) {
                                    grid.collapseRow(event.currentTarget);
                                    openRows[uid] = false;
                                }
                                else {
                                    grid.expandRow(event.currentTarget);
                                    openRows[uid] = true;
                                }
                            }
                        });
                    }    

                    openRows = {};
                },
                detailExpand: function (e) {
                    var uid = e.masterRow.data('uid');
                    openRows[uid] = true;
                },
                detailCollapse: function (e) {
                    var uid = e.masterRow.data('uid');
                    openRows[uid] = false;
                }
            };
        }

        function productRateDetailTableOptions(loanAppId, productId, eligibilityType, productData) {
            // var filter = {
            //     logic: 'and',
            //     filters: []
            // };

            // if (eligibilityType) {
            //     filter.filters.push({
            //         field: 'eligibility',
            //         operator: 'eq',
            //         value: eligibilityType
            //     });
            // }

            var openFindings = function (index) {
                // Opens Findings Report
                openFindingsReportModal(loanAppId, productId, productData, index).then(function (data) {
                    // Opens modal to select product
                    openRegistrationModal(loanAppId, productId, productData, data, $location.search()).then(function () {
                        $timeout(function () {
                            $location.url('loan-applications/' + loanAppId);
                        });
                    }, function () {
                        // On cancel, reopen Findings Report
                        openFindings(productData.pricing.indexOf(data));
                    });
                });
            };

            return {
                filterable: false,
                resizable: false,
                sortable: true,
                columns: [
                    {
                        // title: 'Eligibility', width: 80,
                        title: ' ', width: 31, attributes: { 'class': 'text-center' },
                        template: function (dataItem) {
                            // var labelClass = '',
                            //     text = '';
                            
                            var iconClass = '';
                            
                            switch (dataItem.eligibility){
                                case 'eligible':
                                    // labelClass = 'label-success';
                                    // text = 'Eligible';
                                    iconClass = 'text-success';
                                    break;

                                case 'nearmiss':
                                    // labelClass = 'label-warning';
                                    // text = 'Near Miss';
                                    iconClass = 'text-warning';
                                    break;

                                case 'ineligible':
                                    // labelClass = 'label-danger';
                                    // text = 'Refer/Ineligible';
                                    iconClass = 'text-danger';
                                    break;
                                    
                                default:
                                    return '';
                            }

                            // return '<span class="label ' + labelClass + '">' + text + '</span>';
                            return '<i class="fa fa-circle ' + iconClass + '"></i>';
                        }
                    },
                    { title: 'Rate', field: 'noteRate', format: '{0:p3}', width: 80 },
                    // { title: 'Price', field: 'lenderPrice', format: '{0:n2}', width: 80 },
                    // { title: 'Premium', field: 'premium', format: '{0:n2}', width: 100 },
                    // { title: 'Discount Points / $', template: '#: discount # / #: kendo.toString(buyUpDown, "c0") #' },
                    { title: 'Discount Points', template: _.partial(discountTemplate, 'discount', '{0}'), width: 110 },
                    { title: 'Discount Cost', template: _.partial(discountTemplate, 'buyUpDown', '{0:c0}') },
                    { title: 'P & I', field: 'payment', format: '{0:c0}', width: 80 },
                    { title: 'PITIA', field: 'pitia', format: '{0:c0}', width: 80 },
                    { title: 'DTI', field: 'dti', format: '{0:p2}', width: 80 },
                    {
                        title: ' ',
                        width: 197,
                        command: [
                            {
                                name: 'detailsButton', text: 'Findings', className: 'btn btn-sm k-primary',
                                click: function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();

                                    var grid = this,
                                        row = angular.element(e.target).closest("tr"),
                                        pricingData = grid.dataItem(row);
                
                                    if (productId) {
                                        $timeout(function () {
                                            var index = grid.dataSource.indexOf(pricingData);
                                            openFindings(index);
                                        });
                                    }    
                                }
                            },
                            {
                                name: 'registerButton', text: 'Select Product', className: 'btn btn-sm k-primary',
                                click: function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();

                                    var grid = this,
                                        row = angular.element(e.target).closest("tr"),
                                        pricingData = grid.dataItem(row);
                                        
                                    if (productId) {
                                        openRegistrationModal(loanAppId, productId, productData, pricingData, $location.search()).then(function () {
                                            $timeout(function () {
                                                $location.url('loan-applications/' + loanAppId);
                                            });
                                        });
                                    }        
                                }
                            }//,
                            // {
                            //     name: 'saveForLaterButton', text: 'Save', className: 'btn btn-sm k-default',
                            //     click: function (e) {
                            //         e.preventDefault();
                            //         e.stopPropagation();
                            //         e.stopImmediatePropagation();
                
                            //         if (productId) {
                            //             $timeout(function () {
                            //                 saveProductForLater(loanAppId, {
                            //                     product: {
                            //                         id: productId,
                            //                         display: productData.productName
                            //                     },
                            //                     conduit: productData.conduit || {}
                            //                 });
                            //             });
                            //         }    
                            //     }
                            // }
                        ]
                    }
                ],
                dataSource: {
                    data: productData.pricing,
                    // filter: filter,
                    sort: [{
                        field: 'noteRate',
                        dir: 'asc'
                    }]
                }
            };
        }

        function lowestEligibleRate(dataItem) {
            var eligibilities = _.groupBy(dataItem.pricing, 'eligibility');

            var pricing = [];
            if (eligibilities['eligible']) {
                pricing = eligibilities['eligible'];
            }
            else if (eligibilities['nearmiss']) {
                pricing = eligibilities['nearmiss'];
            }
            else if (eligibilities['ineligible']) {
                pricing = eligibilities['ineligible'];
            }

            var minimum = _.min(pricing, 'noteRate');
            if (minimum) {
                return minimum.noteRate * 100;
            }

            return '';
        }

        function assetsTableOptions(assets) {
            var data = [],
                assetMap = [
                    { key: 'downPayment', name: 'Down Payment' },
                    { key: 'prepaid', name: 'Prepaid' },
                    { key: 'buyDown', name: 'Buydown' },
                    { key: 'closingCosts', name: 'Closing' }/*,
                    { key: 'reserves', name: 'Reserves' }*/
                ];

            _.forEach(assetMap, function(mapItem) {
                var asset = assets[mapItem.key];
                if (asset) {
                    data.push({
                        name: mapItem.name,
                        required: asset.required,
                        total: asset.total,
                        need: asset.need,
                        assets: asset.assets
                    });
                }    
            });
            // var rowTemplate = '#if(assets.length > 0){# <td class="k-hierarchy-cell"><a class="k-icon k-plus" href="#" tabindex="-1"></a></td> #} else {# <td></td> #}#' +
            //     '<td>#: name #</td>' +
            //     '<td>#: kendo.toString(required, \'c2\') #</td>' +
            //     '<td>#: kendo.toString(total, \'c2\') #</td>' +
            //     '<td>#: kendo.toString(need, \'c2\') #</td></tr>';
            // var detailTemplate = '#if(assets.length > 0){# <tr class="k-detail-row"></tr> #}#';

            return {
                filterable: false,
                groupable: false,
                resizable: true,
                sortable: false,
                // rowTemplate: '<tr class="k-master-row">' + rowTemplate,
                // altRowTemplate: '<tr class="k-alt k-master-row">' + rowTemplate,
                detailTemplate: '<table kendo-grid k-options="::vm.assetDetailsTableOptions(#: kendo.stringify(data) #)"></table>',
                columns: [
                    { title: ' ', field: 'name' },
                    { title: 'Required', field: 'required', format: '{0:c2}', footerTemplate: '#: kendo.toString(data.required.sum, \'c2\') #' },
                    { title: 'Available', field: 'total', format: '{0:c2}', footerTemplate: '#: kendo.toString(data.total.sum, \'c2\') #' },
                    { title: 'Need', field: 'need', format: '{0:c2}', footerTemplate: '#: kendo.toString(data.need.sum, \'c2\') #' }
                ],
                dataSource: {
                    data: data,
                    aggregate: [
                        { field: 'required', aggregate: 'sum' },
                        { field: 'total', aggregate: 'sum' },
                        { field: 'need', aggregate: 'sum' }
                    ]
                }
            };
        }

        function assetDetailsTableOptions(asset) {
            return {
                filterable: false,
                groupable: false,
                resizable: true,
                sortable: false,
                columns: [
                    { title: 'Type', field: 'name' },
                    { title: 'Available', field: 'total', format: '{0:c2}' }
                ],
                dataSource: {
                    data: asset.assets
                }
            };
         }

        function eligibilityFilterLookupOptions(data) {
            return {
                optionLabel: 'Choose...',
                valuePrimitive: true,
                dataTextField: 'display',
                dataValueField: 'value',
                dataSource: {
                    data: data || []
                }
            };
        }

        function getFilterOptions(lenders) {
            var docTypes = [],
                amortizationTypes = [];

            _.forEach(lenders, function (lender) {
                _.forEach(lender.programs, function (program) {
                    _.forEach(program.programs, function (doc) {
                        docTypes.push({
                            display: doc.docType,
                            value: doc.docType
                        });

                        _.forEach(doc.products, function (product) {
                            var filterValue = {
                                display: product.loanAmortizationType,
                                value: product.loanAmortizationType
                            };

                            if(filterValue.value == 'Adjustable Rate'){
                                filterValue.display = 'ARM';
                            }

                            amortizationTypes.push(filterValue);
                        });
                    });
                });
            });

            docTypes = _.sortBy(docTypes, 'display');
            amortizationTypes = _.sortBy(amortizationTypes, 'display');

            /* LODASH MIGRATION HELPER FUNCTION */
            /* LODASH Version 3 & 4 Compatibility Mode */
            if ((_.VERSION).charAt(0) <= 3){ //Detect LODASH version 3 or 4.
                //V3 or lower
                docTypes = _.uniq(docTypes, true, 'value');
                amortizationTypes = _.uniq(amortizationTypes, true, 'value');
            } else {
                /* LODASH Version 4 ONLY */
                //V4 or Higher
                docTypes = _.uniqBy(docTypes, 'value'); // ++ AFTER MIGRATION TO V4 remove helper function with all V3 detect options ++
                amortizationTypes = _.uniqBy(amortizationTypes, 'value'); // ++ AFTER MIGRATION TO V4 remove helper function with all V3 detect options ++
            }

            return {
                docTypes: docTypes,
                amortizationTypes: amortizationTypes
            };
        }

        function openIncompleteLoanApplication(incompleteDataSet, navFunctions) {
            var defaultData = _.map(incompleteDataSet, function (value, modelId) {
                return {
                    data: {
                        value: value
                    },
                    field: {
                        modelId: modelId
                    }
                };
            });
            
            InstancesWindowService.openWindow({
                action: 'create',
                widgetId: 'CDBD77360CD343F5508B1465EDA43380-108',
                defaultData: defaultData,
                validateOnOpen: true,
                navFunctions: navFunctions
            });
        }

        function addDocumentToVault(id) {
            InstancesWindowService.openWindow({
                action: 'create',
                widgetId: 'D84650CD65706FE7A37261002D87D6E6-105',
                defaultData: [{
                    data: {
                        value: {
                            display: id,
                            id: id
                        }
                    },
                    field: {
                        modelId: 'LoanApplicationID'
                    }
                }]
            });
        }

        function buildProductsQueryParams(queryFormData) {
            var amortizations = [],
                ppp = [],
                docTypes = [];
            
            if (queryFormData.arm) {
                amortizations.push('arm');
            }
            if (queryFormData.fixed) {
                amortizations.push('fixed');
            }
            if (queryFormData.interestOnly) {
                amortizations.push('interestonly');
            }

            if (queryFormData.noPrepaymentPenalty) {
                ppp.push('no');
            }
            if (queryFormData['12monthPrepaymentPenalty']) {
                ppp.push('12');
            }
            if (queryFormData['24monthPrepaymentPenalty']) {
                ppp.push('24');
            }
            if (queryFormData['36monthPrepaymentPenalty']) {
                ppp.push('36');
            }
            
            if (queryFormData.fullDocumentation) {
                docTypes.push('Full Document');
            }
            if (queryFormData['12monthBankStatements']) {
                docTypes.push('12M Bank Statements');
            }
            if (queryFormData['24monthBankStatements']) {
                docTypes.push('24M Bank Statements');
            }
            if (queryFormData.assetUtilization) {
                docTypes.push('Asset Utilization');
            }
            if (queryFormData.debtServiceCoverage) {
                docTypes.push('Debt Service Coverage');
            }

            return {
                amortizations: amortizations.join(','),
                ppp: ppp.join(','),
                docTypes: docTypes.join(',')
            };
        }

        function parseProductsQueryParams(queryParams) {
            var queryDefaultData = {
                arm: false,
                fixed: false,
                interestOnly: false,
                noPrepaymentPenalty: false,
                '12monthPrepaymentPenalty': false,
                '24monthPrepaymentPenalty': false,
                '36monthPrepaymentPenalty': false,
                fullDocumentation: false,
                '12monthBankStatements': false,
                '24monthBankStatements': false,
                assetUtilization: false,
                debtServiceCoverage: false
            };
            
            if (queryParams.amortizations) {
                var amortizations = queryParams.amortizations.split(',');
                _.forEach(amortizations, function (val) {
                    if (val == 'arm') {
                        queryDefaultData.arm = true;
                    }
                    else if (val == 'fixed') {
                        queryDefaultData.fixed = true;
                    }
                    else if (val == 'interestonly') {
                        queryDefaultData.interestOnly = true;
                    }
                });
            }
            
            if (queryParams.ppp) {
                var ppp = queryParams.ppp.split(',');
                _.forEach(ppp, function (val) {
                    if (val == 'no') {
                        queryDefaultData.noPrepaymentPenalty = true;
                    }
                    else if (val == '12') {
                        queryDefaultData['12monthPrepaymentPenalty'] = true;
                    }
                    else if (val == '24') {
                        queryDefaultData['24monthPrepaymentPenalty'] = true;
                    }
                    else if (val == '36') {
                        queryDefaultData['36monthPrepaymentPenalty'] = true;
                    }
                });
            }

            if (queryParams.docTypes) {
                var docTypes = queryParams.docTypes.split(',');
                _.forEach(docTypes, function (val) {
                    if (val == 'Full Document') {
                        queryDefaultData.fullDocumentation = true;
                    }
                    else if (val == '12M Bank Statements') {
                        queryDefaultData['12monthBankStatements'] = true;
                    }
                    else if (val == '24M Bank Statements') {
                        queryDefaultData['24monthBankStatements'] = true;
                    }
                    else if (val == 'Asset Utilization') {
                        queryDefaultData['assetUtilization'] = true;
                    }
                    else if (val == 'Debt Service Coverage') {
                        queryDefaultData['debtServiceCoverage'] = true;
                    }
                });
            }

            return queryDefaultData;
        }

        // Helpers
        function parseDate(isoString) {
            var momentObj = moment.utc(isoString, 'MMMM, DD YYYY HH:mm:ss');
            momentObj.local();
            return momentObj.toDate();
        }

        function resolveOData(deferred, oData) {
            if (oData.d.__count !== 1) {
                deferred.resolve(oData.d.results);
            }
            else {
                deferred.resolve([_.omit(oData.d, '__count')]);
            }
        }

        function discountTemplate(field, format, dataItem) {
            var value = dataItem[field],
                formattedValue = kendo.format(format, value);

            if (value < 0) {
                return '<span class="text-bold">' + formattedValue + '</span>';
            }

            return formattedValue;
        }
    }])
;
angular.module('cerberus.les')
    .controller('LESEditQuickApplicationModalCtrl', ["_", "$scope", "$uibModalInstance", "$window", "instanceId", "lesQuickApplicationService", function (_, $scope, $uibModalInstance, $window, instanceId, lesQuickApplicationService) {
        var vm = this;
      
        vm.filters = {};
        vm.dataSet = {};
        vm.orig = {};
        vm.loadingQuickApp = true;
        vm.updatingQuickApp = false;
        vm.showUpdateError = false;
        vm.updateError = [];

        vm.loanPurposeOptions = lesQuickApplicationService.loanPurposeOptions($scope);
        vm.occupancyOptions = lesQuickApplicationService.occupancyOptions($scope);
        vm.propertyTypeOptions = lesQuickApplicationService.propertyTypeOptions($scope);
        vm.citizenshipOptions = lesQuickApplicationService.citizenshipOptions($scope);
        vm.bankruptcyTypeOptions = lesQuickApplicationService.bankruptcyTypeOptions($scope);
        vm.dispositionTypeOptions = lesQuickApplicationService.dispositionTypeOptions($scope);
        vm.dispositionDateOptions = lesQuickApplicationService.dispositionDateOptions();
        vm.currencyOptions = lesQuickApplicationService.currencyOptions();
        vm.unitNumberOptions = lesQuickApplicationService.unitNumberOptions();
        vm.ficoScoreOptions = lesQuickApplicationService.ficoScoreOptions();
        vm.ltvOptions = lesQuickApplicationService.ltvOptions();
        vm.employmentDurationOptions = lesQuickApplicationService.employmentDurationOptions();
        vm.delinquencyNumberOptions = lesQuickApplicationService.delinquencyNumberOptions();
        vm.delinquencyNumberLookupOptions = lesQuickApplicationService.delinquencyNumberLookupOptions();
        vm.showFormFieldValidation = lesQuickApplicationService.showFormFieldValidation;
        vm.popoverHTML = lesQuickApplicationService.popoverHTML;
        vm.toggleMortgageLates12Months = lesQuickApplicationService.toggleMortgageLates12Months;
        vm.toggleMortgageLates24Months = lesQuickApplicationService.toggleMortgageLates24Months;
        vm.toggleMortgageLates36Months = lesQuickApplicationService.toggleMortgageLates36Months;
        vm.displayPercentage = lesQuickApplicationService.displayPercentage;
        vm.isCondominium = lesQuickApplicationService.isCondominium;

        vm.isUnchanged = _isUnchanged;        
        vm.submit = _submit;
        vm.cancel = _cancel;

        init();

        function init() {
            vm.loadingQuickApp = true;
            lesQuickApplicationService.getQuickApplication(instanceId).then(function (quickAppData) {
                vm.loadingQuickApp = false; 
                vm.orig = quickAppData;
                vm.dataSet = angular.copy(quickAppData);

                lesQuickApplicationService.setNgModels($scope, vm.dataSet);
                lesQuickApplicationService.runCalculations($scope, vm.dataSet);
            }, function (reason) {
                if (reason == 'Not Found.') {
                    _cancel();
                }
            });
        }

        function _isUnchanged() {
            var newData = _.omit(vm.dataSet, ['ltv', 'cltv']),
                oldData = _.omit(vm.orig, ['ltv', 'cltv']);
            
            return angular.equals(newData, oldData);
        }

        function _submit(quickAppForm) {
            if(vm.loadingQuickApp || _isUnchanged()){
                $uibModalInstance.close(instanceId);
            }

            if (vm.importingQuickApp || quickAppForm.$invalid || !_.get(vm.dataSet, 'loanPurpose.type')) {
                return;
            }

            if (!_isUnchanged()) {
                vm.updatingQuickApp = true;
                vm.showUpdateError = false;

                lesQuickApplicationService.updateQuickApplication(instanceId, vm.dataSet).then(function (result) {
                    vm.updatingQuickApp = false;
                    if (result.errMsg) {
                        vm.showUpdateError = true;
                        vm.updateError = result.errMsg;
                    }
                    else {
                        $uibModalInstance.close(instanceId);
                    }
                }, function () {
                    vm.updatingQuickApp = false;
                });
            }
            else {
                $uibModalInstance.close(instanceId);
            }
        }

        function _cancel() {
            $uibModalInstance.dismiss();
        }

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESEditQuickApplicationPageCtrl', ["_", "$scope", "$window", "quickApplicationId", "lesQuickApplicationService", "lesLoanApplicationsService", function (_, $scope, $window, quickApplicationId, lesQuickApplicationService, lesLoanApplicationsService) {
        var vm = this;

        vm.quickApplication = {};
        vm.breadcrumbDisplay = 'Loading...';

        init();
        
        function init() {
            lesLoanApplicationsService.getLoanApplication(quickApplicationId).then(function (loanApplication) { 
                if(loanApplication.recordData.findings){
                    vm.quickApplication = loanApplication.recordData.loanApp;
                }
                else{
                    vm.quickApplication = loanApplication.recordData;
                }
                
                var mainBorrowerName = _.get(vm.quickApplication, 'mainBorrower.fullName') || 'No Primary Borrower';
                vm.breadcrumbDisplay = mainBorrowerName + ' (#' + _.last(quickApplicationId.split('-')) + ')';
            });

            lesQuickApplicationService.openNewQuickAppModal(quickApplicationId).then(function () {
                lesQuickApplicationService.openQuickAppEligibilityPage(quickApplicationId);
            }, function () {
                cancel();
            });
        }

        function cancel() {
            $window.history.back();
        }
    }])
;
angular.module('cerberus.les')
    .controller('LESNewQuickApplicationModalCtrl', ["_", "$scope", "$uibModalInstance", "$window", "lesQuickApplicationService", function (_, $scope, $uibModalInstance, $window, lesQuickApplicationService) {
        var vm = this;
      
        vm.filters = {};
        vm.dataSet = lesQuickApplicationService.defaultQuickAppData();
        vm.importingQuickApp = false;
        vm.showImportError = false;
        vm.importError = [];

        vm.loanPurposeOptions = lesQuickApplicationService.loanPurposeOptions($scope);
        vm.occupancyOptions = lesQuickApplicationService.occupancyOptions($scope);
        vm.propertyTypeOptions = lesQuickApplicationService.propertyTypeOptions($scope);
        vm.citizenshipOptions = lesQuickApplicationService.citizenshipOptions($scope);
        vm.bankruptcyTypeOptions = lesQuickApplicationService.bankruptcyTypeOptions($scope);
        vm.dispositionTypeOptions = lesQuickApplicationService.dispositionTypeOptions($scope);
        vm.dispositionDateOptions = lesQuickApplicationService.dispositionDateOptions();
        vm.currencyOptions = lesQuickApplicationService.currencyOptions();
        vm.unitNumberOptions = lesQuickApplicationService.unitNumberOptions();
        vm.ficoScoreOptions = lesQuickApplicationService.ficoScoreOptions();
        vm.ltvOptions = lesQuickApplicationService.ltvOptions();
        vm.employmentDurationOptions = lesQuickApplicationService.employmentDurationOptions();
        vm.delinquencyNumberOptions = lesQuickApplicationService.delinquencyNumberOptions();
        vm.delinquencyNumberLookupOptions = lesQuickApplicationService.delinquencyNumberLookupOptions();
        vm.showFormFieldValidation = lesQuickApplicationService.showFormFieldValidation;
        vm.popoverHTML = lesQuickApplicationService.popoverHTML;
        vm.toggleMortgageLates12Months = lesQuickApplicationService.toggleMortgageLates12Months;
        vm.toggleMortgageLates24Months = lesQuickApplicationService.toggleMortgageLates24Months;
        vm.toggleMortgageLates36Months = lesQuickApplicationService.toggleMortgageLates36Months;
        vm.displayPercentage = lesQuickApplicationService.displayPercentage;
        vm.isCondominium = lesQuickApplicationService.isCondominium;

        vm.submit = _submit;
        vm.cancel = _cancel;

        init();
        
        function init() {
            lesQuickApplicationService.setNgModels($scope, vm.dataSet);
            lesQuickApplicationService.runCalculations($scope, vm.dataSet);
        }

        function _submit(quickAppForm) {
            if (vm.importingQuickApp || quickAppForm.$invalid || !vm.dataSet.loanPurpose.type) {
                return;
            }

            vm.importingQuickApp = true;
            vm.showImportError = false;

            lesQuickApplicationService.submitQuickApplication(vm.dataSet).then(function (result) {
                vm.importingQuickApp = false;
                if (result.errMsg) {
                    vm.showImportError = true;
                    vm.importError = result.errMsg;
                }
                else if (result.instanceId) {
                    $uibModalInstance.close(result.instanceId);
                }
            }, function () {
                vm.importingQuickApp = false;
            });
        }

        function _cancel() {
            // $window.history.back();
            $uibModalInstance.dismiss();
        }

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESNewQuickApplicationPageCtrl', ["_", "$scope", "$window", "lesQuickApplicationService", function (_, $scope, $window, lesQuickApplicationService) {
        // var vm = this;

        init();
        
        function init() {
            lesQuickApplicationService.openNewQuickAppModal().then(function (instanceId) {
                lesQuickApplicationService.openQuickAppEligibilityPage(instanceId);
            }, function () {
                cancel();
            });
        }

        function cancel() {
            $window.history.back();
        }
    }])
;
angular.module('cerberus.les')
    .controller('LESQuickApplicationEligibilityCtrl', ["_", "$scope", "$location", "$timeout", "$q", "quickApplicationId", "lesLoanApplicationsService", "lesQuickApplicationService", "OdataUtilityService", function(_, $scope, $location, $timeout, $q, quickApplicationId, lesLoanApplicationsService, lesQuickApplicationService, OdataUtilityService){
        var vm = this;

        vm.quickApplicationId = quickApplicationId;
        vm.quickApplication = {};
        vm.mainBorrower = '';
        vm.breadcrumbDisplay = 'Loading...';
        vm.lenders = [];
        vm.docTypes = [];
        vm.amortizationTypes = [];
        vm.loadingProducts = false;
        vm.notFound = false;
        vm.tabActive = {};
        vm.eligibilityError = '';
        vm.eligibilityType = '';
        vm.eligibilityTypeCounts = {
            all: 0,
            eligible: 0,
            ineligible: 0,
            nearmiss: 0
        };
        vm.termsFilter = {
            field: 'loanAmortizationType',
            operator: 'eq',
            value: ''
        };
        vm.doctypeFilter = {
            field: 'docType',
            operator: 'eq',
            value: ''
        };
        vm.rateFilter = {
            field: 'rate',
            operator: 'lte',
            value: ''
        };
        vm.rateFilterOptions = {
            step: 0.25,
            format: 'n2',
            min: 0,
            decimals: 2
        };

        vm.productRateDetailTableOptions = lesQuickApplicationService.productRateDetailTableOptions;
        vm.operatorSymbols = OdataUtilityService.operatorSymbols();
        vm.operators = OdataUtilityService.operators();

        vm.updateEligibilityFilter = updateEligibilityFilter;        
        vm.applyFilters = applyFilters;
        vm.clearFilter = clearFilter;
        vm.refineSearch = refineSearch;
        vm.navToLoanPage = navToLoanPage;
        vm.openApplication = openApplication;
        
        init();

        function init(){
            vm.quickApplication = {};
            vm.mainBorrower = '';
            vm.lenders = [];
            vm.docTypes = [];
            vm.amortizationTypes = [];
            vm.tabActive = {};
            vm.eligibilityError = '';
            vm.eligibilityType = '';
            vm.eligibilityTypeCounts = {
                all: 0,
                eligible: 0,
                ineligible: 0,
                nearmiss: 0
            };
            vm.termsFilter = {
                field: 'loanAmortizationType',
                operator: 'eq',
                value: ''
            };
            vm.doctypeFilter = {
                field: 'docType',
                operator: 'eq',
                value: ''
            };
            vm.rateFilter = {
                field: 'rate',
                operator: 'lte',
                value: ''
            };
            vm.loadingProducts = true;
            
            lesLoanApplicationsService.getLoanApplication(quickApplicationId).then(function(loanApplication){
                if(loanApplication.recordData.findings){
                    vm.quickApplication = loanApplication.recordData.loanApp;
                }
                else{
                    vm.quickApplication = loanApplication.recordData;
                }

                var mainBorrowerName = _.get(vm.quickApplication, 'mainBorrower.fullName');
                
                vm.mainBorrower = mainBorrowerName;
                vm.breadcrumbDisplay = (mainBorrowerName || 'No Primary Borrower') + ' (#' + _.last(quickApplicationId.split('-')) + ')';

                if (_.isEmpty($location.search())) {
                    setDefaultQueryParams();
                }
                
                lesLoanApplicationsService.getLoanPrograms(quickApplicationId).then(function (programData) {
                    vm.lenders = programData.lenders;

                    var eligibilityPromises = [];

                    _.forEach(vm.lenders, function (l) {
                        _.forEach(l.programs, function (p) {
                            var prom = lesLoanApplicationsService.getLoanProgramEligibility(quickApplicationId, p.id, l.conduit, $location.search()).then(function (eligibilityData) {
                                _.assign(p, eligibilityData);

                                return true;
                            }, function (err) {
                                vm.eligibilityError = err;

                                return true;
                            });

                            eligibilityPromises.push(prom);
                        });
                    });

                    $q.all(eligibilityPromises).then(function () {
                        vm.productEligibilityTableOptions = lesQuickApplicationService.productEligibilityTableOptions(vm.eligibilityType, vm.lenders);

                        var eligibilityTypeCounts = _.countBy(vm.productEligibilityTableOptions.dataSource.data, 'eligibility');

                        if (eligibilityTypeCounts.eligible) {
                            vm.tabActive['eligible'] = true;
                            vm.eligibilityType = 'eligible';
                            vm.productEligibilityTableOptions.dataSource.filter.filters.push({
                                field: 'eligibility',
                                operator: 'eq',
                                value: 'eligible'
                            });
                        }
                        else {
                            vm.tabActive['all'] = true;
                        }

                        eligibilityTypeCounts.all = vm.productEligibilityTableOptions.dataSource.data.length;
                        _.assign(vm.eligibilityTypeCounts, eligibilityTypeCounts);

                        var filterData = lesLoanApplicationsService.getFilterOptions(vm.lenders);
                        
                        vm.amortizationTypes = filterData.amortizationTypes;
                        vm.termsLookupOptions = lesLoanApplicationsService.eligibilityFilterLookupOptions(filterData.amortizationTypes);
                        
                        vm.docTypes = filterData.docTypes;
                        vm.docTypeLookupOptions = lesLoanApplicationsService.eligibilityFilterLookupOptions(filterData.docTypes);

                        vm.loadingProducts = false;

                        if (eligibilityTypeCounts.all === 0) {
                            vm.eligibilityError = 'No products found. Please refine your search.';
                        }
                    }, function () {
                        vm.loadingProducts = false;
                        vm.productEligibilityTableOptions = lesQuickApplicationService.productEligibilityTableOptions(vm.eligibilityType, []);
                    });
                }, function () {
                    vm.loadingProducts = false;
                    vm.productEligibilityTableOptions = lesQuickApplicationService.productEligibilityTableOptions(vm.eligibilityType, []);
                });
            }, function (reason) {
                if (reason == "Not Found.") {
                    vm.loadingProducts = false;
                    vm.notFound = true;
                }
            });
        }

        function setDefaultQueryParams() {
            var docTypes = [];

            if (vm.quickApplication.isSelfEmployed) {
                docTypes.push('12M Bank Statements');
                docTypes.push('24M Bank Statements');
                }
            // else {
                docTypes.push('Full Document'); // Now unconditional
            // }

            var baseLoanAmount = vm.quickApplication.BaseLoanAmount || 0;
            var totalAssets = vm.quickApplication.totalAssets || 0;

            if ((totalAssets * 2) >= baseLoanAmount) {
                docTypes.push('Asset Utilization');
            }

            if (vm.quickApplication.PropertyUsagetype.display == 'Investor') {
                docTypes.push('Debt Service Coverage');
            }

            $location.replace().search({
                amortizations: 'arm,fixed',
                ppp: 'no',
                docTypes: docTypes.join(',')
            });
        }

        function updateEligibilityFilter(eligibilityType) {
            if (eligibilityType != vm.eligibilityType) {
                vm.eligibilityType = eligibilityType;
                applyFilters();
            }
        }

        function applyFilters() {
            var filter = {
                logic: 'and',
                filters: []
            };

            if (vm.eligibilityType) {
                filter.filters.push({
                    field: 'eligibility',
                    operator: 'eq',
                    value: vm.eligibilityType
                });
            }

            if (vm.termsFilter.value && vm.termsFilter.value !== 'Choose...') {
                filter.filters.push(vm.termsFilter);
            }

            // if (vm.doctypeFilter.value && vm.doctypeFilter.value !== 'Choose...') {
            //     filter.filters.push(vm.doctypeFilter);
            // }

            if (vm.rateFilter.value || vm.rateFilter.value === 0) {
                filter.filters.push(vm.rateFilter);
            }

            $timeout(function () {
                if (vm.productEligibilityTable) {
                    vm.productEligibilityTable.dataSource.filter(filter);
                }
            });
        }

        function clearFilter(filter) {
            filter.value = '';
            applyFilters();
        }

        function refineSearch() {
            var defaultQueryParams = lesLoanApplicationsService.parseProductsQueryParams($location.search());
            lesLoanApplicationsService.openFindProductsModal(defaultQueryParams).then(function (result) {
                $location.replace().search(result);
            });
        }

        function navToLoanPage() {
            $location.url('0AC3913C5D696B2A869CFCF478F49283-177');
        }

        function openApplication() {
            $location.url('quick-application/' + quickApplicationId);
        }

        $scope.$on('$locationChangeStart', function (e, newUrl) {
            newUrl = newUrl || '';

            var path = '/quick-application/' + quickApplicationId + '/eligibility';
            if (newUrl.indexOf(path) < 0 && !e.defaultPrevented) {
                if (vm.productEligibilityTable) {
                    vm.productEligibilityTable.destroy();
                    vm.productEligibilityTable = null;
                }
                
                if (vm.termsLookup) {
                    vm.termsLookup.destroy();
                    vm.termsLookup = null;
                }
            }
        });
    }])
;
angular.module('cerberus.les')
    .controller('LESQuickApplicationFindingsCtrl', ["_", "kendo", "moment", "$scope", "$document", "$location", "$timeout", "$uibModalInstance", "loanApplicationId", "productId", "product", "pricingIndex", "lesLoanApplicationsService", "normalPrintingService", function (_, kendo, moment, $scope, $document, $location, $timeout, $uibModalInstance,
                                                              loanApplicationId, productId, product, pricingIndex,
                                                              lesLoanApplicationsService, normalPrintingService) {
        var vm = this;
        var today = new Date();

        vm.loanApplicationId = loanApplicationId;
        vm.simpleLoanId = _.last(loanApplicationId.split('-'));
        vm.productId = productId;
        vm.product = product;
        vm.pricing = product.pricing[pricingIndex];
        vm.primaryBorrowerName = '';
        vm.propertyAddress = '';
        vm.applicationDataLoaded = false;
        vm.reasons = [];
        vm.reasonCategories = {};
        vm.incomeSources = [];
        vm.proposedExpenses = [];
        vm.printingFindingsReport = false;
        vm.showReasonsCitations = false;
        vm.eligibilityRunDate = '';
        vm.totalOtherProposedExpenses = 0;
        vm.totalRateAdjustments = 0;
        
        vm.ok = ok;
        vm.cancel = cancel;
        vm.formatPercentage = formatPercentage;
        vm.formatDate = formatDate;
        vm.min = min;
        vm.finalRate = finalRate;
        vm.totalAssets = totalAssets;
        vm.setReasons = setReasons;
        vm.printFindingsReport = printFindingsReport;
        vm.assetSum = assetSum;
        vm.totalIncome = totalIncome;

        init();

        function init() {
            vm.totalRateAdjustments = 0;

            _.forEach(product.adjustments, function(adj){
                vm.totalRateAdjustments += adj.value;
            });
            
            setReasons();

            lesLoanApplicationsService.getLoanApplication(loanApplicationId).then(function (loanApplication) {
                if(loanApplication.recordData.findings){
                    vm.loanApplication = loanApplication.recordData.loanApp;
                }
                else{
                    vm.loanApplication = loanApplication.recordData;
                }

                var mainBorrowerName = _.get(vm.loanApplication, 'mainBorrower.fullName');
            
                vm.primaryBorrowerName = mainBorrowerName || 'No Primary Borrower';
                vm.applicationDataLoaded = true;

                if (vm.loanApplication.RegisteredDate) {
                    vm.eligibilityRunDate = vm.loanApplication.RegisteredDate;
                }
                else {
                    vm.eligibilityRunDate = today;
                }

                if (_.has(vm.loanApplication, 'PropertyAddress.properties.formatted_address')) {
                    vm.propertyAddress = vm.loanApplication.PropertyAddress.properties.formatted_address;
                }
                else {
                    vm.propertyAddress = vm.loanApplication.PropertyAddressStreetAddress + ' ' + vm.loanApplication.PropertyAddressCity + ' ' + vm.loanApplication.PropertyAddressState + ' ' + vm.loanApplication.PropertyAddressZIPCode;
                }
            });
        }

        function ok() {
            $uibModalInstance.close(vm.pricing);
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        function formatPercentage(number, decimals) {
            decimals = decimals || '';
            return kendo.toString(number, 'p' + decimals);
        }

        function formatDate(dateValue, format) {
            if (!dateValue) {
                return '';
            }
            if (_.isString(dateValue)) {
                dateValue = moment(dateValue, ['MMMM, DD YYYY HH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ']).toDate();
            }
            return kendo.toString(dateValue, format);
        }

        function setReasons() {
            var reasons = [];

            if(!_.isEmpty(vm.product)){
                reasons = reasons.concat(vm.product.reasons);
            }
            if(!_.isEmpty(vm.pricing)){
                reasons = reasons.concat(vm.pricing.reason);
            }

            /* LODASH Version 4 ONLY */
            //var standardReasons = _.reject(reasons, 'type', 'Rate Sheet');
            /* LODASH Version 3 & 4 Compatibility Mode */
            var standardReasons = _.reject(reasons, function(r){return r.type === 'Rate Sheet';});
            if (standardReasons.length) {
                reasons = standardReasons;
            }

            vm.reasons = reasons;
            vm.reasonCategories = formatReasons(reasons);
        }

        function formatReasons(reasons) {
            var result = {};

            _.forEach(reasons, function (r) {
                if (r.type) {
                    var category = r.type.toLowerCase();
                    if (!result[category]) {
                        result[category] = { label: r.type, eligibility: r.eligibility };
                    }
                    else if (result[category].eligibility != 'ineligible') {
                        result[category].eligibility = r.eligibility;
                    }
                }    
            });

            return result;
        }

        function min(a, b) {
            return Math.min(a, b);
        }

        function finalRate(baseRate, adjustments) {
            var final = baseRate;

            _.forEach(adjustments, function (adj) {
                final += adj.value;
            });

            return final;
        }

        function totalAssets(assetMap) {
            return assetMap.closingCosts.total + assetMap.downPayment.total + assetMap.reserves.total;
        }

        function assetSum(assets, key) {
            return assets.downPayment[key] + assets.prepaid[key] + assets.buyDown[key]  + assets.fundingFee[key] + assets.closingCosts[key];
        }

        function totalIncome(incomeSources, type) {
            if (type) {
                /* LODASH Version 4 ONLY */
                //incomeSources = _.filter(incomeSources, ['BorrowerCurrentIncome_IncomeType_display', type]);
                /* LODASH Version 3 & 4 Compatibility Mode */
                incomeSources = _.filter(incomeSources, function(c){return c.BorrowerCurrentIncome_IncomeType_display === type;});
            }

            var total = 0;

            _.forEach(incomeSources, function(income) {
                total += income.BorrowerCurrentIncome_MonthlyTotalAmount;
            });

            return total;
        }

        function printFindingsReport() {
            if (!vm.printingFindingsReport){
                vm.printingFindingsReport = true;

                $timeout(function () {
                    var findingsReportElement = $document.find('#findings-report'),
                        filename = kendo.format('Findings Report - {0:u}', new Date()),
                        options = {
                            paperSize: 'letter',
                            landscape: false,
                            margin: 0
                        };
                    
                    normalPrintingService.printElement(findingsReportElement, filename, options).then(function () {
                        $timeout(function () {
                            vm.printingFindingsReport = false;
                        });
                    });
                });
            }
        }

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.les')
    .factory('lesQuickApplicationService', ["_", "apiPath", "kendo", "$rootScope", "$q", "$http", "$location", "$uibModal", "$timeout", "OdataUtilityService", function (_, apiPath, kendo, $rootScope, $q, $http, $location, $uibModal, $timeout, OdataUtilityService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';

        return {
            submitQuickApplication: submitQuickApplication,
            getQuickApplication: getQuickApplication,
            updateQuickApplication: updateQuickApplication,
            openQuickAppEligibilityPage: openQuickAppEligibilityPage,
            defaultQuickAppData: defaultQuickAppData,
            loanPurposeOptions: loanPurposeOptions,
            occupancyOptions: occupancyOptions,
            propertyTypeOptions: propertyTypeOptions,
            citizenshipOptions: citizenshipOptions,
            currencyOptions: currencyOptions,
            bankruptcyTypeOptions: bankruptcyTypeOptions,
            dispositionTypeOptions: dispositionTypeOptions,
            dispositionDateOptions: dispositionDateOptions,
            unitNumberOptions: unitNumberOptions,
            ficoScoreOptions: ficoScoreOptions,
            ltvOptions: ltvOptions,
            employmentDurationOptions: employmentDurationOptions,
            popoverHTML: popoverHTML,
            delinquencyNumberOptions: delinquencyNumberOptions,
            delinquencyNumberLookupOptions: delinquencyNumberLookupOptions,
            showFormFieldValidation: showFormFieldValidation,
            productEligibilityTableOptions: productEligibilityTableOptions,
            productRateDetailTableOptions: productRateDetailTableOptions,
            openFindingsReportModal: openFindingsReportModal,
            openNewQuickAppModal: openNewQuickAppModal,
            setNgModels: setNgModels,
            toggleMortgageLates12Months: toggleMortgageLates12Months,
            toggleMortgageLates24Months: toggleMortgageLates24Months,
            toggleMortgageLates36Months: toggleMortgageLates36Months,
            isCondominium: isCondominium,
            runCalculations: runCalculations,
            displayPercentage: displayPercentage
        };
      
        function submitQuickApplication(data) {
            var deferred = $q.defer();

            $http.post(apiPath + 'les/quickApp', { quickAppData: data })
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
  
            return deferred.promise;
        }

        function getQuickApplication(id) {
            var deferred = $q.defer();

            $http.get(apiPath + 'les/quickApp/' + id)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
  
            return deferred.promise;
        }
      
        function updateQuickApplication(id, data) {
            var deferred = $q.defer();

            $http.post(apiPath + 'les/quickApplications/' + id, { quickAppData: data })
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
  
            return deferred.promise;
        }

        function openQuickAppEligibilityPage(instanceId) {
            $location.url('quick-application/' + instanceId + '/eligibility').replace();
        }

        function defaultQuickAppData() {
            return {
                // LOAN
                loanPurpose: { display: 'Purchase', type: 'purchase', id: 'opt1' },
                estimatedClosingCosts: 0,
                baseLoanAmount: '',
                ltv: 0, // !R - static
                cltv: 0, // !R - static

                monthsOwned: 0, // !R
                existingLienAmount: 0,
                otherLienAmount: 0,
                cashOut: 0, // !R - static

                // PROPERTY
                propertyType: {},
                occupancyType: {},
                numberOfUnits: 1,
                state: '',
                nonWarrantable: false,

                appraisedValue: '',
                purchasePrice: '',
                originalCost: '', // !R
                borrowerTaxesInsuranceAndDues: '',

                // BORROWER
                borrowerName: '',
                citizenship: {},
                // employmentDurationMonths: 0,
                fico: '',
                hasForeignCredit: false,
                nonOccupantCoBorrower: false,
                firstTimeHomeBuyer: false,
                selfEmployed: false,
                totalIncome: '',
                presentHousingExpense: 0,

                // REO
                rentalIncome: 0,
                subjPropGrossRent: 0, // !R
                // reoMortAndLiensAmount: 0,
                // reoTaxesInsuranceAndDues: 0,

                // ASSETS
                totalLiquidAssets: 0,
                totalGiftAssets: 0,

                // LIABILITIES
                totalLiabilities: 0,

                delinquent1to12Months: false,
                num30DayDelinquencies12Months: 0,
                num60DayDelinquencies12Months: 0,
                num90DayDelinquencies12Months: 0,
                num120DayDelinquencies12Months: 0,

                delinquent13to24Months: false,
                num30DayDelinquencies24Months: 0,
                num60DayDelinquencies24Months: 0,
                num90DayDelinquencies24Months: 0,
                num120DayDelinquencies24Months: 0,

                delinquent25to36Months: false,
                num30DayDelinquencies36Months: 0,
                num60DayDelinquencies36Months: 0,
                num90DayDelinquencies36Months: 0,
                num120DayDelinquencies36Months: 0,

                // PUBLIC RECORDS        
                hasBankruptcy: false,
                bankruptcyType: {},
                bankruptcyDisposition: {},
                bankruptcyDispositionDate: '',
        
                hasDeedInLieu: false,
                // deedInLieuDisposition: {},
                deedInLieuDispositionDate: '',
        
                hasForeclosure: false,
                // foreclosureDisposition: {},
                foreclosureDispositionDate: '',
        
                hasShortSale: false,
                // shortSaleDisposition: {},
                shortSaleDispositionDate: ''
            };
        }
      
        function loanPurposeOptions(/*scope*/) {
            // return oDataLookup(scope, 'loanPurpose', '4AEB01AB5CC5FF6A4F134BC55601EC84-62', 'LoanPurposeType_LoanPurposeTypeName');
            
            // return {
            //     dataTextField: 'display',
            //     dataValueField: 'id',
            //     dataSource: {
            //         data: [
            //             { display: 'Purchase', id: 'opt1' },
            //             { display: 'Refinance', id: 'opt2' },
            //             { display: 'Refinance (Cash Out)', id: 'opt3' }
            //         ]
            //     }
            // };

            return [
                { display: 'Purchase', type: 'purchase', id: 'opt1' },
                { display: 'Refinance', type: 'refinance', id: 'opt2' }
                // { display: 'Refinance (Cash Out)', type: 'refinance', subType: 'cash-out', id: 'opt3' }
            ];
        }
      
        function occupancyOptions(scope) {
            return oDataLookup(scope, 'occupancyType', '152D91996210747934ADF46B440255E3-64', 'PropertyUsageType_PropertyUsageTypeName');
        }
      
        function propertyTypeOptions(scope) {
            return oDataLookup(scope, 'propertyType', '76AB0251EF9DCDEEF0F8A057E94695BD-50', 'GSEPropertyType_GSEPropertyTypeName');
        }
      
        function citizenshipOptions(scope) {
            return oDataLookup(scope, 'citizenship', '63A8134B2CD17356F209AD47B39B284A-93', 'CitizenshipResidencyType_CitizenshipResidencyTypeName');
        }
      
        function bankruptcyTypeOptions(scope) {
            // return oDataLookup(scope, 'bankruptcyType', 'DF6FE69518E85D5A8DC7353842D02CAB-199', 'BankruptcyType_Name');
            var options = oDataLookup(scope, 'bankruptcyType', '4A8F11E8303E962ACBA34DC10F3C2F57-165', 'PublicRecordsType_PublicRecordTypeName');

            options.dataSource.filter = {
                logic: 'and',
                filters: [{
                    field: 'PublicRecordsType_PublicRecordTypeName',
                    operator: 'startswith',
                    value: 'Bankruptcy'
                }]
            };

            return options;
        }
      
        function dispositionTypeOptions(scope) {
            // TODO: Double-check this query
            return oDataLookup(scope, 'bankruptcyDisposition', 'FC3E253972637FEC4EE555D22A9ADC76-167', 'PublicRecordsDispositionTypes_DispositionTypeName');
        }
      
        function dispositionDateOptions() {
            return {
                format: 'MM/dd/yyyy',
                depth: 'month',
                start: 'month'
            };
        }
      
        function currencyOptions() {
            return {
                decimals: 2,
                min: 0,
                format: 'c',
                step: 0.01
            };
        }
    
        function unitNumberOptions() {
            return {
                value: 1,
                decimals: 0,
                max: 4,
                min: 0,
                format: '###'
            };
        }
    
        function ficoScoreOptions() {
            return {
                decimals: 0,
                max: 850,
                min: 0,
                format: '###'
            };
        }
    
        function ltvOptions() {
            return {
                decimals: 4,
                min: 0,
                step: 0.01,
                format: 'p2'
            };
        }
    
        function employmentDurationOptions() {
            return {
                decimals: 0,
                min: 0,
                max: 99,
                format: '##',
                placeholder: '(Months)'
            };
        }

        function popoverHTML(helpText) {
            return '<div class="help-popover">' + helpText + '</div>';
        }

        function delinquencyNumberOptions() {
            return {
                decimals: 0,
                min: 0
            };
        }

        function delinquencyNumberLookupOptions() {
            return {
                dataTextField: 'display',
                dataValueField: 'value',
                valuePrimitive: true,
                dataSource: {
                    data: [
                        { display: '0', value: 0 },
                        { display: '1', value: 1 },
                        { display: '2', value: 2 },
                        { display: '3', value: 3 },
                        { display: '4', value: 4 },
                        { display: '5', value: 5 },
                        { display: '6', value: 6 },
                        { display: '7', value: 7 },
                        { display: '8', value: 8 },
                        { display: '9', value: 9 }
                    ]
                }
            };
        }

        function oDataLookup(scope, modelId, viewId, display) {
            return {
                dataTextField: 'display',
                dataValueField: 'id',
                optionLabel: { display: 'Choose...', id: '' },
                filter: 'contains',
                dataSource: {
                    type: 'odata',
                    serverFiltering: true,
                    serverPaging: true,
                    serverSorting: true,
                    transport: {
                        read: {
                            url: '/server/rest/v1/views/' + viewId + '/odata.svc',
                            beforeSend: function (xhr) {
                                xhr.setRequestHeader('Authentication', 'Bearer ' + $rootScope.authToken);
                                xhr.setRequestHeader('WSID', $rootScope.userData.currentWorkspace.id);
                            },
                            data: function (options) {
                                var params = {
                                    $lookupDisplay: display,
                                    $top: 20,
                                    $orderBy: display
                                };

                                if (options.filter) {
                                    params.$filter = OdataUtilityService.toOdataFilter(options.filter);
                                    delete options.filter;
                                }

                                return params;
                            },
                            dataType: 'json'
                        }
                    },
                    change: function (e) {
                        if (!e.action && e.items.length == 1) {
                            delete e.items[0].__count;
                        }    
                    }
                },
                change: function (e) {
                    if (e.sender.value() == -1) {
                        scope.$apply('vm.dataSet.' + modelId + ' = {}');
                    }
                },
                dataBinding: function (e) {
                    var value = scope.vm.dataSet[modelId];
                    
                    if (!_.isEmpty(value) && !e.sender.dataSource.get(value.id)) {
                        e.sender.dataSource.add(value);
                    }
                }
            };
        }

        function showFormFieldValidation(form, fieldName) {
            var field = form[fieldName];
            if (field) {
                // return field.$invalid;
                return field.$invalid && (field.$dirty || form.$submitted);
            }

            return false;
        }

        function productEligibilityTableOptions(eligibilityType, lenderData) {
            var products = [],
                filters = [];
            
            if (eligibilityType) {
                filters.push({
                    field: 'eligibility',
                    operator: 'eq',
                    value: eligibilityType
                });
            }

            _.forEach(lenderData, function (lender) {
                _.forEach(lender.programs, function (lenderProgram) {
                    _.forEach(lenderProgram.programs, function (prog) {
                        _.forEach(prog.products, function (product) {
                            var productProgramData = {
                                lenderName: lender.name,
                                // lenderId: lender.id,
                                // conduit: lender.conduit || {},
                                programName: lenderProgram.progName,
                                // programId: lenderProgram.id,
                                investorName: prog.investorName,
                                docType: prog.docType,
                                grade: prog.grade,
                                creditScore: prog.creditScore,
                                // conditions: prog.conditions,
                                reasons: prog.reasons,
                                adjustments: prog.adjustments
                            };

                            products.push(
                                _.assign({ rate: lowestEligibleRate(product) }, product, productProgramData)
                            );
                        });
                    });
                });
            });

            var openRows = {},
                clickHandlerSet = false;

            return {
                selectable: false,
                filterable: {
                    extra: false,
                    operators: {
                        string: {
                            contains: 'Contains',
                            startswith: 'Starts with'
                        },
                        number: {
                            lte: 'Is less than or equal to'
                        }
                    }
                },
                resizable: false,
                sortable: true,
                detailTemplate: '<table kendo-grid k-options="::vm.productRateDetailTableOptions(vm.quickApplicationId, \'#: data.id #\', vm.eligibilityType, #: kendo.stringify(data) #)"></table>',
                columns: [
                    {
                        title: 'Eligibility', width: 100, filterable: false,
                        template: function (dataItem) {
                            var labelClass = '',
                                text = '';
                            
                            switch (dataItem.eligibility) {
                                case 'eligible':
                                    labelClass = 'label-success';
                                    text = 'Eligible';
                                    break;

                                case 'nearmiss':
                                    labelClass = 'label-warning';
                                    text = 'Near Miss';
                                    break;

                                case 'ineligible':
                                    labelClass = 'label-danger';
                                    text = 'Refer/Ineligible';
                                    break;
                                    
                                default:
                                    return '';
                            }

                            return '<span class="label ' + labelClass + '">' + text + '</span>';
                        }
                    },
                    { title: 'Investor', field: 'investorName', width: 120 },
                    { title: 'Program', field: 'programName', width: 120 },
                    { title: 'Product', field: 'productName', width: 160 },
                    { title: 'Doc Type', field: 'docType', width: 120, filterable: { multi: true, checkAll: false } },
                    { title: 'Rate', field: 'rate', format: '{0:n2} %', width: 80 },
                    {
                        title: 'Tags', filterable: false,
                        template: function(dataItem){
                            var labels = [];

                            if (dataItem.prepaymentPenaltyTermMonths !== '') {
                                labels.push('<span class="label label-info">PPP ' + dataItem.prepaymentPenaltyTermMonths + 'M</span> ');
                            }
                            
                            if (dataItem.interestOnlyTerm !== '') {
                                labels.push('<span class="label label-info">IO ' + (dataItem.interestOnlyTerm / 12) + 'YR</span> ');
                            }

                            return labels.join(' ');
                        }
                    }
                ],
                dataSource: {
                    serverFiltering: false,
                    data: products,
                    sort: [
                        {
                            field: 'rate',
                            dir: 'asc'
                        }       
                    ],
                    filter: {
                        logic: 'and',
                        filters: filters
                    },
                    schema: {
                        model: {
                            fields: {
                                conduit: { default: {} },
                                rate: { type: 'number' }
                            }
                        }
                    }
                },
                dataBound: function (e) {
                    var grid = e.sender;

                    if (!clickHandlerSet) {
                        clickHandlerSet = true;

                        grid.tbody.on('click', '.k-master-row', function (event) {
                            var uid = angular.element(event.currentTarget).data('uid');

                            if (!angular.element(event.target).is('a.k-icon')) {
                                if (openRows[uid]) {
                                    grid.collapseRow(event.currentTarget);
                                    openRows[uid] = false;
                                }
                                else {
                                    grid.expandRow(event.currentTarget);
                                    openRows[uid] = true;
                                }
                            }
                        });
                    }

                    openRows = {};
                },
                detailExpand: function (e) {
                    var uid = e.masterRow.data('uid');
                    openRows[uid] = true;
                },
                detailCollapse: function (e) {
                    var uid = e.masterRow.data('uid');
                    openRows[uid] = false;
                }
            };
        }

        function productRateDetailTableOptions(loanAppId, productId, eligibilityType, productData) {
            return {
                filterable: false,
                resizable: false,
                sortable: true,
                columns: [
                    {
                        title: ' ', width: 31, attributes: { 'class': 'text-center' },
                        template: function (dataItem) {
                            var iconClass = '';
                            
                            switch (dataItem.eligibility) {
                                case 'eligible':
                                    iconClass = 'text-success';
                                    break;

                                case 'nearmiss':
                                    iconClass = 'text-warning';
                                    break;

                                case 'ineligible':
                                    iconClass = 'text-danger';
                                    break;
                                    
                                default:
                                    return '';
                            }

                            return '<i class="fa fa-circle ' + iconClass + '"></i>';
                        }
                    },
                    { title: 'Rate', field: 'noteRate', format: '{0:p3}', width: 80 },
                    // { title: 'Price', field: 'lenderPrice', format: '{0:n2}', width: 80 },
                    { title: 'Discount Points', template: _.partial(discountTemplate, 'discount', '{0}'), width: 110 },
                    { title: 'Discount Cost', template: _.partial(discountTemplate, 'buyUpDown', '{0:c0}') },
                    { title: 'P & I', field: 'payment', format: '{0:c0}', width: 80 },
                    { title: 'PITIA', field: 'pitia', format: '{0:c0}', width: 80 },
                    { title: 'DTI', field: 'dti', format: '{0:p2}', width: 80 },
                    {
                        title: ' ',
                        width: 92,
                        command: [
                            {
                                name: 'detailsButton', text: 'Findings', className: 'btn btn-sm k-primary',
                                click: function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    e.stopImmediatePropagation();

                                    var grid = this,
                                        row = angular.element(e.target).closest("tr"),
                                        pricingData = grid.dataItem(row);
                
                                    if (productId) {
                                        $timeout(function () {
                                            var index = grid.dataSource.indexOf(pricingData);
                                            openFindingsReportModal(loanAppId, productId, productData, index);                                            
                                        });
                                    }    
                                }
                            }
                        ]
                    }
                ],
                dataSource: {
                    data: productData.pricing,
                    sort: [{
                        field: 'noteRate',
                        dir: 'asc'
                    }]
                }
            };
        }

        function lowestEligibleRate(dataItem) {
            var eligibilities = _.groupBy(dataItem.pricing, 'eligibility');

            var pricing = [];
            if (eligibilities['eligible']) {
                pricing = eligibilities['eligible'];
            }
            else if (eligibilities['nearmiss']) {
                pricing = eligibilities['nearmiss'];
            }
            else if (eligibilities['ineligible']) {
                pricing = eligibilities['ineligible'];
            }

            var minimum = _.min(pricing, 'noteRate');
            if (minimum) {
                return minimum.noteRate * 100;
            }

            return '';
        }

        function openFindingsReportModal(id, productId, product, pricingIndex) {
            var modalInstance = $uibModal.open({
                size: 'lg',
                templateUrl: 'les/quick-applications/templates/quick-application-findings.tpl.html',
                controller: 'LESQuickApplicationFindingsCtrl',
                controllerAs: 'vm',
                resolve: {
                    loanApplicationId: _.constant(id),
                    productId: _.constant(productId),
                    product: _.constant(product),
                    pricingIndex: _.constant(pricingIndex)
                }
            });

            return modalInstance.result;
        }

        function discountTemplate(field, format, dataItem) {
            var value = dataItem[field],
                formattedValue = kendo.format(format, value);

            if (value < 0) {
                return '<span class="text-bold">' + formattedValue + '</span>';
            }

            return formattedValue;
        }

        function openNewQuickAppModal(instanceId) {
            var modalInstance = null;
            
            if (instanceId) {
                modalInstance = $uibModal.open({
                    templateUrl: 'les/quick-applications/templates/edit-quick-application-modal.tpl.html',
                    controller: 'LESEditQuickApplicationModalCtrl',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        instanceId: _.constant(instanceId)
                    }
                });
            }
            else {
                modalInstance = $uibModal.open({
                    templateUrl: 'les/quick-applications/templates/new-quick-application-modal.tpl.html',
                    controller: 'LESNewQuickApplicationModalCtrl',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {}
                });
            }    

            return modalInstance.result;
        }

        function setNgModels(scope, dataSet) {
            // scope._loanPurpose = _.get(dataSet, 'loanPurpose.id', '');
            scope._estimatedClosingCosts = _.get(dataSet, 'estimatedClosingCosts', '');
            scope._subjPropGrossRent = _.get(dataSet, 'subjPropGrossRent', '');
            scope._baseLoanAmount = _.get(dataSet, 'baseLoanAmount', ''); 
            // scope._ltv = _.get(dataSet, 'ltv', ''); 
            scope._monthsOwned = _.get(dataSet, 'monthsOwned', '');
            scope._existingLienAmount = _.get(dataSet, 'existingLienAmount', '');
            scope._otherLienAmount = _.get(dataSet, 'otherLienAmount', '');
            scope._cashOut = _.get(dataSet, 'cashOut', '');
            scope._propertyType = _.get(dataSet, 'propertyType.id', '');
            scope._occupancyType = _.get(dataSet, 'occupancyType.id', '');
            scope._appraisedValue = _.get(dataSet, 'appraisedValue', '');
            scope._purchasePrice = _.get(dataSet, 'purchasePrice', '');
            scope._originalCost = _.get(dataSet, 'originalCost', '');
            scope._borrowerTaxesInsuranceAndDues = _.get(dataSet, 'borrowerTaxesInsuranceAndDues', '');
            scope._totalIncome = _.get(dataSet, 'totalIncome', '');
            scope._presentHousingExpense = _.get(dataSet, 'presentHousingExpense', '');
            scope._citizenship = _.get(dataSet, 'citizenship.id', '');
            // scope._employmentDurationMonths = _.get(dataSet, 'employmentDurationMonths', '');
            scope._fico = _.get(dataSet, 'fico', '');
            scope._totalLiquidAssets = _.get(dataSet, 'totalLiquidAssets', '');
            scope._totalGiftAssets = _.get(dataSet, 'totalGiftAssets', '');
            scope._rentalIncome = _.get(dataSet, 'rentalIncome', '');
            scope._reoMortAndLiensAmount = _.get(dataSet, 'reoMortAndLiensAmount', '');
            scope._reoTaxesInsuranceAndDues = _.get(dataSet, 'reoTaxesInsuranceAndDues', '');
            scope._totalLiabilities = _.get(dataSet, 'totalLiabilities', '');
            scope._bankruptcyType = _.get(dataSet, 'bankruptcyType.id', '');
            scope._bankruptcyDisposition = _.get(dataSet, 'bankruptcyDisposition.id', '');
            scope._bankruptcyDispositionDate = _.get(dataSet, 'bankruptcyDispositionDate', '');
            scope._deedInLieuDispositionDate = _.get(dataSet, 'deedInLieuDispositionDate', '');
            scope._foreclosureDispositionDate = _.get(dataSet, 'foreclosureDispositionDate', '');
            scope._shortSaleDispositionDate = _.get(dataSet, 'shortSaleDispositionDate', '');
        }

        function toggleMortgageLates12Months(dataSet) {
            if (!dataSet.delinquent1to12Months) {
                dataSet.num30DayDelinquencies12Months = 0;
                dataSet.num60DayDelinquencies12Months = 0;
                dataSet.num90DayDelinquencies12Months = 0;
                dataSet.num120DayDelinquencies12Months = 0;
            }
        }

        function toggleMortgageLates24Months(dataSet) {
            if (!dataSet.delinquent13to24Months) {
                dataSet.num30DayDelinquencies24Months = 0;
                dataSet.num60DayDelinquencies24Months = 0;
                dataSet.num90DayDelinquencies24Months = 0;
                dataSet.num120DayDelinquencies24Months = 0;
            }
        }

        function toggleMortgageLates36Months(dataSet) {
            if (!dataSet.delinquent25to36Months) {
                dataSet.num30DayDelinquencies36Months = 0;
                dataSet.num60DayDelinquencies36Months = 0;
                dataSet.num90DayDelinquencies36Months = 0;
                dataSet.num120DayDelinquencies36Months = 0;
            }
        }

        function isCondominium(propertyTypeDisplay) {
            if (propertyTypeDisplay) {
                return propertyTypeDisplay.indexOf('Condominium') >= 0;
            }

            return false;
        }

        function runCalculations(scope, dataSet) {
            var safeDivide = function (numerator, denominator) {
                if (!numerator || !denominator) {
                    return 0;
                }

                return numerator / denominator;
             };

            // LTV
            scope.$watchGroup(['vm.dataSet.loanPurpose.type', 'vm.dataSet.baseLoanAmount', 'vm.dataSet.purchasePrice', 'vm.dataSet.appraisedValue'], function (newValues/*, oldValues*/) {
                // if (!angular.equals(newValues, oldValues)) {
                    var loanPurpose = newValues[0],
                        baseLoanAmount = newValues[1],
                        purchasePrice = newValues[2],
                        appraisedValue = newValues[3];

                    if (loanPurpose == 'refinance') {
                        dataSet.ltv = safeDivide(baseLoanAmount, appraisedValue);
                    }
                    else {
                        dataSet.ltv = safeDivide(baseLoanAmount, Math.min(appraisedValue, purchasePrice));
                    }
                // }
            });

            // CLTV
            scope.$watchGroup(['vm.dataSet.loanPurpose.type', 'vm.dataSet.appraisedValue', 'vm.dataSet.otherLienAmount', 'vm.dataSet.baseLoanAmount'], function (newValues/*, oldValues*/) {
                // if (!angular.equals(newValues, oldValues)) {0
                    var loanPurpose = newValues[0],
                        appraisedValue = newValues[1],
                        otherLiens = newValues[2],
                        baseLoanAmount = newValues[3];

                    if (loanPurpose == 'refinance') {
                        dataSet.cltv = safeDivide(baseLoanAmount + otherLiens, appraisedValue);
                    }
                    else {
                        dataSet.cltv = 0;
                    }
                // }
            });

            // Cash Out
            scope.$watchGroup(['vm.dataSet.loanPurpose.type', 'vm.dataSet.existingLienAmount', 'vm.dataSet.estimatedClosingCosts', 'vm.dataSet.baseLoanAmount'], function (newValues, oldValues) {
                if (!angular.equals(newValues, oldValues)) {
                    var loanPurpose = newValues[0],
                        existingLiens = newValues[1],
                        estClosingCosts = newValues[2],
                        baseLoanAmount = newValues[3];

                    if (loanPurpose == 'refinance') {
                        dataSet.cashOut = Math.max(baseLoanAmount - (existingLiens + estClosingCosts), 0);
                        scope._cashOut = _.get(dataSet, 'cashOut', ''); 
                    }
                    else {
                        dataSet.cashOut = 0;
                    }
                }
            });
        }

        function displayPercentage(ltv) {
            return kendo.toString(ltv, 'p2');
        }
    }])
;
angular.module('cerberus.les')
/**
 * @ngdoc config
 * @description router config
 */
    .config(["$routeProvider", function($routeProvider){
        $routeProvider.when('/quick-application', {
            templateUrl: 'les/quick-applications/templates/new-quick-application-page.tpl.html',
            controller: 'LESNewQuickApplicationPageCtrl',
            controllerAs: 'vm',
            title: 'Quick Application',
            resolve: {
                _wait: 'WaitForUserData'
            }
        });

        $routeProvider.when('/quick-application/:id', {
            templateUrl: 'les/quick-applications/templates/edit-quick-application-page.tpl.html',
            controller: 'LESEditQuickApplicationPageCtrl',
            controllerAs: 'vm',
            title: 'Quick Application',
            resolve: {
                _wait: 'WaitForUserData',
                quickApplicationId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
      
        $routeProvider.when('/quick-application/:id/eligibility', {
            templateUrl: 'les/quick-applications/templates/quick-application-eligibility.tpl.html',
            controller: 'LESQuickApplicationEligibilityCtrl',
            controllerAs: 'vm',
            title: 'Eligibility',
            resolve: {
                _wait: 'WaitForUserData',
                quickApplicationId: ["$route", function($route){
                    return $route.current.params.id;
                }]
            }
        });
    }])
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name ConfirmModalService
     * @alias cerberus/ui:ConfirmModalService
     * @description Provides quick, custom modals
     */
    .factory('ConfirmModalService', ["$uibModal", function ConfirmModalService($uibModal){

        var modalDefaults = {
            backdropClass: 'confirm',
            windowClass: 'modal-confirm',
            backdrop: true,
            keyboard: true,
            modalFade: true,
            templateUrl: 'ui/nim-confirm-modal/confirm-modal.tpl.html'
        };

        var modalOptions = {
            closeButtonText: 'Close',
            actionButtonText: 'OK',
            headerText: 'Proceed?',
            bodyText: 'Perform this action?',
            showActionButton: true,
            actionButtonClass: 'btn-danger',
            actionButtonIcon: '',
            actionButtonPosition: 'body',
            showCloseButton: true,
            closeButtonClass: 'btn-default',
            closeButtonIcon: 'fa-ban',
            showFooter: true,
            footerAlignment: 'right'
        };

        function showModal(customModalDefaults, customModalOptions) {
            if (!customModalDefaults) {
                customModalDefaults = {};
            }
            customModalDefaults.backdrop = 'static';
            return show(customModalDefaults, customModalOptions);
        }

        function show(customModalDefaults, customModalOptions) {
            //Create temp objects to work with since we're in a singleton service
            var tempModalDefaults = {};
            var tempModalOptions = {};

            //Map angular-ui modal custom defaults to modal defaults defined in service
            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

            //Map modal.html $scope custom properties to defaults defined in service
            angular.extend(tempModalOptions, modalOptions, customModalOptions);

            if (!tempModalDefaults.controller) {
                tempModalDefaults.controller = tempModalDefaultsCtrl;
                tempModalDefaults.controllerAs = 'vm';
                tempModalDefaultsCtrl.$inject = ['$scope','$uibModalInstance'];
            }
            function tempModalDefaultsCtrl($scope, $uibModalInstance) {
                var vm = this;

                // Prevents Navigation while in modal
                var allowNavigation = $scope.$on('$locationChangeStart', function(event){
                    event.preventDefault();
                });

                vm.confirmTitle = '';
                vm.modalOptions = tempModalOptions;
                vm.modalOptions.ok = function (result) {
                    // De-registers event that prevents navigation
                    allowNavigation();

                    if(vm.modalOptions.confirm){
                        var promise = vm.modalOptions.confirm();
                        if(promise){
                            promise.then(function(){
                                if(vm.modalOptions.callback){
                                    vm.modalOptions.callback();
                                }
                                $uibModalInstance.close(result);
                            });
                        }
                        else {
                            $uibModalInstance.close(result);
                        }
                    }
                    else {
                        $uibModalInstance.close(result);
                    }
                };

                vm.modalOptions.close = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }

            return $uibModal.open(tempModalDefaults).result;
        }

        return {
            showModal: showModal
        };
    }])
;
angular.module('cerberus.ui')
    .controller('ExportConfigModalCtrl', ["_", "$scope", "$uibModalInstance", "defaultConfig", function(_, $scope, $uibModalInstance, defaultConfig){
        var vm = this;

        vm.exportConfig = {
            type: 'pdf',
            filename: 'download',
            options: {
                paperSize: 'letter',
                landscape: false,
                margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            }
        };

        vm.exportTypes = [
            {value: 'pdf', display: 'PDF'},
            {value: 'png', display: 'PNG'},
            {value: 'svg', display: 'SVG'}
        ];

        vm.supportedPaperSizes = [
            {value: 'auto', display: '(AUTO)'},
            //{value: 'a0', display: 'A0'},
            {value: 'a1', display: 'A1'},
            {value: 'a2', display: 'A2'},
            {value: 'a3', display: 'A3'},
            {value: 'a4', display: 'A4'},
            //{value: 'a5', display: 'A5'},
            //{value: 'a6', display: 'A6'},
            //{value: 'a7', display: 'A7'},
            //{value: 'a8', display: 'A8'},
            //{value: 'a9', display: 'A9'},
            //{value: 'a10', display: 'A10'},
            //{value: 'b0', display: 'B0'},
            //{value: 'b1', display: 'B1'},
            //{value: 'b2', display: 'B2'},
            //{value: 'b3', display: 'B3'},
            //{value: 'b4', display: 'B4'},
            //{value: 'b5', display: 'B5'},
            //{value: 'b6', display: 'B6'},
            //{value: 'b7', display: 'B7'},
            //{value: 'b8', display: 'B8'},
            //{value: 'b9', display: 'B9'},
            //{value: 'b10', display: 'B10'},
            //{value: 'c0', display: 'C0'},
            //{value: 'c1', display: 'C1'},
            //{value: 'c2', display: 'C2'},
            //{value: 'c3', display: 'C3'},
            //{value: 'c4', display: 'C4'},
            //{value: 'c5', display: 'C5'},
            //{value: 'c6', display: 'C6'},
            //{value: 'c7', display: 'C7'},
            //{value: 'c8', display: 'C8'},
            //{value: 'c9', display: 'C9'},
            //{value: 'c10', display: 'C10'},
            {value: 'executive', display: 'Executive'},
            {value: 'folio', display: 'Folio'},
            {value: 'legal', display: 'Legal'},
            {value: 'letter', display: 'Letter'},
            {value: 'tabloid', display: 'Tabloid'}
        ];

        vm.pdfOrientations = [
            {value: false, display: 'Portrait'},
            {value: true, display: 'Landscape'}
        ];

        vm.fileTypeOptions = {
            pdf: {
                paperSize: 'Letter',
                landscape: false,
                margin: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            },
            png: {
                height: '',
                width: ''
            },
            svg: {}
        };

        vm.confirm = _confirm;
        vm.cancel = _cancel;
        vm.getFileTypeOptions = _getFileTypeOptions;

        if(!_.isEmpty(defaultConfig)){
            vm.exportConfig = _.defaultsDeep(defaultConfig, vm.exportConfig);
        }

        function _confirm(config){
            $uibModalInstance.close(config);
        }

        function _cancel(){
            $uibModalInstance.dismiss('Canceled');
        }

        function _getFileTypeOptions(type){
            return angular.copy(vm.fileTypeOptions[type]);
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.ui')
    .factory('ExportService', ["_", "kendo", "$q", "$timeout", "$uibModal", function(_, kendo, $q, $timeout, $uibModal){
        var exportClass = 'nim-export-element';

        return {
            exportElement: exportElement,
            exportPage: exportPage
        };

        function exportElement(elem, defaultConfig, cb){
            var callback = angular.noop;

            if(_.isFunction(cb)){
                callback = cb;
            }

            configureExport(defaultConfig).then(function(config){
                elem.addClass(exportClass);

                if(config.options.paperSize !== 'auto') {
                    var paperOptions = kendo.pdf.getPaperOptions(config.options);
                    var width = paperOptions.paperSize[0];

                    if(paperOptions.margin.left){
                        width -= paperOptions.margin.left;
                    }

                    if(paperOptions.margin.right){
                        width -= paperOptions.margin.right;
                    }

                    width = width * 120 / 72;

                    elem.css('width', width);
                }

                $timeout(function(){
                    kendo.drawing.drawDOM(elem, config.options).then(function(group){
                        switch(config.type){
                            case "pdf":
                                return kendo.drawing.exportPDF(group, config.options);
                            case "png":
                                return kendo.drawing.exportImage(group, config.options);
                            case "svg":
                                return kendo.drawing.exportSVG(group, config.options);
                            default:
                                elem.css('width', '')
                                    .removeClass(exportClass);

                                callback();
                                return false;
                        }
                    }).done(function(dataURI){
                        kendo.saveAs({
                            dataURI: dataURI,
                            fileName: config.filename + '.' + config.type
                        });

                        elem.removeClass(exportClass);
                        elem.css('width', '');

                        callback();
                    });
                }, 800);
            }, function(){
                callback();
            });
        }

        function exportPage(body, defaultConfig, cb){
            var callback = angular.noop,
                pageObjects = body
                    .find('#page-content')
                    .children('#content-wrap')
                    .children('.gridster-container')
                    .children('div[gridster]')
                    .children('ul')
                    .children('.nim-page-object');

            if(_.isFunction(cb)){
                callback = cb;
            }

            configureExport(defaultConfig).then(function(config){
                body.addClass(exportClass);

                if(config.options.paperSize !== 'auto') {
                    var paperOptions = kendo.pdf.getPaperOptions(config.options);

                    var width = paperOptions.paperSize[0];

                    if(paperOptions.margin.left){
                        width -= paperOptions.margin.left;
                    }

                    if(paperOptions.margin.right){
                        width -= paperOptions.margin.right;
                    }

                    width = width * 120 / 72;

                    body.css('width', width);
                }

                $timeout(function(){
                    var promises = [];

                    pageObjects.each(function(i, elem){
                        promises.push(
                            kendo.drawing.drawDOM(elem, config.options)
                        );
                    });

                    $q.all(promises).then(function(groups){
                        var root = new kendo.drawing.Group(),
                            exportPromise = null;

                        _.forEach(groups, function(group){
                            root.append(group);
                        });

                        switch(config.type){
                            case "pdf":
                                exportPromise = kendo.drawing.exportPDF(root, config.options);
                                break;
                            case "png":
                                exportPromise = kendo.drawing.exportImage(root, config.options);
                                break;
                            case "svg":
                                exportPromise = kendo.drawing.exportSVG(root, config.options);
                                break;
                            default:
                                body.css('width', '')
                                    .removeClass(exportClass);

                                callback();
                                return;
                        }

                        exportPromise.then(function(dataURI){
                            kendo.saveAs({
                                dataURI: dataURI,
                                fileName: config.filename + '.' + config.type
                            });

                            body.css('width', '')
                                .removeClass(exportClass);

                            callback();
                        });
                    });
                }, 800);
            }, function(){
                callback();
            });
        }

        /**
         * Opens the export configuration modal
         * @param defaultConfig - Initial exportSettings for exported file. Includes filename.
         * @returns {Promise} - Fulfilled when the modal is closed
         */
        function configureExport(defaultConfig){
            var exportConfigModal = $uibModal.open({
                templateUrl: 'ui/nim-export/export-config-modal.tpl.html',
                controller: 'ExportConfigModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-export-config',
                backdropClass: 'export-config',
                resolve: {
                    defaultConfig: _.constant(defaultConfig)
                }
            });

            return exportConfigModal.result;
        }
    }])
;
angular.module('cerberus.ui')
    .controller('NimIconPickerCtrl', ["$scope", "NimIconPickerService", function NimIconPickerCtrl($scope, NimIconPickerService) {
        var vm = this;
        vm.filterText = '';
        vm.icons = [];
        vm.init = init;
        vm.select = select;
        ////////////////////
        function init() {
            NimIconPickerService.getIcons().then(function (value) {
                vm.icons = value;
            });
        }
        function select(icon) {
            $scope.icon = icon;
        }
    }])
    .directive('nimIconPicker', function nimIconPicker() {
        return {
            restrict: 'AE',
            scope: {
                icon: '=nimIconPicker',
                btnClass: '@'
            },
            controller: 'NimIconPickerCtrl',
            controllerAs: 'vm',
            templateUrl: 'ui/nim-icon-picker/nim-icon-picker.tpl.html',
            link: function (scope, element, attributes, controller) {
                controller.init();
            }
        };
    })
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name NimIconPickerService
     * @alias cerberus/ui:NimIconPickerService
     * @description Provides Icons to icon Picker
     */
    .factory('NimIconPickerService', ["$http", function NimIconPickerService($http) {
        var service = {
            getIcons: getIcons
        };
        return service;
        ////////////////////
        /**
         * @function getIcons
         * @return {Promise} fontawesome icons
         */
        function getIcons() {
            return $http.get('/assets/fontawesomeicons.json', {cache:true}).then(function (value) {
                return value.data.icons;
            });
        }
    }])
;
angular.module('cerberus.ui')
    .directive('nimImg', ["InstancesService", function(InstancesService){
        return {
            restrict: 'AE',
            priority: 2000,
            link: function(scope, element, attrs){
                var attachmentId = attrs.nimImg,
                    width = attrs.width,
                    height = attrs.height;
                if(attachmentId && attachmentId != 'undefined'){
                    InstancesService.getDownloadKey(attachmentId).then(function(url){
                        var imageElement = angular.element('<img src="' + url + '" />');
                        if (width) {
                            imageElement.css('width', width);
                        }
                        if (height) {
                            imageElement.css('height', height);
                        }

                        imageElement.appendTo(element.empty());
                    });
                }
            }
        };
    }])
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name LeafletDefaultsService
     * @alias cerberus/ui:LeafletDefaultsService
     * @description Provides default configuration values for the leaflet map
     */
    .factory('LeafletDefaultsService', function LeafletDefaultsService() {
        var service = {
            map: map,
            controls: controls,
            draw: draw,
            layer: layer
        };
        return service;

        ////////////////////
        function map() {
            return {
                center: [33.7, -117.8],
                zoom: 10,
                //layers: layers
                minZoom: undefined,
                maxZoom: undefined,
                maxBounds: undefined,
                dragging: true,
                touchZoom: true,
                scrollWheelZoom: true,
                doubleClickZoom: true,
                boxZoom: true,
                trackResize: true,
                closePopupOnClick: true,
                zoomControl: false,
                attributionControl: false
            };
        }
        function controls() {
            return {
                zoom: true,
                fullscreen: true,
                layers: true,
                scale: true,
                measure: false,
                loading: true,
                coordinate: true,
                zoomBox: false,
                bookmarks: false,
                draw: false
            };
        }
        function draw(layer) {
            return {
                draw: {
                    position: 'topleft',
                    polygon: {
                        title: 'Draw a sexy polygon!',
                        allowIntersection: false,
                        drawError: {
                            color: '#b00b00',
                            timeout: 1000
                        },
                        shapeOptions: {
                            color: '#bada55'
                        },
                        showArea: true
                    },
                    polyline: {
                        metric: false
                    },
                    circle: {
                        shapeOptions: {
                            color: '#662d91'
                        }
                    }
                },
                edit: {
                    featureGroup: layer
                }
            };
        }
        function layer() {
            return {
                type: null,
                name: null,
                url: null,
                visible: false,
                settings: {}
            };
        }
    })
;
/**
 * EXAMPLE
 ***Controller:
 *
 ***Template
 * <div nim-leaflet="123" nim-options="options"></div>
 *
 */

angular.module('cerberus.ui')
    .controller('NimLeafletCtrl', ["_", "L", "mapboxConfig", "$scope", "$attrs", "$element", "$window", "$location", "$log", "$timeout", "$compile", "LeafletMapService", "LeafletDefaultsService", "InstancesWindowService", function NimLeafletCtrl(_, L, mapboxConfig, $scope, $attrs, $element, $window, $location, $log, $timeout, $compile, LeafletMapService, LeafletDefaultsService, InstancesWindowService) {
        var vm = this;

        // Set Leaflet
        L.Icon.Default.imagePath = '/assets/images';

        /* Expose Controller API */

        // Extend default configuration with user defined configs
        vm.config = {
            map: angular.extend(LeafletDefaultsService.map(), $scope.nimOptions.map),
            basemaps: $scope.nimOptions.basemaps || [],
            overlays: $scope.nimOptions.overlays || [],
            controls: angular.extend(LeafletDefaultsService.controls(), $scope.nimOptions.controls)
        };

        // Containers
        vm.id = null;
        vm.map = null;
        vm.basemaps = {};
        vm.overlays = {};
        vm.controls = {};
        vm.markers = {};
        vm.data = {};

        vm.geoAddr = "";
        vm.location = {};


        // Constructor
        vm.init = function (id) {
            // Ugly hack - prevents an empty map div
            $timeout(function () {
                init(id);
            });
        };

        ////////////////////
        /**
         * @function init
         * Configures and builds Leaflet map
         */
        function init() {
            /* Context Menu */
            // TODO: Refactor this context menu junk outta her
            vm.config.map.contextmenu = true;
            vm.config.map.contextmenuItems = [{
                text: 'Bookmark this position',
                callback: function(evt) {
                    this.fire('bookmark:new', {
                        latlng: evt.latlng
                    });
                }
            }];


            /* Map */
            vm.id = $attrs.nimLeafletId;
            // Put in timeout to allow time to update id before binding to map element
            $timeout(function () {
                if (!angular.element('#' + vm.id).length) { 
                    return;
                }

                vm.map = L.map(vm.id, vm.config.map);
                // Publish ready event
                // vm.map.whenReady(function () {
                //     $scope.$emit('nim-leaflet-ready');
                // });

                // Set center and zoom based on user configuration
                var center = vm.config.map.center;
                var zoom = vm.config.map.zoom;

                /* Set View */
                var view = LeafletMapService.getView(vm.id);
                if (view) {
                    vm.map.setView(L.latLng(view.lat, view.lng), view.zoom, true);
                    // $scope.nimBounds = vm.map.getBounds();
                }

                /* Build Layers */
                LeafletMapService.buildBasemaps(vm.config.basemaps, vm.basemaps, vm.map);

                if (vm.config.controls.draw || $scope.nimOptions.drawings) {

                    vm.overlays["My Drawings"] = new L.geoJson(null, {
                        style: function (layer) {
                            var shape = layer.geometry.type.toLowerCase();
                            if($scope.nimOptions.drawOptions.draw[shape]) {
                                return $scope.nimOptions.drawOptions.draw[shape].shapeOptions;
                            }
                            else{
                                return {};
                            }
                        }
                    });
                    vm.overlays["My Drawings"].addTo(vm.map);

                    if($scope.nimOptions.drawings){
                        var geometry = $scope.nimOptions.drawings.geometry;
                        if(geometry) {
                            vm.overlays['My Drawings'].addData(geometry);
                            var bounds = vm.overlays["My Drawings"].getBounds();

                            // Sets center and zoom based on geometry (Form Object)
                            center = bounds.getCenter();
                            zoom = vm.map.getBoundsZoom(bounds);
                        }
                    }
                }

                if(center && zoom){
                    vm.map.setView(center, zoom);
                }
                else if(center){
                    vm.map.setView(center);
                }
                else if(zoom){
                    vm.map.setZoom(zoom);
                }

                LeafletMapService.buildLayers(vm.config.overlays, vm.overlays, vm.map, vm.markers, watchCallback, $scope);

                /* Controls */
                // Setup Controls (in order of position top-right, top-left, bottom-left, bottom-right)
                if (vm.config.controls.layers) {
                    vm.controls.layersControl = L.control.layers(vm.basemaps, vm.overlays).addTo(vm.map);
                }
                if (vm.config.controls.geolocate) {
                    // Mapbox Geocoder
                    vm.controls.geocoderControl = L.mapbox.geocoderControl('mapbox.places', {
                        accessToken: mapboxConfig.token,
                        keepOpen: true
                    }).addTo(vm.map);
                }
                if (vm.config.controls.bookmarks) {
                    vm.controls.bookmarksControl = new L.Control.Bookmarks().addTo(vm.map);
                }
                if (vm.config.controls.zoom) {
                    vm.controls.zoomControl = L.control.zoom().addTo(vm.map);
                }
                if (vm.config.controls.zoomBox) {
                    vm.controls.zoomBoxControl = L.control.zoomBox().addTo(vm.map);
                }
                if (vm.config.controls.fullscreen) {
                    vm.controls.fullscreenControl = new L.Control.FullScreen().addTo(vm.map);
                }
                if (vm.config.controls.draw) {
                    var drawOptions = LeafletDefaultsService.draw(vm.overlays["My Drawings"]);
                    if($scope.nimOptions.drawOptions){
                        drawOptions = angular.extend(drawOptions, $scope.nimOptions.drawOptions);
                    }
                    vm.controls.drawControl = new L.Control.Draw(drawOptions).addTo(vm.map);
                }
                if (vm.config.controls.measure) {
                    vm.controls.measureControl = L.Control.measureControl().addTo(vm.map);
                }
                if (vm.config.controls.loading) {
                    vm.controls.loadingControl = L.Control.loading().addTo(vm.map);
                }
                if (vm.config.controls.scale) {
                    vm.controls.scaleControl = L.control.scale().addTo(vm.map);
                }
                if (vm.config.controls.coordinate) {
//                vm.controls.coordinateControl = L.control.coordinates().addTo(vm.map);
                }


                /* Map Event Listeners */
                vm.map.on("click", function () {
                    //$log.info('click', event);
                });
                
                vm.map.on("moveend", function () {
                    var thisMap = this;

                    // $log.info('moveend', event, thisMap._loaded);
                    if (!thisMap._loaded) {
                        return;
                    }

                    var view = {
                        lat: thisMap.getCenter().lat,
                        lng: thisMap.getCenter().lng,
                        zoom: thisMap.getZoom()
                    };
                    $timeout(function () {
                        if ($scope.nimBounds) {
                            _.assign($scope.nimBounds, thisMap.getBounds());
                        }
                        else {
                            $scope.nimBounds = thisMap.getBounds();
                        }    
                    });
                    LeafletMapService.setView(vm.id, view);
                });

                vm.map.on('draw:created', function (event) {
                    var layer = event.layer;

                    if(!$scope.nimOptions.allowMultiple){
                        vm.overlays["My Drawings"].clearLayers();
                    }
                    vm.overlays["My Drawings"].addLayer(layer);

                    $timeout(function(){
                        $scope.nimDrawingResult = vm.overlays["My Drawings"].toGeoJSON();
                    });
                });

                vm.map.on('draw:edited', function(){
                    $timeout(function(){
                        $scope.nimDrawingResult = vm.overlays["My Drawings"].toGeoJSON();
                    });
                });

                vm.map.on('draw:deleted', function(){
                    $timeout(function(){
                        $scope.nimDrawingResult = vm.overlays["My Drawings"].toGeoJSON();
                    });
                });

                /* $scope Event Triggers */


                /* $scope Event Listeners */
                $scope.$on('$destroy', function () {
                    // Consider destroying Controls & layers first...  .removeFrom(vm.map)
                    vm.map.clearAllEventListeners();
                    vm.map.remove();
                });

                $scope.$on('nim-map-layer-filtered', function (e, data) {
                    e.preventDefault();

                    var points = [];

                    _.forEach(data, function(marker){
                        if(_.has(marker, 'geometry.coordinates')){
                            if(marker.geometry.type === 'Point'){
                                points.push(angular.copy(marker.geometry.coordinates).reverse());
                            }
                            else {
                                points = points.concat(_.map(marker.geometry.coordinates, function(coordinates){
                                    return angular.copy(coordinates).reverse();
                                }));
                            }
                        }
                    });

                    if (points.length > 0) {
                        $timeout(function () {
                            var bounds = L.latLngBounds(points);
                            vm.map.fitBounds(bounds, {
                                maxZoom: 18
                            });
                        });
                    }    
                });

                // Popup edit function
                $scope.edit = function(id){
                    InstancesWindowService.openWindow({
                        action: 'read',
                        instanceId: id
                    });
                };

                /* Expose Leaflet API to parent Controller */
                $scope.nimLeaflet = vm.map;
                $scope.nimBounds = _.result(vm.map, 'getBounds');
            });
        }

        function refreshMarkers(index, data, newIds, oldIds) {
            var key = vm.config.overlays[index].name;

            vm.overlays[key].eachLayer(function(layer){
                var id = layer.options.id;
                var newIndex = newIds.indexOf(id);
                if(newIndex >= 0){
                    // Makes sure the same layer isn't added twice
                    newIds.splice(newIndex, 1);
                }
                else if(oldIds.indexOf(id) >= 0){
                    // Removes layer no longer in view
                    vm.overlays[key].removeLayer(layer);
                }
            });

            _.forEach(data, function(p){
                var props = p.properties;
                if(newIds.indexOf(props.id) >= 0) {
                    // Converts polygon coordinates to single point
                    var latLng = polygonToPoint(p.geometry).reverse();
                    var marker = L.marker(latLng, {
                        icon: LeafletMapService.buildIconMarker(props.markerColor),
                        riseOnHover: true,
                        showOnMouseOver: true,
                        id: props.id
                    });
                    marker.bindPopup(LeafletMapService.buildPopup(props, props.title, vm.config.controls.editPopup ? $scope : null));
                    marker.on('popupopen', LeafletMapService.popupEventHandler($scope, index, 'nim-leaflet-popup-open'));
                    marker.on('popupclose', LeafletMapService.popupEventHandler($scope, index, 'nim-leaflet-popup-close'));
                    marker.addTo(vm.overlays[key]);
                }
            });
        }

        function refreshGeoJson(index, data, newIds, oldIds){
            var key = vm.config.overlays[index].name;

            vm.overlays[key].eachLayer(function(layer){
                var id = layer.feature.properties.id;
                var newIndex = newIds.indexOf(id);
                if(newIndex >= 0){
                    // Makes sure the same layer isn't added twice
                    newIds.splice(newIndex, 1);
                }
                else if(oldIds.indexOf(id) >= 0){
                    // Removes layer no longer in view
                    vm.overlays[key].removeLayer(layer);
                }
            });

            _.forEach(data, function(g){
                if(newIds.indexOf(g.properties.id) >= 0){
                    vm.overlays[key].addData(g);
                }
            });
        }

        //TODO: If we bring heatLayer back, refactor this to refresh similarly to previous functions
        function refreshHeat(index, data) {
            var key = vm.config.overlays[index].name;

            // remove markers
            vm.markers[key] = [];

            // create markers
            for (var j = 0; j < data.length; j++){
                vm.markers[key].push(L.latLng(data[j].lat, data[j].lng));
            }
            vm.overlays[key].setLatLngs(vm.markers[key]);
        }

        function watchCallback(index, layerType) {
            $scope.$watchCollection('nimOptions.overlays[' + index + '].data', function (newValue, oldValue) {
                if (newValue && !angular.equals(newValue, oldValue)) {
                    oldValue = oldValue || [];

                    var newIds = newValue.map(function(e){ return e.properties.id; });
                    var oldIds = oldValue.map(function(e){ return e.properties.id; });

                    // Reduces set of new items to exclude items shared with oldValue
                    // currentIds = items removed
                    var currentIds = _.remove(newIds, function(e){
                        return oldIds.indexOf(e) >= 0;
                    });

                    // Reduces set of old items to exclude items shared with newValue (currentIds)
                    _.remove(oldIds, function(e){
                        return currentIds.indexOf(e) >= 0;
                    });

                    switch(layerType){
                        case 'L.heatLayer':
                            refreshHeat(index, newValue, oldValue);
                            break;
                        case 'nim.geoJson':
                            refreshGeoJson(index, newValue, newIds, oldIds);
                            break;
                        case 'nim.marker':
                        case 'nim.markerClusterGroup':
                            refreshMarkers(index, newValue, newIds, oldIds);
                            break;
                    }
                }
            });
        }

        function polygonToPoint(geom){
            if(geom.type != 'Point'){
                // Couldn't find leaflet function for getting the center for a polygon
                var coords = geom.coordinates[0];

                return coords.reduce(function (x,y) {
                    return [x[0] + y[0]/coords.length, x[1] + y[1]/coords.length];
                }, [0,0]);
            }
            else {
                return geom.coordinates;
            }
        }
    }])

    .directive('nimLeaflet', function nimLeaflet() {
        return {
            restrict: 'AE',
            scope: {
                nimBounds: '=',
                nimDrawingResult: '=',
                nimOptions: '=',
                nimLeaflet: '=',
                nimLeafletId: '@'
            },
            controller: 'NimLeafletCtrl',
            controllerAs: 'vm',
            template: function(/*element, attributes*/) {
                //Model was looking for 'vm.leafletId' in nimLeaflet controller and finding nothing
                //return '<div id="' + attributes.nimLeafletId + '" style="position:absolute;top:0;bottom:0;right:0;left:0;"></div>';
                return '<div id="{{vm.id}}" style="position:absolute;top:0;bottom:0;right:0;left:0;"></div>';
            },
            link: function(scope, element, attributes, controller) {
                controller.init();
            }
        };
    })
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name LeafletListService
     * @alias cerberus/ui:LeafletListService
     * @description Provides lookup values for configuring map object layers
     */
    .factory('LeafletListService', ["_", function LeafletListService(_) {
        var service = {
            basemaps: basemaps,
            layers: layers,
            usesUrlLookUp: usesUrlLookUp,
            layerTypeLookUp: layerTypeLookUp
        };
        return service;
        ////////////////////
        function basemaps() {
            return {
                'mapbox.streets': 'Streets',
                'mapbox.light':'Light',
                'mapbox.dark':'Dark',
                'mapbox.satellite':'Satellite',
                'mapbox.streets-satellite':'Streets Satellite',
                'mapbox.wheatpaste':'Wheatpaste',
                'mapbox.streets-basic':'Streets Basic',
                'mapbox.comic':'Comic',
                'mapbox.outdoors':'Outdoors',
                'mapbox.run-bike-hike':'Run Bike Hike',
                'mapbox.pencil':'Pencil',
                'mapbox.pirates':'Pirates',
                'mapbox.emerald':'Emerald',
                'mapbox.high-contrast':'High Contrast'
                //'custom': 'Custom'
            };
        }
        function layers(includeNimLayers) {
            var overlays = {
                'esri.tiledMapLayer':'Esri Tile Layer',
                'esri.dynamicMapLayer': 'Esri Dynamic Layer',
                'esri.featureLayer': 'Esri Feature Layer',
                //'esri.clusteredFeatureLayer': 'Esri Marker Clustered Layer',
                //'esri.imageMapLayer': 'Esri Image Layer',
                'L.tileLayer': 'Tile Layer',
                'L.tileLayer.wms': 'WMS Tile Layer',
                'nim.geoJson': 'Geographic Data',
                //'L.heatLayer': 'Heat Layer',
                //'L.KML': 'KML Layer',
                //'L.geoJson': 'Geo JSON Layer',
                'nim.marker': 'Marker Layer',
                'nim.markerClusterGroup': 'Marker Clustered Layer'
            };

            if(includeNimLayers === false){
                overlays = _.omit(overlays, ['nim.marker', 'nim.markerClusterGroup', 'nim.geoJson']);
            }

            return overlays;
        }
        function usesUrlLookUp(){
            return {
                'esri.tiledMapLayer': true,
                'esri.dynamicMapLayer': true,
                'esri.featureLayer': true,
                'L.tileLayer': true,
                'L.tileLayer.wms': true,
                'L.KML': true
            };
        }
        // Only for wms for now
        function layerTypeLookUp(){
            return {
                'mapbox.streets': 'mapbox',
                'mapbox.light':'mapbox',
                'mapbox.dark':'mapbox',
                'mapbox.satellite':'mapbox',
                'mapbox.streets-satellite':'mapbox',
                'mapbox.wheatpaste':'mapbox',
                'mapbox.streets-basic':'mapbox',
                'mapbox.comic':'mapbox',
                'mapbox.outdoors':'mapbox',
                'mapbox.run-bike-hike':'mapbox',
                'mapbox.pencil':'mapbox',
                'mapbox.pirates':'mapbox',
                'mapbox.emerald':'mapbox',
                'mapbox.high-contrast':'mapbox',
                'esri.tiledMapLayer': 'esri',
                'esri.dynamicMapLayer': 'esri',
                'esri.featureLayer': 'esri',
                'esri.clusteredFeatureLayer': 'esri',
                'esri.imageMapLayer': 'esri',
                'L.tileLayer': 'leaflet',
                'L.tileLayer.wms': 'wms',
                'nim.geoJson': 'nim',
                'L.heatLayer': 'leaflet',
                'L.KML': 'leaflet',
                'L.geoJson': 'leaflet',
                'nim.marker': 'nim',
                'nim.markerClusterGroup': 'nim'
            };
        }
    }])
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name LeafletMapService
     * @alias cerberus/ui:LeafletMapService
     * @description Provides functions for building leaflet maps
     */
    .factory('LeafletMapService', ["_", "$window", "$compile", "LeafletListService", "mapboxConfig", function LeafletMapService(_, $window, $compile, LeafletListService, mapboxConfig) {
        var localStorage = $window.localStorage || {};
        var L = $window.L;
        var service = {
            getView: getView,
            setView: setView,
            buildBasemaps: buildBasemaps,
            buildLayers: buildLayers,
            buildLayer: buildLayer,
            buildIconMarker: buildIconMarker,
            buildPopup: buildPopup,
            popupEventHandler: popupEventHandler,
            geoJsonOptions: geoJsonOptions,
            isCollection: isCollection
        };
        return service;
        ////////////////////
        /**
         * Retrieves last view from local storage
         * @returns {object}
         */
        function getView(id) {
            var view = localStorage[id];
            try {
                view = $window.JSON.parse(view);
            }
            catch (e) {
                view = null;
            }
            return view;
        }

        /**
         * Sets local storage view
         */
        function setView(id, view) {
            localStorage[id] = $window.JSON.stringify(view);
        }

        /**
         *
         * @param configs
         * @param basemaps
         * @param map
         */
        function buildBasemaps(configs, basemaps, map) {
            var token = mapboxConfig.token;
            var basemapsDict = LeafletListService.basemaps();
            var layersDict = LeafletListService.layers();
            var defaultBasemap = null;
            var lastBasemap = null;

            // Populate basemap object reference
            for (var i = 0; i < configs.length; i++) {
                var label;
                if (basemapsDict[configs[i].type]) {
                    label = configs[i].name || basemapsDict[configs[i].type];
                    basemaps[label] = L.tileLayer('https://{s}.tiles.mapbox.com/v4/' +
                        configs[i].type + '/{z}/{x}/{y}.png?access_token=' +
                        token, {noWrap: true, continuousWorld: false, maxZoom: 22, maxNativeZoom:18});
                }
                else if (layersDict[configs[i].type]) {
                    label = configs[i].name;
                    buildLayer(configs[i], basemaps, map);
                }
                lastBasemap = label;
                if (configs[i].visible){
                    defaultBasemap = configs[i].name;
                }
            }

            // Set Initial Basemap
            if (map) {
                if (defaultBasemap) {
                    map.addLayer(basemaps[defaultBasemap]);
                }
                else if (lastBasemap) {
                    map.addLayer(basemaps[lastBasemap]);
                }
            }
        }

        /**
         * (Convenience function) Parses and configures multiple layers for Leaflet
         * @param {Array} configs - defines the layer parameters
         * @param {object} layers - will hold the layerGroup
         * @param {*} map - Leaflet map
         * @param markers
         * @param watchCallback
         * @param scope
         */
        function buildLayers(configs, layers, map, markers, watchCallback, scope) {
            for (var j = 0; j < configs.length; j++) {
                buildLayer(configs[j], layers, map, markers, watchCallback, j, scope);
            }
        }

        /**
         * Parses and configures a layer for Leaflet.  This will also add layers to the map
         * @param {object} config - defines the layer parameters
         * @param {object} layers - reference to layers object
         * @param {*} map - Leaflet map
         * @param markers
         * @param watchCallback
         * @param idx
         * @param scope
         */
        function buildLayer(config, layers, map, markers, watchCallback, idx, scope) {
            var type = config.type,
                name = config.name,
                url = config.url,
                settings = config.settings;
            if (type && name) {
                switch (type) {
                    case 'nim.marker':
                        // TODO: Styling functions
                        layers[name] = L.layerGroup({opacity: settings.opacity});
                        markers[name] = [];
                        watchCallback(idx, type);
                        break;
                    case 'nim.markerClusterGroup':
                        // TODO: Styling functions
                        layers[name] = L.markerClusterGroup({opacity: settings.opacity});
                        markers[name] = [];
                        watchCallback(idx, type);
                        break;
                    case 'nim.geoJson':
                        layers[name] = L.geoJson(null, geoJsonOptions(scope, idx));
                        markers[name] = [];
                        watchCallback(idx, type);
                        break;
                    case 'L.geoJson':
                        //TODO: geoJson Styling and Build functions
                        layers[name] = L.geoJson();
                        break;
                    case 'L.heatLayer':
                        markers[name] = [];
                        layers[name] = L.heatLayer(markers[name]);
                        watchCallback(idx, type);
                        break;
                    case 'L.KML':
                        //TODO: geoJson Styling and Build functions
                        layers[name] = L.KML(url, {async: true});
                        break;
                    case 'L.tileLayer':
                        settings.noWrap = true;
                        settings.continuousWorld = false;
                        layers[name] = L.tileLayer(url, settings);
                        break;
                    case 'L.tileLayer.wms':
                        layers[name] = L.tileLayer.wms(url, settings);
                        break;
                    case 'esri.tiledMapLayer':
                        //layers[name] = L.esri.tiledMapLayer(url, settings);
                        settings = settings || {};
                        settings.url = url;
                        layers[name] = L.esri.tiledMapLayer(settings);
                        break;
                    case 'esri.dynamicMapLayer':
                        //layers[name] = L.esri.dynamicMapLayer(url, settings);
                        settings = settings || {};
                        settings.url = url;
                        layers[name] = L.esri.dynamicMapLayer(settings);
                        break;
                    case 'esri.featureLayer':
                        //TODO: Styling Functions
                        //layers[name] = L.esri.featureLayer(url);
                        layers[name] = L.esri.featureLayer({url: url});
                        break;
                    case 'esri.clusteredFeatureLayer':
                        //TODO: Styling and Build functions
                        layers[name] = L.esri.clusteredFeatureLayer();
                        break;
                }
            }

            // Turn on overlays with visible: truthy
            if (map && config.visible && layers[name]) {
                map.addLayer(layers[name]);
            }
        }

        function geoJsonOptions(scope, layerIndex){
            var settings = scope.nimOptions.overlays[layerIndex].settings;
            var opacity = 1;
            if(settings && settings.hasOwnProperty('opacity')){
                opacity = settings.opacity;
            }

            return {
                onEachFeature: function (feature, layer) {
                    layer.bindPopup(buildPopup(feature.properties,feature.properties.title,scope));

                    layer.on('popupopen', popupEventHandler(scope, layerIndex, 'nim-leaflet-popup-open'));
                    layer.on('popupclose', popupEventHandler(scope, layerIndex, 'nim-leaflet-popup-close'));
                },
                style: function(feature){
                    var styleOptions = {
                        opacity: opacity
                    };
                    var markerColor = feature.properties.markerColor;
                    styleOptions.markerColor = markerColor;
                    styleOptions.color = markerColor;
                    switch(markerColor){
                        case 'orange-dark':
                            styleOptions.color = 'red';
                            break;
                        case 'green-light':
                            styleOptions.color = 'green';
                            break;
                        case 'cyan':
                            styleOptions.color = 'blue';
                            break;
                        case 'violet':
                            styleOptions.color = 'purple';
                            break;
                    }
                    styleOptions.fillColor = styleOptions.color;

                    var pathOptions = scope.nimOptions.overlays[layerIndex].pathOptions;
                    if(pathOptions){
                        if(pathOptions.hasOwnProperty('weight') && !isNaN(pathOptions.weight)){
                            styleOptions.weight = pathOptions.weight;
                        }
                        if(pathOptions.color && pathOptions.color !== 'default'){
                            styleOptions.color = pathOptions.color;
                        }
                        if(pathOptions.fillColor && pathOptions.fillColor !== 'default'){
                            styleOptions.fillColor = pathOptions.fillColor;
                        }
                    }

                    return styleOptions;
                },
                pointToLayer: function(feature, point){
                    return L.marker(point, {
                        icon: service.buildIconMarker(feature.properties.markerColor),
                        riseOnHover: true,
                        showOnMouseOver: true,
                        opacity: opacity
                    });
                }
            };
        }


        /**
         * @function isCollection
         * Determines the data structure of an array or object
         * @param data
         * @returns {{type: string, mapping: {lat: *, lon: *}}}
         */
        function isCollection(data) {
            if (data.isArray() && data.length > 0) {
                // if Array
                if (data[0].isArray() && data.length > 1) {
                    if (typeof data[0][0] === 'object') {
                        var x, y;
                        for (var key in data[0][0]) {
                            // lat = y, long = x
                            if (data[0][0].hasOwnProperty(key)) {
                                if (key === "lat") {
                                    y = key;
                                }
                                else if (key === "lon") {
                                    x = key;
                                }
                                else if (key === "lng") {
                                    x = key;
                                }
                                else if (key === "long") {
                                    x = key;
                                }
                                else if (key === "x") {
                                    x = key;
                                }
                                else if (key === "y") {
                                    y = key;
                                }
                                else if (key === "latitude") {
                                    y = key;
                                }
                                else if (key === "longitude") {
                                    x = key;
                                }
                            }
                        }
                        return {
                            type: 'collection',
                            mapping: {
                                lat: y,
                                lng: x
                            }
                        };
                    }
                }
            }
        }

        /**
         * Builds an icon marker for use with Leaflet
         * @param {string} color
         * @param {string} shape
         * @param {string} icon
         * @returns {*}
         */
        function buildIconMarker(color, shape, icon) {
            return $window.L.ExtraMarkers.icon({
                markerColor: color || 'cyan',
                shape: shape || 'circle',
                icon: icon || 'fa-circle',
                prefix: 'fa'
            });
        }

        /**
         * Builds a popup template for leaflet layers
         * @param {object} obj
         * @param {string} title
         * @param {Scope} scope
         * @returns {string}
         */
        function buildPopup(obj, title, scope) {
            var html = '<div>';
            if (title) {
                html += '<h4>' + title + '</h4>';
            }
            html += '<table class="table table-condensed"><tbody>';
            for (var key in obj) {
                if (obj.hasOwnProperty(key) && key !== 'title' && key !== 'markerColor' && key !== "lat" && key !=="lng" && key !=="id") {
                                        // removes underscore added in viz-map-directive
                    html += '<tr><td>' + key.replace('_', '') + ':</td>' + '<td>' + obj[key] + '</td></tr>';
                }
            }
            html += '</tbody></table>';

            // TODO: Move this logic out to the Viz directive
            if(scope && scope.nimOptions.controls.editPopup){
                html += '<div class="btn-group"><button class="btn btn-default" ng-click="edit(' + obj.id + ')">Details</button></div></div>';
                return $compile(html)(scope)[0];
            }
            else {
                html += '</div>';
                return html;
            }
        }

        function popupEventHandler(scope, index, event){
            return function(e){
                var dataSourceId = scope.nimOptions.overlays[index].queryId;
                var instanceId = _.get(e.target, 'feature.properties.id', _.get(e.target, 'options.id', null));
                scope.$emit(event, dataSourceId, instanceId);
            };
        }
    }])
;
angular.module('cerberus.ui')
    .controller('nimFilterFormCtrl', ["_", "moment", "$scope", "$rootScope", "$element", "$timeout", "OdataUtilityService", "VizUtilityService", function nimFilterFormCtrl(_, moment, $scope, $rootScope, $element, $timeout, OdataUtilityService, VizUtilityService) {
        var vm = this;

        $scope.btnClass = $scope.btnClass || 'default';
        $scope.debounce = {
            debounce: {
                'default': 300,
                blur: 0
            }
        };

        vm.value = null;
        vm.endValue = null;
        vm.operator = 'eq';
        vm.defaultFilterSet = false;
        vm.operatorSymbols = OdataUtilityService.operatorSymbols();
        vm.operators = OdataUtilityService.operators();
        vm.dateRangeOperators = _.map(vm.operators.dateRange, dateRangeMap);
        vm.dateRanges = {
            '': true,
            thisYtD: true,
            thisQtD: true,
            thisMtD: true,
            yesterday: true,
            today: true
        };

        vm.applyFilter = applyFilter;
        vm.clearFilter = clearFilter;
        vm.scopeApplyFilter = scopeApplyFilter;
        vm.dateRangeOpFilter = dateRangeOpFilter;
        vm.setDateRangeValues = setDateRangeValues;

        init();

        function init() {
            if($scope.params){
                vm.value = $scope.params.value || vm.value;
                vm.endValue = $scope.params.endValue || vm.endValue;
                vm.operator = $scope.params.operator || vm.operator;

                _.assign(vm.dateRanges, $scope.params.dateRangeOperators);

                vm.lookupOptions = {
                    optionLabel: {
                        id: '',
                        display: 'Choose...'
                    },
                    dataTextField: 'display',
                    dataValueField: 'id',
                    filter: 'contains',
                    change: scopeApplyFilter,
                    dataSource: {
                        type: 'odata',
                        serverFiltering: true,
                        serverSorting: true,
                        serverPaging: true,
                        pageSize: 20,
                        transport:{
                            read:{
                                dataType:'json',
                                url:'/server/rest/v1/views/' + $scope.params.viewId + '/odata.svc?$lookupDisplay=' + $scope.params.column,
                                beforeSend: function(xhr){
                                    xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                                    xhr.setRequestHeader('WSID',$rootScope.userData.currentWorkspace.id);
                                },
                                // data: function (dataOptions) {
                                //     var urlParams = {};
                                    
                                //     if (dataOptions.filter) {
                                //         urlParams.$filter = OdataUtilityService.toOdataFilter(dataOptions.filter);
                                //         delete dataOptions.filter;
                                //     }

                                //     return urlParams;
                                // }
                                data: function (dataOptions) {
                                    var urlParams = {},
                                        filterConfig = {filters: [], logic: 'and'};
                                    
                                    if (dataOptions.filter) {
                                        // filterConfig = angular.copy(dataOptions.filter);
                                        filterConfig.filters.push(angular.copy(dataOptions.filter));
                                        delete dataOptions.filter;
                                    }

                                    if ($scope.params.filter) {
                                        filterConfig.filters.push($scope.params.filter);
                                    }

                                    if ($scope.params.useParentFilter) {
                                        var parentFilters = [];

                                        _.forEach($scope.params.parentFilterMap, function (field, filterKey) {
                                            var filterValue = angular.copy($scope.filters[filterKey]);
                                            if (filterValue) {
                                                _.forEach(filterValue.filters, function (filter) {
                                                    filter.field = field;
                                                });

                                                parentFilters.push(filterValue);
                                            }
                                        });

                                        if (parentFilters.length > 0) {
                                            filterConfig.filters.push({
                                                filters: parentFilters,
                                                logic: $scope.params.parentFilterLogic || 'and'
                                            });
                                        }
                                    }

                                    VizUtilityService.cleanFilterConfiguration(filterConfig.filters);
                                    if (filterConfig.filters.length > 0) {
                                        urlParams.$filter = OdataUtilityService.toOdataFilter(filterConfig);
                                    }

                                    return urlParams;
                                }
                            }
                        },
                        change: function(e){
                            var selectedItem = vm.value;

                            if (selectedItem && selectedItem.id) {
                                var id = selectedItem.id,
                                    dataItem = e.sender.get(id);
                                
                                if (id !== -1 && !dataItem) {
                                    e.sender.add(selectedItem);
                                }
                                else if (!selectedItem.display && dataItem) {
                                    vm.value = dataItem;
                                }
                            }    
                        },
                        sort: {field: 'display', dir: 'asc'}
                    }
                };

                if ($scope.params.useParentFilter) { 
                    $scope.$watch(function () {
                        return _.pick($scope.filters, _.keys($scope.params.parentFilterMap));
                    }, function () {
                        _.result(vm, 'lookupFilter.dataSource.read');
                    }, true);
                }
            }

            if($scope.type === 'dateRange' && $scope.params.operator){
                setDateRangeValues($scope.params.operator);
            }

            if($scope.type === 'lookup'){
                fixLookupWidth();
            }

            if($scope.defaultFilter && !_.isEmpty($scope.defaultFilter[$scope.id])){
                vm.value = $scope.defaultFilter[$scope.id];
                vm.defaultFilterSet = true;
            }
            else if ($scope.filters[$scope.id] && !$scope.isPreview) {
                readFilter();
                return;
            }

            if(vm.value){
                applyFilter();
            }
        }

        // This adjusts the dropdownlist's width to fit the input group
        function fixLookupWidth() {
            $scope.$watchGroup([
                function () { return $element.find('.form-group').width(); },
                function () { return $element.find('.input-group-btn').width(); }
            ], function (widths) {
                var groupWidth = widths[0],
                    buttonWidth = widths[1],
                    selectWidth = groupWidth - buttonWidth;
                
                var select = $element.find('.input-group > span.k-dropdown');

                if (select.length) {
                    select.width(selectWidth);
                }
            });
        }

        function applyFilter(){
            if(!_.isNull(vm.value) || !_.isNull(vm.endValue)) {
                switch ($scope.type) {
                    case 'string':
                    case 'date':
                        $scope.filters[$scope.id] = simpleFilter();
                        return;

                    case 'number':
                        $scope.filters[$scope.id] = numberFilter();
                        return;

                    case 'lookup':
                        $scope.filters[$scope.id] = lookupFilter();
                        return;

                    case 'dateRange':
                        $scope.filters[$scope.id] = dateRangeFilter();
                        return;
                }
            }

            $scope.filters[$scope.id] = null;
        }

        // Kendo callback - manually calls digest
        function scopeApplyFilter(){
            $timeout(vm.applyFilter);
        }

        function simpleFilter(){
            if(vm.value || vm.value === 0) {
                return {
                    filters: [{
                        value: vm.value,
                        operator: vm.operator,
                        field: '__nimColumn__'
                    }],
                    logic: 'and'
                };
            }

            return null;
        }

        function lookupFilter(){
            if(_.get(vm.value, 'id') && vm.value.id !== -1) {
                return {
                    filters: [{
                        value: vm.value.id,
                        lookupDisplay: vm.value.display,
                        operator: vm.operator,
                        field: '__nimColumn__'
                    }],
                    logic: 'and'
                };
            }
            return null;
        }

        function numberFilter(){
            var filters = [];

            switch(vm.operator){
                case 'between':
                    if(vm.value || vm.value === 0){
                        filters.push({
                            value: vm.value,
                            operator: 'gte',
                            field: '__nimColumn__'
                        });
                    }

                    if(vm.endValue || vm.endValue === 0){
                        filters.push({
                            value: vm.endValue,
                            operator: 'lte',
                            field: '__nimColumn__'
                        });
                    }

                    return {
                        filters: filters,
                        logic: 'and'
                    };

                case 'notBetween':
                    if(vm.value || vm.value === 0){
                        filters.push({
                            value: vm.value,
                            operator: 'lt',
                            field: '__nimColumn__'
                        });
                    }
                    if(vm.endValue || vm.endValue === 0){
                        filters.push({
                            value: vm.endValue,
                            operator: 'gt',
                            field: '__nimColumn__'
                        });
                    }
                    return {
                        filters: filters,
                        logic: 'or'
                    };

                default:
                    return simpleFilter();
            }
        }

        function dateRangeFilter(){
            if(vm.value || vm.endValue) {
                var filters = [];

                if(vm.value){
                    filters.push({
                        value: vm.value,
                        operator: 'gte',
                        field: '__nimColumn__'
                    });
                }

                if(vm.endValue){
                    filters.push({
                        value: vm.endValue,
                        operator: 'lt',
                    //  operator: 'lte',
                        field: '__nimColumn__'
                    });
                }

                return {
                    filters: filters,
                    logic: 'and'
                };
            }

            return null;
        }

		function setDateRangeValues(preset){
            var startDateTime = moment(),
                endDateTime = moment();

            switch(preset){
                case 'today':
                    startDateTime.startOf('day');
					endDateTime.startOf('day').add(1, 'days');
                //  endDateTime.endOf('day');
                    break;
                case 'yesterday':
                    startDateTime.startOf('day').subtract(1, 'days');
                    endDateTime.startOf('day');
                //  endDateTime.endOf('day').subtract(1, 'days');
                    break;
				case 'tomorrow':
					startDateTime.startOf('day').add(1, 'days');
					endDateTime.startOf('day').add(2, 'days');
                //  endDateTime.endOf('day').add(1, 'days');
					break;


                case 'thisWeek':
                    startDateTime.startOf('week');
                    endDateTime.startOf('week').add(1, 'weeks');
                //  endDateTime.endOf('week');
                    break;
                case 'lastWeek':
                    startDateTime.startOf('week').subtract(1, 'weeks');
                    endDateTime.startOf('week');
                //  endDateTime.endOf('week').subtract(1, 'weeks');
                    break;
                case 'nextWeek':
                    startDateTime.startOf('week').add(1, 'weeks');
                    endDateTime.startOf('week').add(2, 'weeks');
				//  endDateTime.endOf('week').add(1, 'weeks');
                    break;


                case 'thisMonth':
                    startDateTime.startOf('month');
                    endDateTime.startOf('month').add(1, 'months');
                //  endDateTime.endOf('month');
                    break;
                case 'thisMtD':
                    startDateTime.startOf('month');
					endDateTime.startOf('day').add(1, 'days');
                //  endDateTime.endOf('day');
                    break;
                case 'lastMonth':
                    startDateTime.startOf('month').subtract(1, 'months');
					endDateTime.startOf('month');
                //  endDateTime.endOf('month').subtract(1, 'months');
                    break;
                case 'lastMtD':
                    startDateTime.startOf('month').subtract(1, 'months');
					endDateTime.startOf('day').add(1, 'days');
                //  endDateTime.endOf('day');
                    break;
                case 'nextMonth':
                    startDateTime.startOf('month').add(1, 'months');
                    endDateTime.startOf('month').add(2, 'months');
                //  endDateTime.endOf('month').add(1, 'months');
                    break;


                case 'thisQter':
                    startDateTime.startOf('quarter');
                    endDateTime.startOf('quarter').add(1, 'quarters');
                //  endDateTime.endOf('quarter');
                    break;
                case 'thisQtD':
                    startDateTime.startOf('quarter');
					endDateTime.startOf('day').add(1, 'days');
                //  endDateTime.endOf('day');
                    break;
                case 'lastQter':
                    startDateTime.startOf('quarter').subtract(1, 'quarters');
					endDateTime.startOf('quarter');
                //  endDateTime.endOf('quarter').subtract(1, 'quarters');
                    break;
                case 'lastQtD':
                    startDateTime.startOf('quarter').subtract(1, 'quarters');
					endDateTime.startOf('day').add(1, 'days');
                //  endDateTime.endOf('day');
                    break;
                case 'nextQter':
                    startDateTime.startOf('quarter').add(1, 'quarters');
					endDateTime.startOf('quarter').add(2, 'quarters');
                //  endDateTime.endOf('quarter').add(1, 'quarters');
                    break;


                case 'thisYear':
                    startDateTime.startOf('year');
                    endDateTime.startOf('year').add(1, 'years');
                //  endDateTime.endOf('year');
                    break;
                case 'thisYtD':
                    startDateTime.startOf('year');
					endDateTime.startOf('day').add(1, 'days');
                //  endDateTime.endOf('day');
                    break;
                case 'lastYear':
                    startDateTime.startOf('year').subtract(1, 'years');
                    endDateTime.startOf('year');
                //  endDateTime.endOf('year').subtract(1, 'years');
                    break;
                case 'lastYtD':
                    startDateTime.startOf('year').subtract(1, 'years');
					endDateTime.startOf('day').add(1, 'days');
                //  endDateTime.endOf('day').subtract(1, 'years');
                    break;
                case 'nextYear':
                    startDateTime.startOf('year').add(1, 'years');
                    endDateTime.startOf('year').add(2, 'years');
                //  endDateTime.endOf('year').add(1, 'years');
                    break;
            }

            vm.value = startDateTime.toDate();
            vm.endValue = endDateTime.toDate();
            if(vm.startDatePicker) {
                vm.startDatePicker.value(vm.value);
            }
            if(vm.endDatePicker) {
                vm.endDatePicker.value(vm.endValue);
            }
        }
		
        function dateRangeMap(display, key){
            return {
                display: display,
                value: key
            };
        }

        function dateRangeOpFilter(operator){
            return vm.dateRanges[operator.value];
        }

        function readFilter() {
            var filter = $scope.filters[$scope.id];
            if (!_.isEmpty(filter.filters)) {
                switch ($scope.type) {
                    case 'string':
                    case 'date':
                        readSimpleFilter(filter);
                        return;

                    case 'number':
                        readNumberFilter(filter);
                        return;

                    case 'lookup':
                        readLookupFilter(filter);
                        return;

                    case 'dateRange':
                        readDateRangeFilter(filter);
                        return;
                }
            }    
        }

        function readSimpleFilter(filter) {
            var firstFilter = filter.filters[0];
            vm.value = firstFilter.value;
            vm.opterator = firstFilter.operator;
        }

        function readLookupFilter(filter) {
            var firstFilter = filter.filters[0];
            vm.value = { display: '', id: firstFilter.value };
            vm.operator = firstFilter.operator;

            if (firstFilter.lookupDisplay) {
                vm.value.display = firstFilter.lookupDisplay;
            }
        }

        function readNumberFilter(filter) {
            if (filter.filters.length > 1) {
                vm.value = filter.filters[0].value;
                vm.endValue = filter.filters[1].value;

                if (filter.logic == 'and') {
                    vm.operator = 'between';
                }
                else {
                    vm.operator = 'notBetween';
                }
            }
            else {
                readSimpleFilter(filter);
            }
        }

        function readDateRangeFilter(filter) {
            _.forEach(filter.filters, function (f) {
                if (f.operator == 'gte') {
                    vm.value = f.value;
                }
            //  else if (f.operator == 'lte') {
            //      vm.endValue = f.value;
            //  }
                else if (f.operator == 'lt') {
                    vm.endValue = f.value;
                }
            });
        }

        function clearFilter(){
            vm.value = null;
            vm.endValue = null;

            applyFilter();
        }
    }])
    .directive('nimFilterForm', function() {
        return {
            restrict: 'AE',
            controller: 'nimFilterFormCtrl',
            controllerAs: 'vm',
            templateUrl: 'ui/nim-odata/filter-form.tpl.html',
            scope: {
                filters: '=nimFilterForm',
                defaultFilter: '=nimDefaultFilters',
                id: '@',
                type: '=',
                label: '=',
                icon: '=',
                params:'=',
                btnClass:'='
            }
        };
    })
;

angular.module('cerberus.ui')
    /**
     * --------------------------------------------------------------------------------------------
     * @TODO: ADDED BY DHZ ON JAN/11/2019  -  NEED FIX ON "DATE FILTER"
     * @TODO: FIX "Equal to" & "Not equal to" should become range (full day not only 00:00:00), 
     * @TODO: FIX "After" to look at 23:59:59 greater than, (NO RANGE).
     * @TODO: FIX "Before or equal" to look at 23:59:59 less or equal than, (NO RANGE).
     * @TODO: CAN BE FOUND IN OPERATORS AND Functions: simpleFilter & readSimpleFilter similar to readNumberFilter and NumberFilter with "case" options
     * --------------------------------------------------------------------------------------------
     * @ngdoc service
     * @name OdataUtilityService
     * @alias cerberus/ui:OdataUtilityService
     * @description Assists in the creation of Odata filters
     */
    .factory('OdataUtilityService', ["kendo", "moment", function OdataUtilityService(kendo, moment) {
        // Declare oData filters to allow for easier upgrades to future specs
        var odataFilters = {
            eq: "eq",
            neq: "ne",
            gt: "gt",
            gte: "ge",
            lt: "lt",
            lte: "le",
            contains : "substringof",
            doesnotcontain: "substringof",
            endswith: "endswith",
            startswith: "startswith",
            isnull: "isnull",
            isnotnull: "isnotnull"
        };

        return {
            toOdataFilter: toOdataFilter,
            toOdataString: toOdataString,
            operators: operators,
            messages: messages,
            operatorSymbols: operatorSymbols
        };

        ////////////////////
        /**
         * @function messages
         * @return {object} of ui messages
         */
        function messages() {
            return {
                info: "Show items that:",
                isTrue: "is true",
                isFalse: "is false",
                filter: "Filter",
                clear: "Clear",
                and: "And",
                or: "Or",
                selectValue: "-Select value-",
                operator: "Operator",
                value: "Value",
                cancel: "Cancel"
            };
        }
        /**
         * @function operatorSymbols
         * @return {object} of Odata Operator symbols by type
         */
        function operatorSymbols() {
            return {
                between: 'From',
                notBetween: 'Not from',
                eq: '=',
                neq: '!=',
                gte: ">=",
                gt: ">",
                lte: "<=",
                lt: "<",
                startswith: 'Start with:',
                contains: '&sub;',
                doesnotcontain: '&nsub;',
                endswith: 'End with:'
            };
        }
        /**
         * @function operators
         * @return {object} of Odata Operators by type
         */
        function operators() {
            var EQ = "Equal to";
            var NEQ = "Not equal to";
            return {
                date: {
                    eq: EQ,
                    neq: NEQ,
                    gte: "After or equal to",
                    gt: "After",
                    lte: "Before or equal to",
                    lt: "Before"
                },
                dateRange: {
                    today: 'Today',
                     yesterday: 'Yesterday',
                     tomorrow: 'Tomorrow',
                    thisWeek: 'This Week',
                     lastWeek: 'Last Week',
                     nextWeek: 'Next Week',
                    thisMonth: 'This Month',
                     thisMtD: 'This Month-to-date',
                     lastMonth: 'Last Month',
                     lastMtD: 'Last Month-to-date',
                     nextMonth: 'Next Month',
                    thisQter: 'This Quarter',
                     thisQtD: 'This Quarter-to-date',
                     lastQter: 'Last Quarter',
                     lastQtD: 'Last Quarter-to-date',
                     nextQter: 'Next Quarter',
                    thisYear: 'This Year',
                     thisYtD: 'This Year-to-date',
                     lastYear: 'Last Year',
                     lastYtD: 'Last Year-to-date',
                     nextYear: 'Next Year'
                },
                number: {
                    between: 'Between or equal to',
                    notBetween: 'Not Between or equal to',
                    eq: EQ,
                    neq: NEQ,
                    gte: "Greater or equal to",
                    gt: "Greater",
                    lte: "Less or equal to",
                    lt: "Less"
                },
                string: {
                    eq: EQ,
                    neq: NEQ,
                    startswith: "Start with",
                    contains: "Contain",
                    doesnotcontain: "Does not contain",
                    endswith: "End with"
                },
                enums: {
                    eq: EQ,
                    neq: NEQ
                },
                lookup: {
                    eq: EQ,
                    neq: NEQ
                }
            };
        }
        /**
         * @function toOdataFilter
         * @param {object} filter - an object with javascript values
         * @return {object} with values in the proper string Odata format
         */
        function toOdataFilter(filter) {
            var result = [],
                logic = filter.logic || "and",
                idx,
                length,
                field,
                type,
                format,
                operator,
                value,
                // ignoreCase,
                filters = filter.filters,
                isColumnValue;

            for (idx = 0, length = filters.length; idx < length; idx++) {
                filter = filters[idx];
                field = filter.field;
                value = filter.value;
                operator = filter.operator;
                isColumnValue = filter.isColumnValue;

                if (filter.filters) {
                    filter = toOdataFilter(filter);
                } else if(field) {
                    // ignoreCase = filter.ignoreCase;
                    field = field.replace(/\./g, "/");
                    filter = odataFilters[operator];

                    if(filter === "isnull"){
                        filter = kendo.format("{0} eq null", field);
                    }
                    else if(filter === "isnotnull"){
                        filter = kendo.format("{0} ne null", field);
                    }
                    else if (filter && value !== undefined) {
                        type = $.type(value);
                        if (type === "string" && !isColumnValue && value !== 'null') {
                            var parsedDateValue;
                            if (value === '@nim_now') {
                                parsedDateValue = new Date();
                            }
                            else if (
                                (value === '@nim_today') ||
                                (value === '@nim_7days') ||
                                (value === '@nim_30days') ||
                                (value === '@nim_60days') ||
                                (value === '@nim_90days') ||
                                (value === '@nim_180days') ||
                                (value === '@nim_365days') ||
                                (value === '@nim_currYear') ||
                                (value === '@nim_lastYear')
                            ) {
                                result.push(
                                    momentTimeFilter(field, filter, value)
                                );
                                continue;
                            }
                            else {
                                // replaced by HD 2019-07-03
                                // parsedDateValue = kendo.parseDate(value, ['yyyy-MM-ddTHH:mm:ss', 'yyyy-MM-ddTHH:mm:ss.fffZ']);
                                parsedDateValue = kendo.parseDate(value, ['yyyy-MM-ddTHH:mm:ssz', 'yyyy-MM-ddTHH:mm:ss.fffz'], 'yyyy-MM-ddTHH:mm:sszzz');
                            }

                            if(parsedDateValue instanceof Date){
                                value = parsedDateValue.toISOString();
                                format = "datetime'{1}'";
                            }
                            else {
                                format = "'{1}'";
                                value = value.replace(/'/g, "''");

                                // if (ignoreCase === true) {
                                //     field = "tolower(" + field + ")";
                                // }
                            }

                        } else if (type === "date") {
                            value = value.toISOString();
                            format = "datetime'{1}'";
                        } else {
                            format = "{1}";

                            if(type === 'number'){
                                value += 'f';
                            }
                        }

                        if (filter.length > 3) {
                            if (filter !== "substringof") {
                                format = "{0}({2}," + format + ")";
                            } else {
                                format = "{0}(" + format + ",{2})";
                                if (operator === "doesnotcontain") {
                                    format += " eq false";
                                }
                            }
                        } else {
                            format = "{2} {0} " + format;
                        }
                        filter = kendo.format(format, filter, value, field);
                    }
                }

                result.push(filter);
            }

            filter = result.join(" " + logic + " ");

            //if (result.length > 1) {
                filter = "(" + filter + ")";
            //}

            return filter;
        }
        /**
         * @function momentTimeFilter
         * @param {string} field - a string with javascript values from data source column
         * @param {string} operator - a string with javascript values from filter operator
         * @param {string} value - a string with javascript values from filter column
                                (value === '@nim_today') ||
                                (value === '@nim_7days') ||
                                (value === '@nim_30days') ||
                                (value === '@nim_60days') ||
                                (value === '@nim_90days') ||
                                (value === '@nim_180days') ||
                                (value === '@nim_365days') ||
                                (value === '@nim_currYear') ||
                                (value === '@nim_lastYear')
         * @return {string} with values in the proper Kendo datetime format
         */
        function momentTimeFilter(field, operator, value) {
            var format, startOfDay, endOfDay;

            switch (value) {
                case '@nim_7days':
                    startOfDay = moment().subtract(7, 'days').startOf('day').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
                    break;

                case '@nim_30days':
                    startOfDay = moment().subtract(30, 'days').startOf('day').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
                    break;

                case '@nim_60days':
                    startOfDay = moment().subtract(60, 'days').startOf('day').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
                    break;

                case '@nim_90days':
                    startOfDay = moment().subtract(90, 'days').startOf('day').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
                    break;

                case '@nim_180days':
                    startOfDay = moment().subtract(180, 'days').startOf('day').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
                    break;

                case '@nim_365days':
                    startOfDay = moment().subtract(365, 'days').startOf('day').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
                    break;

                case '@nim_currYear':
                    startOfDay = moment().startOf('year').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
                    break;

                case '@nim_lastYear':
                    startOfDay = moment().subtract(1, 'year').startOf('year').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
                    break;

                default: // @nim_today
                    startOfDay = moment().startOf('day').toISOString();
                    endOfDay = moment().endOf('day').toISOString();
            }

            switch (operator) {
                case 'ne':
                    format = '({0} lt datetime\'{1}\' or {0} gt datetime\'{2}\')';
                    break;

                case 'ge':
                    format = '{0} ge datetime\'{1}\'';
                    break;

                case 'gt':
                    if (value === '@nim_today') {
                        format = '{0} gt datetime\'{2}\''; // [greater than] - 'end of Today'; (not including current day).
                    } else {
                        format = '{0} gt datetime\'{1}\'';
                    }
                    break;

                case 'le':
                    if (value === '@nim_today') {
                        format = '{0} le datetime\'{2}\''; // [less or equal] - 'end of Today'; (including current day).
                    } else {
                        format = '{0} le datetime\'{1}\'';
                    }
                    break;

                case 'lt':
                    format = '{0} lt datetime\'{1}\'';
                    break;

                default: // eq
                    format = '({0} ge datetime\'{1}\' and {0} le datetime\'{2}\')';
            }

            return kendo.format(format, field, startOfDay, endOfDay);
        }
        /**
         * @function toOdataString
         * @param {object} operator - Odata operator
         * @param {Array} values - left and values for operator comparison
         * @param {object} field - field name for filtering by
         * @return {string} URL parameter for oData
         */
        function toOdataString(operator, values, field) {
            values = values.map(function(val){
                if(typeof val === 'number'){
                    return val + 'f';
                }
            });

            var filter = {
                logic: 'and',
                filters: [
                    {
                        field: field,
                        value: values[0],
                        operator: operator
                    }
                ]
            };
            if (operator === 'between') {
                filter.filters[0].operator = 'gte';
                filter.filters[1] = {
                    field: field,
                    value: values[1],
                    operator: 'lte'
                };
            }
            if (operator === 'notBetween') {
                filter.filters[0].operator = 'lte';
                filter.filters[1] = {
                    field: field,
                    value: values[1],
                    operator: 'gte'
                };
            }
            return filter;
        }
    }])
;
angular.module('cerberus.core')
    .controller('InstancePushActionCtrl', ["_", "$q", "$scope", "kendo", "InstanceId", "actionType", "pushActionStruct", "$uibModalInstance", "WorkflowsClassService", "pushActionService", "InstancesService", function (_, $q, $scope, kendo, InstanceId, actionType, pushActionStruct, $uibModalInstance, WorkflowsClassService, pushActionService, InstancesService ) {
        var vm = this;

        vm.InstanceId = InstanceId;
        vm.pushActionStruct = pushActionStruct;
        vm.temp = {
            actionType: actionType,
            email: {}
        };
        vm.workflowEmailAccounts = WorkflowsClassService.getDefaultSettings('emailAccounts');

        vm.subjectList = [
            {value: 'Important - Invoice Confirmation', display: 'Invoice confirmation'},
            {value: 'Important - Purchase Order Confirmation', display: 'P.O. confirmation'},
            {value: 'Request reply - Quote Confirmation', display: 'Quote confirmation'},
            {value: 'Request reply - Sales Order Confirmation', display: 'S.O. confirmation'},
            {value: 'Please find the revised invoice in the email', display: 'Revised Invoice'},
            {value: 'Please find the revised Purchase Order in the email', display: 'Revised P.O.'},
            {value: 'Please find the revised Quote in the email', display: 'Revised Quote'},
            {value: 'Please find the revised Sales Order in the email', display: 'Revised S.O.'},
            {value: 'Please find a newer file version in the current email', display: 'Updated file'}
        ];

        vm.actionInProgress = false;
        vm.submitStatusError = false;
        vm.submitErrMsg = '';
        vm.submit = submit;
        vm.cancel = cancel;

        _init();

        function _init() {
            // Load all instance data values
            _getInstanceDataValues().then(function () {
                // Get all params for input push action type 'actionEmail'
                if (vm.temp.actionType === 'actionEmail') {
                    vm.temp.email = angular.copy(vm.pushActionStruct.actions.email); // Initiate default values
                    _getPushActionDataValues(vm.temp.actionType);
                }
                //else if (vm.temp.actionType === 'someOtherAction') { // Get params for other actions... (Reserved for future usage)
                //}
            });
        }

        function _getInstanceDataValues() {
            var deferred = $q.defer();
            InstancesService.getInstance(vm.InstanceId).then(function (data) {
                vm.instance = data;
                _.forEach(vm.pushActionStruct.instance, function (instanceFormAuxiliaryData, key) {
                    vm.instance[key] = instanceFormAuxiliaryData;
                });
                deferred.resolve();
            });
            return deferred.promise;
        }

        function _getPushActionDataValues(actionType) {
            if (actionType === 'actionEmail') {
                // Get subject line.
                var subject = getDataFieldValue(_.get(vm.temp.email.subject, 'text', null), _.get(vm.temp.email.subject, 'autoFill', null), _.get(vm.temp.email.subject, 'modelId', null));
                vm.temp.email.subject = subject;
                // Get 'Send To' email address line.
                var SendTo = getDataFieldValue(_.get(vm.temp.email.SendTo, 'text', null), _.get(vm.temp.email.SendTo, 'autoFill', null), _.get(vm.temp.email.SendTo, 'modelId', null));
                vm.temp.email.SendTo = SendTo;
                // Get 'Send To CC' email address line.
                var SendToCC = getDataFieldValue(_.get(vm.temp.email.SendToCC, 'text', null), _.get(vm.temp.email.SendToCC, 'autoFill', null), _.get(vm.temp.email.SendToCC, 'modelId', null));
                vm.temp.email.SendToCC = SendToCC;
                // Get 'Send To BCC' email address line.
                var SendToBCC = getDataFieldValue(_.get(vm.temp.email.SendToBCC, 'text', null), _.get(vm.temp.email.SendToBCC, 'autoFill', null), _.get(vm.temp.email.SendToBCC, 'modelId', null));
                vm.temp.email.SendToBCC = SendToBCC;
            }
        }

        function getDataFieldValue(column_StaticText, column_AutofillSource, column_FormModelField) {
            if(column_StaticText || column_AutofillSource || column_FormModelField) {
                var textValue = '',
                    autofillValue = '',
                    fieldValue = '';

                if(column_StaticText && _.isString(column_StaticText)) {
                    // Attempt to evaluate data value from workflow explicit static text column
                    textValue = column_StaticText;
                }

                if(column_AutofillSource) {
                    // Attempt to evaluate data value from instance auto-fill object container
                    autofillValue = _.get(vm.instance.autoFillData, column_AutofillSource, ''); 
                    if(_.has(autofillValue, 'display')) {
                        autofillValue = autofillValue.display;
                    }
                }

                if(column_FormModelField) {
                    // Attempt to evaluate data value from instance dataSet object container
                    fieldValue = _.get(vm.instance.dataSet, column_FormModelField, ''); 
                    if(_.has(fieldValue, 'display')) {
                        fieldValue = fieldValue.display;
                    }
                }
                // Concatenate string values and return
                var ret = ''.concat(textValue, autofillValue, fieldValue);
                return ret;
            }
            else {
                return '';
            }
        }

        function submit() {
            // Manage progress monitoring
            vm.actionInProgress = true;
            // Initiate function here
            var promiseData = {
                'action222': 'someactionhere',
                'otherstuff': 'otherCrap2'
            };
            
            vm.temp.promiseDataTempTest = promiseData;
            //temp... here we may propagate explicit instance ID State (single form printing)
            vm.temp.instance_stateId = null;
            //temp... to create invoice number
            vm.temp.instance_defaultFileName = 'Invoice_'.concat(_.get(vm.instance.dataSet, 'InvoiceNumber', '').toString());


            pushActionService.execute(vm.InstanceId, vm.temp).then(function (result) {
                var noteData = {
                    title: _.get(vm.temp.email, 'menutitle', 'Auto'),
                    body: kendo.format('{0} - {1:yyyy-MM-dd HH:mm:ss (zzz)}', '[Auto] '.concat(vm.temp.actionType), new Date()),
                    isPublic: 'YES',
                    type: 'Note'
                };
                pushActionService.placeNote(vm.InstanceId, noteData).then(function (/*result2*/) {
                    vm.actionInProgress = false;
                    if (result.errMsg) {
                        vm.submitStatusError = true;
                        vm.submitErrMsg = result.errMsg;
                    }
                    else if (result) {
                        $uibModalInstance.close(result);
                    }
                    else {
                        $uibModalInstance.close(result);
                    }
                }, function () {
                    vm.actionInProgress = false;
                    vm.submitStatusError = false;
                });
            });
        }

        // Cancel button execution
        function cancel() {
            $uibModalInstance.dismiss();
        }

        // Prevents navigation while modal is open
        var allowNavigation = $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        $scope.$on('modal.closing', function () {
            allowNavigation();
        });
    }])
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name pushActionService
     * @alias cerberus/ui:pushActionService
     * @description Provides functions for handling push actions (Execute actions).
     */
    .factory('pushActionService', ["_", "$http", "apiPath", "$q", "toaster", "$timeout", "normalPrintingService", function pushActionService(_, $http, apiPath, $q, toaster, $timeout, normalPrintingService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        var service = {
            execute: execute,
            placeNote: placeNote
        };
        return service;
        ////////////////////
        
        /**
         * Execute 'push-action' related to specific instance; Will process action from instance action menu based on its workflow
         * @param {string} id
         * @param {struct} structData
         * @returns {deferred.promise|{then}}
         */
         
         //TODO - FIX LOOP TO ALLOW MULTIPLE FILES TO BE ATTACHED FROM ONE SINGLE SHOT...
        function execute(id, structData) {
            var deferred = $q.defer(),
                attachPromises = [],
                stateId = _.get(structData, 'instance_stateId', ''),
                defaultFileName = _.get(structData, 'instance_defaultFileName', null);
                
            //  var qq = {};

            //_.forEach(instanceIds, function(id) {
            //  qq.attachmentsReady[id] = false;

                generateInstancePDF(id, stateId, defaultFileName).then(function(result) {
            //      qq.attachmentsReady[id] = true;
                    var attachStruct = {attachmentInfo: result};
                    attachPromises.push(attachStruct);
            //        console.log(attachStruct); //get filename here...

                //  if(_.every(qq.attachmentsReady)) {
                    //when all attachments are ready. Continue with action
                    structData.attachments = attachPromises;
                    $http.put(apiPath + 'utilities/pushaction/' + id, {actionData: structData})
                        .success(function(value) {
                            toaster.pop('success', 'Success');
                            deferred.resolve(value.DATA);
                        })
                        .error(function(reason) {
                            if(_.has(reason, 'DATA.errMsg')) {
                                toaster.pop('warning', reason.DATA.errMsg);
                                // toaster.pop({
                                    // type: 'warning',
                                    // bodyOutputType: 'trustedHtml',
                                    // body: reason.DATA.errMsg //parseError(reason.DATA.errMsg)
                                // });
                            }
                            else {
                                toaster.pop('warning', _.get(reason, 'MESSAGE', connectionError));
                            }
                            deferred.reject(
                                _.get(reason, 'MESSAGE', connectionError)
                            );
                        });

                        $q.all(attachPromises).then(function () {
                            $timeout(function() {
                                //timeout exec.
                            }, 250 + 150 * attachPromises.length);
                        });
                    //}
                });
            //});
            return deferred.promise;
        }

     /* function parseError(errArr) {
            var str = '';
            //Parsing error into readable string
            for(var i = 0; i < errArr.length; i++ ) {
                str = str + '<strong>' + errArr[i].modelId + '</strong>: ';
                for(var j = 0; j < errArr[i].invalidArr.length; j++) {
                    str = str + errArr[i].invalidArr[j] + ' ';
                }
                str = str + '<br>';
            }
            return str;
        } */

        /**
         * Generate PDF for the given instance
         * @param instanceId
         * @param stateId
         * @param defaultFileName
         */
        function generateInstancePDF(instanceId, stateId, defaultFileName) {
        //------------------------------------------------
        //development - NOTE...
        //add stateId to be able to print a certain form from entire instance / widget container (Useful when widget contains multiple states and forms...
        //------------------------------------------------
            var deferred = $q.defer(),
                //instanceScope = $rootScope.$new(true),
                defaultName = defaultFileName || null,
                normalOptions = {
                    "landscape": false,
                    "paperSize": "letter",
                    "margin": {
                        "bottom": 0,
                        "left": 0,
                        "right": 0,
                        "top": 0
                        }
                },
                instance = {},
                dataSet = {},
                autoFillData = {},
                processPdf = 'write';

            //instanceScope.id = instanceId;
            //instanceScope.TestTempPaperOptions = normalOptions;

            // Call PDF generator function and return filename details
            normalPrintingService.printInstance(instanceId, defaultName, normalOptions, instance, dataSet, autoFillData, processPdf).then(function (value) {
                deferred.resolve(value);
            });

            // instanceScope.done = function() {
                // instanceScope.$destroy();
            // };

            return deferred.promise;
        }
        
        /**
         * Places a note for the given instance
         * @param instanceId
         * @param noteData
         */
        function placeNote(instanceId, noteData) {

            var deferred = $q.defer(),
                noteTitle =  _.get(noteData, 'title', 'Auto'),
                noteBody =  _.get(noteData, 'body', 'Auto'),
                noteIsPublic = _.get(noteData, 'isPublic', 'YES'),
                noteType = _.get(noteData, 'type', 'Note'); 

            var apiUrl = apiPath + 'instances/' + instanceId + '/metadata';
            $http.post(apiUrl, {dataStruct: {title: noteTitle, body: noteBody}, isPublic: noteIsPublic, type: noteType})
                    .success(function(value) {
                        toaster.pop('success', 'Success');
                        deferred.resolve(value.DATA);
                    })
                    .error(function(reason) {
                        if(_.has(reason, 'DATA.errMsg')) {
                            toaster.pop('warning', reason.DATA.errMsg);
                        }
                        else {
                            toaster.pop('warning', _.get(reason, 'MESSAGE', connectionError));
                        }
                        deferred.reject(
                            _.get(reason, 'MESSAGE', connectionError)
                        );
                    });
            return deferred.promise;
        }
    }])
;
/**
 * EXAMPLE
 ***Controller:
 *
 ***Template
 *
 *
 */
angular.module('cerberus.ui')
    .controller('NimRecurrenceCtrl', ["_", "RRule", "$scope", "$rootScope", "$timeout", "$attrs", "RecurrencesService", function NimRecurrenceCtrl(_, RRule, $scope, $rootScope, $timeout, $attrs, RecurrencesService) {
        var vm = this;

        // Changed $scope.model to instance instead of just recurrence
        vm.recurrence = angular.copy($scope.model.recurrence);
        vm.instanceId = $scope.$eval($attrs.nimRecurrenceId);
        vm.monthRepeatBy = '';
        vm.weekdays = RecurrencesService.weekdays();
        vm.frequencies = RecurrencesService.frequencies();

        $scope.$watch('vm.recurrence.rrule', function(newVal, oldVal){
            if(newVal != oldVal){
                var rule = new RRule(angular.copy(vm.recurrence.rrule));
                vm.recurrence.summary = rule.toText();
            }
        },true);

        vm.toggleWeekDaysSelect = function(day){
            var idx =  vm.recurrence.rrule.byweekday.map(function(e) { return e.weekday; }).indexOf(day.value.weekday);
            if(idx > -1){
                day.selected = false;
                vm.recurrence.rrule.byweekday.splice(idx,1);
            }
            else{
                day.selected = true;
                vm.recurrence.rrule.byweekday.push(day.value);
            }
        };
        vm.toggleMonthRepeatBy = function(val){
            if(val === 'dayMonth'){
                vm.recurrence.rrule.byweekday = [];
                vm.recurrence.rrule.bymonthday = vm.recurrence.rrule.dtstart.getDate();
            }
            else if(val === 'dayWeek'){
                vm.recurrence.rrule.bymonthday = null;
                var day = vm.recurrence.rrule.dtstart.getDay() - 1;
                if(day < 0){
                    day = 6;
                }
                var nthDay = Math.ceil(vm.recurrence.rrule.dtstart.getDate()/7);
                vm.recurrence.rrule.byweekday = [vm.weekdays[day].value.nth(nthDay)];
            }
            else{
                vm.recurrence.rrule.byweekday = [];
                vm.recurrence.rrule.bymonthday = null;
            }
        };

        vm.toggleFreq = function(){
            if(vm.recurrence.rrule.freq === 'weekday'){
                vm.recurrence.rrule.freq = RRule.WEEKLY;
                vm.recurrence.rrule.byweekday = [RRule.MO,RRule.TU,RRule.WE,RRule.TH,RRule.FR];
                setWeekdaysArray(true,5);
            }
            else{
                vm.recurrence.rrule.byweekday = [];
                vm.recurrence.rrule.dtstart = new Date();
                setWeekdaysArray(false,vm.weekdays.length);
            }
        };

        vm.close = function(){
            $scope.$parent.instanceRecurrence.close();
        };

        vm.deleteRecurrence = function(recur){
            if(recur.id){
                RecurrencesService.deleteRecurrence(recur.id).then(function(){
                    $scope.model.recurrence = null;
                    vm.close();
                });
            }
            else {
                $scope.model.recurrence = null;
                vm.close();
            }
        };

        vm.ok = function(recur){
            if(vm.instanceId && !recur.id){
                recur.id = vm.instanceId;
            }

            $scope.model.recurrence = angular.copy(recur);
            if(recur.id){
                RecurrencesService.update(recur.id,recur).then(function(){
                    vm.close();
                });
            }
            vm.close();
        };
        _init();
        ////////////////////
        /**
         * Init controller data and server calls
         */
        function setWeekdaysArray(selected,len){
            for(var i = 0; i < len; i++){
                vm.weekdays[i].selected = selected;
            }
        }
        function _init() {
            if(_.isEmpty(vm.recurrence)){
                vm.recurrence = {
                    rrule: {
                        freq: RRule.DAILY,
                        byweekday: [],
                        dtstart: new Date($scope.startDate)
                    },
                    type: 'users',
                    groups: {},
                    summary: 'every day'
                };
            }
            else{
                //Make sure the summary works
                for(var i = 0; i < vm.recurrence.rrule.byweekday.length; i++){
                    for(var j = 0; j < vm.weekdays.length; j++){
                        if(vm.recurrence.rrule.byweekday[i].weekday == vm.weekdays[j].value.weekday){
                            vm.weekdays[j].selected = true;
                            vm.recurrence.rrule.byweekday[i] = vm.weekdays[j].value;
                        }
                    }
                }
                vm.recurrence.rrule.dtstart = new Date(vm.recurrence.rrule.dtstart);
                if(vm.recurrence.rrule.until){
                    vm.recurrence.rrule.until = new Date(vm.recurrence.rrule.until);
                }
                var rule = new RRule(angular.copy(vm.recurrence.rrule));
                vm.recurrence.summary = rule.toText();
            }
        }

        $scope.$on('auth:loginCancelled', function () {
            $timeout(function() {
                vm.close();
            });
        });
    }])
    .directive('nimRecurrence', function nimRecurrence() {
        return {
            restrict: 'AE',
            scope: {
                model: '=nimRecurrence',
                startDate: '=startDate'
            },
            templateUrl: 'ui/nim-recurrence/nim-recurrence.tpl.html',
            controller: 'NimRecurrenceCtrl',
            controllerAs: 'vm'
        };
    })
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name RecurrencesService
     * @alias cerberus/ui:RecurrencesService
     * @description Provides functions for handling configuration of recurrence rules
     */
    .factory('RecurrencesService', ["_", "RRule", "$http", "$q", "apiPath", "toaster", function RecurrencesService(_, RRule, $http, $q, apiPath, toaster) {
        var service = {
            update: update,
            deleteRecurrence: deleteRecurrence,
            weekdays: weekdays,
            frequencies: frequencies
        };
        return service;
        ////////////////////
        /**
         * update
         * @param id
         * @param data
         * @returns {*|r.promise|Function|promise|Document.promise}
         */
        function update(id, data){
            var deferred = $q.defer();
            $http.put(apiPath + 'recurrences/' + id, data)
                .success(function (value) {
                    toaster.pop('success', 'Recurrence data updated');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    if(_.has(reason, 'DATA.errMsg')) {
                        toaster.pop({
                            type: 'warning',
                            bodyOutputType: 'trustedHtml',
                            body: reason.DATA.errMsg
                        });
                    }
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function deleteRecurrence(id){
            var deferred = $q.defer();
            $http.delete(apiPath + 'recurrences/' + id)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function weekdays() {
            return [
                {
                    display:'Mon',
                    value:RRule.MO,
                    selected: false
                },
                {
                    display:'Tues',
                    value:RRule.TU,
                    selected: false
                },
                {
                    display:'Wed',
                    value:RRule.WE,
                    selected: false
                },
                {
                    display:'Thu',
                    value:RRule.TH,
                    selected: false
                },
                {
                    display:'Fri',
                    value:RRule.FR,
                    selected: false
                },
                {
                    display:'Sat',
                    value:RRule.SA,
                    selected: false
                },
                {
                    display:'Sun',
                    value:RRule.SU,
                    selected: false
                }
            ];
        }
        function frequencies() {
            return [
                {
                    display:'Daily',
                    value:RRule.DAILY
                },
                {
                    display:'Weekly',
                    value:RRule.WEEKLY
                },
                {
                    display:'Monthly',
                    value:RRule.MONTHLY
                },
                {
                    display:'Yearly',
                    value:RRule.YEARLY
                },
                {
                    display:'Every Weekday (Monday to Friday)',
                    value:'weekday'
                }
            ];
        }
    }])
;

angular.module('cerberus.ui')
    .controller('NimRibbonCtrl', ["$scope", "$element", "$document", "$window", "$timeout", function ($scope, $element, $document, $window, $timeout) {
        // set local/private vars
        var vm = this;
        var scrollAnimation = null;
        var scrollTimer;

        // set/expose public vars
        vm.$container = $element;
        vm.$currentTab = null;

        // expose methods
        vm.initTab = initTab;
        vm.resize= resize;

        // create arrows
        vm.leftArrowEle = $document[0].createElement('div');
        vm.rightArrowEle = $document[0].createElement('div');
        vm.$leftArrow = angular.element(vm.leftArrowEle);
        vm.$rightArrow = angular.element(vm.rightArrowEle);

        // style arrows
        vm.$leftArrow.addClass('rm-drag-arrow').addClass('left').html('<i class="fa fa-angle-left"></i>');
        vm.$rightArrow.addClass('rm-drag-arrow').addClass('right').html('<i class="fa fa-angle-right"></i>');

        // add arrows
        vm.$container.append(vm.$leftArrow);
        vm.$container.append(vm.$rightArrow);

        // bind events
        vm.$leftArrow.bind('click', scrollSnapLeft);
        vm.$leftArrow.bind('dblclick', scrollFullLeft);
        vm.$leftArrow.bind('touchstart', scrollTouchLeft);
        vm.$leftArrow.bind('touchend', scrollOut);
        vm.$rightArrow.bind('click', scrollSnapRight);
        vm.$rightArrow.bind('dblclick', scrollFullRight);
        vm.$rightArrow.bind('touchstart', scrollTouchRight);
        vm.$rightArrow.bind('touchend', scrollOut);
        vm.$container.resize(resize);
        $scope.$on("$destroy", function() {
            vm.$leftArrow.unbind('click dblclick touchstart touchend').remove();
            vm.$rightArrow.unbind('click dblclick touchstart touchend').remove();
        });

        ////////////////////
        // hide/show arrow
        function displayArrows(x) {
            var pPosition = vm.$container.parent().position() || {top:0, left:0};
            if (vm.$currentTab[0].offsetWidth < vm.$container[0].offsetWidth) {
                vm.$leftArrow.css({display:'none'});
                vm.$rightArrow.css({display:'none'});
                return;
            }
            var right = vm.$currentTab[0].offsetWidth - vm.$container[0].offsetWidth + x;
            if (x > -1 && x < 1 ) {
                vm.$leftArrow.css({display:'none'});
            } else {
                vm.$leftArrow.css({display:'block'});
            }
            if(right < 1) {
                vm.$rightArrow.css({display:'none'});
            } else {
                vm.$rightArrow.css({display:'block', left:vm.$container[0].offsetWidth - pPosition.left - vm.$rightArrow.outerWidth() + 'px'});
            }
        }
        function displayProxy(self) {
            $window.Draggable.get(vm.$currentTab).update();
            displayArrows(self.vars.css.x);
        }

        // scroll functions
        function calcHelper() {
            var frameX = $window.Draggable.get(vm.$currentTab).x;
            var frameWidth = vm.$currentTab[0].offsetWidth;
            var containerWidth = vm.$container[0].offsetWidth;
            var maxX = (frameWidth - containerWidth) * -1;
            var nextX = ((frameX * -1) + containerWidth) * -1;
            var previousX = Math.min(0, (frameX + containerWidth));
            nextX = Math.max(nextX, maxX);
            return {
                maxX: maxX,
                nextX: nextX,
                previousX: previousX
            };
        }

        function scrollFullLeft() {
            var animation = new $window.TweenLite(vm.$currentTab, 0.3, {x: 0});
            animation.eventCallback("onComplete", displayProxy, ["{self}"]);
        }
        function scrollFullRight() {
            var animation = new $window.TweenLite(vm.$currentTab, 0.3, {x: calcHelper().maxX});
            animation.eventCallback("onComplete", displayProxy, ["{self}"]);
        }
        function scrollSnapLeft() {
            var animation = new $window.TweenLite(vm.$currentTab, 0.3, {x: calcHelper().previousX});
            animation.eventCallback("onComplete", displayProxy, ["{self}"]);
        }
        function scrollSnapRight() {
            var animation = new $window.TweenLite(vm.$currentTab, 0.3, {x: calcHelper().nextX});
            animation.eventCallback("onComplete", displayProxy, ["{self}"]);
        }
        function scrollTouchLeft(event) {
            event.preventDefault();
            var animation = new $window.TweenLite(vm.$currentTab, 0.3, {x: calcHelper().previousX});
            animation.eventCallback("onComplete", displayProxy, ["{self}"]);
        }
        function scrollTouchRight(event) {
            event.preventDefault();
            var animation = new $window.TweenLite(vm.$currentTab, 0.3, {x: calcHelper().nextX});
            animation.eventCallback("onComplete", displayProxy, ["{self}"]);
        }
        function scrollOut(event) {
            var e = event.toElement || event.relatedTarget;
            if (e.parentNode == this || e == this) {
                return;
            }
            scrollAnimation.kill();
            $timeout.cancel(scrollTimer);
            $window.Draggable.get(vm.$currentTab).update();
            scrollAnimation = null;
            displayArrows($window.Draggable.get(vm.$currentTab).x);
        }

        function resize() {
            var width = 0;
            var li = vm.$currentTab[0].children;
            var pPosition = vm.$container.position() || {top:0, left:0};
            for (var i = 0; i < li.length; i++) {
                width = width + Math.ceil(angular.element(li[i]).outerWidth()) + 10;
            }
            vm.$currentTab.css({width:width + pPosition.left + 'px'});
            if (vm.$container.outerWidth() > width + pPosition.left) {
                vm.$rightArrow.css({display:'none'});
            }
            vm.$leftArrow.css({display:'none'});
            $window.Draggable.get(vm.$currentTab).applyBounds({
                top: vm.$container.position().top,
                left: vm.$container.position().left,
                height: vm.$container.height(),
                width: vm.$container.innerWidth()
            });
            displayArrows($window.Draggable.get(vm.$currentTab).x);
        }

        function initTab(element) {
            $window.Draggable.create(element, {
                type:"x",
                bounds: vm.$container,
                edgeResistance:0.8,
                throwProps: true,
                maxDuration: 5,
                throwResistance: 3000,
                onDragEnd: function () {
                    displayArrows(this.x);
                },
                onThrowComplete: function () {
                    displayArrows(this.x);
                }
            });
        }

    }])
    .directive('nimRibbon', function() {
        return {
            restrict: 'AE',
            controller: 'NimRibbonCtrl',
            transclude: true,
            template: '<div class="ribbon-wrapper"><div class="tabs-content" ng-transclude></div></div>',
            link: function (scope, element) {
                element.addClass('nim-ribbon');
            }
        };
    })
    .directive('nimRibbonTab', function() {
        return {
            restrict: 'AE',
            require: '^nimRibbon',
            link: function(scope, element, attrs, ctrl) {
                element.addClass('tab-panel');

                // Tell the controller to use this tab in its function closures
                ctrl.$currentTab = element;

                // Init the Controller
                ctrl.initTab(element);

                // Watch for resize items
                scope.$watchGroup([
                        function () { return element.children().length; },
                        function () { return ctrl.$container.innerWidth(); }
                    ],
                    function () { ctrl.resize(); }
                );

            }
        };
    })
;
angular.module('cerberus.ui')
.directive('nimSelectAllOnFocus', function () {
       return {
           restrict: 'A',
           link: function(scope, elm) {
               elm.mouseup(function(event){
                   event.preventDefault();
               });
               elm.focus(function() {
                   elm.select();
               });
           }
       };
   })
;
angular.module('cerberus.ui')
    .controller('nimSignatureModalCtrl', ["$scope", "$uibModalInstance", "nimSignatureService", "isInitial", "restrictTo", "penColor", "isTouchpadSign", function ($scope, $uibModalInstance, nimSignatureService, isInitial, restrictTo, penColor, isTouchpadSign) {
        var vm = this;
        // Settings
        vm.isInitial = isInitial;
        vm.restrictTo = restrictTo;
        vm.penColor = penColor;
        vm.isTouchpadSign = isTouchpadSign;
        // Data Container
        vm.signatureBase64 = '';
        vm.signatureBaseTPad64 = '';

        // UI feedback
        if (isTouchpadSign) {
            vm.signClass= 'text-muted';
            vm.signMsg = 'Use the touch pad to capture data. When done, click Accept.';
        }
        else {
            vm.signClass= 'text-muted';
            vm.signMsg = isInitial ? 'Initial above.' : 'Sign above.';
        }

        // Form Close Actions 
        vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        // Form Submit Actions
        vm.submit = function(isEmpty, withAccount) {
            if (isEmpty === true) {
                vm.signClass = 'text-danger';
                vm.signMsg = 'Please sign above before proceeding!';
                return;
            }
            if (withAccount) {
                nimSignatureService.getSignatureWithAccount().then(success, error);
            }
            else {
                nimSignatureService.saveImage(vm.signatureBase64).then(success, error);
            }
        };

        // Form Submit From Touchpad Device
        vm.submitTouchPad = function(isEmpty, withAccount) {
            if (isEmpty === true) {
                vm.signClass = 'text-danger';
                vm.signMsg = 'No signature! Please sign above before proceeding.';
                return;
            }
            if (vm.signatureBaseTPad64 === '') {
                vm.signClass = 'text-danger';
                vm.signMsg = 'No signature! Please sign above before proceeding.';
                return;
            }
            if (withAccount) {
                nimSignatureService.getSignatureWithAccount().then(success, error);
            }
            else {
                nimSignatureService.saveImage(vm.signatureBaseTPad64).then(success, error);
            }
        };

        ////////////////////
        // Promise Handlers
        function success(data) {
            var response = {
                timestamp: new Date()
            };
            angular.extend(response, data);
            $uibModalInstance.close(response);
        }
        function error() {
            vm.signClass = 'text-warning';
            vm.signMsg = 'Something went wrong, please try again!';
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.ui')
    .directive('nimSignaturePad', ["SignaturePad", "$timeout", "$window", function(SignaturePad, $timeout, $window) {
        return {
            restrict: 'A',
            require: '^ngModel',
            template: '<canvas></canvas>',
            link: function(scope, $element, attrs, ngModel) {
                // Cache Elements
                var canvas = $element[0].querySelector('canvas');
                var penColor = attrs.penColor || 'black';

                // Handle Resize Events (with an iron hammer)
                scope.$watch(function() {
                    return $element.width();
                }, function(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        resizeCanvas();
                    }
                });

                // Create Signature Pad: Expects an element (not a jQuery reference)
                var signaturePad = new SignaturePad(canvas, {
                    minWidth: 0.5,
                    maxWidth: 3,
                    backgroundColor: 'rgb(255, 255, 255)', // (For PNG and SVG, except JPG this field is optional)
                    penColor: penColor
                });

                // Expose Signature Pad
                if (attrs.nimSignaturePad) {
                    scope[attrs.nimSignaturePad] = signaturePad;
                }

                // TODO: Document what this does; I think it renders a picture...
                ngModel.$render = function() {
                    if(ngModel.$viewValue) {
                        signaturePad.fromDataURL(ngModel.$viewValue);
                    }
                    else {
                        // If parent controller clears ngModel, clear canvas
                        signaturePad.clear();
                    }
                };

                // Watch for changes -- especially useful if signature is cleared
                scope.$watch(function() {
                    return signaturePad.toDataURL();
                }, function() {
                    read();
                });


                // Get the signature pad value every stroke end
                signaturePad.onEnd = function() {
                    scope.$evalAsync(read);
                };

                scope.$on('$destroy', function () {
                    signaturePad.off();
                });

                // Init
                read();
                resizeCanvas();
                ////////////////////
                /**
                 * Read dataURL from canvas and populate ngModel
                 */
                function read() {
                    var dataUrl = signaturePad.toDataURL(); // For other formats, include format as ("image/jpeg") or ('image/svg+xml'). [()] / [[empty]] is default (PNG Format).
                    ngModel.$setViewValue(dataUrl);         // Also if format is JPEG, background is required [backgroundColor: 'rgb(255,255,255)']. Consult [signature_pad.js]
                }

                /**
                 * Resize Function
                 * Adjust canvas coordinate space taking into account pixel ratio,
                 * to make it look crisp on mobile devices.
                 * This also causes canvas to be cleared.
                 */
                function resizeCanvas() {
                    // When zoomed out to less than 100%, for some very strange reason,
                    // some browsers report devicePixelRatio as less than 1
                    // and only part of the canvas is cleared then.
                    var ratio =  Math.max($window.devicePixelRatio || 1, 1);
                    // This part causes the canvas to be cleared
                    canvas.width = canvas.offsetWidth * ratio;
                    canvas.height = canvas.offsetHeight * ratio;
                    canvas.getContext("2d").scale(ratio, ratio);
                    // This library does not listen for canvas changes, so after the canvas is automatically
                    // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
                    // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
                    // that the state of this library is consistent with visual state of the canvas, you
                    // have to clear it manually.
                    signaturePad.clear();
                }
            }
        };
    }])
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name nimSignatureService
     * @alias cerberus/ui:nimSignatureService
     * @description Provides functionality to nimSignaturePad directive
     */
    .factory('nimSignatureService', ["$http", "$q", "$uibModal", "apiPath", function ($http, $q, $uibModal, apiPath) {
        var service = {
            openModal: openModal,
            saveImage: saveImage,
            getSignatureWithAccount: getSignatureWithAccount
        };
        return service;
        ////////////////////
        function openModal(isInitial, restrictTo, penColor, isTouchpadSign) {
            return $uibModal.open({
                backdropClass: 'verify-sig',
                windowClass: 'modal-verify-sig',
                backdrop: 'static',
                size: 'lg',
                templateUrl: 'ui/nim-signature/nim-signature-modal.tpl.html',
                controller: 'nimSignatureModalCtrl',
                controllerAs: 'sig',
                resolve: {
                    isInitial: function () {
                        return isInitial || false;
                    },
                    restrictTo: function () {
                        return restrictTo || 'any';
                    },
                    penColor: function () {
                        return penColor;
                    },
                    isTouchpadSign: function () {
                        return isTouchpadSign || false;
                    }
                }
            });
        }

        function saveImage (base64) {
            var deferred = $q.defer();
            $http.post(apiPath + 'utilities/image', {base64String: base64})
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getSignatureWithAccount(){
            var deferred = $q.defer();
            $http.get(apiPath + 'users/verify/signature')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }])
;
angular.module('cerberus.ui')
    .directive('nimThumbnail', ["$window", function($window) {
        var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D),
            isFile: function(item) {
                return angular.isObject(item) && item instanceof $window.File;
            },
            isImage: function(file) {
                var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        };

        return {
            restrict: 'A',
            template: '<canvas></canvas>',
            link: function(scope, element, attributes) {
                if (!helper.support) { return; }

                var params = scope.$eval(attributes.nimThumbnail);

                if (!helper.isFile(params.file)) { return; }
                if (!helper.isImage(params.file)) { return; }

                var canvas = element.find('canvas');
                var reader = new FileReader();

                reader.onload = onLoadFile;
                reader.readAsDataURL(params.file);

                function onLoadFile(event) {
                    var img = new Image();
                    img.onload = onLoadImage;
                    img.src = event.target.result;
                }

                function onLoadImage() {
                    var width = params.width || this.width / this.height * params.height;
                    var height = params.height || this.height / this.width * params.width;
                    canvas.attr({ width: width, height: height });
                    canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                }
            }
        };
    }])
    .directive('nimFileThumb', ["InstancesService", function (InstancesService) {
        var isImage = function (ext) {
            return ['jpg', 'png', 'jpeg', 'bmp', 'gif'].indexOf(ext) !== -1;
        };
        //Font Awesome Icons
        var getFontAwesomeIcon = function (ext) {
            var fileTypeIcons = {
                // Images
                'bmp':  'fa-file-image-o',
                'jpeg': 'fa-file-image-o',
                'jpg':  'fa-file-image-o',
                'gif':  'fa-file-image-o',
                'png':  'fa-file-image-o',

                // Adobe
                'pdf': 'fa-file-pdf-o',

                // Microsoft
                'ppt':  'fa-file-powerpoint-o',
                'pptx': 'fa-file-powerpoint-o',
                'xlsx': 'fa-file-excel-o',
                'xls':  'fa-file-excel-o',
                'doc':  'fa-file-word-o',
                'docx': 'fa-file-word-o',

                // Other Documents
                'txt':   'fa-file-text-o',
                'rtf':   'fa-file-text-o',
                'odt':   'fa-file-text-o',
                'pages': 'fa-file-text-o',
                'wpd':   'fa-file-text-o',
                'wp':    'fa-file-text-o',
                'wp7':   'fa-file-text-o',

                // Archives
                'zip': 'fa-file-archive-o',
                'rar': 'fa-file-archive-o',
                '7z':  'fa-file-archive-o',
                'iso': 'fa-file-archive-o',
                'tar': 'fa-file-archive-o',
                'dmg': 'fa-file-archive-o',
                'war': 'fa-file-archive-o'

            };
            return fileTypeIcons[ext] || 'fa-file-o';
        };

        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                if (attrs.nimFileThumb) {
                    var html = '';
                    var extArr = attrs.nimFileThumb.split('.');
                    var ext = extArr[extArr.length - 1].toLowerCase();
                    var style = '';

                    if(attrs.size){
                        var size = attrs.size.split('x');
                        style = 'style="max-width: ' + size[0] + 'px; max-height: ' + size[1] + 'px"';
                    }
                    else {
                        style = 'style="max-width:100%"';
                    }

                    /* Removing image for now */
                    if (isImage(ext) && !attrs.nimIconOnly) {
                        if(attrs.nimAttachmentId){
                            InstancesService.getDownloadKey(attrs.nimAttachmentId).then(function(url){
                                element.empty().append('<img src="' + url + '" ' + style + ' />');
                            });
                        }
                        else {
                            var newFilePath = attrs.nimFileThumb;
                            if (attrs.size) {
                                newFilePath = extArr[0] + '_' + attrs.size + '.' + extArr[1];
                            }
                            html += '<img style="max-height:100%; max-width:100%;" src="' + newFilePath + '"/>';
                            element.empty().append(html);
                        }
                    }
                    else {
                        html += '<i class="fa fa-fw ' + getFontAwesomeIcon(ext) + '"></i>';
                        element.empty().append(html);
                    }
                }
            }
        };
    }])
;
angular.module('cerberus.ui')
    .run(["$rootScope", "nimTitleService", "appSettingsService", function ($rootScope, nimTitleService, appSettingsService) {

        nimTitleService.set(appSettingsService.branding().platform.name);

        $rootScope.$on('$routeChangeSuccess', function (event, current) {
            if (current.$$route && current.$$route.title) {
                nimTitleService.set(current.$$route.title);
            }
        });
    }])
    .directive('nimTitle', ["nimTitleService", function(nimTitleService) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                scope.$watch(nimTitleService.get, function (newValue) {
                    element.empty().append(newValue);
                });
            }
        };
    }])
;
angular.module('cerberus.ui')
/**
 * @ngdoc service
 * @name nimTitleService
 * @alias cerberus/ui:nimTitleService
 * @description Getter/Setter of page title
 */
    .factory('nimTitleService', function nimTitleService() {
        var _title = '';
        var service = {
            get: get,
            set: set
        };
        return service;
        ////////////////////////
        function get() {
            return _title;
        }
        function set(string) {
            _title = string;
            return _title;
        }
    })
;
angular.module('cerberus.ui')
    .constant('dropdownFormConfig', {
        openClass: 'open',
        containerClass: 'dropdown-form-container',
        uiLibraryClass: 'k-animation-container'
    })
    .controller('DropdownFormController', ["$scope", "$element", "$document", "$attrs", "$parse", "dropdownFormConfig", "dropdownFormService", "$animate", "$uibPosition", function($scope, $element, $document, $attrs, $parse, dropdownFormConfig, dropdownFormService, $animate, $uibPosition) {
        var self = this,
            scope = $scope.$new(), // create a child scope so we are not polluting original one
            openClass = dropdownFormConfig.openClass,
            getIsOpen,
            setIsOpen = angular.noop,
            toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
            appendToBody = false,
            keynavEnabled =false;
            //selectedOption = null;

        this.init = function( element ) {
            element.addClass('dropdown');
            self.$element = element;
            self.$element.addClass(dropdownFormConfig.containerClass);

            if ( $attrs.isOpen ) {
                getIsOpen = $parse($attrs.isOpen);
                setIsOpen = getIsOpen.assign;

                $scope.$watch(getIsOpen, function(value) {
                    scope.isOpen = !!value;
                });
            }

            appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
            keynavEnabled = angular.isDefined($attrs.uibKeyboardNav);

            if (appendToBody && self.dropdownFormMenu) {
                $document.find('body').append(self.dropdownFormMenu);
                $element.on('$destroy', function handleDestroyEvent() {
                    self.dropdownFormMenu.remove();
                });
            }
        };

        this.toggle = function( open ) {
            return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
        };

        // Allow other directives to watch status
        this.isOpen = function() {
            return scope.isOpen;
        };

        scope.getToggleElement = function() {
            return self.toggleElement;
        };

        scope.getAutoClose = function() {
            return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
        };

        scope.getElement = function() {
            return $element;
        };

        scope.isKeynavEnabled = function() {
            return keynavEnabled;
        };

        scope.focusDropdownEntry = function(keyCode) {
            var elems = self.dropdownFormMenu ? //If append to body is used.
                (angular.element(self.dropdownFormMenu).find('a')) :
                (angular.element($element).find('ul').eq(0).find('a'));

            switch (keyCode) {
                case (40): {
                    if (!angular.isNumber(self.selectedOption)) {
                        self.selectedOption = 0;
                    } else {
                        self.selectedOption = (self.selectedOption === elems.length - 1 ?
                            self.selectedOption :
                        self.selectedOption + 1);
                    }
                    break;
                }
                case (38): {
                    if (!angular.isNumber(self.selectedOption)) {
                        self.selectedOption = elems.length - 1;
                    } else {
                        self.selectedOption = self.selectedOption === 0 ?
                            0 : self.selectedOption - 1;
                    }
                    break;
                }
            }
            elems[self.selectedOption].focus();
        };

        scope.getDropdownElement = function() {
            return self.dropdownFormMenu;
        };

        scope.focusToggleElement = function() {
            if ( self.toggleElement ) {
                self.toggleElement[0].focus();
            }
        };

        scope.$watch('isOpen', function(isOpen, wasOpen) {
            if (appendToBody && self.dropdownFormMenu) {
                var pos = $uibPosition.positionElements($element, self.dropdownFormMenu, 'bottom-left', true);
                var css = {
                    top: pos.top + 'px',
                    display: isOpen ? 'block' : 'none'
                };

                var rightalign = self.dropdownFormMenu.hasClass('dropdown-menu-right');
                if (!rightalign) {
                    css.left = pos.left + 'px';
                    css.right = 'auto';
                } else {
                    css.left = 'auto';
                    css.right = (window.innerWidth - (pos.left + $element.prop('offsetWidth'))) + 'px';
                }

                self.dropdownFormMenu.css(css);
            }

            $animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass);

            if ( isOpen ) {
                scope.focusToggleElement();
                dropdownFormService.open( scope );
            } else {
                dropdownFormService.close( scope );
            }

            setIsOpen($scope, isOpen);
            if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
                toggleInvoker($scope, { open: !!isOpen });
            }
        });

        $scope.$on('$locationChangeSuccess', function() {
            scope.isOpen = false;
        });

        $scope.$on('$destroy', function() {
            scope.$destroy();
        });
    }])
    .directive('dropdownForm', function() {
        return {
            controller: 'DropdownFormController',
            link: function(scope, element, attrs, dropdownFormCtrl) {
                dropdownFormCtrl.dropdownFormMenu = element.find('[uib-dropdown-menu]');
                dropdownFormCtrl.init( element );
            }
        };
    })
    .directive('dropdownFormToggle', function() {
        return {
            require: '?^dropdownForm',
            link: function(scope, element, attrs, dropdownFormCtrl) {
                if ( !dropdownFormCtrl ) {
                    return;
                }

                dropdownFormCtrl.toggleElement = element;

                var toggleDropdown = function(event) {
                    event.preventDefault();

                    if ( !element.hasClass('disabled') && !attrs.disabled ) {
                        scope.$apply(function() {
                            dropdownFormCtrl.toggle();
                        });
                    }
                };

                element.bind('click', toggleDropdown);

                // WAI-ARIA
                element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
                scope.$watch(dropdownFormCtrl.isOpen, function( isOpen ) {
                    element.attr('aria-expanded', !!isOpen);
                });

                scope.$on('$destroy', function() {
                    element.unbind('click', toggleDropdown);
                });
            }
        };
    })
;
angular.module('cerberus.ui')
    /**
     * @ngdoc service
     * @name dropdownFormService
     * @alias cerberus/ui:dropdownFormService
     * @description Provides functionality to dropdownForm directive
     */
    .service('dropdownFormService', ["$document", "dropdownFormConfig", function($document, dropdownFormConfig) {
        var openScope = null;

        this.open = function( dropdownScope ) {
            if ( !openScope ) {
                $document.bind('click', closeDropdown);
                $document.bind('keydown', escapeKeyBind);
            }

            if ( openScope && openScope !== dropdownScope ) {
                openScope.isOpen = false;
            }

            openScope = dropdownScope;
        };

        this.close = function( dropdownScope ) {
            if ( openScope === dropdownScope ) {
                openScope = null;
                $document.unbind('click', closeDropdown);
                $document.unbind('keydown', escapeKeyBind);
            }
        };

        var closeDropdown = function( evt ) {
            // This method may still be called during the same mouse event that
            // unbound this event handler. So check openScope before proceeding.
            if (!openScope) { return; }

            // If the click happened in a UI Library that appends widget to body
            if($(evt.target).closest('.'+ dropdownFormConfig.uiLibraryClass).length > 0) {
                return;
            }

            // If the click event was within the dropdown
            if ($(evt.target).closest('.' + dropdownFormConfig.containerClass).length > 0) {
                return;
            }

            var toggleElement = openScope.getToggleElement();
            if ( evt && toggleElement && toggleElement[0].contains(evt.target)) {
                return;
            }

            openScope.$apply(function() {
                openScope.isOpen = false;
            });
        };

        var escapeKeyBind = function( evt ) {
            if ( evt.which === 27 ) {
                openScope.focusToggleElement();
                closeDropdown();
            }
        };
    }])
;
/*jshint bitwise: false*/
/**
 * @module ui/NimValidators
 * @description Validators the for ngModel directive
 */
angular.module('cerberus.ui')
    .directive('nimPassword', function() {
        var regex = /(?=^.{8,50}$)(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).*$/;
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (value) {
                    var status = true;
                    status = status && regex.test(value);
                    ngModel.$setValidity('nimPassword', status);
                    return value;
                });
            }
        };
    })
    .directive('nimWidgetUniqueId', function () {
        var regex = /^[A-Za-z][A-Za-z0-9]{2,30}$/;
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                // Watch Model for changes
                scope.$watch(attrs.ngModel, function (value) {
                    testWidgetId(value);
                });
                ngModel.$parsers.push(function (value) {
                    testWidgetId(value);
                    return value;
                });
                function testWidgetId(value) {
                    var status = true;
                    status = status && regex.test(value);
                    ngModel.$setValidity('nimWidgetUniqueId', status);
                }
            }
        };
    })
    .directive('nimModelId', function () {
        var regex = /^[A-Za-z][A-Za-z0-9]{2,30}$/;
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                // Watch Model for changes
                scope.$watch(attrs.ngModel, function (value) {
                    testModelId(value);
                });
                ngModel.$parsers.push(function (value) {
                    testModelId(value);
                    return value;
                });
                function testModelId(value) {
                    var status = true;
                    status = status && regex.test(value);
                    ngModel.$setValidity('nimModelId', status);
                }
            }
        };
    })
    .directive('nimIp', function () {
        var regex = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                // Watch Model for changes (presumably from controller)
                scope.$watch(attrs.ngModel, function (value) {
                    testIp(value);
                });
                ngModel.$parsers.push(function (value) {
                    testIp(value);
                    return value;
                });
                function testIp(value) {
                    var status = true;
                    status = status && regex.test(value);
                    ngModel.$setValidity('nimIp', status);
                }
            }
        };
    })
    .directive('nimFqdn', function () {
        var regex = /^[A-Za-z0-9][A-Za-z0-9\-]{1,62}[A-Za-z0-9]$/;
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                // Watch Model for changes (presumably from controller)
                scope.$watch(attrs.ngModel, function (value) {
                    testFqdn(value);
                });
                ngModel.$parsers.push(function (value) {
                    testFqdn(value);
                    return value;
                });
                function testFqdn(value) {
                    var status = true;
                    status = status && regex.test(value);
                    ngModel.$setValidity('nimFqdn', status);
                }
            }
        };
    })
    .directive('nimWorkspacePath', function () {
        var regex = /^[A-Za-z0-9][A-Za-z0-9\-\_]{1,30}[A-Za-z0-9]$/;
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                // Watch Model for changes (presumably from controller)
                scope.$watch(attrs.ngModel, function (value) {
                    testPath(value);
                });
                ngModel.$parsers.push(function (value) {
                    testPath(value);
                    return value;
                });
                function testPath(value) {
                    var status = true;
                    status = status && regex.test(value);
                    ngModel.$setValidity('nimWorkspacePath', status);
                }
            }
        };
    })
    .directive('nimSpaces', function () {
        return {
            require : 'ngModel',
            link : function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (value) {
                    var status = true;
                    if (value.match(' ')) {
                        status = false;
                    }
                    ngModel.$setValidity('nimSpaces', status);
                    return value;
                });
            }
        };
    })
    .directive('nimEqual', function() {
        return {
            require : 'ngModel',
            link : function(scope, element, attrs, ngModel) {
                scope.$watch(attrs.nimEqual, function() {
                    ngModel.$validate();
                });
                ngModel.$validators.nimEqual = function(value) {
                    var other = scope.$eval(attrs.nimEqual);
                    return !value || !other || value == other;
                };
            }
        };
    })
    .directive('nimIpLte', function() {
        return {
            require : 'ngModel',
            link : function(scope, element, attrs, ngModel) {
                scope.$watch(attrs.nimIpLte, function() {
                    ngModel.$validate();
                });
                ngModel.$validators.nimIpGte = function(value) {
                    var other = scope.$eval(attrs.nimIpLte);
                    if(value && other){
                        var startArr = value.split('.');
                        var endArr = other.split('.');
                        for(var i=0; i < startArr.length; i++){
                            var n = startArr[i].length;
                            startArr[i] = n >= 3 ? startArr[i] : new Array(3 - n + 1).join(0) + startArr[i];
                        }
                        for(var j=0; j < endArr.length; j++){
                            var m = endArr[j].length;
                            endArr[j] = m >= 3 ? endArr[j] : new Array(3 - m + 1).join(0) + endArr[j];
                        }
                        if(startArr.join('') <= endArr.join('')){
                            return true;
                        }
                    }
                    return false;
                };
            }
        };
    })
    .directive('nimFieldValidation', function () {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ngModel) {
                // Get Elements
                var parent = element.parents('.form-group.has-feedback');
                var icon = parent.find('.nim-validation-icon');
                var validators = {};

                if (ngModel) {
                    validators = ngModel.$validators;

                    // React to view changes (without a watcher!)
                    ngModel.$viewChangeListeners.push(function () {
                        validate();
                    });

                    // Watch for model changes
                    scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            validate(true);
                        }
                    });

                    // Watch for async validators
                    scope.$watch(function () {return ngModel.$pending;}, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            validate(true);
                        }
                    });

                    // Resets styling when form is set to pristine
                    scope.$watch(function () {return ngModel.$pristine;}, function (pristine) {
                        if(pristine){
                            clear();
                        }
                    });

                    // Register Scope Listener for batch validation
                    scope.$on('nim:validate-form-fields', function () {
                        validate(true);
                    });
                }
                if (icon) {
                    icon.addClass('fa-circle');
                }
                ////////////////////
                // Determine/assign visual validation
                function validate(force) {
                    if (ngModel.$touched || ngModel.$dirty || force) {
                        if (ngModel.$valid && !ngModel.$modelValue && !validators.required) {
                            clear();
                        }
                        else if (ngModel.$valid) {
                            success();
                        }
                        else if (ngModel.$invalid) {
                            error();
                        }
                        else {
                            clear();
                        }
                    } else {
                        clear();
                    }
                }
                function clear() {
                    parent.removeClass('has-error');
                    parent.removeClass('has-success');
                }
                function success() {
                    parent.toggleClass('has-error', false);
                    parent.toggleClass('has-success', true);
                }
                function error() {
                    parent.toggleClass('has-error', true);
                    parent.toggleClass('has-success', false);
                }

            }
        };
    })
    .directive('nimVerifyHuman', ["$compile", "$timeout", function($compile, $timeout) {
        return {
            restrict: 'AE',
            link: function(scope, element, attrs) {
                var randomId = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {var r = Math.random()*16|0,v=c=='x'?r:r&0x3|0x8;return v.toString(16);});
                var template = '<input ng-model="' + attrs.model + '" id="' + randomId + '" type="' + attrs.type + '" tabindex="' + attrs.tabindex + '" required />';
                $timeout(function () {
                    element.empty().append(template);
                    $compile(element.contents())(scope);
                }, 5000);
            }
        };
    }])
;
angular.module('cerberus.ui-util')
    /**
     * @ngdoc service
     * @name DeviceSniffService
     * @alias cerberus/ui-util:DeviceSniffService
     * @description Provides functions for detecting device and browser information
     */
    .factory('DeviceSniffService', ["$window", function DeviceSniffService($window){
        var service = {
            deviceBrowser: deviceBrowser,
            isMobile: isMobile,
            deviceWidth: deviceWidth,
            deviceHeight: deviceHeight
        };

        return service;

        /*******************************************************/

        function deviceBrowser(){
            // borrowed from online
            var ua= $window.navigator.userAgent, tem,
                M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE '+(tem[1] || '');
            }
            if(M[1]=== 'Chrome'){
                tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
                if(tem!= null) {return tem.slice(1).join(' ').replace('OPR', 'Opera');}
            }
            M= M[2]? [M[1], M[2]]: [$window.navigator.appName, $window.navigator.appVersion, '-?'];
            if((tem= ua.match(/version\/(\d+)/i))!= null){ M.splice(1, 1, tem[1]);}
            return M.join(' ');
        }

        function isMobile(){
            return $window.document.documentElement.classList.contains('k-mobile');
        }

        function deviceWidth(){
            return ($window.innerWidth > 0) ? $window.innerWidth : $window.screen.width;
        }

        function deviceHeight(){
            return $window.screen.height;
        }
    }])
;
angular.module('cerberus.ui-util')
    /**
     * @ngdoc service
     * @name ExportFileWriteService
     * @alias cerberus/ui-util:ExportFileWriteService
     * @description Provides functions for handling form data exports and save content to file on the main host server.
     */
    .factory('ExportFileWriteService', ["_", "$q", "$http", "apiPath", function ExportFileWriteService(_, $q, $http, apiPath) {
        var service = {
            writeFile: writeFile,
        };

        return service;

        /*******************************************************/

        /**
         * Auxiliary tool to generate Base64 URI string into PDF file
         * Takes Base64 encoded string of encoded file and saves it on the server, and returns its location details
         * @param base64 {URI base 64 encoded string}
         * @param fileAttributes - Optional option may be used to specify filename and file extension)
         * @returns {deferred.promise|{then}} / (Generated filename with it's path is propagated in the 'return.data').
         */
        function writeFile(base64, fileAttributes) {
            var deferred = $q.defer();
            var _base64FMT = base64.substr(base64.indexOf('base64,') + 7); // Strip ['data:application/pdf;base64,'] from beginning of the string, leave remaining part. // Option 2: base64.split(',')[1];
            var _fileAttrFMT = {
                'filename': _.get(fileAttributes, 'filename', null),  // ['filename.pdf']
                'extension': _.get(fileAttributes, 'extension', null) // ['pdf']
            };

            $http.post(apiPath + 'utilities/filewrite', {base64String: _base64FMT, fileAttributes: _fileAttrFMT})
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });

            return deferred.promise;
        }
    }])
;
angular.module("cerberus.ui-util")
    .directive('nimInputImage', function () {
        return {
            restrict: 'AE',
            scope: {
                image: '=nimInputImage'
            },
            link: function (scope, element) {

                var handleFileSelect=function(evt) {
                    var file = evt.currentTarget.files[0];
                    var reader = new FileReader();
                    reader.onload = function (evt) {
                        scope.$apply(function(scope){
                            scope.image = evt.target.result;
                        });
                    };
                    reader.readAsDataURL(file);
                };

                element.on('change', handleFileSelect);

                scope.$on('$destroy', function () {
                   element.off('change');
                });
            }
        };
    })
;


angular.module("cerberus.ui-util")
    /**
     * @ngdoc service
     * @name fileReader
     * @alias cerberus/ui-util:fileReader
     * @description Provides functionality to file reader
     */
    .factory("fileReader", ["$q", function ($q) {

        var onLoad = function(reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.resolve(reader.result);
                });
            };
        };

        var onError = function (reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.reject(reader.result);
                });
            };
        };

        var onProgress = function(reader, scope) {
            return function (event) {
                scope.$broadcast("fileProgress",
                    {
                        total: event.total,
                        loaded: event.loaded
                    });
            };
        };

        var getReader = function(deferred, scope) {
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);
            return reader;
        };

        var readAsDataURL = function (file, scope) {
            var deferred = $q.defer();

            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);

            return deferred.promise;
        };

        return {
            readAsDataUrl: readAsDataURL
        };
    }]
);
angular.module('cerberus.ui-util')
    .filter('kendoToString', ["kendo", function(kendo) {
        /**
         * @param {string} value
         * @param {string} format
         * @param {string} culture
         */
        return function(value, format, culture) {
            return kendo.toString(value, format, culture);
        };
    }])
    .filter('kendoDateToString', ["kendo", function(kendo) {
        /**
         * @param {string} value
         * @param {string} format
         * @param {string} culture
         */
        return function(value, format, culture) {
            return kendo.toString(kendo.parseDate(value), format, culture);
        };
    }])
    .filter('kendoFormat', ["kendo", function(kendo) {
        /**
         * @param {string} format
         * @param {string} value
         */
        return function(value, format) {
            return kendo.format(format, value);
        };
    }])
    .filter('truncateCharacters', function () {
        return function (input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    //get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                }else{
                    while(input.charAt(input.length-1) === ' '){
                        input = input.substr(0, input.length -1);
                    }
                }
                return input + '...';
            }
            return input;
        };
    })
    .filter('truncateWords', function () {
        return function (input, words) {
            if (isNaN(words))  {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        };
    })
    .filter('nimSplit', function() {
        return function(input, delimiter) {
            delimiter = delimiter || ',';
            var arr = [];
            try{
                arr =  input.split(delimiter);
            } catch(e){
                arr[0] = input;
            }
            return arr;
        };
    })
    .filter('toLocalCalendar', ["moment", function toLocalCalendar(moment) {
            return function (str) {
                str = moment.utc(str).local().calendar() || '';
                return str;
            };
        }])
    .filter('toLocalDetail', ["moment", function toLocalDetail(moment) {
            return function (str) {
                str = moment.utc(str).local().format("ddd, MMM Do YYYY, h:mm a") || '';
                return str;
            };
        }])

    .filter('toUpperCase', function() {
        return function(str) {
            str = str || '';
            return str.toUpperCase();
        };
    })
    .filter('toLowerCase', function() {
        return function(str) {
            str = str || '';
            return str.toLowerCase();
        };
    })
    .filter('toTitleCase', function() {
        return function (str) {
            str = str || '';
            return str.replace(/([\w&`'â€˜â€™"â€œ.@:\/\{\(\[<>_]+-? *)/g,
                function(match, p1, index, title){
                    if (index > 0 && title.charAt(index - 2) != ":" &&
                        match.search(/^(a(nd?|s|t)?|b(ut|y)|en|for|i[fn]|o[fnr]|t(he|o)|vs?\.?|via)[ -]/i) > -1) {
                        return match.toLowerCase();
                    }
                    if (title.substring(index - 1, index + 1).search(/['"_{([]/) > -1) {
                        return match.charAt(0) + match.charAt(1).toUpperCase() + match.substr(2);
                    }
                    if (match.substr(1).search(/[A-Z]+|&|[\w]+[._][\w]+/) > -1 ||
                        title.substring(index - 1, index + 1).search(/[\])}]/) > -1) {
                        return match;
                    }
                    return match.charAt(0).toUpperCase() + match.substr(1);
                });
        };
    })
    .filter('toInitials', function() {
        return function(str) {
            str = str || '';
            var initials = '';
            var arr = str.split(' ');
            for (var i = 0; i < arr.length; i++) {
                initials += arr[i].substring(0,1).toUpperCase() + '.';
            }
            return initials;
        };
    })
    .filter('parseDate', ["moment", function parseDate(moment) {
            return function (str) {
                var val = str;
                if(moment(str).isValid()){
                    val = moment(str).format('MM/DD/YY');
                }
                return val;
            };
        }])
;
angular.module('cerberus.ui-util')
    .directive('nimFocus', ["$timeout", function nimFocus($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function(){
                    var focusElement = $(element).find('input, textarea, select, .k-dropdown')
                        .not('input[type=hidden],input[type=button],input[type=submit],input[type=reset],input[type=image],button,.k-dropdown[area-readonly=true],.nim-readonly-form-object *')
                        .filter(':enabled:visible:first');

                    if(focusElement.hasClass('k-dropdown')){
                        focusElement.click();
                    }
                    else {
                        focusElement.focus();
                    }
                }, 100);
            }
        };
    }])
;
angular.module('cerberus.ui-util')
    .directive('nimTabHandler', ["_", "$timeout", function(_, $timeout){
        return {
            restrict: 'A',
            link: function(scope, element){
                var jqElement = $(element);
                //var state = scope.$eval('vm.instance.workflowObjects[state]');
                var dataSet = scope.$eval('vm.temp[state]'),
                    sectionsShown = scope.$eval('vm.sectionsShown'),
                    fieldsShown = scope.$eval('vm.fieldsShown'),
                    fieldsActive = scope.$eval('vm.fieldsActive');

                // Get necessary form info from workflow state
                var forms = [];

                scope.$watch('vm.instance.workflowObjects[state]', function(state){
                    forms = _.map(_.get(state, 'model.forms', []), function(formModel){
                        return {
                            // Sort form objects by tabindex after rejecting ignored form object types
                            objects: _.sortBy(_.reject(_.get(formModel, 'form.objects', []), function(formObj){
                                var config = formObj.model.config;
                                var type = config.type;
                                var dataType = config.dataType;

                                // Ignore form objects that meet these criteria
                                return config.isHidden || type == 'table' || type == 'map' || type == 'signature' || dataType == 'readonly' || dataType == 'static';
                            }), 'model.tag.attrs.tabindex'),
                            sections: _.get(formModel, 'form.sections', []),
                            formOriginId: formModel.originatorId
                        };
                    });
                }, true);

                // Sets the active state to catch all keypress events
                jqElement
                    .keypress(function(e){
                        // Tab keyCode = 9
                        if(e.keyCode === 9) {
                            e.preventDefault();
                        }
                    })
                    .keyup(function(e){
                        if(e.keyCode === 9) {
                            e.preventDefault();
                        }
                    })
                    .keydown(function(e){
                        if(e.keyCode === 9) {
                            e.preventDefault();
                            tabHandler(e.shiftKey);
                        }
                    })
                ;

                /**
                 * Find the next form object or button and focus on it
                 * @param shift - User pressed shift + tab
                 */
                function tabHandler(shift){
                    // Focused form object
                    var focusedElement = jqElement.find('.nim-form-object *:focus, .nim-form-object:focus').closest('.nim-form-object'),
                        modelId = focusedElement.attr('nim-form-object-id'),
                        formOriginId = focusedElement.attr('form-origin-id'),
                        section = focusedElement.closest('div[gridster]').attr('nim-section-name');

                    var focusedButton = jqElement.find('.nim-instances-buttons button:focus');

                    // Next form object to be focused, if there is one
                    var nextFormObject = null;

                    // If modelId and formOriginId are present, current item is a form object
                    if(modelId && formOriginId) {
                        // Finds any radios in form object
                        var radios = focusedElement.find('input[type="radio"]');

                        // If current element is a radio/checkbox, focus the next one
                        if(radios.length && focusNextRadio(radios, shift)){
                            return;
                        }

                        // If current form object is not a radio button or the selected item is the
                        // last radio in the form object, find the next available form object
                        nextFormObject = getNextFormObject(forms, formOriginId, modelId, dataSet, section, shift);
                    }
                    else if(focusedButton.is('button')){
                        // If currently selected item is an instance button, focus the next one
                        focusButton(focusedButton, shift);
                        return;
                    }
                    else {
                        // If user was focused on some other element in the window,
                        // focus on the first available form object
                        var formIndex = shift ? forms.length - 1 : 0;
                        nextFormObject = getNextFormObject(forms, forms[formIndex].formOriginId, null, dataSet, section, shift);
                    }

                    // If an available form object was found, focus on it
                    if(nextFormObject){
                        focusFormObject(nextFormObject.model, shift);
                    }
                    else {
                        // If there are no more form objects after the previous one, move to instance buttons
                        focusButton(focusedElement, shift);
                    }
                }

                /**
                 * Starting from currently selected form object, find next available form object to focus
                 * @param forms
                 * @param formOriginId - ID of current form
                 * @param modelId - ID of currently selected form object
                 * @param dataSet
                 * @param sectionName - Section containing current form object
                 * @param shift - If true, find previous form object
                 * @returns {*} - Next form object
                 */
                function getNextFormObject(forms, formOriginId, modelId, dataSet, sectionName, shift){
                    if(shift){
                        return getPreviousFormObject(forms, formOriginId, modelId, dataSet, sectionName);
                    }

                    // Find the index of the form we should be starting from
                    /* LODASH Version 4 ONLY */
                    //var currentFormIndex = _.findIndex(forms, ['formOriginId', parseInt(formOriginId)]);
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    var currentFormIndex = _.findIndex(forms, function(f){return f.formOriginId === parseInt(formOriginId);});

                    for(var formIndex = currentFormIndex; formIndex < forms.length; formIndex++){
                        var form = forms[formIndex];
                        var nextObjectIndex = 0;

                        // If form object's modelId is provided, start from the next form object
                        if(modelId && formIndex == currentFormIndex){
                            var matchCriteria = {
                                model: {
                                    config: {
                                        modelId: modelId
                                    }
                                }
                            };

                            if(sectionName){
                                matchCriteria.model.display = {
                                    section: sectionName
                                };
                            }

                            nextObjectIndex = _.findIndex(form.objects, matchCriteria) + 1;
                        }

                        for(nextObjectIndex; nextObjectIndex < form.objects.length; nextObjectIndex++){
                            var formObj = form.objects[nextObjectIndex],
                                id = formObj.model.config.modelId,
                                section = formObj.model.display.section,
                                isSectionShown = section !== '__nimHiddenSection' && (!section || _.get(sectionsShown, scope.state + '.' + formOriginId + '.' + section));

                            if(fieldsActive[scope.state][id] && fieldsShown[scope.state][id] && isSectionShown){
                                // Change to tab of next form object
                                changeFormTab(formIndex);
                                return formObj;
                            }
                        }
                    }

                    return null;
                }

                /**
                 * Starting from currently selected form object, find previous available form object to focus
                 * @param forms
                 * @param formOriginId - ID of current form
                 * @param modelId - ID of currently selected form object
                 * @param dataSet
                 * @param sectionName - Section containing current form object
                 * @returns {*} - Previous form object
                 */
                function getPreviousFormObject(forms, formOriginId, modelId, dataSet, sectionName){
                    // Find the index of the form we should be starting from
                    /* LODASH Version 4 ONLY */
                    //var currentFormIndex = _.findIndex(forms, ['formOriginId', parseInt(formOriginId)]);
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    var currentFormIndex = _.findIndex(forms, function(f){return f.formOriginId === parseInt(formOriginId);});

                    for(var formIndex = currentFormIndex; formIndex >= 0; formIndex--){
                        var form = forms[formIndex];
                        var previousObjectIndex = form.objects.length - 1;

                        // If form object's modelId is provided, start from the next form object
                        if(modelId && formIndex == currentFormIndex){
                            var matchCriteria = {
                                model: {
                                    config: {
                                        modelId: modelId
                                    }
                                }
                            };

                            if(sectionName){
                                matchCriteria.model.display = {
                                    section: sectionName
                                };
                            }

                            previousObjectIndex = _.findIndex(form.objects, matchCriteria) - 1;
                        }

                        for(previousObjectIndex; previousObjectIndex >= 0; previousObjectIndex--){
                            var formObj = form.objects[previousObjectIndex],
                                id = formObj.model.config.modelId,
                                section = formObj.model.display.section,
                                isSectionShown = section !== '__nimHiddenSection' && (!section || _.get(sectionsShown, scope.state + '.' + formOriginId + '.' + section));

                            if(fieldsActive[scope.state][id] && fieldsShown[scope.state][id] && isSectionShown){
                                // Change to tab of next form object
                                changeFormTab(formIndex);
                                return formObj;
                            }
                        }
                    }

                    return null;
                }

                /**
                 * Focuses on a form object
                 * @param formObject
                 * @param shift
                 */
                function focusFormObject(formObject, shift){
                    var modelId = formObject.config.modelId;
                    var id = '#' + modelId;
                    var selector = '.nim-form-object[nim-form-object-id=' + modelId + ']';

                    $timeout(function(){
                        switch(formObject.config.type){
                            case 'text':
                            case 'autocomplete':
                            case 'location':
                            case 'textarea':
                            case 'datetime':
                                jqElement.find(id).focus();
                                break;
                            case 'number':
                                jqElement.find(selector).find('.k-numerictextbox').find('.k-input').focus();
                                break;
                            case 'select':
                                jqElement.find(selector).find('.k-dropdown').click();
                                break;
                            case 'multiselect':
                                jqElement.find(selector).find('.k-multiselect').find('.k-input').focus();
                                break;

                            // Focus on first radio
                            case 'radio':
                                var radio = jqElement.find(id + ' input[type="radio"]');
                                var radioIndex = shift ? radio.length - 1 : 0;
                                radio.eq(radioIndex).focus();
                                break;
                            case 'checkbox':
                                jqElement.find('input[type="checkbox"]' + id).focus();
                                break;
                        }
                    });
                }

                /**
                 * If one of the instance buttons is currently focused, focus the next one
                 * @param focusedElement - Currently focused jQuery element that may or may not be a button
                 * @param shift
                 */
                function focusButton(focusedElement, shift){
                    // Save/Submit/Close buttons on toolbar at the bottom of the state
                    var buttons = jqElement.find('.nim-instances-buttons button');
                    var nextIndex = buttons.index(focusedElement);

                    if(shift){
                        // Previous button
                        if(nextIndex == -1){
                            // If focused element is not a button, get last button
                            nextIndex = buttons.length - 1;
                        }
                        else {
                            nextIndex--;
                        }
                    }
                    else {
                        // Next button
                        nextIndex++;
                    }

                    // If currently selected item is not the last button, focus the next one
                    if(nextIndex < buttons.length && nextIndex >= 0){
                        buttons.eq(nextIndex).focus();
                    }
                    else {
                        // Get first available form object that we can tab to
                        var formIndex = shift ? forms.length - 1 : 0;
                        var firstFormObject = getNextFormObject(forms, forms[formIndex].formOriginId, null, dataSet, null, shift);

                        if(firstFormObject){
                            focusFormObject(firstFormObject.model, shift);
                        }
                        else if(shift){
                            // focus last button
                            buttons.eq(buttons.length - 1).focus();
                        }
                        else {
                            // If there are no available form objects,
                            // for whatever reason, focus on the first button
                            buttons.eq(0).focus();
                        }
                    }
                }

                /**
                 * For radio form objects, focus on the next item
                 * @param items - jQuery selected inputs of type radio
                 * @param shift - If true, focus the previous radio button
                 * @returns {boolean} - Tells calling function if next item was focused
                 */
                function focusNextRadio(items, shift){
                    var currentItem = items.filter(':focus');
                    var nextIndex = items.index(currentItem);

                    if(shift){
                        // Index of previous item
                        nextIndex--;
                    }
                    else {
                        // Index of next item
                        nextIndex++;
                    }

                    // If current item is not the last radio, focus the next one
                    if(nextIndex < items.length && nextIndex >= 0){
                        items.eq(nextIndex).focus();

                        // Let calling function know not to focus next form object
                        return true;
                    }

                    // Let calling function focus next form object instead
                    return false;
                }

                /**
                 * Clicks the tab header at specified index to change tabs
                 * @param index - Index of form in workflow state
                 */
                function changeFormTab(index){
                    // There are no tabs if there is only one form
                    if(forms.length > 1) {
                        // Tab headers
                        var tabs = jqElement.find('ul.nav-tabs > li');

                        // Rather than creep on the uib-tab scope,
                        // click the anchor tag to run its select function
                        tabs.eq(index).find('a').click();
                    }
                }
            }
        };
    }])
;
angular.module('cerberus.util')
    .factory('CalculationService', ["_", "kendo", "moment", "writtenNumber", "rollCalculationService", function CalculationService(_, kendo, moment, writtenNumber, rollCalculationService){
        return {
            enforcedDecimalPrecision: 13,

            /**
             * Takes array of parsed tokens and calculates the result of the equation.
             *
             * @param parsedItems Array of tokens that have been parsed
             * @return {object} Resulting number value or string
             */
            calculate: function(parsedItems){
                try {
                    var startIndex = 0;
                    var endIndex = parsedItems.length;

                    var operatorStack = [];
                    var operandStack = [];

                    var hasAddOrSubtractOp = false;
                    var hasMultiplyorDivideOp = false;
                    var hasExponentOp = false;
                    var hasConcatenateOp = false;
                    var hasLogicalOp = false;

                    for (var tokenIndex = startIndex; tokenIndex < endIndex; tokenIndex++) {     // FOR LOOP: operands and operators are pushed to the appropriate stack
                        var token = parsedItems[tokenIndex];

                        switch (token.type) {
                            case 'error':
                                return token;
                            case 'subexpression':
                                var end = this.getSubexpressions(parsedItems, tokenIndex, false)[1];          // Gets subexpression indices
                                //var subResult = this.calculate(null, i + 1, end);
                                var operand = this.calculate(parsedItems.slice(tokenIndex + 1, end));       // Calculates value of the subexpression
                                if (operand.type == 'error') {
                                    return operand;
                                }
                                tokenIndex = end;                                                           // Moves iterator to the end of the subexpression
                                operandStack.push(operand);                                                 // Pushes value of subexpression to stack
                                break;
                            case 'function': // TODO: handle IF
                                var indices = this.getSubexpressions(parsedItems, tokenIndex, true);          // Gets indices of function arguments
                                var funcArgs = [];
                                if (indices[0] + 1 != indices[indices.length - 1]) {
                                    for (var j = 0; j < indices.length - 1; j++) {            // Calculates value of each argument
                                        var subExpression = parsedItems.slice(indices[j] + 1, indices[j + 1]);

                                        if (token.value === 'IF' && j > 0) {
                                            funcArgs[j] = subExpression;
                                        }
                                        else {
                                            var funcArgResult = this.calculate(subExpression);
                                            if (funcArgResult.type == 'error') {
                                                return funcArgResult;
                                            }
                                            funcArgs[j] = funcArgResult.value;
                                        }
                                    }
                                }
                                tokenIndex = indices[indices.length - 1];
                                var oper = {
                                    type: "operand"
                                };
                                oper.value = this.excel(token.value, funcArgs);
                                if(oper.value === null || oper.value === undefined){
                                    oper.value = '';
                                }
                                if (oper.value.error) {
                                    oper.type = 'error';
                                    oper.value = oper.value.error;
                                    return oper;
                                } else if (oper.type === 'error'){
                                    return oper;
                                } else if (typeof oper.value == "number") {
                                    oper.subtype = "number";
                                } else if (typeof oper.value == "string") {
                                    oper.subtype = "text";
                                } else if (typeof oper.value == "boolean") {
                                    oper.subtype = "logical";
                                } else if (oper.value instanceof Date) {
                                    oper.subtype = "date";
                                }
                                operandStack.push(oper);
                                break;
                            case 'operand':
                                operandStack.push(token);
                                break;
                            case 'operator-infix':
                                if ("+-".indexOf(token.value) >= 0) {
                                    hasAddOrSubtractOp = true;
                                } else if ("*/".indexOf(token.value) >= 0) {
                                    hasMultiplyorDivideOp = true;
                                } else if (token.value == "^") {
                                    hasExponentOp = true;
                                } else if (token.value == "&") {
                                    hasConcatenateOp = true;
                                } else if (token.subtype == 'logical'){
                                    hasLogicalOp = true;
                                }
                                operatorStack.push(token);
                                break;
                        }
                    } // END FOR LOOP

                    // Now that the functions and subexpressions are solved, we solve for each operator in order of operations:
                    if (hasExponentOp) {                                  // Solves for power operators
                        for (var exponentIndex = 0; exponentIndex < operatorStack.length; exponentIndex++) {
                            if (operatorStack[exponentIndex].value == "^") {
                                var exponentResult = {
                                    type: "operand",
                                    subtype: "number"
                                };
                                exponentResult.value = this.power(operandStack[exponentIndex].value, operandStack[exponentIndex + 1].value);
                                operandStack.splice(exponentIndex, 2, exponentResult);
                                operatorStack.splice(exponentIndex, 1);
                                exponentIndex--;
                            }
                        }
                    }
                    if (hasMultiplyorDivideOp) {                   // Solves for Multiplication and Division operators
                        for (var multDivIndex = 0; multDivIndex < operatorStack.length; multDivIndex++) {
                            if (operatorStack[multDivIndex].value == "*") {
                                var multiplyResult = {
                                    type: "operand",
                                    subtype: "number"
                                };
                                multiplyResult.value = this.product([operandStack[multDivIndex].value, operandStack[multDivIndex + 1].value]);
                                operandStack.splice(multDivIndex, 2, multiplyResult);
                                operatorStack.splice(multDivIndex, 1);
                                multDivIndex--;
                            } else if (operatorStack[multDivIndex].value == "/") {
                                var divideResult = {
                                    type: "operand",
                                    subtype: "number"
                                };
                                divideResult.value = this.quotient(operandStack[multDivIndex].value, operandStack[multDivIndex + 1].value);
                                if (divideResult.value.error) {
                                    divideResult.value = divideResult.value.error;
                                    divideResult.type = 'error';
                                    divideResult.subtype = null;
                                    return divideResult;
                                }
                                operandStack.splice(multDivIndex, 2, divideResult);
                                operatorStack.splice(multDivIndex, 1);
                                multDivIndex--;
                            }
                        }
                    }
                    if (hasAddOrSubtractOp) {                      // Solves for Addition and Subtraction operators
                        for (var addSubIndex = 0; addSubIndex < operatorStack.length; addSubIndex++) {
                            if (operatorStack[addSubIndex].value == "+") {
                                var additionResult = {
                                    type: "operand",
                                    subtype: "number"
                                };
                                additionResult.value = this.sum([operandStack[addSubIndex].value, operandStack[addSubIndex + 1].value]);
                                operandStack.splice(addSubIndex, 2, additionResult);
                                operatorStack.splice(addSubIndex, 1);
                                addSubIndex--;
                            } else if (operatorStack[addSubIndex].value == "-") {
                                var subtractionResult = {
                                    type: "operand",
                                    subtype: "number"
                                };
                                subtractionResult.value = this.sum([operandStack[addSubIndex].value, -1 * this.parseNum(operandStack[addSubIndex + 1].value)]);
                                operandStack.splice(addSubIndex, 2, subtractionResult);
                                operatorStack.splice(addSubIndex, 1);
                                addSubIndex--;
                            }
                        }
                    }
                    if (hasConcatenateOp) {                        // Solves for Concatenation operators
                        for (var concatIndex = 0; concatIndex < operatorStack.length; concatIndex++) {
                            if (operatorStack[concatIndex].value == "&") {
                                var concatenationResult = {
                                    type: "operand",
                                    subtype: "text"
                                };
                                var val1 = operandStack[concatIndex].value;
                                var val2 = operandStack[concatIndex + 1].value;
                                if (typeof val1 === 'object') {
                                    val1 = _.get(val1, 'display', '');
                                }
                                if (typeof val2 === 'object') {
                                    val2 = _.get(val2, 'display', '');
                                }
                                concatenationResult.value = val1 + "" + val2;
                                operandStack.splice(concatIndex, 2, concatenationResult);
                                operatorStack.splice(concatIndex, 1);
                                concatIndex--;
                            }
                        }
                    }
                    if(hasLogicalOp){
                        for(var logicIndex = 0; logicIndex < operatorStack.length; logicIndex++){
                            var leftLogicValue = operandStack[logicIndex].value,
                                rightLogicValue = operandStack[logicIndex + 1].value,
                                logicOperator = operatorStack[logicIndex].value,
                                logicResult = {
                                    type: 'operand',
                                    subType: 'logical'
                                };

                            if (typeof leftLogicValue === 'object') {
                                leftLogicValue = _.get(leftLogicValue, 'display', '');
                            }
                            if (typeof rightLogicValue === 'object') {
                                rightLogicValue = _.get(rightLogicValue, 'display', '');
                            }

                            if(logicOperator == '>'){
                                logicResult.value = leftLogicValue > rightLogicValue;
                                operandStack.splice(logicIndex, 2, logicResult);
                                operatorStack.splice(logicIndex, 1);
                                logicIndex--;
                            }
                            else if(logicOperator == '<'){
                                logicResult.value = leftLogicValue < rightLogicValue;
                                operandStack.splice(logicIndex, 2, logicResult);
                                operatorStack.splice(logicIndex, 1);
                                logicIndex--;
                            }
                            else if(logicOperator == '>='){
                                logicResult.value = leftLogicValue >= rightLogicValue;
                                operandStack.splice(logicIndex, 2, logicResult);
                                operatorStack.splice(logicIndex, 1);
                                logicIndex--;
                            }
                            else if(logicOperator == '<='){
                                logicResult.value = leftLogicValue <= rightLogicValue;
                                operandStack.splice(logicIndex, 2, logicResult);
                                operatorStack.splice(logicIndex, 1);
                                logicIndex--;
                            }
                            else if(logicOperator == '='){
                                logicResult.value = leftLogicValue == rightLogicValue;
                                operandStack.splice(logicIndex, 2, logicResult);
                                operatorStack.splice(logicIndex, 1);
                                logicIndex--;
                            }
                            else if(logicOperator == '<>'){
                                logicResult.value = leftLogicValue != rightLogicValue;
                                operandStack.splice(logicIndex, 2, logicResult);
                                operatorStack.splice(logicIndex, 1);
                                logicIndex--;
                            }
                            else if(logicOperator == '&&'){
                                logicResult.value = leftLogicValue && rightLogicValue;
                                operandStack.splice(logicIndex, 2, logicResult);
                                operatorStack.splice(logicIndex, 1);
                                logicIndex--;
                            }
                            else if(logicOperator == '||'){
                                logicResult.value = leftLogicValue || rightLogicValue;
                                operandStack.splice(logicIndex, 2, logicResult);
                                operatorStack.splice(logicIndex, 1);
                                logicIndex--;
                            }
                        }
                    }
                    return operandStack[0];     // After solving all operations, there should just be one operand on the stack
                }
                catch(e){
                    return {
                        value: {error: e}
                    };
                }
            },

            /**
             * Iterates through the list of items to determine the range of a subexpression and returns the indices
             * of the starting bracket, the ending bracket, and each comma in between (for function arguments).
             *
             * @param parsedItems List of items containing the subexpression
             * @param startIndex Index of the open bracket that begins the subexpression
             * @param isFunction Boolean value - true if getting indices for a function's arguments
             * @return {Array} Array of indices
             */
            getSubexpressions: function(parsedItems, startIndex, isFunction){
                var openBrackets = 1; // Number of open brackets found without matching end brackets
                var subexpIndex = startIndex;
                var indices = [subexpIndex];
                while(subexpIndex < parsedItems.length && openBrackets > 0){
                    subexpIndex++;
                    var token = parsedItems[subexpIndex];
                    if(token.subtype && token.subtype == 'start'){
                        openBrackets++;
                    } else if(token.subtype && token.subtype == 'stop'){
                        openBrackets--;
                    } else if(token.type == 'argument' && isFunction && openBrackets == 1){
                        indices.push(subexpIndex);
                    }
                }
                indices.push(subexpIndex);
                return indices;
            },

            /**
             * Passes function parameters to the corresponding Excel function and returns the result.
             *
             * @param functionName Name of the Excel function to run
             * @param funcArgs Arguments to be passed to the Excel function
             * @returns {string, number, object} Result of Excel function
             */
            excel: function(functionName, funcArgs){
                switch(functionName){
                    // STRING
                    case 'CONCATENATE':
                        return this.concatenate(funcArgs);
                    case 'LEFT':
                        return this.left(funcArgs[0], funcArgs[1]);
                    case 'RIGHT':
                        return this.right(funcArgs[0], funcArgs[1]);
                    case 'SUBSTITUTE':
                        return this.substitute(funcArgs[0], funcArgs[1], funcArgs[2]);
                    case 'LEN':
                        return this.len(funcArgs[0]);
                    case 'TEXT':
                        return this.text(funcArgs[0], funcArgs[1]);
                    case 'TEXTCASE':
                        return this.textcase(funcArgs[0], funcArgs[1]);
                    case 'TRIM':
                        return this.trim(funcArgs[0]);
                    case 'VALUE':
                        return this.value(funcArgs[0]);
                    case 'WRITTENNUMBER':
                        return this.writtenNumber(funcArgs[0]);

                    // MATH
                    case 'SUM':
                        return this.sum(funcArgs);
                    case 'POWER':
                        return this.power(funcArgs[0], funcArgs[1]);
                    case 'PRODUCT':
                        return this.product(funcArgs);
                    case 'QUOTIENT':
                        return this.quotient(funcArgs[0], funcArgs[1]);
                    case 'AVERAGE':
                        return this.average(funcArgs);
                    case 'ROUND':
                        return this.round(funcArgs[0], funcArgs[1]);
                    case 'FLOOR':
                        return this.floor(funcArgs[0], funcArgs[1]);
                    case 'CEILING':
                        return this.ceiling(funcArgs[0], funcArgs[1]);
                    case 'PI':
                        return this.pi();
                    case 'ABS':
                        return this.abs(funcArgs[0]);
                    case 'SQRT':
                        return this.sqrt(funcArgs[0]);
                    case 'MIN':
                        return this.min.apply(this, funcArgs);
                    case 'MAX':
                        return this.max.apply(this, funcArgs);

                    // DATE
                    case 'NOW':
                        return this.now();
                    case 'DATEADD':
                        return this.dateAdd(funcArgs[0], funcArgs[1], funcArgs[2]);
                    case 'DATESUB':
                        return this.dateSub(funcArgs[0], funcArgs[1], funcArgs[2]);
                    case 'DATEDIFF':
                        if(funcArgs.length < 3){
                            return this.dateDiff(funcArgs[0], funcArgs[1], null);
                        }
                        return this.dateDiff(funcArgs[0], funcArgs[1], funcArgs[2]);

                    // LOGIC
                    case 'IF':
                        return this['if'](funcArgs[0], funcArgs[1], funcArgs[2]);

                    // ROLL
                    case 'ROLLLENGTH':
                        return rollCalculationService.rollLength(funcArgs[0], funcArgs[1], funcArgs[2]);
                    case 'ROLLOUTERDIAMETER':
                        return rollCalculationService.rollOuterDiameter(funcArgs[0], funcArgs[1], funcArgs[2]);
                    case 'ROLLINNERDIAMETER':
                        return rollCalculationService.rollInnerDiameter(funcArgs[0], funcArgs[1], funcArgs[2]);
                    case 'INROLLCALIPER':
                        return rollCalculationService.inRollCaliper(funcArgs[0], funcArgs[1], funcArgs[2]);
                    case 'ROLLWEIGHT':
                        return rollCalculationService.rollWeight(funcArgs[0], funcArgs[1], funcArgs[2]);
                    case 'ROLLBASISWEIGHT':
                        return rollCalculationService.rollBasisWeight(funcArgs[0], funcArgs[1], funcArgs[2]);
                }
            },

            /**
             * Helper function to parse strings and boolean values to number values. String representations of
             * numbers are parsed to floats, while boolean values are parsed to 1 if true or 0 if false.
             *
             * @param number - The value to be parsed to number value
             * @returns {number}
             */
            parseNum: function(number){
                if(typeof number == 'number' && !isNaN(number)){
                    return number;
                } else if(typeof number == 'string' && !isNaN(parseFloat(number))){
                    return parseFloat(number);
                } else if(number === true){
                    return 1;
                } else if(number === false){
                    return 0;
                } else {
                    return null;
                }
            },

            /**
             * Helper function that checks sign of a number for comparison with another number
             *
             * @param number - Number to find the sign for
             * @returns {number}
             */
            sign: function(number){
                if(number === 0){
                    return 0;
                }
                else if(number > 0){
                    return 1;
                }
                else{
                    return -1;
                }
            },

            /**
             * Helper function that formats an ISO date string
             *
             * @param value - may or may not be a date string
             * @returns {*}
             */
            toDate: function(value){
                if(value && typeof value == 'string' && value.search(/^[0-9]{4}-[0-9]{2}-[0-9]{2}[Tt][0-9]{2}:[0-9]{2}:[0-9]{2}(.[0-9]{1,4})?[Zz]?$/) >= 0){ // Checks if is ISO-format date string
                    return kendo.toString(new Date(value), 'g');
                }
                else if(value instanceof Date){
                    return kendo.toString(value, 'g');
                }
                else {
                    return value;
                }
            },

            /**
             * Takes a floating point number and finds the multiple of 10 that can be used to move the decimal
             * point to make the number an integer.  Used for a workaround for floating point errors.
             *
             * @param number Floating point number that needs to be converted to integer
             * @returns {number} Multiple of 10 that, when multiplied with the float, will result in an integer
             */
            getDecimalPlace: function(number){
                var dec = 1;
                var num = number;
                while(num % 1 !== 0){
                    num *= 10;
                    dec *= 10;
                }
                return dec;
            },

            // STRING FUNCTIONS
            /**
             * Joins two or more values into one string object. Equivalent to & operator.
             *
             * @param strings Array of arguments to be concatenated
             * @return {string}
             */
            concatenate: function(strings){
                return strings.join("");
            },

            /**
             * Finds the leftmost character(s) for a given string.
             *
             * @param text String to retrieve characters from
             * @param numChar Number of characters to retrieve from left of string
             * @returns {string}
             */
            left: function(text, numChar){
                text = text.toString();
                if(numChar == null){
                    numChar = 1;
                } else {
                    numChar = this.parseNum(numChar);
                    if(numChar < 0){
                        numChar = 1;
                    } else if(numChar >= text.length){
                        return text;
                    }
                }
                return text.substr(0, numChar);
            },

            /**
             * Finds the rightmost character(s) for a given string.
             *
             * @param text String to retrieve characters from
             * @param numChar Number of characters to retrieve from right of string
             * @returns {string}
             */
            right: function(text, numChar){
                text = text.toString();
                if(numChar == null){
                    numChar = 1;
                } else {
                    numChar = this.parseNum(numChar);
                    if(numChar < 0){
                        numChar = 1;
                    } else if(numChar >= text.length){
                        return text;
                    }
                }
                return text.substr(text.length - numChar, numChar);
            },

            /**
             * Does a global text replacement on the given string
             * @param text
             * @param find
             * @param replace
             * @returns {string}
             */
            substitute: function(text, find, replace){
                text = text.toString();
                if(find){
                    var regex = new RegExp(find, 'g');

                    text = text.replace(regex, replace);
                }

                return text || '';
            },

            /**
             * Returns length of string.
             *
             * @param text String return length of.
             * @returns {number}
             */
            len: function(text){
                text = text.toString();
                return text.length;
            },

            /**
             * Formats dates and numbers to strings. Uses kendo formatting.
             *
             * @param value {number|Date}
             * @param format {string}
             * @returns {string}
             */
            text: function(value, format){
                return kendo.toString(value, format);
            },

            /**
             * Formats text cases.
             *
             * @param txt {string}
             * @param format {string} [OPTIONS: "TITLECASE","UPPERCASE","LOWERCASE","FIRSTUPPERCASE","FIRSTLOWERCASE","FIRSTONLYUPPERCASE","FIRSTONLYLOWERCASE"]
             * @returns {string}
             */
            textcase: function(text, format){
                text = text.toString();
                if(format == null){
                    text = text;
                } else if(format === 'TITLECASE'){
                    text = text.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
                } else if(format === 'UPPERCASE'){
                    text = text.toUpperCase();
                } else if(format === 'LOWERCASE'){
                    text = text.toLowerCase();
                } else if(format === 'FIRSTUPPERCASE'){
                    text = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
                } else if(format === 'FIRSTLOWERCASE'){
                    text = text.charAt(0).toLowerCase() + text.slice(1).toUpperCase();
                } else if(format === 'FIRSTONLYUPPERCASE'){
                    text = text.charAt(0).toUpperCase() + text.slice(1);
                } else if(format === 'FIRSTONLYLOWERCASE'){
                    text = text.charAt(0).toLowerCase() + text.slice(1);
                }
                return text;
            },

            /**
             * Removes leading and trailing whitespace from a string
             *
             * @param text {string}
             * @returns {string}
             */
            trim: function(text){
                return _.trim(text);
            },

            /**
             * Converts string to numeric value
             *
             * @param text
             * @returns {*}
             */
            value: function(text){
                var numberValue = this.parseNum(text);

                // Throws error if text is parsed to NaN or Infinity
                if(_.isNaN(numberValue) || !_.isFinite(numberValue)){
                    return {error: '#VALUE!: Can not be interpreted as a numeric value'};
                }

                return numberValue;
            },

            /**
             * Returns number as text (2 -> "two")
             *
             * @param number
             * @returns {*}
             */
            writtenNumber: function(number){
                // writtenNumber function does not accept floats
                var integer = parseInt(number);

                return writtenNumber(integer);
            },

            // MATH FUNCTIONS
            /**
             * Adds two or more values together and returns the result. Equivalent to + operator.
             * Boolean and string values will be parsed to number values.
             *
             * @param numbers Array of numbers to be added
             * @return {number}
             */
            sum: function(numbers){
                var result = 0;
                var dec = 1;
                for(var sumIndex = 0; sumIndex < numbers.length; sumIndex++){
                    var num = this.parseNum(numbers[sumIndex]);
                    if(num != null){
                        var tempDec = this.getDecimalPlace(num);
                        if(tempDec > dec){
                            result /= dec;
                            dec = tempDec;
                            result *= dec;
                            num *= dec;
                        } else if(dec > 1) {
                            num *= dec;
                        }
                        result += num;
                    }
                }
                result /= dec;
                return result;
            },

            /**
             * Raises the value of the first argument to the power of the second argument. Equivalent to ^ operator.
             *
             * @param number Number value that will be raised to nth power
             * @param power Power that the number will be raised to
             * @return {number}
             */
            power: function(number, power){
                var num = number;
                var dec = this.getDecimalPlace(num);
                num *= dec;
                var result = Math.pow(num, power);
                result /= Math.pow(dec, power);
                return result;
            },

            /**
             * Multiplies two or more number values together and returns the result. Equivalent to * operator.
             * Boolean and string values will be parsed to number values.
             *
             * @param numbers Array of numbers that will be multiplied
             * @return {number|string}
             */
            product: function(numbers){
                var result = null;
                for(var productIndex = 0; productIndex < numbers.length; productIndex++){
                    var num = this.parseNum(numbers[productIndex]);
                    if(num != null){
                        if(result != null) {
                            var resultDec = this.getDecimalPlace(result);
                            var numDec = this.getDecimalPlace(num);
                            result *= resultDec;
                            num *= numDec;
                            result *= num;
                            result /= resultDec;
                            result /= numDec;
                        } else {
                            result = num;
                        }
                    }
                    else {
                        return '';
                    }
                }
                return this.round(result, this.enforcedDecimalPrecision);
            },

            /**
             * Divides the first argument by the second and returns the result. Equivalent to / operator
             *
             * @param dividend Number that will be divided
             * @param divisor Magnitude by which numerator will be divided
             * @return {number, object}
             */
            quotient: function(dividend, divisor){ // handle #VALUE! error
                if(typeof dividend != 'number' || typeof divisor != 'number') {
                    return {error: '#VALUE!: Attempted to divide with non-number value'};
                } else if(divisor === 0){
                    return {error: '#VALUE!: Attempted to divide by zero'};
                } else {
                    var result = dividend / divisor;
                    return this.round(result, this.enforcedDecimalPrecision);
                }
            },

            /**
             * Finds the average of two or more number values and returns the result. Empty (null) values are not
             * counted, but boolean values and string representations of numbers are.
             *
             * @param numbers Array of arguments to be averaged
             * @return {number}
             */
            average: function(numbers){
                var sum;
                var length = 0;
                for(var averageIndex = 0; averageIndex < numbers.length; averageIndex++){
                    var num = this.parseNum(numbers[averageIndex]);
                    if(num != null){
                        //sum += num;
                        length++;
                    }
                }

                if(length === 0){
                    return 0;
                }

                sum = this.sum(numbers);
                var dec = this.getDecimalPlace(sum);
                var result = sum * dec;
                result /= length;
                result /= dec;
                return this.round(result, this.enforcedDecimalPrecision);
            },

            /**
             * Rounds a number to the specified number of digits.
             *
             * @param number Number value to be rounded
             * @param numberDigits Number of digits the number value will be rounded to
             * @return {number}
             */
            round: function (number, numberDigits) {
                numberDigits = numberDigits || 0;
                var place = this.power(10, numberDigits);
                var numSign = this.sign(number);
                return numSign * Math.round(numSign * number * place) / place;
            },

            /**
             * Rounds number down, toward zero, to the nearest multiple of significance.
             *
             * @param number Number value to be rounded
             * @param significance Multiple of significance to which the number will be rounded
             * @return {number, object}
             */
            floor: function(number, significance){
                var result = 0;
                if(typeof number != 'number') { // #VALUE! error
                    return {error: '#VALUE!: Attempted to FLOOR non-number value'};
                } else if(typeof significance != 'number') {
                    return {error: '#VALUE!: Multiple of significance for FLOOR is not a number'};
                } else if(this.sign(number) != this.sign(significance)) { // #NUM! error
                    return {error: '#NUM!: FLOOR: Arguments\' signs must match'};
                } else {
                    var numSign = this.sign(number);
                    var num = number * numSign;
                    var sig = significance * numSign;
                    var dec = 1;
                    while(sig % 1 !== 0 || num % 1 !== 0){ // Workaround for some issues with floating points
                        sig *= 10;
                        num *= 10;
                        dec *= 10;
                    }
                    var mult = Math.floor(num / sig);
                    result = ( mult * sig ) / dec;
                    result *= numSign;
                    return result;
                }
            },

            /**
             * Rounds number up, away from zero, to the nearest multiple of significance.
             *
             * @param number Number value to be rounded
             * @param significance Multiple of significance to which the number will be rounded
             * @return {number, object}
             */
            ceiling: function(number, significance){
                var result = 0;
                if(typeof number != 'number') { // #VALUE! error
                    return {error: '#VALUE!: Attempted to find ceiling of non-number value'};
                } else if(typeof significance != 'number') {
                    return {error: '#VALUE!: Multiple of significance for CEILING is not a number'};
                } else if(this.sign(number) != this.sign(significance)) { // #NUM! error
                    return {error: '#NUM!: CEILING: Arguments\' signs must match'};
                } else {
                    var numSign = this.sign(number);
                    var num = number * numSign;
                    var sig = significance * numSign;
                    var dec = 1;
                    while(sig % 1 !== 0 || num % 1 !== 0){
                        sig *= 10;
                        num *= 10;
                        dec *= 10;
                    }
                    var mult = Math.ceil(num / sig);
                    result = ( mult * sig ) / dec;
                    result *= numSign;
                    return result;
                }
            },

            /**
             * Returns value of pi
             *
             * @returns {number|Math.PI|*}
             */
            pi: function(){
                return Math.PI;
            },

            /**
             * Finds absolute value of number value
             *
             * @param n
             * @returns {*}
             */
            abs: function(n){
                return Math.abs(n);
            },

            /**
             * Finds square root of number value
             *
             * @param n
             * @returns {*}
             */
            sqrt: function(n){
                return Math.sqrt(n);
            },

            /**
             * Finds and returns the smallest number value
             *
             * @returns {*}
             */
            min: function(){
                var minimumValue = '';

                for (var i = 0; i < arguments.length; i++){
                    var numberValue = this.parseNum(arguments[i]);

                    if(_.isNaN(numberValue) || !_.isFinite(numberValue)){
                        // return { error: '#VALUE!: Can not be interpreted as a numeric value' };   // Throws error if value cannot be parsed to finite number
                        continue;   // Skips this value if it cannot be parsed to a valid number
                    }

                    if (minimumValue === '' || numberValue < minimumValue) {
                        minimumValue = numberValue;
                    }
                }

                return minimumValue;
            },

            /**
             * Finds and returns the largest number value
             *
             * @returns {*}
             */
            max: function(){
                var maximumValue = '';

                for (var i = 0; i < arguments.length; i++){
                    var numberValue = this.parseNum(arguments[i]);

                    if(_.isNaN(numberValue) || !_.isFinite(numberValue)){
                        // return { error: '#VALUE!: Can not be interpreted as a numeric value' };   // Throws error if value cannot be parsed to finite number
                        continue;   // Skips this value if it cannot be parsed to a valid number
                    }

                    if (maximumValue === '' || numberValue > maximumValue) {
                        maximumValue = numberValue;
                    }
                }

                return maximumValue;
            },

            /**
             * Returns date Now
             *
             * @returns {string}
             */
            now: function(){
                return moment().toISOString();
            },

            /**
             * Increments date by number of units
             *
             * @param date Date to be modified
             * @param value Number of units to add
             * @param unit Type of unit to add (e.g., days, months, years...)
             * @returns {string}
             */
            dateAdd: function(date, value, unit){
                var newDate;
                
                if(!date){
                    return null;
                }
                else if(date instanceof Date){
                    if(date.toString() == 'Invalid Date'){
                        return null;
                    }

                    newDate = moment(date.toISOString());
                }
                else {
                    newDate = moment(date);
                }

                newDate.add(this.parseNum(value), unit);
                return newDate.toDate();
            },

            /**
             * Decrements date by number of units
             *
             * @param date Date to be modified
             * @param value Number of units to subtract
             * @param unit Type of unit to subtract (e.g., days, months, years...)
             * @returns {string}
             */
            dateSub: function(date, value, unit){
                var newDate;

                if(!date){
                    return null;
                }
                else if(date instanceof Date){
                    if(date.toString() == 'Invalid Date'){
                        return null;
                    }
                    
                    newDate = moment(date.toISOString());
                }
                else {
                    newDate = moment(date);
                }

                newDate.subtract(this.parseNum(value), unit);
                return newDate.toDate();
            },

            /**
             * Finds difference between two dates
             *
             * @param a First Date string
             * @param b Second Date string
             * @param unit Type of unit to find difference
             * @returns {*}
             */
            dateDiff: function(a, b, unit){
                var dateA = a instanceof Date ? moment(a.toISOString()) : moment(a);
                var dateB = b instanceof Date ? moment(b.toISOString()) : moment(b);
                if(unit) {
                    return Math.ceil(dateB.diff(dateA, unit, true));
                }
                else {
                    return dateB.diff(dateA);
                }
            },

            /**
             * Returns value based on the result of the given condition
             *
             * @param conditionResult - Condition that is used to determine which value to return
             * @param trueValue - Returned if the given condition resulted in a truthy value
             * @param falseValue - Returned if the condition resulted in a falsey value
             * @returns {*}
             */
            'if': function(conditionResult, trueValue, falseValue){
                if (!!conditionResult) {
                    if (trueValue instanceof Array) { // If true value is array of tokens, evaluate it first
                        var trueResult = this.calculate(trueValue);

                        if (trueResult.type === 'error') {
                            return { error: trueResult.value };
                        }

                        trueValue = trueResult.value;
                    }

                    return trueValue;
                }
                if (falseValue === null || typeof falseValue  === 'undefined') {
                    falseValue = '';
                }
                else if (falseValue instanceof Array){ // If false value is array of tokens, evaluate it first
                    var falseResult = this.calculate(falseValue);

                    if (falseResult.type === 'error') {
                            return { error: falseResult.value };
                    }

                    falseValue = falseResult.value;
                }
                return falseValue;
            }
        };
    }])
;
/*globals define, CodeMirror */
(function(mod) {
    if (typeof exports == "object" && typeof module == "object") {// CommonJS
        mod(require("../../lib/codemirror")); }
    else if (typeof define == "function" && define.amd) {// AMD
        define(["../../lib/codemirror"], mod); }
    else {// Plain browser env
        mod(CodeMirror); }
})(function(CodeMirror) {
    "use strict";

    var functions = [
        'ABS',
        'AVERAGE',
        'CEILING',
        'CONCATENATE',
        'DATEADD',
        'DATEDIFF',
        'DATESUB',
        'FLOOR',
        'IF',
        'INROLLCALIPER',
        'LEFT',
        'LEN',
        'MAX',
        'MIN',
        'NOW',
        'PI',
        'POWER',
        'PRODUCT',
        'QUOTIENT',
        'RIGHT',
        'ROLLBASISWEIGHT',
        'ROLLINNERDIAMETER',
        'ROLLLENGTH',
        'ROLLOUTERDIAMETER',
        'ROLLWEIGHT',
        'ROUND',
        'SQRT',
        'SUBSTITUTE',
        'SUM',
        'TEXT',
        'TEXTCASE(Text, [OPTIONS: "TITLECASE","UPPERCASE","LOWERCASE","FIRSTUPPERCASE","FIRSTLOWERCASE","FIRSTONLYUPPERCASE","FIRSTONLYLOWERCASE"])',
        'TRIM',
        'VALUE',
        'WRITTENNUMBER'
    ];
    var pos = CodeMirror.Pos;

    function getText(item) {
        return typeof item == "string" ? item : item.text;
    }

    function match(string, word) {
        var len = string.length;
        var sub = getText(word).substr(0, len);
        return string.toUpperCase() === sub.toUpperCase();
    }

    function looseMatch(string, word) {
        var sub = getText(word).indexOf(string.replace("'", ""));
        return sub !== -1;
    }

    function addMatches(result, search, wordlist, formatter) {
        if (wordlist && wordlist.length && typeof wordlist === 'object') {
            for (var i = 0; i < wordlist.length; i++) {
                if (match(search, wordlist[i])) {
                    result.push(formatter(wordlist[i]));
                }
            }
        }
    }

    function addLooseMatches(result, search, wordlist, formatter) {
        if (wordlist && wordlist.length && typeof wordlist === 'object') {
            for (var i = 0; i < wordlist.length; i++) {
                if (looseMatch(search, wordlist[i])) {
                    result.push(formatter(wordlist[i]));
                }
            }
        }
    }

    CodeMirror.registerHelper("hint", "nimcalc", function(editor, options) {
        var udf = options && options.udf || [];
        var namedVars = options && options.namedVars || [];

        var cur = editor.getCursor();
        var result = [];
        var token = editor.getTokenAt(cur),
            start, end, search;
        if (token.end > cur.ch) {
            token.end = cur.ch;
            token.string = token.string.slice(0, cur.ch - token.start);
        }
        if (token.string.match(/^[.'\w@]\w*$/)) {
            search = token.string;
            start = token.start;
            end = token.end;
        } else {
            start = end = cur.ch;
            search = "";
        }

        if (search.charAt(0) == "'" || token.type === 'variable') {
            addLooseMatches(result, search, namedVars, function(w) {
                return w;
            });
        } else if (search.charAt(0) == "("){
            // TODO: Show parameter help
        } else {
            addMatches(result, search, functions, function(w) {
                return w;
            });
            addMatches(result, search, udf, function(w) {
                return w;
            });
        }
        return {
            list: result,
            from: pos(cur.line, start),
            to: pos(cur.line, end)
        };
    });
});
/*globals define, CodeMirror */
(function(mod) {
    if (typeof exports == "object" && typeof module == "object") {// CommonJS
        mod(require("../../lib/codemirror")); }
    else if (typeof define == "function" && define.amd) {// AMD
        define(["../../lib/codemirror"], mod); }
    else {// Plain browser env
        mod(CodeMirror); }
})(function(CodeMirror) {
    "use strict";

    CodeMirror.defineMode("nimcalc", function () {
        return {
            startState: function () {
                return {
                    stringType: null,
                    stack: []
                };
            },
            token: function (stream, state) {
                if (!stream) {return;}

                //check for state changes
                if (state.stack.length === 0) {
                    //strings
                    if ((stream.peek() == '"')) {
                        state.stringType = stream.peek();
                        stream.next(); // Skip quote
                        state.stack.unshift("string");
                    }
                }

                //return state
                //stack has
                switch (state.stack[0]) {
                    case "string":
                        while (state.stack[0] === "string" && !stream.eol()) {
                            if (stream.peek() === state.stringType) {
                                stream.next(); // Skip quote
                                state.stack.shift(); // Clear flag
                            } else if (stream.peek() === "\\") {
                                stream.next();
                                stream.next();
                            } else {
                                stream.match(/^.[^\\\"]*/);
                            }
                        }
                        return "string";
                    case "characterClass":
                        while (state.stack[0] === "characterClass" && !stream.eol()) {
                            if (!(stream.match(/^[^\]\\]+/) || stream.match(/^\\./))) {
                                state.stack.shift();
                            }
                        }
                        return "operator";
                }

                var peek = stream.peek();

                //no stack
                switch (peek) {
                    case "[":
                        stream.next();
                        state.stack.unshift("characterClass");
                        return "bracket";
                    case ":":
                        stream.next();
                        return "operator";
                    case "\\":
                        if (stream.match(/\\[a-z]+/)) { return "string-2"; }
                        else {
                            stream.next();
                            return "atom";
                        }
                    /* falls through */
                    case ".":
                    case ",":
                    case ";":
                    case "*":
                    case "-":
                    case "+":
                    case "^":
                    case "<":
                    case "/":
                    case "=":
                        stream.next();
                        return "atom";
                    case "$":
                        stream.next();
                        return "builtin";
                }

                if (stream.match(/\d+/)) {
                    if (stream.match(/^\w+/)) { return "error"; }
                    return "number";
                } else if (stream.match(/^'[a-zA-Z_ ]*'?/)) {
                    return "variable";
                } else if (stream.match(/^[a-zA-Z_]\w*/)) {
                    if (stream.match(/(?=[\(.])/, false)) { return "keyword"; }
                    return "variable-2";
                } else if (["(", ")"].indexOf(peek) != -1) {
                    stream.next();
                    return "bracket";
                } else if (["[", "]", "{", "}"].indexOf(peek) != -1) {
                    stream.next();
                    return "error";
                } else if (!stream.eatSpace()) {
                    stream.next();
                }
                return null;
            }
        };
    });

    CodeMirror.defineMIME("text/x-nimcalc", "nimcalc");
});
angular.module('cerberus.util')
    /**
     * Roll Calculator
     * Equations taken from http://www.giangrandi.ch/soft/spiral/spiral.shtml
     * Inspiration taken from http://www.handymath.com/calculators.html
     */
    .factory('rollCalculationService', function() {
        var service = {
            rollLength: rollLength,
            rollOuterDiameter: rollOuterDiameter,
            rollInnerDiameter: rollInnerDiameter,
            inRollCaliper: inRollCaliper,
            rollBasisWeight: rollBasisWeight,
            rollWeight: rollWeight
        };
        return service;
        ////////////////////
        /**
         * Roll Length Calculator
         * @param {number} h - Thickness or height of material
         * @param {number} d0 - Inner Diameter
         * @param {number} d1 - Outer Diameter
         * @return {number}
         */
        function rollLength(h, d0, d1) {
            var n, l, phi0, phi1;
            // n = number of revolutions
            n = (d1 - d0) / (2 * h);
            phi0 = Math.PI * d0 / h;
            phi1 = Math.PI * d1 / h;
            l = getExact_length(phi0, phi1, h);
            return l;
        }
        /**
         * Roll Diameter Calculator
         * @param {number} h - Thickness or height of material
         * @param {number} d0 - Inner Diameter
         * @param {number} l - Roll Length
         * @return {number}
         */
        function rollOuterDiameter(h, d0, l) {
            var n, d1, phi0, phi1, delta_phi, max_iter;
            // Maximum number of interation for convergence of the Newton's method.
            max_iter = 200;
            /////////////////////////////////////////////////////////////////////////////
            // To find "phi1" from L(phi1)=(h/2pi)(...) we have to numerically solve
            // (h/2pi)(...)-L=0, so we have f(phi1)=(h/2pi)(...)-L=0
            // The approximate formula is used to find a starting point, from which we
            // use Newton's method to find a more accurate numerical solution as follows:
            //
            // phi_n+1 = phi_n - (f(phi_n)/f'(phi_n))
            //
            // Whith this method, there is no need to invert the function, it's only
            // necessary to find it's derivative. It converges quite quickly and only a
            // few iterations are required for the precision of the floating point
            // variable used.
            /////////////////////////////////////////////////////////////////////////////
            n = (h - d0 + Math.sqrt((d0 - h) * (d0 - h) + (4 * h * l) / Math.PI)) / (2 * h);
            d1 = 2 * n * h + d0;
            phi0 = Math.PI * d0 / h;
            phi1 = Math.PI * d1 / h;
            // This is the starting approximation.
            for (var i = 0; i <= max_iter; i++) {
                delta_phi = (getExact_length(phi0, phi1, h) - l) / getExact_dL_dphi(phi1, h);
                phi1 -= delta_phi;
                // Stop looping if solution already found.
                if (delta_phi === 0) {
                    break;
                }
            } // Now we have phi1 and we find d1.
            d1 = phi1 * h / Math.PI;
            // And find a more accurate N.
            // n = number of revolutions
            n = (d1 - d0) / (2 * h);
            return d1;
        }
        /**
         * Inner Diameter of Roll
         * @param {number} h - Thickness or height of material
         * @param {number} d1 - Outer Diameter
         * @param {number} l - Roll Length
         * @return {number}
         */
        function rollInnerDiameter(h, d1, l) {
            var minOuterDia, len, dia;
            minOuterDia = rollOuterDiameter(h, h, l);
            len = rollLength(h, minOuterDia, d1);
            dia = rollOuterDiameter(h, h, len);
            return dia;
        }
        /**
         * Thickness of Material on a Roll
         * Winding: Machines, Mechanics and Measurements
         * By James K. Good, David R. Roisum
         * page 124
         * @param {number} d0 - Inner Diameter
         * @param {number} d1 - Outer Diameter
         * @param {number} l - Roll Length
         * @return {number}
         */
        function inRollCaliper(d0, d1, l) {
            var h = (Math.PI / (4 * l)) * (Math.pow(d1, 2) - Math.pow(d0, 2));
            return h;
        }

        /**
         * Calculates the Basis Weight of a roll
         * Notes: 1000 square feet = 144000 square inches
         * @param {number} l - Length
         * @param {number} w - Width
         * @param {number} rw - Weight of Roll
         * @return {number}
         */
        function rollBasisWeight(l, w, rw) {
            var bw = rw / (l * w / 144000);
            return bw;
        }

        /**
         * Calculates the Weight of a roll
         * Notes: 1000 square feet = 144000 square inches
         * @param {number} l - Length
         * @param {number} w - Width
         * @param {number} bw - Basis Weight
         * @return {number}
         */
        function rollWeight(l, w, bw) {
            var rw = l * w * (bw / 144000);
            return rw;
        }

        /**
         * Length Helper
         * @param {number} phi0
         * @param {number} phi1
         * @param {number} h
         * @return {number}
         */
        function getExact_length(phi0, phi1, h) {
            var length;
            length = (phi1 / 2) * Math.sqrt(phi1 * phi1 + 1);
            length += (1 / 2) * Math.log(phi1 + Math.sqrt(phi1 * phi1 + 1));
            length -= (phi0 / 2) * Math.sqrt(phi0 * phi0 + 1);
            length -= (1 / 2) * Math.log(phi0 + Math.sqrt(phi0 * phi0 + 1));
            length *= h / (2 * Math.PI);
            return length;
        }
        /**
         * Diameter Helper
         * @param {number} phi
         * @param {number} h
         * @return {number}
         */
        function getExact_dL_dphi(phi, h) {
            var dL_dphi;
            dL_dphi = (2 * phi * phi + 1) / (2 * Math.sqrt(phi * phi + 1));
            dL_dphi += (phi + Math.sqrt(phi * phi + 1)) / (2 * phi * Math.sqrt(phi * phi + 1) + 2 * phi * phi + 2);
            dL_dphi *= h / (2 * Math.PI);
            return dL_dphi;
        }
    })
;
angular.module('cerberus.util')
    .factory('nimCalcService', function nimCalcService() {
        /**
         * http://ewbi.blogs.com/develops/2004/12/excel_formula_p.html
         */
        /**@private */
        var TOK_TYPE_NOOP = "noop";
        var TOK_TYPE_OPERAND = "operand";
        var TOK_TYPE_FUNCTION = "function";
        var TOK_TYPE_SUBEXPR = "subexpression";
        var TOK_TYPE_ARGUMENT = "argument";
        var TOK_TYPE_OP_PRE = "operator-prefix";
        var TOK_TYPE_OP_IN = "operator-infix";
        var TOK_TYPE_OP_POST = "operator-postfix";
        var TOK_TYPE_WSPACE = "white-space";
        var TOK_TYPE_UNKNOWN = "unknown";

        var TOK_SUBTYPE_START = "start";
        var TOK_SUBTYPE_STOP = "stop";

        var TOK_SUBTYPE_TEXT = "text";
        var TOK_SUBTYPE_NUMBER = "number";
        var TOK_SUBTYPE_LOGICAL = "logical";
        var TOK_SUBTYPE_ERROR = "error";
        var TOK_SUBTYPE_RANGE = "range";

        var TOK_SUBTYPE_MATH = "math";
        var TOK_SUBTYPE_CONCAT = "concatenate";
        var TOK_SUBTYPE_INTERSECT = "intersect";
        var TOK_SUBTYPE_UNION = "union";

        function F_token(value, type, subtype) {
            this.value = value;
            this.type = type;
            this.subtype = subtype;
        }

        function F_tokens() {
            this.items = [];
            this.add = function (value, type, subtype) {
                if (!subtype) {
                    subtype = "";
                }
                var token = new F_token(value, type, subtype);
                this.addRef(token);
                return token;
            };
            this.addRef = function (token) {
                this.items.push(token);
            };
            this.index = -1;
            this.reset = function () {
                this.index = -1;
            };
            this.BOF = function () {
                return (this.index <= 0);
            };
            this.EOF = function () {
                return (this.index >= (this.items.length - 1));
            };
            this.moveNext = function () {
                if (this.EOF()) {
                    return false;
                }
                this.index++;
                return true;
            };
            this.current = function () {
                if (this.index == -1) {
                    return null;
                }
                return (this.items[this.index]);
            };
            this.next = function () {
                if (this.EOF()) {
                    return null;
                }
                return (this.items[this.index + 1]);
            };
            this.previous = function () {
                if (this.index < 1) {
                    return null;
                }
                return (this.items[this.index - 1]);
            };
        }

        function F_tokenStack() {
            this.items = [];
            this.push = function (token) {
                this.items.push(token);
            };
            this.pop = function () {
                var token = this.items.pop();
                return (new F_token("", token.type, TOK_SUBTYPE_STOP));
            };
            this.token = function () {
                return ((this.items.length > 0) ? this.items[this.items.length - 1] : null);
            };
            this.value = function () {
                return ((this.token()) ? this.token().value : "");
            };
            this.type = function () {
                return ((this.token()) ? this.token().type : "");
            };
            this.subtype = function () {
                return ((this.token()) ? this.token().subtype : "");
            };
        }

        var getTokens = function (formula) {
            formula = formula.trim();

            var tokens = new F_tokens();
            var tokenStack = new F_tokenStack();
            var offset = 0;
            var currentChar = function () {
                return formula.substr(offset, 1);
            };
            var doubleChar = function () {
                return formula.substr(offset, 2);
            };
            var nextChar = function () {
                return formula.substr(offset + 1, 1);
            };
            var EOF = function () {
                return (offset >= formula.length);
            };
            var token = "";
            var inString = false;
            var inPath = false;
            var inRange = false;
            var inError = false;

            while (formula.length > 0) {
                if (formula.substr(0, 1) == " ") {
                    formula = formula.substr(1);
                } else {
                    if (formula.substr(0, 1) == "=") {
                        formula = formula.substr(1);
                    }
                    break;
                }
            }

            var regexSN = /^[1-9]{1}(\.[0-9]+)?E{1}$/;

            while (!EOF()) {
                // state-dependent character evaluation (order is important)

                // double-quoted strings
                // embeds are doubled
                // end marks token
                if (inString) {
                    if (currentChar() == "\"") {
                        if (nextChar() == "\"") {
                            token += "\"";
                            offset += 1;
                        } else {
                            inString = false;
                            tokens.add(token, TOK_TYPE_OPERAND, TOK_SUBTYPE_TEXT);
                            token = "";
                        }
                    } else {
                        token += currentChar();
                    }
                    offset += 1;
                    continue;
                }

                // single-quoted strings (links)
                // embeds are double
                // end does not mark a token
                if (inPath) {
                    if (currentChar() == "'") {
                        if (nextChar() == "'") {
                            token += "'";
                            offset += 1;
                        } else {
                            inPath = false;
                        }
                    } else {
                        token += currentChar();
                    }
                    offset += 1;
                    continue;
                }

                // bracked strings (range offset or linked workbook name)
                // no embeds (changed to "()" by Excel)
                // end does not mark a token
                if (inRange) {
                    if (currentChar() == "]") {
                        inRange = false;
                    }
                    token += currentChar();
                    offset += 1;
                    continue;
                }

                // error values
                // end marks a token, determined from absolute list of values
                if (inError) {
                    token += currentChar();
                    offset += 1;
                    if ((",#NULL!,#DIV/0!,#VALUE!,#REF!,#NAME?,#NUM!,#N/A,").indexOf("," + token + ",") != -1) {
                        inError = false;
                        tokens.add(token, TOK_TYPE_OPERAND, TOK_SUBTYPE_ERROR);
                        token = "";
                    }
                    continue;
                }

                // scientific notation check
                if (("+-").indexOf(currentChar()) != -1) {
                    if (token.length > 1) {
                        if (token.match(regexSN)) {
                            token += currentChar();
                            offset += 1;
                            continue;
                        }
                    }
                }

                // independent character evaulation (order not important)
                // establish state-dependent character evaluations
                if (currentChar() == "\"") {
                    if (token.length > 0) {
                        // not expected
                        tokens.add(token, TOK_TYPE_UNKNOWN);
                        token = "";
                    }
                    inString = true;
                    offset += 1;
                    continue;
                }

                if (currentChar() == "'") {
                    if (token.length > 0) {
                        // not expected
                        tokens.add(token, TOK_TYPE_UNKNOWN);
                        token = "";
                    }
                    inPath = true;
                    offset += 1;
                    continue;
                }

                if (currentChar() == "[") {
                    inRange = true;
                    token += currentChar();
                    offset += 1;
                    continue;
                }

                if (currentChar() == "#") {
                    if (token.length > 0) {
                        // not expected
                        tokens.add(token, TOK_TYPE_UNKNOWN);
                        token = "";
                    }
                    inError = true;
                    token += currentChar();
                    offset += 1;
                    continue;
                }

                // mark start and end of arrays and array rows
                if (currentChar() == "{") {
                    if (token.length > 0) {
                        // not expected
                        tokens.add(token, TOK_TYPE_UNKNOWN);
                        token = "";
                    }
                    tokenStack.push(tokens.add("ARRAY", TOK_TYPE_FUNCTION, TOK_SUBTYPE_START));
                    tokenStack.push(tokens.add("ARRAYROW", TOK_TYPE_FUNCTION, TOK_SUBTYPE_START));
                    offset += 1;
                    continue;
                }

                if (currentChar() == ";") {
                    if (token.length > 0) {
                        tokens.add(token, TOK_TYPE_OPERAND);
                        token = "";
                    }
                    tokens.addRef(tokenStack.pop());
                    tokens.add(",", TOK_TYPE_ARGUMENT);
                    tokenStack.push(tokens.add("ARRAYROW", TOK_TYPE_FUNCTION, TOK_SUBTYPE_START));
                    offset += 1;
                    continue;
                }

                if (currentChar() == "}") {
                    if (token.length > 0) {
                        tokens.add(token, TOK_TYPE_OPERAND);
                        token = "";
                    }
                    tokens.addRef(tokenStack.pop());
                    tokens.addRef(tokenStack.pop());
                    offset += 1;
                    continue;
                }

                // trim white-space
                if (currentChar() == " ") {
                    if (token.length > 0) {
                        tokens.add(token, TOK_TYPE_OPERAND);
                        token = "";
                    }
                    tokens.add("", TOK_TYPE_WSPACE);
                    offset += 1;
                    while ((currentChar() == " ") && (!EOF())) {
                        offset += 1;
                    }
                    continue;
                }

                // multi-character comparators
                if ((",>=,<=,<>,&&,||,").indexOf("," + doubleChar() + ",") != -1) {
                    if (token.length > 0) {
                        tokens.add(token, TOK_TYPE_OPERAND);
                        token = "";
                    }
                    tokens.add(doubleChar(), TOK_TYPE_OP_IN, TOK_SUBTYPE_LOGICAL);
                    offset += 2;
                    continue;
                }

                // standard infix operators
                if (("+-*/^&=><").indexOf(currentChar()) != -1) {
                    if (token.length > 0) {
                        tokens.add(token, TOK_TYPE_OPERAND);
                        token = "";
                    }
                    tokens.add(currentChar(), TOK_TYPE_OP_IN);
                    offset += 1;
                    continue;
                }

                // standard postfix operators
                if (("%").indexOf(currentChar()) != -1) {
                    if (token.length > 0) {
                        tokens.add(token, TOK_TYPE_OPERAND);
                        token = "";
                    }
                    tokens.add(currentChar(), TOK_TYPE_OP_POST);
                    offset += 1;
                    continue;
                }

                // start subexpression or function
                if (currentChar() == "(") {
                    if (token.length > 0) {
                        tokenStack.push(tokens.add(token, TOK_TYPE_FUNCTION, TOK_SUBTYPE_START));
                        token = "";
                    } else {
                        tokenStack.push(tokens.add("", TOK_TYPE_SUBEXPR, TOK_SUBTYPE_START));
                    }
                    offset += 1;
                    continue;
                }

                // function, subexpression, array parameters
                if (currentChar() == ",") {
                    if (token.length > 0) {
                        tokens.add(token, TOK_TYPE_OPERAND);
                        token = "";
                    }
                    //if (!(tokenStack.type() == TOK_TYPE_FUNCTION)) {
                    if (tokenStack.type() !== TOK_TYPE_FUNCTION) {
                        tokens.add(currentChar(), TOK_TYPE_OP_IN, TOK_SUBTYPE_UNION);
                    } else {
                        tokens.add(currentChar(), TOK_TYPE_ARGUMENT);
                    }
                    offset += 1;
                    continue;
                }

                // stop subexpression
                if (currentChar() == ")") {
                    if (token.length > 0) {
                        tokens.add(token, TOK_TYPE_OPERAND);
                        token = "";
                    }
                    tokens.addRef(tokenStack.pop());
                    offset += 1;
                    continue;
                }

                // token accumulation
                token += currentChar();
                offset += 1;

            }

            // dump remaining accumulation
            if (token.length > 0) {
                tokens.add(token, TOK_TYPE_OPERAND);
            }

            // move all tokens to a new collection, excluding all unnecessary white-space tokens
            var tokens2 = new F_tokens();

            while (tokens.moveNext()) {
                token = tokens.current();
                if (token.type == TOK_TYPE_WSPACE) {
                    if ((tokens.BOF()) || (tokens.EOF())) {
                    } else if (!(
                            ((tokens.previous().type == TOK_TYPE_FUNCTION) && (tokens.previous().subtype == TOK_SUBTYPE_STOP)) ||
                            ((tokens.previous().type == TOK_TYPE_SUBEXPR) && (tokens.previous().subtype == TOK_SUBTYPE_STOP)) ||
                            (tokens.previous().type == TOK_TYPE_OPERAND)
                        )
                    ) {
                    } else if (!(
                            ((tokens.next().type == TOK_TYPE_FUNCTION) && (tokens.next().subtype == TOK_SUBTYPE_START)) ||
                            ((tokens.next().type == TOK_TYPE_SUBEXPR) && (tokens.next().subtype == TOK_SUBTYPE_START)) ||
                            (tokens.next().type == TOK_TYPE_OPERAND)
                        )
                    ) {
                    } else {
                        tokens2.add(token.value, TOK_TYPE_OP_IN, TOK_SUBTYPE_INTERSECT);
                    }
                    continue;
                }
                tokens2.addRef(token);
            }

            // switch infix "-" operator to prefix when appropriate, switch infix "+" operator to noop when appropriate, identify operand
            // and infix-operator subtypes, pull "@" from in front of function names
            while (tokens2.moveNext()) {
                token = tokens2.current();
                if ((token.type == TOK_TYPE_OP_IN) && (token.value == "-")) {
                    if (tokens2.BOF()) {
                        token.type = TOK_TYPE_OP_PRE;
                    } else if (
                        ((tokens2.previous().type == TOK_TYPE_FUNCTION) && (tokens2.previous().subtype == TOK_SUBTYPE_STOP)) ||
                        ((tokens2.previous().type == TOK_TYPE_SUBEXPR) && (tokens2.previous().subtype == TOK_SUBTYPE_STOP)) ||
                        (tokens2.previous().type == TOK_TYPE_OP_POST) ||
                        (tokens2.previous().type == TOK_TYPE_OPERAND)
                    ) {
                        token.subtype = TOK_SUBTYPE_MATH;
                    } else {
                        token.type = TOK_TYPE_OP_PRE;
                    }
                    continue;
                }

                if ((token.type == TOK_TYPE_OP_IN) && (token.value == "+")) {
                    if (tokens2.BOF()) {
                        token.type = TOK_TYPE_NOOP;
                    } else if (
                        ((tokens2.previous().type == TOK_TYPE_FUNCTION) && (tokens2.previous().subtype == TOK_SUBTYPE_STOP)) ||
                        ((tokens2.previous().type == TOK_TYPE_SUBEXPR) && (tokens2.previous().subtype == TOK_SUBTYPE_STOP)) ||
                        (tokens2.previous().type == TOK_TYPE_OP_POST) ||
                        (tokens2.previous().type == TOK_TYPE_OPERAND)
                    ) {
                        token.subtype = TOK_SUBTYPE_MATH;
                    } else {
                        token.type = TOK_TYPE_NOOP;
                    }
                    continue;
                }

                //if ((token.type == TOK_TYPE_OP_IN) && (token.subtype.length == 0)) {
                if ((token.type == TOK_TYPE_OP_IN) && (token.subtype.length === 0)) {
                    if (token.value != "&" && ("<>=&&||").indexOf(token.value.substr(0, 1)) != -1) {
                        token.subtype = TOK_SUBTYPE_LOGICAL;
                    } else if (token.value == "&") {
                        token.subtype = TOK_SUBTYPE_CONCAT;
                    } else {
                        token.subtype = TOK_SUBTYPE_MATH;
                    }
                    continue;
                }

                //if ((token.type == TOK_TYPE_OPERAND) && (token.subtype.length == 0)) {
                if ((token.type == TOK_TYPE_OPERAND) && (token.subtype.length === 0)) {
                    if (isNaN(parseFloat(token.value))) {
                        if ((token.value == 'TRUE') || (token.value == 'FALSE')) {
                            token.subtype = TOK_SUBTYPE_LOGICAL;
                        } else {
                            token.subtype = TOK_SUBTYPE_RANGE;
                        }
                    } else {
                        token.subtype = TOK_SUBTYPE_NUMBER;
                        token.value = parseFloat(token.value);
                    }
                    continue;
                }

                if (token.type == TOK_TYPE_FUNCTION) {
                    if (token.value.substr(0, 1) == "@") {
                        token.value = token.value.substr(1);
                    }
                    continue;
                }
            }

            tokens2.reset();

            // move all tokens to a new collection, excluding all noops
            tokens = new F_tokens();

            while (tokens2.moveNext()) {
                if (tokens2.current().type != TOK_TYPE_NOOP) {
                    tokens.addRef(tokens2.current());
                }
            }

            tokens.reset();

            return tokens;
        };

        /**@public */
        return {
            parse: getTokens,
            TOK_SUBTYPE_START: TOK_SUBTYPE_START,
            TOK_SUBTYPE_STOP: TOK_SUBTYPE_STOP
        };
    })
    .directive('nimCalcParsedTable', ["nimCalcService", function(nimCalcService) {
        return {
            restrict: 'AE',
            scope: {
                formula: '=nimCalcParsedTable'
            },
            link: function(scope, element) {
                var parserToTable = function (formula) {
                    var indentCount = 0;
                    var indent = function() {
                        var s = "|";
                        for (var i = 0; i < indentCount; i++) {
                            s += "&nbsp;&nbsp;&nbsp;|";
                        }
                        return s;
                    };
                    var tokens = nimCalcService.parse(formula);
                    var tokensHtml = "";
                    tokensHtml += "<table cellspacing='0' style='border-top: 1px #cecece solid; margin-top: 5px; margin-bottom: 5px'>";
                    tokensHtml += "<tr>";
                    tokensHtml += "<td class='token' style='font-weight: bold; width: 50px'>index</td>";
                    tokensHtml += "<td class='token' style='font-weight: bold; width: 125px'>type</td>";
                    tokensHtml += "<td class='token' style='font-weight: bold; width: 125px'>subtype</td>";
                    tokensHtml += "<td class='token' style='font-weight: bold; width: 150px'>token</td>";
                    tokensHtml += "<td class='token' style='font-weight: bold; width: 300px'>token tree</td></tr>";

                    while (tokens.moveNext()) {
                        var token = tokens.current();
                        if (token.subtype == nimCalcService.TOK_SUBTYPE_STOP) {
                            indentCount -= ((indentCount > 0) ? 1 : 0);
                        }
                        tokensHtml += "<tr>";
                        tokensHtml += "<td class='token'>" + (tokens.index + 1) + "</td>";
                        tokensHtml += "<td class='token'>" + token.type + "</td>";
                        tokensHtml += "<td class='token'>" + ((token.subtype.length === 0) ? "&nbsp;" : token.subtype) + "</td>";
                        tokensHtml += "<td class='token'>" + ((token.value.length === 0) ? "&nbsp;" : token.value).split(" ").join("&nbsp;") + "</td>";
                        tokensHtml += "<td class='token'>" + indent() + ((token.value.length === 0) ? "&nbsp;" : token.value).split(" ").join("&nbsp;") + "</td>";
                        tokensHtml += "</tr>";
                        if (token.subtype == nimCalcService.TOK_SUBTYPE_START) {
                            indentCount += 1;
                        }
                    }
                    tokensHtml += "</table>";
                    return tokensHtml;
                };

                scope.$watch('formula', function(newValue){
                    element.html(parserToTable(newValue));
                });
            }
        };
    }])
;
/*jshint bitwise: false*/
angular.module('cerberus.util')
    /**
     * @ngdoc service
     * @name DesignerUtilityService
     * @alias cerberus/util:DesignerUtilityService
     * @description Provides UI functions for the designer modules
     */
    .factory('DesignerUtilityService', ["_", "kendo", "CodeMirror", "moment", "$http", "$rootScope", "$location", "$timeout", "$compile", "$sanitize", "ConfirmModalService", function DesignerUtilityService(_, kendo, CodeMirror, moment, $http, $rootScope, $location, $timeout, $compile, $sanitize, ConfirmModalService) {

        return {
            generateGuid: generateGuid,
            focusFirstElement: focusFirstElement,
            preventSpace: preventSpace,
            labelToUniqueId: labelToUniqueId,
            cssToArray: cssToArray,
            arrayToCss: arrayToCss,
            decodeHtml: decodeHtml,
            textEditorOptions: textEditorOptions,
            getIcons: getIcons,
            formGrid: formGrid,
            formDetailGrid: formDetailGrid,
            codemirrorLoaded: codemirrorLoaded,
            cancelRouteNav: cancelRouteNav,
            filterOperators: filterOperators,
            conditionFilter: conditionFilter,
            conditionOperators: conditionOperators,
            conditionBooleanValues: conditionBooleanValues,
            conditionActionValues: conditionActionValues,
            getConditionType: getConditionType,
            addCondition: addCondition,
            lookUpDefaultValueOptions: lookUpDefaultValueOptions,
            deleteProperty: deleteProperty,
            getFilters: getFilters,
            parseDateField: parseDateField,
            mergeFieldsWithCurrentForm: mergeFieldsWithCurrentForm,
            firstBy: (function firstBy() {
                /* mixin for the `thenBy` property */
                function extend(f) {
                    f.thenBy = tb;
                    return f;
                }
                /* adds a secondary compare function to the target function (`this` context)
                 which is applied in case the first one returns 0 (equal)
                 returns a new compare function, which has a `thenBy` method as well */
                function tb(y) {
                    var x = this;
                    return extend(function (a, b) {
                        return x(a, b) || y(a, b);
                    });
                }
                return extend;
            })()
        };
        ////////////////////
        /**
         * generateGuid
         * @returns {string}
         */
        function generateGuid() {
            return 'i_xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8; return v.toString(16); });
        }
        /**
         * @function focusFirstElement
         * @param {string} formName - this is an ugly hack for angular-ui modals
         */
        function focusFirstElement(formName) {
            setTimeout(function () {
                document[formName][0].focus();
            }, 1);
        }
        /**
         * @function preventSpace
         * @param {object} $event - an angular ui event
         */
        function preventSpace($event) {
            // spacebar = 32
            if ($event.keyCode === 32 || $event.which === 32) {
                $event.preventDefault();
            }
        }

        /**
         * @function labelToUniqueId
         * @param {string} label - user input
         * @param {Array} existingIds - an array of Ids not to be used
         * @return {string} unique id to be used in a user defined schema/form
         */
        function labelToUniqueId(label, existingIds) {
            var lbl = label || '';
            var id = lbl.replace(/^([^A-Za-z])+/g, ''); //Remove preceding characters that are not letters
            id = id.replace(/[^A-Z0-9a-z]/g, '').substring(0, 30);  //Remove anything that is not a letter or number
            var copyNumber, newNumber;
            if (existingIds.indexOf(id) > -1) {
                copyNumber = existingIds[existingIds.indexOf(id)].substr(existingIds[existingIds.indexOf(id)].length - 1);
                if (isNaN(copyNumber)) {
                    id = id + '1';
                }
                else {
                    newNumber = parseInt(copyNumber) + 1;
                    id = id + newNumber;
                }
            }
            return id;
        }

        /**
         * @function cssToArray
         * @param {string} css - css string "top right bottom left"
         * @return {Array} array of integers
         */
        function cssToArray(css) {
            if (css) {
                var arr = _.map(css.split('px'), function (val) {
                    return parseInt(val);
                });
                return arr.slice(0, 4);
            }
        }

        /**
         * @function cssToArray
         * @param {Array} arr - array of integers
         * @return {string} css string "top right bottom left"
         */
        function arrayToCss(arr) {
            if (arr) {
                var string = '';
                for (var i = 0; i < 4; i++) {
                    string += arr[i] + 'px ';
                }
                return string.trim();
            }
        }

        /**
         * Lame but necessary Hack
         * @function decodeHtml
         * @param {string} html - html from rich text editor
         * @return {string} clean html
         */
        function decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        }

        function textEditorOptions(scope) {
            return {
                encoded: false,
                tools: [
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "justifyLeft",
                    "justifyCenter",
                    "justifyRight",
                    "justifyFull",
                    "insertUnorderedList",
                    "insertOrderedList",
                    "indent",
                    "outdent",
                    "createLink",
                    "unlink",
                    "insertImage",
                    "subscript",
                    "superscript",
                    "createTable",
                    "addRowAbove",
                    "addRowBelow",
                    "addColumnLeft",
                    "addColumnRight",
                    "deleteRow",
                    "deleteColumn",
                    //"viewHtml",
                    {
                        name: 'nimViewHtml',
                        template: '<a href="" role="button" class="k-tool k-group-start k-group-end" unselectable="on" title="View HTML"><i class="fa fa-code"></i></a>',
                        exec: function (e) {
                            e.preventDefault();
                            var editor = $(e.currentTarget).closest('.k-editor');
                            var textarea = editor.find('textarea');
                            var id = textarea.attr('id');
                            var model = textarea.attr('k-ng-model') || textarea.attr('ng-model');
                            var newId = 'nim_' + id + '_html';
                            var htmlInput = $('#' + newId);
                            if (id && scope) {
                                if (htmlInput.length === 0) {
                                    var html = '<textarea id="' + newId + '" class="form-control" rows="10" ng-model="' + model + '" ng-model-options="{debounce: {default: 500}}"></textarea>';
                                    editor.after($compile(html)(scope));
                                }
                                else {
                                    htmlInput.remove();
                                }
                            }
                        }
                    },
                    "formatting",
                    "cleanFormatting",
                    "fontName",
                    "fontSize",
                    "foreColor",
                    "backColor"
                ],
                paste: function (e) {
                    e.html = $sanitize(e.html);
                }
            };
        }

        /**
         * @function getIcons
         * @return {Array} fontawesome icons
         */
        function getIcons() {
            return $http.get('/assets/fontawesomeicons.json', { cache: true }).then(function (value) {
                return value.data.icons;
            });
        }

        /**
         * @function formGrid
         */
        function formGrid(data) {
            return {
                dataSource: {
                    data: data,
                    schema: {
                        model: {
                            fields: {
                                formName: { type: "string" }
                            }
                        }
                    },
                    pageSize: 15
                },
                detailTemplate: kendo.template('<div kendo-grid k-options="detailGridOptions(dataItem)"></div>'),
                dataBound: function () {
                    this.expandRow(this.tbody.find("tr.k-master-row").first());
                },
                columns: [{
                    field: "formName",
                    title: "Form Name"
                }]
            };
        }
        /**
         * @function formDetailGrid
         */
        function formDetailGrid(scope) {
            return function (dataItem) {
                var data = angular.copy(dataItem.objects);
                _.remove(data, function (d) {
                    return !d.modelId;
                });

                return {
                    dataSource: {
                        data: dataItem.objects,
                        schema: {
                            model: {
                                fields: {
                                    label: { type: "string" },
                                    modelId: { type: "string" },
                                    usage: { type: "string" }
                                }
                            }
                        },
                        pageSize: 20
                    },
                    selectable: "row",
                    change: function () {
                        var selectedRows = this.select();
                        var dataItemUsage = this.dataItem(selectedRows).usage;
                        $timeout(function () {
                            if (scope.temp.model.calculation.formula) {
                                scope.temp.model.calculation.formula = scope.temp.model.calculation.formula + ' ' + dataItemUsage;
                            }
                            else {
                                scope.temp.model.calculation.formula = dataItemUsage;
                            }
                        }, 0);
                    },
                    scrollable: false,
                    sortable: true,
                    pageable: true,
                    columns: [
                        { field: "label", title: "Field Name", width: "110px" },
                        { field: "modelId", title: "Unique Field Name", width: "110px" },
                        { field: "usage", title: "Usage", width: "110px" }
                    ]
                };
            };
        }

        /**
         * @function codemirrorLoaded
         */
        function codemirrorLoaded(operands) {
            return function (_editor) {
                var timeout;
                // Editor part
                var _doc = _editor.getDoc();
                //_editor.focus();

                // Options
                _editor.setOption('theme', 'nimcalc');
                _editor.setOption('lineWrapping', true);
                _editor.setOption('matchBrackets', true);
                _editor.setOption('autoCloseBrackets', '()[]""');
                _editor.setOption('mode', 'nimcalc');
                _doc.markClean();

                // Events
                _editor.on("inputRead", function (cm) {
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    timeout = setTimeout(function () {
                        CodeMirror.showHint(cm, CodeMirror.hint.nimcalc, {
                            completeSingle: false,
                            namedVars: operands
                        });
                    }, 150);
                });
            };
        }

        /**
         * cancelRouteNav
         * @param scope
         * @param hasChanges
         */
        function cancelRouteNav(scope, hasChanges) {
            var onRouteChangeOff = scope.$on('$locationChangeStart', routeChange);
            function routeChange(event, newUrl) {
                //Navigate to newUrl if the form isn't dirty
                if (!hasChanges()) {
                    return;
                }

                var modalOptions = {
                    closeButtonText: 'Cancel',
                    actionButtonText: 'Ignore Changes',
                    headerText: 'Unsaved Changes',
                    bodyText: 'You have unsaved changes. Leave the page?',
                    check: function () {
                        return true;
                    },
                    confirm: function () {
                        onRouteChangeOff(); //Stop listening for location changes
                        var newPath = newUrl.split('/#/');
                        $location.url(newPath[1]); //Go to page they're interested in
                    }
                };

                ConfirmModalService.showModal({}, modalOptions);

                //prevent navigation by default since we'll handle it
                //once the user selects a dialog option
                event.preventDefault();
            }
        }

        function filterOperators() {
            return {
                string: [
                    { value: 'contains', display: 'Contains' },
                    { value: 'doesnotcontain', display: 'Does not contain' },
                    { value: 'eq', display: 'Equal to' },
                    { value: 'neq', display: 'Not equal to' },
                    { value: 'startswith', display: 'Starts with' },
                    { value: 'endswith', display: 'Ends with' }
                ],
                number: [
                    { value: 'eq', display: 'Equal to' },
                    { value: 'gt', display: 'Greater' },
                    { value: 'gte', display: 'Greater or equal to' },
                    { value: 'lt', display: 'Less' },
                    { value: 'lte', display: 'Less or equal to' },
                    { value: 'neq', display: 'Not equal to' }
                ],
                date: [
                    { value: 'eq', display: 'Equal to' },
                    { value: 'gt', display: 'Greater' },
                    { value: 'gte', display: 'Greater or equal to' },
                    { value: 'lt', display: 'Less' },
                    { value: 'lte', display: 'Less or equal to' },
                    { value: 'neq', display: 'Not equal to' }
                ],
                bigint: [
                    { value: 'eq', display: 'Equal to' },
                    { value: 'gt', display: 'Greater' },
                    { value: 'gte', display: 'Greater or equal to' },
                    { value: 'lt', display: 'Less' },
                    { value: 'lte', display: 'Less or equal to' },
                    { value: 'neq', display: 'Not equal to' }
                ]
            };
        }

        function conditionFilter(formOriginId, modelId) {
            return function (formObj) {
                return (formObj.modelId == '__nimRecordAction' ||
                    formObj.isCustomLookup ||
                    formObj.isLookUp ||
                    formObj.type === 'checkbox' ||
                    formObj.dataType === 'string' ||
                    formObj.dataType === 'number') &&
                    formObj.modelId !== modelId;
            };
        }

        function conditionOperators() {
            return {
                string: [
                    { value: 'str_contains', display: 'Contains' },
                    { value: 'str_doesnotcontain', display: 'Does not contain' },
                    { value: 'str_eq', display: 'Equal to' },
                    { value: 'str_neq', display: 'Not equal to' },
                    { value: 'str_startswith', display: 'Starts with' },
                    { value: 'str_endswith', display: 'Ends with' }
                ],
                number: [
                    { value: 'num_eq', display: 'Equal to' },
                    { value: 'num_gt', display: 'Greater than' },
                    { value: 'num_gte', display: 'Greater than or equal to' },
                    { value: 'num_lt', display: 'Less than' },
                    { value: 'num_lte', display: 'Less than or equal to' },
                    { value: 'num_neq', display: 'Not equal to' }
                ],
                lookup: [
                    { value: 'eq', display: 'Equal to' },
                    { value: 'neq', display: 'Not equal to' }
                ],
                action: [
                    { value: 'str_eq', display: 'Equal to' },
                    { value: 'str_neq', display: 'Not equal to' }
                ],
                boolean: [
                    { value: 'eq', display: 'Equal to' }
                ],
                '': []
            };
        }

        function conditionBooleanValues() {
            return [
                { value: true, display: 'True' },
                { value: false, display: 'False' }
            ];
        }

        function conditionActionValues() {
            return [
                { value: 'create', display: 'Create' },
                { value: 'read', display: 'Read' }
            ];
        }

        function getConditionType(formObjArray, condition, oldType) {
            var formObj = _.find(formObjArray, 'modelId', condition.modelId),
                type = '';

            if (formObj) {
                if (formObj.isLookUp || formObj.isCustomLookup) {
                    type = 'lookup';
                }
                else if (formObj.dataType === 'string') {
                    type = 'string';
                }
                else if (formObj.dataType === 'number') {
                    type = 'number';
                }
                else if (formObj.type === 'checkbox') {
                    type = 'boolean';
                }
                else if (formObj.modelId === '__nimRecordAction') {
                    type = 'action';
                }
            }

            if (type !== oldType) {
                condition.op = '';

                if (type === 'boolean') {
                    condition.op = 'eq';
                    condition.val = true;
                }

                if (oldType === 'boolean') {
                    condition.val = null;
                }
            }

            return type;
        }

        function addCondition(formObj, formOriginId) {
            _.defaults(formObj.model.param, { condition: [] });
            return function (condition) {
                var newCondition = angular.copy(condition);
                newCondition.formOriginId = formOriginId;
                formObj.model.param.condition.push(newCondition);
                _.assign(condition, { modelId: null, op: null, val: null, isFormObj: false });
            };
        }

        function lookUpDefaultValueOptions(option, sort) {
            return {
                autoBind: true,
                filter: 'contains',
                optionLabel: {
                    id: -1,
                    display: 'Choose...'
                },
                dataTextField: 'display',
                dataValueField: 'id',
                dataSource: new kendo.data.DataSource({
                    type: 'odata',
                    serverFiltering: true,
                    serverPaging: true,
                    serverSorting: true,
                    pageSize: 20,
                    sort: sort || {
                        field: option.orderCol || 'display',
                        dir: option.orderBy || 'asc'
                    },
                    transport: {
                        read: function (readOptions) {
                            if (option.column && option.id) {
                                var filterValue = _.get(readOptions, 'data.filter.filters[0].value');

                                if (_.isNumber(filterValue)) {
                                    filterValue += 'f';
                                }

                                var lookupDisplay = option.column;

                                if (option.columnType === 'location') {
                                    lookupDisplay += '_formatted_address';
                                }

                                var params = {
                                    $lookupDisplay: lookupDisplay,
                                    $top: option.returnNum
                                };

                                if (readOptions.data.sort) {
                                    params.$orderby = _.map(readOptions.data.sort, function (s) {
                                        return s.field + ' ' + (s.dir || 'asc');
                                    }).join(',');
                                }

                                if (filterValue) {
                                    params.$filter = 'substringof(\'' + filterValue + '\',' + option.column + ')';
                                }

                                $http.get('/server/rest/v1/views/' + option.id + '/odata.svc', {
                                    params: params
                                }).then(function (result) {
                                    readOptions.success(result.data);
                                });
                            }
                            else {
                                readOptions.success({ d: { __count: 0, results: [] } });
                            }

                        }
                    }
                })
            };
        }

        /**
         * Deletes a property from an object; useful when removing a configuration
         * @param {object} obj
         * @param {string} prop
         */
        function deleteProperty(obj, prop) {
            if (_.has(obj, prop)) {
                delete obj[prop];
            }
        }

        /**
         * Finds all available filters in page object array
         * @param pageObjects - Array of page objects
         * @param ignoreObj - Object to exclude (if looking for filters for that object)
         * @returns {Array}
         */
        function getFilters(pageObjects, ignoreObj) {
            var filters = [];

            _.forEach(pageObjects, function (pageObj) {
                if (!angular.equals(ignoreObj, pageObj)) {
                    if (pageObj.type === 'button') {
                        _.forEach(pageObj.params.buttons, function (button) {
                            if (button.type === 'filter') {
                                filters.push(button);
                            }
                        });
                    }
                    else if (pageObj.type === 'viz') {
                        var vizType = pageObj.viz.type;
                        if (vizType === 'table' || vizType === 'kanban') {
                            var params = pageObj.params;
                            if (params.asFilter && params.filterId) {
                                filters.push({
                                    id: params.filterId,
                                    label: params.filterName
                                });
                            }
                        }
                        else if (vizType === 'map') {
                            var mapFilters = pageObj.params.filters;
                            if (mapFilters) {
                                _.forEach(mapFilters, function (filter) {
                                    if (filter.asFilter) {
                                        filters.push(filter);
                                    }
                                });
                            }
                        }
                    }
                }
            });
            
            return filters;
        }

        /**
         * Parses date string back to a Date object
         * @param value - date string serialized by Coldfusion
         * @returns {Date, string} - corrected Date or empty string if no value
         */
        function parseDateField(value) {
            if (value && !_.isDate(value)) {
                try {
                    var dateValue = moment.utc(value, 'MMMM, DD YYYY HH:mm:ss');
                    dateValue.local();

                    return dateValue.toDate();
                }
                catch (e) { }
            }
            else if (_.isDate(value)) {
                return value;
            }

            return '';
        }

        /**
         * Merges form objects from current form with loaded widget fields object.
         * @param widgetFormFields
         * @param currentFormObjects
         */
        function mergeFieldsWithCurrentForm(widgetFormFields, currentFormObjects) {
            var form = _.find(widgetFormFields.display, 'originId', currentFormObjects.display.originId);

            if (form) {
                var length = widgetFormFields.operands.length,
                    startIndex = 0;

                if (length > 0 && form.objects.length > 0) {
                    startIndex = widgetFormFields.operands.indexOf(form.objects[0].usage);
                }

                _.forEach(currentFormObjects.operands, function (op, index) {
                    var trueIndex = startIndex + index;
                    if (index < length) {
                        widgetFormFields.operands[trueIndex] = op;
                    }
                    else {
                        widgetFormFields.operands.splice(trueIndex, 0, op);
                    }
                });

                form.objects = currentFormObjects.display.objects;
            }
            else {
                widgetFormFields.operands = widgetFormFields.operands.concat(currentFormObjects.operands);
                widgetFormFields.display.push(currentFormObjects.display);
            }
        }
    }])
;
angular.module('cerberus.util')
    .factory('BugLogService', ["$window", "bugLogConfig", function BugLogService($window, bugLogConfig) {
        var service = {
            logBug: logBug
        };
        return service;
        /////////////////////

        /**
         * Communicates with a BugLogHq Server
         * @param {string} cause
         * @param {object} error
         * @param {string} [severityCode]
         */
        function logBug(cause, error, severityCode) {
            var data = {};
            data.message = error.toString() || 'Unknown';
            data.exceptionMessage = 'Caused by: ' + cause;
            data.exceptionDetails =  buildStacktrace(error) || 'something went wrong';
            data.severityCode = severityCode || bugLogConfig.defaultSeverity || 'ERROR';
            data.HTMLReport = buildHtmlReport() || 'something went wrong';
            data.userAgent = navigator.userAgent || 'Unknown';
            data.templatePath = document.URL || 'Unknown';
            data.applicationCode = bugLogConfig.applicationCode || 'Unknown';
            data.APIKey = bugLogConfig.apiKey || '';
			// Try to create hostname if it was not declared previously.
			data.hostName = bugLogConfig.hostName || window.location.host;
            // data.hostName = bugLogConfig.hostName || '';
            // Make server call; we could use the $http via the $injector service (to avoid circular dependencies)
            // but customer header could be set that upset CORS requests to the bugLog server
            // so a plain old javascript XHR request is used.
            var xhr = new XMLHttpRequest();
            xhr.open('POST', encodeURI(bugLogConfig.listener));
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(angular.toJson(data));
        }

        /**
         * Build Stacktrace
         * @param {Error} error
         * @return {string}
         */
        function buildStacktrace(error) {
            var stack = 'Error building stacktrace string';
            try {
                stack = $window.ErrorStackParser.parse(error).join('\n');
            } catch (e) {
                // We tried our best folks
            }
            return stack;
        }

        /**
         * Build HTML Report
         * The $rootScope is included because it holds our user session object
         * If your app uses a service instead the $injector service can be used to retrieve it
         * @returns {string}
         */
        function buildHtmlReport() {
            var html = '<h3>Bug Report</h3>';
            var rootScope = getRootScope() || 'something went wrong';
            var scripts = getScripts() || 'something went wrong';
            var stylesheets = getStylesheets() || 'something went wrong';
            html += '<h4>RootScope:</h4><pre>' + angular.toJson(rootScope, 2) + '</pre>';
            html += '<h4>Scripts:</h4><pre>' + angular.toJson(scripts, 2) + '</pre>';
            html += '<h4>Stylesheets:</h4><pre>' + angular.toJson(stylesheets, 2) + '</pre>';
            return html;
        }

        /**
         * Gets an Html Document's stylesheets
         * @returns {Array}
         */
        function getStylesheets() {
            var assets = [];
            var links = document.getElementsByTagName('link');
            for(var i = 0; i < links.length; i++) {
                if (links[i].href && links[i].rel && links[i].rel.toLowerCase() === 'stylesheet') {
                    var href = links[i].href.split('/');
                    assets.push(href[href.length-1]);
                }
            }
            return assets;
        }

        /**
         * Gets an Html Document's scripts
         * @returns {Array}
         */
        function getScripts() {
            var assets = [];
            var scripts = document.getElementsByTagName('script');
            for(var j = 0; j < scripts.length; j++) {
                if (scripts[j].src) {
                    var src = scripts[j].src.split('/');
                    assets.push(src[src.length-1]);
                }
            }
            return assets;
        }

        /**
         * Finds an AngularJs rootScope and returns its properties
         * @returns {{}}
         */
        function getRootScope() {
            var body = angular.element(document.body);
            var rootScope = body.scope().$root || undefined;
            return cleanScope(rootScope);
        }

        /**
         * Returns an object with copied properties from an AngularJs scope
         * @param scope
         * @returns {{}}
         */
        function cleanScope(scope) {
            var obj = {};
            for (var key in scope) {
                if(key.substring(0, 1) !== '$' && key.substring(0,2) !== '__' && key !== 'constructor') {
                    obj[key] = angular.copy(scope[key]);
                }
            }
            return obj;
        }
    }])
;
angular.module('cerberus.util')
// bugLogConfig: Settings for the bug logging service
.constant('bugLogConfig', {
    // This is the location of the BugLog server that will be receiving the error reports
    // example: 'https://domain/buglog/listeners/bugLogListenerREST.cfm',
    listener: "https://erp.crownpaperconverting.com/bugLog/listeners/bugLogListenerREST.cfm",
    // Tell BugLog which application is submitting this bug
    applicationCode: 'CPC-ERP-Client',
    // If the BugLog server requires an API Key to talk to it, then here is where you put it.
    apiKey: "B93BC459-E1D6-4967-45974B7F45FA9CCB",
    // The hostname to tell BugLog from where the report is coming from. Leave empty to get the info from the browser.
    // hostName: '',
    // Default bug serverity code
    defaultSeverity: 'ERROR'
})
    .config(["$provide", "$httpProvider", function ($provide, $httpProvider) {

        $provide.decorator('$exceptionHandler', ["_", "$delegate", "$log", "BugLogService", function (_, $delegate, $log, BugLogService) {
            var errorsBeingLogged = {};
            return function (exception, cause) {
                if (!errorsBeingLogged[exception]) {
                    //Custom error handling.
                    try {
                        BugLogService.logBug(cause, exception);
                        delayErrorLogging(_, errorsBeingLogged, exception);
                    }
                    catch (e) {
                        $log.warn("BugLog Service: Error logging bug", e);
                    }
                }    

                // Calls the original $exceptionHandler.
                $delegate(exception, cause);
            };
        }]);
        $httpProvider.interceptors.push(["_", "$q", "$log", "toaster", "BugLogService", function (_, $q, $log, toaster, BugLogService) {
            var errorsBeingLogged = {};
            return {
                responseError: function (rejection) {
                    // If no URL provided with the rejection object, assume
                    // this is an error with the parsing, not the HTTP call
                    if (_.has(rejection, 'config.url')) {

                        //Ignore Authentication, Authorization, and validation errors
                        if ([400, 401, 403, 409, 422].indexOf(rejection.status) === -1) {
                            // For 404 - Not Found, do not log error, just show toaster
                            if (rejection.status === 404) {
                                toaster.pop('warning', 'Not Found');
                                delayErrorLogging(_, errorsBeingLogged, '404');
                            }
                            else if (rejection.status === -1) {
                                toaster.pop('warning', 'Looks like the Connection failed. Try the action again or refresh the page.');
                                delayErrorLogging(_, errorsBeingLogged, '-1');
                            }
                            else {
                                // Build $http error message
                                var errorMsg = '' +
                                    _.get(rejection, 'config.method', '') + ' ' +
                                    _.get(rejection, 'config.url', '') + ' ' +
                                    _.get(rejection, 'status', '') + '(' +
                                    _.get(rejection, 'text', '') + ')';
                            
                                if (!errorsBeingLogged[errorMsg]) {
                                    // Try to log the bug
                                    try {
                                        BugLogService.logBug('$http', new Error(errorMsg));
                                        // Tell the user that we are working on it
                                        toaster.pop('error', 'Error', 'Support Ticket Opened');
                                        delayErrorLogging(_, errorsBeingLogged, errorMsg);
                                        // Trigger message used for debugging only.
										// alert('TRIGGERED BUG LOG.');
                                    }
                                    catch (e) {
                                        $log.warn("BugLog Service: Error logging bug", e);
                                        // Mommy, mommy hit the reset button -- there is no reset button in life!
                                        toaster.pop('error', 'Error', 'Please contact support');
                                    }
                                }
                            }
                        }
                    }

                    // otherwise, default behaviour
                    return $q.reject(rejection);
                }
            };
        }]);

        function delayErrorLogging(_, errorsBeingLogged, error) {
            errorsBeingLogged[error] = true;
            _.delay(function () {
                errorsBeingLogged[error] = false;
            }, 5000);
        }
    }])
;
angular.module('cerberus.util')
    .factory('checkPrintingService', ["_", "kendo", "$compile", "$http", "$q", "$rootScope", "$location", "$timeout", "$window", "DeviceSniffService", function(_, kendo, $compile, $http, $q, $rootScope, $location, $timeout, $window, DeviceSniffService){
        var service = {
            printChecks: printChecks
        };

        return service;

        /**
         * Prints checks from the specified instances
         * @param instanceIds
         * @param checkOptions - options set by user in the print configuration modal
         * @param checkOptions.targetForm - originator ID of the form of type "check" that will be printed
         * @param checkOptions.pageCounter - model ID of the form field that will contain the check number
         * @param checkOptions.checksPerPage - number of checks that will be printed on each page
         * @param checkOptions.checkNumbers - map of check numbers assigned to each instance
         * @param checkOptions.checkNumExists - map of check numbers restricted to be updated (Record detected and preserved)
         * @param checkOptions.carbonCopy - if true, each page will be printed twice
         * @param [formData] - Loaded form data passed in from an open instance
         * @param [autoFillData] - Loaded autofill data passed in from an open instance
         */
        function printChecks(instanceIds, filename, checkOptions, formData, autoFillData){
            var element,
                deferred = $q.defer(),    
                printSection = angular.element('#print-build-section'),
                checkScope = $rootScope.$new(true),
                paperOptions = kendo.pdf.getPaperOptions(angular.copy(checkOptions)),
                template = '<div nim-check-builder></div>';

            // Set scope variables
            checkScope.instanceIds = instanceIds;
            checkScope.formOriginId = _.last(checkOptions.targetForm.split('-'));
            checkScope.pageCounter = checkOptions.pageCounter;
            checkScope.checksPerPage = checkOptions.checksPerPage;
            checkScope.checkNumbers = checkOptions.checkNumbers;
            checkScope.checkNumExists = checkOptions.checkNumExists;
            checkScope.carbonCopy = checkOptions.carbonCopy;
            checkScope.paperOptions = paperOptions;
            checkScope.formData = {};

            if(!_.isEmpty(formData)) {
                checkScope.formData = formData;
            }

            if(!_.isEmpty(autoFillData)) {
                checkScope.autoFillData = autoFillData;
            }

            // Load CSS
            var cssLink = angular.element($window.document).find('link[rel=stylesheet]');
            var cssPromise = null;
            if (cssLink[0]) {
                cssPromise = $http.get(cssLink[0].href);
            }

            // Called by check-building directive when the checks have been loaded
            checkScope.done = function() {
                checkScope.$destroy();

                var browser = DeviceSniffService.deviceBrowser(),
                    isIE = _.startsWith(browser, 'IE'),
                    printWindow = null;
                
                if (!isIE) {
                    printWindow = $window.open();
                }

                // If Internet Explorer, download pdf
                if (isIE || !printWindow) {
                    exportPDF(element, paperOptions).done(function (dataURI) {
                        printSection.empty();

                        kendo.saveAs({
                            dataURI: dataURI,
                            fileName: filename + '.pdf'
                        });

                        deferred.resolve();
                    });
                }
                else {
                    deferred.resolve();

                    // Else, open in new window
                    printInWindow(element, printWindow, filename, cssPromise);
                    printSection.empty();
                }
            };

            element = $compile(template)(checkScope);

            printSection.empty()
                .append(element);
            
            return deferred.promise;
        }

        /**
         * Exports the rendered element to a PDF
         * @param element {jQuery}
         * @param paperOptions {Object}
         */
        function exportPDF(element, paperOptions) {
            // Check necessary page size and create printing options
            var checks = element.find('.nim-check-form'),
                pageHeight = pixelsToInteger(paperOptions.paperSize[1]),
                pageWidth = pixelsToInteger(paperOptions.paperSize[0]),
                options = {
                    forcePageBreak: '.nim-page-break',
                    paperSize: [pageWidth, pageHeight],
                    margin: {
                        top: paperOptions.margin.top,
                        bottom: paperOptions.margin.bottom
                    }
                };

            // Make sure each check stays this height
            checks.css('height', checks.height());

            return kendo.drawing.drawDOM(element, options).then(function (group) {
                return kendo.drawing.exportPDF(group, options);
            });
        }

        /**
         * Opens new window to print rendered element
         * @param element {jQuery}
         */
        function printInWindow(element, printWindow, filename, cssPromise) {
            var printContent = element.children().clone(),
                base = $location.protocol() + '://' + $location.host(),
                // cssLinks = angular.element($window.document).find('link[rel=stylesheet]').clone(),
                windowHead = angular.element(printWindow.document.head),
                windowBody = angular.element(printWindow.document.body);

            windowHead
                .append('<title>' + filename + '</title><base href="' + base + '" />');
                // .append('<title>' + filename + '</title><base href="' + base + '" />')
                // .append(cssLinks);
            
            windowBody
                .addClass('nim-print-window-body')  
                .css('padding', '0')
                .css('overflow', 'visible');
            
            windowBody.append(printContent);

            if (cssPromise) {
                cssPromise.then(function (result) {
                    var style = angular.element('<style type="text/css">' + result.data + '</style>');
                    style[0].onload = function () {
                        executePrint();
                    };
                    windowHead.append(style);
                });
            }
            else {
                executePrint();
            }
            
            function executePrint() {
                $timeout(function () {
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                }, 1);
            }
        }

        /**
         * Takes string of format "0px", removes "px" and returns the number
         * @param pixelString
         * @returns {*|number}
         */
        function pixelsToInteger(pixelString) {
            var valueString = pixelString.replace('px', '');
            return parseInt(valueString);
        }
    }])
;
angular.module('cerberus.util')
    .controller('nimCheckBuilderCtrl', ["_", "kendo", "moment", "$scope", "$timeout", "$q", "FormsService", "InstancesService", function(_, kendo, moment, $scope, $timeout, $q, FormsService, InstancesService){
        var vm = this;

        // Each page is an array of instanceIds with a length matching the specified checksPerPage
        vm.pages = _.chunk($scope.instanceIds, $scope.checksPerPage);

        vm.checkForms = {};
        vm.dataSet = {};
        vm.filters = {};
        vm.doneLoading = {};
        vm.sectionsShown = {};
        vm.fieldsShown = {};
        vm.autoFillData = {};
        vm.staticGridsterOptions = {
            pushing: true
        };

        vm.sectionFilter = FormsService.sectionFilter;

        init();

        function init() {
            if ($scope.autoFillData) {
                vm.autoFillData = $scope.autoFillData;
            }

            // If carbon copy is desired, double up each page
            if($scope.carbonCopy) {
                var pages = [];
                _.forEach(vm.pages, function(page) {
                    pages.push(page);
                    pages.push(page);
                });
                vm.pages = pages;
            }

            var promises = [],
                promiseIds = [],
                updateArray = [];

            _.forEach($scope.instanceIds, function(id) {
                vm.doneLoading[id] = false;
                vm.dataSet[id] = {};
                vm.filters[id] = {};
                vm.sectionsShown[id] = {};
                vm.fieldsShown[id] = {};

                InstancesService.getInstance(id).then(function (data) {
                    vm.doneLoading[id] = true;
                    vm.autoFillData[id] = vm.autoFillData[id] || {};
                    
                    var stateId = _.findKey(data.instanceWorkflow, $scope.formOriginId);
                    //var workflowState = data.instanceWorkflow[stateId];
                    //var formId = workflowState[$scope.formOriginId];

                    // Check each check if record was previously made, and record 'Check No' only if no record is found
                    if ($scope.checkNumExists && $scope.checkNumExists[id] == false) {
                        var updateData = {};
                        updateData[$scope.pageCounter] = $scope.checkNumbers[id];
                        updateArray.push({
                            id: id,
                            currentStateId: stateId,
                            data: updateData,
                            ignoreSections: []
                        });
                    }
                    if ($scope.formData[id]) {
                        var form = $scope.formData[id];

                        vm.checkForms[id] = form;
                        _.assign(vm.dataSet[id], form.defaultDataSet);
                        vm.filters[id] = {};

                        checkSectionConditions(id, form.form.sections);
                        checkFieldConditions(id, form.form.objects);
                    }
                    else {
                        var workflowState = _.find(data.instanceWorkflow, $scope.formOriginId),
                            formArray = [];

                        _.forEach(workflowState, function(formId, key){
                            if(!_.startsWith(key, '__')) {
                                formArray.push({
                                    formId: formId,
                                    isPk: true,
                                    displayOrder: '1'
                                });
                            }
                        });

                        var formDataPromise = InstancesService.getFormData(id, formArray);

                        promises.push(formDataPromise);
                        promiseIds.push(id);

                        formDataPromise.then(function (result) {
                            vm.checkForms[id] = _.find(result.formData, 'originatorId', parseInt($scope.formOriginId));

                            _.forEach(result.formData, function(form){
                                _.defaults(vm.checkForms[id].defaultDataSet, form.defaultDataSet);
                            });
                            
                            _.assign(vm.dataSet[id], vm.checkForms[id].defaultDataSet);
                            vm.filters[id] = {};

                            _.forEach(result.formData, function (form) {
                                checkSectionConditions(id, form.form.sections);
                                checkFieldConditions(id, form.form.objects);
                            });
                        });
                    }

                    if(_.every(vm.doneLoading)) {
                        // When data has been updated and all forms have loaded,
                        // trigger the print function
                        $q.all(promises).then(function (formDataResults) {
                            var autoFillPromises = [];

                            _.forEach(formDataResults, function (result, index) {
                                var IDx = promiseIds[index];

                                if (_.isEmpty(vm.autoFillData[IDx])) {
                                    autoFillPromises = autoFillPromises.concat(
                                        loadAutoFillData(IDx, result.formData, vm.checkForms[IDx].defaultDataSet)
                                    );
                                }
                            });                            

                            $q.all(autoFillPromises).then(function () {
                                // Update FormObj 'CheckNo' column in the Instance(s) only if needed.
                                var updateArrayPromise = [];
                                if (!_.isEmpty(updateArray)) {
                                    updateArrayPromise.push(InstancesService.batchUpdate(updateArray));
                                }

                                $q.all(updateArrayPromise).then(function () {
                                    $timeout(function() {
                                        $scope.done();
                                    }, 250 + 150 * vm.pages.length /* *$scope.instanceIds.length */); // Page size varies if 1 or 3 check(s) per page.
                                });
                            });
                        });
                    }
                });
            });
        }
        
/* // OLD ORIGINAL CODE - UNABLE TO BATCH PRINT MULTIPLE CHECKS - WORKED ONLY WITH SINGLE CHECKS - 
   // ISSUES WITH autoFillData AND There is a promises.push(recordDataPromise); not used in new style code. Need to check again what is this "recordData"...
   // Transition to new code style 2021-12-18 - By HD -
   
        function init() {

            if ($scope.autoFillData) {
                vm.autoFillData = $scope.autoFillData;
            }

            if($scope.carbonCopy){
                var pages = [];

                // If carbon copy is desired, double up each page
                _.forEach(vm.pages, function(page){
                    pages.push(page);
                    pages.push(page);
                });

                vm.pages = pages;
            }

            var updateArray = [],
                promises = [];

            _.forEach($scope.instanceIds, function(id){
                vm.doneLoading[id] = false;
                vm.dataSet[id] = {};
                vm.filters[id] = {};
                vm.sectionsShown[id] = {};
                vm.fieldsShown[id] = {};

                InstancesService.getInstance(id).then(function(data){
                    vm.doneLoading[id] = true;
                    
                    var stateId = _.findKey(data.instanceWorkflow, $scope.formOriginId),
                        workflowState = data.instanceWorkflow[stateId],
                        formId = workflowState[$scope.formOriginId],
                        updateData = {};

                    updateData[$scope.pageCounter] = $scope.checkNumbers[id];

                    updateArray.push({
                        id: id,
                        currentStateId: stateId,
                        data: updateData,
                        ignoreSections: []
                    });

                    if($scope.formData[id]){
                        var form = $scope.formData[id];

                        vm.checkForms[id] = form;
                        form.defaultDataSet[$scope.pageCounter] = $scope.checkNumbers[id];
                        _.assign(vm.dataSet[id], form.defaultDataSet);
                        vm.filters[id] = {};
                        checkSectionConditions(id, form.form.sections);
                        checkFieldConditions(id, form.form.objects);
                    }
                    else {
                        var displayOrder = data.workflowObjects[stateId].display.order,
                            trimmedFormId = parseInt(_.last(formId.split('-'))),
                            checkForm = _.find(data.workflowObjects[stateId].model.forms, 'formId', trimmedFormId),
                            forms = [];
                        
                        _.forEach(data.workflowObjects, function (wfo) {
                            if (wfo.display.order <= displayOrder) {
                                forms = forms.concat(wfo.model.forms);
                            }
                        });

                        _.remove(forms, 'formId', trimmedFormId);

                        var formDataPromise = InstancesService.getFormData(id, [checkForm]),
                            recordDataPromise = InstancesService.getFormData(id, forms, null, true);
                        
                        promises.push(formDataPromise);
                        promises.push(recordDataPromise);

                        formDataPromise.then(function(result){
                            var form = result.formData[0];

                            vm.checkForms[id] = form;
                            form.defaultDataSet[$scope.pageCounter] = $scope.checkNumbers[id];

                            recordDataPromise.then(function (recordResult) {
                                _.defaults(form.defaultDataSet, recordResult.recordData);
                                _.assign(vm.dataSet[id], form.defaultDataSet);
                                vm.filters[id] = {};
                                checkSectionConditions(id, form.form.sections);
                                checkFieldConditions(id, form.form.objects);
                            });
                        });
                    }

                    if(_.every(vm.doneLoading)){
                        promises.push(
                            InstancesService.batchUpdate(updateArray)
                        );

                        // When data has been updated and all forms have loaded,
                        // trigger the print function
                        $q.all(promises).then(function(){
                            $timeout(function(){
                                $scope.done();
                            }, 400);
                        });
                    }
                });
            });
        }
*/

        function checkSectionConditions(id, sections) {
            _.forEach(sections, function(section) {
                if(!_.isEmpty(section.condition)) {
                    vm.sectionsShown[id][section.name] = FormsService.sectionCondition(section.condition, vm.dataSet[id], section.logic, 'read');
                }
                else {
                    vm.sectionsShown[id][section.name] = true;
                }
            });
        }

        function checkFieldConditions(id, formObjects) {
            _.forEach(formObjects, function (formObj) {
                var modelId = formObj.model.config.modelId,
                    section = formObj.model.display.section,
                    params = formObj.model.param;

                var sectionShown = !section || section == '__nimHiddenSection' || vm.sectionsShown[id][section];
                if (sectionShown && !_.isEmpty(params.condition) && (params.conditionalAction === 'show' || params.conditionalAction === 'hide')) {
                    var result = FormsService.sectionCondition(params.condition, vm.dataSet[id], params.conditionalLogic, 'read');

                    if (params.conditionalAction === 'hide') {
                        vm.fieldsShown[id][modelId] = !result;
                    }
                    else {
                        vm.fieldsShown[id][modelId] = result;
                    }
                }
                else {
                    vm.fieldsShown[id][modelId] = true;
                }
            });
        }

        function loadAutoFillData(id, formData, dataSet) {
            var promises = [];

            _.forEach(formData, function (form) {
                _.forEach(form.form.objects, function (f) {
                    var option = f.model.option,
                        modelId = f.model.config.modelId,
                        fieldValue = dataSet[modelId];

                    if (f.model.config.type == 'datetime' && fieldValue && _.isString(fieldValue)) {
                      //replaced by HD 2019-07-03
                      //dataSet[modelId] = kendo.parseDate(fieldValue, ['yyyy-MM-ddTHH:mm:ss', 'yyyy-MM-ddTHH:mm:ss.fffZ']);
                        dataSet[modelId] = kendo.parseDate(fieldValue, ['yyyy-MM-ddTHH:mm:ssz', 'yyyy-MM-ddTHH:mm:ss.fffz'], 'yyyy-MM-ddTHH:mm:sszzz');
                    }

                    if (!vm.autoFillData[id][modelId] && option.type !== 'custom' && !_.isEmpty(option.autoFill)) {
                        vm.autoFillData[id][modelId] = {};

                        var sectionShown = !f.model.display.section || f.model.display.section == '__nimHiddenSection' || vm.sectionsShown[id][f.model.display.section];

                        if (!_.isEmpty(dataSet[modelId]) && sectionShown && vm.fieldsShown[id][modelId]) {
                            var autoFillPromise = FormsService.getAutoFillValues(dataSet[modelId].id, option);

                            promises.push(autoFillPromise);

                            autoFillPromise.then(function (data) { 
                                if (data.length > 0) {
                                    $timeout(function () {
                                        _.forEach(data, function (targetField, index) {
                                            var autoFillMap = option.autoFill[index],
                                                propertyId = autoFillMap.value,
                                                value = targetField.value;

                                            if (targetField.type === 'timestamp') {
                                                value = moment.utc(value, 'MMMM, DD YYYY HH:mm:ss').toDate();
                                            }

                                            if (typeof value === 'object') {
                                                vm.autoFillData[id][modelId][propertyId] = _.get(value, 'display', '');
                                            }
                                            else {
                                                vm.autoFillData[id][modelId][propertyId] = value;
                                            }
                                        });
                                    });
                                }
                            });
                        }
                    }
                });
            });
            return promises;
        }
    }])
    .directive('nimCheckBuilder', function() {
        return {
            restrict: 'AE',
            templateUrl: 'util/nim-print-check/nim-check-builder.tpl.html',
            controller: 'nimCheckBuilderCtrl',
            controllerAs: 'vm',
            link: function(scope, element) {
                element.css('height', scope.paperOptions.paperSize[1] + 'in')
                    .css('width', scope.paperOptions.paperSize[0] + 'in');

                scope.paperOptions.paperSize[0] = element.css('width');
                scope.paperOptions.paperSize[1] = element.css('height');

                element.css('width', '-=' + scope.paperOptions.margin.left + 'px')
                    .css('width', '-=' + scope.paperOptions.margin.right + 'px')
                    .css('height', '');
                
                scope.checkWidth = element.css('width');

                element.css('paddingLeft', scope.paperOptions.margin.left + 'px')
                    .css('paddingRight', scope.paperOptions.margin.right + 'px');
            }
        };
    })
;
angular.module('cerberus.util')
    .factory('labelPrintingService', ["_", "kendo", "$compile", "$http", "$q", "$rootScope", "$location", "$timeout", "$window", "DeviceSniffService", function(_, kendo, $compile, $http, $q, $rootScope, $location, $timeout, $window, DeviceSniffService){
        var service = {
            printLabels: printLabels
        };

        return service;

        /**
         * Prints labels from the specified instance
         * @param instanceIds
         * @param labelOptions - options set by user in the print configuration modal
         * @param labelOptions.targetForm - originator ID of the form of type "label" that will be printed
         * @param labelOptions.pageTotal - total number of pages that will be printed
         * @param [formData] - Loaded form data passed in from an open instance
         * @param [autoFillData] - Loaded autofill data passed in from an open instance
         */
        function printLabels(instanceIds, filename, labelOptions, formData, autoFillData) {
            var element,
                deferred = $q.defer(),    
                printSection = angular.element('#print-build-section'),
                labelScope = $rootScope.$new(true),
                paperOptions = kendo.pdf.getPaperOptions(angular.copy(labelOptions)),
                template = '<div nim-label-builder></div>';

            // Set scope variables
            labelScope.instanceIds = instanceIds;
            labelScope.paperOptions = paperOptions;
            labelScope.formOriginId = _.last(labelOptions.targetForm.split('-'));
            labelScope.pageTotals = labelOptions.pageTotal;
            labelScope.formData = {};

            if(!_.isEmpty(formData)) {
                labelScope.formData = formData;
            }

            if(!_.isEmpty(autoFillData)) {
                labelScope.autoFillData = autoFillData;
            }

            // Load CSS
            var cssLink = angular.element($window.document).find('link[rel=stylesheet]');
            var cssPromise = null;
            if (cssLink[0]) {
                cssPromise = $http.get(cssLink[0].href);
            }

            // Called by label-building directive when the labels have been loaded
            labelScope.done = function() {
                labelScope.$destroy();

                var browser = DeviceSniffService.deviceBrowser(),
                    isIE = _.startsWith(browser, 'IE'),
                    printWindow = null;
                
                if (!isIE) {
                    printWindow = $window.open();
                }

                // If Internet Explorer or the window is blocked, download pdf
                if (isIE || !printWindow) {
                    exportPDF(element, paperOptions).done(function (dataURI) {
                        printSection.empty();

                        kendo.saveAs({
                            dataURI: dataURI,
                            fileName: filename + '.pdf'
                        });

                        deferred.resolve();
                    });
                }
                else {
                    deferred.resolve();
                    
                    // Else, open in new window
                    printInWindow(element, printWindow, filename, cssPromise);
                    printSection.empty();
                }
            };

            element = $compile(template)(labelScope);

            printSection.empty()
                .append(element);
            
            return deferred.promise;
        }

        /**
         * Exports the rendered element to a PDF
         * @param element {jQuery}
         * @param paperOptions {Object}
         */
        function exportPDF(element, paperOptions) {
            // Check necessary page size and create printing options
            var labels = element.find('.nim-label-form'),
                pageHeight = pixelsToInteger(paperOptions.paperSize[1]),
                pageWidth = pixelsToInteger(paperOptions.paperSize[0]),
                options = {
                    forcePageBreak: '.nim-page-break',
                    paperSize: [pageWidth, pageHeight],
                    margin: {
                        top: paperOptions.margin.top,
                        bottom: paperOptions.margin.bottom
                    }
                };

            // Make sure each label stays this height
            labels.css('height', labels.height());

            return kendo.drawing.drawDOM(element, options).then(function (group) {
                return kendo.drawing.exportPDF(group, options);
            });
        }

        /**
         * Opens new window to print rendered element
         * @param element {jQuery}
         * @param printWindow {Window}
         */
        function printInWindow(element, printWindow, filename, cssPromise) {
            var printContent = element.clone(),
                base = $location.protocol() + '://' + $location.host(),
                // cssLinks = angular.element($window.document).find('link[rel=stylesheet]').clone(),
                windowHead = angular.element(printWindow.document.head),
                windowBody = angular.element(printWindow.document.body);

            windowHead
                .append('<title>' + filename + '</title><base href="' + base + '" />');
                // .append('<title>' + filename + '</title><base href="' + base + '" />')
                // .append(cssLinks);
        
            windowBody
                .addClass('nim-print-window-body')    
                .css('padding', '0')
                .css('overflow', 'visible');
        
            windowBody.append(printContent);

            if (cssPromise) {
                cssPromise.then(function (result) {
                    var style = angular.element('<style type="text/css">' + result.data + '</style>');
                    style[0].onload = function () {
                        executePrint();
                    };
                    windowHead.append(style);
                });
            }
            else {
                executePrint();
            }
            
            function executePrint() {
                $timeout(function () {
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                }, 1);
            }
        }

        /**
         * Takes string of format "0px", removes "px" and returns the number
         * @param pixelString
         * @returns {*|number}
         */
        function pixelsToInteger(pixelString) {
            var valueString = pixelString.replace('px', '');
            return parseInt(valueString);
        }
    }])
;
angular.module('cerberus.util')
    .controller('nimLabelBuilderCtrl', ["_", "kendo", "moment", "$scope", "$timeout", "$q", "FormsService", "InstancesService", function(_, kendo, moment, $scope, $timeout, $q, FormsService, InstancesService){
        var vm = this;

        vm.items = {};
        vm.labelForm = {};
        vm.dataSet = {};
        vm.filters = {};
        vm.doneLoading = {};
        vm.sectionsShown = {};
        vm.fieldsShown = {};
        vm.autoFillData = {};
        vm.staticGridsterOptions = {
            pushing: true
        };

        vm.sectionFilter = FormsService.sectionFilter;

        init();

        function init() {
            if ($scope.autoFillData) {
                vm.autoFillData = $scope.autoFillData;
            }

            var promises = [],
                promiseIds = [];

            // console.time('loaddata');
            _.forEach($scope.instanceIds, function (id) {
                vm.items[id] = [];
                vm.doneLoading[id] = false;
                vm.dataSet[id] = {};
                vm.filters[id] = {};
                vm.sectionsShown[id] = {};
                vm.fieldsShown[id] = {}; 

                for(var i = 0; i < $scope.pageTotals[id]; i++){
                    vm.items[id].push(i + 1);
                }

                InstancesService.getInstance(id).then(function (data) {
                    vm.doneLoading[id] = true;
                    vm.autoFillData[id] = vm.autoFillData[id] || {};
                    
                    if ($scope.formData[id]) {
                        var form = $scope.formData[id];

                        vm.labelForm[id] = form;
                        _.assign(vm.dataSet[id], form.defaultDataSet);
                        vm.filters[id] = {};

                        checkSectionConditions(id, form.form.sections);
                        checkFieldConditions(id, form.form.objects);
                    }
                    else {
                        var workflowState = _.find(data.instanceWorkflow, $scope.formOriginId),
                            formArray = [];

                        _.forEach(workflowState, function(formId, key){
                            if(!_.startsWith(key, '__')) {
                                formArray.push({
                                    formId: formId,
                                    isPk: true,
                                    displayOrder: '1'
                                });
                            }
                        });

                        var formDataPromise = InstancesService.getFormData(id, formArray);

                        promises.push(formDataPromise);
                        promiseIds.push(id);

                        formDataPromise.then(function (result) {
                            vm.labelForm[id] = _.find(result.formData, 'originatorId', parseInt($scope.formOriginId));

                            _.forEach(result.formData, function(form){
                                _.defaults(vm.labelForm[id].defaultDataSet, form.defaultDataSet);
                            });
                            
                            _.assign(vm.dataSet[id], vm.labelForm[id].defaultDataSet);
                            vm.filters[id] = {};

                            _.forEach(result.formData, function (form) {
                                checkSectionConditions(id, form.form.sections);
                                checkFieldConditions(id, form.form.objects);
                            });
                        });
                    }

                    if(_.every(vm.doneLoading)) {
                        // When data has been updated and all forms have loaded,
                        // trigger the print function
                        $q.all(promises).then(function (formDataResults) {
                            var autoFillPromises = [];

                            _.forEach(formDataResults, function (result, index) {
                                var IDx = promiseIds[index];

                                if (_.isEmpty(vm.autoFillData[IDx])) {
                                    autoFillPromises = autoFillPromises.concat(
                                        loadAutoFillData(IDx, result.formData, vm.labelForm[IDx].defaultDataSet)
                                    );
                                }
                            });                            

                            $q.all(autoFillPromises).then(function () {
                                var maxPages = 0;
                                _.forEach($scope.pageTotals, function (total) {
                                    if (total > maxPages) {
                                        maxPages = total;
                                    }
                                });

                                // console.time('timeout');
                                $timeout(function() {
                                    // console.timeEnd('timeout');
                                    // console.timeEnd('loaddata');
                                    $scope.done();
                                // }, 0);
                                }, 250 + 150 * maxPages * $scope.instanceIds.length);
                            });
                        });
                    }
                });
            });
        }

        function checkSectionConditions(id, sections) {
            _.forEach(sections, function(section) {
                if(!_.isEmpty(section.condition)) {
                    vm.sectionsShown[id][section.name] = FormsService.sectionCondition(section.condition, vm.dataSet[id], section.logic, 'read');
                }
                else {
                    vm.sectionsShown[id][section.name] = true;
                }
            });
        }

        function checkFieldConditions(id, formObjects) {
            _.forEach(formObjects, function (formObj) {
                var modelId = formObj.model.config.modelId,
                    section = formObj.model.display.section,
                    params = formObj.model.param;

                var sectionShown = !section || section == '__nimHiddenSection' || vm.sectionsShown[id][section];
                if (sectionShown && !_.isEmpty(params.condition) && (params.conditionalAction === 'show' || params.conditionalAction === 'hide')) {
                    var result = FormsService.sectionCondition(params.condition, vm.dataSet[id], params.conditionalLogic, 'read');

                    if (params.conditionalAction === 'hide') {
                        vm.fieldsShown[id][modelId] = !result;
                    }
                    else {
                        vm.fieldsShown[id][modelId] = result;
                    }
                }
                else {
                    vm.fieldsShown[id][modelId] = true;
                }
            });
        }

        function loadAutoFillData(id, formData, dataSet) {
            var promises = [];

            _.forEach(formData, function (form) {
                _.forEach(form.form.objects, function (f) {
                    var option = f.model.option,
                        modelId = f.model.config.modelId,
                        fieldValue = dataSet[modelId];

                    if (f.model.config.type == 'datetime' && fieldValue && _.isString(fieldValue)) {
                      //replaced by HD 2019-07-03
                      //dataSet[modelId] = kendo.parseDate(fieldValue, ['yyyy-MM-ddTHH:mm:ss', 'yyyy-MM-ddTHH:mm:ss.fffZ']);
                        dataSet[modelId] = kendo.parseDate(fieldValue, ['yyyy-MM-ddTHH:mm:ssz', 'yyyy-MM-ddTHH:mm:ss.fffz'], 'yyyy-MM-ddTHH:mm:sszzz');
                    }
                    
                    if (!vm.autoFillData[id][modelId] && option.type !== 'custom' && !_.isEmpty(option.autoFill)) {
                        vm.autoFillData[id][modelId] = {};

                        var sectionShown = !f.model.display.section || f.model.display.section == '__nimHiddenSection' || vm.sectionsShown[id][f.model.display.section];

                        if (!_.isEmpty(dataSet[modelId]) && sectionShown && vm.fieldsShown[id][modelId]) {
                            var autoFillPromise = FormsService.getAutoFillValues(dataSet[modelId].id, option);

                            promises.push(autoFillPromise);

                            autoFillPromise.then(function (data) { 
                                if (data.length > 0) {
                                    $timeout(function () {
                                        _.forEach(data, function (targetField, index) {
                                            var autoFillMap = option.autoFill[index],
                                                propertyId = autoFillMap.value,
                                                value = targetField.value;

                                            if (targetField.type === 'timestamp') {
                                                value = moment.utc(value, 'MMMM, DD YYYY HH:mm:ss').toDate();
                                            }

                                            if (typeof value === 'object') {
                                                vm.autoFillData[id][modelId][propertyId] = _.get(value, 'display', '');
                                            }
                                            else {
                                                vm.autoFillData[id][modelId][propertyId] = value;
                                            }
                                        });
                                    });
                                }
                            });
                        }
                    }
                });
            });
            
            return promises;
        }
    }])
    .directive('nimLabelBuilder', function() {
        return {
            restrict: 'AE',
            templateUrl: 'util/nim-print-label/nim-label-builder.tpl.html',
            controller: 'nimLabelBuilderCtrl',
            controllerAs: 'vm',
            link: function(scope, element) {
                element.css('height', scope.paperOptions.paperSize[1] + 'in')
                    .css('width', scope.paperOptions.paperSize[0] + 'in');

                scope.paperOptions.paperSize[0] = element.css('width');
                scope.paperOptions.paperSize[1] = element.css('height');

                element.css('width', '-=' + scope.paperOptions.margin.left + 'px')
                    .css('width', '-=' + scope.paperOptions.margin.right + 'px')
                    .css('height', '');
                
                scope.labelWidth = element.css('width');

                element.css('paddingLeft', scope.paperOptions.margin.left + 'px')
                    .css('paddingRight', scope.paperOptions.margin.right + 'px');
            }
        };
    })
;
angular.module('cerberus.util')
    .controller('nimPrintBuilderCtrl', ["_", "$scope", "$timeout", "FormsService", "InstancesService", function(_, $scope, $timeout, FormsService, InstancesService){
        var vm = this;

        vm.states = [];
        vm.dataSet = {};
        vm.filters = {};
        vm.staticGridsterOptions = {
            pushing: true
        };
        vm.instanceForm = {};
        vm.doneLoading = {};
        vm.sectionsShown = {};
        vm.fieldsShown = {};
        vm.dataSeriesRows = 0;
        vm.gridsterItems = [];

        vm.sectionFilter = FormsService.sectionFilter;
        vm.autoFillData = $scope.autoFillData;
        vm.gridsterItemOptions = gridsterItemOptions;

        if(_.isEmpty($scope.instance)) {
            InstancesService.getInstance($scope.instanceId).then(function (data) {
                vm.instanceData = data;
                vm.states = angular.copy(data.workflowPath).reverse();

                _.forEach(vm.states, function (state) {
                    vm.sectionsShown[state] = {};
                    vm.fieldsShown[state] = {};

                    if (data.workflowObjects[state]) {
                        vm.doneLoading[state] = false;

                        var displayForm = data.workflowObjects[state].model.forms[0],
                            formOptions = [displayForm];

                        InstancesService.getFormData($scope.instanceId, formOptions).then(function (result) {
                            var form = result.formData[0];
                            vm.sectionsShown[state][form.originatorId] = {};

                            vm.instanceForm[state] = form;
                            _.assign(vm.dataSet, form.defaultDataSet);
                            vm.filters = {};
                            vm.doneLoading[state] = true;


                            if (_.every(vm.doneLoading)) {
                                checkConditions();
                                finishAfterResize();
                            }
                        });
                    }
                });
            });
        }
        else {
            var data = $scope.instance;

            if(!_.isEmpty($scope.dataSet)){
                vm.dataSet = $scope.dataSet;
            }

            if(!_.isEmpty($scope.autoFillData)){
                vm.autoFillData = $scope.autoFillData;
            }

            vm.instanceData = data;
            vm.states = angular.copy(data.workflowPath).reverse();

            _.forEach(vm.states, function (state) {
                vm.sectionsShown[state] = {};
                vm.fieldsShown[state] = {};

                if (data.workflowObjects[state]) {
                    var form = data.workflowObjects[state].model.forms[0];
                    vm.sectionsShown[state][form.originatorId] = {};
                    vm.instanceForm[state] = form;
                }
            });

            checkConditions();
            finishAfterResize();
        }

        function finishAfterResize() {
            $timeout(function () {
                var removeGridsterWatcher = angular.noop;
                var removeInitWatcher = angular.noop;
                var timeout = 1000 + (1000 * vm.dataSeriesRows);
                var done = _.debounce(function () {
                    removeGridsterWatcher();
                    removeInitWatcher();
                    $timeout($scope.done);
                }, timeout);

                removeGridsterWatcher = $scope.$watch('vm.gridsterItems', function () { 
                    done();
                }, true);
                
                done();
            });
        }

        function checkConditions(){
            _.forEach(vm.instanceForm, function(form, state){
                var formOriginId = form.originatorId;

                // Section Conditions
                _.forEach(form.form.sections, function(section){
                    if (!_.isEmpty(section.condition)) {
                        vm.sectionsShown[state][formOriginId][section.name] = FormsService.sectionCondition(section.condition, vm.dataSet, section.logic, 'read');
                    }
                    else {
                        vm.sectionsShown[state][formOriginId][section.name] = true;
                    }
                });

                _.forEach(form.form.objects, function(formObj){
                    var modelId = formObj.model.config.modelId,
                        section = formObj.model.display.section,
                        params = formObj.model.param;

                    // Form Object Conditions
                    var sectionShown = !section || section == '__nimHiddenSection' || vm.sectionsShown[state][formOriginId][section];
                    if(sectionShown && !_.isEmpty(params.condition) && (params.conditionalAction === 'show' || params.conditionalAction === 'hide')){
                        var result = FormsService.sectionCondition(params.condition, vm.dataSet, params.conditionalLogic, 'read');

                        if(params.conditionalAction === 'hide'){
                            vm.fieldsShown[state][modelId] = !result;
                        }
                        else {
                            vm.fieldsShown[state][modelId] = result;
                        }
                    }
                    else {
                        vm.fieldsShown[state][modelId] = true;
                    }

                    // Rendering Dataseries
                    if (vm.fieldsShown[state][modelId] && sectionShown && formObj.model.config.type == 'table') {
                        var rows = vm.instanceForm[state].defaultDataSet[modelId] || [];
                        vm.dataSeriesRows += rows.length;
                    }
                });
            });
        }

        function gridsterItemOptions(formObjectModel) {
            var options = _.pick(formObjectModel, ['sizeX', 'sizeY', 'row', 'col']);

            vm.gridsterItems.push(options);

            return options;
        }
    }])
    .directive('nimPrintBuilder', function(){
        return {
            restrict: 'AE',
            templateUrl: 'util/nim-print-normal/nim-print-builder.tpl.html',
            controller: 'nimPrintBuilderCtrl',
            controllerAs: 'vm',
            link: function(scope, element){
                element.css('height', scope.paperOptions.paperSize[1])
                    .css('width', scope.paperOptions.paperSize[0]);

                scope.paperOptions.paperSize[0] = element.css('width');
                scope.paperOptions.paperSize[1] = element.css('height');

                element.css('width', '-=' + scope.paperOptions.margin.left + 'px')
                    .css('width', '-=' + scope.paperOptions.margin.right + 'px')
                    .css('height', '');
            }
        };
    })
;
angular.module('cerberus.util')
    .factory('normalPrintingService', ["_", "kendo", "$compile", "$http", "$q", "$rootScope", "$location", "$timeout", "$window", "DeviceSniffService", "ExportFileWriteService", function(_, kendo, $compile, $http, $q, $rootScope, $location, $timeout, $window, DeviceSniffService, ExportFileWriteService){
        var service = {
            printElement: printElement,
            printInstance: printInstance
        };

        return service;

        // function printElement(elem, filename, normalOptions) {
        //     var printSection = angular.element('#print-build-section'),
        //         paperOptions = kendo.pdf.getPaperOptions(normalOptions),
        //         deferred = $q.defer();
            
        //     printSection.empty()
        //         .append(elem[0].outerHTML);
            
        //     var element = printSection.children();
            
        //     // Convert paperSize from px (at 72ppi) to in.
        //     paperOptions.paperSize = _.map(paperOptions.paperSize, function(px){
        //         var inches = px / 72;
        //         return inches + 'in';
        //     });

        //     element.css('height', paperOptions.paperSize[1])
        //         .css('width', paperOptions.paperSize[0]);

        //     var options = {
        //             paperSize: [
        //                 pixelsToInteger(element.css('width')),
        //                 pixelsToInteger(element.css('height'))
        //             ],
        //             margin: normalOptions.margin,
        //             multiPage: true
        //         };

        //     kendo.drawing.drawDOM(element, options).then(function (group) {
        //         return kendo.drawing.exportPDF(group, options);
        //     }).done(function (dataURI) {
        //         printSection.empty();

        //         var browser = DeviceSniffService.deviceBrowser();
        //         if (_.startsWith(browser, 'IE')) {
        //             kendo.saveAs({
        //                 dataURI: dataURI,
        //                 fileName: filename + '.pdf'
        //             });
        //         }
        //         else {
        //             $window.open(dataURI);
        //         }

        //         deferred.resolve();
        //     });

        //     return deferred.promise;
        // }

        /**
         * Prints the given element
         * @param elem - Element identifier
         * @param defaultFileName - Filename of PDF when it's ready to be generated
         * @param normalOptions - Options set by user in the print configuration modal
         */
        function printElement(elem, defaultFileName, normalOptions) {
            var printSection = angular.element('#print-build-section'),
                paperOptions = kendo.pdf.getPaperOptions(normalOptions),
                element = elem.clone(),
                browser = DeviceSniffService.deviceBrowser(),
                isIE = _.startsWith(browser, 'IE'),
                printWindow = null,
                deferred = $q.defer(),
                filename = 'Download';

            if(defaultFileName){
                filename = defaultFileName;
            }

            element.append('<div class="row text-center"><div class="col-xs-12"><div class="padding-sm">Powered by <a href="https://crownpaperconverting.com">crownpaperconverting.com</a></div></div></div>');
            
            printSection.empty()
                .append(element);
            
            element.css('width', '816px');
            
            if (!isIE) {
                printWindow = $window.open();
            }
            
            // If Internet Explorer, download pdf
            if (isIE || !printWindow) {
                exportPDF(element, paperOptions).done(function (dataURI) {
                    printSection.empty();

                    kendo.saveAs({
                        dataURI: dataURI,
                        fileName: filename + '.pdf'
                    });

                    deferred.resolve();
                });
            }
            else {
                deferred.resolve();

                // Load CSS
                var cssLink = angular.element($window.document).find('link[rel=stylesheet]');
                var cssPromise = null;
                if (cssLink[0]) {
                    cssPromise = $http.get(cssLink[0].href);
                }

                // Else, open in new window
                printInWindow(element, printWindow, filename, cssPromise);
                printSection.empty();
            }

            return deferred.promise;
        }

        /**
         * Prints the given instance
         * @param instanceId
         * @param defaultFileName - Filename of PDF when it's ready to be generated
         * @param normalOptions - Options set by user in the print configuration modal
         * @param [instance]
         * @param [dataSet]
         * @param [autoFillData] - Loaded autofill data passed in from an open instance
         * @param [processPdf] - (Optional) : Available commands used for PDF Processing invoked after generating is complete: 
         *            (1) 'save'  - Force PDF file to be directly downloaded without any extra print window preview
         *            (2) 'write' - Force PDF file to be internally stored locally on server
         *            (3) 'false' - Default, None or Null - Go to printing process
         */
        function printInstance(instanceId, defaultFileName, normalOptions, instance, dataSet, autoFillData, processPdf){
            var element,
                deferred = $q.defer(),    
                printSection = angular.element('#print-build-section'),
                paperOptions = kendo.pdf.getPaperOptions(normalOptions),
                instanceScope = $rootScope.$new(true),
                template = '<div nim-print-builder></div>',
                filename = 'Download';

            if(defaultFileName){
                filename = defaultFileName;
            }
            // Convert paperSize from px (at 72ppi) to in.
            paperOptions.paperSize = _.map(paperOptions.paperSize, function(px){
                var inches = px / 72;
                return inches + 'in';
            });

            processPdf = processPdf || false;
            instanceScope.instanceId = instanceId;
            instanceScope.paperOptions = paperOptions;
            instanceScope.instance = {};
            instanceScope.dataSet = {};
            instanceScope.autoFillData = {};

            if(!_.isEmpty(instance)){
                instanceScope.instance = instance;
            }
            if(!_.isEmpty(dataSet)){
                instanceScope.dataSet = dataSet;
            }
            if(!_.isEmpty(autoFillData)){
                instanceScope.autoFillData = autoFillData;
            }

            // Load CSS
            var cssLink = angular.element($window.document).find('link[rel=stylesheet]');
            var cssPromise = null;
            if (cssLink[0]) {
                cssPromise = $http.get(cssLink[0].href);
            }

            instanceScope.done = function(){
                instanceScope.$destroy();

                var browser = DeviceSniffService.deviceBrowser(),
                    isIE = _.startsWith(browser, 'IE'),
                    printWindow = null;
                
                if (!isIE && !processPdf) {
                    printWindow = $window.open();
                }

                // If Internet Explorer or if PDF is forced, download pdf
                if (isIE || !printWindow || processPdf) {
                    exportPDF(element, paperOptions).done(function (dataURI) {
                        printSection.empty();
                        if (processPdf === 'write') {
                            filename = null; //Let system to generate a unique name if empty
                            if(defaultFileName){
                                filename = defaultFileName + '.pdf';
                            }
                            ExportFileWriteService.writeFile(dataURI, {filename: filename}).then(function (result) {
                                deferred.resolve(result);
                            });
                        }
                        else {
                            kendo.saveAs({
                                dataURI: dataURI,
                                fileName: filename + '.pdf'
                            });
                            deferred.resolve();
                        }
                    });
                }
                else {
                    deferred.resolve();

                    // Else, open in new window
                    printInWindow(element, printWindow, filename, cssPromise);
                    printSection.empty();
                }

            };

            element = $compile(template)(instanceScope);

            printSection.empty()
                .append(element);

            return deferred.promise;
        }

        /**
         * Exports the rendered element to a PDF
         * @param element {jQuery}
         * @param paperOptions {Object}
         */
        function exportPDF(element, paperOptions) {
            var elemWidth = element.css('width'),
                elemHeight = element.css('height'),
                options = {
                    paperSize: [
                        pixelsToInteger(elemWidth),
                        pixelsToInteger(elemHeight)
                    ],
                    margin: paperOptions.margin,
                    multiPage: true
                };

            element.css('height', elemHeight)
                .css('width', elemWidth);

            return kendo.drawing.drawDOM(element, options).then(function (group) {
                return kendo.drawing.exportPDF(group, options);
            });
        }

        /**
         * Opens new window to print rendered element
         * @param element {jQuery}
         */
        function printInWindow(element, printWindow, filename, cssPromise) {
            var printContent = element.clone(),
                base = $location.protocol() + '://' + $location.host(),
                windowHead = angular.element(printWindow.document.head),
                windowBody = angular.element(printWindow.document.body);
            
            windowHead
                .append('<title>' + filename + '</title><base href="' + base + '" />');
            
            windowBody
                .addClass('nim-print-window-body')
                .css('padding', '0');
            
            // Print these elements in color:
            var printInColor = [
                '.k-event',
                '.k-event div',
                '.k-scheduler .k-header .k-state-selected',
                '.k-scheduler .k-header .k-state-selected .k-link',
                '.k-grid .k-state-selected',
                '.k-grid .k-state-selected *',
                '.k-gantt .k-task-wrap *',
                '.k-gantt .k-gantt-views *',
                '.leaflet-map-pane *',
                '.kanban .column-title',
                '.kanban .column-title *'
            ];

            printContent
                .find(printInColor.join(', '))
                .addClass('print-in-color');
            
            windowBody.append(printContent);

            if (cssPromise) {
                cssPromise.then(function (result) {
                    var style = angular.element('<style type="text/css">' + result.data + '</style>');
                    style[0].onload = function () {
                        executePrint();
                    };
                    windowHead.append(style);
                });
            }
            else {
                executePrint();
            }
            
            function executePrint() {
                $timeout(function () {
                    printWindow.document.close();
                    printWindow.focus();
                    printWindow.print();
                }, 100);
            }
        }

        /**
         * Takes string of format "0px", removes "px" and returns the number
         * @param pixelString
         * @returns {*|number}
         */
        function pixelsToInteger(pixelString){
            var valueString = pixelString.replace('px', '');
            return parseInt(valueString);
        }
    }])
;
angular.module('cerberus.util')
    .directive('nimStopBackspace', function(){
        return {
            restrict: 'AE',
            link: function (scope, element) {
                // Prevents backspace from triggering navigation
                // while the user is focused on an input field.
                angular.element(element)
                    .keydown(function(e){
                        if (e.keyCode == 8) {
                            var target = $(e.target);
                            var isInput = target.is('input,textarea,select');
                            if(!isInput || e.target.disabled || e.target.readOnly){
                                e.preventDefault();
                            }
                        }
                    })
                ;
            }
        };
    })
;
angular.module('cerberus.util')
    .directive('nimStopEnter', function(){
        return {
            restrict: 'AE',
            link: function(scope, element){
                // Prevents enter key from triggering form submission on certain fields
                element
                    .keydown(preventEnter)
                    .keypress(preventEnter)
                ;
            }
        };

        function preventEnter(e){
            if(e.key === 'Enter'){
                e.preventDefault();
            }
        }
    })
;
angular.module('cerberus.util')
    .factory('nimUtilityService', ["_", "kendo", "moment", "writtenNumber", function(_, kendo, moment, writtenNumber){
        return {
            toWrittenNumber: writtenNumber,
            format: kendo.format,
            toString: kendo.toString,
            parseInt: kendo.parseInt,
            parseFloat: kendo.parseFloat,
            parseDate: kendo.parseDate,
            toCamelCase: kendo.toCamelCase,
            toHyphens: kendo.toHyphens,
            lodash: _,
            moment: moment,
            toUpperCase: toUpperCase,
            toLowerCase: toLowerCase,
            toSentenceCase: toSentenceCase,
            truncateWords: truncateWords,
            truncateCharacters: truncateCharacters,
            toInitials: toInitials,
            toTitleCase: toTitleCase,
            dateFormat: dateFormat
        };

        function toUpperCase(str){
            str = str || '';
            return str.toUpperCase();
        }

        function toLowerCase(str){
            str = str || '';
            return str.toLowerCase();
        }

        function toSentenceCase(str){
            var sentence = '';
            if(str && str.length > 0){
                sentence += str.charAt(0).toUpperCase();
                if(str.length > 1){
                    sentence += str.substr(1, str.length - 1).toLowerCase();
                }
            }
            return sentence;
        }

        function truncateWords(input, words) {
            if (isNaN(words))  {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }

        function truncateCharacters(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    //get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                }else{
                    while(input.charAt(input.length-1) === ' '){
                        input = input.substr(0, input.length -1);
                    }
                }
                return input + '...';
            }
            return input;
        }

        function toInitials(str) {
            str = str || '';
            var initials = '';
            var arr = str.split(' ');
            for (var i = 0; i < arr.length; i++) {
                initials += arr[i].substring(0,1).toUpperCase() + '.';
            }
            return initials;
        }

        function toTitleCase(string) {
            string = string || '';
            return string.replace(/([\w&`'â€˜â€™"â€œ.@:\/\{\(\[<>_]+-? *)/g,
                function(match, p1, index, title){
                    if (index > 0 && title.charAt(index - 2) != ":" &&
                        match.search(/^(a(nd?|s|t)?|b(ut|y)|en|for|i[fn]|o[fnr]|t(he|o)|vs?\.?|via)[ -]/i) > -1) {
                        return match.toLowerCase();
                    }
                    if (title.substring(index - 1, index + 1).search(/['"_{([]/) > -1) {
                        return match.charAt(0) + match.charAt(1).toUpperCase() + match.substr(2);
                    }
                    if (match.substr(1).search(/[A-Z]+|&|[\w]+[._][\w]+/) > -1 ||
                        title.substring(index - 1, index + 1).search(/[\])}]/) > -1) {
                        return match;
                    }
                    return match.charAt(0).toUpperCase() + match.substr(1);
                });
        }

        function dateFormat(date, formatString) {
            if (_.isDate(date)) {
                return kendo.toString(date, formatString);
            }
            else if (_.isString(date)) {
              //replaced by HD 2019-07-03
              //var dateValue = kendo.parseDate(date, ['yyyy-MM-ddTHH:mm:ss.fffZ','yyyy-MM-dd HH:mm:ss.fff']);
			  //This quickfix was not tested properly, has to be tested in development env.
                var dateValue = kendo.parseDate(date, ['yyyy-MM-ddTHH:mm:ssz', 'yyyy-MM-ddTHH:mm:ss.fffz', 'yyyy-MM-dd HH:mm:ss.fff', 'yyyy-MM-dd HH:mm:ss'], 'yyyy-MM-ddTHH:mm:sszzz');
                return kendo.toString(dateValue, formatString);
            }

            return '';
        }
    }])
;
angular.module('cerberus.util')
    .controller('PrintConfigurationModalCtrl', ["_", "$scope", "$q", "$uibModalInstance", "defaultConfiguration", "enabledPrintTypes", "instanceIds", "displayValues", "widgetId", "InstancesService", "WidgetsService", function(_, $scope, $q, $uibModalInstance, defaultConfiguration, enabledPrintTypes,
                                                           instanceIds, displayValues, widgetId, InstancesService, WidgetsService){
        var vm = this;

        vm.instanceIds = _.uniq(instanceIds);
        vm.forms = [];
        vm.startingCheckNumber = 0;
        vm.checkNumberChanged = false;
        // vm.fileNameChanged = false;
        vm.displayValues = displayValues;
        vm.checkNumberFieldMissing = false;
        vm.showPageTotals = false;
        vm.useDefaultMargin = true;

        vm.printConfiguration = {
            // filename: '',
            type: '',
            defaultMargin: { top: 0, right: 0, bottom: 0, left: 0 },
            normal: {
                paperSize: 'letter',
                landscape: false,
                margin: 0
            },
            check: {
                targetForm: '',
                pageCounter: '',
                checksPerPage: 1,
                carbonCopy: true,
                checkNumbers: {},
                checkNumExists: {}
            },
            label: {
                targetForm: '',
                pageTotal: {}
            }
        };

        vm.printTypes = [
            {value: 'normal', display: 'Normal'},
            {value: 'check', display: 'Checks'},
            {value: 'label', display: 'Labels'}
        ];

        vm.supportedPaperSizes = [
            {value: 'legal', display: 'Legal'},
            {value: 'letter', display: 'Letter'},
            {value: 'tabloid', display: 'Tabloid'}
        ];

        vm.pdfOrientations = [
            {value: false, display: 'Portrait'},
            {value: true, display: 'Landscape'}
        ];

        vm.checksPerPageOptions = [
            {value: 1, display: "1-Up"},
            {value: 3, display: "3-Up"}
        ];

        vm.enabledPrintTypes = enabledPrintTypes || {};

        vm.confirm = _confirm;
        vm.cancel = _cancel;
        vm.printTypeIsEnabled = _printTypeIsEnabled;
        vm.printTypeChanged = _printTypeChanged;
        vm.startingNumberChanged = _setCheckNumbers;
        vm.loadFormSettings = _loadFormSettings;
        vm.printConfigIncomplete = _printConfigIncomplete;

        _init();

        function _init() {
            _.assign(vm.printConfiguration, defaultConfiguration);

            if(vm.printConfiguration.type) {
                _printTypeChanged(vm.printConfiguration.type);
            }
        }

        function _confirm(config) {
            var options = config[config.type];

            if (vm.useDefaultMargin) {
                options.margin = config.defaultMargin;
            }

            $uibModalInstance.close({
                // filename: config.filename,
                type: config.type,
                options: config[config.type]
            });
        }

        function _cancel() {
            $uibModalInstance.dismiss('Canceled');
        }

        function _printTypeIsEnabled(printTypeOption) {
            return vm.enabledPrintTypes[printTypeOption.value];
        }

        function _printTypeChanged(type) {
            // Gets all forms of the selected type. Normal printing includes
            // whole instance, so no individual form needs to be selected.
            if(type !== 'normal') {
                WidgetsService.getAllForms(widgetId, type).then(function (forms) {
                    vm.forms = forms;

                    if (!_.isEmpty(forms)) {
                        // Automatically set first form as the target form
                        var formOriginId = forms[0].originatorId;

                        vm.printConfiguration[type].targetForm = formOriginId;
                        _loadFormSettings(formOriginId, type);
                    }
                });
            }

            if(type === 'check') {
                // Set check numbers for each instance
                _setCheckNumbers(vm.startingCheckNumber);
            }
        }

        function _setCheckNumbers(startingNumber) {
            // If check numbers have not been manually changed, automatically set them based on startingNumber
            if(!vm.checkNumberChanged) {
                vm.printConfiguration.check.checkNumbers = {};
                vm.printConfiguration.check.checkNumExists = {};
                var modelId = vm.printConfiguration.check.pageCounter;
                var instanceIndex = 0;
                var formArray = [];
                if(vm.printConfiguration.check.targetForm) {
                    formArray = [{
                        formId: vm.printConfiguration.check.targetForm,
                        isPk: false,
                        displayOrder: '1'
                    }];
                }
                _.forEach(instanceIds, function(id) {
                    InstancesService.getFormData(id, formArray, null, true).then(function (result) {
                        if(modelId && !vm.checkNumberFieldMissing && result.recordData[modelId]) {
                            vm.printConfiguration.check.checkNumbers[id] = result.recordData[modelId];
                            vm.printConfiguration.check.checkNumExists[id] = true;
                        }
                        else {
                            instanceIndex++;
                            vm.printConfiguration.check.checkNumbers[id] = startingNumber + instanceIndex;
                            vm.printConfiguration.check.checkNumExists[id] = false;
                        }
                    });
                });
            }
        }

        function _loadFormSettings(formOriginId, type) {
            if(formOriginId){
                var form = _.find(vm.forms, 'originatorId', formOriginId);
                vm.checkNumberFieldMissing = false;

                if (form.settings.print.margin) {
                    vm.printConfiguration.defaultMargin = form.settings.print.margin;
                }

                if(type === 'label') {
                    var formArray = [{
                            formId: formOriginId,
                            isPk: false,
                            displayOrder: '1'
                        }],
                        pageTotalModel = form.settings.print.pageTotal;

                    vm.printConfiguration.label.paperSize = form.settings.print.pageSize || [8.5, 11];
                    vm.printConfiguration.label.margin = angular.copy(vm.printConfiguration.defaultMargin);

                    if (pageTotalModel) {
                        _.forEach(instanceIds, function (id) {
                            // Get the default number of pages for this record
                            InstancesService.getFormData(id, formArray, null, true).then(function (result) {
                                // Use value set in pageTotal field as the default pageTotal value
                                vm.printConfiguration.label.pageTotal[id] = result.recordData[pageTotalModel] || 1;
                            });
                        });

                        vm.showPageTotals = true;
                    }
                    else {
                        _.forEach(instanceIds, function (id) {
                            vm.printConfiguration.label.pageTotal[id] =  1;
                        });

                        vm.showPageTotals = false;
                    }
                }
                else if(type === 'check') {
                    var modelId = form.settings.print.pageCounter;
                    vm.printConfiguration.check.pageCounter = modelId;
                    vm.printConfiguration.check.paperSize = form.settings.print.pageSize || [8.5, 11];
                    vm.printConfiguration.check.margin = angular.copy(vm.printConfiguration.defaultMargin);

                    /* Get Max Page Counter - Find last check entered in the system */
                    if (modelId) {
                        WidgetsService.getMax(widgetId, modelId).then(function(result) {
                            vm.startingCheckNumber = result.max + 1;
                            vm.checkNumberChanged = false;
                            _setCheckNumbers(vm.startingCheckNumber);
                        });
                    }
                    else {
                        vm.checkNumberFieldMissing = true;
                    }
                }
                else if (type === 'normal') {
                    vm.printConfiguration.normal.margin = angular.copy(vm.printConfiguration.defaultMargin);
                }
            }
        }

        // Checks if configuration is incomplete based on print type
        function _printConfigIncomplete(type/*, filename*/) {
            // if(!type || !filename){
            if(!type){
                return true;
            }
            else if(type === 'check') {
                var checkSettings = vm.printConfiguration.check;

                return !checkSettings.targetForm || !checkSettings.pageCounter || !_.every(checkSettings.checkNumbers) || !checkSettings.paperSize[0] || !checkSettings.paperSize[1];
            }
            else if(type === 'label') {
                var labelSettings = vm.printConfiguration.label;

                var pageTotalsSet = _.every(instanceIds, function (id) {
                    return _.isNumber(labelSettings.pageTotal[id]) && labelSettings.pageTotal[id] > 0;
                });

                return !labelSettings.targetForm || !pageTotalsSet || !labelSettings.paperSize[0] || !labelSettings.paperSize[1];
            }

            return false;
        }

        // Prevents navigation while in the modal.
        // This is cleared when the modal scope is destroyed.
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.util')
    .factory('printService', ["_", "$window", "$q", "$uibModal", "checkPrintingService", "labelPrintingService", "normalPrintingService", "WidgetsService", function PagesCtrl(_, $window, $q, $uibModal, checkPrintingService, labelPrintingService, normalPrintingService, WidgetsService) {

        var windowArea = angular.element('#nim-window-area');
        var $printSection = angular.element("#print-section");

        if ($window.matchMedia) {
            var mediaQueryList = $window.matchMedia('print');
            mediaQueryList.addListener(function(mql) {
                if (mql.matches) {
                    beforePrint();
                } else {
                    afterPrint();
                }
            });
        }
        $window.onbeforeprint = beforePrint;
        $window.onafterprint = afterPrint;

        var service = {
            printElement: printElement,
            openPrintConfigurationModal: openPrintConfigurationModal,
            configureAndPrint: configureAndPrint
        };
        return service;
        ///////////////////
        /**
         *
         * @param elem
         */
        function printElement(elem) {
            var domClone = elem.cloneNode(true);
            $printSection.empty().append(domClone);
        }
        function beforePrint() {
            var windows = windowArea.find('.k-window');
            if (windows.length > 0) {
                return;
            }
            var domClone = angular.element('#content-wrap').clone(true, true);
            $printSection.empty().append(domClone);
        }
        function afterPrint() {
            var windows = windowArea.find('.k-window');
            if (windows.length > 0) {
                return;
            }
            $printSection.empty();
        }

        /**
         * Opens configuration modal to set print options
         * @param widgetId - widget the specified instances belong to
         * @param instanceIds - instances to export to pdf
         * @param displayValues - Display values for check printing
         * @param enabledPrintTypes - map that specifies which print types the user may select
         * @param defaultConfiguration - default options to be passed into the config modal
         * @returns {Promise}
         */
        function openPrintConfigurationModal(widgetId, instanceIds, displayValues, enabledPrintTypes, defaultConfiguration) {
            var openModal = function () { 
                var printConfigurationModal = $uibModal.open({
                    templateUrl: 'util/print/print-configuration-modal.tpl.html',
                    controller: 'PrintConfigurationModalCtrl',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        defaultConfiguration: _.constant(defaultConfiguration || {}),
                        enabledPrintTypes: _.constant(enabledPrintTypes || {}),
                        instanceIds: _.constant(instanceIds || []),
                        displayValues: _.constant(displayValues || {}),
                        widgetId: _.constant(widgetId || '')
                    }
                });

                return printConfigurationModal.result;
            };

            // Shortcut for printing single instance's labels
            if (_.get(defaultConfiguration, 'type') == 'label' && instanceIds.length == 1) {
                var deferred = $q.defer();
                var config = {
                    type: 'label',
                    options: {
                        targetForm: '',
                        pageTotal: {}
                    }
                };

                config.options.pageTotal[instanceIds[0]] = 1;

                _.assign(config.options, _.get(defaultConfiguration, 'label'));

                WidgetsService.getAllForms(widgetId, 'label').then(function (forms) {
                    if (forms.length == 1) {
                        // Set first form as the target form
                        var form = forms[0];
                        var formOriginId = form.originatorId;
                        var pageTotalModel = form.settings.print.pageTotal;

                        config.options.targetForm = formOriginId;
                        config.options.paperSize = form.settings.print.pageSize || [8.5, 11];
                        config.options.margin = form.settings.print.margin || 0;

                        if (pageTotalModel) {
                            openModal().then(function(c){
                                deferred.resolve(c);
                            });
                        }
                        else {
                            deferred.resolve(config);
                        }    
                    }
                    else {
                        openModal().then(function(c){
                            deferred.resolve(c);
                        });
                    }
                });

                return deferred.promise;
            }

            return openModal();
        }

        /**
         * Configures print options then automatically calls the correct function based on print type
         * @param widgetId - widget the specified instances belong to
         * @param instanceIds - instances to export to pdf
         * @param displayValues - Map of display values for each record (for check printing)
         * @param enabledPrintTypes - map that specifies which print types the user may select
         * @param defaultConfiguration - default options to be passed into the config modal
         */
        function configureAndPrint(widgetId, instanceIds, displayValues, enabledPrintTypes, defaultConfiguration, defaultName){
            var deferred = $q.defer();

            service.openPrintConfigurationModal(widgetId, instanceIds, displayValues, enabledPrintTypes, defaultConfiguration).then(function (config) {
                defaultName = config.filename || defaultName || 'download';

                // When configuration is complete, call the correct service according to the print type selected
                if(config.type === 'normal'){
                    normalPrintingService.printInstance(instanceIds[0], defaultName, config.options).then(function () {
                        deferred.resolve();
                    });
                }
                else if(config.type === 'label'){
                    labelPrintingService.printLabels(instanceIds, defaultName, config.options).then(function () {
                        deferred.resolve();
                    });
                }
                else if (config.type === 'check') {
                    checkPrintingService.printChecks(instanceIds, defaultName, config.options).then(function () {
                        deferred.resolve();
                    });
                }
                else {
                    deferred.resolve();
                }
            }, function () {
                deferred.reject();
            });

            return deferred.promise;
        }
    }])
;
/*jshint bitwise: false*/
angular.module('cerberus.admin')
    .controller('MenusDesignerCtrl', ["$scope", "$location", "$uibModal", "menuId", "MenusService", "PagesService", "PageDesignerService", "DesignerUtilityService", function MenusDesignerCtrl($scope, $location, $uibModal, menuId, MenusService, PagesService, PageDesignerService, DesignerUtilityService) {
        var vm = this;

        vm.menuId = menuId;
        vm.menu = {};
        vm.orig = [];
        vm.pages = [];
        vm.pagesCopy = [];
        vm.pageFilter = '';

        vm.createArray = [];
        vm.updateArray = [];
        vm.deleteArray = [];

        vm.settingsCollapse = true;
        vm.menuTree = angular.element('#menu-root').scope();
        // For scaling pages panel to menu panel height
        vm.menuPanel = document.getElementById("menu-tree-panel");

        init();
        DesignerUtilityService.cancelRouteNav($scope, hasChanges);

        vm.isUnchanged = isUnchanged;
        vm.save = save;
        vm.close = close;
        vm.openMenuPageModal = openMenuPageModal;
        vm.deleteItem = deleteItem;
        vm.deleteMenu = deleteMenu;
        vm.open = open;

        // For keeping all page items in page tree after dragging one to menu
        $scope.$watchCollection('vm.pages', function(pages){
            if(!angular.equals(pages, vm.pagesCopy)){
                vm.pages = angular.copy(vm.pagesCopy);
            }
        });

        function init(){
            MenusService.getMenu(vm.menuId).then(function(menu){
                vm.menu = menu;
                vm.menu.is_default = vm.menu.is_default == 1;
                vm.orig = angular.copy(vm.menu);
            });

            PagesService.getPages().then(function(pages){
                var formattedPages = pages;
                for(var p = 0; p < formattedPages.length; p++){
                    formattedPages[p] = pageToMenuItem(formattedPages[p]);
                }

                vm.pages = angular.copy(formattedPages);
                vm.pagesCopy = angular.copy(formattedPages);
            });
        }

        function pageToMenuItem(page){
            return {
                description: page.description,
                icon: page.icon,
                id: getId() + 1,
                isDefault: false,
                items: [],
                pageId: page.id,
                permissions: {},
                title: page.name
            };
        }

        function isUnchanged(){
            return angular.equals(vm.orig, vm.menu);
        }

        function hasChanges(){
            return !isUnchanged();
        }

        function save(closeMenu){
            var menuData = angular.copy(vm.menu);
            open(menuData.items, false);    // Set Menu items to be closed by default
            MenusService.updateMenu(vm.menuId, menuData).then(function(){
                vm.orig = angular.copy(vm.menu);
                if(closeMenu){
                    close();
                }
            });
        }

        function close (){
            $location.url('/settings/menus');
        }

        function openMenuPageModal (menuData) {
            var editFlag = menuData != null;
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/menus/designer/menus-designer-modal.tpl.html',
                controller: 'MenusDesignerModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    menuData: function(){
                        return menuData;
                    },
                    editFlag: function(){
                        return editFlag;
                    }
                }
            });
            modalInstance.result.then(function (data) {
                if(editFlag){
                    if(data.isDefault && !menuData.isDefault){
                        setDefaultPage(data.id);
                    }
                    editItem(data);
                }
                else{
                    var newPage = {
                        name: data.title,
                        icon: data.icon,
                        description: data.description,
                        permissions: data.permissions
                    };
                    PageDesignerService.create(newPage).then(function(pageId){
                        data.id = getId() + 1;
                        data.pageId = pageId;
                        vm.pagesCopy.push(data);
                        vm.pages.push(data);
                    });
                }
            });
        }

        function getId(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {var r = Math.random()*16|0,v=c=='x'?r:r&0x3|0x8;return v.toString(16);});
        }

        function setDefaultPage(id){
            MenusService.setDefaultPage(id, vm.menu.items);
        }

        function editItem(item){
            var arr = vm.menu.items;
            var edit = function(array){
                for(var i = 0;i < array.length; i++){
                    if(array[i].id === item.id){
                        array[i] = item;
                        return;
                    }
                    else{
                        edit(array[i].items);
                    }
                }
            };
            edit(arr);
        }

        function deleteItem(item){
            var arr = vm.menu.items;
            var menuObj;
            var del = function(array){
                for(var i = 0;i < array.length; i++){
                    if(array[i] === item){
                        menuObj = array[i];
                        array.splice(i,1);
                        return;
                    }
                    else{
                        del(array[i].items);
                    }
                }
            };
            del(arr);
        }

        function deleteMenu(){
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/menus/designer/delete-modal.tpl.html',
                controller: 'DeleteMenuModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    menu: function (){
                        return vm.menu;
                    }
                }
            });
            modalInstance.result.then(function() {
                MenusService.deleteMenu(vm.menuId).then(function(){
                    close();
                });
            });
        }

        // Sets the 'open' attribute for menu items
        function open(items, expand) {
            for(var i = 0; i < items.length; i++){
                items[i].open = expand;
                open(items[i].items);
            }
        }
    }])
;
angular.module('cerberus.admin')
    .controller('MenusDesignerModalCtrl', ["$scope", "$rootScope", "$uibModalInstance", "menuData", "editFlag", function MenusDesignerModalCtrl($scope, $rootScope, $uibModalInstance, menuData, editFlag) {
        var vm = this;

        vm.workspace = $rootScope.userData.currentWorkspace;
        vm.menuData = angular.copy(menuData);
        vm.isCollapsed = true;
        vm.groups = [];
        vm.editFlag = editFlag;

        vm.isUnchanged = isUnchanged;
        vm.cancel = cancel;
        vm.finish = finish;

        init();

        function init(){
            if (!editFlag){
                vm.menuData = {
                    icon: 'file-o',
                    items: [],
                    title: '',
                    permissions:{}
                };
            }

            $scope.$on('$locationChangeStart', function(event){
                event.preventDefault();
            });
        }
        function isUnchanged(){
            return angular.equals(vm.menuData, menuData);
        }
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
        function finish(){
            $uibModalInstance.close(vm.menuData);
        }
    }])
    .controller('DeleteMenuModalCtrl', ["$scope", "$uibModalInstance", "menu", function DeleteMenuModalCtrl($scope, $uibModalInstance, menu) {
        // Modified to delete Menu instead of page
        var vm = this;

        vm.menu = angular.copy(menu);

        vm.isNotEqual = function(data){
            return !angular.equals('DELETE ' + vm.menu.name, data);
        };
        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.finish = function(){
            $uibModalInstance.close(vm.menu);
        };

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('PagesDesignerCtrl', ["_", "$scope", "$rootScope", "$uibModal", "$location", "$timeout", "$q", "toaster", "pageId", "ConfirmModalService", "DesignerUtilityService", "PagesService", "PagesClassService", "pageObjectsService", "PageDesignerService", "PagesDesignerConvenienceService", "PageObjectsDesignerService", "WorkspacesGroupsService", function PagesDesignerCtrl(_, $scope, $rootScope, $uibModal, $location, $timeout, $q, toaster, pageId,
                                                                ConfirmModalService, DesignerUtilityService, PagesService, PagesClassService, pageObjectsService,
                                                                PageDesignerService, PagesDesignerConvenienceService, PageObjectsDesignerService, WorkspacesGroupsService) {
        $scope.designerWidth = 'auto';
        $scope.filters = {};
        $scope.settingsCollapse = true;
        $scope.importPageObjectId = null;
        $scope.gridsterOpts = {
            swapping: false,
            resizable: {
                enabled: true,
                stop: pageObjectMove
            },
            draggable: {
                enabled: true,
                stop: pageObjectMove
            },
            height: 'auto',
            margins: _.get($scope.temp, 'options.gridsterConfig.margins', [15, 15]),
            outerMargin: _.get($scope.temp, 'options.gridsterConfig.outerMargin', true)
        };

        // CRUD Arrays
        $scope.createArray = [];
        $scope.updateArray = [];
        $scope.deleteArray = [];

        $scope.isPreviewObj = isPreviewObj;

        function pageObjectMove(event, element, widget){
            if($scope.createArray.indexOf(widget) < 0 && $scope.updateArray.indexOf(widget) < 0){
                $scope.updateArray.push(widget);
            }
        }

        function formatName(name){
            var formattedName = '';
            if(name && name.length > 0){
                formattedName += name.charAt(0).toUpperCase();
                if(name.length > 1){
                    formattedName += name.substr(1, name.length - 1).toLowerCase();
                }
            }
            return formattedName;
        }

        $scope.hasChanges = function () {
            return !(angular.equals($scope.orig, $scope.temp) && angular.equals($scope.permissions, $scope.oldPermissions));
        };

        DesignerUtilityService.cancelRouteNav($scope, $scope.hasChanges);

        // Page Item Commands
        $scope.deleteBox = function(index){
            var cin = $scope.createArray.indexOf($scope.temp.items[index]);
            var uin = $scope.updateArray.indexOf($scope.temp.items[index]);
            if(cin >= 0){
                $scope.createArray.splice(cin, 1);
            }
            else{
                if(uin >= 0){
                    $scope.updateArray.splice(uin, 1);
                }
                $scope.deleteArray.push($scope.temp.items[index].id);
            }
            $scope.temp.items.splice(index, 1);
        };

        $scope.deletePage = function(data){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to delete this page?',
                instructionText: 'Type "DELETE ' + data.name + '" to confirm.',
                actionButtonText: 'Delete Page Forever',
                closeButtonText: 'Cancel',
                check: function(input){
                    return angular.equals(input, 'DELETE ' + data.name);
                },
                confirm: function(){
                    return PageDesignerService.deletePage(data.id);
                },
                callback: function(){
                    $location.url('/settings/pages');
                }
            });
        };

        $scope.deletePageObject = function(pageObject, index){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: 'Are you sure you want to delete this page object and remove it from each page that uses it?',
                instructionText: 'Type "DELETE ' + pageObject.name + '" to confirm.',
                actionButtonText: 'Delete Page Object',
                closeButtonText: 'Cancel',
                check: function(input){
                    return angular.equals(input, 'DELETE ' + pageObject.name);
                },
                confirm: function(){
                    return PageObjectsDesignerService.deletePageObject(pageObject.id);
                },
                callback: function(){
                    var uin = $scope.updateArray.indexOf(pageObject);
                    if(uin >= 0){
                        $scope.updateArray.splice(uin, 1);
                    }

                    $scope.temp.items.splice(index, 1);
                }
            });
        };

        $scope.copyPageObject = function(item){
            var newObj = angular.copy(item);
            newObj.id = null;
            delete newObj.imported;
            $scope.createArray.push(newObj);
            $scope.temp.items.push(newObj);
        };

        $scope.openPageObjectConfigModal = function(item, index){
            var controller;
            if(item.viz.subType){
                controller = formatName(item.viz.subType) + 'ConfigCtrl';
            }
            else if(item.viz.type){
                controller = formatName(item.viz.type) + 'ConfigCtrl';
            }
            else{
                controller = formatName(item.type) + 'ConfigCtrl';
            }

            if(item.wrapper.header === true){
                item.wrapper.header = {style:{}};
            }
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/pages/designer/common/config-modal.tpl.html',
                controller: controller,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    pageObject: function (){
                        return item;
                    },
                    filters: function () {
                        //return $scope.temp.options.filters;
                        return DesignerUtilityService.getFilters($scope.temp.items, item);
                    }
                }
            });
            modalInstance.result.then(function (data) {
                    if(!data.hasOwnProperty('subType')){
                        data.subType = null;
                    }

                    data.viz.settings.batchEdit = data.tools.edit || data.tools.delete;

                    if(index < 0){
                        $scope.temp.items.push(data);
                        $scope.createArray.push(data);
                    }
                    else{
                        var cin = $scope.createArray.indexOf($scope.temp.items[index]);
                        var uin = $scope.updateArray.indexOf($scope.temp.items[index]);
                        $scope.temp.items[index] = data;
                        if(cin >= 0){
                            $scope.createArray[cin] = data;
                        }
                        else if(uin >= 0){
                            $scope.updateArray[uin] = data;
                        }
                        else{
                            $scope.updateArray.push(data);
                        }
                    }

                    if(data.id){
                        var deleteIndex = $scope.deleteArray.indexOf(data.id);
                        if(deleteIndex >= 0){
                            $scope.deleteArray.splice(deleteIndex, 1);
                        }
                    }
                },
                function(reason){
                    if(reason === 'delete'){
                        $scope.deletePageObject(item, index);
                    }
                });
        };

        $scope.createPageObject = function(type, vizCode){
            var item = PagesClassService.newPageObject();
            if (vizCode && PagesDesignerConvenienceService[vizCode]) {
                item.viz = PagesDesignerConvenienceService[vizCode]();
                item.type = type;
                _.defaults(item.tools, {
                    showToolbar: false,
                    create: true,
                    delete: false,
                    refresh: true
                });

                if(item.viz.type === 'template'){
                    _.defaults(item.tools, {
                        print: true
                    });
                }
                else if(item.viz.type === 'kanban'){
                    _.defaults(item.params, {
                        editable: true
                    });
                }
            }
            else if(type && PagesClassService[type]){
                item = PagesClassService[type]();
            }

            if(vizCode === 'table' || vizCode === 'listview' || vizCode === 'scheduleGantt' || vizCode === 'schedule'){
                item.wrapper = PagesDesignerConvenienceService.portlet();
            }
            else if(type === 'tabset'){
                item.wrapper = PagesDesignerConvenienceService.tile();
                item.wrapper.shadow = false;
            }
            else {
                item.wrapper = PagesDesignerConvenienceService.tile();
            }

            $scope.openPageObjectConfigModal(item, -1);
        };

        $scope.importPageObject = function(importPageObjectId, duplicate){
            var index = $scope.temp.items.map(function(obj){ return obj.id; }).indexOf(importPageObjectId);

            if(index < 0 || duplicate){ // Doesn't import an object already on the page
                pageObjectsService.getPageObject(importPageObjectId).then(function(pageObject){
                    $timeout(function(){
                        $scope.importPageObjectId = null;
                        $scope.importShow = false;
                        delete pageObject.col;
                        delete pageObject.row;
                        pageObject.sizeX = 6;
                        pageObject.sizeY = 7;
                        pageObject.subType = null;
                        if(duplicate){
                            pageObject.id = null;
                            $scope.createArray.push(pageObject);
                        }
                        else {
                            pageObject.imported = true;
                            $scope.updateArray.push(pageObject);
                        }

                        $scope.temp.items.push(pageObject);

                        var deleteIndex = $scope.deleteArray.indexOf(pageObject.id);
                        if(deleteIndex >= 0){
                            $scope.deleteArray.splice(deleteIndex, 1);
                        }
                    });
                });
            }
        };

        $scope.isUnchanged = function () {
            return angular.equals($scope.orig, $scope.temp) && angular.equals($scope.permissions, $scope.oldPermissions);
        };

        $scope.save = function (close) {
            var promises = [];

            if($scope.createArray.length > 0) {
                promises.push(
                    PageDesignerService.createObjects($scope.temp.id, $scope.createArray).then(function(){
                        $scope.createArray = [];
                    })
                );
            }
            if($scope.updateArray.length > 0) {
                promises.push(
                    PageDesignerService.updateObjects($scope.temp.id, $scope.updateArray).then(function(){
                        $scope.updateArray = [];
                    })
                );
            }
            if($scope.deleteArray.length > 0) {
                promises.push(
                    PageDesignerService.removeObjects($scope.temp.id, $scope.deleteArray).then(function(){
                        $scope.deleteArray = [];
                    })
                );
            }
            if(optionsChanged($scope.temp, $scope.orig)){
                promises.push(
                    PageDesignerService.update($scope.temp.id, $scope.temp.options, $scope.temp.name, $scope.temp.description, $scope.temp.icon)
                );
            }
            if(!angular.equals($scope.permissions, $scope.oldPermissions)){
                promises.push(
                    PageDesignerService.updatePagePermissions($scope.temp.id, {permissions:$scope.permissions})
                );
            }

            $q.all(promises).then(function(){
                toaster.pop('success', 'Page Saved');
                if(close){
                    $scope.orig = angular.copy($scope.temp);
                    $scope.close();
                }
                else {
                    PagesService.getPage($scope.temp.id).then(function(data){
                        $scope.temp = angular.copy(data);
                        $scope.orig = angular.copy(data);
                    });
                    $scope.oldPermissions = angular.copy($scope.permissions);
                }
            });
        };

        $scope.saveAndClose = function () {
            $scope.save(true);
        };

        $scope.close = function () {
            $location.url('/settings/pages');
        };

        $scope.$on('nim-page-object-list-selected', function(e, pageObject){
            e.stopPropagation();
            $timeout(function(){
                $scope.importPageObjectId = pageObject.id;
            });
        });

        $scope.updateGridsterMargins = updateGridsterMargins;

        function optionsChanged(temp, orig){
            return !(angular.equals(temp.options, orig.options) && temp.name === orig.name && temp.description === orig.description && temp.icon === orig.icon);
        }

        _init();

        $scope.$on('$locationChangeStart', function (e) {
            if (!e.defaultPrevented) {
                $scope.$broadcast('nim-remove-page-objects');
            }
        });

        function _init(){
            PagesService.getPage(pageId).then(function(pageModel){
                _.defaults(pageModel.options, { gridsterConfig:{ margins: [15, 15], outerMargin: true } });

                var gridsterConfig = pageModel.options.gridsterConfig;

                // Protects against potential issue with gridster margins being saved as an object instead of an array
                if(!_.isArray(gridsterConfig.margins)){
                    gridsterConfig.margins = [
                        gridsterConfig.margins[0],
                        gridsterConfig.margins[1]
                    ];
                }

                $scope.gridsterOpts.margins = _.get(pageModel.options, 'gridsterConfig.margins');
                $scope.gridsterOpts.outerMargin = _.get(pageModel.options, 'gridsterConfig.outerMargin');

                $scope.orig = angular.copy(pageModel);
                $scope.temp = angular.copy(pageModel);
            });

            PagesService.getPagePermissions(pageId).then(function(permissions){
                $scope.oldPermissions = angular.copy(permissions);
                $scope.permissions = angular.copy(permissions);
            });

            WorkspacesGroupsService.getGroups($rootScope.userData.currentWorkspace.id).then(function(groups){
                $scope.groups = _.filter(groups, function(g) {
                    return g.type === 'Custom' || g.type === 'User';
                });
            });
        }

        function updateGridsterMargins(pageObjectGridsterConfig, gridsterOptions){
            gridsterOptions.margins = pageObjectGridsterConfig.margins;
        }

        function isPreviewObj(pageObject) {
            return !!(!pageObject.id || _.find($scope.updateArray, 'id', pageObject.id));
        }
    }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name PagesDesignerConvenienceService
 * @alias cerberus/pages-designer:PagesDesignerConvenienceService
 * @description Constructs PageObject class
 */
    .factory('PagesDesignerConvenienceService', ["PagesClassService", "WrapperClassService", "VizClassService", function PagesDesignerConvenienceService(PagesClassService, WrapperClassService, VizClassService) {
        /* Import Classes */
        var Wrapper = WrapperClassService.wrapper;
        var Header = WrapperClassService.header;
        var Body = WrapperClassService.body;
        var Footer = WrapperClassService.footer;
        var Viz = VizClassService.viz;

        var service = {
            portlet: portlet,
            tile: tile,
            circletile: circletile,
            template: template,
            table: table,
            chartArea: chartArea,
            chartBar: chartBar,
            chartBubble: chartBubble,
            chartBullet: chartBullet,
            chartDonut: chartDonut,
            chartFunnel: chartFunnel,
            chartLine: chartLine,
            chartPie: chartPie,
            chartScatter: chartScatter,
            schedule: schedule,
            scheduleGantt: scheduleGantt,
            scheduleCalendar: scheduleCalendar,
            map: map,
            progress: progress,
            listview: listview,
            kanban: kanban
        };
        return service;

        ////////////////////
        /* Define Wrappers */
        /**
         * Builds a default portlet wrapper
         * @function portlet
         * @returns {Wrapper}
         */
        function portlet() {
            return new Wrapper(
                'portlet',
                new Header(null, null, null, {
                    color: '#ffffff',
                    'border-color': '#444444',
                    background: '#444444'
                }),
                new Body(null, {}),
                new Footer(null, {
                    color: '#e6e6e6',
                    background: '#444444'
                }),
                true,
                {
                    margin: '0px 0px 0px 0px'
                }
            );
        }

        /**
         * Builds a default tile wrapper
         * @function tile
         * @returns {Wrapper}
         */
        function tile() {
            return new Wrapper(
                'tile',
                new Header(null, null, null, {}),
                new Body(null, {}),
                new Footer(null, {}),
                true,
                {
                    margin: '0px 0px 0px 0px',
                    padding: '8px 8px 8px 8px',
                    background: '#ffffff'
                }
            );
        }

        /**
         * Builds a default circleTile wrapper
         * @function circletile
         * @returns {Wrapper}
         */
        function circletile() {
            return new Wrapper(
                'circletile',
                new Header(null, null, null, {
                    'border-color':'#808080',
                    background: '#444444'
                }),
                new Body(null, {
                    background: '#444444'
                }),
                new Footer(null, {}),
                true,
                {
                    margin: '0px 0px 0px 0px'
                }
            );
        }

        /* Define Visualizations */

        /**
         * Builds a template Viz
         * @function template
         * @returns {Viz}
         */
        function template() {
            return new Viz('template', null, null,
                {
                    template: null,
                    defaultText: null,
                    schema:{},
                    columns: [],
                    dataSource: {
                        schema: {
                            model: {
                                fields: {}
                            }
                        },
                        pageSize: 1,
                        sort: []
                    },
                    aggregate: [],
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                }
            );
        }

        /**
         * Builds a table Viz
         * @function table
         * @returns {Viz}
         */
        function table() {
            return new Viz('table', null, null,
                {
                    columns: [],
                    batchEdit: false,
                    filterable: true,
                    groupable: false,
                    sortable: true,
                    pageable: true,
                    propertyColumns: [],
                    dataSource: {
                        pageSize: 10,
                        schema: {
                            model: {
                                id: 'id',
                                parentId: 'parentId',
                                fields: {
                                    parentId: {
                                        type:'number',
                                        nullable: true
                                    }
                                }
                            }
                        },
                        sort: [],
                        aggregate: [],
                        filter: {
                            filters: [],
                            logic: 'and'
                        }
                    }
                }
            );
        }

        /**
         * Builds a chart/area Viz
         * @function chartArea
         * @returns {Viz}
         */
        function chartArea() {
            return new Viz('chart', 'area', null, {
                theme: 'erp_majestic_theme',
                columns: [],
                dataSource: {
                    schema: {
                        model: {
                            fields: {}
                        }
                    },
                    sort: [],
                    aggregate: [],
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                },
                chartArea: {
                    margin: {},
                    background: 'transparent',
                    opacity: 1
                },
                seriesDefaults: {
                    type: "area",
                    area: {
                        line: {
                            style: "smooth"
                        }
                    }
                },
                series: [{}],
                valueAxis: {
                    visible: true,
                    type: 'numeric',
                    line: {
                        visible: false
                    },
                    minorGridLines: {
                        visible: true
                    },
                    crosshair: {
                        visible: false
                    }
                },
                categoryAxis: {
                    visible: true,
                    type: 'category',
                    labels: {},
                    crosshair: {
                        visible: false
                    }
                },
                legend: {
                    visible: false,
                    position: '',
                    align: '',
                    labels: {},
                    reverse: false
                },
                tooltip: {
                    visible: false,
                    template: "#= series.name #: #= value #"
                }
            });
        }

        /**
         * Builds a chart/bar Viz
         * @function chartBar
         * @returns {Viz}
         */
        function chartBar() {
            return new Viz('chart', 'bar', null, {
                theme: 'erp_majestic_theme',
                columns: [],
                dataSource: {
                    schema: {
                        model: {
                            fields: {}
                        }
                    },
                    sort: [],
                    aggregate: [],
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                },
                chartArea: {
                    margin: {},
                    background: 'transparent',
                    opacity: 1
                },
                seriesDefaults: {
                    type: "bar"
                },
                series: [{}],
                valueAxis: {
                    visible: true,
                    type: 'numeric',
                    line: {
                        visible: false
                    },
                    minorGridLines: {
                        visible: true
                    },
                    crosshair: {
                        visible: false
                    }
                },
                categoryAxis: {
                    visible: true,
                    type: 'category',
                    field: '',
                    labels: {},
                    crosshair: {
                        visible: false
                    }
                },
                legend: {
                    visible: false,
                    position: '',
                    align: '',
                    labels: {},
                    reverse: false
                },
                tooltip: {
                    visible: false,
                    template: "#= series.name #: #= value #"
                }
            });
        }

        /**
         * Builds a chart/bubble Viz
         * @function chartBubble
         * @returns {Viz}
         */
        function chartBubble() {
            return new Viz('chart', 'bubble', null, {
                theme: 'erp_majestic_theme',
                columns: [],
                dataSource: {
                    schema: {
                        model: {
                            fields: {}
                        }
                    },
                    sort: [],
                    aggregate: [],
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                },
                chartArea: {
                    margin: {},
                    background: 'transparent',
                    opacity: 1
                },
                seriesDefaults: {
                    type: "bubble"
                },
                series: [{
                    yField: "",
                    xField: "",
                    sizeField: ""
                }],
                xAxis: {
                    visible: true,
                    type: 'numeric',
                    labels: {}
                },
                yAxis: {
                    visible: true,
                    type: 'numeric',
                    labels: {},
                    line: {
                        width: 0
                    }
                },
                legend: {
                    visible: false,
                    position: '',
                    align: '',
                    labels: {},
                    reverse: false
                },
                tooltip: {
                    visible: false,
                    format: '{0:n0}'
                }
            });
        }

        /**
         * Builds a chart/bullet Viz
         * @function chartBullet
         * @returns {Viz}
         */
        function chartBullet(template) {
            var tpl = template || null;
            var viz = new Viz('chart', 'bullet', tpl,
                {
                    theme: 'erp_majestic_theme',
                    autoBind: false,
                    columns: {
                        value: [],
                        plot: [],
                        target: []
                    },
                    dataSource:{
                        value: {
                            name: 'Value Source',
                            schema: {
                                model: {
                                    fields: {}
                                }
                            },
                            sort: [],
                            aggregate: [],
                            filter: {
                                filters: [],
                                logic: 'and'
                            }
                        },
                        plot: {
                            name: 'Plotband Source',
                            schema: {
                                model: {
                                    fields: {}
                                }
                            },
                            sort: [],
                            aggregate: [],
                            filter: {
                                filters: [],
                                logic: 'and'
                            }
                        },
                        target: {
                            name: 'Target Source',
                            schema: {
                                model: {
                                    fields: {
                                        category:{},
                                        target:{}
                                    }
                                }
                            },
                            sort: [],
                            aggregate: [],
                            filter: {
                                filters: [],
                                logic: 'and'
                            }
                        }
                    },
                    chartArea: {
                        margin: {},
                        background: 'transparent',
                        opacity: 1
                    },
                    legend: {
                        visible: false,
                        position: '',
                        align: '',
                        labels: {},
                        reverse: false
                    },
                    tooltip: {
                        visible: false,
                        template: "#= value.current #"
                    },
                    categoryAxis: {
                        visible: true,
                        type: 'category',
                        line: {
                            visible: true
                        },
                        majorGridLines: {
                            visible: true
                        },
                        minorGridLines: {
                            visible: false
                        },
                        labels: {},
                        crosshair: {
                            visible: false
                        }
                    },
                    valueAxis: {
                        visible: true,
                        type: 'numeric',
                        line: {
                            visible: true
                        },
                        majorGridLines: {
                            visible: true
                        },
                        minorGridLines: {
                            visible: false
                        },
                        crosshair: {
                            visible: false
                        }
                    },
                    seriesDefaults: {
                        type: "bullet"
                    },
                    series: [{
                        field: "value",
                        name: ""
                    }]
                }
            );
            if (tpl === 'sales1') {
                angular.extend(viz, {
                    tooltip: {
                        visible: true,
                        template: "Current: #= kendo.format('{0:c}',kendo.parseFloat(value.current))#"
                    },
                    valueAxis: {
                        majorGridLines: {
                            visible: false
                        },
                        line: {
                            visible: false
                        },
                        labels: {
                            template: "#= kendo.format('{0:c0}',value)#"
                        }
                    },
                    categoryAxis: {
                        majorGridLines: {
                            visible: false
                        },
                        line: {
                            visible: false
                        }
                    }
                });
            }
            return viz;
        }

        /**
         * Builds a chart/donut Viz
         * @function chart
         * @returns {Viz}
         */
        function chartDonut(){
            return new Viz('chart', 'donut', null,
                {
                    theme: 'erp_majestic_theme',
                    columns: [],
                    dataSource: {
                        schema: {
                            model: {
                                fields: {}
                            }
                        },
                        sort: [],
                        aggregate: [],
                        filter: {
                            filters: [],
                            logic: 'and'
                        }
                    },
                    chartArea: {
                        margin: {},
                        background: 'transparent',
                        opacity: 1
                    },
                    seriesDefaults: {
                        labels: {
                            visible: true,
                            background: "transparent",
                            template: "",
                            position: "outsideEnd"
                        },
                        type: 'donut',
                        donut: {
                            categoryField: ""
                        }
                    },
                    series: [{}],
                    legend: {
                        visible: false,
                        position: '',
                        align: '',
                        labels: {},
                        reverse: false
                    },
                    tooltip: {
                        visible: false,
                        template: "#= series.name #: #= value #"
                    }
                }
            );
        }

        /**
         * Builds a chart/funnel Viz
         * @function chart
         * @returns {Viz}
         */
        function chartFunnel(){
            return new Viz('chart', 'funnel', null,
                {
                    theme: 'erp_majestic_theme',
                    columns: [],
                    dataSource: {
                        schema: {
                            model: {
                                fields: {}
                            }
                        },
                        sort: [],
                        aggregate: [],
                        filter: {
                            filters: [],
                            logic: 'and'
                        }
                    },
                    chartArea: {
                        margin: {},
                        background: 'transparent',
                        opacity: 1
                    },
                    seriesDefaults: {
                        labels: {
                            align: "center",
                            visible: true,
                            background: "transparent",
                            position: "center"
                        },
                        type: 'funnel',
                        funnel: {
                            categoryField: "",
                            segmentSpacing: 0,
                            neckRatio: 0.3,
                            dynamicSlope: false,
                            dynamicHeight: true
                        }
                    },
                    series: [{}],
                    legend: {
                        visible: false,
                        position: '',
                        align: '',
                        labels: {},
                        reverse: false
                    },
                    tooltip: {
                        visible: false,
                        template: "#= category #"
                    }
                }
            );
        }

        /**
         * Builds a chart/line Viz
         * @function chart
         * @returns {Viz}
         */
        function chartLine() {
            return new Viz('chart', 'line', null,
                {
                    theme: 'erp_majestic_theme',
                    columns: [],
                    dataSource: {
                        schema: {
                            model: {
                                fields: {}
                            }
                        },
                        sort: [],
                        aggregate: [],
                        filter: {
                            filters: [],
                            logic: 'and'
                        }
                    },
                    chartArea: {
                        margin: {},
                        background: 'transparent',
                        opacity: 1
                    },
                    legend: {
                        visible: false,
                        position: '',
                        align: '',
                        labels: {},
                        reverse: false
                    },
                    tooltip: {
                        visible: false,
                        template: "#= series.name #: #= value #"
                    },
                    categoryAxis: {
                        visible: true,
                        type: 'category',
                        field: '',
                        labels: {},
                        crosshair: {
                            visible: false
                        }
                    },
                    valueAxis: {
                        visible: true,
                        type: 'numeric',
                        line: {
                            visible: false
                        },
                        minorGridLines: {
                            visible: true
                        },
                        crosshair: {
                            visible: false
                        }
                    },
                    seriesDefaults: {
                        style: 'normal',
                        "type": "line"
                    },
                    series: [{}]
                }
            );
        }

        /**
         * Builds a chart/pie Viz
         * @function chartPie
         * @returns {Viz}
         */
        function chartPie() {
            return new Viz('chart', 'pie', null,
                {
                    theme: 'erp_majestic_theme',
                    columns: [],
                    dataSource: {
                        schema: {
                            model: {
                                fields: {}
                            }
                        },
                        sort: [],
                        aggregate: [],
                        filter: {
                            filters: [],
                            logic: 'and'
                        }
                    },
                    chartArea: {
                        margin: {},
                        background: 'transparent',
                        opacity: 1
                    },
                    seriesDefaults: {
                        labels: {
                            visible: true,
                            background: "transparent"
                        },
                        type: 'pie'
                    },
                    series: [{
                        field: "",
                        categoryField: ""
                    }],
                    legend: {
                        visible: false,
                        position: '',
                        align: '',
                        labels: {},
                        reverse: false
                    },
                    tooltip: {
                        visible: false,
                        template: '',
                        format: "{0:%}%"
                    }
                }
            );
        }

        /**
         * Builds a chart/scatter Viz
         * @function chartScatter
         * @returns {Viz}
         */
        function chartScatter() {
            return new Viz('chart', 'scatter', null, {
                theme: 'erp_majestic_theme',
                dataSource: {
                    schema: {
                        model: {
                            fields: {}
                        }
                    },
                    sort: [],
                    aggregate: [],
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                },
                chartArea: {
                    margin: {},
                    background: 'transparent',
                    opacity: 1
                },
                columns: [],
                legend: {
                    visible: false,
                    position: '',
                    align: '',
                    labels: {},
                    reverse: false
                },
                tooltip: {
                    visible: true,
                    template: "#= series.name #: #= value #"
                },
                seriesDefaults: {
                    type: "scatter"
                },
                series: [
                    {
                        "xField": "",
                        "yField": ""
                    }
                ],
                xAxis: {
                    visible: true,
                    type: 'numeric',
                    crosshair: {
                        visible: false,
                        tooltip: {
                            visible: true,
                            format: "n1"
                        }
                    }
                },
                yAxis: {
                    visible: true,
                    type: 'numeric',
                    crosshair: {
                        visible: false,
                        tooltip: {
                            visible: true,
                            format: "n1"
                        }
                    }
                }
            });
        }

        /**
         * Builds a schedule Viz
         * @function schedule
         * @returns {Viz}
         */
        function schedule() {
            return new Viz('schedule', null, null, {
                columns: {},
                views: [
                    { type: "day", selected: false },
                    { type: "workWeek", selected: false },
                    { type: "week", selected: false },
                    { type: "month", selected: true }
                ],
                showWorkHours: true,
                workDayStart: new Date('2013/6/6 06:00 AM'),
                workDayEnd: new Date('2013/6/6 06:00 PM'),
                editable: false,
                eventTemplate: "<span class='custom-event'>{{dataItem.title}}</span>",
                allDayEventTemplate: "<div class='custom-all-day-event'>{{dataItem.title}}</div>",
                timezone: "Etc/UTC",
                dataSource: {},
                resources: {}
            });
        }

        /**
         * Builds a schedule/gantt Viz
         * @function scheduleGantt
         * @returns {Viz}
         */
        function scheduleGantt() {
            return new Viz('schedule', 'gantt', null, {
                dataSource: {
                    aggregate: [],
                    sort: [],
                    schema: {
                        model: {
                            id: "id",
                            fields: {
                                orderId: { from: "", type: "number", defaultValue: 0 },
                                parentId: { from: "", type: "number", defaultValue: null },
                                start: { from: "", type: "date" },
                                end: { from: "", type: "date" },
                                title: { from: "", defaultValue: "", type: "string" },
                                percentComplete: { from: "", type: "number" },
                                summary: { from: "", type: "boolean", defaultValue: false },
                                expanded: { from: "", type: "boolean", defaultValue: true }
                            }
                        }
                    },
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                },
                views: [
                    // "day",
                    { type: "week", selected: false },
                    { type: "month", selected: true }
                ],
                columns: [],
                height: 600,
                showWorkHours: false,
                showWorkDays: false,
                editable: false,
                resizable: true
            });
        }

        /**
         * Builds a schedule/calendar Viz
         * @function scheduleCalendar
         * @returns {Viz}
         */
        function scheduleCalendar() {
            return new Viz('schedule', 'calendar', null, {
//                value: new Date(2000, 10, 1),
                dataSource: {
                    schema: {
                        model: {
                            fields: {
                                date: {
                                    type: "date"
                                }
                            }
                        }
                    },
                    sort: [],
                    aggregate: [],
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                },
                columns: []
            });
        }

        /**
         * Builds a map Viz
         * @function map
         * @returns {Viz}
         */
        function map() {
            return new Viz('map', null, null, {
                dataSource: {},
                columns: {},
                map: {
                    center: [33.7, -117.8],
                    zoom: 10,
                    scrollWheelZoom: false,
                    closePopupOnClick: true
                },
                controls: {
                    zoom: true,
                    layers: true,
                    scale: true,
                    loading: true,
                    editPopup: true
                },
                basemaps: [
                    {
                        type: "mapbox.streets-basic",
                        name:"Basic",
                        visible: true
                    },
                    {
                        type: "mapbox.streets-satellite",
                        name:"Satellite",
                        visible: false
                    }
                ],
                overlays: [],
                groupColors: {}
            });
        }

        /**
         * Builds a progress bar Viz
         * @function progress
         * @returns {VizClassService.viz}
         */
        function progress(){
            return new Viz('progress', null, null, {
                type: 'percent', // 'value'|'percent'|'chunk'
                orientation: 'horizontal',
                reverse: false,
                showStatus: false,
                max: 100,
                min: 0,
                value: 0,
                percent: 0,
                columns: [],
                dataSource: {
                    aggregate: [
                        {
                            nimLabel: 'value',
                            field: '',
                            aggregate: 'sum'
                        }
                    ],
                    sort: [],
                    serverAggregates: true,
                    schema: {
                        model: {
                            fields: {
                                value: { from: "" }
                            }
                        },
                        aggregates: 'nim_aggregate'
                    },
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                }
            });
        }

        function listview(){
            return new Viz('list', null, null, {
                template: '',
                columns: [],
                dataSource: {
                    aggregate: [],
                    sort: [],
                    schema: {
                        model: {
                            fields: {
                                title: {
                                    from: '',
                                    type: 'string'
                                },
                                description: {
                                    from: '',
                                    type: 'string'
                                },
                                name: {
                                    from: '',
                                    type: 'string'
                                },
                                email: {
                                    from: '',
                                    type: 'string'
                                }
                            }
                        }
                    },
                    filter: {
                        filters: [],
                        logic: 'and'
                    },
                    pageSize: 10
                }
            });
        }

        function kanban(){
            return new Viz('kanban', null, null, {
                template: '<div class="nim-text-overflow-ellipsis">(Label Value Here) <span>(Order Value Here)</span></div>',
                columns: [],
                dataSource: {
                    aggregate: [],
                    sort: [],
                    schema: {
                        model: {
                            fields: {}
                        }
                    },
                    filter: {
                        filters: [],
                        logic: 'and'
                    }
                }
            });
        }
    }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name PagesDesignerListService
 * @alias cerberus/pages-designer:PagesDesignerListService
 * @description Lists of options and features for User Interface
 */
    .factory('PagesDesignerListService', function PagesDesignerListService() {
        var wrapperSettingsPath = 'admin/pages/designer/wrapper-settings/';
        return {
            markerColors: markerColors,
            filters: filters,
            wrapperConfig: wrapperConfig,
            wrapperTypes: wrapperTypes,
            palette: palette,
            listViewTemplatePresets: listViewTemplatePresets,
            kanbanTemplatePresets: kanbanTemplatePresets,
            dataVizThemes: dataVizThemes
        };
        ////////////////////

        /**
         * markerColors
         * @returns {{text: string, color: string}[]}
         */
        function markerColors() {
            return [
                {
                    text: 'Red',
                    color: 'orange-dark'
                },
                {
                    text: 'Orange',
                    color: 'orange'
                },
                {
                    text: 'Yellow',
                    color: 'yellow'
                },
                {
                    text: 'Green',
                    color: 'green-light'
                },
                {
                    text: 'Blue',
                    color: 'cyan'
                },
                {
                    text: 'Purple',
                    color: 'violet'
                },
                {
                    text: 'Black',
                    color: 'black'
                }
            ];
        }

        /**
         * wrapperTypes
         * @returns {{value: string, display: string}[]}
         */
        function wrapperTypes() {
            return [
                {value: 'portlet', display: 'Portlet'},
                {value: 'tile', display: 'Tile'},
                {value: 'circle-tile', display: 'Circle Tile'}
            ];
        }

        /**
         * @function filters
         * @return {object} of filters for UI
         */
        function filters() {
            return {
                date: 'Date',
                dateRange: 'Date Range',
                number: 'Number',
                string: 'Text',
                lookup: 'Look Up'
            };
        }

        /**
         * @function wrappers
         * @return {object} of page wrappers for UI
         */
        function wrapperConfig() {
            return {
                tile: [wrapperSettingsPath + 'padding.tpl.html',wrapperSettingsPath + 'margin.tpl.html',wrapperSettingsPath + 'header.tpl.html',wrapperSettingsPath + 'body.tpl.html',wrapperSettingsPath + 'footer.tpl.html'],
                portlet: [wrapperSettingsPath + 'padding.tpl.html',wrapperSettingsPath + 'margin.tpl.html',wrapperSettingsPath + 'header.tpl.html',wrapperSettingsPath + 'body.tpl.html',wrapperSettingsPath + 'footer.tpl.html'],
                'circle-tile': [wrapperSettingsPath + 'header.tpl.html',wrapperSettingsPath + 'body.tpl.html']
            };
        }

        /**
         * @function palettes
         * @return {Array} of application colors for UI
         */
        function palette() {
            return [
                "#ffffe5","#ffffd9","#f7fcf0","#f7fcfd","#fff7fb","#fff7fb","#f7fcfd","#fff7f3","#f7f4f9","#fff7ec","#ffffcc","#ffffe5","#fcfbfd","#f7fbff","#f7fcf5","#fff5eb","#fff5f0","#ffffff","#b35806","#8c510a","#762a83","#c51b7d","#b2182b","#b2182b","#d73027","#d53e4f","#d73027","#a6cee3","#fbb4ae","#e41a1c","#8dd3c7",
                "#f7fcb9","#edf8b1","#e0f3db","#e5f5f9","#ece2f0","#ece7f2","#e0ecf4","#fde0dd","#e7e1ef","#fee8c8","#ffeda0","#fff7bc","#efedf5","#deebf7","#e5f5e0","#fee6ce","#fee0d2","#f0f0f0","#e08214","#bf812d","#9970ab","#de77ae","#d6604d","#d6604d","#f46d43","#f46d43","#f46d43","#1f78b4","#b3cde3","#377eb8","#ffffb3",
                "#d9f0a3","#c7e9b4","#ccebc5","#ccece6","#d0d1e6","#d0d1e6","#bfd3e6","#fcc5c0","#d4b9da","#fdd49e","#fed976","#fee391","#dadaeb","#c6dbef","#c7e9c0","#fdd0a2","#fcbba1","#d9d9d9","#fdb863","#dfc27d","#c2a5cf","#f1b6da","#f4a582","#f4a582","#fdae61","#fdae61","#fdae61","#b2df8a","#ccebc5","#4daf4a","#bebada",
                "#addd8e","#7fcdbb","#a8ddb5","#99d8c9","#a6bddb","#a6bddb","#9ebcda","#fa9fb5","#c994c7","#fdbb84","#feb24c","#fec44f","#bcbddc","#9ecae1","#a1d99b","#fdae6b","#fc9272","#bdbdbd","#fee0b6","#f6e8c3","#e7d4e8","#fde0ef","#fddbc7","#fddbc7","#fee090","#fee08b","#fee08b","#33a02c","#decbe4","#984ea3","#fb8072",
                "#78c679","#41b6c4","#7bccc4","#66c2a4","#67a9cf","#74a9cf","#8c96c6","#f768a1","#df65b0","#fc8d59","#fd8d3c","#fe9929","#9e9ac8","#6baed6","#74c476","#fd8d3c","#fb6a4a","#969696","#f7f7f7","#f5f5f5","#f7f7f7","#f7f7f7","#f7f7f7","#ffffff","#ffffbf","#ffffbf","#ffffbf","#fb9a99","#fed9a6","#ff7f00","#80b1d3",
                "#41ab5d","#1d91c0","#4eb3d3","#41ae76","#3690c0","#3690c0","#8c6bb1","#dd3497","#e7298a","#ef6548","#fc4e2a","#ec7014","#807dba","#4292c6","#41ab5d","#f16913","#ef3b2c","#737373","#d8daeb","#c7eae5","#d9f0d3","#e6f5d0","#d1e5f0","#e0e0e0","#e0f3f8","#e6f598","#d9ef8b","#e31a1c","#ffffcc","#ffff33","#fdb462",
                "#238443","#225ea8","#2b8cbe","#238b45","#02818a","#0570b0","#88419d","#ae017e","#ce1256","#d7301f","#e31a1c","#cc4c02","#6a51a3","#2171b5","#238b45","#d94801","#cb181d","#525252","#b2abd2","#80cdc1","#a6dba0","#b8e186","#92c5de","#bababa","#abd9e9","#abdda4","#a6d96a","#fdbf6f","#e5d8bd","#a65628","#b3de69",
                "#006837","#253494","#0868ac","#006d2c","#016c59","#045a8d","#810f7c","#7a0177","#980043","#b30000","#bd0026","#993404","#54278f","#08519c","#006d2c","#a63603","#a50f15","#252525","#8073ac","#35978f","#5aae61","#7fbc41","#4393c3","#878787","#74add1","#66c2a5","#66bd63","#ff7f00","#fddaec","#f781bf","#fccde5",
                "#004529","#081d58","#084081","#00441b","#014636","#023858","#4d004b","#49006a","#67001f","#7f0000","#800026","#662506","#3f007d","#08306b","#00441b","#7f2704","#67000d","#000000","#542788","#01665e","#1b7837","#4d9221","#2166ac","#4d4d4d","#4575b4","#3288bd","#1a9850","#cab2d6","#f2f2f2","#999999","#d9d9d9"
            ];
        }

        /**
         * @function listViewTemplatePresets
         * @returns {Object}
         */
        function listViewTemplatePresets(){
            return {
                photos:
                '<div data-uid="#: data.uid #" class="nim-list-photos-item">' +
                    '<img class="nim-list-photos-image" src="#: data.file.loc #" />' +
                    '#: ui.checkbox #' +
                    '<div class="nim-list-photos-caption">' +
                        '<div class="nim-list-caption-text">' +
                            '<label>[CAPTION GOES HERE]</label>' +
                        '</div>' +
                        '<div class="nim-list-photos-info">' +
                            '#: ui.infoButton #' +
                        '</div>' +
                    '</div>' +
                '</div>',

                files:
                '<div data-uid="#: data.uid #" class="nim-list-files-item" #: onClick.selectSingle #>' +
                    '<img class="nim-list-files-image" src="#: data.file.loc #" />' +
                    '<div class="nim-list-files-caption">' +
                        '<div class="nim-list-caption-text">' +
                            '<label title="#: data.file.name #">#: data.file.name #</label>' +
                        '</div>' +
                        '<div class="nim-list-files-info">' +
                            '#: ui.infoButton #' +
                        '</div>' +
                    '</div>' +
                '</div>',

                contacts:
                '<div data-uid="#: data.uid #" class="nim-list-contacts-item" #: onClick.viewAndSelect #>' +
                    '<div class="nim-list-contacts-image">' +
                        '<img src="#: data.file.loc #" />' +
                    '</div>' +
                    '<div class="nim-list-contacts-caption">' +
                        '<label class="control-label">[CAPTION GOES HERE]</label>' +
                        '<div class="nim-list-contacts-info">' +
                            '[CONTACT INFO]' +
                        '</div>' +
                    '</div>' +
                '</div>',

                'card-large':
                '<div data-uid="#: data.uid #" class="nim-list-card-large-item" #: onClick.viewAndSelect #>' +
                    '<img class="nim-list-card-image" src="#: data.file.loc #" />' +
                    '<div class="nim-list-card-caption">' +
                        '<label class="control-label">[CAPTION GOES HERE]</label>' +
                        '<div class="nim-list-card-description">' +
                            '[DESCRIPTION]' +
                        '</div>' +
                    '</div>' +
                '</div>',

                'card-medium':
                '<div data-uid="#: data.uid #" class="nim-list-card-medium-item" #: onClick.viewAndSelect #>' +
                    '<img style="left:0;" class="nim-list-card-image" src="#: data.file.loc #" />' +
                    '<div style="border-left:1px solid rgba(0,0,0,0.26); left:160px; right:0;" class="nim-list-card-caption">' +
                        '<label class="control-label">[CAPTION GOES HERE]</label>' +
                        '<div class="nim-list-card-description">' +
                            '[DESCRIPTION]' +
                        '</div>' +
                    '</div>' +
                '</div>',

                'card-small':
                '<div data-uid="#: data.uid #" class="nim-list-card-small-item" #: onClick.viewAndSelect #>' +
                    '<img class="nim-list-card-image" src="#: data.file.loc #" />' +
                    '<div class="nim-list-card-caption" style="border-top: 1px solid rgba(0,0,0,0.26); top: 80px">' +
                        '<label class="control-label">[CAPTION GOES HERE]</label>' +
                        '<div class="nim-list-card-description">' +
                            '[DESCRIPTION]' +
                        '</div>' +
                    '</div>' +
                '</div>'
            };
        }

        function kanbanTemplatePresets(){
            return {
                default: '<div data-uid="#: data.uid #" class="nim-text-overflow-ellipsis">(Label Value Here) <span>(Order Value Here)</span></div>',
                photos:
                '<div data-uid="#: data.uid #" class="nim-list-photos-item">' +
                '<img class="nim-list-photos-image" src="#: data.file.loc #" />' +
                //'#: ui.checkbox #' +
                '<div class="nim-list-photos-caption">' +
                '<div class="nim-list-caption-text">' +
                '<label class="nim-text-overflow-ellipsis">[CAPTION GOES HERE]</label>' +
                '</div>' +
                '<div class="nim-list-photos-info">' +
                //'#: ui.infoButton #' +
                '</div>' +
                '</div>' +
                '</div>',

                files:
                //'<div data-uid="#: data.uid #" class="nim-list-files-item" #: onClick.selectSingle #>' +
                '<div data-uid="#: data.uid #" class="nim-list-files-item">' +
                '<img class="nim-list-files-image" src="#: data.file.loc #" />' +
                '<div class="nim-list-files-caption">' +
                '<div class="nim-list-caption-text">' +
                '<label title="#: data.file.name #" class="nim-text-overflow-ellipsis">#: data.file.name #</label>' +
                '</div>' +
                '<div class="nim-list-files-info">' +
                //'#: ui.infoButton #' +
                '</div>' +
                '</div>' +
                '</div>',

                contacts:
                //'<div data-uid="#: data.uid #" class="nim-list-contacts-item" #: onClick.viewAndSelect #>' +
                '<div data-uid="#: data.uid #" class="nim-list-contacts-item">' +
                '<div class="nim-list-contacts-image">' +
                '<img src="#: data.file.loc #" />' +
                '</div>' +
                '<div class="nim-list-contacts-caption">' +
                '<label class="control-label nim-text-overflow-ellipsis">[CAPTION GOES HERE]</label>' +
                '<div class="nim-list-contacts-info nim-text-overflow-ellipsis">' +
                '[CONTACT INFO]' +
                '</div>' +
                '</div>' +
                '</div>',

                'card-large':
                //'<div data-uid="#: data.uid #" class="nim-list-card-large-item" #: onClick.viewAndSelect #>' +
                '<div data-uid="#: data.uid #" class="nim-list-card-large-item nim-text-overflow-ellipsis">' +
                '<img class="nim-list-card-image" src="#: data.file.loc #" />' +
                '<div class="nim-list-card-caption">' +
                '<label class="control-label nim-text-overflow-ellipsis">[CAPTION GOES HERE]</label>' +
                '<div class="nim-list-card-description nim-text-overflow-ellipsis">' +
                '[DESCRIPTION]' +
                '</div>' +
                '</div>' +
                '</div>',

                'card-medium':
                //'<div data-uid="#: data.uid #" class="nim-list-card-medium-item" #: onClick.viewAndSelect #>' +
                '<div data-uid="#: data.uid #" class="nim-list-card-medium-item">' +
                '<img style="left:0;" class="nim-list-card-image" src="#: data.file.loc #" />' +
                '<div style="border-left:1px solid rgba(0,0,0,0.26); left:160px; right:0;" class="nim-list-card-caption">' +
                '<label class="control-label nim-text-overflow-ellipsis">[CAPTION GOES HERE]</label>' +
                '<div class="nim-list-card-description nim-text-overflow-ellipsis">' +
                '[DESCRIPTION]' +
                '</div>' +
                '</div>' +
                '</div>',

                'card-small':
                //'<div data-uid="#: data.uid #" class="nim-list-card-small-item" #: onClick.viewAndSelect #>' +
                '<div data-uid="#: data.uid #" class="nim-list-card-small-item">' +
                '<img class="nim-list-card-image" src="#: data.file.loc #" />' +
                '<div class="nim-list-card-caption" style="border-top: 1px solid rgba(0,0,0,0.26); top: 80px">' +
                '<label class="control-label nim-text-overflow-ellipsis">[CAPTION GOES HERE]</label>' +
                '<div class="nim-list-card-description nim-text-overflow-ellipsis">' +
                '[DESCRIPTION]' +
                '</div>' +
                '</div>' +
                '</div>'
            };
        }

        function dataVizThemes(){
            return [
                { display: 'Black', value: 'black' },
                { display: 'Blue Opal', value: 'blueopal' },
                { display: 'Bootstrap', value: 'bootstrap' },
                { display: 'Flat', value: 'flat' },
                { display: 'High Contrast', value: 'highcontrast' },
                { display: 'ERP Majestic', value: 'erp_majestic_theme' },
                { display: 'Kendo', value: 'default' },
                { display: 'Material', value: 'material' },
                { display: 'Material Black', value: 'materialblack' },
                { display: 'Metro', value: 'metro' },
                { display: 'Metro Black', value: 'metroblack' },
                { display: 'Moonlight', value: 'moonlight' },
                { display: 'Silver', value: 'silver' },
                { display: 'Uniform', value: 'uniform' },
                { display: 'Fiori', value: 'fiori' },
                { display: 'Nova', value: 'nova' }
            ];
        }
    })
;

angular.module('cerberus.admin')
    /**
     * @ngdoc service
     * @name PageDesignerService
     * @alias cerberus/pages-designer:PageDesignerService
     * @description REST service for "pages" resource
     */
    .factory('PageDesignerService', ["$http", "$q", "apiPath", "toaster", function PageDesignerService($http, $q, apiPath, toaster) {
            return {
                update: update,
                create: create,
                updatePagePermissions: updatePagePermissions,
                deletePage: deletePage,
                createObjects: createObjects,
                updateObjects: updateObjects,
                removeObjects: removeObjects
            };
            ///////////////////
            /**
             * Saves page edits to server
             * @function update
             * @param {string} id
             * @param {string} name
             * @param {string} description
             * @param {string} icon
             * @param {object} options
             * @return {promise}
             */
            function update(id, options, name, description, icon) {
                var deferred = $q.defer();
                $http.put(apiPath + 'pages/'+ id, {
                        options: options,
                        name: name,
                        description: description,
                        icon: icon
                    })
                    .success(function(value){
                        deferred.resolve(value.DATA);
                    })
                    .error(function(reason){
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             * Creates a new page
             * @function create
             * @param {object} data - page
             * @return {promise}
             */
            function create(data) {
                var deferred = $q.defer();
                $http.post(apiPath + 'pages', data)
                    .success(function(value){
                        deferred.resolve(value.DATA);
                    })
                    .error(function(reason){
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             * Updates a page's permissions
             * @function updatePagePermissions
             * @param {string} id - empty page
             * @param {object} data - permissions object
             * @return {promise}
             */
            function updatePagePermissions(id, data) {
                var deferred = $q.defer();
                $http.put(apiPath + 'pages/' + id + '/permissions', data)
                    .success(function(value){
                        deferred.resolve(value.DATA);
                    })
                    .error(function(reason){
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             * Deletes a page from the server
             * @function deletePage
             * @param {string} id
             * @return {promise}
             */
            function deletePage(id) {
                var deferred = $q.defer();
                $http({method: 'DELETE', url: apiPath + 'pages/' + id})
                    .success(function(value){
                        deferred.resolve(value);
                    })
                    .error(function(reason){
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             * Adds page objects
             * @function createObjects
             * @param {string} id
             * @param {array} data
             * @returns {promise}
             */
            function createObjects(id, data){
                var deferred = $q.defer();
                $http.post(apiPath + 'pages/' + id + '/objects', {pageObjects: data})
                    .success(function(value){
                        deferred.resolve(value);
                    })
                    .error(function(reason){
                        toaster.pop('warning', 'Warning', 'New Page Objects not created');
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             * Updates page objects
             * @function updateObjects
             * @param {string} id
             * @param {array} data
             * @returns {promise}
             */
            function updateObjects(id, data){
                var deferred = $q.defer();
                $http.put(apiPath + 'pages/' + id + '/objects', {pageObjects: data})
                    .success(function(value){
                        deferred.resolve(value);
                    })
                    .error(function(reason){
                        toaster.pop('warning', 'Warning', 'Page Objects not updated');
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }

            /**
             * Removes page objects
             * @function removeObjects
             * @param {string} id
             * @param {array} data
             * @returns {promise}
             */
            function removeObjects(id, data){
                var deferred = $q.defer();
                $http.put(apiPath + 'pages/' + id + '/objects/remove', {pageObjectIds: data})
                    .success(function(value){
                        deferred.resolve(value);
                    })
                    .error(function(reason){
                        toaster.pop('warning', 'Warning', 'Page Objects not removed');
                        deferred.reject(reason);
                    });
                return deferred.promise;
            }
        }])
;

angular.module('cerberus.admin')
    .controller('PageFilterConfigCtrl', ["$scope", "$uibModalInstance", "filter", "idArray", "PagesDesignerListService", "ViewsService", "DesignerUtilityService", function PageFilterConfigCtrl($scope, $uibModalInstance, filter, idArray, PagesDesignerListService, ViewsService, DesignerUtilityService) {
            $scope.temp = angular.copy(filter);
            $scope.orig = angular.copy(filter);
            $scope.types = PagesDesignerListService.filters();
            $scope.editFlag = filter.id ? true: false;
            $scope.views = null;

            $scope.preventSpace = DesignerUtilityService.preventSpace;
            $scope.labelToUniqueId = function (item){
                item.id = DesignerUtilityService.labelToUniqueId(item.label, idArray);
            };

            $scope.typeChange = function (item) {
                if (item.type === 'string' || item.type === 'number') {
                    item.icon = 'filter';
                }
                if (item.type === 'date' || item.type === 'dateRange') {
                    item.icon = 'calendar';
                }
                if (item.type === 'lookup') {
                    $scope.getViews();
                }
            };

            $scope.getViews = function () {
                // Only make server call if we have too
                if ($scope.views === null) {
                    ViewsService.get(true).then(function(data){
                        $scope.views = data;
                    });
                }
            };

            $scope.viewChange = function (item){
                if(item.params && item.params.viewId){
                    ViewsService.getColumns(item.params.viewId).then(function(data){
                        if(data.length === 0){
                            $scope.errStr = '<div class="alert alert-warning" role="alert"><strong>Warning!</strong> There are no columns in this view.</div>';
                        }
                        else{
                            $scope.errStr = null;
                        }
                        $scope.viewColumns = data;
                    });
                }
                else {
                    $scope.viewColumns = [];
                    $scope.errStr = null;
                }
            };

            $scope.isUnchanged = function () {
                return angular.equals($scope.temp, $scope.orig);
            };

            $scope.save = function (item) {
                $uibModalInstance.close(item);
            };

            $scope.cancel = function(){
                $uibModalInstance.dismiss();
            };

            // Init
            if (filter.type === 'lookup') {
                $scope.getViews();
            }
            if (filter.params && filter.params.viewId) {
                $scope.viewChange(filter);
            }
        }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name pageObjectConfigService
 */
    .factory('pageObjectConfigService', ["_", "$compile", "$sanitize", "$timeout", "$http", "toaster", "DesignerUtilityService", "ViewsService", "WidgetsSettingsService", function pageObjectConfigService(_, $compile, $sanitize, $timeout, $http, toaster, DesignerUtilityService, ViewsService, WidgetsSettingsService) {
        return {
            deleteProperty: deleteProperty,
            textEditorOptions: textEditorOptions,
            filterOperators: filterOperators,
            chartLabelFormats: chartLabelFormats,
            createSortableOptions: createSortableOptions,
            reorderItem: reorderItem,
            notPropertyColumnFilter: notPropertyColumnFilter,
            addColorToSeries: addColorToSeries,
            onViewChange: onViewChange,
            loadColumns: loadColumns,
            selectColumn: selectColumn,
            addColumn: addColumn,
            removeColumn: removeColumn,
            selectAllColumns: selectAllColumns,
            removeAllColumns: removeAllColumns,
            colIsSelected: colIsSelected,
            allColSelected: allColSelected,
            setBaseWidget: setBaseWidget,
            loadFormFields: loadFormFields,
            getFilterType: getFilterType,
            addDSFilter: addDSFilter,
            addToFilterMap: addToFilterMap,
            removeFromFilterMap: removeFromFilterMap,
            savePageObjConfig: savePageObjConfig,
            fillCSSArray: fillCSSArray,
            updateSortConfig: updateSortConfig,
            addSortItem: addSortItem,
            loadCategories: loadCategories
        };

        ////////////////////////////////////////////////////////////////////////////

        /**
         * Deletes a property from an object; useful when removing a configuration
         * @param {object} obj
         * @param {string} prop
         */
        function deleteProperty(obj, prop) {
            if(_.has(obj, prop)) {
                delete obj[prop];
            }
        }
        function textEditorOptions(scope) {
            return {
                encoded: false,
                tools: [
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "justifyLeft",
                    "justifyCenter",
                    "justifyRight",
                    "justifyFull",
                    "insertUnorderedList",
                    "insertOrderedList",
                    "indent",
                    "outdent",
                    "createLink",
                    "unlink",
                    "insertImage",
                    "subscript",
                    "superscript",
                    "createTable",
                    "addRowAbove",
                    "addRowBelow",
                    "addColumnLeft",
                    "addColumnRight",
                    "deleteRow",
                    "deleteColumn",
                    //"viewHtml",
                    {
                        name: 'nimViewHtml',
                        template: '<a href="" role="button" class="k-tool k-group-start k-group-end" unselectable="on" title="View HTML"><i class="fa fa-code"></i></a>',
                        exec: function(e){
                            e.preventDefault();
                            var editor = $(e.currentTarget).closest('.k-editor');
                            var textarea = editor.find('textarea');
                            var id = textarea.attr('id');
                            var model = textarea.attr('ng-model');
                            var newId = 'nim_' + id + '_html';
                            var htmlInput = $('#' + newId);
                            if(id && scope){
                                if(htmlInput.length === 0){
                                    var html = '<textarea id="' + newId + '" class="form-control" rows="10" ng-model="' + model + '" ng-model-options="{debounce: {default: 500}}"></textarea>';
                                    editor.after($compile(html)(scope));
                                }
                                else{
                                    htmlInput.remove();
                                }
                            }
                        }
                    },
                    "formatting",
                    "cleanFormatting",
                    "fontName",
                    "fontSize",
                    "foreColor",
                    "backColor"
                ],
                paste: function (e) {
                    e.html = $sanitize(e.html);
                }
            };
        }

        /**
         * Lists possible operators by input type for filter settings
         * @returns {Object}
         */
        function filterOperators() {
            return {
                string: [
                    {value: 'contains', display: 'Contains'},
                    {value: 'doesnotcontain', display: 'Does not contain'},
                    {value: 'eq', display: 'Equal to'},
                    {value: 'neq', display: 'Not equal to'},
                    {value: 'startswith', display: 'Starts with'},
                    {value: 'endswith', display: 'Ends with'}
                ],
                number: [
                    {value: 'eq', display: 'Equal to'},
                    {value: 'gt', display: 'Greater'},
                    {value: 'gte', display: 'Greater or equal to'},
                    {value: 'lt', display: 'Less'},
                    {value: 'lte', display: 'Less or equal to'},
                    {value: 'neq', display: 'Not equal to'}
                ],
                date: [
                    {value: 'eq', display: 'Equal to'},
                    {value: 'gt', display: 'Greater'},
                    {value: 'gte', display: 'Greater or equal to'},
                    {value: 'lt', display: 'Less'},
                    {value: 'lte', display: 'Less or equal to'},
                    {value: 'neq', display: 'Not equal to'}
                ],
                bigint: [
                    {value: 'eq', display: 'Equal to'},
                    {value: 'gt', display: 'Greater'},
                    {value: 'gte', display: 'Greater or equal to'},
                    {value: 'lt', display: 'Less'},
                    {value: 'lte', display: 'Less or equal to'},
                    {value: 'neq', display: 'Not equal to'}
                ]
            };
        }

        /**
         * Returns array of possible formats for viz chart labels
         * @returns {Array}
         */
        function chartLabelFormats(){
            return [
                { value: '{0}',     display: 'Default' },
                { value: '{0:n0}',  display: 'Integer' },
                { value: '{0:n2}',  display: 'Decimal' },
                { value: '{0:c}',   display: 'Currency' },
                { value: '{0:c0}',  display: 'Currency, no decimal' },
                { value: '{0:p}',   display: 'Percent' },
                { value: '{0:p0}',  display: 'Percent, no decimal' }
            ];
        }

        /**
         * Creates options for kendo sortable widget
         * @param columnArray - Column array (or map of arrays) to reorder
         * @param controller - for multi-data-source objects only
         * @returns {Object} - Kendo sortable options
         */
        function createSortableOptions(columnArray, controller){
            return {
                ignore: "input,select",
                change: function (e) {
                    $timeout(function () {
                        if(_.isArray(columnArray)){
                            reorderItem(columnArray, e.oldIndex, e.newIndex);
                        }
                        else if(controller){
                            // key of column array to reorder
                            var id = controller.editDataSource;

                            reorderItem(columnArray[id], e.oldIndex, e.newIndex);
                        }
                    },0);
                }
            };
        }

        /**
         * Helper function that moves array item to new index
         * @param array
         * @param oldIndex
         * @param newIndex
         */
        function reorderItem(array, oldIndex, newIndex){
            var item = array.splice(oldIndex, 1)[0];
            array.splice(newIndex, 0, item);
        }

        /**
         * Filter for ngRepeat that skips columns of type "property"
         * @param column - from viewColumns
         * @returns {boolean}
         */
        function notPropertyColumnFilter(column){
            return column.type !== 'property';
        }

        /**
         * Adds a color to a chart page object's series colors array
         * @param pageObj
         * @param color
         */
        function addColorToSeries(pageObj, color){
            _.defaults(pageObj.viz.settings, {seriesColors: []});

            if(pageObj.viz.settings.seriesColors.indexOf(color) < 0) {
                pageObj.viz.settings.seriesColors.push(color);
            }
        }

        /**
         * Loads view columns and sets dataSource view ID
         * @param controller
         * @param onRemove
         * @param dataSource
         * @param vizColumns
         * @param viewId
         */
        function onViewChange(controller, onRemove, dataSource, vizColumns, viewId){
            loadColumns(controller, viewId);                            // loads view columns
            dataSource.nim_viewId = viewId;                             // Source query
            removeAllColumns(dataSource, vizColumns, onRemove);
        }

        /**
         * Loads view columns and adds them to controller
         * @param controller
         * @param viewId
         */
        function loadColumns(controller, viewId){
            if(viewId){
                ViewsService.getColumns(viewId).then(function(columns){
                    controller.viewColumns = columns;
                });
            }
        }

        /**
         * Adds column to viz columns array and data source schema
         * @param dataSource - viz.settings.dataSource (or viz.settings.dataSource[id])
         * @param vizColumns - viz.settings.columns (or viz.settings.columns[id])
         * @param column - from viewColumns array
         */
        function addColumn(dataSource, vizColumns, column){
            var field = column.colName;
            var type = column.castType;

            var settingsColumn = {
                field: field,
                title: column.name,
                type: type,
                attributes: {},
                format: column.format || '',
                aggregates: [],
                footerTemplate: ''
            };

            if(column.type === 'property'){
                settingsColumn.nim_propertyId = column.propId;
            }

            // For displaying locations on tables
            if(column.type === 'location'){
                settingsColumn.nim_locationProperty = 'formatted_address';
            }

            vizColumns.push(settingsColumn);

            dataSource.schema.model.fields[field] = {
                type: type,
                from: field
            };
        }

        /**
         * Removes column from viz columns array and data source schema
         * @param dataSource - viz.settings.dataSource (or viz.settings.dataSource[id])
         * @param vizColumns - viz.settings.columns (or viz.settings.columns[id])
         * @param colIndex
         * @param colField
         */
        function removeColumn(dataSource, vizColumns, colIndex, colField){
            if(colIndex >= 0){
                vizColumns.splice(colIndex, 1);
                delete dataSource.schema.model.fields[colField];
            }
        }

        /**
         * Creates function to handle toggling of columns in page object.
         * Uses controller-specific functions to handle additional
         * functionality on addition/removal of columns.
         * @param onAdd - callback for addition of column
         * @param onRemove - callback for removal of column
         * @returns {Function}
         */
        function selectColumn(onAdd, onRemove){
            /**
             * Adds a view column to viz columns or removes it if already present
             * @param dataSource - viz.settings.dataSource (or viz.settings.dataSource[id])
             * @param vizColumns - viz.settings.columns (or viz.settings.columns[id])
             * @param column - from viewColumns array
             */
            return function (dataSource, vizColumns, column){
                var field = column.colName;
                /* LODASH Version 4 ONLY */
                //var index = _.findIndex(vizColumns, ['field', field]);
                /* LODASH Version 3 & 4 Compatibility Mode */
                var index = _.findIndex(vizColumns, function(f){return f.field === field;});

                if(index >= 0) {
                    // If column is already selected, remove it
                    removeColumn(dataSource, vizColumns, index, field);

                    // Controller-specific handler
                    if(_.isFunction(onRemove)){
                        onRemove(field);
                    }
                }
                else {
                    // Else, add it to viz columns and dataSource
                    addColumn(dataSource, vizColumns, column);

                    // Controller-specific handler
                    if(_.isFunction(onAdd)){
                        onAdd(field);
                    }
                }
            };
        }

        /**
         * Creates function to handle toggling of all columns in page object.
         * Uses controller-specific functions to handle additional
         * functionality on addition/removal of individual columns.
         * @param onAdd - callback for addition of column
         * @param onRemove - callback for removal of column
         * @returns {Function}
         */
        function selectAllColumns(onAdd, onRemove){
            /**
             * Selects (or deselects) all view columns
             * @param dataSource - viz.settings.dataSource (or viz.settings.dataSource[id])
             * @param vizColumns - viz.settings.columns (or viz.settings.columns[id])
             * @param viewColumns
             */
            return function (dataSource, vizColumns, viewColumns){
                if(allColSelected(vizColumns, viewColumns)) {
                    // If all columns selected, deselect them
                    removeAllColumns(dataSource, vizColumns, onRemove);
                }
                else{
                    // Otherwise, add columns not already selected
                    for(var j = 0; j < viewColumns.length; j++){
                        var column = viewColumns[j];
                        if(!colIsSelected(vizColumns, column)){
                            addColumn(dataSource, vizColumns, column);

                            // Controller-specific handler
                            if(_.isFunction(onAdd)){
                                onAdd(column.colName);
                            }
                        }
                    }
                }
            };
        }

        /**
         * Function that handles removal of all selected columns.
         * @param dataSource - viz.settings.dataSource (or viz.settings.dataSource[id])
         * @param vizColumns - viz.settings.columns (or viz.settings.columns[id])
         * @param onRemove - callback for removal of column
         */
        function removeAllColumns(dataSource, vizColumns, onRemove){
            for(var i = vizColumns.length - 1; i >= 0; i--) {
                var colField = vizColumns[i].field;

                removeColumn(dataSource, vizColumns, i, colField);

                // Controller-specific handler
                if(_.isFunction(onRemove)){
                    onRemove(colField);
                }
            }
        }

        /**
         * Checks if a view column has been added to a page object's columns
         * @param vizColumns - viz.settings.columns (or viz.settings.columns[id])
         * @param column - from viewColumns array
         * @returns {boolean}
         */
        function colIsSelected(vizColumns, column){
            /* LODASH Version 4 ONLY */
            //return _.some(vizColumns, ['field', column.colName]);
            /* LODASH Version 3 & 4 Compatibility Mode */
            return _.some(vizColumns, function(f){return f.field === column.colName;});
        }

        /**
         * Checks if all viewColumns have been selected
         * @param vizColumns - viz.settings.columns (or viz.settings.columns[id])
         * @param viewColumns
         * @returns {boolean}
         */
        function allColSelected(vizColumns, viewColumns){
            if(!_.isEmpty(viewColumns)) {
                return _.every(viewColumns, function(viewCol){
                    return colIsSelected(vizColumns, viewCol);
                });
            }
            else {
                return false;
            }
        }

        /**
         * Sets the page object's base widget and loads form fields
         * @param controller
         * @param pageObj
         * @param viewId - Data source's nim_viewId
         * @param skipLoad - (Optional) If true, do not load form fields
         */
        function setBaseWidget(controller, pageObj, viewId, skipLoad){
            /* LODASH Version 4 ONLY */
            //var selectedView = _.find(controller.views, ['id', viewId]);
            /* LODASH Version 3 & 4 Compatibility Mode */
            var selectedView = _.find(controller.views, function(f){return f.id === viewId;});
            pageObj.viz.widgetId = _.get(selectedView, 'base_widget_id');

            if(!skipLoad){
                loadFormFields(controller, pageObj.viz.widgetId);
            }
        }

        /**
         * Loads form objects for selected widget and adds them to controller
         * @param controller
         * @param widgetId
         */
        function loadFormFields(controller, widgetId){
            if(widgetId) {
                WidgetsSettingsService.getFormFields(widgetId).then(function (data) {
                    controller.formFieldsArray = WidgetsSettingsService.parseFormObjects(data.display);
                });
            }
        }

        /**
         * Checks viewColumns to get filter field's castType
         * @param viewColumns
         * @param filter - temporary filter object
         * @param oldFilterType
         * @returns {string} - "string", "number", "date"
         */
        function getFilterType(viewColumns, filter, oldFilterType){
            var filterType = '';

            if(filter){
                if(filter.field){
                    /* LODASH Version 4 ONLY */
                    //var index = _.findIndex(viewColumns, ['colName', filter.field]);
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    var index = _.findIndex(viewColumns, function(f){return f.colName === filter.field;});
                    if(index >= 0){
                        filterType = viewColumns[index].castType;

                        // Don't allow filter to keep value of different type
                        if(filterType !== oldFilterType){
                            filter.value = null;
                        }
                    }
                    else {
                        // Remove value if field is invalid
                        filter.value = null;
                    }
                }
                else{
                    _.assign(filter, {
                        operator: null,
                        value: null
                    });
                }
            }

            return filterType;
        }

        /**
         * Adds filter to dataSource and clears temporary filter object
         * @param dataSource - viz.settings.dataSource (or viz.settings.dataSource[id])
         * @param filter - temporary filter object
         * @param filterType
         */
        function addDSFilter(dataSource, filter, filterType){
            if(filterType === 'date' && !filter.value){
                filter.value = null;
            }

            _.defaults(dataSource, { filter: { filters: [], logic: 'and' } });

            dataSource.filter.filters.push(angular.copy(filter));

            // Empties temporary filter
            _.assign(filter, {
                field: null,
                operator: null,
                value: null,
                isDateValue: false,
                isColumnValue: false
            });
        }

        /**
         * Adds filter configuration to page object's filterMap
         * @param pageObj
         * @param filter - temporary filter object
         * @param id - dataSource id
         */
        function addToFilterMap(pageObj, filter, id) {
            if (filter.key) {
                var filterMap = pageObj.filterMap,
                    requiredFilters = pageObj.params.requiredFilters;
                    
                if (id) {
                    filterMap = filterMap[id];
                    requiredFilters = requiredFilters[id];
                }

                filterMap[filter.key] = filter.value;

                // For fields with recurrence enabled (table and calendar only)
                if(filter.repeat){
                    pageObj.params.repeatEnabled = filter.key;
                    filter.repeat = false;
                }

                // For tables, this marks filters that are required to show data
                if (filter.required) {
                    requiredFilters[filter.key] = true;
                    filter.required = false;
                }

                // Resets temporary filter
                filter.key = null;
                filter.value = null;
            }
        }

        /**
         * Removes filter from map and resets parameters that rely on it
         * @param pageObj
         * @param key - filter key
         * @param id - dataSource ID
         */
        function removeFromFilterMap(pageObj, key, id) {
            var filterMap = pageObj.filterMap,
                requiredFilters = pageObj.params.requiredFilters;
                
            if (id) {
                filterMap = filterMap[id];
                requiredFilters = requiredFilters[id];
            }

            delete filterMap[key];

            // Resets/Removes parameters that rely on this filter
            if(pageObj.params.repeatEnabled === key){
                delete pageObj.params.repeatEnabled;
            }

            if(!_.isEmpty(requiredFilters)){
                delete requiredFilters[key];
            }
        }

        /**
         * Creates handler for save button
         * @param modal - config modal instance
         * @param margin - margin configuration array
         * @param padding - padding configuration array
         * @returns {Function} - ngClick handler
         */
        function savePageObjConfig(modal, margin, padding) {
            /**
             * If the form is not invalid, saves the page object configuration
             * @param pageObj - page object configuration
             * @param invalid - true if modal form is invalid
             */
            return function(pageObj, invalid) {
                if(invalid){
                    toaster.pop('error', 'Form invalid', '');
                }
                else {
                    if (pageObj.wrapper.type === 'circletile') {
                        pageObj.wrapper.header.style.background = pageObj.wrapper.body.style.background;
                    }

                    // Converts the margin/padding arrays to CSS strings
                    pageObj.wrapper.style.margin = DesignerUtilityService.arrayToCss(margin);
                    pageObj.wrapper.style.padding = DesignerUtilityService.arrayToCss(padding);

                    modal.close(pageObj);
                }
            };
        }

        /**
         * Creates change handler for padding and margin numeric text-boxes
         * @param cssArray - array to be filled
         * @returns {Function}
         */
        function fillCSSArray(cssArray){
            // Kendo change handler
            return function(e){
                var value = _.result(e, 'sender.value', 0);
                _.fill(cssArray, parseInt(value));
            };
        }

        /**
         * Updates dataSource's sort configuration to be an array instead of an object
         * @param dataSource
         */
        function updateSortConfig(dataSource){
            if(!_.isArray(dataSource.sort)) {
                if (!dataSource.sort || !dataSource.sort.field) {
                    dataSource.sort = [];
                }
                else {
                    dataSource.sort = [dataSource.sort];
                }
            }
        }

        /**
         * Adds sort configuration object to array
         * @param sortArray
         * @param sortObj
         */
        function addSortItem(sortArray, sortObj){
            sortArray.push({
                field: sortObj.field,
                dir: sortObj.dir || 'desc'
            });

            // Reset temporary object
            _.assign(sortObj, {
                field: '',
                dir: 'desc'
            });
        }

        function loadCategories(vm, categoryField){
            if(categoryField.isLookup){
                $http.get('/server/rest/v1/views/' + categoryField.viewId + '/odata.svc?$lookupDisplay=' + categoryField.lookupCol)
                    .then(function(result){
                        var d = _.get(result, 'data.d');
                        if(d.__count === 1){
                            vm.categories = [d];
                        }
                        else {
                            vm.categories = d.results;
                        }
                    });
            }
            else if(categoryField.isCustomLookup){
                $http.get('/server/rest/v1/forms/' + categoryField.formId + '/objects/' + categoryField.modelId + '/options')
                    .then(function(result){
                        vm.categories = _.get(result, 'data.DATA.values', []);
                    });
            }
            else {
                vm.categories = [];
            }
        }
    }])
;

angular.module('cerberus.admin')
    .controller('ViewsDesignerAddWidgetModalCtrl', ["$scope", "$uibModalInstance", "WidgetsService", function ViewsDesignerAddWidgetModalCtrl($scope, $uibModalInstance, WidgetsService) {
        var vm = this;

        vm.widgetsArray = [];
        vm.data = null;

        // Modal Actions
        vm.ok = function (){
            $uibModalInstance.close(vm.data);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        _init();

        function _init(){
            WidgetsService.getWidgets().then(function(widgetsArray) {
                vm.widgetsArray = widgetsArray;
            });
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('ViewsDesignerAdvCtrl', ["$scope", "CodeMirror", "$timeout", "DesignerUtilityService", "ViewsDesignerService", "ViewsPropertiesService", "WidgetsService", function ViewsDesignerAdvCtrl($scope, CodeMirror, $timeout, DesignerUtilityService, ViewsDesignerService, ViewsPropertiesService, WidgetsService) {
        var vm = this;
        $scope.viewDesignerAdvCtrl.vm = vm;
        vm.advModel = {};
        vm.advModelOrig = {};
        vm.sql = '';
        vm.sqlOrig = '';
        vm.widgets = [];
        vm.widgetIds = [];
        vm.tempViewProp = [];
        vm.origViewProp = [];
        vm.editPropIndex = null;
        vm.editProp = null;
        vm.agg = {};
        vm.preventSpace = DesignerUtilityService.preventSpace;
        // Codemirror
        vm.codemirrorLoaded = function(_editor){
            var timeout;
            // Editor part
            var _doc = _editor.getDoc();

            // Options
            _editor.setOption('theme', 'nimcalc');
            _editor.setOption('lineWrappißng', true);
            _editor.setOption('matchBrackets', true);
            _editor.setOption('autoCloseBrackets', "()[]\"\"");
            _editor.setOption('indentWithTabs', true);
            _editor.setOption('autofocus', true);
            _editor.setOption('lineNumbers', true);
            _editor.setOption('mode', 'text/x-pgsql');
            _editor.setSize('100%', 500);
            _doc.markClean();
            _editor.on("inputRead", function(cm) {
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = $timeout(function() {
                    if (cm.getTokenAt(cm.getCursor()).string != ' ') {
                        CodeMirror.showHint(cm, CodeMirror.hint.sql, {
                            completeSingle: false
                            // TODO: Pass in two options
                            // tables: an object with table names as keys and array of respective column names as values.
                            // defaultTable: a string corresponding to a table name in tables for autocompletion.
                        });
                    }
                }, 150);
            });
        };
        vm.addProperty = function(data,type){
            var modeledData = ViewsPropertiesService.modelData(data,true,type);
            if(modeledData.isValid){
                ViewsPropertiesService.add($scope.viewId,modeledData.d).then(function(){
                    vm.tempViewProp.push(modeledData.d);
                    data.name = null;
                    data.description = null;
                    data.adv = null;
                    data.where = null;
                });
            }
        };
        vm.delProperty = function(property){
            var id = property.id;
            ViewsPropertiesService.remove(id).then(function(){
                var index = vm.tempViewProp.indexOf(property);
                vm.tempViewProp.splice(index,1);
            });
        };
        vm.editProperty = function(index, property){
            vm.editPropIndex = index;
            vm.editProp = angular.copy(property);
        };

        vm.cancelProperty = function(){
            vm.editProp = null;
            vm.editPropIndex = null;
        };
        vm.updateProperty = function(prop, data){
            if(data.name && data.property.adv){
                ViewsPropertiesService.update(prop.id, data).then(function(){
                    angular.extend(prop, data);
                    vm.cancelProperty();
                });
            }
        };
        vm.bindWidgetDependencies = function(e){
            e.sender.value(vm.advModel.widgetDependencies);
        };
        //Init function
        _init();
        ////////////////////
        /**
         * Init controller data and server calls
         */
        function _init() {
            WidgetsService.getWidgets().then(function (d) {
                vm.widgets = d;
                vm.widgetIds = d.map(function(e){return {name: e.name, id: parseId(e.id)};});
            });
            ViewsDesignerService.getModel($scope.viewId).then(function(d){
                vm.advModel = d;
                vm.advModelOrig = angular.copy(vm.advModel);
            });
            ViewsPropertiesService.get($scope.viewId).then(function(d){
                vm.tempViewProp = d;
                vm.origViewProp = angular.copy(vm.tempViewProp);
            });
        }

        function parseId(fullId){
            var components = fullId.split('-');
            var id = components[components.length - 1];
            return parseInt(id);
        }
    }])
;
angular.module('cerberus.admin')
    .controller('ViewsDesignerCtrl', ["_", "kendo", "$scope", "$location", "$uibModal", "$rootScope", "viewId", "ConfirmModalService", "DesignerUtilityService", "ViewsService", "ViewsDesignerService", "WidgetsSettingsService", function ViewsDesignerCtrl(_, kendo, $scope, $location, $uibModal, $rootScope, viewId, ConfirmModalService, DesignerUtilityService, ViewsService, ViewsDesignerService, WidgetsSettingsService) {
        var vm = this;

        $scope.viewDesignerNormalCtrl = {};
        $scope.viewDesignerAdvCtrl = {};
        $scope.viewId = viewId;
        vm.mode = '';
        vm.resultsCollapse = true;
        vm.settingsCollapse = true;
        vm.updateError = null;
        vm.viewData = {};
        vm.viewDataOrig = {};

        vm.hasChanges = function () {
            var adv = false;
            var norm = false;
            if($scope.viewDesignerAdvCtrl.vm){
                adv = !angular.equals($scope.viewDesignerAdvCtrl.vm.advModel, $scope.viewDesignerAdvCtrl.vm.advModelOrig);
            }
            if($scope.viewDesignerNormalCtrl.vm){
                norm = !angular.equals($scope.viewDesignerNormalCtrl.vm.viewModel, $scope.viewDesignerNormalCtrl.vm.viewModelOrig);
            }
            return norm || !angular.equals(vm.viewData, vm.viewDataOrig) || adv;
        };
        DesignerUtilityService.cancelRouteNav($scope, vm.hasChanges);

        //Results grid functions
        vm.viewResults = function(){
            vm.resultsCollapse = !vm.resultsCollapse;
            if(!vm.resultsCollapse){
                //var columns = [];
                var fields = {};
                if(vm.mode === 'normal'){
                    for(var i = 0; i < $scope.viewDesignerNormalCtrl.vm.viewModel.model.selectArray.length; i++){
                        var fieldName = $scope.viewDesignerNormalCtrl.vm.viewModel.model.selectArray[i].uniqueName + '_' + $scope.viewDesignerNormalCtrl.vm.viewModel.model.selectArray[i].modelId;
                        if($scope.viewDesignerNormalCtrl.vm.viewModel.model.selectArray[i].isLookUp){
                            fieldName = fieldName + '_display';
                        }
                        //columns.push({
                        //    field: fieldName,
                        //    width: 200,
                        //    type: $scope.viewDesignerNormalCtrl.vm.viewModel.model.selectArray[i].type
                        //});
                        fields[fieldName] = {
                            type: $scope.viewDesignerNormalCtrl.vm.viewModel.model.selectArray[i].type
                        };
                    }
                }
                //Kendo Grid
                var dataSource = new kendo.data.DataSource({
                    type: 'odata',
                    transport:{
                        read: {
                            url: '/server/rest/v1/views/' + viewId + '/odata.svc',
                            beforeSend: function(xhr){
                                xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                                xhr.setRequestHeader('WSID',$rootScope.userData.currentWorkspace.id);
                            },
                            dataType: 'json'
                        }
                    },
                    serverFiltering: true,
                    serverPaging: true,
                    serverSorting: true,
                    pageSize: 20,
                    schema: {
                        model: {
                            fields: fields
                        }
                    }
                });
                vm.options = {
                    excel: {
                        fileName: "view" + viewId + ".xlsx",
                        filterable: true
                    },
                    columnMenu: true,
                    //columns:  columns,
                    dataSource: dataSource,
                    filterable: true,
                    mobile: false,
                    pageable: true,
                    reorderable: true,
                    resizable: true,
                    sortable: true,
                    scrollable: true,
                    groupable: true
                };

                if(vm.grid) {
                    vm.grid.setOptions(vm.options);
                }
            }
        };
        //Delete view
        vm.deleteView = function(id){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: '<strong>Are you sure you want to delete this view?</strong>',
                actionButtonText: 'Delete',
                closeButtonText: 'Cancel',
                confirm: function(){
                    ViewsService.remove(id).then(function(){
                        $location.url('/settings/queries');
                    });
                },
                check: function(){
                    return true;
                }
            });
        };
        //Open Modal to add a widget
        vm.openAddWidgetModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/views/designer/views-designer-add-widget-modal.tpl.html',
                controller: 'ViewsDesignerAddWidgetModalCtrl',
                controllerAs: 'viewDesignerWidget',
                size: 'lg',
                backdrop: 'static'
            });
            modalInstance.result.then(function (widgetData) {
                WidgetsSettingsService.getFormFields(widgetData.id).then(function(data){
                    data.display.push({
                        formName: 'System Columns',
                        objects: [
                            {
                                dataType: 'date',
                                isLookUp: false,
                                label: 'Date Created',
                                modelId: 'sys_created_date',
                                type: 'date',
                                isSystem: true
                            },
                            {
                                dataType: 'date',
                                isLookUp: false,
                                label: 'Date Modified',
                                modelId: 'sys_last_modified_date',
                                type: 'date',
                                isSystem: true
                            },
                            {
                                dataType: 'string',
                                isLookUp: false,
                                label: 'Created By User',
                                modelId: 'sys_created_by',
                                type: 'string',
                                isSystem: true
                            },
                            {
                                dataType: 'string',
                                isLookUp: false,
                                label: 'Modified By User',
                                modelId: 'sys_last_modified_by',
                                type: 'string',
                                isSystem: true
                            }
                        ]
                    });
                    $scope.viewDesignerNormalCtrl.vm.viewModel.model.tableArray.push({
                        id: widgetData.id,
                        name: widgetData.name,
                        uniqueName: widgetData.uniqueName,
                        forms: data.display,
                        selectAll: true
                    });
                    $scope.viewDesignerNormalCtrl.vm.selectAll($scope.viewDesignerNormalCtrl.vm.viewModel.model.tableArray[$scope.viewDesignerNormalCtrl.vm.viewModel.model.tableArray.length-1],$scope.viewDesignerNormalCtrl.vm.viewModel.model);
                    if(!$scope.viewDesignerNormalCtrl.vm.viewModel.baseWidget){
                        $scope.viewDesignerNormalCtrl.vm.viewModel.baseWidget = widgetData.uniqueName;
                    }
                });
            });
        };

        //Tool bar functions
        vm.switchMode = function(){
            if(vm.mode === 'normal'){
                vm.mode = 'adv';
            }
            else{
                vm.mode = 'normal';
            }
        };
        vm.refreshView = function(){
            ViewsDesignerService.refresh(viewId);
        };

        vm.save = save;
        $scope.save = save;

        vm.close = function(){
            $location.url('/settings/queries');
        };
        //Init function
        _init();

        $scope.$on('$locationChangeStart', function (e) {
            if (!e.defaultPrevented) {
                if (vm.grid) {
                    vm.grid.destroy();
                    vm.grid = null;
                }
            }
        });
        ////////////////////
        /**
         * Init controller data and server calls
         */
        function _init() {
            ViewsService.getDetails(viewId).then(function(d){
                vm.mode = d.mode;
                vm.viewData = d;
                vm.viewDataOrig = angular.copy(vm.viewData);
            });
        }

        function save(close){
            if(vm.viewData.name){
                var data = {
                    viewData: vm.viewData
                };
                if(vm.mode === 'normal'){
                    data.viewModel = ViewsDesignerService.createViewModel($scope.viewDesignerNormalCtrl.vm.viewModel.model);
                    data.baseWidget = $scope.viewDesignerNormalCtrl.vm.viewModel.baseWidget;
                    if($scope.viewDesignerAdvCtrl.vm){
                        $scope.viewDesignerAdvCtrl.vm.advModel.advSql = '';
                    }
                }
                else{
                    data.viewModel = $scope.viewDesignerAdvCtrl.vm.advModel;
                    data.baseWidget = $scope.viewDesignerAdvCtrl.vm.advModel.baseWidget;
                    if($scope.viewDesignerNormalCtrl.vm){
                        $scope.viewDesignerNormalCtrl.vm.viewModel = {};
                    }
                }
                ViewsDesignerService.updateModel(viewId, data).then(function(){
                    // Clear error
                    vm.updateError = null;

                    if(vm.mode === 'normal'){
                        $scope.viewDesignerNormalCtrl.vm.viewModelOrig = angular.copy($scope.viewDesignerNormalCtrl.vm.viewModel);
                        vm.viewDataOrig = angular.copy(vm.viewData);
                    }
                    else{
                        $scope.viewDesignerAdvCtrl.vm.advModelOrig = angular.copy($scope.viewDesignerAdvCtrl.vm.advModel);
                    }

                    // If user has not clicked the "Results" button, this grid does not exist
                    if(vm.grid) {
                        vm.grid.dataSource.read();
                    }
                    if(close) {
                        vm.close();
                    }
                }, function(error){
                    // Display error
                    vm.updateError = _.get(error, 'DATA.details');
                });
            }
        }
    }])
;
angular.module('cerberus.admin')
    .controller('ViewsDesignerNormalCtrl', ["$scope", "ViewsService", "DesignerUtilityService", "ViewsPropertiesService", "ViewsDesignerService", function ViewsDesignerNormalCtrl($scope, ViewsService, DesignerUtilityService, ViewsPropertiesService, ViewsDesignerService) {
        var vm = this;
        $scope.viewDesignerNormalCtrl.vm = vm;
        vm.viewModelOrig  = {};
        vm.viewModel  = {};
        vm.tempViewProp = [];
        vm.origViewProp = [];
        vm.joinTypes = ViewsDesignerService.getJoinTypes();
        vm.editPropIndex = null;
        vm.editProp = null;
        vm.custom = {};
        vm.agg = {};
        vm.simpleAggFunctions = ViewsDesignerService.simpleAggFunctions();
        vm.tempJoin = {
            type: 'INNER',
            leftCol:{},
            rightCol:{},
            operator:'='
        };

        //Property and customer column functions
        vm.preventSpace = DesignerUtilityService.preventSpace;
        vm.addProperty = function(data,adv,type){
            var modeledData = ViewsPropertiesService.modelData(data,adv,type);
            if(modeledData.isValid){
                ViewsPropertiesService.add($scope.viewId,modeledData.d).then(function(id){
                    modeledData.d.id = id;
                    vm.tempViewProp.push(modeledData.d);
                    data.name = null;
                    data.description = null;
                    data.adv = null;
                    $scope.save();
                });
            }

        };

        vm.delProperty = function(property){
            var id = property.id;
            ViewsPropertiesService.remove(id).then(function(){
                var index = vm.tempViewProp.indexOf(property);
                vm.tempViewProp.splice(index,1);
                $scope.save();
            });
        };

        vm.editProperty = function(index, property){
            vm.editPropIndex = index;
            vm.editProp = angular.copy(property);
        };

        vm.cancelProperty = function(){
            vm.editProp = null;
            vm.editPropIndex = null;
        };

        vm.updateProperty = function(prop, data){
            if(data.name && (data.property.adv || data.property.function && data.property.field)){
                ViewsPropertiesService.update(prop.id, data).then(function(){
                    angular.extend(prop, data);
                    $scope.save();
                    vm.cancelProperty();
                });
            }
        };
        //Widgets and join functions
        vm.addJoinArray = function(joinObj){
            var d = {
                type: joinObj.type,
                operator: joinObj.operator,
                leftCol:{
                    id: joinObj.leftCol.id,
                    uniqueName: joinObj.leftCol.uniqueName,
                    modelId: joinObj.leftCol.modelId,
                    isLookUp: joinObj.leftCol.isLookUp
                },
                rightCol:{
                    id: joinObj.rightCol.id,
                    uniqueName: joinObj.rightCol.uniqueName,
                    modelId: joinObj.rightCol.modelId || 'instance_id',
                    isLookUp: joinObj.rightCol.isLookUp || false
                }
            };
            vm.viewModel.model.joinArray.push(d);
        };

        vm.delJoinArr = function(index){
          vm.viewModel.model.joinArray.splice(index,1);
        };

        vm.modifySelectArray = ViewsDesignerService.modifySelectArray;

        vm.selectAll = ViewsDesignerService.selectAll;

        vm.setBaseWidget = function(index){
            var widget = vm.viewModel.model.tableArray[index];
            vm.viewModel.baseWidget = widget.uniqueName;
        };

        vm.removeWidget = function(index){
            var widget = vm.viewModel.model.tableArray[index];
            for(var i = 0; i < vm.viewModel.model.selectArray.length; i++){
                if (vm.viewModel.model.selectArray[i].id === widget.id) {
                    vm.viewModel.model.selectArray.splice(i, 1);
                    i = i - 1;
                }
            }
            vm.viewModel.model.tableArray.splice(index,1);
            if(widget.uniqueName === vm.viewModel.baseWidget){
                if(vm.viewModel.model.tableArray.length >0){
                    vm.setBaseWidget(0);
                }
                else{
                    vm.viewModel.baseWidget = null;
                }
            }
        };
        //Init function
        _init();
        ////////////////////
        /**
         * Init controller data and server calls
         */
        function _init() {
            ViewsDesignerService.getModel($scope.viewId).then(function(d){
               vm.viewModel = d;
               vm.viewModelOrig = angular.copy(vm.viewModel);
                ViewsDesignerService.removeOldFields(d.model);
            });

            ViewsPropertiesService.get($scope.viewId).then(function(d){
                vm.tempViewProp = d;
                vm.origViewProp = angular.copy(vm.tempViewProp);
            });
        }
    }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name ViewsService
 * @alias cerberus/views-designer:ViewsService
 * @description Provides REST service for "views" resource
 */
    .factory('ViewsDesignerService', ["_", "$http", "$q", "apiPath", "toaster", "ConfirmModalService", function ViewsDesignerService(_, $http, $q, apiPath, toaster, ConfirmModalService) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            getJoinTypes: getJoinTypes,
            createViewModel:createViewModel,
            updateModel: updateModel,
            getModel:getModel,
            refresh:refresh,
            simpleAggFunctions: simpleAggFunctions,
            selectAll: selectAll,
            modifySelectArray: modifySelectArray,
            findRemovedFields: findRemovedFields,
            removeOldFields: removeOldFields

    };
        ////////////////////

        /**
         * This function gets all the join types
         * @function getJoinTypes
         * @return {Object} joins
         */
        function getJoinTypes() {
            return {
                types:[
                    'INNER',
                    'LEFT OUTER',
                    'RIGHT OUTER',
                    'FULL OUTER'
                ],
                operators: [
                    '=',
                    '<>',
                    '>',
                    '>=',
                    '<',
                    '<='
                ]
            };
        }
        /**
         * This function gets all the simple aggregate functions
         * @function simpleAggFunctions
         * @return {array} simpleAggFunctions
         */
        function simpleAggFunctions() {
            return [
                {
                    func: 'SUM',
                    argType: 'float'
                },
                {
                    func:'AVG',
                    argType:'float'
                },
                {
                    func:'COUNT',
                    argType:'varchar'
                },
                {
                    func:'MAX',
                    argType:'float'
                },
                {
                    func:'MIN',
                    argType: 'float'
                }
            ];
        }
        /**
         * Makes a get call REST api "views/{id}/model" resource
         * @function getModel
         * @param {string} id - view id
         * @return {promise}
         */
        function getModel(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'views/' + id + '/model')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    if(reason.CODE == 404){
                        toaster.pop('info', "This view's widget(s) has been deleted.");
                    }
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

        /**
         * This function models the data before it sends it up to the server
         * @function createViewModel
         * @param {object} dataModel. - model
         * @return {Object} viewModel
         */
        function createViewModel(dataModel){
            var d = {
                widgets:{},
                joins: dataModel.joinArray,
                where: dataModel.whereArray,
                settings:dataModel.settings
            };
            for(var i = 0; i < dataModel.tableArray.length; i++){
                var tmpSelectArr = [];
                for(var j = 0; j < dataModel.selectArray.length; j++){
                    if(dataModel.selectArray[j].id === dataModel.tableArray[i].id){
                        var format = null;
                        var forms = dataModel.tableArray[i].forms;
                        for(var k = 0; k < forms.length; k++){
                            var objects = forms[k].objects;
                            for(var l = 0; l < objects.length; l++){
                                if(objects[l].modelId === dataModel.selectArray[j].modelId){
                                    format = objects[l].format || '';
                                    break;
                                }
                            }
                            if(format){
                                break;
                            }
                        }

                        var tmpCol = {
                            modelId: dataModel.selectArray[j].modelId,
                            type: dataModel.selectArray[j].type,
                            isLookUp: (dataModel.selectArray[j].isLookUp || dataModel.selectArray[j].isCustomLookup) ? true : false, // just to be sure undefined isn't passed in instead of false
                            format: format || ''
                        };
                        //For dataseries that has a fk to another widget
                        if(dataModel.selectArray[j].widgetId){
                            tmpCol.widgetId = dataModel.selectArray[j].widgetId;
                            tmpCol.fk = dataModel.selectArray[j].fk;
                        }

                        tmpSelectArr.push(tmpCol);
                    }
                }
                d.widgets[dataModel.tableArray[i].id] = {
                    id: dataModel.tableArray[i].id,
                    select:tmpSelectArr,
                    name: dataModel.tableArray[i].name,
                    uniqueName: dataModel.tableArray[i].uniqueName
                };
            }
            return d;
        }
        /**
         * Makes a put call REST api "views/{id}/model" resource by id
         * @function updateModel
         * @param {string} id
         * @param {View} data - view object
         * @return {promise}
         */
        function updateModel(id, data){
            var deferred = $q.defer();
            $http.put(apiPath + 'views/' + id + '/model', data)
                .success(function(value){
                    toaster.pop('success', 'View Saved');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    toaster.pop('error', _.get(reason, 'MESSAGE'));
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        /**
         * Makes a put call REST api "views/{id}/refresh" resource by id
         * @function refresh
         * @param {string} id
         * @return {promise}
         */
        function refresh(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'views/' + id + '/refresh')
                .success(function(value){
                    toaster.pop('info', 'View Refresh Started...');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        /**
         * This function selects all the form fields in a widget
         * @function selectAll
         * @return {Object} joins
         */
        function selectAll(table, model) {
            var select = false;
            if(table.selectAll){
                select = true;
            }
            for(var j = 0; j < table.forms.length; j++){
                for(var k = 0; k < table.forms[j].objects.length; k++){
                    table.forms[j].objects[k].selected = select;
                    modifySelectArray(table.forms[j].objects[k],table.name, table.uniqueName, table.id, model);
                }
            }
        }
        /**
         * This function modifies the select array in the data model
         * @function modifySelectArray
         * @return {Object} joins
         */
        function modifySelectArray(object,widgetName,widgetUniqueName, widgetId, model) {
            object.name = widgetName;
            object.uniqueName = widgetUniqueName;
            object.id = widgetId;

            var index = _.findIndex(model.selectArray, {id: object.id, modelId: object.modelId});

            if(!object.selected){
                model.selectArray.splice(index,1);
            }
            else if(index < 0){
                model.selectArray.push(object);
            }
        }

        /**
         * Finds all fields in the select array that have been removed from their respective widgets
         * @param model
         * @returns {Array}
         */
        function findRemovedFields(model){
            var fields = [];

            _.forEach(model.selectArray, function(selectedField){
                // Find field's widget in table array
                var widget = _.find(model.tableArray, 'id', selectedField.id);

                if(widget){
                    // Checks if any of the forms has the selected field
                    var found = _.some(widget.forms, function(form){
                        /* LODASH Version 4 ONLY */
                        //return _.findIndex(form.objects, ['modelId', selectedField.modelId]) >= 0;
                        /* LODASH Version 3 & 4 Compatibility Mode */
                        return _.findIndex(form.objects, function(f){return f.modelId === selectedField.modelId;}) >= 0;
                    });

                    // Field no longer exists
                    if(!found){
                        fields.push(selectedField);
                    }
                }
                else {
                    // If widget is not in table array, this field should be removed
                    fields.push(selectedField);
                }
            });

            return fields;
        }

        function removeOldFields(model){
            var removedFields = findRemovedFields(model);
            if(!_.isEmpty(removedFields)) {
                var fieldDisplay = '';

                _.forEach(removedFields, function(r){
                    fieldDisplay += '<br /><em>' + r.uniqueName + '</em>_<strong>' + r.modelId + '</strong>';
                });

                ConfirmModalService.showModal(null, {
                    headerText: 'Confirm Removal',
                    bodyText: 'These fields no longer exist. Would you like to remove them?<br />' + fieldDisplay,
                    actionButtonText: 'Remove',
                    closeButtonText: 'Cancel',
                    check: function () {
                        return true;
                    },
                    confirm: function () {
                        _.forEach(removedFields, function(r){
                            _.remove(model.selectArray, r);
                        });
                    }
                });
            }
        }
    }])
;

angular.module('cerberus.admin')
    .controller('WidgetsDataCtrl', ["_", "kendo", "moment", "$scope", "$rootScope", "$window", "$uibModal", "$timeout", "widgetId", "ConfirmModalService", "InstancesService", "InstancesWindowService", "OdataUtilityService", "WidgetsService", "WidgetsSettingsService", function WidgetsDataCtrl(_, kendo, moment, $scope, $rootScope, $window, $uibModal, $timeout, widgetId,
                                                            ConfirmModalService, InstancesService, InstancesWindowService, OdataUtilityService, WidgetsService, WidgetsSettingsService) {

        /* Populate Scope */
        $scope.widgetPublicKey = widgetId;
        $scope.widgetModel = {};
        $scope.activeRoute = 'overview';
        $scope.formFieldsArray = [];
        $scope.selectedRows = [];
        $scope.columns = [{
            template: '<input class="form-control" type="checkbox" ng-checked="rowSelected(#: id #)" ng-model="selected" ng-click="toggleSelectRow(#: id #)" />',
            width: 30,
            type: 'batch',
            title: '',
            headerTemplate: '<input class="form-control" type="checkbox" ng-model="selected" ng-click="selectAllRows(selected)" />',
            menu: false
        }];
        $scope.fields = {};
        $scope.nestedDataSources = {};
        $scope.navFunctions = {
            getNext: getNext,
            getPrevious: getPrevious,
            callback: instanceCallback
        };
        $scope.pageSize = 20;

        $scope.tools = [
            {
                type: 'button',
                text: '<span class="fa fa-plus"></span>&nbsp;Create Record',
                click: function(){
                    $scope.openWindow($scope.widgetPublicKey);
                }
            },
            {
                type: 'splitButton',
                text: '<i class="fa fa-file-excel-o"></i>&nbsp;Export as Excel',
                click: function(){
                    $scope.exportAsExcel();
                },
                menuButtons: [
                    {
                        type: 'button',
                        text: '<i class="fa fa-file-text-o"></i>&emsp;Export All',
                        click: function(){
                            $scope.openWidgetExportAllModal();
                        }
                    }
                ]
            },
            {
                type: 'splitButton',
                text: 'Page Size: {{pageSize}}',
                menuButtons: [
                    {
                        type: 'button',
                        text: '20',
                        click: function(){
                            $timeout(function(){
                                $scope.setPageSize(20);
                            });
                        }
                    },
                    {
                        type: 'button',
                        text: '50',
                        click: function(){
                            $timeout(function(){
                                $scope.setPageSize(50);
                            });
                        }
                    },
                    {
                        type: 'button',
                        text: '100',
                        click: function(){
                            $timeout(function(){
                                $scope.setPageSize(100);
                            });
                        }
                    }
                ]
            },
            {
                type: 'separator'
            },
            {
                type: 'button',
                attributes: {
                    'ng-disabled': 'selectedRows.length < 1'
                },
                text: '<i class="fa fa-trash-o"></i>&nbsp;Delete Selected',
                click: function(){
                    $scope.deleteSelected($scope.selectedRows);
                }
            },
            {
                type: 'separator'
            },
    //-------------------------------------------------------------------------------------------------
    //-------------------------------------------------------------------------------------------------
    // REMOVED IN FEBRUARY 2019, MODAL INTRODUCED FOR BETTER RESULTS AND OPTIONS
    //-------------------------------------------------------------------------------------------------
    //        {
    //            type: 'splitButton',
    //            text: '<i class="fa fa-wrench"></i>&nbsp;Update Selected Schema',
    //            attributes: {
    //                'ng-disabled': 'selectedRows.length < 1'
    //            },
    //            click: function(){
    //                $scope.updateSelectedSchemas($scope.selectedRows, true, true);
    //            },
    //            menuButtons: [
    //                //{
    //                //    type: 'button',
    //                //    text: 'Selected',
    //                //    click: function(){
    //                //        $scope.updateSelectedSchemas($scope.selectedRows, true, true);
    //                //    }
    //                //},
    //                {
    //                    type: 'button',
    //                    text: 'Update All',
    //                    click: function(){
    //                        $scope.updateAllSchemas($scope.widgetPublicKey, true, true);
    //                    }
    //                }
    //            ]
    //        },
    //-------------------------------------------------------------------------------------------------
    //-------------------------------------------------------------------------------------------------
            {
                type: 'splitButton',
                text: '<i class="fa fa-wrench"></i>&nbsp;Schema Update Selected',
                attributes: {
                    'ng-disabled': 'selectedRows.length < 1'
                },
                click: function(){
                    $scope.openWidgetSchemaUpdateModal($scope.selectedRows, null);
                },
                menuButtons: [
                    {
                        type: 'button',
                        text: '<i class="fa fa-exclamation-triangle"></i>&emsp;All Widget Schema Update',
                        click: function(){
                            $scope.openWidgetSchemaUpdateModal(null, $scope.widgetPublicKey);
                        }
                    }
                ]
            },
            {
                type: 'splitButton',
                text: '<i class="fa fa-retweet"></i>&nbsp;Data Mass Update',
                attributes: {
                    'ng-disabled': 'selectedRows.length < 1'
                },
                click: function(){
                    $scope.openWidgetMassUpdateModal($scope.selectedRows, null);
                },
                menuButtons: [
                    {
                        type: 'button',
                        text: '<i class="fa fa-exclamation-triangle"></i>&emsp;All Widget Mass Update',
                        click: function(){
                            $scope.openWidgetMassUpdateModal(null, $scope.widgetPublicKey);
                        }
                    }
                ]
            },
            /*{
                type: 'splitButton',
                text: '<i class="fa fa-wrench"></i>&nbsp;Recalculate Selected',
                attributes: {
                    'ng-disabled': 'selectedRows.length < 1'
                },
                click: function(){
                    $scope.updateSelectedCalculations($scope.selectedRows);
                },
                menuButtons: [
                    {
                        type: 'button',
                        text: 'Recalculate All',
                        click: function(){
                            $scope.updateAllCalculations($scope.widgetPublicKey);
                        }
                    }
                ]
            },*/
            {
                type: 'separator'
            },
            {
                type: 'button',
                text: '<span class="fa fa-lightbulb-o"></span>&nbsp;Id',
                attributes: {
                    'ng-disabled': '((selectedRows.length > 5) || (selectedRows.length < 1))'
                },
                click: function(){
                  ConfirmModalService.showModal(null, {
                    headerText: 'Instance(s) Id',
                    bodyText: '<strong>' + $scope.selectedRows + '</strong>',
                    closeButtonText: 'Cancel',
                    check: function(){
                        return true;
                    }
                  });
                }
            }
        ];

        //Batch Options
        $scope.toggleSelectRow = function(rowId){
            var index = $scope.selectedRows.indexOf(rowId);
            if(index < 0){
                $scope.selectedRows.push(rowId);
            }
            else{
                $scope.selectedRows.splice(index, 1);
            }
            selectGridRows($scope.selectedRows);
        };

        $scope.selectAllRows = function(selected){
            var rows = $scope.grid.dataSource.data();
            if(rows.length > 0 && $scope.grid.pager){
                var pageNum = $scope.grid.pager.page();
                var pageSize = $scope.grid.pager.pageSize();
                var start = pageSize * (pageNum - 1);
                var end = (pageSize * pageNum) - 1;
                if(end >= rows.length){
                    end = rows.length - 1;
                }
                for(var r = start; r <= end; r++){
                    var id = rows[r].id;
                    var index = $scope.selectedRows.indexOf(id);
                    if(selected && index < 0){
                        $scope.selectedRows.push(id);
                    }
                    else if(!selected && index >= 0){
                        $scope.selectedRows.splice(index, 1);
                    }
                }
            }
        };

        $scope.rowSelected = function(id){
            return $scope.selectedRows.indexOf(id) >= 0;
        };

        $scope.deleteSelected = function(idArr){
            ConfirmModalService.showModal(null, {
                headerText: 'Confirm Deletion',
                bodyText: '<strong>Are you sure you want to delete these records FOREVER?</strong>',
                actionButtonText: 'Delete',
                closeButtonText: 'Cancel',
                confirm: function(){
                    InstancesService.hardDelete(idArr).then(function(){
                        $scope.options.dataSource.read();
                        $scope.selectedRows = [];
                    });
                },
                check: function(){
                    return true;
                }
            });
        };

        //Modal schema update
        $scope.openWidgetSchemaUpdateModal = function(idArr, widId){
            var selectiveUpdate;
            if(idArr){selectiveUpdate = true;}else{selectiveUpdate = false;}
            var updateOptions = {
                isSelective: selectiveUpdate,
                createRevision: true,
                updateWorkflow: false,
                dataSourceFilter: ""
            };
            var sourceFilter = $scope.options.dataSource.filter();
            if (sourceFilter) {
                updateOptions.dataSourceFilter = OdataUtilityService.toOdataFilter(sourceFilter);
            }
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/data/widgets-data-schema-update-modal.tpl.html',
                controller: 'WidgetSchemaUpdateModalCtrl',
                backdrop: 'static',
                resolve: {
                    widget: function(){
                        return $scope.widgetModel;
                    },
                    updateOptions: function(){
                        return updateOptions;
                    }
                }
            });
            modalInstance.result.then(function () {
                //update selective records
                if(idArr){
                    InstancesService.updateSchema({ids:idArr, updateSettings:updateOptions}).then(function(){
                        $scope.options.dataSource.read();
                        $scope.selectedRows = [];
                    });
                }
                //update all records from widget / (include option to use selective filter criteria)
                else if(widId) {
                    InstancesService.updateAllSchema(widId, updateOptions).then(function(){
                        $scope.options.dataSource.read();
                        $scope.selectedRows = [];
                    });
                }
            });
        };

        //Modal 'Object Mass Update Data' from columns
        $scope.openWidgetMassUpdateModal = function(idArr, widId){
            var selectiveUpdate;
            if(idArr){selectiveUpdate = true;}else{selectiveUpdate = false;}
            var updateOptions = {
                isSelective: selectiveUpdate,
                createRevision: true,
                updateRevision: false,
                updateAction: "",
                updateSrcKey: {
                    isFormObj: true,
                    modelId: "",
                    label: ""
                    },
                updateSrcKey_IsObject: true,
                updateNewKey: {
                    isFormObj: true,
                    modelId: "",
                    label: ""
                    },
                updateNewKey_IsObject: true,
                updateNewVal: {
                    text: "",
                    formula: "",
                    obj_keys: "id,display",
                    obj_values: "1234,Sample Test"
                    },
                updateNewValueType: "",
                dataSourceFilter: ""
            };
            var sourceFilter = $scope.options.dataSource.filter();
            if (sourceFilter) {
                updateOptions.dataSourceFilter = OdataUtilityService.toOdataFilter(sourceFilter);
            }
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/data/widgets-data-mass-update-modal.tpl.html',
                controller: 'WidgetMassUpdateModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    widget: function(){
                        return $scope.widgetModel;
                    },
                    updateOptions: function(){
                        return updateOptions;
                    }
                }
            });
            modalInstance.result.then(function () {
                //update selective records
                if(idArr){
                    //console.log(updateOptions['updateNewVal']['formula']);
                    InstancesService.updateInstanceObject({ids:idArr, updateSettings:updateOptions}).then(function(){
                        $scope.options.dataSource.read();
                        $scope.selectedRows = [];
                    });
                }
                //update all records from widget / (include option to use selective filter criteria)
                else if(widId){
                    InstancesService.updateAllInstanceObject(widId, updateOptions).then(function(){
                        $scope.options.dataSource.read();
                        $scope.selectedRows = [];
                    });
                }
            });
        };

    //-------------------------------------------------------------------------------------------------
    //-------------------------------------------------------------------------------------------------
    // REMOVED IN FEBRUARY 2019, MODAL INTRODUCED FOR BETTER RESULTS AND OPTIONS
    //-------------------------------------------------------------------------------------------------
    //
    //    //Update Schemas
    //        $scope.updateSelectedSchemas = function(idArr, createRev, updWorkFlowState){
    //            var body_msg = '<p><strong>Are you sure you want to update the selected records?</strong></p>';
    //            body_msg = body_msg + '<p>Schema update <strong>"with revisions"</strong> will push existing instance data into a revision and resets instances with corresponding new published workflow and ';
    //            body_msg = body_msg + 'associated workflow -> object -> form(s). <i><strong>"Current Workflow StateID" resets to "1".</strong></i></p>'; 
    //            body_msg = body_msg + '<p>Schema update <strong>"without revisions"</strong> is similar, but revisions are not made, "Current Workflow StateID" & "Previous Workflow Paths" are not changed.</p>';
    //            body_msg = body_msg + '<p>Note: <strong><i>Workflows will be processed and operations within objects may occur.</i></strong> Ex: send emails, push notifications, update data within other widgets, etc.</p>';
    //            ConfirmModalService.showModal(null, {
    //                headerText: 'Confirm Schema Update',
    //                bodyText: body_msg,
    //                actionButtonText: 'YES, I HAVE READ THE INSTRUCTIONS AND I AM READY TO PROCEED.',
    //                closeButtonText: 'Cancel',
    //                confirm: function(){
    //                InstancesService.updateSchema({ids:idArr, createRevision:createRev, updateWflowState:updWorkFlowState}).then(function(){
    //                    $scope.options.dataSource.read();
    //                    $scope.selectedRows = [];
    //                });
    //                },
    //                check: function(){
    //                    return true;
    //                }
    //            });
    //        };
    //        $scope.updateAllSchemas = function(widgetId, createRev, updWorkFlowState){
    //            var body_msg = '<p><strong>Are you sure you want to update "All Records"?</strong></p>';
    //            body_msg = body_msg + '<p>Schema update <strong>"with revisions"</strong> will push existing instance data into a revision and resets instances with corresponding new published workflow and ';
    //            body_msg = body_msg + 'associated workflow -> object -> form(s). <i><strong>"Current Workflow StateID" resets to "1".</strong></i></p>';
    //            body_msg = body_msg + '<p>Schema update <strong>"without revisions"</strong> is similar, but revisions are not made, "Current Workflow StateID" & "Previous Workflow Paths" are not changed.</p>';
    //            body_msg = body_msg + '<p>Note: <strong><i>Workflows will be processed and operations within objects may occur.</i></strong> Ex: send emails, push notifications, update data within other widgets, etc.</p>';
    //            ConfirmModalService.showModal(null, {
    //                headerText: 'Confirm Schema Update',
    //                bodyText: body_msg,
    //                actionButtonText: 'YES, I HAVE READ THE INSTRUCTIONS AND I AM READY TO PROCEED.',
    //                closeButtonText: 'Cancel',
    //                confirm: function(){
    //                InstancesService.updateAllSchema(widgetId, createRev, updWorkFlowState).then(function(){
    //                    $scope.options.dataSource.read();
    //                    $scope.selectedRows = [];
    //                });
    //                },
    //                check: function(){
    //                    return true;
    //                }
    //            });
    //        };
    //-------------------------------------------------------------------------------------------------
    //-------------------------------------------------------------------------------------------------

        //Update Calculations
        $scope.updateSelectedCalculations = function(idArr){
            InstancesService.updateCalculations({ids:idArr}).then(function(){
                $scope.options.dataSource.read();
                $scope.selectedRows = [];
            });
        };
        $scope.updateAllCalculations = function(widgetId){
            InstancesService.updateAllCalculations(widgetId).then(function(){
                $scope.options.dataSource.read();
                $scope.selectedRows = [];
            });
        };

        /* Get widget data */
        $scope.$watch(WidgetsService.widgetComponents, function (newValue){
            if(newValue) {
                $scope.widgetModel = angular.copy(newValue);
            }
        });

        /* Overview Logic */
        $scope.openFile = function (loc) {
            $window.open(loc);
        };

        $scope.init = function(){
            // widgetModel resolve
            WidgetsService.getWidget(widgetId).then(function(widgetModel){
                $scope.widgetModel = angular.copy(widgetModel);

                var widgetFileName = widgetModel.name || 'UntitledWidget';
                widgetFileName = widgetFileName.replace(/[\W_]/g,'') + '_' + kendo.toString(new Date(), 'yyyy_MM_dd');
                var excelOptions = {
                    excel: {
                        fileName: widgetFileName + ".xlsx",
                        filterable: true
                    }
                };

                _.assign($scope.options, excelOptions);

                if($scope.grid){
                    $scope.grid.setOptions(excelOptions);
                }
            });

            // formFieldsArray resolve
            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldsArray){
                $scope.formFieldsArray = formFieldsArray;

                for(var i = 0; i < $scope.formFieldsArray.display.length; i++){
                    if($scope.formFieldsArray.display[i].objects){
                        for(var j = 0; j < $scope.formFieldsArray.display[i].objects.length; j++){
                            var colObj = $scope.formFieldsArray.display[i].objects[j];
                            if(colObj.type != 'readonly' && colObj.type != 'dataseries' && colObj.type != 'map'){
                                var fieldName = colObj.modelId;
                                var schemaField = {
                                    type: colObj.type
                                };

                                if(colObj.type === 'string'){
                                    schemaField.parse = stripHTML;
                                }
                                else if (colObj.type == 'date') {
                                    schemaField.parse = parseDateField;
                                }
                                if(colObj.isLookUp || colObj.isUsersRelationship || colObj.isCustomLookup){
                                    fieldName = colObj.modelId + '.display';
                                    schemaField.parse = setDefaultDisplayValue;
                                }
                                else if(colObj.type === 'location'){
                                    fieldName = colObj.modelId + '.properties.formatted_address';
                                    schemaField.parse = setDefaultGeoDisplayValue;
                                }

                                $scope.columns.push(
                                    {
                                        field: fieldName,
                                        title: colObj.label,
                                        type: colObj.type,
                                        width: 130
                                    }
                                );

                                if(colObj.format){
                                    _.last($scope.columns).format = colObj.format;
                                }

                                $scope.fields[colObj.modelId] = schemaField;
                            }
                        }
                    }
                }

                $scope.fields['sys_created_date'] = {
                    type: 'date',
                    parse: parseSystemDateField
                };

                $scope.fields['sys_last_modified_date'] = {
                    type: 'date',
                    parse: parseSystemDateField
                };

                $scope.columns.push(
                    {
                        title: 'Created By',
                        field: 'sys_created_by',
                        width: 130,
                        menu: false
                    },
                    {
                        title: 'Created On',
                        field: 'sys_created_date',
                        format: '{0:G}',
                        width: 130,
                        menu: false
                    },
                    {
                        title: 'Last Modified By',
                        field: 'sys_last_modified_by',
                        width: 130,
                        menu: false
                    },
                    {
                        title: 'Last Modified On',
                        field: 'sys_last_modified_date',
                        format: '{0:G}',
                        width: 130,
                        menu: false
                    },
                    {
                        title: 'Attachments',
                        field: 'attachment_count',
                        width: 60,
                        menu: false
                    },
                    {
                        title: 'Notes',
                        field: 'note_count',
                        width: 60,
                        menu: false
                    }
                );

                var dataSource = new kendo.data.DataSource({
                    type: 'odata',
                    transport:{
                        read: {
                            url: '/server/rest/v1/widgets/' + $scope.widgetPublicKey + '/records/odata.svc',
                            beforeSend: function(xhr){
                                xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                                xhr.setRequestHeader('WSID',$rootScope.userData.currentWorkspace.id);
                            },
                            dataType: 'json',
                            data: function(config){
                                if(config.filter) {
                                    var filter = config.filter;
                                    delete config.filter;

                                    return {
                                        $filter: OdataUtilityService.toOdataFilter(filter)
                                    };
                                }
                            }
                        }
                    },
                    serverFiltering: true,
                    serverPaging: true,
                    serverSorting: true,
                    pageSize: $scope.pageSize,
                    schema: {
                        model: {
                            fields: $scope.fields
                        }
                    }
                });

                $scope.options.dataSource = dataSource;

                if($scope.grid){
                    $scope.grid.setDataSource(dataSource);
                    $scope.grid.setOptions({ columns: $scope.columns });
                }
            });
        };

        $scope.init();

        $scope.options = {
            columnMenu: true,
            columns:  $scope.columns,
            filterable: true,
            mobile: false,
            pageable: true,
            reorderable: true,
            resizable: true,
            sortable: true,
            groupable: true,
            selectable: "row",
            remove: function (e) {
                var id = e.model.id;
                InstancesService.remove(id);
            },
            change: function(e){
                var selected = e.sender.select();
                if(selected.length > 0) {
                    var dataItem = this.dataItem(selected[0]);
                    
                    InstancesWindowService.openWindow({
                        action: 'read',
                        instanceId: dataItem.id,
                        title: $scope.widgetModel.name,
                        navFunctions: $scope.navFunctions
                    });
                }
            }
        };

        $scope.$on('$locationChangeStart', function(){
            if ($scope.grid) {
                $scope.grid.destroy();
                $scope.grid = null;
            }
        });

        $scope.$on('$destroy', function () {
            
            delete $scope.navFunctions.getNext;
            delete $scope.navFunctions.getPrevious;
            delete $scope.navFunctions.callback;
        });

        $scope.setPageSize = function (size) {
            if ($scope.grid) {
                $scope.pageSize = size;
                $scope.options.dataSource.pageSize(parseInt(size));
                $scope.grid.refresh();
            }
        };

        $scope.exportAsExcel = function () {
            if ($scope.grid) {
                $scope.grid.saveAsExcel();
            }
        };

        $scope.openWidgetExportAllModal = function(){
            var exportOptions = {
                    LineBreak: 'crlf',
                    CellsFormatCrLfDetection: 'none',
                    CellsFormatQuoteCharReplace: 'none',
                    quoteAllCells: false,
                    markNullCells: false,
                    fieldDelimiter: 'comma',
                    CellsFormatCrLfDetection_IsField: true,
                    CellsFormatQuoteCharReplace_IsField: true
                };
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/data/widgets-data-exportall-advanced-modal.tpl.html',
                controller: 'WidgetExportAllAdvancedModalCtrl',
                backdrop: 'static',
                resolve: {
                    exportOptions: function(){
                        return exportOptions;
                    }
                }
            });
            modalInstance.result.then(function(){
                WidgetsSettingsService.exportAllAsExcel($scope.widgetPublicKey, $scope.options.dataSource.filter(), $scope.options.dataSource.sort(), exportOptions).then(function(result){
                        $scope.options.dataSource.read();
                        $scope.selectedRows = [];
                        if(result){ //download file...
                            $window.open(result, '_self');
                        }
                    });
            });
        };

        $scope.openWindow = function(wId){
            InstancesWindowService.openWindow({
                action: 'create',
                widgetId: wId,
                title: $scope.widgetModel.name,
                navFunctions: $scope.navFunctions
            });
        };

        function selectGridRows(ids){
            var data = $scope.options.dataSource.data();
            for(var i = 0; i < data.length; i++){
                var selector = ".k-grid tr:eq(" + (i + 1) + ")";
                if(ids.indexOf(data[i].id) >= 0){
                    $(selector).addClass('selected');
                }
                else{
                    $(selector).removeClass('selected');
                }
            }
        }

        // For removing HTML tags from strings
        function stripHTML(string){
            if(string) {
                // Wraps in div to ensure the string is not treated as a selector
                return angular.element('<div>' + string + '</div>').text();
            }
            return string;
        }

        function setDefaultDisplayValue(displayVal){
            return displayVal || '';
        }

        function setDefaultGeoDisplayValue(displayVal){
            if(!_.isEmpty(displayVal)){
                return displayVal;
            }
            else {
                return { properties: { formatted_address: '' } };
            }
        }

        function getPrevious(instanceController){
            if($scope.grid){
                var dataSource = $scope.grid.dataSource,
                    currentId = instanceController.instanceId,
                    currentDataItem = dataSource.get(currentId),
                    currentIndex = dataSource.indexOf(currentDataItem),
                    prevItem;

                if(currentIndex >= 0) {
                    if (currentIndex > 0) {
                        prevItem = dataSource.at(currentIndex - 1);
                    }

                    if (prevItem) {
                        instanceController.updateInstanceAttrs(prevItem.id, 'read');
                        instanceController.init();
                    }
                }
            }
        }

        function getNext(instanceController){
            if($scope.grid){
                var dataSource = $scope.grid.dataSource,
                    currentId = instanceController.instanceId,
                    currentDataItem = dataSource.get(currentId),
                    currentIndex = dataSource.indexOf(currentDataItem),
                    currentPageSize = dataSource.data().length,
                    nextItem;

                if(currentIndex >= 0) {
                    if (currentIndex < currentPageSize - 1) {
                        nextItem = dataSource.at(currentIndex + 1);
                    }

                    if (nextItem) {
                        instanceController.updateInstanceAttrs(nextItem.id, 'read');
                        instanceController.init();
                    }
                }
            }
        }

        function instanceCallback(){
            $scope.options.dataSource.read();
        }

        /**
         * The parse function for data-source schema fields of type date.
         * Changes date string back to a Date object
         * @param value - date string serialized by Coldfusion
         * @returns {Date, string} - corrected Date or empty string if no value
         */
        function parseDateField(value){
            if(value && !_.isDate(value)){
                try {
                    var dateValue = moment.utc(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
                    dateValue.local();

                    return dateValue.toDate();
                }
                catch(e){}
            }
            else if(_.isDate(value)){
                return value;
            }

            return '';
        }

        /**
         * The parse function for data-source schema fields of type date.
         * Changes date string back to a Date object
         * @param value - date string serialized by Coldfusion
         * @returns {Date, string} - corrected Date or empty string if no value
         */
        function parseSystemDateField(value){
            if(value && !_.isDate(value)){
                try {
                    var dateValue = moment.utc(value, 'MMMM, DD YYYY HH:mm:ss');
                    dateValue.local();

                    return dateValue.toDate();
                }
                catch(e){}
            }
            else if(_.isDate(value)){
                return value;
            }

            return '';
        }
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetExportAllAdvancedModalCtrl', ["$scope", "$uibModalInstance", "exportOptions", function WidgetExportAllAdvancedModalCtrl($scope, $uibModalInstance, exportOptions) {

        $scope.exportOptions = exportOptions;

        $scope.exportLineBreakTypes = [
            {value: 'crlf', display: '[CR] + [LF]'},
            {value: 'lf', display: '[LF] - New Line Feed'},
            {value: 'cr', display: '[CR] - Carriage Return'},
            {value: 'pipe', display: 'PIPE SIGN [ | ]'}
        ];

        $scope.CellsFormatCrLfDetectTypes = [
            {value: 'none', display: 'None - (AS IS)'},
            {value: 'deleteCrLf', display: 'Remove [\\r\\n]'},
            {value: 'injectSpace', display: 'Replace with space'}
        ];
        
        $scope.CellsFormatQuoteCharReplaceTypes = [
            {value: 'none', display: 'None - (AS IS)'},
            {value: 'backQuote', display: 'Back quote [ ` ]'},
            {value: 'tildeChar', display: 'Tilde sign [ ~ ]'},
            {value: 'injectSpace', display: 'Replace with space'}
        ];
        
        //init fucntions here...

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.finish = function(){
            $uibModalInstance.close($scope.widget);
        };

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetMassUpdateModalCtrl', ["_", "$scope", "$uibModalInstance", "pageObjectConfigService", "WidgetsSettingsService", "DesignerUtilityService", "widget", "updateOptions", function WidgetMassUpdateModalCtrl(_, $scope, $uibModalInstance,
                    pageObjectConfigService, WidgetsSettingsService, DesignerUtilityService, widget, updateOptions) {
        var vm = this;

        vm.widget = angular.copy(widget);
        vm.updateOptions = updateOptions;
        $scope.temp = {
            model: {
                calculation: {
                    formula: "" //formula struct holder, (used by codemirror)
                }
            }
        };

        vm.updateActionTypes = [
            {value: 'deleteKey', display: 'Delete Column'},
            {value: 'updateKey', display: 'Update Column'},
            {value: 'copyKey', display: 'Copy Column'},
            {value: 'moveKey', display: 'Move Column'}
        ];

        vm.formulasList = [
            {value: '(((\'Price\' * \'Rate\') + 5.5 - 3) \\ 2)', display: 'Arithmetic'},
            {value: '(\'Rate\' - 2) ^ 2', display: 'Math power (^)'},
            {value: '\'CustomerName\' & " - " & \'OrderNumber\'', display: 'Str - Concatenate'},
            {value: 'REReplace(\'CustomerName\', "[q|7|W|\\n]", "X", "ALL")', display: 'Str - RegExReplace (Case sensitive)'},
            {value: 'REReplaceNoCase(\'CustomerName\', "[q|7|W|\\n]", "X", "ALL")', display: 'Str - RegExReplace (Case unsensitive)'},
            {value: 'UCase(\'CustomerName\')', display: 'Str - Convert uppercase'},
            {value: 'LCase(\'CustomerName\')', display: 'Str - Convert lowercase'},
            {value: 'Len(\'CustomerName\')', display: 'Str - Return length of string'},
            {value: 'Left(\'CustomerName\', "5")', display: 'Str - Get nr. of chars starting leftside'},
            {value: 'Right(\'CustomerName\', "5")', display: 'Str - Get nr. of chars starting rightside'},
            {value: 'LTrim(\'CustomerName\')', display: 'Str - Trim leading spaces from left'},
            {value: 'RTrim(\'CustomerName\')', display: 'Str - Trim trailing spaces from right'},
            {value: 'Trim(\'CustomerName\')', display: 'Str - Trim leading & trailing spaces'}
        ];

        vm.FormulaHelper =  "..:: Useful variables and formula usage ::..\n" +
                            "If more than 2 'math operators', use '( )' brackets to set up calculation order and priority. " + 
                            "Tested math operators: '+ - * / ^'. To join (Concatenate) multiple objects use '&' operator. " + 
                            "single-quotes represent object links, double-quotes represent text strings.\n" +
                            "..:: List of supported ColdFusion function(s) ::..\n" +
                            "REReplace, ReReplaceNoCase, UCase, LCase, Len, Left, Right, LTrim, RTrim, Trim.\n" +
                            "..:: Basic examples ::..\n" +
                            "{Concatenation} - 'CustomerName' & \" - \" & 'OrderNumber' - 'Concatenation' example.\n" +
                            "{Math Operations} - ('Price' * 'Rate') + 1.5 - 'Math' example.\n" +
                            "(End of instructions).";

        // Widget functions
        vm.formFieldsArray = [];       // fields from Page objects service script (pageObjectConfigService)
        vm.WidgetFormFieldsArray = []; // fields from Widgets service script (WidgetsSettingsService)
        vm.loadFormFields = _.partial(pageObjectConfigService.loadFormFields, vm);

        // Modal functions
        $scope.isNotEqual = function(data){
            return !angular.equals('MASSUPDATE ' + vm.widget.name, data);
        };

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        $scope.finish = function(){
            updateOptions.updateNewVal.formula = $scope.temp.model.calculation.formula; //update formula
            $uibModalInstance.close(vm.widget, vm.updateOptions);
        };

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        //Init
        init();

        //Predefined functions
        function init(){
            // Get all Field Objects Form Objects for the DropDown
            vm.loadFormFields(vm.widget.publicKey);
            
            // Get all Field Objects from Widget for Grid Table
            WidgetsSettingsService.getFormFields(vm.widget.publicKey).then(function(formFieldArray){
            vm.WidgetFormFieldsArray = getFormFieldObjects(formFieldArray);
            
            // Form Objects Grid
            $scope.mainGridOptions = DesignerUtilityService.formGrid(formFieldArray.display);
            $scope.detailGridOptions = DesignerUtilityService.formDetailGrid($scope);

            // Codemirror
            $scope.codemirrorLoaded = DesignerUtilityService.codemirrorLoaded(formFieldArray.operands);
            });
        }

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    objects.push(object);
                }
            }
            return objects;
        }

    //-----------------
    //end of controller
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetSchemaUpdateModalCtrl', ["$scope", "$uibModalInstance", "widget", "updateOptions", function WidgetSchemaUpdateModalCtrl($scope, $uibModalInstance, widget, updateOptions) {
		
        $scope.widget = angular.copy(widget);
        $scope.updateOptions = updateOptions;
		
        $scope.isNotEqual = function(data){
            return !angular.equals('UPDATE ' + $scope.widget.name, data);
        };
		
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
		
        $scope.finish = function(){
            $uibModalInstance.close($scope.widget);
        };
		
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetDeleteModalCtrl', ["$scope", "$uibModalInstance", "widget", function WidgetDeleteModalCtrl($scope, $uibModalInstance, widget) {
        $scope.widget = angular.copy(widget);
        $scope.isNotEqual = function(data){
            return !angular.equals('DELETE ' + $scope.widget.name, data);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.finish = function(){
            $uibModalInstance.close($scope.widget);
        };

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
    .controller('WidgetsCtrl', ["$scope", "$location", "workspaceId", "localStorageService", "WidgetsService", function WidgetsCtrl($scope, $location, workspaceId, localStorageService, WidgetsService) {
        $scope.widgetsArray = [];
        $scope.select = _select;
        $scope.widgetFilter = _widgetFilter;

        _init();

        function _init(){
            WidgetsService.getWidgets();

            $scope.$watch(WidgetsService.widgets, function (newValue){
                $scope.widgetsArray = angular.copy(newValue);
            });
        }

        function _select(id){
            if(id) {
                $location.url('/settings/widgets/' + id);
            }
        }

        // Getter-Setter function for filter
        function _widgetFilter(filterText){
            // Checks if value was passed in
            if(arguments.length){
                localStorageService.set('widgetFilter.' + workspaceId, filterText);
                return filterText || '';
            }
            else {
                return localStorageService.get('widgetFilter.' + workspaceId) || '';
            }
        }
    }])
    .controller('FormModalCtrl', ["$scope", "$uibModalInstance", "$timeout", "form", "TemplatesServices", function FormModalCtrl($scope, $uibModalInstance, $timeout, form, TemplatesServices) {
        $scope.templatesArray = [];
        $scope.origData = angular.copy(form);
        $scope.formData = angular.copy(form);
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.isUnchanged = function(){
            return angular.equals($scope.formData, $scope.origData);
        };
        $scope.finish = function(){
            $uibModalInstance.close($scope.formData);
        };
        $scope.preventInvalidCharacters = preventInvalidCharacters;
        $scope.removeInvalidCharacters = removeInvalidCharacters;

        init();

        function init(){
            TemplatesServices.get('Form').then(function(templates){
                $scope.templatesArray = templates;
            });
        }

        function preventInvalidCharacters(event){
            var period = event.which === 190,
                underscore = event.which === 189 && event.shiftKey;

            if(period || underscore){
                event.preventDefault();
            }
        }

        function removeInvalidCharacters(){
            $timeout(function(){
                if($scope.formData.name){
                    $scope.formData.name = $scope.formData.name.replace(/[._]/g, '');
                }
            });
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
    .controller('DeleteWidgetComponentsModalCtrl', ["$scope", "$uibModalInstance", "formOriginId", "data", "FormsDesignerService", function DeleteWidgetComponentsModalCtrl($scope, $uibModalInstance, formOriginId, data, FormsDesignerService) {
        $scope.cannotDelete = null;
        $scope.data = angular.copy(data);
        $scope.isNotEqual = function(data){
            return !angular.equals($scope.data.name, data);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.finish = function(){
            $uibModalInstance.close($scope.data);
        };

        FormsDesignerService.checkFormUsedInWorkflow(formOriginId).then(function(deleteCheck){
            $scope.cannotDelete = deleteCheck;
        });

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetsDetailsCtrl', ["_", "$scope", "$location", "$uibModal", "widgetId", "WidgetsService", "WidgetsSettingsService", "ViewsService", function WidgetsDetailsCtrl(_, $scope, $location, $uibModal, widgetId, WidgetsService, WidgetsSettingsService, ViewsService){
        $scope.widgetPublicKey = widgetId;
        $scope.activeRoute = 'details';
        $scope.views = [];
        $scope.columns = [];
        $scope.widgetData = {};
        $scope.widgetModel = {};
        $scope.formFields = [];
        $scope.alerts = [
            {
                value: 30,
                display:'30 minutes before'
            },
            {
                value: 60,
                display:'1 hour before'
            },
            {
                value: 120,
                display:'2 hours before'
            },
            {
                value: 1440,
                display:'1 day before'
            },
            {
                value: 2880,
                display:'2 days before'
            },
            {
                value: 10080,
                display:'1 week before'
            }
        ];
        $scope.formActions = [
            { value: 'submit', display: 'Submit'},
            { value: 'submitAndNew', display: 'Submit & New'},
            { value: 'submitAndClose', display: 'Submit & Close'}
        ];

        $scope.isUnchanged = function(data){
            return angular.equals(data, $scope.widgetModel);
        };
        $scope.save = function(data){
            WidgetsSettingsService.updateWidget(data['publicKey'], data).then(function(){
                init();
            });
        };
        $scope.selectView = function(id){
            ViewsService.getColumns(id).then(function(data){
                $scope.columns = data;
            });
        };

        $scope.openWidgetDeleteModal = function(){
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/details/delete-widget-modal.tpl.html',
                controller: 'WidgetDeleteModalCtrl',
                resolve: {
                    widget: function(){
                        return $scope.widgetModel;
                    }
                }
            });
            modalInstance.result.then(function (data) {
                WidgetsSettingsService.deleteWidget(data['publicKey']).then(function(){
                    $location.url('/settings/widgets');
                });
            });
        };

        init();

        function init(){
            WidgetsService.getWidget(widgetId).then(function(data){
                $scope.widgetData = data;
                $scope.widgetModel = angular.copy($scope.widgetData);
                WidgetsSettingsService.getBaseWidgetViews($scope.widgetData.uniqueName).then(function(data){
                    $scope.views = data;
                });

                if($scope.widgetData.settings.view) {
                    $scope.selectView($scope.widgetData.settings.view.id);
                }

                if(!$scope.widgetData.settings.defaultAction){
                    $scope.widgetData.settings.defaultAction = $scope.widgetData.settings.defaultSubmitAndNew ? 'submitAndNew' : 'submitAndClose';
                }
            });

            WidgetsSettingsService.getFormFields(widgetId).then(function(data){
                $scope.formFields = WidgetsSettingsService.parseFormObjects(data.display);
            });
        }
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetsFormsCtrl', ["_", "moment", "$scope", "$location", "$uibModal", "widgetId", "DesignerUtilityService", "FormsDesignerService", "TemplatesServices", "WidgetsService", function WidgetsFormsCtrl(_, moment, $scope, $location, $uibModal, widgetId, DesignerUtilityService,
                                                              FormsDesignerService, TemplatesServices, WidgetsService) {
        /* Populate Scope */
        $scope.widgetPublicKey = widgetId;
        $scope.widgetModel = {};
        $scope.activeRoute = 'forms';
        $scope.formArray = [];
        $scope.predicate1 = 'name';
        $scope.reverse1 = false;

        /* Forms Logic */
        $scope.openFormDesigner = function (widgetId, formId) {
            $location.url('/settings/widgets/' + widgetId + '/forms/' + formId);
        };

        $scope.openFormModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/forms/form-modal.tpl.html',
                controller: 'FormModalCtrl',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    form: function (){
                        return {
                            templateId: '',
                            name: '',
                            description: ''
                        };
                    }
                }
            });
            modalInstance.result.then(function (data) {
                FormsDesignerService.create(data, $scope.widgetPublicKey).then(function(){
                    $scope.init();
                });
            });
        };
        $scope.init = function(){
            WidgetsService.getAllForms($scope.widgetPublicKey).then(function(formArray){
                $scope.formArray = formArray;

                _.forEach(formArray, function(form){
                    form.lastModified = moment.utc(form.lastModified, 'MMMM, DD YYYY HH:mm:ss').toDate();
                });
            });

            // Still needed, for now, to get the widget name and icon for the title
            WidgetsService.getWidget($scope.widgetPublicKey).then(function(widgetModel){
                $scope.widgetModel = angular.copy(widgetModel);
            });
        };
        $scope.init();
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetsImportsCtrl', ["_", "$scope", "moment", "$location", "$timeout", "widgetId", "ImportService", "WidgetsService", "WidgetsSettingsService", function WidgetsImportsCtrl(_, $scope, moment, $location, $timeout, widgetId, ImportService, WidgetsService, WidgetsSettingsService) {

        /* Populate Scope */
        $scope.widgetPublicKey = widgetId;
        $scope.widgetModel = {};
        $scope.importSettingsArray = [];
        $scope.importJobs = [];
        $scope.formFieldsArray = [];
        $scope.activeRoute = 'imports';
        $scope.newImportCollapse = true;

        /*
         * Import Functions and Settings
         */
        $scope.deleteImportConfig = function(id){
            ImportService.deleteConfig(id).then(function(){
                for(var i = 0; i < $scope.importSettingsArray.length; i++ ){
                    if($scope.importSettingsArray[i].id === id){
                        $scope.importSettingsArray.splice(i,1);
                        break;
                    }
                }
            });
        };
        $scope.goToImportSettings = function(id){
            if(id){
                $location.url('/settings/widgets/' + $scope.widgetPublicKey + '/imports/rules/' + id);
            }
            else{
                $location.url('/settings/widgets/' + $scope.widgetPublicKey + '/imports/rules/create');
            }
        };
        $scope.goToImportJobs = function(){
            $location.url('/settings/widgets/' + $scope.widgetPublicKey + '/imports/jobs');
        };

        $scope.rollback = function(item, idx){
            ImportService.rollback(item.id).then(function () {
                $scope.importJobs.splice(idx, 1);
            });
        };
        $scope.deleteJob = function(id, idx){
            ImportService.deleteJob(id).then(function(){
                $scope.importJobs.splice(idx, 1);
            });
        };

        $scope.startImportJob = function(id, idx){
            $scope.importJobs[idx].status = 'Importing';
            ImportService.startImport(id, $scope.importJobs[idx].name).then(function(){
                $timeout(function(){
                    $scope.getListOfAllJobs();
                });
            });
        };

        $scope.validateImport = function(id){
            ImportService.validateImport(id).then(function(){
                $scope.getListOfAllJobs();
            });
        };

        // $scope.validateImport = function(id){
            // ImportService.validateImport(id).then(function(){
                // ImportService.getAllJobs($scope.widgetPublicKey).then(function(importJobs){
                    // $scope.importJobs = angular.copy(importJobs);
                    // _.forEach($scope.importJobs, function(impJob){
                        // impJob.date = moment.utc(impJob.date, 'MMMM, DD YYYY HH:mm:ss').toDate();
                        // impJob.validateDate = moment.utc(impJob.validateDate, 'MMMM, DD YYYY HH:mm:ss').toDate();
                    // });
                // });
            // });
        // };

        $scope.getListOfAllJobs = function (){
            ImportService.getAllJobs(widgetId).then(function(importJobs){
                $scope.importJobs = angular.copy(importJobs);
                _.forEach($scope.importJobs, function(impJob){
                    impJob.date = moment.utc(impJob.date, 'MMMM, DD YYYY HH:mm:ss').toDate();
                    impJob.validateDate = moment.utc(impJob.validateDate, 'MMMM, DD YYYY HH:mm:ss').toDate();
                });
            });
        };

        $scope.refreshAll = function (){
            $scope.getListOfAllJobs();
        };

        _init();

        function _init(){
            WidgetsService.getWidget(widgetId).then(function(widgetModel){
                $scope.widgetModel = widgetModel;
            });

            ImportService.getAllSettings(widgetId).then(function(importSettings){
                $scope.importSettingsArray = importSettings;
            });

            $scope.getListOfAllJobs();

            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldsArray){
                $scope.formFieldsArray = formFieldsArray;
            });
        }
    }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name ImportExchangeService
 * @alias cerberus/widgets:ImportExchangeService
 * @description Provides REST service for "import exchange server" resource
 */
    .factory('ImportExchangeService', ["_", "$http", "$q", "apiPath", function ImportExchangeService(_, $http, $q, apiPath) {
        var connectionError = 'Looks like the Connection failed. Try the action again or refresh the page.';
        return {
            getExchangeData: getExchangeData
        };
        ////////////////////

        /**
         * Makes a get call REST api "views/{id}/details" resource
         * @function getExchangeData
         * @param {string} id - exchange server id
         * @param {string} type - type of data
         * @return {promise}
         */
        function getExchangeData(id,type) {
            var deferred = $q.defer();
            $http.get(apiPath + 'exchange/server/' + id + '?type=' + type)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(
                        _.get(reason, 'MESSAGE', connectionError)
                    );
                });
            return deferred.promise;
        }

    }])
;

angular.module('cerberus.admin')
    .controller('WidgetsImportsJobsCtrl',
    ["_", "$window", "$location", "$timeout", "authToken", "widgetId", "workspaceId", "ImportService", "ImportExchangeService", "usersProfileService", function WidgetsImportsJobsCtrl(_, $window, $location, $timeout, authToken, widgetId, workspaceId,
                                    ImportService, ImportExchangeService, usersProfileService) {
            var vm = this;

            vm.importSettingsArray = [];
            vm.importJobModel = {
                jsonData: {},
                validate: true
            };
            vm.widgetPublicKey = widgetId;
            vm.importSource = null;
            vm.mailServers = [];
            vm.errors = null;

            vm.changeSource = function(){
                for(var i = 0; i < vm.importSettingsArray.length; i++){
                    if(vm.importJobModel.importSettingId == vm.importSettingsArray[i].id){
                        vm.importSource = vm.importSettingsArray[i].type;
                    }
                }
                if(vm.importSource.substring(0,8) === 'exchange'){
                    usersProfileService.getAll('Mail Server').then(function(data){
                       vm.mailServers = data;
                    });
                }
            };
            vm.getExchangeData = function(id,importSource){
                if(id){
                    ImportExchangeService.getExchangeData(id,importSource).then(function(data){
                        vm.importJobModel.jsonData.exchangeData = data;
                    });
                }
                else{
                    vm.importJobModel.jsonData.exchangeData = [];
                }
            };
            vm.submit = function(isValid){
                if(isValid){
                    ImportService.createImportJob(vm.widgetPublicKey,vm.importJobModel).then(function(){
                        $location.url('/settings/widgets/' + vm.widgetPublicKey + '/imports');
                    });
                }
            };
            vm.asyncOptions = {
                saveUrl: '/server/rest/v1/widgets/' + vm.widgetPublicKey + '/import/jobs',
                removeUrl: 'remove',
                autoUpload: false
            };
            vm.localizationOptions = {
                uploadSelectedFiles: 'Submit'
            };

            vm.onUpload = function(e) {
                delete vm.importJobModel.jsonData;
                e.data = vm.importJobModel;
                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener("readystatechange", function () {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader('Authentication','Bearer ' + authToken);
                            xhr.setRequestHeader('WSID', workspaceId);
                            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest ');
                        }
                    });
                }
            };
            vm.onError = function(e){
                $timeout(function(){
                    var resp = angular.fromJson(e.XMLHttpRequest.response);
                    vm.errors = _.get(resp, 'DATA.message', '');
                });
            };
            vm.onSuccess = function (){
                $timeout(function(){
                    vm.errors = null;
                    $location.url('/settings/widgets/' + vm.widgetPublicKey + '/imports');
                });
            };
            vm.cancel = function () {
                $location.url('/settings/widgets/' + vm.widgetPublicKey + '/imports');
            };

            //Init function
            _init();
            ////////////////////
            /**
             * Init controller data and server calls
             */
            function _init() {
                ImportService.getAllSettings(widgetId).then(function(d){
                    vm.importSettingsArray = d;
                });
            }
        }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name ImportListService
 * @alias cerberus/widgets:ImportListService
 * @description Provides REST service for "imports list" resource
 */
    .factory('ImportListService', function ImportListService() {
        var exchangeTypes = {
            exchangeContact:[
                'Assistant',
                'BusinessAddress',
                'BusinessPhoneNumber',
                'Categories',
                'Company',
                'Department',
                'Description',
                'DisplayAs',
                'Email1',
                'Email2',
                'Email3',
                'FirstName',
                'HomeAddress',
                'HomePhoneNumber',
                'HtmlDescription',
                'JobTitle',
                'LastName',
                'Manager',
                'MiddleName',
                'MobilePhoneNumber',
                'NickName',
                'Office',
                'OtherAddress',
                'OtherPhoneNumber',
                'Pager',
                'Profession',
                'SpouseName',
                'WebPage',
                'businessFax',
                'mailingAddressType'
            ],
            exchangeTask:[
                'ActualWork',
                'BillingInfo',
                'Categories',
                'Companies',
                'DateCompleted',
                'DueDate',
                'HTMLMessage',
                'Message',
                'Mileage',
                'PercentCompleted',
                'Priority',
                'ReminderDate',
                'StartDate',
                'Status',
                'Subject',
                'TotalWork'
            ],
            exchangeCalendar:[
                'AllDayEvent',
                'Categories',
                'Duration',
                'EndTime',
                'Importance',
                'IsRecurring',
                'Label',
                'Location',
                'Message',
                'OptionalAttendees',
                'Organizer',
                'RequiredAttendees',
                'Resources',
                'Sensitivity',
                'StartTime',
                'Subject'
            ]
        };

        return {
            getConfigTypes: getConfigTypes,
            getTypeColumns:getTypeColumns
        };
        ////////////////////

        /**
         * This function gets all the different config types
         * @function getConfigTypes
         * @return {object[]} types
         */
        function getConfigTypes() {
            return [
                {
                    display: 'CSV',
                    value: 'csv'
                },
                {
                    display:'Exchange Contacts',
                    value: 'exchangeContact'
                },
                {
                    display:'Exchange Tasks',
                    value: 'exchangeTask'
                },
                {
                    display:'Exchange Calendar',
                    value: 'exchangeCalendar'
                },
                {
                    display:'Files',
                    value: 'files'
                }
            ];
        }

        /**
         * This function gets all the columns for a specific type
         * @function getExchangeColumns
         * @return {object} cols
         */
        function getTypeColumns() {
            return exchangeTypes;
        }

    })
;

angular.module('cerberus.admin')
    .controller('WidgetsImportsRulesCreateCtrl', ["$scope", "$location", "widgetId", "ImportService", "ImportListService", "WidgetsSettingsService", function WidgetsImportsRulesCreateCtrl($scope, $location, widgetId,
                                                                                        ImportService, ImportListService, WidgetsSettingsService) {
        $scope.widgetId = widgetId;
        $scope.tempImportSettings = {
            map:[],
            name:'',
            description:'',
            type:'csv',
            ignoreExtraColumns: true
        };
        $scope.origImportSettings = angular.copy($scope.tempImportSettings);
        $scope.forms = [];
        $scope.types = ImportListService.getConfigTypes();
        $scope.typeColumns = ImportListService.getTypeColumns() || {};
        $scope.input = {
            fieldMap:null,
            colHeader:null
        };

        $scope.setPrimaryKey = function(importSetArray,index){
            if(importSetArray[index].primaryKey){
                for(var i = 0; i < importSetArray.length; i++){
                    if(i != index){
                        importSetArray[i].primaryKey = false;
                    }
                }
            }
        };

        $scope.setAppendUpdate = function(importSetArray,index){
            if(importSetArray[index].appendUpdateKey){
                for(var i = 0; i < importSetArray.length; i++){
                    if(i != index){
                        importSetArray[i].appendUpdateKey = false;
                    }
                }
            }
        };

        $scope.onTypeChange = function(importSettings){
            if(importSettings.type === 'files'){
                importSettings.map[0] = {};
                importSettings.map[1] = {
                    modelId: 'sys_created_date',
                    colHeader:null
                };
                importSettings.map[2] = {
                    modelId:'client_file_name',
                    colHeader:null
                };
                importSettings.map[3] = {
                    modelId:'sys_created_by',
                    colHeader:null
                };
            }
            else{
                importSettings.map = [];
            }
        };

        $scope.addFieldMap = function(fieldMap,hdr){
            if(!$scope.tempImportSettings.map){
                $scope.tempImportSettings.map = [];
            }

            if($scope.tempImportSettings.map.map(function(e) { return e.colHeader; }).indexOf(hdr) === -1){
                var d = fieldMap;
                d.colHeader = hdr;
                $scope.tempImportSettings.map.push(d);
            }
            $scope.input = {
                fieldMap:null,
                colHeader:null
            };
        };

        $scope.isEqual = function(){
            return angular.equals($scope.tempImportSettings, $scope.origImportSettings);
        };

        $scope.removeFieldMap = function(index){
            $scope.tempImportSettings.map.splice(index,1);
        };

        $scope.cancel = function () {
            $location.url('/settings/widgets/' + $scope.widgetId + '/imports');
        };
        $scope.submit = function(isValid, data){
            if(isValid){
                ImportService.create($scope.widgetId,data).then(function(){
                    $location.url('/settings/widgets/' + $scope.widgetId + '/imports');
                });
            }
        };

        _init();

        function _init(){
            WidgetsSettingsService.getFormFields(widgetId).then(function (d) {
                $scope.forms = WidgetsSettingsService.parseFormObjects(d.display);
            });
        }
    }])
;
angular.module('cerberus.admin')
    .controller('WidgetsImportsRulesDetailsCtrl', ["$scope", "$location", "widgetId", "importRuleId", "ImportService", "ImportListService", "WidgetsSettingsService", function WidgetsImportsRulesDetailsCtrl($scope, $location, widgetId, importRuleId,
                                                                                          ImportService, ImportListService, WidgetsSettingsService) {
        $scope.widgetId = widgetId;
        $scope.importSettingsId = importRuleId;
        $scope.tempImportSettings = {};
        $scope.origImportSettings = {};
        $scope.forms = [];
        $scope.types = ImportListService.getConfigTypes();
        $scope.typeColumns = ImportListService.getTypeColumns() || {};
        $scope.input = {
            fieldMap:null,
            colHeader:null
        };

        $scope.setPrimaryKey = function(importSetArray,index){
            if(importSetArray[index].primaryKey){
                for(var i = 0; i < importSetArray.length; i++){
                    if(i != index){
                        importSetArray[i].primaryKey = false;
                    }
                }
            }
        };

        $scope.setAppendUpdate = function(importSetArray,index){
            if(importSetArray[index].appendUpdateKey){
                for(var i = 0; i < importSetArray.length; i++){
                    if(i != index){
                        importSetArray[i].appendUpdateKey = false;
                    }
                }
            }
        };

        $scope.onTypeChange = function(importSettings){
            if(importSettings.type === 'files'){
                importSettings.map[0] = {};
                importSettings.map[1] = {
                    modelId: 'sys_created_date',
                    colHeader:null
                };
                importSettings.map[2] = {
                    modelId:'client_file_name',
                    colHeader:null
                };
                importSettings.map[3] = {
                    modelId:'sys_created_by',
                    colHeader:null
                };
            }
            else{
                importSettings.map = [];
            }
        };

        $scope.addFieldMap = function(fieldMap,hdr){
            if(!$scope.tempImportSettings.map){
                $scope.tempImportSettings.map = [];
            }

            if($scope.tempImportSettings.map.map(function(e) { return e.colHeader; }).indexOf(hdr) === -1){
                var d = fieldMap;
                d.colHeader = hdr;
                $scope.tempImportSettings.map.push(d);
            }
            $scope.input = {
                fieldMap:null,
                colHeader:null
            };
        };

        $scope.isEqual = function(){
            return angular.equals($scope.tempImportSettings, $scope.origImportSettings);
        };

        $scope.removeFieldMap = function(index){
            $scope.tempImportSettings.map.splice(index,1);
        };

        $scope.cancel = function () {
            $location.url('/settings/widgets/' + $scope.widgetId + '/imports');
        };
        $scope.submit = function(isValid, data){
            if(isValid){
                ImportService.update($scope.importSettingsId,data).then(function(){
                    $location.url('/settings/widgets/' + $scope.widgetId + '/imports');
                });
            }
        };

        _init();

        function _init(){
            ImportService.getSetting(importRuleId).then(function(importSettings){
                $scope.tempImportSettings = angular.copy(importSettings);
                $scope.origImportSettings = angular.copy(importSettings);
            });

            WidgetsSettingsService.getFormFields(widgetId).then(function (d) {
                $scope.forms = WidgetsSettingsService.parseFormObjects(d.display);
            });
        }
    }])
;
angular.module('cerberus.admin')
    .factory('ImportService', ["$http", "$q", "apiPath", "toaster", "ImportListService", function ImportService($http, $q, apiPath, toaster, ImportListService) {
            /** @public */
            return {
                create: function(id,data){
                    var deferred = $q.defer();
                    $http.post(apiPath + 'widgets/' + id + '/import/settings',data)
                        .success(function (value) {
                            toaster.pop('success', 'Import settings has been created.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                getAllSettings: function(id, exclusivePermissions){
                    var findDisplay = function(typesArray,type){
                        return typesArray.map(function(e) { return e.value; }).indexOf(type);
                    };

                    var deferred = $q.defer();
                    var params = {
                        $exclPermissions: exclusivePermissions || false
                    };
                    $http.get(apiPath + 'widgets/' + id + '/import/settings',{params:params})
                        .success(function (value) {
                            var types = ImportListService.getConfigTypes();
                            var d = value.DATA;
                            for(var i = 0; i < d.length; i++){
                                var idx = findDisplay(types,d[i].type);
                                d[i].typeDisplay = types[idx].display;
                            }
                            deferred.resolve(d);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                getAllJobs: function(id, exclusivePermissions){
                    var deferred = $q.defer();
                    var params = {
                        $exclPermissions: exclusivePermissions || false
                    };
                    $http.get(apiPath + 'widgets/' + id + '/import/jobs',{params:params})
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                getSetting: function(id){
                    var deferred = $q.defer();
                    $http.get(apiPath + 'import/settings/' + id)
                        .success(function (value) {
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                update: function(id,data){
                    var deferred = $q.defer();
                    $http.put(apiPath + 'import/settings/' + id,data)
                        .success(function (value) {
                            toaster.pop('success', 'Import settings has been updated.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                startImport: function(id,name,exclusivePermissions){
                    var deferred = $q.defer();
                    var params = {
                        $exclPermissions: exclusivePermissions || false
                    };
                    $http.put(apiPath + 'import/jobs/' + id,{$exclPermissions:params.$exclPermissions})
                        .success(function (value) {
                            toaster.pop('success', 'Import job: ' + name + ' has been started.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                deleteJob: function (id, exclusivePermissions) {
                    var deferred = $q.defer();
                    var params = {
                        $exclPermissions: exclusivePermissions || false
                    };
                    $http({method: 'DELETE', url: apiPath + 'import/jobs/' + id, params: params})
                        .success(function(value){
                            toaster.pop('info', 'Import job has been deleted.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function(reason){
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                validateImport: function(id, exclusivePermissions){
                    var deferred = $q.defer();
                    var params = {
                        $exclPermissions: exclusivePermissions || false
                    };
                    $http.put(apiPath + 'import/jobs/' + id + '/validate',{$exclPermissions:params.$exclPermissions})
                        .success(function (value) {
                            toaster.pop('success', 'Import job has been validated.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                rollback: function(id, exclusivePermissions){
                    var deferred = $q.defer();
                    var params = {
                        $exclPermissions: exclusivePermissions || false
                    };
                    $http.put(apiPath + 'imports/' + id +'/rollback',{$exclPermissions:params.$exclPermissions})
                        .success(function (value) {
                            toaster.pop('success', 'Import job has been rolled back.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                deleteConfig: function (id) {
                    var deferred = $q.defer();
                    $http({method: 'DELETE', url: apiPath + 'import/settings/' + id})
                        .success(function(value){
                            toaster.pop('info', 'Import configuration has been deleted.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function(reason){
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                },
                createImportJob: function(id,data){
                    var deferred = $q.defer();
                    $http.post(apiPath + 'widgets/' + id + '/import/jobs',data)
                        .success(function (value) {
                            toaster.pop('success', 'Import Job has been created.');
                            deferred.resolve(value.DATA);
                        })
                        .error(function (reason) {
                            deferred.reject(reason);
                        });
                    return deferred.promise;
                }
            };
        }])
;

angular.module('cerberus.admin')
    .controller('WidgetsWorkflowCtrl', ["$scope", "$location", "widgetId", "WidgetsService", "WorkflowsService", "WorkflowDiagramService", function WidgetsWorkflowCtrl($scope, $location, widgetId, WidgetsService, WorkflowsService, WorkflowDiagramService) {
        /* Populate Scope */
        $scope.widgetPublicKey = widgetId;
        $scope.widgetModel = {};
        $scope.activeRoute = 'workflow';

        /* Workflow Logic */
        $scope.openWorkflowDesigner = function (widgetId, workflowId) {
            $location.url('/settings/widgets/' + widgetId + '/workflow/' + workflowId);
        };

        init();

        ////////////////////

        function init() {
            WidgetsService.getWidget($scope.widgetPublicKey).then(function(widgetModel){
                $scope.widgetModel = widgetModel;

                WorkflowsService.getPublishedWorkflow(widgetModel.workflow.originatorId).then(function(data){
                    $scope.workflow = data.workflow;
                    $scope.diagramOptions = WorkflowDiagramService.buildWFDiagram($scope, 'workflow', true);
                });
            });
        }

    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizClassService
     * @alias cerberus/core:VizClassService
     * @description
     *   Constructs Viz classes
     */
    .factory('VizClassService', function VizClassService() {
        /**
         * Constructs a new Viz
         * @class Viz
         * @classdesc describes a Viz
         * @memberOf VizClassService
         * @param {string} type
         * @param {string} subType
         * @param {string} template
         * @param {Object} settings
         */
        function Viz(type, subType, template, settings) {
            this.type = type;
            this.subType = subType;
            this.template = template;
            this.settings = settings;
        }

        return {
            viz: Viz,
            newViz: newViz
        };
        ////////////////////

        /**
         * Builds a viz
         * @function newViz
         * @returns {Viz}
         */
        function newViz() {
            return new Viz(null, null, null, {});
        }

    })
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name vizListService
     * @alias cerberus/viz:vizListService
     * @description Provides UI Lists for the designer modules
     */
    .factory('vizListService', ["_", function vizListService(_) {
        return {
            vizDictionary: vizDictionary,
            colorbrewer: colorbrewer,
            colorbrewerDataTypes: colorbrewerDataTypes,
            colorbrewerDataTypeSizes: colorbrewerDataTypeSizes
        };
        ////////////////////
        /**
         * @function vizTypes
         * @return {object} an object of viz types
         */
        function vizDictionary() {
            return {
                chart: {
                    name: 'Chart',
                    subTypes: {
                        area: {
                            name: 'Area Chart'
                        },
                        bar: {
                            name: 'Bar Chart'
                        },
                        bubble: {
                            name: 'Bubble Chart'
                        },
                        bullet: {
                            name: 'Bullet Chart',
                            templates: {
                                sales01: {
                                    name: 'Sales Comparison 1'
                                },
                                sales02: {
                                    name: 'Sales Comparison 2'
                                }
                            }
                        },
                        donut: {
                            name: 'Donut Chart'
                        },
                        line: {
                            name: 'Line Chart'
                        },
                        pie: {
                            name: 'Pie Chart'
                        },
                        scatter: {
                            name: 'Scatter (x,y) Chart'
                        }
                    }
                },
                map: {
                    name: 'Map'
                },
                progress: {
                    name: 'Progress Bar'
                },
                schedule: {
                    name: 'Schedule',
                    subTypes: {
                        gantt: {
                            name: 'Gantt'
                        },
                        calendar: {
                            name: 'Calendar'
                        }
                    }
                },
                table: {
                    name: 'Table'
                },
                template: {
                    name: 'Custom Template'
                },
                list: {
                    name: 'List'
                },
                kanban: {
                    name: 'Kanban'
                }
            };
        }

        /**
         * @function colorbrewer
         * @returns {Object} - map of colorbrewer palettes
         */
        function colorbrewer() {
            return {
                sequential: {
                    BuGn: {
                        3: ["#e5f5f9", "#99d8c9", "#2ca25f"],
                        4: ["#edf8fb", "#b2e2e2", "#66c2a4", "#238b45"],
                        5: ["#edf8fb", "#b2e2e2", "#66c2a4", "#2ca25f", "#006d2c"],
                        6: ["#edf8fb", "#ccece6", "#99d8c9", "#66c2a4", "#2ca25f", "#006d2c"],
                        7: ["#edf8fb", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#005824"],
                        8: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#005824"],
                        9: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"]
                    }, BuPu: {
                        3: ["#e0ecf4", "#9ebcda", "#8856a7"],
                        4: ["#edf8fb", "#b3cde3", "#8c96c6", "#88419d"],
                        5: ["#edf8fb", "#b3cde3", "#8c96c6", "#8856a7", "#810f7c"],
                        6: ["#edf8fb", "#bfd3e6", "#9ebcda", "#8c96c6", "#8856a7", "#810f7c"],
                        7: ["#edf8fb", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#6e016b"],
                        8: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#6e016b"],
                        9: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"]
                    }, GnBu: {
                        3: ["#e0f3db", "#a8ddb5", "#43a2ca"],
                        4: ["#f0f9e8", "#bae4bc", "#7bccc4", "#2b8cbe"],
                        5: ["#f0f9e8", "#bae4bc", "#7bccc4", "#43a2ca", "#0868ac"],
                        6: ["#f0f9e8", "#ccebc5", "#a8ddb5", "#7bccc4", "#43a2ca", "#0868ac"],
                        7: ["#f0f9e8", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#08589e"],
                        8: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#08589e"],
                        9: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"]
                    }, OrRd: {
                        3: ["#fee8c8", "#fdbb84", "#e34a33"],
                        4: ["#fef0d9", "#fdcc8a", "#fc8d59", "#d7301f"],
                        5: ["#fef0d9", "#fdcc8a", "#fc8d59", "#e34a33", "#b30000"],
                        6: ["#fef0d9", "#fdd49e", "#fdbb84", "#fc8d59", "#e34a33", "#b30000"],
                        7: ["#fef0d9", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#990000"],
                        8: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#990000"],
                        9: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"]
                    }, PuBu: {
                        3: ["#ece7f2", "#a6bddb", "#2b8cbe"],
                        4: ["#f1eef6", "#bdc9e1", "#74a9cf", "#0570b0"],
                        5: ["#f1eef6", "#bdc9e1", "#74a9cf", "#2b8cbe", "#045a8d"],
                        6: ["#f1eef6", "#d0d1e6", "#a6bddb", "#74a9cf", "#2b8cbe", "#045a8d"],
                        7: ["#f1eef6", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#034e7b"],
                        8: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#034e7b"],
                        9: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"]
                    }, PuBuGn: {
                        3: ["#ece2f0", "#a6bddb", "#1c9099"],
                        4: ["#f6eff7", "#bdc9e1", "#67a9cf", "#02818a"],
                        5: ["#f6eff7", "#bdc9e1", "#67a9cf", "#1c9099", "#016c59"],
                        6: ["#f6eff7", "#d0d1e6", "#a6bddb", "#67a9cf", "#1c9099", "#016c59"],
                        7: ["#f6eff7", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016450"],
                        8: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016450"],
                        9: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"]
                    }, PuRd: {
                        3: ["#e7e1ef", "#c994c7", "#dd1c77"],
                        4: ["#f1eef6", "#d7b5d8", "#df65b0", "#ce1256"],
                        5: ["#f1eef6", "#d7b5d8", "#df65b0", "#dd1c77", "#980043"],
                        6: ["#f1eef6", "#d4b9da", "#c994c7", "#df65b0", "#dd1c77", "#980043"],
                        7: ["#f1eef6", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#91003f"],
                        8: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#91003f"],
                        9: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"]
                    }, RdPu: {
                        3: ["#fde0dd", "#fa9fb5", "#c51b8a"],
                        4: ["#feebe2", "#fbb4b9", "#f768a1", "#ae017e"],
                        5: ["#feebe2", "#fbb4b9", "#f768a1", "#c51b8a", "#7a0177"],
                        6: ["#feebe2", "#fcc5c0", "#fa9fb5", "#f768a1", "#c51b8a", "#7a0177"],
                        7: ["#feebe2", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177"],
                        8: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177"],
                        9: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"]
                    }, YlGn: {
                        3: ["#f7fcb9", "#addd8e", "#31a354"],
                        4: ["#ffffcc", "#c2e699", "#78c679", "#238443"],
                        5: ["#ffffcc", "#c2e699", "#78c679", "#31a354", "#006837"],
                        6: ["#ffffcc", "#d9f0a3", "#addd8e", "#78c679", "#31a354", "#006837"],
                        7: ["#ffffcc", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#005a32"],
                        8: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#005a32"],
                        9: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"]
                    }, YlGnBu: {
                        3: ["#edf8b1", "#7fcdbb", "#2c7fb8"],
                        4: ["#ffffcc", "#a1dab4", "#41b6c4", "#225ea8"],
                        5: ["#ffffcc", "#a1dab4", "#41b6c4", "#2c7fb8", "#253494"],
                        6: ["#ffffcc", "#c7e9b4", "#7fcdbb", "#41b6c4", "#2c7fb8", "#253494"],
                        7: ["#ffffcc", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#0c2c84"],
                        8: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#0c2c84"],
                        9: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"]
                    }, YlOrBr: {
                        3: ["#fff7bc", "#fec44f", "#d95f0e"],
                        4: ["#ffffd4", "#fed98e", "#fe9929", "#cc4c02"],
                        5: ["#ffffd4", "#fed98e", "#fe9929", "#d95f0e", "#993404"],
                        6: ["#ffffd4", "#fee391", "#fec44f", "#fe9929", "#d95f0e", "#993404"],
                        7: ["#ffffd4", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#8c2d04"],
                        8: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#8c2d04"],
                        9: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"]
                    }, YlOrRd: {
                        3: ["#ffeda0", "#feb24c", "#f03b20"],
                        4: ["#ffffb2", "#fecc5c", "#fd8d3c", "#e31a1c"],
                        5: ["#ffffb2", "#fecc5c", "#fd8d3c", "#f03b20", "#bd0026"],
                        6: ["#ffffb2", "#fed976", "#feb24c", "#fd8d3c", "#f03b20", "#bd0026"],
                        7: ["#ffffb2", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#b10026"],
                        8: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#b10026"],
                        9: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"]
                    }, Blues: {
                        3: ["#deebf7", "#9ecae1", "#3182bd"],
                        4: ["#eff3ff", "#bdd7e7", "#6baed6", "#2171b5"],
                        5: ["#eff3ff", "#bdd7e7", "#6baed6", "#3182bd", "#08519c"],
                        6: ["#eff3ff", "#c6dbef", "#9ecae1", "#6baed6", "#3182bd", "#08519c"],
                        7: ["#eff3ff", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#084594"],
                        8: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#084594"],
                        9: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"]
                    }, Greens: {
                        3: ["#e5f5e0", "#a1d99b", "#31a354"],
                        4: ["#edf8e9", "#bae4b3", "#74c476", "#238b45"],
                        5: ["#edf8e9", "#bae4b3", "#74c476", "#31a354", "#006d2c"],
                        6: ["#edf8e9", "#c7e9c0", "#a1d99b", "#74c476", "#31a354", "#006d2c"],
                        7: ["#edf8e9", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#005a32"],
                        8: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#005a32"],
                        9: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"]
                    }, Greys: {
                        3: ["#f0f0f0", "#bdbdbd", "#636363"],
                        4: ["#f7f7f7", "#cccccc", "#969696", "#525252"],
                        5: ["#f7f7f7", "#cccccc", "#969696", "#636363", "#252525"],
                        6: ["#f7f7f7", "#d9d9d9", "#bdbdbd", "#969696", "#636363", "#252525"],
                        7: ["#f7f7f7", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525"],
                        8: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525"],
                        9: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"]
                    }, Oranges: {
                        3: ["#fee6ce", "#fdae6b", "#e6550d"],
                        4: ["#feedde", "#fdbe85", "#fd8d3c", "#d94701"],
                        5: ["#feedde", "#fdbe85", "#fd8d3c", "#e6550d", "#a63603"],
                        6: ["#feedde", "#fdd0a2", "#fdae6b", "#fd8d3c", "#e6550d", "#a63603"],
                        7: ["#feedde", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#8c2d04"],
                        8: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#8c2d04"],
                        9: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"]
                    }, Purples: {
                        3: ["#efedf5", "#bcbddc", "#756bb1"],
                        4: ["#f2f0f7", "#cbc9e2", "#9e9ac8", "#6a51a3"],
                        5: ["#f2f0f7", "#cbc9e2", "#9e9ac8", "#756bb1", "#54278f"],
                        6: ["#f2f0f7", "#dadaeb", "#bcbddc", "#9e9ac8", "#756bb1", "#54278f"],
                        7: ["#f2f0f7", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#4a1486"],
                        8: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#4a1486"],
                        9: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"]
                    }, Reds: {
                        3: ["#fee0d2", "#fc9272", "#de2d26"],
                        4: ["#fee5d9", "#fcae91", "#fb6a4a", "#cb181d"],
                        5: ["#fee5d9", "#fcae91", "#fb6a4a", "#de2d26", "#a50f15"],
                        6: ["#fee5d9", "#fcbba1", "#fc9272", "#fb6a4a", "#de2d26", "#a50f15"],
                        7: ["#fee5d9", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#99000d"],
                        8: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#99000d"],
                        9: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"]
                    }
                },
                diverging: {
                    BrBG: {
                        3: ["#d8b365", "#f5f5f5", "#5ab4ac"],
                        4: ["#a6611a", "#dfc27d", "#80cdc1", "#018571"],
                        5: ["#a6611a", "#dfc27d", "#f5f5f5", "#80cdc1", "#018571"],
                        6: ["#8c510a", "#d8b365", "#f6e8c3", "#c7eae5", "#5ab4ac", "#01665e"],
                        7: ["#8c510a", "#d8b365", "#f6e8c3", "#f5f5f5", "#c7eae5", "#5ab4ac", "#01665e"],
                        8: ["#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#c7eae5", "#80cdc1", "#35978f", "#01665e"],
                        9: ["#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e"],
                        10: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
                        11: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"]
                    }, PiYG: {
                        3: ["#e9a3c9", "#f7f7f7", "#a1d76a"],
                        4: ["#d01c8b", "#f1b6da", "#b8e186", "#4dac26"],
                        5: ["#d01c8b", "#f1b6da", "#f7f7f7", "#b8e186", "#4dac26"],
                        6: ["#c51b7d", "#e9a3c9", "#fde0ef", "#e6f5d0", "#a1d76a", "#4d9221"],
                        7: ["#c51b7d", "#e9a3c9", "#fde0ef", "#f7f7f7", "#e6f5d0", "#a1d76a", "#4d9221"],
                        8: ["#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221"],
                        9: ["#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221"],
                        10: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
                        11: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"]
                    }, PRGn: {
                        3: ["#af8dc3", "#f7f7f7", "#7fbf7b"],
                        4: ["#7b3294", "#c2a5cf", "#a6dba0", "#008837"],
                        5: ["#7b3294", "#c2a5cf", "#f7f7f7", "#a6dba0", "#008837"],
                        6: ["#762a83", "#af8dc3", "#e7d4e8", "#d9f0d3", "#7fbf7b", "#1b7837"],
                        7: ["#762a83", "#af8dc3", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#7fbf7b", "#1b7837"],
                        8: ["#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837"],
                        9: ["#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837"],
                        10: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
                        11: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"]
                    }, PuOr: {
                        3: ["#f1a340", "#f7f7f7", "#998ec3"],
                        4: ["#e66101", "#fdb863", "#b2abd2", "#5e3c99"],
                        5: ["#e66101", "#fdb863", "#f7f7f7", "#b2abd2", "#5e3c99"],
                        6: ["#b35806", "#f1a340", "#fee0b6", "#d8daeb", "#998ec3", "#542788"],
                        7: ["#b35806", "#f1a340", "#fee0b6", "#f7f7f7", "#d8daeb", "#998ec3", "#542788"],
                        8: ["#b35806", "#e08214", "#fdb863", "#fee0b6", "#d8daeb", "#b2abd2", "#8073ac", "#542788"],
                        9: ["#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788"],
                        10: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
                        11: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"]
                    }, RdBu: {
                        3: ["#ef8a62", "#f7f7f7", "#67a9cf"],
                        4: ["#ca0020", "#f4a582", "#92c5de", "#0571b0"],
                        5: ["#ca0020", "#f4a582", "#f7f7f7", "#92c5de", "#0571b0"],
                        6: ["#b2182b", "#ef8a62", "#fddbc7", "#d1e5f0", "#67a9cf", "#2166ac"],
                        7: ["#b2182b", "#ef8a62", "#fddbc7", "#f7f7f7", "#d1e5f0", "#67a9cf", "#2166ac"],
                        8: ["#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac"],
                        9: ["#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac"],
                        10: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
                        11: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"]
                    }, RdGy: {
                        3: ["#ef8a62", "#ffffff", "#999999"],
                        4: ["#ca0020", "#f4a582", "#bababa", "#404040"],
                        5: ["#ca0020", "#f4a582", "#ffffff", "#bababa", "#404040"],
                        6: ["#b2182b", "#ef8a62", "#fddbc7", "#e0e0e0", "#999999", "#4d4d4d"],
                        7: ["#b2182b", "#ef8a62", "#fddbc7", "#ffffff", "#e0e0e0", "#999999", "#4d4d4d"],
                        8: ["#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#e0e0e0", "#bababa", "#878787", "#4d4d4d"],
                        9: ["#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d"],
                        10: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
                        11: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"]
                    }, RdYlBu: {
                        3: ["#fc8d59", "#ffffbf", "#91bfdb"],
                        4: ["#d7191c", "#fdae61", "#abd9e9", "#2c7bb6"],
                        5: ["#d7191c", "#fdae61", "#ffffbf", "#abd9e9", "#2c7bb6"],
                        6: ["#d73027", "#fc8d59", "#fee090", "#e0f3f8", "#91bfdb", "#4575b4"],
                        7: ["#d73027", "#fc8d59", "#fee090", "#ffffbf", "#e0f3f8", "#91bfdb", "#4575b4"],
                        8: ["#d73027", "#f46d43", "#fdae61", "#fee090", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4"],
                        9: ["#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4"],
                        10: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
                        11: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"]
                    }, RdYlGn: {
                        3: ["#fc8d59", "#ffffbf", "#91cf60"],
                        4: ["#d7191c", "#fdae61", "#a6d96a", "#1a9641"],
                        5: ["#d7191c", "#fdae61", "#ffffbf", "#a6d96a", "#1a9641"],
                        6: ["#d73027", "#fc8d59", "#fee08b", "#d9ef8b", "#91cf60", "#1a9850"],
                        7: ["#d73027", "#fc8d59", "#fee08b", "#ffffbf", "#d9ef8b", "#91cf60", "#1a9850"],
                        8: ["#d73027", "#f46d43", "#fdae61", "#fee08b", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850"],
                        9: ["#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850"],
                        10: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
                        11: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"]
                    }, Spectral: {
                        3: ["#fc8d59", "#ffffbf", "#99d594"],
                        4: ["#d7191c", "#fdae61", "#abdda4", "#2b83ba"],
                        5: ["#d7191c", "#fdae61", "#ffffbf", "#abdda4", "#2b83ba"],
                        6: ["#d53e4f", "#fc8d59", "#fee08b", "#e6f598", "#99d594", "#3288bd"],
                        7: ["#d53e4f", "#fc8d59", "#fee08b", "#ffffbf", "#e6f598", "#99d594", "#3288bd"],
                        8: ["#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#e6f598", "#abdda4", "#66c2a5", "#3288bd"],
                        9: ["#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd"],
                        10: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
                        11: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"]
                    }
                },
                qualitative: {
                    Accent: {
                        3: ["#7fc97f", "#beaed4", "#fdc086"],
                        4: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99"],
                        5: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0"],
                        6: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f"],
                        7: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17"],
                        8: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"]
                    }, Dark2: {
                        3: ["#1b9e77", "#d95f02", "#7570b3"],
                        4: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a"],
                        5: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e"],
                        6: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02"],
                        7: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d"],
                        8: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"]
                    }, Paired: {
                        3: ["#a6cee3", "#1f78b4", "#b2df8a"],
                        4: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c"],
                        5: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99"],
                        6: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c"],
                        7: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f"],
                        8: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00"],
                        9: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6"],
                        10: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a"],
                        11: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99"],
                        12: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"]
                    }, Pastel1: {
                        3: ["#fbb4ae", "#b3cde3", "#ccebc5"],
                        4: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4"],
                        5: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6"],
                        6: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc"],
                        7: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd"],
                        8: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec"],
                        9: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
                    }, Pastel2: {
                        3: ["#b3e2cd", "#fdcdac", "#cbd5e8"],
                        4: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4"],
                        5: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9"],
                        6: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae"],
                        7: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc"],
                        8: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"]
                    }, Set1: {
                        3: ["#e41a1c", "#377eb8", "#4daf4a"],
                        4: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3"],
                        5: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00"],
                        6: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33"],
                        7: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628"],
                        8: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf"],
                        9: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"]
                    }, Set2: {
                        3: ["#66c2a5", "#fc8d62", "#8da0cb"],
                        4: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3"],
                        5: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854"],
                        6: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f"],
                        7: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494"],
                        8: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"]
                    }, Set3: {
                        3: ["#8dd3c7", "#ffffb3", "#bebada"],
                        4: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072"],
                        5: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3"],
                        6: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462"],
                        7: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69"],
                        8: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5"],
                        9: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9"],
                        10: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd"],
                        11: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5"],
                        12: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"]
                    }
                }
            };
        }

        function colorbrewerDataTypes(){
            return {
                sequential: 'Numeric',
                diverging: 'Opposing',
                qualitative: 'Categorical'
            };
        }

        function colorbrewerDataTypeSizes(){
            return _.mapValues(colorbrewer(), function(type){
                return _.mapValues(type, function(color){
                    return _.keys(color);
                });
            });
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizMathService
     * @alias cerberus/core:VizMathService
     * @description Provides pedestrian math functions for viz directives
     */
    .factory('VizMathService', function VizMathService() {
        return {
            smartRoundUp: smartRoundUp,
            arrayMax: arrayMax,
            round: round,
            delta: delta,
            isNumber: isNumber,
            toPercentageString: toPercentageString
        };

        ////////////////////

        /**
         * @function smartRoundUp
         * @param {number} number
         * @return {number}
         */
        function smartRoundUp(number) {
            //Double tilda is a bitwise operator to eliminate
            var length = (Math.floor(number) + '').length;
            var factor = Math.pow(10, length - 1);
            return Math.ceil(number/factor)*factor;
        }

        /**
         * @function smartRoundUp
         * @param {Array} array
         * @return {number}
         */
        function arrayMax(array) {
            return Math.max.apply(Math, array);
        }

        /**
         * @function round
         * @param {number} number
         * @param {number} place
         * @return {number}
         */
        function round(number, place) {
            return Math.round(number * place)/place;
        }

        /**
         * @function delta
         * @param {number} previous
         * @param {number} current
         * @return {number}
         */
        function delta(previous, current) {
            return (current / previous) - 1;
        }

        /**
         * @function isNumber
         * @param {any} number
         * @return {boolean}
         */
        function isNumber(number) {
            return typeof number === 'number' && !isNaN(parseFloat(number)) && isFinite(number);
        }

        /**
         * @function toPercentageString
         * @param number
         * @param total
         * @returns {string}
         */
        function toPercentageString(number, total){
            return round(delta(total, number) * 100, 100) + '%';
        }
    })
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizUtilityService
     * @alias cerberus/core:VizUtilityService
     * @description Provides functions for viz directives and configuration
     */
    .factory('VizUtilityService', ["_", "apiPath", "kendo", "moment", "$rootScope", "$location", "$log", "$timeout", "$window", "nimUtilityService", "OdataUtilityService", function VizUtilityService(_, apiPath, kendo, moment, $rootScope, $location, $log, $timeout, $window, nimUtilityService, OdataUtilityService) {
        return {
            createOdataUrl: createOdataUrl,
            subscribeToPageFilters: subscribeToPageFilters,
            setFilter: setFilter,
            buildBaseHttpOptions: buildBaseHttpOptions,
            buildHttpParams: buildHttpParams,
            cleanFilterConfiguration: cleanFilterConfiguration,
            clientSort: clientSort,
            createSortArray: createSortArray,
            formatOrderBy: formatOrderBy,
            buildRecurrenceData: buildRecurrenceData,
            buildAggregateParams: buildAggregateParams,
            parseDateField: parseDateField,
            parseNumberField: parseNumberField,
            isFilterEmpty: isFilterEmpty,
            openPageObjectRoute: openPageObjectRoute,
            setRequestHeaders: setRequestHeaders
        };
        ////////////////////
        /**
         * Create an odata url
         * @function createOdataUrl
         * @param {object} id - pageObject Id
         * @return {string} of an odata url
         */
        function createOdataUrl(id) {
            return apiPath + 'page/objects/' + id + '/odata.svc';
        }

        /**
         * Creates watchers on specific page filters for a pageObject
         * @function subscribeToPageFilters
         * @param {object} filterMap
         * @param {object} scope - angularJs directive scope
         * @param {object} dataSource - viz datasource
         */
        function subscribeToPageFilters(filterMap, scope, dataSource) {
            if(_.size(filterMap) > 0) {
                // On page object load, some filters may already be set
                var filterSet = false;
                angular.forEach(filterMap, function (value, key) {
                    scope.$watch('filters.' + key, function (newValue, oldValue) {
                        //Only fire the callback if there is a newValue
                        //Or if there is an oldValue but no newValue
                        if (newValue || !newValue && oldValue) {
                            setFilter(dataSource, key, value, newValue);
                        }
                    });

                    // Checks if this filter has already been set
                    if(!_.isNull(_.get(scope.filters, key, null))){
                        filterSet = true;
                    }
                });

                if(!filterSet){ // If no filters set when page object is loaded, read without those filters
                    dataSource.read();
                }
            }
            else {
                dataSource.read();
            }
        }
        /**
         * Used as a callback to a pageFilter watcher
         * @function setFilter
         * @param {object} dataSource
         * @param {string} key
         * @param {object} value
         * @param {object} newFilter
         */
        function setFilter(dataSource, key, value, newFilter) {
            //Set filter values
            var filter = angular.copy(newFilter);

            try {
                filter.key = key;        // Mark this filter as originating from the page filter described by key
                for (var i = 0; i < filter.filters.length; i++) {
                    filter.filters[i].field = value;    // Replace "__nimColumn__" with data source's field name

                    if(!filter.filters[i].value && filter.filters[i].value !== 0){
                        filter.filters.splice(i, 1);
                        i--;
                    }
                }
            }
            catch (e) {}

            var dataSourceFilter = dataSource.filter(),         // Original dataSource filters
                allFilters = angular.copy(dataSourceFilter);    // Copy that will be modified and pushed to dataSource

            if(!allFilters){
                allFilters = {
                    filters: [],
                    logic: 'and'
                };
            }

            var pageFilters = _.find(allFilters.filters, 'pageFilter');

            if(!pageFilters){
                pageFilters = {
                    pageFilter: true,
                    logic: 'and',
                    filters: []
                };

                allFilters.filters.push(pageFilters);
            }

            if(allFilters){
                _.remove(pageFilters.filters, 'key', key); // If old filter is from the given page filter, remove it

                //Push new filters
                if(filter){
                    pageFilters.filters.push(filter);
                }
            }
            else{
                allFilters = filter;
            }

            if(!angular.equals(dataSourceFilter, allFilters)) {
                dataSource.filter(allFilters);
            }
        }

        /**
         * Builds options for $http call for datasource read (sans URL parameters)
         * @param {*} pageObject 
         * @param {*} isPreview 
         */
        function buildBaseHttpOptions(pageObject, isPreview) {
            var options = {
                url: apiPath + 'page/objects/' + pageObject.id + '/odata.svc',
                method: 'GET',
                params: {}
            };

            if (isPreview || !pageObject.id) {
                options.url = apiPath + 'page/objects/preview';
                options.method = 'POST';
                options.data = angular.toJson({ pageObject: pageObject });
            }
            
            return options;
        }

        function buildHttpParams(scope, dataSourceOptions, options) {
            var params = {};
            if (dataSourceOptions.serverPaging) {
                params.$inlinecount = 'allpages';

                if (_.get(options, 'data.pageSize')) {
                    params.$top = options.data.pageSize;
                }

                if (_.get(options, 'data.skip')) {
                    params.$skip = options.data.skip;
                }
            }

            if (dataSourceOptions.serverFiltering) {
                var filter = options.data.filter;
                if (!filter) {
                    filter = {
                        logic: 'and',
                        filters: []
                    };
                }

                cleanFilterConfiguration(_.get(filter, 'filters', []));

                if (scope.nimParentId && scope.nimParentLookUp) {
                    filter.filters.push({
                        operator: 'eq',
                        field: scope.nimParentLookUp,
                        value: scope.nimParentId
                    });
                }
                    
                if (!_.isEmpty(filter.filters)) {
                    params.$filter = OdataUtilityService.toOdataFilter(filter);
                }
            }

            if (dataSourceOptions.serverSorting && !_.isEmpty(options.data.sort)) {
                params.$orderBy = formatOrderBy(options.data.sort);
            }

            if (dataSourceOptions.serverAggregates && !_.isEmpty(options.data.aggregate)) {
                buildAggregateParams(params, options.data.aggregate);
            }

            return params;
        }

        // Removes empty filters and escapes "and" and "or"
        function cleanFilterConfiguration(filterArray){
            for(var i = 0; i < filterArray.length;){
                var filterObj = filterArray[i];
                if(_.isString(filterObj.value)){
                    filterObj.value = filterObj.value.replace(' and ', ' \\and ').replace(' or ', ' \\or ');
                }

                if(_.isArray(filterObj.filters)){
                    cleanFilterConfiguration(filterObj.filters);

                    if(filterObj.filters.length === 0){
                        _.pullAt(filterArray, i);
                        continue;
                    }
                    else if(filterObj.filters.length === 1){
                        filterArray[i] = _.head(filterObj.filters);
                    }
                }

                i++;
            }
        }

        /**
         * For sorting data client-side
         * @param data
         * @param sortOptions
         * @returns {Function}
         */
        function clientSort(data, sortOptions) {
            var fields = [],
                dirs = [],
                sortedData = data;
            
            if (_.isArray(sortOptions)) {
                _.forEach(sortOptions, function (opt) {
                    if (opt.field) {
                        fields.push(opt.field);
                        dirs.push(opt.dir || 'asc');
                    }
                });
            }
            else if (sortOptions.field) {
                fields.push(sortOptions.field);
                dirs.push(sortOptions.dir || 'asc');
            }
            
            if (fields.length > 0) {
                /* LODASH MIGRATION HELPER FUNCTION */
                /* LODASH Version 3 & 4 Compatibility Mode */
                if ((_.VERSION).charAt(0) <= 3){ //Detect LODASH version 3 or 4. Function for V4 was renamed from 'sortByOrder' into 'orderBy'
                    //V3 or lower
                    console.log('Upgrade LODASH from V3 to V4 ASAP - ERRCode00DHLD3.2');
                    sortedData = _.sortByOrder(data, fields, dirs);
                } else {
                    //V4 or Higher
                    /* LODASH Version 4 ONLY */
                    sortedData = _.orderBy(data, fields, dirs); // ++ AFTER MIGRATION TO V4 remove helper function with all V3 detect options ++
                }
            }

            return sortedData;
        }

        /**
         * Adds group config to sort config as a work-around for not having server grouping
         * @param dataSourceOptions
         * @returns {Array}
         */
        function createSortArray(dataSourceOptions) {
            var sort = []; // New sort config, which can be an array of objects

            if (_.get(dataSourceOptions, 'group.field')) {
                sort.push(dataSourceOptions.group);
            }
            if(_.isArray(dataSourceOptions.sort)){
                _.forEach(dataSourceOptions.sort, function(sortOpt){
                    // Make sure each sort option has a field
                    if(sortOpt.field){
                        sort.push(sortOpt);
                    }
                });
            }
            else if(_.get(dataSourceOptions, 'sort.field')){
                sort.push(dataSourceOptions.sort);
            }

            return sort;
        }

        /**
         * Builds $orderBy URL parameter
         * @param {Array} sortOpts 
         */
        function formatOrderBy(sortOpts) {
            if (_.isArray(sortOpts)) {
                var sortItems = _.map(sortOpts, sortItemToString);

                return sortItems.join(',');
            }
            else if(_.isObject(sortOpts) && sortOpts.field) {
                return sortItemToString(sortOpts);
            }
            
            return '';
        }

        function sortItemToString(item) {
            var dir = item.dir || 'asc';
            return item.field + ' ' + dir;
        }

        /**
         * Builds $recurrence URL parameter
         * @param pageObject
         * @param scope
         * @param config
         * @returns {string}
         */
        function buildRecurrenceData(pageObject, scope, config){
            // Field the recurrence applies to
            var filterId = pageObject.params.repeatEnabled;
            var filter = scope.filters[filterId];
            if(filterId && filter) {
                var values = [];
                var field;
                // Start date only
                if (filter.value) {
                    values.push(filter.value);
                    field = filter.field;
                }
                // Date Range with start date and [optional] end date
                else if (filter.filters && filter.filters.length && filter.filters[0].value) {
                    for (var i = 0; i < filter.filters.length; i++) {
                        if (filter.filters[i].value) {
                            values.push(filter.filters[i].value);
                        }
                    }
                    field = filter.filters[0].field;
                }
                // No date values, no recurrence
                else {
                    return '';
                }

                // Remove the start/end dates from filters
                for (var j = 0; j < config.filter.filters.length; j++) {
                    var f = config.filter.filters[j];
                    if (f.field === field && f.operator === 'gte' && f.value == values[0]) {
                        config.filter.filters.splice(j);
                        j--;
                    }
                    else if (values.length >= 2 && f.field === field && f.operator === 'lte' && f.value == values[1]) {
                        config.filter.filters.splice(j);
                        j--;
                    }
                }

                // $recurrence=field,startDate[,endDate]
                return field + ',' + values.map(function(v){
                        // Makes sure the dates are in ISO format
                        var dateValue = new Date(v);
                        return dateValue.toISOString();
                    }).join(',');
            }
        }

        /**
         * Builds aggregate URL parameters
         * @param {Object} params 
         * @param {Array} aggregates 
         */
        function buildAggregateParams(params, aggregates) {
            _.forEach(aggregates, function (columnAggregate, i) {
                _.forEach(columnAggregate, function (value, key) {
                    if (!_.startsWith(key, '$')) {
                        var param = kendo.format('aggregate[{0}][{1}]', i, key);
                        params[param] = value;
                    }    
                });
            });
        }

        /**
         * The parse function for data-source schema fields of type date.
         * Changes date string back to a Date object
         * @param value - date string serialized by Coldfusion
         * @returns {Date, string} - corrected Date or empty string if no value
         */
        function parseDateField(value){
            if(value && !_.isDate(value)){
                try {
                    var dateValue = moment.utc(value, 'MMMM, DD YYYY HH:mm:ss');
                    dateValue.local();

                    return dateValue.toDate();
                }
                catch(e){}
            }
            else if(_.isDate(value)){
                return value;
            }

            return '';
        }

        function parseNumberField(value) {
            if (!value && value !== 0) {
                return '';
            }

            return kendo.parseFloat(value);
        }

        /**
         * Recursively checks if filter value has been set
         * @param filterObj {Object} - Filter configuration object
         * @param filterObj.value {*} - Value of filter (only for single filter)
         * @param filterObj.filters {Array} - Array of filters
         * @returns {boolean}
         */
        function isFilterEmpty(filterObj){
            if(!_.isEmpty(filterObj)){
                if(_.has(filterObj, 'value')){
                    return false;
                }
                else if(!_.isEmpty(filterObj.filters)){
                    return _.every(filterObj.filters, isFilterEmpty);
                }
            }

            return true;
        }

        /**
         * Compiles and opens route for selected record
         * @param routeTemplateString - Path template specified in page object configuration
         * @param dataItem - Selected record
         * @param target - Where the route will be opened ("_self" or "_blank")
         */
        function openPageObjectRoute(routeTemplateString, dataItem, target) {
            var user = $rootScope.userData,
                compileData = {
                    data: dataItem,
                    nim: nimUtilityService,
                    user: {
                        firstName: user.firstName,
                        lastName: user.lastName,
                        fullName: user.firstName + ' ' + user.lastName
                    }
                };
            

            try {
                var template = kendo.template(routeTemplateString),
                    path = template(compileData),
                    isLocal = _.startsWith(path, '/');
                
                $timeout(function () { 
                    if (isLocal) {
                        if (target !== '_self') {
                            var absUrl = $location.absUrl(),
                                currentPath = $location.path(),
                                pathIndex = absUrl.indexOf(currentPath),
                                newUrl = absUrl.slice(0, pathIndex);
                            
                            $window.open(newUrl + path, target);
                        }
                        else {
                            $location.url(path);
                        }    
                    }
                    else {
                        $window.open(path, target);
                    }
                });
            }
            catch (e) {
                $log.error('Error compiling route:', e);
            }    
        }

        /**
         * Sets the XMLHttpRequest headers for dataSource requests
         * @param xhr
         */
        function setRequestHeaders(xhr) {
            xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
            xhr.setRequestHeader('WSID', _.get($rootScope, 'userData.currentWorkspace.id', ''));
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name WrapperClassService
     * @alias cerberus/core:WrapperClassService
     * @description
     *   Constructs Wrapper classes
     */
    .factory('WrapperClassService', function WrapperClassService() {
        /**
         * Constructs a new header
         * @class Header
         * @classdesc describes a PageObject's Header
         * @memberOf WrapperClassService
         * @param {string} icon
         * @param {string} title
         * @param {string} subTitle
         * @param {Object} style
         */
        function Header(icon, title, subTitle, style) {
            this.icon = icon;
            this.title = title;
            this.subTitle = subTitle;
            this.style = style;
        }

        /**
         * Constructs a new body
         * @class Body
         * @classdesc describes a PageObject's Body
         * @memberOf WrapperClassService
         * @param {string} text
         * @param {Object} style
         */
        function Body(text, style) {
            this.text = text;
            this.style = style || {background:'#ffffff'};
        }

        /**
         * Constructs a new footer
         * @class Footer
         * @classdesc describes a PageObject's Footer
         * @memberOf WrapperClassService
         * @param {string} text
         * @param {Object} style
         */
        function Footer(text, style) {
            this.text = text;
            this.style = style;
        }

        /**
         * Constructs a new wrapper
         * @class Wrapper
         * @classdesc describes a PageObject's wrapper
         * @memberOf WrapperClassService
         * @param {string} type
         * @param {Header} header
         * @param {Body} body
         * @param {Footer} footer
         * @param {boolean} shadow
         * @param {Object} style
         */
        function Wrapper(type, header, body, footer, shadow, style) {
            this.type = type;
            this.header = header;
            this.body = body;
            this.footer = footer;
            this.shadow = shadow;
            this.style = style;
        }

        return {
            wrapper: Wrapper,
            header: Header,
            body: Body,
            footer: Footer,
            newWrapper: newWrapper
        };
        ////////////////////
        /**
         * Builds a empty wrapper
         * @function wrapper
         * @returns {Wrapper}
         */
        function newWrapper() {
            return new Wrapper(
                null,
                new Header(null, null, null, {}),
                new Body(null, {}),
                new Footer(null, {}),
                false,
                {}
            );
        }
    })
;
angular.module('cerberus.core')
    .directive('nimWrapper', function () {
        return {
            restrict: 'AE',
            transclude: true,
            templateUrl: function(element, attributes){
                return 'core/pages/wrappers/' + attributes.nimWrapper + '.tpl.html';
            }
        };
    })
;
angular.module('cerberus.admin')
    .controller('ButtonConfigCtrl', ["_", "kendo", "$scope", "$rootScope", "$uibModalInstance", "toaster", "pageObject", "filters", "DesignerUtilityService", "OdataUtilityService", "PagesService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "WidgetsService", "WidgetsSettingsService", function ButtonConfigCtrl(_, kendo, $scope, $rootScope, $uibModalInstance, toaster, pageObject, filters,
                                                              DesignerUtilityService, OdataUtilityService, PagesService, PagesDesignerListService,
                                                              pageObjectConfigService, ViewsService, WidgetsService, WidgetsSettingsService) {
        var vm = this;

        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.pages = [];
        vm.views = [];
        vm.widgets = [];
        vm.idArray = _.compact(_.map(filters, 'id'));
        vm.filters = filters;
        vm.buttonFilters = [];
        vm.viewColumns = {};
        vm.widgetFields = {};
        vm.viewData = {};
        vm.tabTemplates = [{name: "General", url: "admin/pages/designer/button/general-tab.tpl.html"}];
        vm.editButton = null;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0, 0, 0, 0];
        vm.tempParentFilter = {};
        vm.tempDefaultData = {};

        vm.actions = [
            {action: 'route', display: 'Route'},
            {action: 'link', display: 'Link'},
            {action: 'create', display: 'Create'}
        ];

        vm.buttonTypes = [
            {type: 'single', display: 'Single'},
            {type: 'split', display: 'Split'},
            {type: 'dropdown', display: 'Drop-down'},
            {type: 'filter', display: 'Filter'}
        ];

        vm.buttonStyles = [
            {style: 'default', display: 'Default'},
            {style: 'info', display: 'Info'},
            {style: 'primary', display: 'Primary'},
            {style: 'warning', display: 'Warning'},
            {style: 'danger', display: 'Danger'}
        ];

        vm.tempFilter = {};
        vm.filterType = '';
        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;
        vm.removeItemFromArray = _.pullAt;
        vm.buttonTypeChanged = buttonTypeChanged;
        vm.buttonActionChanged = buttonActionChanged;
        vm.loadFormFields = loadFormFields;

        vm.filterTypes = PagesDesignerListService.filters();
        vm.operators = OdataUtilityService.operators();
        vm.dateRangeOperators = _.map(vm.operators.dateRange, dateRangeMap);

        vm.dataSource = new kendo.data.DataSource({
            type: 'odata',
            serverFiltering:true,
            serverPaging: true,
            serverSorting: true,
            pageSize: 20,
            sort: {field: 'display', dir:'asc'},
            transport:{
                read:{
                    dataType:'json',
                    url: function(){
                        var displayText = '';
                        if(vm.editButton.filterParams.column){
                            displayText = '?$lookupDisplay=' + vm.editButton.filterParams.column;
                        }
                        return '/server/rest/v1/views/' + vm.editButton.filterParams.viewId + '/odata.svc' + displayText;
                    },
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                        xhr.setRequestHeader('WSID',$rootScope.userData.currentWorkspace.id);
                    }
                }
            }
        });

        vm.lookupFilterOptions = {
            filter: 'startswith',
            optionLabel: {
                id: '',
                display: 'Choose...'
            },
            dataTextField: 'display',
            dataValueField: 'id',
            dataSource: vm.dataSource,
            change: function(e){
                if(!e.sender.value()){
                    vm.editButton.filterParams.value = null;
                }
            }
        };

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;

        vm.filterTypeChange = function(){
            vm.editButton.filterParams.value = null;
            vm.editButton.filterParams.endValue = null;
            vm.editButton.filterParams.operator = null;

            if (!vm.editButton.filterParams.filter) {
                vm.editButton.filterParams.filter = {
                    logic: 'and',
                    filters: []
                };
            }

            if(!vm.editButton.filterParams.dateRangeOperators){
                vm.editButton.filterParams.dateRangeOperators = {};
                _.forEach(vm.dateRangeOperators, function(op){
                    vm.editButton.filterParams.dateRangeOperators[op.value] = true;
                });
            }
        };

        vm.addButton = function(){
            var newButton = {
                icon: '',
                label: '',
                action: '',
                targetId: '',
                type: 'single',
                style: 'default',
                items: [],
                filterParams: {},
                defaultData: []
            };
            vm.temp.params.buttons.push(newButton);
            vm.setEditButton(newButton);
        };

        vm.setEditButton = function (button) {
            vm.editButton = button;

            vm.buttonFilters = getFilters();
            vm.tempDefaultData = {};
        };

        vm.removeButton = function(button){
            if(button === vm.editButton){
                vm.editButton = null;
            }

            removeArrayItem(vm.temp.params.buttons, button);
        };

        vm.addItem = function(button){
           button.items.push({
               icon: '',
               label: '',
               action: '',
               targetId: ''
           });
        };

        vm.removeItem = function(button, item){
            removeArrayItem(button.items, item);
        };

        vm.labelToUniqueId = function (item){
            item.id = DesignerUtilityService.labelToUniqueId(item.label, vm.idArray);
        };

        function removeArrayItem(array, item){
            var index = array.indexOf(item);
            if(index >= 0){
                array.splice(index, 1);
            }
        }

        vm.defaultParentConfiguration = defaultParentConfiguration;
        vm.addParentFilter = addParentFilter;
        vm.removeParentFilter = removeParentFilter;
        vm.getFilters = getFilters;

        // Modal Commands
        vm.save = function () {
            if($scope.form.$invalid){
                toaster.pop('warning', 'Form invalid', '');
            }
            else {
                vm.temp.wrapper.style.margin = DesignerUtilityService.arrayToCss(vm.margin);
                $uibModalInstance.close(vm.temp);
            }
        };

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        vm.loadColumns = function(vid){
            if(!vm.viewColumns[vid]){
                ViewsService.getColumns(vid).then(function(columns){
                    vm.viewColumns[vid] = columns;
                    loadViewData(columns);
                });
            }
            else {
                loadViewData(vm.viewColumns[vid]);
            }
        };

        function loadViewData(columns){
            if(vm.editButton && vm.editButton.type === 'filter' && vm.editButton.action === 'lookup') {
                vm.editButton.filterParams.value = {};
                vm.editButton.filterParams.endValue = null;

                var hasColumns = columns.length > 0,
                    columnSelected = !!(_.find(columns, 'colName', vm.editButton.filterParams.column));
                
                if (hasColumns && !columnSelected) {
                    vm.editButton.filterParams.column = columns[0].colName;
                    vm.dataSource.read();
                }
                else if(!columnSelected) {
                    vm.editButton.filterParams.column = null;
                }
            }
        }

        vm.dateRangeFilter = dateRangeFilter;
        vm.dateRangeOpToggled = dateRangeOpToggled;

        // Init
        init();

        function init() {
            PagesService.getPages().then(function(pages){
                vm.pages = pages;
            });

            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            WidgetsService.getWidgets().then(function (widgets) {
                vm.widgets = widgets;
            });

            for (var b = 0; b < vm.temp.params.buttons.length; b++) {
                var button = vm.temp.params.buttons[b];

                _.defaults(button, {
                    defaultData: []
                });

                if ((button.type === 'single' || button.type === 'split') && button.action === 'create' && button.targetId) {
                    loadFormFields(button.targetId);
                }

                if (button.filterParams && button.filterParams.viewId) {
                    vm.loadColumns(button.filterParams.viewId);
                }
            }

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].id) {
                    vm.idArray.push(filters[i].id);
                }
            }
        }

        function dateRangeFilter(operator){
            return vm.editButton.filterParams.dateRangeOperators[operator.value];
        }

        function dateRangeOpToggled(key){
            var opDisabled = !vm.editButton.filterParams.dateRangeOperators[key],
                opSelected = vm.editButton.filterParams.operator === key;

            if(opDisabled && opSelected){
                vm.editButton.filterParams.operator = '';
            }
        }

        function buttonTypeChanged(button) {
            if (button.type !== 'single' && button.type !== 'split') {
                button.defaultData = [];
            }
        }

        function buttonActionChanged(button) {
            button.targetId = '';
        }

        function loadFormFields(targetId) {
            if (targetId && !vm.widgetFields[targetId]) {
                WidgetsSettingsService.getFormFields(targetId).then(function (data) {
                    vm.widgetFields[targetId] = WidgetsSettingsService.parseFormObjects(data.display);
                });
            }
        }

        function dateRangeMap(display, key){
            return {
                display: display,
                value: key
            };
        }

        function getFilters() {
            var buttonFilters = _.filter(vm.temp.params.buttons, function(b) {
                return b.type === 'filter' && b.id !== vm.editButton.id;
            });

            return filters.concat(buttonFilters);
        }

        // Parent Filter

        function defaultParentConfiguration(filterParams) {
            if (!filterParams.parentFilterMap) {
                filterParams.parentFilterMap = {};
            }
        }

        function addParentFilter(parentFilterMap, tempFilter) {
            parentFilterMap[tempFilter.key] = tempFilter.value;

            delete tempFilter.value;
            delete tempFilter.key;
        }

        function removeParentFilter(parentFilterMap, key) {
            delete parentFilterMap[key];
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;

angular.module('cerberus.admin')
    .controller('TabsetConfigCtrl', ["_", "$scope", "$uibModalInstance", "$timeout", "pageObject", "filters", "PagesService", "PagesClassService", "PagesDesignerListService", "pageObjectConfigService", "DesignerUtilityService", function TabsetConfigCtrl(_, $scope, $uibModalInstance, $timeout, pageObject, filters,
                                                              PagesService, PagesClassService, PagesDesignerListService,
                                                              pageObjectConfigService, DesignerUtilityService) {
        var vm = this;

        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters= filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.pages = [];
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};

        vm.colSelected = {};

        vm.tabTemplates = [{
            name: "General",
            url: "admin/pages/designer/tabset/general-tabset-tab.tpl.html"
        }];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.params.tabs);

        // Helper functions
        vm.capitalize = _.capitalize;

        // Tab Commands
        vm.addTab = function () {
            var newTab = PagesClassService.tab();
            vm.temp.params.tabs.push(newTab);
        };

        vm.removeTab = function (index) {
            vm.temp.params.tabs.splice(index,1);
        };

        // Modal Commands
        vm.save = function () {
            if(vm.temp.wrapper.type === 'circletile') {
                vm.temp.wrapper.header.style.background = vm.temp.wrapper.body.style.background;
            }
            vm.temp.wrapper.style.margin = DesignerUtilityService.arrayToCss(vm.margin);
            vm.temp.wrapper.style.padding = DesignerUtilityService.arrayToCss(vm.padding);
            $uibModalInstance.close(vm.temp);
        };

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        init();

        function init(){
            PagesService.getPages().then(function(pages){
                vm.pages = pages;
            });
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .factory('AutoFillService', ["_", function AutoFillService(_) {
        return {
            autoFillObject: autoFillObject,
            dataSeriesAutoFillObject: dataSeriesAutoFillObject,
            autoFillSubItem: autoFillSubItem,
            setAutoFillMetaData: setAutoFillMetaData,
            setDataSeriesAutoFillData: setDataSeriesAutoFillData,
            setTargetFormId: setTargetFormId,
            setSubItemIds: setSubItemIds
        };

        /**************************************************/

        /**
         * Returns json object for autoFill item
         * @returns {Object}
         */
        function autoFillObject(){
            return {
                type: '',       // The source column type
                value: '',      // The source model id
                persists: false,
                current: {      // The target model id and it's info
                    formId: '', // target form origin id
                    modelId: ''
                }
            };
        }

        /**
         * Returns json object for dataSeries' autoFill item
         * @returns {Object}
         */
        function dataSeriesAutoFillObject(){
            return {
                type: '',
                value: '',
                current: {
                    formId: '',
                    modelId: ''
                },
                // Additional Info needed if type === 'dataseries'
                widgetId: '',   // The source modelId's widget id
                fk: '',         // The source's fk
                targetWidgetId: '',
                subMap: []
            };
        }

        /**
         * Returns json object for autoFill subMap item
         * @returns {Object}
         */
        function autoFillSubItem(){
            return {
                value: '',
                current: {
                    formId: '',         // form pk
                    formOriginId: '',   // form origin id
                    modelId: ''
                }
            };
        }

        /**
         * Sets the autoFill object's cast type
         * @param obj - autoFill object
         * @param columns - view columns
         */
        function setAutoFillMetaData(obj, columns){
            for(var i = 0; i < columns.length; i++){
                var source = columns[i];
                if(source.colName === obj.value){
                    obj.type = source.castType;
                    if(obj.type === 'dataseries'){
                        obj.fk = source.fk;
                        obj.widgetId = source.widgetId;
                    }
                    else if(obj.widgetId){
                        delete obj.fk;
                        delete obj.widgetId;
                    }
                    return;
                }
            }
        }

        /**
         * Sets dataSeries autoFill object's type, widgetId, and fk
         * @param obj - autoFill object
         * @param fields - widget form fields
         * @param widgetId
         * @param fks - dataSeries' foreign keys
         */
        function setDataSeriesAutoFillData(obj, fields, widgetId, fks){
            obj.widgetId = widgetId;
            if(fks && fks.length){
                obj.fk = fks[0].modelId;
            }
            for(var i = 0; i < fields.length; i++){
                if(fields[i].modelId === obj.value){
                    obj.type = fields[i].type;
                    return;
                }
            }
        }

        /**
         * Sets autoFill target's formId
         * @param obj - autoFill object
         * @param formFieldObjects
         * @param formId
         * @param widgetId
         */
        function setTargetFormId(obj, formFieldObjects, formId){
            for(var i = 0; i < formFieldObjects.length; i++){
                var target = formFieldObjects[i];
                if(obj.current.modelId === target.modelId){
                    obj.current.formId = target.formId;
                    // Sets table-specific data
                    if(target.type === 'table'){
                        obj.targetWidgetId = target.widgetId;
                        obj.subMap = [];
                    }
                    else if(obj.targetWidgetId){
                        // removes table data
                        delete obj.targetWidgetId;
                        delete obj.subMap;
                    }
                    return;
                }
            }

            obj.current.formId = _.last(formId.split('-'));
        }

        /**
         * Sets autoFill subMap item's form and origin ids
         * @param target - subMap item's current object
         * @param formFieldObjects
         * @param originId
         */
        function setSubItemIds(target, formFieldObjects, originId){
            for(var i = 0; i < formFieldObjects.length; i++){
                if(target.modelId === formFieldObjects[i].modelId){
                    target.formId = formFieldObjects[i].realFormId;
                    target.formOriginId = formFieldObjects[i].formId;
                    return;
                }
            }

            target.originId = _.last(originId.split('-'));
        }
    }])
;

angular.module('cerberus.admin')
    .controller('FormsDesignerCtrl',
    ["_", "moment", "$scope", "$location", "$log", "$timeout", "$uibModal", "formOriginId", "widgetId", "CalculationService", "ConfirmModalService", "FormsService", "FormsClassService", "FormsDesignerConvenienceService", "FormsDesignerService", "WidgetsService", "FormsDesignerListService", "DesignerUtilityService", "nimCalcService", function FormsDesignerCtrl(_, moment, $scope, $location, $log, $timeout, $uibModal, formOriginId, widgetId,
                               CalculationService, ConfirmModalService, FormsService, FormsClassService,
                               FormsDesignerConvenienceService, FormsDesignerService, WidgetsService,
                               FormsDesignerListService, DesignerUtilityService, nimCalcService) {
        // Determine Originator Id
        $scope.originPubId = formOriginId;
        $scope.originId = _.last(formOriginId.split('-'));

        $scope.widgetId = widgetId;

        // Set models
        $scope.temp = {};
        $scope.orig = {};
        $scope.revisions = [];

        // Set data containers
        $scope.fieldOptions = {};
        $scope.dataSet = {};
        $scope.filters = {};
        $scope.fileAttachments = {};

        // Printer Variables
        $scope.pageCounter = '####';
        $scope.pageCurrent = '#';
        $scope.pageTotal = '#';

        // Print/Export FileName Systax Examples
        $scope.FileNameFieldFormat = [
            {value: '{0}', display: '[Field]'},
            {value: 'PO_{0}', display: 'PO_[Field]'},
            {value: 'Invoice {0}', display: 'Invoice [Field]'},
            {value: '{0} SalesOrder', display: '[Field] SalesOrder'},
            {value: '{0} - {1:yyyy-MM-dd}', display: '[Field] - Y-M-D'},
            {value: '{1:yyyy-MM-dd} - {0}', display: 'Y-M-D - [Field]'},
            {value: '{0}_{1:yyyy-MM-dd}', display: '[Field]_Y-M-D'},
            {value: '{1:yyyy-MM-dd}_{0}', display: 'Y-M-D_[Field]'},
            {value: '{0} ({1:yyyy-MM-dd})', display: '[Field] (Y-M-D)'},
            {value: '({1:yyyy-MM-dd}) {0}', display: '(Y-M-D) [Field]'},
            {value: '{0} - {1:yyyy-MM-dd HH_mm_ss}', display: '[Field] - Y-M-D hh_mm_ss'},
            {value: '{1:yyyy-MM-dd HH_mm_ss} - {0}', display: 'Y-M-D hh_mm_ss - [Field]'}
        ];

        // UI Variables & Functions
        $scope.canSave = true;
        $scope.designer = {
            activeSection: false,
            width: 1024
        };
        $scope.revisionsCollapse = true;
        $scope.settingsCollapse = true;
        $scope.hiddenFieldsCollapse = true;
        $scope.warningCollapse = true;
        $scope.warnings = [];
        $scope.formTypes = [
            {value: 'normal', display: 'Normal'},
            {value: 'check', display: 'Check'},
            {value: 'label', display: 'Label'}
        ];
        $scope.gridsterOpts = {
            pushing: false,
            swapping: false,
            resizable: {
                enabled: true
            },
            draggable: {
                enabled: true
            }
        };

        var formObjects = FormsDesignerListService.formObjects();

        $scope.sectionFilter = FormsService.sectionFilter;
        $scope.addSectionToForm = FormsDesignerService.addSectionToForm;
        $scope.removeSectionFromForm = removeSectionFromForm;
        $scope.reorderItem = reorderItem;
        $scope.updateSection = FormsDesignerService.updateSection;
        $scope.sectionConditionString = FormsDesignerService.sectionConditionString;
        $scope.numberFilter = numberFilter;
        $scope.preventInvalidCharacters = preventInvalidCharacters;
        //$scope.preventInvalidFileName = preventInvalidFileName;
        $scope.removeInvalidCharacters = removeInvalidCharacters;
        $scope.showFormObject = showFormObject;
        $scope.disableFormObject = disableFormObject;
        $scope.requireFormObject = requireFormObject;
        /* Toolbar Functions */
        $scope.createTemplate = function(){
            $location.url('/settings/widgets/' + widgetId + '/forms/' + formOriginId + '/template');
        };
        $scope.hasChanges = function () {
            return !angular.equals($scope.orig, $scope.temp);
        };
        //Check for changed data
        DesignerUtilityService.cancelRouteNav($scope, $scope.hasChanges);

        $scope.preview = function () {
            // TODO: Launch a modal with a specific class for size
        };

        $scope.delForm = function(data){
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/forms/delete-form-modal.tpl.html',
                controller: 'DeleteWidgetComponentsModalCtrl',
                resolve: {
                    formOriginId: _.constant(formOriginId),
                    data: _.constant(data)
                }
            });
            modalInstance.result.then(function (data) {
                FormsDesignerService.remove(data.originatorId, data.widgetId).then(function(){
                    $location.url('/settings/widgets/' + data.widgetId + '/forms');
                });
            });
        };

        $scope.save = function (originPubId, data, publish) {
            $scope.canSave = false;
            FormsDesignerService.createRevision(originPubId, data).then(function(value){
                if (publish) {
                    FormsDesignerService.publish(value).then(function(){
                        $scope.temp.published = true;
                        $scope.orig.published = true;
                        _init();
                    });
                }
                else{
                    $scope.temp.published = false;
                    _init();
                }
                $scope.temp.formId = value;
                $scope.orig = angular.copy($scope.temp);
            }).finally(function () {
                $scope.canSave = true;
            });
        };
        //$scope.saveAndClose = function (originPubId, data) {
        //    $scope.canSave = false;
        //    FormsDesignerService.createRevision(originPubId, data).then(
        //        function(){
        //            $scope.orig = angular.copy($scope.temp);
        //            $location.url('/settings/widgets/' + data.widgetId + '/forms');
        //        }, function () {
        //            $scope.canSave = true;
        //        }
        //    );
        //};
        $scope.publish = function(originPubId, data){
            if ($scope.hasChanges() === true) {
                $scope.save(originPubId, data, true);
            }
            else {
                FormsDesignerService.publish(data.formId).then(function () {
                    $scope.temp.published = true;
                    $scope.orig.published = true;
                    getRevisions();
                });
            }
        };
        $scope.close = function () {
            $location.url('/settings/widgets/' + widgetId + '/forms');
        };

        /* Revisions Panel */
        $scope.getForm = function (id) {
            FormsService.getForm(id, true).then(function(form){
                $scope.temp = angular.copy(form);
                $scope.orig = angular.copy(form);
                $scope.revisionsCollapse = true;
            });
        };

        /* Form Manipulation */
        $scope.createFormObject = function(type){
            var newFormObject = {
                model: FormsClassService[type](),
                //Define width based on type
                sizeY: formObjects[type].defaultSizeY,
                sizeX: formObjects[type].defaultSizeX
            };
            $scope.openFormObjectConfigModal(newFormObject,-1);
        };

        $scope.createConvenienceObject = function(type, convenienceType){
            var newFormObject = {
                model: FormsDesignerConvenienceService[convenienceType](),
                //Define width based on type
                sizeY: formObjects[type].defaultSizeY,
                sizeX: formObjects[type].defaultSizeX
            };
            $scope.openFormObjectConfigModal(newFormObject,-1);
        };

        $scope.createHiddenField = function(type){
            var newHiddenObject = {
                model: FormsDesignerConvenienceService[type](),
                sizeY: 0,
                sizeX: 0
            };
            $scope.openFormObjectConfigModal(newHiddenObject, -1);
        };

        // Function for creating geocoder with auto-populated fields
        $scope.createGeocodeArray = function(){
            // Create Geocode Field
            var geocoder = {
                model: FormsClassService.location(),
                sizeY: formObjects.location.defaultSizeY,
                sizeX: formObjects.location.defaultSizeX
            };
            geocoder.model.display.section = $scope.designer.activeSection;

            // Configures Geocode Field
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/forms/designer/common/config-modal.tpl.html',
                controller: 'FormsDesigner_stringCtrl',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    autoTabIndex: _.constant($scope.temp.form.settings.autoTabIndex.enabled),
                    currentFormObjects: getCurrentFormObjects,
                    editFlag: _.constant(false),
                    formOriginId: _.constant($scope.originId),
                    formObj: _.constant(geocoder),
                    idArray: _.constant(_.map($scope.temp.form.objects, 'model.config.modelId')),
                    sections: _.constant([{val: false, display: '(Default)'},{val: '__nimHiddenSection', display: '(Hidden)'}].concat($scope.temp.form.sections.map(function(s){ return {val: s.name, display: s.name}; }))),
                    widgetId: _.constant(widgetId)
                }
            });

            modalInstance.result.then(function (formObj) {
                //Set Default Values
                var defaultVal = formObj.model.config.defaultValue;
                if(defaultVal || defaultVal === false || defaultVal === 0){
                    defaultVal = FormsService.parseDefaultValue(formObj.model.config.type,formObj.model.config.defaultValue);
                    if(!formObj.model.param.filter) {
                        $scope.dataSet[formObj.model.config.modelId] = angular.copy(defaultVal);
                    }
                    $scope.filters[formObj.model.config.modelId] = angular.copy(defaultVal);
                }

                $scope.temp.form.objects.push(formObj);

                if (formObj.model.calculation.formula || !_.isEmpty(formObj.model.calculation.tokens)) {
                    formObj.model.calculation.formula = _.trim(formObj.model.calculation.formula);
                    formObj.model.calculation.tokens = nimCalcService.parse(formObj.model.calculation.formula).items;
                    var tokenCpy = angular.copy(formObj.model.calculation.tokens);
                    parseFormObjectTokens(tokenCpy ,formObj.model.config.modelId);
                }

                // Creates other fields
                var geoId = formObj.model.config.modelId;
                var formId = $scope.originId;

                var addressFormObject = {
                    model: FormsClassService.text(),
                    sizeY: formObjects.readonly.defaultSizeY,
                    sizeX: formObjects.readonly.defaultSizeX
                };
                addressFormObject.model.display.section = geocoder.model.display.section;
                var fields = formObj.model.param.fields;
                var geoFields = [
                    {name: 'Street Address',value: 'street_address'},
                    {name: 'City',value: 'locality_long_name'},
                    {name: 'ZIP Code',value: 'postal_code_short_name'},
                    {name: 'State',value: 'administrative_area_level_1_short_name'},
                    {name: 'County',value: 'administrative_area_level_2_long_name'},
                    {name: 'Country',value: 'country_long_name'}
                ];
                var setFields = _.map(fields, 'value');
                for(var gf = 0; gf < geoFields.length; gf++){
                    var gField = geoFields[gf];
                    if(setFields.indexOf(gField.value) < 0){
                        var newId = geoId + gField.name.replace(/ /g, '');
                        fields[newId] = {
                            form: formId,
                            usage: "'" + newId + "'",
                            value: gField.value
                        };
                        var newField = angular.copy(addressFormObject);
                        newField.model.label.text = gField.name;
                        newField.model.config.modelId = newId;
                        $scope.temp.form.objects.push(newField);
                    }
                }
            });
        };

        $scope.getInnerFieldOption = function(fieldObj){
            var f = {option:fieldObj.option};
            FormsDesignerService.getFieldOption(f).then(function(value){
                $scope.fieldOptions[fieldObj.field] = value;
            });
        };

        $scope.copyFormObject = function (obj) {
            var formObj = angular.copy(obj);
            formObj.row += formObj.sizeY;
            //Change model id if exists
            if(formObj.model.config.modelId){
                var cpyNum = formObj.model.config.modelId.substr(formObj.model.config.modelId.length - 1);
                var newModelId;
                if(isNaN(cpyNum)){
                    newModelId = formObj.model.config.modelId + '1';
                }
                else{
                    var b = parseInt(cpyNum) + 1;
                    newModelId = formObj.model.config.modelId.substring(0,formObj.model.config.modelId.length - 1) + b;
                }
                formObj.model.config.modelId = newModelId;
            }
            //Change label text
            formObj.model.label.text = 'Copy Of ' + formObj.model.label.text;
            $scope.temp.form.objects.push(formObj);
            //Copy custom values
            if(formObj.model.option.values.length > 0){
                $scope.fieldOptions[formObj.model.config.modelId] = formObj.model.option.values;
            }
            //Copy default values
            var defaultValue = formObj.model.config.defaultValue;
            if(defaultValue || defaultValue === false || defaultValue === 0){
                if(!formObj.model.param.filter){
                    $scope.dataSet[formObj.model.config.modelId] = angular.copy(defaultValue);
                }
                //else{
                    $scope.filters[formObj.model.config.modelId] = angular.copy(defaultValue);
                //}
            }
        };
        $scope.deleteBox = function (box) {
            var idx = $scope.temp.form.objects.indexOf(box);
            FormsDesignerService.breakingChangesCheck($scope.temp.formId,box.model.config.modelId).then(function(msg){
                if(msg.length > 0){
                    ConfirmModalService.showModal(null, {
                        headerText: 'Confirm Deletion',
                        bodyText: msg + '<br> <strong>Are you sure you want to delete?</strong>',
                        actionButtonText: 'Delete',
                        closeButtonText: 'Cancel',
                        confirm: function(){
                            $scope.temp.form.objects.splice(idx, 1);
                            $scope.warnings.push(msg);
                        },
                        check: function(){
                            return true;
                        }
                    });
                }
                else{
                    $scope.temp.form.objects.splice(idx, 1);
                }
            });
        };

        // Form Object Configuration Modal
        $scope.openFormObjectConfigModal = function (formObject) {
            var index = $scope.temp.form.objects.indexOf(formObject);

            if(index < 0 && !formObject.model.display.section){
                formObject.model.display.section = $scope.designer.activeSection;
            }

            var decodeHtml = function (html) {
                var txt = document.createElement("textarea");
                txt.innerHTML = html;
                return txt.value;
            };
            if(formObject.model.config.type === 'statictext'){
                formObject.model.param.text = decodeHtml(formObject.model.param.text);
            }

            var dataType = formObject.model.config.dataType;
            if(formObject.model.config.type === 'map'){
                dataType = 'map';
            }
            else if(formObject.model.config.type === 'location'){
                dataType = 'string';
            }

            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/forms/designer/common/config-modal.tpl.html',
                controller: 'FormsDesigner_' + dataType + 'Ctrl',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    autoTabIndex: _.constant($scope.temp.form.settings.autoTabIndex.enabled),
                    currentFormObjects: getCurrentFormObjects,
                    editFlag: _.constant(index > -1),
                    formObj: _.constant(formObject),
                    formOriginId: _.constant($scope.originId),
                    idArray: _.constant(_.map($scope.temp.form.objects, 'model.config.modelId')),
                    sections: _.constant([{val: false, display: '(Default)'},{val: '__nimHiddenSection', display: '(Hidden)'}].concat($scope.temp.form.sections.map(function(s){ return {val: s.name, display: s.name}; }))),
                    widgetId: _.constant(widgetId)
                }
            });

            modalInstance.result.then(function (formObj) {
                //Set Default Values
                var defaultValue = formObj.model.config.defaultValue;
                if(defaultValue || defaultValue === false || defaultValue === 0){
                    var interval = null;

                    // For parsing default date value to nearest interval
                    if(formObj.model.config.type === 'datetime' && formObj.model.display.format.match(/[HhfmstgG]/g)){
                        interval = formObj.model.tag.attrs['k-interval'];
                    }

                    var defaultVal = FormsService.parseDefaultValue(formObj.model.config.type, defaultValue, interval);
                    if(!formObj.model.param.filter) {
                        $scope.dataSet[formObj.model.config.modelId] = angular.copy(defaultVal);
                    }
                    //else{
                        $scope.filters[formObj.model.config.modelId] = angular.copy(defaultVal);
                    //}
                }
                //Populate options object
                if(formObj.model.option.type === 'custom'){
                    $scope.fieldOptions[formObj.model.config.modelId] = formObj.model.option.values;
                }
                //else if (formObj.model.option.type === 'groups' ){
                //    var d = {option:formObj.model.option};
                //    FormsDesignerService.getFieldOption(d).then(function(value){
                //        $scope.fieldOptions[$scope.originId][formObj.model.config.modelId] = value;
                //    });
                //}

                //for tables
                if(formObj.model.config.type === 'table'){
                    for(var i = 0; i < formObj.model.tag.inner.length; i++){
                        if(formObj.model.tag.inner[i].option){
                            if(formObj.model.tag.inner[i].option.type === 'custom'){
                                $scope.fieldOptions[formObj.model.tag.inner[i].field] = formObj.model.tag.inner[i].option.values;
                            }
                            else{
                                $scope.getInnerFieldOption(formObj.model.tag.inner[i]);
                            }
                        }
                    }
                }
                //Editing a form object.
                if(index > -1){
                    $scope.temp.form.objects.splice(index, 1, formObj);
                }
                //Creating a new form object.
                else{
                    $scope.temp.form.objects.push(formObj);
                }

                if(formObj.model.calculation.formula || !_.isEmpty(formObj.model.calculation.tokens)){
                    formObj.model.calculation.formula = _.trim(formObj.model.calculation.formula);
                    formObj.model.calculation.tokens = nimCalcService.parse(formObj.model.calculation.formula).items;
                    var tokenCpy = angular.copy(formObj.model.calculation.tokens);
                    parseFormObjectTokens(tokenCpy ,formObj.model.config.modelId);
                }
            });
        };

        $scope.openSectionModal = function(form, section){
            _.defaults(form, {sections: []});
            var index = form.sections.indexOf(section),
                sectionNames = _.map(form.sections, 'name');


            // Includes checkbox/radios/drop-downs of type "custom" or "views" and excludes fields in this section
            var fields = _.filter(form.objects, function(formObj){
                var type = _.get(formObj, 'model.config.type'),
                    dataType = _.get(formObj, 'model.config.dataType'),
                    lookupType = _.get(formObj, 'model.option.type');

                return lookupType === 'custom' ||
                    lookupType === 'views' ||
                    type === 'checkbox' ||
                    dataType === 'string' ||
                    dataType === 'number';
            });

            if(index >= 0){
                _.pull(sectionNames, section.name);
                /* LODASH Version 4 ONLY */
                //fields = _.reject(fields, ['model.display.section', section.name]);
                /* LODASH Version 3 & 4 Compatibility Mode */
                fields = _.reject(fields, function(r){return r.model.display.section === section.name;});
            }

            sectionNames.push('__nimHiddenSection'); // Add name of hidden section

            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/forms/designer/section/section-config-modal.tpl.html',
                controller: 'FormsDesigner_SectionCtrl',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    section: _.constant(section),
                    sectionArray: _.constant(sectionNames),
                    formOriginId: _.constant($scope.originId),
                    fields: _.constant(fields)
                }
            });

            modalInstance.result.then(function(data){
                if(index >= 0){
                    $scope.updateSection(form, data, index);
                }
                else {
                    $scope.addSectionToForm(form, data);
                }
                $scope.designer.activeSection = data.name;
            });
        };

        /* Formulas */
        //Functions for parsing form objects with formulas
        function parseFormObjectTokens(tokenArray, resultModelId){
            var hasVariables = false,
                resultObj = {
                id: $scope.originId,
                model: resultModelId
            };
            for(var k = 0; k < tokenArray.length; k++){
                if(tokenArray[k].type === 'operand' && tokenArray[k].subtype === 'range'){
                    var tokValArr = tokenArray[k].value.split('_'),
                        operandModelId = _.last(tokValArr);

                    if(!$scope.dataSet[operandModelId]){
                        $scope.dataSet[operandModelId] = '';
                    }

                    tokenArray[k].value = $scope.dataSet[operandModelId];

                    if(operandModelId.substring(0,1) !== '@'){
                        createWatcher($scope.originId, operandModelId, tokenArray, k, resultObj);
                        hasVariables = true;
                    }
                }
            }

            if(!hasVariables){
                var result = CalculationService.calculate(tokenArray);
                if(result.type !== 'error') {
                    $scope.dataSet[resultModelId] = result.value;
                }
            }
        }

        function createWatcher(formOriginId, modelId, tokenArr, tokIndex, resultVar){
            tokenArr[tokIndex].value = '';
            modelId = _.trim(modelId);
            if (modelId) {
                $scope.$watch('dataSet["' + modelId + '"]', function (newValue) {
                    tokenArr[tokIndex].value = newValue;

                    // Checks if empty lookup value
                    if (angular.equals(newValue, {}) || (_.get(newValue, 'id') === '-1')) {
                        tokenArr[tokIndex].value = '';
                    }

                    if (modelId !== resultVar.model) {
                        var result = CalculationService.calculate(tokenArr),
                            resultValue = result.value;

                        if (result.type === 'error') {
                            $log.warn(resultVar.model, '\t', result.value);
                            resultValue = null;
                        }

                        $scope.dataSet[resultVar.model] = resultValue;

                        if (_.has(resultValue, 'id') && resultValue.id === '-1') {
                            $scope.filters[resultVar.model] = null;
                        }
                        else {
                            $scope.filters[resultVar.model] = resultValue;
                        }
                    }
                });
            }
        }

        /* Init */
        _init();

        $scope.$on('$locationChangeStart', function (e) {
            if (!e.defaultPrevented) {
                $scope.$broadcast('nim-remove-form-objects');
            }
        });

        function _init(){
            FormsService.getForm(formOriginId).then(function(formModel){
                $scope.temp = angular.copy(formModel);
                $scope.orig = angular.copy(formModel);

                _.defaultsDeep($scope.temp.form.settings, {
                    print: {
                        type: 'normal',
                        pageSize: [8.5, 11],
                        pageTotal: '',
                        margin: {
                            left: 0,
                            top: 0,
                            right: 0,
                            bottom: 0
                        }
                    }
                });

                initFormVars();
            });

            getRevisions();
        }

        function initFormVars(){
            $scope.fieldOptions = $scope.temp.fieldOptions || {};
            //$scope.temp.form.settings = $scope.temp.form.settings;
            $scope.dataSet = angular.copy($scope.temp.defaultDataSet);
            for(var i = 0; i < $scope.temp.form.objects.length; i++){
                var formObj = $scope.temp.form.objects[i];
                var modelId = formObj.model.config.modelId;
                if(formObj.model.calculation.formula){
                    var tokensCopy = angular.copy(formObj.model.calculation.tokens);
                    parseFormObjectTokens(tokensCopy, modelId);
                }
                var defaultValue = formObj.model.config.defaultValue;
                if(defaultValue || defaultValue === false || defaultValue === 0){
                    var interval = null;

                    // For parsing default date value to nearest interval
                    if(formObj.model.config.type === 'datetime' && formObj.model.display.format.match(/[HhfmstgG]/g)){
                        interval = formObj.model.tag.attrs['k-interval'];
                    }

                    var defaultVal = FormsService.parseDefaultValue(formObj.model.config.type, defaultValue, interval);
                    if(!formObj.model.param.filter){
                        $scope.dataSet[modelId] = angular.copy(defaultVal);
                    }
                    //else{
                    $scope.filters[modelId] = angular.copy(defaultVal);
                    //}
                }
            }
        }

        function getRevisions(){
            FormsDesignerService.getRevisions(formOriginId).then(function(revisions){
                _.forEach(revisions, function(rev){
                    rev.createdDate = moment.utc(rev.createdDate, 'MMMM, DD YYYY HH:mm:ss').toDate();
                });
                $scope.revisions = revisions;
            });
        }

        function removeSectionFromForm(form, index){
            if($scope.designer.activeSection === form.sections[index].name){
                $scope.designer.activeSection = false;
            }
            FormsDesignerService.removeSectionFromForm(form, index);
        }

        function reorderItem(array, oldIndex, newIndex){
            var item = array.splice(oldIndex, 1)[0];
            array.splice(newIndex, 0, item);
        }

        function getCurrentFormObjects(){
            var objects = [],
                operands = [],
                formId = _.last($scope.temp.formId.split('-'));

            _.forEach($scope.temp.form.objects, function(formObj){
                var usage = "'" + formObj.model.config.modelId + "'",
                    currentFormObject = {
                        modelId: formObj.model.config.modelId,
                        type: formObj.model.config.type,
                        dataType: formObj.model.config.dataType,
                        label: formObj.model.label.text,
                        formId: $scope.temp.originatorId,
                        realFormId: formId,
                        usage: usage,
                        isLookUp: formObj.model.option.type === 'views',
                        isCustomLookup: formObj.model.option.type === 'custom'
                    };

                if(currentFormObject.isLookUp){
                    currentFormObject.widgetId = formObj.model.option.widgetId;
                }
                else if (currentFormObject.dataType === "dataseries"){
                    currentFormObject.widgetId = formObj.model.param.widgetId;
                }

                operands.push(usage);
                objects.push(currentFormObject);
            });

            return {
                display: {
                    formId: formId,
                    originId: $scope.temp.originatorId,
                    formName: $scope.temp.name,
                    hasUpload: $scope.temp.form.settings.nimupload.enabled,
                    objects: objects
                },
                operands: operands
            };
        }

        function numberFilter(formObj){
            return formObj.model.config.type === 'number';
        }

        function preventInvalidCharacters(event){
            var period = event.which === 190,
                underscore = event.which === 189 && event.shiftKey;

            if(period || underscore){
                event.preventDefault();
            }
        }

//        function preventInvalidFileName(event){
//            try {
//                if (/^[a-zA-Z0-9\_\- ]*$/.test(event.key)) {
//                    return true;
//                } else {
//                    event.preventDefault();
//                    return false;
//                }
//            } catch (event) {
//            }
//        }

        function removeInvalidCharacters(){
            $timeout(function(){
                if($scope.temp.name){
                    $scope.temp.name = $scope.temp.name.replace(/[._]/g, '');
                }
            });
        }

        function showFormObject(formObject){
            if(!_.isEmpty(formObject.param.condition) && (formObject.param.conditionalAction === 'show' || formObject.param.conditionalAction === 'hide'|| !formObject.param.conditionalAction)){
                var result = FormsService.sectionCondition(formObject.param.condition, $scope.dataSet, formObject.param.conditionalLogic, 'create');

                if(formObject.param.conditionalAction === 'hide'){
                    return !result;
                }

                return result;
            }

            return true;
        }

        function disableFormObject(formObject){
            if(!_.isEmpty(formObject.param.condition) && (formObject.param.conditionalAction === 'active' || formObject.param.conditionalAction === 'readonly')){
                var result = FormsService.sectionCondition(formObject.param.condition, $scope.dataSet, formObject.param.conditionalLogic, 'create');

                if(formObject.param.conditionalAction === 'active'){
                    return !result;
                }
                else if(formObject.param.conditionalAction === 'readonly'){
                    return result;
                }
            }

            return false;
        }

        function requireFormObject(formObject) {
            if(!_.isEmpty(formObject.param.condition) && (formObject.param.conditionalAction === 'required' || formObject.param.conditionalAction === 'optional')){
                var result = FormsService.sectionCondition(formObject.param.condition, $scope.dataSet, formObject.param.conditionalLogic, 'create');

                if(formObject.param.conditionalAction === 'optional'){
                    return !result;
                }

                return result;
            }

            return false;
        }
    }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name FormsDesignerConvenienceService
 * @alias cerberus/forms:FormsDesignerConvenienceService
 * @description Modifies Field classes for user convenience
 */
    .factory('FormsDesignerConvenienceService', ["FormsClassService", function FormsDesignerConvenienceService(FormsClassService){
        return {
            currency: currency,
            wholeNumber: wholeNumber,
            decimal: decimal,
            email: email,
            percentage: percentage,
            phonenumber: phonenumber,
            socialsecurity: socialsecurity,
            url: url,
            zip: zip,
            shortDate: shortDate,
            longDate: longDate,
            twentyFourHourTime: twentyFourHourTime,
            twelveHourTime: twelveHourTime,
            shortDateTime: shortDateTime,
            longDateTime: longDateTime,
            hiddenText: hiddenText,
            hiddenNumber: hiddenNumber,
            hiddenDatetime: hiddenDatetime,
            hiddenDropDown: hiddenDropDown
        };

        /**
         * Builds a number field modified for currency values
         * @function currency
         * @returns {Field}
         */
        function currency(){
            var field = FormsClassService.number();
            field.display.format = "c";
            field.param.decimals = 2;
            field.param.step = 0.01;
            return field;
        }

        /**
         * Builds a number field modified for integer values
         * @function wholeNumber
         * @returns {Field}
         */
        function wholeNumber(){
            var field = FormsClassService.number();
            field.display.format = "n0";
            field.param.decimals = 0;
            field.param.step = 1;
            return field;
        }

        /**
         * Builds a number field modified for decimal values
         * @function decimal
         * @returns {Field}
         */
        function decimal(){
            var field = FormsClassService.number();
            field.display.format = "n";
            field.param.decimals = 2;
            field.param.step = 0.01;
            return field;
        }

        /**
         * Builds a text field modified for email addresses
         * @function email
         * @returns {Field}
         */
        function email(){
            var field = FormsClassService.text();
            field.validation.pattern = '/^\\w[\\w\\.\\-]*@\\w+[\\w\\.\\-]*\.[a-zA-Z]{2,}$/';
            return field;
        }

        /**
         * Builds a number field modified for percentage values
         * @function percentage
         * @returns {Field}
         */
        function percentage(){
            var field = FormsClassService.number();
            field.display.format = "p";
            field.param.decimals = 2;
            field.param.step = 0.01;
            return field;
        }

        /**
         * Builds a text field modified for phone numbers
         * @function phonenumber
         * @returns {Field}
         */
        function phonenumber(){
            var field = FormsClassService.text();
            field.validation.mask = '(000) 000-0000';
            return field;
        }

        /**
         * Builds a text field modified for social security numbers
         * @function socialsecurity
         * @returns {Field}
         */
        function socialsecurity(){
            var field = FormsClassService.text();
            field.validation.mask = '000-00-0000';
            return field;
        }

        /**
         * Builds a text field modified for URLs
         * @function url
         * @returns {Field}
         */
        function url(){
            var field = FormsClassService.text();
            field.validation.pattern = '/^((http|https):\\/\\/)?[a-zA-Z]+\\.[a-zA-Z\\.]*[a-zA-Z]+(:[0-9]+)?[a-zA-Z0-9\\.\\?#\\-%&=\\/_]*$/';
            return field;
        }

        /**
         * Builds a text field modified for ZIP codes
         * @function zip
         * @returns {Field}
         */
        function zip(){
            var field = FormsClassService.text();
//                field.validation.mask = "00000-0000"; // ZIP +4
            field.validation.mask = "00000";
            return field;
        }

        /**
         * Builds a datetime field with short date format
         * @function shortDate
         * @returns {Field}
         */
        function shortDate(){
            var field = FormsClassService.datetime();
            field.display.format = 'd';
            return field;
        }

        /**
         * Builds a datetime field with long date format
         * @function longDate
         * @returns {Field}
         */
        function longDate(){
            var field = FormsClassService.datetime();
            field.display.format = 'D';
            return field;
        }

        /**
         * Builds a datetime field with 24-hour time format
         * @function twentyFourHourTime
         * @returns {Field}
         */
        function twentyFourHourTime(){
            var field = FormsClassService.datetime();
            field.display.format = 'HH:mm';
            return field;
        }

        /**
         * Builds a datetime field with 12-hour time format
         * @function twelveHourTime
         * @returns {Field}
         */
        function twelveHourTime(){
            var field = FormsClassService.datetime();
            field.display.format = 'h:mm tt';
            return field;
        }

        /**
         * Builds a datetime field that shows short date-time format
         * @function shortDateTime
         * @returns {Field}
         */
        function shortDateTime(){
            var field = FormsClassService.datetime();
            field.display.format = 'g';
            return field;
        }

        /**
         * Builds a datetime field that shows long date-time format
         * @function shortDateTime
         * @returns {Field}
         */
        function longDateTime(){
            var field = FormsClassService.datetime();
            field.display.format = 'G';
            return field;
        }

        function hiddenText(){
            var field = FormsClassService.text();
            field.config.isHidden = true;
            return field;
        }

        function hiddenNumber(){
            var field = FormsClassService.number();
            field.config.isHidden = true;
            return field;
        }

        function hiddenDatetime(){
            var field = FormsClassService.datetime();
            field.config.isHidden = true;
            return field;
        }

        function hiddenDropDown(){
            var field = FormsClassService.select();
            field.config.isHidden = true;
            return field;
        }
    }])
;

angular.module('cerberus.admin')
    .controller('FormsDesigner_dataseriesCtrl',
    ["_", "$scope", "$timeout", "$uibModalInstance", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsDesignerListService", "PagesService", "ViewsService", "WidgetsService", "WidgetsSettingsService", function FormsDesigner_dataseriesCtrl(_, $scope, $timeout, $uibModalInstance, autoTabIndex, currentFormObjects,
                                          editFlag, formObj, formOriginId, idArray, sections, widgetId,
                                          DesignerUtilityService, FormsDesignerListService, PagesService,
                                          ViewsService, WidgetsService, WidgetsSettingsService) {
        // Populate Scope
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.formId = formOriginId;
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.widgets = [];
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.formFieldObjects = [];
        $scope.conditionOptions = [];
        $scope.targetWidgetFields = [];
        $scope.viewColumns = [];
        $scope.defaultData = {
            type: 'field',
            sourceValue: null,
            sourceModelId: '',
            targetField: null
        };
        $scope.workflowFormObjects = [];

        $scope.defaultFilter = {};
        $scope.defaultFilterType = null;
        $scope.defaultFilterOperators = DesignerUtilityService.filterOperators();
        $scope.cascadeFilter = {};
        $scope.filterType = null;
        $scope.filterOperators = {
            number: [
                {value: 'eq', display: 'Equal To'},
                {value: 'gte', display: 'Greater Than or Equal To'},
                {value: 'lte', display: 'Less Than or Equal To'}
            ],
            string: [
                {value: 'contains', display: 'Contains'}
            ],
            selection: [
                {value: 'eq', display: 'Equal To'}
            ]
        };

        $scope.groups = [];
        $scope.columns = [];
        $scope.fieldOptions = {};
        $scope.update = false;
        $scope.aggregates = {
            average: 'Average',
            count: 'Count',
            max: 'Max',
            min: 'Min',
            sum: 'Sum'
        };
        $scope.resultFilterOperators = [
            {value: '\'contains\'', display: 'Contains'},
            {value: '\'startswith\'', display: 'Starts With'}
        ];
        $scope.aggregateColumn = null;
        $scope.aggregateType = null;
        $scope.aggregateData = {title: '', field: ''};
        $scope.forms = [];
        $scope.lookups = [];
        $scope.sections = sections;
        $scope.conditionalActions = FormsDesignerListService.conditionalActions();
        $scope.conditionType = '';
        $scope.conditionOperators = DesignerUtilityService.conditionOperators();
        $scope.conditionBooleanValues = DesignerUtilityService.conditionBooleanValues();
        $scope.conditionActionValues = DesignerUtilityService.conditionActionValues();
        $scope.conditionFilter = DesignerUtilityService.conditionFilter(formOriginId, formObj.model.config.modelId);
        $scope.getConditionType = DesignerUtilityService.getConditionType;
        $scope.addCondition = DesignerUtilityService.addCondition($scope.temp, formOriginId);
        $scope.dataSeriesColLookupOptions = dataSeriesColLookupOptions;

        $scope.pages = [];
        $scope.pageObjects = [];
        $scope.pageObjectFields = [];

        $scope.geoProperties = [
            { value: 'formatted_address', display: 'Full Address' },
            { value: 'postal_address', display: 'Postal Address' },
            { value: 'country_long_name', display: 'Country (Long)' },
            { value: 'country_short_name', display: 'Country (Short)' },
            { value: 'administrative_area_level_1_long_name', display: 'State (Long)' },
            { value: 'administrative_area_level_1_short_name', display: 'State (Short)' },
            { value: 'administrative_area_level_2_long_name', display: 'County (Long)' },
            { value: 'administrative_area_level_2_short_name', display: 'County (Short)' },
            { value: 'locality_long_name', display: 'City (Long)' },
            { value: 'locality_short_name', display: 'City (Short)' },
            { value: 'postal_code_long_name', display: 'ZIP (Long)' },
            { value: 'postal_code_short_name', display: 'ZIP (Short)' },
            { value: 'street_address', display: 'Street Address' }
        ];

        $scope.sortableColumnsOptions = {
            ignore: "input,select",
            change: function (e) {
                $timeout(function () {
                    reorderItem($scope.temp.model.tag.inner, e.oldIndex, e.newIndex);
                });
            }
        };

        $scope.addDefaultData = addDefaultData;

        // UI Helper Functions
        $scope.deleteProperty = DesignerUtilityService.deleteProperty;
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        // Generates Unique ID for column field
        $scope.labelToColumnUniqueId = function(column){
            if(!$scope.update) {
                var ids = angular.copy(idArray);
                for(var c = 0; c < $scope.columns.length; c++){
                    ids.push($scope.columns[c].field);
                }
                column.field = DesignerUtilityService.labelToUniqueId(column.title, ids);
            }
        };

        $scope.createFieldString = function(container, options, values){
            var inputString = '<select class="k-input k-textbox" name="' + options.field + '" bind="value:' + options.field + '">';
            inputString += '<option value class>Choose...</option>';
            if(values) {
                for (var v = 0; v < values.length; v++) {
                    inputString += '<option value="' + values[v].display + '">' + values[v].display + '</option>';
                }
            }
            inputString += '</select>';
            var input = $(inputString);
            input.appendTo(container);
        };

        $scope.addOption = function(array,data){
            var r = /\d+/;
            var a = 0;
            if(array.length > 0){
                a = Math.max.apply(Math,array.map(function(o){return o.id.match(r);}));
                a = a + 1;
            }
            data.id = 'opt' + a;
            array.push(data);
        };
        $scope.deleteArrayObject = function(array,index){
            array.splice(index, 1);
        };
        $scope.concatArrays = function(arrayA, arrayB){
            var combinedArray = arrayA.concat(arrayB);
            angular.copy(combinedArray, arrayA);
        };

        $scope.selectWidget = function(id){
            $scope.temp.model.param.fk = null;
            $scope.temp.model.param.optionId = null;
            $scope.temp.model.param.column = null;
            $scope.temp.model.param.fkFormOrigin = null;
            $scope.temp.model.param.fkFormId = null;
            $scope.temp.model.param.lookup = null;
            $scope.temp.model.param.lookupFormOrigin = null;
            $scope.temp.model.param.lookupFormId = null;
            $scope.temp.model.param.defaultFilter = null;
            $scope.temp.model.param.workflowId = null;

            if($scope.temp.model.config.type === 'multiselect') {
                $scope.temp.model.option.id = null;
                $scope.temp.model.option.widgetId = null;
                $scope.temp.model.option.column = null;
            }

            if(id){
                WidgetsSettingsService.getFormFields(id).then(function(data){
                    var lookups = [];
                    var forms = [];
                    var targetWidgetFields = [];

                    for(var i = 0; i < data.display.length; i++){
                        var fields = data.display[i].objects;
                        for(var j = 0; j < fields.length; j++){
                            var field = fields[j];
                            var tmp = {
                                modelId: field.modelId,
                                label: field.label,
                                formName: data.display[i].formName,
                                formId: data.display[i].originId,
                                stateId: data.display[i].stateId,
                                isLookup: field.isLookUp,
                                isCustomLookup: field.isCustomLookup,
                                type: field.type,
                                dataType: field.dataType
                            };
                            if(field.isLookUp){
                                tmp.lookupCol = field.column;
                                tmp.viewId = field.optionId;

                                if(field.widgetId == widgetId && field.optionId){
                                    field.__formOriginId = data.display[i].originId;
                                    field.__formId = data.display[i].formId;
                                    lookups.push(field);
                                    fields.splice(j, 1);
                                    j--;
                                }

                                if($scope.temp.model.config.type === 'table' && field.widgetId == id && !$scope.temp.model.param.lookup){
                                    $scope.temp.model.param.lookup = field.modelId;
                                    $scope.temp.model.param.lookupFormOrigin = data.display[i].originId;
                                    $scope.temp.model.param.lookupFormId = data.display[i].formId;
                                }

                                if($scope.temp.model.param.lookup === field.modelId){
                                    if(!$scope.temp.model.param.lookupFormOrigin) {
                                        $scope.temp.model.param.lookupFormOrigin = data.display[i].originId;
                                        $scope.temp.model.param.lookupFormId = data.display[i].formId;
                                    }

                                    if($scope.temp.model.config.type === 'multiselect') {
                                        $scope.temp.model.param.defaultFilter = field.filters;
                                    }
                                }
                            }
                            targetWidgetFields.push(tmp);
                        }
                        forms.push(data.display[i]);
                    }

                    $scope.forms = forms;
                    $scope.targetWidgetFields = targetWidgetFields;
                    $scope.lookups = lookups;

                    if($scope.lookups.length > 0){
                        var fk = $scope.lookups[0];
                        $scope.temp.model.param.fk = fk.modelId;
                        $scope.temp.model.param.optionId = fk.optionId;
                        $scope.temp.model.param.column = fk.column;
                        $scope.temp.model.param.fkFormOrigin = fk.__formOriginId;
                        $scope.temp.model.param.fkFormId = fk.__formId;

                        if($scope.temp.model.config.type === 'multiselect') {
                            $scope.setOptionId(fk);
                        }
                    }
                });

                WidgetsService.getWidget(id).then(function(data){
                    $scope.temp.model.param.workflowId = data.workflow.originatorId;
                });
            }
        };

        $scope.toggleField = function (field, formOriginId) {
            var index = $scope.fieldIndex(field, $scope.temp.model.tag.inner);
            if (index < 0) {
                var col = {
                    title: field.label,
                    field: (field.isLookUp || field.isCustomLookup) ? '__' + field.modelId + '_display' : field.modelId,
                    isLookUp: field.isLookUp,
                    isCustomLookup: field.isCustomLookup,
                    format: field.format || null,
                    type: field.type,
                    formOriginId: formOriginId
                };

                if (col.type == 'dataseries') {
                    col.widgetId = field.widgetId;
                }

                $scope.temp.model.tag.inner.push(col);
            }
            else {
                if(angular.equals($scope.temp.model.tag.inner[index], $scope.aggregateColumn)){
                    $timeout(function(){
                        $scope.aggregateColumn = null;
                    });
                }
                $scope.temp.model.tag.inner.splice(index, 1);
            }
        };

        $scope.fieldIndex = function (field, array){
            var modelId = (field.isLookUp || field.isCustomLookup) ? '__' + field.modelId + '_display' : field.modelId;
            for(var i = 0; i < array.length; i++){
                if(array[i].field === modelId){
                    return i;
                }
            }
            return -1;
        };

        $scope.noTablesFilter = function(field){
            return field.type !== 'dataseries';
        };

        $scope.recursiveTablesFilter = function(field){
            return field.type === 'dataseries' && field.widgetId === $scope.temp.model.param.widgetId;
        };

        $scope.lookupsFilter = function(e){
            return e.isLookUp;
        };

        $scope.setOptionId = function(lookup){
            $scope.temp.model.option.id = null;
            $scope.temp.model.option.widgetId = null;
            $scope.temp.model.option.column = null;
            $scope.temp.model.param.lookupFormOrigin = null;
            $scope.viewColumns = [];

            if(lookup){
                for(var i = 0; i < $scope.forms.length; i++){
                    var objects = $scope.forms[i].objects;
                    for(var j = 0; j < objects.length; j++){
                        var obj = objects[j];
                        if(obj.modelId === lookup && obj.isLookUp){
                            $scope.temp.model.option.id = obj.optionId;
                            $scope.temp.model.option.widgetId = obj.widgetId;
                            $scope.temp.model.option.column = obj.column;
                            $scope.temp.model.param.lookupFormOrigin = $scope.forms[i].originId;
                            $scope.temp.model.param.lookupFormId = $scope.forms[i].formId;

                            if(obj.type && obj.type !== 'string'){
                                $scope.temp.model.option.type = obj.type;
                            }

                            $scope.temp.model.param.defaultFilter = obj.filters;

                            $scope.loadViewColumns(obj.optionId);
                            return;
                        }
                    }
                }
            }
        };

        $scope.loadViewColumns = function(id){
            if(id){
                ViewsService.getColumns(id).then(function(data){
                    $scope.viewColumns = data;
                });
            }
            else{
                $scope.viewColumns = [];
            }
        };

        $scope.deleteAggregate = function(field, type){
            delete $scope.temp.model.param.aggregates[field][type];
        };
        
        $scope.addAggregate = function (field, type) {
            $scope.temp.model.param.aggregates[field] = $scope.temp.model.param.aggregates[field] || {};
            if(!$scope.temp.model.param.aggregates[field][type]){
                $scope.temp.model.param.aggregates[field][type] = {
                    title: $scope.aggregateData.title,
                    field: $scope.aggregateData.field
                };
                $scope.aggregateType = "";
                _.assign($scope.aggregateData, {title: '', field: ''});
            }
        };

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    objects.push(object);
                }
            }
            return objects;
        }

        // Default Filter
        $scope.notPropertyColumn = function(col){
            return col.type === 'column';
        };

        $scope.updateDefaultFilterType = function(){
            if($scope.defaultFilter.field && $scope.defaultFilter.field !== ''){
                //var index = $scope.viewColumns.map(function (elem) { return elem.colName; }).indexOf($scope.defaultFilter.field); /* NON LODASH OPTION */

                /* LODASH Version 4 ONLY */
                //var index = _.findIndex($scope.viewColumns, ['colName', $scope.defaultFilter.field]);
                /* LODASH Version 3 & 4 Compatibility Mode */
                var index = _.findIndex($scope.viewColumns, function(f){return f.colName === $scope.defaultFilter.field;});
                if(index >= 0){
                    $scope.defaultFilterType = $scope.viewColumns[index].castType;
                    return;
                }
            }
            $scope.defaultFilterType = null;
        };

        $scope.addFilter = function(){
            $scope.temp.model.param.defaultFilter.filters.push($scope.defaultFilter);
            $scope.defaultFilter = {};
            $scope.defaultFilterType = null;
        };

        // Cascade Filter
        $scope.updateFilterType = function(){
            var id = $scope.cascadeFilter.value;
            if(id) {
                for (var i = 0; i < $scope.formFieldObjects.length; i++) {
                    if ($scope.formFieldObjects[i].modelId === id) {
                        $scope.filterType = $scope.formFieldObjects[i].dataType;
                        $scope.cascadeFilter.operator = $scope.filterOperators[$scope.filterType][0].value;
                        return;
                    }
                }
            }
        };

        $scope.addCascadeFilter = function(){
            $scope.temp.model.param.cascadeFilter.filters.push($scope.cascadeFilter);
            $scope.cascadeFilter = {};
            $scope.filterType = null;
        };

        // Advanced Selection
        $scope.loadPageObjects = loadPageObjects;
        $scope.getPageObjectFields = getPageObjectFields;
        $scope.addAdvSelFilter = addAdvSelFilter;
        $scope.compatiblePageObjectFilter = compatiblePageObjectFilter;
        $scope.lookupFilter = lookupFilter;

        function loadPageObjects(pageId){
            if(pageId){
                PagesService.getPage(pageId).then(function(pageModel){
                    $scope.pageObjects = pageModel.items;
                    $scope.filters = DesignerUtilityService.getFilters($scope.pageObjects);

                    if(_.has($scope.temp, 'model.param.advSel.pageObjectId')){
                        getPageObjectFields(_.get($scope.temp, 'model.param.advSel.pageObjectId'));
                    }
                });
            }
            else {
                $scope.pageObjects = [];
            }
        }

        function getPageObjectFields(pageObjectId){
            var pageObj = _.find($scope.pageObjects, 'id', pageObjectId);
            if(pageObj){
                $scope.pageObjectFields = pageObj.viz.settings.columns;
            }
            else {
                $scope.pageObjectFields = [];
            }
        }

        function addAdvSelFilter(filter, modelId){
            var filterMap = $scope.temp.model.param.advSel.filterMap;
            var filterObj = {
                filter: filter,
                modelId: modelId
            };

            var valueObject = _.find($scope.formFieldObjects, 'modelId', modelId);
            if(valueObject){
                filterObj.formOriginId = valueObject.formId;
                filterMap.push(filterObj);
            }
        }

        function compatiblePageObjectFilter(pageObject){
            return _.get(pageObject, 'viz.type') === 'table';
        }

        function lookupFilter(column){
            return column.isLookUp || column.isCustomLookup;
        }

        function reorderItem(array, oldIndex, newIndex){
            var item = array.splice(oldIndex, 1)[0];
            array.splice(newIndex, 0, item);
        }

        init();

        // Init
        function init(){
            if($scope.temp.model.config.type === 'table') {
                _.defaults($scope.temp.model.param, {
                    otherData: [],
                    aggregates: {},
                    advSel: {
                        filterMap: []
                    },
                    disableDuplicate: true
                });

                PagesService.getPages().then(function (pages) {
                    $scope.pages = pages;
                });

                loadPageObjects(_.get($scope.temp, 'model.param.advSel.pageId'));
            }
            else if($scope.temp.model.config.type === 'multiselect') {
                _.defaults($scope.temp.model.param, {
                    defaultFilter: {
                        logic: 'and',
                        filters: []
                    },
                    cascadeFilter: {
                        logic: 'and',
                        filters: []
                    }
                });

                $scope.loadViewColumns($scope.temp.model.option.id);
            }

            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);

                var conditionOptions = _.sortBy(_.filter($scope.formFieldObjects, $scope.conditionFilter), 'label');
                $scope.conditionOptions = [{ label: '(Record Action)', modelId: '__nimRecordAction' }].concat(conditionOptions);
            });

            WidgetsService.getWidgets().then(function(widgets){
                $scope.widgets = widgets;
            });

            if(formObj.model.param.widgetId){
                WidgetsSettingsService.getFormFields(formObj.model.param.widgetId).then(function(data){
                    var lookups = [];
                    var forms = [];
                    var targetWidgetFields = [];

                    for(var i = 0; i < data.display.length; i++){
                        var fields = data.display[i].objects;
                        for(var j = 0; j < fields.length; j++){
                            var field = fields[j];
                            var tmp = {
                                modelId: field.modelId,
                                label: field.label,
                                formName: data.display[i].formName,
                                formId: data.display[i].originId,
                                stateId: data.display[i].stateId,
                                isLookup: field.isLookUp,
                                isCustomLookup: field.isCustomLookup,
                                type: field.type,
                                dataType: field.dataType
                            };
                            if(field.isLookUp){
                                tmp.lookupCol = field.column;
                                tmp.viewId = field.optionId;

                                if(field.widgetId == widgetId && field.optionId){
                                    field.__formOriginId = data.display[i].originId;
                                    field.__formId = data.display[i].formId;
                                    lookups.push(field);
                                    fields.splice(j, 1);
                                    j--;
                                }
                            }
                            targetWidgetFields.push(tmp);
                        }
                        forms.push(data.display[i]);
                    }

                    $scope.forms = forms;
                    $scope.targetWidgetFields = targetWidgetFields;
                    $scope.lookups = lookups;
                });
            }
        }

        function addDefaultData(){
            $scope.temp.model.param.otherData.push($scope.defaultData);
            $scope.defaultData = {
                type: 'field',
                sourceValue: null,
                sourceModelId: '',
                targetField: null
            };
        }

        function dataSeriesColLookupOptions(widgetId) {
            return {
                dataTextField: 'label',
                dataValueField: 'modelId',
                optionLabel: { label: 'Choose...', modelId: '' },
                valuePrimitive: true,
                dataSource: {
                    transport: {
                        read: function (options) {
                            WidgetsSettingsService.getFormFields(widgetId).then(function (data) { 
                                options.success(getFormFieldObjects(data));
                            });
                        }
                    }
                }
            };
        }

        // Modal Actions
        $scope.ok = function (){
            $uibModalInstance.close($scope.temp);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_datetimeCtrl', ["_", "moment", "kendo", "$scope", "$uibModalInstance", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "FormsDesignerListService", "FormsClassService", "DesignerUtilityService", "WidgetsSettingsService", function FormsDesigner_datetimeCtrl(_, moment, kendo, $scope, $uibModalInstance, autoTabIndex, currentFormObjects,
                                                                                  editFlag, formObj, formOriginId, idArray, sections, widgetId,
                                                                                  FormsDesignerListService, FormsClassService,
                                                                                  DesignerUtilityService, WidgetsSettingsService) {
        // Populate Scope
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.defaultValType = null;
        $scope.customDefaultVal = null;
        $scope.valueTypes = FormsDesignerListService.defaultDateValues();
        $scope.formFields = [];
        $scope.formFieldObjects = [];
        $scope.conditionOptions = [];
        $scope.sections = sections;
        $scope.isTimeFormat = $scope.temp.model.display.format.match(/[HhfmstgG]/g);
        $scope.customParseFormat = {};
        $scope.conditionalActions = FormsDesignerListService.conditionalActions();
        $scope.conditionType = '';
        $scope.conditionOperators = DesignerUtilityService.conditionOperators();
        $scope.conditionBooleanValues = DesignerUtilityService.conditionBooleanValues();
        $scope.conditionActionValues = DesignerUtilityService.conditionActionValues();
        $scope.conditionFilter = DesignerUtilityService.conditionFilter(formOriginId, formObj.model.config.modelId);
        $scope.getConditionType = DesignerUtilityService.getConditionType;
        $scope.addCondition = DesignerUtilityService.addCondition($scope.temp, formOriginId);
        $scope.addCustomParseFormat = addCustomParseFormat;
        $scope.previewCustomParseFormat = previewCustomParseFormat;

        $scope.updateDefaultValue = function(defaultVal, customVal){
            if(defaultVal === '@nim_today'){
                $scope.temp.model.config.defaultValue = '@nim_today';
            }
            else{
                $scope.temp.model.config.defaultValue = customVal;
            }
        };

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        // Form Object Specific Logic
        $scope.formatList = [
            { display: 'Short Date', value: 'd' },
            { display: 'Long Date', value: 'D' },
            { display: '24-Hour Time', value: 'HH:mm:ss' },
            { display: '12-Hour Time', value: 'h:mm:ss tt' },
            { display: 'Short Date-Time', value: 'g' },
            { display: 'Long Date-Time', value: 'G' }
        ];

        $scope.formatChanged = function(){
            $scope.isTimeFormat = $scope.temp.model.display.format.match(/[HhfmstgG]/g);
            $scope.formattedDate = getFormatDate();
        };

        $scope.deleteArrayObject = function(array, index){
            array.splice(index, 1);
        };

        // Modal Actions
        $scope.ok = function (){
            $uibModalInstance.close($scope.temp);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Init
        init();

        function init(){
            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFields = formFieldArray;
                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);

                var conditionOptions = _.sortBy(_.filter($scope.formFieldObjects, $scope.conditionFilter), 'label');
                $scope.conditionOptions = [{ label: '(Record Action)', modelId: '__nimRecordAction' }].concat(conditionOptions);

                // Codemirror
                $scope.codemirrorLoaded = DesignerUtilityService.codemirrorLoaded(formFieldArray.operands);
                $scope.mainGridOptions = DesignerUtilityService.formGrid(formFieldArray.display);
                $scope.detailGridOptions = DesignerUtilityService.formDetailGrid($scope);
            });

            if(formObj.model.config.defaultValue === '@nim_today'){
                $scope.defaultValType = '@nim_today';
            }
            else{
                $scope.defaultValType = 'custom';
                $scope.customDefaultVal = formObj.model.config.defaultValue;
            }

            $scope.formattedDate = getFormatDate();

            // Hack
            DesignerUtilityService.focusFirstElement('configForm');
        }

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    objects.push(object);
                }
            }
            return objects;
        }

        function getFormatDate(){
            var now = moment(new Date()),
                interval = $scope.temp.model.tag.attrs['k-interval'];

            if(interval && now.round && $scope.isTimeFormat){
                now.round(interval, 'minutes');
            }

            return kendo.toString(now.toDate(), $scope.temp.model.display.format);
        }

        function addCustomParseFormat(format) {
            if (!$scope.temp.model.param.parseFormats){
                $scope.temp.model.param.parseFormats = [];
            }

            $scope.temp.model.param.parseFormats.push(format.text);
            format.text = '';
        }

        function previewCustomParseFormat(format) {
            return kendo.toString(new Date(), format);
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name FormsDesignerListService
 * @alias cerberus/forms-designer:FormsDesignerListService
 * @description Returns options for User Interface
 */
    .factory('FormsDesignerListService', function FormsDesignerListService() {
        return {
            formObjects: formObjects,
            patterns: patterns,
            masks: masks,
            separators: separators,
            defaultDateValues: defaultDateValues,
            addressFields: addressFields,
            conditionalActions: conditionalActions
        };
        /////////////////////
        function defaultDateValues(){
            return [
                {
                    label: 'Today',
                    value: '@nim_today'
                },
                {
                    label: 'Custom',
                    value: 'custom'
                }
            ];
        }
        /**
         * @function formObjects
         * @returns {{text: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, textarea: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, autocomplete: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, number: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, datetime: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, select: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, multiselect: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, radio: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, checkbox: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, signature: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, table: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, hr: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, statictext: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}, readonly: {tabTemplates: {name: string, url: string}[], dataType: string, display: string, defaultSizeX: number, defaultSizeY: number}}}
         */
        function formObjects() {
            return {
                text:{
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/string/advanced-tab.tpl.html'
                        },
                        {
                            name: 'Calculation',
                            url: 'admin/widgets/forms/designer/string/calculation-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'string',
                    display: 'Text',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                textarea: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/string/advanced-textarea-tab.tpl.html'
                        },
                        {
                            name: 'Calculation',
                            url: 'admin/widgets/forms/designer/string/calculation-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'string',
                    display: 'Paragraph Text',
                    defaultSizeX: 12,
                    defaultSizeY: 35
                },
                autocomplete: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/string/advanced-autocomplete-tab.tpl.html'
                        },
                        {
                            name: 'Calculation',
                            url: 'admin/widgets/forms/designer/string/calculation-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'string',
                    display: 'Auto Complete',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                location: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/string/advanced-location-tab.tpl.html'
                        },
                        {
                            name: 'Calculation',
                            url: 'admin/widgets/forms/designer/string/calculation-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'string',
                    display: 'Geolocation',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                map: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/map/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/map/advanced-tab.tpl.html'
                        }
                    ],
                    dataType: 'map',
                    display: 'Map',
                    defaultSizeX: 24,
                    defaultSizeY: 85
                },
                number: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/number/advanced-tab.tpl.html'
                        },
                        {
                            name: 'Calculation',
                            url: 'admin/widgets/forms/designer/number/calculation-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'number',
                    display: 'Number',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                datetime: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/datetime/advanced-tab.tpl.html'
                        },
                        {
                            name: 'Calculation',
                            url: 'admin/widgets/forms/designer/datetime/calculation-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'datetime',
                    display: 'Date/Time',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                select: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/selection/advanced-tab.tpl.html'
                        },
                        //{
                        //    name: 'Calculation',
                        //    url: 'admin/widgets/forms/designer/selection/calculation-tab.tpl.html'
                        //},
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'selection',
                    display: 'Drop Down',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                multiselect: {
                    tabTemplates: [
                        //{
                        //    name: 'General',
                        //    url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        //},
                        //{
                        //    name: 'Advanced',
                        //    url: 'admin/widgets/forms/designer/selection/advanced-tab.tpl.html'
                        //},
                        //{
                        //    name: 'Calculation',
                        //    url: 'admin/widgets/forms/designer/selection/calculation-tab.tpl.html'
                        //},
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/dataseries/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/dataseries/advanced-table-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'dataseries',
                    display: 'Multiple Select',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                radio: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/selection/advanced-tab.tpl.html'
                        },
                        //{
                        //    name: 'Calculation',
                        //    url: 'admin/widgets/forms/designer/selection/calculation-tab.tpl.html'
                        //},
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'selection',
                    display: 'Radio',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                checkbox: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'selection',
                    display: 'Checkbox',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                signature: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/signature/advanced-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'signature',
                    display: 'Signature',
                    defaultSizeX: 8,
                    defaultSizeY: 10
                },
                table: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/dataseries/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/dataseries/advanced-table-tab.tpl.html'
                        }
                    ],
                    dataType: 'dataseries',
                    display: 'Table',
                    defaultSizeX: 12,
                    defaultSizeY: 60
                },
                hr: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/static/general-hr-tab.tpl.html'
                        }
                    ],
                    dataType: 'static',
                    display: 'Divider',
                    defaultSizeX: 12,
                    defaultSizeY: 6
                },
                statictext: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/static/general-statictext-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'static',
                    display: 'Static Text',
                    defaultSizeX: 12,
                    defaultSizeY: 7
                },
                barcode:{
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/readonly/barcode-config-tab.tpl.html'
                        },
                        {
                            name: 'Condition',
                            url: 'admin/widgets/forms/designer/common/condition-tab.tpl.html'
                        }
                    ],
                    dataType: 'barcode',
                    display: 'Barcode',
                    defaultSizeX: 6,
                    defaultSizeY: 9
                },
                readonly: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/readonly/advanced-tab.tpl.html'
                        },
                        {
                            name: 'Calculation',
                            url: 'admin/widgets/forms/designer/readonly/calculation-tab.tpl.html'
                        }
                    ],
                    dataType: 'readonly',
                    display: 'Read Only',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                timer: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/readonly/timer-config-tab.tpl.html'
                        }
                    ],
                    dataType: 'timer',
                    display: 'Timer',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                image: {
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/image/image-config-tab.tpl.html'
                        }
                    ],
                    dataType: 'image',
                    display: 'Image',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                },
                rule:{
                    tabTemplates: [
                        {
                            name: 'General',
                            url: 'admin/widgets/forms/designer/common/general-tab.tpl.html'
                        },
                        {
                            name: 'Advanced',
                            url: 'admin/widgets/forms/designer/rule/advanced-tab.tpl.html'
                        }
                    ],
                    dataType: 'rule',
                    display: 'Rule',
                    defaultSizeX: 6,
                    defaultSizeY: 7
                }
            };
        }

        /**
         * @function patterns
         * @returns {{id: string, display: string, pattern: string}[]}
         */
        function patterns() {
            return [
                {
                    id: 'email',
                    display: 'Email',
                    pattern: '^\w[\w\.\-]*\w@\w+[\w\.\-]*\.[a-zA-Z]{2,}$'
                },
                {
                    id: 'url',
                    display: 'URL',
                    pattern: '^(https?:\/\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\/\\w \\.-]*)*\/?$'
                }
            ];
        }

        /**
         * @function masks
         * @returns {{display: string, mask: string}[]}
         */
        function masks() {
            return [
                {
                    display: 'U.S. Phone Number',
                    mask: '(000) 000-0000'
                }
            ];
        }

        /**
         * @function separators
         * @returns {string[]}
         */
        function separators() {
            return [
                'None',
                ', ',
                '| ',
                '; '
            ];
        }

        function addressFields(){
            return {
                formatted_address: 'Full Address',
                postal_address: 'Postal Address',
                street_address: 'Street Address',
                street_number_long_name: 'Street Number',
                route_long_name: 'Street',
                establishment: 'Establishment',
                locality_long_name: 'City',
                administrative_area_level_1_short_name: 'State',
                administrative_area_level_2_long_name: 'County',
                postal_code_short_name: 'ZIP Code',
                postal_code_suffix_long_name: 'ZIP +4',
                country_long_name: 'Country',
                lat: 'Latitude',
                lng: 'Longitude'
            };
        }

        /**
         * @function conditionalActions
         * @param isStaticField
         * @returns {{display: string, value: string}[]}
         */
        function conditionalActions(isStaticField){
            if(isStaticField){
                return [
                    {
                        display: 'Show',
                        value: 'show'
                    },
                    {
                        display: 'Hide',
                        value: 'hide'
                    }
                ];
            }

            return [
                {
                    display: 'Show',
                    value: 'show'
                },
                {
                    display: 'Hide',
                    value: 'hide'
                },
                {
                    display: 'Active',
                    value: 'active'
                },
                {
                    display: 'Readonly',
                    value: 'readonly'
                },
                {
                    display: 'Required',
                    value: 'required'
                },
                {
                    display: 'Optional',
                    value: 'optional'
                }
            ];
        }
    })
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_mapCtrl', ["_", "$timeout", "$scope", "$uibModalInstance", "$window", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsDesignerListService", "LeafletListService", "WidgetsSettingsService", function FormsDesigner_mapCtrl(_, $timeout, $scope, $uibModalInstance, $window, autoTabIndex,
                                                                        currentFormObjects, editFlag, formObj, idArray, sections, widgetId,
                                                                        DesignerUtilityService, FormsDesignerListService,
                                                                        LeafletListService, WidgetsSettingsService) {
        // Populate Scope
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.patternsList = FormsDesignerListService.patterns();
        $scope.masksList = FormsDesignerListService.masks();
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.separatorList = FormsDesignerListService.separators();
        $scope.isValidRegexTestCase = true;
        $scope.formInput = {
            testPattern: null
        };
        $scope.formFields = [];
        $scope.basemaps = _.defaults(LeafletListService.basemaps(), LeafletListService.layers(false));
        $scope.overlays = LeafletListService.layers(false);
        $scope.usesUrl = LeafletListService.usesUrlLookUp();
        $scope.layerType = LeafletListService.layerTypeLookUp();
        $scope.sections = sections;

        $scope.sortBasemapOptions = {
            ignore: "input,select",
            change: function (e) {
                //The internal splice gets the old and the external place the new
                $timeout(function () {
                    $scope.temp.params.basemaps.splice(e.newIndex, 0, $scope.temp.params.basemaps.splice(e.oldIndex, 1)[0]);
                },0);
            }
        };

        $scope.sortOverlayOptions = {
            ignore: "input,select",
            change: function (e) {
                $timeout(function () {
                    $scope.temp.params.overlays.splice(e.newIndex, 0, $scope.temp.params.overlays.splice(e.oldIndex, 1)[0]);
                },0);
            }
        };

        $scope.colors = [
            {value: 'none', display: 'None'},
            {value: 'red', display: 'Red'},
            {value: 'orange', display: 'Orange'},
            {value: 'yellow', display: 'Yellow'},
            {value: 'green', display: 'Green'},
            {value: 'blue', display: 'Blue'},
            {value: 'purple', display: 'Purple'}
        ];

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        // Form Object Specific Logic
        $scope.checkRegexTestCase = function(){
            if ($scope.formInput.testPattern){
                var pattern = new RegExp($scope.temp.model.validation.pattern);
                $scope.isValidRegexTestCase = $scope.formInput.testPattern.match(pattern);
            }
        };
        $scope.getFormFieldObjects = function(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    objects.push(object);
                }
            }
            return objects;
        };
        $scope.deleteArrayObject = function(array,index){
            array.splice(index, 1);
        };

        $scope.checkBasemapVisibility = function(index, visible, basemaps){
            if(visible){
                for(var i = 0; i < basemaps.length; i++){
                    if(i != index && basemaps[i]){
                        basemaps[i].visible = false;
                    }
                }
            }
        };

        $scope.addLayer = function(array){
            array.push({
                name: '',
                type: null,
                visible: false
            });
        };

        $scope.removeLayer = function(array, index){
            array.splice(index, 1);
        };

        // Modal Actions
        $scope.ok = function (){
            $uibModalInstance.close($scope.temp);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Init
        init();

        function init(){
            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFields = formFieldArray;
            });

            // Hack
            DesignerUtilityService.focusFirstElement('configForm');
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_numberCtrl', ["_", "$scope", "$uibModalInstance", "$timeout", "$window", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsDesignerListService", "WidgetsSettingsService", function FormsDesigner_numberCtrl(_, $scope, $uibModalInstance, $timeout, $window, autoTabIndex, currentFormObjects,
                                                                              editFlag, formObj, formOriginId, idArray, sections, widgetId,
                                                                              DesignerUtilityService, FormsDesignerListService, WidgetsSettingsService) {
        // Populate Scope
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.formFields = [];
        $scope.formFieldObjects = [];
        $scope.conditionOptions = [];
        $scope.sections = sections;
        $scope.defaultValueOptions = buildDefaultValueOptions(formObj.model);
        $scope.conditionalActions = FormsDesignerListService.conditionalActions();
        $scope.conditionType = '';
        $scope.conditionOperators = DesignerUtilityService.conditionOperators();
        $scope.conditionBooleanValues = DesignerUtilityService.conditionBooleanValues();
        $scope.conditionActionValues = DesignerUtilityService.conditionActionValues();
        $scope.conditionFilter = DesignerUtilityService.conditionFilter(formOriginId, formObj.model.config.modelId);
        $scope.getConditionType = DesignerUtilityService.getConditionType;
        $scope.addCondition = DesignerUtilityService.addCondition($scope.temp, formOriginId);
        $scope.rebuildDefaultValue = rebuildDefaultValue;

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        // Form Object Specific Logic
        $scope.validateIsUniqueReliant = function(){
            // Remove orphan record from 'Is unique' selection, when reliant field selection is empty
            if($scope.temp.model.param.isUniqueReliant && (_.isEmpty($scope.temp.model.param.isUniqueReliant.modelId) || $scope.temp.model.validation.unique === false)){
                delete $scope.temp.model.param.isUniqueReliant;
            }
        };

        $scope.setMaskAndDec = function(value){
            var decimalIndex = value.indexOf('.');
            var decimal = 0;
            if(decimalIndex >= 0){
                decimal = value.length - 1 - decimalIndex;
            }
            $scope.temp.model.param.decimals = decimal;
            $scope.temp.model.display.format = value.replace(/[1-9]/g, '0');
        };

        $scope.deleteArrayObject = function(array,index){
            array.splice(index, 1);
        };

        // Modal Actions
        $scope.ok = function () {
            $scope.validateIsUniqueReliant(); //clean orphan record from 'is unique' reliant, if any...
            $uibModalInstance.close($scope.temp);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    objects.push(object);
                }
            }
            return objects;
        }

        // Init
        init();

        function init(){
            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFields = formFieldArray;
                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);

                var conditionOptions = _.sortBy(_.filter($scope.formFieldObjects, $scope.conditionFilter), 'label');
                $scope.conditionOptions = [{ label: '(Record Action)', modelId: '__nimRecordAction' }].concat(conditionOptions);

                // Grid
                $scope.mainGridOptions = DesignerUtilityService.formGrid(formFieldArray.display);
                $scope.detailGridOptions = DesignerUtilityService.formDetailGrid($scope);

                // Codemirror
                $scope.codemirrorLoaded = DesignerUtilityService.codemirrorLoaded(formFieldArray.operands);
            });

            // Hack
            DesignerUtilityService.focusFirstElement('configForm');
        }

        function buildDefaultValueOptions(model){
            var options = {
                decimals: model.param.decimals,
                max: model.validation.max,
                min: model.validation.min,
                step: model.param.step,
                placeholder: model.display.placeholder
            };

            if(model.display.format){
                options.format = model.display.format;
            }

            return options;
        }

        function rebuildDefaultValue(model){
            $scope.defaultValueOptions = null;

            $timeout(function(){
                $scope.defaultValueOptions = buildDefaultValueOptions(model);
            });
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_readonlyCtrl', ["_", "$scope", "$uibModalInstance", "$window", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsDesignerListService", "WidgetsSettingsService", function FormsDesigner_readonlyCtrl(_, $scope, $uibModalInstance, $window, autoTabIndex, currentFormObjects,
                                                                                  editFlag, formObj, formOriginId, idArray, sections, widgetId,
                                                                                  DesignerUtilityService, FormsDesignerListService, WidgetsSettingsService) {
        // Populate Scope
        $scope.formOriginId = formOriginId;
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.formFields = [];
        $scope.sections = sections;
        $scope.widgetFieldIds = idArray;
        $scope.formFieldObjects = [];

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.setAddInfo = setAddInfo;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        $scope.deleteArrayObject = function(array,index){
            array.splice(index, 1);
        };

        // Modal Actions
        $scope.ok = function (){
            $uibModalInstance.close($scope.temp);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Init
        init();

        function init(){
            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFields = formFieldArray;

                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);
                $scope.widgetFieldIds = _.union(idArray, _.map($scope.formFieldObjects, 'modelId'));
                $scope.widgetFieldIds.sort();

                // Grid
                $scope.mainGridOptions = DesignerUtilityService.formGrid($scope.formFields.display);
                $scope.detailGridOptions = DesignerUtilityService.formDetailGrid($scope);

                // Codemirror
                $scope.codemirrorLoaded = DesignerUtilityService.codemirrorLoaded($scope.formFields.operands);
            });

            // Hack
            DesignerUtilityService.focusFirstElement('configForm');
        }

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    objects.push(object);
                }
            }
            return objects;
        }

        function setAddInfo(obj, formFieldObjects, formId){
            for(var i = 0; i < formFieldObjects.length; i++){
                var target = formFieldObjects[i];
                if(obj.modelId === target.modelId){
                    obj.formId = target.formId;
                    return;
                }
            }
            obj.formId = _.last(formId.split('-'));
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_selectionCtrl',
    ["_", "$scope", "$timeout", "$rootScope", "$uibModalInstance", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "AutoFillService", "DesignerUtilityService", "FormsDesignerListService", "FormsDesignerService", "PagesService", "UsersProfileListService", "ViewsService", "WidgetsSettingsService", "WorkspacesGroupsService", function FormsDesigner_selectionCtrl(_, $scope, $timeout, $rootScope, $uibModalInstance, autoTabIndex,
                                         currentFormObjects, editFlag, formObj, formOriginId, idArray, sections, widgetId,
                                         AutoFillService, DesignerUtilityService, FormsDesignerListService, FormsDesignerService,
                                         PagesService, UsersProfileListService, ViewsService, WidgetsSettingsService, WorkspacesGroupsService) {
        // Populate Scope
        $scope.formOriginId = formOriginId;
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.views = [];
        $scope.viewColumns = [];
        $scope.autoFillViewColumns = {};
        $scope.groups = [];
        $scope.profiles = [];
        $scope.errStr = null;
        $scope.selectedWidgetOperands = [];
        $scope.selectedProfileFields = [];
        $scope.curModelIds = idArray;
        $scope.formFieldObjects = [];
        $scope.conditionOptions = [];
        $scope.filterFieldArray = [];
        $scope.widgetFieldIds = idArray;
        $scope.baseWidgetFields = [];
        $scope.sections = sections;
        $scope.autoFill = AutoFillService.autoFillObject();
        $scope.autoFillSubItem = [];
        $scope.autoFillSourceItems = [];
        $scope.autoFillTargetItems = [];
        $scope.lookUpValues = null;
        $scope.sortObj = {
            field: '',
            dir: 'asc'
        };

        $scope.pages = [];
        $scope.pageObjects = [];
        $scope.pageObjectFields = [];
        $scope.advSelTargetColumns = [];

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.cascadeFilter = {value:''};
        $scope.filterType = null;
        $scope.filterOperators = {
            number: [
                {value: 'eq', display: 'Equal To'},
                {value: 'gte', display: 'Greater Than or Equal To'},
                {value: 'lte', display: 'Less Than or Equal To'}
            ],
            string: [
                {value: 'contains', display: 'Contains'}
            ],
            selection: [
                {value: 'eq', display: 'Equal To'}
            ]
        };
        $scope.resultFilterOperators = [
            {value: '\'contains\'', display: 'Contains'},
            {value: '\'startswith\'', display: 'Starts With'}
        ];
        $scope.buttonClasses = [
            {value: 'default', display: 'Default'},
            {value: 'primary', display: 'Primary'},
            {value: 'success', display: 'Success'},
            {value: 'danger', display: 'Danger'},
            {value: 'warning', display: 'Warning'},
            {value: 'info', display: 'Info'}
        ];

        $scope.sortBySortableOptions = {
            ignore: "input,select",
            change: function (e) {
                $timeout(function () {
                    var sortArray = $scope.temp.model.param.sortBy;
                    if(sortArray){
                        reorderItem(sortArray, e.oldIndex, e.newIndex);
                    }
                },0);
            }
        };

        $scope.defaultFilter = {value: ''};
        $scope.defaultFilterType = null;
        $scope.defaultFilterOperators = DesignerUtilityService.filterOperators();
        $scope.conditionalActions = FormsDesignerListService.conditionalActions();
        $scope.conditionType = '';
        $scope.conditionOperators = DesignerUtilityService.conditionOperators();
        $scope.conditionBooleanValues = DesignerUtilityService.conditionBooleanValues();
        $scope.conditionActionValues = DesignerUtilityService.conditionActionValues();
        $scope.conditionFilter = DesignerUtilityService.conditionFilter(formOriginId, formObj.model.config.modelId);
        $scope.getConditionType = DesignerUtilityService.getConditionType;
        $scope.addCondition = DesignerUtilityService.addCondition($scope.temp, formOriginId);
        $scope.lookUpDefaultValueOptions = DesignerUtilityService.lookUpDefaultValueOptions($scope.temp.model.option);
        $scope.deleteProperty = DesignerUtilityService.deleteProperty;
        $scope.addSortItem = addSortItem;
        $scope.removeSortItem = removeSortItem;
        $scope.setOptionColumnType = setOptionColumnType;

        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        // Form Object Specific Logic
        $scope.validateIsUniqueReliant = function(){
            // Remove orphan record from 'Is unique' selection, when reliant field selection is empty
            if($scope.temp.model.param.isUniqueReliant && (_.isEmpty($scope.temp.model.param.isUniqueReliant.modelId) || $scope.temp.model.validation.unique === false)){
                delete $scope.temp.model.param.isUniqueReliant;
            }
        };

        $scope.addOption = function(array,data){
            if(!array){
                array = [];
            }
            var r = /\d+/;
            var a = 0;
            if(array.length > 0){
                a = Math.max.apply(Math,array.map(function(o){return o.id.match(r);}));
                a = a + 1;
            }
            data.id = 'opt' + a;
            array.push(data);
        };

        $scope.addAutoFill = function(){
            var index = $scope.autoFillTargetItems.length;
            var widgetId = $scope.autoFill.widgetId;
            var targetWidgetId = $scope.autoFill.targetWidgetId;
            var type = $scope.autoFill.type;

            $scope.temp.model.option.autoFill.push($scope.autoFill);
            $scope.autoFillSubItem.push(AutoFillService.autoFillSubItem());
            $scope.autoFillSourceItems.push([]);
            $scope.autoFillTargetItems.push([]);
            $scope.autoFill = AutoFillService.autoFillObject();

            if(type !== 'query'){
                loadTableFields(widgetId, $scope.autoFillSourceItems, index);
            }

            loadTableFields(targetWidgetId, $scope.autoFillTargetItems, index);
        };

        $scope.addAutoFillSubItem = function(index){
            $scope.temp.model.option.autoFill[index].subMap.push($scope.autoFillSubItem[index]);
            $scope.autoFillSubItem[index] = AutoFillService.autoFillSubItem();
        };

        $scope.removeAutoFill = function(index){
            $scope.deleteArrayObject($scope.temp.model.option.autoFill, index);
            $scope.deleteArrayObject($scope.autoFillSubItem, index);
            $scope.deleteArrayObject($scope.autoFillTargetItems, index);
        };

        $scope.setAutoFillMetaData = AutoFillService.setAutoFillMetaData;
        $scope.setTargetFormId = AutoFillService.setTargetFormId;
        $scope.setSubItemIds = AutoFillService.setSubItemIds;

        $scope.toggleDefaultValue = function(objConfig, opt){
            $timeout(function(){
                if($scope.optionIsDefault(objConfig.defaultValue, opt)){
                    objConfig.defaultValue = null;
                }
                else {
                    objConfig.defaultValue = opt;
                }
            });
        };

        $scope.optionIsDefault = function(defaultVal, opt){
            return (defaultVal != null && defaultVal.id === opt.id);
        };

        $scope.deleteArrayObject = function(array,index){
            array.splice(index,1);
        };
        $scope.selectColumn = function(id){
            if(id){
                ViewsService.getColumns(id).then(function(data){
                    if(data.length === 0){
                        $scope.errStr = '<div class="alert alert-warning" role="alert"><strong>Warning!</strong> There are no columns in this view.</div>';
                    }
                    else{
                        $scope.errStr = null;
                    }

                    $scope.viewColumns = data;

                    // Populates Select Column when query is selected
                    /* LODASH Version 4 ONLY */
                    //if(_.findIndex(data, ['colName', $scope.temp.model.option.column]) <= 0){
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    if(_.findIndex(data, function(f){return f.colName === $scope.temp.model.option.column;}) <= 0){ 
                        $scope.temp.model.option.column = data[0].colName;
                        setOptionColumnType(data, $scope.temp.model.option);
                        $scope.lookUpDefaultValueOptions.dataSource.read();
                    }
                });

                for(var i = 0; i < $scope.views.length; i++){
                    if($scope.views[i].id === id){
                        $scope.temp.model.option.widgetId = $scope.views[i].base_widget_id;
                        loadBaseWidgetFields($scope.temp.model.option.widgetId);
                        break;
                    }
                }
            }
            else{
                $scope.viewColumns = [];
                $scope.errStr = null;
            }
        };

        $scope.loadAutoFillViewColumns = function(id){
            if(id){
                if(!$scope.autoFillViewColumns[id]) {
                    ViewsService.getColumns(id).then(function (data) {
                        _.forEach(data, function(col){
                            col.colName = col.colName.replace(/_display$/, '');
                        });
                        $scope.autoFillViewColumns[id] = data;
                    });
                }
            }
        };

        $scope.setAutoFillBaseWidget = function(id){
            $scope.loadAutoFillViewColumns(id);
            for(var i = 0; i < $scope.views.length; i++){
                if($scope.views[i].id === id){
                    $scope.autoFill.widgetId = $scope.views[i].base_widget_id;
                    break;
                }
            }
        };

        $scope.queryName = function(id){
            var query = _.find($scope.views, 'id', id);
            return _.get(query, 'name', '');
        };

        $scope.getGroupsList = function(){
            $scope.temp.model.option.type='groups';
            WorkspacesGroupsService.getGroups($rootScope.userData.currentWorkspace.id).then(function(value){
                $scope.groups = value;
            });
        };
        $scope.getProfileTypes = function(){
            $scope.temp.model.option.type='profile';
            $scope.profiles = [];
            angular.forEach(UsersProfileListService.profileFields(),function(v,k){
                $scope.profiles.push(k);
            });
        };
        $scope.selectProfile = function(type){
            $scope.selectedProfileFields = UsersProfileListService.profileFields()[type];
        };

        // Cascade Filter
        $scope.updateFilterType = function(){
            var id = $scope.cascadeFilter.value;
            if(id) {
                for (var i = 0; i < $scope.formFieldObjects.length; i++) {
                    if ($scope.formFieldObjects[i].modelId === id) {
                        $scope.filterType = $scope.formFieldObjects[i].dataType;
                        $scope.cascadeFilter.operator = $scope.filterOperators[$scope.filterType][0].value;
                        return;
                    }
                }
            }
        };

        $scope.addCascadeFilter = function(){
            $scope.temp.model.param.cascadeFilter.filters.push($scope.cascadeFilter);
            $scope.cascadeFilter = {value:''};
            $scope.filterType = null;
        };

        // Default Filter
        $scope.notPropertyColumn = function(col){
            return col.type === 'column';
        };

        $scope.updateDefaultFilterType = function(){
            if($scope.defaultFilter.field && $scope.defaultFilter.field !== ''){
                var index = $scope.viewColumns.map(function(elem){return elem.colName;}).indexOf($scope.defaultFilter.field);
                if(index >= 0){
                    $scope.defaultFilterType = $scope.viewColumns[index].castType;
                    return;
                }
            }
            $scope.defaultFilterType = null;
        };

        $scope.addFilter = function(){
            $scope.temp.model.param.defaultFilter.filters.push($scope.defaultFilter);
            $scope.defaultFilter = {value:''};
            $scope.defaultFilterType = null;
        };

        $scope.sortableOptions = {
            ignore: "input",
            change: function (e) {
                $timeout(function () {
                    var item = $scope.temp.model.option.values.splice(e.oldIndex, 1)[0];
                    $scope.temp.model.option.values.splice(e.newIndex, 0, item);
                },0);
            }
        };

        // Advanced Selection
        $scope.loadPageObjects = loadPageObjects;
        $scope.getPageObjectFields = getPageObjectFields;
        $scope.addAdvSelFilter = addAdvSelFilter;
        $scope.getAdvSelTargetColumns = getAdvSelTargetColumns;
        $scope.compatiblePageObjectFilter = compatiblePageObjectFilter;
        $scope.lookupFilter = lookupFilter;
        $scope.tableFormObjectFilter = tableFormObjectFilter;

        function loadPageObjects(pageId){
            if(pageId){
                PagesService.getPage(pageId).then(function(pageModel){
                    $scope.pageObjects = pageModel.items;
                    $scope.filters = DesignerUtilityService.getFilters($scope.pageObjects);

                    if(_.get($scope.temp, 'model.param.advSel.pageObjectId')){
                        getPageObjectFields($scope.temp.model.param.advSel.pageObjectId);
                    }
                });
            }
            else {
                $scope.pageObjects = [];
            }
        }

        function getPageObjectFields(pageObjectId){
            var pageObj = _.find($scope.pageObjects, 'id', pageObjectId);
            if(pageObj){
                $scope.pageObjectFields = pageObj.viz.settings.columns;
            }
            else {
                $scope.pageObjectFields = [];
            }
        }

        function loadBaseWidgetFields(widgetId){
            if(widgetId){
                WidgetsSettingsService.getFormFields(widgetId).then(function(data){
                    var baseWidgetFields = [];

                    _.forEach(data.display, function(form){
                        _.forEach(form.objects, function(field){
                            baseWidgetFields.push({
                                modelId: field.modelId,
                                label: field.label,
                                formName: form.formName,
                                formId: form.originId,
                                stateId: form.stateId,
                                isLookup: field.isLookUp,
                                isCustomLookup: field.isCustomLookup,
                                dataType: field.dataType
                            });
                        });
                    });

                    $scope.baseWidgetFields = baseWidgetFields;
                });
            }
        }

        function addAdvSelFilter(filter, modelId){
            _.defaults($scope.temp.model.param.advSel, { filterMap: [] });
            var filterMap = $scope.temp.model.param.advSel.filterMap;
            var filterObj = {
                filter: filter,
                modelId: modelId
            };

            var valueObject = _.find($scope.formFieldObjects, 'modelId', modelId);
            if(valueObject){
                filterObj.formOriginId = valueObject.formId;
                filterMap.push(filterObj);
            }
        }

        function getAdvSelTargetColumns(formObjects, modelId){
            var target = _.find(formObjects, 'modelId', modelId);
            if(target.widgetId){
                WidgetsSettingsService.getFormFields(target.widgetId).then(function(data){
                    var formFields = getFormFieldObjects(data);

                    $scope.advSelTargetColumns = _.map(formFields, function(field){
                        var col = {
                            label: field.label
                        };

                        if(field.isLookUp || field.isCustomLookup){
                            col.modelId = '__' + field.modelId + '_display';
                        }
                        else {
                            col.modelId = field.modelId;
                        }

                        return col;
                    });
                });
            }
        }

        function compatiblePageObjectFilter(pageObject){
            return _.get(pageObject, 'viz.type') === 'table';
        }

        function lookupFilter(column){
            return column.isLookUp || column.isCustomLookup;
        }

        function tableFormObjectFilter(formObject){
            return formObject.type === 'dataseries';
        }

        // Init
        init();

        function init(){
            // Hack
            DesignerUtilityService.focusFirstElement('configForm');

            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);
                $scope.widgetFieldIds = _.union(idArray, _.map($scope.formFieldObjects, 'modelId'));

                var conditionOptions = _.sortBy(_.filter($scope.formFieldObjects, $scope.conditionFilter), 'label');
                $scope.conditionOptions = [{ label: '(Record Action)', modelId: '__nimRecordAction' }].concat(conditionOptions);

                $scope.updateFilterType();

                if(_.get($scope.temp, 'model.param.advSel.modelId')) {
                    getAdvSelTargetColumns($scope.formFieldObjects, $scope.temp.model.param.advSel.modelId);
                }
            });

            if($scope.temp.model.config.type !== 'checkbox'){
                if($scope.temp.model.config.type === 'select') {
                    $scope.temp.model.param.defaultData = $scope.temp.model.param.defaultData || [];

                    PagesService.getPages().then(function (pages) {
                        $scope.pages = pages;
                    });

                    loadPageObjects(_.get($scope.temp, 'model.param.advSel.pageId'));
                }

                ViewsService.get().then(function(views){
                    $scope.views = views;

                    if($scope.editFlag && $scope.temp.model.option.type === 'views'){
                        $scope.selectColumn($scope.temp.model.option.id);
                    }
                    else if($scope.editFlag && $scope.temp.model.option.type === 'groups'){
                        $scope.getGroupsList();
                    }
                    else if($scope.editFlag && $scope.temp.model.option.type === 'profile'){
                        $scope.getProfileTypes($scope.temp.model.option.id);
                    }
                });

                _.defaults($scope.temp.model.param, {
                    defaultFilter: {
                        logic: 'and',
                        filters: []
                    },
                    cascadeFilter: {
                        logic: 'and',
                        filters: []
                    }
                });

                if(!$scope.temp.model.param.sortBy){
                    var sortBy = [],
                        option = $scope.temp.model.option;

                    if(option.orderBy === 'oldest'){
                        sortBy.push({
                            field: 'id',
                            dir: 'asc'
                        });
                    }
                    else if(option.orderBy === 'newest'){
                        sortBy.push({
                            field: 'id',
                            dir: 'desc'
                        });
                    }
                    else if(option.orderCol || option.column){
                        sortBy.push({
                            field: option.orderCol || option.column,
                            dir: option.orderBy || 'asc'
                        });
                    }

                    $scope.temp.model.param.sortBy = sortBy;
                }

                // Init Auto-Fill stuff
                if($scope.temp.model.option.autoFill){
                    for(var af = 0; af < $scope.temp.model.option.autoFill.length; af++){
                        $scope.autoFillSubItem.push(AutoFillService.autoFillSubItem());
                        $scope.autoFillSourceItems.push([]);
                        $scope.autoFillTargetItems.push([]);

                        var autoFill = $scope.temp.model.option.autoFill[af];

                        if(!_.has(autoFill, 'persists')){
                            autoFill.persists = true;
                        }

                        if(autoFill.type === 'query'){
                            $scope.loadAutoFillViewColumns(autoFill.queryId);
                        }
                        else {
                            loadTableFields(autoFill.widgetId, $scope.autoFillSourceItems, af);
                        }
                        loadTableFields(autoFill.targetWidgetId, $scope.autoFillTargetItems, af);
                    }
                }
                else{
                    $scope.temp.model.option.autoFill = [];
                }
            }
        }

        $scope.ok = function () {
            $scope.validateIsUniqueReliant(); //clean orphan record from 'is unique' reliant, if any...
            $uibModalInstance.close($scope.temp);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    objects.push(object);
                }
            }
            return objects;
        }

        function loadTableFields(id, array, index){
            if(id){
                WidgetsSettingsService.getFormFields(id).then(function(data){
                    array[index] = getFormFieldObjects(data);
                });
            }
        }

        function addSortItem(sortObj){
            $scope.temp.model.param.sortBy.push(
                angular.copy(sortObj)
            );
            sortObj.field = '';

            $scope.lookUpDefaultValueOptions.dataSource.sort($scope.temp.model.param.sortBy);
        }

        function removeSortItem($index){
            _.pullAt($scope.temp.model.param.sortBy, $index);
            $scope.lookUpDefaultValueOptions.dataSource.sort($scope.temp.model.param.sortBy);
        }

        function reorderItem(array, oldIndex, newIndex){
            var item = array.splice(oldIndex, 1)[0];
            array.splice(newIndex, 0, item);
        }

        function setOptionColumnType(viewColumns, option){
            if(option.column) {
                var column = _.find(viewColumns, "colName", option.column);

                if (column) {
                    option.columnType = column.castType;
                }
            }
            else {
                option.columnType = "";
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name FormsDesignerService
 * @alias cerberus/forms-designer:FormsDesignerService
 * @description Makes calls transformative calls to the "forms" resource
 */
    .factory('FormsDesignerService', ["_", "$http", "$q", "apiPath", "WidgetsService", "toaster", "DesignerUtilityService", function FormsDesignerService(_, $http, $q, apiPath, WidgetsService, toaster, DesignerUtilityService) {
        return {
            create: create,
            remove: remove,
            publish: publish,
            createRevision: createRevision,
            getRevisions: getRevisions,
            moveArrayItem: moveArrayItem,
            breakingChangesCheck: breakingChangesCheck,
            addSectionToForm: addSectionToForm,
            removeSectionFromForm: removeSectionFromForm,
            updateSection: updateSection,
            sectionConditionString: sectionConditionString,
            checkFormUsedInWorkflow: checkFormUsedInWorkflow
        };
        ////////////////////

        function checkFormUsedInWorkflow(formOriginId){
            var deferred = $q.defer();
            $http.get(apiPath + 'forms/'+ formOriginId + '/workflow/check')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        /**
         * breakingChangesCheck
         * @param formId
         * @param modelId
         * @returns {*}
         */
        function breakingChangesCheck(formId, modelId){
            var deferred = $q.defer();
            $http.get(apiPath + 'forms/'+ formId +'/breaking/changes?modelId=' + modelId)
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        /**
         * Creates a new form
         * @function create
         * @param {object} data - contains form definition
         * @param {string} widgetId
         * @returns {promise}
         */
        function create(data, widgetId){
            var deferred = $q.defer();
            $http.post(apiPath + 'widgets/'+ widgetId +'/forms', data)
                .success(function(value){
                    WidgetsService.getWidget(widgetId);
                    deferred.resolve(value);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        /**
         * Deletes a form
         * @function remove
         * @param {string} originatorId
         * @param {string} widgetId
         * @returns {promise}
         */
        function remove(originatorId, widgetId){
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'forms/' + originatorId})
                .success(function(value){
                    WidgetsService.getWidget(widgetId);
                    deferred.resolve(value);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        /**
         * Makes the form the default form when called by originator Id
         * @function publish
         * @param {string} id
         * @returns {promise}
         */
        function publish(id) {
            var deferred = $q.defer();
            $http.put(apiPath + 'forms/' + id + '/publish')
                .success(function (value) {
                    toaster.pop('success', 'Form Published', 'This revision has been published.');
                    deferred.resolve(value);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        /**
         * @function createRevision
         * @param {string} id - originator Id
         * @param {object} formModel
         * @returns {promise}
         */
        function createRevision(id, formModel) {
            var form = formModel.form;
            var formSorted = form.objects.sort(
                DesignerUtilityService.firstBy(function(v1,v2){return v1.row - v2.row;})
                    .thenBy(function(v1,v2){return v1.col - v2.col;})
            );
            var dataObject = {
                id: id,
                name: formModel.name,
                description: formModel.description,
                form: {
                    objects: formSorted,
                    settings: _.get(form, 'settings', {}),
                    sections: _.get(form, 'sections', [])
                }
            };
            var deferred = $q.defer();
            $http.put(apiPath + 'forms/' + id + '/revision', dataObject)
                .success(function(value){
                    toaster.pop('success', 'Form Saved', 'New revision added!');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        /**
         * @function getRevisions
         * @param {string} id - originator Id
         * @returns {promise}
         */
        function getRevisions(id) {
            var deferred = $q.defer();
            $http.get(apiPath + 'forms/' + id + '/revision')
                .success(function(value){
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        /**
         * moveArrayItem
         * @param newIndex
         * @param oldIndex
         * @param array
         * @param length
         */
        function moveArrayItem(newIndex, oldIndex, array, length) {
            //Handle Negative
            while (oldIndex < 0) {
                oldIndex += length;
            }
            //Handle Negative
            while (newIndex < 0) {
                newIndex += length;
            }
            //Pad the array with an undefined if newIndex is beyond the array (just in case)
            if (newIndex >= array.length) {
                var i = newIndex - array.length;
                while ((i--) + 1) {
                    array.push(undefined);
                }
            }
        }

        function addSectionToForm(form, section) {
            var sections = _.get(form, 'sections', []);
            sections.push(section);
            form.sections = sections;
        }

        /**
         * @function removeSectionFromForm
         * @description Removes section and its objects from form
         * @param form
         * @param index
         */
        function removeSectionFromForm(form, index){
            var section = form.sections[index];
            _.remove(form.sections, section);       // Removes section from form
            _.remove(form.objects, function(obj){   // Removes form objects in section from form
                return obj.model.display.section === section.name;
            });
        }

        function updateSection(form, section, index){
            var oldName = form.sections[index].name;
            _.assign(form.sections[index], section);

            _.forEach(form.objects, function(obj){
                if(obj.model.display.section === oldName){
                    obj.model.display.section = section.name;
                }
                else if(!_.has(obj.model.display, 'section')){
                    obj.model.display.section = false;
                }
            });
        }

        function sectionConditionString(condition){
            return condition.modelId + ' ' + condition.op + ' "' + condition.val + '"';
        }
    }])
;

angular.module('cerberus.admin')
    .controller('FormsDesigner_signatureCtrl', ["_", "$scope", "$uibModalInstance", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsClassService", "FormsDesignerListService", "WidgetsSettingsService", function FormsDesigner_signatureCtrl(_, $scope, $uibModalInstance, autoTabIndex, currentFormObjects, editFlag, formObj, formOriginId, idArray, sections, widgetId,
                                                                                    DesignerUtilityService, FormsClassService, FormsDesignerListService, WidgetsSettingsService) {
        // Populate Scope
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.sections = sections;
        $scope.formFieldObjects = [];
        $scope.conditionOptions = [];
        $scope.conditionalActions = FormsDesignerListService.conditionalActions();
        $scope.conditionType = '';
        $scope.conditionOperators = DesignerUtilityService.conditionOperators();
        $scope.conditionBooleanValues = DesignerUtilityService.conditionBooleanValues();
        $scope.conditionActionValues = DesignerUtilityService.conditionActionValues();
        $scope.conditionFilter = DesignerUtilityService.conditionFilter(formOriginId, formObj.model.config.modelId);
        $scope.getConditionType = DesignerUtilityService.getConditionType;
        $scope.addCondition = DesignerUtilityService.addCondition($scope.temp, formOriginId);

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        $scope.deleteArrayObject = function(array,index){
            array.splice(index, 1);
        };

        // Modal Actions
        $scope.ok = function (){
            $uibModalInstance.close($scope.temp);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Init
        init();

        function init(){
            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFields = formFieldArray;
                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);

                var conditionOptions = _.sortBy(_.filter($scope.formFieldObjects, $scope.conditionFilter), 'label');
                $scope.conditionOptions = [{ label: '(Record Action)', modelId: '__nimRecordAction' }].concat(conditionOptions);
            });

            // Hack
            DesignerUtilityService.focusFirstElement('configForm');
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    objects.push(object);
                }
            }
            return objects;
        }
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_staticCtrl', ["_", "$scope", "$uibModalInstance", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsDesignerListService", "WidgetsSettingsService", function FormsDesigner_staticCtrl(_, $scope, $uibModalInstance, autoTabIndex, currentFormObjects, editFlag, formObj, formOriginId, idArray,
                                                                              sections, widgetId, DesignerUtilityService, FormsDesignerListService, WidgetsSettingsService) {
        // Populate Scope
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.sections = sections;
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.formFieldObjects = [];
        $scope.conditionOptions = [];
        $scope.widgetFieldIds = [];
        $scope.conditionalActions = FormsDesignerListService.conditionalActions(true);
        $scope.conditionType = '';
        $scope.conditionOperators = DesignerUtilityService.conditionOperators();
        $scope.conditionBooleanValues = DesignerUtilityService.conditionBooleanValues();
        $scope.conditionActionValues = DesignerUtilityService.conditionActionValues();
        $scope.conditionFilter = DesignerUtilityService.conditionFilter(formOriginId, formObj.model.config.modelId);
        $scope.getConditionType = DesignerUtilityService.getConditionType;
        $scope.addCondition = DesignerUtilityService.addCondition($scope.temp, formOriginId);

        // Modal Actions
        $scope.ok = function (){
            $uibModalInstance.close($scope.temp);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.deleteArrayObject = function(array,index){
            array.splice(index, 1);
        };
        $scope.editorTools = DesignerUtilityService.textEditorOptions($scope).tools;

        init();

        function init(){
            // Hack
            if(formObj.model.config.type !== 'hr') { // For divider, first element is radio button
                DesignerUtilityService.focusFirstElement('configForm');
            }

            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);
                $scope.widgetFieldIds = _.compact(_.union(idArray, _.map($scope.formFieldObjects, 'modelId')));
                $scope.widgetFieldIds.sort();

                var conditionOptions = _.sortBy(_.filter($scope.formFieldObjects, $scope.conditionFilter), 'label');
                $scope.conditionOptions = [{ label: '(Record Action)', modelId: '__nimRecordAction' }].concat(conditionOptions);
            });
        }

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    objects.push(object);
                }
            }
            return objects;
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_stringCtrl',
    ["_", "$scope", "$rootScope", "$uibModalInstance", "$window", "$sanitize", "$timeout", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsDesignerListService", "UsersProfileListService", "ViewsService", "WidgetsSettingsService", "WorkspacesGroupsService", function FormsDesigner_stringCtrl(_, $scope, $rootScope, $uibModalInstance, $window, $sanitize, $timeout,
                                      autoTabIndex, currentFormObjects, editFlag, formObj, formOriginId, idArray,
                                      sections, widgetId, DesignerUtilityService, FormsDesignerListService,
                                      UsersProfileListService, ViewsService, WidgetsSettingsService, WorkspacesGroupsService) {
        // Populate Scope
        $scope.formOriginId = formOriginId;
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.views = [];
        $scope.viewColumns = [];
        $scope.groups = [];
        $scope.profiles = [];
        $scope.errStr = null;
        $scope.selectedWidgetOperands = [];
        $scope.selectedProfileFields = [];
        $scope.formFields = [];
        $scope.formFieldObjects = [];
        $scope.conditionOptions = [];
        $scope.widgetFieldIds = idArray;
        $scope.filterFieldArray = [];
        $scope.curModelIds = idArray;
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.patternsList = FormsDesignerListService.patterns();
        $scope.masksList = FormsDesignerListService.masks();
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.separatorList = FormsDesignerListService.separators();
        $scope.isValidRegexTestCase = true;
        $scope.formInput = {
            testPattern: null
        };
        $scope.sections = sections;
        $scope.defaultFilter = {};
        $scope.defaultFilterType = null;
        $scope.defaultFilterOperators = DesignerUtilityService.filterOperators();
        $scope.conditionalActions = FormsDesignerListService.conditionalActions();
        $scope.conditionType = '';
        $scope.conditionOperators = DesignerUtilityService.conditionOperators();
        $scope.conditionBooleanValues = DesignerUtilityService.conditionBooleanValues();
        $scope.conditionActionValues = DesignerUtilityService.conditionActionValues();
        $scope.conditionFilter = DesignerUtilityService.conditionFilter(formOriginId, formObj.model.config.modelId);
        $scope.getConditionType = DesignerUtilityService.getConditionType;
        $scope.addCondition = DesignerUtilityService.addCondition($scope.temp, formOriginId);
        $scope.lookUpDefaultValueOptions = DesignerUtilityService.lookUpDefaultValueOptions($scope.temp.model.option);
        $scope.addressFields = FormsDesignerListService.addressFields();
        $scope.textEditorOptions = DesignerUtilityService.textEditorOptions($scope);

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        // Form Object Specific Logic
        $scope.validateIsUniqueReliant = function(){
            // Remove orphan record from 'Is unique' selection, when reliant field selection is empty
            if($scope.temp.model.param.isUniqueReliant && (_.isEmpty($scope.temp.model.param.isUniqueReliant.modelId) || $scope.temp.model.validation.unique === false)){
                delete $scope.temp.model.param.isUniqueReliant;
            }
        };

        $scope.checkRegexTestCase = function(){
            if ($scope.formInput.testPattern){
                var pattern = new RegExp($scope.temp.model.validation.pattern);
                $scope.isValidRegexTestCase = $scope.formInput.testPattern.match(pattern);
            }
        };

        $scope.addField = function(field, value){
            $scope.temp.model.param.fields[field.modelId] = {
                usage: field.label,
                value: value || 'locality',
                form: field.formId
            };
        };
        $scope.removeField = function(id){
            delete $scope.temp.model.param.fields[id];
        };

        $scope.toggleDefaultValue = function(objConfig, opt){
            $timeout(function(){
                if($scope.optionIsDefault(objConfig.defaultValue, opt)){
                    objConfig.defaultValue = null;
                }
                else {
                    objConfig.defaultValue = opt;
                }
            });
        };

        $scope.optionIsDefault = function(defaultVal, opt){
            return (defaultVal != null && defaultVal.id === opt.id);
        };

        $scope.addOption = function(array, data){
            var r = /\d+/;
            var a = 0;
            if(array.length > 0){
                a = Math.max.apply(Math, array.map(function(o){return o.id.match(r);}));
                a = a + 1;
            }
            data.id = 'opt' + a;
            array.push(data);
        };
        $scope.deleteArrayObject = function(array,index){
            array.splice(index, 1);
        };
        $scope.selectColumn = function(id){
            if(id){
                ViewsService.getColumns(id).then(function(data){
                    if(data.length === 0){
                        $scope.errStr = '<div class="alert alert-warning" role="alert"><strong>Warning!</strong> There are no columns in this view.</div>';
                    }
                    else{
                        $scope.errStr = null;
                    }
                    $scope.viewColumns = data;
                });
                for(var i = 0; i < $scope.views.length; i++){
                    if($scope.views[i].id === id){
                        $scope.temp.model.option.widgetId = $scope.views[i].base_widget_id;
                        break;
                    }
                }
            }
            else{
                $scope.viewColumns = [];
                $scope.errStr = null;
            }
        };

        $scope.getProfileTypes = function(){
            $scope.temp.model.option.type='profile';
            angular.forEach(UsersProfileListService.profileFields(),function(v,k){
                $scope.profiles.push(k);
            });
        };
        $scope.selectProfile = function(type){
            $scope.selectedProfileFields = UsersProfileListService.profileFields()[type];
        };
        $scope.getGroupsList = function(){
            $scope.temp.model.option.type='groups';
            WorkspacesGroupsService.getGroups($rootScope.userData.currentWorkspace.id).then(function(value){
                $scope.groups = value;
            });
        };
        $scope.sortableOptions = {
            ignore: "input",
            change: function (e) {
                $timeout(function () {
                    var item = $scope.temp.model.option.values.splice(e.oldIndex, 1)[0];
                    $scope.temp.model.option.values.splice(e.newIndex, 0, item);
                },0);
            }
        };

        // Default Filter
        $scope.notPropertyColumn = function(col){
            return col.type === 'column';
        };

        $scope.updateDefaultFilterType = function(){
            if($scope.defaultFilter.field && $scope.defaultFilter.field !== ''){
                var index = $scope.viewColumns.map(function(elem){return elem.colName;}).indexOf($scope.defaultFilter.field);
                if(index >= 0){
                    $scope.defaultFilterType = $scope.viewColumns[index].castType;
                    return;
                }
            }
            $scope.defaultFilterType = null;
        };

        $scope.addFilter = function(){
            $scope.temp.model.param.defaultFilter.filters.push($scope.defaultFilter);
            $scope.defaultFilter = {};
            $scope.defaultFilterType = null;
        };

        // Modal Actions
        $scope.ok = function () {
            $scope.validateIsUniqueReliant(); //clean orphan record from 'is unique' reliant, if any...
            $uibModalInstance.close($scope.temp);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Init
        init();

        function init(){
            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                $scope.formFields = formFieldArray;
                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);
                $scope.widgetFieldIds = _.union(idArray, _.map($scope.formFieldObjects, 'modelId'));

                var conditionOptions = _.sortBy(_.filter($scope.formFieldObjects, $scope.conditionFilter), 'label');
                $scope.conditionOptions = [{ label: '(Record Action)', modelId: '__nimRecordAction' }].concat(conditionOptions);

                // Grid
                $scope.mainGridOptions = DesignerUtilityService.formGrid(formFieldArray.display);
                $scope.detailGridOptions = DesignerUtilityService.formDetailGrid($scope);

                // Codemirror
                $scope.codemirrorLoaded = DesignerUtilityService.codemirrorLoaded(formFieldArray.operands);
            });

            ViewsService.get().then(function(views){
                $scope.views = views;

                if($scope.editFlag && $scope.temp.model.option.type === 'views'){
                    $scope.selectColumn($scope.temp.model.option.id);
                }
                else if($scope.editFlag && $scope.temp.model.option.type === 'profile'){
                    $scope.getProfileTypes($scope.temp.model.option.id);
                }
            });

            $scope.temp.model.param.defaultFilter = $scope.temp.model.param.defaultFilter || {
                logic: 'and',
                filters: []
            };

            // Hack
            DesignerUtilityService.focusFirstElement('configForm');
        }

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    objects.push(object);
                }
            }
            return objects;
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .directive('nimModelIdAvailable', ["$http", "apiPath", function($http, apiPath) {
        return {
            require : 'ngModel',
            link : function($scope, element, attrs, ngModel) {
                ngModel.$asyncValidators.nimModelIdAvailable = function(name) {
                    valid(false);
                    loading(true);
                    return $http.get(apiPath + 'forms/model/id/available?id='+ name).then(
                        function(value) {
                            valid(value.data.DATA.isAvailable);
                            loading(false);
                        }
                    );
                };
                ////////////////////
                function valid(bool) {
                    ngModel.$setValidity('record-unavailable', bool);
                }

                function loading(bool) {
                    ngModel.$setValidity('record-loading', !bool);
                }
            }
        };
    }])
;
angular.module('cerberus.admin')
.directive('nimColumnSortResize', ["$compile", "$timeout", function ($compile, $timeout) {
        return {
            restrict: 'AE',
            scope: {
                data: '=nimColumnSortResize'
            },
            controller: ["$scope", function ($scope) {
                $scope.gridOptions = {
                    dataSource: {
                        data: []
                    },
                    resizable: true,
                    reorderable: true,
                    columns: angular.copy($scope.data),
                    columnResize: function (e) {
                        for (var i = 0; i < $scope.data.length; i++) {
                            if ($scope.data[i].field === e.column.field) {
                                $scope.data[i].width = e.newWidth;
                            }
                        }
                    },
                    columnReorder: function(e){
                        $timeout(function () {
                            $scope.$emit('nim-column-sorted', {columns: e.sender.columns, newIndex: e.newIndex, oldIndex: e.oldIndex});
                            $scope.data = angular.copy(e.sender.columns);
                        });
                    }
                };
            }],
            link: function (scope, element) {
                var template = '<div kendo-grid="grid" k-options="gridOptions"></div>';
                var build = function () {
                    if (scope.grid) {
                        try {
                            scope.grid.destroy();
                        }
                        catch (e) {
                            //who gives a fuck
                        }
                    }
                    element.empty().append(template);
                    $compile(element.contents())(scope);
                };
                element.on('click', 'div.k-grid th', function () {
                    var field = $(this).data('field');
                    var index = $(this).parent().children().index($(this));
                    scope.$emit('columnClick', {
                        index: index,
                        field: field
                    });
                });
                //watchCollection only goes one level deep (mostly for arrays)
                scope.$watch('data', function (newValue) {
                    scope.gridOptions.columns = angular.copy(newValue);
                    build();
                }, true);

                scope.$on('$destroy', function () {
                   element.off('click');
                });
            }
        };
    }])
;
angular.module('cerberus.admin')
    .controller('FormsTemplatesCreateCtrl', ["_", "$scope", "$location", "formOriginId", "widgetId", "FormsService", "TemplatesServices", function FormsTemplatesCreateCtrl(_, $scope, $location, formOriginId, widgetId, FormsService, TemplatesServices) {
        $scope.tempData = {
            type:'Form',
            originId: formOriginId
        };
        $scope.origData = angular.copy($scope.tempData);
        $scope.formModel = {};
        $scope.filters = {};
        $scope.dataSet = {};
        $scope.securityTypes = TemplatesServices.getSecurityLevels();

        $scope.hasChanges = _hasChanges;
        $scope.submit = _submit;
        $scope.cancel = _navToForm;

        _init();

        function _init(){
            FormsService.getForm(formOriginId).then(function(formModel){
                $scope.formModel = formModel;
            });
        }

        function _hasChanges(){
            return !angular.equals($scope.origData, $scope.tempData);
        }

        function _submit(isValid, data){
            if(isValid){
                data.template = $scope.formModel.form;
                TemplatesServices.create(data).then(function(){
                    _navToForm();
                });
            }
        }

        function _navToForm(){
            $location.url('/settings/widgets/' + widgetId + '/forms/' + formOriginId);
        }
    }])
;
angular.module('cerberus.admin')
    .factory('TemplatesServices',
    ["$http", "$q", "apiPath", "toaster", function ($http, $q, apiPath, toaster) {
        var service = {
            create: create,
            get: get,
            getSecurityLevels: getSecurityLevels,
            getUserTemplates: getUserTemplates,
            getDetails: getDetails,
            update: update,
            deleteTemplate: deleteTemplate
        };
        return service;
        ////////////////////
        function create(data){
            var deferred = $q.defer();
            $http.post(apiPath + 'templates', data)
                .success(function (value) {
                    toaster.pop('success', 'Created');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        function get(type){
            var deferred = $q.defer();
            $http.get(apiPath + 'templates?type='+type)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        function getSecurityLevels(){
            return ['Private','Organization','Public'];
        }
        function getUserTemplates(){
            var deferred = $q.defer();
            $http.get(apiPath + 'users/templates')
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        function getDetails(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'templates/details/'+id)
                .success(function (value) {
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        function update(id, data){
            var deferred = $q.defer();
            $http.put(apiPath + 'templates/details/'+id,data)
                .success(function (value) {
                    toaster.pop('success', 'Updated');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
        function deleteTemplate (id) {
            var deferred = $q.defer();
            $http({method: 'DELETE', url: apiPath + 'templates/details/' + id})
                .success(function(value){
                    toaster.pop('info', 'Template deleted.');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }]
)
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name WorkflowsClassService
 * @alias cerberus/workflows-designer:WorkflowsClassService
 * @description
 *  Constructs Workflow and state classes
 */
.factory('WorkflowsClassService', ["_", function WorkflowsClassService(_){

        // Describes default parameters for process subtypes
        var defaultParams = {
            email: {
                bcc: {text: '', modelId: ''},
                cc: {text: '', modelId: ''},
                body: {text: '', modelId: ''},
                subject: {text: '', modelId: ''},
                to: {text: '', modelId: ''},
                template: {modelId: 'wflowDefaultTemplate'},
                account: {modelId: 'accountDefault'},
                showHeader: {modelId: true},
                showButton: {modelId: true},
                showSettings: {modelId: true}
            },
            createInstance: {
                targetWidgetId: '',
                map: [],
                fk: {}
            },
            updateInstance: {
                targetWidgetId: '',
                map: [],
                lookupModelId: '',
                type: '',
                fk: ''
            },
            notification: {
                pkColumn: '',
                viewId: '',
                staticMsgColumn1: '',
                viewMsgColumn1: '',
                staticMsgColumn2: '',
                viewMsgColumn2: '',
                staticMsgColumn3: '',
                groupIds: []
            }
        };

        // Container with global settings from Dropdown Configurations. 
        // Used in miscellaneous drop down select fields within workflow.
        var containerGlobalConfigSelections = {
            procSubTypes : [
                { type: 'email', display: 'Email' },
                { type: 'createInstance', display: 'Instance Creation' },
                { type: 'updateInstance', display: 'Instance Update' },
                { type: 'notification', display: 'Notification' }
            ],
            emailTemplates : [
                {label: 'wflowDefaultTemplate', display: 'Default - Designed for Internal usage'},
                {label: 'wflowOrderCreated', display: 'Sales Order - S.O. Created'},
                {label: 'wflowOrderStaged', display: 'Sales Order - S.O. Ready to ship'},
                {label: 'wflowOrderShipped', display: 'Sales Order - S.O. Shipped'}
            ],
            emailAccounts : [
                {label: 'default', display: 'Default - Default server provided account'},
                {label: 'csr', display: 'CSR - Customer Service Dept.'},
                {label: 'salesrep', display: 'Sales Rep - Sales & Quote follow up'},
                {label: 'shipping', display: 'Shipping - Shipping Dept.'},
                {label: 'accounting', display: 'Accounting - Accounting Dept.'},
                {label: 'executives', display: 'Executives - Officers and CEO'}
            ]
        };

        /**
         * Constructs new Workflow
         * @class Workflow
         * @classdesc for holding workflow data
         * @memberOf WorkflowsClassService
         * @param {object} tasks
         * @param {object} objects
         */
        function Workflow(tasks, objects){
            this.tasks = tasks || {};
            this.objects = objects || {};
        }

        /**
         * Constructs new State
         * @class State
         * @classdesc describes workflow state
         * @param {object} model
         * @param {Display} display
         */
        function State(model, display){
            this.model = model;
            this.display = display;
        }

        /**
         * Constructs new Decision
         * @class Decision
         * @classdesc for describing workflow decision
         * @memberOf WorkflowsClassService
         * @param {string} name
         * @param {object} to
         */
        function Decision(name, to){
            this.name = name || '';
            this.type = 'decision';
            this.to = to || {};
        }

        /**
         * Constructs new Document
         * @class Document
         * @classdesc for describing workflow document
         * @memberOf WorkflowsClassService
         * @param {string} name
         * @param {array} to
         * @param {array} forms
         * @param {object} permissions
         * @param {boolean} isFinal
         * @param {boolean} editable
         */
        function Document(name, to, forms, permissions, isFinal, editable){
            this.name = name || '';
            this.type = 'document';
            this.to = to || [];
            this.forms = forms || [];
            this.permissions = permissions || {};
            this.isFinal = isFinal || false;
            this.editable = editable || !isFinal;
        }

        /**
         * Constructs new Process
         * @class Process
         * @classdesc describes a workflow process
         * @memberOf WorkflowsClassService
         * @param {string} name
         * @param {array} to
         * @param {string} subType
         * @param {object} params
         */
        function Process(name, to, subType, params){
            this.name = name || '';
            this.type = 'process';
            this.to = to || [];
            this.subType = subType || '';
            this.params = params || getParams(subType);
        }

        /**
         * Constructs Display property for State object
         * @class Display
         * @classdesc describes a state's display properties
         * @param {number} order
         */
        function Display(order){
            this.order = order;
        }

        /**
         * Retrieves default params for the given process type
         * @memberOf WorkflowsClassService
         * @param type
         * @returns {object}
         */
        function getParams(type){
            return angular.copy(_.get(defaultParams, type, {}));
        }

        /**
         * Retrieves default settings from generic container
         * @memberOf WorkflowsClassService
         * @param objKey
         * @returns {object}
         */
        function getDefaultSettings(objKey){
            return angular.copy(_.get(containerGlobalConfigSelections, objKey, {}));
        }

        /**
         * Builds a Workflow object with initial state
         * @memberOf WorkflowsClassService
         * @param {object} data
         * @returns {Workflow}
         */
        function newWorkflow(data){
            var newWF = new Workflow(
                null,
                {
                    '1': new State(
                        new Document('Start', null, false, [], null),
                        new Display(1)
                    )
                }
            );
            if(data){
                angular.extend(newWF, data);
            }
            return newWF;
        }

        /**
         * newIndex method - generates index for new state
         * @memberOf Workflow
         * @returns {number}
         */
        Workflow.prototype.newIndex = function(){
            var index = 2;
            while(this.objects[index] != null){
                index++;
            }
            return index;
        };

        /**
         * newDocument method - creates Document State
         * @memberOf Workflow
         * @param {Array} forms
         * @param {boolean} isFinal
         * @returns {State}
         */
        Workflow.prototype.newDocument = function(forms, isFinal){
            var index = this.newIndex();
            return new State(
                new Document('Workflow State ' + index, null, forms, null, isFinal),
                new Display(index)
            );
        };

        /**
         * newDocument method - creates Decision State
         * @memberOf Workflow
         * @returns {State}
         */
        Workflow.prototype.newDecision = function(){
            return new State(
                new Decision('Workflow State ' + this.newIndex(), null),
                new Display(-1)
            );
        };

        /**
         * newDocument method - creates Decision State
         * @memberOf Workflow
         * @param {string} subType
         * @param {object} params
         * @returns {State}
         */
        Workflow.prototype.newProcess = function(subType, params){
            return new State(
                new Process('Workflow State ' + this.newIndex(), null, subType, params),
                new Display(-1)
            );
        };

        /**
         * getForms method - retrieves ids for forms available to workflow state
         * @memberOf Workflow
         * @param {string} id
         * @returns {Array}
         */
        Workflow.prototype.getForms = function(id){
            var forms = [];
            for (var wfoId in this.objects) {
                if (this.objects.hasOwnProperty(wfoId) && wfoId !== id) {
                    var wfObject = this.objects[wfoId];
                    var wfoForms = [];
                    if (wfObject.model.type === 'decision') {
                        if (wfObject.model.to[id]) {
                            wfoForms = this.getForms(wfoId);
                        }
                    }
                    else if (wfObject.model.to.indexOf(id) >= 0) {
                        if(wfoId !== '1') {
                            wfoForms = this.getForms(wfoId);
                        }
                        if(wfObject.model.type === 'document'){
                            wfoForms = wfoForms.concat(wfObject.model.forms);
                        }
                    }
                    for (var i = 0; i < wfoForms.length; i++) {
                        var formId = wfoForms[i];
                        if (forms.indexOf(formId) < 0) {
                            forms.push(formId);
                        }
                    }
                }
            }
            return forms;
        };

        Workflow.prototype.getStates = function(id){
            var wf = this;
            var states = [];

            _.forEach(wf.objects, function(wfObject, wfoId){
                if(wfoId !== id && wfObject.model.type === 'document' && wfObject.model.to.indexOf(id) >= 0){
                    var state = angular.copy(wfObject.model);
                    state.id = wfoId;

                    states.unshift(state);

                    if(wfoId !== '1') {
                        states = wf.getStates(wfoId).concat(states);
                    }
                }
            });

            return states;
        };

        return {
            newWorkflow: newWorkflow,
            getParams: getParams,
            getDefaultSettings: getDefaultSettings
        };
    }])
;
angular.module('cerberus.admin')
    .factory('WorkflowsService', ["$http", "$q", "apiPath", "toaster", "WorkflowsClassService", function WorkflowsService($http, $q, apiPath, toaster, WorkflowsClassService) {
        return {
            getPublishedWorkflow: getPublishedWorkflow,
            getRevision: getRevision,
            newRevision: newRevision,
            getRevisions: getRevisions,
            publish: publish
        };

        function getPublishedWorkflow(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'workflows/' + id + '/publish')
                .success(function(value){
                    var d = value.DATA;
                    d.workflow = WorkflowsClassService.newWorkflow(d.workflow);
                    deferred.resolve(d);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getRevision(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'workflows/' + id)
                .success(function(value){
                    var d = value.DATA;
                    d.workflow = WorkflowsClassService.newWorkflow(d.workflow);
                    deferred.resolve(d);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function newRevision(data, id){
            var deferred = $q.defer();
            $http.put(apiPath + 'workflows/' + id, data)
                .success(function(value){
                    toaster.pop('success', 'Workflow Saved', 'New revision added!');
                    deferred.resolve(value.DATA);
                })
                .error(function(reason){
                    toaster.pop('warning', 'Syntax Error', reason);
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function getRevisions(id){
            var deferred = $q.defer();
            $http.get(apiPath + 'workflows/' + id + '/revisions')
                .success(function(value){
                    var d = value.DATA;
                    deferred.resolve(d);
                })
                .error(function(reason){
                    deferred.reject(reason);
                });
            return deferred.promise;
        }

        function publish(id){
            var deferred = $q.defer();
            $http.put(apiPath + 'workflows/' + id + '/publish', null)
                .success(function (value) {
                    toaster.pop('success', 'Workflow Published', 'This revision has been published.');
                    deferred.resolve(value.DATA);
                })
                .error(function (reason) {
                    deferred.reject(reason);
                });
            return deferred.promise;
        }
    }])
;

angular.module('cerberus.admin')
    .controller('WorkflowsDesignerShapeModalCtrl', ["_", "CodeMirror", "$scope", "$uibModalInstance", "$timeout", "formIdArray", "stateId", "states", "widgetId", "workflowObject", "workspaceId", "DesignerUtilityService", "FormsService", "ViewsService", "WidgetsService", "WidgetsSettingsService", "WorkflowsClassService", "WorkspacesGroupsService", function WorkflowsDesignerShapeModalCtr(_, CodeMirror, $scope, $uibModalInstance, $timeout, formIdArray,
                                                                                            stateId, states, widgetId, workflowObject, workspaceId, 
                                                                                            DesignerUtilityService, FormsService, ViewsService, WidgetsService,
                                                                                            WidgetsSettingsService, WorkflowsClassService, WorkspacesGroupsService) {
        var vm = this;

        vm.pageTitle = 'Edit Shape';
        vm.orig = angular.copy(workflowObject);
        vm.temp = angular.copy(workflowObject);
        vm.stateId = stateId;
        vm.jsonEdit = angular.copy(angular.toJson(vm.temp));
        vm.widgetId = widgetId;
        vm.formFields = [];
        vm.targetLookups = [];
        vm.formArray = [];
        vm.forms = [];
        vm.views = [];
        vm.viewColumns = [];
        vm.widgets = [];
        vm.widgetFields = [];
        vm.groups = [];
        vm.subTypes = WorkflowsClassService.getDefaultSettings('procSubTypes');
        vm.emailTemplates = WorkflowsClassService.getDefaultSettings('emailTemplates');
        vm.emailAccounts = WorkflowsClassService.getDefaultSettings('emailAccounts');
        vm.tempFieldMap = {};

        vm.targetLookupChanged = targetLookupChanged;
        vm.isLookup = isLookup;
        vm.hasWidgetId = hasWidgetId;
        vm.getWidgetName = getWidgetName;
        vm.notificationViewSelected = notificationViewSelected;
        
        vm.notificationGroupsOptions = {
            dataTextField: 'name',
            dataValueField: 'id',
            valuePrimitive: true,
            dataSource: {
                transport: {
                    read: function (options) {
                        options.success(vm.groups);
                    }
                }
            }
        };

        $scope.detailGridOptions = function (dataItem) {
            return {
                dataSource: {
                    data: dataItem.objects,
                    schema: {
                        model: {
                            fields: {
                                label: { type: 'string' },
                                modelId: { type: 'string' },
                                usage: { type: 'string' }
                            }
                        }
                    },
                    pageSize: 20
                },
                selectable: 'row',
                change: function (e) {
                    var selectedRows = e.sender.select();
                    var dataItm = e.sender.dataItem(selectedRows).usage;
                    $timeout(function () {
                        if (vm.tempFieldMap.val) {
                            vm.tempFieldMap.val = vm.tempFieldMap.val + ' ' + dataItm;
                        }
                        else {
                            vm.tempFieldMap.val = dataItm;
                        }
                    }, 0);
                },
                scrollable: false,
                sortable: true,
                pageable: true,
                columns: [
                    { field: 'label', title: 'Field Name', width: '110px' },
                    { field: 'modelId', title: 'Unique Field Name', width: '110px' },
                    { field: 'usage', title: 'Usage', width: '110px' }
                ]
            };
        };

        vm.groupsFilter = function (group) {
            return !group.isSystem || group.type === 'User';
        };

        vm.ok = function () {
            $uibModalInstance.close(vm.temp);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.updateParams = function () {
            var params = WorkflowsClassService.getParams(vm.temp.model.subType);
            _.assign(vm.temp.model.params, params);

            if (vm.temp.model.subType === 'updateInstance') {
                targetLookupChanged(vm.temp.model.params, vm.formFields);
            }
        };

        vm.getGroupName = function (gid) {
            return _.result(_.find(vm.groups, 'id', gid), 'name');
        };

        vm.addGroup = function (pid) {
            if (!vm.temp.model.permissions[pid]) {
                vm.temp.model.permissions[pid] = {
                    create: true,
                    read: true,
                    update: true,
                    delete: true
                };
            }
        };

        vm.removeGroup = function (pid) {
            if (vm.temp.model.permissions[pid]) {
                delete vm.temp.model.permissions[pid];
            }
        };

        vm.loadWidgetFields = function (wid) {
            if (wid) {
                WidgetsSettingsService.getFormFields(wid).then(function (data) {
                    vm.widgetFields = parseFormsToFields(data.display);
                    autoSetFK();
                });
            }
            else {
                vm.widgetFields = [];
                vm.temp.model.params.fk = {};
            }
        };

        vm.addMap = function (map) {
            vm.temp.model.params.map.push({
                targetModelId: map.id,
                formula: map.val
            });
            map.id = null;
            map.val = '';
        };

        vm.removeMap = function (index) {
            vm.temp.model.params.map.splice(index, 1);
        };

        vm.FormulaHelper =  "\t..:: USEFUL VARIABLES AND FORMULA (Consult ColdFusion for help) ::..\n" +
            "'Len', 'Left', 'Mid', 'Right', 'UCase,\n" +
			"'DateDiff', 'ParseDateTime', 'DateTimeFormat', 'Now',\n" +
			"'Replace', 'REReplace', 'IsValid', 'IsDefined', 'IsNull',\n" +
            "'StructKeyExists', 'IsStruct',\n" +
            "'functions.queryView',\n" +
            "'functions.queryViewAdvRegEx',\n" +
            "'functions.createStruct',\n\n" +
            "\t...::: CONDITIONS (Check 'condition.cfc' if needed) :::...\n" +
            "AND, OR, EQ, NEQ, GT, LT, GTE, LTE, TRUE, FALSE";

        //Init function
        _init();
        ////////////////////
        /**
         * Init controller data and server calls
         */
        function _init() {
            WorkspacesGroupsService.getGroups(workspaceId).then(function (groups) {
                vm.groups = groups;
            });

            ViewsService.get(false).then(function (views) {
                vm.views = views;
            });

            if (vm.temp.model.subType == 'notification' && vm.temp.model.params.viewId) {
                loadViewColumns(vm.temp.model.params.viewId);
            }

            var formIds = angular.copy(formIdArray);
            if (workflowObject.model.type == 'document') {
                for (var fid = 0; fid < workflowObject.model.forms.length; fid++) {
                    if (formIds.indexOf(workflowObject.model.forms[fid]) == -1) {
                        formIds.push(workflowObject.model.forms[fid]);
                    }
                }
            }

            if (formIds.length > 0) {
                WidgetsSettingsService.getFormFields(widgetId, formIds).then(function (data) {
                    var fields = data.display;
                    vm.mainGridOptions = DesignerUtilityService.formGrid(fields);
                    vm.formFields = parseFormsToFields(fields);
                    vm.targetLookups = [{ modelId: '', label: '(None)', widgetId: widgetId }].concat(vm.formFields);
                });
            }

            DesignerUtilityService.focusFirstElement('configForm');
            WidgetsService.getAllForms(vm.widgetId).then(function (data) {
                for (var f = 0; f < data.length; f++) {
                    var form = data[f];
                    vm.formArray.push({
                        id: getFormId(form.originatorId),
                        name: form.name
                    });
                }
                vm.documentFormOptions = {
                    dataTextField: 'name',
                    dataValueField: 'id',
                    dataSource: vm.formArray,
                    value: vm.temp.model.forms,
                    valuePrimitive: true,
                    change: function (e) {
                        var formIds = angular.copy(formIdArray);
                        vm.temp.model.forms = e.sender.value();
                        for (var fo = 0; fo < vm.temp.model.forms.length; fo++) {
                            if (formIds.indexOf(vm.temp.model.forms[fo]) == -1) {
                                formIds.push(vm.temp.model.forms[fo]);
                            }
                        }
                        if (formIds.length > 0) {
                            WidgetsSettingsService.getFormFields(widgetId, formIds).then(function (data) {
                                vm.formFields = parseFormsToFields(data.display);
                                vm.targetLookups = [{ modelId: '', label: '(None)', widgetId: widgetId }].concat(vm.formFields);
                            });
                        }
                        else {
                            vm.formFields = [{ modelId: '', label: '(None)', widgetId: widgetId }];
                        }
                    }
                };
            });

            WidgetsService.getWidgets().then(function (widgets) {
                vm.widgets = widgets;
            });

            if (_.get(vm.temp.model, 'params.targetWidgetId')) {
                WidgetsSettingsService.getFormFields(vm.temp.model.params.targetWidgetId).then(function (data) {
                    vm.widgetFields = parseFormsToFields(data.display);
                });
            }
        }

        function getFormId(guid) {
            var ids = guid.split('-');
            return ids[ids.length - 1];
        }

        function getWidgetName(wId) {
            var widget = _.find(vm.widgets, 'id', wId);
            return _.get(widget, 'name', '');
        }

        function parseFormsToFields(forms) {
            var formFields = [];
            for (var i = 0; i < forms.length; i++) {
                formFields = formFields.concat(forms[i].objects);
            }
            return formFields;
        }

        function autoSetFK() {
            if (vm.widgetFields) {
                var lookUp = _.find(vm.widgetFields, 'widgetId', vm.widgetId);
                var fk = {};
                if (lookUp) {
                    fk = _.pick(lookUp, ['column', 'modelId', 'optionId']);
                }
                _.set(vm.temp.model, 'params.fk', fk);
            }
        }

        function targetLookupChanged(params, formFields) {
            if (params.lookupModelId) {
                var lookup = _.find(formFields, 'modelId', params.lookupModelId);
                if (lookup || lookup.widgetId) {
                    params.targetWidgetId = lookup.widgetId;
                    params.type = lookup.type;
                    if (params.type == 'dataseries') {
                        params.fk = lookup.fk;
                    }
                    WidgetsSettingsService.getFormFields(lookup.widgetId).then(function (data) {
                        vm.widgetFields = parseFormsToFields(data.display);
                    });
                }
                else {
                    vm.widgetFields = [];
                    params.targetWidgetId = '';
                }
            }
            else {
                vm.widgetFields = formFields;
                params.targetWidgetId = widgetId;
            }
        }

        function isLookup(field) {
            return field.isLookUp;
        }

        function hasWidgetId(field) {
            return !!(field.widgetId);
        }

        function notificationViewSelected(params) {
            params.pkColumn = '';
            params.staticMsgColumn1 = '';
            params.viewMsgColumn1 = '';
            params.staticMsgColumn2 = '';
            params.viewMsgColumn2 = '';
            params.staticMsgColumn3 = '';

            loadViewColumns(params.viewId);
        }

        function loadViewColumns(viewId) {
            ViewsService.getColumns(viewId).then(function (columns) {
                vm.viewColumns = columns;
            });
        }

        var timeout;
        vm.codemirrorLoaded = function (_editor) {
            // Editor part
            var _doc = _editor.getDoc();
            _editor.focus();

            // Options
            _editor.setOption('theme', 'nimcalc');
            _editor.setOption('lineWrapping', true);
            _editor.setOption('matchBrackets', true);
            _editor.setOption('autoCloseBrackets', '()[]\"\"');

            _editor.setOption('mode', {
                name: 'nimcalc',
                globalVars: []
            });
            _doc.markClean();

            // Events
            _editor.on('inputRead', function (cm) {
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = $timeout(function () {
                    CodeMirror.showHint(cm, CodeMirror.hint.nimcalc, {
                        completeSingle: false,
                        localVars: vm.formFieldModelId
                    });
                }, 150, false);
            });
            _editor.on('keyup', function (cm, event) {
                var keyCode = event.keyCode || event.which;
                if (keyCode == 8 || keyCode == 46) {
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    timeout = $timeout(function () {
                        CodeMirror.showHint(cm, CodeMirror.hint.nimcalc, {
                            completeSingle: false
                        });
                    }, 150, false);
                }
                vm.updateData();
            });
        };

        vm.editorOptions = function (_editor) {
            // Editor part
            var _doc = _editor.getDoc();
            // Options
            _editor.setOption('lineWrapping', true);
            _editor.setOption('lineNumbers', true);
            _editor.setOption('matchBrackets', true);
            _editor.setOption('autoCloseBrackets', true);
            _editor.setOption('mode', 'application/ld+json');
            //Prep
            _doc.markClean();
            _editor.focus();
            //Open
            _editor.setSize('100%', '500px');
            _editor.on('keyup', function (cm, event) {
                var keyCode = event.keyCode || event.which;
                if (keyCode === 192 && event.ctrlKey) {
                    var formatted_json = vm.formatJson(_editor.getValue());
                    _editor.setValue(formatted_json);
                }
                vm.updateData();
            });
        };

        function repeat(s, count) {
            return new Array(count + 1).join(s);
        }

        vm.formatJson = function (json) {
            var i = 0,
                il = 0,
                tab = '  ',
                newJson = '',
                indentLevel = 0,
                inString = false,
                currentChar = null;

            for (i = 0, il = json.length; i < il; i += 1) {
                currentChar = json.charAt(i);

                switch (currentChar) {
                    case '{':
                    case '[':
                        if (!inString) {
                            newJson += currentChar + '\n' + repeat(tab, indentLevel + 1);
                            indentLevel += 1;
                        } else {
                            newJson += currentChar;
                        }
                        break;
                    case '}':
                    case ']':
                        if (!inString) {
                            indentLevel -= 1;
                            newJson += '\n' + repeat(tab, indentLevel) + currentChar;
                        } else {
                            newJson += currentChar;
                        }
                        break;
                    case ',':
                        if (!inString) {
                            newJson += ',\n' + repeat(tab, indentLevel);
                        } else {
                            newJson += currentChar;
                        }
                        break;
                    case ':':
                        if (!inString) {
                            newJson += ': ';
                        } else {
                            newJson += currentChar;
                        }
                        break;
                    case ' ':
                    case '\n':
                    case '\t':
                        if (inString) {
                            newJson += currentChar;
                        }
                        break;
                    case '"':
                        if (i > 0 && json.charAt(i - 1) !== '\\') {
                            inString = !inString;
                        }
                        newJson += currentChar;
                        break;
                    default:
                        newJson += currentChar;
                        break;
                }
            }
            return newJson;
        };

        vm.updateData = function () {
            $timeout(function () {
                vm.temp = angular.copy(angular.fromJson(vm.jsonEdit));
                $scope.$apply();
            });
        };

        vm.updateJson = function () {
            $timeout(function () {
                vm.jsonEdit = vm.formatJson(angular.toJson(vm.temp));
                $scope.$apply();
            });
        };

        $scope.$watch('vm.temp', function () {
            vm.updateJson();
        }, true);

        $scope.$on('$locationChangeStart', function (event) {
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('WorkflowsDesignerCtrl', ["kendo", "$log", "moment", "$scope", "workspaceId", "$timeout", "$uibModal", "$location", "toaster", "_", "originId", "DesignerUtilityService", "WorkflowsService", "WorkflowsClassService", "WorkflowDiagramService", function WorkflowDesignerCtrl(kendo, $log, moment, $scope, workspaceId, $timeout, $uibModal, $location, toaster, _, originId,
                                                                       DesignerUtilityService, WorkflowsService, WorkflowsClassService, WorkflowDiagramService) {
        $scope.originId = originId;

        $scope.copiedWorkflowObject = null;

        $scope.revisionsCollapse = true;

        $scope.diagram = null;
        $scope.diagramZoom = 100;

        $scope.lastPos = 75;

        var undoing = false;
        var checkingConnections = false;

        //var Shape = kendo.dataviz.diagram.Shape,
        //    Connection = kendo.dataviz.diagram.Connection,
        var Connector = kendo.dataviz.diagram.Connector;

        $scope.connectorConfig = WorkflowDiagramService.connectorConfig();
        $scope.shapeConfig = WorkflowDiagramService.shapeConfig();

        $scope.diagramZoomOptions = {
            min: 10,
            max: 200,
            value: 100,
            smallStep: 10,
            largeStep: 50,
            tickPlacement: 'none',
            showButtons: false,
            change: updateSliderIndicator,
            slide: updateSliderIndicator
        };

        $scope.hasChanges = function(){
            return !angular.equals($scope.workflowData, $scope.masterWorkflowData);
        };

        DesignerUtilityService.cancelRouteNav($scope, $scope.hasChanges);

        $scope.close = function(){
            $location.url('/settings/widgets/' + $scope.workflowData.widgetId + '/workflow');
        };

        $scope.save = function(after){
            var workflowCopy = angular.copy($scope.workflowData.workflow);
            WorkflowsService.newRevision({workflowData: _.omit(workflowCopy, 'settings')}, $scope.originId).then(function(value){
                $scope.workflowId = value.id;
                $scope.masterWorkflowData = angular.copy($scope.workflowData);
                if(after){
                    after();
                }
            });
        };

        $scope.publish = function(){
            WorkflowsService.publish($scope.workflowId).then(function(){
                $timeout(function(){
                    $scope.workflowData.published = true;
                    $scope.masterWorkflowData.published = true;
                    for(var r = 0; r < $scope.revisions.length; r++){
                        $scope.revisions[r].is_published = $scope.revisions[r].id == $scope.workflowId;
                    }
                });
            });
        };

        $scope.edit = function(shapeObj){
            var shapeOptions = shapeObj.options;
            var id = shapeObj.id;
            var workflowObj = $scope.workflowData.workflow.objects[id];
            $scope.openShapeModal(shapeOptions, workflowObj, id);
        };

        $scope.copyWFObject = function(){
            var selected = $scope.diagram.select();
            if(selected.length){
                var id = selected[0].id;
                $scope.copiedWorkflowObject = angular.copy($scope.workflowData.workflow.objects[id]);
                if($scope.copiedWorkflowObject.model.type == 'decision'){
                    $scope.copiedWorkflowObject.model.to = {};
                }
                else {
                    $scope.copiedWorkflowObject.model.to = [];
                }
            }
        };

        $scope.pasteWFObject = function(id){
            if($scope.copiedWorkflowObject && id){
                if($scope.copiedWorkflowObject.model.type == 'document') {
                    $scope.copiedWorkflowObject.display.order = $scope.workflowData.workflow.newIndex();
                }
                $scope.workflowData.workflow.objects[id] = $scope.copiedWorkflowObject;
            }
        };

        $scope.copy = function() {
            $scope.diagram.copy();
            $scope.copyWFObject();
        };

        $scope.remove = function(shapeObj){
            var id = shapeObj.id;
            if(id == '1'){
                $log.warn('Cannot delete Initial State');
            }
            else {
                $scope.diagram.remove(shapeObj);
            }
        };

        function trimParams(obj){
            var params = WorkflowsClassService.getParams(obj.model.subType);
            for(var p in params){
                if(params.hasOwnProperty(p) && obj.model.params[p]){
                    params[p] = obj.model.params[p];
                }
            }
            obj.model.params = params;
        }

        function updateSliderIndicator(e) {
            $timeout(function(){
                $scope.diagram.zoom(e.value / 100);
            });
        }

        $scope.zoomOut = function(){
            $timeout(function(){
                var newZoom = $scope.diagramZoom - $scope.diagramZoomOptions.smallStep;
                if(newZoom < $scope.diagramZoomOptions.min){
                    $scope.diagramZoom = $scope.diagramZoomOptions.min;
                }
                else {
                    $scope.diagramZoom = newZoom;
                }
                $scope.diagram.zoom($scope.diagramZoom / 100);
            });
        };

        $scope.zoomIn = function(){
            $timeout(function(){
                var newZoom = $scope.diagramZoom + $scope.diagramZoomOptions.smallStep;
                if(newZoom > $scope.diagramZoomOptions.max){
                    $scope.diagramZoom = $scope.diagramZoomOptions.max;
                }
                else {
                    $scope.diagramZoom = newZoom;
                }
                $scope.diagram.zoom($scope.diagramZoom / 100);
            });
        };

        $scope.diagramClickHandler = function(e){
            if(e.target.localName == 'circle'){
                $timeout(function(){
                    checkConnections();
                });
            }
        };

        $scope.diagramKeyHandler = function(e){
            if(e.keyCode == 46 && getSelectedId() == '1'){ // Delete
                e.stopImmediatePropagation();
            }
            else if(e.keyCode == 67 && e.ctrlKey){ // Copy
                $scope.copyWFObject();
            }
            else if(e.keyCode == 68 && e.ctrlKey){ // Duplicate
                $scope.copyWFObject();
                $timeout(function(){
                    $scope.pasteWFObject(getSelectedId());
                });
            }
            else if(e.keyCode == 86 && e.ctrlKey){ // Paste
                $timeout(function(){
                    $scope.pasteWFObject(getSelectedId());
                });
            }
            else if(e.keyCode == 88 && e.ctrlKey){ // Cut
                $scope.copyWFObject();
            }
            else if(e.keyCode == 89 && e.ctrlKey){ // Redo
                e.stopImmediatePropagation();
            }
            else if(e.keyCode == 90 && e.ctrlKey){ // Undo
                e.stopImmediatePropagation();
            }
        };

        function getSelectedId(){
            return _.get($scope.diagram.select()[0], 'id');
        }

        function connectionError(msg){
            toaster.pop('error', 'Connection Error', msg);
        }

        function checkConnections(){
            if(checkingConnections){
                return;
            } else {
                checkingConnections = true;
            }
            $timeout(function () {
                // Copies workflow objects and resets "to" attribute for each
                var workflowObjects = angular.copy($scope.workflowData.workflow.objects);
                for (var id in workflowObjects) {
                    if (workflowObjects.hasOwnProperty(id)) {
                        var workflowObj = workflowObjects[id];
                        if (workflowObj.model.type !== 'decision') {
                            workflowObj.model.to = [];
                        }
                    }
                }

                var pointOccupied = {}; // Used to track if each point is occupied
                var hasSource = {};
                for (var c = 0; c < $scope.diagram.connections.length; c++) {
                    var connection = $scope.diagram.connections[c];
                    var source = connection.source().shape;
                    var target = connection.target().shape;
                    var sourcePoint = connection.sourcePoint();
                    var targetPoint = connection.targetPoint();
                    var sourcePath = [sourcePoint, source.id];
                    var targetPath = [targetPoint, target.id];

                    // Checks if connected at both ends
                    if(!(connection.source() instanceof Connector) || !(connection.target() instanceof Connector)){
                        connectionError('Did not connect to second shape');
                        undo();
                        checkingConnections = false;
                        return;
                    }

                    // Checks if source is output node
                    if(connection.source().options.description != 'output'){
                        connectionError('Input nodes only accept incoming connections');
                        undo();
                        checkingConnections = false;
                        return;
                    }

                    // Checks if target is input node
                    if(connection.target().options.description != 'input'){
                        connectionError('Output nodes only accept outgoing connections');
                        undo();
                        checkingConnections = false;
                        return;
                    }

                    // Checks if target is State 1
                    if(connection.target().shape.id == '1'){
                        connectionError('State 1 does not accept incoming connections');
                        undo();
                        checkingConnections = false;
                        return;
                    }

                    // Checks if point already has connection
                    // Decisions are the exception
                    if (source.type !== 'decision' &&(_.get(pointOccupied, sourcePath, false) || _.get(pointOccupied, targetPath, false))) {
                        connectionError('Node already has connection');
                        undo();
                        checkingConnections = false;
                        return;
                    } else {
                        _.set(pointOccupied, sourcePath, true); // Each point is identified by position and shape id
                    }

                    // Checks if source Shape has too many outgoing connections
                    // If not, adds target to workflow object's "to" property
                    var to = workflowObjects[source.id].model.to;
                    if (source.type !== 'decision') {
                        if (to.length > 0) {
                            connectionError('This object may have only 1 output connection');
                            undo();
                            checkingConnections = false;
                            return;
                        } else {
                            to.push('' + target.id);
                        }
                    }
                    else {
                        if(!to[target.id]){
                            to[target.id] = {};
                        }
                    }

                    var targetHasSourcePath = [target.id, source.id];
                    // Checks if Shape has two incoming connections from the same source
                    if(_.get(hasSource, targetHasSourcePath, false)){
                        connectionError('This object may not have two connections from the same source.');
                        undo();
                        checkingConnections = false;
                        return;
                    } else {
                        _.set(hasSource, targetHasSourcePath, true);
                    }
                }

                $scope.workflowData.workflow.objects = workflowObjects;
                checkingConnections = false;
            });
        }

        function undo(){
            if(!undoing) {
                undoing = true;
                $scope.diagram.undo();
                $timeout(function(){
                    undoing = false;
                }, 1, false);
            }
        }

        $scope.getWorkflow = function(id){
            WorkflowsService.getRevision(id).then(function(wf){
                angular.extend($scope.masterWorkflowData, wf);
                $scope.workflowData = angular.copy($scope.masterWorkflowData);
                $scope.workflowId = wf.workflowId;
                $scope.diagram.load(WorkflowDiagramService.workflowModelToShapes($scope.workflowData.workflow));
            });
        };

        $scope.openShapeModal = function(shapeOptions, object, id){
            var shape = angular.copy(shapeOptions);
            var formIdArray = [];
            var states = [];
            if(id) {
                formIdArray = $scope.workflowData.workflow.getForms('' + id);
                states = $scope.workflowData.workflow.getStates('' + id);
            }

            var formIds = formIdArray.concat([]);
            if(object.model.type == 'document') {
                for (var fid = 0; fid < object.model.forms.length; fid++) {
                    if (formIds.indexOf(object.model.forms[fid]) == -1) {
                        formIds.push(object.model.forms[fid]);
                    }
                }
            }
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/widgets/workflows/designer/workflow-shape-modal.tpl.html',
                controller: 'WorkflowsDesignerShapeModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    formIdArray: _.constant(formIdArray),
                    stateId: _.constant(id),
                    states: _.constant(states),
                    widgetId: _.constant($scope.workflowData.widgetId),
                    workflowObject: _.constant(object),
                    workspaceId: _.constant(workspaceId)
                }
            });
            modalInstance.result.then(function(wfObject){
                shape.content = shape.content || {};
                shape.content.text = wfObject.model.name;
                if(shape.x == null || shape.y == null) {
                    shape.x = $scope.lastPos;
                    shape.y = $scope.lastPos;
                    $scope.lastPos += 25;
                }
                if(wfObject.model.type == 'process'){
                    trimParams(wfObject);
                }
                if(id){
                    var shapeObject = $scope.diagram.getShapeById(id);
                    shapeObject.redraw(shape);
                    $scope.workflowData.workflow.objects[id] = wfObject;
                }
                else {
                    var addedShape = $scope.diagram.addShape(shape);
                    $scope.workflowData.workflow.objects[addedShape.id] = wfObject;
                }
            });
        };

        _init();

        function _init(){
            WorkflowsService.getPublishedWorkflow(originId).then(function(workflow){
                $scope.workflowId = workflow.workflowId;
                $scope.workflowData = angular.copy(workflow);
                $scope.masterWorkflowData = angular.copy(workflow);

                $scope.diagramOptions = WorkflowDiagramService.buildWFDiagram($scope, 'workflowData.workflow');
            });

            WorkflowsService.getRevisions(originId).then(function(revisions){
                $scope.revisions = revisions;

                _.forEach(revisions, function(rev){
                    var serverTime = rev.SYS_CREATED_DATE;
                    var m = moment.utc(serverTime,'MMMM, DD YYYY HH:mm:ss');

                    // Converts to local time
                    m.local();

                    rev.SYS_CREATED_DATE = m.toDate();
                });
            });
        }
    }])
;
angular.module('cerberus.admin')
/**
 * @ngdoc service
 * @name WorkflowDiagramService
 * @alias cerberus/workflows-designer:WorkflowDiagramService
 * @description
 *  Helper functions for building Workflow Diagram
 */
    .factory('WorkflowDiagramService', ["_", "kendo", function WorkflowDiagramService(_, kendo){

        var diameter = 13;
        var connectorConfig = {
            vertical: {
                decision: [
                    {name: 'left',description: 'output',width: diameter,height: diameter},
                    {name: 'right',description: 'output',width: diameter,height: diameter},
                    {name: 'top',description: 'input',width: diameter,height: diameter}
                ],
                document: [
                    {name: 'top',description: 'input',width: diameter,height: diameter},
                    {name: 'bottom',description: 'output',width: diameter,height: diameter}
                ],
                endState: [
                    {name: 'top',description: 'input',width: diameter,height: diameter}
                ],
                process: [
                    {name: 'top',description: 'input',width: diameter,height: diameter},
                    {name: 'bottom',description: 'output',width: diameter,height: diameter}
                ]
            },
            horizontal: {
                decision: [
                    {name: 'top',description: 'output',width: diameter,height: diameter},
                    {name: 'bottom',description: 'output',width: diameter,height: diameter},
                    {name: 'left',description: 'input',width: diameter,height: diameter}
                ],
                document: [
                    {name: 'left',description: 'input',width: diameter,height: diameter},
                    {name: 'right',description: 'output',width: diameter,height: diameter}
                ],
                endState: [
                    {name: 'left',description: 'input',width: diameter,height: diameter}
                ],
                process: [
                    {name: 'left',description: 'input',width: diameter,height: diameter},
                    {name: 'right',description: 'output',width: diameter,height: diameter}
                ]
            }
        };

        var shapeConfig = {
            decision: {
                width: 120,
                height: 120,
                type: 'decision',
                stroke: {
                    color: '#feb24c'
                },
                fill: '#ffeda0',
                path: 'M0 60 L60 0 120 60 60 120Z',
                connectors: connectorConfig.vertical.decision
            },
            document: {
                width: 120,
                height: 54,
                type: 'document',
                stroke: {
                    color: '#9ecae1',
                    width: 3
                },
                fill: '#deebf7',
                path: 'M0 0 L120 0 120 57 Q90 43 60 56 30 69 0 55Z',
                connectors: connectorConfig.vertical.document
            },
            endState: {
                width: 120,
                height: 54,
                type: 'document',
                stroke: {
                    color: '#bdbdbd'
                },
                fill: '#f0f0f0',
                path: 'M34 54 C 0 54 0 0 34 0 L 86 0 C 120 0 120 54 86 54Z',
                connectors: connectorConfig.vertical.endState
            },
            process: {
                width: 120,
                height: 70,
                type: 'process',
                stroke: {
                    color: '#a1d99b',
                    width: 1
                },
                fill: '#e5f5e0',
                path: 'M0 0 L60 0 60 40 0 40Z',
                connectors: connectorConfig.vertical.process
            }
        };

        var defaultDiagramOptions = {
            theme: 'default',
            zoomRate: 0,
            shapeDefaults: {
                fill: '#e8eff7',
                stroke: {
                    color: '#586477',
                    width: 2
                },
                editable: {
                    connect: true,
                    drag: true
                },
                content: {
                    color: '#000000',
                    //color: '#ffffff',
                    fontSize: 14
                }
            },
            connectionDefaults: {
                endCap: {
                    type: 'ArrowEnd',
                    fill: '#586477',
                    stroke: '#586477'
                },
                type: 'cascading',
                stroke: {
                    color: '#586477',
                    width: 2
                }
            },
            editable: {
                resize: false,
                rotate: false
            }
        };

        var Shape = kendo.dataviz.diagram.Shape,
            Connection = kendo.dataviz.diagram.Connection;
            //Connector = kendo.dataviz.diagram.Connector;

        return {
            connectorConfig: _.constant(connectorConfig),
            shapeConfig: _.constant(shapeConfig),
            buildWFDiagram: buildWFDiagram,
            workflowModelToShapes: workflowModelToShapes
        };

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /**
         * Builds options for kendo diagram
         *
         * @param scope
         * @param path - path to workflow model in scope
         * @param readonly - determines if diagram is editable
         * @returns {object}
         */
        function buildWFDiagram(scope, path, readonly){
            var workflow = _.get(scope, path);
            var options = workflowModelToShapes(workflow, readonly);

            _.assign(options, defaultDiagramOptions);

            if(readonly) {
                options.editable = false;
                options.selectable = false;
            }
            else {
                var handlers = {
                    select: diagramSelectHandler,
                    change: diagramChangeHandler(scope, path),
                    itemBoundsChange: diagramItemMovedHandler(scope, path)/*,
                     dragEnd: diagramDragEndHandler(scope, path),
                     remove: diagramItemRemoveHandler()*/
                };
                _.assign(options, handlers);
            }

            return options;
        }

        /**
         * Translates workflow model to shapes and connections configuration
         *
         * @param workflow - workflow model
         * @param readonly - determines if shapes and connections should be editable
         * @returns {{shapes: Array, connections: Array}}
         */
        function workflowModelToShapes(workflow, readonly){
            var shapes = [];
            var connections = [];

            _.forEach(workflow.objects, function(state, id){
                var shape = {
                    id: id,
                    content: {
                        text: state.model.name
                    },
                    x: _.get(state, 'display.x', 0),
                    y: _.get(state, 'display.y', 0)
                };

                if(readonly){
                    shape.editable = false;
                    shape.selectable = false;
                }

                if(state.model.isFinal){
                    _.assign(shape, shapeConfig['endState']);
                }
                else {
                    _.assign(shape, shapeConfig[state.model.type]);
                }

                shapes.push(shape);

                if(shape.type == 'decision'){
                    var connector = 'left';
                    _.forEach(state.model.to, function(t, to){
                        var connection = {
                            from: {
                                shapeId: id,
                                connector: 'left'
                            },
                            to: {
                                shapeId: to,
                                connector: 'top'
                            }
                        };

                        if(readonly){
                            connection.editable = false;
                            connection.selectable = false;
                        }
                        connections.push(connection);

                        connector = 'right';
                    });
                }
                else {
                    _.forEach(state.model.to, function(to){
                        var connection = {
                            from: {
                                shapeId: id,
                                connector: 'bottom'
                            },
                            to: {
                                shapeId: to,
                                connector: 'top'
                            }
                        };

                        if(readonly){
                            connection.editable = false;
                            connection.selectable = false;
                        }
                        connections.push(connection);
                    });
                }
            });

            return {shapes: shapes, connections: connections};
        }

        function diagramSelectHandler(e){
            if (e.selected.length) {
                var selectedItems = e.sender.select();
                var element = e.selected[0];
                if(selectedItems.length > 1){
                    e.sender.select(false);
                    e.sender.select(element);
                }
            }
        }

        function diagramChangeHandler(scope, path){
            return function(e){
                var workflow = _.get(scope, path);
                var diagram = e.sender;

                // Handles removed shapes
                if(e.removed.length){
                    for (var r = 0; r < e.removed.length; r++) {
                        var removedShape = e.removed[r];
                        if (removedShape instanceof Shape) {
                            delete workflow.objects[removedShape.id];
                            for (var id in workflow.objects) {
                                if (workflow.objects.hasOwnProperty(id)) {
                                    var obj = workflow.objects[id];
                                    if (obj.model.type == 'decision' && obj.model.to[removedShape.id]) {
                                        delete obj.model.to[removedShape.id];
                                    } else if (obj.model.type != 'decision' && obj.model.to[0] == removedShape.id) {
                                        obj.model.to.pop();
                                    }
                                }
                            }
                        }
                        else if (removedShape instanceof Connection){
                            if(_.has(removedShape, 'from.shape.id') && _.has(removedShape, 'to.shape.id')){
                                var fromId = removedShape.from.shape.id;
                                var toId = removedShape.to.shape.id;
                                var fromObject = workflow.objects[fromId];
                                if(fromObject.model.type == 'decision'){
                                    delete fromObject.model.to[toId];
                                }
                                else {
                                    fromObject.model.to.pop();
                                }
                            }
                        }
                    }

                    for (var c = 0; c < diagram.connections.length; c++) {
                        var connection = diagram.connections[c];
                        if (!connection.source().shape || !connection.target().shape) {
                            diagram.remove(connection, false);
                            c--;
                        }
                    }
                }
            };
        }

        function diagramItemMovedHandler(scope, path){
            return function(e){
                var workflow = _.get(scope, path);
                var obj = workflow.objects[e.item.id];
                if(obj){
                    _.assign(obj.display, _.pick(e.bounds, ['x', 'y']));
                }
            };
        }

        // TODO: Refactor logic from checkConnections and move it here
        //function diagramDragEndHandler(scope, path){
        //    return function(e){
        //        var workflow = _.get(scope, path);
        //        if(_.has(e, 'connections[0].to')){
        //            var to = e.connections[0].to;
        //            if(!(to instanceof Connector)){
        //                e.preventDefault();
        //            }
        //        }
        //    };
        //}

        // TODO: Move item-removal logic from change handler to this function
        //function diagramItemRemoveHandler(){
        //    return function(e){
        //    };
        //}
    }])
;
angular.module('cerberus.core')
    .controller('nimVizChartAreaCtrl', ["_", "$scope", "VizChartService", "VizChartAreaService", "VizUtilityService", "$firebaseObject", "fbUtil", "$timeout", function nimVizChartAreaCtrl(_, $scope, VizChartService, VizChartAreaService, VizUtilityService, $firebaseObject, fbUtil, $timeout) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;

        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function() { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        init();

        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.chart) {
                $scope.chart.destroy();
                $scope.chart = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);

            // Fix any misconfigurations
            VizChartService.fixChartOptions(options);

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options);
            options.dataSource = vm.dataSource;

            VizChartService.setSeriesColors(options, $scope.pageObject.params);

            // Exposes options to view model
            vm.options = options;

            // Watch Filters
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
            
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartAreaService
     * @alias cerberus/core:VizChartAreaService
     * @description Provides functions for configuring area charts
     */
    .factory('VizChartAreaService', function VizChartAreaService(){
        return {
            //configArea: configArea
        };

        /**
         * This function dynamically adjusts certain parameters for the chart settings
         * @function configArea
         * @param {object} data
         * @param {object} options
         * function configArea(data, options){}
         */

    })
;
angular.module('cerberus.core')
    .controller('nimVizChartBarCtrl', ["_", "$scope", "VizChartService", "VizChartBarService", "VizUtilityService", "$firebaseObject", "fbUtil", "$timeout", function nimVizChartBarCtrl(_, $scope, VizChartService, VizChartBarService, VizUtilityService, $firebaseObject, fbUtil, $timeout) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;
        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function() { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        init();

        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.chart) {
                $scope.chart.destroy();
                $scope.chart = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);
            
            // Fix any misconfigurations
            VizChartService.fixChartOptions(options);

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options);
            options.dataSource = vm.dataSource;

            VizChartService.setSeriesColors(options, $scope.pageObject.params);

            // Expose options to view model
            vm.options = options;

            // Watch Filters
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartBarService
     * @alias cerberus/core:VizChartBarService
     * @description Provides functions for configuring bar charts
     */
    .factory('VizChartBarService', function VizChartBarService(){
        return {
            //configBar: configBar
        };

        /**
         * This function dynamically adjusts certain parameters for the chart settings
         * @function configBar
         * @param {object} data
         * @param {object} options
         * function configBar(data, options){}
         */

    })
;
angular.module('cerberus.core')
    .controller('nimVizChartBubbleCtrl', ["_", "$scope", "VizChartService", "VizChartBubbleService", "VizUtilityService", "VizMathService", "$firebaseObject", "fbUtil", "$timeout", function nimVizChartBubbleCtrl(_, $scope, VizChartService, VizChartBubbleService, VizUtilityService, VizMathService, $firebaseObject, fbUtil, $timeout) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;
        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function() { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        init();

        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.chart) {
                $scope.chart.destroy();
                $scope.chart = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);
            
            // Fix any misconfigurations
            VizChartService.fixChartOptions(options);

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options);
            options.dataSource = vm.dataSource;

            VizChartService.setSeriesColors(options, $scope.pageObject.params);

            // Exposes options to view model
            vm.options = options;

            // Watch Filters
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartBubbleService
     * @alias cerberus/core:VizChartBubbleService
     * @description Provides functions for configuring bubble charts
     */
    .factory('VizChartBubbleService', function VizChartBubbleService(){
        return {
            //configBubble: configBubble
        };

        /**
         * This function dynamically adjusts certain parameters for the chart settings
         * @function configBubble
         * @param {object} data
         * @param {object} options
         * function configBubble(data, options){}
         */

    })
;
angular.module('cerberus.core')
    .controller('nimVizChartBulletCtrl', ["_", "$scope", "$timeout", "VizChartBulletService", "VizUtilityService", "VizMathService", "vizListService", "$firebaseObject", "fbUtil", function nimVizChartBulletCtrl(_, $scope, $timeout, VizChartBulletService, VizUtilityService, VizMathService, vizListService, $firebaseObject, fbUtil) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;

        vm.toPercentageString = VizMathService.toPercentageString;

        // Debounced refresh function and Firebase watchers
        var debouncedRefresh = _.debounce(function () { _.result($scope, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchPlot = setFirebaseWatcher($scope.pageObject.viz.settings.dataSource.plot.nim_viewId),
            unwatchValue = setFirebaseWatcher($scope.pageObject.viz.settings.dataSource.value.nim_viewId),
            unwatchTarget = setFirebaseWatcher($scope.pageObject.viz.settings.dataSource.target.nim_viewId);
        
        init();

        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            // Removes these firebase watchers
            unwatchPlot();
            unwatchValue();
            unwatchTarget();
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.chart) {
                $scope.chart.destroy();
                $scope.chart = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            // Options not yet exposed to delay chart initialization
            var options = angular.copy($scope.pageObject.viz.settings);

            $scope.currentField = options.series[0].currentField;
            $scope.plotField = options.series[0].toField;
            vm.data = {
                value: [],
                target: [],
                plot: []
            };

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            // Used for coloring plotbands
            $scope.plotColors = vizListService.colorbrewer().sequential.Greys[3];

            var bulletDataSources = angular.copy($scope.pageObject.viz.settings.dataSource);

            // TODO: Refactor these buildBulletDataSource calls
            var dataSource = VizChartBulletService.buildBulletDataSource($scope.pageObject, bulletDataSources.value, options, $scope, 'value',
                VizChartBulletService.valueFetchCallback($scope, options));
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap.value || {}, $scope, dataSource);

            // Builds plotband data source and configures plotbands with data
            if ($scope.pageObject.viz.settings.dataSource.plot.nim_viewId) {
                bulletDataSources.plot = VizChartBulletService.buildBulletDataSource($scope.pageObject, bulletDataSources.plot, options, $scope, 'plot',
                    VizChartBulletService.plotBandFetchCallback($scope, options));
                VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap.plot || {}, $scope, bulletDataSources.plot);
            }
            else {
                $scope.plot = [];
            }

            // Builds target data source
            if ($scope.pageObject.viz.settings.dataSource.target.nim_viewId) {
                bulletDataSources.target = VizChartBulletService.buildBulletDataSource($scope.pageObject, bulletDataSources.target, options, $scope, 'target',
                    VizChartBulletService.targetFetchCallback($scope, options));
                VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap.target || {}, $scope, bulletDataSources.target);
            }
            else {
                $scope.target = [];
            }

            // Finally expose options to view model for kendo binding
            vm.options = options;
            $scope.dataSource = dataSource;
        }

        function setFirebaseWatcher(viewId) {
            if (viewId) {
                var initializing = true;
                return $firebaseObject(fbUtil.ref('queries/' + viewId)).$watch(function () {
                    if (initializing) {
                        //Stops first firing of the event
                        $timeout(function () { initializing = false; });
                    } else {
                        debouncedRefresh();
                    }
                });
            }

            return angular.noop;
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartBulletService
     * @alias cerberus/core:VizChartBulletService
     * @description Provides functions for configuring bullet charts
     */
    .factory('VizChartBulletService', ["_", "kendo", "$rootScope", "$http", "$timeout", "apiPath", "VizUtilityService", function VizChartBulletService(_, kendo, $rootScope, $http, $timeout, apiPath, VizUtilityService){
        return {
            configBullet: configBullet,
            buildBulletDataSource: buildBulletDataSource,
            valueFetchCallback: valueFetchCallback,
            plotBandFetchCallback: plotBandFetchCallback,
            targetFetchCallback: targetFetchCallback
        };

        ///////////////////////////

        /**
         * This function dynamically adjusts certain parameters for the chart settings
         * @function configBullet
         * @param {object} data
         * @param {object} options
         */
        function configBullet(data, options) {
            if(data) {
                var fieldsChecked = {};
                var max = options.valueAxis.max || 0;
                var min = options.valueAxis.min || 0;

                _.forEach(options.series, function (series) {
                    var field = series.currentField;

                    if(!fieldsChecked[field]){
                        fieldsChecked[field] = true;

                        _.forEach(data, function (dataItem) {
                            var value = dataItem[field];
                            var target = dataItem.target;

                            if(typeof value == "number"){
                                if(value > max){
                                    max = value;
                                }
                                else if(value < min){
                                    min = value;
                                }
                            }

                            if(target && typeof target == "number"){
                                if(target > max){
                                    max = target;
                                }
                                else if(target < min){
                                    min = target;
                                }
                            }
                        });
                    }

                    series.data = data;
                });

                if(options.valueAxis.plotBands && options.valueAxis.plotBands.length && options.valueAxis.plotBands[0].to > max){
                    max = options.valueAxis.plotBands[0].to;
                }

                options.valueAxis.max = max;
                options.valueAxis.min = min;
            }
        }

        /**
         * Joins target data and value data on category values
         * @param valueData
         * @param valueCatField
         * @param targetData
         */
        function joinValueAndTarget(valueData, valueCatField, targetData) {
            if(valueData && targetData && targetData.length == 1 && !targetData[0].category){
                //If only 1 target with no category, apply that target to all values
                var targetValue = targetData[0].target;
                _.forEach(valueData, function (valueItem) {
                    valueItem.target = targetValue;
                });
            }
            else if(valueData && valueCatField && valueCatField !== '' && targetData){
                // Joins data by category
                _.forEach(targetData, function (targetItem) {
                    var category = targetItem.category;
                    var target = targetItem.target;

                    _.forEach(valueData, function (valueItem) {
                        // joins data if value's category matches target's category
                        if(valueItem[valueCatField] === category){
                            valueItem.target = target;
                        }
                    });
                });
            }
        }

        /**
         * Builds simple dataSource for bullet chart
         * @param pageObject
         * @param source
         * @param options
         * @param scope
         * @param id
         * @param cb
         * @returns {kendo.data.DataSource}
         */
        function buildBulletDataSource(pageObject, source, options, scope, id, cb){
            if(source) {
                var dataSourceOptions = {
                    type: 'odata',
                    transport: {
                        read: read
                    },
                    serverFiltering: true,
                    serverSorting: true,
                    serverPaging: true,
                    serverAggregates: true,
                    serverGrouping: false,
                    requestStart: function (e) {
                        var requiredFilters = _.get(pageObject.params, ['requiredFilters', id], {});
                        if(!_.isEmpty(requiredFilters)){
                            _.forEach(requiredFilters, function(required, filter){
                                if(required && VizUtilityService.isFilterEmpty(scope.filters[filter])){
                                    e.preventDefault();

                                    $timeout(function(){
                                        e.sender.success({d:{results: [], __count: 0}});
                                    });

                                    return false;
                                }
                            });
                        }
                    },
                    change: function (e) {
                        $timeout(function(){
                            scope[id] = e.sender.data();
                            cb(e.sender);
                            configBullet(scope.value, options);
                            if(scope.chart) {
                                scope.chart.setOptions(options);

                                scope.chart.refresh();
                            }
                        }, 1);
                    }
                };

                var sortOptions = {
                    sort: VizUtilityService.createSortArray(source)
                };

                var baseFilter = angular.copy(source.filter) || {
                    filters: [],
                    logic: 'and'
                };

                var filterOptions = {
                    filter: {
                        filters: [baseFilter],
                        logic: pageObject.params.filterLogic || 'and'
                    }
                };

                angular.extend(dataSourceOptions, source, sortOptions, filterOptions);

                // Adds parse function to make sure date fields are correct
                _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                    if (field.type === 'date') {
                        field.parse = VizUtilityService.parseDateField;
                    }
                });

                return new kendo.data.DataSource(dataSourceOptions);
            }

            function read(options) {
                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);
                httpOptions.params.$ds = id;

                if (pageObject.params) {
                    var recurrence = VizUtilityService.buildRecurrenceData(pageObject, scope, options.data);
                    if (recurrence) {
                        httpOptions.params.$recurrence = recurrence;
                    }
                }

                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }
        }

        /**
         * Builds callback function for fetching value data
         * @param scope
         * @param options
         * @returns {Function}
         */
        function valueFetchCallback(scope, options){
            return function (valueSource) {
                var data = valueSource.data();
                scope.currentField = options.series[0].currentField;

                // if target data has been retrieved, join the data
                if(scope.target){
                    joinValueAndTarget(data, options.series[0].categoryField, scope.target);
                }

                if (options.seriesColors && options.seriesColors.length < 1) {
                    options.seriesColors = null;
                }

                scope.mainPageObject.vizCtrl.data.value = data;
                scope.mainPageObject.vizCtrl.data.currentField = scope.currentField;
            };
        }

        /**
         * Builds callback function for fetching plotband data
         * @param scope
         * @param options
         * @returns {Function}
         */
        function plotBandFetchCallback(scope, options) {
            return function(source){
                // Extracts plotband 'to' values from returned data and sorts it
                var rawPlotData = source.data();
                setPlotBands(scope, options, rawPlotData);

                if(scope.chart) {
                    scope.chart.setOptions(options);
                }

                scope.mainPageObject.vizCtrl.data.plot = scope.plot;
                scope.mainPageObject.vizCtrl.data.plotField = scope.plotField;
            };
        }

        function setPlotBands(scope, options, data){
            scope.plotField = options.series[0].toField;
            var plotToValues = _.map(data, scope.plotField).sort().reverse();

            // Sets plotbands' colors and adds them to the chart
            var plotBands = [];
            for(var pv = 0; pv < plotToValues.length && pv < scope.plotColors.length; pv++){
                plotBands.push({
                    from: 0,
                    to: plotToValues[pv],
                    color: scope.plotColors[pv]
                });
            }

            options.valueAxis.plotBands = plotBands;
        }

        /**
         * Builds callback function for fetching target data
         * @param scope
         * @param options
         * @returns {Function}
         */
        function targetFetchCallback(scope, options){
            return function(targetSource){
                // joins value and target data if both have been fetched
                if(scope.chart && scope.chart.dataSource && scope.value){
                    var data = scope.value;
                    joinValueAndTarget(data, options.series[0].categoryField, targetSource.data());
                    scope.chart.dataSource.data(data);
                }

                scope.mainPageObject.vizCtrl.data.target = scope.target;
                scope.mainPageObject.vizCtrl.data.targetField = 'target';
            };
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizScheduleCalendarCtrl', ["$scope", function($scope) {
        var vm = this;

        vm.options = angular.copy($scope.pageObject.viz.settings);
        // Calendar doesn't need any special configuration yet
    }])
;
angular.module('cerberus.core')
/**
 * @ngdoc service
 * @name VizScheduleCalendarService
 * @alias cerberus/core:VizScheduleCalendarService
 * @description Provides functions for configuring calendars
 */
    .factory('VizScheduleCalendarService', function VizScheduleCalendarService(){
        return {
            //configCalendar: configCalendar
        };

        /**
         * Modifies calendar settings
         * @param data
         * @param options
         * function configCalendar(data, options){}
         */

    })
;
angular.module('cerberus.core')
    .directive('nimVizChart', function() {
        return {
            restrict: 'AE',
            templateUrl: function (tElement, tAttributes) {
                if (tAttributes.subType) {
                    if (tAttributes.template) {
                        return 'core/pages/viz/' + tAttributes.subType + '/chart-' + tAttributes.subType + '-' + tAttributes.template + '.tpl.html';
                    }
                    else {
                        return 'core/pages/viz/' + tAttributes.subType + '/chart-' + tAttributes.subType + '.tpl.html';
                    }
                }
                else {
                    return 'core/pages/viz/chart/chart.tpl.html';
                }
            },
            scope: true,
            require: '^nimPageObject',
            controller: "@",
            name: 'controllerName',
            controllerAs: 'vm'
        };
    })
;

angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartService
     * @alias cerberus/core:VizChartService
     * @description Preps and dynamically configures a chart viz based on data
     */
    .factory('VizChartService', ["_", "kendo", "$timeout", "$http", "VizUtilityService", "vizListService", function VizChartService(_, kendo, $timeout, $http, VizUtilityService, vizListService) {
        return {
            buildDataSource: buildDataSource,
            setSeriesColors: setSeriesColors,
            fixChartOptions: fixChartOptions
        };
        ////////////////////
        /**
         * Parses grid definition to properly set defines schema
         * @function buildDataSource
         * @param {object} pageObject
         * @param {object} scope - angularJs scope
         * @param {object} chartOptions
         * @param {function} configFunc - contains object-specific function to configure data/options
         * @return {kendo.data.DataSource}
         */
        function buildDataSource(pageObject, scope, chartOptions, configFunc) {
            var usesDateCategory = _.get(pageObject, 'viz.settings.categoryAxis.type') === 'date',
                groupField = _.get(pageObject, 'viz.settings.dataSource.group.field', ''),
                useClientSort = pageObject.viz.subType === 'pie' || pageObject.viz.subType === 'donut' || usesDateCategory,
                origDataSourceOptions = pageObject.viz.settings.dataSource;

            var realSortOptions = VizUtilityService.createSortArray(origDataSourceOptions);

            var dataSourceOptions = {
                type: 'odata',
                transport: {
                    read: read
                },
                serverFiltering: true,
                serverSorting: !useClientSort,
                serverPaging: true,
                serverAggregates: true,
                serverGrouping: false,
                requestStart: function (e){
                    if(!_.isEmpty(pageObject.params.requiredFilters)){
                        _.forEach(pageObject.params.requiredFilters, function(required, filter){
                            if(required && VizUtilityService.isFilterEmpty(scope.filters[filter])){
                                e.preventDefault();

                                $timeout(function(){
                                    e.sender.success({d:{results: [], __count: 0}});
                                });

                                return false;
                            }
                        });
                    }
                },
                change: function (e) {
                    if (groupField) {
                        _.forEach(e.sender.view(), function (group) {
                            var sortedItems = VizUtilityService.clientSort(group.items, realSortOptions);
                            if (!angular.equals(sortedItems, group.items)) {
                                group.items = sortedItems;
                            }
                        });
                    }
                    
                    scope.mainPageObject.vizCtrl.data = e.sender.data();
                }
            };

            var sortOptions = {
                sort: []
            };

            if (!useClientSort) {
                sortOptions.sort = realSortOptions;
            }

            var baseFilter = angular.copy(origDataSourceOptions.filter) || {
                filters: [],
                logic: 'and'
            };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: pageObject.params.filterLogic || 'and'
                }
            };

            // Extend any user-defined dataSource settings
            angular.extend(dataSourceOptions, origDataSourceOptions, sortOptions, filterOptions);

            // Adds parse function to make sure date fields are correct
            _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                if (field.type === 'date') {
                    field.parse = VizUtilityService.parseDateField;
                }
            });

            // Return new Datasource
            return new kendo.data.DataSource(dataSourceOptions);

            function read(options) {
                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);

                $http(httpOptions).then(function (result) {
                    var data = oDataToArray(result.data);
                    var categoryField = _.get(pageObject, 'viz.settings.categoryAxis.field');

                    // Fixes issue with grouping while using a date category
                    if (usesDateCategory && groupField) {
                        fixDateCategoryData(categoryField, groupField, data);
                    }
                    
                    // Client-side sorting
                    if (realSortOptions && useClientSort) {
                        data = VizUtilityService.clientSort(data, realSortOptions);
                    }

                    // Fix pageSize issue
                    var pageSize = _.get(options, 'data.pageSize');
                    if (data.length > pageSize) {
                        data.splice(pageSize, data.length - 1);
                    }
                    
                    // Transform data
                    if (configFunc && chartOptions) {
                        configFunc(data, chartOptions);
                    }

                    options.success(arrayToOData(data));
                }, function (result) {
                    options.error(result);
                });
            }
        }

        function setSeriesColors(chartOptions, params){
            var colorbrewer = vizListService.colorbrewer();
            var pathToPalette = [params.seriesDataType, params.seriesColorPalette, params.seriesClassNum];
            if(_.has(colorbrewer, pathToPalette)){
                chartOptions.seriesColors = _.get(colorbrewer, pathToPalette);
                chartOptions.seriesColors.reverse();
            }
            if(_.isEmpty(chartOptions.seriesColors)){
                delete chartOptions.seriesColors;
            }
        }

        function oDataToArray(oDataResult) {
            var data = [];

            if (_.has(oDataResult, 'd')) {
                if (_.isArray(oDataResult.d.results)) {
                    data = oDataResult.d.results;
                }
                else {
                    data.push(_.omit(oDataResult.d, '__count'));
                }
            }

            return data;
        }

        function arrayToOData(arr) {
            var odata = {
                d: {
                    __count: arr.length
                }
            };

            if (arr.length == 1) {
                _.assign(odata.d, arr[0]);
            }
            else {
                odata.d.results = arr;
            }

            return odata;
        }

        /**
         * Fix issues with incomplete configurations
         * @param {Object} options - Options for the kendo chart
         */
        function fixChartOptions(options) {
            if (options.categoryAxis && options.categoryAxis.type == 'date' && !options.categoryAxis.baseUnitStep) {
                options.categoryAxis.baseUnitStep = 1;
            }
        }

        /**
         * Fixes issue where a chart with grouping and a date category will
         * only render values for the categories present in the first group
         * @param {*} categoryField 
         * @param {*} groupField 
         * @param {*} data 
         */
        function fixDateCategoryData(categoryField, groupField, data) {
            // List of all category values
            var categories = _.compact(_.uniq(_.map(data, categoryField)));

            // Preview of grouped data
            var groups = _.groupBy(data, groupField);
            
            _.forEach(groups, function (groupData, groupValue) {
                _.forEach(categories, function (cat) { 
                    // If category value is not present in this group...
                    if (!_.find(groupData, categoryField, cat)) {
                        // Add new data item that falls in this group with the given category
                        // but with no value so the item doesn't render
                        var newDataItem = {
                            __nimAttachments: []
                        };

                        newDataItem[categoryField] = cat;
                        newDataItem[groupField] = groupValue;

                        data.push(newDataItem);
                    }
                });
            });
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizChartFunnelCtrl', ["_", "$scope", "VizChartService", "VizChartFunnelService", "VizUtilityService", "$firebaseObject", "fbUtil", "$timeout", function nimVizChartFunnelCtrl(_, $scope, VizChartService, VizChartFunnelService, VizUtilityService, $firebaseObject, fbUtil, $timeout) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;
        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function() { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        init();

        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.chart) {
                $scope.chart.destroy();
                $scope.chart = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            VizChartService.setSeriesColors(options, $scope.pageObject.params);

            if(options.series.length > 1){
                for(var s = 0; s < options.series.length - 1; s++){
                    options.series[s].labels = options.series[s].labels || {};
                    options.series[s].labels.template = ' ';
                }
            }

            vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options);
            options.dataSource = vm.dataSource;

            // Exposes options to view model
            vm.options = options;

            // Watch Filters
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartFunnelService
     * @alias cerberus/core:VizChartFunnelService
     * @description Provides functions for configuring funnel charts
     */
    .factory('VizChartFunnelService', function VizChartFunnelService(){
        return {
            //configFunnel: configFunnel
        };

        /*function configFunnel(data, options){
            // Nothing, yet
        }*/
    })
;
angular.module('cerberus.core')
    .controller('nimVizChartDonutCtrl', ["_", "$scope", "VizChartService", "VizChartDonutService", "VizUtilityService", "$firebaseObject", "fbUtil", "$timeout", function nimVizChartDonutCtrl(_, $scope, VizChartService, VizChartDonutService, VizUtilityService, $firebaseObject, fbUtil, $timeout) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;
        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function () {
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function () { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        init();

        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.grid) {
                $scope.grid.destroy();
                $scope.grid = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);
            
            // Fix any misconfigurations
            VizChartService.fixChartOptions(options);

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            reorderSeries(options);

            VizChartService.setSeriesColors(options, $scope.pageObject.params);

            if (options.series.length > 1) {
                _.forEach(options.series, function (series) {
                    series.labels = series.labels || {};
                    series.labels.template = ' ';
                });
            }

            //vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options, VizChartDonutService.configDonut($scope.pageObject.params));
            vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options, VizChartDonutService.configDonut($scope.pageObject.params));
            options.dataSource = vm.dataSource;

            // Exposes options to view model
            vm.options = options;

            // Watch Filters
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }

        function reorderSeries(options){
            var sortField = '';
            if (_.isArray(options.dataSource.sort)) {
                // TODO: this only works if the first sort field matches a series
                // Update this to handle multiple sort conditions
                sortField = _.get(options.dataSource, 'sort[0].field', '');
            }
            else if (_.isObject(options.dataSource.sort)) {
                sortField = _.get(options.dataSource, 'sort.field', '');
            }
            
            if(sortField){
                // var index = options.series.map(function(e){ return e.field; }).indexOf(sortField); /* NON LODASH OPTION */
                /* LODASH Version 4 ONLY */
                //var index = _.findIndex(options.series, ['field', sortField]);
                /* LODASH Version 3 & 4 Compatibility Mode */
                var index = _.findIndex(options.series, function(f){return f.field === sortField;});
                if(index >= 0){
                    var top = options.series.splice(index, 1);
                    options.series.push(top[0]);
                }
            }
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartDonutService
     * @alias cerberus/core:VizChartDonutService
     * @description Provides functions for configuring donut charts
     */
    .factory('VizChartDonutService', ["_", function VizChartDonutService(_){
        return {
            configDonut: configDonut
        };

        function configDonut(params){
            return function(data, options){
                var displayNum = params.displayNum;
                if(displayNum && data.length > displayNum) {
                    var categoryField = options.seriesDefaults.donut.categoryField;
                    if (!categoryField) {
                        categoryField = 'category';
                    }

                    var other = {};
                    other[categoryField] = 'Other';

                    var otherItems = data.splice(displayNum, data.length - displayNum);
                    _.forEach(options.series, function (series) {
                        var valueField = series.field;
                        other[valueField] = 0;

                        _.forEach(otherItems, function (item) {
                            var val = item[valueField];
                            if (val) {
                                other[valueField] += val;
                            }
                        });
                    });

                    data.push(other);
                    return data;
                }
            };
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizScheduleGanttCtrl', ["_", "moment", "$scope", "$timeout", "VizScheduleGanttService", "VizUtilityService", "$firebaseObject", "fbUtil", function(_, moment, $scope, $timeout, VizScheduleGanttService, VizUtilityService, $firebaseObject, fbUtil) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;

        vm.exportICS = _.partial(VizScheduleGanttService.exportICS, $scope);

        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function() { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });
        
        init();

        // Event Bindings
        var removeGanttSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.schedule) {
                event.preventDefault();
                event.stopPropagation();

                var list = widget.element.find('.k-gantt-treelist');
                
                if (!list.width() && widget.options.listWidth) {
                    list.width(widget.options.listWidth);
                }

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeGanttSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.schedule) {
                $scope.schedule.destroy();
                $scope.schedule = null;
            }

            removeGanttSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);
            options.autoBind = false;
            options.columns = angular.copy(_.reject(options.columns, 'hidden'));

            var titleCol = _.find(options.columns, 'field', $scope.pageObject.viz.settings.dataSource.schema.model.title);

            if (titleCol) {
                titleCol.field = 'title';
            }

            vm.dataSource = VizScheduleGanttService.buildDataSource($scope, $scope.pageObject, options);
            options.dataSource = vm.dataSource;
            options.change = selectHandler;
            options.dataBound = dataBoundHandler;
            options.resizable = true;
            options.date = moment().startOf('week').toDate();

            options.tooltip = {
                template: '<div class="#=styles.taskDetails#">' +
                '<strong>#=task.title#</strong>' +
                '<div class="#=styles.taskDetailsPercent#">#=kendo.toString(task.percentComplete, "p0")#</div>' +
                '<ul class="#=styles.reset#">' +
                '<li>#=messages.start#: #=kendo.toString(task.start, "ddd, MMM d")#</li>' +
                '<li>#=messages.end#: #=kendo.toString(task.end, "ddd, MMM d")#</li>' +
                '</ul>' +
                '</div>'
            };

            // Expose Options to Scope
            vm.options = options;

            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }

        function selectHandler(e) {
            var selected = e.sender.select();
            if($scope.pageObject.params.openOnSelect && selected.length){
                var uid = selected.data('uid');
                var dataItem = e.sender.dataSource.getByUid(uid);

                VizScheduleGanttService.viewRecord(dataItem.id/*, navFunctions*/);
            }
        }

        function dataBoundHandler(e) {
            resizeGantt(e.sender);
        }

        function resizeGantt(gantt) {
            if (gantt) {
                var list = gantt.element.find('.k-gantt-treelist'),
                    timeline = gantt.element.find('.k-gantt-timeline'),
                    splitbar = gantt.element.find('.k-splitbar');
                
                if (!gantt.options.height) {
                    gantt.element.css('height', '').find('.k-gantt-layout, .k-grid-content').css('height', '');

                    var listHeight = list.height();
                    var timelineHeight = timeline.height();
            
                    splitbar.css('height', Math.max(listHeight, timelineHeight));
                }

                if ($scope.resizeGridsterItem) {
                    $timeout(function () {
                        $scope.resizeGridsterItem();
                    }, 10);
                }
            }    
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizScheduleGanttService
     * @alias cerberus/core:VizScheduleGanttService
     * @description Provides functions for configuring Gantt charts
     */
    .factory('VizScheduleGanttService', ["_", "ics", "moment", "kendo", "$http", "$timeout", "$window", "InstancesWindowService", "VizUtilityService", function VizScheduleGanttService(_, ics, moment, kendo, $http, $timeout, $window,
                                                                         InstancesWindowService, VizUtilityService){
        return {
            buildDataSource: buildDataSource,
            configGantt: configGantt,
            viewRecord: viewRecord,
            exportICS: exportICS
        };

        /**
         * Builds ganttDataSource and modifies Gantt chart settings
         * @param scope
         * @param pageObject
         * @param scheduleOptions
         * @returns {kendo.data.GanttDataSource}
         */
        function buildDataSource(scope, pageObject, scheduleOptions) {
            var dependencyDataSource = new kendo.data.GanttDependencyDataSource();
            scheduleOptions.dependencies = dependencyDataSource;

            var dataSourceOptions = {
                type: 'odata',
                transport: {
                    read: read
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                serverAggregates: true,
                serverGrouping: false,
                change: function (e) {
                    var data = e.sender.data();
                    if (scope.schedule) {
                        // Adjust and set options
                        if(configGantt) {
                            configGantt(data, scope.pageObject.viz.settings, dependencyDataSource);
                        }
                    }
                    scope.data = data;
                    scope.mainPageObject.vizCtrl.data = data;
                },
                requestStart: function (e){
                    if(!_.isEmpty(pageObject.params.requiredFilters)){
                        _.forEach(pageObject.params.requiredFilters, function(required, filter){
                            if(required && VizUtilityService.isFilterEmpty(scope.filters[filter])){
                                e.preventDefault();

                                $timeout(function(){
                                    e.sender.success({d:{results: [], __count: 0}});
                                });

                                return false;
                            }
                        });
                    }
                },
                requestEnd: function (e) {
                    if (e.response) {
                        var model = scope.pageObject.viz.settings.dataSource.schema.model,
                            data = [];
                        
                        if (e.response.d.__count == 1) {
                            data = [e.response.d];
                        }
                        else {
                            data = e.response.d.results;
                        }

                        setGanttFields(model, data);
                    }

                    if (scope.schedule) {
                        $timeout(function(){
                            scope.schedule.refresh();
                        });
                    }
                }

            };

            var sortOptions = {
                sort: VizUtilityService.createSortArray(scheduleOptions.dataSource)
            };

            var baseFilter = angular.copy(pageObject.viz.settings.dataSource.filter) || {
                filters: [],
                logic: 'and'
            };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: pageObject.params.filterLogic || 'and'
                }
            };

            if(scheduleOptions && scheduleOptions.dataSource) {
                angular.extend(dataSourceOptions, scheduleOptions.dataSource, sortOptions, filterOptions);
            }

            // Adds parse function to make sure date fields are correct
            var schemaModel = dataSourceOptions.schema.model;
            _.forEach(schemaModel.fields, function (fieldObj) {
                if(fieldObj.type === 'date') {
                    fieldObj.parse = VizUtilityService.parseDateField;
                }
            });

            return new kendo.data.GanttDataSource(dataSourceOptions);

            function read(options) {
                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);

                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }
        }

        /**
         * Modifies data so parent tasks show sub-tasks
         * @param data
         */
        function configGantt(data, options, dependencyDataSource) {
            var model = options.dataSource.schema.model,
                dependencies = [];

            for (var d = 0; d < data.length; d++) {
                var dataItem = data[d];

                // Default Date-Time rules
                var hasStartTime = dataItem.start && dataItem.start instanceof Date;
                var hasEndTime = dataItem.end && dataItem.end instanceof Date;
                var defaultOffsetValue = 30;
                var defaultOffsetUnit = 'm';

                if(hasStartTime && hasEndTime){
                    var start = moment(dataItem.start.toISOString());
                    var end = moment(dataItem.end.toISOString());

                    // Make sure end time is not before start time
                    if(end.diff(start) < 0){
                        dataItem.end = start.add(defaultOffsetValue, defaultOffsetUnit).toDate();
                    }
                }
                else if(hasStartTime){
                    // If record has start and no end, set end to [defaultOffset] after start time
                    dataItem.end = moment(dataItem.start.toISOString()).add(defaultOffsetValue, defaultOffsetUnit).toDate();
                }
                else if(hasEndTime){
                    // If record has end and no start, set start to [defaultOffset] before end time
                    dataItem.start = moment(dataItem.end.toISOString()).subtract(defaultOffsetValue, defaultOffsetUnit).toDate();
                }
                else{
                    // If neither time is set, remove from data
                    // Lack of start time breaks gantt chart
                    data.splice(d, 1);
                    d--;
                    continue;
                }

                if (model.dependency && dataItem[model.dependency]) {
                    dependencies.push({
                        id: d,
                        predecessorId: dataItem[model.dependency],
                        successorId: dataItem.id,
                        type: 1
                    });
                }
            }

            dependencyDataSource.data(dependencies);
        }

        function setGanttFields(model, data) {

            _.forEach(data, function (dataItem) {
                parseFrom(model, 'title', dataItem);
                parseFrom(model, 'parentId', dataItem);
                parseFrom(model, 'start', dataItem);
                parseFrom(model, 'end', dataItem);
                parseFrom(model, 'percentComplete', dataItem);
                dataItem.orderId = 0;
                // dataItem.orderId = index;

                if (model.wbs) {
                    findParentViaWBS(dataItem, model, data);
                }
                else if(model.parentId) {
                    var hasChildren = !!(_.find(data, model.parentId, dataItem.id));

                    if (hasChildren) {
                        dataItem.summary = true;
                        dataItem.expanded = model.fields.expanded.defaultValue;
                    }
                }    
            });
        }

        function parseFrom(model, field, dataItem) {
            if (model[field]) {
                var val = angular.copy(_.get(dataItem, model[field], ''));
                
                if (model.fields[field].type === 'date') {
                    val = VizUtilityService.parseDateField(val);
                }

                dataItem[field] = val;
            }
        }

        function findParentViaWBS(dataItem, model, data) {
            var wbsField = model.wbs;
            var wbs = _.get(dataItem, wbsField, '');

            if (wbs) {
                var wbsComponents = wbs.toString().split('.');
                dataItem.orderId = wbsComponents.pop();

                if (wbsComponents.length) {
                    var parentWBS = wbsComponents.join('.');
                    var parent = _.find(data, function (item) {
                        return item[wbsField] == parentWBS;
                    });

                    if (parent) {
                        dataItem.parentId = parent.id;

                        parent.summary = true;
                        parent.expanded = model.fields.expanded.defaultValue;
                    }
                }
            }
        }

        /**
         * Opens selected record in instance window
         * @function viewRecord
         * @param id
         * @param navFunctions
         */
        function viewRecord(id, navFunctions) {
            InstancesWindowService.openWindow({
                action: 'read',
                instanceId: id,
                navFunctions: navFunctions
            });
        }

        // Exports Calendar data (current view) to .ics
        function exportICS(scope){
            var cal = ics();

            _.forEach(scope.schedule.dataSource.data(), function(event){
                // addEvent REQUIRES the following arguments:
                // @param {string} subject     Subject/Title of event
                // @param {string} description Description of event
                // @param {string} location    Location of event
                // @param {string} begin       Beginning date of event
                // @param {string} stop        Ending date of event
                cal.addEvent(event.title || '(Untitled)', event.description || '', '', event.start, event.end);
            });

            if(cal.events().length > 0) {
                var content = cal.calendar();
                var blob = new Blob([content], {type: "text/plain;charset=utf-8"});

                $window.saveAs(blob, scope.pageObject.name + '.ics');
            }
        }
    }])
;
// Gage
// TODO: Mapped field for Progress bar (optional)
// TODO: Mapped field for Due Date (optional)
// TODO: Mapped field for Tags Field (optional)

angular.module('cerberus.core')
    .controller('nimVizKanbanCtrl', ["_", "kendo", "$scope", "$element", "$log", "$timeout", "vizKanbanService", "VizUtilityService", "$firebaseObject", "fbUtil", function nimVizKanbanCtrl(_, kendo, $scope, $element, $log, $timeout, vizKanbanService, VizUtilityService, $firebaseObject, fbUtil) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;

        // View model
        vm.bins = [];
        vm.binKey = _.get($scope.pageObject, 'params.binKey');
        vm.orderKey = _.get($scope.pageObject, 'params.orderKey');
        vm.orderDir = _.get($scope.pageObject, 'params.orderDir', 'desc');
        vm.binField = _.get($scope.pageObject, 'params.binField');
        vm.orderField = _.get($scope.pageObject, 'params.orderField');
        vm.useCustom = _.get($scope.pageObject, 'params.useCustomCategories');
        vm.customBins = _.get($scope.pageObject, 'params.customCategories');
        vm.aggregates = _.get($scope.pageObject, 'viz.settings.dataSource.aggregate');
        vm.treeOptions = {
            beforeDrag: onBeforeDrag,
            beforeDrop: onBeforeDrop,
            dropped: onDropped,
            dragStart: function () { vm.dragging = true; },
            dragStop: function () { vm.dragging = false; }
        };
        vm.dragging = false;
        vm.loading = {};
        vm.initialized = {};
        vm.selectedIds = [];
        vm.selectedItems = [];
        vm.showOpenButton = _.get($scope.pageObject, 'params.openOnSelect', false) || _.get($scope.pageObject, 'params.routeSettings.enabled', false);

        vm.buildItemFromTemplate = buildItemFromTemplate;
        vm.selectItem = selectItem;
        vm.openItem = openItem;
        vm.addItem = vizKanbanService.addItem;

        var dataBound = false,
            checkedForDefaultFilter = false,
            fbUnwatchers = [],
            navFunctions = {
                getNext: viewNextRecord,
                getPrevious: viewPreviousRecord
            };

        // Initialize Controller
        init();

        $scope.$on('$destroy', function () {
            delete navFunctions.getNext;
            delete navFunctions.getPrevious;
            
            _.forEach(fbUnwatchers, function (unwatchFb) {
                unwatchFb();
            });
        });
        
        /////////////////////
        function init() {
            vm.dragEnabled = !!($scope.pageObject.params.allowCategoryChange || $scope.pageObject.params.allowSortChange);
            var itemDataSource = vizKanbanService.buildDataSource($scope.pageObject, $scope, vm.loading);

            vm.itemDataSource = itemDataSource;

            //Firebase
            watchFirebase(itemDataSource, _.get($scope.pageObject, 'viz.settings.dataSource.nim_viewId'), 'item');

            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, itemDataSource);

            if(!_.isEmpty(vm.binField)){
                vm.categoryDataSource = vizKanbanService.buildCategoryDataSource(vm.binField, vm.loading);

                if(vm.binField.isLookup){
                    watchFirebase(vm.categoryDataSource, vm.binField.viewId, 'category');
                }

                $scope.$watchGroup(['vm.categoryDataSource.data()', 'vm.itemDataSource.data()'], function (newData, oldData) {
                    var categories = newData[0],
                        items = newData[1],
                        oldItems = oldData[1];
                    
                    buildBins(categories, items);

                    if (!angular.equals(items, oldItems)) {
                        itemsChanged(items);
                    }
                });

                vm.categoryDataSource.read();
            }
            else {
                $scope.$watch('vm.itemDataSource.data()', function(items, oldItems){
                    buildBins([], items);

                    if (!angular.equals(items, oldItems)) {
                        itemsChanged(items);
                    }
                });
            }

            if(!$scope.pageObject.params.scrollable){
                $scope.$watch('vm.loading', function(loading){
                    if(!loading.item && !loading.category) {
                        resizeGridster();
                    }
                }, true);
            }
        }

        function watchFirebase(dataSource, viewId, dsId) {
            var refreshFunction = _.partial(refreshIfNotDragging, dataSource);
            var debounceOpts = { leading: true, trailing: true };
            var debouncedRefresh = _.debounce(refreshFunction, 5000, debounceOpts);
            var unwatchFb = $firebaseObject(fbUtil.ref('queries/' + viewId)).$watch(function(){
                if (!vm.initialized[dsId]) {
                    //Stops first firing of the event
                    $timeout(function() { vm.initialized[dsId] = true; });
                } else {
                    debouncedRefresh();
                }
            });

            fbUnwatchers.push(unwatchFb);
        }

        function refreshIfNotDragging(dataSource) {
            if (!vm.dragging) {
                _.result(dataSource, 'read');
            }
        }

        /**
         * Builds Kanban bins using values from data sources
         * @param categories - category values from lookup field
         * @param items - items pulled from query
         */
        function buildBins(categories, items){
            vm.bins = [];

            // Use custom categories if set
            var binCategories = vm.useCustom ? vm.customBins : categories;

            _.forEach(binCategories, function (binCategory) {
                var title = binCategory.title || binCategory.display;
                var displayValue = binCategory.display;
                var categoryId = binCategory.id;
                var titleClass = binCategory.titleClass || 'bg-default';

                if(vm.useCustom){
                    // If using custom categories and category data was pulled from
                    // the server, match the custom categories to their ids.
                    categoryId = findBinId(binCategory, categories);
                }

                var binData = vizKanbanService.filter(items, vm.binKey, displayValue, categoryId);

                if (vm.orderKey) {
                    binData = vizKanbanService.buildList(binData, vm.orderKey);
                }

                var bin = {
                    title: title,
                    category: displayValue,
                    titleClass: titleClass,
                    id: categoryId,
                    data: binData
                };

                bin.aggregate = vizKanbanService.binAggregate(vm.aggregates, bin.data);

                if(_.isEmpty(bin.data)){
                    bin.data = [{ _type: 'empty' }];
                }

                vm.bins.push(bin);
            });
        }

        function itemsChanged(items) {
            if (!checkedForDefaultFilter) {
                var params = $scope.pageObject.params,
                    filter = $scope.filters[params.filterId];
                
                if (params.asFilter && filter) {
                    if (!_.isEmpty(filter.filters)) {
                        _.forEach(filter.filters, function (f) {
                            if (f.value) {
                                var dataItem = _.find(items, 'id', f.value);

                                if (dataItem) {
                                    if (params.filterDisplay) {
                                        f.lookupDisplay = dataItem[params.filterDisplay];
                                    }
                                    else {
                                        f.dataItem = dataItem;
                                    }

                                    vm.selectedIds = [dataItem.id];
                                    vm.selectedItems = [dataItem];
                                }
                            }
                        });
                    }
                }
            }
            else if(vm.selectedIds.length){
                var updatedItem = _.find(items, 'id', vm.selectedIds[0]);
                
                if (updatedItem) {
                    vm.selectedItems[0] = updatedItem;
                }
                else {
                    vm.selectedIds = [];
                    vm.selectedItems = [];
                }
            } 

            applyFilter();
        }

        /**
         * Matches user-defined category to lookup category
         * @param customCategory
         * @param lookupCategories
         * @returns {*} - ID of matched lookup category
         */
        function findBinId(customCategory, lookupCategories){
            var match = _.find(lookupCategories, 'display', customCategory.display);
            if(match){
                return match.id;
            }
            return '';
        }

        function onBeforeDrag(sourceNodeScope) {
            return sourceNodeScope.$modelValue._type !== 'empty';
        }

        function onBeforeDrop(event) {
            if (event.source.nodeScope.$modelValue._type === 'empty') {
                return false;
            }

            var dataItem = event.source.nodeScope.$modelValue,
                // id = dataItem.id,
                sourceBin = dataItem[vm.binKey],
                destBin = event.dest.nodesScope.binModel.category,
                destBinId = event.dest.nodesScope.binModel.id,
                // sourceOrder = dataItem[vm.orderKey],
                destArr = event.dest.nodesScope.$modelValue,
                destIdx = event.dest.index,
                sourceArr = event.source.nodesScope.$modelValue,
                sourceIdx = event.source.index;

            // If no change return
            if (sourceBin === destBin && sourceIdx === destIdx) {
                // Removed redundant logic for selecting/opening item
                return true;
            }
            else if (!$scope.pageObject.params.allowCategoryChange && sourceBin !== destBin){
                $log.warn('Kanban: Category change not enabled for "' + $scope.pageObject.name + '"');
                return false;
            }
            else if(!$scope.pageObject.params.allowSortChange && sourceBin === destBin && sourceIdx !== destIdx){
                $log.warn('Kanban: Sort order change not enabled for "' + $scope.pageObject.name + '"');
                return false;
            }
            else {
                var updateData = {};

                // Set Order and Bin/Category
                if ($scope.pageObject.params.allowSortChange) {
                    if (!_.isEmpty(vm.orderField)) {
                        var oldPrevDataItem = sourceArr[sourceIdx - 1],
                            oldNextDataItem = sourceArr[sourceIdx + 1],
                            newPrevDataItem = destArr[destIdx],
                            newNextDataItem = destArr[destIdx + 1];
                        
                        if (sourceIdx > destIdx || sourceBin !== destBin) {
                            newPrevDataItem = destArr[destIdx - 1];
                            newNextDataItem = destArr[destIdx];
                        }
                        
                        vizKanbanService.addNextToUpdateData(updateData, vm.orderField, vm.orderKey, dataItem, newNextDataItem);
                        vizKanbanService.addNextToUpdateData(updateData, vm.orderField, vm.orderKey, newPrevDataItem, dataItem);
                        vizKanbanService.addNextToUpdateData(updateData, vm.orderField, vm.orderKey, oldPrevDataItem, oldNextDataItem);
                    }
                }

                if ($scope.pageObject.params.allowCategoryChange && sourceBin !== destBin) {
                    // item[vm.binKey] = destBin;

                    if (!_.isEmpty(vm.binField)) {
                        updateData[dataItem.id] = updateData[dataItem.id] || {};
                        updateData[dataItem.id][vm.binField.stateId] = updateData[dataItem.id][vm.binField.stateId] || {};

                        // Assumes the category is a lookup
                        updateData[dataItem.id][vm.binField.stateId][vm.binField.modelId] = {
                            display: destBin,
                            id: destBinId
                        };
                    }
                }

                _.forEach(updateData, function (recordData, instanceId) {
                    if (_.isEmpty(recordData)) {
                        delete updateData[instanceId];
                    }
                });

                // Resolve Promise
                if(!_.isEmpty(updateData)) {
                    vm.loading.item = true;
                    return vizKanbanService.updateItem(updateData).then(function () {
                        vm.loading.item = false;
                    }, function(){
                        vm.loading.item = false;
                    });
                }
                else {
                    return true;
                }
            }
        }

        function onDropped(event) {
            var sourceArr = event.source.nodesScope.$modelValue,
                destArr = event.dest.nodesScope.$modelValue;
            // Remove Empty Placeholder
            if (destArr.length > 1) {
                _.remove(destArr, '_type', 'empty');
            }
            // Add Empty placeholder
            if (sourceArr.length < 1) {
                var item = { _type: 'empty' };
                
                if (vm.orderKey) {
                    item[vm.orderKey] = 1;
                }
                
                sourceArr.push(item);
            }
        }

        function buildItemFromTemplate(dataItem){
            if(dataItem._type === 'empty'){
                var msg = 'Empty';
                if($scope.pageObject.params.allowCategoryChange) {
                    msg = 'Empty (drag here)';
                }

                return '<div class="empty"><em>' + msg + '</em></div>';
            }
            else {
                try {
                    var template = kendo.template($scope.pageObject.viz.settings.template);
                    var templateData = vizKanbanService.templateData(dataItem);
                    var html = template(templateData).replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&gt;/g, '>');

                    return vizKanbanService.stripMisplacedAttributes(html, templateData.onClick);
                }
                catch (e) {
                    $log.error(e);
                    return '';
                }
            }
        }

        function selectItem(item, eventType) {
            // Run this function on mousedown if drag is enabled or on click if drag is disabled
            if ((eventType == 'mousedown' && !vm.dragEnabled) || (eventType == 'click' && vm.dragEnabled)) {
                return;
            }

            // Do not select if this is an empty item
            if (item._type === 'empty') {
                return;
            }

            vm.selectedIds = [item.id];
            vm.selectedItems = [item];

            if ($scope.pageObject.params.asFilter) {
                applyFilter();
            }
        }

        function openItem(item, eventType, event) {
            // Run this function on mousedown if drag is enabled or on click if drag is disabled
            if ((eventType == 'mousedown' && !vm.dragEnabled) || (eventType == 'click' && vm.dragEnabled)) {
                return;
            }

            // Do not open/route if this is an empty item
            if (item._type === 'empty') {
                return;
            }
            if (eventType == 'mousedown' && vm.dragEnabled) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }

            // Opens Instance Window
            if($scope.pageObject.params.openOnSelect && item.id){
                vizKanbanService.viewRecord(item.id, $scope.pageObject, navFunctions);
            }

            // Opens Route
            var routeSettings = _.get($scope.pageObject.params, 'routeSettings', {});
            if (routeSettings.enabled && routeSettings.template) {
                var target = routeSettings.newTab ? '_blank' : '_self';
                VizUtilityService.openPageObjectRoute(routeSettings.template, item, target);
            }
        }

        function applyFilter() {
            var params = $scope.pageObject.params;
            if (params.asFilter && params.filterId) {
                if (!dataBound) {
                    dataBound = true;
                }
                else {
                    $timeout(function () {
                        var filters = _.map(vm.selectedItems, function (row) {
                            var dataItem = angular.copy(row),
                                filterObj = {
                                    field: '__nimColumn__',
                                    operator: 'eq',
                                    value: row.id
                                };

                            if (params.filterDisplay && dataItem) {
                                filterObj.lookupDisplay = dataItem[params.filterDisplay];
                            }
                            else if (dataItem) {
                                // For objects that will use the filter for default data
                                filterObj.dataItem = dataItem;
                            }

                            return filterObj;
                        });

                        $scope.filters[params.filterId] = {
                            logic: 'or',
                            filters: filters
                        };
                    });
                }
            }
        }

        function viewNextRecord(instanceController){
            var id = instanceController.instanceId,
                dataItem = vm.itemDataSource.get(id),
                categoryVal = dataItem[vm.binKey],
                category = _.find(vm.bins, 'category', categoryVal),
                data = category.data,
                index = data.indexOf(dataItem);

            if(index >= 0 && index < data.length - 1){
                var next = data[index + 1];
                instanceController.updateInstanceAttrs(next.id, 'read');
                instanceController.init();
            }
        }

        function viewPreviousRecord(instanceController){
            var id = instanceController.instanceId,
                dataItem = vm.itemDataSource.get(id),
                categoryVal = dataItem[vm.binKey],
                category = _.find(vm.bins, 'category', categoryVal),
                data = category.data,
                index = data.indexOf(dataItem);

            if(index > 0){
                var previous = data[index - 1];
                instanceController.updateInstanceAttrs(previous.id, 'read');
                instanceController.init();
            }
        }

        function resizeGridster() {
            if ($scope.resizeGridsterItem) {
                $timeout(function () {
                    $scope.resizeGridsterItem();
                }, 400);
            }    
        }
    }])
    .directive('nimVizKanban', function() {
        return {
            restrict: 'AE',
            templateUrl: 'core/pages/viz/kanban/kanban.tpl.html',
            scope: true,
            require: '^nimPageObject',
            controller: 'nimVizKanbanCtrl',
            controllerAs: 'vm'
        };
    })
;
angular.module('cerberus.core')
/**
 * @ngdoc service
 * @name vizKanbanService
 * @alias cerberus/core:vizKanbanService
 * @description Provides datasources and helpers kanban viz
 */
    .factory('vizKanbanService', ["_", "kendo", "$q", "$http", "$timeout", "InstancesService", "InstancesWindowService", "nimUtilityService", "pageObjectsService", "VizUtilityService", function vizKanbanService(_, kendo, $q, $http, $timeout,
                                                           InstancesService, InstancesWindowService, nimUtilityService,
                                                           pageObjectsService, VizUtilityService) {
        var service = {
            buildDataSource: buildDataSource,
            buildCategoryDataSource: buildCategoryDataSource,
            filter: filter,
            buildList: buildList,
            addNextToUpdateData: addNextToUpdateData,
            updateItem: updateItem,
            templateData: templateData,
            binAggregate: binAggregate,
            stripMisplacedAttributes: stripMisplacedAttributes,
            viewRecord: viewRecord,
            addItem: addItem
        };
        return service;
        ////////////////////

        /**
         * Builds dataSource for the Kanban
         * @param pageObject
         * @param scope
         * @param loading
         * @returns {kendo.data.DataSource}
         */
        function buildDataSource(pageObject, scope, loading) {
            var dataSourceOptions = {
                type: 'odata',
                transport: {
                    read: read
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                serverAggregates: false,
                serverGrouping: false,
                pageSize: 20,
                requestStart: function (e) {
                    if(!_.isEmpty(pageObject.params.requiredFilters)){
                        _.forEach(pageObject.params.requiredFilters, function(required, filter){
                            if(required && VizUtilityService.isFilterEmpty(scope.filters[filter])){
                                e.preventDefault();

                                $timeout(function(){
                                    e.sender.success({d:{results: [], __count: 0}});
                                });

                                return false;
                            }
                        });
                    }
                    
                    if (!e.isDefaultPrevented()) {
                        $timeout(function () {
                            loading.item = true;
                        });
                    }
                },
                requestEnd: function () {
                    $timeout(function () {
                        loading.item = false;
                    });
                },
                error: function () {
                    $timeout(function () {
                        loading.item = false;
                    });
                },
                change: function () {
                    var data = this.data();

                    _.forEach(data, function (dataItem) {
                        if (dataItem.__nimAttachments.length > 0) {
                            dataItem.file = dataItem.__nimAttachments[0];
                        }
                        else {
                            dataItem.file = { name: '' };
                        }
                    });

                    scope.mainPageObject.vizCtrl.data = data;
                }
            };

            var sortOptions = {
                sort: VizUtilityService.createSortArray(pageObject.viz.settings.dataSource)
            };

            var baseFilter = angular.copy(pageObject.viz.settings.dataSource.filter) || {
                filters: [],
                logic: 'and'
            };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: pageObject.params.filterLogic || 'and'
                }
            };

            // Extend any user-defined dataSource settings
            angular.extend(dataSourceOptions, pageObject.viz.settings.dataSource, sortOptions, filterOptions);

            // Adds parse function to make sure date fields are correct
            _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                if (field.type === 'date') {
                    field.parse = VizUtilityService.parseDateField;
                }
                else if (field.type === 'number') {
                    field.parse = VizUtilityService.parseNumberField;
                }
            });

            // Return new Datasource
            return new kendo.data.DataSource(dataSourceOptions);

            function read(options) {
                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);

                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }
        }

        function buildCategoryDataSource(binField, loading){
            var options = {
                requestStart: function () {
                    $timeout(function () {
                        loading.category = true;
                    });
                },
                requestEnd: function () {
                    $timeout(function () {
                        loading.category = false;
                    });
                },
                error: function () {
                    $timeout(function () {
                        loading.category = false;
                    });
                }
            };

            if(binField.isLookup){
                options = {
                    type:'odata',
                    transport: {
                        read: {
                            dataType: 'json',
                            url: '/server/rest/v1/views/' + binField.viewId + '/odata.svc?$lookupDisplay=' + binField.lookupCol,
                            beforeSend: VizUtilityService.setRequestHeaders
                        }
                    }
                };
            }
            else if(binField.isCustomLookup){
                options = {
                    type: 'odata',
                    transport: {
                        read: function(opt){
                            $http.get('/server/rest/v1/forms/' + binField.formId + '/objects/' + binField.modelId + '/options').then(function(result){
                                // Format the response data
                                var data = _.get(result, 'data.DATA.values', []);
                                opt.success({
                                    d: {
                                        results: data,
                                        __count: data.length
                                    }
                                });
                            }, function (reason) {
                                opt.error(reason);
                            });
                        }
                    }
                };
            }

            return new kendo.data.DataSource(options);
        }

        /**
         * Filters data items by category
         * @param items - Data items pulled from server 
         * @param key - Category column
         * @param binValue - Bin's display value
         * @param id - Bin id
         */
        function filter(items, key, binValue, id) {
            return items.filter(function (dataItem) {
                var categoryValue = dataItem[key];

                // Data item's category value is a lookup struct
                if (_.isObject(categoryValue)) {
                    // If bin id is provided, match the ids
                    if (id) {
                        return categoryValue.id == id;
                    }
                    
                    // First check if bin value matches id
                    var idMatchesDisplay = categoryValue.id == binValue;

                    // Then check if bin value matches display
                    if (!idMatchesDisplay) {
                        return categoryValue.display == binValue;
                    }                    

                    return idMatchesDisplay;
                }
                // If bin id provided, check category value against id
                else if (id && categoryValue == id) {
                    return true;
                }

                // Compare category value with bin's display value by default
                return categoryValue == binValue;
            });
        }

        // function calcOrder(initOrder, sourceIdx, destIdx, destArr, orderKey, dir) {
        //     var order = initOrder;
        //     // If empty destination array
        //     if (destArr.length === 0) {
        //         order = 1;
        //     }
        //     // Else populated array
        //     else {
        //         // If item was moved to the top
        //         if (destIdx === 0) {
        //             if (dir == 'asc') {
        //                 order = destArr[0][orderKey] - 1;
        //             }
        //             else {
        //                 order = destArr[0][orderKey] + 1;
        //             }    
        //         }
        //         // If item was moved to the bottom
        //         if (destIdx >= destArr.length - 1) {
        //             if (dir == 'asc') {
        //                 order = destArr[destArr.length - 1][orderKey] + 1;
        //             }
        //             else {
        //                 order = destArr[destArr.length - 1][orderKey] - 1;
        //             }    
        //         }
        //         // If item was moved within the array
        //         if (destIdx > 0 && destIdx < destArr.length - 1) {
        //             var max, min, diff;
        //             // This is some funky logic that must calculate the min the max based
        //             // on whether the item was moved up or down...
        //             if (sourceIdx > destIdx) {
        //                 if (dir == 'asc') {
        //                     min = destArr[destIdx - 1][orderKey] || 0;
        //                     max = destArr[destIdx][orderKey] || 0;
        //                 }
        //                 else {
        //                     max = destArr[destIdx - 1][orderKey] || 0;
        //                     min = destArr[destIdx][orderKey] || 0;
        //                 }
        //             }
        //             else {
        //                 if (dir == 'asc') {
        //                     min = destArr[destIdx][orderKey] || 0;
        //                     max = destArr[destIdx + 1][orderKey] || 0;
        //                 }
        //                 else {
        //                     max = destArr[destIdx][orderKey] || 0;
        //                     min = destArr[destIdx + 1][orderKey] || 0;
        //                 }
        //             }
        //             diff = max - min;

        //             // If no difference
        //             if(diff === 0) {
        //                 //order = min + 1;
        //                 order = min; // If put between two items of the same priority, should be assigned same priority
        //             }
        //             // If at least a whole number difference
        //             if (diff > 1) {
        //                 order = Math.floor(min) + 1;
        //             }
        //             // If fractional difference
        //             if (diff > 0 && diff <= 1) {
        //                 order = max === min ? min + 1 : (diff / 2) + min;
        //             }

        //         }
        //     }
        //     return order;
        // }

        function buildList(binData, key) {
            var orderedList = [];
            var unorderedList = _.map(binData, function (dataItem) { return new ListItem(dataItem, key); });
            
            for (var i = 0; i < unorderedList.length; i++){
                var listItem = unorderedList[i],
                    hasPrev = !!(_.find(unorderedList, 'next', listItem.id)),
                    nextItem = null;
                
                if (listItem.next !== listItem.id){
                    nextItem = _.find(unorderedList, 'id', listItem.next);
                }
                
                if (nextItem && !hasPrev) {
                    i = -1;
                    addToOtherArray(unorderedList, orderedList, listItem);
                    addNextListItem(orderedList, unorderedList, nextItem);
                }
                else if(!nextItem){
                    listItem.next = null;

                    if (!hasPrev) {
                        i--;
                        addToOtherArray(unorderedList, orderedList, listItem);
                    }
                }
            }

            return _.map(orderedList.concat(unorderedList), 'data');
        }

        function ListItem(record, key) {
            if (_.endsWith(key, '_display') && _.has(record, key.replace(/_display$/, ''))) {
                key = key.replace(/_display$/, '');
            }

            this.data = record;
            this.id = record.id;
            this.next = record[key] || null;

            if (_.isObject(this.next) && !_.isDate(this.next)) {
                this.next = this.next.id;
            }
        }

        function addNextListItem(orderedList, unorderedList, prevItem) {
            addToOtherArray(unorderedList, orderedList, prevItem);

            var nextItem = _.find(unorderedList, function (item) {
                return item.id == prevItem.next;
            });

            if (nextItem) {
                addNextListItem(orderedList, unorderedList, nextItem);
            }
            else {
                // Next item does not exist
                prevItem.next = null;
            }
        }

        function addToOtherArray(currentArray, otherArray, item) {
            _.pull(currentArray, item);
            otherArray.push(item);
        }

        function addNextToUpdateData(updateData, nextField, nextKey, dataItem, nextItem) {
            var nextValue = {};

            if (dataItem) {
                var id = dataItem.id,
                    stateId = nextField.stateId;
                
                updateData[id] = updateData[id] || {};
                updateData[id][stateId] = updateData[id][stateId] || {};
            
                if (nextItem) {
                    nextValue = {
                        display: nextItem[nextField.lookupCol],
                        id: nextItem.id
                    };
                }

                updateData[id][stateId][nextField.modelId] = nextValue;
                dataItem[nextKey] = nextValue.display || '';
            }
        }

        /**
         * Updates dataItem that has been moved
         * @param data
         * @returns {Promise}
         */
        function updateItem(data) {
            var promises = [];

            _.forEach(data, function (instanceData, instanceId) {
                if (instanceId) {
                    // If order and category are from different states, resolve revisions separately
                    _.forEach(instanceData, function (state, stateId) {
                        promises.push(InstancesService.update(instanceId, { currentStateId: stateId, recordData: state }));
                    });
                }    
            });  

            return $q.all(promises);
        }

        /**
         * Generates the object to use when compiling the kendo template
         * @param dataItem
         * @returns {Object}
         */
        function templateData(dataItem){
            var id = dataItem.id;

            return {
                data: dataItem,
                nim: nimUtilityService,
                ui: {
                    checkbox: '<input class="form-control nim-list-checkbox" type="checkbox" ng-checked="vm.itemSelected(' + id + ')" ng-model="selected" ng-click="vm.selectItem(' + id + ')" />',
                    infoButton: '<button class="btn btn-link" ng-click="vm.viewRecord(' + id + ')" title="More Info"><i class="fa fa-info-circle"></i></button>'
                },
                onClick: {
                    selectSingle: 'ng-click="vm.selectSingle(' + id + ')"',
                    viewAndSelect: 'ng-click="vm.viewAndSelect(' + id + ')"'
                }
            };
        }

        /**
         * Uses aggregate settings to create footer for bin
         * @param aggregateArray
         * @param data - bin items
         * @returns {string}
         */
        function binAggregate(aggregateArray, data){
            var aggregateItems = [],
                aggregateFormat = '<span class="padding-sm-r">{0}: {1}</span>';
            _.forEach(aggregateArray, function(aggregate){
                var value = '';
                switch(aggregate.aggregate){
                    case 'sum':
                        value = aggregateSum(data, aggregate.field);
                        break;

                    case 'count':
                        value = aggregateCount(data);
                        break;

                    case 'avg':
                    case 'average':
                        value = aggregateAverage(data, aggregate.field);
                        break;

                    default:
                        break;
                }

                if(aggregate.format){
                    value = kendo.format(aggregate.format, value);
                }

                aggregateItems.push(
                    kendo.format(aggregateFormat, aggregate.nimLabel, value)
                );
            });

            return aggregateItems.join('');
        }

        /**
         * Calculates sum aggregate
         * @param data
         * @param field - Value used for sum
         * @returns {number}
         */
        function aggregateSum(data, field){
            var sum = 0;

            _.forEach(data, function(dataItem){
                sum += _.get(dataItem, field, 0);
            });

            return sum;
        }

        /**
         * Calculates count aggregate
         * @param data
         * @returns {number}
         */
        function aggregateCount(data){
            var count = 0;

            _.forEach(data, function(dataItem){
                if (_.get(dataItem, '_type') !== 'empty') {
                    count++;
                }
            });

            return count;
        }

        /**
         * Calculates average aggregate
         * @param data
         * @param field - Value used for sum
         * @returns {number}
         */
        function aggregateAverage(data, field){
            var count = aggregateCount(data);

            if (count === 0) {
                return 0;
            }

            var sum = aggregateSum(data, field);

            return sum / count;
        }

        /**
         * If someone puts one of the onClick attributes outside of an html tag, this will remove it
         * @param listItem - compiled text for list item
         * @param onClickMap - contains the ng-click definitions in string form
         * @returns {string}
         */
        function stripMisplacedAttributes(listItem, onClickMap){
            var jqHTML = angular.element(listItem);

            // Text without the html tags
            var text = jqHTML.text();

            _.forEach(onClickMap, function(attr){
                // If one of the attributes was added outside of a tag, remove it
                if(text.indexOf(attr) >= 0){
                    // Couldn't get the stupid regex to work
                    listItem = listItem.split(attr).join('');
                }
            });

            return listItem;
        }

        /**
         * Opens record in instance window
         * @param instanceId
         * @param pageObject
         * @param navFunctions
         */
        function viewRecord(instanceId, pageObject, navFunctions) {
            InstancesWindowService.openWindow({
                action: 'read',
                widgetId: pageObject.viz.widgetId,
                instanceId: instanceId,
                title: pageObject.name,
                navFunctions: navFunctions
            });
        }

        function addItem(bin, field, pageObject){
            var defaultData = [{
                data: {
                    value: bin.id,
                    lookupDisplay: bin.category
                },
                field: field
            }];

            pageObjectsService.addCustomValuesToDefaultData(defaultData, pageObject.params.defaultValues);

            InstancesWindowService.openWindow({
                action: 'create',
                widgetId: pageObject.viz.widgetId,
                title: pageObject.name,
                defaultData: defaultData
            });
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizChartLineCtrl', ["_", "moment", "$scope", "VizChartService", "VizChartLineService", "VizUtilityService", "$firebaseObject", "fbUtil", "$timeout", function nimVizChartLineCtrl(_, moment, $scope, VizChartService, VizChartLineService, VizUtilityService, $firebaseObject, fbUtil, $timeout) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;
        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function () {
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function () { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        init();

        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function () {
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });


        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.chart) {
                $scope.chart.destroy();
                $scope.chart = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);

            // Fix any misconfigurations
            VizChartService.fixChartOptions(options);

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options);
            options.dataSource = vm.dataSource;

            VizChartService.setSeriesColors(options, $scope.pageObject.params);

            // Exposes options to view model
            vm.options = options;
            
            // Watch Filters
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartLineService
     * @alias cerberus/core:VizChartLineService
     * @description Provides functions for configuring line charts
     */
    .factory('VizChartLineService', function VizChartLineService(){
        return {
            //configLine: configLine
        };

        /**
         * This function dynamically adjusts certain parameters for the chart settings
         * @function configLine
         * @param {object} data
         * @param {object} options
         * function configLine(data, options) {}
         */

    })
;
angular.module('cerberus.core')
    .controller('ListUploadModalCtrl', ["_", "$scope", "$rootScope", "$timeout", "$q", "$uibModalInstance", "defaultData", "listPageObject", "draftsService", "InstancesService", "WidgetsService", function (_, $scope, $rootScope, $timeout, $q, $uibModalInstance, defaultData, listPageObject, draftsService, InstancesService, WidgetsService) {
        var vm = this;

        vm.widgetId = listPageObject.viz.widgetId;
        vm.filenameField = listPageObject.params.uploadFilename;
        vm.uploadImageField = listPageObject.params.uploadImageField;
        vm.formId = '';
        vm.formOriginId = '';
        vm.isProcessingUploads = false;
        vm.files = [];
        vm.draftIds = {};
        vm.recordData = {};
        vm.fileUploadOptions = {
            async:{
                saveUrl: '/Server/REST/v1/upload',
                removeUrl: 'remove',
                autoUpload: false,
                batch: false
            },
            localization: {
                dropFilesHere: 'Drop files here to start the upload.'
            },
            select: function (e) {
                vm.isProcessingUploads = true;
                e.sender.disable();
                var draftPromises = [];
                vm.files = e.files;
                _.forEach(e.files, function (file) {
                    var recordData = angular.copy(vm.defaultDataSet);

                    if (vm.filenameField) {
                        recordData[vm.filenameField.modelId] = file.name;
                    }

                    var d = {
                        widgetId: vm.widgetId,
                        recordData: recordData,
                        stateId: 1
                    };

                    vm.recordData[file.uid] = recordData;

                    var promise = draftsService.create(d);
                    
                    promise.then(function (value) {
                        vm.draftIds[file.uid] = value.draftId;
                    });

                    draftPromises.push(promise);
                });

                $q.all(draftPromises).then(function () {
                    e.sender.enable();
                    angular.element(".k-button.k-upload-selected").trigger('click');
                });
            },
            upload: function (e) {
                var file = e.files[0];
                e.data = {
                    formOriginId: vm.formOriginId,
                    formId: vm.formId,
                    widgetId: vm.widgetId
                };
                e.data.draftId = vm.draftIds[file.uid];

                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener("readystatechange", function () {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader('Authentication','Bearer ' + $rootScope.authToken);
                            xhr.setRequestHeader('WSID',$rootScope.userData.currentWorkspace.id);
                            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest ');
                        }
                    });
                }
            },
            success: function (e) {
                var itemData = e.response.DATA;
                var file = _.find(vm.files, 'name', itemData.name);
                if (file) {
                    var draftId = vm.draftIds[file.uid];
                    $timeout(function () {
                        // var form = vm.instance.workflowObjects[vm.activeState].model.forms[vm.selectedForm[vm.activeState]];
                        // form.fileAttachments = form.fileAttachments || [];
                        // itemData.disableClick = true;
                        // form.fileAttachments.push(itemData);
                        // if(!vm.temp[vm.activeState].nimupload){
                        //     vm.temp[vm.activeState].nimupload = [];
                        // }
                        vm.recordData[file.uid].nimupload.push(itemData.id + ',create');
                        if (vm.uploadImageField) {
                            vm.recordData[file.uid][vm.uploadImageField.modelId] = itemData.id;
                        }

                        InstancesService.createInstance({
                            widgetId: vm.widgetId,
                            draftId: draftId,
                            recordData: vm.recordData[file.uid],
                            current: vm.nextWorkflowState,
                            // recurrence: vm.instance.recurrence,
                            // ignoreSections: _sectionsIgnored(vm.instance.workflowObjects[state].model.forms, state)
                        });
                    });
                }    
            },
            complete: function () {
                $timeout(function () {
                    vm.isProcessingUploads = false;
                    $(".k-upload-files.k-reset").find("li").remove();
                    ok();
                });
            },
            cancel: function(){
                $timeout(function(){
                    vm.isProcessingUploads = false;
                });
            },
            error: function(){
                $timeout(function(){
                    vm.isProcessingUploads = false;
                });
            }
        };
        
        vm.ok = ok;
        vm.cancel = cancel;

        init();

        function init() {
            WidgetsService.getFirstState(vm.widgetId).then(function (data) { 
                var defaultDataSet = {};
                _.forEach(data.workflowObjects[1].model.forms, function (f) {
                    _.assign(defaultDataSet, f.defaultDataSet);

                    if (!vm.formId && _.get(f, 'form.settings.nimupload.enabled', false)) {
                        vm.formId = f.formId;
                        vm.formOriginId = f.originatorId;
                    }
                });

                if (defaultData) {
                    _.forEach(defaultData, function (item) {
                        var value = _.get(item, 'data.value');

                        if(item.field.isLookup || item.field.isCustomLookup){
                            value = {id: _.get(item, 'data.value')};

                            if(_.has(item, 'data.lookupDisplay')){
                                value.display = item.data.lookupDisplay;
                            }
                            // For table filters
                            else if(_.has(item, 'data.dataItem')){
                                value.display = _.get(item.data.dataItem, item.field.lookupCol);
                            }
                        }

                        defaultDataSet[item.field.modelId] = value;
                    });
                }

                vm.defaultDataSet = defaultDataSet;
                vm.nextWorkflowState = _.get(data.workflowObjects[1].model.to, 0, '');
            }, function () {
                vm.defaultDataSet = {};
            });
        }

        function ok() {
            $uibModalInstance.close();
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }
    }])
;
/* Templates:
   Photos - square with a transparent black bottom area with title and more info button and a checkbox (top left or bottom right?)
   Files - similar to photos but with a transparent bottom with no checkbox and the filename with a small info button
   Entry - full width with title, description, picture, and small info at very button; no vertical spacing
   Contact - http://www.google.com/design/spec/components/chips.html#chips-contact-chips

   Card Large- 320 x 320 card with picture on top and a white bottom for Title description
   Card Medium - 320 x 160 photo left, photo right and no photo variant
   Card Small - 160 x 160 photo top and no photo variants
    http://www.google.com/design/spec/components/cards.html#cards-content
 */

angular.module('cerberus.core')
    .controller('nimVizListCtrl',["_", "kendo", "$scope", "$log", "$timeout", "VizUtilityService", "VizListViewService", "$firebaseObject", "fbUtil", function nimVizListCtrl(_, kendo, $scope, $log, $timeout, VizUtilityService, VizListViewService, $firebaseObject, fbUtil) {
        var vm = this;
        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function () {
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function () { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            }),
            dataSource = VizListViewService.buildDataSource($scope.pageObject, $scope),
            navFunctions = {
                getNext: _.partialRight(VizListViewService.viewNextRecord, dataSource),
                getPrevious: _.partialRight(VizListViewService.viewPreviousRecord, dataSource)
            };

        vm.selectedItems = [];
        vm.selectedIds = [];

        vm.viewRecord = _.partialRight(VizListViewService.viewRecord, navFunctions);
        vm.itemSelected = itemSelected;
        vm.selectItem = selectItem;
        vm.selectSingle = selectSingle;
        vm.viewAndSelect = viewAndSelect;
        vm.uploadFiles = uploadFiles;

        init();        

        // Event Bindings
        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();

            if($scope.list) {
                $scope.list.refresh();
            }
            
            if ($scope.pager) {
                $scope.pager.refresh();
            }
        });

        $scope.$on('nim-viz-update-data', function(e, action, id/*, data*/){
            if(action === 'create'){
                // Nothing here, for now...
            }
            else if(action === 'update'){
                // Nothing here, for now...
            }
            else if(action === 'delete'){
                _.forEach(id, function (itemId) {
                    var dataItem = dataSource.get(itemId);
                    dataSource.remove(dataItem);
                });

                vm.selectedIds = [];
                vm.selectedItems = [];
                $scope.list.refresh();
            }
        });

        $scope.$on('list-source-changed', function(e, list){
            if(list == $scope.list){
                vm.data = list.dataSource.data();
                if(vm.selectedIds.length > 0) {
                    var selectedPageRows = [];
                    var pageData = list.dataSource.data();

                    _.forEach(pageData, function (dataItem) {
                        var selector = "div[data-uid=" + dataItem.uid + "]";
                        if(vm.selectedIds.indexOf(dataItem.id) >= 0){
                            selectedPageRows.push(selector);
                        }
                    });

                    $timeout(function () {
                        list.select(selectedPageRows.join(', '));
                    }, 1);
                }
            }
        });

        $scope.$on('$destroy', function () {
            delete navFunctions.getNext;
            delete navFunctions.getPrevious;

            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.list) {
                $scope.list.destroy();
                $scope.list = null;
            }
            if ($scope.pager) {
                $scope.pager.destroy();
                $scope.pager = null;
            }
        });

        function init() {
            vm.dataSource = dataSource;
            vm.options = {
                autoBind: false,
                columns: $scope.pageObject.viz.settings.columns,
                dataSource: dataSource,
                navigatable: true,
                template: function(dataItem){
                    try {
                        var template = kendo.template($scope.pageObject.viz.settings.template);
                        var templateData = VizListViewService.templateData(dataItem);
                        var html = template(templateData).replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&gt;/g, '>');
                        return VizListViewService.stripMisplacedAttributes(html, templateData.onClick);
                    }
                    catch(e){
                        $log.warn(e);
                        return '';
                    }
                },
                selectable: 'multiple',
                altTemplate: null,
                editTemplate: null,
                dataBound: resizeList
            };

            var pagerOptions = {
                dataSource: dataSource
            };

            if($scope.pageObject.params.pageable === true){
                vm.pagerOptions = pagerOptions;
            }
            else if($scope.pageObject.params.pageable){
                vm.pagerOptions = angular.extend(pagerOptions, $scope.pageObject.params.pageable);
            }
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, dataSource);
            $scope.mainPageObject.vizCtrl = vm;

            debouncedRefresh();
        }

        function applyFilter(){
            var params = $scope.pageObject.params;
            if($scope.list && params.asFilter && params.filterId){
                var filters = _.map(vm.selectedIds, function (id) {
                    return {
                        field: '__nimColumn__',
                        operator: 'eq',
                        value: id
                    };
                });
                
                $scope.filters[params.filterId] = {
                    logic: 'or',
                    filters: filters
                };
            }
        }

        function resizeList(){
            if ($scope.resizeGridsterItem) {
                $timeout(function () {
                    $scope.resizeGridsterItem();
                }, 1);
            }
        }

        function itemSelected(id){
            return vm.selectedIds.indexOf(id) >= 0;
        }
        
        function selectItem(id){
            var index = vm.selectedIds.indexOf(id);
            if(index >= 0){
                vm.selectedIds.splice(index, 1);
                vm.selectedItems.splice(index, 1);
            }
            else {
                vm.selectedIds.push(id);
                vm.selectedItems.push(dataSource.get(id));
            }
            applyFilter();
        }

        function selectSingle(id){
            vm.selectedIds = [id];
            vm.selectedItems = [dataSource.get(id)];
            applyFilter();
        }

        function viewAndSelect(id){
            vm.viewRecord(id);
            vm.selectSingle(id);
        }

        function uploadFiles() {
            VizListViewService.openUploadModal($scope.pageObject);
        }
    }])
    .directive('nimVizList', function() {
        return {
            restrict: 'AE',
            templateUrl: 'core/pages/viz/list/list.tpl.html',
            scope: true,
            require: '^nimPageObject',
            controller: 'nimVizListCtrl',
            controllerAs: 'vm'
        };
    })
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizListViewService
     * @alias cerberus/core:VizListViewService
     * @description Provides functions for configuring list (card) views
     */
    .factory('VizListViewService', ["_", "kendo", "$http", "$timeout", "$uibModal", "nimUtilityService", "VizUtilityService", "InstancesWindowService", function VizListViewService(_, kendo, $http, $timeout, $uibModal, nimUtilityService, VizUtilityService, InstancesWindowService){
        return {
            buildDataSource: buildDataSource,
            viewRecord: viewRecord,
            viewNextRecord: viewNextRecord,
            viewPreviousRecord: viewPreviousRecord,
            templateData: templateData,
            stripMisplacedAttributes: stripMisplacedAttributes,
            openUploadModal: openUploadModal
        };

        function buildDataSource(pageObject, scope){
            var dataSourceOptions = {
                type: 'odata',
                transport:{
                    read: read
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                serverAggregates: true,
                serverGrouping: false,
                pageSize: 20,
                requestStart: function (e) {
                    if (!_.isEmpty(pageObject.params.requiredFilters)) {
                        _.forEach(pageObject.params.requiredFilters, function (required, filter) {
                            if (required && VizUtilityService.isFilterEmpty(scope.filters[filter])) {
                                e.preventDefault();

                                $timeout(function () {
                                    e.sender.success({ d: { results: [], __count: 0 } });
                                });

                                return false;
                            }
                        });
                    }
                },
                change: function(e){
                    var data = e.sender.data();
                    _.forEach(data, function (dataItem) {
                        if(dataItem.__nimAttachments.length > 0){
                            dataItem.file = dataItem.__nimAttachments[0];
                        }
                        else{
                            dataItem.file = {name:''};
                        }
                    });
                    scope.vm.data = data;
                    scope.$emit('list-source-changed', scope.list);
                }
            };

            var sortOptions = {
                sort: VizUtilityService.createSortArray(pageObject.viz.settings.dataSource)
            };

            var baseFilter = angular.copy(pageObject.viz.settings.dataSource.filter) || {
                    filters: [],
                    logic: 'and'
                };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: pageObject.params.filterLogic || 'and'
                }
            };

            // Extend any user-defined dataSource settings
            angular.extend(dataSourceOptions, pageObject.viz.settings.dataSource, sortOptions, filterOptions);

            // Adds parse function to make sure date and number fields are correct
            _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                if(field.type === 'date') {
                    field.parse = VizUtilityService.parseDateField;
                }
                else if(field.type === 'number') {
                    field.parse = VizUtilityService.parseNumberField;
                }
            });

            // Return new Datasource
            return new kendo.data.DataSource(dataSourceOptions);

            function read(options) {
                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);
                
                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }
        }

        /**
         * Generates the object to use when compiling the kendo template
         * @param dataItem
         * @returns {Object}
         */
        function templateData(dataItem){
            var id = dataItem.id;

            return {
                data: dataItem,
                nim: nimUtilityService,
                ui: {
                    checkbox: '<input class="form-control nim-list-checkbox" type="checkbox" ng-checked="vm.itemSelected(' + id + ')" ng-model="selected" ng-click="vm.selectItem(' + id + ')" />',
                    infoButton: '<button class="btn btn-link" ng-click="vm.viewRecord(' + id + ')" title="More Info"><i class="fa fa-info-circle"></i></button>'
                },
                onClick: {
                    selectSingle: 'ng-click="vm.selectSingle(' + id + ')"',
                    viewAndSelect: 'ng-click="vm.viewAndSelect(' + id + ')"'
                }
            };
        }

        /**
         * If someone puts one of the onClick attributes outside of an html tag, this will remove it
         * @param listItem - compiled text for list item
         * @param onClickMap - contains the ng-click definitions in string form
         * @returns {string}
         */
        function stripMisplacedAttributes(listItem, onClickMap){
            var jqHTML = $(listItem);

            // Text without the html tags
            var text = jqHTML.text();

            _.forEach(onClickMap, function(attr){
                // If one of the attributes was added outside of a tag, remove it
                if(text.indexOf(attr) >= 0){
                    // Couldn't get the stupid regex to work
                    listItem = listItem.split(attr).join('');
                }
            });

            return listItem;

        }

        function viewRecord(instanceId, navFunctions) {
            InstancesWindowService.openWindow({
                action: 'read',
                instanceId: instanceId,
                navFunctions: navFunctions
            });
        }

        /**
         * Navigation function used to open next record from instance window
         * @param instanceController
         * @param dataSource
         */
        function viewNextRecord(instanceController, dataSource){
            var currentId = instanceController.instanceId,
                currentDataItem = dataSource.get(currentId),
                currentIndex = dataSource.indexOf(currentDataItem),
                currentPageSize = dataSource.data().length,
                nextItem;

            if(currentIndex >= 0) {
                if (currentIndex < currentPageSize - 1) {
                    nextItem = dataSource.at(currentIndex + 1);
                }

                if (nextItem) {
                    instanceController.updateInstanceAttrs(nextItem.id, 'read');
                    instanceController.init();
                }
            }
        }

        /**
         * Navigation function used to open previous record from instance window
         * @param instanceController
         * @param dataSource
         */
        function viewPreviousRecord(instanceController, dataSource){
            var currentId = instanceController.instanceId,
                currentDataItem = dataSource.get(currentId),
                currentIndex = dataSource.indexOf(currentDataItem),
                prevItem;

            if(currentIndex >= 0) {
                if (currentIndex > 0) {
                    prevItem = dataSource.at(currentIndex - 1);
                }

                if (prevItem) {
                    instanceController.updateInstanceAttrs(prevItem.id, 'read');
                    instanceController.init();
                }
            }
        }

        function openUploadModal(pageObject) {
            var modal = $uibModal.open({
                templateUrl: 'core/pages/viz/list/list-upload-modal.tpl.html',
                controller: 'ListUploadModalCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    listPageObject: _.constant(pageObject)
                }
            });

            return modal.result;
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizChartPieCtrl', ["_", "$scope", "VizChartService", "VizChartPieService", "VizUtilityService", "$firebaseObject", "fbUtil", "$timeout", function nimVizChartPieCtrl(_, $scope, VizChartService, VizChartPieService, VizUtilityService, $firebaseObject, fbUtil, $timeout) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;

        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function() { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        init();
        
        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.chart) {
                $scope.chart.destroy();
                $scope.chart = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);
            
            // Fix any misconfigurations
            VizChartService.fixChartOptions(options);

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options, VizChartPieService.configPie($scope.pageObject.params));
            options.dataSource = vm.dataSource;

            VizChartService.setSeriesColors(options, $scope.pageObject.params);

            // Exposes options to view model
            vm.options = options;

            // Watch Filters
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartPieService
     * @alias cerberus/core:VizChartPieService
     * @description Provides functions for configuring pie charts
     */
    .factory('VizChartPieService', ["_", function VizChartPieService(_){
        return {
            configPie: configPie
        };

        /**
         * This function dynamically adjusts certain parameters for the chart settings
         * @function configPie
         * @param {object} params
         */
        function configPie(params){
            return function(data, options){
                var displayNum = params.displayNum;
                if(displayNum && data.length > displayNum){
                    var valueField = options.series[0].field;

                    var categoryField = options.series[0].categoryField;
                    if(!categoryField){
                        categoryField = 'category';
                    }

                    var otherItems = data.splice(displayNum, data.length - displayNum);
                    var other = {};
                    other[categoryField] = 'Other';
                    other[valueField] = 0;
                    _.forEach(otherItems, function (item) {
                        var val = item[valueField];
                        if(val){
                            other[valueField] += val;
                        }
                    });

                    data.push(other);
                }
            };
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizMapCtrl', ["_", "$scope", "$timeout", "VizUtilityService", "LeafletDefaultsService", "VizMapService", "$firebaseObject", "fbUtil", function (_, $scope, $timeout, VizUtilityService, LeafletDefaultsService, VizMapService, $firebaseObject, fbUtil) {
        var vm = this;

        //Firebase
        var initialized = {},
            fbUnwatchers = [],
            dataSource = {},
            // debouncedRefresh = _.debounce(refresh, 5000, { leading: true, trailing: true });
            debouncedRefresh = {},
            delayedBoundsRefresh = _.debounce(function () {
                _.forEach(debouncedRefresh, function (fn) {
                    fn();
                });
            }, 1000);
        
        $scope.skipBoundsCheck = false;
        $scope.data = {};

        vm.bounds = null;
        vm.leafletId = $scope.pageObject.id;

        init();

        // Watchers
        $scope.$watch('vm.bounds', function (newValue, oldValue) {
            if ($scope.skipBoundsCheck) {
                $scope.skipBoundsCheck = false;
                return;
            }

            if (newValue && !angular.equals(newValue, oldValue)) {
                $timeout(delayedBoundsRefresh);
            }
        }, true);

        // Events
        $scope.$on('gridster-item-transition-end', function () {
            if($scope.map) {
                $scope.map.invalidateSize();
            }
        });

        $scope.$on('resize', function () {
            if($scope.map) {
                $scope.map.invalidateSize();
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            //Stop propagation
            event.preventDefault();

        });

        $scope.$on('nim-leaflet-popup-open', function(event, dataSourceId, instanceId){
            var filters = $scope.pageObject.params.filters;
            if(filters && filters[dataSourceId] && filters[dataSourceId].asFilter) {
                var filterSettings = filters[dataSourceId];
                $timeout(function(){
                    $scope.filters[filterSettings.id] = {
                        logic: 'or',
                        filters: [{
                            field: '__nimColumn__',
                            operator: 'eq',
                            value: instanceId,
                            id: instanceId
                        }]
                    };
                });
            }
        });

        $scope.$on('nim-leaflet-popup-close', function(event, dataSourceId, instanceId){
            var filters = $scope.pageObject.params.filters;
            if(filters && filters[dataSourceId] && filters[dataSourceId].asFilter) {
                var filterSettings = filters[dataSourceId];
                $timeout(function(){
                    var filter = $scope.filters[filterSettings.id];
                    if(filter && filter.filters.length && filter.filters[0].id === instanceId){
                        $scope.filters[filterSettings.id] = null;
                    }
                }, 1);
            }
        });

        $scope.$on('$destroy', function(){
            _.forEach(fbUnwatchers, function(unwatchFb){
                unwatchFb();
            });
        });

        function init() {
            var mapOptions = angular.copy($scope.pageObject.viz.settings.map);

            if ($scope.nimEditing === true) {
                mapOptions = angular.extend(mapOptions, {
                    dragging: false,
                    scrollWheelZoom: false
                });
            }

            vm.options = {
                basemaps: angular.copy($scope.pageObject.viz.settings.basemaps),
                overlays: angular.copy($scope.pageObject.viz.settings.overlays),
                map: mapOptions,
                controls: angular.copy($scope.pageObject.viz.settings.controls)
            };

            if (!vm.leafletId) {
                vm.leafletId = VizMapService.generateLeafletId();
            }

            // Build Data Sources
            _.forEach($scope.pageObject.viz.settings.dataSource, function (ds, id) {
                // Builds dataSource's color map by category
                var colorMap = {};
                _.forEach($scope.pageObject.viz.settings.groupColors[id], function (groupColor) {
                    if (groupColor.group && groupColor.color) {
                        colorMap[groupColor.group] = groupColor.color;
                    }
                });

                // Creates Kendo dataSource
                dataSource[id] = VizMapService.buildDataSource($scope, $scope.pageObject, vm.options, id, colorMap);

                // Subscribe to filters
                VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap[id], $scope, dataSource[id]);

                // Watch firebase
                if (ds.nim_viewId) {
                    debouncedRefresh[id] = _.debounce(_.partial(refresh, id), 5000, { leading: true, trailing: true });
                    
                    var unwatchFb = $firebaseObject(fbUtil.ref('queries/' + ds.nim_viewId)).$watch(function () {
                        if (!initialized[id]) {
                            //Stops first firing of the event
                            $timeout(function () {
                                initialized[id] = true;
                            });
                        } else {
                            debouncedRefresh[id]();
                        }
                    });

                    fbUnwatchers.push(unwatchFb);
                }
            });
        }

        function refresh(queryId) {
            dataSource[queryId].read();
        }
    }])
    .directive('nimVizMap', function() {
        return {
            restrict: 'AE',
            templateUrl: 'core/pages/viz/map/map.tpl.html',
            scope: true,
            require: '^nimPageObject',
            controller: 'nimVizMapCtrl',
            controllerAs: 'vm'
        };
    })
;
angular.module('cerberus.core')
/**
 * @ngdoc service
 * @name VizMapService
 * @alias cerberus/core:VizMapService
 * @description Provides functions for configuring viz maps
 */
    .factory('VizMapService', ["_", "kendo", "$http", "$timeout", "VizUtilityService", function(_, kendo, $http, $timeout, VizUtilityService){
        return {
            buildDataSource: buildDataSource,
            generateLeafletId: generateLeafletId
        };

        /**
         * Builds dataSource for map page object
         * @param scope
         * @param object - copy of original page object
         * @param mapOptions - leaflet options
         * @param id - dataSource/query ID
         * @param colorMap - map of color options for categories
         */
        function buildDataSource(scope, object, mapOptions, id, colorMap) {
            var initialDataRead = false; // Used to prevent zooming into points on initial load
            var oldPageFilter = null;
            var source = object.viz.settings.dataSource[id];
            var dataSourceOptions = {
                type: 'odata',
                transport: {
                    read: read
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                serverAggregates: true,
                serverGrouping: false,
                pageSize: 20,
                requestStart: function (e) {
                    var requiredFilters = _.get(object.params, ['requiredFilters', id], {});
                    if(!_.isEmpty(requiredFilters)){
                        _.forEach(requiredFilters, function(required, filter){
                            if(required && VizUtilityService.isFilterEmpty(scope.filters[filter])){
                                e.preventDefault();

                                $timeout(function(){
                                    e.sender.success({d:{results: [], __count: 0}});
                                });

                                return false;
                            }
                        });
                    }
                },
                change: change
            };

            var sortOptions = {
                sort: VizUtilityService.createSortArray(source)
            };

            var baseFilter = angular.copy(source.filter) || {
                filters: [],
                logic: 'and'
            };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: object.params.filterLogic || 'and'
                }
            };

            // Extend any user-defined dataSource settings
            angular.extend(dataSourceOptions, source, sortOptions, filterOptions);

            _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                if (field.type === 'date') {
                    field.parse = VizUtilityService.parseDateField;
                }
            });

            // Return new Datasource
            return new kendo.data.DataSource(dataSourceOptions);

            function read(options) {
                var filtered = false;
                if (options.data.filter && options.data.filter.filters) {
                    var pageFilter = _.find(options.data.filter.filters, 'pageFilter');
                    filtered = !!(pageFilter && !_.isEmpty(pageFilter.filters));
                }

                var httpOptions = VizUtilityService.buildBaseHttpOptions(object, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);

                httpOptions.params.$ds = id;
                httpOptions.params.$format = 'geoJson';

                var bounds = scope.$eval('vm.bounds');
                if (bounds && !filtered) {
                    var sw = bounds.getSouthWest(),
                        ne = bounds.getNorthEast(),
                        geoCol = source.schema.model.fields.location.from + '_nim_geometry';

                    httpOptions.params.$geoCol = 'bbox(' + geoCol + ',' + sw.lng + ',' + sw.lat + ',' + ne.lng + ',' + ne.lat + ')';
                }
                
                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }

            function change(e) {
                var data = e.sender.data().toJSON(),
                    filter = e.sender.filter(),
                    filtered = false,
                    columns = scope.pageObject.viz.settings.columns[id],
                    fields = source.schema.model.fields,
                    locationField = fields.location.from,
                    titleField = fields.title.from;

                scope.data[id] = angular.copy(data);
                    
                var otherColumns = _.reject(columns, function (c) {
                    return c.field === locationField || c.field === titleField;
                });

                // Additional fields to be listed in popup
                var otherFields = _.map(otherColumns, function (c) {
                    return {
                        title: c.title,
                        fieldName: c.field
                    };
                });

                // Check if page filter has been set
                var pageFilter = null;
                if (filter) {
                    pageFilter = _.find(filter.filters, 'pageFilter');
                    filtered = !!(pageFilter && !_.isEmpty(pageFilter.filters));
                }
                
                var markers = buildMarkers(data, fields, otherFields, colorMap);
                var hasOverlay = false;

                _.forEach(mapOptions.overlays, function (overlay) {
                    if (overlay.queryId == id) {
                        overlay.data = markers;
                        hasOverlay = true;
                    }
                });

                if (filtered && hasOverlay && !angular.equals(pageFilter, oldPageFilter) && initialDataRead) {
                    scope.skipBoundsCheck = true;
                    scope.$broadcast('nim-map-layer-filtered', markers);
                }
                oldPageFilter = pageFilter;
                initialDataRead = true;
            }
        }

        function buildMarkers(data, fields, otherFields, colorMap) {
            var titleField = fields.title.from,
                categoryField = fields.category.from,
                locationField = fields.location.from,
                markers = [];
            
            _.forEach(data, function (dataItem) {
                var geometry = _.get(dataItem.properties[locationField], 'geometry');
                if (geometry) {
                    var newMarker = {
                        geometry: geometry,
                        properties: {
                            title: dataItem.properties[titleField],
                            markerColor: colorMap[dataItem.properties[categoryField]] || colorMap['_default'],
                            id: dataItem.properties.id
                        },
                        type: dataItem.type
                    };

                    _.forEach(otherFields, function (otherField) {
                        var property = dataItem.properties[otherField.fieldName];
                        if (fields[otherField.fieldName].type === 'location') {
                            if (property) {
                                newMarker.properties[otherField.title] = property.properties.formatted_address;
                            }
                            else {
                                newMarker.properties[otherField.title] = dataItem.properties.formatted_address;
                            }
                        }
                        else if (fields[otherField.fieldName].type === 'date') {
                            newMarker.properties[otherField.title] = VizUtilityService.parseDateField(property);
                        }
                        else {
                            newMarker.properties[otherField.title] = property;
                        }
                    });

                    markers.push(newMarker);
                }
            });

            return markers;
        }
        
        function generateLeafletId() {
            return _.uniqueId('temp_leaflet_id_');
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizProgressCtrl',["_", "$scope", "$timeout", "VizUtilityService", "VizProgressService", "$firebaseObject", "fbUtil", function(_, $scope, $timeout, VizUtilityService, VizProgressService, $firebaseObject, fbUtil) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;

        vm.value = 0;
        vm.percent = 0;

        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function() { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        // Init
        init();

        // Event Bindings
        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            if($scope.progress) {
                debouncedRefresh();
            }
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.progress) {
                $scope.progress.destroy();
                $scope.progress = null;
            }
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);

            vm.dataSource = VizProgressService.buildDataSource($scope.pageObject, $scope, options);
            vm.options = options;

            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }
    }])
    .directive('nimVizProgress', function() {
        return {
            restrict: 'AE',
            templateUrl: 'core/pages/viz/progress/progress.tpl.html',
            scope: true,
            require: '^nimPageObject',
            controller: 'nimVizProgressCtrl',
            controllerAs: 'vm'
        };
    })
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizProgressService
     * @alias cerberus/core:VizProgressService
     * @description Provides functions for configuring progress bars
     */
    .factory('VizProgressService', ["_", "kendo", "$http", "$timeout", "VizUtilityService", function VizProgressService(_, kendo, $http, $timeout, VizUtilityService){
        return {
            buildDataSource: buildDataSource
        };

        function buildDataSource(pageObject, scope, progressOptions) {
            var dataSourceOptions = {
                type: 'odata',
                transport: {
                    read: read
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                serverAggregates: true,
                serverGrouping: false,
                requestStart: function (e){
                    if(!_.isEmpty(pageObject.params.requiredFilters)){
                        _.forEach(pageObject.params.requiredFilters, function(required, filter){
                            if(required && VizUtilityService.isFilterEmpty(scope.filters[filter])){
                                e.preventDefault();

                                $timeout(function(){
                                    e.sender.success({d:{results: [], __count: 0}});
                                });

                                return false;
                            }
                        });
                    }
                },
                change: function(e){
                    var field = '';
                    _.forEach(e.sender.aggregate(), function (aggregate) {
                        if (aggregate.aggregate == 'sum') {
                            field = aggregate.field;
                            return false;
                        }
                    });
                    
                    var value = _.get(e.sender.aggregates(), [field, 'sum'], 0);

                    scope.mainPageObject.vizCtrl.data = e.sender.data();
                    scope.mainPageObject.vizCtrl.value = value;
                    scope.mainPageObject.vizCtrl.percent = calculatePercentage(value, progressOptions.min, progressOptions.max);

                    if (scope.progress) {
                        scope.progress.value(value);
                    }
                    else {
                        progressOptions.value = value;
                    }
                }
            };

            var sortOptions = {
                sort: VizUtilityService.createSortArray(progressOptions.dataSource)
            };

            var baseFilter = angular.copy(pageObject.viz.settings.dataSource.filter) || {
                    filters: [],
                    logic: 'and'
                };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: pageObject.params.filterLogic || 'and'
                }
            };

            // Extend any user-defined dataSource settings
            if(progressOptions && progressOptions.dataSource) {
                angular.extend(dataSourceOptions, progressOptions.dataSource, sortOptions, filterOptions);
            }

            // Adds parse function to make sure date fields are correct

            _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                if(field.type === 'date') {
                    field.parse = VizUtilityService.parseDateField;
                }
            });

            // Return new Datasource
            return new kendo.data.DataSource(dataSourceOptions);

            function read(options) {
                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);

                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }
        }

        function calculatePercentage(value, min, max) {
            return parseInt(100 * (value - min) / (max - min));
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizChartScatterCtrl', ["_", "$scope", "VizChartService", "VizChartScatterService", "VizUtilityService", "$firebaseObject", "fbUtil", "$timeout", function nimVizChartScatterCtrl(_, $scope, VizChartService, VizChartScatterService, VizUtilityService,$firebaseObject, fbUtil, $timeout) {
        var vm = this;
        $scope.mainPageObject.vizCtrl = vm;
        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
            if (initializing) {
                //Stops first firing of the event
                $timeout(function() { initializing = false; });
            } else {
                debouncedRefresh();
            }
            });
        
        init();

        // Event Bindings
        var removeChartSizeWatcher = angular.noop;
        $scope.$on('kendoWidgetCreated', function (event, widget) {
            if (widget === $scope.chart) {
                event.preventDefault();
                event.stopPropagation();

                var debouncedResizeFunc = _.debounce(function () {
                    widget.resize();
                }, 400, { leading: true, trailing: true });
                removeChartSizeWatcher = $scope.$watch(function(){
                    return widget.wrapper.width();
                }, debouncedResizeFunc);
            }
        });

        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
            debouncedRefresh();
        });

        $scope.$on('$destroy', function () {
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.chart) {
                $scope.chart.destroy();
                $scope.chart = null;
            }

            removeChartSizeWatcher();
        });

        function init() {
            var options = angular.copy($scope.pageObject.viz.settings);
            
            // Fix any misconfigurations
            VizChartService.fixChartOptions(options);

            // Ensure that autoBind is set to false to prevent multiple server calls
            // We want to manually bind the data because some options will depend on the server's response
            // See the dataSource.fetch() callback function
            options.autoBind = false;

            vm.dataSource = VizChartService.buildDataSource($scope.pageObject, $scope, options);
            options.dataSource = vm.dataSource;

            VizChartService.setSeriesColors(options, $scope.pageObject.params);

            // Exposes options to view model
            vm.options = options;

            // Watch Filters
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, vm.dataSource);
        }
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizChartScatterService
     * @alias cerberus/core:VizChartScatterService
     * @description Provides functions for configuring scatter charts
     */
    .factory('VizChartScatterService', function VizChartScatterService(){
        return {
            //configScatter: configScatter
        };

        /**
         * This function dynamically adjusts certain parameters for the chart settings
         * @function configScatter
         * @param data
         * @param options
         *  function configScatter(data, options){
         *   // No extra config needed, for now
         *  }
         */

    })
;
angular.module('cerberus.core')
    .controller('nimVizScheduleCtrl', ["_", "moment", "ics", "kendo", "$scope", "$rootScope", "$log", "$timeout", "$window", "$element", "$firebaseObject", "fbUtil", "nimUtilityService", "VizScheduleService", function(_, moment, ics, kendo, $scope, $rootScope, $log, $timeout, $window, $element, $firebaseObject, fbUtil, nimUtilityService, VizScheduleService) {
        var vm = this;

        $scope.mainPageObject.vizCtrl = vm;
        $scope.dragging = false;

        vm.selectedEvents = [];
        vm.selectedIds = [];
        vm.exportICS = exportICS;

        //Firebase
        var initObj = {},
            fbUnwatchers = [],
            templates = $scope.pageObject.params.eventTemplates || {},
            navFunctions = {
                getNext: getNext,
                getPrevious: getPrevious
            };

        init();

        // Event Bindings
        var removeHeightWatcher = angular.noop;
        var removeWidthWatcher = angular.noop;
        $scope.$on("kendoWidgetCreated", function (e, widget) {
            e.preventDefault();
            e.stopPropagation();
            // $scope.dataSource.read();

            // Re-render widget when size changes
            // Necessary to prevent bug when selecting dates
            var resizeTimeout;
            removeHeightWatcher = $scope.$watch(function () {
                return widget.element.height();
            }, function (size, oldSize) {
                if (size != oldSize || !resizeTimeout) {
                    if (resizeTimeout) {
                        $timeout.cancel(resizeTimeout);
                    }
                    // Refreshes
                    resizeTimeout = $timeout(function () {
                        // refresh(widget);
                        resizeGridster();
                    }, 400);
                }
            });
            removeWidthWatcher = $scope.$watch(function () {
                return widget.element.width();
            }, function (size, oldSize) {
                if (size != oldSize) {
                    widget.resize();
                }
            });
            
            widget.dataSource.read();
        });

        $scope.$on('nim-viz-update-data', function(e, action, id){
            if (action === 'delete') {
                _.forEach(id, function (instanceId) {
                    var dataItem = $scope.dataSource.get(instanceId);

                    if(dataItem) {
                        $scope.dataSource.remove(dataItem);
                    }
                });
                
                vm.selectedIds = [];
                vm.selectedEvents = [];
            }
        });

        $scope.$on('$destroy', function () {
            delete navFunctions.getNext;
            delete navFunctions.getPrevious;

            _.forEach(fbUnwatchers, function (unwatchFb) {
                unwatchFb();
            });
        });

        $scope.$on('nim-remove-page-objects', function () {
            if ($scope.schedule) {
                $scope.schedule.destroy();
                $scope.schedule = null;
            }

            removeHeightWatcher();
        });

        function init() {
            // Firebase watchers
            _.forEach($scope.pageObject.viz.settings.dataSource, function (source, pgDs) {
                initObj[pgDs] = true;

                var unwatchFb = $firebaseObject(fbUtil.ref('queries/' + source.nim_viewId)).$watch(firebaseRefresh(pgDs));
                fbUnwatchers.push(unwatchFb);

                if (!templates[pgDs]) {
                    templates[pgDs] = '#: data.title #';
                }
            });

            // Data Source
            $scope.dataSource = VizScheduleService.buildDataSource($scope, $scope.pageObject);
            
            // Scheduler options
            var options = angular.copy($scope.pageObject.viz.settings);
            _.assign(options, {
                autoBind: false,
                dataSource: $scope.dataSource,
                editable: {
                    confirmation: false,
                    create: _.get($scope.pageObject.params, 'createOnClick', true),
                    destroy: false,
                    move: $scope.pageObject.params.allowMove,
                    resize: $scope.pageObject.params.allowMove,
                    update: false
                },
                selectable: $scope.pageObject.params.openOnSelect || $scope.pageObject.tools.delete,
                workDayStart: toDate(options.workDayStart, '2013/6/6 08:00 AM'),
                workDayEnd: toDate(options.workDayEnd, '2013/6/6 05:00 AM'),
                add: addHandler,
                allDayEventTemplate: eventTemplate,
                change: eventSelect,
                dataBound: dataBoundHandler,
                eventTemplate: eventTemplate,
                moveStart: dragHandler,
                moveEnd: moveEndHandler,
                navigate: navigateHandler,
                resizeStart: dragHandler,
                resizeEnd: moveEndHandler
            });

            if ($scope.pageObject.viz.settings.resources) {
                // Creates flat array of all colors specified by user
                var colors = [];
                _.forEach($scope.pageObject.viz.settings.resources, function (resource) {
                    colors.push({
                        color: resource.defaultColor
                    });

                    _.forEach(resource.dataSource, function (resItem) {
                        if (_.isBoolean(resItem.value)) {
                            resItem.value += '';
                        }

                        colors.push({
                            color: resItem.color
                        });
                    });
                });

                // Scheduler checks this to determine what color to use when rendering events
                options.resources = [{
                    field: '__color',
                    dataValueField: 'color',
                    dataSource: colors
                }];
            }

            // Expose Options to Scope
            vm.options = options;
        }

        function dataBoundHandler(e) {
            if($scope.pageObject.params.openOnSelect){
                e.sender.element.find('.k-event')
                    .click(function(jqEvent){
                        var uid = angular.element(jqEvent.currentTarget).data('uid');
                        var dataItem = e.sender.dataSource.getByUid(uid);

                        VizScheduleService.viewRecord(dataItem.id, navFunctions);
                    });
            }
        }

        function eventSelect(e){
            e.preventDefault();

            vm.selectedEvents = e.events;
            vm.selectedIds = _.map(e.events, function(ev){
                // If this event is recurring, the recurrenceId will be used as the instanceId
                return _.isUndefined(ev.recurrenceId) ? ev.id : ev.recurrenceId;
            });
        }

        function navigateHandler(e) {
            // Reloads data when view changes
            if (e.action === 'changeView' || e.action === 'next' || e.action === 'previous') {
                $timeout(function () {
                    $scope.$broadcast('nim-viz-reload');
                    //e.sender.dataSource.read();
                });
             }

            // Resizes gridster when user changes view or work day hours
            // Note: action "changeWorkDay" is undocumented for some reason
            if (e.action === 'changeView' || e.action === 'changeWorkDay') {
                resizeGridster();
            }

            // When user switches to day view, scroll to current time 
            if(e.action === 'changeView') {
                $timeout(function () {
                    if (e.view === 'day') {
                        var element = e.sender.element;
                        if (element) {
                            var currentTime = element.find('.k-current-time');
                            if (currentTime.length) {
                                var top = currentTime.offset().top;
                                element.parents('#page-content').scrollTop(top - 56);
                            }
                        }
                    }
                }, 400);
            }
        }

        function dragHandler() {
            $scope.dragging = true;
        }

        var movingEvent = false;
        function moveEndHandler(e) {
            $scope.dragging = false;
            if (movingEvent || !e.event || !e.sender.dataSource.getByUid(e.event.uid)) {
                e.preventDefault();
                return;
            }

            movingEvent = true;

            try {
                var dataItem = e.sender.dataSource.get(e.event.id);
                var sourceId = dataItem.__sourceId;
                var ds = $scope.pageObject.viz.settings.dataSource[sourceId];
                var updateData = {};
                var startField = $scope.pageObject.params.startDateField,
                    endField = $scope.pageObject.params.endDateField,
                    localStart = toLocal(e.start),
                    localEnd = toLocal(e.end);
                //endMoment = moment(localEnd);

                //if(endMoment.hours() === 0 && endMoment.minutes() === 0 && endMoment.seconds() === 0){
                //    endMoment.subtract(1, 's');
                //    localEnd = endMoment.toDate();
                //}

                if (ds.nim_widgetId) {
                    startField = _.get(ds, 'secondaryFieldMap.startDateField');
                    endField = _.get(ds, 'secondaryFieldMap.endDateField');
                }

                if (startField) {
                    updateData[startField.stateId] = updateData[startField.stateId] || {};
                    updateData[startField.stateId][startField.modelId] = localStart;
                }

                if (endField) {
                    updateData[endField.stateId] = updateData[endField.stateId] || {};
                    updateData[endField.stateId][endField.modelId] = localEnd;
                }

                if (!_.isEmpty(updateData)) {
                    dataItem.start = localStart;
                    dataItem.end = localEnd;
                    refresh(e.sender);

                    VizScheduleService.updateItem(e.event.id, updateData).then(function () {
                        movingEvent = false;

                        e.event.start = localStart;
                        e.event.end = localEnd;
                        refresh(e.sender);
                    }, function () {
                        movingEvent = false;
                    });
                }
                else {
                    movingEvent = false;
                    e.preventDefault();
                }
            }
            catch (ex) {
                $log.error(ex);
                movingEvent = false;
            }
        }

        // Handles adding new record when user double-clicks date/time on calendar
        function addHandler(e){
            // Stop Kendo from using its own window for data creation
            e.preventDefault();

            var defaultData = [],
                startDateField = $scope.pageObject.params.startDateField,
                endDateField = $scope.pageObject.params.endDateField;

            if (startDateField) {
                var startValue = e.event.start;

                if(e.sender.viewName() == 'month'){
                    startValue = moment(startValue).hour(11).toDate();
                }

                defaultData.push({
                    data: {
                        value: startValue
                    },
                    field: startDateField
                });
            }

            if(endDateField){
                var endValue = e.event.end;

                if(e.sender.viewName() == 'month'){
                    endValue = moment(endValue).hour(12).toDate();
                }

                defaultData.push({
                    data: {
                        value: endValue
                    },
                    field: endDateField
                });
            }

            VizScheduleService.createRecord($scope.pageObject, defaultData);
        }

        function exportICS(){
            var cal = ics();

            _.forEach($scope.schedule.data(), function(event){
                // addEvent REQUIRES the following arguments:
                var title = event.title || '(Untitled)',    // @param {string} subject     Subject/Title of event
                    description = event.description || '',  // @param {string} description Description of event
                    location = '',                          // @param {string} location    Location of event
                    begin = event.start,                    // @param {string} begin       Beginning date of event
                    stop = event.end,                       // @param {string} stop        Ending date of event
                    before = '',
                    unit = '';
                
                if ($scope.pageObject.params.setReminders){
                    before = $scope.pageObject.params.reminderBeforeAmount || 0;
                    unit = $scope.pageObject.params.reminderBeforeUnit || 'M';
                }

                cal.addEvent(title, description, location, begin, stop, before, unit);
            });

            if (cal.events().length > 0) {
                var content = cal.calendar();
                var blob = new Blob([content], {type: "text/plain;charset=utf-8"});

                $window.saveAs(blob, $scope.pageObject.name + '.ics');
            }
        }

        // Fix for kendo scheduler directive consistently assigning the wrong text color
        function eventTemplate(dataItem){
            var textColor = '#ffffff',
                eventContent = dataItem.title || '',
                template = templates[dataItem['__sourceId']] || '#: data.title #',
                user = $rootScope.userData;

            if(dataItem.__color) {
                var color = kendo.parseColor(dataItem.__color);
                if (color) {
                    // Taken from kendo code
                    var brightness = Math.sqrt(0.241 * color.r * color.r + 0.691 * color.g * color.g + 0.068 * color.b * color.b);

                    if (brightness >= 180) {
                        textColor = '#555555';
                    }
                }
            }

            var compileData = {
                data: defaultPropsToBlank(dataItem),
                nim: nimUtilityService,
                user: {
                    firstName: user.firstName,
                    lastName: user.lastName,
                    fullName: user.firstName + ' ' + user.lastName
                }
            };

            try {
                eventContent = kendo.template(template)(compileData);
            }
            catch(e){
                $log.warn(e);
            }

            return '<div style="height:100%;position:relative;color:' + textColor + '">' + eventContent + '</div>';
        }

        /**
         * Sets null values in dataItem to empty string
         * @param dataItem
         */
        function defaultPropsToBlank(dataItem){
            var newDataItem = {};

            _.forEach(dataItem, function(value, field){
                if(value == null){
                    newDataItem[field] = '';
                }
                else {
                    newDataItem[field] = value;
                }
            });

            return newDataItem;
        }

        function toLocal(date){
            // Eliminates UTC offset so time sent to server is consistent with time selected on calendar
            var m = moment.utc(date);
            m.local();
            return m.toDate();
        }

        function resizeGridster(){
            if ($scope.resizeGridsterItem) {
                $timeout(function () {
                    $scope.resizeGridsterItem();
                }, 10);
            }
        }

        function toDate(value, defaultVal){
            if(_.isDate(value)){
                return value;
            }
            else if(_.isString(value)){
                return new Date(value);
            }

            return new Date(defaultVal);
        }

        function refresh(scheduler) {
            var view = scheduler.viewName();

            if (view && scheduler.element) {
                scheduler.view(view);
            }
        }

        function firebaseRefresh(dsId){
            return function() {
                if (initObj[dsId]) {
                    //Stops first firing of the event
                    $timeout(function () {
                        initObj[dsId] = false;
                    });
                } else {
                    reloadIfNotDragging();
                }
            };
        }

        function reloadIfNotDragging() {
            if (!$scope.dragging) {
                $timeout(function () {
                    $scope.$broadcast('nim-viz-reload');
                });
            }
        }

        function getPrevious(instanceController){
            var currentId = instanceController.instanceId,
                currentDataItem = $scope.dataSource.get(currentId),
                currentIndex = $scope.dataSource.indexOf(currentDataItem),
                prevItem;

            if(currentIndex >= 0) {
                if (currentIndex > 0) {
                    prevItem = $scope.dataSource.at(currentIndex - 1);
                }

                if (prevItem) {
                    instanceController.updateInstanceAttrs(prevItem.id, 'read');
                    instanceController.init();
                }
            }
        }

        function getNext(instanceController){
            var currentId = instanceController.instanceId,
                currentDataItem = $scope.dataSource.get(currentId),
                currentIndex = $scope.dataSource.indexOf(currentDataItem),
                currentPageSize = $scope.dataSource.data().length,
                nextItem;

            if(currentIndex < currentPageSize - 1){
                nextItem = $scope.dataSource.at(currentIndex + 1);
            }

            if(nextItem){
                instanceController.updateInstanceAttrs(nextItem.id, 'read');
                instanceController.init();
            }
        }
    }])
    .directive('nimVizSchedule', function() {
        return {
            restrict: 'AE',
            templateUrl: function(tElement, tAttributes){
                if (tAttributes.subType) {
                    if (tAttributes.template) {
                        return 'core/pages/viz/' + tAttributes.subType + '/schedule-' + tAttributes.subType + '-' + tAttributes.template + '.tpl.html';
                    }
                    else {
                        return 'core/pages/viz/' + tAttributes.subType + '/schedule-' + tAttributes.subType + '.tpl.html';
                    }
                }
                else {
                    return 'core/pages/viz/schedule/schedule.tpl.html';
                }
            },
            scope: true,
            require: '^nimPageObject',
            controller: '@',
            name: 'controllerName',
            controllerAs: 'vm'
        };
    })
;

angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizScheduleService
     * @alias cerberus/core:VizScheduleService
     * @description Provides functions for configuring schedulers
     */
    .factory('VizScheduleService', ["_", "kendo", "moment", "$timeout", "$http", "$q", "pageObjectsService", "VizUtilityService", "InstancesService", "InstancesWindowService", function VizScheduleService(_, kendo, moment, $timeout, $http, $q,
        pageObjectsService, VizUtilityService, InstancesService, InstancesWindowService) {
        return {
            buildDataSource: buildDataSource,
            configSchedule: configSchedule,
            viewRecord: viewRecord,
            createRecord: createRecord,
            updateItem: updateItem
        };

        /**
         * Builds main dataSource for schedule page object
         * @param scope
         * @param pageObject
         * @returns {kendo.data.SchedulerDataSource}
         */
        function buildDataSource(scope, pageObject) {
            var sourcesCreated = false;
            var sources = [],
                ids = [];

            var dataSourceOptions = {
                transport: {
                    read: function (options) {
                        var data = [];

                        if (!sourcesCreated) {
                             sourcesCreated = true;

                             for(var id in pageObject.viz.settings.dataSource){
                                 if(pageObject.viz.settings.dataSource.hasOwnProperty(id)) {
                                     var newSource = buildSubDataSource(scope, pageObject, id);
                                     VizUtilityService.subscribeToPageFilters(_.get(pageObject.filterMap, id, {}), scope, newSource);
                                     sources.push(newSource);
                                     ids.push(id);
                                 }
                             }
                        }
                        
                        _.forEach(sources, function (source, index) {
                            var subData = source.data().toJSON();
                            data = data.concat(subData);

                            _.forEach(subData, function (dataItem) {
                                dataItem['__sourceId'] = ids[index];
                            });
                        });

                        data.sort(byDate('end')).sort(byDate('start'));

                        options.success(data);
                    }
                },
                change: function (e) {
                    var data = e.sender.data();

                    if (scope.schedule) {
                        // Adjust and set options
                        configSchedule(data);
                    }

                    scope.data = data;
                    scope.mainPageObject.vizCtrl.data = data;
                }
            };

            // Read from sub-data-sources on refresh
            var debouncedRefresh = _.debounce(function () {
                _.forEach(sources, function (s) {
                    s.read();
                });
            }, 5000, { leading: true, trailing: true });

            scope.$on('nim-viz-reload', function (event) {
                event.preventDefault();
                debouncedRefresh();
            });

            return new kendo.data.SchedulerDataSource(dataSourceOptions);
        }

        /**
         * Builds child dataSource for schedule page object
         * @param scope
         * @param pageObject
         * @param id - data source ID
         * @returns {kendo.data.SchedulerDataSource}
         */
        function buildSubDataSource(scope, pageObject, dsid) {
            var source = pageObject.viz.settings.dataSource[dsid];
            var dataSourceOptions = {
                type: 'odata',
                transport: {
                    read: read
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                serverAggregates: true,
                serverGrouping: false,
                requestStart: function (e) {
                    var requiredFilters = _.get(pageObject.params, ['requiredFilters', dsid], {});
                    if(!_.isEmpty(requiredFilters)){
                        _.forEach(requiredFilters, function(required, filter){
                            if(required && VizUtilityService.isFilterEmpty(scope.filters[filter])){
                                e.preventDefault();

                                $timeout(function(){
                                    e.sender.success({d:{results: [], __count: 0}});
                                });

                                return false;
                            }
                        });
                    }
                },
                change: function (e) {
                    var data = e.sender.data();

                    if (_.get(source, 'schema.model.fields.isAllDay.defaultValue')) {
                        _.forEach(data, function (dataItem) {
                            dataItem.isAllDay = true;
                        });
                    }

                    if (pageObject.viz.settings.resources) {
                        setColors(data, pageObject.viz.settings.resources[dsid]);
                    }

                    $timeout(function () {
                        if (scope.dataSource) {
                            scope.dataSource.read();
                        }
                    });
                }
            };

            var sortOptions = {
                sort: VizUtilityService.createSortArray(source)
            };
            
            var baseFilter = angular.copy(source.filter) || {
                filters: [],
                logic: 'and'
            };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: pageObject.params.filterLogic || 'and'
                }
            };

            angular.extend(dataSourceOptions, source, sortOptions, filterOptions);

            _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                if (field.type === 'date') {
                    field.parse = VizUtilityService.parseDateField;
                }
            });

            return new kendo.data.SchedulerDataSource(dataSourceOptions);

            function read(options) {
                if (!options.data.filter) {
                    options.data.filter = {
                        logic: 'and',
                        filters: []
                    };
                }

                // Filter by calendar view
                addViewFilter(scope, source, options.data.filter.filters);

                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);

                httpOptions.params.$ds = dsid;

                if (pageObject.params) {
                    var recurrence = VizUtilityService.buildRecurrenceData(pageObject, scope, options.data);
                    if (recurrence) {
                        httpOptions.params.$recurrence = recurrence;
                    }
                }

                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }
        }

        function addViewFilter(scope, source, filterArray) {
            var view = _.result(scope.schedule, 'view');
            if (view) {
                var viewStartDate = moment(view.startDate()),
                    viewEndDate = moment(view.endDate()),
                    startField = source.schema.model.fields.start.from,
                    endField = source.schema.model.fields.end.from;

                // End date is set to midnight of the last day in the view,
                // so events on that day are outside of the date range
                viewEndDate.add(1, 'd');

                var startValue = viewStartDate.toDate(),
                    endValue = viewEndDate.toDate();

                if (startField && endField) {
                    filterArray.push(
                        {
                            operator: 'gt',
                            field: endField,
                            value: startValue
                        },
                        {
                            operator: 'lt',
                            field: startField,
                            value: endValue
                        }
                    );
                }
                else if (startField) {
                    filterArray.push(
                        {
                            operator: 'gte',
                            field: startField,
                            value: startValue
                        },
                        {
                            operator: 'lt',
                            field: startField,
                            value: endValue
                        }
                    );
                }
                else if (endField) {
                    filterArray.push(
                        {
                            operator: 'gt',
                            field: endField,
                            value: startValue
                        },
                        {
                            operator: 'lte',
                            field: endField,
                            value: endValue
                        }
                    );
                }
            }
        }

        /**
         * Modifies scheduler settings
         * @param data
         */
        function configSchedule(data){
            for (var d = 0; d < data.length; d++) {
                var dataItem = data[d];

                // Default Date-Time rules
                var hasStartTime = dataItem.start && dataItem.start instanceof Date;
                var hasEndTime = dataItem.end && dataItem.end instanceof Date;
                var defaultOffsetValue = 30;
                var defaultOffsetUnit = 'm';

                if(hasStartTime && hasEndTime){
                    var start = moment(dataItem.start);
                    var end = moment(dataItem.end);

                    // Make sure end time is not before start time
                    if(end.diff(start) < 0){
                        dataItem.end = start.add(defaultOffsetValue, defaultOffsetUnit).toDate();
                    }
                }
                else if(hasStartTime){
                    // If record has start and no end, set end to [defaultOffset] after start time
                    dataItem.end = moment(dataItem.start).add(defaultOffsetValue, defaultOffsetUnit).toDate();
                }
                else if(hasEndTime){
                    // If record has end and no start, set start to [defaultOffset] before end time
                    dataItem.start = moment(dataItem.end).subtract(defaultOffsetValue, defaultOffsetUnit).toDate();
                }
                else{
                    // If neither time is set, remove from data
                    // Lack of start time breaks gantt chart
                    data.splice(d, 1);
                    d--;
                }
            }
        }

        function byDate(dateField){
            return function (a, b){
                var dateA = a[dateField],
                    dateB = b[dateField],
                    momentA = moment(dateA);

                if(!dateA || momentA.isBefore(dateB)){
                    return -1;
                }
                else if(momentA.isAfter(dateB)){
                    return 1;
                }

                return 0;
            };
        }

        /**
         * Sets color value for each calendar event
         * @param data - Query data from singular dataSource
         * @param resources - DataSource's resource configuration
         */
        function setColors(data, resources){
            _.forEach(data, function(event){
                // Checks if event's category matches item in color map
                var match = _.find(resources.dataSource, 'value', event[resources.field]);

                if(match){
                    event.__color = match.color;
                }
                else {
                    // Assigns default color if no match is found
                    event.__color = resources.defaultColor;
                }
            });
        }

        /**
         * Opens selected record in instance window
         * @function viewRecord
         * @param id
         * @param navFunctions
         */
        function viewRecord(id, navFunctions) {
            InstancesWindowService.openWindow({
                action: 'read',
                instanceId: id,
                navFunctions: navFunctions
            });
        }

        /**
         * Creates new record using default data from selected date
         * @param pageObject
         * @param defaultDataArray
         */
        function createRecord(pageObject, defaultDataArray){
            pageObjectsService.addCustomValuesToDefaultData(defaultDataArray, pageObject.params.defaultValues);
            InstancesWindowService.openWindow({
                action: 'create',
                widgetId: pageObject.viz.widgetId,
                title: pageObject.name,
                defaultData: defaultDataArray
            });
        }

        /**
         * Updates event that has been moved
         * @param instanceId
         * @param data
         * @returns {Promise}
         */
        function updateItem(instanceId, data) {
            var promises = [];

            // If order and category are from different states, resolve revisions separately
            _.forEach(data, function(state, stateId){
                promises.push(InstancesService.update(instanceId, { currentStateId: stateId, recordData: state }));
            });

            return $q.all(promises);
        }
    }])
;
angular.module('cerberus.core')
    .controller('MassimportUploadModalController', ["_", "moment", "$uibModalInstance", "listPageObject", "ImportService", "$timeout", "authToken", "workspaceId", "ImportExchangeService", "usersProfileService", function (_, moment, $uibModalInstance, listPageObject, ImportService, $timeout, authToken, workspaceId, ImportExchangeService, usersProfileService) {
        var vm = this;

        vm.newJobCreationSelected = false;
        vm.widgetId = listPageObject.viz.widgetId;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.$exclPermissions = true; //Allow non-admin exclusive permissions
        vm.rollbackAllowed = false; //Disable permissions for rollback operations (prevent operatord mass-delete data). If needed add a slider with Yes/No selector.

        /* Functions related to 'new import job settings' (getAllsettings, upload) */

        vm.getListOfAllImportSettings = function(){
            ImportService.getAllSettings(vm.widgetId, vm.$exclPermissions).then(function(d){
                vm.importSettingsArray = d;
            });
        };

        vm.importSettingsArray = [];
        vm.importJobModel = {
            jsonData: {},
            $exclPermissions: vm.$exclPermissions,
            validate: true
        };
        vm.importSource = null;
        vm.mailServers = [];
        vm.errors = null;

        vm.changeSource = function(){
            for(var i = 0; i < vm.importSettingsArray.length; i++){
                if(vm.importJobModel.importSettingId == vm.importSettingsArray[i].id){
                    vm.importSource = vm.importSettingsArray[i].type;
                }
            }
            if(vm.importSource.substring(0,8) === 'exchange'){
                usersProfileService.getAll('Mail Server').then(function(data){
                   vm.mailServers = data;
                });
            }
        };

        vm.getExchangeData = function(id,importSource){
            if(id){
                ImportExchangeService.getExchangeData(id,importSource).then(function(data){
                    vm.importJobModel.jsonData.exchangeData = data;
                });
            }
            else{
                vm.importJobModel.jsonData.exchangeData = [];
            }
        };

        vm.submit = function(isValid){
            if(isValid){
                ImportService.createImportJob(vm.widgetId,vm.importJobModel).then(function(){
                    $timeout(function(){
                        vm.getListOfAllJobs(); //update list
                    });
                });
            }
        };

        vm.asyncOptions = {
            saveUrl: '/server/rest/v1/widgets/' + vm.widgetId + '/import/jobs',
            removeUrl: 'remove',
            autoUpload: false
        };

        vm.localizationOptions = {
            uploadSelectedFiles: 'Submit to upload'
        };

        vm.onUpload = function(e) {
            delete vm.importJobModel.jsonData;
            e.data = vm.importJobModel;
            var xhr = e.XMLHttpRequest;
            if (xhr) {
                xhr.addEventListener("readystatechange", function () {
                    if (xhr.readyState == 1 /* OPENED */) {
                        xhr.setRequestHeader('Authentication','Bearer ' + authToken);
                        xhr.setRequestHeader('WSID', workspaceId);
                        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest ');
                    }
                });
            }
        };

        vm.onError = function(e){
            $timeout(function(){
                var resp = angular.fromJson(e.XMLHttpRequest.response);
                vm.errors = _.get(resp, 'DATA.message', '');
            });
        };

        vm.onSuccess = function (){
            $timeout(function(){
                vm.errors = null;
                vm.getListOfAllJobs(); //update list
            });
        };

        /* Functions related to 'import jobs list table' (getAll, create, validate, submit and delete) */

        vm.startImportJob = function(id, idx){
            vm.importJobs[idx].status = 'Importing';
            ImportService.startImport(id, vm.importJobs[idx].name, vm.$exclPermissions).then(function(){
                $timeout(function(){
                    vm.getListOfAllJobs();
                });
            });
        };

        vm.deleteJob = function(id, idx){
            ImportService.deleteJob(id, vm.$exclPermissions)
            .then(function(){
                vm.importJobs.splice(idx, 1);
            });
        };

        vm.validateImport = function(id){
            ImportService.validateImport(id, vm.$exclPermissions).then(function(){
                vm.getListOfAllJobs();
            });
        };
        
        // vm.validateImport = function(id){
            // ImportService.validateImport(id, vm.$exclPermissions).then(function(){
                // ImportService.getAllJobs(vm.widgetId, vm.$exclPermissions).then(function(importJobs){
                    // vm.importJobs = angular.copy(importJobs);
                    // _.forEach(vm.importJobs, function(impJob){
                        // impJob.date = moment.utc(impJob.date, 'MMMM, DD YYYY HH:mm:ss').toDate();
                        // impJob.validateDate = moment.utc(impJob.validateDate, 'MMMM, DD YYYY HH:mm:ss').toDate();
                    // });
                // });
            // });
        // };

        vm.rollback = function(item, idx){
            ImportService.rollback(item.id, vm.$exclPermissions)
            .then(function () {
                vm.importJobs.splice(idx, 1);
            });
        };

        vm.getListOfAllJobs = function (){
            ImportService.getAllJobs(vm.widgetId, vm.$exclPermissions).then(function(importJobs){
                vm.importJobs = angular.copy(importJobs);
                _.forEach(vm.importJobs, function(impJob){
                    impJob.date = moment.utc(impJob.date, 'MMMM, DD YYYY HH:mm:ss').toDate();
                    impJob.validateDate = moment.utc(impJob.validateDate, 'MMMM, DD YYYY HH:mm:ss').toDate();
                });
            });
        };

        vm.refreshAll = function (){
            vm.getListOfAllJobs();
        };

        vm.goToNewJobCreation = function (){
            vm.newJobCreationSelected = true;
        };

        //Init function        
        init();
        ////////////////////
        /**
         * Init controller data and server calls
         */
        function init() {
            //get all jop settings
            vm.getListOfAllImportSettings();
            //get all job history list
            vm.getListOfAllJobs();
        }

        function ok(){
            $uibModalInstance.close();
        }

        function cancel(){
            $uibModalInstance.dismiss();
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizTableCtrl',["_", "kendo", "$scope", "$timeout", "$firebaseObject", "fbUtil", "VizTableService", "VizUtilityService", function(_, kendo, $scope, $timeout, $firebaseObject, fbUtil,
                                           VizTableService, VizUtilityService) {
        var vm = this;
        var dataSource = VizTableService.buildDataSource($scope.pageObject, $scope);
        var dataBound = false;
        var navFunctions = {
            getNext: _.partialRight(VizTableService.viewNextRecord, dataSource),
            getPrevious: _.partialRight(VizTableService.viewPreviousRecord, dataSource)
        };
        var debouncedRefresh = _.debounce(refreshTable, 5000, { leading: true, trailing: true });

        vm.selectedRows = [];
        vm.selectedIds = [];
        vm.expandedRows = [];
        vm.detailPageObjects = [];
        vm.allRowsSelected = false;
        vm.data = [];
        vm.aggregates = {};

        $scope.grid = null;
        $scope.colFilters = {};
        $scope.checkedForDefaultFilter = false;
        $scope.pageChanging = false;

        vm.notesGridOptions = VizTableService.notesGridOptions;
        vm.attachmentGridOptions = VizTableService.attachmentGridOptions;
        vm.exportXLS = exportXLS;
        vm.exportAllAsXLS = exportAllAsXLS;
        vm.selectRow = selectRow;
        vm.selectAllRows = selectAllRows;
        vm.rowSelected = rowSelected;
        vm.detailTabChanged = detailTabChanged;

        init();

        function init() {
            //Firebase
            var initializing = true,
                unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                    if (initializing) {
                        //Stops first firing of the event
                        $timeout(function () {
                            initializing = false;
                        });
                    } else {
                        debouncedRefresh();
                    }
                });
            
            vm.options = buildOptions($scope.pageObject);

            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, dataSource);
            $scope.mainPageObject.vizCtrl = vm;

            if ($scope.nimIsAdvSelObject) {
                $scope.$watchCollection('vm.selectedRows', function (selectedRows, oldRows) {
                    if (!angular.equals(selectedRows, oldRows)) {
                        $scope.$emit('nim-advanced-selection-updated', selectedRows);
                    }
                });
            }

            // Event Bindings
            $scope.$on('nim-viz-reload', function (event) {
                event.preventDefault();
                debouncedRefresh();
            });

            var removeGridSizeWatcher = angular.noop;
            $scope.$on("kendoWidgetCreated", function (e, widget) {
                e.preventDefault();
                e.stopPropagation();

                if (widget == $scope.grid) {
                    var debouncedResizeFunc = _.debounce(function () {
                        if ($scope.resizeGridsterItem) {
                            $timeout(function () {
                                $scope.resizeGridsterItem();
                            }, 1);
                        }
                    }, 400, { leading: true, trailing: true });

                    removeGridSizeWatcher = $scope.$watchGroup([
                        function () {
                            return _.result(widget, 'tbody.height');
                        },
                        function () {
                            return _.result(widget, 'pager.element.height');
                        }
                    ], debouncedResizeFunc);
                    
                    if (widget.options.detailTemplate && !_.get($scope.pageObject.params, 'routeSettings.enabled') && !$scope.pageObject.params.openOnSelect) {
                        widget.tbody.on('click', '.k-master-row', function (event) {
                            var target = angular.element(event.target);
                        
                            if (!target.is('a') && !target.is('input')) {
                                target.closest('.k-master-row').find('.k-hierarchy-cell a.k-icon').trigger('click');
                            }
                        });
                    }
                }
            });

            $scope.$on('nim-viz-update-data', function (e, action, id/*, data*/) {
                //var oldData = dataSource.data();
                if (action === 'create') {
                    // Nothing here, for now...
                }
                else if (action === 'update') {
                    // Nothing here, for now...
                }
                else if (action === 'delete') {
                    _.forEach(id, function (deletedId) {
                        var dataItem = dataSource.get(deletedId);

                        if (dataItem) {
                            dataSource.remove(dataItem);
                        }
                    });

                    vm.selectedIds = [];
                    vm.selectedRows = [];
                    debouncedRefresh();
                }
            });

            $scope.$on('$destroy', function () {
                delete navFunctions.getNext;
                delete navFunctions.getPrevious;

                unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
            });

            $scope.$on('nim-remove-page-objects', function () {
                if ($scope.grid) {
                    $scope.grid.destroy();
                    $scope.grid = null;
                }

                removeGridSizeWatcher();
            });
        }

        function buildOptions(pageObject) {
            var options = {
                autoBind: false,
                columns: [],
                dataSource: dataSource,
                columnMenu: false,
                editable: false,
                filterable: _.get(pageObject, "viz.settings.filterable", true),
                mobile: false,
                navigatable: true,
                pageable: false,    // By default, paging is disabled in favor of virtual scrolling
                reorderable: true,
                resizable: true,
                noRecords: true,
                scrollable: {
                    virtual: true   // Enabled by default
                },
                selectable: "row",
                sortable: false,
                toolbar: false,
                groupable: _.get(pageObject, "viz.settings.groupable", false),
                change: rowSelectHandler,
                dataBinding: dataBindingHandler,
                dataBound: dataBoundHandler,
                filterMenuInit: filterMenuInitHandler,
                detailExpand: detailExpandHandler,
                detailCollapse: detailCollapseHandler,
                expand: resizeTable,
                collapse: resizeTable
            };

            var params = pageObject.params;

            VizTableService.addCheckColumns(options, pageObject);
            VizTableService.addMainColumns(options, pageObject);
            var hasDetails =
            VizTableService.addDetailColumnsAndTemplates(vm, options, pageObject, navFunctions);

            // If virtual scrolling has been disabled, allow use of paging configuration
            if (_.get(params, "disableVirtualScrolling", true)) {
                options.pageable = _.get(pageObject, "viz.settings.pageable", true);
                options.scrollable.virtual = false; // Turn off virtual scrolling
            }

            if (_.get(pageObject, "viz.settings.sortable", true)) {
                options.sortable = true;

                // If doing a groupby, we want to be able to keep the records sorted by group
                // in addition to other sorting options
                if (_.has(pageObject, 'viz.settings.dataSource.group.field')) {
                    options.sortable = {
                        mode: 'multiple'
                    };
                }
            }    

            if (params.useRowColors && !params.useRowIcons) {
                options.rowTemplate = _.partial(VizTableService.buildRow, params.rowColors, options.columns, hasDetails);
            }
            else if (params.useCustomTemplate) {
                var row = buildCustomRowTemplate(hasDetails, pageObject.viz.settings.showAttaches, pageObject.viz.settings.showNotes);
                options.rowTemplate = rowTemplate(row);
                options.altRowTemplate = altRowTemplate(row);
            }

            return options;
        }

        function dataBindingHandler(e) {
            var dataSource = e.sender.dataSource;
            
            // Makes sure grouping does not mess up the sort order
            if (!_.isEmpty(dataSource.group())) {
                sortView(dataSource.sort(), dataSource.view());
            }
        }

        function dataBoundHandler(e) {
            var grid = e.sender,
                dataSource = grid.dataSource;
            var params = $scope.pageObject.params;
                    
            vm.data = dataSource.data();
            vm.aggregates = dataSource.aggregates();
            setKeyUpEvent(grid);

            _.forEach(vm.selectedIds, function (id, index) {
                var updatedRow = dataSource.get(id);
                    
                if (updatedRow) {
                    vm.selectedRows[index] = updatedRow;
                }
            });

            if (vm.expandedRows.length > 0) {
                $timeout(function () {
                    grid.expandRow(grid.tbody.children().filter(function (idx, row) {
                        var uid = angular.element(row).data('uid'),
                            dataItem = dataSource.getByUid(uid);

                        if (dataItem) {
                            return _.includes(vm.expandedRows, dataItem.id);
                        }

                        return false;
                    }));
                });
            }

            if (!$scope.nimIsAdvSelObject && !$scope.checkedForDefaultFilter) {
                // Makes sure row is selected after loading table filter from URL
                var filterId = params.filterId,
                    filter = $scope.filters[filterId],
                    asFilter = params.asFilter;

                if (asFilter && filter) {
                    if (!_.isEmpty(filter.filters)) {
                        _.forEach(filter.filters, function (f) {
                            if (f.value) {
                                var dataItem = dataSource.get(f.value);

                                if (dataItem) {
                                    // Makes sure tables which use this table as a
                                    // filter can access the lookup display value
                                    if (params.filterDisplay) {
                                        f.lookupDisplay = dataItem[params.filterDisplay];
                                    }
                                    else {
                                        f.dataItem = dataItem;
                                    }

                                    toggleSelectRow(f.value);

                                    // Has grid select row
                                    if (!params.allowMultiSelect && dataItem) {
                                        var rowObject = grid.table.find('tr[data-uid=' + dataItem.uid + ']');
                                        grid.select(rowObject);
                                    }
                                }
                            }
                        });
                    }
                }
            }

            $scope.checkedForDefaultFilter = true;

            if (grid && vm.selectedIds.length > 0) {
                var selectedPageRows = [];
                var pageData = dataSource.data();

                _.forEach(pageData, function (dataItem) {
                    var selector = "tr[data-uid=" + dataItem.uid + "]";
                    if (vm.selectedIds.indexOf(dataItem.id) >= 0) {
                        selectedPageRows.push(selector);
                    }
                });

                if (selectedPageRows.length > 0) {
                    $timeout(function () {
                        if (grid.table) {
                            $scope.pageChanging = true;

                            var selectedPageRowSelector = selectedPageRows.join(', ');
                            var selectedPageRowJQuery = grid.table.find(selectedPageRowSelector);
                                
                            grid.select(selectedPageRowJQuery);

                            $scope.pageChanging = false;
                        }
                    }, 1);
                }
            }

            applyTableFilter(e);
            resizeTable();
        }
            
        function filterMenuInitHandler(e) {
            // If column displays string value, change filter operator to "contains" by default
            // Taken from Kendo demo
            var field = $scope.pageObject.viz.settings.dataSource.schema.model.fields[e.field];
            if (_.get(field, 'type') === 'string') {
                var firstValueDropDown = e.container.find("select:eq(0)").data("kendoDropDownList");
                firstValueDropDown.value("contains");
                firstValueDropDown.trigger("change");

                var secondValueDropDown = e.container.find("select:eq(2)").data("kendoDropDownList");
                secondValueDropDown.value("contains");
                secondValueDropDown.trigger("change");
            }
        }

        function exportXLS() {
            _.result($scope, 'grid.saveAsExcel');
        }

        function exportAllAsXLS() {
            var filters = dataSource.filter();
            var sort = dataSource.sort();
            VizTableService.exportRecordsAsXLS($scope.pageObject.id, filters, sort);
        }

        function toggleSelectRow(rowId) {
            var index = rowIndex(rowId);
            $timeout(function () {
                if (index < 0) {
                    vm.selectedRows.push(dataSource.get(rowId));
                    vm.selectedIds.push(rowId);
                }
                else {
                    _.pullAt(vm.selectedRows, index);
                    _.pullAt(vm.selectedIds, index);
                }
            });
        }

        function selectRow(rowId) {
            toggleSelectRow(rowId);

            // Apply Filter
            applyTableFilter();
        }

        function selectAllRows(selected) {
            var rows = $scope.grid.dataSource.data();

            _.forEach(rows, function (row) {
                var id = row.id;
                var index = rowIndex(id);
                if(selected && index < 0){
                    vm.selectedRows.push(row);
                    vm.selectedIds.push(id);
                }
                else if(!selected && index >= 0){
                    _.pullAt(vm.selectedRows, index);
                    _.pullAt(vm.selectedIds, index);
                }
            });

            // Apply Filter
            applyTableFilter();
        }

        function checkRowSelection() {
            $timeout(function () {
                var rows = dataSource.data();
                var page = _.map(rows, 'id');

                vm.allRowsSelected = _.every(page, rowSelected);
            });    
        }

        function rowSelected(id) {
            return rowIndex(id) >= 0;
        }

        function refreshTable(){
            if ($scope.grid) {
                dataSource.read();
                applyTableFilter();
            }
        }

        function rowIndex(id){
            return vm.selectedIds.indexOf(id);
        }

        function applyTableFilter() {
            checkRowSelection();

            var params = $scope.pageObject.params;
            if ($scope.grid && params.asFilter && params.filterId) {
                if (!dataBound) {
                    dataBound = true;
                }
                else {
                    $timeout(function () {
                        var filters = _.map(vm.selectedRows, function (row, i) {
                            var id = vm.selectedIds[i],
                                dataItem = angular.copy(row),
                                filterObj = {
                                    field: '__nimColumn__',
                                    operator: 'eq',
                                    value: id
                                };

                            if (params.filterDisplay && dataItem) {
                                filterObj.lookupDisplay = dataItem[params.filterDisplay];
                            }
                            else if(dataItem) {
                                filterObj.dataItem = dataItem; // For objects that will use the filter for default data
                            }

                            return filterObj;
                        });

                        $scope.filters[params.filterId] = {
                            logic: 'or',
                            filters: filters
                        };
                    });
                }
            }
        }

        // ADDED BY HD - 2018-09-25
        var click_selection_object_id= null, click_selection_times = 0;    //used for double click selection
        // END ADDED BY HD - 2018-09-25
        
        function rowSelectHandler(e){
            if(!$scope.pageChanging) {
                var selected = e.sender.select();
                if (selected && selected.length > 0) {
                    var dataItem = e.sender.dataItem(selected[0]);

                    $timeout(function () {
                        // Opens Instance Window on Single Click Selection
                        if ($scope.pageObject.params.openOnSelect) {
                            VizTableService.viewRecord(dataItem.id, navFunctions);
                        }

                        // ADDED BY HD - 2018-09-25
                        // OPENS INSTANCE WINDOW ON DOUBLE CLICK SELECTION
                        // Uses 2 external variables: click_selection_object_id = null, click_selection_times = 0;
                        if ($scope.pageObject.params.openButton) {
                        var clkTimer = null, delay = 300;
                        click_selection_times++;        //count click_selection_times
                        if(click_selection_times == 1) {
                          clkTimer = setTimeout(function() {
                            $scope.$apply(function () {
                            click_selection_object_id = dataItem.id;
                            click_selection_times = 0;  //after action performed, reset counter
                            }); 
                          }, delay);
                          } else {
                            if (click_selection_object_id === dataItem.id) {
                                VizTableService.viewRecord(dataItem.id, navFunctions);
                            }
                            clearTimeout(clkTimer);     //prevent single-click action
                            click_selection_times = 0;  //after action performed, reset counter
                          }
                        }
                        // END ADDED BY HD - 2018-09-25
                        
                        var routeSettings = _.get($scope.pageObject.params, 'routeSettings', {});
                        if (routeSettings.enabled && routeSettings.template) {
                            var target = routeSettings.newTab ? '_blank' : '_self';
                            VizUtilityService.openPageObjectRoute(routeSettings.template, dataItem, target);
                        }

                        // Filters by row
                        if (!$scope.pageObject.params.allowMultiSelect) {
                            vm.selectedRows = [dataItem];
                            vm.selectedIds = [dataItem.id];
                            if ($scope.pageObject.params.asFilter) {
                                applyTableFilter();
                            }
                        }
                    });
                }
            }
        }

        /**
         *
         * @param e - kendo event data
         * @param e.detailRow {jQuery}
         * @param e.masterRow {jQuery}
         * @param e.sender {kendo.ui.Grid}
         */
        function detailExpandHandler(e){
            resizeTable();

            var uid = e.masterRow.data('uid'),
                dataItem = e.sender.dataSource.getByUid(uid);

            if(dataItem && dataItem.id) {
                vm.expandedRows.push(dataItem.id);
            }
        }

        /**
         *
         * @param e - kendo event data
         * @param e.detailRow {jQuery}
         * @param e.masterRow {jQuery}
         * @param e.sender {kendo.ui.Grid}
         */
        function detailCollapseHandler(e){
            resizeTable();

            var uid = e.masterRow.data('uid'),
                dataItem = e.sender.dataSource.getByUid(uid);

            if(dataItem.id) {
                _.pull(vm.expandedRows, dataItem.id);
            }
        }

        /**
         * Sets keyup event to handle filtering the selected [cell's] column
         * @param grid
         */
        function setKeyUpEvent(grid) {
            // Used to keep track of full typed string
            var typedString = '',
                timeout = null,
                selectedCell = null,
                filterOp = $scope.pageObject.params.colFilterOp || 'startswith';

            // Detects key up on grid table
            grid.table.on('keyup', function (event) {
                // Gets currently selected cell
                selectedCell = grid.current();

                // If holding ALT or CTRL or if no table
                // cell is selected, ignore key press
                if (event.altKey || event.ctrlKey || !selectedCell) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                var keyCode = event.keyCode;

                // If using number pad, change to number keys
                if (keyCode >= 96 && keyCode <= 105) {
                    keyCode -= 48;
                }

                // Checks that keyCode matches characters 0-9, A-Z
                if (keyCode >= 48 && keyCode <= 90) {
                    // Converts key code to character and appends to string
                    typedString += String.fromCharCode(keyCode);

                    // Used for debouncing - previous timeout will not run
                    if (timeout) {
                        $timeout.cancel(timeout);
                    }

                    timeout = $timeout(function () {
                        if (selectedCell) {
                            // The many steps to find the right column to filter
                            var describedBy = selectedCell.attr('aria-describedby');    // Contains ID of column element

                            if (describedBy) {
                                var columnId = describedBy.split(' ')[0],                   // Parses ID
                                    columnElement = grid.thead.find('#' + columnId),        // Finds column element
                                    columnIndex = columnElement.data('index'),              // Gets index of column (in column array)
                                    column = grid.columns[columnIndex];                     // Finally found it

                                // This filtering is specifically for string values
                                if (_.get(column, 'type') === 'string') {
                                    var filterConfig = grid.dataSource.filter() || {
                                        filters: [],
                                        logic: 'and'
                                    };

                                    if ($scope.colFilters[column.field]) {
                                        var index = filterConfig.filters.indexOf($scope.colFilters[column.field]);

                                        if (index >= 0) {
                                            filterConfig.filters.splice(index, 1);
                                        }
                                    }

                                    $scope.colFilters[column.field] = {
                                        field: column.field,
                                        operator: filterOp,
                                        value: typedString
                                    };

                                    filterConfig.filters.push($scope.colFilters[column.field]);

                                    grid.dataSource.filter(filterConfig);
                                }
                            }
                        }

                        // Reset variables
                        typedString = '';
                        selectedCell = null;
                        timeout = null;

                    }, 300); // 300 millisecond debounce
                }
                else if (keyCode === 8 || keyCode === 46) { // Key codes for Backspace and Delete
                    if (timeout) {
                        $timeout.cancel(timeout);
                    }

                    // The many steps to find the right column to NOT filter
                    var describedBy = selectedCell.attr('aria-describedby');    // Contains ID of column element

                    if (describedBy) {
                        var columnId = describedBy.split(' ')[0],                   // Parses ID
                            columnElement = grid.thead.find('#' + columnId),        // Finds column element
                            columnIndex = columnElement.data('index'),              // Gets index of column (in column array)
                            column = grid.columns[columnIndex];                     // Finally found it

                        if (_.get(column, 'type') === 'string' && $scope.colFilters[column.field]) {
                            var filterConfig = grid.dataSource.filter() || {
                                filters: [],
                                logic: 'and'
                            };

                            if (filterConfig) {
                                var index = filterConfig.filters.indexOf($scope.colFilters[column.field]);

                                if (index >= 0) {
                                    filterConfig.filters.splice(index, 1);
                                }
                            }

                            delete $scope.colFilters[column.field];
                            grid.dataSource.filter(filterConfig);
                        }
                    }
                }
            }).on('keydown', function (event) {
                if (event.keyCode === 8) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                }
            });
        }

        function rowTemplate(row){
            var template = '';

            row.filter('tr').each(function(index, element){
                template += element.outerHTML;
            });

            return kendo.template(template);
        }

        function altRowTemplate(row){
            var template = '';

            row.addClass('k-alt').filter('tr').each(function(index, element){
                template += element.outerHTML;
            });

            return kendo.template(template);
        }

        function buildCustomRowTemplate(hasDetails, showAttach, showNotes){
            var row = angular.element($scope.pageObject.params.customTemplate);

            if(!row.is('tr')){
                row = angular.element('<tr>' + $scope.pageObject.params.customTemplate + '</tr>');
            }

            row.attr('data-uid', '#: uid #');

            if($scope.pageObject.params.allowMultiSelect){
                row.first().prepend('<td rowspan="' + row.filter('tr').length + '"><input class="form-control" type="checkbox" ng-checked="vm.rowSelected(#: id #)" ng-model="selected" ng-click="vm.selectRow(#: id #)" /></td>');
            }

            if(hasDetails){
                row.addClass('k-master-row')
                    .prepend('<td class="k-hierarchy-cell"><a class="k-icon k-plus" tabindex="-1"></a></td>');
            }

            if(showAttach){
                row.append('<td>#:attachment_count#</td>');
            }

            if(showNotes){
                row.append('<td>#:note_count#</td>');
            }

            return row;
        }

        function sortView(sortArray, viewArray) {
            // Iterates over each group
            _.forEach(viewArray, function(view){
                    /* LODASH Version 4 ONLY */
                    //var sorts = _.reject(sortArray, ['field', view.field]),
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    var sorts = _.reject(sortArray, function(r){return r.field === view.field;}),
                    sortFields = _.map(sorts, 'field'),
                    sortDirs = _.map(sorts, 'dir');
                // Group's data items
                var data = view.items;
                if (!_.isEmpty(data)) {
                    if (view.hasSubgroups) {
                        sortView(sorts, data);
                    }
                    else {
                        /* LODASH MIGRATION HELPER FUNCTION */
                        /* LODASH Version 3 & 4 Compatibility Mode */
                        if ((_.VERSION).charAt(0) <= 3){ //Detect LODASH version 3 or 4. Function for V4 was renamed from 'sortByOrder' into 'orderBy'
                            //V3 or lower
                            console.log('Upgrade LODASH from V3 to V4 ASAP - ERRCode00DHLD3.1');
                            data = _.sortByOrder(data, sortFields, sortDirs);
                        } else {
                            //V4 or Higher
                            /* LODASH Version 4 ONLY */
                            data = _.orderBy(data, sortFields, sortDirs); // ++ AFTER MIGRATION TO V4 remove helper function with all V3 detect options ++
                        }
                    }

                    // Assigns sorted data to view
                    _.assign(view.items, data);
                }    
            });
        }

        function resizeTable(){
            if ($scope.resizeGridsterItem) {
                $timeout(function () {
                    $scope.resizeGridsterItem();
                }, 1);
            }
        }

        function detailTabChanged() {
            resizeTable();
        }
    }])
    .directive('nimVizTable', function() {
            return {
                restrict: 'AE',
                templateUrl: 'core/pages/viz/table/table.tpl.html',
                scope: true,
                require: '^nimPageObject',
                controller: 'nimVizTableCtrl',
                controllerAs: 'vm'
            };
        })
;
angular.module('cerberus.core')
/**
 * @ngdoc service
 * @name VizTableService
 * @alias cerberus/core:VizTableService
 * @description Provides datasources and helpers table viz
 */
    .factory('VizTableService', ["_", "kendo", "moment", "apiPath", "$window", "$timeout", "$http", "$log", "InstancesService", "InstancesWindowService", "OdataUtilityService", "pageObjectsService", "VizUtilityService", function VizTableService(_, kendo, moment, apiPath, $window, $timeout, $http, $log,
                                                        InstancesService, InstancesWindowService, OdataUtilityService,
                                                        pageObjectsService, VizUtilityService) {
        return {
            buildDataSource: buildDataSource,
            addCheckColumns: addCheckColumns,
            addMainColumns: addMainColumns,
            addDetailColumnsAndTemplates: addDetailColumnsAndTemplates,
            attachmentGridOptions: attachmentGridOptions,
            notesGridOptions: notesGridOptions,
            viewRecord: viewRecord,
            viewNextRecord: viewNextRecord,
            viewPreviousRecord: viewPreviousRecord,
            footerTemplate: footerTemplate,
            exportRecordsAsXLS: exportRecordsAsXLS,
            addDetailPageObjects: addDetailPageObjects,
            buildRow: buildRow
        };
        ////////////////////
        /**
         * Parses grid definition to properly set defines schema
         * @function buildDataSource
         * @param {object} pageObject
         * @param {object} scope - angularJs scope
         * @return {object} containing an Array of Columns and a Fields object
         */
        function buildDataSource(pageObject, scope) {
            var dataSourceOptions = {
                type: 'odata',
                transport:{
                    read: read
                },
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                serverAggregates: true,
                serverGrouping: false,
                pageSize: 20,
                requestStart: function (e){
                    if(!_.isEmpty(pageObject.params.requiredFilters)){
                        _.forEach(pageObject.params.requiredFilters, function(required, filter){
                            if(required && VizUtilityService.isFilterEmpty(scope.filters[filter])){
                                e.preventDefault();

                                $timeout(function(){
                                    e.sender.success({d:{results: [], __count: 0}});
                                });

                                return false;
                            }
                        });
                    }
                }
            };

            var sortOptions = {
                sort: VizUtilityService.createSortArray(pageObject.viz.settings.dataSource)
            };

            var baseFilter = angular.copy(pageObject.viz.settings.dataSource.filter) || {
                filters: [],
                logic: 'and'
            };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: pageObject.params.filterLogic || 'and'
                }
            };

            // Extend any user-defined dataSource settings
            angular.extend(dataSourceOptions, pageObject.viz.settings.dataSource, sortOptions, filterOptions);

            _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                if(field.type === 'string') {
                    field.parse = parseStringValue;
                }
                else if(field.type === 'date') {
                    field.parse = VizUtilityService.parseDateField;
                }
                else if(field.type === 'number') {
                    field.parse = VizUtilityService.parseNumberField;
                }
            });

            if (_.get(pageObject, 'params.isTreeList', false)) {
                dataSourceOptions.schema.model.expanded = _.get(pageObject, 'params.treeExpanded', false);
                dataSourceOptions.serverAggregates = false;
                delete dataSourceOptions.pageSize;

                var parentModel = dataSourceOptions.schema.model.fields.parentId;
                if (!parentModel) {
                    parentModel = {
                        type: 'number'
                    };
                    dataSourceOptions.schema.model.fields.parentId = parentModel;
                }

                parentModel.parse = function (id) {
                    return id || null;
                 };

                return new kendo.data.TreeListDataSource(dataSourceOptions);
            }
            // Return new Datasource
            return new kendo.data.DataSource(dataSourceOptions);

            function read(options) {
                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);

                if (pageObject.params) {
                    var recurrence = VizUtilityService.buildRecurrenceData(pageObject, scope, options.data);
                    if (recurrence) {
                        httpOptions.params.$recurrence = recurrence;
                    }
                }

                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }
        }

        function addCheckColumns(options, pageObject) {
            var columnArray = options.columns;
            
            //Page Object Filtering
            if (pageObject.params.allowMultiSelect) {
                columnArray.push({
                    template: '<input class="form-control" type="checkbox" ng-checked="vm.rowSelected(#: id #)" ng-model="selected" ng-click="vm.selectRow(#: id #)" />',
                    width: 30,
                    type: 'filter',
                    title: '',
                    headerTemplate: '<input class="form-control" type="checkbox" ng-checked="vm.allRowsSelected" ng-click="vm.selectAllRows(!vm.allRowsSelected)" />',
                    menu: false
                });
            }

            // Row Icons
            if (pageObject.params.useRowColors && pageObject.params.useRowIcons) {
                columnArray.push({
                    template: _.partial(rowIconTemplate, pageObject.params.rowColors),
                    width: 34,
                    title: '',
                    headerTemplate: ' ',
                    menu: false
                });
            }
        }

        // Builds Primary data columns
        function addMainColumns(options, pageObject) {
            var mainColumns = angular.copy(pageObject.viz.settings.columns),
                columnArray = options.columns;
            
            _.forEach(mainColumns, function (col) {
                // Hide Group Column
                if (_.has(pageObject, 'viz.settings.dataSource.group.field')) {
                    if (col.field === pageObject.viz.settings.dataSource.group.field) {
                        col.hidden = true;
                    }
                }    

                // Hide Parent Column
                if (pageObject.params.isTreeList && pageObject.params.parentField) {
                    if (col.field === pageObject.params.parentField) {
                        col.hidden = true;
                    }
                }

                // Set Template
                if(col.type === 'string'){
                    col.template = stringColumnTemplate(col);
                }
                else if(col.type === 'location'){
                    setLocationColumnField(col);
                }
                else if(col.type === 'number'){
                    col.filterable = {
                        ui: _.partial(numberColumnFilterableUI, col)
                    };
                }

                // Set Footer Template - 'Get aggregate columns'
                /* LODASH Version 4 ONLY */
                //var colAggregates = _.filter(pageObject.viz.settings.dataSource.aggregate, ['field', col.field]);
                /* LODASH Version 3 & 4 Compatibility Mode */
                var colAggregates = _.filter(pageObject.viz.settings.dataSource.aggregate, function(c){return c.field === col.field;});

                if (colAggregates.length) {
                    col.footerTemplate = _.partial(footerTemplate, colAggregates);
                }

                columnArray.push(col);
            });

            return mainColumns;
        }

        function addDetailColumnsAndTemplates(vm, options, pageObject, navFunctions) {
            var detailTemplates = [];

            // Recurrence column
            if (pageObject.viz.settings.showRecurrence) {
                options.columns.push({
                    title: 'Repeat',
                    field: '__nimRRuleText'
                });
            }

            // Detail Page Objects - now much simpler
            if (_.isArray(pageObject.viz.drillDownSettings)) {
                vm.detailPageObjects = new Array(pageObject.viz.drillDownSettings.length);
                addDetailPageObjects(detailTemplates, vm.detailPageObjects, pageObject.viz.drillDownSettings);
            }

            //Attachments
            if (pageObject.viz.settings.showAttaches) {
                detailTemplates.push({
                    title: 'Attachments',
                    body: '<div kendo-grid="attachmentGrid" k-options="vm.attachmentGridOptions(dataItem)"></div>'
                });

                options.columns.push({
                    title: 'Attachments',
                    field: 'attachment_count',
                    headerTemplate: '<i class="fa fa-lg fa-paperclip" title="Attachments"></i>',
                    width: 50,
                    filterable: false
                });
            }

            //Notes
            if (pageObject.viz.settings.showNotes) {
                detailTemplates.push({
                    title: 'Notes',
                    body: '<div kendo-grid="noteGrid" k-options="vm.notesGridOptions(dataItem)"></div>'
                });

                options.columns.push({
                    title: 'Notes',
                    field: 'note_count',
                    headerTemplate: '<i class="fa fa-lg fa-sticky-note-o" title="Notes"></i>',
                    width: 50,
                    filterable: false
                });
            }

            // "Open" Button
            if (pageObject.params.openButton) {
                options.columns.push({
                    title: ' ',
                    menu: false,
                    width: 90,
                    headerTemplate: '<i class="fa fa-lg fa-clone"></i>',
                    command: [{
                        name: 'openRecord',
                        text: 'Open',
                        click: function (e) {
                            e.preventDefault();

                            var tr = e.target.closest('tr'),
                                dataItem = this.dataItem(tr);

                            if (dataItem) {
                                viewRecord(dataItem.id, navFunctions);
                            }
                        }
                    }]
                });
            }

            // Tree List "Add Child" Button
            if (pageObject.params.isTreeList && pageObject.params.addChild) {
                options.columns.push({
                    title: '',
                    menu: false,
                    command: [{
                        name: 'addChild',
                        text: _.get(pageObject, 'params.addChildText', 'Add Child'),
                        click: function (e) {
                            var tr = e.target.closest('tr'),
                                dataItem = this.dataItem(tr),
                                defaultData = [{
                                    data: {
                                        value: dataItem.id,
                                        lookupDisplay: dataItem.__parent_text
                                    },
                                    field: pageObject.params.parentField
                                }];

                            pageObjectsService.addCustomValuesToDefaultData(defaultData, pageObject.params.defaultValues);

                            InstancesWindowService.openWindow({
                                action: 'create',
                                widgetId: pageObject.viz.widgetId,
                                title: pageObject.wrapper.header.title,
                                defaultData: defaultData
                            });
                        }
                    }]
                });
            }

            if (detailTemplates.length > 1) {
                var titleHtml = '';
                var bodyHtml = '';
                _.forEach(detailTemplates, function (dtemp, i) {
                    var activeState = '';
                    if (i === 0) {
                        activeState = 'class="k-state-active"';
                    }
                    titleHtml = titleHtml + '<li ' + activeState + '>' + dtemp.title + '</li>';
                    bodyHtml = bodyHtml + '<div>' + dtemp.body + '</div>';
                });
                options.detailTemplate = '<div kendo-tabstrip k-activate="vm.detailTabChanged">' + '<ul>' + titleHtml + '</ul>' + bodyHtml + '</div>';
            }
            else if (detailTemplates.length == 1) {
                options.detailTemplate = detailTemplates[0].body;
            }

            return detailTemplates.length > 0;
        }

        // Options for Attachments detail grid
        function attachmentGridOptions(dataItem) {
            return {
                columns: [
                    {
                        field: 'name',
                        title: 'Name'
                    },
                    {
                        field: 'uploadedBy',
                        title: 'Uploaded By'
                    },
                    {
                        field: 'uploadDate',
                        title: 'Upload Date',
                        template: function(attachment){
                            return VizUtilityService.parseDateField(attachment.uploadDate);
                        }
                    }
                ],
                dataSource: {
                    data: dataItem.__nimAttachments,
                    pageSize: 10
                },
                height: 377,
                columnMenu: false,
                editable: false,
                filterable: true,
                mobile: false,
                navigatable: true,
                pageable: true,
                reorderable: false,
                resizable: true,
                scrollable: true,
                selectable: true,
                sortable: true,
                change: function(e){
                    var selected = e.sender.select();
                    if(selected.length > 0){
                        var attachment = e.sender.dataItem(selected[0]);

                        InstancesService.getDownloadKey(attachment.id).then(function (d) {
                            InstancesService.getBlob(d).then(function (pdfBlob) {
                                $window.saveAs(pdfBlob, attachment.name);
                            });
                        });
                    }
                }
            };
        }

        // Options for Notes detail grid
        function notesGridOptions(dataItem) {
            var noteDs = new kendo.data.DataSource({
                type: 'odata',
                transport:{
                    read: {
                        url: apiPath + 'instances/' + dataItem.id + '/metadata/odata.svc?type=Note',
                        beforeSend: VizUtilityService.setRequestHeaders,
                        dataType: 'json'
                    },
                    create: {
                        url: apiPath + 'instances/' + dataItem.id + '/metadata',
                        beforeSend: VizUtilityService.setRequestHeaders,
                        dataType: 'json'
                    },
                    update: {
                        url: function(options){
                            return apiPath + 'instance/metadata/' + options.id;
                        },
                        beforeSend: VizUtilityService.setRequestHeaders,
                        dataType: 'json'
                    },
                    destroy: {
                        url: function(options){
                            return apiPath + 'instance/metadata/' + options.id;
                        },
                        beforeSend: VizUtilityService.setRequestHeaders,
                        dataType: 'json'
                    },
                    parameterMap: function(options, operation) {
                        if ((operation !== 'destroy' && operation !== 'read') && options.title) {
                            return angular.toJson({
                                dataStruct:{
                                    title: options.title,
                                    body: options.body
                                },
                                type: 'Note',
                                isPublic: options.is_public
                            });
                        }
                    }
                },
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                noRecords: true,
                pageSize: 10,
                schema: {
                    model: {
                        id: 'id',
                        fields:{
                            id: {editable: false},
                            sys_created_by: {editable: false},
                            is_public: {type:'boolean'},
                            title: {validation: { required: true}}
                        }
                    }
                }
            });
            return {
                columns: [
                    {
                        field: 'title',
                        title: 'Title',
                        width: 200
                    },
                    {
                        field: 'body',
                        title: 'Body'
                    },
                    {
                        field: 'is_public',
                        title: 'Public',
                        template: '#= is_public ? \'Yes\' : \'No\' #',
                        width: 80
                    },
                    {
                        field: 'sys_created_by',
                        title: 'Created By',
                        width: 150
                    },
                    {
                        command: ['edit', 'destroy'],
                        title: '&nbsp;',
                        width: '230px'
                    }

                ],
                toolbar: ["create"],
                dataSource: noteDs,
                height: 377,
                columnMenu: false,
                editable: 'inline',
                filterable: true,
                mobile: false,
                navigatable: true,
                pageable: true,
                reorderable: true,
                resizable: true,
                scrollable: true,
                sortable: true
            };
        }

        /**
         * Callback function to be used with kendo grid's onChange event
         * @function viewRecord
         */
        function viewRecord(instanceId, navFunctions) {
            InstancesWindowService.openWindow({
                action: 'read',
                instanceId: instanceId,
                navFunctions: navFunctions
            });
        }

        /**
         * Navigation function used to open next record from instance window
         * @param instanceController
         * @param dataSource
         */
        function viewNextRecord(instanceController, dataSource){
            var currentId = instanceController.instanceId,
                currentDataItem = dataSource.get(currentId),
                currentIndex = dataSource.indexOf(currentDataItem),
                currentPageSize = dataSource.data().length,
                nextItem;

            if(currentIndex >= 0) {
                if (currentIndex < currentPageSize - 1) {
                    nextItem = dataSource.at(currentIndex + 1);
                }

                if (nextItem) {
                    instanceController.updateInstanceAttrs(nextItem.id, 'read');
                    instanceController.init();
                }
            }
        }

        /**
         * Navigation function used to open previous record from instance window
         * @param instanceController
         * @param dataSource
         */
        function viewPreviousRecord(instanceController, dataSource){
            var currentId = instanceController.instanceId,
                currentDataItem = dataSource.get(currentId),
                currentIndex = dataSource.indexOf(currentDataItem),
                prevItem;

            if(currentIndex >= 0) {
                if (currentIndex > 0) {
                    prevItem = dataSource.at(currentIndex - 1);
                }

                if (prevItem) {
                    instanceController.updateInstanceAttrs(prevItem.id, 'read');
                    instanceController.init();
                }
            }
        }

        /**
         * Builds footer string to display column aggregates
         * @param aggregates
         * @param aggregatesValue
         */
        function footerTemplate(aggregates, aggregatesValue) {
            var footerHTML = '';

            _.forEach(aggregates, function (aggr) {
                var value;

                if(_.has(aggregatesValue, aggr.field)){
                    value = aggregatesValue[aggr.field][aggr.aggregate];
                }
                else {
                    value = aggregatesValue[aggr.aggregate];
                }

                if (aggr.format) {
                    try {
                        value = kendo.format(aggr.format, value);
                    }
                    catch (e) {
                        $log.error(e);
                    }
                }
                footerHTML += '<div>' + aggr.nimLabel + ': ' + value + '</div>';
            });

            return footerHTML;
        }

        function exportRecordsAsXLS(id, filter, sort) {
            var params = {
                $orderBy: VizUtilityService.formatOrderBy(sort)
            };

            if (filter) {
                VizUtilityService.cleanFilterConfiguration(filter.filters);

                if (!_.isEmpty(filter.filters)) {
                    params.$filter = OdataUtilityService.toOdataFilter(filter);
                }
            }
            $http.get(apiPath + '/page/objects/' + id + '/export',{
                params: params
            }).then(function(result){
                $window.open(result.data, '_self');
            });
        }

        function addDetailPageObjects(tempArray, detailArray, pageObjects) {
            _.forEach(pageObjects, function (pageObj, i) {
                var col = pageObj.column || 'id';
                tempArray.push({
                    title: pageObj.title,
                    body: '<div ng-if="vm.detailPageObjects[' + i + ']" nim-page-object="vm.detailPageObjects[' + i + ']" no-wrapper parent-id="dataItem.' + col + '" parent-look-up="\'' + pageObj.field + '\'"></div>'
                });
                loadDetailPageObject(detailArray, pageObj.pageObjectId, i);
            });
        }

        function buildRow(rowColors, columns, hasDetails, dataItem){
            var styles = [];

            _.forEach(rowColors, function (rc) {
                if (rc.conditions.length > 0) {
                    if (checkCondition(rc, dataItem)) {
                        styles.push('background-color:' + rc.color);

                        var color = kendo.parseColor(rc.color);
                        if (color) {
                            // Taken from kendo code
                            var brightness = Math.sqrt(0.241 * color.r * color.r + 0.691 * color.g * color.g + 0.068 * color.b * color.b);

                            if (brightness < 180) {
                                styles.push('color:#ffffff');
                            }
                        }

                        return false;
                    }
                }    
            });

            var rowClass = '';

            if(hasDetails){
                rowClass = 'class="k-master-row"';
            }

            var row = '<tr ' + rowClass + ' data-uid="' + dataItem.uid + '" style="' + styles.join(';') + '">';

            if(hasDetails){
                row += '<td class="k-hierarchy-cell"><a class="k-icon k-i-expand" tabindex="-1"></a></td>';
            }

            _.forEach(columns, function(c){
                if(!c.hidden) {
                    row += '<td>';

                    if (c.template) {
                        var tempFunction = c.template;

                        if (!_.isFunction(tempFunction)) {
                            tempFunction = kendo.template(c.template);
                        }

                        row += tempFunction(dataItem);
                    }
                    else if (c.format) {
                        row += kendo.format(c.format, dataItem[c.field]);
                    }
                    else if (c.command) {
                        _.forEach(c.command, function (command) {
                            row += commandTemplate(command);
                        });
                    }
                    else {
                        row += dataItem[c.field];
                    }

                    row += '</td>';
                }
            });

            row += '</tr>';

            return row;
        }

        // Helpers

        function numberColumnFilterableUI(column, element){
            element.kendoNumericTextBox({
                format: column.format || 'n',
                decimals: 13
            });
        }

        // For formatting Phone Numbers and URLs
        function stringColumnTemplate(column){
            return function(dataItem){
                var field = column.field,
                    value = dataItem[field];

                if(typeof value === 'string'){
                    if (value.search(/^((http|https):\/\/)[a-zA-Z]+\.[a-zA-Z\.]*[a-zA-Z]+(:[0-9]+)?(\/[a-zA-Z0-9\.\?#\-%&=])*$/) >= 0) {
                        return '<a ng-bind="dataItem.' + field + '" ng-href="{{dataItem.' + field + '}}" target="_blank"></a>';
                    }
                    else if (value.search(/^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/) >= 0) {
                        var pNum = value.replace('(', '').replace(')', '').replace(' ', '-');
                        return '<a ng-bind="dataItem.' + field + '" href="tel:' + pNum + '"></a>';
                    }
                    else if (value.search(/^\\w[\\w\\.\\-]*\\w@\\w+[\\w\\.\\-]*\\.[a-zA-Z]{2,}$/) >= 0) {
                        return '<a ng-bind="dataItem.' + field + '" ng-href="mailto:{{dataItem.' + field + '}}"></a>';
                    }
                    else if (column.format === 'image') {
                        if (value) {
                            var widthString = '';
                            if (column.width) {
                                widthString = 'width="' + (column.width - 20) + '"';
                            }
                            return '<div nim-img="' + value + '" ' + widthString + '></div>';
                        }
                        else {
                            return '';
                        }
                    }
                }
                else if (typeof value == 'number' && column.format === 'fileSize'){
                    return getFileSize(value);
                }
                else if(typeof value === 'object'){
                    return '<span ng-bind="dataItem.' + field + '.display"></span>';
                }
                else if(column.format === 'boolCheck'){
                    if(value === true) {
                        return '<i class="fa fa-check"></i>';
                    }
                    else if(!value){
                        return '';
                    }
                }
                return '<span ng-bind="dataItem.' + field + '"></span>'; 
            };
        }

        function getFileSize(bytes){
            var kilobytes = bytes / 1024,
                megabytes = kilobytes / 1024,
                gigabytes = megabytes / 1024;

            if(bytes < 1000){
                return bytes + ' B';
            }
            else if(kilobytes < 1000){
                return _.round(kilobytes, 1) + ' KB';
            }
            else if(megabytes < 1000){
                return _.round(megabytes, 1) + ' MB';
            }
            else {
                return _.round(gigabytes, 1) + ' GB';
            }
        }

        function setLocationColumnField(column){
            var property = _.get(column, 'nim_locationProperty', 'formatted_address');
            column.field = column.field + '.properties.' + property;

            column.template = function(dataItem){
                return _.get(dataItem, column.field, '');                                                                                                                                                                                                                                                                                                                                                                                                 
            };
        }

        function parseStringValue(value){
            if(typeof value === 'string') {
                // Removes HTML tags from strings
                // Wraps in div to ensure the string is not treated as a selector
                return angular.element('<div>' + value + '</div>').text();
            }
            else if(_.has(value, 'display')){
                return parseStringValue(value.display);
            }
            else if(angular.equals(value, {})){
                return '';
            }
            return value;
        }

        function loadDetailPageObject(detailArray, id, index){
            pageObjectsService.getPageObject(id).then(function(pageObject){
                detailArray[index] = pageObject;
            });
        }

        // Checks row color conditions and displays an icon
        function rowIconTemplate(rowColors, dataItem) {
            var icon = '';

            _.forEach(rowColors, function (rc) {
                if (rc.conditions.length > 0) {
                    if (rc.icon && checkCondition(rc, dataItem)) {
                        icon = '<i class="fa fa-' + rc.icon + '" style="color:' + rc.color + '"></i>';

                        return false;
                    }
                }    
            });

            return icon;
        }

        function checkCondition(rowColor, dataItem){
            var iteratee = function(cond){
                var colValue = dataItem[cond.field];
                var value = cond.value;
                if(_.isString(value) && value.length > 2 && _.startsWith(value, '"') && _.endsWith(value, '"')){
                    var valueCol = cond.value.replace(/^"/, '').replace(/"$/, '');
                    value = dataItem[valueCol];
                }

                switch(cond.operator){
                    case 'conains':
                        return _.get(dataItem, cond.field, '').indexOf(value) >= 0;
                    case 'doesnotcontain':
                        return _.get(dataItem, cond.field, '').indexOf(value) < 0;
                    case 'startswith':
                        return _.startsWith(_.get(dataItem, cond.field, ''), value);
                    case 'endswith':
                        return _.endsWith(_.get(dataItem, cond.field, ''), value);
                    case 'eq':
                        if(_.isDate(colValue) && _.isDate(value)){
                            return moment(colValue).isSame(value);
                        }
                        else if(!_.isDate(colValue) && !_.isDate(value)){
                            return colValue === value;
                        }
                        return false;
                    case 'neq':
                        if(_.isDate(colValue) && _.isDate(value)){
                            return !moment(colValue).isSame(value);
                        }
                        else if(!_.isDate(colValue) && !_.isDate(value)){
                            return colValue !== value;
                        }
                        return false;
                    case 'gt':
                        if(_.isDate(colValue) && _.isDate(value)){
                            return moment(colValue).isAfter(value);
                        }
                        else if(!_.isDate(colValue) && !_.isDate(value)){
                            return colValue > value;
                        }
                        return false;
                    case 'gte':
                        if(_.isDate(colValue) && _.isDate(value)){
                            return moment(colValue).isSameOrAfter(value);
                        }
                        else if(!_.isDate(colValue) && !_.isDate(value)){
                            return colValue >= value;
                        }
                        return false;
                    case 'lt':
                        if(_.isDate(colValue) && _.isDate(value)){
                            return moment(colValue).isBefore(value);
                        }
                        else if(!_.isDate(colValue) && !_.isDate(value)){
                            return colValue < value;
                        }
                        return false;
                    case 'lte':
                        if(_.isDate(colValue) && _.isDate(value)){
                            return moment(colValue).isSameOrBefore(value);
                        }
                        else if(!_.isDate(colValue) && !_.isDate(value)){
                            return colValue <= value;
                        }
                        return false;
                    default:
                        return false;
                }
            };

            if(rowColor.logic === 'or'){
                return _.some(rowColor.conditions, iteratee);
            }
            else {
                return _.every(rowColor.conditions, iteratee);
            }
        }

        function commandTemplate(command) {
            var temp = '<a class="k-button k-button-icontext# if(data.name){ # k-grid-#: data.name # # }## if(data.className){ # #: data.className # # }#" href="">' +
                '<span class=""></span># if(data.text){ # #= data.text # # } else if(data.name){ # #: data.name # # } #' +
            '</a > ';

            try {
                return kendo.template(temp)(command);
            }
            catch (e) {
                $log.error(e);
                return '';
            }
        }
    }])
;
angular.module('cerberus.core')
    .controller('nimVizTemplateCtrl', ["_", "kendo", "$scope", "$timeout", "$window", "VizUtilityService", "VizTemplateService", "$firebaseObject", "fbUtil", function (_, kendo, $scope, $timeout, $window, VizUtilityService, VizTemplateService, $firebaseObject, fbUtil) {
        var vm = this;
        
        // Instantiate Variables
        $scope.vizCtrl = {};
        $scope.usingTemplate = false;
        $scope.mainPageObject.vizCtrl = $scope.vizCtrl;

        $scope.viewRecord = VizTemplateService.viewRecord;
        //Firebase
        var initializing = true,
            debouncedRefresh = _.debounce(function () { _.result(vm, 'dataSource.read'); }, 5000, { leading: true, trailing: true }),
            unwatchFb = $firebaseObject(fbUtil.ref('queries/' + $scope.pageObject.viz.settings.dataSource.nim_viewId)).$watch(function(){
                if (initializing) {
                    //Stops first firing of the event
                    $timeout(function() { initializing = false; });
                } else {
                    debouncedRefresh();
                }
            });

        // Init
        init();

        // Event Bindings
        $scope.$on('nim-viz-reload', function (event) {
            event.preventDefault();
        });

        $scope.$on('$destroy', function(){
            unwatchFb();     // Remove this watcher so it stops firing after the user has left the page
        });

        function init() {
            var dataSource = new kendo.data.DataSource({
                requestStart: function (e) {
                    if (!VizTemplateService.requiredFiltersSet($scope.pageObject, $scope.filters)) {
                        e.preventDefault();

                        $timeout(function () {
                            e.sender.success({ d: { results: [], __count: 0 } });
                        });

                        return false;
                    }
                },
                requestEnd: function () {
                    var defaultText = angular.copy($scope.pageObject.viz.settings.defaultText) || '';

                    if (VizTemplateService.requiredFiltersSet($scope.pageObject, $scope.filters) || _.isEmpty($scope.pageObject.viz.settings.defaultText)) {
                        $timeout(function () {
                            var data = dataSource.data();

                            $scope.vizCtrl.data = data;
                            var html = VizTemplateService.setHtml(data, $scope.pageObject.viz);
                            $scope.usingTemplate = html !== defaultText;
                            $scope.templateHtml = html;
                            $scope.vizCtrl.templateHtml = $scope.templateHtml;
                        });
                    }
                    else {
                        $scope.usingTemplate = false;
                        $scope.templateHtml = defaultText;
                        $scope.vizCtrl.templateHtml = $scope.templateHtml;
                    }
                }
            });
            if ($scope.pageObject.viz.settings.columns.length > 0) {
                dataSource = VizTemplateService.buildDataSource($scope.pageObject, $scope);
            }

            vm.dataSource = dataSource;

            $scope.templateHtml = $scope.pageObject.viz.settings.defaultText || '';
            $scope.vizCtrl.templateHtml = $scope.templateHtml;

        
            VizUtilityService.subscribeToPageFilters($scope.pageObject.filterMap, $scope, dataSource);
        }
    }])
    .directive('nimVizTemplate', ["$compile", function($compile) {
        return {
            restrict: 'AE',
            templateUrl: 'core/pages/viz/template/template.tpl.html',
            scope: true,
            require: '^nimPageObject',
            controller: 'nimVizTemplateCtrl',
            link: function(scope, element){
                scope.$watch('templateHtml', function(html){
                    var templateDiv = element.find('.nim-template-html');
                    templateDiv.empty().append(html);
                    $compile(templateDiv[0])(scope);
                });
            }
        };
    }])
;
angular.module('cerberus.core')
    /**
     * @ngdoc service
     * @name VizTemplateService
     * @alias cerberus/core:VizTemplateService
     * @description Provides helper functions to the readout view
     */
    .factory('VizTemplateService', ["_", "kendo", "$rootScope", "$timeout", "$http", "$log", "nimUtilityService", "InstancesWindowService", "pageObjectsService", "VizUtilityService", function VizTemplateService(_, kendo, $rootScope, $timeout, $http, $log,
                                                               nimUtilityService, InstancesWindowService, pageObjectsService, VizUtilityService) {
        return {
            setHtml: setHtml,
            buildDataSource: buildDataSource,
            viewRecord: viewRecord,
            requiredFiltersSet: requiredFiltersSet
        };
        ////////////////////
        /**
         * @function getTemplateValue
         * @param {string} data
         * @param {string} viz
         * @return {string} html string
         */
        function setHtml(data, viz) {
            if (!_.isEmpty(viz.settings.template)) {

                var pageSize = _.get(viz, 'settings.dataSource.pageSize');

                var dataItem = pageSize != 1 ? [] : {};
                var user = $rootScope.userData;

                if(!_.isEmpty(data)){
                    if(pageSize != 1){
                        dataItem = _.map(data, defaultPropsToBlank);
                    }
                    else {
                        dataItem = defaultPropsToBlank(data[0]);
                    }
                }

                var compileData = {
                    data: dataItem,
                    nim: nimUtilityService,
                    user: {
                        firstName: user.firstName,
                        lastName: user.lastName,
                        fullName: user.firstName + ' ' + user.lastName
                    }
                };

                try {
                    var templateString = viz.settings.template.replace(/&lt;/g, '<'),
                        escapedString = pageObjectsService.escapePoundSign(templateString);
                    return kendo.template(escapedString)(compileData);
                }
                catch(e){
                    $log.error('Error building HTML:', e);
                }
            }
            // Set Default text
            return angular.copy(viz.settings.defaultText) || '';
        }

        /**
         * Sets null values in dataItem to empty string
         * @param dataItem
         */
        function defaultPropsToBlank(dataItem){
            var newDataItem = {};

            _.forEach(dataItem, function(value, field){
                if(_.isNull(value) || _.isUndefined(value)){
                    newDataItem[field] = '';
                }
                else {
                    newDataItem[field] = value;
                }
            });

            return newDataItem;
        }

        /**
         * Build datasource for template views
         * @function buildDataSource
         * @param {object} pageObject
         * @param {object} scope - angularJs scope
         * @return {object} containing an Array of Columns and a Fields object
         */
        function buildDataSource(pageObject, scope) {
            // var resizeGridsterItem = scope.resizeGridsterItem || angular.noop;
            var dataSourceOptions = {
                type: 'odata',
                serverFiltering: true,
                serverSorting: true,
                serverPaging: true,
                serverAggregates: true,
                serverGrouping: false,
                pageSize: 1,
                transport: {
                    read: read
                },
                change: function(e){
                    var othis = e.sender;
                    scope.vizCtrl.data = othis.data();

                    var defaultText = angular.copy(pageObject.viz.settings.defaultText) || '';

                    if(requiredFiltersSet(pageObject, scope.filters) || _.isEmpty(pageObject.viz.settings.defaultText)) {
                        $timeout(function () {
                            var html = setHtml(scope.vizCtrl.data, pageObject.viz);
                            scope.usingTemplate = html !== defaultText;
                            scope.templateHtml = html;
                            scope.vizCtrl.templateHtml = scope.templateHtml;
                        });
                    }
                    else {
                        scope.templateHtml = defaultText;
                        scope.vizCtrl.templateHtml = scope.templateHtml;
                        scope.usingTemplate = false;
                    }

                    // $timeout(function () {
                    //     resizeGridsterItem();
                    // }, 1);
                },
                requestStart: function (e){
                    if(!requiredFiltersSet(pageObject, scope.filters)){
                        e.preventDefault();

                        $timeout(function(){
                            e.sender.success({d:{results: [], __count: 0}});
                        });

                        return false;
                    }
                }
            };

            var sortOptions = {
                sort: VizUtilityService.createSortArray(pageObject.viz.settings.dataSource)
            };

            var baseFilter = angular.copy(pageObject.viz.settings.dataSource.filter) || {
                    filters: [],
                    logic: 'and'
                };

            var filterOptions = {
                filter: {
                    filters: [baseFilter],
                    logic: pageObject.params.filterLogic || 'and'
                }
            };

            // Extend any user-defined dataSource settings
            angular.extend(dataSourceOptions, pageObject.viz.settings.dataSource, sortOptions, filterOptions);

            // Adds parse function to make sure date fields are correct
            _.forEach(dataSourceOptions.schema.model.fields, function (field) {
                if (field.type === 'date') {
                    field.parse = VizUtilityService.parseDateField;
                }
            });

            // Return new Datasource
            return new kendo.data.DataSource(dataSourceOptions);

            function read(options) {
                var httpOptions = VizUtilityService.buildBaseHttpOptions(pageObject, scope.isPreview);
                httpOptions.params = VizUtilityService.buildHttpParams(scope, dataSourceOptions, options);

                $http(httpOptions).then(function (result) {
                    options.success(result.data);
                }, function (result) {
                    options.error(result);
                });
            }
        }

        /**
         * Opens selected record in instance window
         * @function viewRecord
         * @param id
         */
        function viewRecord(id) {
            if(id) {
                InstancesWindowService.openWindow({
                    action: 'read',
                    instanceId: id
                });
            }
        }

        function requiredFiltersSet(pageObject, filters){
            var filtersSet = true;

            if(!_.isEmpty(pageObject.params.requiredFilters)){
                _.forEach(pageObject.params.requiredFilters, function(required, filter){
                    if(required && VizUtilityService.isFilterEmpty(filters[filter])){
                        filtersSet = false;
                    }
                });
            }

            return filtersSet;
        }
    }])
;
angular.module('cerberus.admin')
    .controller('AreaConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function AreaConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                          DesignerUtilityService, PagesDesignerListService,
                                                          pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;

        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.views = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = '';
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();

        vm.vizDict = vizListService.vizDictionary();
        vm.tabTemplates = [
            {name: 'General', url: 'admin/pages/designer/common/general-tab.tpl.html'},
            {name: 'Wrapper', url: 'admin/pages/designer/common/wrapper-tab.tpl.html'},
            {name: 'Data', url: 'admin/pages/designer/viz/area/area-data-tab.tpl.html'},
            {name: 'Filters', url: 'admin/pages/designer/common/filter-tab.tpl.html'},
            {name: 'Tools', url: 'admin/pages/designer/common/tools-tab.tpl.html'}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.colorbrewer = vizListService.colorbrewer();
        vm.seriesDataTypes = vizListService.colorbrewerDataTypes();
        vm.seriesDataTypeSizes = vizListService.colorbrewerDataTypeSizes();

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var settings = vm.temp.viz.settings;
            var type = settings.dataSource.schema.model.fields[colField].type;

            if(type === 'number' && !settings.series[0].field){ // Value Field
                settings.series[0].field = colField;
            }
            else if(!settings.categoryAxis.field){ // Category Field
                settings.categoryAxis.field = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var settings = vm.temp.viz.settings;
            var source = settings.dataSource;

            // Category
            if(settings.categoryAxis.field === colField){
                delete settings.categoryAxis.field;
            }

            // Value
            if(settings.series[0].field === colField){
                delete settings.series[0].field;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('BarConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function BarConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                        DesignerUtilityService, PagesDesignerListService,
                                                        pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.views = [];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();

        vm.vizDict = vizListService.vizDictionary();
        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/bar/bar-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.colorbrewer = vizListService.colorbrewer();
        vm.seriesDataTypes = vizListService.colorbrewerDataTypes();
        vm.seriesDataTypeSizes = vizListService.colorbrewerDataTypeSizes();

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var settings = vm.temp.viz.settings;
            var type = settings.dataSource.schema.model.fields[colField].type;

            if(type === 'number' && !settings.series[0].field){ // Value Field
                settings.series[0].field = colField;
            }
            else if(!settings.categoryAxis.field){ // Category Field
                settings.categoryAxis.field = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var settings = vm.temp.viz.settings;
            var source = settings.dataSource;

            // Category
            if(settings.categoryAxis.field === colField){
                delete settings.categoryAxis.field;
            }

            // Value
            if(settings.series[0].field === colField){
                delete settings.series[0].field;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('BubbleConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function BubbleConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                              DesignerUtilityService, PagesDesignerListService,
                                                              pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;

        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.views = [];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();

        vm.vizDict = vizListService.vizDictionary();

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/bubble/bubble-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.colorbrewer = vizListService.colorbrewer();
        vm.seriesDataTypes = vizListService.colorbrewerDataTypes();
        vm.seriesDataTypeSizes = vizListService.colorbrewerDataTypeSizes();

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var type = vm.temp.viz.settings.dataSource.schema.model.fields[colField].type;
            var series = vm.temp.viz.settings.series[0];

            if(type === 'number'){
                if(!series.xField){ // X-Value Field
                    series.xField = colField;
                }
                else if(!series.yField){ // Y-Value Field
                    series.yField = colField;
                }
                else if(!series.sizeField){ // Size Field
                    series.sizeField = colField;
                }
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;
            var series = vm.temp.viz.settings.series[0];

            // X-Value Field
            if(series.xField === colField){
                delete series.xField;
            }

            // Y-Value Field
            if(series.yField === colField){
                delete series.yField;
            }

            // Size Field
            if(series.sizeField === colField){
                delete series.sizeField;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('BulletConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", "WidgetsService", "$timeout", function BulletConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                              DesignerUtilityService, PagesDesignerListService,
                                                              pageObjectConfigService, ViewsService, vizListService, WidgetsService, $timeout) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.vizDict = vizListService.vizDictionary();
        vm.views = [];
        vm.widgets = [];
        vm.viewColumns = [];
        vm.editView =  vm.temp.viz.settings.dataSource['value'].nim_viewId;
        vm.editDataSource = 'value';
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };
        vm.formFieldsArray = [];
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/bullet/bullet-data-tab.tpl.html"},
            {name: "Record Actions", url: "admin/pages/designer/viz/bullet/records-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-multiple-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns, vm);

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.loadFormFields = _.partial(pageObjectConfigService.loadFormFields, vm);
        vm.setBaseWidget = setBaseWidget;
        vm.resetRecordFields = resetRecordFields;

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // DataSource Commands
        vm.setEditDataSource = function(id){
            vm.editDataSource = id;
            vm.editView =  vm.temp.viz.settings.dataSource[id].nim_viewId;
            vm.tempFilter = {};
            vm.filterType = null;
            vm.loadColumns(vm.editView);
        };

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init(){
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            WidgetsService.getWidgets().then(function(widgets){
                vm.widgets = widgets;
            });

            vm.loadColumns(vm.editView);
            vm.loadFormFields(pageObject.viz.widgetId);

            _.defaults(vm.temp.params, {
                defaultValues: {},
                requiredFilters: {
                    value: {},
                    target: {},
                    plot: {}
                }
            });

            _.forEach(vm.temp.viz.settings.dataSource, function(ds, id){
                pageObjectConfigService.updateSortConfig(ds);
                vm.temp.filterMap[id] = vm.temp.filterMap[id] || {};
            });

            vm.sortBySortableOptions = {
                ignore: "input,select",
                change: function (e) {
                    $timeout(function () {
                        pageObjectConfigService.reorderItem(vm.temp.viz.settings.dataSource[vm.editDataSource].sort, e.oldIndex, e.newIndex);
                    },0);
                }
            };
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var source = vm.temp.viz.settings.dataSource[vm.editDataSource];
            var schemaFields = source.schema.model.fields;
            var type = schemaFields[colField].type;
            var series = vm.temp.viz.settings.series[0];

            if(vm.editDataSource === 'value'){ // Value DataSource
                if(type === 'number' && !series.currentField){ // Current Value Field
                    series.currentField = colField;
                }
                else if(!series.categoryField){ // Category Field
                    series.categoryField = colField;
                }
            }
            else if(vm.editDataSource === 'target'){ // Target DataSource
                if(type === 'number' && !schemaFields.target.from){ // Target Value Field
                    schemaFields.target.from = colField;
                }
                else if(!schemaFields.category.from){ // Category Field (to match up to Current if more than one value)
                    schemaFields.category.from = colField;
                }
            }
            else if(vm.editDataSource === 'plot'){ // Plotband DataSource
                if(type === 'number' && !series.toField){ // Plotband "To" Field
                    series.toField = colField;
                }
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource[vm.editDataSource];
            var schemaFields = source.schema.model.fields;
            var series = vm.temp.viz.settings.series[0];

            if(vm.editDataSource === 'value'){ // Value DataSource
                // Current Value Field
                if(series.currentField === colField){
                    delete series.currentField;
                }

                // Category Field
                if(series.categoryField === colField){
                    delete series.categoryField;
                }
            }
            else if(vm.editDataSource === 'target'){ // Target DataSource
                // Target Value Field
                if(schemaFields.target.from === colField){
                    delete schemaFields.target.from;
                }

                // Category Field
                if(schemaFields.category.from === colField){
                    delete schemaFields.category.from;
                }
            }
            else if(vm.editDataSource === 'plot'){ // Plotband DataSource
                // Plotband "To" Field
                if(series.toField === colField){
                    delete series.toField;
                }
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        // Bullet-specific implementation for setBaseWidget
        function setBaseWidget(){
            if(vm.editDataSource === 'value') {
                var selectedView = _.find(vm.views, 'id', vm.editView);
                vm.temp.viz.widgetId = _.get(selectedView, 'base_widget_id');
                vm.loadFormFields = (vm.temp.viz.widgetId);
            }
        }

        function resetRecordFields(){
            vm.temp.params.defaultValues = {};
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('CalendarConfigCtrl', ["$scope", "$timeout", "$uibModalInstance", "toaster", "pageObject", "icons", "filters", "views", "pages", "PagesDesignerListService", "pageObjectConfigService", "DesignerUtilityService", "ViewsService", "vizListService", function CalendarConfigCtrl($scope, $timeout, $uibModalInstance, toaster, pageObject, icons,
                                                                  filters, views, pages, PagesDesignerListService, pageObjectConfigService,
                                                                  DesignerUtilityService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.icons = icons;
        vm.filters = filters;
        vm.views = views;
        vm.pages = pages;
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.jsonEdit = angular.toJson(vm.temp.viz.settings);
        vm.viewColumns = [];
        vm.viewDetails = {};
        vm.indexLookup = {};
        vm.editView =  null;
        vm.filterMap = {};

        vm.colSelected = {};
        vm.advCollapse = true;

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);

        vm.vizDict = vizListService.vizDictionary();

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/calendar/calendar-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.deleteProperty = pageObjectConfigService.deleteProperty;

        vm.onViewChange = function(viewId){
            for(var i = 0; i < vm.views.length; i++){
                if(vm.views[i].id === viewId){
                    vm.temp.query.create = vm.views[i].base_widget_id;
                    break;
                }
            }
        };
        // Helper functions
        vm.upper = function(s){
            return s.substr(0, 1).toUpperCase() + s.substr(1, s.length - 1);
        };

        vm.stripQuotes = function(s){
            return s.replace(/"/g, '');
        };

        // Load functions
        vm.loadColumns = function(vid){
            if(vid){
                ViewsService.getColumns(vid).then(function(columns){
                    vm.viewColumns[vid] = columns;
                });
            }
        };

        // Column selection
        vm.allSelected = function(view){
            if(vm.viewColumns[view]) {
                for (var vc = 0; vc < vm.viewColumns[view].length; vc++) {
                    if (!vm.isSelected(view, vm.viewColumns[view][vc])) {
                        return false;
                    }
                }
                return true;
            }
            else {
                return false;
            }
        };

        vm.isSelected = function(view, column){
            return vm.indexLookup[vm.stripQuotes(column.value)] >= 0;
        };

        vm.selectColumn = function(view, column){
            var value = vm.stripQuotes(column.value);
            if(column.type === 'property'){
                value = column.name;
            }
            vm.temp.query.from[view] = vm.temp.query.from[view] || {
                id: view,
                select: []
            };
            vm.temp.viz.settings.columns = vm.temp.viz.settings.columns || [];
            if(vm.isSelected(view, column)) {
                var index = vm.indexLookup[vm.stripQuotes(column.value)];

                if(index != null && index >= 0) {
                    vm.temp.viz.settings.columns.splice(index, 1);
                    delete vm.temp.viz.settings.dataSource.schema.model.fields[value];
                    vm.temp.query.from[view].select.splice(index, 1);
                    if(vm.temp.query.from[view].select.length < 1){
                        delete vm.temp.query.from[view];
                    }
                    delete vm.indexLookup[value];
                }
            }
            else {
                var fromColumn = {
                    type: column.type,
                    name: column.name,
                    value: column.value,
                    asLabel: column.name
                };
                var settingsColumn = {
                    field: value,
                    title: fromColumn.asLabel,
                    type: column.castType,
                    attributes: {},
                    format: column.format || '',
                    aggregates: [],
                    footerTemplate: ''
                };
                vm.temp.query.from[view].select.push(fromColumn);
                vm.temp.viz.settings.columns.push(settingsColumn);
                vm.temp.viz.settings.dataSource.schema.model.fields[value] = {
                    type: column.castType,
                    from: value
                };
            }
            $timeout(function(){
                vm.tableColumns = angular.copy(vm.temp.viz.settings.columns);
            });
            updateIndices(view, vm.temp.query, vm.indexLookup);
        };

        vm.selectAll = function(view, remove){
            if(vm.allSelected(view)) {
                var columns = vm.viewColumns[view];
                for(var col in columns){
                    if(columns.hasOwnProperty(col)){
                        vm.selectColumn(view, columns[col], remove);
                    }
                }
                delete vm.temp.query.from[view];
            }
            else {
                for(var c = 0; c < vm.viewColumns[view].length; c++){
                    if(!vm.isSelected(view, vm.viewColumns[view][c])){
                        vm.selectColumn(view, vm.viewColumns[view][c], remove);
                    }
                }
            }
        };

        // Change callbacks
        vm.updateLabel = function(view, col){
            var index = vm.indexLookup[vm.stripQuotes(col.value)];
            if(index != null && index >= 0 && vm.temp.viz.settings.columns[index]) {
                vm.temp.viz.settings.columns[index].title = angular.copy(vm.temp.query.from[view].select[index].asLabel);
                vm.tableColumns = angular.copy(vm.temp.viz.settings.columns);
            }
        };

        vm.resetValue = function(series, col){
            var value = vm.stripQuotes(col.value);
            var fields = [
                'categoryField',
                'field',
                'xField',
                'yField',
                'sizeField'
            ];
            for(var f = 0; f < fields.length; f++){
                var field = fields[f];
                if(series[0].hasOwnProperty(field) && series[0][field] == value){
                    series[0][field] = "";
                }
            }
        };

        vm.hasValue = function(series, col){
            for(var s = 0; s < series.length; s++){
                if(series[s].field == col.field){
                    return true;
                }
            }
            return false;
        };

        // View Commands
        vm.selectView = function(view, item){
            item.viewInfo = {id:view.id};
            item.id = view.originId;
            item.viewObject = view.viewObject;
        };

        vm.setEditView = function(query){
            if(query.from && Object.keys(query.from).length > 0 ){
                vm.editView = query.from[Object.keys(query.from)[0]].id;
            }
        };

        // Filter Commands
        vm.addFilterMap = function (item) {
            if(item.key) {
                vm.temp.filterMap = vm.temp.filterMap || {};
                vm.temp.filterMap[item.key] = item.value;
                item.key = null;
                item.value = null;
            }
        };

        vm.removeFilterMap = function (key) {
            delete vm.temp.filterMap[key];
        };

        // Custom Buttons
        vm.addCustomButton = function(pageObj){
            pageObj.tools.customButtons = pageObj.tools.customButtons || [];
            pageObj.tools.customButtons.push({});
        };

        vm.removeCustomButton = function(pageObj, index){
            if(pageObj.tools.customButtons && index < pageObj.tools.customButtons.length) {
                pageObj.tools.customButtons.splice(index, 1);
            }
        };

        // Modal Commands
        vm.save = function () {
            if($scope.form.$invalid){
                toaster.pop('warning', 'Form invalid', '');
            }
            else {
                if (vm.temp.wrapper.type === 'circletile') {
                    vm.temp.wrapper.header.style.background = vm.temp.wrapper.body.style.background;
                }
                vm.temp.wrapper.style.margin = DesignerUtilityService.arrayToCss(vm.margin);
                vm.temp.wrapper.style.padding = DesignerUtilityService.arrayToCss(vm.padding);
                $uibModalInstance.close(vm.temp);
            }
        };

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        // JSON Editor
        vm.editorOptions = function (_editor) {
            // Editor part
            var _doc = _editor.getDoc();
            // Options
            _editor.setOption('lineWrapping', true);
            _editor.setOption('lineNumbers', true);
            _editor.setOption('matchBrackets', true);
            _editor.setOption('autoCloseBrackets', true);
            _editor.setOption('mode', "application/ld+json");
            //Prep
            _doc.markClean();
//            _editor.focus();
            //Open
            _editor.setSize("100%", "300px");
            _editor.on("keyup", function (cm, event) {
                var keyCode = event.keyCode || event.which;
                if (keyCode === 192 && event.ctrlKey) {
                    var formatted_json = vm.formatJson(_editor.getValue());
                    _editor.setValue(formatted_json);
                }
                $timeout(function(){
                    vm.jsonEdit = _editor.getValue();
                    vm.temp.viz.settings = angular.fromJson(vm.jsonEdit);
                });
            });
        };

        vm.formatJson = function (json) {
            var i = 0,
                il = 0,
                tab = "  ",
                newJson = "",
                indentLevel = 0,
                inString = false,
                currentChar = null;

            for (i = 0, il = json.length; i < il; i += 1) {
                currentChar = json.charAt(i);

                switch (currentChar) {
                    case '{':
                    case '[':
                        if (!inString) {
                            newJson += currentChar + "\n" + repeat(tab, indentLevel + 1);
                            indentLevel += 1;
                        } else {
                            newJson += currentChar;
                        }
                        break;
                    case '}':
                    case ']':
                        if (!inString) {
                            indentLevel -= 1;
                            newJson += "\n" + repeat(tab, indentLevel) + currentChar;
                        } else {
                            newJson += currentChar;
                        }
                        break;
                    case ',':
                        if (!inString) {
                            newJson += ",\n" + repeat(tab, indentLevel);
                        } else {
                            newJson += currentChar;
                        }
                        break;
                    case ':':
                        if (!inString) {
                            newJson += ": ";
                        } else {
                            newJson += currentChar;
                        }
                        break;
                    case ' ':
                    case "\n":
                    case "\t":
                        if (inString) {
                            newJson += currentChar;
                        }
                        break;
                    case '"':
                        if (i > 0 && json.charAt(i - 1) !== '\\') {
                            inString = !inString;
                        }
                        newJson += currentChar;
                        break;
                    default:
                        newJson += currentChar;
                        break;
                }
            }
            return newJson;
        };


        //Init
        for (var queryView in vm.temp.query.from) {
            if (vm.temp.query.from.hasOwnProperty(queryView)) {
                updateIndices(queryView, vm.temp.query, vm.indexLookup);
            }
        }

        for(var v = 0; v < views.length; v++){
            vm.loadColumns(angular.copy(views[v].id));
        }

        vm.setEditView(vm.temp.query);
        vm.onViewChange(vm.editView);

        function repeat(s, count) {
            return new Array(count + 1).join(s);
        }

        function updateIndices(view, query, lookup){
            if(!query.from[view]){
                return;
            }
            var select = query.from[view].select;
            for(var vCol = 0; vCol < select.length; vCol++){
                lookup[vm.stripQuotes(select[vCol].value)] = vCol;
            }
        }

        /*
        function footerTemplateString(aggregate){
            return '<div>' + aggregate.nimLabel + ': #=' + aggregate.aggregate + '#</div>';
        }
        */
    }])
;
angular.module('cerberus.admin')
    .controller('DonutConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function DonutConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                            DesignerUtilityService, PagesDesignerListService,
                                                            pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.views = [];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/donut/donut-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];
        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();

        vm.vizDict = vizListService.vizDictionary();

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.colorbrewer = vizListService.colorbrewer();
        vm.seriesDataTypes = vizListService.colorbrewerDataTypes();
        vm.seriesDataTypeSizes = vizListService.colorbrewerDataTypeSizes();

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var settings = vm.temp.viz.settings;
            var type = settings.dataSource.schema.model.fields[colField].type;

            if(type === 'number' && !settings.series[0].field){ // Value Field
                settings.series[0].field = colField;
            }
            else if(!settings.seriesDefaults.donut.categoryField){ // Category Field
                settings.seriesDefaults.donut.categoryField = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var settings = vm.temp.viz.settings;
            var source = settings.dataSource;

            // Category
            if(settings.seriesDefaults.donut.categoryField === colField){
                delete settings.seriesDefaults.donut.categoryField;
            }

            // Value
            if(settings.series[0].field === colField){
                delete settings.series[0].field;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FunnelConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function FunnelConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                            DesignerUtilityService, PagesDesignerListService,
                                                            pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.views = [];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/funnel/funnel-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];
        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();
        vm.labelAlignments = [
            {value: 'center', display: 'Center'},
            {value: 'right', display: 'Right'},
            {value: 'left', display: 'Left'}
        ];

        vm.vizDict = vizListService.vizDictionary();

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.colorbrewer = vizListService.colorbrewer();
        vm.seriesDataTypes = vizListService.colorbrewerDataTypes();
        vm.seriesDataTypeSizes = vizListService.colorbrewerDataTypeSizes();

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // Load functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var settings = vm.temp.viz.settings;
            var type = settings.dataSource.schema.model.fields[colField].type;

            if(type === 'number' && !settings.series[0].field){ // Value Field
                settings.series[0].field = colField;
            }
            else if(!settings.seriesDefaults.funnel.categoryField){ // Category Field
                settings.seriesDefaults.funnel.categoryField = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var settings = vm.temp.viz.settings;
            var source = settings.dataSource;

            // Category
            if(settings.seriesDefaults.funnel.categoryField === colField){
                delete settings.seriesDefaults.funnel.categoryField;
            }

            // Value
            if(settings.series[0].field === colField){
                delete settings.series[0].field;
            }

            // Sort By
            if(_.get(source, 'sort.field') === colField){
                delete source.sort;
            }

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('GanttConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function GanttConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                            DesignerUtilityService, PagesDesignerListService,
                                                            pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.views = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.geoProperties = [
            { value: 'formatted_address', display: 'Full Address' },
            { value: 'postal_address', display: 'Postal Address' },
            { value: 'country_long_name', display: 'Country (Long)' },
            { value: 'country_short_name', display: 'Country (Short)' },
            { value: 'administrative_area_level_1_long_name', display: 'State (Long)' },
            { value: 'administrative_area_level_1_short_name', display: 'State (Short)' },
            { value: 'administrative_area_level_2_long_name', display: 'County (Long)' },
            { value: 'administrative_area_level_2_short_name', display: 'County (Short)' },
            { value: 'locality_long_name', display: 'City (Long)' },
            { value: 'locality_short_name', display: 'City (Short)' },
            { value: 'postal_code_long_name', display: 'ZIP (Long)' },
            { value: 'postal_code_short_name', display: 'ZIP (Short)' },
            { value: 'street_address', display: 'Street Address' }
        ];

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/gantt/gantt-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.calendarViews = [
            // { value: 'day', display: 'Day' },
            { value: 'week', display: 'Week' },
            { value: 'month', display: 'Month' }
        ];

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);

        vm.vizDict = vizListService.vizDictionary();

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        vm.selectedCalendarView = selectedCalendarView;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            vm.loadColumns(vm.editView);

            if (vm.temp.viz.settings.views[0] == 'day'){
                vm.temp.viz.settings.views = [
                    { type: "week", selected: false },
                    { type: "month", selected: true }
                ];
            }

            _.defaults(vm.temp.viz.settings, { height: 600 });
            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var model = vm.temp.viz.settings.dataSource.schema.model;
            var type = model.fields[colField].type;

            if (type === 'number') {
                if(!model.percentComplete){ // Completion Percentage
                    model.percentComplete = colField;
                }
                // else if (!fields.orderId.from) { // Sort Order ID
                //     fields.orderId.from = colField;
                // }
            }
            else if(type === 'date'){
                if(!model.start){ // Start Date
                    model.start = colField;
                }
                else if(!model.end){ // End Date
                    model.end = colField;
                }
            }
            else if(!model.title) { // Title
                model.title = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;
            var model = source.schema.model;

            // Title
            if(model.title === colField){
                delete model.title;
            }

            // WBS
            if(model.wbs === colField){
                delete model.wbs;
            }

            // Parent ID
            if(model.parentId === colField){
                delete model.parentId;
            }

            // Start Date
            if(model.start === colField){
                delete model.start;
            }

            // End Date
            if(model.end === colField){
                delete model.end;
            }

            // Completion Percentage
            if(model.percentComplete === colField){
                delete model.percentComplete;
            }

            // // Sort Order ID
            // if(fields.orderId.from === colField){
            //     delete fields.orderId.from;
            // }

            // // Show Summary
            // if(fields.summary.from === colField){
            //     delete fields.summary.from;
            // }

            // // Task Expanded
            // if(fields.expanded.from === colField){
            //     delete fields.expanded.from;
            // }

            // Dependency
            if(model.dependency === colField){
                delete model.dependency;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        // Getter/Setter for selected calendar view
        function selectedCalendarView(type){
            var views = vm.temp.viz.settings.views;
            if(arguments.length){
                _.forEach(views, function(view){
                    view.selected = view.type === type;
                });

                return type;
            }
            else {
                var selectedView = _.find(views, 'selected', true);
                return selectedView.type;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('KanbanConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", "WidgetsService", "WidgetsSettingsService", function KanbanConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                            DesignerUtilityService, PagesDesignerListService, pageObjectConfigService,
                                                            ViewsService, vizListService, WidgetsService, WidgetsSettingsService) {
        var vm = this;

        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.views = [];
        vm.widgets = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.viewColumns = [];
        vm.editView =  vm.temp.viz.settings.dataSource.nim_viewId;
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/kanban/data-tab.tpl.html"},
            {name: "Record Actions", url: "admin/pages/designer/viz/kanban/records-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];
        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        /* LODASH Version 4 ONLY */
        //vm.editorTools = _.reject(vm.textEditorOptions.tools, ['name', 'nimViewHtml']);
        /* LODASH Version 3 & 4 Compatibility Mode */
        vm.editorTools = _.reject(vm.textEditorOptions.tools, function(r){return r.name === 'nimViewHtml';});
        vm.formFieldsArray = [];
        vm.categories = [];

        vm.aggregate = {
            field: null,
            aggregate: null,
            nimLabel: ''
        };

        vm.aggregateFunctions = [
            {value:'sum', display:'Sum'},
            {value:'count', display:'Count'}/*,
            {value:'avg', display:'Average'}*/
        ];

        vm.titleClasses = [
            {value: 'bg-default', display: 'Default'},
            {value: 'bg-primary', display: 'Primary'},
            {value: 'bg-success', display: 'Success'},
            {value: 'bg-danger', display: 'Danger'},
            {value: 'bg-warning', display: 'Warning'},
            {value: 'bg-info', display: 'Info'}
        ];

        vm.vizDict = vizListService.vizDictionary();

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);
        vm.aggregateSortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.aggregate);
        vm.listViewTemplatePresets = PagesDesignerListService.kanbanTemplatePresets();

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;
        vm.loadCategories = _.partial(pageObjectConfigService.loadCategories, vm);

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;
        vm.preventSpace = DesignerUtilityService.preventSpace;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.loadFormFields = _.partial(pageObjectConfigService.loadFormFields, vm);
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);
        vm.resetRecordFields = resetRecordFields;

        // Column selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        vm.addCategory = function(){
            var newCategory = {
                display: '',
                id: ''
            };

            vm.temp.params.customCategories.push(newCategory);
        };

        // Aggregates
        vm.addAggregate = function(aggregate){
            vm.temp.viz.settings.dataSource.schema.aggregates = 'nim_aggregate';
            vm.temp.viz.settings.dataSource.aggregate = vm.temp.viz.settings.dataSource.aggregate || [];
            vm.temp.viz.settings.dataSource.aggregate.push(angular.copy(aggregate));

            for(var c = 0; c < vm.temp.viz.settings.columns.length; c++){
                var column = vm.temp.viz.settings.columns[c];
                if(column.field == aggregate.field){
                    if(column.aggregates.indexOf(aggregate.aggregate) == -1) {
                        column.aggregates.push(aggregate.aggregate);
                    }
                    break;
                }
            }

            aggregate.field = null;
            aggregate.format = null;
            aggregate.aggregate = null;
            aggregate.nimLabel = '';
        };

        vm.removeAggregate = function(aggregate, index){
            vm.temp.viz.settings.dataSource.aggregate.splice(index, 1);

            _.forEach(vm.temp.viz.settings.columns, function (column) {
                if(column.field == aggregate.field){
                    column.aggregates.splice(column.aggregates.indexOf(aggregate.aggregate), 1);
                    return false;
                }
            });
        };

        //Init
        init();

        function init(){
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            vm.loadColumns(vm.editView);
            loadFormFields(pageObject.viz.widgetId);

            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);

            WidgetsService.getWidgets().then(function(widgets){
                vm.widgets = widgets;
            });

            _.defaults(vm.temp.params, {
                customCategories: [],
                openOnSelect: true,
                allowSortChange: vm.temp.params.editable,
                allowCategoryChange:  vm.temp.params.editable,
                showNewButton: true,
                defaultValues: {},
                requiredFilters: {},
                routeSettings: {
                    enabled: false,
                    newTab: false,
                    template: ''
                }
            });

            if(vm.temp.params.binField) {
                vm.loadCategories(vm.temp.params.binField);
            }

            vm.categorySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.params.customCategories);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var source = vm.temp.viz.settings.dataSource;
            var schemaFields = source.schema.model.fields;
            var type = schemaFields[colField].type;
            var params = vm.temp.params;

            if(type === 'number' && !params.orderKey){ // Item Order Field
                params.orderKey = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;
            var params = vm.temp.params;

            // Item Category Field
            if(params.binKey === colField){
                delete params.binKey;
            }

            // Item Order Field
            if(params.orderKey === colField){
                delete params.orderKey;
            }

            // Sort By
            if(_.get(source, 'sort.field') === colField){
                delete source.sort;
            }

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        function loadFormFields(widgetId){
            if(widgetId) {
                WidgetsSettingsService.getFormFields(widgetId).then(function (data) {
                    vm.formFieldsArray = WidgetsSettingsService.parseFormObjects(data.display);
                });
            }
        }

        function resetRecordFields(){
            vm.temp.params.binField = null;
            vm.temp.params.orderField = null;
            vm.temp.params.defaultValues = {};
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('LineConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function LineConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                          DesignerUtilityService, PagesDesignerListService,
                                                          pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.views = [];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/line/line-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();

        vm.vizDict = vizListService.vizDictionary();

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.colorbrewer = vizListService.colorbrewer();
        vm.seriesDataTypes = vizListService.colorbrewerDataTypes();
        vm.seriesDataTypeSizes = vizListService.colorbrewerDataTypeSizes();

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var settings = vm.temp.viz.settings;
            var type = settings.dataSource.schema.model.fields[colField].type;

            if(type === 'number' && !settings.series[0].field){ // Value Field
                settings.series[0].field = colField;
            }
            else if(!settings.categoryAxis.field){ // Category Field
                settings.categoryAxis.field = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var settings = vm.temp.viz.settings;
            var source = settings.dataSource;

            // Category
            if(settings.categoryAxis.field === colField){
                delete settings.categoryAxis.field;
            }

            // Value
            if(settings.series[0].field === colField){
                delete settings.series[0].field;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('ListConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", "WidgetsService", function ListConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                          DesignerUtilityService, PagesDesignerListService,
                                                          pageObjectConfigService, ViewsService, vizListService, WidgetsService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.views = [];
        vm.widgets = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');

        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.formFieldsArray = [];
        vm.idArray = _.compact(_.map(filters, 'id'));
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        /* LODASH Version 4 ONLY */
        //vm.editorTools = _.reject(vm.textEditorOptions.tools, ['name', 'nimViewHtml']);
        /* LODASH Version 3 & 4 Compatibility Mode */
        vm.editorTools = _.reject(vm.textEditorOptions.tools, function(r){return r.name === 'nimViewHtml';});

        vm.vizDict = vizListService.vizDictionary();
        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/list/list-data-tab.tpl.html"},
            {name: "Record Actions", url: "admin/pages/designer/viz/list/records-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);
        vm.listViewTemplatePresets = PagesDesignerListService.listViewTemplatePresets();

        vm.templateChanged = function(){
            vm.temp.params.variant = 'none';
            var fields = vm.temp.viz.settings.dataSource.schema.model.fields;
            if(vm.temp.viz.settings.template === 'contacts'){
                fields.title.from = '';
                fields.description.from = '';
            }
            else {
                fields.name.from = '';
                fields.email.from = '';
            }
        };

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;
        vm.preventSpace = DesignerUtilityService.preventSpace;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.loadFormFields = _.partial(pageObjectConfigService.loadFormFields, vm);
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);
        vm.resetRecordFields = resetRecordFields;

        // Column selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            WidgetsService.getWidgets().then(function(widgets){
                vm.widgets = widgets;
            });
            
            vm.loadFormFields(pageObject.viz.widgetId);

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(/*colField*/){ /* There was some code here, but it's gone now */ }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }

            if(_.get(vm.temp.params, 'uploadFilename.modelId') === colField){
                delete vm.temp.params.uploadFilename;
            }

            if(_.get(vm.temp.params, 'uploadImageField.modelId') === colField){
                delete vm.temp.params.uploadImageField;
            }
        }

        function resetRecordFields(){
            vm.temp.params.uploadFilename = null;
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('MapConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "LeafletListService", "ViewsService", "vizListService", "WidgetsService", "$timeout", "kendo", function MapConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                        DesignerUtilityService, PagesDesignerListService, pageObjectConfigService,
                                                        LeafletListService, ViewsService, vizListService, WidgetsService, $timeout, kendo) {
        var vm = this;

        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters= filters;
        vm.views = [];
        vm.widgets = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.markerColors = PagesDesignerListService.markerColors();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];

        vm.viewColumns = [];
        vm.editView =  null;
        vm.editDataSource =  null;
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.idArray = [];
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };
        vm.formFieldsArray = [];

        vm.basemaps = _.defaults(LeafletListService.basemaps(), LeafletListService.layers(false));
        vm.overlays = LeafletListService.layers();
        vm.usesUrl = LeafletListService.usesUrlLookUp();
        vm.layerType = LeafletListService.layerTypeLookUp();

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);

        vm.vizDict = vizListService.vizDictionary();

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/map/data-tab.tpl.html"},
            {name: "Record Actions", url: "admin/pages/designer/viz/map/records-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-multiple-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.colors = [
            {value: 'none', display: 'None'},
            {value: 'default', display: 'Default'},
            {value: 'red', display: 'Red'},
            {value: 'orange', display: 'Orange'},
            {value: 'yellow', display: 'Yellow'},
            {value: 'green', display: 'Green'},
            {value: 'blue', display: 'Blue'},
            {value: 'purple', display: 'Purple'}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns, vm);
        vm.sortBasemapOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.basemaps);
        vm.sortOverlayOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.overlays);

        vm.percentSliderOptions = {
            min: 0,
            max: 1,
            smallStep: 0.01,
            largeStep: 0.1,
            tickPlacement: 'none',
            tooltip: {
                format: '{0:p0}'
            }
        };

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.labelToUniqueId = function (item){
            item.id = DesignerUtilityService.labelToUniqueId(item.label, vm.idArray);
        };

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        vm.toPercentageString = function(val){
            //return Math.round(val * 100) + '%';
            return kendo.format('{0:p0}', val);
        };

        // Map functions
        vm.addLayer = function(array){
            array.push({
                name: '',
                type: null,
                visible: false,
                settings: {
                    opacity: 1
                }
            });
        };

        vm.addGroup = function(groupColors){
            groupColors.push({
                group: null,
                color: null
            });
        };

        vm.checkBasemapVisibility = function(index, visible, basemaps){
            if(visible){
                for(var i = 0; i < basemaps.length; i++){
                    if(i !== index && basemaps[i]){
                        basemaps[i].visible = false;
                    }
                }
            }
        };

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.loadFormFields = _.partial(pageObjectConfigService.loadFormFields, vm);
        vm.setBaseWidget = setBaseWidget;
        vm.resetRecordFields = resetRecordFields;

        // Column selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        vm.addDataSource = function(dataSources, columns){
            var ids = Object.keys(dataSources);
            var max = 0;
            for(var i = 0; i < ids.length; i++){
                var id = parseInt(ids[i].replace(/^ds/, ''));
                if(id > max){
                    max = id;
                }
            }
            var newId = 'ds' + (max + 1);
            dataSources[newId] = {
                schema: {
                    model: {
                        fields: {
                            location: {from: '', type: ''},
                            title: {from: '', type: 'string'},
                            category: {from: '', type: 'string'}
                        }
                    }
                },
                aggregate: [],
                filter: {
                    filters: [],
                    logic: 'and'
                }
            };
            columns[newId] = [];
            vm.temp.filterMap[newId] = {};
            vm.temp.viz.settings.groupColors[newId] = [
                {
                    group: '_default',
                    color: 'cyan'
                }
            ];
        };
        // DataSource
        vm.setEditDataSource = function(id){
            vm.editDataSource = id;
            vm.editView =  vm.temp.viz.settings.dataSource[id].nim_viewId;
            vm.tempFilter = {};
            vm.filterType = null;
            vm.loadColumns(vm.editView);
        };

        vm.removeDataSource = function(id){
            if(vm.editDataSource === id){
                vm.editDataSource = null;
                vm.editView = null;
            }
            delete vm.temp.viz.settings.columns[id];
            delete vm.temp.viz.settings.dataSource[id];
            delete vm.temp.viz.settings.groupColors[id];
            delete vm.temp.filterMap[id];
        };

        vm.setLocationType = function(schemaFields){
            schemaFields.location.type = schemaFields[schemaFields.location.from].type;
        };

        //Init
        init();

        function init(){
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            vm.loadFormFields(pageObject.viz.widgetId);

            WidgetsService.getWidgets().then(function(widgets){
                vm.widgets = widgets;
            });

            for(var i = 0; i < filters.length; i++){
                if(filters[i].id){
                    vm.idArray.push(filters[i].id);
                }
            }

            _.defaults(vm.temp.params, {
                defaultValues: {},
                requiredFilters: {}
            });

            for(var j = 0; j < vm.temp.viz.settings.overlays.length; j++){
                var overlay = vm.temp.viz.settings.overlays[j];

                if(!overlay.hasOwnProperty('settings')){
                    overlay.settings = {opacity: 1};
                }
                else if(!overlay.settings.hasOwnProperty('opacity')){
                    overlay.settings.opacity = 1;
                }
            }

            _.forEach(vm.temp.viz.settings.dataSource, function(ds, id){
                vm.temp.filterMap[id] = vm.temp.filterMap[id] || {};
                vm.temp.params.requiredFilters[id] = vm.temp.params.requiredFilters[id] || {};
                pageObjectConfigService.updateSortConfig(ds);
            });

            vm.sortBySortableOptions = {
                ignore: "input,select",
                change: function (e) {
                    $timeout(function () {
                        pageObjectConfigService.reorderItem(vm.temp.viz.settings.dataSource[vm.editDataSource].sort, e.oldIndex, e.newIndex);
                    },0);
                }
            };
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var source = vm.temp.viz.settings.dataSource[vm.editDataSource];
            var schemaFields = source.schema.model.fields;

            if(schemaFields[colField].type === 'location' && !schemaFields.location.from){ // Location
                schemaFields.location.from = colField;
            }
            else if(!schemaFields.title.from){ // Title
                schemaFields.title.from = colField;
            }
            else if(!schemaFields.category.from){ // Category
                schemaFields.category.from = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource[vm.editDataSource];
            var schemaFields = source.schema.model.fields;

            // Location
            if(schemaFields.location.from === colField){
                delete schemaFields.location.from;
            }

            // Title
            if(schemaFields.title.from === colField){
                delete schemaFields.title.from;
            }

            // Category
            if(schemaFields.category.from === colField){
                delete schemaFields.category.from;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        // Map-specific implementation for setBaseWidget
        function setBaseWidget(){
            // Only automatically set base widget if not already set.
            // This is important since this page object has multiple data sources.
            if(!vm.temp.viz.widgetId) {
                var selectedView = _.find(vm.views, 'id', vm.editView);
                vm.temp.viz.widgetId = _.get(selectedView, 'base_widget_id');
                vm.loadFormFields = (vm.temp.viz.widgetId);
            }
        }

        function resetRecordFields(){
            vm.temp.params.defaultValues = {};
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('PieConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function PieConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                        DesignerUtilityService, PagesDesignerListService,
                                                        pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.views = [];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();

        vm.vizDict = vizListService.vizDictionary();

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/pie/pie-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.colorbrewer = vizListService.colorbrewer();
        vm.seriesDataTypes = vizListService.colorbrewerDataTypes();
        vm.seriesDataTypeSizes = vizListService.colorbrewerDataTypeSizes();

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var type = vm.temp.viz.settings.dataSource.schema.model.fields[colField].type;
            var series = vm.temp.viz.settings.series[0];

            if(type === 'number' && !series.field){ // Value Field
                series.field = colField;
            }
            else if(!series.categoryField){ // Category Field
                series.categoryField = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;
            var series = vm.temp.viz.settings.series[0];

            // Category
            if(series.categoryField === colField){
                delete series.categoryField;
            }

            // Value
            if(series.field === colField){
                delete series.field;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('ProgressConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function ProgressConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                                  DesignerUtilityService, PagesDesignerListService,
                                                                  pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;

        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.views = [];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);

        vm.vizDict = vizListService.vizDictionary();

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/progress/progress-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillArray = _.fill;
        vm.parseInt = parseInt;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            // Sum Aggregate Field
            if(!vm.temp.viz.settings.dataSource.aggregate[0].field){
                vm.temp.viz.settings.dataSource.aggregate[0].field = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;

            // Sum Aggregate Field
            if(source.aggregate[0].field === colField){
                delete source.aggregate[0].field;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('ScatterConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function ScatterConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                                DesignerUtilityService, PagesDesignerListService,
                                                                pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.views = [];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.labelFormats = pageObjectConfigService.chartLabelFormats();

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/scatter/scatter-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.vizDict = vizListService.vizDictionary();

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.dataVizThemes = PagesDesignerListService.dataVizThemes();
        vm.colorbrewer = vizListService.colorbrewer();
        vm.seriesDataTypes = vizListService.colorbrewerDataTypes();
        vm.seriesDataTypeSizes = vizListService.colorbrewerDataTypeSizes();

        vm.addColorToSeries = pageObjectConfigService.addColorToSeries;

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column Selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var type = vm.temp.viz.settings.dataSource.schema.model.fields[colField].type;
            var series = vm.temp.viz.settings.series[0];

            if(type === 'number'){
                if(!series.xField){ // X-Value Field
                    series.xField = colField;
                }
                else if(!series.yField){ // Y-Value Field
                    series.yField = colField;
                }
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;
            var series = vm.temp.viz.settings.series[0];

            // X-Value
            if(series.xField === colField){
                delete series.xField;
            }

            // Y-Value
            if(series.yField === colField){
                delete series.yField;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('ScheduleConfigCtrl', ["_", "$scope", "$timeout", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", "WidgetsService", "WidgetsSettingsService", function ScheduleConfigCtrl(_, $scope, $timeout, $uibModalInstance, pageObject, filters,
                                                                  DesignerUtilityService, PagesDesignerListService, pageObjectConfigService,
                                                                  ViewsService, vizListService, WidgetsService, WidgetsSettingsService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.views = [];
        vm.widgets = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.viewColumns = [];
        vm.editView =  null;
        vm.editDataSource =  null;
        vm.filterMap = {};
        vm.repeatable = true;
        vm.tempFilter = {};
        vm.filterType = null;
        vm.idArray = [];
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };
        vm.formFieldsArray = [];
        vm.secondaryFieldsArray = [];

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);

        vm.vizDict = vizListService.vizDictionary();
        vm.defaultColorOptions = vizListService.colorbrewer().qualitative.Paired[12];

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/schedule/data-tab.tpl.html"},
            {name: "Record Actions", url: "admin/pages/designer/viz/schedule/records-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-multiple-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.calendarViews = [
            { value: 'day', display: 'Day' },
            { value: 'workWeek', display: 'Work Week' },
            { value: 'week', display: 'Week' },
            { value: 'month', display: 'Month' }
        ];

        vm.icsTimeUnitTypes = [
            {value: 'S', display: 'Seconds'},
            {value: 'M', display: 'Minutes'},
            {value: 'H', display: 'Hours'},
            {value: 'D', display: 'Days'},
            {value: 'W', display: 'Weeks'}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns, vm);

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);
        vm.dataSourceViewSelected = dataSourceViewSelected;

        // Widget functions
        vm.loadFormFields = _.partial(pageObjectConfigService.loadFormFields, vm);
        vm.setBaseWidget = setBaseWidget;
        vm.resetRecordFields = resetRecordFields;

        vm.loadSecondaryWidget = loadSecondaryWidget;

        // Column selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        vm.selectedCalendarView = selectedCalendarView;

        // DataSource Commands
        vm.addDataSource = function(dataSources, columns){
            var ids = Object.keys(dataSources);
            var max = 0;
            for(var i = 0; i < ids.length; i++){
                var id = parseInt(ids[i].replace(/^ds/, ''));
                if(id > max){
                    max = id;
                }
            }
            var newId = 'ds' + (max + 1);
            dataSources[newId] = {
                aggregate: [],
                schema: {
                    model: {
                        id: "id",
                        fields: {
                            taskId: { from: "TaskID", type: "number" },
                            title: { defaultValue: "No title", validation: { required: true } },
                            start: { type: "date" },
                            end: { type: "date" },
                            startTimezone: { from: "StartTimezone" },
                            endTimezone: { from: "EndTimezone" },
                            description: { from: "Description" },
                            recurrenceId: { from: "__nimRRuleId" },
                            recurrenceRule: { from: "__nimRRule" },
                            recurrenceException: { from: "__nimRRuleEx" },
                            ownerId: { from: "OwnerID", defaultValue: 1 },
                            isAllDay: { type: "boolean", from: "IsAllDay" }
                        }
                    }
                },
                filter: {
                    filters: [],
                    logic: 'and'
                }
            };
            columns[newId] = [];
            vm.temp.viz.settings.resources[newId] = {field: '', defaultColor: '#005683', dataSource: []};
            vm.temp.filterMap[newId] = {};
        };

        vm.setEditDataSource = function(id){
            vm.editDataSource = id;
            vm.editView =  vm.temp.viz.settings.dataSource[id].nim_viewId;
            vm.tempFilter = {};
            vm.filterType = null;
            vm.loadColumns(vm.editView);
        };

        vm.removeDataSource = function(id){
            if(vm.editDataSource === id){
                vm.editDataSource = null;
                vm.editView = null;
            }

            delete vm.temp.viz.settings.columns[id];
            delete vm.temp.viz.settings.dataSource[id];
            delete vm.temp.viz.settings.resources[id];
            delete vm.temp.filterMap[id];
        };

        vm.addColorCategory = function(resources){
            var color = vm.defaultColorOptions[11];
            if(resources.dataSource.length < 12){
                color = vm.defaultColorOptions[resources.dataSource.length];
            }

            resources.dataSource.push({
                color: color,
                value: ''
            });
        };

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init(){
            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            vm.loadFormFields(pageObject.viz.widgetId);

            WidgetsService.getWidgets().then(function(widgets){
                vm.widgets = widgets;
            });

            for(var i = 0; i < filters.length; i++){
                if(filters[i].id){
                    vm.idArray.push(filters[i].id);
                }
            }

            _.defaults(vm.temp.params, {
                openOnSelect: true,
                allowMove: false,
                createOnClick: true,
                eventTemplates: {},
                defaultValues: {},
                requiredFilters: {},
                reminderBeforeAmount: 15,
                reminderBeforeUnit: 'M'
            });

            if(_.isString(vm.temp.viz.settings.workDayStart)){
                vm.temp.viz.settings.workDayStart = new Date(vm.temp.viz.settings.workDayStart);
            }
            if(_.isString(vm.temp.viz.settings.workDayEnd)){
                vm.temp.viz.settings.workDayEnd = new Date(vm.temp.viz.settings.workDayEnd);
            }

            // Fixes old configuration by making all views objects which can then be configured
            _.forEach(vm.temp.viz.settings.views, function(view, index, viewArray){
                if(_.isString(view)){
                    viewArray[index] = { type: view, selected: false };
                }
            });

            if(!_.has(vm.temp, 'viz.settings.resources')){
                vm.temp.viz.settings.resources = {};

                _.forEach(vm.temp.viz.settings.dataSource, function(ds, id){
                    vm.temp.viz.settings.resources[id] = {field: '', defaultColor: '#005683', dataSource: []};
                    vm.temp.filterMap[id] = vm.temp.filterMap[id] || {};
                    vm.temp.params.requiredFilters[id] = vm.temp.params.requiredFilters[id] || {};

                    pageObjectConfigService.updateSortConfig(ds);
                });
            }
            else {
                _.forEach(vm.temp.viz.settings.dataSource, function(ds, id){
                    pageObjectConfigService.updateSortConfig(ds);
                    vm.temp.filterMap[id] = vm.temp.filterMap[id] || {};
                    vm.temp.params.requiredFilters[id] = vm.temp.params.requiredFilters[id] || {};
                });
            }

            vm.sortBySortableOptions = {
                ignore: "input,select",
                change: function (e) {
                    $timeout(function () {
                        pageObjectConfigService.reorderItem(vm.temp.viz.settings.dataSource[vm.editDataSource].sort, e.oldIndex, e.newIndex);
                    },0);
                }
            };
        }

        // Controller-specific functions
        function onColumnAdded(colField){ // Fills in fields by default when column is selected
            var source = vm.temp.viz.settings.dataSource[vm.editDataSource];
            var schemaFields = source.schema.model.fields;

            // Date Fields
            if(schemaFields[colField].type === 'date'){
                if(!schemaFields.start.from){ // Start Date
                    schemaFields.start.from = colField;
                }
                else if(!schemaFields.end.from){ // End Date
                    schemaFields.end.from = colField;
                }
            }
            else if(!schemaFields.title.from){ // Title
                schemaFields.title.from = colField;
            }
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource[vm.editDataSource];
            var schemaFields = source.schema.model.fields;

            // Start Date
            if(schemaFields.start.from === colField){
                delete schemaFields.start.from;
            }

            // End Date
            if(schemaFields.end.from === colField){
                delete schemaFields.end.from;
            }

            // Title
            if(schemaFields.title.from === colField){
                delete schemaFields.title.from;
            }

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        function dataSourceViewSelected() {
            vm.onViewChange(vm.temp.viz.settings.dataSource[vm.editDataSource], vm.temp.viz.settings.columns[vm.editDataSource], vm.editView);
            vm.setBaseWidget(vm.editView, true);
            vm.temp.viz.settings.dataSource[vm.editDataSource].sort = [];
            vm.temp.viz.settings.dataSource[vm.editDataSource].secondaryFieldMap = {};
            vm.temp.viz.settings.dataSource[vm.editDataSource].nim_widgetId = '';
        }

        // Scheduler-specific implementation for setBaseWidget
        function setBaseWidget(){
            // Only automatically set base widget if not already set.
            // This is important since this page object has multiple data sources.
            if(!vm.temp.viz.widgetId) {
                var selectedView = _.find(vm.views, 'id', vm.editView);
                vm.temp.viz.widgetId = _.get(selectedView, 'base_widget_id');
                vm.loadFormFields = (vm.temp.viz.widgetId);
            }
        }

        function resetRecordFields(){
            vm.temp.params.startDateField = null;
            vm.temp.params.endDateField = null;
            vm.temp.params.defaultValues = {};
        }

        // Getter/Setter for selected calendar view
        function selectedCalendarView(type){
            var views = vm.temp.viz.settings.views;
            if(arguments.length){
                _.forEach(views, function(view){
                    view.selected = view.type === type;
                });

                return type;
            }
            else {
                var selectedView = _.find(views, 'selected', true);
                return selectedView.type;
            }
        }

        function loadSecondaryWidget(dsId) {
            var ds = vm.temp.viz.settings.dataSource[dsId];

            if (ds.nim_widgetId) {
                WidgetsSettingsService.getFormFields(ds.nim_widgetId).then(function (data) {
                    vm.secondaryFieldsArray = WidgetsSettingsService.parseFormObjects(data.display);
                });
            }
            else {
                vm.secondaryFieldsArray = [];
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('TableConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "pageObjectsService", "ViewsService", "vizListService", "WidgetsService", function TableConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters, DesignerUtilityService,
                                                            PagesDesignerListService, pageObjectConfigService,
                                                            pageObjectsService, ViewsService, vizListService, WidgetsService) {
        var vm = this;

        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.views = [];
        vm.widgets = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.jsonEdit = angular.toJson(vm.temp.viz.settings);
        vm.viewColumns = [];
        vm.detailColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');
        vm.filterMap = {};
        vm.tempFilter = {};
        vm.repeatable = true;
        vm.useColAsFilterVal = false;
        vm.tempDefaultData = {};
        vm.formFieldsArray = [];
        vm.filterType = '';
        vm.idArray = [];
        vm.detailObject = {
            column: 'id'
        };
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.condition = [];
        vm.conditionType = [];
        vm.isColumnValue = [];

        vm.aggregate = {
            field: null,
            aggregate: null,
            nimLabel: ''
        };

        vm.aggregateFunctions = [
            {value:'sum', display:'Sum'},
            {value:'count', display:'Count'},
            {value:'avg', display:'Average'}
        ];

        vm.geoProperties = [
            { value: 'formatted_address', display: 'Full Address' },
            { value: 'postal_address', display: 'Postal Address' },
            { value: 'country_long_name', display: 'Country (Long)' },
            { value: 'country_short_name', display: 'Country (Short)' },
            { value: 'administrative_area_level_1_long_name', display: 'State (Long)' },
            { value: 'administrative_area_level_1_short_name', display: 'State (Short)' },
            { value: 'administrative_area_level_2_long_name', display: 'County (Long)' },
            { value: 'administrative_area_level_2_short_name', display: 'County (Short)' },
            { value: 'locality_long_name', display: 'City (Long)' },
            { value: 'locality_short_name', display: 'City (Short)' },
            { value: 'postal_code_long_name', display: 'ZIP (Long)' },
            { value: 'postal_code_short_name', display: 'ZIP (Short)' },
            { value: 'street_address', display: 'Street Address' }
        ];

        vm.columnFilterOperators = [
            {value: 'contains', display: 'Contains'},
            {value: 'startswith', display: 'Starts with'}
        ];

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/table/data-tab.tpl.html"},
            {name: "Record Actions", url: "admin/pages/designer/viz/table/records-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.pageObjects = [];

        vm.vizDict = vizListService.vizDictionary();

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;
        vm.labelToUniqueId = DesignerUtilityService.labelToUniqueId;
        vm.preventSpace = DesignerUtilityService.preventSpace;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.loadFormFields = _.partial(pageObjectConfigService.loadFormFields, vm);
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);
        vm.resetRecordFields = resetRecordFields;

        // Column selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Row Color
        vm.addRowColor = addRowColor;
        vm.removeRowColor = removeRowColor;
        vm.getConditionType = getConditionType;
        vm.conditionStringValue = conditionStringValue;
        vm.matchingConditionType = matchingConditionType;
        vm.addCondition = addCondition;

        vm.checkParentSettings = function(){
            var model = vm.temp.viz.settings.dataSource.schema.model;
            model.id = 'id';
            model.parentId = 'parentId';
            model.fields.parentId = model.fields.parentId || {
                type: 'number',
                nullable: true
            };
        };

        vm.setParentData = function(parentField){
            if(parentField) {
                vm.temp.viz.settings.dataSource.schema.model.fields.parentId.from = parentField;
            }
        };

        $scope.$on('nim-column-sorted', function(e, args){
            // Reorders columns in dataSource when they are sorted in table preview
            var oldI = args.oldIndex;
            var newI = args.newIndex;

            var colObj = vm.temp.viz.settings.columns.splice(oldI, 1)[0];

            vm.temp.viz.settings.columns.splice(newI, 0, colObj);
        });

        // Aggregates
        vm.addAggregate = function(aggregate){
            vm.temp.viz.settings.dataSource.schema.aggregates = 'nim_aggregate';
            vm.temp.viz.settings.dataSource.aggregate = vm.temp.viz.settings.dataSource.aggregate || [];
            vm.temp.viz.settings.dataSource.aggregate.push(angular.copy(aggregate));

            for(var c = 0; c < vm.temp.viz.settings.columns.length; c++){
                var column = vm.temp.viz.settings.columns[c];
                if(column.field == aggregate.field){
                    if(column.aggregates.indexOf(aggregate.aggregate) == -1) {
                        column.aggregates.push(aggregate.aggregate);
                    }
                    break;
                }
            }

            aggregate.field = null;
            aggregate.format = null;
            aggregate.aggregate = null;
            aggregate.nimLabel = '';
        };

        vm.removeAggregate = function(aggregate, index){
            vm.temp.viz.settings.dataSource.aggregate.splice(index, 1);

            for(var c = 0; c < vm.temp.viz.settings.columns.length; c++){
                var column = vm.temp.viz.settings.columns[c];
                if(column.field == aggregate.field){
                    column.aggregates.splice(column.aggregates.indexOf(aggregate.aggregate), 1);
                    break;
                }
            }
        };

        vm.updateDrillDownViz = function(id){
            /* LODASH Version 4 ONLY */
            //var pageObject = _.find(vm.pageObjects, ['id', id]);
            /* LODASH Version 3 & 4 Compatibility Mode */
            var pageObject = _.find(vm.pageObjects, function(f){return f.id === id;});
            vm.detailObject.title = pageObject.name;
            delete vm.detailObject.field;

            pageObjectsService.getPageObject(id).then(function(pageObjectData){
                var vId = _.get(pageObjectData, 'viz.settings.dataSource.nim_viewId');
                if(vId){
                    vm.detailObject.viewId = vId;
                    ViewsService.getColumns(vId).then(function(columns){
                        vm.detailColumns = [];
                        _.forEach(columns, function(c){
                            var split = c.colName.split('_');
                            if(split.length > 2 && _.last(split) === 'display'){
                                vm.detailColumns.push({
                                    field: c.colName.replace(/_display$/, ''),
                                    name: c.name
                                });
                                vm.detailColumns.push({
                                    field: c.colName,
                                    name: c.name + ' Display'
                                });
                            }
                            else {
                                vm.detailColumns.push({
                                    field: c.colName,
                                    name: c.name
                                });
                            }
                        });
                    });
                }
                else {
                    delete vm.detailObject.viewId;
                    vm.detailColumns = [];
                }
            });
        };

        vm.addDetailPageObject = function(){
            if(!_.isArray(vm.temp.viz.drillDownSettings)){
                vm.temp.viz.drillDownSettings = [];
            }
            vm.temp.viz.drillDownSettings.push(vm.detailObject);
            vm.detailObject = {
                column: 'id'
            };
            vm.detailColumns = [];
        };

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        vm.filterByType = function(column){
            return column.castType === vm.filterType && vm.notPropertyColumn(column);
        };

        // Getters/Setters
        vm.tempFilterStringValue = function(newStringValue){
            if(arguments.length){
                vm.tempFilter.value = newStringValue.replace(/^"/, '\\"').replace(/"$/, '\\"');
                return newStringValue;
            }
            else {
                var value = _.get(vm.tempFilter, 'value');
                return vm.removeEscaping(value);
            }
        };

        vm.removeEscaping = function(value){
            if(_.isString(value)){
                return value.replace(/^\\"/, '"').replace(/\\"$/, '"');
            }
            else if(_.isNull(value)){
                return '';
            }

            return value;
        };

        vm.addQuotes = function(text){
            return '"' + text + '"';
        };

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init(){
            _.defaults(vm.temp.params, {
                disableVirtualScrolling: true,
                defaultData: [],
                openOnSelect: true,
                rowColors: [],
                colFilterOp: 'startswith',
                requiredFilters: {},
                defaultValues: {},
                routeSettings: {
                    enabled: false,
                    newTab: false,
                    template: ''
                }
            });

            _.forEach(vm.temp.params.rowColors, function(){
                vm.condition.push({});
                vm.conditionType.push('');
                vm.isColumnValue.push(false);
            });

            for(var i = 0; i < filters.length; i++){
                if(filters[i].id){
                    vm.idArray.push(filters[i].id);
                }
            }

            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            vm.loadFormFields(pageObject.viz.widgetId);

            WidgetsService.getWidgets().then(function(widgets){
                vm.widgets = widgets;
            });

            pageObjectsService.getPageObjects().then(function(data){
                vm.pageObjects = data;
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(/*colField*/){
            // Empty, for now
        }

        function onColumnRemoved(colField){
            var source = vm.temp.viz.settings.dataSource;

            // Clears fields bound to the removed column
            // Sort By
            /* LODASH Version 4 ONLY */
            //_.remove(source.sort, ['field', colField]);
            /* LODASH Version 3 & 4 Compatibility Mode */
            _.remove(source.sort, function(rm){return rm.field === colField;});

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }

            if(_.get(vm.temp.params, 'uploadFilename.modelId') === colField){
                delete vm.temp.params.uploadFilename;
            }

            if(_.get(vm.temp.params, 'uploadImageField.modelId') === colField){
                delete vm.temp.params.uploadImageField;
            }
        }

        function resetRecordFields(){
            vm.temp.params.defaultData = [];
            vm.temp.params.defaultValues = {};
        }

        function addRowColor(rowColorArray){
            rowColorArray.push({
                name: '',
                color: '#ffffff',
                logic: 'and',
                conditions: []
            });

            vm.condition.push({});
            vm.conditionType.push('');
            vm.isColumnValue.push(false);
        }

        function removeRowColor(rowColorArray, index){
            rowColorArray.splice(index, 1);
            vm.condition.splice(index, 1);
            vm.conditionType.splice(index, 1);
            vm.isColumnValue.splice(index, 1);
        }

        function getConditionType(columns, condition, index){
            var conditionType = '';

            if(condition){
                if(condition.field){
                    /* LODASH Version 4 ONLY */
                    //var colIndex = _.findIndex(columns, ['field', condition.field]);
                    /* LODASH Version 3 & 4 Compatibility Mode */
                    var colIndex = _.findIndex(columns, function(f){return f.field === condition.field;});
                    if(colIndex >= 0){
                        conditionType = columns[colIndex].type;

                        // Don't allow filter to keep value of different type
                        if(conditionType !== vm.conditionType[index]){
                            condition.value = null;
                        }
                    }
                    else {
                        // Remove value if field is invalid
                        condition.value = null;
                    }
                }
                else{
                    _.assign(condition, {
                        operator: null,
                        value: null
                    });
                }
            }

            vm.conditionType[index] = conditionType;
        }

        function conditionStringValue(index){
            return function(newStringValue){
                if(arguments.length){
                    vm.condition[index].value = newStringValue.replace(/^"/, '\\"').replace(/"$/, '\\"');
                    return newStringValue;
                }
                else {
                    var value = _.get(vm.condition[index], 'value');
                    return vm.removeEscaping(value);
                }
            };
        }

        function matchingConditionType(index){
            return function(column){
                return column.type === vm.conditionType[index];
            };
        }

        function addCondition(rowColor, condition, index){
            rowColor.conditions.push(angular.copy(condition));

            condition.value = null;
            condition.op = null;
            condition.field = '';

            vm.conditionType[index] = '';
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('TemplateConfigCtrl', ["_", "$scope", "$uibModalInstance", "pageObject", "filters", "DesignerUtilityService", "PagesDesignerListService", "pageObjectConfigService", "ViewsService", "vizListService", function TemplateConfigCtrl(_, $scope, $uibModalInstance, pageObject, filters,
                                                                  DesignerUtilityService, PagesDesignerListService,
                                                                  pageObjectConfigService, ViewsService, vizListService) {
        var vm = this;
        
        vm.temp = angular.copy(pageObject);
        vm.orig = angular.copy(pageObject);
        vm.filters = filters;
        vm.views = [];
        vm.wrapperTypes = PagesDesignerListService.wrapperTypes();
        vm.wrapperConfig = PagesDesignerListService.wrapperConfig();
        vm.paletteOptions = {
            palette: PagesDesignerListService.palette(),
            columns: 31,
            tileSize: 18
        };
        vm.margin = DesignerUtilityService.cssToArray(pageObject.wrapper.style.margin) || [0,0,0,0];
        vm.padding = DesignerUtilityService.cssToArray(pageObject.wrapper.style.padding) || [0,0,0,0];
        vm.viewColumns = [];
        vm.editView = _.get(pageObject,'viz.settings.dataSource.nim_viewId');

        vm.filterMap = {};
        vm.tempFilter = {};
        vm.filterType = null;
        vm.sortObj = {
            field: '',
            dir: 'desc'
        };

        vm.filterOperators = pageObjectConfigService.filterOperators();
        vm.textEditorOptions = pageObjectConfigService.textEditorOptions($scope);
        vm.editorTools = vm.textEditorOptions.tools;

        vm.vizDict = vizListService.vizDictionary();

        vm.tabTemplates = [
            {name: "General", url: "admin/pages/designer/common/general-tab.tpl.html"},
            {name: "Wrapper", url: "admin/pages/designer/common/wrapper-tab.tpl.html"},
            {name: "Data", url: "admin/pages/designer/viz/template/template-data-tab.tpl.html"},
            {name: "Filters", url: "admin/pages/designer/common/filter-tab.tpl.html"},
            {name: "Tools", url: "admin/pages/designer/common/tools-tab.tpl.html"}
        ];

        vm.sortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.columns);

        vm.getFilterType = pageObjectConfigService.getFilterType;
        vm.addDSFilter = pageObjectConfigService.addDSFilter;

        vm.notPropertyColumn = pageObjectConfigService.notPropertyColumnFilter;

        // Helper functions
        vm.deleteProperty = pageObjectConfigService.deleteProperty;
        vm.capitalize = _.capitalize;
        vm.removeItemFromArray = _.pullAt;
        vm.fillCSSArray = pageObjectConfigService.fillCSSArray;

        // View functions
        vm.loadColumns = _.partial(pageObjectConfigService.loadColumns, vm);
        vm.onViewChange = _.partial(pageObjectConfigService.onViewChange, vm, onColumnRemoved);

        // Widget functions
        vm.setBaseWidget = _.partial(pageObjectConfigService.setBaseWidget, vm, vm.temp);

        // Column selection
        vm.removeColumn = pageObjectConfigService.removeColumn;
        vm.selectColumn = pageObjectConfigService.selectColumn(onColumnAdded, onColumnRemoved);
        vm.selectAllColumns = pageObjectConfigService.selectAllColumns(onColumnAdded, onColumnRemoved);
        vm.removeAllColumns = pageObjectConfigService.removeAllColumns;
        vm.colIsSelected = pageObjectConfigService.colIsSelected;
        vm.allColSelected = pageObjectConfigService.allColSelected;

        vm.onColumnAdded = onColumnAdded;
        vm.onColumnRemoved = onColumnRemoved;

        // Filter Commands
        vm.addToFilterMap = pageObjectConfigService.addToFilterMap;
        vm.removeFromFilterMap = pageObjectConfigService.removeFromFilterMap;

        // Sort Commands
        vm.addSortItem = pageObjectConfigService.addSortItem;

        // Modal Commands
        vm.save = pageObjectConfigService.savePageObjConfig($uibModalInstance, vm.margin, vm.padding);

        vm.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };

        vm.deletePageObject = function(){
            $uibModalInstance.dismiss('delete');
        };

        //Init
        init();

        function init() {
            _.defaults(vm.temp.params, {
                requiredFilters: {}
            });

            ViewsService.get(false).then(function(views){
                vm.views = views;
            });

            vm.loadColumns(vm.editView);
            pageObjectConfigService.updateSortConfig(vm.temp.viz.settings.dataSource);
            vm.sortBySortableOptions = pageObjectConfigService.createSortableOptions(vm.temp.viz.settings.dataSource.sort);
        }

        // Controller-specific functions
        function onColumnAdded(/*colField*/){ // Fills in fields by default when column is selected
            // No fields to auto-populate, for now
        }

        function onColumnRemoved(colField){ // Clears fields bound to the removed column
            var source = vm.temp.viz.settings.dataSource;

            // Sort By
            _.remove(source.sort, 'field', colField);

            // Group By
            if(_.get(source, 'group.field') === colField){
                delete source.group;
            }

            // ID Override
            if(_.get(source, 'schema.model.id') === colField){
                delete source.schema.model.id;
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_imageCtrl', ["$scope", "$uibModalInstance", "$window", "autoTabIndex", "editFlag", "formObj", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsDesignerListService", "_", "formOriginId", function FormsDesigner_imageCtrl($scope, $uibModalInstance, $window, autoTabIndex,
                                                                                  editFlag, formObj, idArray, sections, widgetId,
                                                                                  DesignerUtilityService, FormsDesignerListService, _, formOriginId) {
        // Populate Scope
        $scope.formOriginId = formOriginId;
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.formFields = [];
        $scope.sections = sections;
        $scope.widgetFieldIds = idArray;
        $scope.formFieldObjects = [];

        $scope.areaTypeOptions = [
            {
                display: 'Circle',
                value: 'circle'
            },
            {
                display: 'Square',
                value: 'square'
            }
        ];

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        // Modal Actions
        $scope.ok = function (){
            $uibModalInstance.close($scope.temp);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Init
        init();

        function init(){
            // Hack
            DesignerUtilityService.focusFirstElement('configForm');
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_ruleCtrl',
    ["_", "$scope", "$rootScope", "$uibModalInstance", "$window", "$sanitize", "$timeout", "autoTabIndex", "currentFormObjects", "editFlag", "formObj", "formOriginId", "idArray", "sections", "widgetId", "DesignerUtilityService", "FormsDesignerListService", "RulesService", "WidgetsSettingsService", function FormsDesigner_ruleCtrl(_, $scope, $rootScope, $uibModalInstance, $window, $sanitize, $timeout,
                                      autoTabIndex, currentFormObjects, editFlag, formObj, formOriginId, idArray,
                                      sections, widgetId, DesignerUtilityService, FormsDesignerListService,
                                      RulesService, WidgetsSettingsService) {
        // Populate Scope
        $scope.formOriginId = formOriginId;
        $scope.temp = angular.copy(formObj);
        $scope.orig = angular.copy(formObj);
        $scope.formFields = [];
        $scope.formFieldObjects = [];
        $scope.widgetFieldIds = idArray;
        $scope.curModelIds = idArray;
        $scope.editFlag = editFlag;
        $scope.autoTabIndex = autoTabIndex;
        $scope.tabsTemplate = FormsDesignerListService.formObjects();
        $scope.sections = sections;
        $scope.availableRules = [];
        $scope.rule = null;
        $scope.state = null;
        $scope.needsUpdate = {};
        $scope.needsRemoval = {};

        $scope.deleteProperty = DesignerUtilityService.deleteProperty;
        $scope.getRule = getRule;
        $scope.setParamData = setParamData;
        $scope.sameState = sameState;
        $scope.removeParameter = removeParameter;

        // UI Helper Functions
        $scope.preventSpace = DesignerUtilityService.preventSpace;
        $scope.labelToUniqueId = function (item){
            if (!$scope.orig.model.config.modelId) {
                item.model.config.modelId = DesignerUtilityService.labelToUniqueId(item.model.label.text, idArray);
            }
        };

        $scope.deleteArrayObject = function(array,index){
            array.splice(index, 1);
        };

        // Modal Actions
        $scope.ok = function (){
            $uibModalInstance.close($scope.temp);
        };
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Init
        init();

        function init(){
            WidgetsSettingsService.getFormFields(widgetId).then(function(formFieldArray){
                DesignerUtilityService.mergeFieldsWithCurrentForm(formFieldArray, currentFormObjects);

                //$scope.formFields = formFieldArray;
                $scope.formFieldObjects = getFormFieldObjects(formFieldArray);
                //$scope.widgetFieldIds = _.union(idArray, _.map($scope.formFieldObjects, 'modelId'));

                // Codemirror
                $scope.codemirrorLoaded = DesignerUtilityService.codemirrorLoaded(formFieldArray.operands);
            });

            RulesService.getAvailableRules().then(function(ruleData){
                $scope.availableRules = ruleData.rules;
            });

            getRule($scope.temp.model.param.ruleId);

            // Hack
            DesignerUtilityService.focusFirstElement('configForm');
        }

        function getFormFieldObjects(fieldArray){
            var objects = [];
            for(var f = 0; f < fieldArray.display.length; f++){
                var form = fieldArray.display[f];
                if(form.originId + '' === formOriginId){
                    $scope.state = form.stateId;
                }
                for(var o = 0; o < form.objects.length; o++){
                    var object = form.objects[o];
                    object.formId = form.originId;
                    object.realFormId = form.formId;
                    object.stateId = form.stateId;
                    objects.push(object);
                }
            }
            return objects;
        }

        function getRule(id){
            if(id){
                RulesService.getRule(id).then(function(rule){
                    $scope.rule = rule;
                    $scope.temp.model.param.ruleName = rule.name;

                    var params = $scope.temp.model.param.parameterMap;

                    _.forEach(rule.params, function(p){
                        params[p.name] = params[p.name] || angular.copy(p);
                    });

                    var needsUpdateParams = {},
                        needsRemovalParams = {};

                    // Check for params that need to be removed/updated
                    _.forEach(params, function(p){
                        var origParam = _.find(rule.params, 'name', p.name);

                        if(!origParam){
                            needsRemovalParams[p.name] = true;
                        }
                        else {
                            var props = _.keys(origParam),
                                newParam = _.pick(p, props);

                            if(!angular.equals(origParam, newParam)){
                                needsUpdateParams[p.name] = true;
                            }
                        }
                    });

                    $scope.needsUpdate = needsUpdateParams;
                    $scope.needsRemoval = needsRemovalParams;
                });
            }
            else {
                $scope.temp.model.param.ruleName = '';
            }
        }

        function setParamData(paramField){
            if(paramField.modelId) {
                var field = _.find($scope.formFieldObjects, 'modelId', paramField.modelId);

                if(field){
                    paramField.formId = field.formId;
                    paramField.stateId = field.stateId;
                }
            }
        }

        function sameState(formField){
            return formField.stateId === $scope.state;
        }

        function removeParameter(paramArray, paramMap, paramName){
            var origParam = _.find(paramArray, 'name', paramName);
            if($scope.needsRemoval[paramName]){
                delete paramMap[paramName];
                $scope.needsRemoval[paramName] = false;
            }
            else if($scope.needsUpdate[paramName]){
                _.assign(paramMap[paramName], origParam);
                $scope.needsUpdate[paramName] = false;
            }
            else {
                paramMap[paramName] = angular.copy(origParam);
            }
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .controller('FormsDesigner_SectionCtrl', ["_", "$scope", "$uibModalInstance", "section", "sectionArray", "formOriginId", "fields", "DesignerUtilityService", function FormsDesigner_SectionCtrl(_, $scope, $uibModalInstance, section, sectionArray, formOriginId, fields, DesignerUtilityService){
        var vm = this;
        vm.orig = angular.copy(section);
        vm.temp = angular.copy(section);
        vm.fields = [];
        vm.fieldType = '';
        vm.condition = {};
        vm.operators = DesignerUtilityService.conditionOperators();
        vm.conditionActionValues = DesignerUtilityService.conditionActionValues();
        vm.boolValues = [
            {value: true, display: 'True'},
            {value: false, display: 'False'}
        ];

        vm.save = save;
        vm.cancel = cancel;
        vm.isUnchanged = isUnchanged;
        vm.validateName = validateName;
        vm.addCondition = addCondition;
        vm.removeCondition = removeCondition;
        vm.checkFieldType = checkFieldType;

        init();

        function init() {
            vm.fields = [{
                model: {
                    config: {
                        modelId: '__nimRecordAction'
                    },
                    label: {
                        text: '(Record Action)'
                    }
                }
            }].concat(_.sortBy(fields, function (f) {
                return _.get(f, 'model.config.modelId');
            }));
        }

        function save(){
            if(!$scope.configForm.$invalid && !vm.isUnchanged()) {
                $uibModalInstance.close(vm.temp);
            }
        }

        function cancel(){
            $uibModalInstance.dismiss();
        }

        function isUnchanged(){
            return angular.equals(vm.temp, vm.orig);
        }

        function validateName(input, name){
            input.$setValidity('hasName', _.get(name, 'length', 0) > 0);
            input.$setValidity('notTaken', sectionArray.indexOf(name) < 0);
        }

        function addCondition(section, condition){
            condition.formOriginId = formOriginId;
            section.condition.push(angular.copy(condition));
            _.assign(condition, {modelId: null, op: null, val: null, isFormObj: false});
        }

        function removeCondition(section, index){
            _.pullAt(section.condition, index);
        }

        function checkFieldType(condition){
            var field = _.find(fields, 'model.config.modelId', condition.modelId);
            var fieldType = '',
                type = _.get(field, 'model.config.type'),
                dataType = _.get(field, 'model.config.dataType'),
                lookUpType = _.get(field, 'model.option.type');

            if(type === 'checkbox'){
                fieldType = 'boolean';
            }
            else if(dataType === 'string'){
                fieldType = 'string';
            }
            else if(dataType === 'number'){
                fieldType = 'number';
            }
            else if(lookUpType === 'custom' || lookUpType === 'views'){
                fieldType = 'lookup';
            }
            else if (condition.modelId == '__nimRecordAction') {
                fieldType = 'action';
            }

            if(fieldType !== vm.fieldType){
                condition.op = '';

                if(fieldType === 'boolean'){
                    condition.op = 'eq';
                    condition.val = true;
                }

                if(vm.fieldType === 'boolean'){
                    condition.val = null;
                }
            }

            vm.fieldType = fieldType;
        }

        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    }])
;
angular.module('cerberus.admin')
    .factory('SmartObjectsService', function SmartObjectsService() {
        var service = {
            smartObjectsList: smartObjectsList
        };
        return service;
        ////////////////////

        function smartObjectsList() {
            return [
                {
                    name: 'Email',
                    value: 'email'
                }
            ];
        }
    })
;
